/* eslint-disable */

export const AllTypesProps: Record<string,any> = {
	Query:{
		getArticle:{
			by:{
				type:"ArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listArticle:{
			filter:{
				type:"ArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArticle:{
			filter:{
				type:"ArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateArticle:{
			data:{
				type:"ArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateArticle:{
			by:{
				type:"ArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getArticleAuthor:{
			by:{
				type:"ArticleAuthorUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleAuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listArticleAuthor:{
			filter:{
				type:"ArticleAuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleAuthorOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArticleAuthor:{
			filter:{
				type:"ArticleAuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleAuthorOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateArticleAuthor:{
			data:{
				type:"ArticleAuthorCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateArticleAuthor:{
			by:{
				type:"ArticleAuthorUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ArticleAuthorUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getAuthor:{
			by:{
				type:"AuthorUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listAuthor:{
			filter:{
				type:"AuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AuthorOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateAuthor:{
			filter:{
				type:"AuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AuthorOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateAuthor:{
			data:{
				type:"AuthorCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateAuthor:{
			by:{
				type:"AuthorUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"AuthorUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getAuthorTopArticle:{
			by:{
				type:"AuthorTopArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AuthorTopArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listAuthorTopArticle:{
			filter:{
				type:"AuthorTopArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AuthorTopArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateAuthorTopArticle:{
			filter:{
				type:"AuthorTopArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AuthorTopArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateAuthorTopArticle:{
			data:{
				type:"AuthorTopArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateAuthorTopArticle:{
			by:{
				type:"AuthorTopArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"AuthorTopArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContent:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContent:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContent:{
			data:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentPart:{
			by:{
				type:"ContentPartUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentPartWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentPart:{
			filter:{
				type:"ContentPartWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentPartOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentPart:{
			filter:{
				type:"ContentPartWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentPartOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentPart:{
			data:{
				type:"ContentPartCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentPart:{
			by:{
				type:"ContentPartUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentPartUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentReference:{
			data:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHomepageArticle:{
			by:{
				type:"HomepageArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomepageArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHomepageArticle:{
			filter:{
				type:"HomepageArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomepageArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHomepageArticle:{
			filter:{
				type:"HomepageArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomepageArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHomepageArticle:{
			data:{
				type:"HomepageArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHomepageArticle:{
			by:{
				type:"HomepageArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HomepageArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImage:{
			data:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImageUse:{
			by:{
				type:"ImageUseUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImageUse:{
			filter:{
				type:"ImageUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageUseOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImageUse:{
			filter:{
				type:"ImageUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageUseOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImageUse:{
			data:{
				type:"ImageUseCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImageUse:{
			by:{
				type:"ImageUseUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageUseUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImageTag:{
			by:{
				type:"ImageTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImageTag:{
			filter:{
				type:"ImageTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImageTag:{
			filter:{
				type:"ImageTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImageTag:{
			data:{
				type:"ImageTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImageTag:{
			by:{
				type:"ImageTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getIssue:{
			by:{
				type:"IssueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"IssueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listIssue:{
			filter:{
				type:"IssueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"IssueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateIssue:{
			filter:{
				type:"IssueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"IssueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateIssue:{
			data:{
				type:"IssueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateIssue:{
			by:{
				type:"IssueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"IssueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getIssueArticle:{
			by:{
				type:"IssueArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"IssueArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listIssueArticle:{
			filter:{
				type:"IssueArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"IssueArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateIssueArticle:{
			filter:{
				type:"IssueArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"IssueArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateIssueArticle:{
			data:{
				type:"IssueArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateIssueArticle:{
			by:{
				type:"IssueArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"IssueArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLink:{
			data:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTextContent:{
			by:{
				type:"TextContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTextContent:{
			filter:{
				type:"TextContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TextContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTextContent:{
			filter:{
				type:"TextContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TextContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTextContent:{
			data:{
				type:"TextContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTextContent:{
			by:{
				type:"TextContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TextContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTextContentPart:{
			by:{
				type:"TextContentPartUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextContentPartWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTextContentPart:{
			filter:{
				type:"TextContentPartWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TextContentPartOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTextContentPart:{
			filter:{
				type:"TextContentPartWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TextContentPartOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTextContentPart:{
			data:{
				type:"TextContentPartCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTextContentPart:{
			by:{
				type:"TextContentPartUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TextContentPartUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTextContentReference:{
			by:{
				type:"TextContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTextContentReference:{
			filter:{
				type:"TextContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TextContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTextContentReference:{
			filter:{
				type:"TextContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TextContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTextContentReference:{
			data:{
				type:"TextContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTextContentReference:{
			by:{
				type:"TextContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TextContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getUrl:{
			by:{
				type:"UrlUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"UrlWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listUrl:{
			filter:{
				type:"UrlWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"UrlOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateUrl:{
			filter:{
				type:"UrlWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"UrlOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateUrl:{
			data:{
				type:"UrlCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateUrl:{
			by:{
				type:"UrlUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"UrlUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getArticleTag:{
			by:{
				type:"ArticleTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listArticleTag:{
			filter:{
				type:"ArticleTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArticleTag:{
			filter:{
				type:"ArticleTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateArticleTag:{
			data:{
				type:"ArticleTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateArticleTag:{
			by:{
				type:"ArticleTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ArticleTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getCategory:{
			by:{
				type:"CategoryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listCategory:{
			filter:{
				type:"CategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CategoryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateCategory:{
			filter:{
				type:"CategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CategoryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateCategory:{
			data:{
				type:"CategoryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateCategory:{
			by:{
				type:"CategoryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"CategoryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getArticleCategory:{
			by:{
				type:"ArticleCategoryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleCategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listArticleCategory:{
			filter:{
				type:"ArticleCategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleCategoryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArticleCategory:{
			filter:{
				type:"ArticleCategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleCategoryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateArticleCategory:{
			data:{
				type:"ArticleCategoryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateArticleCategory:{
			by:{
				type:"ArticleCategoryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ArticleCategoryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getAudio:{
			by:{
				type:"AudioUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AudioWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listAudio:{
			filter:{
				type:"AudioWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AudioOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateAudio:{
			filter:{
				type:"AudioWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AudioOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateAudio:{
			data:{
				type:"AudioCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateAudio:{
			by:{
				type:"AudioUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"AudioUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getAudioUse:{
			by:{
				type:"AudioUseUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AudioUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listAudioUse:{
			filter:{
				type:"AudioUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AudioUseOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateAudioUse:{
			filter:{
				type:"AudioUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AudioUseOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateAudioUse:{
			data:{
				type:"AudioUseCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateAudioUse:{
			by:{
				type:"AudioUseUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"AudioUseUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getEmbed:{
			by:{
				type:"EmbedUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmbedWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listEmbed:{
			filter:{
				type:"EmbedWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EmbedOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateEmbed:{
			filter:{
				type:"EmbedWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EmbedOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateEmbed:{
			data:{
				type:"EmbedCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateEmbed:{
			by:{
				type:"EmbedUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"EmbedUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImageContent:{
			by:{
				type:"ImageContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImageContent:{
			filter:{
				type:"ImageContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImageContent:{
			filter:{
				type:"ImageContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImageContent:{
			data:{
				type:"ImageContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImageContent:{
			by:{
				type:"ImageContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getListicle:{
			by:{
				type:"ListicleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ListicleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listListicle:{
			filter:{
				type:"ListicleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ListicleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateListicle:{
			filter:{
				type:"ListicleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ListicleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateListicle:{
			data:{
				type:"ListicleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateListicle:{
			by:{
				type:"ListicleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ListicleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPollAnswer:{
			by:{
				type:"PollAnswerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PollAnswerWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPollAnswer:{
			filter:{
				type:"PollAnswerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PollAnswerOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePollAnswer:{
			filter:{
				type:"PollAnswerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PollAnswerOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePollAnswer:{
			data:{
				type:"PollAnswerCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePollAnswer:{
			by:{
				type:"PollAnswerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PollAnswerUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTag:{
			by:{
				type:"TagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTag:{
			filter:{
				type:"TagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTag:{
			filter:{
				type:"TagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTag:{
			data:{
				type:"TagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTag:{
			by:{
				type:"TagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFAQ:{
			by:{
				type:"FAQUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FAQWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFAQ:{
			filter:{
				type:"FAQWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FAQOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFAQ:{
			filter:{
				type:"FAQWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FAQOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFAQ:{
			data:{
				type:"FAQCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFAQ:{
			by:{
				type:"FAQUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FAQUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLinkContent:{
			by:{
				type:"LinkContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLinkContent:{
			filter:{
				type:"LinkContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinkContent:{
			filter:{
				type:"LinkContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLinkContent:{
			data:{
				type:"LinkContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLinkContent:{
			by:{
				type:"LinkContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getAwardContent:{
			by:{
				type:"AwardContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AwardContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listAwardContent:{
			filter:{
				type:"AwardContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AwardContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateAwardContent:{
			filter:{
				type:"AwardContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AwardContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateAwardContent:{
			data:{
				type:"AwardContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateAwardContent:{
			by:{
				type:"AwardContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"AwardContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getReviewContent:{
			by:{
				type:"ReviewContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ReviewContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listReviewContent:{
			filter:{
				type:"ReviewContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ReviewContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateReviewContent:{
			filter:{
				type:"ReviewContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ReviewContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateReviewContent:{
			data:{
				type:"ReviewContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateReviewContent:{
			by:{
				type:"ReviewContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ReviewContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPage:{
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePage:{
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePage:{
			data:{
				type:"PageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTextTranslation:{
			by:{
				type:"TextTranslationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextTranslationWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTextTranslation:{
			filter:{
				type:"TextTranslationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TextTranslationOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTextTranslation:{
			filter:{
				type:"TextTranslationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TextTranslationOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTextTranslation:{
			data:{
				type:"TextTranslationCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTextTranslation:{
			by:{
				type:"TextTranslationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TextTranslationUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSeo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSeo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSeo:{
			data:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFile:{
			by:{
				type:"FileUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFile:{
			filter:{
				type:"FileWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FileOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFile:{
			filter:{
				type:"FileWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FileOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFile:{
			data:{
				type:"FileCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFile:{
			by:{
				type:"FileUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FileUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFileUse:{
			by:{
				type:"FileUseUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFileUse:{
			filter:{
				type:"FileUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FileUseOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFileUse:{
			filter:{
				type:"FileUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FileUseOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFileUse:{
			data:{
				type:"FileUseCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFileUse:{
			by:{
				type:"FileUseUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FileUseUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentBlock:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentBlock:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentBlock:{
			data:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentArticle:{
			by:{
				type:"ContentArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentArticle:{
			filter:{
				type:"ContentArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentArticle:{
			filter:{
				type:"ContentArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentArticle:{
			data:{
				type:"ContentArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentArticle:{
			by:{
				type:"ContentArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getUnlockedArticle:{
			by:{
				type:"UnlockedArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"UnlockedArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listUnlockedArticle:{
			filter:{
				type:"UnlockedArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"UnlockedArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateUnlockedArticle:{
			filter:{
				type:"UnlockedArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"UnlockedArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateUnlockedArticle:{
			data:{
				type:"UnlockedArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateUnlockedArticle:{
			by:{
				type:"UnlockedArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"UnlockedArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getUser:{
			by:{
				type:"UserUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"UserWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listUser:{
			filter:{
				type:"UserWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"UserOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateUser:{
			filter:{
				type:"UserWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"UserOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateUser:{
			data:{
				type:"UserCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateUser:{
			by:{
				type:"UserUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"UserUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getNotification:{
			by:{
				type:"NotificationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NotificationWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listNotification:{
			filter:{
				type:"NotificationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NotificationOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateNotification:{
			filter:{
				type:"NotificationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NotificationOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateNotification:{
			data:{
				type:"NotificationCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateNotification:{
			by:{
				type:"NotificationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"NotificationUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getAppReview:{
			by:{
				type:"AppReviewUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AppReviewWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listAppReview:{
			filter:{
				type:"AppReviewWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AppReviewOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateAppReview:{
			filter:{
				type:"AppReviewWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AppReviewOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateAppReview:{
			data:{
				type:"AppReviewCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateAppReview:{
			by:{
				type:"AppReviewUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"AppReviewUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getProduct:{
			by:{
				type:"ProductUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProductWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listProduct:{
			filter:{
				type:"ProductWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProductOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateProduct:{
			filter:{
				type:"ProductWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProductOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateProduct:{
			data:{
				type:"ProductCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateProduct:{
			by:{
				type:"ProductUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ProductUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSubscriptionForm:{
			by:{
				type:"SubscriptionFormUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSubscriptionForm:{
			filter:{
				type:"SubscriptionFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubscriptionFormOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSubscriptionForm:{
			filter:{
				type:"SubscriptionFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubscriptionFormOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSubscriptionForm:{
			data:{
				type:"SubscriptionFormCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSubscriptionForm:{
			by:{
				type:"SubscriptionFormUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SubscriptionFormUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSubscriptionFormSection:{
			by:{
				type:"SubscriptionFormSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSubscriptionFormSection:{
			filter:{
				type:"SubscriptionFormSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubscriptionFormSectionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSubscriptionFormSection:{
			filter:{
				type:"SubscriptionFormSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubscriptionFormSectionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSubscriptionFormSection:{
			data:{
				type:"SubscriptionFormSectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSubscriptionFormSection:{
			by:{
				type:"SubscriptionFormSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SubscriptionFormSectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSubscriptionFormInput:{
			by:{
				type:"SubscriptionFormInputUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormInputWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSubscriptionFormInput:{
			filter:{
				type:"SubscriptionFormInputWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubscriptionFormInputOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSubscriptionFormInput:{
			filter:{
				type:"SubscriptionFormInputWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubscriptionFormInputOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSubscriptionFormInput:{
			data:{
				type:"SubscriptionFormInputCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSubscriptionFormInput:{
			by:{
				type:"SubscriptionFormInputUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SubscriptionFormInputUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSubscriptionFormOption:{
			by:{
				type:"SubscriptionFormOptionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormOptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSubscriptionFormOption:{
			filter:{
				type:"SubscriptionFormOptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubscriptionFormOptionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSubscriptionFormOption:{
			filter:{
				type:"SubscriptionFormOptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubscriptionFormOptionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSubscriptionFormOption:{
			data:{
				type:"SubscriptionFormOptionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSubscriptionFormOption:{
			by:{
				type:"SubscriptionFormOptionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SubscriptionFormOptionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getButton:{
			by:{
				type:"ButtonUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ButtonWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listButton:{
			filter:{
				type:"ButtonWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ButtonOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateButton:{
			filter:{
				type:"ButtonWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ButtonOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateButton:{
			data:{
				type:"ButtonCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateButton:{
			by:{
				type:"ButtonUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ButtonUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getArticleHistoryTag:{
			by:{
				type:"ArticleHistoryTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleHistoryTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listArticleHistoryTag:{
			filter:{
				type:"ArticleHistoryTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleHistoryTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArticleHistoryTag:{
			filter:{
				type:"ArticleHistoryTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleHistoryTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateArticleHistoryTag:{
			data:{
				type:"ArticleHistoryTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateArticleHistoryTag:{
			by:{
				type:"ArticleHistoryTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ArticleHistoryTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getArticleHistoryPeriod:{
			by:{
				type:"ArticleHistoryPeriodUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleHistoryPeriodWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listArticleHistoryPeriod:{
			filter:{
				type:"ArticleHistoryPeriodWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleHistoryPeriodOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArticleHistoryPeriod:{
			filter:{
				type:"ArticleHistoryPeriodWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleHistoryPeriodOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateArticleHistoryPeriod:{
			data:{
				type:"ArticleHistoryPeriodCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateArticleHistoryPeriod:{
			by:{
				type:"ArticleHistoryPeriodUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ArticleHistoryPeriodUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHistoryTag:{
			by:{
				type:"HistoryTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHistoryTag:{
			filter:{
				type:"HistoryTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HistoryTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHistoryTag:{
			filter:{
				type:"HistoryTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HistoryTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHistoryTag:{
			data:{
				type:"HistoryTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHistoryTag:{
			by:{
				type:"HistoryTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HistoryTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHistoryPeriod:{
			by:{
				type:"HistoryPeriodUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryPeriodWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHistoryPeriod:{
			filter:{
				type:"HistoryPeriodWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HistoryPeriodOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHistoryPeriod:{
			filter:{
				type:"HistoryPeriodWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HistoryPeriodOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHistoryPeriod:{
			data:{
				type:"HistoryPeriodCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHistoryPeriod:{
			by:{
				type:"HistoryPeriodUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HistoryPeriodUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHistoryHomePage:{
			by:{
				type:"HistoryHomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryHomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHistoryHomePage:{
			filter:{
				type:"HistoryHomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HistoryHomePageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHistoryHomePage:{
			filter:{
				type:"HistoryHomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HistoryHomePageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHistoryHomePage:{
			data:{
				type:"HistoryHomePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHistoryHomePage:{
			by:{
				type:"HistoryHomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HistoryHomePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHistoryCover:{
			by:{
				type:"HistoryCoverUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryCoverWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHistoryCover:{
			filter:{
				type:"HistoryCoverWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HistoryCoverOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHistoryCover:{
			filter:{
				type:"HistoryCoverWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HistoryCoverOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHistoryCover:{
			data:{
				type:"HistoryCoverCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHistoryCover:{
			by:{
				type:"HistoryCoverUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HistoryCoverUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHistoryTextList:{
			by:{
				type:"HistoryTextListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryTextListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHistoryTextList:{
			filter:{
				type:"HistoryTextListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HistoryTextListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHistoryTextList:{
			filter:{
				type:"HistoryTextListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HistoryTextListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHistoryTextList:{
			data:{
				type:"HistoryTextListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHistoryTextList:{
			by:{
				type:"HistoryTextListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HistoryTextListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHistoryTextItem:{
			by:{
				type:"HistoryTextItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryTextItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHistoryTextItem:{
			filter:{
				type:"HistoryTextItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HistoryTextItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHistoryTextItem:{
			filter:{
				type:"HistoryTextItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HistoryTextItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHistoryTextItem:{
			data:{
				type:"HistoryTextItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHistoryTextItem:{
			by:{
				type:"HistoryTextItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HistoryTextItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFooterMenu:{
			by:{
				type:"FooterMenuUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterMenuWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFooterMenu:{
			filter:{
				type:"FooterMenuWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterMenuOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFooterMenu:{
			filter:{
				type:"FooterMenuWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterMenuOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFooterMenu:{
			data:{
				type:"FooterMenuCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFooterMenu:{
			by:{
				type:"FooterMenuUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FooterMenuUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLinkSection:{
			by:{
				type:"LinkSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLinkSection:{
			filter:{
				type:"LinkSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkSectionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinkSection:{
			filter:{
				type:"LinkSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkSectionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLinkSection:{
			data:{
				type:"LinkSectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLinkSection:{
			by:{
				type:"LinkSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkSectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLinkList:{
			by:{
				type:"LinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLinkList:{
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinkList:{
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLinkList:{
			data:{
				type:"LinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLinkList:{
			by:{
				type:"LinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLinkItem:{
			by:{
				type:"LinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLinkItem:{
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinkItem:{
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLinkItem:{
			data:{
				type:"LinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLinkItem:{
			by:{
				type:"LinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getNewsletterSection:{
			by:{
				type:"NewsletterSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listNewsletterSection:{
			filter:{
				type:"NewsletterSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsletterSectionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateNewsletterSection:{
			filter:{
				type:"NewsletterSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsletterSectionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateNewsletterSection:{
			data:{
				type:"NewsletterSectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateNewsletterSection:{
			by:{
				type:"NewsletterSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"NewsletterSectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getNewsletter:{
			by:{
				type:"NewsletterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listNewsletter:{
			filter:{
				type:"NewsletterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsletterOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateNewsletter:{
			filter:{
				type:"NewsletterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsletterOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateNewsletter:{
			data:{
				type:"NewsletterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateNewsletter:{
			by:{
				type:"NewsletterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"NewsletterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getOnlineSection:{
			by:{
				type:"OnlineSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"OnlineSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listOnlineSection:{
			filter:{
				type:"OnlineSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"OnlineSectionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateOnlineSection:{
			filter:{
				type:"OnlineSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"OnlineSectionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateOnlineSection:{
			data:{
				type:"OnlineSectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateOnlineSection:{
			by:{
				type:"OnlineSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"OnlineSectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getAppLink:{
			by:{
				type:"AppLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AppLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listAppLink:{
			filter:{
				type:"AppLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AppLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateAppLink:{
			filter:{
				type:"AppLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AppLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateAppLink:{
			data:{
				type:"AppLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateAppLink:{
			by:{
				type:"AppLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"AppLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getAppLinkList:{
			by:{
				type:"AppLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AppLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listAppLinkList:{
			filter:{
				type:"AppLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AppLinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateAppLinkList:{
			filter:{
				type:"AppLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AppLinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateAppLinkList:{
			data:{
				type:"AppLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateAppLinkList:{
			by:{
				type:"AppLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"AppLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getAppLinkItem:{
			by:{
				type:"AppLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AppLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listAppLinkItem:{
			filter:{
				type:"AppLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AppLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateAppLinkItem:{
			filter:{
				type:"AppLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AppLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateAppLinkItem:{
			data:{
				type:"AppLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateAppLinkItem:{
			by:{
				type:"AppLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"AppLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSocialSection:{
			by:{
				type:"SocialSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSocialSection:{
			filter:{
				type:"SocialSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialSectionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSocialSection:{
			filter:{
				type:"SocialSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialSectionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSocialSection:{
			data:{
				type:"SocialSectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSocialSection:{
			by:{
				type:"SocialSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SocialSectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSocialLink:{
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSocialLink:{
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSocialLink:{
			data:{
				type:"SocialLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SocialLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSocialLinkList:{
			by:{
				type:"SocialLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSocialLinkList:{
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSocialLinkList:{
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSocialLinkList:{
			data:{
				type:"SocialLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSocialLinkList:{
			by:{
				type:"SocialLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SocialLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSocialLinkItem:{
			by:{
				type:"SocialLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSocialLinkItem:{
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSocialLinkItem:{
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSocialLinkItem:{
			data:{
				type:"SocialLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSocialLinkItem:{
			by:{
				type:"SocialLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SocialLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSharedContent:{
			by:{
				type:"SharedContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SharedContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSharedContent:{
			filter:{
				type:"SharedContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SharedContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSharedContent:{
			filter:{
				type:"SharedContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SharedContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSharedContent:{
			data:{
				type:"SharedContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSharedContent:{
			by:{
				type:"SharedContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SharedContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		}
	},
	Article:{
		url:{
			filter:{
				type:"UrlWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		authors:{
			filter:{
				type:"ArticleAuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleAuthorOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		subtitle:{
			filter:{
				type:"TextContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		content:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		coverPhoto:{
			filter:{
				type:"ImageUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		previewContent:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		audio:{
			filter:{
				type:"AudioUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		categories:{
			filter:{
				type:"ArticleCategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleCategoryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		issues:{
			filter:{
				type:"IssueArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"IssueArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentBlocks:{
			filter:{
				type:"ContentArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		unlocked:{
			filter:{
				type:"UnlockedArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"UnlockedArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		coverPhotoVertical:{
			filter:{
				type:"ImageUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		tags:{
			filter:{
				type:"ArticleTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		historyTags:{
			filter:{
				type:"ArticleHistoryTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleHistoryTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		historyPeriods:{
			filter:{
				type:"ArticleHistoryPeriodWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleHistoryPeriodOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		authorsByAuthor:{
			by:{
				type:"ArticleAuthorsByAuthorUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleAuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		authorsByLegacyStringAuthor:{
			by:{
				type:"ArticleAuthorsByLegacyStringAuthorUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleAuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		categoriesByCategory:{
			by:{
				type:"ArticleCategoriesByCategoryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleCategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		issuesByIssue:{
			by:{
				type:"ArticleIssuesByIssueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"IssueArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		tagsByTag:{
			by:{
				type:"ArticleTagsByTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		historyTagsByHistoryTag:{
			by:{
				type:"ArticleHistoryTagsByHistoryTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleHistoryTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		historyPeriodsByHistoryPeriod:{
			by:{
				type:"ArticleHistoryPeriodsByHistoryPeriodUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleHistoryPeriodWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateAuthors:{
			filter:{
				type:"ArticleAuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleAuthorOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateCategories:{
			filter:{
				type:"ArticleCategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleCategoryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateIssues:{
			filter:{
				type:"IssueArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"IssueArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentBlocks:{
			filter:{
				type:"ContentArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateUnlocked:{
			filter:{
				type:"UnlockedArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"UnlockedArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTags:{
			filter:{
				type:"ArticleTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHistoryTags:{
			filter:{
				type:"ArticleHistoryTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleHistoryTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHistoryPeriods:{
			filter:{
				type:"ArticleHistoryPeriodWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleHistoryPeriodOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	UUID: "String",
	Url:{
		article:{
			filter:{
				type:"ArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		author:{
			filter:{
				type:"AuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		issue:{
			filter:{
				type:"IssueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		page:{
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		category:{
			filter:{
				type:"CategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		tag:{
			filter:{
				type:"TagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ArticleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"UrlWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		authors:{
			type:"ArticleAuthorWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		hideInMostRead:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		hideAds:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		state:{
			type:"ArticleStateCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		locked:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishAt:{
			type:"DateTimeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		template:{
			type:"TemplateCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"TextContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverPhoto:{
			type:"ImageUseWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleAlignment:{
			type:"ArticleTitleAlignmentCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		tagline:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTimeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		previewContent:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"AudioUseWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		categories:{
			type:"ArticleCategoryWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		issues:{
			type:"IssueArticleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentBlocks:{
			type:"ContentArticleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		unlocked:{
			type:"UnlockedArticleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverPhotoVertical:{
			type:"ImageUseWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"ArticleTagWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		isHistory:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyTags:{
			type:"ArticleHistoryTagWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyPeriods:{
			type:"ArticleHistoryPeriodWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ArticleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ArticleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ArticleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UUIDCondition:{
		and:{
			type:"UUIDCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"UUIDCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"UUID",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"UUID",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StringCondition:{
		and:{
			type:"StringCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"StringCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"String",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"String",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contains:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		startsWith:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		endsWith:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		containsCI:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		startsWithCI:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		endsWithCI:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"AuthorWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"IssueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"PageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		category:{
			type:"CategoryWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		tag:{
			type:"TagWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"UrlWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"UrlWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"UrlWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		position:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		twitterHandle:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebookId:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		about:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		topArticles:{
			type:"AuthorTopArticleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		users:{
			type:"UserWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		startOfCooperation:{
			type:"DateCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		photo:{
			type:"ImageUseWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		illustration:{
			type:"ImageUseWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		category:{
			type:"AuthorCategoryCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"UrlWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagramUsername:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"AuthorWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"AuthorWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"AuthorWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BooleanCondition:{
		and:{
			type:"BooleanCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"BooleanCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"Boolean",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"Boolean",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IntCondition:{
		and:{
			type:"IntCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"IntCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"Int",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"Int",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		parts:{
			type:"ContentPartWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ContentWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ContentWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentPartWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentReferenceWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ContentPartWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ContentPartWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ContentPartWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentReferenceTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentPart:{
			type:"ContentPartWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		variant:{
			type:"ContentReferenceVariantCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		color:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		embed:{
			type:"EmbedWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"AudioUseWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUseWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		images:{
			type:"ImageContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		pollAnswer:{
			type:"PollAnswerWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		listicle:{
			type:"ListicleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		faq:{
			type:"FAQWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"LinkContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		awards:{
			type:"AwardContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		reviews:{
			type:"ReviewContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionForm:{
			type:"SubscriptionFormWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttons:{
			type:"ButtonWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		sharedContent:{
			type:"SharedContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ContentReferenceWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ContentReferenceWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ContentReferenceWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceTypeCondition:{
		and:{
			type:"ContentReferenceTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"ContentReferenceTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"ContentReferenceTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"ContentReferenceType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"ContentReferenceType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceType: "enum",
	ContentReferenceVariantCondition:{
		and:{
			type:"ContentReferenceVariantCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"ContentReferenceVariantCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"ContentReferenceVariantCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"ContentReferenceVariant",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"ContentReferenceVariant",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"ContentReferenceVariant",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"ContentReferenceVariant",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"ContentReferenceVariant",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"ContentReferenceVariant",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"ContentReferenceVariant",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"ContentReferenceVariant",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceVariant: "enum",
	EmbedWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"EmbedTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtubeId:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		vimeoId:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		spotifyId:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		spotifyType:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		soundCloudId:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"EmbedWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"EmbedWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"EmbedWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmbedTypeCondition:{
		and:{
			type:"EmbedTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"EmbedTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"EmbedTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"EmbedType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"EmbedType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"EmbedType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"EmbedType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"EmbedType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"EmbedType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"EmbedType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"EmbedType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmbedType: "enum",
	AudioUseWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"AudioWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"AudioUseWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"AudioUseWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"AudioUseWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AudioWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"AuthorWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		uses:{
			type:"AudioUseWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"AudioWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"AudioWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"AudioWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUseWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ImageUseWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ImageUseWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ImageUseWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"AuthorWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"ImageTagWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		uses:{
			type:"ImageUseWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		align:{
			type:"ImageAlignCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ImageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ImageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageTagWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		images:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ImageTagWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ImageTagWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ImageTagWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageAlignCondition:{
		and:{
			type:"ImageAlignCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"ImageAlignCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"ImageAlignCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"ImageAlign",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"ImageAlign",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"ImageAlign",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"ImageAlign",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"ImageAlign",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"ImageAlign",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"ImageAlign",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"ImageAlign",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageAlign: "enum",
	ImageContentWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentReference:{
			type:"ContentReferenceWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUseWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ImageContentWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ImageContentWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ImageContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PollAnswerWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		authorName:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		authorPosition:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		authorImage:{
			type:"ImageUseWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"PollAnswerWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"PollAnswerWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"PollAnswerWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ListicleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUseWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentReference:{
			type:"ContentReferenceWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ListicleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ListicleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ListicleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"LinkTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		externalTarget:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalTarget:{
			type:"UrlWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		queryParameters:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"LinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"LinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkTypeCondition:{
		and:{
			type:"LinkTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"LinkTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"LinkTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"LinkType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"LinkType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkType: "enum",
	FAQWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		answer:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		question:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentReference:{
			type:"ContentReferenceWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"FAQWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"FAQWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"FAQWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkContentWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentReference:{
			type:"ContentReferenceWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"LinkContentWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"LinkContentWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"LinkContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AwardContentWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUseWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentReference:{
			type:"ContentReferenceWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"AwardContentWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"AwardContentWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"AwardContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ReviewContentWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentReference:{
			type:"ContentReferenceWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ReviewContentWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ReviewContentWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ReviewContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTimeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		sections:{
			type:"SubscriptionFormSectionWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentBlock:{
			type:"ContentBlockWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		products:{
			type:"ProductWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentReferences:{
			type:"ContentReferenceWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		validity:{
			type:"DateTimeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SubscriptionFormWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SubscriptionFormWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SubscriptionFormWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DateTimeCondition:{
		and:{
			type:"DateTimeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"DateTimeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"DateTimeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"DateTime",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"DateTime",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DateTime: "String",
	SubscriptionFormSectionWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		form:{
			type:"SubscriptionFormWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		inputs:{
			type:"SubscriptionFormInputWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SubscriptionFormSectionWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SubscriptionFormSectionWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SubscriptionFormSectionWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormInputWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"SubscriptionFormInputTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUseWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		section:{
			type:"SubscriptionFormSectionWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		options:{
			type:"SubscriptionFormOptionWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		required:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SubscriptionFormInputWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SubscriptionFormInputWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SubscriptionFormInputWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormInputTypeCondition:{
		and:{
			type:"SubscriptionFormInputTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"SubscriptionFormInputTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"SubscriptionFormInputTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"SubscriptionFormInputType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"SubscriptionFormInputType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"SubscriptionFormInputType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"SubscriptionFormInputType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"SubscriptionFormInputType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"SubscriptionFormInputType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"SubscriptionFormInputType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"SubscriptionFormInputType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormInputType: "enum",
	SubscriptionFormOptionWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		hasProductId:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		priceTag:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		priceTagWithDiscount:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		products:{
			type:"ProductWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		formInput:{
			type:"SubscriptionFormInputWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		value:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLabel:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SubscriptionFormOptionWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SubscriptionFormOptionWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SubscriptionFormOptionWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		price:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"TypesCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		formOptions:{
			type:"SubscriptionFormOptionWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		form:{
			type:"SubscriptionFormWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		productId:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ProductWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ProductWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ProductWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TypesCondition:{
		and:{
			type:"TypesCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"TypesCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"TypesCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"Types",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"Types",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"Types",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"Types",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"Types",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"Types",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"Types",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"Types",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Types: "enum",
	ContentBlockWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentBlockTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtubeId:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		targetLabel:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"IssueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		articles:{
			type:"ContentArticleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionForm:{
			type:"SubscriptionFormWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ContentBlockWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ContentBlockWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ContentBlockWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockTypeCondition:{
		and:{
			type:"ContentBlockTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"ContentBlockTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"ContentBlockTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"ContentBlockType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"ContentBlockType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"ContentBlockType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"ContentBlockType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"ContentBlockType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"ContentBlockType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"ContentBlockType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"ContentBlockType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockType: "enum",
	IssueWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		closed:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		free:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		year:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishedSince:{
			type:"DateCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishedUntil:{
			type:"DateCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishDigital:{
			type:"DateTimeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		mobileAppsKey:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"UrlWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		articles:{
			type:"IssueArticleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		kind:{
			type:"IssueKindCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		notificationTitle:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		notificationMessage:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		pdf:{
			type:"FileUseWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		printBuy:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		printText:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		blocks:{
			type:"ContentBlockWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverPhoto:{
			type:"ImageUseWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		printTarget:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		backgroundPhoto:{
			type:"ImageUseWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"IssueWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"IssueWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"IssueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DateCondition:{
		and:{
			type:"DateCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"DateCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"DateCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"Date",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"Date",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Date: "String",
	IssueArticleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"IssueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"IssueArticleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"IssueArticleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"IssueArticleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueKindCondition:{
		and:{
			type:"IssueKindCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"IssueKindCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"IssueKindCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"IssueKind",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"IssueKind",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"IssueKind",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"IssueKind",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"IssueKind",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"IssueKind",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"IssueKind",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"IssueKind",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueKind: "enum",
	FileUseWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		file:{
			type:"FileWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"FileUseWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"FileUseWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"FileUseWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		uses:{
			type:"FileUseWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"FileWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"FileWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"FileWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentArticleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentBlock:{
			type:"ContentBlockWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ContentArticleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ContentArticleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ContentArticleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ButtonWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ButtonTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentReference:{
			type:"ContentReferenceWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ButtonWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ButtonWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ButtonWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ButtonTypeCondition:{
		and:{
			type:"ButtonTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"ButtonTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"ButtonTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"ButtonType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"ButtonType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"ButtonType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"ButtonType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"ButtonType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"ButtonType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"ButtonType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"ButtonType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ButtonType: "enum",
	SharedContentWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentReference:{
			type:"ContentReferenceWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SharedContentWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SharedContentWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SharedContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorTopArticleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"AuthorWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"AuthorTopArticleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"AuthorTopArticleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"AuthorTopArticleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UserWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		ihnedId:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		authors:{
			type:"AuthorWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		unlockedArticles:{
			type:"UnlockedArticleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		appReviews:{
			type:"AppReviewWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"UserWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"UserWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"UserWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UnlockedArticleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTimeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		views:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		user:{
			type:"UserWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"UnlockedArticleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"UnlockedArticleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"UnlockedArticleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppReviewWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		done:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		deviceId:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTimeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		rating:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		note:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		user:{
			type:"UserWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"AppReviewWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"AppReviewWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"AppReviewWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorCategoryCondition:{
		and:{
			type:"AuthorCategoryCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"AuthorCategoryCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"AuthorCategoryCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"AuthorCategory",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"AuthorCategory",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"AuthorCategory",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"AuthorCategory",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"AuthorCategory",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"AuthorCategory",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"AuthorCategory",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"AuthorCategory",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorCategory: "enum",
	PageWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishAt:{
			type:"DateTimeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTimeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		template:{
			type:"PageTemplateCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"UrlWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionValidity:{
			type:"DateTimeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"PageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"PageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"PageWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageTemplateCondition:{
		and:{
			type:"PageTemplateCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"PageTemplateCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"PageTemplateCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"PageTemplate",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"PageTemplate",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"PageTemplate",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"PageTemplate",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"PageTemplate",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"PageTemplate",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"PageTemplate",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"PageTemplate",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageTemplate: "enum",
	SeoWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"PageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		twCard:{
			type:"SeoTwCardCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"ImageUseWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SeoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SeoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoTwCardCondition:{
		and:{
			type:"SeoTwCardCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"SeoTwCardCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"SeoTwCardCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"SeoTwCard",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"SeoTwCard",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"SeoTwCard",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"SeoTwCard",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"SeoTwCard",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"SeoTwCard",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"SeoTwCard",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"SeoTwCard",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoTwCard: "enum",
	CategoryWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		articleCategory:{
			type:"ArticleCategoryWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"UrlWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"CategoryWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"CategoryWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"CategoryWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleCategoryWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		category:{
			type:"CategoryWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ArticleCategoryWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ArticleCategoryWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ArticleCategoryWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TagWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		useAsTagline:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		articleTag:{
			type:"ArticleTagWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"UrlWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"TagWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"TagWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"TagWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleTagWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		tag:{
			type:"TagWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ArticleTagWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ArticleTagWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ArticleTagWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleAuthorWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"AuthorWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyStringAuthor:{
			type:"ArticleAuthorLegacyStringAuthorCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ArticleAuthorWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ArticleAuthorWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ArticleAuthorWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleAuthorLegacyStringAuthorCondition:{
		and:{
			type:"ArticleAuthorLegacyStringAuthorCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"ArticleAuthorLegacyStringAuthorCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"ArticleAuthorLegacyStringAuthorCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"ArticleAuthorLegacyStringAuthor",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"ArticleAuthorLegacyStringAuthor",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"ArticleAuthorLegacyStringAuthor",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"ArticleAuthorLegacyStringAuthor",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"ArticleAuthorLegacyStringAuthor",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"ArticleAuthorLegacyStringAuthor",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"ArticleAuthorLegacyStringAuthor",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"ArticleAuthorLegacyStringAuthor",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleAuthorLegacyStringAuthor: "enum",
	ArticleStateCondition:{
		and:{
			type:"ArticleStateCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"ArticleStateCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"ArticleStateCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"ArticleState",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"ArticleState",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"ArticleState",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"ArticleState",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"ArticleState",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"ArticleState",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"ArticleState",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"ArticleState",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleState: "enum",
	TemplateCondition:{
		and:{
			type:"TemplateCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"TemplateCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"TemplateCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"Template",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"Template",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"Template",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"Template",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"Template",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"Template",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"Template",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"Template",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Template: "enum",
	TextContentWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		parts:{
			type:"TextContentPartWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"TextContentWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"TextContentWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"TextContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentPartWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"TextContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"TextContentReferenceWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"TextContentPartWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"TextContentPartWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"TextContentPartWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentReferenceWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"TextContentReferenceTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentPart:{
			type:"TextContentPartWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"TextContentReferenceWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"TextContentReferenceWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"TextContentReferenceWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentReferenceTypeCondition:{
		and:{
			type:"TextContentReferenceTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"TextContentReferenceTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"TextContentReferenceTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"TextContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"TextContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"TextContentReferenceType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"TextContentReferenceType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"TextContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"TextContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"TextContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"TextContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentReferenceType: "enum",
	ArticleTitleAlignmentCondition:{
		and:{
			type:"ArticleTitleAlignmentCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"ArticleTitleAlignmentCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"ArticleTitleAlignmentCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"ArticleTitleAlignment",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"ArticleTitleAlignment",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"ArticleTitleAlignment",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"ArticleTitleAlignment",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"ArticleTitleAlignment",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"ArticleTitleAlignment",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"ArticleTitleAlignment",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"ArticleTitleAlignment",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleTitleAlignment: "enum",
	ArticleHistoryTagWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyTag:{
			type:"HistoryTagWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ArticleHistoryTagWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ArticleHistoryTagWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ArticleHistoryTagWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTagWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		articleHistoryTag:{
			type:"ArticleHistoryTagWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		slug:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"HistoryTagWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"HistoryTagWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"HistoryTagWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleHistoryPeriodWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyPeriod:{
			type:"HistoryPeriodWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ArticleHistoryPeriodWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ArticleHistoryPeriodWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ArticleHistoryPeriodWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryPeriodWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		articleHistoryPeriod:{
			type:"ArticleHistoryPeriodWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		slug:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		cover:{
			type:"HistoryCoverWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"HistoryPeriodWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"HistoryPeriodWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"HistoryPeriodWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryCoverWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		tileParagraph:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverImage:{
			type:"ImageUseWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		tileImage:{
			type:"ImageUseWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		mobileImage:{
			type:"ImageUseWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadContent:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		annotations:{
			type:"HistoryTextListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"HistoryCoverWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"HistoryCoverWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"HistoryCoverWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTextListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"HistoryTextItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"HistoryTextListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"HistoryTextListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"HistoryTextListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTextItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		key:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"HistoryTextListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUseWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"HistoryTextItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"HistoryTextItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"HistoryTextItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Author:{
		about:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		topArticles:{
			filter:{
				type:"AuthorTopArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AuthorTopArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		users:{
			filter:{
				type:"UserWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"UserOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		photo:{
			filter:{
				type:"ImageUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		illustration:{
			filter:{
				type:"ImageUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		url:{
			filter:{
				type:"UrlWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTopArticles:{
			filter:{
				type:"AuthorTopArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AuthorTopArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateUsers:{
			filter:{
				type:"UserWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"UserOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Content:{
		parts:{
			filter:{
				type:"ContentPartWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentPartOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		partsByReferences:{
			by:{
				type:"ContentPartsByReferencesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentPartWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateParts:{
			filter:{
				type:"ContentPartWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentPartOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ContentPart:{
		content:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		references:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		referencesByEmbed:{
			by:{
				type:"ContentPartReferencesByEmbedUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		referencesByAudio:{
			by:{
				type:"ContentPartReferencesByAudioUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		referencesByImage:{
			by:{
				type:"ContentPartReferencesByImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		referencesByPollAnswer:{
			by:{
				type:"ContentPartReferencesByPollAnswerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		referencesByListicle:{
			by:{
				type:"ContentPartReferencesByListicleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		referencesByFaq:{
			by:{
				type:"ContentPartReferencesByFaqUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		referencesByLinks:{
			by:{
				type:"ContentPartReferencesByLinksUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		referencesByAwards:{
			by:{
				type:"ContentPartReferencesByAwardsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		referencesByReviews:{
			by:{
				type:"ContentPartReferencesByReviewsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		referencesByTarget:{
			by:{
				type:"ContentPartReferencesByTargetUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		referencesByButtons:{
			by:{
				type:"ContentPartReferencesByButtonsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateReferences:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ContentReference:{
		contentPart:{
			filter:{
				type:"ContentPartWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		embed:{
			filter:{
				type:"EmbedWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		article:{
			filter:{
				type:"ArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		audio:{
			filter:{
				type:"AudioUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		image:{
			filter:{
				type:"ImageUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		images:{
			filter:{
				type:"ImageContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		pollAnswer:{
			filter:{
				type:"PollAnswerWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listicle:{
			filter:{
				type:"ListicleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ListicleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		faq:{
			filter:{
				type:"FAQWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FAQOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		links:{
			filter:{
				type:"LinkContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		awards:{
			filter:{
				type:"AwardContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AwardContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		reviews:{
			filter:{
				type:"ReviewContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ReviewContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		target:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		subscriptionForm:{
			filter:{
				type:"SubscriptionFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		buttons:{
			filter:{
				type:"ButtonWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ButtonOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		sharedContent:{
			filter:{
				type:"SharedContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		buttonsByTarget:{
			by:{
				type:"ContentReferenceButtonsByTargetUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ButtonWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImages:{
			filter:{
				type:"ImageContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateListicle:{
			filter:{
				type:"ListicleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ListicleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFaq:{
			filter:{
				type:"FAQWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FAQOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinks:{
			filter:{
				type:"LinkContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateAwards:{
			filter:{
				type:"AwardContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AwardContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateReviews:{
			filter:{
				type:"ReviewContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ReviewContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateButtons:{
			filter:{
				type:"ButtonWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ButtonOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	AudioUse:{
		audio:{
			filter:{
				type:"AudioWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Audio:{
		author:{
			filter:{
				type:"AuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		uses:{
			filter:{
				type:"AudioUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AudioUseOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateUses:{
			filter:{
				type:"AudioUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AudioUseOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	AudioUseOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"AudioOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OrderDirection: "enum",
	AudioOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"AuthorOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		position:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		twitterHandle:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebookId:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		about:{
			type:"ContentOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		startOfCooperation:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		photo:{
			type:"ImageUseOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		illustration:{
			type:"ImageUseOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		category:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"UrlOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagramUsername:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUseOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"AuthorOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		align:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"AuthorOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"IssueOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"PageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		category:{
			type:"CategoryOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		tag:{
			type:"TagOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"UrlOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		hideInMostRead:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		hideAds:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		state:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		locked:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishAt:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		template:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"TextContentOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverPhoto:{
			type:"ImageUseOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleAlignment:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		tagline:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		previewContent:{
			type:"ContentOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"AudioUseOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverPhotoVertical:{
			type:"ImageUseOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		isHistory:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		closed:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		free:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		year:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishedSince:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishedUntil:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishDigital:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		mobileAppsKey:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"UrlOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		kind:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		notificationTitle:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		notificationMessage:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		pdf:{
			type:"FileUseOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		printBuy:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		printText:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverPhoto:{
			type:"ImageUseOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		printTarget:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		backgroundPhoto:{
			type:"ImageUseOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileUseOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		file:{
			type:"FileOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		externalTarget:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalTarget:{
			type:"UrlOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		queryParameters:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishAt:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		template:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"UrlOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionValidity:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"PageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		twCard:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"ImageUseOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"UrlOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TagOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		useAsTagline:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"UrlOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUse:{
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Image:{
		author:{
			filter:{
				type:"AuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		tags:{
			filter:{
				type:"ImageTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		uses:{
			filter:{
				type:"ImageUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageUseOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTags:{
			filter:{
				type:"ImageTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateUses:{
			filter:{
				type:"ImageUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageUseOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ImageTag:{
		images:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImages:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ImageTagOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageContent:{
		contentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		image:{
			filter:{
				type:"ImageUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ContentReferenceOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentPart:{
			type:"ContentPartOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		variant:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		color:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		embed:{
			type:"EmbedOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"AudioUseOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUseOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		pollAnswer:{
			type:"PollAnswerOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionForm:{
			type:"SubscriptionFormOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		sharedContent:{
			type:"SharedContentOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentPartOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmbedOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtubeId:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		vimeoId:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		spotifyId:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		spotifyType:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		soundCloudId:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PollAnswerOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		authorName:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		authorPosition:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		authorImage:{
			type:"ImageUseOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		validity:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SharedContentOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageContentOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUseOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PollAnswer:{
		authorImage:{
			filter:{
				type:"ImageUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Listicle:{
		image:{
			filter:{
				type:"ImageUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		target:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		content:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Link:{
		internalTarget:{
			filter:{
				type:"UrlWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ListicleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUseOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentReference:{
			type:"ContentReferenceOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FAQ:{
		contentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	FAQOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		answer:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		question:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentReference:{
			type:"ContentReferenceOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkContent:{
		contentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		target:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	LinkContentOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentReference:{
			type:"ContentReferenceOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AwardContent:{
		image:{
			filter:{
				type:"ImageUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		target:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	AwardContentOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUseOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentReference:{
			type:"ContentReferenceOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ReviewContent:{
		contentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ReviewContentOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentReference:{
			type:"ContentReferenceOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionForm:{
		sections:{
			filter:{
				type:"SubscriptionFormSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubscriptionFormSectionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentBlock:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		products:{
			filter:{
				type:"ProductWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProductOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentReferences:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		sectionsByInputs:{
			by:{
				type:"SubscriptionFormSectionsByInputsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentBlockByTarget:{
			by:{
				type:"SubscriptionFormContentBlockByTargetUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentBlockByArticles:{
			by:{
				type:"SubscriptionFormContentBlockByArticlesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentReferencesByEmbed:{
			by:{
				type:"SubscriptionFormContentReferencesByEmbedUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentReferencesByAudio:{
			by:{
				type:"SubscriptionFormContentReferencesByAudioUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentReferencesByImage:{
			by:{
				type:"SubscriptionFormContentReferencesByImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentReferencesByPollAnswer:{
			by:{
				type:"SubscriptionFormContentReferencesByPollAnswerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentReferencesByListicle:{
			by:{
				type:"SubscriptionFormContentReferencesByListicleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentReferencesByFaq:{
			by:{
				type:"SubscriptionFormContentReferencesByFaqUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentReferencesByLinks:{
			by:{
				type:"SubscriptionFormContentReferencesByLinksUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentReferencesByAwards:{
			by:{
				type:"SubscriptionFormContentReferencesByAwardsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentReferencesByReviews:{
			by:{
				type:"SubscriptionFormContentReferencesByReviewsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentReferencesByTarget:{
			by:{
				type:"SubscriptionFormContentReferencesByTargetUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentReferencesByButtons:{
			by:{
				type:"SubscriptionFormContentReferencesByButtonsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSections:{
			filter:{
				type:"SubscriptionFormSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubscriptionFormSectionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentBlock:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateProducts:{
			filter:{
				type:"ProductWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProductOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentReferences:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	SubscriptionFormSection:{
		form:{
			filter:{
				type:"SubscriptionFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		inputs:{
			filter:{
				type:"SubscriptionFormInputWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubscriptionFormInputOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		inputsByImage:{
			by:{
				type:"SubscriptionFormSectionInputsByImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormInputWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		inputsByOptions:{
			by:{
				type:"SubscriptionFormSectionInputsByOptionsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormInputWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		inputsByDescription:{
			by:{
				type:"SubscriptionFormSectionInputsByDescriptionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormInputWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateInputs:{
			filter:{
				type:"SubscriptionFormInputWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubscriptionFormInputOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	SubscriptionFormInput:{
		image:{
			filter:{
				type:"ImageUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		section:{
			filter:{
				type:"SubscriptionFormSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		options:{
			filter:{
				type:"SubscriptionFormOptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubscriptionFormOptionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		description:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateOptions:{
			filter:{
				type:"SubscriptionFormOptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubscriptionFormOptionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	SubscriptionFormOption:{
		products:{
			filter:{
				type:"ProductWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProductOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		formInput:{
			filter:{
				type:"SubscriptionFormInputWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateProducts:{
			filter:{
				type:"ProductWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProductOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Product:{
		formOptions:{
			filter:{
				type:"SubscriptionFormOptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubscriptionFormOptionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		form:{
			filter:{
				type:"SubscriptionFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFormOptions:{
			filter:{
				type:"SubscriptionFormOptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubscriptionFormOptionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	SubscriptionFormOptionOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		hasProductId:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		priceTag:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		priceTagWithDiscount:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		formInput:{
			type:"SubscriptionFormInputOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		value:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLabel:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormInputOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUseOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		section:{
			type:"SubscriptionFormSectionOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"ContentOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		required:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormSectionOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		form:{
			type:"SubscriptionFormOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		price:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		form:{
			type:"SubscriptionFormOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		productId:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormSectionInputsByImageUniqueWhere:{
		image:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUseUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormSectionInputsByOptionsUniqueWhere:{
		options:{
			type:"SubscriptionFormOptionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormOptionUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormSectionInputsByDescriptionUniqueWhere:{
		description:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		parts:{
			type:"ContentPartUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentPartUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		embed:{
			type:"EmbedUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"AudioUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		pollAnswer:{
			type:"PollAnswerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		listicle:{
			type:"ListicleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		faq:{
			type:"FAQUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"LinkContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		awards:{
			type:"AwardContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		reviews:{
			type:"ReviewContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttons:{
			type:"ButtonUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmbedUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AudioUseUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PollAnswerUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ListicleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FAQUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkContentUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AwardContentUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ReviewContentUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ButtonUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlock:{
		issue:{
			filter:{
				type:"IssueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		target:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		articles:{
			filter:{
				type:"ContentArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		subscriptionForm:{
			filter:{
				type:"SubscriptionFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArticles:{
			filter:{
				type:"ContentArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Issue:{
		url:{
			filter:{
				type:"UrlWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		articles:{
			filter:{
				type:"IssueArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"IssueArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		pdf:{
			filter:{
				type:"FileUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		blocks:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		coverPhoto:{
			filter:{
				type:"ImageUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		printTarget:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		backgroundPhoto:{
			filter:{
				type:"ImageUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		articlesByArticle:{
			by:{
				type:"IssueArticlesByArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"IssueArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		blocksByTarget:{
			by:{
				type:"IssueBlocksByTargetUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		blocksByArticles:{
			by:{
				type:"IssueBlocksByArticlesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArticles:{
			filter:{
				type:"IssueArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"IssueArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBlocks:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	IssueArticle:{
		issue:{
			filter:{
				type:"IssueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		article:{
			filter:{
				type:"ArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	IssueArticleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"IssueOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileUse:{
		file:{
			filter:{
				type:"FileWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	File:{
		uses:{
			filter:{
				type:"FileUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FileUseOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateUses:{
			filter:{
				type:"FileUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FileUseOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ContentBlockOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtubeId:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		targetLabel:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"IssueOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionForm:{
			type:"SubscriptionFormOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueArticlesByArticleUniqueWhere:{
		article:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"UrlUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		authors:{
			type:"ArticleAuthorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"TextContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverPhoto:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		previewContent:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"AudioUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		categories:{
			type:"ArticleCategoryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		issues:{
			type:"IssueArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentBlocks:{
			type:"ContentArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		unlocked:{
			type:"UnlockedArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverPhotoVertical:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"ArticleTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyTags:{
			type:"ArticleHistoryTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyPeriods:{
			type:"ArticleHistoryPeriodUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"AuthorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"IssueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"PageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		category:{
			type:"CategoryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		tag:{
			type:"TagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		about:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		topArticles:{
			type:"AuthorTopArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		photo:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		illustration:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"UrlUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorTopArticleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		kind:{
			type:"IssueKind",
			array:false,
			arrayRequired:false,
			required:false
		},
		year:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"UrlUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		articles:{
			type:"IssueArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		pdf:{
			type:"FileUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		blocks:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverPhoto:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		printTarget:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		backgroundPhoto:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueArticleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"IssueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileUseUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		articles:{
			type:"ContentArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentArticleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"UrlUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"PageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		articleCategory:{
			type:"ArticleCategoryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"UrlUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleCategoryUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		category:{
			type:"CategoryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TagUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		articleTag:{
			type:"ArticleTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"UrlUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleTagUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		tag:{
			type:"TagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleAuthorUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"AuthorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyStringAuthor:{
			type:"ArticleAuthorLegacyStringAuthor",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		parts:{
			type:"TextContentPartUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentPartUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"TextContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentReferenceUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UnlockedArticleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleHistoryTagUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyTag:{
			type:"HistoryTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTagUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		slug:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		articleHistoryTag:{
			type:"ArticleHistoryTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleHistoryPeriodUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyPeriod:{
			type:"HistoryPeriodUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryPeriodUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		slug:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		articleHistoryPeriod:{
			type:"ArticleHistoryPeriodUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		cover:{
			type:"HistoryCoverUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryCoverUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverImage:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		tileImage:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		mobileImage:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadContent:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		annotations:{
			type:"HistoryTextListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTextListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"HistoryTextItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTextItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueBlocksByTargetUniqueWhere:{
		target:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueBlocksByArticlesUniqueWhere:{
		articles:{
			type:"ContentArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentArticle:{
		contentBlock:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		article:{
			filter:{
				type:"ArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ContentArticleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentBlock:{
			type:"ContentBlockOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormSectionsByInputsUniqueWhere:{
		inputs:{
			type:"SubscriptionFormInputUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormInputUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		options:{
			type:"SubscriptionFormOptionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormContentBlockByTargetUniqueWhere:{
		target:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormContentBlockByArticlesUniqueWhere:{
		articles:{
			type:"ContentArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormContentReferencesByEmbedUniqueWhere:{
		embed:{
			type:"EmbedUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormContentReferencesByAudioUniqueWhere:{
		audio:{
			type:"AudioUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormContentReferencesByImageUniqueWhere:{
		image:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormContentReferencesByPollAnswerUniqueWhere:{
		pollAnswer:{
			type:"PollAnswerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormContentReferencesByListicleUniqueWhere:{
		listicle:{
			type:"ListicleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormContentReferencesByFaqUniqueWhere:{
		faq:{
			type:"FAQUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormContentReferencesByLinksUniqueWhere:{
		links:{
			type:"LinkContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormContentReferencesByAwardsUniqueWhere:{
		awards:{
			type:"AwardContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormContentReferencesByReviewsUniqueWhere:{
		reviews:{
			type:"ReviewContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormContentReferencesByTargetUniqueWhere:{
		target:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormContentReferencesByButtonsUniqueWhere:{
		buttons:{
			type:"ButtonUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Button:{
		target:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ButtonOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentReference:{
			type:"ContentReferenceOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SharedContent:{
		contentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		content:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentReferenceByEmbed:{
			by:{
				type:"SharedContentContentReferenceByEmbedUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentReferenceByAudio:{
			by:{
				type:"SharedContentContentReferenceByAudioUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentReferenceByImage:{
			by:{
				type:"SharedContentContentReferenceByImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentReferenceByPollAnswer:{
			by:{
				type:"SharedContentContentReferenceByPollAnswerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentReferenceByListicle:{
			by:{
				type:"SharedContentContentReferenceByListicleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentReferenceByFaq:{
			by:{
				type:"SharedContentContentReferenceByFaqUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentReferenceByLinks:{
			by:{
				type:"SharedContentContentReferenceByLinksUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentReferenceByAwards:{
			by:{
				type:"SharedContentContentReferenceByAwardsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentReferenceByReviews:{
			by:{
				type:"SharedContentContentReferenceByReviewsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentReferenceByTarget:{
			by:{
				type:"SharedContentContentReferenceByTargetUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contentReferenceByButtons:{
			by:{
				type:"SharedContentContentReferenceByButtonsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	SharedContentContentReferenceByEmbedUniqueWhere:{
		embed:{
			type:"EmbedUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SharedContentContentReferenceByAudioUniqueWhere:{
		audio:{
			type:"AudioUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SharedContentContentReferenceByImageUniqueWhere:{
		image:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SharedContentContentReferenceByPollAnswerUniqueWhere:{
		pollAnswer:{
			type:"PollAnswerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SharedContentContentReferenceByListicleUniqueWhere:{
		listicle:{
			type:"ListicleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SharedContentContentReferenceByFaqUniqueWhere:{
		faq:{
			type:"FAQUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SharedContentContentReferenceByLinksUniqueWhere:{
		links:{
			type:"LinkContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SharedContentContentReferenceByAwardsUniqueWhere:{
		awards:{
			type:"AwardContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SharedContentContentReferenceByReviewsUniqueWhere:{
		reviews:{
			type:"ReviewContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SharedContentContentReferenceByTargetUniqueWhere:{
		target:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SharedContentContentReferenceByButtonsUniqueWhere:{
		buttons:{
			type:"ButtonUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceButtonsByTargetUniqueWhere:{
		target:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentPartReferencesByEmbedUniqueWhere:{
		embed:{
			type:"EmbedUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentPartReferencesByAudioUniqueWhere:{
		audio:{
			type:"AudioUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentPartReferencesByImageUniqueWhere:{
		image:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentPartReferencesByPollAnswerUniqueWhere:{
		pollAnswer:{
			type:"PollAnswerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentPartReferencesByListicleUniqueWhere:{
		listicle:{
			type:"ListicleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentPartReferencesByFaqUniqueWhere:{
		faq:{
			type:"FAQUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentPartReferencesByLinksUniqueWhere:{
		links:{
			type:"LinkContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentPartReferencesByAwardsUniqueWhere:{
		awards:{
			type:"AwardContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentPartReferencesByReviewsUniqueWhere:{
		reviews:{
			type:"ReviewContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentPartReferencesByTargetUniqueWhere:{
		target:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentPartReferencesByButtonsUniqueWhere:{
		buttons:{
			type:"ButtonUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentPartsByReferencesUniqueWhere:{
		references:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorTopArticle:{
		author:{
			filter:{
				type:"AuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		article:{
			filter:{
				type:"ArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	AuthorTopArticleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"AuthorOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	User:{
		authors:{
			filter:{
				type:"AuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AuthorOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		unlockedArticles:{
			filter:{
				type:"UnlockedArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"UnlockedArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		appReviews:{
			filter:{
				type:"AppReviewWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AppReviewOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateAuthors:{
			filter:{
				type:"AuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AuthorOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateUnlockedArticles:{
			filter:{
				type:"UnlockedArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"UnlockedArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateAppReviews:{
			filter:{
				type:"AppReviewWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AppReviewOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	UnlockedArticle:{
		user:{
			filter:{
				type:"UserWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		article:{
			filter:{
				type:"ArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	UnlockedArticleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		views:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		user:{
			type:"UserOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UserOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		ihnedId:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppReview:{
		user:{
			filter:{
				type:"UserWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	AppReviewOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		done:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		deviceId:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		rating:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		note:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		user:{
			type:"UserOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Page:{
		url:{
			filter:{
				type:"UrlWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		content:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Seo:{
		page:{
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		ogImage:{
			filter:{
				type:"ImageUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Category:{
		articleCategory:{
			filter:{
				type:"ArticleCategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleCategoryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		url:{
			filter:{
				type:"UrlWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		articleCategoryByArticle:{
			by:{
				type:"CategoryArticleCategoryByArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleCategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArticleCategory:{
			filter:{
				type:"ArticleCategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleCategoryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ArticleCategory:{
		article:{
			filter:{
				type:"ArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		category:{
			filter:{
				type:"CategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ArticleCategoryOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		category:{
			type:"CategoryOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryArticleCategoryByArticleUniqueWhere:{
		article:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Tag:{
		articleTag:{
			filter:{
				type:"ArticleTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		url:{
			filter:{
				type:"UrlWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		articleTagByArticle:{
			by:{
				type:"TagArticleTagByArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArticleTag:{
			filter:{
				type:"ArticleTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ArticleTag:{
		tag:{
			filter:{
				type:"TagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		article:{
			filter:{
				type:"ArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ArticleTagOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		tag:{
			type:"TagOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TagArticleTagByArticleUniqueWhere:{
		article:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleAuthor:{
		article:{
			filter:{
				type:"ArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		author:{
			filter:{
				type:"AuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ArticleAuthorOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"AuthorOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyStringAuthor:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContent:{
		parts:{
			filter:{
				type:"TextContentPartWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TextContentPartOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		partsByReferences:{
			by:{
				type:"TextContentPartsByReferencesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextContentPartWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateParts:{
			filter:{
				type:"TextContentPartWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TextContentPartOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	TextContentPart:{
		content:{
			filter:{
				type:"TextContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		references:{
			filter:{
				type:"TextContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TextContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		referencesByTarget:{
			by:{
				type:"TextContentPartReferencesByTargetUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateReferences:{
			filter:{
				type:"TextContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TextContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	TextContentReference:{
		contentPart:{
			filter:{
				type:"TextContentPartWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		target:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	TextContentReferenceOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentPart:{
			type:"TextContentPartOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentPartOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"TextContentOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentPartReferencesByTargetUniqueWhere:{
		target:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentPartsByReferencesUniqueWhere:{
		references:{
			type:"TextContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleHistoryTag:{
		article:{
			filter:{
				type:"ArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		historyTag:{
			filter:{
				type:"HistoryTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	HistoryTag:{
		articleHistoryTag:{
			filter:{
				type:"ArticleHistoryTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleHistoryTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		articleHistoryTagByArticle:{
			by:{
				type:"HistoryTagArticleHistoryTagByArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleHistoryTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArticleHistoryTag:{
			filter:{
				type:"ArticleHistoryTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleHistoryTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ArticleHistoryTagOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyTag:{
			type:"HistoryTagOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTagOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		slug:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTagArticleHistoryTagByArticleUniqueWhere:{
		article:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleHistoryPeriod:{
		article:{
			filter:{
				type:"ArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		historyPeriod:{
			filter:{
				type:"HistoryPeriodWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	HistoryPeriod:{
		articleHistoryPeriod:{
			filter:{
				type:"ArticleHistoryPeriodWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleHistoryPeriodOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		cover:{
			filter:{
				type:"HistoryCoverWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		articleHistoryPeriodByArticle:{
			by:{
				type:"HistoryPeriodArticleHistoryPeriodByArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleHistoryPeriodWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArticleHistoryPeriod:{
			filter:{
				type:"ArticleHistoryPeriodWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleHistoryPeriodOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ArticleHistoryPeriodOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyPeriod:{
			type:"HistoryPeriodOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryPeriodOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		slug:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		cover:{
			type:"HistoryCoverOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryCoverOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		tileParagraph:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverImage:{
			type:"ImageUseOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		tileImage:{
			type:"ImageUseOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		mobileImage:{
			type:"ImageUseOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadContent:{
			type:"ContentOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		annotations:{
			type:"HistoryTextListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTextListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryCover:{
		coverImage:{
			filter:{
				type:"ImageUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		tileImage:{
			filter:{
				type:"ImageUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		mobileImage:{
			filter:{
				type:"ImageUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		leadContent:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		annotations:{
			filter:{
				type:"HistoryTextListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	HistoryTextList:{
		items:{
			filter:{
				type:"HistoryTextItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HistoryTextItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		itemsByImage:{
			by:{
				type:"HistoryTextListItemsByImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryTextItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"HistoryTextItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HistoryTextItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	HistoryTextItem:{
		list:{
			filter:{
				type:"HistoryTextListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		image:{
			filter:{
				type:"ImageUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	HistoryTextItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		key:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"HistoryTextListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUseOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTextListItemsByImageUniqueWhere:{
		image:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryPeriodArticleHistoryPeriodByArticleUniqueWhere:{
		article:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleAuthorsByAuthorUniqueWhere:{
		author:{
			type:"AuthorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleAuthorsByLegacyStringAuthorUniqueWhere:{
		legacyStringAuthor:{
			type:"ArticleAuthorLegacyStringAuthor",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleCategoriesByCategoryUniqueWhere:{
		category:{
			type:"CategoryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleIssuesByIssueUniqueWhere:{
		issue:{
			type:"IssueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleTagsByTagUniqueWhere:{
		tag:{
			type:"TagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleHistoryTagsByHistoryTagUniqueWhere:{
		historyTag:{
			type:"HistoryTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleHistoryPeriodsByHistoryPeriodUniqueWhere:{
		historyPeriod:{
			type:"HistoryPeriodUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"ArticleCreateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		authors:{
			type:"ArticleCreateAuthorsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		hideInMostRead:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		hideAds:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		state:{
			type:"ArticleState",
			array:false,
			arrayRequired:false,
			required:false
		},
		locked:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		template:{
			type:"Template",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"ArticleCreateSubtitleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ArticleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverPhoto:{
			type:"ArticleCreateCoverPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleAlignment:{
			type:"ArticleTitleAlignment",
			array:false,
			arrayRequired:false,
			required:false
		},
		tagline:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		previewContent:{
			type:"ArticleCreatePreviewContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ArticleCreateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		categories:{
			type:"ArticleCreateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		issues:{
			type:"ArticleCreateIssuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contentBlocks:{
			type:"ArticleCreateContentBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		unlocked:{
			type:"ArticleCreateUnlockedEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		coverPhotoVertical:{
			type:"ArticleCreateCoverPhotoVerticalEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"ArticleCreateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		isHistory:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyTags:{
			type:"ArticleCreateHistoryTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		historyPeriods:{
			type:"ArticleCreateHistoryPeriodsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleCreateUrlEntityRelationInput:{
		connect:{
			type:"UrlUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"UrlWithoutArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlWithoutArticleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"UrlCreateAuthorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"UrlCreateIssueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"UrlCreatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		category:{
			type:"UrlCreateCategoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tag:{
			type:"UrlCreateTagEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlCreateAuthorEntityRelationInput:{
		connect:{
			type:"AuthorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AuthorWithoutUrlCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorWithoutUrlCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		position:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		twitterHandle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebookId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		about:{
			type:"AuthorCreateAboutEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		topArticles:{
			type:"AuthorCreateTopArticlesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		users:{
			type:"AuthorCreateUsersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		startOfCooperation:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		photo:{
			type:"AuthorCreatePhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		illustration:{
			type:"AuthorCreateIllustrationEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		category:{
			type:"AuthorCategory",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagramUsername:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorCreateAboutEntityRelationInput:{
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		parts:{
			type:"ContentCreatePartsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentCreatePartsEntityRelationInput:{
		connect:{
			type:"ContentPartUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentPartWithoutContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentPartWithoutContentCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentPartCreateReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentPartCreateReferencesEntityRelationInput:{
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutContentPartCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutContentPartCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		variant:{
			type:"ContentReferenceVariant",
			array:false,
			arrayRequired:false,
			required:false
		},
		color:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		embed:{
			type:"ContentReferenceCreateEmbedEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ContentReferenceCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ContentReferenceCreateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		images:{
			type:"ContentReferenceCreateImagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pollAnswer:{
			type:"ContentReferenceCreatePollAnswerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		listicle:{
			type:"ContentReferenceCreateListicleEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		faq:{
			type:"ContentReferenceCreateFaqEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		links:{
			type:"ContentReferenceCreateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		awards:{
			type:"ContentReferenceCreateAwardsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		reviews:{
			type:"ContentReferenceCreateReviewsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		target:{
			type:"ContentReferenceCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionForm:{
			type:"ContentReferenceCreateSubscriptionFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttons:{
			type:"ContentReferenceCreateButtonsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		sharedContent:{
			type:"ContentReferenceCreateSharedContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateEmbedEntityRelationInput:{
		connect:{
			type:"EmbedUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EmbedCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmbedCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"EmbedType",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtubeId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		vimeoId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		spotifyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		spotifyType:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		soundCloudId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateArticleEntityRelationInput:{
		connect:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateAudioEntityRelationInput:{
		connect:{
			type:"AudioUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AudioUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AudioUseCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"AudioUseCreateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AudioUseCreateAudioEntityRelationInput:{
		connect:{
			type:"AudioUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AudioWithoutUsesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AudioUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		uses:{
			type:"AudioUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AudioWithoutUsesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"AudioCreateAuthorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AudioCreateAuthorEntityRelationInput:{
		connect:{
			type:"AuthorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AuthorCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		position:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		twitterHandle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebookId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		about:{
			type:"AuthorCreateAboutEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		topArticles:{
			type:"AuthorCreateTopArticlesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		users:{
			type:"AuthorCreateUsersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		startOfCooperation:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		photo:{
			type:"AuthorCreatePhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		illustration:{
			type:"AuthorCreateIllustrationEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		category:{
			type:"AuthorCategory",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"AuthorCreateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagramUsername:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorCreateTopArticlesEntityRelationInput:{
		connect:{
			type:"AuthorTopArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AuthorTopArticleWithoutAuthorCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorTopArticleWithoutAuthorCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"AuthorTopArticleCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorTopArticleCreateArticleEntityRelationInput:{
		connect:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorCreateUsersEntityRelationInput:{
		connect:{
			type:"UserUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"UserWithoutAuthorsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UserUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		ihnedId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		unlockedArticles:{
			type:"UnlockedArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		appReviews:{
			type:"AppReviewUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppReviewUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UserWithoutAuthorsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		ihnedId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		unlockedArticles:{
			type:"UserCreateUnlockedArticlesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		appReviews:{
			type:"UserCreateAppReviewsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UserCreateUnlockedArticlesEntityRelationInput:{
		connect:{
			type:"UnlockedArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"UnlockedArticleWithoutUserCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UnlockedArticleWithoutUserCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		views:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"UnlockedArticleCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UnlockedArticleCreateArticleEntityRelationInput:{
		connect:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleWithoutUnlockedCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleWithoutUnlockedCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"ArticleCreateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		authors:{
			type:"ArticleCreateAuthorsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		hideInMostRead:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		hideAds:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		state:{
			type:"ArticleState",
			array:false,
			arrayRequired:false,
			required:false
		},
		locked:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		template:{
			type:"Template",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"ArticleCreateSubtitleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ArticleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverPhoto:{
			type:"ArticleCreateCoverPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleAlignment:{
			type:"ArticleTitleAlignment",
			array:false,
			arrayRequired:false,
			required:false
		},
		tagline:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		previewContent:{
			type:"ArticleCreatePreviewContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ArticleCreateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		categories:{
			type:"ArticleCreateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		issues:{
			type:"ArticleCreateIssuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contentBlocks:{
			type:"ArticleCreateContentBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		coverPhotoVertical:{
			type:"ArticleCreateCoverPhotoVerticalEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"ArticleCreateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		isHistory:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyTags:{
			type:"ArticleCreateHistoryTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		historyPeriods:{
			type:"ArticleCreateHistoryPeriodsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleCreateAuthorsEntityRelationInput:{
		connect:{
			type:"ArticleAuthorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleAuthorWithoutArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleAuthorWithoutArticleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"ArticleAuthorCreateAuthorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyStringAuthor:{
			type:"ArticleAuthorLegacyStringAuthor",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleAuthorCreateAuthorEntityRelationInput:{
		connect:{
			type:"AuthorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AuthorCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleCreateSubtitleEntityRelationInput:{
		connect:{
			type:"TextContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TextContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		parts:{
			type:"TextContentCreatePartsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentCreatePartsEntityRelationInput:{
		connect:{
			type:"TextContentPartUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TextContentPartWithoutContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentPartWithoutContentCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"TextContentPartCreateReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentPartCreateReferencesEntityRelationInput:{
		connect:{
			type:"TextContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TextContentReferenceWithoutContentPartCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentReferenceWithoutContentPartCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"TextContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"TextContentReferenceCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentReferenceCreateTargetEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		externalTarget:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalTarget:{
			type:"LinkCreateInternalTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		queryParameters:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkCreateInternalTargetEntityRelationInput:{
		connect:{
			type:"UrlUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"UrlCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"UrlCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"UrlCreateAuthorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"UrlCreateIssueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"UrlCreatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		category:{
			type:"UrlCreateCategoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tag:{
			type:"UrlCreateTagEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlCreateArticleEntityRelationInput:{
		connect:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleWithoutUrlCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleWithoutUrlCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		authors:{
			type:"ArticleCreateAuthorsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		hideInMostRead:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		hideAds:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		state:{
			type:"ArticleState",
			array:false,
			arrayRequired:false,
			required:false
		},
		locked:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		template:{
			type:"Template",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"ArticleCreateSubtitleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ArticleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverPhoto:{
			type:"ArticleCreateCoverPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleAlignment:{
			type:"ArticleTitleAlignment",
			array:false,
			arrayRequired:false,
			required:false
		},
		tagline:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		previewContent:{
			type:"ArticleCreatePreviewContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ArticleCreateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		categories:{
			type:"ArticleCreateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		issues:{
			type:"ArticleCreateIssuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contentBlocks:{
			type:"ArticleCreateContentBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		unlocked:{
			type:"ArticleCreateUnlockedEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		coverPhotoVertical:{
			type:"ArticleCreateCoverPhotoVerticalEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"ArticleCreateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		isHistory:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyTags:{
			type:"ArticleCreateHistoryTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		historyPeriods:{
			type:"ArticleCreateHistoryPeriodsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleCreateContentEntityRelationInput:{
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleCreateCoverPhotoEntityRelationInput:{
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUseCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUseCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUseCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageWithoutUsesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		uses:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageWithoutUsesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"ImageCreateAuthorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"ImageCreateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		align:{
			type:"ImageAlign",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageCreateAuthorEntityRelationInput:{
		connect:{
			type:"AuthorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AuthorCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageCreateTagsEntityRelationInput:{
		connect:{
			type:"ImageTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageTagWithoutImagesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageTagUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageTagWithoutImagesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleCreatePreviewContentEntityRelationInput:{
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleCreateAudioEntityRelationInput:{
		connect:{
			type:"AudioUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AudioUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleCreateCategoriesEntityRelationInput:{
		connect:{
			type:"ArticleCategoryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleCategoryWithoutArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleCategoryWithoutArticleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		category:{
			type:"ArticleCategoryCreateCategoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleCategoryCreateCategoryEntityRelationInput:{
		connect:{
			type:"CategoryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"CategoryWithoutArticleCategoryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryWithoutArticleCategoryCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"CategoryCreateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryCreateUrlEntityRelationInput:{
		connect:{
			type:"UrlUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"UrlWithoutCategoryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlWithoutCategoryCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"UrlCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"UrlCreateAuthorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"UrlCreateIssueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"UrlCreatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tag:{
			type:"UrlCreateTagEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlCreateIssueEntityRelationInput:{
		connect:{
			type:"IssueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"IssueWithoutUrlCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueWithoutUrlCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		closed:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		free:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		year:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishedSince:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishedUntil:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishDigital:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		mobileAppsKey:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		articles:{
			type:"IssueCreateArticlesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		kind:{
			type:"IssueKind",
			array:false,
			arrayRequired:false,
			required:false
		},
		notificationTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		notificationMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		pdf:{
			type:"IssueCreatePdfEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		printBuy:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		printText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		blocks:{
			type:"IssueCreateBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		coverPhoto:{
			type:"IssueCreateCoverPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		printTarget:{
			type:"IssueCreatePrintTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		backgroundPhoto:{
			type:"IssueCreateBackgroundPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueCreateArticlesEntityRelationInput:{
		connect:{
			type:"IssueArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"IssueArticleWithoutIssueCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueArticleWithoutIssueCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"IssueArticleCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueArticleCreateArticleEntityRelationInput:{
		connect:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleWithoutIssuesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleWithoutIssuesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"ArticleCreateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		authors:{
			type:"ArticleCreateAuthorsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		hideInMostRead:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		hideAds:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		state:{
			type:"ArticleState",
			array:false,
			arrayRequired:false,
			required:false
		},
		locked:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		template:{
			type:"Template",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"ArticleCreateSubtitleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ArticleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverPhoto:{
			type:"ArticleCreateCoverPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleAlignment:{
			type:"ArticleTitleAlignment",
			array:false,
			arrayRequired:false,
			required:false
		},
		tagline:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		previewContent:{
			type:"ArticleCreatePreviewContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ArticleCreateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		categories:{
			type:"ArticleCreateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contentBlocks:{
			type:"ArticleCreateContentBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		unlocked:{
			type:"ArticleCreateUnlockedEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		coverPhotoVertical:{
			type:"ArticleCreateCoverPhotoVerticalEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"ArticleCreateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		isHistory:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyTags:{
			type:"ArticleCreateHistoryTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		historyPeriods:{
			type:"ArticleCreateHistoryPeriodsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleCreateContentBlocksEntityRelationInput:{
		connect:{
			type:"ContentArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentArticleWithoutArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentArticleWithoutArticleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentBlock:{
			type:"ContentArticleCreateContentBlockEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentArticleCreateContentBlockEntityRelationInput:{
		connect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentBlockWithoutArticlesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWithoutArticlesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentBlockType",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtubeId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		targetLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"ContentBlockCreateIssueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"ContentBlockCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionForm:{
			type:"ContentBlockCreateSubscriptionFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockCreateIssueEntityRelationInput:{
		connect:{
			type:"IssueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"IssueWithoutBlocksCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueWithoutBlocksCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		closed:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		free:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		year:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishedSince:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishedUntil:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishDigital:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		mobileAppsKey:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"IssueCreateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		articles:{
			type:"IssueCreateArticlesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		kind:{
			type:"IssueKind",
			array:false,
			arrayRequired:false,
			required:false
		},
		notificationTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		notificationMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		pdf:{
			type:"IssueCreatePdfEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		printBuy:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		printText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverPhoto:{
			type:"IssueCreateCoverPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		printTarget:{
			type:"IssueCreatePrintTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		backgroundPhoto:{
			type:"IssueCreateBackgroundPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueCreateUrlEntityRelationInput:{
		connect:{
			type:"UrlUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"UrlWithoutIssueCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlWithoutIssueCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"UrlCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"UrlCreateAuthorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"UrlCreatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		category:{
			type:"UrlCreateCategoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tag:{
			type:"UrlCreateTagEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlCreatePageEntityRelationInput:{
		connect:{
			type:"PageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PageWithoutUrlCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageWithoutUrlCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		template:{
			type:"PageTemplate",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"PageCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionValidity:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageCreateContentEntityRelationInput:{
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoWithoutPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoWithoutPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		twCard:{
			type:"SeoTwCard",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"SeoCreateOgImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoCreateOgImageEntityRelationInput:{
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlCreateCategoryEntityRelationInput:{
		connect:{
			type:"CategoryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"CategoryWithoutUrlCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryWithoutUrlCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		articleCategory:{
			type:"CategoryCreateArticleCategoryEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryCreateArticleCategoryEntityRelationInput:{
		connect:{
			type:"ArticleCategoryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleCategoryWithoutCategoryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleCategoryWithoutCategoryCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleCategoryCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleCategoryCreateArticleEntityRelationInput:{
		connect:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleWithoutCategoriesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleWithoutCategoriesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"ArticleCreateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		authors:{
			type:"ArticleCreateAuthorsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		hideInMostRead:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		hideAds:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		state:{
			type:"ArticleState",
			array:false,
			arrayRequired:false,
			required:false
		},
		locked:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		template:{
			type:"Template",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"ArticleCreateSubtitleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ArticleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverPhoto:{
			type:"ArticleCreateCoverPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleAlignment:{
			type:"ArticleTitleAlignment",
			array:false,
			arrayRequired:false,
			required:false
		},
		tagline:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		previewContent:{
			type:"ArticleCreatePreviewContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ArticleCreateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		issues:{
			type:"ArticleCreateIssuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contentBlocks:{
			type:"ArticleCreateContentBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		unlocked:{
			type:"ArticleCreateUnlockedEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		coverPhotoVertical:{
			type:"ArticleCreateCoverPhotoVerticalEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"ArticleCreateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		isHistory:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyTags:{
			type:"ArticleCreateHistoryTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		historyPeriods:{
			type:"ArticleCreateHistoryPeriodsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleCreateIssuesEntityRelationInput:{
		connect:{
			type:"IssueArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"IssueArticleWithoutArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueArticleWithoutArticleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"IssueArticleCreateIssueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueArticleCreateIssueEntityRelationInput:{
		connect:{
			type:"IssueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"IssueWithoutArticlesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueWithoutArticlesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		closed:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		free:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		year:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishedSince:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishedUntil:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishDigital:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		mobileAppsKey:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"IssueCreateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		kind:{
			type:"IssueKind",
			array:false,
			arrayRequired:false,
			required:false
		},
		notificationTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		notificationMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		pdf:{
			type:"IssueCreatePdfEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		printBuy:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		printText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		blocks:{
			type:"IssueCreateBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		coverPhoto:{
			type:"IssueCreateCoverPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		printTarget:{
			type:"IssueCreatePrintTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		backgroundPhoto:{
			type:"IssueCreateBackgroundPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueCreatePdfEntityRelationInput:{
		connect:{
			type:"FileUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FileUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileUseCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		file:{
			type:"FileUseCreateFileEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileUseCreateFileEntityRelationInput:{
		connect:{
			type:"FileUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FileWithoutUsesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		uses:{
			type:"FileUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileWithoutUsesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueCreateBlocksEntityRelationInput:{
		connect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentBlockWithoutIssueCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWithoutIssueCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentBlockType",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtubeId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		targetLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"ContentBlockCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		articles:{
			type:"ContentBlockCreateArticlesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		subscriptionForm:{
			type:"ContentBlockCreateSubscriptionFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockCreateTargetEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockCreateArticlesEntityRelationInput:{
		connect:{
			type:"ContentArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentArticleWithoutContentBlockCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentArticleWithoutContentBlockCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ContentArticleCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentArticleCreateArticleEntityRelationInput:{
		connect:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleWithoutContentBlocksCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleWithoutContentBlocksCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"ArticleCreateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		authors:{
			type:"ArticleCreateAuthorsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		hideInMostRead:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		hideAds:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		state:{
			type:"ArticleState",
			array:false,
			arrayRequired:false,
			required:false
		},
		locked:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		template:{
			type:"Template",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"ArticleCreateSubtitleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ArticleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverPhoto:{
			type:"ArticleCreateCoverPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleAlignment:{
			type:"ArticleTitleAlignment",
			array:false,
			arrayRequired:false,
			required:false
		},
		tagline:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		previewContent:{
			type:"ArticleCreatePreviewContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ArticleCreateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		categories:{
			type:"ArticleCreateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		issues:{
			type:"ArticleCreateIssuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		unlocked:{
			type:"ArticleCreateUnlockedEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		coverPhotoVertical:{
			type:"ArticleCreateCoverPhotoVerticalEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"ArticleCreateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		isHistory:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyTags:{
			type:"ArticleCreateHistoryTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		historyPeriods:{
			type:"ArticleCreateHistoryPeriodsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleCreateUnlockedEntityRelationInput:{
		connect:{
			type:"UnlockedArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"UnlockedArticleWithoutArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UnlockedArticleWithoutArticleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		views:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		user:{
			type:"UnlockedArticleCreateUserEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UnlockedArticleCreateUserEntityRelationInput:{
		connect:{
			type:"UserUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"UserWithoutUnlockedArticlesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UserWithoutUnlockedArticlesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		ihnedId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		authors:{
			type:"UserCreateAuthorsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		appReviews:{
			type:"UserCreateAppReviewsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UserCreateAuthorsEntityRelationInput:{
		connect:{
			type:"AuthorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AuthorWithoutUsersCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorWithoutUsersCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		position:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		twitterHandle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebookId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		about:{
			type:"AuthorCreateAboutEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		topArticles:{
			type:"AuthorCreateTopArticlesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		startOfCooperation:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		photo:{
			type:"AuthorCreatePhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		illustration:{
			type:"AuthorCreateIllustrationEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		category:{
			type:"AuthorCategory",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"AuthorCreateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagramUsername:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorCreatePhotoEntityRelationInput:{
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorCreateIllustrationEntityRelationInput:{
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorCreateUrlEntityRelationInput:{
		connect:{
			type:"UrlUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"UrlWithoutAuthorCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlWithoutAuthorCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"UrlCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"UrlCreateIssueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"UrlCreatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		category:{
			type:"UrlCreateCategoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tag:{
			type:"UrlCreateTagEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlCreateTagEntityRelationInput:{
		connect:{
			type:"TagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TagWithoutUrlCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TagWithoutUrlCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		useAsTagline:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		articleTag:{
			type:"TagCreateArticleTagEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		order:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TagCreateArticleTagEntityRelationInput:{
		connect:{
			type:"ArticleTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleTagWithoutTagCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleTagWithoutTagCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleTagCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleTagCreateArticleEntityRelationInput:{
		connect:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleWithoutTagsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleWithoutTagsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"ArticleCreateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		authors:{
			type:"ArticleCreateAuthorsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		hideInMostRead:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		hideAds:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		state:{
			type:"ArticleState",
			array:false,
			arrayRequired:false,
			required:false
		},
		locked:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		template:{
			type:"Template",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"ArticleCreateSubtitleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ArticleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverPhoto:{
			type:"ArticleCreateCoverPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleAlignment:{
			type:"ArticleTitleAlignment",
			array:false,
			arrayRequired:false,
			required:false
		},
		tagline:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		previewContent:{
			type:"ArticleCreatePreviewContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ArticleCreateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		categories:{
			type:"ArticleCreateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		issues:{
			type:"ArticleCreateIssuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contentBlocks:{
			type:"ArticleCreateContentBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		unlocked:{
			type:"ArticleCreateUnlockedEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		coverPhotoVertical:{
			type:"ArticleCreateCoverPhotoVerticalEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		isHistory:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyTags:{
			type:"ArticleCreateHistoryTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		historyPeriods:{
			type:"ArticleCreateHistoryPeriodsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleCreateCoverPhotoVerticalEntityRelationInput:{
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleCreateHistoryTagsEntityRelationInput:{
		connect:{
			type:"ArticleHistoryTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleHistoryTagWithoutArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleHistoryTagWithoutArticleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyTag:{
			type:"ArticleHistoryTagCreateHistoryTagEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleHistoryTagCreateHistoryTagEntityRelationInput:{
		connect:{
			type:"HistoryTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HistoryTagWithoutArticleHistoryTagCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTagWithoutArticleHistoryTagCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		slug:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleCreateHistoryPeriodsEntityRelationInput:{
		connect:{
			type:"ArticleHistoryPeriodUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleHistoryPeriodWithoutArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleHistoryPeriodWithoutArticleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyPeriod:{
			type:"ArticleHistoryPeriodCreateHistoryPeriodEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleHistoryPeriodCreateHistoryPeriodEntityRelationInput:{
		connect:{
			type:"HistoryPeriodUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HistoryPeriodWithoutArticleHistoryPeriodCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryPeriodWithoutArticleHistoryPeriodCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		slug:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		cover:{
			type:"HistoryPeriodCreateCoverEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"HistoryPeriodCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryPeriodCreateCoverEntityRelationInput:{
		connect:{
			type:"HistoryCoverUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HistoryCoverCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryCoverCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tileParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverImage:{
			type:"HistoryCoverCreateCoverImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tileImage:{
			type:"HistoryCoverCreateTileImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		mobileImage:{
			type:"HistoryCoverCreateMobileImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadContent:{
			type:"HistoryCoverCreateLeadContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		annotations:{
			type:"HistoryCoverCreateAnnotationsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryCoverCreateCoverImageEntityRelationInput:{
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryCoverCreateTileImageEntityRelationInput:{
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryCoverCreateMobileImageEntityRelationInput:{
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryCoverCreateLeadContentEntityRelationInput:{
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryCoverCreateAnnotationsEntityRelationInput:{
		connect:{
			type:"HistoryTextListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HistoryTextListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTextListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"HistoryTextListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTextListCreateItemsEntityRelationInput:{
		connect:{
			type:"HistoryTextItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HistoryTextItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTextItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		key:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"HistoryTextItemCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTextItemCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryPeriodCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"SeoCreatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		twCard:{
			type:"SeoTwCard",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"SeoCreateOgImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoCreatePageEntityRelationInput:{
		connect:{
			type:"PageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PageWithoutSeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageWithoutSeoCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		template:{
			type:"PageTemplate",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"PageCreateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"PageCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionValidity:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageCreateUrlEntityRelationInput:{
		connect:{
			type:"UrlUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"UrlWithoutPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlWithoutPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"UrlCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"UrlCreateAuthorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"UrlCreateIssueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		category:{
			type:"UrlCreateCategoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tag:{
			type:"UrlCreateTagEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UserCreateAppReviewsEntityRelationInput:{
		connect:{
			type:"AppReviewUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AppReviewWithoutUserCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppReviewWithoutUserCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		done:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		deviceId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		rating:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		note:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleCreateTagsEntityRelationInput:{
		connect:{
			type:"ArticleTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleTagWithoutArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleTagWithoutArticleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		tag:{
			type:"ArticleTagCreateTagEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleTagCreateTagEntityRelationInput:{
		connect:{
			type:"TagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TagWithoutArticleTagCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TagWithoutArticleTagCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		useAsTagline:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"TagCreateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TagCreateUrlEntityRelationInput:{
		connect:{
			type:"UrlUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"UrlWithoutTagCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlWithoutTagCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"UrlCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"UrlCreateAuthorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"UrlCreateIssueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"UrlCreatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		category:{
			type:"UrlCreateCategoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockCreateSubscriptionFormEntityRelationInput:{
		connect:{
			type:"SubscriptionFormUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SubscriptionFormWithoutContentBlockCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		sections:{
			type:"SubscriptionFormSectionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentBlock:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		products:{
			type:"ProductUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentReferences:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormSectionUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		inputs:{
			type:"SubscriptionFormInputUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormWithoutContentBlockCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		sections:{
			type:"SubscriptionFormCreateSectionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		products:{
			type:"SubscriptionFormCreateProductsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contentReferences:{
			type:"SubscriptionFormCreateContentReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		validity:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormCreateSectionsEntityRelationInput:{
		connect:{
			type:"SubscriptionFormSectionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SubscriptionFormSectionWithoutFormCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormSectionWithoutFormCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		inputs:{
			type:"SubscriptionFormSectionCreateInputsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormSectionCreateInputsEntityRelationInput:{
		connect:{
			type:"SubscriptionFormInputUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SubscriptionFormInputWithoutSectionCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormInputWithoutSectionCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"SubscriptionFormInputType",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"SubscriptionFormInputCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		options:{
			type:"SubscriptionFormInputCreateOptionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		description:{
			type:"SubscriptionFormInputCreateDescriptionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		required:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormInputCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormInputCreateOptionsEntityRelationInput:{
		connect:{
			type:"SubscriptionFormOptionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SubscriptionFormOptionWithoutFormInputCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormOptionWithoutFormInputCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		hasProductId:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		priceTag:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		priceTagWithDiscount:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		products:{
			type:"SubscriptionFormOptionCreateProductsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		value:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormOptionCreateProductsEntityRelationInput:{
		connect:{
			type:"ProductUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProductWithoutFormOptionsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductWithoutFormOptionsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		price:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"Types",
			array:false,
			arrayRequired:false,
			required:false
		},
		form:{
			type:"ProductCreateFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		productId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductCreateFormEntityRelationInput:{
		connect:{
			type:"SubscriptionFormUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SubscriptionFormWithoutProductsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormWithoutProductsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		sections:{
			type:"SubscriptionFormCreateSectionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contentBlock:{
			type:"SubscriptionFormCreateContentBlockEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contentReferences:{
			type:"SubscriptionFormCreateContentReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		validity:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormCreateContentBlockEntityRelationInput:{
		connect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentBlockWithoutSubscriptionFormCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWithoutSubscriptionFormCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentBlockType",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtubeId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		targetLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"ContentBlockCreateIssueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"ContentBlockCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		articles:{
			type:"ContentBlockCreateArticlesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormCreateContentReferencesEntityRelationInput:{
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutSubscriptionFormCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutSubscriptionFormCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentPart:{
			type:"ContentReferenceCreateContentPartEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		variant:{
			type:"ContentReferenceVariant",
			array:false,
			arrayRequired:false,
			required:false
		},
		color:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		embed:{
			type:"ContentReferenceCreateEmbedEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ContentReferenceCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ContentReferenceCreateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		images:{
			type:"ContentReferenceCreateImagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pollAnswer:{
			type:"ContentReferenceCreatePollAnswerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		listicle:{
			type:"ContentReferenceCreateListicleEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		faq:{
			type:"ContentReferenceCreateFaqEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		links:{
			type:"ContentReferenceCreateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		awards:{
			type:"ContentReferenceCreateAwardsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		reviews:{
			type:"ContentReferenceCreateReviewsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		target:{
			type:"ContentReferenceCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttons:{
			type:"ContentReferenceCreateButtonsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		sharedContent:{
			type:"ContentReferenceCreateSharedContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateContentPartEntityRelationInput:{
		connect:{
			type:"ContentPartUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentPartWithoutReferencesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentPartWithoutReferencesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentPartCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentPartCreateContentEntityRelationInput:{
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentWithoutPartsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentWithoutPartsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateImagesEntityRelationInput:{
		connect:{
			type:"ImageContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageContentWithoutContentReferenceCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageContentUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageContentWithoutContentReferenceCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageContentCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageContentCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreatePollAnswerEntityRelationInput:{
		connect:{
			type:"PollAnswerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PollAnswerCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PollAnswerCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		authorName:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		authorPosition:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		authorImage:{
			type:"PollAnswerCreateAuthorImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PollAnswerCreateAuthorImageEntityRelationInput:{
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateListicleEntityRelationInput:{
		connect:{
			type:"ListicleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ListicleWithoutContentReferenceCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ListicleWithoutContentReferenceCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ListicleCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"ListicleCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ListicleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ListicleCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ListicleCreateTargetEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ListicleCreateContentEntityRelationInput:{
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateFaqEntityRelationInput:{
		connect:{
			type:"FAQUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FAQWithoutContentReferenceCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FAQWithoutContentReferenceCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		answer:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		question:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateLinksEntityRelationInput:{
		connect:{
			type:"LinkContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkContentWithoutContentReferenceCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkContentWithoutContentReferenceCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"LinkContentCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkContentCreateTargetEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateAwardsEntityRelationInput:{
		connect:{
			type:"AwardContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AwardContentWithoutContentReferenceCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AwardContentWithoutContentReferenceCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"AwardContentCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"AwardContentCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AwardContentCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AwardContentCreateTargetEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateReviewsEntityRelationInput:{
		connect:{
			type:"ReviewContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ReviewContentWithoutContentReferenceCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ReviewContentWithoutContentReferenceCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateTargetEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateButtonsEntityRelationInput:{
		connect:{
			type:"ButtonUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ButtonWithoutContentReferenceCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ButtonWithoutContentReferenceCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ButtonType",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"ButtonCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ButtonCreateTargetEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateSharedContentEntityRelationInput:{
		connect:{
			type:"SharedContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SharedContentWithoutContentReferenceCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SharedContentUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentReference:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SharedContentWithoutContentReferenceCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"SharedContentCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SharedContentCreateContentEntityRelationInput:{
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormInputCreateDescriptionEntityRelationInput:{
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormCreateProductsEntityRelationInput:{
		connect:{
			type:"ProductUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProductWithoutFormCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductWithoutFormCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		price:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"Types",
			array:false,
			arrayRequired:false,
			required:false
		},
		formOptions:{
			type:"ProductCreateFormOptionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		productId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductCreateFormOptionsEntityRelationInput:{
		connect:{
			type:"SubscriptionFormOptionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SubscriptionFormOptionWithoutProductsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormOptionWithoutProductsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		hasProductId:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		priceTag:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		priceTagWithDiscount:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		formInput:{
			type:"SubscriptionFormOptionCreateFormInputEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		value:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormOptionCreateFormInputEntityRelationInput:{
		connect:{
			type:"SubscriptionFormInputUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SubscriptionFormInputWithoutOptionsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormInputWithoutOptionsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"SubscriptionFormInputType",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"SubscriptionFormInputCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		section:{
			type:"SubscriptionFormInputCreateSectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"SubscriptionFormInputCreateDescriptionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		required:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormInputCreateSectionEntityRelationInput:{
		connect:{
			type:"SubscriptionFormSectionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SubscriptionFormSectionWithoutInputsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormSectionWithoutInputsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		form:{
			type:"SubscriptionFormSectionCreateFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormSectionCreateFormEntityRelationInput:{
		connect:{
			type:"SubscriptionFormUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SubscriptionFormWithoutSectionsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormWithoutSectionsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentBlock:{
			type:"SubscriptionFormCreateContentBlockEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		products:{
			type:"SubscriptionFormCreateProductsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contentReferences:{
			type:"SubscriptionFormCreateContentReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		validity:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueCreateCoverPhotoEntityRelationInput:{
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueCreatePrintTargetEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueCreateBackgroundPhotoEntityRelationInput:{
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateSubscriptionFormEntityRelationInput:{
		connect:{
			type:"SubscriptionFormUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SubscriptionFormWithoutContentReferencesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormWithoutContentReferencesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		sections:{
			type:"SubscriptionFormCreateSectionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contentBlock:{
			type:"SubscriptionFormCreateContentBlockEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		products:{
			type:"SubscriptionFormCreateProductsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		validity:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"ArticleUpdateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		authors:{
			type:"ArticleUpdateAuthorsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		hideInMostRead:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		hideAds:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		state:{
			type:"ArticleState",
			array:false,
			arrayRequired:false,
			required:false
		},
		locked:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		template:{
			type:"Template",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"ArticleUpdateSubtitleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ArticleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverPhoto:{
			type:"ArticleUpdateCoverPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleAlignment:{
			type:"ArticleTitleAlignment",
			array:false,
			arrayRequired:false,
			required:false
		},
		tagline:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		previewContent:{
			type:"ArticleUpdatePreviewContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ArticleUpdateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		categories:{
			type:"ArticleUpdateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		issues:{
			type:"ArticleUpdateIssuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contentBlocks:{
			type:"ArticleUpdateContentBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		unlocked:{
			type:"ArticleUpdateUnlockedEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		coverPhotoVertical:{
			type:"ArticleUpdateCoverPhotoVerticalEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"ArticleUpdateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		isHistory:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyTags:{
			type:"ArticleUpdateHistoryTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		historyPeriods:{
			type:"ArticleUpdateHistoryPeriodsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpdateUrlEntityRelationInput:{
		create:{
			type:"UrlWithoutArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"UrlWithoutArticleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArticleUpsertUrlRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"UrlUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlWithoutArticleUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"UrlUpdateAuthorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"UrlUpdateIssueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"UrlUpdatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		category:{
			type:"UrlUpdateCategoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tag:{
			type:"UrlUpdateTagEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlUpdateAuthorEntityRelationInput:{
		create:{
			type:"AuthorWithoutUrlCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"AuthorWithoutUrlUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"UrlUpsertAuthorRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"AuthorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorWithoutUrlUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		position:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		twitterHandle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebookId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		about:{
			type:"AuthorUpdateAboutEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		topArticles:{
			type:"AuthorUpdateTopArticlesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		users:{
			type:"AuthorUpdateUsersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		startOfCooperation:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		photo:{
			type:"AuthorUpdatePhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		illustration:{
			type:"AuthorUpdateIllustrationEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		category:{
			type:"AuthorCategory",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagramUsername:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorUpdateAboutEntityRelationInput:{
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"AuthorUpsertAboutRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentUpdateInput:{
		parts:{
			type:"ContentUpdatePartsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentUpdatePartsEntityRelationInput:{
		create:{
			type:"ContentPartWithoutContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentUpdatePartsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentUpsertPartsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentPartUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ContentPartUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ContentPartUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentUpdatePartsRelationInput:{
		by:{
			type:"ContentPartUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ContentPartWithoutContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentPartWithoutContentUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentPartUpdateReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentPartUpdateReferencesEntityRelationInput:{
		create:{
			type:"ContentReferenceWithoutContentPartCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentPartUpdateReferencesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentPartUpsertReferencesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentPartUpdateReferencesRelationInput:{
		by:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ContentReferenceWithoutContentPartUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutContentPartUpdateInput:{
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		variant:{
			type:"ContentReferenceVariant",
			array:false,
			arrayRequired:false,
			required:false
		},
		color:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		embed:{
			type:"ContentReferenceUpdateEmbedEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ContentReferenceUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ContentReferenceUpdateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		images:{
			type:"ContentReferenceUpdateImagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pollAnswer:{
			type:"ContentReferenceUpdatePollAnswerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		listicle:{
			type:"ContentReferenceUpdateListicleEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		faq:{
			type:"ContentReferenceUpdateFaqEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		links:{
			type:"ContentReferenceUpdateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		awards:{
			type:"ContentReferenceUpdateAwardsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		reviews:{
			type:"ContentReferenceUpdateReviewsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		target:{
			type:"ContentReferenceUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionForm:{
			type:"ContentReferenceUpdateSubscriptionFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttons:{
			type:"ContentReferenceUpdateButtonsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		sharedContent:{
			type:"ContentReferenceUpdateSharedContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateEmbedEntityRelationInput:{
		create:{
			type:"EmbedCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"EmbedUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertEmbedRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"EmbedUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmbedUpdateInput:{
		type:{
			type:"EmbedType",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtubeId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		vimeoId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		spotifyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		spotifyType:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		soundCloudId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertEmbedRelationInput:{
		update:{
			type:"EmbedUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EmbedCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateArticleEntityRelationInput:{
		create:{
			type:"ArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArticleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertArticleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertArticleRelationInput:{
		update:{
			type:"ArticleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateAudioEntityRelationInput:{
		create:{
			type:"AudioUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"AudioUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertAudioRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"AudioUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AudioUseUpdateInput:{
		audio:{
			type:"AudioUseUpdateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AudioUseUpdateAudioEntityRelationInput:{
		create:{
			type:"AudioWithoutUsesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"AudioWithoutUsesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"AudioUseUpsertAudioRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"AudioUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AudioWithoutUsesUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"AudioUpdateAuthorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AudioUpdateAuthorEntityRelationInput:{
		create:{
			type:"AuthorCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"AuthorUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"AudioUpsertAuthorRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"AuthorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		position:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		twitterHandle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebookId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		about:{
			type:"AuthorUpdateAboutEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		topArticles:{
			type:"AuthorUpdateTopArticlesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		users:{
			type:"AuthorUpdateUsersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		startOfCooperation:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		photo:{
			type:"AuthorUpdatePhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		illustration:{
			type:"AuthorUpdateIllustrationEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		category:{
			type:"AuthorCategory",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"AuthorUpdateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagramUsername:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorUpdateTopArticlesEntityRelationInput:{
		create:{
			type:"AuthorTopArticleWithoutAuthorCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"AuthorUpdateTopArticlesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"AuthorUpsertTopArticlesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"AuthorTopArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"AuthorTopArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"AuthorTopArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorUpdateTopArticlesRelationInput:{
		by:{
			type:"AuthorTopArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"AuthorTopArticleWithoutAuthorUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorTopArticleWithoutAuthorUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"AuthorTopArticleUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorTopArticleUpdateArticleEntityRelationInput:{
		create:{
			type:"ArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArticleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"AuthorTopArticleUpsertArticleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorTopArticleUpsertArticleRelationInput:{
		update:{
			type:"ArticleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorUpsertTopArticlesRelationInput:{
		by:{
			type:"AuthorTopArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"AuthorTopArticleWithoutAuthorUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AuthorTopArticleWithoutAuthorCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorUpdateUsersEntityRelationInput:{
		create:{
			type:"UserWithoutAuthorsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"AuthorUpdateUsersRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"AuthorUpsertUsersRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"UserUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"UserUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"UserUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorUpdateUsersRelationInput:{
		by:{
			type:"UserUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"UserWithoutAuthorsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UserWithoutAuthorsUpdateInput:{
		ihnedId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		unlockedArticles:{
			type:"UserUpdateUnlockedArticlesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		appReviews:{
			type:"UserUpdateAppReviewsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UserUpdateUnlockedArticlesEntityRelationInput:{
		create:{
			type:"UnlockedArticleWithoutUserCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"UserUpdateUnlockedArticlesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"UserUpsertUnlockedArticlesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"UnlockedArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"UnlockedArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"UnlockedArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UserUpdateUnlockedArticlesRelationInput:{
		by:{
			type:"UnlockedArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"UnlockedArticleWithoutUserUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UnlockedArticleWithoutUserUpdateInput:{
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		views:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"UnlockedArticleUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UnlockedArticleUpdateArticleEntityRelationInput:{
		create:{
			type:"ArticleWithoutUnlockedCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArticleWithoutUnlockedUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"UnlockedArticleUpsertArticleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleWithoutUnlockedUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"ArticleUpdateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		authors:{
			type:"ArticleUpdateAuthorsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		hideInMostRead:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		hideAds:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		state:{
			type:"ArticleState",
			array:false,
			arrayRequired:false,
			required:false
		},
		locked:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		template:{
			type:"Template",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"ArticleUpdateSubtitleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ArticleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverPhoto:{
			type:"ArticleUpdateCoverPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleAlignment:{
			type:"ArticleTitleAlignment",
			array:false,
			arrayRequired:false,
			required:false
		},
		tagline:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		previewContent:{
			type:"ArticleUpdatePreviewContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ArticleUpdateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		categories:{
			type:"ArticleUpdateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		issues:{
			type:"ArticleUpdateIssuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contentBlocks:{
			type:"ArticleUpdateContentBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		coverPhotoVertical:{
			type:"ArticleUpdateCoverPhotoVerticalEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"ArticleUpdateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		isHistory:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyTags:{
			type:"ArticleUpdateHistoryTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		historyPeriods:{
			type:"ArticleUpdateHistoryPeriodsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpdateAuthorsEntityRelationInput:{
		create:{
			type:"ArticleAuthorWithoutArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArticleUpdateAuthorsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArticleUpsertAuthorsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArticleAuthorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ArticleAuthorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ArticleAuthorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpdateAuthorsRelationInput:{
		by:{
			type:"ArticleAuthorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ArticleAuthorWithoutArticleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleAuthorWithoutArticleUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"ArticleAuthorUpdateAuthorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyStringAuthor:{
			type:"ArticleAuthorLegacyStringAuthor",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleAuthorUpdateAuthorEntityRelationInput:{
		create:{
			type:"AuthorCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"AuthorUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArticleAuthorUpsertAuthorRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"AuthorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleAuthorUpsertAuthorRelationInput:{
		update:{
			type:"AuthorUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AuthorCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpsertAuthorsRelationInput:{
		by:{
			type:"ArticleAuthorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArticleAuthorWithoutArticleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleAuthorWithoutArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpdateSubtitleEntityRelationInput:{
		create:{
			type:"TextContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TextContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArticleUpsertSubtitleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TextContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentUpdateInput:{
		parts:{
			type:"TextContentUpdatePartsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentUpdatePartsEntityRelationInput:{
		create:{
			type:"TextContentPartWithoutContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TextContentUpdatePartsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TextContentUpsertPartsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TextContentPartUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"TextContentPartUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"TextContentPartUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentUpdatePartsRelationInput:{
		by:{
			type:"TextContentPartUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"TextContentPartWithoutContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentPartWithoutContentUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"TextContentPartUpdateReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentPartUpdateReferencesEntityRelationInput:{
		create:{
			type:"TextContentReferenceWithoutContentPartCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TextContentPartUpdateReferencesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TextContentPartUpsertReferencesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TextContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"TextContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"TextContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentPartUpdateReferencesRelationInput:{
		by:{
			type:"TextContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"TextContentReferenceWithoutContentPartUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentReferenceWithoutContentPartUpdateInput:{
		type:{
			type:"TextContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"TextContentReferenceUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentReferenceUpdateTargetEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TextContentReferenceUpsertTargetRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkUpdateInput:{
		type:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		externalTarget:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalTarget:{
			type:"LinkUpdateInternalTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		queryParameters:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkUpdateInternalTargetEntityRelationInput:{
		create:{
			type:"UrlCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"UrlUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkUpsertInternalTargetRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"UrlUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"UrlUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"UrlUpdateAuthorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"UrlUpdateIssueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"UrlUpdatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		category:{
			type:"UrlUpdateCategoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tag:{
			type:"UrlUpdateTagEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlUpdateArticleEntityRelationInput:{
		create:{
			type:"ArticleWithoutUrlCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArticleWithoutUrlUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"UrlUpsertArticleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleWithoutUrlUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		authors:{
			type:"ArticleUpdateAuthorsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		hideInMostRead:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		hideAds:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		state:{
			type:"ArticleState",
			array:false,
			arrayRequired:false,
			required:false
		},
		locked:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		template:{
			type:"Template",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"ArticleUpdateSubtitleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ArticleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverPhoto:{
			type:"ArticleUpdateCoverPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleAlignment:{
			type:"ArticleTitleAlignment",
			array:false,
			arrayRequired:false,
			required:false
		},
		tagline:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		previewContent:{
			type:"ArticleUpdatePreviewContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ArticleUpdateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		categories:{
			type:"ArticleUpdateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		issues:{
			type:"ArticleUpdateIssuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contentBlocks:{
			type:"ArticleUpdateContentBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		unlocked:{
			type:"ArticleUpdateUnlockedEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		coverPhotoVertical:{
			type:"ArticleUpdateCoverPhotoVerticalEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"ArticleUpdateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		isHistory:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyTags:{
			type:"ArticleUpdateHistoryTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		historyPeriods:{
			type:"ArticleUpdateHistoryPeriodsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpdateContentEntityRelationInput:{
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArticleUpsertContentRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpsertContentRelationInput:{
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpdateCoverPhotoEntityRelationInput:{
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArticleUpsertCoverPhotoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUseUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUseUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUseUpdateImageEntityRelationInput:{
		create:{
			type:"ImageWithoutUsesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageWithoutUsesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ImageUseUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageWithoutUsesUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"ImageUpdateAuthorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"ImageUpdateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		align:{
			type:"ImageAlign",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUpdateAuthorEntityRelationInput:{
		create:{
			type:"AuthorCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"AuthorUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ImageUpsertAuthorRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"AuthorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUpsertAuthorRelationInput:{
		update:{
			type:"AuthorUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AuthorCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUpdateTagsEntityRelationInput:{
		create:{
			type:"ImageTagWithoutImagesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateTagsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ImageUpsertTagsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ImageTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ImageTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUpdateTagsRelationInput:{
		by:{
			type:"ImageTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ImageTagWithoutImagesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageTagWithoutImagesUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUpsertTagsRelationInput:{
		by:{
			type:"ImageTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageTagWithoutImagesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageTagWithoutImagesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUseUpsertImageRelationInput:{
		update:{
			type:"ImageWithoutUsesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageWithoutUsesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpsertCoverPhotoRelationInput:{
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpdatePreviewContentEntityRelationInput:{
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArticleUpsertPreviewContentRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpsertPreviewContentRelationInput:{
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpdateAudioEntityRelationInput:{
		create:{
			type:"AudioUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"AudioUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArticleUpsertAudioRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"AudioUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpsertAudioRelationInput:{
		update:{
			type:"AudioUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AudioUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpdateCategoriesEntityRelationInput:{
		create:{
			type:"ArticleCategoryWithoutArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArticleUpdateCategoriesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArticleUpsertCategoriesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArticleCategoryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ArticleCategoryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ArticleCategoryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpdateCategoriesRelationInput:{
		by:{
			type:"ArticleCategoryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ArticleCategoryWithoutArticleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleCategoryWithoutArticleUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		category:{
			type:"ArticleCategoryUpdateCategoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleCategoryUpdateCategoryEntityRelationInput:{
		create:{
			type:"CategoryWithoutArticleCategoryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"CategoryWithoutArticleCategoryUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArticleCategoryUpsertCategoryRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"CategoryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryWithoutArticleCategoryUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"CategoryUpdateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryUpdateUrlEntityRelationInput:{
		create:{
			type:"UrlWithoutCategoryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"UrlWithoutCategoryUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"CategoryUpsertUrlRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"UrlUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlWithoutCategoryUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"UrlUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"UrlUpdateAuthorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"UrlUpdateIssueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"UrlUpdatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tag:{
			type:"UrlUpdateTagEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlUpdateIssueEntityRelationInput:{
		create:{
			type:"IssueWithoutUrlCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"IssueWithoutUrlUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"UrlUpsertIssueRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"IssueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueWithoutUrlUpdateInput:{
		closed:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		free:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		year:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishedSince:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishedUntil:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishDigital:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		mobileAppsKey:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		articles:{
			type:"IssueUpdateArticlesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		kind:{
			type:"IssueKind",
			array:false,
			arrayRequired:false,
			required:false
		},
		notificationTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		notificationMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		pdf:{
			type:"IssueUpdatePdfEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		printBuy:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		printText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		blocks:{
			type:"IssueUpdateBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		coverPhoto:{
			type:"IssueUpdateCoverPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		printTarget:{
			type:"IssueUpdatePrintTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		backgroundPhoto:{
			type:"IssueUpdateBackgroundPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueUpdateArticlesEntityRelationInput:{
		create:{
			type:"IssueArticleWithoutIssueCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"IssueUpdateArticlesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"IssueUpsertArticlesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"IssueArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"IssueArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"IssueArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueUpdateArticlesRelationInput:{
		by:{
			type:"IssueArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"IssueArticleWithoutIssueUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueArticleWithoutIssueUpdateInput:{
		article:{
			type:"IssueArticleUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueArticleUpdateArticleEntityRelationInput:{
		create:{
			type:"ArticleWithoutIssuesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArticleWithoutIssuesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"IssueArticleUpsertArticleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleWithoutIssuesUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"ArticleUpdateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		authors:{
			type:"ArticleUpdateAuthorsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		hideInMostRead:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		hideAds:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		state:{
			type:"ArticleState",
			array:false,
			arrayRequired:false,
			required:false
		},
		locked:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		template:{
			type:"Template",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"ArticleUpdateSubtitleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ArticleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverPhoto:{
			type:"ArticleUpdateCoverPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleAlignment:{
			type:"ArticleTitleAlignment",
			array:false,
			arrayRequired:false,
			required:false
		},
		tagline:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		previewContent:{
			type:"ArticleUpdatePreviewContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ArticleUpdateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		categories:{
			type:"ArticleUpdateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contentBlocks:{
			type:"ArticleUpdateContentBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		unlocked:{
			type:"ArticleUpdateUnlockedEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		coverPhotoVertical:{
			type:"ArticleUpdateCoverPhotoVerticalEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"ArticleUpdateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		isHistory:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyTags:{
			type:"ArticleUpdateHistoryTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		historyPeriods:{
			type:"ArticleUpdateHistoryPeriodsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpdateContentBlocksEntityRelationInput:{
		create:{
			type:"ContentArticleWithoutArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArticleUpdateContentBlocksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArticleUpsertContentBlocksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ContentArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ContentArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpdateContentBlocksRelationInput:{
		by:{
			type:"ContentArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ContentArticleWithoutArticleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentArticleWithoutArticleUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentBlock:{
			type:"ContentArticleUpdateContentBlockEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentArticleUpdateContentBlockEntityRelationInput:{
		create:{
			type:"ContentBlockWithoutArticlesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentBlockWithoutArticlesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentArticleUpsertContentBlockRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWithoutArticlesUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentBlockType",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtubeId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		targetLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"ContentBlockUpdateIssueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"ContentBlockUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionForm:{
			type:"ContentBlockUpdateSubscriptionFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpdateIssueEntityRelationInput:{
		create:{
			type:"IssueWithoutBlocksCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"IssueWithoutBlocksUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentBlockUpsertIssueRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"IssueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueWithoutBlocksUpdateInput:{
		closed:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		free:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		year:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishedSince:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishedUntil:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishDigital:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		mobileAppsKey:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"IssueUpdateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		articles:{
			type:"IssueUpdateArticlesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		kind:{
			type:"IssueKind",
			array:false,
			arrayRequired:false,
			required:false
		},
		notificationTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		notificationMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		pdf:{
			type:"IssueUpdatePdfEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		printBuy:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		printText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverPhoto:{
			type:"IssueUpdateCoverPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		printTarget:{
			type:"IssueUpdatePrintTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		backgroundPhoto:{
			type:"IssueUpdateBackgroundPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueUpdateUrlEntityRelationInput:{
		create:{
			type:"UrlWithoutIssueCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"UrlWithoutIssueUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"IssueUpsertUrlRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"UrlUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlWithoutIssueUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"UrlUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"UrlUpdateAuthorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"UrlUpdatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		category:{
			type:"UrlUpdateCategoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tag:{
			type:"UrlUpdateTagEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlUpdatePageEntityRelationInput:{
		create:{
			type:"PageWithoutUrlCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PageWithoutUrlUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"UrlUpsertPageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"PageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageWithoutUrlUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		template:{
			type:"PageTemplate",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"PageUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionValidity:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageUpdateContentEntityRelationInput:{
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PageUpsertContentRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageUpsertContentRelationInput:{
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoWithoutPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoWithoutPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PageUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoWithoutPageUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		twCard:{
			type:"SeoTwCard",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"SeoUpdateOgImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUpdateOgImageEntityRelationInput:{
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SeoUpsertOgImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUpsertOgImageRelationInput:{
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageUpsertSeoRelationInput:{
		update:{
			type:"SeoWithoutPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoWithoutPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlUpsertPageRelationInput:{
		update:{
			type:"PageWithoutUrlUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PageWithoutUrlCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlUpdateCategoryEntityRelationInput:{
		create:{
			type:"CategoryWithoutUrlCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"CategoryWithoutUrlUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"UrlUpsertCategoryRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"CategoryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryWithoutUrlUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		articleCategory:{
			type:"CategoryUpdateArticleCategoryEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryUpdateArticleCategoryEntityRelationInput:{
		create:{
			type:"ArticleCategoryWithoutCategoryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"CategoryUpdateArticleCategoryRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"CategoryUpsertArticleCategoryRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArticleCategoryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ArticleCategoryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ArticleCategoryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryUpdateArticleCategoryRelationInput:{
		by:{
			type:"ArticleCategoryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ArticleCategoryWithoutCategoryUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleCategoryWithoutCategoryUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleCategoryUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleCategoryUpdateArticleEntityRelationInput:{
		create:{
			type:"ArticleWithoutCategoriesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArticleWithoutCategoriesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArticleCategoryUpsertArticleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleWithoutCategoriesUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"ArticleUpdateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		authors:{
			type:"ArticleUpdateAuthorsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		hideInMostRead:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		hideAds:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		state:{
			type:"ArticleState",
			array:false,
			arrayRequired:false,
			required:false
		},
		locked:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		template:{
			type:"Template",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"ArticleUpdateSubtitleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ArticleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverPhoto:{
			type:"ArticleUpdateCoverPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleAlignment:{
			type:"ArticleTitleAlignment",
			array:false,
			arrayRequired:false,
			required:false
		},
		tagline:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		previewContent:{
			type:"ArticleUpdatePreviewContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ArticleUpdateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		issues:{
			type:"ArticleUpdateIssuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contentBlocks:{
			type:"ArticleUpdateContentBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		unlocked:{
			type:"ArticleUpdateUnlockedEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		coverPhotoVertical:{
			type:"ArticleUpdateCoverPhotoVerticalEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"ArticleUpdateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		isHistory:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyTags:{
			type:"ArticleUpdateHistoryTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		historyPeriods:{
			type:"ArticleUpdateHistoryPeriodsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpdateIssuesEntityRelationInput:{
		create:{
			type:"IssueArticleWithoutArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArticleUpdateIssuesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArticleUpsertIssuesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"IssueArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"IssueArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"IssueArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpdateIssuesRelationInput:{
		by:{
			type:"IssueArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"IssueArticleWithoutArticleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueArticleWithoutArticleUpdateInput:{
		issue:{
			type:"IssueArticleUpdateIssueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueArticleUpdateIssueEntityRelationInput:{
		create:{
			type:"IssueWithoutArticlesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"IssueWithoutArticlesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"IssueArticleUpsertIssueRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"IssueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueWithoutArticlesUpdateInput:{
		closed:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		free:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		year:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishedSince:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishedUntil:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishDigital:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		mobileAppsKey:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"IssueUpdateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		kind:{
			type:"IssueKind",
			array:false,
			arrayRequired:false,
			required:false
		},
		notificationTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		notificationMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		pdf:{
			type:"IssueUpdatePdfEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		printBuy:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		printText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		blocks:{
			type:"IssueUpdateBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		coverPhoto:{
			type:"IssueUpdateCoverPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		printTarget:{
			type:"IssueUpdatePrintTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		backgroundPhoto:{
			type:"IssueUpdateBackgroundPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueUpdatePdfEntityRelationInput:{
		create:{
			type:"FileUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FileUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"IssueUpsertPdfRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"FileUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileUseUpdateInput:{
		file:{
			type:"FileUseUpdateFileEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileUseUpdateFileEntityRelationInput:{
		create:{
			type:"FileWithoutUsesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FileWithoutUsesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FileUseUpsertFileRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"FileUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileWithoutUsesUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileUseUpsertFileRelationInput:{
		update:{
			type:"FileWithoutUsesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FileWithoutUsesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueUpsertPdfRelationInput:{
		update:{
			type:"FileUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FileUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueUpdateBlocksEntityRelationInput:{
		create:{
			type:"ContentBlockWithoutIssueCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"IssueUpdateBlocksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"IssueUpsertBlocksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueUpdateBlocksRelationInput:{
		by:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ContentBlockWithoutIssueUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWithoutIssueUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentBlockType",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtubeId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		targetLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"ContentBlockUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		articles:{
			type:"ContentBlockUpdateArticlesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		subscriptionForm:{
			type:"ContentBlockUpdateSubscriptionFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpdateTargetEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentBlockUpsertTargetRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpsertTargetRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpdateArticlesEntityRelationInput:{
		create:{
			type:"ContentArticleWithoutContentBlockCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentBlockUpdateArticlesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentBlockUpsertArticlesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ContentArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ContentArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpdateArticlesRelationInput:{
		by:{
			type:"ContentArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ContentArticleWithoutContentBlockUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentArticleWithoutContentBlockUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ContentArticleUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentArticleUpdateArticleEntityRelationInput:{
		create:{
			type:"ArticleWithoutContentBlocksCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArticleWithoutContentBlocksUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentArticleUpsertArticleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleWithoutContentBlocksUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"ArticleUpdateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		authors:{
			type:"ArticleUpdateAuthorsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		hideInMostRead:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		hideAds:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		state:{
			type:"ArticleState",
			array:false,
			arrayRequired:false,
			required:false
		},
		locked:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		template:{
			type:"Template",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"ArticleUpdateSubtitleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ArticleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverPhoto:{
			type:"ArticleUpdateCoverPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleAlignment:{
			type:"ArticleTitleAlignment",
			array:false,
			arrayRequired:false,
			required:false
		},
		tagline:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		previewContent:{
			type:"ArticleUpdatePreviewContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ArticleUpdateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		categories:{
			type:"ArticleUpdateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		issues:{
			type:"ArticleUpdateIssuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		unlocked:{
			type:"ArticleUpdateUnlockedEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		coverPhotoVertical:{
			type:"ArticleUpdateCoverPhotoVerticalEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"ArticleUpdateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		isHistory:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyTags:{
			type:"ArticleUpdateHistoryTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		historyPeriods:{
			type:"ArticleUpdateHistoryPeriodsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpdateUnlockedEntityRelationInput:{
		create:{
			type:"UnlockedArticleWithoutArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArticleUpdateUnlockedRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArticleUpsertUnlockedRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"UnlockedArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"UnlockedArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"UnlockedArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpdateUnlockedRelationInput:{
		by:{
			type:"UnlockedArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"UnlockedArticleWithoutArticleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UnlockedArticleWithoutArticleUpdateInput:{
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		views:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		user:{
			type:"UnlockedArticleUpdateUserEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UnlockedArticleUpdateUserEntityRelationInput:{
		create:{
			type:"UserWithoutUnlockedArticlesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"UserWithoutUnlockedArticlesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"UnlockedArticleUpsertUserRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"UserUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UserWithoutUnlockedArticlesUpdateInput:{
		ihnedId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		authors:{
			type:"UserUpdateAuthorsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		appReviews:{
			type:"UserUpdateAppReviewsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UserUpdateAuthorsEntityRelationInput:{
		create:{
			type:"AuthorWithoutUsersCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"UserUpdateAuthorsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"UserUpsertAuthorsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"AuthorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"AuthorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"AuthorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UserUpdateAuthorsRelationInput:{
		by:{
			type:"AuthorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"AuthorWithoutUsersUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorWithoutUsersUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		position:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		twitterHandle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebookId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		about:{
			type:"AuthorUpdateAboutEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		topArticles:{
			type:"AuthorUpdateTopArticlesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		startOfCooperation:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		photo:{
			type:"AuthorUpdatePhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		illustration:{
			type:"AuthorUpdateIllustrationEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		category:{
			type:"AuthorCategory",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"AuthorUpdateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagramUsername:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorUpdatePhotoEntityRelationInput:{
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"AuthorUpsertPhotoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorUpsertPhotoRelationInput:{
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorUpdateIllustrationEntityRelationInput:{
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"AuthorUpsertIllustrationRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorUpsertIllustrationRelationInput:{
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorUpdateUrlEntityRelationInput:{
		create:{
			type:"UrlWithoutAuthorCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"UrlWithoutAuthorUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"AuthorUpsertUrlRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"UrlUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlWithoutAuthorUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"UrlUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"UrlUpdateIssueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"UrlUpdatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		category:{
			type:"UrlUpdateCategoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tag:{
			type:"UrlUpdateTagEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlUpdateTagEntityRelationInput:{
		create:{
			type:"TagWithoutUrlCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TagWithoutUrlUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"UrlUpsertTagRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TagWithoutUrlUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		useAsTagline:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		articleTag:{
			type:"TagUpdateArticleTagEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		order:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TagUpdateArticleTagEntityRelationInput:{
		create:{
			type:"ArticleTagWithoutTagCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TagUpdateArticleTagRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TagUpsertArticleTagRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArticleTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ArticleTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ArticleTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TagUpdateArticleTagRelationInput:{
		by:{
			type:"ArticleTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ArticleTagWithoutTagUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleTagWithoutTagUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleTagUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleTagUpdateArticleEntityRelationInput:{
		create:{
			type:"ArticleWithoutTagsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArticleWithoutTagsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArticleTagUpsertArticleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleWithoutTagsUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"ArticleUpdateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		authors:{
			type:"ArticleUpdateAuthorsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		hideInMostRead:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		hideAds:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		state:{
			type:"ArticleState",
			array:false,
			arrayRequired:false,
			required:false
		},
		locked:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		template:{
			type:"Template",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"ArticleUpdateSubtitleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ArticleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverPhoto:{
			type:"ArticleUpdateCoverPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleAlignment:{
			type:"ArticleTitleAlignment",
			array:false,
			arrayRequired:false,
			required:false
		},
		tagline:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		previewContent:{
			type:"ArticleUpdatePreviewContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ArticleUpdateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		categories:{
			type:"ArticleUpdateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		issues:{
			type:"ArticleUpdateIssuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contentBlocks:{
			type:"ArticleUpdateContentBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		unlocked:{
			type:"ArticleUpdateUnlockedEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		coverPhotoVertical:{
			type:"ArticleUpdateCoverPhotoVerticalEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		isHistory:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyTags:{
			type:"ArticleUpdateHistoryTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		historyPeriods:{
			type:"ArticleUpdateHistoryPeriodsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpdateCoverPhotoVerticalEntityRelationInput:{
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArticleUpsertCoverPhotoVerticalRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpsertCoverPhotoVerticalRelationInput:{
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpdateHistoryTagsEntityRelationInput:{
		create:{
			type:"ArticleHistoryTagWithoutArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArticleUpdateHistoryTagsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArticleUpsertHistoryTagsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArticleHistoryTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ArticleHistoryTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ArticleHistoryTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpdateHistoryTagsRelationInput:{
		by:{
			type:"ArticleHistoryTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ArticleHistoryTagWithoutArticleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleHistoryTagWithoutArticleUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyTag:{
			type:"ArticleHistoryTagUpdateHistoryTagEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleHistoryTagUpdateHistoryTagEntityRelationInput:{
		create:{
			type:"HistoryTagWithoutArticleHistoryTagCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HistoryTagWithoutArticleHistoryTagUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArticleHistoryTagUpsertHistoryTagRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"HistoryTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTagWithoutArticleHistoryTagUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		slug:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleHistoryTagUpsertHistoryTagRelationInput:{
		update:{
			type:"HistoryTagWithoutArticleHistoryTagUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HistoryTagWithoutArticleHistoryTagCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpsertHistoryTagsRelationInput:{
		by:{
			type:"ArticleHistoryTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArticleHistoryTagWithoutArticleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleHistoryTagWithoutArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpdateHistoryPeriodsEntityRelationInput:{
		create:{
			type:"ArticleHistoryPeriodWithoutArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArticleUpdateHistoryPeriodsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArticleUpsertHistoryPeriodsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArticleHistoryPeriodUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ArticleHistoryPeriodUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ArticleHistoryPeriodUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpdateHistoryPeriodsRelationInput:{
		by:{
			type:"ArticleHistoryPeriodUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ArticleHistoryPeriodWithoutArticleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleHistoryPeriodWithoutArticleUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyPeriod:{
			type:"ArticleHistoryPeriodUpdateHistoryPeriodEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleHistoryPeriodUpdateHistoryPeriodEntityRelationInput:{
		create:{
			type:"HistoryPeriodWithoutArticleHistoryPeriodCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HistoryPeriodWithoutArticleHistoryPeriodUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArticleHistoryPeriodUpsertHistoryPeriodRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"HistoryPeriodUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryPeriodWithoutArticleHistoryPeriodUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		slug:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		cover:{
			type:"HistoryPeriodUpdateCoverEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"HistoryPeriodUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryPeriodUpdateCoverEntityRelationInput:{
		create:{
			type:"HistoryCoverCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HistoryCoverUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HistoryPeriodUpsertCoverRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"HistoryCoverUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryCoverUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tileParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverImage:{
			type:"HistoryCoverUpdateCoverImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tileImage:{
			type:"HistoryCoverUpdateTileImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		mobileImage:{
			type:"HistoryCoverUpdateMobileImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadContent:{
			type:"HistoryCoverUpdateLeadContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		annotations:{
			type:"HistoryCoverUpdateAnnotationsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryCoverUpdateCoverImageEntityRelationInput:{
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HistoryCoverUpsertCoverImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryCoverUpsertCoverImageRelationInput:{
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryCoverUpdateTileImageEntityRelationInput:{
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HistoryCoverUpsertTileImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryCoverUpsertTileImageRelationInput:{
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryCoverUpdateMobileImageEntityRelationInput:{
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HistoryCoverUpsertMobileImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryCoverUpsertMobileImageRelationInput:{
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryCoverUpdateLeadContentEntityRelationInput:{
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HistoryCoverUpsertLeadContentRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryCoverUpsertLeadContentRelationInput:{
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryCoverUpdateAnnotationsEntityRelationInput:{
		create:{
			type:"HistoryTextListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HistoryTextListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HistoryCoverUpsertAnnotationsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"HistoryTextListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTextListUpdateInput:{
		items:{
			type:"HistoryTextListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTextListUpdateItemsEntityRelationInput:{
		create:{
			type:"HistoryTextItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HistoryTextListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HistoryTextListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"HistoryTextItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"HistoryTextItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"HistoryTextItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTextListUpdateItemsRelationInput:{
		by:{
			type:"HistoryTextItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"HistoryTextItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTextItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		key:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"HistoryTextItemUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTextItemUpdateImageEntityRelationInput:{
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HistoryTextItemUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTextItemUpsertImageRelationInput:{
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTextListUpsertItemsRelationInput:{
		by:{
			type:"HistoryTextItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HistoryTextItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HistoryTextItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryCoverUpsertAnnotationsRelationInput:{
		update:{
			type:"HistoryTextListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HistoryTextListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryPeriodUpsertCoverRelationInput:{
		update:{
			type:"HistoryCoverUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HistoryCoverCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryPeriodUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HistoryPeriodUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"SeoUpdatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		twCard:{
			type:"SeoTwCard",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"SeoUpdateOgImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUpdatePageEntityRelationInput:{
		create:{
			type:"PageWithoutSeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PageWithoutSeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SeoUpsertPageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"PageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageWithoutSeoUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		template:{
			type:"PageTemplate",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"PageUpdateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"PageUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionValidity:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageUpdateUrlEntityRelationInput:{
		create:{
			type:"UrlWithoutPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"UrlWithoutPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PageUpsertUrlRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"UrlUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlWithoutPageUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"UrlUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"UrlUpdateAuthorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"UrlUpdateIssueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		category:{
			type:"UrlUpdateCategoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tag:{
			type:"UrlUpdateTagEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageUpsertUrlRelationInput:{
		update:{
			type:"UrlWithoutPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"UrlWithoutPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUpsertPageRelationInput:{
		update:{
			type:"PageWithoutSeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PageWithoutSeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryPeriodUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleHistoryPeriodUpsertHistoryPeriodRelationInput:{
		update:{
			type:"HistoryPeriodWithoutArticleHistoryPeriodUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HistoryPeriodWithoutArticleHistoryPeriodCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpsertHistoryPeriodsRelationInput:{
		by:{
			type:"ArticleHistoryPeriodUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArticleHistoryPeriodWithoutArticleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleHistoryPeriodWithoutArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleTagUpsertArticleRelationInput:{
		update:{
			type:"ArticleWithoutTagsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleWithoutTagsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TagUpsertArticleTagRelationInput:{
		by:{
			type:"ArticleTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArticleTagWithoutTagUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleTagWithoutTagCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlUpsertTagRelationInput:{
		update:{
			type:"TagWithoutUrlUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TagWithoutUrlCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorUpsertUrlRelationInput:{
		update:{
			type:"UrlWithoutAuthorUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"UrlWithoutAuthorCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UserUpsertAuthorsRelationInput:{
		by:{
			type:"AuthorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"AuthorWithoutUsersUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AuthorWithoutUsersCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UserUpdateAppReviewsEntityRelationInput:{
		create:{
			type:"AppReviewWithoutUserCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"UserUpdateAppReviewsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"UserUpsertAppReviewsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"AppReviewUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"AppReviewUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"AppReviewUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UserUpdateAppReviewsRelationInput:{
		by:{
			type:"AppReviewUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"AppReviewWithoutUserUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppReviewWithoutUserUpdateInput:{
		done:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		deviceId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		rating:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		note:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UserUpsertAppReviewsRelationInput:{
		by:{
			type:"AppReviewUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"AppReviewWithoutUserUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AppReviewWithoutUserCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UnlockedArticleUpsertUserRelationInput:{
		update:{
			type:"UserWithoutUnlockedArticlesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"UserWithoutUnlockedArticlesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpsertUnlockedRelationInput:{
		by:{
			type:"UnlockedArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"UnlockedArticleWithoutArticleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"UnlockedArticleWithoutArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpdateTagsEntityRelationInput:{
		create:{
			type:"ArticleTagWithoutArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArticleUpdateTagsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArticleUpsertTagsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArticleTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ArticleTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ArticleTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpdateTagsRelationInput:{
		by:{
			type:"ArticleTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ArticleTagWithoutArticleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleTagWithoutArticleUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		tag:{
			type:"ArticleTagUpdateTagEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleTagUpdateTagEntityRelationInput:{
		create:{
			type:"TagWithoutArticleTagCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TagWithoutArticleTagUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArticleTagUpsertTagRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TagWithoutArticleTagUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		useAsTagline:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"TagUpdateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TagUpdateUrlEntityRelationInput:{
		create:{
			type:"UrlWithoutTagCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"UrlWithoutTagUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TagUpsertUrlRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"UrlUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlWithoutTagUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"UrlUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"UrlUpdateAuthorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"UrlUpdateIssueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"UrlUpdatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		category:{
			type:"UrlUpdateCategoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TagUpsertUrlRelationInput:{
		update:{
			type:"UrlWithoutTagUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"UrlWithoutTagCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleTagUpsertTagRelationInput:{
		update:{
			type:"TagWithoutArticleTagUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TagWithoutArticleTagCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpsertTagsRelationInput:{
		by:{
			type:"ArticleTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArticleTagWithoutArticleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleTagWithoutArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentArticleUpsertArticleRelationInput:{
		update:{
			type:"ArticleWithoutContentBlocksUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleWithoutContentBlocksCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpsertArticlesRelationInput:{
		by:{
			type:"ContentArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentArticleWithoutContentBlockUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentArticleWithoutContentBlockCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpdateSubscriptionFormEntityRelationInput:{
		create:{
			type:"SubscriptionFormWithoutContentBlockCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SubscriptionFormWithoutContentBlockUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentBlockUpsertSubscriptionFormRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SubscriptionFormUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormWithoutContentBlockUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		sections:{
			type:"SubscriptionFormUpdateSectionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		products:{
			type:"SubscriptionFormUpdateProductsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contentReferences:{
			type:"SubscriptionFormUpdateContentReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		validity:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormUpdateSectionsEntityRelationInput:{
		create:{
			type:"SubscriptionFormSectionWithoutFormCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SubscriptionFormUpdateSectionsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SubscriptionFormUpsertSectionsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SubscriptionFormSectionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"SubscriptionFormSectionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"SubscriptionFormSectionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormUpdateSectionsRelationInput:{
		by:{
			type:"SubscriptionFormSectionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"SubscriptionFormSectionWithoutFormUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormSectionWithoutFormUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		inputs:{
			type:"SubscriptionFormSectionUpdateInputsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormSectionUpdateInputsEntityRelationInput:{
		create:{
			type:"SubscriptionFormInputWithoutSectionCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SubscriptionFormSectionUpdateInputsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SubscriptionFormSectionUpsertInputsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SubscriptionFormInputUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"SubscriptionFormInputUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"SubscriptionFormInputUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormSectionUpdateInputsRelationInput:{
		by:{
			type:"SubscriptionFormInputUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"SubscriptionFormInputWithoutSectionUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormInputWithoutSectionUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"SubscriptionFormInputType",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"SubscriptionFormInputUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		options:{
			type:"SubscriptionFormInputUpdateOptionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		description:{
			type:"SubscriptionFormInputUpdateDescriptionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		required:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormInputUpdateImageEntityRelationInput:{
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SubscriptionFormInputUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormInputUpsertImageRelationInput:{
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormInputUpdateOptionsEntityRelationInput:{
		create:{
			type:"SubscriptionFormOptionWithoutFormInputCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SubscriptionFormInputUpdateOptionsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SubscriptionFormInputUpsertOptionsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SubscriptionFormOptionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"SubscriptionFormOptionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"SubscriptionFormOptionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormInputUpdateOptionsRelationInput:{
		by:{
			type:"SubscriptionFormOptionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"SubscriptionFormOptionWithoutFormInputUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormOptionWithoutFormInputUpdateInput:{
		hasProductId:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		priceTag:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		priceTagWithDiscount:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		products:{
			type:"SubscriptionFormOptionUpdateProductsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		value:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormOptionUpdateProductsEntityRelationInput:{
		create:{
			type:"ProductWithoutFormOptionsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SubscriptionFormOptionUpdateProductsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SubscriptionFormOptionUpsertProductsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ProductUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ProductUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ProductUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormOptionUpdateProductsRelationInput:{
		by:{
			type:"ProductUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ProductWithoutFormOptionsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductWithoutFormOptionsUpdateInput:{
		price:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"Types",
			array:false,
			arrayRequired:false,
			required:false
		},
		form:{
			type:"ProductUpdateFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		productId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductUpdateFormEntityRelationInput:{
		create:{
			type:"SubscriptionFormWithoutProductsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SubscriptionFormWithoutProductsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ProductUpsertFormRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SubscriptionFormUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormWithoutProductsUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		sections:{
			type:"SubscriptionFormUpdateSectionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contentBlock:{
			type:"SubscriptionFormUpdateContentBlockEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contentReferences:{
			type:"SubscriptionFormUpdateContentReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		validity:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormUpdateContentBlockEntityRelationInput:{
		create:{
			type:"ContentBlockWithoutSubscriptionFormCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SubscriptionFormUpdateContentBlockRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SubscriptionFormUpsertContentBlockRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormUpdateContentBlockRelationInput:{
		by:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ContentBlockWithoutSubscriptionFormUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWithoutSubscriptionFormUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentBlockType",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtubeId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		targetLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"ContentBlockUpdateIssueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"ContentBlockUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		articles:{
			type:"ContentBlockUpdateArticlesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormUpsertContentBlockRelationInput:{
		by:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentBlockWithoutSubscriptionFormUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentBlockWithoutSubscriptionFormCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormUpdateContentReferencesEntityRelationInput:{
		create:{
			type:"ContentReferenceWithoutSubscriptionFormCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SubscriptionFormUpdateContentReferencesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SubscriptionFormUpsertContentReferencesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormUpdateContentReferencesRelationInput:{
		by:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ContentReferenceWithoutSubscriptionFormUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutSubscriptionFormUpdateInput:{
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentPart:{
			type:"ContentReferenceUpdateContentPartEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		variant:{
			type:"ContentReferenceVariant",
			array:false,
			arrayRequired:false,
			required:false
		},
		color:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		embed:{
			type:"ContentReferenceUpdateEmbedEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ContentReferenceUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ContentReferenceUpdateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		images:{
			type:"ContentReferenceUpdateImagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pollAnswer:{
			type:"ContentReferenceUpdatePollAnswerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		listicle:{
			type:"ContentReferenceUpdateListicleEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		faq:{
			type:"ContentReferenceUpdateFaqEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		links:{
			type:"ContentReferenceUpdateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		awards:{
			type:"ContentReferenceUpdateAwardsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		reviews:{
			type:"ContentReferenceUpdateReviewsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		target:{
			type:"ContentReferenceUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttons:{
			type:"ContentReferenceUpdateButtonsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		sharedContent:{
			type:"ContentReferenceUpdateSharedContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateContentPartEntityRelationInput:{
		create:{
			type:"ContentPartWithoutReferencesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentPartWithoutReferencesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertContentPartRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentPartUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentPartWithoutReferencesUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentPartUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentPartUpdateContentEntityRelationInput:{
		create:{
			type:"ContentWithoutPartsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentWithoutPartsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentPartUpsertContentRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentWithoutPartsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentPartUpsertContentRelationInput:{
		update:{
			type:"ContentWithoutPartsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentWithoutPartsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertContentPartRelationInput:{
		update:{
			type:"ContentPartWithoutReferencesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentPartWithoutReferencesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateImageEntityRelationInput:{
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertImageRelationInput:{
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateImagesEntityRelationInput:{
		create:{
			type:"ImageContentWithoutContentReferenceCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentReferenceUpdateImagesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertImagesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ImageContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ImageContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateImagesRelationInput:{
		by:{
			type:"ImageContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ImageContentWithoutContentReferenceUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageContentWithoutContentReferenceUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageContentUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageContentUpdateImageEntityRelationInput:{
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ImageContentUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageContentUpsertImageRelationInput:{
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertImagesRelationInput:{
		by:{
			type:"ImageContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageContentWithoutContentReferenceUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageContentWithoutContentReferenceCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdatePollAnswerEntityRelationInput:{
		create:{
			type:"PollAnswerCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PollAnswerUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertPollAnswerRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"PollAnswerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PollAnswerUpdateInput:{
		authorName:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		authorPosition:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		authorImage:{
			type:"PollAnswerUpdateAuthorImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PollAnswerUpdateAuthorImageEntityRelationInput:{
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PollAnswerUpsertAuthorImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PollAnswerUpsertAuthorImageRelationInput:{
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertPollAnswerRelationInput:{
		update:{
			type:"PollAnswerUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PollAnswerCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateListicleEntityRelationInput:{
		create:{
			type:"ListicleWithoutContentReferenceCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentReferenceUpdateListicleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertListicleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ListicleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ListicleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ListicleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateListicleRelationInput:{
		by:{
			type:"ListicleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ListicleWithoutContentReferenceUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ListicleWithoutContentReferenceUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ListicleUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"ListicleUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ListicleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ListicleUpdateImageEntityRelationInput:{
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ListicleUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ListicleUpsertImageRelationInput:{
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ListicleUpdateTargetEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ListicleUpsertTargetRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ListicleUpsertTargetRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ListicleUpdateContentEntityRelationInput:{
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ListicleUpsertContentRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ListicleUpsertContentRelationInput:{
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertListicleRelationInput:{
		by:{
			type:"ListicleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ListicleWithoutContentReferenceUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ListicleWithoutContentReferenceCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateFaqEntityRelationInput:{
		create:{
			type:"FAQWithoutContentReferenceCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentReferenceUpdateFaqRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertFaqRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"FAQUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"FAQUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"FAQUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateFaqRelationInput:{
		by:{
			type:"FAQUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"FAQWithoutContentReferenceUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FAQWithoutContentReferenceUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		answer:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		question:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertFaqRelationInput:{
		by:{
			type:"FAQUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FAQWithoutContentReferenceUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FAQWithoutContentReferenceCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateLinksEntityRelationInput:{
		create:{
			type:"LinkContentWithoutContentReferenceCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentReferenceUpdateLinksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertLinksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"LinkContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"LinkContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateLinksRelationInput:{
		by:{
			type:"LinkContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"LinkContentWithoutContentReferenceUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkContentWithoutContentReferenceUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"LinkContentUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkContentUpdateTargetEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkContentUpsertTargetRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkContentUpsertTargetRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertLinksRelationInput:{
		by:{
			type:"LinkContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkContentWithoutContentReferenceUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkContentWithoutContentReferenceCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateAwardsEntityRelationInput:{
		create:{
			type:"AwardContentWithoutContentReferenceCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentReferenceUpdateAwardsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertAwardsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"AwardContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"AwardContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"AwardContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateAwardsRelationInput:{
		by:{
			type:"AwardContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"AwardContentWithoutContentReferenceUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AwardContentWithoutContentReferenceUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"AwardContentUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"AwardContentUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AwardContentUpdateImageEntityRelationInput:{
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"AwardContentUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AwardContentUpsertImageRelationInput:{
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AwardContentUpdateTargetEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"AwardContentUpsertTargetRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AwardContentUpsertTargetRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertAwardsRelationInput:{
		by:{
			type:"AwardContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"AwardContentWithoutContentReferenceUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AwardContentWithoutContentReferenceCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateReviewsEntityRelationInput:{
		create:{
			type:"ReviewContentWithoutContentReferenceCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentReferenceUpdateReviewsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertReviewsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ReviewContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ReviewContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ReviewContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateReviewsRelationInput:{
		by:{
			type:"ReviewContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ReviewContentWithoutContentReferenceUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ReviewContentWithoutContentReferenceUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertReviewsRelationInput:{
		by:{
			type:"ReviewContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ReviewContentWithoutContentReferenceUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ReviewContentWithoutContentReferenceCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateTargetEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertTargetRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertTargetRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateButtonsEntityRelationInput:{
		create:{
			type:"ButtonWithoutContentReferenceCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentReferenceUpdateButtonsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertButtonsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ButtonUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ButtonUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ButtonUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateButtonsRelationInput:{
		by:{
			type:"ButtonUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ButtonWithoutContentReferenceUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ButtonWithoutContentReferenceUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ButtonType",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"ButtonUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ButtonUpdateTargetEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ButtonUpsertTargetRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ButtonUpsertTargetRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertButtonsRelationInput:{
		by:{
			type:"ButtonUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ButtonWithoutContentReferenceUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ButtonWithoutContentReferenceCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateSharedContentEntityRelationInput:{
		create:{
			type:"SharedContentWithoutContentReferenceCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SharedContentWithoutContentReferenceUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertSharedContentRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SharedContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SharedContentWithoutContentReferenceUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"SharedContentUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SharedContentUpdateContentEntityRelationInput:{
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SharedContentUpsertContentRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SharedContentUpsertContentRelationInput:{
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertSharedContentRelationInput:{
		update:{
			type:"SharedContentWithoutContentReferenceUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SharedContentWithoutContentReferenceCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormUpsertContentReferencesRelationInput:{
		by:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentReferenceWithoutSubscriptionFormUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutSubscriptionFormCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductUpsertFormRelationInput:{
		update:{
			type:"SubscriptionFormWithoutProductsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SubscriptionFormWithoutProductsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormOptionUpsertProductsRelationInput:{
		by:{
			type:"ProductUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ProductWithoutFormOptionsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProductWithoutFormOptionsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormInputUpsertOptionsRelationInput:{
		by:{
			type:"SubscriptionFormOptionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SubscriptionFormOptionWithoutFormInputUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SubscriptionFormOptionWithoutFormInputCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormInputUpdateDescriptionEntityRelationInput:{
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SubscriptionFormInputUpsertDescriptionRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormInputUpsertDescriptionRelationInput:{
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormSectionUpsertInputsRelationInput:{
		by:{
			type:"SubscriptionFormInputUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SubscriptionFormInputWithoutSectionUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SubscriptionFormInputWithoutSectionCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormUpsertSectionsRelationInput:{
		by:{
			type:"SubscriptionFormSectionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SubscriptionFormSectionWithoutFormUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SubscriptionFormSectionWithoutFormCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormUpdateProductsEntityRelationInput:{
		create:{
			type:"ProductWithoutFormCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SubscriptionFormUpdateProductsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SubscriptionFormUpsertProductsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ProductUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ProductUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ProductUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormUpdateProductsRelationInput:{
		by:{
			type:"ProductUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ProductWithoutFormUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductWithoutFormUpdateInput:{
		price:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"Types",
			array:false,
			arrayRequired:false,
			required:false
		},
		formOptions:{
			type:"ProductUpdateFormOptionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		productId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductUpdateFormOptionsEntityRelationInput:{
		create:{
			type:"SubscriptionFormOptionWithoutProductsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ProductUpdateFormOptionsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ProductUpsertFormOptionsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SubscriptionFormOptionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"SubscriptionFormOptionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"SubscriptionFormOptionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductUpdateFormOptionsRelationInput:{
		by:{
			type:"SubscriptionFormOptionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"SubscriptionFormOptionWithoutProductsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormOptionWithoutProductsUpdateInput:{
		hasProductId:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		priceTag:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		priceTagWithDiscount:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		formInput:{
			type:"SubscriptionFormOptionUpdateFormInputEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		value:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormOptionUpdateFormInputEntityRelationInput:{
		create:{
			type:"SubscriptionFormInputWithoutOptionsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SubscriptionFormInputWithoutOptionsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SubscriptionFormOptionUpsertFormInputRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SubscriptionFormInputUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormInputWithoutOptionsUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"SubscriptionFormInputType",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"SubscriptionFormInputUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		section:{
			type:"SubscriptionFormInputUpdateSectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"SubscriptionFormInputUpdateDescriptionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		required:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormInputUpdateSectionEntityRelationInput:{
		create:{
			type:"SubscriptionFormSectionWithoutInputsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SubscriptionFormSectionWithoutInputsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SubscriptionFormInputUpsertSectionRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SubscriptionFormSectionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormSectionWithoutInputsUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		form:{
			type:"SubscriptionFormSectionUpdateFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormSectionUpdateFormEntityRelationInput:{
		create:{
			type:"SubscriptionFormWithoutSectionsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SubscriptionFormWithoutSectionsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SubscriptionFormSectionUpsertFormRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SubscriptionFormUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormWithoutSectionsUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentBlock:{
			type:"SubscriptionFormUpdateContentBlockEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		products:{
			type:"SubscriptionFormUpdateProductsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contentReferences:{
			type:"SubscriptionFormUpdateContentReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		validity:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormSectionUpsertFormRelationInput:{
		update:{
			type:"SubscriptionFormWithoutSectionsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SubscriptionFormWithoutSectionsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormInputUpsertSectionRelationInput:{
		update:{
			type:"SubscriptionFormSectionWithoutInputsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SubscriptionFormSectionWithoutInputsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormOptionUpsertFormInputRelationInput:{
		update:{
			type:"SubscriptionFormInputWithoutOptionsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SubscriptionFormInputWithoutOptionsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductUpsertFormOptionsRelationInput:{
		by:{
			type:"SubscriptionFormOptionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SubscriptionFormOptionWithoutProductsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SubscriptionFormOptionWithoutProductsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormUpsertProductsRelationInput:{
		by:{
			type:"ProductUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ProductWithoutFormUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ProductWithoutFormCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpsertSubscriptionFormRelationInput:{
		update:{
			type:"SubscriptionFormWithoutContentBlockUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SubscriptionFormWithoutContentBlockCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueUpsertBlocksRelationInput:{
		by:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentBlockWithoutIssueUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentBlockWithoutIssueCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueUpdateCoverPhotoEntityRelationInput:{
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"IssueUpsertCoverPhotoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueUpsertCoverPhotoRelationInput:{
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueUpdatePrintTargetEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"IssueUpsertPrintTargetRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueUpsertPrintTargetRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueUpdateBackgroundPhotoEntityRelationInput:{
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"IssueUpsertBackgroundPhotoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueUpsertBackgroundPhotoRelationInput:{
		update:{
			type:"ImageUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueArticleUpsertIssueRelationInput:{
		update:{
			type:"IssueWithoutArticlesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"IssueWithoutArticlesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpsertIssuesRelationInput:{
		by:{
			type:"IssueArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"IssueArticleWithoutArticleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"IssueArticleWithoutArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleCategoryUpsertArticleRelationInput:{
		update:{
			type:"ArticleWithoutCategoriesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleWithoutCategoriesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryUpsertArticleCategoryRelationInput:{
		by:{
			type:"ArticleCategoryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArticleCategoryWithoutCategoryUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleCategoryWithoutCategoryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlUpsertCategoryRelationInput:{
		update:{
			type:"CategoryWithoutUrlUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"CategoryWithoutUrlCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueUpsertUrlRelationInput:{
		update:{
			type:"UrlWithoutIssueUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"UrlWithoutIssueCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpsertIssueRelationInput:{
		update:{
			type:"IssueWithoutBlocksUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"IssueWithoutBlocksCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentArticleUpsertContentBlockRelationInput:{
		update:{
			type:"ContentBlockWithoutArticlesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentBlockWithoutArticlesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpsertContentBlocksRelationInput:{
		by:{
			type:"ContentArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentArticleWithoutArticleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentArticleWithoutArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueArticleUpsertArticleRelationInput:{
		update:{
			type:"ArticleWithoutIssuesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleWithoutIssuesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueUpsertArticlesRelationInput:{
		by:{
			type:"IssueArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"IssueArticleWithoutIssueUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"IssueArticleWithoutIssueCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlUpsertIssueRelationInput:{
		update:{
			type:"IssueWithoutUrlUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"IssueWithoutUrlCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryUpsertUrlRelationInput:{
		update:{
			type:"UrlWithoutCategoryUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"UrlWithoutCategoryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleCategoryUpsertCategoryRelationInput:{
		update:{
			type:"CategoryWithoutArticleCategoryUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"CategoryWithoutArticleCategoryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpsertCategoriesRelationInput:{
		by:{
			type:"ArticleCategoryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArticleCategoryWithoutArticleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleCategoryWithoutArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlUpsertArticleRelationInput:{
		update:{
			type:"ArticleWithoutUrlUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleWithoutUrlCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkUpsertInternalTargetRelationInput:{
		update:{
			type:"UrlUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"UrlCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentReferenceUpsertTargetRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentPartUpsertReferencesRelationInput:{
		by:{
			type:"TextContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TextContentReferenceWithoutContentPartUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TextContentReferenceWithoutContentPartCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentUpsertPartsRelationInput:{
		by:{
			type:"TextContentPartUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TextContentPartWithoutContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TextContentPartWithoutContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpsertSubtitleRelationInput:{
		update:{
			type:"TextContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TextContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UnlockedArticleUpsertArticleRelationInput:{
		update:{
			type:"ArticleWithoutUnlockedUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleWithoutUnlockedCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UserUpsertUnlockedArticlesRelationInput:{
		by:{
			type:"UnlockedArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"UnlockedArticleWithoutUserUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"UnlockedArticleWithoutUserCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorUpsertUsersRelationInput:{
		by:{
			type:"UserUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"UserWithoutAuthorsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"UserWithoutAuthorsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AudioUpsertAuthorRelationInput:{
		update:{
			type:"AuthorUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AuthorCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AudioUseUpsertAudioRelationInput:{
		update:{
			type:"AudioWithoutUsesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AudioWithoutUsesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertAudioRelationInput:{
		update:{
			type:"AudioUseUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AudioUseCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateSubscriptionFormEntityRelationInput:{
		create:{
			type:"SubscriptionFormWithoutContentReferencesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SubscriptionFormWithoutContentReferencesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertSubscriptionFormRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SubscriptionFormUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormWithoutContentReferencesUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		sections:{
			type:"SubscriptionFormUpdateSectionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contentBlock:{
			type:"SubscriptionFormUpdateContentBlockEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		products:{
			type:"SubscriptionFormUpdateProductsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		validity:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertSubscriptionFormRelationInput:{
		update:{
			type:"SubscriptionFormWithoutContentReferencesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SubscriptionFormWithoutContentReferencesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentPartUpsertReferencesRelationInput:{
		by:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentReferenceWithoutContentPartUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutContentPartCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentUpsertPartsRelationInput:{
		by:{
			type:"ContentPartUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentPartWithoutContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentPartWithoutContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorUpsertAboutRelationInput:{
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UrlUpsertAuthorRelationInput:{
		update:{
			type:"AuthorWithoutUrlUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AuthorWithoutUrlCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleUpsertUrlRelationInput:{
		update:{
			type:"UrlWithoutArticleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"UrlWithoutArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleAuthorCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleAuthorCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"ArticleAuthorCreateAuthorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyStringAuthor:{
			type:"ArticleAuthorLegacyStringAuthor",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleAuthorCreateArticleEntityRelationInput:{
		connect:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleWithoutAuthorsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleWithoutAuthorsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"ArticleCreateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		hideInMostRead:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		hideAds:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		state:{
			type:"ArticleState",
			array:false,
			arrayRequired:false,
			required:false
		},
		locked:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		template:{
			type:"Template",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"ArticleCreateSubtitleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ArticleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverPhoto:{
			type:"ArticleCreateCoverPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleAlignment:{
			type:"ArticleTitleAlignment",
			array:false,
			arrayRequired:false,
			required:false
		},
		tagline:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		previewContent:{
			type:"ArticleCreatePreviewContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ArticleCreateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		categories:{
			type:"ArticleCreateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		issues:{
			type:"ArticleCreateIssuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contentBlocks:{
			type:"ArticleCreateContentBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		unlocked:{
			type:"ArticleCreateUnlockedEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		coverPhotoVertical:{
			type:"ArticleCreateCoverPhotoVerticalEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"ArticleCreateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		isHistory:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyTags:{
			type:"ArticleCreateHistoryTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		historyPeriods:{
			type:"ArticleCreateHistoryPeriodsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleAuthorUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleAuthorUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"ArticleAuthorUpdateAuthorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyStringAuthor:{
			type:"ArticleAuthorLegacyStringAuthor",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleAuthorUpdateArticleEntityRelationInput:{
		create:{
			type:"ArticleWithoutAuthorsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArticleWithoutAuthorsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArticleAuthorUpsertArticleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleWithoutAuthorsUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"ArticleUpdateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		hideInMostRead:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		hideAds:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		state:{
			type:"ArticleState",
			array:false,
			arrayRequired:false,
			required:false
		},
		locked:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		template:{
			type:"Template",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"ArticleUpdateSubtitleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ArticleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverPhoto:{
			type:"ArticleUpdateCoverPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleAlignment:{
			type:"ArticleTitleAlignment",
			array:false,
			arrayRequired:false,
			required:false
		},
		tagline:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		previewContent:{
			type:"ArticleUpdatePreviewContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ArticleUpdateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		categories:{
			type:"ArticleUpdateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		issues:{
			type:"ArticleUpdateIssuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contentBlocks:{
			type:"ArticleUpdateContentBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		unlocked:{
			type:"ArticleUpdateUnlockedEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		coverPhotoVertical:{
			type:"ArticleUpdateCoverPhotoVerticalEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"ArticleUpdateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		isHistory:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyTags:{
			type:"ArticleUpdateHistoryTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		historyPeriods:{
			type:"ArticleUpdateHistoryPeriodsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleAuthorUpsertArticleRelationInput:{
		update:{
			type:"ArticleWithoutAuthorsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleWithoutAuthorsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorTopArticleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"AuthorTopArticleCreateAuthorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"AuthorTopArticleCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorTopArticleCreateAuthorEntityRelationInput:{
		connect:{
			type:"AuthorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AuthorWithoutTopArticlesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorWithoutTopArticlesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		position:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		twitterHandle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebookId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		about:{
			type:"AuthorCreateAboutEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		users:{
			type:"AuthorCreateUsersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		startOfCooperation:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		photo:{
			type:"AuthorCreatePhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		illustration:{
			type:"AuthorCreateIllustrationEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		category:{
			type:"AuthorCategory",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"AuthorCreateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagramUsername:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorTopArticleUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"AuthorTopArticleUpdateAuthorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"AuthorTopArticleUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorTopArticleUpdateAuthorEntityRelationInput:{
		create:{
			type:"AuthorWithoutTopArticlesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"AuthorWithoutTopArticlesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"AuthorTopArticleUpsertAuthorRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"AuthorUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorWithoutTopArticlesUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		position:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		twitterHandle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebookId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographer:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		about:{
			type:"AuthorUpdateAboutEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		users:{
			type:"AuthorUpdateUsersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		startOfCooperation:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		photo:{
			type:"AuthorUpdatePhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		illustration:{
			type:"AuthorUpdateIllustrationEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		category:{
			type:"AuthorCategory",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"AuthorUpdateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagramUsername:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AuthorTopArticleUpsertAuthorRelationInput:{
		update:{
			type:"AuthorWithoutTopArticlesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AuthorWithoutTopArticlesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentPartCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentPartCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentPartCreateReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentPartUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentPartUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentPartUpdateReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentPart:{
			type:"ContentReferenceCreateContentPartEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		variant:{
			type:"ContentReferenceVariant",
			array:false,
			arrayRequired:false,
			required:false
		},
		color:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		embed:{
			type:"ContentReferenceCreateEmbedEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ContentReferenceCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ContentReferenceCreateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		images:{
			type:"ContentReferenceCreateImagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pollAnswer:{
			type:"ContentReferenceCreatePollAnswerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		listicle:{
			type:"ContentReferenceCreateListicleEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		faq:{
			type:"ContentReferenceCreateFaqEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		links:{
			type:"ContentReferenceCreateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		awards:{
			type:"ContentReferenceCreateAwardsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		reviews:{
			type:"ContentReferenceCreateReviewsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		target:{
			type:"ContentReferenceCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionForm:{
			type:"ContentReferenceCreateSubscriptionFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttons:{
			type:"ContentReferenceCreateButtonsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		sharedContent:{
			type:"ContentReferenceCreateSharedContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateInput:{
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentPart:{
			type:"ContentReferenceUpdateContentPartEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		variant:{
			type:"ContentReferenceVariant",
			array:false,
			arrayRequired:false,
			required:false
		},
		color:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		embed:{
			type:"ContentReferenceUpdateEmbedEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ContentReferenceUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ContentReferenceUpdateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		images:{
			type:"ContentReferenceUpdateImagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pollAnswer:{
			type:"ContentReferenceUpdatePollAnswerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		listicle:{
			type:"ContentReferenceUpdateListicleEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		faq:{
			type:"ContentReferenceUpdateFaqEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		links:{
			type:"ContentReferenceUpdateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		awards:{
			type:"ContentReferenceUpdateAwardsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		reviews:{
			type:"ContentReferenceUpdateReviewsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		target:{
			type:"ContentReferenceUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionForm:{
			type:"ContentReferenceUpdateSubscriptionFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttons:{
			type:"ContentReferenceUpdateButtonsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		sharedContent:{
			type:"ContentReferenceUpdateSharedContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomepageArticle:{
		article:{
			filter:{
				type:"ArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	HomepageArticleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomepageArticleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		tag:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"HomepageArticleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"HomepageArticleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"HomepageArticleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomepageArticleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		tag:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomepageArticleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		tag:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"HomepageArticleCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomepageArticleCreateArticleEntityRelationInput:{
		connect:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomepageArticleUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		tag:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"HomepageArticleUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomepageArticleUpdateArticleEntityRelationInput:{
		create:{
			type:"ArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArticleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HomepageArticleUpsertArticleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomepageArticleUpsertArticleRelationInput:{
		update:{
			type:"ArticleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"ImageCreateAuthorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"ImageCreateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		uses:{
			type:"ImageCreateUsesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		align:{
			type:"ImageAlign",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageCreateUsesEntityRelationInput:{
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseWithoutImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUseWithoutImageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"ImageUpdateAuthorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"ImageUpdateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		uses:{
			type:"ImageUpdateUsesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		align:{
			type:"ImageAlign",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUpdateUsesEntityRelationInput:{
		create:{
			type:"ImageUseWithoutImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateUsesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ImageUpsertUsesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUpdateUsesRelationInput:{
		by:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ImageUseWithoutImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUseWithoutImageUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUpsertUsesRelationInput:{
		by:{
			type:"ImageUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUseWithoutImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageUseWithoutImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageTagCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		images:{
			type:"ImageTagCreateImagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageTagCreateImagesEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageWithoutTagsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageWithoutTagsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"ImageCreateAuthorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		uses:{
			type:"ImageCreateUsesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		align:{
			type:"ImageAlign",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageTagUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		images:{
			type:"ImageTagUpdateImagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageTagUpdateImagesEntityRelationInput:{
		create:{
			type:"ImageWithoutTagsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageTagUpdateImagesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ImageTagUpsertImagesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageTagUpdateImagesRelationInput:{
		by:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ImageWithoutTagsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageWithoutTagsUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"ImageUpdateAuthorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		uses:{
			type:"ImageUpdateUsesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		align:{
			type:"ImageAlign",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageTagUpsertImagesRelationInput:{
		by:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageWithoutTagsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageWithoutTagsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		closed:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		free:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		year:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishedSince:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishedUntil:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishDigital:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		mobileAppsKey:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"IssueCreateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		articles:{
			type:"IssueCreateArticlesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		kind:{
			type:"IssueKind",
			array:false,
			arrayRequired:false,
			required:false
		},
		notificationTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		notificationMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		pdf:{
			type:"IssueCreatePdfEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		printBuy:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		printText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		blocks:{
			type:"IssueCreateBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		coverPhoto:{
			type:"IssueCreateCoverPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		printTarget:{
			type:"IssueCreatePrintTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		backgroundPhoto:{
			type:"IssueCreateBackgroundPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueUpdateInput:{
		closed:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		free:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		year:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishedSince:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishedUntil:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishDigital:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		mobileAppsKey:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"IssueUpdateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		articles:{
			type:"IssueUpdateArticlesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		kind:{
			type:"IssueKind",
			array:false,
			arrayRequired:false,
			required:false
		},
		notificationTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		notificationMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		pdf:{
			type:"IssueUpdatePdfEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		printBuy:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		printText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		blocks:{
			type:"IssueUpdateBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		coverPhoto:{
			type:"IssueUpdateCoverPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		printTarget:{
			type:"IssueUpdatePrintTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		backgroundPhoto:{
			type:"IssueUpdateBackgroundPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueArticleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"IssueArticleCreateIssueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"IssueArticleCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IssueArticleUpdateInput:{
		issue:{
			type:"IssueArticleUpdateIssueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"IssueArticleUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentPartCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"TextContentPartCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"TextContentPartCreateReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentPartCreateContentEntityRelationInput:{
		connect:{
			type:"TextContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TextContentWithoutPartsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentWithoutPartsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentPartUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"TextContentPartUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"TextContentPartUpdateReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentPartUpdateContentEntityRelationInput:{
		create:{
			type:"TextContentWithoutPartsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TextContentWithoutPartsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TextContentPartUpsertContentRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TextContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentWithoutPartsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentPartUpsertContentRelationInput:{
		update:{
			type:"TextContentWithoutPartsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TextContentWithoutPartsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentReferenceCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"TextContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentPart:{
			type:"TextContentReferenceCreateContentPartEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"TextContentReferenceCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentReferenceCreateContentPartEntityRelationInput:{
		connect:{
			type:"TextContentPartUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TextContentPartWithoutReferencesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentPartWithoutReferencesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"TextContentPartCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentReferenceUpdateInput:{
		type:{
			type:"TextContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentPart:{
			type:"TextContentReferenceUpdateContentPartEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"TextContentReferenceUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentReferenceUpdateContentPartEntityRelationInput:{
		create:{
			type:"TextContentPartWithoutReferencesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TextContentPartWithoutReferencesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TextContentReferenceUpsertContentPartRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TextContentPartUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentPartWithoutReferencesUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"TextContentPartUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextContentReferenceUpsertContentPartRelationInput:{
		update:{
			type:"TextContentPartWithoutReferencesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TextContentPartWithoutReferencesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleTagCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		tag:{
			type:"ArticleTagCreateTagEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleTagCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleTagUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		tag:{
			type:"ArticleTagUpdateTagEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleTagUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		articleCategory:{
			type:"CategoryCreateArticleCategoryEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		url:{
			type:"CategoryCreateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		articleCategory:{
			type:"CategoryUpdateArticleCategoryEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		url:{
			type:"CategoryUpdateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleCategoryCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleCategoryCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		category:{
			type:"ArticleCategoryCreateCategoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleCategoryUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleCategoryUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		category:{
			type:"ArticleCategoryUpdateCategoryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AudioCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"AudioCreateAuthorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		uses:{
			type:"AudioCreateUsesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AudioCreateUsesEntityRelationInput:{
		connect:{
			type:"AudioUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AudioUseWithoutAudioCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AudioUseWithoutAudioCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AudioUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		author:{
			type:"AudioUpdateAuthorEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		uses:{
			type:"AudioUpdateUsesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AudioUpdateUsesEntityRelationInput:{
		create:{
			type:"AudioUseWithoutAudioCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"AudioUpdateUsesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"AudioUpsertUsesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"AudioUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"AudioUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"AudioUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AudioUpdateUsesRelationInput:{
		by:{
			type:"AudioUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"AudioUseWithoutAudioUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AudioUseWithoutAudioUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AudioUpsertUsesRelationInput:{
		by:{
			type:"AudioUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"AudioUseWithoutAudioUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AudioUseWithoutAudioCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageContentCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentReference:{
			type:"ImageContentCreateContentReferenceEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		image:{
			type:"ImageContentCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageContentCreateContentReferenceEntityRelationInput:{
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutImagesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutImagesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentPart:{
			type:"ContentReferenceCreateContentPartEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		variant:{
			type:"ContentReferenceVariant",
			array:false,
			arrayRequired:false,
			required:false
		},
		color:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		embed:{
			type:"ContentReferenceCreateEmbedEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ContentReferenceCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ContentReferenceCreateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		pollAnswer:{
			type:"ContentReferenceCreatePollAnswerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		listicle:{
			type:"ContentReferenceCreateListicleEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		faq:{
			type:"ContentReferenceCreateFaqEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		links:{
			type:"ContentReferenceCreateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		awards:{
			type:"ContentReferenceCreateAwardsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		reviews:{
			type:"ContentReferenceCreateReviewsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		target:{
			type:"ContentReferenceCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionForm:{
			type:"ContentReferenceCreateSubscriptionFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttons:{
			type:"ContentReferenceCreateButtonsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		sharedContent:{
			type:"ContentReferenceCreateSharedContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageContentUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentReference:{
			type:"ImageContentUpdateContentReferenceEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		image:{
			type:"ImageContentUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageContentUpdateContentReferenceEntityRelationInput:{
		create:{
			type:"ContentReferenceWithoutImagesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageContentUpdateContentReferenceRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ImageContentUpsertContentReferenceRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageContentUpdateContentReferenceRelationInput:{
		by:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ContentReferenceWithoutImagesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutImagesUpdateInput:{
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentPart:{
			type:"ContentReferenceUpdateContentPartEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		variant:{
			type:"ContentReferenceVariant",
			array:false,
			arrayRequired:false,
			required:false
		},
		color:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		embed:{
			type:"ContentReferenceUpdateEmbedEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ContentReferenceUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ContentReferenceUpdateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		pollAnswer:{
			type:"ContentReferenceUpdatePollAnswerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		listicle:{
			type:"ContentReferenceUpdateListicleEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		faq:{
			type:"ContentReferenceUpdateFaqEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		links:{
			type:"ContentReferenceUpdateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		awards:{
			type:"ContentReferenceUpdateAwardsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		reviews:{
			type:"ContentReferenceUpdateReviewsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		target:{
			type:"ContentReferenceUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionForm:{
			type:"ContentReferenceUpdateSubscriptionFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttons:{
			type:"ContentReferenceUpdateButtonsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		sharedContent:{
			type:"ContentReferenceUpdateSharedContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageContentUpsertContentReferenceRelationInput:{
		by:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentReferenceWithoutImagesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutImagesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ListicleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ListicleCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentReference:{
			type:"ListicleCreateContentReferenceEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"ListicleCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ListicleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ListicleCreateContentReferenceEntityRelationInput:{
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutListicleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutListicleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentPart:{
			type:"ContentReferenceCreateContentPartEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		variant:{
			type:"ContentReferenceVariant",
			array:false,
			arrayRequired:false,
			required:false
		},
		color:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		embed:{
			type:"ContentReferenceCreateEmbedEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ContentReferenceCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ContentReferenceCreateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		images:{
			type:"ContentReferenceCreateImagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pollAnswer:{
			type:"ContentReferenceCreatePollAnswerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		faq:{
			type:"ContentReferenceCreateFaqEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		links:{
			type:"ContentReferenceCreateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		awards:{
			type:"ContentReferenceCreateAwardsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		reviews:{
			type:"ContentReferenceCreateReviewsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		target:{
			type:"ContentReferenceCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionForm:{
			type:"ContentReferenceCreateSubscriptionFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttons:{
			type:"ContentReferenceCreateButtonsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		sharedContent:{
			type:"ContentReferenceCreateSharedContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ListicleUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ListicleUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentReference:{
			type:"ListicleUpdateContentReferenceEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"ListicleUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ListicleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ListicleUpdateContentReferenceEntityRelationInput:{
		create:{
			type:"ContentReferenceWithoutListicleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentReferenceWithoutListicleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ListicleUpsertContentReferenceRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutListicleUpdateInput:{
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentPart:{
			type:"ContentReferenceUpdateContentPartEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		variant:{
			type:"ContentReferenceVariant",
			array:false,
			arrayRequired:false,
			required:false
		},
		color:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		embed:{
			type:"ContentReferenceUpdateEmbedEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ContentReferenceUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ContentReferenceUpdateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		images:{
			type:"ContentReferenceUpdateImagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pollAnswer:{
			type:"ContentReferenceUpdatePollAnswerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		faq:{
			type:"ContentReferenceUpdateFaqEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		links:{
			type:"ContentReferenceUpdateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		awards:{
			type:"ContentReferenceUpdateAwardsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		reviews:{
			type:"ContentReferenceUpdateReviewsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		target:{
			type:"ContentReferenceUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionForm:{
			type:"ContentReferenceUpdateSubscriptionFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttons:{
			type:"ContentReferenceUpdateButtonsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		sharedContent:{
			type:"ContentReferenceUpdateSharedContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ListicleUpsertContentReferenceRelationInput:{
		update:{
			type:"ContentReferenceWithoutListicleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutListicleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TagCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		useAsTagline:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		articleTag:{
			type:"TagCreateArticleTagEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		url:{
			type:"TagCreateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TagUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		useAsTagline:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		articleTag:{
			type:"TagUpdateArticleTagEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		url:{
			type:"TagUpdateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FAQCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		answer:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		question:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentReference:{
			type:"FAQCreateContentReferenceEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FAQCreateContentReferenceEntityRelationInput:{
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutFaqCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutFaqCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentPart:{
			type:"ContentReferenceCreateContentPartEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		variant:{
			type:"ContentReferenceVariant",
			array:false,
			arrayRequired:false,
			required:false
		},
		color:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		embed:{
			type:"ContentReferenceCreateEmbedEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ContentReferenceCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ContentReferenceCreateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		images:{
			type:"ContentReferenceCreateImagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pollAnswer:{
			type:"ContentReferenceCreatePollAnswerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		listicle:{
			type:"ContentReferenceCreateListicleEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		links:{
			type:"ContentReferenceCreateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		awards:{
			type:"ContentReferenceCreateAwardsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		reviews:{
			type:"ContentReferenceCreateReviewsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		target:{
			type:"ContentReferenceCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionForm:{
			type:"ContentReferenceCreateSubscriptionFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttons:{
			type:"ContentReferenceCreateButtonsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		sharedContent:{
			type:"ContentReferenceCreateSharedContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FAQUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		answer:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		question:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentReference:{
			type:"FAQUpdateContentReferenceEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FAQUpdateContentReferenceEntityRelationInput:{
		create:{
			type:"ContentReferenceWithoutFaqCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentReferenceWithoutFaqUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FAQUpsertContentReferenceRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutFaqUpdateInput:{
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentPart:{
			type:"ContentReferenceUpdateContentPartEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		variant:{
			type:"ContentReferenceVariant",
			array:false,
			arrayRequired:false,
			required:false
		},
		color:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		embed:{
			type:"ContentReferenceUpdateEmbedEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ContentReferenceUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ContentReferenceUpdateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		images:{
			type:"ContentReferenceUpdateImagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pollAnswer:{
			type:"ContentReferenceUpdatePollAnswerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		listicle:{
			type:"ContentReferenceUpdateListicleEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		links:{
			type:"ContentReferenceUpdateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		awards:{
			type:"ContentReferenceUpdateAwardsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		reviews:{
			type:"ContentReferenceUpdateReviewsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		target:{
			type:"ContentReferenceUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionForm:{
			type:"ContentReferenceUpdateSubscriptionFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttons:{
			type:"ContentReferenceUpdateButtonsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		sharedContent:{
			type:"ContentReferenceUpdateSharedContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FAQUpsertContentReferenceRelationInput:{
		update:{
			type:"ContentReferenceWithoutFaqUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutFaqCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkContentCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentReference:{
			type:"LinkContentCreateContentReferenceEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"LinkContentCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkContentCreateContentReferenceEntityRelationInput:{
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutLinksCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutLinksCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentPart:{
			type:"ContentReferenceCreateContentPartEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		variant:{
			type:"ContentReferenceVariant",
			array:false,
			arrayRequired:false,
			required:false
		},
		color:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		embed:{
			type:"ContentReferenceCreateEmbedEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ContentReferenceCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ContentReferenceCreateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		images:{
			type:"ContentReferenceCreateImagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pollAnswer:{
			type:"ContentReferenceCreatePollAnswerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		listicle:{
			type:"ContentReferenceCreateListicleEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		faq:{
			type:"ContentReferenceCreateFaqEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		awards:{
			type:"ContentReferenceCreateAwardsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		reviews:{
			type:"ContentReferenceCreateReviewsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		target:{
			type:"ContentReferenceCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionForm:{
			type:"ContentReferenceCreateSubscriptionFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttons:{
			type:"ContentReferenceCreateButtonsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		sharedContent:{
			type:"ContentReferenceCreateSharedContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkContentUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentReference:{
			type:"LinkContentUpdateContentReferenceEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"LinkContentUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkContentUpdateContentReferenceEntityRelationInput:{
		create:{
			type:"ContentReferenceWithoutLinksCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentReferenceWithoutLinksUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkContentUpsertContentReferenceRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutLinksUpdateInput:{
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentPart:{
			type:"ContentReferenceUpdateContentPartEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		variant:{
			type:"ContentReferenceVariant",
			array:false,
			arrayRequired:false,
			required:false
		},
		color:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		embed:{
			type:"ContentReferenceUpdateEmbedEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ContentReferenceUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ContentReferenceUpdateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		images:{
			type:"ContentReferenceUpdateImagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pollAnswer:{
			type:"ContentReferenceUpdatePollAnswerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		listicle:{
			type:"ContentReferenceUpdateListicleEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		faq:{
			type:"ContentReferenceUpdateFaqEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		awards:{
			type:"ContentReferenceUpdateAwardsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		reviews:{
			type:"ContentReferenceUpdateReviewsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		target:{
			type:"ContentReferenceUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionForm:{
			type:"ContentReferenceUpdateSubscriptionFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttons:{
			type:"ContentReferenceUpdateButtonsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		sharedContent:{
			type:"ContentReferenceUpdateSharedContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkContentUpsertContentReferenceRelationInput:{
		update:{
			type:"ContentReferenceWithoutLinksUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutLinksCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AwardContentCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"AwardContentCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentReference:{
			type:"AwardContentCreateContentReferenceEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"AwardContentCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AwardContentCreateContentReferenceEntityRelationInput:{
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutAwardsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutAwardsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentPart:{
			type:"ContentReferenceCreateContentPartEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		variant:{
			type:"ContentReferenceVariant",
			array:false,
			arrayRequired:false,
			required:false
		},
		color:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		embed:{
			type:"ContentReferenceCreateEmbedEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ContentReferenceCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ContentReferenceCreateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		images:{
			type:"ContentReferenceCreateImagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pollAnswer:{
			type:"ContentReferenceCreatePollAnswerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		listicle:{
			type:"ContentReferenceCreateListicleEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		faq:{
			type:"ContentReferenceCreateFaqEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		links:{
			type:"ContentReferenceCreateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		reviews:{
			type:"ContentReferenceCreateReviewsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		target:{
			type:"ContentReferenceCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionForm:{
			type:"ContentReferenceCreateSubscriptionFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttons:{
			type:"ContentReferenceCreateButtonsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		sharedContent:{
			type:"ContentReferenceCreateSharedContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AwardContentUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"AwardContentUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentReference:{
			type:"AwardContentUpdateContentReferenceEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"AwardContentUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AwardContentUpdateContentReferenceEntityRelationInput:{
		create:{
			type:"ContentReferenceWithoutAwardsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentReferenceWithoutAwardsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"AwardContentUpsertContentReferenceRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutAwardsUpdateInput:{
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentPart:{
			type:"ContentReferenceUpdateContentPartEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		variant:{
			type:"ContentReferenceVariant",
			array:false,
			arrayRequired:false,
			required:false
		},
		color:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		embed:{
			type:"ContentReferenceUpdateEmbedEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ContentReferenceUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ContentReferenceUpdateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		images:{
			type:"ContentReferenceUpdateImagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pollAnswer:{
			type:"ContentReferenceUpdatePollAnswerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		listicle:{
			type:"ContentReferenceUpdateListicleEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		faq:{
			type:"ContentReferenceUpdateFaqEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		links:{
			type:"ContentReferenceUpdateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		reviews:{
			type:"ContentReferenceUpdateReviewsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		target:{
			type:"ContentReferenceUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionForm:{
			type:"ContentReferenceUpdateSubscriptionFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttons:{
			type:"ContentReferenceUpdateButtonsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		sharedContent:{
			type:"ContentReferenceUpdateSharedContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AwardContentUpsertContentReferenceRelationInput:{
		update:{
			type:"ContentReferenceWithoutAwardsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutAwardsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ReviewContentCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentReference:{
			type:"ReviewContentCreateContentReferenceEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ReviewContentCreateContentReferenceEntityRelationInput:{
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutReviewsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutReviewsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentPart:{
			type:"ContentReferenceCreateContentPartEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		variant:{
			type:"ContentReferenceVariant",
			array:false,
			arrayRequired:false,
			required:false
		},
		color:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		embed:{
			type:"ContentReferenceCreateEmbedEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ContentReferenceCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ContentReferenceCreateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		images:{
			type:"ContentReferenceCreateImagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pollAnswer:{
			type:"ContentReferenceCreatePollAnswerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		listicle:{
			type:"ContentReferenceCreateListicleEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		faq:{
			type:"ContentReferenceCreateFaqEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		links:{
			type:"ContentReferenceCreateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		awards:{
			type:"ContentReferenceCreateAwardsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		target:{
			type:"ContentReferenceCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionForm:{
			type:"ContentReferenceCreateSubscriptionFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttons:{
			type:"ContentReferenceCreateButtonsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		sharedContent:{
			type:"ContentReferenceCreateSharedContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ReviewContentUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentReference:{
			type:"ReviewContentUpdateContentReferenceEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ReviewContentUpdateContentReferenceEntityRelationInput:{
		create:{
			type:"ContentReferenceWithoutReviewsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentReferenceWithoutReviewsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ReviewContentUpsertContentReferenceRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutReviewsUpdateInput:{
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentPart:{
			type:"ContentReferenceUpdateContentPartEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		variant:{
			type:"ContentReferenceVariant",
			array:false,
			arrayRequired:false,
			required:false
		},
		color:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		embed:{
			type:"ContentReferenceUpdateEmbedEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ContentReferenceUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ContentReferenceUpdateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		images:{
			type:"ContentReferenceUpdateImagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pollAnswer:{
			type:"ContentReferenceUpdatePollAnswerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		listicle:{
			type:"ContentReferenceUpdateListicleEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		faq:{
			type:"ContentReferenceUpdateFaqEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		links:{
			type:"ContentReferenceUpdateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		awards:{
			type:"ContentReferenceUpdateAwardsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		target:{
			type:"ContentReferenceUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionForm:{
			type:"ContentReferenceUpdateSubscriptionFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttons:{
			type:"ContentReferenceUpdateButtonsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		sharedContent:{
			type:"ContentReferenceUpdateSharedContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ReviewContentUpsertContentReferenceRelationInput:{
		update:{
			type:"ContentReferenceWithoutReviewsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutReviewsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		template:{
			type:"PageTemplate",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"PageCreateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"PageCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionValidity:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		template:{
			type:"PageTemplate",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"PageUpdateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"PageUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionValidity:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextTranslationUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		key:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextTranslationWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		key:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		value:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		draft:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"TextTranslationWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"TextTranslationWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"TextTranslationWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextTranslationOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		key:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		value:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		draft:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextTranslationCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		key:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		value:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		draft:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TextTranslationUpdateInput:{
		key:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		value:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		draft:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		uses:{
			type:"FileCreateUsesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileCreateUsesEntityRelationInput:{
		connect:{
			type:"FileUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FileUseWithoutFileCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileUseWithoutFileCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		uses:{
			type:"FileUpdateUsesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileUpdateUsesEntityRelationInput:{
		create:{
			type:"FileUseWithoutFileCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FileUpdateUsesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FileUpsertUsesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"FileUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"FileUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"FileUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileUpdateUsesRelationInput:{
		by:{
			type:"FileUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"FileUseWithoutFileUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileUseWithoutFileUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileUpsertUsesRelationInput:{
		by:{
			type:"FileUseUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FileUseWithoutFileUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FileUseWithoutFileCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentBlockType",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtubeId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		targetLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"ContentBlockCreateIssueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"ContentBlockCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		articles:{
			type:"ContentBlockCreateArticlesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		subscriptionForm:{
			type:"ContentBlockCreateSubscriptionFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentBlockType",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtubeId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		targetLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		issue:{
			type:"ContentBlockUpdateIssueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"ContentBlockUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		articles:{
			type:"ContentBlockUpdateArticlesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		subscriptionForm:{
			type:"ContentBlockUpdateSubscriptionFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentArticleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentBlock:{
			type:"ContentArticleCreateContentBlockEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ContentArticleCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentArticleUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentBlock:{
			type:"ContentArticleUpdateContentBlockEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ContentArticleUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UnlockedArticleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		views:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		user:{
			type:"UnlockedArticleCreateUserEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"UnlockedArticleCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UnlockedArticleUpdateInput:{
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		views:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		user:{
			type:"UnlockedArticleUpdateUserEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"UnlockedArticleUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UserCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		ihnedId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		authors:{
			type:"UserCreateAuthorsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		unlockedArticles:{
			type:"UserCreateUnlockedArticlesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		appReviews:{
			type:"UserCreateAppReviewsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UserUpdateInput:{
		ihnedId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		authors:{
			type:"UserUpdateAuthorsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		unlockedArticles:{
			type:"UserUpdateUnlockedArticlesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		appReviews:{
			type:"UserUpdateAppReviewsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NotificationUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NotificationWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		message:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		sendAt:{
			type:"DateTimeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		sent:{
			type:"DateTimeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"NotificationWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"NotificationWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"NotificationWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NotificationOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		message:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		sendAt:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		sent:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NotificationCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		message:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		sendAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		sent:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NotificationUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		message:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		sendAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		sent:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppReviewCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		done:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		deviceId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		rating:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		note:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		user:{
			type:"AppReviewCreateUserEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppReviewCreateUserEntityRelationInput:{
		connect:{
			type:"UserUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"UserWithoutAppReviewsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UserWithoutAppReviewsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		ihnedId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		authors:{
			type:"UserCreateAuthorsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		unlockedArticles:{
			type:"UserCreateUnlockedArticlesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppReviewUpdateInput:{
		done:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		deviceId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		rating:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		note:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		user:{
			type:"AppReviewUpdateUserEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppReviewUpdateUserEntityRelationInput:{
		create:{
			type:"UserWithoutAppReviewsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"UserWithoutAppReviewsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"AppReviewUpsertUserRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"UserUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UserWithoutAppReviewsUpdateInput:{
		ihnedId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		authors:{
			type:"UserUpdateAuthorsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		unlockedArticles:{
			type:"UserUpdateUnlockedArticlesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppReviewUpsertUserRelationInput:{
		update:{
			type:"UserWithoutAppReviewsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"UserWithoutAppReviewsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		price:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"Types",
			array:false,
			arrayRequired:false,
			required:false
		},
		formOptions:{
			type:"ProductCreateFormOptionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		form:{
			type:"ProductCreateFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		productId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ProductUpdateInput:{
		price:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"Types",
			array:false,
			arrayRequired:false,
			required:false
		},
		formOptions:{
			type:"ProductUpdateFormOptionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		form:{
			type:"ProductUpdateFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		productId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		sections:{
			type:"SubscriptionFormCreateSectionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contentBlock:{
			type:"SubscriptionFormCreateContentBlockEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		products:{
			type:"SubscriptionFormCreateProductsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contentReferences:{
			type:"SubscriptionFormCreateContentReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		validity:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		sections:{
			type:"SubscriptionFormUpdateSectionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contentBlock:{
			type:"SubscriptionFormUpdateContentBlockEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		products:{
			type:"SubscriptionFormUpdateProductsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contentReferences:{
			type:"SubscriptionFormUpdateContentReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		validity:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormSectionCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		form:{
			type:"SubscriptionFormSectionCreateFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		inputs:{
			type:"SubscriptionFormSectionCreateInputsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormSectionUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		form:{
			type:"SubscriptionFormSectionUpdateFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		inputs:{
			type:"SubscriptionFormSectionUpdateInputsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormInputCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"SubscriptionFormInputType",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"SubscriptionFormInputCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		section:{
			type:"SubscriptionFormInputCreateSectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		options:{
			type:"SubscriptionFormInputCreateOptionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		description:{
			type:"SubscriptionFormInputCreateDescriptionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		required:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormInputUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"SubscriptionFormInputType",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"SubscriptionFormInputUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		section:{
			type:"SubscriptionFormInputUpdateSectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		options:{
			type:"SubscriptionFormInputUpdateOptionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		description:{
			type:"SubscriptionFormInputUpdateDescriptionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		required:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormOptionCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		hasProductId:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		priceTag:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		priceTagWithDiscount:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		products:{
			type:"SubscriptionFormOptionCreateProductsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		formInput:{
			type:"SubscriptionFormOptionCreateFormInputEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		value:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubscriptionFormOptionUpdateInput:{
		hasProductId:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		priceTag:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		priceTagWithDiscount:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		products:{
			type:"SubscriptionFormOptionUpdateProductsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		formInput:{
			type:"SubscriptionFormOptionUpdateFormInputEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		value:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ButtonCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ButtonType",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"ButtonCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentReference:{
			type:"ButtonCreateContentReferenceEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ButtonCreateContentReferenceEntityRelationInput:{
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutButtonsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutButtonsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentPart:{
			type:"ContentReferenceCreateContentPartEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		variant:{
			type:"ContentReferenceVariant",
			array:false,
			arrayRequired:false,
			required:false
		},
		color:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		embed:{
			type:"ContentReferenceCreateEmbedEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ContentReferenceCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ContentReferenceCreateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		images:{
			type:"ContentReferenceCreateImagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pollAnswer:{
			type:"ContentReferenceCreatePollAnswerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		listicle:{
			type:"ContentReferenceCreateListicleEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		faq:{
			type:"ContentReferenceCreateFaqEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		links:{
			type:"ContentReferenceCreateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		awards:{
			type:"ContentReferenceCreateAwardsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		reviews:{
			type:"ContentReferenceCreateReviewsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		target:{
			type:"ContentReferenceCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionForm:{
			type:"ContentReferenceCreateSubscriptionFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		sharedContent:{
			type:"ContentReferenceCreateSharedContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ButtonUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ButtonType",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"ButtonUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentReference:{
			type:"ButtonUpdateContentReferenceEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ButtonUpdateContentReferenceEntityRelationInput:{
		create:{
			type:"ContentReferenceWithoutButtonsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentReferenceWithoutButtonsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ButtonUpsertContentReferenceRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutButtonsUpdateInput:{
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentPart:{
			type:"ContentReferenceUpdateContentPartEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		variant:{
			type:"ContentReferenceVariant",
			array:false,
			arrayRequired:false,
			required:false
		},
		color:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		embed:{
			type:"ContentReferenceUpdateEmbedEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ContentReferenceUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ContentReferenceUpdateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		images:{
			type:"ContentReferenceUpdateImagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pollAnswer:{
			type:"ContentReferenceUpdatePollAnswerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		listicle:{
			type:"ContentReferenceUpdateListicleEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		faq:{
			type:"ContentReferenceUpdateFaqEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		links:{
			type:"ContentReferenceUpdateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		awards:{
			type:"ContentReferenceUpdateAwardsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		reviews:{
			type:"ContentReferenceUpdateReviewsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		target:{
			type:"ContentReferenceUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionForm:{
			type:"ContentReferenceUpdateSubscriptionFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		sharedContent:{
			type:"ContentReferenceUpdateSharedContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ButtonUpsertContentReferenceRelationInput:{
		update:{
			type:"ContentReferenceWithoutButtonsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutButtonsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleHistoryTagCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleHistoryTagCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyTag:{
			type:"ArticleHistoryTagCreateHistoryTagEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleHistoryTagCreateArticleEntityRelationInput:{
		connect:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleWithoutHistoryTagsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleWithoutHistoryTagsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"ArticleCreateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		authors:{
			type:"ArticleCreateAuthorsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		hideInMostRead:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		hideAds:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		state:{
			type:"ArticleState",
			array:false,
			arrayRequired:false,
			required:false
		},
		locked:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		template:{
			type:"Template",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"ArticleCreateSubtitleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ArticleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverPhoto:{
			type:"ArticleCreateCoverPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleAlignment:{
			type:"ArticleTitleAlignment",
			array:false,
			arrayRequired:false,
			required:false
		},
		tagline:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		previewContent:{
			type:"ArticleCreatePreviewContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ArticleCreateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		categories:{
			type:"ArticleCreateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		issues:{
			type:"ArticleCreateIssuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contentBlocks:{
			type:"ArticleCreateContentBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		unlocked:{
			type:"ArticleCreateUnlockedEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		coverPhotoVertical:{
			type:"ArticleCreateCoverPhotoVerticalEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"ArticleCreateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		isHistory:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyPeriods:{
			type:"ArticleCreateHistoryPeriodsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleHistoryTagUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleHistoryTagUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyTag:{
			type:"ArticleHistoryTagUpdateHistoryTagEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleHistoryTagUpdateArticleEntityRelationInput:{
		create:{
			type:"ArticleWithoutHistoryTagsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArticleWithoutHistoryTagsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArticleHistoryTagUpsertArticleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleWithoutHistoryTagsUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"ArticleUpdateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		authors:{
			type:"ArticleUpdateAuthorsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		hideInMostRead:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		hideAds:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		state:{
			type:"ArticleState",
			array:false,
			arrayRequired:false,
			required:false
		},
		locked:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		template:{
			type:"Template",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"ArticleUpdateSubtitleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ArticleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverPhoto:{
			type:"ArticleUpdateCoverPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleAlignment:{
			type:"ArticleTitleAlignment",
			array:false,
			arrayRequired:false,
			required:false
		},
		tagline:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		previewContent:{
			type:"ArticleUpdatePreviewContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ArticleUpdateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		categories:{
			type:"ArticleUpdateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		issues:{
			type:"ArticleUpdateIssuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contentBlocks:{
			type:"ArticleUpdateContentBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		unlocked:{
			type:"ArticleUpdateUnlockedEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		coverPhotoVertical:{
			type:"ArticleUpdateCoverPhotoVerticalEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"ArticleUpdateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		isHistory:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyPeriods:{
			type:"ArticleUpdateHistoryPeriodsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleHistoryTagUpsertArticleRelationInput:{
		update:{
			type:"ArticleWithoutHistoryTagsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleWithoutHistoryTagsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleHistoryPeriodCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleHistoryPeriodCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyPeriod:{
			type:"ArticleHistoryPeriodCreateHistoryPeriodEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleHistoryPeriodCreateArticleEntityRelationInput:{
		connect:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleWithoutHistoryPeriodsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleWithoutHistoryPeriodsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"ArticleCreateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		authors:{
			type:"ArticleCreateAuthorsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		hideInMostRead:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		hideAds:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		state:{
			type:"ArticleState",
			array:false,
			arrayRequired:false,
			required:false
		},
		locked:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		template:{
			type:"Template",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"ArticleCreateSubtitleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ArticleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverPhoto:{
			type:"ArticleCreateCoverPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleAlignment:{
			type:"ArticleTitleAlignment",
			array:false,
			arrayRequired:false,
			required:false
		},
		tagline:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		previewContent:{
			type:"ArticleCreatePreviewContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ArticleCreateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		categories:{
			type:"ArticleCreateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		issues:{
			type:"ArticleCreateIssuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contentBlocks:{
			type:"ArticleCreateContentBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		unlocked:{
			type:"ArticleCreateUnlockedEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		coverPhotoVertical:{
			type:"ArticleCreateCoverPhotoVerticalEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"ArticleCreateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		isHistory:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyTags:{
			type:"ArticleCreateHistoryTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleHistoryPeriodUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleHistoryPeriodUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyPeriod:{
			type:"ArticleHistoryPeriodUpdateHistoryPeriodEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleHistoryPeriodUpdateArticleEntityRelationInput:{
		create:{
			type:"ArticleWithoutHistoryPeriodsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArticleWithoutHistoryPeriodsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArticleHistoryPeriodUpsertArticleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArticleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleWithoutHistoryPeriodsUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"ArticleUpdateUrlEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		authors:{
			type:"ArticleUpdateAuthorsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		hideInMostRead:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		hideAds:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		state:{
			type:"ArticleState",
			array:false,
			arrayRequired:false,
			required:false
		},
		locked:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		publishAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		template:{
			type:"Template",
			array:false,
			arrayRequired:false,
			required:false
		},
		subtitle:{
			type:"ArticleUpdateSubtitleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ArticleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		coverPhoto:{
			type:"ArticleUpdateCoverPhotoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleAlignment:{
			type:"ArticleTitleAlignment",
			array:false,
			arrayRequired:false,
			required:false
		},
		tagline:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		previewContent:{
			type:"ArticleUpdatePreviewContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ArticleUpdateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		categories:{
			type:"ArticleUpdateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		issues:{
			type:"ArticleUpdateIssuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contentBlocks:{
			type:"ArticleUpdateContentBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		unlocked:{
			type:"ArticleUpdateUnlockedEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		coverPhotoVertical:{
			type:"ArticleUpdateCoverPhotoVerticalEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		legacyId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"ArticleUpdateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		isHistory:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		historyTags:{
			type:"ArticleUpdateHistoryTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleHistoryPeriodUpsertArticleRelationInput:{
		update:{
			type:"ArticleWithoutHistoryPeriodsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleWithoutHistoryPeriodsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTagCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		articleHistoryTag:{
			type:"HistoryTagCreateArticleHistoryTagEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		slug:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTagCreateArticleHistoryTagEntityRelationInput:{
		connect:{
			type:"ArticleHistoryTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleHistoryTagWithoutHistoryTagCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleHistoryTagWithoutHistoryTagCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleHistoryTagCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTagUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		articleHistoryTag:{
			type:"HistoryTagUpdateArticleHistoryTagEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		slug:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTagUpdateArticleHistoryTagEntityRelationInput:{
		create:{
			type:"ArticleHistoryTagWithoutHistoryTagCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HistoryTagUpdateArticleHistoryTagRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HistoryTagUpsertArticleHistoryTagRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArticleHistoryTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ArticleHistoryTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ArticleHistoryTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTagUpdateArticleHistoryTagRelationInput:{
		by:{
			type:"ArticleHistoryTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ArticleHistoryTagWithoutHistoryTagUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleHistoryTagWithoutHistoryTagUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleHistoryTagUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTagUpsertArticleHistoryTagRelationInput:{
		by:{
			type:"ArticleHistoryTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArticleHistoryTagWithoutHistoryTagUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleHistoryTagWithoutHistoryTagCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryPeriodCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		articleHistoryPeriod:{
			type:"HistoryPeriodCreateArticleHistoryPeriodEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		slug:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		cover:{
			type:"HistoryPeriodCreateCoverEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"HistoryPeriodCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryPeriodCreateArticleHistoryPeriodEntityRelationInput:{
		connect:{
			type:"ArticleHistoryPeriodUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleHistoryPeriodWithoutHistoryPeriodCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleHistoryPeriodWithoutHistoryPeriodCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleHistoryPeriodCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryPeriodUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		articleHistoryPeriod:{
			type:"HistoryPeriodUpdateArticleHistoryPeriodEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		slug:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		cover:{
			type:"HistoryPeriodUpdateCoverEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"HistoryPeriodUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryPeriodUpdateArticleHistoryPeriodEntityRelationInput:{
		create:{
			type:"ArticleHistoryPeriodWithoutHistoryPeriodCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HistoryPeriodUpdateArticleHistoryPeriodRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HistoryPeriodUpsertArticleHistoryPeriodRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArticleHistoryPeriodUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ArticleHistoryPeriodUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ArticleHistoryPeriodUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryPeriodUpdateArticleHistoryPeriodRelationInput:{
		by:{
			type:"ArticleHistoryPeriodUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ArticleHistoryPeriodWithoutHistoryPeriodUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArticleHistoryPeriodWithoutHistoryPeriodUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ArticleHistoryPeriodUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryPeriodUpsertArticleHistoryPeriodRelationInput:{
		by:{
			type:"ArticleHistoryPeriodUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArticleHistoryPeriodWithoutHistoryPeriodUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArticleHistoryPeriodWithoutHistoryPeriodCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryHomePage:{
		cover:{
			filter:{
				type:"HistoryCoverWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	HistoryHomePageUnique: "enum",
	HistoryHomePageUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"HistoryHomePageUnique",
			array:false,
			arrayRequired:false,
			required:false
		},
		slug:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		cover:{
			type:"HistoryCoverUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryHomePageWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"HistoryHomePageUniqueCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		timePeriodTitle:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		personalitiesTitle:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		cover:{
			type:"HistoryCoverWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		slug:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"HistoryHomePageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"HistoryHomePageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"HistoryHomePageWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryHomePageUniqueCondition:{
		and:{
			type:"HistoryHomePageUniqueCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"HistoryHomePageUniqueCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"HistoryHomePageUniqueCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"HistoryHomePageUnique",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"HistoryHomePageUnique",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"HistoryHomePageUnique",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"HistoryHomePageUnique",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"HistoryHomePageUnique",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"HistoryHomePageUnique",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"HistoryHomePageUnique",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"HistoryHomePageUnique",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryHomePageOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		timePeriodTitle:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		personalitiesTitle:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		cover:{
			type:"HistoryCoverOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		slug:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryHomePageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"HistoryHomePageUnique",
			array:false,
			arrayRequired:false,
			required:false
		},
		timePeriodTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		personalitiesTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		cover:{
			type:"HistoryHomePageCreateCoverEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"HistoryHomePageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		slug:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryHomePageCreateCoverEntityRelationInput:{
		connect:{
			type:"HistoryCoverUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HistoryCoverCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryHomePageCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryHomePageUpdateInput:{
		unique:{
			type:"HistoryHomePageUnique",
			array:false,
			arrayRequired:false,
			required:false
		},
		timePeriodTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		personalitiesTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		cover:{
			type:"HistoryHomePageUpdateCoverEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"HistoryHomePageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		slug:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryHomePageUpdateCoverEntityRelationInput:{
		create:{
			type:"HistoryCoverCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HistoryCoverUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HistoryHomePageUpsertCoverRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"HistoryCoverUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryHomePageUpsertCoverRelationInput:{
		update:{
			type:"HistoryCoverUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HistoryCoverCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryHomePageUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HistoryHomePageUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryHomePageUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTextItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		key:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"HistoryTextItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"HistoryTextItemCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTextItemCreateListEntityRelationInput:{
		connect:{
			type:"HistoryTextListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HistoryTextListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTextListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTextItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		key:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"HistoryTextItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"HistoryTextItemUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTextItemUpdateListEntityRelationInput:{
		create:{
			type:"HistoryTextListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HistoryTextListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HistoryTextItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"HistoryTextListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTextListWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HistoryTextItemUpsertListRelationInput:{
		update:{
			type:"HistoryTextListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HistoryTextListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterMenu:{
		online:{
			filter:{
				type:"OnlineSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		links:{
			filter:{
				type:"LinkSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		linksTwo:{
			filter:{
				type:"LinkSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		social:{
			filter:{
				type:"SocialSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		newsletter:{
			filter:{
				type:"NewsletterSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	FooterMenuUnique: "enum",
	OnlineSection:{
		appLinks:{
			filter:{
				type:"AppLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		links:{
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	AppLinkList:{
		items:{
			filter:{
				type:"AppLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AppLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		itemsByAppLink:{
			by:{
				type:"AppLinkListItemsByAppLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AppLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"AppLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AppLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	AppLinkItem:{
		list:{
			filter:{
				type:"AppLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		appLink:{
			filter:{
				type:"AppLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	AppLinkListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"AppLinkItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"AppLinkListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"AppLinkListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"AppLinkListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppLinkItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"AppLinkListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		appLink:{
			type:"AppLinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"AppLinkItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"AppLinkItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"AppLinkItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppLinkWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"AppLinkTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"AppLinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"AppLinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"AppLinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppLinkTypeCondition:{
		and:{
			type:"AppLinkTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"AppLinkTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"AppLinkTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"AppLinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"AppLinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"AppLinkType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"AppLinkType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"AppLinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"AppLinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"AppLinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"AppLinkType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppLinkType: "enum",
	AppLinkItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"AppLinkListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		appLink:{
			type:"AppLinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppLinkListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppLinkOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppLinkListItemsByAppLinkUniqueWhere:{
		appLink:{
			type:"AppLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppLinkUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkList:{
		items:{
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	LinkItem:{
		list:{
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	LinkListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"LinkItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"LinkListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"LinkListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"LinkListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"LinkListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"LinkItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"LinkItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"LinkItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"LinkListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OnlineSectionWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		appLinks:{
			type:"AppLinkListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"LinkListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"OnlineSectionWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"OnlineSectionWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"OnlineSectionWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkSection:{
		links:{
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	LinkSectionWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"LinkListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"LinkSectionWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"LinkSectionWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"LinkSectionWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialSection:{
		socialLinks:{
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	SocialLinkList:{
		items:{
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		itemsBySocialLink:{
			by:{
				type:"SocialLinkListItemsBySocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	SocialLinkItem:{
		list:{
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		socialLink:{
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	SocialLinkListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"SocialLinkItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SocialLinkListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SocialLinkListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SocialLinkListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"SocialLinkListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLink:{
			type:"SocialLinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SocialLinkItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SocialLinkItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SocialLinkItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"SocialLinkTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SocialLinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SocialLinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SocialLinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkTypeCondition:{
		and:{
			type:"SocialLinkTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"SocialLinkTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"SocialLinkTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"SocialLinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"SocialLinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"SocialLinkType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"SocialLinkType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"SocialLinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"SocialLinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"SocialLinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"SocialLinkType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkType: "enum",
	SocialLinkItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"SocialLinkListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLink:{
			type:"SocialLinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListItemsBySocialLinkUniqueWhere:{
		socialLink:{
			type:"SocialLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialSectionWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"SocialLinkListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SocialSectionWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SocialSectionWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SocialSectionWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterSection:{
		newsletter:{
			filter:{
				type:"NewsletterWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	NewsletterWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		input:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		button:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"NewsletterWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"NewsletterWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"NewsletterWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterSectionWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletter:{
			type:"NewsletterWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"NewsletterSectionWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"NewsletterSectionWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"NewsletterSectionWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterMenuUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"FooterMenuUnique",
			array:false,
			arrayRequired:false,
			required:false
		},
		online:{
			type:"OnlineSectionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"LinkSectionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		linksTwo:{
			type:"LinkSectionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		social:{
			type:"SocialSectionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletter:{
			type:"NewsletterSectionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OnlineSectionUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		appLinks:{
			type:"AppLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"LinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppLinkListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"AppLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppLinkItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		appLink:{
			type:"AppLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"LinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkSectionUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"LinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialSectionUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"SocialLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"SocialLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLink:{
			type:"SocialLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterSectionUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletter:{
			type:"NewsletterUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterMenuWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"FooterMenuUniqueCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		copyright:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		online:{
			type:"OnlineSectionWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"LinkSectionWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		linksTwo:{
			type:"LinkSectionWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		social:{
			type:"SocialSectionWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletter:{
			type:"NewsletterSectionWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"FooterMenuWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"FooterMenuWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"FooterMenuWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterMenuUniqueCondition:{
		and:{
			type:"FooterMenuUniqueCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"FooterMenuUniqueCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"FooterMenuUniqueCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"FooterMenuUnique",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"FooterMenuUnique",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"FooterMenuUnique",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"FooterMenuUnique",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"FooterMenuUnique",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"FooterMenuUnique",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"FooterMenuUnique",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"FooterMenuUnique",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterMenuOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		copyright:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		online:{
			type:"OnlineSectionOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"LinkSectionOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		linksTwo:{
			type:"LinkSectionOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		social:{
			type:"SocialSectionOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletter:{
			type:"NewsletterSectionOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OnlineSectionOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		appLinks:{
			type:"AppLinkListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"LinkListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkSectionOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"LinkListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialSectionOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"SocialLinkListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterSectionOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletter:{
			type:"NewsletterOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		input:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		button:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterMenuCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"FooterMenuUnique",
			array:false,
			arrayRequired:false,
			required:false
		},
		copyright:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		online:{
			type:"FooterMenuCreateOnlineEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"FooterMenuCreateLinksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		linksTwo:{
			type:"FooterMenuCreateLinksTwoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		social:{
			type:"FooterMenuCreateSocialEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletter:{
			type:"FooterMenuCreateNewsletterEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterMenuCreateOnlineEntityRelationInput:{
		connect:{
			type:"OnlineSectionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"OnlineSectionCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OnlineSectionCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		appLinks:{
			type:"OnlineSectionCreateAppLinksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"OnlineSectionCreateLinksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OnlineSectionCreateAppLinksEntityRelationInput:{
		connect:{
			type:"AppLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AppLinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppLinkListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"AppLinkListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppLinkListCreateItemsEntityRelationInput:{
		connect:{
			type:"AppLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AppLinkItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppLinkItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		appLink:{
			type:"AppLinkItemCreateAppLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppLinkItemCreateAppLinkEntityRelationInput:{
		connect:{
			type:"AppLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AppLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"AppLinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OnlineSectionCreateLinksEntityRelationInput:{
		connect:{
			type:"LinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"LinkListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListCreateItemsEntityRelationInput:{
		connect:{
			type:"LinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkItemCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterMenuCreateLinksEntityRelationInput:{
		connect:{
			type:"LinkSectionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkSectionCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkSectionCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"LinkSectionCreateLinksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkSectionCreateLinksEntityRelationInput:{
		connect:{
			type:"LinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterMenuCreateLinksTwoEntityRelationInput:{
		connect:{
			type:"LinkSectionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkSectionCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterMenuCreateSocialEntityRelationInput:{
		connect:{
			type:"SocialSectionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SocialSectionCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialSectionCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"SocialSectionCreateSocialLinksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialSectionCreateSocialLinksEntityRelationInput:{
		connect:{
			type:"SocialLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SocialLinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"SocialLinkListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListCreateItemsEntityRelationInput:{
		connect:{
			type:"SocialLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SocialLinkItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLink:{
			type:"SocialLinkItemCreateSocialLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemCreateSocialLinkEntityRelationInput:{
		connect:{
			type:"SocialLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SocialLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"SocialLinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterMenuCreateNewsletterEntityRelationInput:{
		connect:{
			type:"NewsletterSectionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"NewsletterSectionCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterSectionCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletter:{
			type:"NewsletterSectionCreateNewsletterEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterSectionCreateNewsletterEntityRelationInput:{
		connect:{
			type:"NewsletterUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"NewsletterCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		input:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		button:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterMenuUpdateInput:{
		unique:{
			type:"FooterMenuUnique",
			array:false,
			arrayRequired:false,
			required:false
		},
		copyright:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		online:{
			type:"FooterMenuUpdateOnlineEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"FooterMenuUpdateLinksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		linksTwo:{
			type:"FooterMenuUpdateLinksTwoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		social:{
			type:"FooterMenuUpdateSocialEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletter:{
			type:"FooterMenuUpdateNewsletterEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterMenuUpdateOnlineEntityRelationInput:{
		create:{
			type:"OnlineSectionCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"OnlineSectionUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterMenuUpsertOnlineRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"OnlineSectionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OnlineSectionUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		appLinks:{
			type:"OnlineSectionUpdateAppLinksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"OnlineSectionUpdateLinksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OnlineSectionUpdateAppLinksEntityRelationInput:{
		create:{
			type:"AppLinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"AppLinkListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"OnlineSectionUpsertAppLinksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"AppLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppLinkListUpdateInput:{
		items:{
			type:"AppLinkListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppLinkListUpdateItemsEntityRelationInput:{
		create:{
			type:"AppLinkItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"AppLinkListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"AppLinkListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"AppLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"AppLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"AppLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppLinkListUpdateItemsRelationInput:{
		by:{
			type:"AppLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"AppLinkItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppLinkItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		appLink:{
			type:"AppLinkItemUpdateAppLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppLinkItemUpdateAppLinkEntityRelationInput:{
		create:{
			type:"AppLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"AppLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"AppLinkItemUpsertAppLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"AppLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppLinkUpdateInput:{
		type:{
			type:"AppLinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppLinkItemUpsertAppLinkRelationInput:{
		update:{
			type:"AppLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AppLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppLinkListUpsertItemsRelationInput:{
		by:{
			type:"AppLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"AppLinkItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AppLinkItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OnlineSectionUpsertAppLinksRelationInput:{
		update:{
			type:"AppLinkListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AppLinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OnlineSectionUpdateLinksEntityRelationInput:{
		create:{
			type:"LinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"OnlineSectionUpsertLinksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListUpdateInput:{
		items:{
			type:"LinkListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListUpdateItemsEntityRelationInput:{
		create:{
			type:"LinkItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"LinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"LinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListUpdateItemsRelationInput:{
		by:{
			type:"LinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"LinkItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkItemUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkItemUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemUpsertLinkRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListUpsertItemsRelationInput:{
		by:{
			type:"LinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OnlineSectionUpsertLinksRelationInput:{
		update:{
			type:"LinkListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterMenuUpsertOnlineRelationInput:{
		update:{
			type:"OnlineSectionUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"OnlineSectionCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterMenuUpdateLinksEntityRelationInput:{
		create:{
			type:"LinkSectionCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkSectionUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterMenuUpsertLinksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkSectionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkSectionUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"LinkSectionUpdateLinksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkSectionUpdateLinksEntityRelationInput:{
		create:{
			type:"LinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkSectionUpsertLinksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkSectionUpsertLinksRelationInput:{
		update:{
			type:"LinkListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterMenuUpsertLinksRelationInput:{
		update:{
			type:"LinkSectionUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkSectionCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterMenuUpdateLinksTwoEntityRelationInput:{
		create:{
			type:"LinkSectionCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkSectionUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterMenuUpsertLinksTwoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkSectionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterMenuUpsertLinksTwoRelationInput:{
		update:{
			type:"LinkSectionUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkSectionCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterMenuUpdateSocialEntityRelationInput:{
		create:{
			type:"SocialSectionCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SocialSectionUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterMenuUpsertSocialRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SocialSectionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialSectionUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"SocialSectionUpdateSocialLinksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialSectionUpdateSocialLinksEntityRelationInput:{
		create:{
			type:"SocialLinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SocialLinkListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SocialSectionUpsertSocialLinksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SocialLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListUpdateInput:{
		items:{
			type:"SocialLinkListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListUpdateItemsEntityRelationInput:{
		create:{
			type:"SocialLinkItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SocialLinkListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SocialLinkListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SocialLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"SocialLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"SocialLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListUpdateItemsRelationInput:{
		by:{
			type:"SocialLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"SocialLinkItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLink:{
			type:"SocialLinkItemUpdateSocialLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemUpdateSocialLinkEntityRelationInput:{
		create:{
			type:"SocialLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SocialLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SocialLinkItemUpsertSocialLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SocialLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkUpdateInput:{
		type:{
			type:"SocialLinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemUpsertSocialLinkRelationInput:{
		update:{
			type:"SocialLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SocialLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListUpsertItemsRelationInput:{
		by:{
			type:"SocialLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SocialLinkItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SocialLinkItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialSectionUpsertSocialLinksRelationInput:{
		update:{
			type:"SocialLinkListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SocialLinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterMenuUpsertSocialRelationInput:{
		update:{
			type:"SocialSectionUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SocialSectionCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterMenuUpdateNewsletterEntityRelationInput:{
		create:{
			type:"NewsletterSectionCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"NewsletterSectionUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterMenuUpsertNewsletterRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"NewsletterSectionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterSectionUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletter:{
			type:"NewsletterSectionUpdateNewsletterEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterSectionUpdateNewsletterEntityRelationInput:{
		create:{
			type:"NewsletterCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"NewsletterUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"NewsletterSectionUpsertNewsletterRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"NewsletterUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterUpdateInput:{
		input:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		button:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterSectionUpsertNewsletterRelationInput:{
		update:{
			type:"NewsletterUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"NewsletterCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterMenuUpsertNewsletterRelationInput:{
		update:{
			type:"NewsletterSectionUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"NewsletterSectionCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"LinkItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkItemCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemCreateListEntityRelationInput:{
		connect:{
			type:"LinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"LinkItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkItemUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemUpdateListEntityRelationInput:{
		create:{
			type:"LinkListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemUpsertListRelationInput:{
		update:{
			type:"LinkListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppLinkItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"AppLinkItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		appLink:{
			type:"AppLinkItemCreateAppLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppLinkItemCreateListEntityRelationInput:{
		connect:{
			type:"AppLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AppLinkListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppLinkListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppLinkItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"AppLinkItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		appLink:{
			type:"AppLinkItemUpdateAppLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppLinkItemUpdateListEntityRelationInput:{
		create:{
			type:"AppLinkListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"AppLinkListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"AppLinkItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"AppLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppLinkListWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	AppLinkItemUpsertListRelationInput:{
		update:{
			type:"AppLinkListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"AppLinkListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"SocialLinkItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLink:{
			type:"SocialLinkItemCreateSocialLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemCreateListEntityRelationInput:{
		connect:{
			type:"SocialLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SocialLinkListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"SocialLinkItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLink:{
			type:"SocialLinkItemUpdateSocialLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemUpdateListEntityRelationInput:{
		create:{
			type:"SocialLinkListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SocialLinkListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SocialLinkItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SocialLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemUpsertListRelationInput:{
		update:{
			type:"SocialLinkListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SocialLinkListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SharedContentCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentReference:{
			type:"SharedContentCreateContentReferenceEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		content:{
			type:"SharedContentCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SharedContentCreateContentReferenceEntityRelationInput:{
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutSharedContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutSharedContentCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentPart:{
			type:"ContentReferenceCreateContentPartEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		variant:{
			type:"ContentReferenceVariant",
			array:false,
			arrayRequired:false,
			required:false
		},
		color:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		embed:{
			type:"ContentReferenceCreateEmbedEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ContentReferenceCreateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ContentReferenceCreateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		images:{
			type:"ContentReferenceCreateImagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pollAnswer:{
			type:"ContentReferenceCreatePollAnswerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		listicle:{
			type:"ContentReferenceCreateListicleEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		faq:{
			type:"ContentReferenceCreateFaqEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		links:{
			type:"ContentReferenceCreateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		awards:{
			type:"ContentReferenceCreateAwardsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		reviews:{
			type:"ContentReferenceCreateReviewsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		target:{
			type:"ContentReferenceCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionForm:{
			type:"ContentReferenceCreateSubscriptionFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttons:{
			type:"ContentReferenceCreateButtonsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SharedContentUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentReference:{
			type:"SharedContentUpdateContentReferenceEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		content:{
			type:"SharedContentUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SharedContentUpdateContentReferenceEntityRelationInput:{
		create:{
			type:"ContentReferenceWithoutSharedContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SharedContentUpdateContentReferenceRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SharedContentUpsertContentReferenceRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SharedContentUpdateContentReferenceRelationInput:{
		by:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ContentReferenceWithoutSharedContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutSharedContentUpdateInput:{
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentPart:{
			type:"ContentReferenceUpdateContentPartEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		variant:{
			type:"ContentReferenceVariant",
			array:false,
			arrayRequired:false,
			required:false
		},
		color:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		embed:{
			type:"ContentReferenceUpdateEmbedEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		article:{
			type:"ContentReferenceUpdateArticleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		audio:{
			type:"ContentReferenceUpdateAudioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		images:{
			type:"ContentReferenceUpdateImagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pollAnswer:{
			type:"ContentReferenceUpdatePollAnswerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		listicle:{
			type:"ContentReferenceUpdateListicleEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		faq:{
			type:"ContentReferenceUpdateFaqEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		links:{
			type:"ContentReferenceUpdateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		awards:{
			type:"ContentReferenceUpdateAwardsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		reviews:{
			type:"ContentReferenceUpdateReviewsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		target:{
			type:"ContentReferenceUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptionForm:{
			type:"ContentReferenceUpdateSubscriptionFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttons:{
			type:"ContentReferenceUpdateButtonsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SharedContentUpsertContentReferenceRelationInput:{
		by:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentReferenceWithoutSharedContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutSharedContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	QueryTransaction:{
		getArticle:{
			by:{
				type:"ArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listArticle:{
			filter:{
				type:"ArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArticle:{
			filter:{
				type:"ArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateArticle:{
			data:{
				type:"ArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateArticle:{
			by:{
				type:"ArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getArticleAuthor:{
			by:{
				type:"ArticleAuthorUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleAuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listArticleAuthor:{
			filter:{
				type:"ArticleAuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleAuthorOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArticleAuthor:{
			filter:{
				type:"ArticleAuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleAuthorOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateArticleAuthor:{
			data:{
				type:"ArticleAuthorCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateArticleAuthor:{
			by:{
				type:"ArticleAuthorUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ArticleAuthorUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getAuthor:{
			by:{
				type:"AuthorUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listAuthor:{
			filter:{
				type:"AuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AuthorOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateAuthor:{
			filter:{
				type:"AuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AuthorOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateAuthor:{
			data:{
				type:"AuthorCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateAuthor:{
			by:{
				type:"AuthorUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"AuthorUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getAuthorTopArticle:{
			by:{
				type:"AuthorTopArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AuthorTopArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listAuthorTopArticle:{
			filter:{
				type:"AuthorTopArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AuthorTopArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateAuthorTopArticle:{
			filter:{
				type:"AuthorTopArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AuthorTopArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateAuthorTopArticle:{
			data:{
				type:"AuthorTopArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateAuthorTopArticle:{
			by:{
				type:"AuthorTopArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"AuthorTopArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContent:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContent:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContent:{
			data:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentPart:{
			by:{
				type:"ContentPartUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentPartWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentPart:{
			filter:{
				type:"ContentPartWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentPartOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentPart:{
			filter:{
				type:"ContentPartWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentPartOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentPart:{
			data:{
				type:"ContentPartCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentPart:{
			by:{
				type:"ContentPartUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentPartUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentReference:{
			data:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHomepageArticle:{
			by:{
				type:"HomepageArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomepageArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHomepageArticle:{
			filter:{
				type:"HomepageArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomepageArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHomepageArticle:{
			filter:{
				type:"HomepageArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomepageArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHomepageArticle:{
			data:{
				type:"HomepageArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHomepageArticle:{
			by:{
				type:"HomepageArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HomepageArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImage:{
			data:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImageUse:{
			by:{
				type:"ImageUseUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImageUse:{
			filter:{
				type:"ImageUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageUseOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImageUse:{
			filter:{
				type:"ImageUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageUseOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImageUse:{
			data:{
				type:"ImageUseCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImageUse:{
			by:{
				type:"ImageUseUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageUseUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImageTag:{
			by:{
				type:"ImageTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImageTag:{
			filter:{
				type:"ImageTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImageTag:{
			filter:{
				type:"ImageTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImageTag:{
			data:{
				type:"ImageTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImageTag:{
			by:{
				type:"ImageTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getIssue:{
			by:{
				type:"IssueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"IssueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listIssue:{
			filter:{
				type:"IssueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"IssueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateIssue:{
			filter:{
				type:"IssueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"IssueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateIssue:{
			data:{
				type:"IssueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateIssue:{
			by:{
				type:"IssueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"IssueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getIssueArticle:{
			by:{
				type:"IssueArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"IssueArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listIssueArticle:{
			filter:{
				type:"IssueArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"IssueArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateIssueArticle:{
			filter:{
				type:"IssueArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"IssueArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateIssueArticle:{
			data:{
				type:"IssueArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateIssueArticle:{
			by:{
				type:"IssueArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"IssueArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLink:{
			data:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTextContent:{
			by:{
				type:"TextContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTextContent:{
			filter:{
				type:"TextContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TextContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTextContent:{
			filter:{
				type:"TextContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TextContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTextContent:{
			data:{
				type:"TextContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTextContent:{
			by:{
				type:"TextContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TextContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTextContentPart:{
			by:{
				type:"TextContentPartUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextContentPartWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTextContentPart:{
			filter:{
				type:"TextContentPartWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TextContentPartOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTextContentPart:{
			filter:{
				type:"TextContentPartWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TextContentPartOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTextContentPart:{
			data:{
				type:"TextContentPartCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTextContentPart:{
			by:{
				type:"TextContentPartUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TextContentPartUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTextContentReference:{
			by:{
				type:"TextContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTextContentReference:{
			filter:{
				type:"TextContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TextContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTextContentReference:{
			filter:{
				type:"TextContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TextContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTextContentReference:{
			data:{
				type:"TextContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTextContentReference:{
			by:{
				type:"TextContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TextContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getUrl:{
			by:{
				type:"UrlUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"UrlWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listUrl:{
			filter:{
				type:"UrlWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"UrlOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateUrl:{
			filter:{
				type:"UrlWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"UrlOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateUrl:{
			data:{
				type:"UrlCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateUrl:{
			by:{
				type:"UrlUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"UrlUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getArticleTag:{
			by:{
				type:"ArticleTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listArticleTag:{
			filter:{
				type:"ArticleTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArticleTag:{
			filter:{
				type:"ArticleTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateArticleTag:{
			data:{
				type:"ArticleTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateArticleTag:{
			by:{
				type:"ArticleTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ArticleTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getCategory:{
			by:{
				type:"CategoryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listCategory:{
			filter:{
				type:"CategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CategoryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateCategory:{
			filter:{
				type:"CategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CategoryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateCategory:{
			data:{
				type:"CategoryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateCategory:{
			by:{
				type:"CategoryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"CategoryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getArticleCategory:{
			by:{
				type:"ArticleCategoryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleCategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listArticleCategory:{
			filter:{
				type:"ArticleCategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleCategoryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArticleCategory:{
			filter:{
				type:"ArticleCategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleCategoryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateArticleCategory:{
			data:{
				type:"ArticleCategoryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateArticleCategory:{
			by:{
				type:"ArticleCategoryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ArticleCategoryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getAudio:{
			by:{
				type:"AudioUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AudioWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listAudio:{
			filter:{
				type:"AudioWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AudioOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateAudio:{
			filter:{
				type:"AudioWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AudioOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateAudio:{
			data:{
				type:"AudioCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateAudio:{
			by:{
				type:"AudioUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"AudioUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getAudioUse:{
			by:{
				type:"AudioUseUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AudioUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listAudioUse:{
			filter:{
				type:"AudioUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AudioUseOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateAudioUse:{
			filter:{
				type:"AudioUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AudioUseOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateAudioUse:{
			data:{
				type:"AudioUseCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateAudioUse:{
			by:{
				type:"AudioUseUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"AudioUseUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getEmbed:{
			by:{
				type:"EmbedUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmbedWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listEmbed:{
			filter:{
				type:"EmbedWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EmbedOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateEmbed:{
			filter:{
				type:"EmbedWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EmbedOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateEmbed:{
			data:{
				type:"EmbedCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateEmbed:{
			by:{
				type:"EmbedUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"EmbedUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImageContent:{
			by:{
				type:"ImageContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImageContent:{
			filter:{
				type:"ImageContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImageContent:{
			filter:{
				type:"ImageContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImageContent:{
			data:{
				type:"ImageContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImageContent:{
			by:{
				type:"ImageContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getListicle:{
			by:{
				type:"ListicleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ListicleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listListicle:{
			filter:{
				type:"ListicleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ListicleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateListicle:{
			filter:{
				type:"ListicleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ListicleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateListicle:{
			data:{
				type:"ListicleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateListicle:{
			by:{
				type:"ListicleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ListicleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPollAnswer:{
			by:{
				type:"PollAnswerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PollAnswerWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPollAnswer:{
			filter:{
				type:"PollAnswerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PollAnswerOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePollAnswer:{
			filter:{
				type:"PollAnswerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PollAnswerOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePollAnswer:{
			data:{
				type:"PollAnswerCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePollAnswer:{
			by:{
				type:"PollAnswerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PollAnswerUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTag:{
			by:{
				type:"TagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTag:{
			filter:{
				type:"TagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTag:{
			filter:{
				type:"TagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTag:{
			data:{
				type:"TagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTag:{
			by:{
				type:"TagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFAQ:{
			by:{
				type:"FAQUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FAQWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFAQ:{
			filter:{
				type:"FAQWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FAQOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFAQ:{
			filter:{
				type:"FAQWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FAQOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFAQ:{
			data:{
				type:"FAQCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFAQ:{
			by:{
				type:"FAQUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FAQUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLinkContent:{
			by:{
				type:"LinkContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLinkContent:{
			filter:{
				type:"LinkContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinkContent:{
			filter:{
				type:"LinkContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLinkContent:{
			data:{
				type:"LinkContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLinkContent:{
			by:{
				type:"LinkContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getAwardContent:{
			by:{
				type:"AwardContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AwardContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listAwardContent:{
			filter:{
				type:"AwardContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AwardContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateAwardContent:{
			filter:{
				type:"AwardContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AwardContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateAwardContent:{
			data:{
				type:"AwardContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateAwardContent:{
			by:{
				type:"AwardContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"AwardContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getReviewContent:{
			by:{
				type:"ReviewContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ReviewContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listReviewContent:{
			filter:{
				type:"ReviewContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ReviewContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateReviewContent:{
			filter:{
				type:"ReviewContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ReviewContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateReviewContent:{
			data:{
				type:"ReviewContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateReviewContent:{
			by:{
				type:"ReviewContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ReviewContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPage:{
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePage:{
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePage:{
			data:{
				type:"PageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTextTranslation:{
			by:{
				type:"TextTranslationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextTranslationWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTextTranslation:{
			filter:{
				type:"TextTranslationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TextTranslationOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTextTranslation:{
			filter:{
				type:"TextTranslationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TextTranslationOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTextTranslation:{
			data:{
				type:"TextTranslationCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTextTranslation:{
			by:{
				type:"TextTranslationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TextTranslationUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSeo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSeo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSeo:{
			data:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFile:{
			by:{
				type:"FileUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFile:{
			filter:{
				type:"FileWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FileOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFile:{
			filter:{
				type:"FileWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FileOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFile:{
			data:{
				type:"FileCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFile:{
			by:{
				type:"FileUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FileUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFileUse:{
			by:{
				type:"FileUseUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFileUse:{
			filter:{
				type:"FileUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FileUseOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFileUse:{
			filter:{
				type:"FileUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FileUseOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFileUse:{
			data:{
				type:"FileUseCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFileUse:{
			by:{
				type:"FileUseUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FileUseUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentBlock:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentBlock:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentBlock:{
			data:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentArticle:{
			by:{
				type:"ContentArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentArticle:{
			filter:{
				type:"ContentArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentArticle:{
			filter:{
				type:"ContentArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentArticle:{
			data:{
				type:"ContentArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentArticle:{
			by:{
				type:"ContentArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getUnlockedArticle:{
			by:{
				type:"UnlockedArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"UnlockedArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listUnlockedArticle:{
			filter:{
				type:"UnlockedArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"UnlockedArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateUnlockedArticle:{
			filter:{
				type:"UnlockedArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"UnlockedArticleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateUnlockedArticle:{
			data:{
				type:"UnlockedArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateUnlockedArticle:{
			by:{
				type:"UnlockedArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"UnlockedArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getUser:{
			by:{
				type:"UserUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"UserWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listUser:{
			filter:{
				type:"UserWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"UserOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateUser:{
			filter:{
				type:"UserWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"UserOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateUser:{
			data:{
				type:"UserCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateUser:{
			by:{
				type:"UserUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"UserUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getNotification:{
			by:{
				type:"NotificationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NotificationWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listNotification:{
			filter:{
				type:"NotificationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NotificationOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateNotification:{
			filter:{
				type:"NotificationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NotificationOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateNotification:{
			data:{
				type:"NotificationCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateNotification:{
			by:{
				type:"NotificationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"NotificationUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getAppReview:{
			by:{
				type:"AppReviewUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AppReviewWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listAppReview:{
			filter:{
				type:"AppReviewWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AppReviewOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateAppReview:{
			filter:{
				type:"AppReviewWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AppReviewOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateAppReview:{
			data:{
				type:"AppReviewCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateAppReview:{
			by:{
				type:"AppReviewUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"AppReviewUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getProduct:{
			by:{
				type:"ProductUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProductWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listProduct:{
			filter:{
				type:"ProductWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProductOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateProduct:{
			filter:{
				type:"ProductWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ProductOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateProduct:{
			data:{
				type:"ProductCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateProduct:{
			by:{
				type:"ProductUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ProductUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSubscriptionForm:{
			by:{
				type:"SubscriptionFormUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSubscriptionForm:{
			filter:{
				type:"SubscriptionFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubscriptionFormOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSubscriptionForm:{
			filter:{
				type:"SubscriptionFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubscriptionFormOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSubscriptionForm:{
			data:{
				type:"SubscriptionFormCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSubscriptionForm:{
			by:{
				type:"SubscriptionFormUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SubscriptionFormUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSubscriptionFormSection:{
			by:{
				type:"SubscriptionFormSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSubscriptionFormSection:{
			filter:{
				type:"SubscriptionFormSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubscriptionFormSectionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSubscriptionFormSection:{
			filter:{
				type:"SubscriptionFormSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubscriptionFormSectionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSubscriptionFormSection:{
			data:{
				type:"SubscriptionFormSectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSubscriptionFormSection:{
			by:{
				type:"SubscriptionFormSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SubscriptionFormSectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSubscriptionFormInput:{
			by:{
				type:"SubscriptionFormInputUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormInputWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSubscriptionFormInput:{
			filter:{
				type:"SubscriptionFormInputWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubscriptionFormInputOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSubscriptionFormInput:{
			filter:{
				type:"SubscriptionFormInputWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubscriptionFormInputOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSubscriptionFormInput:{
			data:{
				type:"SubscriptionFormInputCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSubscriptionFormInput:{
			by:{
				type:"SubscriptionFormInputUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SubscriptionFormInputUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSubscriptionFormOption:{
			by:{
				type:"SubscriptionFormOptionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormOptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSubscriptionFormOption:{
			filter:{
				type:"SubscriptionFormOptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubscriptionFormOptionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSubscriptionFormOption:{
			filter:{
				type:"SubscriptionFormOptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubscriptionFormOptionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSubscriptionFormOption:{
			data:{
				type:"SubscriptionFormOptionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSubscriptionFormOption:{
			by:{
				type:"SubscriptionFormOptionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SubscriptionFormOptionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getButton:{
			by:{
				type:"ButtonUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ButtonWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listButton:{
			filter:{
				type:"ButtonWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ButtonOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateButton:{
			filter:{
				type:"ButtonWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ButtonOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateButton:{
			data:{
				type:"ButtonCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateButton:{
			by:{
				type:"ButtonUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ButtonUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getArticleHistoryTag:{
			by:{
				type:"ArticleHistoryTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleHistoryTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listArticleHistoryTag:{
			filter:{
				type:"ArticleHistoryTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleHistoryTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArticleHistoryTag:{
			filter:{
				type:"ArticleHistoryTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleHistoryTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateArticleHistoryTag:{
			data:{
				type:"ArticleHistoryTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateArticleHistoryTag:{
			by:{
				type:"ArticleHistoryTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ArticleHistoryTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getArticleHistoryPeriod:{
			by:{
				type:"ArticleHistoryPeriodUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleHistoryPeriodWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listArticleHistoryPeriod:{
			filter:{
				type:"ArticleHistoryPeriodWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleHistoryPeriodOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArticleHistoryPeriod:{
			filter:{
				type:"ArticleHistoryPeriodWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArticleHistoryPeriodOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateArticleHistoryPeriod:{
			data:{
				type:"ArticleHistoryPeriodCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateArticleHistoryPeriod:{
			by:{
				type:"ArticleHistoryPeriodUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ArticleHistoryPeriodUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHistoryTag:{
			by:{
				type:"HistoryTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHistoryTag:{
			filter:{
				type:"HistoryTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HistoryTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHistoryTag:{
			filter:{
				type:"HistoryTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HistoryTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHistoryTag:{
			data:{
				type:"HistoryTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHistoryTag:{
			by:{
				type:"HistoryTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HistoryTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHistoryPeriod:{
			by:{
				type:"HistoryPeriodUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryPeriodWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHistoryPeriod:{
			filter:{
				type:"HistoryPeriodWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HistoryPeriodOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHistoryPeriod:{
			filter:{
				type:"HistoryPeriodWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HistoryPeriodOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHistoryPeriod:{
			data:{
				type:"HistoryPeriodCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHistoryPeriod:{
			by:{
				type:"HistoryPeriodUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HistoryPeriodUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHistoryHomePage:{
			by:{
				type:"HistoryHomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryHomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHistoryHomePage:{
			filter:{
				type:"HistoryHomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HistoryHomePageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHistoryHomePage:{
			filter:{
				type:"HistoryHomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HistoryHomePageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHistoryHomePage:{
			data:{
				type:"HistoryHomePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHistoryHomePage:{
			by:{
				type:"HistoryHomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HistoryHomePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHistoryCover:{
			by:{
				type:"HistoryCoverUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryCoverWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHistoryCover:{
			filter:{
				type:"HistoryCoverWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HistoryCoverOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHistoryCover:{
			filter:{
				type:"HistoryCoverWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HistoryCoverOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHistoryCover:{
			data:{
				type:"HistoryCoverCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHistoryCover:{
			by:{
				type:"HistoryCoverUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HistoryCoverUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHistoryTextList:{
			by:{
				type:"HistoryTextListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryTextListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHistoryTextList:{
			filter:{
				type:"HistoryTextListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HistoryTextListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHistoryTextList:{
			filter:{
				type:"HistoryTextListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HistoryTextListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHistoryTextList:{
			data:{
				type:"HistoryTextListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHistoryTextList:{
			by:{
				type:"HistoryTextListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HistoryTextListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHistoryTextItem:{
			by:{
				type:"HistoryTextItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryTextItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHistoryTextItem:{
			filter:{
				type:"HistoryTextItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HistoryTextItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHistoryTextItem:{
			filter:{
				type:"HistoryTextItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HistoryTextItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHistoryTextItem:{
			data:{
				type:"HistoryTextItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHistoryTextItem:{
			by:{
				type:"HistoryTextItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HistoryTextItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFooterMenu:{
			by:{
				type:"FooterMenuUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterMenuWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFooterMenu:{
			filter:{
				type:"FooterMenuWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterMenuOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFooterMenu:{
			filter:{
				type:"FooterMenuWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterMenuOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFooterMenu:{
			data:{
				type:"FooterMenuCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFooterMenu:{
			by:{
				type:"FooterMenuUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FooterMenuUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLinkSection:{
			by:{
				type:"LinkSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLinkSection:{
			filter:{
				type:"LinkSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkSectionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinkSection:{
			filter:{
				type:"LinkSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkSectionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLinkSection:{
			data:{
				type:"LinkSectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLinkSection:{
			by:{
				type:"LinkSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkSectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLinkList:{
			by:{
				type:"LinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLinkList:{
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinkList:{
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLinkList:{
			data:{
				type:"LinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLinkList:{
			by:{
				type:"LinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLinkItem:{
			by:{
				type:"LinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLinkItem:{
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinkItem:{
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLinkItem:{
			data:{
				type:"LinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLinkItem:{
			by:{
				type:"LinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getNewsletterSection:{
			by:{
				type:"NewsletterSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listNewsletterSection:{
			filter:{
				type:"NewsletterSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsletterSectionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateNewsletterSection:{
			filter:{
				type:"NewsletterSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsletterSectionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateNewsletterSection:{
			data:{
				type:"NewsletterSectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateNewsletterSection:{
			by:{
				type:"NewsletterSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"NewsletterSectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getNewsletter:{
			by:{
				type:"NewsletterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listNewsletter:{
			filter:{
				type:"NewsletterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsletterOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateNewsletter:{
			filter:{
				type:"NewsletterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsletterOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateNewsletter:{
			data:{
				type:"NewsletterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateNewsletter:{
			by:{
				type:"NewsletterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"NewsletterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getOnlineSection:{
			by:{
				type:"OnlineSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"OnlineSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listOnlineSection:{
			filter:{
				type:"OnlineSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"OnlineSectionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateOnlineSection:{
			filter:{
				type:"OnlineSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"OnlineSectionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateOnlineSection:{
			data:{
				type:"OnlineSectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateOnlineSection:{
			by:{
				type:"OnlineSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"OnlineSectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getAppLink:{
			by:{
				type:"AppLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AppLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listAppLink:{
			filter:{
				type:"AppLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AppLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateAppLink:{
			filter:{
				type:"AppLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AppLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateAppLink:{
			data:{
				type:"AppLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateAppLink:{
			by:{
				type:"AppLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"AppLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getAppLinkList:{
			by:{
				type:"AppLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AppLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listAppLinkList:{
			filter:{
				type:"AppLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AppLinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateAppLinkList:{
			filter:{
				type:"AppLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AppLinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateAppLinkList:{
			data:{
				type:"AppLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateAppLinkList:{
			by:{
				type:"AppLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"AppLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getAppLinkItem:{
			by:{
				type:"AppLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AppLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listAppLinkItem:{
			filter:{
				type:"AppLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AppLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateAppLinkItem:{
			filter:{
				type:"AppLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"AppLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateAppLinkItem:{
			data:{
				type:"AppLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateAppLinkItem:{
			by:{
				type:"AppLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"AppLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSocialSection:{
			by:{
				type:"SocialSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSocialSection:{
			filter:{
				type:"SocialSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialSectionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSocialSection:{
			filter:{
				type:"SocialSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialSectionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSocialSection:{
			data:{
				type:"SocialSectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSocialSection:{
			by:{
				type:"SocialSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SocialSectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSocialLink:{
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSocialLink:{
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSocialLink:{
			data:{
				type:"SocialLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SocialLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSocialLinkList:{
			by:{
				type:"SocialLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSocialLinkList:{
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSocialLinkList:{
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSocialLinkList:{
			data:{
				type:"SocialLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSocialLinkList:{
			by:{
				type:"SocialLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SocialLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSocialLinkItem:{
			by:{
				type:"SocialLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSocialLinkItem:{
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSocialLinkItem:{
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSocialLinkItem:{
			data:{
				type:"SocialLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSocialLinkItem:{
			by:{
				type:"SocialLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SocialLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSharedContent:{
			by:{
				type:"SharedContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SharedContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSharedContent:{
			filter:{
				type:"SharedContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SharedContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSharedContent:{
			filter:{
				type:"SharedContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SharedContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSharedContent:{
			data:{
				type:"SharedContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSharedContent:{
			by:{
				type:"SharedContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SharedContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		}
	},
	Mutation:{
		createArticle:{
			data:{
				type:"ArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteArticle:{
			by:{
				type:"ArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateArticle:{
			by:{
				type:"ArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertArticle:{
			by:{
				type:"ArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createArticleAuthor:{
			data:{
				type:"ArticleAuthorCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteArticleAuthor:{
			by:{
				type:"ArticleAuthorUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleAuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateArticleAuthor:{
			by:{
				type:"ArticleAuthorUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleAuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ArticleAuthorUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertArticleAuthor:{
			by:{
				type:"ArticleAuthorUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleAuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ArticleAuthorUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ArticleAuthorCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createAuthor:{
			data:{
				type:"AuthorCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteAuthor:{
			by:{
				type:"AuthorUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateAuthor:{
			by:{
				type:"AuthorUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"AuthorUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertAuthor:{
			by:{
				type:"AuthorUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"AuthorUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"AuthorCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createAuthorTopArticle:{
			data:{
				type:"AuthorTopArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteAuthorTopArticle:{
			by:{
				type:"AuthorTopArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AuthorTopArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateAuthorTopArticle:{
			by:{
				type:"AuthorTopArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AuthorTopArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"AuthorTopArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertAuthorTopArticle:{
			by:{
				type:"AuthorTopArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AuthorTopArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"AuthorTopArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"AuthorTopArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContent:{
			data:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentPart:{
			data:{
				type:"ContentPartCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentPart:{
			by:{
				type:"ContentPartUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentPartWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentPart:{
			by:{
				type:"ContentPartUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentPartWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentPartUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentPart:{
			by:{
				type:"ContentPartUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentPartWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentPartUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentPartCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentReference:{
			data:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHomepageArticle:{
			data:{
				type:"HomepageArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHomepageArticle:{
			by:{
				type:"HomepageArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomepageArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHomepageArticle:{
			by:{
				type:"HomepageArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomepageArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HomepageArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHomepageArticle:{
			by:{
				type:"HomepageArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomepageArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HomepageArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HomepageArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImage:{
			data:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImageUse:{
			data:{
				type:"ImageUseCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImageUse:{
			by:{
				type:"ImageUseUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImageUse:{
			by:{
				type:"ImageUseUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageUseUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImageUse:{
			by:{
				type:"ImageUseUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageUseUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageUseCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImageTag:{
			data:{
				type:"ImageTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImageTag:{
			by:{
				type:"ImageTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImageTag:{
			by:{
				type:"ImageTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImageTag:{
			by:{
				type:"ImageTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createIssue:{
			data:{
				type:"IssueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteIssue:{
			by:{
				type:"IssueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"IssueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateIssue:{
			by:{
				type:"IssueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"IssueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"IssueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertIssue:{
			by:{
				type:"IssueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"IssueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"IssueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"IssueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createIssueArticle:{
			data:{
				type:"IssueArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteIssueArticle:{
			by:{
				type:"IssueArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"IssueArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateIssueArticle:{
			by:{
				type:"IssueArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"IssueArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"IssueArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertIssueArticle:{
			by:{
				type:"IssueArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"IssueArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"IssueArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"IssueArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLink:{
			data:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTextContent:{
			data:{
				type:"TextContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTextContent:{
			by:{
				type:"TextContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTextContent:{
			by:{
				type:"TextContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TextContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTextContent:{
			by:{
				type:"TextContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TextContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TextContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTextContentPart:{
			data:{
				type:"TextContentPartCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTextContentPart:{
			by:{
				type:"TextContentPartUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextContentPartWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTextContentPart:{
			by:{
				type:"TextContentPartUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextContentPartWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TextContentPartUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTextContentPart:{
			by:{
				type:"TextContentPartUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextContentPartWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TextContentPartUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TextContentPartCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTextContentReference:{
			data:{
				type:"TextContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTextContentReference:{
			by:{
				type:"TextContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTextContentReference:{
			by:{
				type:"TextContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TextContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTextContentReference:{
			by:{
				type:"TextContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TextContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TextContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createUrl:{
			data:{
				type:"UrlCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteUrl:{
			by:{
				type:"UrlUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"UrlWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateUrl:{
			by:{
				type:"UrlUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"UrlWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"UrlUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertUrl:{
			by:{
				type:"UrlUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"UrlWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"UrlUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"UrlCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createArticleTag:{
			data:{
				type:"ArticleTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteArticleTag:{
			by:{
				type:"ArticleTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateArticleTag:{
			by:{
				type:"ArticleTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ArticleTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertArticleTag:{
			by:{
				type:"ArticleTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ArticleTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ArticleTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createCategory:{
			data:{
				type:"CategoryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteCategory:{
			by:{
				type:"CategoryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateCategory:{
			by:{
				type:"CategoryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"CategoryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertCategory:{
			by:{
				type:"CategoryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"CategoryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"CategoryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createArticleCategory:{
			data:{
				type:"ArticleCategoryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteArticleCategory:{
			by:{
				type:"ArticleCategoryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleCategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateArticleCategory:{
			by:{
				type:"ArticleCategoryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleCategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ArticleCategoryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertArticleCategory:{
			by:{
				type:"ArticleCategoryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleCategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ArticleCategoryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ArticleCategoryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createAudio:{
			data:{
				type:"AudioCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteAudio:{
			by:{
				type:"AudioUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AudioWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateAudio:{
			by:{
				type:"AudioUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AudioWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"AudioUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertAudio:{
			by:{
				type:"AudioUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AudioWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"AudioUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"AudioCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createAudioUse:{
			data:{
				type:"AudioUseCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteAudioUse:{
			by:{
				type:"AudioUseUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AudioUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateAudioUse:{
			by:{
				type:"AudioUseUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AudioUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"AudioUseUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertAudioUse:{
			by:{
				type:"AudioUseUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AudioUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"AudioUseUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"AudioUseCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createEmbed:{
			data:{
				type:"EmbedCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteEmbed:{
			by:{
				type:"EmbedUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmbedWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateEmbed:{
			by:{
				type:"EmbedUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmbedWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"EmbedUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertEmbed:{
			by:{
				type:"EmbedUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmbedWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"EmbedUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"EmbedCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImageContent:{
			data:{
				type:"ImageContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImageContent:{
			by:{
				type:"ImageContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImageContent:{
			by:{
				type:"ImageContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImageContent:{
			by:{
				type:"ImageContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createListicle:{
			data:{
				type:"ListicleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteListicle:{
			by:{
				type:"ListicleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ListicleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateListicle:{
			by:{
				type:"ListicleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ListicleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ListicleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertListicle:{
			by:{
				type:"ListicleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ListicleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ListicleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ListicleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPollAnswer:{
			data:{
				type:"PollAnswerCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePollAnswer:{
			by:{
				type:"PollAnswerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PollAnswerWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePollAnswer:{
			by:{
				type:"PollAnswerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PollAnswerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PollAnswerUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPollAnswer:{
			by:{
				type:"PollAnswerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PollAnswerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PollAnswerUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PollAnswerCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTag:{
			data:{
				type:"TagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTag:{
			by:{
				type:"TagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTag:{
			by:{
				type:"TagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTag:{
			by:{
				type:"TagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFAQ:{
			data:{
				type:"FAQCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFAQ:{
			by:{
				type:"FAQUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FAQWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFAQ:{
			by:{
				type:"FAQUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FAQWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FAQUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFAQ:{
			by:{
				type:"FAQUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FAQWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FAQUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FAQCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLinkContent:{
			data:{
				type:"LinkContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLinkContent:{
			by:{
				type:"LinkContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLinkContent:{
			by:{
				type:"LinkContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLinkContent:{
			by:{
				type:"LinkContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createAwardContent:{
			data:{
				type:"AwardContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteAwardContent:{
			by:{
				type:"AwardContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AwardContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateAwardContent:{
			by:{
				type:"AwardContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AwardContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"AwardContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertAwardContent:{
			by:{
				type:"AwardContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AwardContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"AwardContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"AwardContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createReviewContent:{
			data:{
				type:"ReviewContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteReviewContent:{
			by:{
				type:"ReviewContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ReviewContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateReviewContent:{
			by:{
				type:"ReviewContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ReviewContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ReviewContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertReviewContent:{
			by:{
				type:"ReviewContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ReviewContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ReviewContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ReviewContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPage:{
			data:{
				type:"PageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTextTranslation:{
			data:{
				type:"TextTranslationCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTextTranslation:{
			by:{
				type:"TextTranslationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextTranslationWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTextTranslation:{
			by:{
				type:"TextTranslationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextTranslationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TextTranslationUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTextTranslation:{
			by:{
				type:"TextTranslationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextTranslationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TextTranslationUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TextTranslationCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSeo:{
			data:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFile:{
			data:{
				type:"FileCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFile:{
			by:{
				type:"FileUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFile:{
			by:{
				type:"FileUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FileUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFile:{
			by:{
				type:"FileUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FileUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FileCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFileUse:{
			data:{
				type:"FileUseCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFileUse:{
			by:{
				type:"FileUseUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFileUse:{
			by:{
				type:"FileUseUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FileUseUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFileUse:{
			by:{
				type:"FileUseUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FileUseUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FileUseCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentBlock:{
			data:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentArticle:{
			data:{
				type:"ContentArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentArticle:{
			by:{
				type:"ContentArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentArticle:{
			by:{
				type:"ContentArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentArticle:{
			by:{
				type:"ContentArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createUnlockedArticle:{
			data:{
				type:"UnlockedArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteUnlockedArticle:{
			by:{
				type:"UnlockedArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"UnlockedArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateUnlockedArticle:{
			by:{
				type:"UnlockedArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"UnlockedArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"UnlockedArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertUnlockedArticle:{
			by:{
				type:"UnlockedArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"UnlockedArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"UnlockedArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"UnlockedArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createUser:{
			data:{
				type:"UserCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteUser:{
			by:{
				type:"UserUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"UserWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateUser:{
			by:{
				type:"UserUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"UserWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"UserUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertUser:{
			by:{
				type:"UserUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"UserWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"UserUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"UserCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createNotification:{
			data:{
				type:"NotificationCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteNotification:{
			by:{
				type:"NotificationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NotificationWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateNotification:{
			by:{
				type:"NotificationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NotificationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"NotificationUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertNotification:{
			by:{
				type:"NotificationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NotificationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"NotificationUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"NotificationCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createAppReview:{
			data:{
				type:"AppReviewCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteAppReview:{
			by:{
				type:"AppReviewUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AppReviewWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateAppReview:{
			by:{
				type:"AppReviewUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AppReviewWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"AppReviewUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertAppReview:{
			by:{
				type:"AppReviewUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AppReviewWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"AppReviewUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"AppReviewCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createProduct:{
			data:{
				type:"ProductCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteProduct:{
			by:{
				type:"ProductUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProductWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateProduct:{
			by:{
				type:"ProductUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProductWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ProductUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertProduct:{
			by:{
				type:"ProductUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProductWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ProductUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ProductCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSubscriptionForm:{
			data:{
				type:"SubscriptionFormCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSubscriptionForm:{
			by:{
				type:"SubscriptionFormUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSubscriptionForm:{
			by:{
				type:"SubscriptionFormUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SubscriptionFormUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSubscriptionForm:{
			by:{
				type:"SubscriptionFormUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SubscriptionFormUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SubscriptionFormCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSubscriptionFormSection:{
			data:{
				type:"SubscriptionFormSectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSubscriptionFormSection:{
			by:{
				type:"SubscriptionFormSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSubscriptionFormSection:{
			by:{
				type:"SubscriptionFormSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SubscriptionFormSectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSubscriptionFormSection:{
			by:{
				type:"SubscriptionFormSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SubscriptionFormSectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SubscriptionFormSectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSubscriptionFormInput:{
			data:{
				type:"SubscriptionFormInputCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSubscriptionFormInput:{
			by:{
				type:"SubscriptionFormInputUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormInputWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSubscriptionFormInput:{
			by:{
				type:"SubscriptionFormInputUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormInputWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SubscriptionFormInputUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSubscriptionFormInput:{
			by:{
				type:"SubscriptionFormInputUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormInputWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SubscriptionFormInputUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SubscriptionFormInputCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSubscriptionFormOption:{
			data:{
				type:"SubscriptionFormOptionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSubscriptionFormOption:{
			by:{
				type:"SubscriptionFormOptionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormOptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSubscriptionFormOption:{
			by:{
				type:"SubscriptionFormOptionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormOptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SubscriptionFormOptionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSubscriptionFormOption:{
			by:{
				type:"SubscriptionFormOptionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormOptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SubscriptionFormOptionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SubscriptionFormOptionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createButton:{
			data:{
				type:"ButtonCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteButton:{
			by:{
				type:"ButtonUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ButtonWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateButton:{
			by:{
				type:"ButtonUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ButtonWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ButtonUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertButton:{
			by:{
				type:"ButtonUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ButtonWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ButtonUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ButtonCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createArticleHistoryTag:{
			data:{
				type:"ArticleHistoryTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteArticleHistoryTag:{
			by:{
				type:"ArticleHistoryTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleHistoryTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateArticleHistoryTag:{
			by:{
				type:"ArticleHistoryTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleHistoryTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ArticleHistoryTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertArticleHistoryTag:{
			by:{
				type:"ArticleHistoryTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleHistoryTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ArticleHistoryTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ArticleHistoryTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createArticleHistoryPeriod:{
			data:{
				type:"ArticleHistoryPeriodCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteArticleHistoryPeriod:{
			by:{
				type:"ArticleHistoryPeriodUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleHistoryPeriodWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateArticleHistoryPeriod:{
			by:{
				type:"ArticleHistoryPeriodUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleHistoryPeriodWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ArticleHistoryPeriodUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertArticleHistoryPeriod:{
			by:{
				type:"ArticleHistoryPeriodUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleHistoryPeriodWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ArticleHistoryPeriodUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ArticleHistoryPeriodCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHistoryTag:{
			data:{
				type:"HistoryTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHistoryTag:{
			by:{
				type:"HistoryTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHistoryTag:{
			by:{
				type:"HistoryTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HistoryTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHistoryTag:{
			by:{
				type:"HistoryTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HistoryTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HistoryTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHistoryPeriod:{
			data:{
				type:"HistoryPeriodCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHistoryPeriod:{
			by:{
				type:"HistoryPeriodUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryPeriodWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHistoryPeriod:{
			by:{
				type:"HistoryPeriodUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryPeriodWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HistoryPeriodUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHistoryPeriod:{
			by:{
				type:"HistoryPeriodUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryPeriodWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HistoryPeriodUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HistoryPeriodCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHistoryHomePage:{
			data:{
				type:"HistoryHomePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHistoryHomePage:{
			by:{
				type:"HistoryHomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryHomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHistoryHomePage:{
			by:{
				type:"HistoryHomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryHomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HistoryHomePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHistoryHomePage:{
			by:{
				type:"HistoryHomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryHomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HistoryHomePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HistoryHomePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHistoryCover:{
			data:{
				type:"HistoryCoverCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHistoryCover:{
			by:{
				type:"HistoryCoverUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryCoverWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHistoryCover:{
			by:{
				type:"HistoryCoverUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryCoverWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HistoryCoverUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHistoryCover:{
			by:{
				type:"HistoryCoverUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryCoverWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HistoryCoverUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HistoryCoverCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHistoryTextList:{
			data:{
				type:"HistoryTextListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHistoryTextList:{
			by:{
				type:"HistoryTextListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryTextListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHistoryTextList:{
			by:{
				type:"HistoryTextListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryTextListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HistoryTextListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHistoryTextList:{
			by:{
				type:"HistoryTextListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryTextListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HistoryTextListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HistoryTextListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHistoryTextItem:{
			data:{
				type:"HistoryTextItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHistoryTextItem:{
			by:{
				type:"HistoryTextItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryTextItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHistoryTextItem:{
			by:{
				type:"HistoryTextItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryTextItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HistoryTextItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHistoryTextItem:{
			by:{
				type:"HistoryTextItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryTextItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HistoryTextItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HistoryTextItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFooterMenu:{
			data:{
				type:"FooterMenuCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFooterMenu:{
			by:{
				type:"FooterMenuUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterMenuWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFooterMenu:{
			by:{
				type:"FooterMenuUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterMenuWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FooterMenuUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFooterMenu:{
			by:{
				type:"FooterMenuUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterMenuWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FooterMenuUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FooterMenuCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLinkSection:{
			data:{
				type:"LinkSectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLinkSection:{
			by:{
				type:"LinkSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLinkSection:{
			by:{
				type:"LinkSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkSectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLinkSection:{
			by:{
				type:"LinkSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkSectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkSectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLinkList:{
			data:{
				type:"LinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLinkList:{
			by:{
				type:"LinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLinkList:{
			by:{
				type:"LinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLinkList:{
			by:{
				type:"LinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLinkItem:{
			data:{
				type:"LinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLinkItem:{
			by:{
				type:"LinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLinkItem:{
			by:{
				type:"LinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLinkItem:{
			by:{
				type:"LinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createNewsletterSection:{
			data:{
				type:"NewsletterSectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteNewsletterSection:{
			by:{
				type:"NewsletterSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateNewsletterSection:{
			by:{
				type:"NewsletterSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"NewsletterSectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertNewsletterSection:{
			by:{
				type:"NewsletterSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"NewsletterSectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"NewsletterSectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createNewsletter:{
			data:{
				type:"NewsletterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteNewsletter:{
			by:{
				type:"NewsletterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateNewsletter:{
			by:{
				type:"NewsletterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"NewsletterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertNewsletter:{
			by:{
				type:"NewsletterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"NewsletterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"NewsletterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createOnlineSection:{
			data:{
				type:"OnlineSectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteOnlineSection:{
			by:{
				type:"OnlineSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"OnlineSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateOnlineSection:{
			by:{
				type:"OnlineSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"OnlineSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"OnlineSectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertOnlineSection:{
			by:{
				type:"OnlineSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"OnlineSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"OnlineSectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"OnlineSectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createAppLink:{
			data:{
				type:"AppLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteAppLink:{
			by:{
				type:"AppLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AppLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateAppLink:{
			by:{
				type:"AppLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AppLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"AppLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertAppLink:{
			by:{
				type:"AppLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AppLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"AppLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"AppLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createAppLinkList:{
			data:{
				type:"AppLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteAppLinkList:{
			by:{
				type:"AppLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AppLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateAppLinkList:{
			by:{
				type:"AppLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AppLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"AppLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertAppLinkList:{
			by:{
				type:"AppLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AppLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"AppLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"AppLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createAppLinkItem:{
			data:{
				type:"AppLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteAppLinkItem:{
			by:{
				type:"AppLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AppLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateAppLinkItem:{
			by:{
				type:"AppLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AppLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"AppLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertAppLinkItem:{
			by:{
				type:"AppLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AppLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"AppLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"AppLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSocialSection:{
			data:{
				type:"SocialSectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSocialSection:{
			by:{
				type:"SocialSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSocialSection:{
			by:{
				type:"SocialSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SocialSectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSocialSection:{
			by:{
				type:"SocialSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SocialSectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SocialSectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSocialLink:{
			data:{
				type:"SocialLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SocialLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SocialLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SocialLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSocialLinkList:{
			data:{
				type:"SocialLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSocialLinkList:{
			by:{
				type:"SocialLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSocialLinkList:{
			by:{
				type:"SocialLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SocialLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSocialLinkList:{
			by:{
				type:"SocialLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SocialLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SocialLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSocialLinkItem:{
			data:{
				type:"SocialLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSocialLinkItem:{
			by:{
				type:"SocialLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSocialLinkItem:{
			by:{
				type:"SocialLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SocialLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSocialLinkItem:{
			by:{
				type:"SocialLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SocialLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SocialLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSharedContent:{
			data:{
				type:"SharedContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSharedContent:{
			by:{
				type:"SharedContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SharedContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSharedContent:{
			by:{
				type:"SharedContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SharedContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SharedContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSharedContent:{
			by:{
				type:"SharedContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SharedContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SharedContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SharedContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		transaction:{
			options:{
				type:"MutationTransactionOptions",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		generateUploadUrl:{
			contentType:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			},
			expiration:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			prefix:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:false
			},
			acl:{
				type:"S3Acl",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		generateReadUrl:{
			objectKey:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			},
			expiration:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	_MutationErrorType: "enum",
	MutationTransaction:{
		createArticle:{
			data:{
				type:"ArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteArticle:{
			by:{
				type:"ArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateArticle:{
			by:{
				type:"ArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertArticle:{
			by:{
				type:"ArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createArticleAuthor:{
			data:{
				type:"ArticleAuthorCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteArticleAuthor:{
			by:{
				type:"ArticleAuthorUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleAuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateArticleAuthor:{
			by:{
				type:"ArticleAuthorUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleAuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ArticleAuthorUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertArticleAuthor:{
			by:{
				type:"ArticleAuthorUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleAuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ArticleAuthorUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ArticleAuthorCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createAuthor:{
			data:{
				type:"AuthorCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteAuthor:{
			by:{
				type:"AuthorUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateAuthor:{
			by:{
				type:"AuthorUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"AuthorUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertAuthor:{
			by:{
				type:"AuthorUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AuthorWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"AuthorUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"AuthorCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createAuthorTopArticle:{
			data:{
				type:"AuthorTopArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteAuthorTopArticle:{
			by:{
				type:"AuthorTopArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AuthorTopArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateAuthorTopArticle:{
			by:{
				type:"AuthorTopArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AuthorTopArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"AuthorTopArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertAuthorTopArticle:{
			by:{
				type:"AuthorTopArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AuthorTopArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"AuthorTopArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"AuthorTopArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContent:{
			data:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentPart:{
			data:{
				type:"ContentPartCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentPart:{
			by:{
				type:"ContentPartUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentPartWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentPart:{
			by:{
				type:"ContentPartUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentPartWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentPartUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentPart:{
			by:{
				type:"ContentPartUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentPartWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentPartUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentPartCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentReference:{
			data:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHomepageArticle:{
			data:{
				type:"HomepageArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHomepageArticle:{
			by:{
				type:"HomepageArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomepageArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHomepageArticle:{
			by:{
				type:"HomepageArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomepageArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HomepageArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHomepageArticle:{
			by:{
				type:"HomepageArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomepageArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HomepageArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HomepageArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImage:{
			data:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImageUse:{
			data:{
				type:"ImageUseCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImageUse:{
			by:{
				type:"ImageUseUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImageUse:{
			by:{
				type:"ImageUseUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageUseUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImageUse:{
			by:{
				type:"ImageUseUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageUseUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageUseCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImageTag:{
			data:{
				type:"ImageTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImageTag:{
			by:{
				type:"ImageTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImageTag:{
			by:{
				type:"ImageTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImageTag:{
			by:{
				type:"ImageTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createIssue:{
			data:{
				type:"IssueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteIssue:{
			by:{
				type:"IssueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"IssueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateIssue:{
			by:{
				type:"IssueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"IssueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"IssueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertIssue:{
			by:{
				type:"IssueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"IssueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"IssueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"IssueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createIssueArticle:{
			data:{
				type:"IssueArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteIssueArticle:{
			by:{
				type:"IssueArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"IssueArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateIssueArticle:{
			by:{
				type:"IssueArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"IssueArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"IssueArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertIssueArticle:{
			by:{
				type:"IssueArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"IssueArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"IssueArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"IssueArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLink:{
			data:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTextContent:{
			data:{
				type:"TextContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTextContent:{
			by:{
				type:"TextContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTextContent:{
			by:{
				type:"TextContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TextContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTextContent:{
			by:{
				type:"TextContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TextContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TextContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTextContentPart:{
			data:{
				type:"TextContentPartCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTextContentPart:{
			by:{
				type:"TextContentPartUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextContentPartWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTextContentPart:{
			by:{
				type:"TextContentPartUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextContentPartWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TextContentPartUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTextContentPart:{
			by:{
				type:"TextContentPartUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextContentPartWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TextContentPartUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TextContentPartCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTextContentReference:{
			data:{
				type:"TextContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTextContentReference:{
			by:{
				type:"TextContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTextContentReference:{
			by:{
				type:"TextContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TextContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTextContentReference:{
			by:{
				type:"TextContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TextContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TextContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createUrl:{
			data:{
				type:"UrlCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteUrl:{
			by:{
				type:"UrlUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"UrlWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateUrl:{
			by:{
				type:"UrlUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"UrlWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"UrlUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertUrl:{
			by:{
				type:"UrlUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"UrlWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"UrlUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"UrlCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createArticleTag:{
			data:{
				type:"ArticleTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteArticleTag:{
			by:{
				type:"ArticleTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateArticleTag:{
			by:{
				type:"ArticleTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ArticleTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertArticleTag:{
			by:{
				type:"ArticleTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ArticleTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ArticleTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createCategory:{
			data:{
				type:"CategoryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteCategory:{
			by:{
				type:"CategoryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateCategory:{
			by:{
				type:"CategoryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"CategoryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertCategory:{
			by:{
				type:"CategoryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"CategoryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"CategoryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createArticleCategory:{
			data:{
				type:"ArticleCategoryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteArticleCategory:{
			by:{
				type:"ArticleCategoryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleCategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateArticleCategory:{
			by:{
				type:"ArticleCategoryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleCategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ArticleCategoryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertArticleCategory:{
			by:{
				type:"ArticleCategoryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleCategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ArticleCategoryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ArticleCategoryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createAudio:{
			data:{
				type:"AudioCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteAudio:{
			by:{
				type:"AudioUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AudioWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateAudio:{
			by:{
				type:"AudioUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AudioWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"AudioUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertAudio:{
			by:{
				type:"AudioUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AudioWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"AudioUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"AudioCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createAudioUse:{
			data:{
				type:"AudioUseCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteAudioUse:{
			by:{
				type:"AudioUseUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AudioUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateAudioUse:{
			by:{
				type:"AudioUseUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AudioUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"AudioUseUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertAudioUse:{
			by:{
				type:"AudioUseUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AudioUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"AudioUseUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"AudioUseCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createEmbed:{
			data:{
				type:"EmbedCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteEmbed:{
			by:{
				type:"EmbedUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmbedWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateEmbed:{
			by:{
				type:"EmbedUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmbedWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"EmbedUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertEmbed:{
			by:{
				type:"EmbedUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmbedWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"EmbedUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"EmbedCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImageContent:{
			data:{
				type:"ImageContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImageContent:{
			by:{
				type:"ImageContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImageContent:{
			by:{
				type:"ImageContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImageContent:{
			by:{
				type:"ImageContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createListicle:{
			data:{
				type:"ListicleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteListicle:{
			by:{
				type:"ListicleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ListicleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateListicle:{
			by:{
				type:"ListicleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ListicleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ListicleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertListicle:{
			by:{
				type:"ListicleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ListicleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ListicleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ListicleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPollAnswer:{
			data:{
				type:"PollAnswerCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePollAnswer:{
			by:{
				type:"PollAnswerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PollAnswerWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePollAnswer:{
			by:{
				type:"PollAnswerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PollAnswerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PollAnswerUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPollAnswer:{
			by:{
				type:"PollAnswerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PollAnswerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PollAnswerUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PollAnswerCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTag:{
			data:{
				type:"TagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTag:{
			by:{
				type:"TagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTag:{
			by:{
				type:"TagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTag:{
			by:{
				type:"TagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFAQ:{
			data:{
				type:"FAQCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFAQ:{
			by:{
				type:"FAQUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FAQWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFAQ:{
			by:{
				type:"FAQUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FAQWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FAQUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFAQ:{
			by:{
				type:"FAQUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FAQWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FAQUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FAQCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLinkContent:{
			data:{
				type:"LinkContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLinkContent:{
			by:{
				type:"LinkContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLinkContent:{
			by:{
				type:"LinkContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLinkContent:{
			by:{
				type:"LinkContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createAwardContent:{
			data:{
				type:"AwardContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteAwardContent:{
			by:{
				type:"AwardContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AwardContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateAwardContent:{
			by:{
				type:"AwardContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AwardContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"AwardContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertAwardContent:{
			by:{
				type:"AwardContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AwardContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"AwardContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"AwardContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createReviewContent:{
			data:{
				type:"ReviewContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteReviewContent:{
			by:{
				type:"ReviewContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ReviewContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateReviewContent:{
			by:{
				type:"ReviewContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ReviewContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ReviewContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertReviewContent:{
			by:{
				type:"ReviewContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ReviewContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ReviewContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ReviewContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPage:{
			data:{
				type:"PageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTextTranslation:{
			data:{
				type:"TextTranslationCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTextTranslation:{
			by:{
				type:"TextTranslationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextTranslationWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTextTranslation:{
			by:{
				type:"TextTranslationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextTranslationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TextTranslationUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTextTranslation:{
			by:{
				type:"TextTranslationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TextTranslationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TextTranslationUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TextTranslationCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSeo:{
			data:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFile:{
			data:{
				type:"FileCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFile:{
			by:{
				type:"FileUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFile:{
			by:{
				type:"FileUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FileUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFile:{
			by:{
				type:"FileUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FileUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FileCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFileUse:{
			data:{
				type:"FileUseCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFileUse:{
			by:{
				type:"FileUseUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFileUse:{
			by:{
				type:"FileUseUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FileUseUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFileUse:{
			by:{
				type:"FileUseUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileUseWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FileUseUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FileUseCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentBlock:{
			data:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentArticle:{
			data:{
				type:"ContentArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentArticle:{
			by:{
				type:"ContentArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentArticle:{
			by:{
				type:"ContentArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentArticle:{
			by:{
				type:"ContentArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createUnlockedArticle:{
			data:{
				type:"UnlockedArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteUnlockedArticle:{
			by:{
				type:"UnlockedArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"UnlockedArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateUnlockedArticle:{
			by:{
				type:"UnlockedArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"UnlockedArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"UnlockedArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertUnlockedArticle:{
			by:{
				type:"UnlockedArticleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"UnlockedArticleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"UnlockedArticleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"UnlockedArticleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createUser:{
			data:{
				type:"UserCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteUser:{
			by:{
				type:"UserUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"UserWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateUser:{
			by:{
				type:"UserUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"UserWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"UserUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertUser:{
			by:{
				type:"UserUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"UserWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"UserUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"UserCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createNotification:{
			data:{
				type:"NotificationCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteNotification:{
			by:{
				type:"NotificationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NotificationWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateNotification:{
			by:{
				type:"NotificationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NotificationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"NotificationUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertNotification:{
			by:{
				type:"NotificationUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NotificationWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"NotificationUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"NotificationCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createAppReview:{
			data:{
				type:"AppReviewCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteAppReview:{
			by:{
				type:"AppReviewUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AppReviewWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateAppReview:{
			by:{
				type:"AppReviewUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AppReviewWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"AppReviewUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertAppReview:{
			by:{
				type:"AppReviewUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AppReviewWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"AppReviewUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"AppReviewCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createProduct:{
			data:{
				type:"ProductCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteProduct:{
			by:{
				type:"ProductUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProductWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateProduct:{
			by:{
				type:"ProductUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProductWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ProductUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertProduct:{
			by:{
				type:"ProductUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ProductWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ProductUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ProductCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSubscriptionForm:{
			data:{
				type:"SubscriptionFormCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSubscriptionForm:{
			by:{
				type:"SubscriptionFormUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSubscriptionForm:{
			by:{
				type:"SubscriptionFormUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SubscriptionFormUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSubscriptionForm:{
			by:{
				type:"SubscriptionFormUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SubscriptionFormUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SubscriptionFormCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSubscriptionFormSection:{
			data:{
				type:"SubscriptionFormSectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSubscriptionFormSection:{
			by:{
				type:"SubscriptionFormSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSubscriptionFormSection:{
			by:{
				type:"SubscriptionFormSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SubscriptionFormSectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSubscriptionFormSection:{
			by:{
				type:"SubscriptionFormSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SubscriptionFormSectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SubscriptionFormSectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSubscriptionFormInput:{
			data:{
				type:"SubscriptionFormInputCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSubscriptionFormInput:{
			by:{
				type:"SubscriptionFormInputUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormInputWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSubscriptionFormInput:{
			by:{
				type:"SubscriptionFormInputUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormInputWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SubscriptionFormInputUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSubscriptionFormInput:{
			by:{
				type:"SubscriptionFormInputUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormInputWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SubscriptionFormInputUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SubscriptionFormInputCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSubscriptionFormOption:{
			data:{
				type:"SubscriptionFormOptionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSubscriptionFormOption:{
			by:{
				type:"SubscriptionFormOptionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormOptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSubscriptionFormOption:{
			by:{
				type:"SubscriptionFormOptionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormOptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SubscriptionFormOptionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSubscriptionFormOption:{
			by:{
				type:"SubscriptionFormOptionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubscriptionFormOptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SubscriptionFormOptionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SubscriptionFormOptionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createButton:{
			data:{
				type:"ButtonCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteButton:{
			by:{
				type:"ButtonUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ButtonWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateButton:{
			by:{
				type:"ButtonUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ButtonWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ButtonUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertButton:{
			by:{
				type:"ButtonUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ButtonWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ButtonUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ButtonCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createArticleHistoryTag:{
			data:{
				type:"ArticleHistoryTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteArticleHistoryTag:{
			by:{
				type:"ArticleHistoryTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleHistoryTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateArticleHistoryTag:{
			by:{
				type:"ArticleHistoryTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleHistoryTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ArticleHistoryTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertArticleHistoryTag:{
			by:{
				type:"ArticleHistoryTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleHistoryTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ArticleHistoryTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ArticleHistoryTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createArticleHistoryPeriod:{
			data:{
				type:"ArticleHistoryPeriodCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteArticleHistoryPeriod:{
			by:{
				type:"ArticleHistoryPeriodUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleHistoryPeriodWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateArticleHistoryPeriod:{
			by:{
				type:"ArticleHistoryPeriodUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleHistoryPeriodWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ArticleHistoryPeriodUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertArticleHistoryPeriod:{
			by:{
				type:"ArticleHistoryPeriodUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArticleHistoryPeriodWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ArticleHistoryPeriodUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ArticleHistoryPeriodCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHistoryTag:{
			data:{
				type:"HistoryTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHistoryTag:{
			by:{
				type:"HistoryTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHistoryTag:{
			by:{
				type:"HistoryTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HistoryTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHistoryTag:{
			by:{
				type:"HistoryTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HistoryTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HistoryTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHistoryPeriod:{
			data:{
				type:"HistoryPeriodCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHistoryPeriod:{
			by:{
				type:"HistoryPeriodUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryPeriodWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHistoryPeriod:{
			by:{
				type:"HistoryPeriodUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryPeriodWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HistoryPeriodUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHistoryPeriod:{
			by:{
				type:"HistoryPeriodUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryPeriodWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HistoryPeriodUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HistoryPeriodCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHistoryHomePage:{
			data:{
				type:"HistoryHomePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHistoryHomePage:{
			by:{
				type:"HistoryHomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryHomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHistoryHomePage:{
			by:{
				type:"HistoryHomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryHomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HistoryHomePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHistoryHomePage:{
			by:{
				type:"HistoryHomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryHomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HistoryHomePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HistoryHomePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHistoryCover:{
			data:{
				type:"HistoryCoverCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHistoryCover:{
			by:{
				type:"HistoryCoverUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryCoverWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHistoryCover:{
			by:{
				type:"HistoryCoverUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryCoverWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HistoryCoverUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHistoryCover:{
			by:{
				type:"HistoryCoverUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryCoverWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HistoryCoverUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HistoryCoverCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHistoryTextList:{
			data:{
				type:"HistoryTextListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHistoryTextList:{
			by:{
				type:"HistoryTextListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryTextListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHistoryTextList:{
			by:{
				type:"HistoryTextListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryTextListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HistoryTextListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHistoryTextList:{
			by:{
				type:"HistoryTextListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryTextListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HistoryTextListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HistoryTextListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHistoryTextItem:{
			data:{
				type:"HistoryTextItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHistoryTextItem:{
			by:{
				type:"HistoryTextItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryTextItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHistoryTextItem:{
			by:{
				type:"HistoryTextItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryTextItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HistoryTextItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHistoryTextItem:{
			by:{
				type:"HistoryTextItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HistoryTextItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HistoryTextItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HistoryTextItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFooterMenu:{
			data:{
				type:"FooterMenuCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFooterMenu:{
			by:{
				type:"FooterMenuUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterMenuWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFooterMenu:{
			by:{
				type:"FooterMenuUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterMenuWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FooterMenuUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFooterMenu:{
			by:{
				type:"FooterMenuUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterMenuWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FooterMenuUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FooterMenuCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLinkSection:{
			data:{
				type:"LinkSectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLinkSection:{
			by:{
				type:"LinkSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLinkSection:{
			by:{
				type:"LinkSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkSectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLinkSection:{
			by:{
				type:"LinkSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkSectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkSectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLinkList:{
			data:{
				type:"LinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLinkList:{
			by:{
				type:"LinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLinkList:{
			by:{
				type:"LinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLinkList:{
			by:{
				type:"LinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLinkItem:{
			data:{
				type:"LinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLinkItem:{
			by:{
				type:"LinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLinkItem:{
			by:{
				type:"LinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLinkItem:{
			by:{
				type:"LinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createNewsletterSection:{
			data:{
				type:"NewsletterSectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteNewsletterSection:{
			by:{
				type:"NewsletterSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateNewsletterSection:{
			by:{
				type:"NewsletterSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"NewsletterSectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertNewsletterSection:{
			by:{
				type:"NewsletterSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"NewsletterSectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"NewsletterSectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createNewsletter:{
			data:{
				type:"NewsletterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteNewsletter:{
			by:{
				type:"NewsletterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateNewsletter:{
			by:{
				type:"NewsletterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"NewsletterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertNewsletter:{
			by:{
				type:"NewsletterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"NewsletterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"NewsletterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createOnlineSection:{
			data:{
				type:"OnlineSectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteOnlineSection:{
			by:{
				type:"OnlineSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"OnlineSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateOnlineSection:{
			by:{
				type:"OnlineSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"OnlineSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"OnlineSectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertOnlineSection:{
			by:{
				type:"OnlineSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"OnlineSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"OnlineSectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"OnlineSectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createAppLink:{
			data:{
				type:"AppLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteAppLink:{
			by:{
				type:"AppLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AppLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateAppLink:{
			by:{
				type:"AppLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AppLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"AppLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertAppLink:{
			by:{
				type:"AppLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AppLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"AppLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"AppLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createAppLinkList:{
			data:{
				type:"AppLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteAppLinkList:{
			by:{
				type:"AppLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AppLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateAppLinkList:{
			by:{
				type:"AppLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AppLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"AppLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertAppLinkList:{
			by:{
				type:"AppLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AppLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"AppLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"AppLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createAppLinkItem:{
			data:{
				type:"AppLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteAppLinkItem:{
			by:{
				type:"AppLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AppLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateAppLinkItem:{
			by:{
				type:"AppLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AppLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"AppLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertAppLinkItem:{
			by:{
				type:"AppLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"AppLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"AppLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"AppLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSocialSection:{
			data:{
				type:"SocialSectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSocialSection:{
			by:{
				type:"SocialSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSocialSection:{
			by:{
				type:"SocialSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SocialSectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSocialSection:{
			by:{
				type:"SocialSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialSectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SocialSectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SocialSectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSocialLink:{
			data:{
				type:"SocialLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SocialLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SocialLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SocialLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSocialLinkList:{
			data:{
				type:"SocialLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSocialLinkList:{
			by:{
				type:"SocialLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSocialLinkList:{
			by:{
				type:"SocialLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SocialLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSocialLinkList:{
			by:{
				type:"SocialLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SocialLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SocialLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSocialLinkItem:{
			data:{
				type:"SocialLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSocialLinkItem:{
			by:{
				type:"SocialLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSocialLinkItem:{
			by:{
				type:"SocialLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SocialLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSocialLinkItem:{
			by:{
				type:"SocialLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SocialLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SocialLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSharedContent:{
			data:{
				type:"SharedContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSharedContent:{
			by:{
				type:"SharedContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SharedContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSharedContent:{
			by:{
				type:"SharedContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SharedContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SharedContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSharedContent:{
			by:{
				type:"SharedContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SharedContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SharedContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SharedContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		}
	},
	MutationTransactionOptions:{
		deferForeignKeyConstraints:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Json: "String",
	_OnDeleteBehaviour: "enum",
	_RelationSide: "enum",
	_OrderByDirection: "enum",
	S3Acl: "enum"
}

export const ReturnTypes: Record<string,any> = {
	Query:{
		getArticle:"Article",
		listArticle:"Article",
		paginateArticle:"ArticleConnection",
		validateCreateArticle:"_ValidationResult",
		validateUpdateArticle:"_ValidationResult",
		getArticleAuthor:"ArticleAuthor",
		listArticleAuthor:"ArticleAuthor",
		paginateArticleAuthor:"ArticleAuthorConnection",
		validateCreateArticleAuthor:"_ValidationResult",
		validateUpdateArticleAuthor:"_ValidationResult",
		getAuthor:"Author",
		listAuthor:"Author",
		paginateAuthor:"AuthorConnection",
		validateCreateAuthor:"_ValidationResult",
		validateUpdateAuthor:"_ValidationResult",
		getAuthorTopArticle:"AuthorTopArticle",
		listAuthorTopArticle:"AuthorTopArticle",
		paginateAuthorTopArticle:"AuthorTopArticleConnection",
		validateCreateAuthorTopArticle:"_ValidationResult",
		validateUpdateAuthorTopArticle:"_ValidationResult",
		getContent:"Content",
		listContent:"Content",
		paginateContent:"ContentConnection",
		validateCreateContent:"_ValidationResult",
		validateUpdateContent:"_ValidationResult",
		getContentPart:"ContentPart",
		listContentPart:"ContentPart",
		paginateContentPart:"ContentPartConnection",
		validateCreateContentPart:"_ValidationResult",
		validateUpdateContentPart:"_ValidationResult",
		getContentReference:"ContentReference",
		listContentReference:"ContentReference",
		paginateContentReference:"ContentReferenceConnection",
		validateCreateContentReference:"_ValidationResult",
		validateUpdateContentReference:"_ValidationResult",
		getHomepageArticle:"HomepageArticle",
		listHomepageArticle:"HomepageArticle",
		paginateHomepageArticle:"HomepageArticleConnection",
		validateCreateHomepageArticle:"_ValidationResult",
		validateUpdateHomepageArticle:"_ValidationResult",
		getImage:"Image",
		listImage:"Image",
		paginateImage:"ImageConnection",
		validateCreateImage:"_ValidationResult",
		validateUpdateImage:"_ValidationResult",
		getImageUse:"ImageUse",
		listImageUse:"ImageUse",
		paginateImageUse:"ImageUseConnection",
		validateCreateImageUse:"_ValidationResult",
		validateUpdateImageUse:"_ValidationResult",
		getImageTag:"ImageTag",
		listImageTag:"ImageTag",
		paginateImageTag:"ImageTagConnection",
		validateCreateImageTag:"_ValidationResult",
		validateUpdateImageTag:"_ValidationResult",
		getIssue:"Issue",
		listIssue:"Issue",
		paginateIssue:"IssueConnection",
		validateCreateIssue:"_ValidationResult",
		validateUpdateIssue:"_ValidationResult",
		getIssueArticle:"IssueArticle",
		listIssueArticle:"IssueArticle",
		paginateIssueArticle:"IssueArticleConnection",
		validateCreateIssueArticle:"_ValidationResult",
		validateUpdateIssueArticle:"_ValidationResult",
		getLink:"Link",
		listLink:"Link",
		paginateLink:"LinkConnection",
		validateCreateLink:"_ValidationResult",
		validateUpdateLink:"_ValidationResult",
		getTextContent:"TextContent",
		listTextContent:"TextContent",
		paginateTextContent:"TextContentConnection",
		validateCreateTextContent:"_ValidationResult",
		validateUpdateTextContent:"_ValidationResult",
		getTextContentPart:"TextContentPart",
		listTextContentPart:"TextContentPart",
		paginateTextContentPart:"TextContentPartConnection",
		validateCreateTextContentPart:"_ValidationResult",
		validateUpdateTextContentPart:"_ValidationResult",
		getTextContentReference:"TextContentReference",
		listTextContentReference:"TextContentReference",
		paginateTextContentReference:"TextContentReferenceConnection",
		validateCreateTextContentReference:"_ValidationResult",
		validateUpdateTextContentReference:"_ValidationResult",
		getUrl:"Url",
		listUrl:"Url",
		paginateUrl:"UrlConnection",
		validateCreateUrl:"_ValidationResult",
		validateUpdateUrl:"_ValidationResult",
		getArticleTag:"ArticleTag",
		listArticleTag:"ArticleTag",
		paginateArticleTag:"ArticleTagConnection",
		validateCreateArticleTag:"_ValidationResult",
		validateUpdateArticleTag:"_ValidationResult",
		getCategory:"Category",
		listCategory:"Category",
		paginateCategory:"CategoryConnection",
		validateCreateCategory:"_ValidationResult",
		validateUpdateCategory:"_ValidationResult",
		getArticleCategory:"ArticleCategory",
		listArticleCategory:"ArticleCategory",
		paginateArticleCategory:"ArticleCategoryConnection",
		validateCreateArticleCategory:"_ValidationResult",
		validateUpdateArticleCategory:"_ValidationResult",
		getAudio:"Audio",
		listAudio:"Audio",
		paginateAudio:"AudioConnection",
		validateCreateAudio:"_ValidationResult",
		validateUpdateAudio:"_ValidationResult",
		getAudioUse:"AudioUse",
		listAudioUse:"AudioUse",
		paginateAudioUse:"AudioUseConnection",
		validateCreateAudioUse:"_ValidationResult",
		validateUpdateAudioUse:"_ValidationResult",
		getEmbed:"Embed",
		listEmbed:"Embed",
		paginateEmbed:"EmbedConnection",
		validateCreateEmbed:"_ValidationResult",
		validateUpdateEmbed:"_ValidationResult",
		getImageContent:"ImageContent",
		listImageContent:"ImageContent",
		paginateImageContent:"ImageContentConnection",
		validateCreateImageContent:"_ValidationResult",
		validateUpdateImageContent:"_ValidationResult",
		getListicle:"Listicle",
		listListicle:"Listicle",
		paginateListicle:"ListicleConnection",
		validateCreateListicle:"_ValidationResult",
		validateUpdateListicle:"_ValidationResult",
		getPollAnswer:"PollAnswer",
		listPollAnswer:"PollAnswer",
		paginatePollAnswer:"PollAnswerConnection",
		validateCreatePollAnswer:"_ValidationResult",
		validateUpdatePollAnswer:"_ValidationResult",
		getTag:"Tag",
		listTag:"Tag",
		paginateTag:"TagConnection",
		validateCreateTag:"_ValidationResult",
		validateUpdateTag:"_ValidationResult",
		getFAQ:"FAQ",
		listFAQ:"FAQ",
		paginateFAQ:"FAQConnection",
		validateCreateFAQ:"_ValidationResult",
		validateUpdateFAQ:"_ValidationResult",
		getLinkContent:"LinkContent",
		listLinkContent:"LinkContent",
		paginateLinkContent:"LinkContentConnection",
		validateCreateLinkContent:"_ValidationResult",
		validateUpdateLinkContent:"_ValidationResult",
		getAwardContent:"AwardContent",
		listAwardContent:"AwardContent",
		paginateAwardContent:"AwardContentConnection",
		validateCreateAwardContent:"_ValidationResult",
		validateUpdateAwardContent:"_ValidationResult",
		getReviewContent:"ReviewContent",
		listReviewContent:"ReviewContent",
		paginateReviewContent:"ReviewContentConnection",
		validateCreateReviewContent:"_ValidationResult",
		validateUpdateReviewContent:"_ValidationResult",
		getPage:"Page",
		listPage:"Page",
		paginatePage:"PageConnection",
		validateCreatePage:"_ValidationResult",
		validateUpdatePage:"_ValidationResult",
		getTextTranslation:"TextTranslation",
		listTextTranslation:"TextTranslation",
		paginateTextTranslation:"TextTranslationConnection",
		validateCreateTextTranslation:"_ValidationResult",
		validateUpdateTextTranslation:"_ValidationResult",
		getSeo:"Seo",
		listSeo:"Seo",
		paginateSeo:"SeoConnection",
		validateCreateSeo:"_ValidationResult",
		validateUpdateSeo:"_ValidationResult",
		getFile:"File",
		listFile:"File",
		paginateFile:"FileConnection",
		validateCreateFile:"_ValidationResult",
		validateUpdateFile:"_ValidationResult",
		getFileUse:"FileUse",
		listFileUse:"FileUse",
		paginateFileUse:"FileUseConnection",
		validateCreateFileUse:"_ValidationResult",
		validateUpdateFileUse:"_ValidationResult",
		getContentBlock:"ContentBlock",
		listContentBlock:"ContentBlock",
		paginateContentBlock:"ContentBlockConnection",
		validateCreateContentBlock:"_ValidationResult",
		validateUpdateContentBlock:"_ValidationResult",
		getContentArticle:"ContentArticle",
		listContentArticle:"ContentArticle",
		paginateContentArticle:"ContentArticleConnection",
		validateCreateContentArticle:"_ValidationResult",
		validateUpdateContentArticle:"_ValidationResult",
		getUnlockedArticle:"UnlockedArticle",
		listUnlockedArticle:"UnlockedArticle",
		paginateUnlockedArticle:"UnlockedArticleConnection",
		validateCreateUnlockedArticle:"_ValidationResult",
		validateUpdateUnlockedArticle:"_ValidationResult",
		getUser:"User",
		listUser:"User",
		paginateUser:"UserConnection",
		validateCreateUser:"_ValidationResult",
		validateUpdateUser:"_ValidationResult",
		getNotification:"Notification",
		listNotification:"Notification",
		paginateNotification:"NotificationConnection",
		validateCreateNotification:"_ValidationResult",
		validateUpdateNotification:"_ValidationResult",
		getAppReview:"AppReview",
		listAppReview:"AppReview",
		paginateAppReview:"AppReviewConnection",
		validateCreateAppReview:"_ValidationResult",
		validateUpdateAppReview:"_ValidationResult",
		getProduct:"Product",
		listProduct:"Product",
		paginateProduct:"ProductConnection",
		validateCreateProduct:"_ValidationResult",
		validateUpdateProduct:"_ValidationResult",
		getSubscriptionForm:"SubscriptionForm",
		listSubscriptionForm:"SubscriptionForm",
		paginateSubscriptionForm:"SubscriptionFormConnection",
		validateCreateSubscriptionForm:"_ValidationResult",
		validateUpdateSubscriptionForm:"_ValidationResult",
		getSubscriptionFormSection:"SubscriptionFormSection",
		listSubscriptionFormSection:"SubscriptionFormSection",
		paginateSubscriptionFormSection:"SubscriptionFormSectionConnection",
		validateCreateSubscriptionFormSection:"_ValidationResult",
		validateUpdateSubscriptionFormSection:"_ValidationResult",
		getSubscriptionFormInput:"SubscriptionFormInput",
		listSubscriptionFormInput:"SubscriptionFormInput",
		paginateSubscriptionFormInput:"SubscriptionFormInputConnection",
		validateCreateSubscriptionFormInput:"_ValidationResult",
		validateUpdateSubscriptionFormInput:"_ValidationResult",
		getSubscriptionFormOption:"SubscriptionFormOption",
		listSubscriptionFormOption:"SubscriptionFormOption",
		paginateSubscriptionFormOption:"SubscriptionFormOptionConnection",
		validateCreateSubscriptionFormOption:"_ValidationResult",
		validateUpdateSubscriptionFormOption:"_ValidationResult",
		getButton:"Button",
		listButton:"Button",
		paginateButton:"ButtonConnection",
		validateCreateButton:"_ValidationResult",
		validateUpdateButton:"_ValidationResult",
		getArticleHistoryTag:"ArticleHistoryTag",
		listArticleHistoryTag:"ArticleHistoryTag",
		paginateArticleHistoryTag:"ArticleHistoryTagConnection",
		validateCreateArticleHistoryTag:"_ValidationResult",
		validateUpdateArticleHistoryTag:"_ValidationResult",
		getArticleHistoryPeriod:"ArticleHistoryPeriod",
		listArticleHistoryPeriod:"ArticleHistoryPeriod",
		paginateArticleHistoryPeriod:"ArticleHistoryPeriodConnection",
		validateCreateArticleHistoryPeriod:"_ValidationResult",
		validateUpdateArticleHistoryPeriod:"_ValidationResult",
		getHistoryTag:"HistoryTag",
		listHistoryTag:"HistoryTag",
		paginateHistoryTag:"HistoryTagConnection",
		validateCreateHistoryTag:"_ValidationResult",
		validateUpdateHistoryTag:"_ValidationResult",
		getHistoryPeriod:"HistoryPeriod",
		listHistoryPeriod:"HistoryPeriod",
		paginateHistoryPeriod:"HistoryPeriodConnection",
		validateCreateHistoryPeriod:"_ValidationResult",
		validateUpdateHistoryPeriod:"_ValidationResult",
		getHistoryHomePage:"HistoryHomePage",
		listHistoryHomePage:"HistoryHomePage",
		paginateHistoryHomePage:"HistoryHomePageConnection",
		validateCreateHistoryHomePage:"_ValidationResult",
		validateUpdateHistoryHomePage:"_ValidationResult",
		getHistoryCover:"HistoryCover",
		listHistoryCover:"HistoryCover",
		paginateHistoryCover:"HistoryCoverConnection",
		validateCreateHistoryCover:"_ValidationResult",
		validateUpdateHistoryCover:"_ValidationResult",
		getHistoryTextList:"HistoryTextList",
		listHistoryTextList:"HistoryTextList",
		paginateHistoryTextList:"HistoryTextListConnection",
		validateCreateHistoryTextList:"_ValidationResult",
		validateUpdateHistoryTextList:"_ValidationResult",
		getHistoryTextItem:"HistoryTextItem",
		listHistoryTextItem:"HistoryTextItem",
		paginateHistoryTextItem:"HistoryTextItemConnection",
		validateCreateHistoryTextItem:"_ValidationResult",
		validateUpdateHistoryTextItem:"_ValidationResult",
		getFooterMenu:"FooterMenu",
		listFooterMenu:"FooterMenu",
		paginateFooterMenu:"FooterMenuConnection",
		validateCreateFooterMenu:"_ValidationResult",
		validateUpdateFooterMenu:"_ValidationResult",
		getLinkSection:"LinkSection",
		listLinkSection:"LinkSection",
		paginateLinkSection:"LinkSectionConnection",
		validateCreateLinkSection:"_ValidationResult",
		validateUpdateLinkSection:"_ValidationResult",
		getLinkList:"LinkList",
		listLinkList:"LinkList",
		paginateLinkList:"LinkListConnection",
		validateCreateLinkList:"_ValidationResult",
		validateUpdateLinkList:"_ValidationResult",
		getLinkItem:"LinkItem",
		listLinkItem:"LinkItem",
		paginateLinkItem:"LinkItemConnection",
		validateCreateLinkItem:"_ValidationResult",
		validateUpdateLinkItem:"_ValidationResult",
		getNewsletterSection:"NewsletterSection",
		listNewsletterSection:"NewsletterSection",
		paginateNewsletterSection:"NewsletterSectionConnection",
		validateCreateNewsletterSection:"_ValidationResult",
		validateUpdateNewsletterSection:"_ValidationResult",
		getNewsletter:"Newsletter",
		listNewsletter:"Newsletter",
		paginateNewsletter:"NewsletterConnection",
		validateCreateNewsletter:"_ValidationResult",
		validateUpdateNewsletter:"_ValidationResult",
		getOnlineSection:"OnlineSection",
		listOnlineSection:"OnlineSection",
		paginateOnlineSection:"OnlineSectionConnection",
		validateCreateOnlineSection:"_ValidationResult",
		validateUpdateOnlineSection:"_ValidationResult",
		getAppLink:"AppLink",
		listAppLink:"AppLink",
		paginateAppLink:"AppLinkConnection",
		validateCreateAppLink:"_ValidationResult",
		validateUpdateAppLink:"_ValidationResult",
		getAppLinkList:"AppLinkList",
		listAppLinkList:"AppLinkList",
		paginateAppLinkList:"AppLinkListConnection",
		validateCreateAppLinkList:"_ValidationResult",
		validateUpdateAppLinkList:"_ValidationResult",
		getAppLinkItem:"AppLinkItem",
		listAppLinkItem:"AppLinkItem",
		paginateAppLinkItem:"AppLinkItemConnection",
		validateCreateAppLinkItem:"_ValidationResult",
		validateUpdateAppLinkItem:"_ValidationResult",
		getSocialSection:"SocialSection",
		listSocialSection:"SocialSection",
		paginateSocialSection:"SocialSectionConnection",
		validateCreateSocialSection:"_ValidationResult",
		validateUpdateSocialSection:"_ValidationResult",
		getSocialLink:"SocialLink",
		listSocialLink:"SocialLink",
		paginateSocialLink:"SocialLinkConnection",
		validateCreateSocialLink:"_ValidationResult",
		validateUpdateSocialLink:"_ValidationResult",
		getSocialLinkList:"SocialLinkList",
		listSocialLinkList:"SocialLinkList",
		paginateSocialLinkList:"SocialLinkListConnection",
		validateCreateSocialLinkList:"_ValidationResult",
		validateUpdateSocialLinkList:"_ValidationResult",
		getSocialLinkItem:"SocialLinkItem",
		listSocialLinkItem:"SocialLinkItem",
		paginateSocialLinkItem:"SocialLinkItemConnection",
		validateCreateSocialLinkItem:"_ValidationResult",
		validateUpdateSocialLinkItem:"_ValidationResult",
		getSharedContent:"SharedContent",
		listSharedContent:"SharedContent",
		paginateSharedContent:"SharedContentConnection",
		validateCreateSharedContent:"_ValidationResult",
		validateUpdateSharedContent:"_ValidationResult",
		transaction:"QueryTransaction",
		_info:"Info",
		schema:"_Schema",
		s3DummyQuery:"String"
	},
	Article:{
		_meta:"ArticleMeta",
		id:"UUID",
		title:"String",
		url:"Url",
		authors:"ArticleAuthor",
		hideInMostRead:"Boolean",
		hideAds:"Boolean",
		state:"ArticleState",
		locked:"Boolean",
		publishAt:"DateTime",
		template:"Template",
		subtitle:"TextContent",
		content:"Content",
		coverPhoto:"ImageUse",
		titleAlignment:"ArticleTitleAlignment",
		tagline:"String",
		createdAt:"DateTime",
		previewContent:"Content",
		audio:"AudioUse",
		categories:"ArticleCategory",
		issues:"IssueArticle",
		contentBlocks:"ContentArticle",
		unlocked:"UnlockedArticle",
		coverPhotoVertical:"ImageUse",
		legacyId:"String",
		tags:"ArticleTag",
		isHistory:"Boolean",
		historyTags:"ArticleHistoryTag",
		historyPeriods:"ArticleHistoryPeriod",
		authorsByAuthor:"ArticleAuthor",
		authorsByLegacyStringAuthor:"ArticleAuthor",
		categoriesByCategory:"ArticleCategory",
		issuesByIssue:"IssueArticle",
		tagsByTag:"ArticleTag",
		historyTagsByHistoryTag:"ArticleHistoryTag",
		historyPeriodsByHistoryPeriod:"ArticleHistoryPeriod",
		paginateAuthors:"ArticleAuthorConnection",
		paginateCategories:"ArticleCategoryConnection",
		paginateIssues:"IssueArticleConnection",
		paginateContentBlocks:"ContentArticleConnection",
		paginateUnlocked:"UnlockedArticleConnection",
		paginateTags:"ArticleTagConnection",
		paginateHistoryTags:"ArticleHistoryTagConnection",
		paginateHistoryPeriods:"ArticleHistoryPeriodConnection"
	},
	ArticleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		url:"FieldMeta",
		authors:"FieldMeta",
		hideInMostRead:"FieldMeta",
		hideAds:"FieldMeta",
		state:"FieldMeta",
		locked:"FieldMeta",
		publishAt:"FieldMeta",
		template:"FieldMeta",
		subtitle:"FieldMeta",
		content:"FieldMeta",
		coverPhoto:"FieldMeta",
		titleAlignment:"FieldMeta",
		tagline:"FieldMeta",
		createdAt:"FieldMeta",
		previewContent:"FieldMeta",
		audio:"FieldMeta",
		categories:"FieldMeta",
		issues:"FieldMeta",
		contentBlocks:"FieldMeta",
		unlocked:"FieldMeta",
		coverPhotoVertical:"FieldMeta",
		legacyId:"FieldMeta",
		tags:"FieldMeta",
		isHistory:"FieldMeta",
		historyTags:"FieldMeta",
		historyPeriods:"FieldMeta"
	},
	FieldMeta:{
		readable:"Boolean",
		updatable:"Boolean"
	},
	Url:{
		_meta:"UrlMeta",
		id:"UUID",
		url:"String",
		article:"Article",
		author:"Author",
		issue:"Issue",
		page:"Page",
		category:"Category",
		tag:"Tag",
		redirect:"String"
	},
	UrlMeta:{
		id:"FieldMeta",
		url:"FieldMeta",
		article:"FieldMeta",
		author:"FieldMeta",
		issue:"FieldMeta",
		page:"FieldMeta",
		category:"FieldMeta",
		tag:"FieldMeta",
		redirect:"FieldMeta"
	},
	Author:{
		_meta:"AuthorMeta",
		id:"UUID",
		name:"String",
		position:"String",
		twitterHandle:"String",
		facebookId:"String",
		email:"String",
		photographer:"Boolean",
		order:"Int",
		about:"Content",
		topArticles:"AuthorTopArticle",
		users:"User",
		startOfCooperation:"Date",
		photo:"ImageUse",
		illustration:"ImageUse",
		legacyId:"String",
		category:"AuthorCategory",
		url:"Url",
		instagramUsername:"String",
		paginateTopArticles:"AuthorTopArticleConnection",
		paginateUsers:"UserConnection"
	},
	AuthorMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		position:"FieldMeta",
		twitterHandle:"FieldMeta",
		facebookId:"FieldMeta",
		email:"FieldMeta",
		photographer:"FieldMeta",
		order:"FieldMeta",
		about:"FieldMeta",
		topArticles:"FieldMeta",
		users:"FieldMeta",
		startOfCooperation:"FieldMeta",
		photo:"FieldMeta",
		illustration:"FieldMeta",
		legacyId:"FieldMeta",
		category:"FieldMeta",
		url:"FieldMeta",
		instagramUsername:"FieldMeta"
	},
	Content:{
		_meta:"ContentMeta",
		id:"UUID",
		parts:"ContentPart",
		partsByReferences:"ContentPart",
		paginateParts:"ContentPartConnection"
	},
	ContentMeta:{
		id:"FieldMeta",
		parts:"FieldMeta"
	},
	ContentPart:{
		_meta:"ContentPartMeta",
		id:"UUID",
		order:"Int",
		json:"String",
		content:"Content",
		references:"ContentReference",
		referencesByEmbed:"ContentReference",
		referencesByAudio:"ContentReference",
		referencesByImage:"ContentReference",
		referencesByPollAnswer:"ContentReference",
		referencesByListicle:"ContentReference",
		referencesByFaq:"ContentReference",
		referencesByLinks:"ContentReference",
		referencesByAwards:"ContentReference",
		referencesByReviews:"ContentReference",
		referencesByTarget:"ContentReference",
		referencesByButtons:"ContentReference",
		paginateReferences:"ContentReferenceConnection"
	},
	ContentPartMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		json:"FieldMeta",
		content:"FieldMeta",
		references:"FieldMeta"
	},
	ContentReference:{
		_meta:"ContentReferenceMeta",
		id:"UUID",
		type:"ContentReferenceType",
		contentPart:"ContentPart",
		primaryText:"String",
		secondaryText:"String",
		variant:"ContentReferenceVariant",
		color:"String",
		embed:"Embed",
		article:"Article",
		audio:"AudioUse",
		image:"ImageUse",
		images:"ImageContent",
		pollAnswer:"PollAnswer",
		listicle:"Listicle",
		faq:"FAQ",
		links:"LinkContent",
		awards:"AwardContent",
		reviews:"ReviewContent",
		target:"Link",
		subscriptionForm:"SubscriptionForm",
		buttons:"Button",
		sharedContent:"SharedContent",
		buttonsByTarget:"Button",
		paginateImages:"ImageContentConnection",
		paginateListicle:"ListicleConnection",
		paginateFaq:"FAQConnection",
		paginateLinks:"LinkContentConnection",
		paginateAwards:"AwardContentConnection",
		paginateReviews:"ReviewContentConnection",
		paginateButtons:"ButtonConnection"
	},
	ContentReferenceMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		contentPart:"FieldMeta",
		primaryText:"FieldMeta",
		secondaryText:"FieldMeta",
		variant:"FieldMeta",
		color:"FieldMeta",
		embed:"FieldMeta",
		article:"FieldMeta",
		audio:"FieldMeta",
		image:"FieldMeta",
		images:"FieldMeta",
		pollAnswer:"FieldMeta",
		listicle:"FieldMeta",
		faq:"FieldMeta",
		links:"FieldMeta",
		awards:"FieldMeta",
		reviews:"FieldMeta",
		target:"FieldMeta",
		subscriptionForm:"FieldMeta",
		buttons:"FieldMeta",
		sharedContent:"FieldMeta"
	},
	Embed:{
		_meta:"EmbedMeta",
		id:"UUID",
		type:"EmbedType",
		youtubeId:"String",
		vimeoId:"String",
		spotifyId:"String",
		spotifyType:"String",
		soundCloudId:"String"
	},
	EmbedMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		youtubeId:"FieldMeta",
		vimeoId:"FieldMeta",
		spotifyId:"FieldMeta",
		spotifyType:"FieldMeta",
		soundCloudId:"FieldMeta"
	},
	AudioUse:{
		_meta:"AudioUseMeta",
		id:"UUID",
		audio:"Audio"
	},
	AudioUseMeta:{
		id:"FieldMeta",
		audio:"FieldMeta"
	},
	Audio:{
		_meta:"AudioMeta",
		id:"UUID",
		url:"String",
		type:"String",
		author:"Author",
		uses:"AudioUse",
		paginateUses:"AudioUseConnection"
	},
	AudioMeta:{
		id:"FieldMeta",
		url:"FieldMeta",
		type:"FieldMeta",
		author:"FieldMeta",
		uses:"FieldMeta"
	},
	AudioUseConnection:{
		pageInfo:"PageInfo",
		edges:"AudioUseEdge"
	},
	PageInfo:{
		totalCount:"Int"
	},
	AudioUseEdge:{
		node:"AudioUse"
	},
	ImageUse:{
		_meta:"ImageUseMeta",
		id:"UUID",
		title:"String",
		image:"Image"
	},
	ImageUseMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		image:"FieldMeta"
	},
	Image:{
		_meta:"ImageMeta",
		id:"UUID",
		url:"String",
		width:"Int",
		height:"Int",
		title:"String",
		text:"String",
		author:"Author",
		tags:"ImageTag",
		uses:"ImageUse",
		align:"ImageAlign",
		legacyId:"String",
		paginateTags:"ImageTagConnection",
		paginateUses:"ImageUseConnection"
	},
	ImageMeta:{
		id:"FieldMeta",
		url:"FieldMeta",
		width:"FieldMeta",
		height:"FieldMeta",
		title:"FieldMeta",
		text:"FieldMeta",
		author:"FieldMeta",
		tags:"FieldMeta",
		uses:"FieldMeta",
		align:"FieldMeta",
		legacyId:"FieldMeta"
	},
	ImageTag:{
		_meta:"ImageTagMeta",
		id:"UUID",
		name:"String",
		images:"Image",
		paginateImages:"ImageConnection"
	},
	ImageTagMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		images:"FieldMeta"
	},
	ImageConnection:{
		pageInfo:"PageInfo",
		edges:"ImageEdge"
	},
	ImageEdge:{
		node:"Image"
	},
	ImageTagConnection:{
		pageInfo:"PageInfo",
		edges:"ImageTagEdge"
	},
	ImageTagEdge:{
		node:"ImageTag"
	},
	ImageUseConnection:{
		pageInfo:"PageInfo",
		edges:"ImageUseEdge"
	},
	ImageUseEdge:{
		node:"ImageUse"
	},
	ImageContent:{
		_meta:"ImageContentMeta",
		id:"UUID",
		order:"Int",
		contentReference:"ContentReference",
		image:"ImageUse",
		paginateContentReference:"ContentReferenceConnection"
	},
	ImageContentMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		contentReference:"FieldMeta",
		image:"FieldMeta"
	},
	ContentReferenceConnection:{
		pageInfo:"PageInfo",
		edges:"ContentReferenceEdge"
	},
	ContentReferenceEdge:{
		node:"ContentReference"
	},
	PollAnswer:{
		_meta:"PollAnswerMeta",
		id:"UUID",
		authorName:"String",
		authorPosition:"String",
		text:"String",
		authorImage:"ImageUse"
	},
	PollAnswerMeta:{
		id:"FieldMeta",
		authorName:"FieldMeta",
		authorPosition:"FieldMeta",
		text:"FieldMeta",
		authorImage:"FieldMeta"
	},
	Listicle:{
		_meta:"ListicleMeta",
		id:"UUID",
		order:"Int",
		primaryText:"String",
		image:"ImageUse",
		contentReference:"ContentReference",
		target:"Link",
		content:"Content"
	},
	ListicleMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		primaryText:"FieldMeta",
		image:"FieldMeta",
		contentReference:"FieldMeta",
		target:"FieldMeta",
		content:"FieldMeta"
	},
	Link:{
		_meta:"LinkMeta",
		id:"UUID",
		type:"LinkType",
		externalTarget:"String",
		internalTarget:"Url",
		queryParameters:"String"
	},
	LinkMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		externalTarget:"FieldMeta",
		internalTarget:"FieldMeta",
		queryParameters:"FieldMeta"
	},
	FAQ:{
		_meta:"FAQMeta",
		id:"UUID",
		order:"Int",
		answer:"String",
		question:"String",
		contentReference:"ContentReference"
	},
	FAQMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		answer:"FieldMeta",
		question:"FieldMeta",
		contentReference:"FieldMeta"
	},
	LinkContent:{
		_meta:"LinkContentMeta",
		id:"UUID",
		order:"Int",
		contentReference:"ContentReference",
		text:"String",
		target:"Link"
	},
	LinkContentMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		contentReference:"FieldMeta",
		text:"FieldMeta",
		target:"FieldMeta"
	},
	AwardContent:{
		_meta:"AwardContentMeta",
		id:"UUID",
		order:"Int",
		image:"ImageUse",
		contentReference:"ContentReference",
		target:"Link"
	},
	AwardContentMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		image:"FieldMeta",
		contentReference:"FieldMeta",
		target:"FieldMeta"
	},
	ReviewContent:{
		_meta:"ReviewContentMeta",
		id:"UUID",
		order:"Int",
		text:"String",
		contentReference:"ContentReference"
	},
	ReviewContentMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		text:"FieldMeta",
		contentReference:"FieldMeta"
	},
	SubscriptionForm:{
		_meta:"SubscriptionFormMeta",
		id:"UUID",
		name:"String",
		code:"String",
		createdAt:"DateTime",
		sections:"SubscriptionFormSection",
		contentBlock:"ContentBlock",
		products:"Product",
		contentReferences:"ContentReference",
		validity:"DateTime",
		sectionsByInputs:"SubscriptionFormSection",
		contentBlockByTarget:"ContentBlock",
		contentBlockByArticles:"ContentBlock",
		contentReferencesByEmbed:"ContentReference",
		contentReferencesByAudio:"ContentReference",
		contentReferencesByImage:"ContentReference",
		contentReferencesByPollAnswer:"ContentReference",
		contentReferencesByListicle:"ContentReference",
		contentReferencesByFaq:"ContentReference",
		contentReferencesByLinks:"ContentReference",
		contentReferencesByAwards:"ContentReference",
		contentReferencesByReviews:"ContentReference",
		contentReferencesByTarget:"ContentReference",
		contentReferencesByButtons:"ContentReference",
		paginateSections:"SubscriptionFormSectionConnection",
		paginateContentBlock:"ContentBlockConnection",
		paginateProducts:"ProductConnection",
		paginateContentReferences:"ContentReferenceConnection"
	},
	SubscriptionFormMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		code:"FieldMeta",
		createdAt:"FieldMeta",
		sections:"FieldMeta",
		contentBlock:"FieldMeta",
		products:"FieldMeta",
		contentReferences:"FieldMeta",
		validity:"FieldMeta"
	},
	SubscriptionFormSection:{
		_meta:"SubscriptionFormSectionMeta",
		id:"UUID",
		order:"Int",
		title:"String",
		form:"SubscriptionForm",
		inputs:"SubscriptionFormInput",
		inputsByImage:"SubscriptionFormInput",
		inputsByOptions:"SubscriptionFormInput",
		inputsByDescription:"SubscriptionFormInput",
		paginateInputs:"SubscriptionFormInputConnection"
	},
	SubscriptionFormSectionMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		title:"FieldMeta",
		form:"FieldMeta",
		inputs:"FieldMeta"
	},
	SubscriptionFormInput:{
		_meta:"SubscriptionFormInputMeta",
		id:"UUID",
		order:"Int",
		type:"SubscriptionFormInputType",
		image:"ImageUse",
		section:"SubscriptionFormSection",
		options:"SubscriptionFormOption",
		description:"Content",
		required:"Boolean",
		paginateOptions:"SubscriptionFormOptionConnection"
	},
	SubscriptionFormInputMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		type:"FieldMeta",
		image:"FieldMeta",
		section:"FieldMeta",
		options:"FieldMeta",
		description:"FieldMeta",
		required:"FieldMeta"
	},
	SubscriptionFormOption:{
		_meta:"SubscriptionFormOptionMeta",
		id:"UUID",
		hasProductId:"Boolean",
		order:"Int",
		label:"String",
		priceTag:"String",
		priceTagWithDiscount:"String",
		products:"Product",
		formInput:"SubscriptionFormInput",
		value:"String",
		internalLabel:"String",
		paginateProducts:"ProductConnection"
	},
	SubscriptionFormOptionMeta:{
		id:"FieldMeta",
		hasProductId:"FieldMeta",
		order:"FieldMeta",
		label:"FieldMeta",
		priceTag:"FieldMeta",
		priceTagWithDiscount:"FieldMeta",
		products:"FieldMeta",
		formInput:"FieldMeta",
		value:"FieldMeta",
		internalLabel:"FieldMeta"
	},
	Product:{
		_meta:"ProductMeta",
		id:"UUID",
		price:"Int",
		type:"Types",
		formOptions:"SubscriptionFormOption",
		form:"SubscriptionForm",
		productId:"String",
		paginateFormOptions:"SubscriptionFormOptionConnection"
	},
	ProductMeta:{
		id:"FieldMeta",
		price:"FieldMeta",
		type:"FieldMeta",
		formOptions:"FieldMeta",
		form:"FieldMeta",
		productId:"FieldMeta"
	},
	SubscriptionFormOptionConnection:{
		pageInfo:"PageInfo",
		edges:"SubscriptionFormOptionEdge"
	},
	SubscriptionFormOptionEdge:{
		node:"SubscriptionFormOption"
	},
	ProductConnection:{
		pageInfo:"PageInfo",
		edges:"ProductEdge"
	},
	ProductEdge:{
		node:"Product"
	},
	SubscriptionFormInputConnection:{
		pageInfo:"PageInfo",
		edges:"SubscriptionFormInputEdge"
	},
	SubscriptionFormInputEdge:{
		node:"SubscriptionFormInput"
	},
	ContentBlock:{
		_meta:"ContentBlockMeta",
		id:"UUID",
		order:"Int",
		type:"ContentBlockType",
		youtubeId:"String",
		text:"String",
		targetLabel:"String",
		issue:"Issue",
		target:"Link",
		articles:"ContentArticle",
		subscriptionForm:"SubscriptionForm",
		paginateArticles:"ContentArticleConnection"
	},
	ContentBlockMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		type:"FieldMeta",
		youtubeId:"FieldMeta",
		text:"FieldMeta",
		targetLabel:"FieldMeta",
		issue:"FieldMeta",
		target:"FieldMeta",
		articles:"FieldMeta",
		subscriptionForm:"FieldMeta"
	},
	Issue:{
		_meta:"IssueMeta",
		id:"UUID",
		closed:"Boolean",
		free:"Boolean",
		title:"String",
		subtitle:"String",
		year:"Int",
		issue:"Int",
		publishedSince:"Date",
		publishedUntil:"Date",
		publishDigital:"DateTime",
		mobileAppsKey:"String",
		url:"Url",
		articles:"IssueArticle",
		kind:"IssueKind",
		notificationTitle:"String",
		notificationMessage:"String",
		pdf:"FileUse",
		printBuy:"Boolean",
		printText:"String",
		blocks:"ContentBlock",
		coverPhoto:"ImageUse",
		printTarget:"Link",
		backgroundPhoto:"ImageUse",
		legacyId:"String",
		articlesByArticle:"IssueArticle",
		blocksByTarget:"ContentBlock",
		blocksByArticles:"ContentBlock",
		paginateArticles:"IssueArticleConnection",
		paginateBlocks:"ContentBlockConnection"
	},
	IssueMeta:{
		id:"FieldMeta",
		closed:"FieldMeta",
		free:"FieldMeta",
		title:"FieldMeta",
		subtitle:"FieldMeta",
		year:"FieldMeta",
		issue:"FieldMeta",
		publishedSince:"FieldMeta",
		publishedUntil:"FieldMeta",
		publishDigital:"FieldMeta",
		mobileAppsKey:"FieldMeta",
		url:"FieldMeta",
		articles:"FieldMeta",
		kind:"FieldMeta",
		notificationTitle:"FieldMeta",
		notificationMessage:"FieldMeta",
		pdf:"FieldMeta",
		printBuy:"FieldMeta",
		printText:"FieldMeta",
		blocks:"FieldMeta",
		coverPhoto:"FieldMeta",
		printTarget:"FieldMeta",
		backgroundPhoto:"FieldMeta",
		legacyId:"FieldMeta"
	},
	IssueArticle:{
		_meta:"IssueArticleMeta",
		id:"UUID",
		issue:"Issue",
		article:"Article",
		order:"Int"
	},
	IssueArticleMeta:{
		id:"FieldMeta",
		issue:"FieldMeta",
		article:"FieldMeta",
		order:"FieldMeta"
	},
	FileUse:{
		_meta:"FileUseMeta",
		id:"UUID",
		file:"File"
	},
	FileUseMeta:{
		id:"FieldMeta",
		file:"FieldMeta"
	},
	File:{
		_meta:"FileMeta",
		id:"UUID",
		url:"String",
		uses:"FileUse",
		paginateUses:"FileUseConnection"
	},
	FileMeta:{
		id:"FieldMeta",
		url:"FieldMeta",
		uses:"FieldMeta"
	},
	FileUseConnection:{
		pageInfo:"PageInfo",
		edges:"FileUseEdge"
	},
	FileUseEdge:{
		node:"FileUse"
	},
	IssueArticleConnection:{
		pageInfo:"PageInfo",
		edges:"IssueArticleEdge"
	},
	IssueArticleEdge:{
		node:"IssueArticle"
	},
	ContentBlockConnection:{
		pageInfo:"PageInfo",
		edges:"ContentBlockEdge"
	},
	ContentBlockEdge:{
		node:"ContentBlock"
	},
	ContentArticle:{
		_meta:"ContentArticleMeta",
		id:"UUID",
		order:"Int",
		contentBlock:"ContentBlock",
		article:"Article"
	},
	ContentArticleMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		contentBlock:"FieldMeta",
		article:"FieldMeta"
	},
	ContentArticleConnection:{
		pageInfo:"PageInfo",
		edges:"ContentArticleEdge"
	},
	ContentArticleEdge:{
		node:"ContentArticle"
	},
	SubscriptionFormSectionConnection:{
		pageInfo:"PageInfo",
		edges:"SubscriptionFormSectionEdge"
	},
	SubscriptionFormSectionEdge:{
		node:"SubscriptionFormSection"
	},
	Button:{
		_meta:"ButtonMeta",
		id:"UUID",
		order:"Int",
		type:"ButtonType",
		label:"String",
		target:"Link",
		contentReference:"ContentReference"
	},
	ButtonMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		type:"FieldMeta",
		label:"FieldMeta",
		target:"FieldMeta",
		contentReference:"FieldMeta"
	},
	SharedContent:{
		_meta:"SharedContentMeta",
		id:"UUID",
		name:"String",
		contentReference:"ContentReference",
		content:"Content",
		contentReferenceByEmbed:"ContentReference",
		contentReferenceByAudio:"ContentReference",
		contentReferenceByImage:"ContentReference",
		contentReferenceByPollAnswer:"ContentReference",
		contentReferenceByListicle:"ContentReference",
		contentReferenceByFaq:"ContentReference",
		contentReferenceByLinks:"ContentReference",
		contentReferenceByAwards:"ContentReference",
		contentReferenceByReviews:"ContentReference",
		contentReferenceByTarget:"ContentReference",
		contentReferenceByButtons:"ContentReference",
		paginateContentReference:"ContentReferenceConnection"
	},
	SharedContentMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		contentReference:"FieldMeta",
		content:"FieldMeta"
	},
	ImageContentConnection:{
		pageInfo:"PageInfo",
		edges:"ImageContentEdge"
	},
	ImageContentEdge:{
		node:"ImageContent"
	},
	ListicleConnection:{
		pageInfo:"PageInfo",
		edges:"ListicleEdge"
	},
	ListicleEdge:{
		node:"Listicle"
	},
	FAQConnection:{
		pageInfo:"PageInfo",
		edges:"FAQEdge"
	},
	FAQEdge:{
		node:"FAQ"
	},
	LinkContentConnection:{
		pageInfo:"PageInfo",
		edges:"LinkContentEdge"
	},
	LinkContentEdge:{
		node:"LinkContent"
	},
	AwardContentConnection:{
		pageInfo:"PageInfo",
		edges:"AwardContentEdge"
	},
	AwardContentEdge:{
		node:"AwardContent"
	},
	ReviewContentConnection:{
		pageInfo:"PageInfo",
		edges:"ReviewContentEdge"
	},
	ReviewContentEdge:{
		node:"ReviewContent"
	},
	ButtonConnection:{
		pageInfo:"PageInfo",
		edges:"ButtonEdge"
	},
	ButtonEdge:{
		node:"Button"
	},
	ContentPartConnection:{
		pageInfo:"PageInfo",
		edges:"ContentPartEdge"
	},
	ContentPartEdge:{
		node:"ContentPart"
	},
	AuthorTopArticle:{
		_meta:"AuthorTopArticleMeta",
		id:"UUID",
		order:"Int",
		author:"Author",
		article:"Article"
	},
	AuthorTopArticleMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		author:"FieldMeta",
		article:"FieldMeta"
	},
	User:{
		_meta:"UserMeta",
		id:"UUID",
		ihnedId:"String",
		email:"String",
		authors:"Author",
		unlockedArticles:"UnlockedArticle",
		appReviews:"AppReview",
		paginateAuthors:"AuthorConnection",
		paginateUnlockedArticles:"UnlockedArticleConnection",
		paginateAppReviews:"AppReviewConnection"
	},
	UserMeta:{
		id:"FieldMeta",
		ihnedId:"FieldMeta",
		email:"FieldMeta",
		authors:"FieldMeta",
		unlockedArticles:"FieldMeta",
		appReviews:"FieldMeta"
	},
	UnlockedArticle:{
		_meta:"UnlockedArticleMeta",
		id:"UUID",
		createdAt:"DateTime",
		code:"String",
		views:"Int",
		user:"User",
		article:"Article"
	},
	UnlockedArticleMeta:{
		id:"FieldMeta",
		createdAt:"FieldMeta",
		code:"FieldMeta",
		views:"FieldMeta",
		user:"FieldMeta",
		article:"FieldMeta"
	},
	AppReview:{
		_meta:"AppReviewMeta",
		id:"UUID",
		done:"Boolean",
		deviceId:"String",
		createdAt:"DateTime",
		rating:"Int",
		note:"String",
		user:"User"
	},
	AppReviewMeta:{
		id:"FieldMeta",
		done:"FieldMeta",
		deviceId:"FieldMeta",
		createdAt:"FieldMeta",
		rating:"FieldMeta",
		note:"FieldMeta",
		user:"FieldMeta"
	},
	AuthorConnection:{
		pageInfo:"PageInfo",
		edges:"AuthorEdge"
	},
	AuthorEdge:{
		node:"Author"
	},
	UnlockedArticleConnection:{
		pageInfo:"PageInfo",
		edges:"UnlockedArticleEdge"
	},
	UnlockedArticleEdge:{
		node:"UnlockedArticle"
	},
	AppReviewConnection:{
		pageInfo:"PageInfo",
		edges:"AppReviewEdge"
	},
	AppReviewEdge:{
		node:"AppReview"
	},
	AuthorTopArticleConnection:{
		pageInfo:"PageInfo",
		edges:"AuthorTopArticleEdge"
	},
	AuthorTopArticleEdge:{
		node:"AuthorTopArticle"
	},
	UserConnection:{
		pageInfo:"PageInfo",
		edges:"UserEdge"
	},
	UserEdge:{
		node:"User"
	},
	Page:{
		_meta:"PageMeta",
		id:"UUID",
		title:"String",
		publishAt:"DateTime",
		createdAt:"DateTime",
		template:"PageTemplate",
		url:"Url",
		content:"Content",
		seo:"Seo",
		subscriptionValidity:"DateTime"
	},
	PageMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		publishAt:"FieldMeta",
		createdAt:"FieldMeta",
		template:"FieldMeta",
		url:"FieldMeta",
		content:"FieldMeta",
		seo:"FieldMeta",
		subscriptionValidity:"FieldMeta"
	},
	Seo:{
		_meta:"SeoMeta",
		id:"UUID",
		title:"String",
		description:"String",
		ogTitle:"String",
		ogDescription:"String",
		page:"Page",
		twCard:"SeoTwCard",
		ogImage:"ImageUse"
	},
	SeoMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		description:"FieldMeta",
		ogTitle:"FieldMeta",
		ogDescription:"FieldMeta",
		page:"FieldMeta",
		twCard:"FieldMeta",
		ogImage:"FieldMeta"
	},
	Category:{
		_meta:"CategoryMeta",
		id:"UUID",
		name:"String",
		articleCategory:"ArticleCategory",
		url:"Url",
		legacyId:"String",
		articleCategoryByArticle:"ArticleCategory",
		paginateArticleCategory:"ArticleCategoryConnection"
	},
	CategoryMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		articleCategory:"FieldMeta",
		url:"FieldMeta",
		legacyId:"FieldMeta"
	},
	ArticleCategory:{
		_meta:"ArticleCategoryMeta",
		id:"UUID",
		order:"Int",
		article:"Article",
		category:"Category"
	},
	ArticleCategoryMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		article:"FieldMeta",
		category:"FieldMeta"
	},
	ArticleCategoryConnection:{
		pageInfo:"PageInfo",
		edges:"ArticleCategoryEdge"
	},
	ArticleCategoryEdge:{
		node:"ArticleCategory"
	},
	Tag:{
		_meta:"TagMeta",
		id:"UUID",
		name:"String",
		useAsTagline:"Boolean",
		articleTag:"ArticleTag",
		url:"Url",
		order:"String",
		legacyId:"String",
		articleTagByArticle:"ArticleTag",
		paginateArticleTag:"ArticleTagConnection"
	},
	TagMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		useAsTagline:"FieldMeta",
		articleTag:"FieldMeta",
		url:"FieldMeta",
		order:"FieldMeta",
		legacyId:"FieldMeta"
	},
	ArticleTag:{
		_meta:"ArticleTagMeta",
		id:"UUID",
		order:"Int",
		tag:"Tag",
		article:"Article"
	},
	ArticleTagMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		tag:"FieldMeta",
		article:"FieldMeta"
	},
	ArticleTagConnection:{
		pageInfo:"PageInfo",
		edges:"ArticleTagEdge"
	},
	ArticleTagEdge:{
		node:"ArticleTag"
	},
	ArticleAuthor:{
		_meta:"ArticleAuthorMeta",
		id:"UUID",
		order:"Int",
		article:"Article",
		author:"Author",
		legacyStringAuthor:"ArticleAuthorLegacyStringAuthor"
	},
	ArticleAuthorMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		article:"FieldMeta",
		author:"FieldMeta",
		legacyStringAuthor:"FieldMeta"
	},
	TextContent:{
		_meta:"TextContentMeta",
		id:"UUID",
		parts:"TextContentPart",
		partsByReferences:"TextContentPart",
		paginateParts:"TextContentPartConnection"
	},
	TextContentMeta:{
		id:"FieldMeta",
		parts:"FieldMeta"
	},
	TextContentPart:{
		_meta:"TextContentPartMeta",
		id:"UUID",
		order:"Int",
		json:"String",
		content:"TextContent",
		references:"TextContentReference",
		referencesByTarget:"TextContentReference",
		paginateReferences:"TextContentReferenceConnection"
	},
	TextContentPartMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		json:"FieldMeta",
		content:"FieldMeta",
		references:"FieldMeta"
	},
	TextContentReference:{
		_meta:"TextContentReferenceMeta",
		id:"UUID",
		type:"TextContentReferenceType",
		contentPart:"TextContentPart",
		target:"Link"
	},
	TextContentReferenceMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		contentPart:"FieldMeta",
		target:"FieldMeta"
	},
	TextContentReferenceConnection:{
		pageInfo:"PageInfo",
		edges:"TextContentReferenceEdge"
	},
	TextContentReferenceEdge:{
		node:"TextContentReference"
	},
	TextContentPartConnection:{
		pageInfo:"PageInfo",
		edges:"TextContentPartEdge"
	},
	TextContentPartEdge:{
		node:"TextContentPart"
	},
	ArticleHistoryTag:{
		_meta:"ArticleHistoryTagMeta",
		id:"UUID",
		order:"Int",
		article:"Article",
		historyTag:"HistoryTag"
	},
	ArticleHistoryTagMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		article:"FieldMeta",
		historyTag:"FieldMeta"
	},
	HistoryTag:{
		_meta:"HistoryTagMeta",
		id:"UUID",
		name:"String",
		articleHistoryTag:"ArticleHistoryTag",
		slug:"String",
		articleHistoryTagByArticle:"ArticleHistoryTag",
		paginateArticleHistoryTag:"ArticleHistoryTagConnection"
	},
	HistoryTagMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		articleHistoryTag:"FieldMeta",
		slug:"FieldMeta"
	},
	ArticleHistoryTagConnection:{
		pageInfo:"PageInfo",
		edges:"ArticleHistoryTagEdge"
	},
	ArticleHistoryTagEdge:{
		node:"ArticleHistoryTag"
	},
	ArticleHistoryPeriod:{
		_meta:"ArticleHistoryPeriodMeta",
		id:"UUID",
		order:"Int",
		article:"Article",
		historyPeriod:"HistoryPeriod"
	},
	ArticleHistoryPeriodMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		article:"FieldMeta",
		historyPeriod:"FieldMeta"
	},
	HistoryPeriod:{
		_meta:"HistoryPeriodMeta",
		id:"UUID",
		name:"String",
		articleHistoryPeriod:"ArticleHistoryPeriod",
		slug:"String",
		order:"Int",
		cover:"HistoryCover",
		seo:"Seo",
		articleHistoryPeriodByArticle:"ArticleHistoryPeriod",
		paginateArticleHistoryPeriod:"ArticleHistoryPeriodConnection"
	},
	HistoryPeriodMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		articleHistoryPeriod:"FieldMeta",
		slug:"FieldMeta",
		order:"FieldMeta",
		cover:"FieldMeta",
		seo:"FieldMeta"
	},
	HistoryCover:{
		_meta:"HistoryCoverMeta",
		id:"UUID",
		title:"String",
		tileParagraph:"String",
		coverImage:"ImageUse",
		tileImage:"ImageUse",
		mobileImage:"ImageUse",
		leadContent:"Content",
		annotations:"HistoryTextList"
	},
	HistoryCoverMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		tileParagraph:"FieldMeta",
		coverImage:"FieldMeta",
		tileImage:"FieldMeta",
		mobileImage:"FieldMeta",
		leadContent:"FieldMeta",
		annotations:"FieldMeta"
	},
	HistoryTextList:{
		_meta:"HistoryTextListMeta",
		id:"UUID",
		items:"HistoryTextItem",
		itemsByImage:"HistoryTextItem",
		paginateItems:"HistoryTextItemConnection"
	},
	HistoryTextListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	HistoryTextItem:{
		_meta:"HistoryTextItemMeta",
		id:"UUID",
		order:"Int",
		key:"String",
		text:"String",
		list:"HistoryTextList",
		image:"ImageUse"
	},
	HistoryTextItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		key:"FieldMeta",
		text:"FieldMeta",
		list:"FieldMeta",
		image:"FieldMeta"
	},
	HistoryTextItemConnection:{
		pageInfo:"PageInfo",
		edges:"HistoryTextItemEdge"
	},
	HistoryTextItemEdge:{
		node:"HistoryTextItem"
	},
	ArticleHistoryPeriodConnection:{
		pageInfo:"PageInfo",
		edges:"ArticleHistoryPeriodEdge"
	},
	ArticleHistoryPeriodEdge:{
		node:"ArticleHistoryPeriod"
	},
	ArticleAuthorConnection:{
		pageInfo:"PageInfo",
		edges:"ArticleAuthorEdge"
	},
	ArticleAuthorEdge:{
		node:"ArticleAuthor"
	},
	ArticleConnection:{
		pageInfo:"PageInfo",
		edges:"ArticleEdge"
	},
	ArticleEdge:{
		node:"Article"
	},
	_ValidationResult:{
		valid:"Boolean",
		errors:"_ValidationError"
	},
	_ValidationError:{
		path:"_PathFragment",
		message:"_ValidationMessage"
	},
	_PathFragment:{
		"...on _FieldPathFragment":"_FieldPathFragment",
		"...on _IndexPathFragment":"_IndexPathFragment"
	},
	_FieldPathFragment:{
		field:"String"
	},
	_IndexPathFragment:{
		index:"Int",
		alias:"String"
	},
	_ValidationMessage:{
		text:"String"
	},
	ContentConnection:{
		pageInfo:"PageInfo",
		edges:"ContentEdge"
	},
	ContentEdge:{
		node:"Content"
	},
	HomepageArticle:{
		_meta:"HomepageArticleMeta",
		id:"UUID",
		order:"Int",
		tag:"String",
		article:"Article"
	},
	HomepageArticleMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		tag:"FieldMeta",
		article:"FieldMeta"
	},
	HomepageArticleConnection:{
		pageInfo:"PageInfo",
		edges:"HomepageArticleEdge"
	},
	HomepageArticleEdge:{
		node:"HomepageArticle"
	},
	IssueConnection:{
		pageInfo:"PageInfo",
		edges:"IssueEdge"
	},
	IssueEdge:{
		node:"Issue"
	},
	LinkConnection:{
		pageInfo:"PageInfo",
		edges:"LinkEdge"
	},
	LinkEdge:{
		node:"Link"
	},
	TextContentConnection:{
		pageInfo:"PageInfo",
		edges:"TextContentEdge"
	},
	TextContentEdge:{
		node:"TextContent"
	},
	UrlConnection:{
		pageInfo:"PageInfo",
		edges:"UrlEdge"
	},
	UrlEdge:{
		node:"Url"
	},
	CategoryConnection:{
		pageInfo:"PageInfo",
		edges:"CategoryEdge"
	},
	CategoryEdge:{
		node:"Category"
	},
	AudioConnection:{
		pageInfo:"PageInfo",
		edges:"AudioEdge"
	},
	AudioEdge:{
		node:"Audio"
	},
	EmbedConnection:{
		pageInfo:"PageInfo",
		edges:"EmbedEdge"
	},
	EmbedEdge:{
		node:"Embed"
	},
	PollAnswerConnection:{
		pageInfo:"PageInfo",
		edges:"PollAnswerEdge"
	},
	PollAnswerEdge:{
		node:"PollAnswer"
	},
	TagConnection:{
		pageInfo:"PageInfo",
		edges:"TagEdge"
	},
	TagEdge:{
		node:"Tag"
	},
	PageConnection:{
		pageInfo:"PageInfo",
		edges:"PageEdge"
	},
	PageEdge:{
		node:"Page"
	},
	TextTranslation:{
		_meta:"TextTranslationMeta",
		id:"UUID",
		key:"String",
		description:"String",
		value:"String",
		draft:"Boolean"
	},
	TextTranslationMeta:{
		id:"FieldMeta",
		key:"FieldMeta",
		description:"FieldMeta",
		value:"FieldMeta",
		draft:"FieldMeta"
	},
	TextTranslationConnection:{
		pageInfo:"PageInfo",
		edges:"TextTranslationEdge"
	},
	TextTranslationEdge:{
		node:"TextTranslation"
	},
	SeoConnection:{
		pageInfo:"PageInfo",
		edges:"SeoEdge"
	},
	SeoEdge:{
		node:"Seo"
	},
	FileConnection:{
		pageInfo:"PageInfo",
		edges:"FileEdge"
	},
	FileEdge:{
		node:"File"
	},
	Notification:{
		_meta:"NotificationMeta",
		id:"UUID",
		title:"String",
		message:"String",
		sendAt:"DateTime",
		sent:"DateTime"
	},
	NotificationMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		message:"FieldMeta",
		sendAt:"FieldMeta",
		sent:"FieldMeta"
	},
	NotificationConnection:{
		pageInfo:"PageInfo",
		edges:"NotificationEdge"
	},
	NotificationEdge:{
		node:"Notification"
	},
	SubscriptionFormConnection:{
		pageInfo:"PageInfo",
		edges:"SubscriptionFormEdge"
	},
	SubscriptionFormEdge:{
		node:"SubscriptionForm"
	},
	HistoryTagConnection:{
		pageInfo:"PageInfo",
		edges:"HistoryTagEdge"
	},
	HistoryTagEdge:{
		node:"HistoryTag"
	},
	HistoryPeriodConnection:{
		pageInfo:"PageInfo",
		edges:"HistoryPeriodEdge"
	},
	HistoryPeriodEdge:{
		node:"HistoryPeriod"
	},
	HistoryHomePage:{
		_meta:"HistoryHomePageMeta",
		id:"UUID",
		unique:"HistoryHomePageUnique",
		timePeriodTitle:"String",
		personalitiesTitle:"String",
		cover:"HistoryCover",
		seo:"Seo",
		slug:"String"
	},
	HistoryHomePageMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		timePeriodTitle:"FieldMeta",
		personalitiesTitle:"FieldMeta",
		cover:"FieldMeta",
		seo:"FieldMeta",
		slug:"FieldMeta"
	},
	HistoryHomePageConnection:{
		pageInfo:"PageInfo",
		edges:"HistoryHomePageEdge"
	},
	HistoryHomePageEdge:{
		node:"HistoryHomePage"
	},
	HistoryCoverConnection:{
		pageInfo:"PageInfo",
		edges:"HistoryCoverEdge"
	},
	HistoryCoverEdge:{
		node:"HistoryCover"
	},
	HistoryTextListConnection:{
		pageInfo:"PageInfo",
		edges:"HistoryTextListEdge"
	},
	HistoryTextListEdge:{
		node:"HistoryTextList"
	},
	FooterMenu:{
		_meta:"FooterMenuMeta",
		id:"UUID",
		unique:"FooterMenuUnique",
		copyright:"String",
		online:"OnlineSection",
		links:"LinkSection",
		linksTwo:"LinkSection",
		social:"SocialSection",
		newsletter:"NewsletterSection"
	},
	FooterMenuMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		copyright:"FieldMeta",
		online:"FieldMeta",
		links:"FieldMeta",
		linksTwo:"FieldMeta",
		social:"FieldMeta",
		newsletter:"FieldMeta"
	},
	OnlineSection:{
		_meta:"OnlineSectionMeta",
		id:"UUID",
		title:"String",
		appLinks:"AppLinkList",
		links:"LinkList"
	},
	OnlineSectionMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		appLinks:"FieldMeta",
		links:"FieldMeta"
	},
	AppLinkList:{
		_meta:"AppLinkListMeta",
		id:"UUID",
		items:"AppLinkItem",
		itemsByAppLink:"AppLinkItem",
		paginateItems:"AppLinkItemConnection"
	},
	AppLinkListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	AppLinkItem:{
		_meta:"AppLinkItemMeta",
		id:"UUID",
		order:"Int",
		list:"AppLinkList",
		appLink:"AppLink"
	},
	AppLinkItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		appLink:"FieldMeta"
	},
	AppLink:{
		_meta:"AppLinkMeta",
		id:"UUID",
		type:"AppLinkType",
		url:"String"
	},
	AppLinkMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		url:"FieldMeta"
	},
	AppLinkItemConnection:{
		pageInfo:"PageInfo",
		edges:"AppLinkItemEdge"
	},
	AppLinkItemEdge:{
		node:"AppLinkItem"
	},
	LinkList:{
		_meta:"LinkListMeta",
		id:"UUID",
		items:"LinkItem",
		paginateItems:"LinkItemConnection"
	},
	LinkListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	LinkItem:{
		_meta:"LinkItemMeta",
		id:"UUID",
		order:"Int",
		list:"LinkList",
		link:"Link",
		title:"String"
	},
	LinkItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		link:"FieldMeta",
		title:"FieldMeta"
	},
	LinkItemConnection:{
		pageInfo:"PageInfo",
		edges:"LinkItemEdge"
	},
	LinkItemEdge:{
		node:"LinkItem"
	},
	LinkSection:{
		_meta:"LinkSectionMeta",
		id:"UUID",
		title:"String",
		links:"LinkList"
	},
	LinkSectionMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		links:"FieldMeta"
	},
	SocialSection:{
		_meta:"SocialSectionMeta",
		id:"UUID",
		title:"String",
		socialLinks:"SocialLinkList"
	},
	SocialSectionMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		socialLinks:"FieldMeta"
	},
	SocialLinkList:{
		_meta:"SocialLinkListMeta",
		id:"UUID",
		items:"SocialLinkItem",
		itemsBySocialLink:"SocialLinkItem",
		paginateItems:"SocialLinkItemConnection"
	},
	SocialLinkListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	SocialLinkItem:{
		_meta:"SocialLinkItemMeta",
		id:"UUID",
		order:"Int",
		list:"SocialLinkList",
		socialLink:"SocialLink"
	},
	SocialLinkItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		socialLink:"FieldMeta"
	},
	SocialLink:{
		_meta:"SocialLinkMeta",
		id:"UUID",
		type:"SocialLinkType",
		url:"String"
	},
	SocialLinkMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		url:"FieldMeta"
	},
	SocialLinkItemConnection:{
		pageInfo:"PageInfo",
		edges:"SocialLinkItemEdge"
	},
	SocialLinkItemEdge:{
		node:"SocialLinkItem"
	},
	NewsletterSection:{
		_meta:"NewsletterSectionMeta",
		id:"UUID",
		title:"String",
		newsletter:"Newsletter"
	},
	NewsletterSectionMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		newsletter:"FieldMeta"
	},
	Newsletter:{
		_meta:"NewsletterMeta",
		id:"UUID",
		input:"String",
		button:"String"
	},
	NewsletterMeta:{
		id:"FieldMeta",
		input:"FieldMeta",
		button:"FieldMeta"
	},
	FooterMenuConnection:{
		pageInfo:"PageInfo",
		edges:"FooterMenuEdge"
	},
	FooterMenuEdge:{
		node:"FooterMenu"
	},
	LinkSectionConnection:{
		pageInfo:"PageInfo",
		edges:"LinkSectionEdge"
	},
	LinkSectionEdge:{
		node:"LinkSection"
	},
	LinkListConnection:{
		pageInfo:"PageInfo",
		edges:"LinkListEdge"
	},
	LinkListEdge:{
		node:"LinkList"
	},
	NewsletterSectionConnection:{
		pageInfo:"PageInfo",
		edges:"NewsletterSectionEdge"
	},
	NewsletterSectionEdge:{
		node:"NewsletterSection"
	},
	NewsletterConnection:{
		pageInfo:"PageInfo",
		edges:"NewsletterEdge"
	},
	NewsletterEdge:{
		node:"Newsletter"
	},
	OnlineSectionConnection:{
		pageInfo:"PageInfo",
		edges:"OnlineSectionEdge"
	},
	OnlineSectionEdge:{
		node:"OnlineSection"
	},
	AppLinkConnection:{
		pageInfo:"PageInfo",
		edges:"AppLinkEdge"
	},
	AppLinkEdge:{
		node:"AppLink"
	},
	AppLinkListConnection:{
		pageInfo:"PageInfo",
		edges:"AppLinkListEdge"
	},
	AppLinkListEdge:{
		node:"AppLinkList"
	},
	SocialSectionConnection:{
		pageInfo:"PageInfo",
		edges:"SocialSectionEdge"
	},
	SocialSectionEdge:{
		node:"SocialSection"
	},
	SocialLinkConnection:{
		pageInfo:"PageInfo",
		edges:"SocialLinkEdge"
	},
	SocialLinkEdge:{
		node:"SocialLink"
	},
	SocialLinkListConnection:{
		pageInfo:"PageInfo",
		edges:"SocialLinkListEdge"
	},
	SocialLinkListEdge:{
		node:"SocialLinkList"
	},
	SharedContentConnection:{
		pageInfo:"PageInfo",
		edges:"SharedContentEdge"
	},
	SharedContentEdge:{
		node:"SharedContent"
	},
	QueryTransaction:{
		getArticle:"Article",
		listArticle:"Article",
		paginateArticle:"ArticleConnection",
		validateCreateArticle:"_ValidationResult",
		validateUpdateArticle:"_ValidationResult",
		getArticleAuthor:"ArticleAuthor",
		listArticleAuthor:"ArticleAuthor",
		paginateArticleAuthor:"ArticleAuthorConnection",
		validateCreateArticleAuthor:"_ValidationResult",
		validateUpdateArticleAuthor:"_ValidationResult",
		getAuthor:"Author",
		listAuthor:"Author",
		paginateAuthor:"AuthorConnection",
		validateCreateAuthor:"_ValidationResult",
		validateUpdateAuthor:"_ValidationResult",
		getAuthorTopArticle:"AuthorTopArticle",
		listAuthorTopArticle:"AuthorTopArticle",
		paginateAuthorTopArticle:"AuthorTopArticleConnection",
		validateCreateAuthorTopArticle:"_ValidationResult",
		validateUpdateAuthorTopArticle:"_ValidationResult",
		getContent:"Content",
		listContent:"Content",
		paginateContent:"ContentConnection",
		validateCreateContent:"_ValidationResult",
		validateUpdateContent:"_ValidationResult",
		getContentPart:"ContentPart",
		listContentPart:"ContentPart",
		paginateContentPart:"ContentPartConnection",
		validateCreateContentPart:"_ValidationResult",
		validateUpdateContentPart:"_ValidationResult",
		getContentReference:"ContentReference",
		listContentReference:"ContentReference",
		paginateContentReference:"ContentReferenceConnection",
		validateCreateContentReference:"_ValidationResult",
		validateUpdateContentReference:"_ValidationResult",
		getHomepageArticle:"HomepageArticle",
		listHomepageArticle:"HomepageArticle",
		paginateHomepageArticle:"HomepageArticleConnection",
		validateCreateHomepageArticle:"_ValidationResult",
		validateUpdateHomepageArticle:"_ValidationResult",
		getImage:"Image",
		listImage:"Image",
		paginateImage:"ImageConnection",
		validateCreateImage:"_ValidationResult",
		validateUpdateImage:"_ValidationResult",
		getImageUse:"ImageUse",
		listImageUse:"ImageUse",
		paginateImageUse:"ImageUseConnection",
		validateCreateImageUse:"_ValidationResult",
		validateUpdateImageUse:"_ValidationResult",
		getImageTag:"ImageTag",
		listImageTag:"ImageTag",
		paginateImageTag:"ImageTagConnection",
		validateCreateImageTag:"_ValidationResult",
		validateUpdateImageTag:"_ValidationResult",
		getIssue:"Issue",
		listIssue:"Issue",
		paginateIssue:"IssueConnection",
		validateCreateIssue:"_ValidationResult",
		validateUpdateIssue:"_ValidationResult",
		getIssueArticle:"IssueArticle",
		listIssueArticle:"IssueArticle",
		paginateIssueArticle:"IssueArticleConnection",
		validateCreateIssueArticle:"_ValidationResult",
		validateUpdateIssueArticle:"_ValidationResult",
		getLink:"Link",
		listLink:"Link",
		paginateLink:"LinkConnection",
		validateCreateLink:"_ValidationResult",
		validateUpdateLink:"_ValidationResult",
		getTextContent:"TextContent",
		listTextContent:"TextContent",
		paginateTextContent:"TextContentConnection",
		validateCreateTextContent:"_ValidationResult",
		validateUpdateTextContent:"_ValidationResult",
		getTextContentPart:"TextContentPart",
		listTextContentPart:"TextContentPart",
		paginateTextContentPart:"TextContentPartConnection",
		validateCreateTextContentPart:"_ValidationResult",
		validateUpdateTextContentPart:"_ValidationResult",
		getTextContentReference:"TextContentReference",
		listTextContentReference:"TextContentReference",
		paginateTextContentReference:"TextContentReferenceConnection",
		validateCreateTextContentReference:"_ValidationResult",
		validateUpdateTextContentReference:"_ValidationResult",
		getUrl:"Url",
		listUrl:"Url",
		paginateUrl:"UrlConnection",
		validateCreateUrl:"_ValidationResult",
		validateUpdateUrl:"_ValidationResult",
		getArticleTag:"ArticleTag",
		listArticleTag:"ArticleTag",
		paginateArticleTag:"ArticleTagConnection",
		validateCreateArticleTag:"_ValidationResult",
		validateUpdateArticleTag:"_ValidationResult",
		getCategory:"Category",
		listCategory:"Category",
		paginateCategory:"CategoryConnection",
		validateCreateCategory:"_ValidationResult",
		validateUpdateCategory:"_ValidationResult",
		getArticleCategory:"ArticleCategory",
		listArticleCategory:"ArticleCategory",
		paginateArticleCategory:"ArticleCategoryConnection",
		validateCreateArticleCategory:"_ValidationResult",
		validateUpdateArticleCategory:"_ValidationResult",
		getAudio:"Audio",
		listAudio:"Audio",
		paginateAudio:"AudioConnection",
		validateCreateAudio:"_ValidationResult",
		validateUpdateAudio:"_ValidationResult",
		getAudioUse:"AudioUse",
		listAudioUse:"AudioUse",
		paginateAudioUse:"AudioUseConnection",
		validateCreateAudioUse:"_ValidationResult",
		validateUpdateAudioUse:"_ValidationResult",
		getEmbed:"Embed",
		listEmbed:"Embed",
		paginateEmbed:"EmbedConnection",
		validateCreateEmbed:"_ValidationResult",
		validateUpdateEmbed:"_ValidationResult",
		getImageContent:"ImageContent",
		listImageContent:"ImageContent",
		paginateImageContent:"ImageContentConnection",
		validateCreateImageContent:"_ValidationResult",
		validateUpdateImageContent:"_ValidationResult",
		getListicle:"Listicle",
		listListicle:"Listicle",
		paginateListicle:"ListicleConnection",
		validateCreateListicle:"_ValidationResult",
		validateUpdateListicle:"_ValidationResult",
		getPollAnswer:"PollAnswer",
		listPollAnswer:"PollAnswer",
		paginatePollAnswer:"PollAnswerConnection",
		validateCreatePollAnswer:"_ValidationResult",
		validateUpdatePollAnswer:"_ValidationResult",
		getTag:"Tag",
		listTag:"Tag",
		paginateTag:"TagConnection",
		validateCreateTag:"_ValidationResult",
		validateUpdateTag:"_ValidationResult",
		getFAQ:"FAQ",
		listFAQ:"FAQ",
		paginateFAQ:"FAQConnection",
		validateCreateFAQ:"_ValidationResult",
		validateUpdateFAQ:"_ValidationResult",
		getLinkContent:"LinkContent",
		listLinkContent:"LinkContent",
		paginateLinkContent:"LinkContentConnection",
		validateCreateLinkContent:"_ValidationResult",
		validateUpdateLinkContent:"_ValidationResult",
		getAwardContent:"AwardContent",
		listAwardContent:"AwardContent",
		paginateAwardContent:"AwardContentConnection",
		validateCreateAwardContent:"_ValidationResult",
		validateUpdateAwardContent:"_ValidationResult",
		getReviewContent:"ReviewContent",
		listReviewContent:"ReviewContent",
		paginateReviewContent:"ReviewContentConnection",
		validateCreateReviewContent:"_ValidationResult",
		validateUpdateReviewContent:"_ValidationResult",
		getPage:"Page",
		listPage:"Page",
		paginatePage:"PageConnection",
		validateCreatePage:"_ValidationResult",
		validateUpdatePage:"_ValidationResult",
		getTextTranslation:"TextTranslation",
		listTextTranslation:"TextTranslation",
		paginateTextTranslation:"TextTranslationConnection",
		validateCreateTextTranslation:"_ValidationResult",
		validateUpdateTextTranslation:"_ValidationResult",
		getSeo:"Seo",
		listSeo:"Seo",
		paginateSeo:"SeoConnection",
		validateCreateSeo:"_ValidationResult",
		validateUpdateSeo:"_ValidationResult",
		getFile:"File",
		listFile:"File",
		paginateFile:"FileConnection",
		validateCreateFile:"_ValidationResult",
		validateUpdateFile:"_ValidationResult",
		getFileUse:"FileUse",
		listFileUse:"FileUse",
		paginateFileUse:"FileUseConnection",
		validateCreateFileUse:"_ValidationResult",
		validateUpdateFileUse:"_ValidationResult",
		getContentBlock:"ContentBlock",
		listContentBlock:"ContentBlock",
		paginateContentBlock:"ContentBlockConnection",
		validateCreateContentBlock:"_ValidationResult",
		validateUpdateContentBlock:"_ValidationResult",
		getContentArticle:"ContentArticle",
		listContentArticle:"ContentArticle",
		paginateContentArticle:"ContentArticleConnection",
		validateCreateContentArticle:"_ValidationResult",
		validateUpdateContentArticle:"_ValidationResult",
		getUnlockedArticle:"UnlockedArticle",
		listUnlockedArticle:"UnlockedArticle",
		paginateUnlockedArticle:"UnlockedArticleConnection",
		validateCreateUnlockedArticle:"_ValidationResult",
		validateUpdateUnlockedArticle:"_ValidationResult",
		getUser:"User",
		listUser:"User",
		paginateUser:"UserConnection",
		validateCreateUser:"_ValidationResult",
		validateUpdateUser:"_ValidationResult",
		getNotification:"Notification",
		listNotification:"Notification",
		paginateNotification:"NotificationConnection",
		validateCreateNotification:"_ValidationResult",
		validateUpdateNotification:"_ValidationResult",
		getAppReview:"AppReview",
		listAppReview:"AppReview",
		paginateAppReview:"AppReviewConnection",
		validateCreateAppReview:"_ValidationResult",
		validateUpdateAppReview:"_ValidationResult",
		getProduct:"Product",
		listProduct:"Product",
		paginateProduct:"ProductConnection",
		validateCreateProduct:"_ValidationResult",
		validateUpdateProduct:"_ValidationResult",
		getSubscriptionForm:"SubscriptionForm",
		listSubscriptionForm:"SubscriptionForm",
		paginateSubscriptionForm:"SubscriptionFormConnection",
		validateCreateSubscriptionForm:"_ValidationResult",
		validateUpdateSubscriptionForm:"_ValidationResult",
		getSubscriptionFormSection:"SubscriptionFormSection",
		listSubscriptionFormSection:"SubscriptionFormSection",
		paginateSubscriptionFormSection:"SubscriptionFormSectionConnection",
		validateCreateSubscriptionFormSection:"_ValidationResult",
		validateUpdateSubscriptionFormSection:"_ValidationResult",
		getSubscriptionFormInput:"SubscriptionFormInput",
		listSubscriptionFormInput:"SubscriptionFormInput",
		paginateSubscriptionFormInput:"SubscriptionFormInputConnection",
		validateCreateSubscriptionFormInput:"_ValidationResult",
		validateUpdateSubscriptionFormInput:"_ValidationResult",
		getSubscriptionFormOption:"SubscriptionFormOption",
		listSubscriptionFormOption:"SubscriptionFormOption",
		paginateSubscriptionFormOption:"SubscriptionFormOptionConnection",
		validateCreateSubscriptionFormOption:"_ValidationResult",
		validateUpdateSubscriptionFormOption:"_ValidationResult",
		getButton:"Button",
		listButton:"Button",
		paginateButton:"ButtonConnection",
		validateCreateButton:"_ValidationResult",
		validateUpdateButton:"_ValidationResult",
		getArticleHistoryTag:"ArticleHistoryTag",
		listArticleHistoryTag:"ArticleHistoryTag",
		paginateArticleHistoryTag:"ArticleHistoryTagConnection",
		validateCreateArticleHistoryTag:"_ValidationResult",
		validateUpdateArticleHistoryTag:"_ValidationResult",
		getArticleHistoryPeriod:"ArticleHistoryPeriod",
		listArticleHistoryPeriod:"ArticleHistoryPeriod",
		paginateArticleHistoryPeriod:"ArticleHistoryPeriodConnection",
		validateCreateArticleHistoryPeriod:"_ValidationResult",
		validateUpdateArticleHistoryPeriod:"_ValidationResult",
		getHistoryTag:"HistoryTag",
		listHistoryTag:"HistoryTag",
		paginateHistoryTag:"HistoryTagConnection",
		validateCreateHistoryTag:"_ValidationResult",
		validateUpdateHistoryTag:"_ValidationResult",
		getHistoryPeriod:"HistoryPeriod",
		listHistoryPeriod:"HistoryPeriod",
		paginateHistoryPeriod:"HistoryPeriodConnection",
		validateCreateHistoryPeriod:"_ValidationResult",
		validateUpdateHistoryPeriod:"_ValidationResult",
		getHistoryHomePage:"HistoryHomePage",
		listHistoryHomePage:"HistoryHomePage",
		paginateHistoryHomePage:"HistoryHomePageConnection",
		validateCreateHistoryHomePage:"_ValidationResult",
		validateUpdateHistoryHomePage:"_ValidationResult",
		getHistoryCover:"HistoryCover",
		listHistoryCover:"HistoryCover",
		paginateHistoryCover:"HistoryCoverConnection",
		validateCreateHistoryCover:"_ValidationResult",
		validateUpdateHistoryCover:"_ValidationResult",
		getHistoryTextList:"HistoryTextList",
		listHistoryTextList:"HistoryTextList",
		paginateHistoryTextList:"HistoryTextListConnection",
		validateCreateHistoryTextList:"_ValidationResult",
		validateUpdateHistoryTextList:"_ValidationResult",
		getHistoryTextItem:"HistoryTextItem",
		listHistoryTextItem:"HistoryTextItem",
		paginateHistoryTextItem:"HistoryTextItemConnection",
		validateCreateHistoryTextItem:"_ValidationResult",
		validateUpdateHistoryTextItem:"_ValidationResult",
		getFooterMenu:"FooterMenu",
		listFooterMenu:"FooterMenu",
		paginateFooterMenu:"FooterMenuConnection",
		validateCreateFooterMenu:"_ValidationResult",
		validateUpdateFooterMenu:"_ValidationResult",
		getLinkSection:"LinkSection",
		listLinkSection:"LinkSection",
		paginateLinkSection:"LinkSectionConnection",
		validateCreateLinkSection:"_ValidationResult",
		validateUpdateLinkSection:"_ValidationResult",
		getLinkList:"LinkList",
		listLinkList:"LinkList",
		paginateLinkList:"LinkListConnection",
		validateCreateLinkList:"_ValidationResult",
		validateUpdateLinkList:"_ValidationResult",
		getLinkItem:"LinkItem",
		listLinkItem:"LinkItem",
		paginateLinkItem:"LinkItemConnection",
		validateCreateLinkItem:"_ValidationResult",
		validateUpdateLinkItem:"_ValidationResult",
		getNewsletterSection:"NewsletterSection",
		listNewsletterSection:"NewsletterSection",
		paginateNewsletterSection:"NewsletterSectionConnection",
		validateCreateNewsletterSection:"_ValidationResult",
		validateUpdateNewsletterSection:"_ValidationResult",
		getNewsletter:"Newsletter",
		listNewsletter:"Newsletter",
		paginateNewsletter:"NewsletterConnection",
		validateCreateNewsletter:"_ValidationResult",
		validateUpdateNewsletter:"_ValidationResult",
		getOnlineSection:"OnlineSection",
		listOnlineSection:"OnlineSection",
		paginateOnlineSection:"OnlineSectionConnection",
		validateCreateOnlineSection:"_ValidationResult",
		validateUpdateOnlineSection:"_ValidationResult",
		getAppLink:"AppLink",
		listAppLink:"AppLink",
		paginateAppLink:"AppLinkConnection",
		validateCreateAppLink:"_ValidationResult",
		validateUpdateAppLink:"_ValidationResult",
		getAppLinkList:"AppLinkList",
		listAppLinkList:"AppLinkList",
		paginateAppLinkList:"AppLinkListConnection",
		validateCreateAppLinkList:"_ValidationResult",
		validateUpdateAppLinkList:"_ValidationResult",
		getAppLinkItem:"AppLinkItem",
		listAppLinkItem:"AppLinkItem",
		paginateAppLinkItem:"AppLinkItemConnection",
		validateCreateAppLinkItem:"_ValidationResult",
		validateUpdateAppLinkItem:"_ValidationResult",
		getSocialSection:"SocialSection",
		listSocialSection:"SocialSection",
		paginateSocialSection:"SocialSectionConnection",
		validateCreateSocialSection:"_ValidationResult",
		validateUpdateSocialSection:"_ValidationResult",
		getSocialLink:"SocialLink",
		listSocialLink:"SocialLink",
		paginateSocialLink:"SocialLinkConnection",
		validateCreateSocialLink:"_ValidationResult",
		validateUpdateSocialLink:"_ValidationResult",
		getSocialLinkList:"SocialLinkList",
		listSocialLinkList:"SocialLinkList",
		paginateSocialLinkList:"SocialLinkListConnection",
		validateCreateSocialLinkList:"_ValidationResult",
		validateUpdateSocialLinkList:"_ValidationResult",
		getSocialLinkItem:"SocialLinkItem",
		listSocialLinkItem:"SocialLinkItem",
		paginateSocialLinkItem:"SocialLinkItemConnection",
		validateCreateSocialLinkItem:"_ValidationResult",
		validateUpdateSocialLinkItem:"_ValidationResult",
		getSharedContent:"SharedContent",
		listSharedContent:"SharedContent",
		paginateSharedContent:"SharedContentConnection",
		validateCreateSharedContent:"_ValidationResult",
		validateUpdateSharedContent:"_ValidationResult"
	},
	Info:{
		description:"String"
	},
	Mutation:{
		createArticle:"ArticleCreateResult",
		deleteArticle:"ArticleDeleteResult",
		updateArticle:"ArticleUpdateResult",
		upsertArticle:"ArticleUpsertResult",
		createArticleAuthor:"ArticleAuthorCreateResult",
		deleteArticleAuthor:"ArticleAuthorDeleteResult",
		updateArticleAuthor:"ArticleAuthorUpdateResult",
		upsertArticleAuthor:"ArticleAuthorUpsertResult",
		createAuthor:"AuthorCreateResult",
		deleteAuthor:"AuthorDeleteResult",
		updateAuthor:"AuthorUpdateResult",
		upsertAuthor:"AuthorUpsertResult",
		createAuthorTopArticle:"AuthorTopArticleCreateResult",
		deleteAuthorTopArticle:"AuthorTopArticleDeleteResult",
		updateAuthorTopArticle:"AuthorTopArticleUpdateResult",
		upsertAuthorTopArticle:"AuthorTopArticleUpsertResult",
		createContent:"ContentCreateResult",
		deleteContent:"ContentDeleteResult",
		updateContent:"ContentUpdateResult",
		upsertContent:"ContentUpsertResult",
		createContentPart:"ContentPartCreateResult",
		deleteContentPart:"ContentPartDeleteResult",
		updateContentPart:"ContentPartUpdateResult",
		upsertContentPart:"ContentPartUpsertResult",
		createContentReference:"ContentReferenceCreateResult",
		deleteContentReference:"ContentReferenceDeleteResult",
		updateContentReference:"ContentReferenceUpdateResult",
		upsertContentReference:"ContentReferenceUpsertResult",
		createHomepageArticle:"HomepageArticleCreateResult",
		deleteHomepageArticle:"HomepageArticleDeleteResult",
		updateHomepageArticle:"HomepageArticleUpdateResult",
		upsertHomepageArticle:"HomepageArticleUpsertResult",
		createImage:"ImageCreateResult",
		deleteImage:"ImageDeleteResult",
		updateImage:"ImageUpdateResult",
		upsertImage:"ImageUpsertResult",
		createImageUse:"ImageUseCreateResult",
		deleteImageUse:"ImageUseDeleteResult",
		updateImageUse:"ImageUseUpdateResult",
		upsertImageUse:"ImageUseUpsertResult",
		createImageTag:"ImageTagCreateResult",
		deleteImageTag:"ImageTagDeleteResult",
		updateImageTag:"ImageTagUpdateResult",
		upsertImageTag:"ImageTagUpsertResult",
		createIssue:"IssueCreateResult",
		deleteIssue:"IssueDeleteResult",
		updateIssue:"IssueUpdateResult",
		upsertIssue:"IssueUpsertResult",
		createIssueArticle:"IssueArticleCreateResult",
		deleteIssueArticle:"IssueArticleDeleteResult",
		updateIssueArticle:"IssueArticleUpdateResult",
		upsertIssueArticle:"IssueArticleUpsertResult",
		createLink:"LinkCreateResult",
		deleteLink:"LinkDeleteResult",
		updateLink:"LinkUpdateResult",
		upsertLink:"LinkUpsertResult",
		createTextContent:"TextContentCreateResult",
		deleteTextContent:"TextContentDeleteResult",
		updateTextContent:"TextContentUpdateResult",
		upsertTextContent:"TextContentUpsertResult",
		createTextContentPart:"TextContentPartCreateResult",
		deleteTextContentPart:"TextContentPartDeleteResult",
		updateTextContentPart:"TextContentPartUpdateResult",
		upsertTextContentPart:"TextContentPartUpsertResult",
		createTextContentReference:"TextContentReferenceCreateResult",
		deleteTextContentReference:"TextContentReferenceDeleteResult",
		updateTextContentReference:"TextContentReferenceUpdateResult",
		upsertTextContentReference:"TextContentReferenceUpsertResult",
		createUrl:"UrlCreateResult",
		deleteUrl:"UrlDeleteResult",
		updateUrl:"UrlUpdateResult",
		upsertUrl:"UrlUpsertResult",
		createArticleTag:"ArticleTagCreateResult",
		deleteArticleTag:"ArticleTagDeleteResult",
		updateArticleTag:"ArticleTagUpdateResult",
		upsertArticleTag:"ArticleTagUpsertResult",
		createCategory:"CategoryCreateResult",
		deleteCategory:"CategoryDeleteResult",
		updateCategory:"CategoryUpdateResult",
		upsertCategory:"CategoryUpsertResult",
		createArticleCategory:"ArticleCategoryCreateResult",
		deleteArticleCategory:"ArticleCategoryDeleteResult",
		updateArticleCategory:"ArticleCategoryUpdateResult",
		upsertArticleCategory:"ArticleCategoryUpsertResult",
		createAudio:"AudioCreateResult",
		deleteAudio:"AudioDeleteResult",
		updateAudio:"AudioUpdateResult",
		upsertAudio:"AudioUpsertResult",
		createAudioUse:"AudioUseCreateResult",
		deleteAudioUse:"AudioUseDeleteResult",
		updateAudioUse:"AudioUseUpdateResult",
		upsertAudioUse:"AudioUseUpsertResult",
		createEmbed:"EmbedCreateResult",
		deleteEmbed:"EmbedDeleteResult",
		updateEmbed:"EmbedUpdateResult",
		upsertEmbed:"EmbedUpsertResult",
		createImageContent:"ImageContentCreateResult",
		deleteImageContent:"ImageContentDeleteResult",
		updateImageContent:"ImageContentUpdateResult",
		upsertImageContent:"ImageContentUpsertResult",
		createListicle:"ListicleCreateResult",
		deleteListicle:"ListicleDeleteResult",
		updateListicle:"ListicleUpdateResult",
		upsertListicle:"ListicleUpsertResult",
		createPollAnswer:"PollAnswerCreateResult",
		deletePollAnswer:"PollAnswerDeleteResult",
		updatePollAnswer:"PollAnswerUpdateResult",
		upsertPollAnswer:"PollAnswerUpsertResult",
		createTag:"TagCreateResult",
		deleteTag:"TagDeleteResult",
		updateTag:"TagUpdateResult",
		upsertTag:"TagUpsertResult",
		createFAQ:"FAQCreateResult",
		deleteFAQ:"FAQDeleteResult",
		updateFAQ:"FAQUpdateResult",
		upsertFAQ:"FAQUpsertResult",
		createLinkContent:"LinkContentCreateResult",
		deleteLinkContent:"LinkContentDeleteResult",
		updateLinkContent:"LinkContentUpdateResult",
		upsertLinkContent:"LinkContentUpsertResult",
		createAwardContent:"AwardContentCreateResult",
		deleteAwardContent:"AwardContentDeleteResult",
		updateAwardContent:"AwardContentUpdateResult",
		upsertAwardContent:"AwardContentUpsertResult",
		createReviewContent:"ReviewContentCreateResult",
		deleteReviewContent:"ReviewContentDeleteResult",
		updateReviewContent:"ReviewContentUpdateResult",
		upsertReviewContent:"ReviewContentUpsertResult",
		createPage:"PageCreateResult",
		deletePage:"PageDeleteResult",
		updatePage:"PageUpdateResult",
		upsertPage:"PageUpsertResult",
		createTextTranslation:"TextTranslationCreateResult",
		deleteTextTranslation:"TextTranslationDeleteResult",
		updateTextTranslation:"TextTranslationUpdateResult",
		upsertTextTranslation:"TextTranslationUpsertResult",
		createSeo:"SeoCreateResult",
		deleteSeo:"SeoDeleteResult",
		updateSeo:"SeoUpdateResult",
		upsertSeo:"SeoUpsertResult",
		createFile:"FileCreateResult",
		deleteFile:"FileDeleteResult",
		updateFile:"FileUpdateResult",
		upsertFile:"FileUpsertResult",
		createFileUse:"FileUseCreateResult",
		deleteFileUse:"FileUseDeleteResult",
		updateFileUse:"FileUseUpdateResult",
		upsertFileUse:"FileUseUpsertResult",
		createContentBlock:"ContentBlockCreateResult",
		deleteContentBlock:"ContentBlockDeleteResult",
		updateContentBlock:"ContentBlockUpdateResult",
		upsertContentBlock:"ContentBlockUpsertResult",
		createContentArticle:"ContentArticleCreateResult",
		deleteContentArticle:"ContentArticleDeleteResult",
		updateContentArticle:"ContentArticleUpdateResult",
		upsertContentArticle:"ContentArticleUpsertResult",
		createUnlockedArticle:"UnlockedArticleCreateResult",
		deleteUnlockedArticle:"UnlockedArticleDeleteResult",
		updateUnlockedArticle:"UnlockedArticleUpdateResult",
		upsertUnlockedArticle:"UnlockedArticleUpsertResult",
		createUser:"UserCreateResult",
		deleteUser:"UserDeleteResult",
		updateUser:"UserUpdateResult",
		upsertUser:"UserUpsertResult",
		createNotification:"NotificationCreateResult",
		deleteNotification:"NotificationDeleteResult",
		updateNotification:"NotificationUpdateResult",
		upsertNotification:"NotificationUpsertResult",
		createAppReview:"AppReviewCreateResult",
		deleteAppReview:"AppReviewDeleteResult",
		updateAppReview:"AppReviewUpdateResult",
		upsertAppReview:"AppReviewUpsertResult",
		createProduct:"ProductCreateResult",
		deleteProduct:"ProductDeleteResult",
		updateProduct:"ProductUpdateResult",
		upsertProduct:"ProductUpsertResult",
		createSubscriptionForm:"SubscriptionFormCreateResult",
		deleteSubscriptionForm:"SubscriptionFormDeleteResult",
		updateSubscriptionForm:"SubscriptionFormUpdateResult",
		upsertSubscriptionForm:"SubscriptionFormUpsertResult",
		createSubscriptionFormSection:"SubscriptionFormSectionCreateResult",
		deleteSubscriptionFormSection:"SubscriptionFormSectionDeleteResult",
		updateSubscriptionFormSection:"SubscriptionFormSectionUpdateResult",
		upsertSubscriptionFormSection:"SubscriptionFormSectionUpsertResult",
		createSubscriptionFormInput:"SubscriptionFormInputCreateResult",
		deleteSubscriptionFormInput:"SubscriptionFormInputDeleteResult",
		updateSubscriptionFormInput:"SubscriptionFormInputUpdateResult",
		upsertSubscriptionFormInput:"SubscriptionFormInputUpsertResult",
		createSubscriptionFormOption:"SubscriptionFormOptionCreateResult",
		deleteSubscriptionFormOption:"SubscriptionFormOptionDeleteResult",
		updateSubscriptionFormOption:"SubscriptionFormOptionUpdateResult",
		upsertSubscriptionFormOption:"SubscriptionFormOptionUpsertResult",
		createButton:"ButtonCreateResult",
		deleteButton:"ButtonDeleteResult",
		updateButton:"ButtonUpdateResult",
		upsertButton:"ButtonUpsertResult",
		createArticleHistoryTag:"ArticleHistoryTagCreateResult",
		deleteArticleHistoryTag:"ArticleHistoryTagDeleteResult",
		updateArticleHistoryTag:"ArticleHistoryTagUpdateResult",
		upsertArticleHistoryTag:"ArticleHistoryTagUpsertResult",
		createArticleHistoryPeriod:"ArticleHistoryPeriodCreateResult",
		deleteArticleHistoryPeriod:"ArticleHistoryPeriodDeleteResult",
		updateArticleHistoryPeriod:"ArticleHistoryPeriodUpdateResult",
		upsertArticleHistoryPeriod:"ArticleHistoryPeriodUpsertResult",
		createHistoryTag:"HistoryTagCreateResult",
		deleteHistoryTag:"HistoryTagDeleteResult",
		updateHistoryTag:"HistoryTagUpdateResult",
		upsertHistoryTag:"HistoryTagUpsertResult",
		createHistoryPeriod:"HistoryPeriodCreateResult",
		deleteHistoryPeriod:"HistoryPeriodDeleteResult",
		updateHistoryPeriod:"HistoryPeriodUpdateResult",
		upsertHistoryPeriod:"HistoryPeriodUpsertResult",
		createHistoryHomePage:"HistoryHomePageCreateResult",
		deleteHistoryHomePage:"HistoryHomePageDeleteResult",
		updateHistoryHomePage:"HistoryHomePageUpdateResult",
		upsertHistoryHomePage:"HistoryHomePageUpsertResult",
		createHistoryCover:"HistoryCoverCreateResult",
		deleteHistoryCover:"HistoryCoverDeleteResult",
		updateHistoryCover:"HistoryCoverUpdateResult",
		upsertHistoryCover:"HistoryCoverUpsertResult",
		createHistoryTextList:"HistoryTextListCreateResult",
		deleteHistoryTextList:"HistoryTextListDeleteResult",
		updateHistoryTextList:"HistoryTextListUpdateResult",
		upsertHistoryTextList:"HistoryTextListUpsertResult",
		createHistoryTextItem:"HistoryTextItemCreateResult",
		deleteHistoryTextItem:"HistoryTextItemDeleteResult",
		updateHistoryTextItem:"HistoryTextItemUpdateResult",
		upsertHistoryTextItem:"HistoryTextItemUpsertResult",
		createFooterMenu:"FooterMenuCreateResult",
		deleteFooterMenu:"FooterMenuDeleteResult",
		updateFooterMenu:"FooterMenuUpdateResult",
		upsertFooterMenu:"FooterMenuUpsertResult",
		createLinkSection:"LinkSectionCreateResult",
		deleteLinkSection:"LinkSectionDeleteResult",
		updateLinkSection:"LinkSectionUpdateResult",
		upsertLinkSection:"LinkSectionUpsertResult",
		createLinkList:"LinkListCreateResult",
		deleteLinkList:"LinkListDeleteResult",
		updateLinkList:"LinkListUpdateResult",
		upsertLinkList:"LinkListUpsertResult",
		createLinkItem:"LinkItemCreateResult",
		deleteLinkItem:"LinkItemDeleteResult",
		updateLinkItem:"LinkItemUpdateResult",
		upsertLinkItem:"LinkItemUpsertResult",
		createNewsletterSection:"NewsletterSectionCreateResult",
		deleteNewsletterSection:"NewsletterSectionDeleteResult",
		updateNewsletterSection:"NewsletterSectionUpdateResult",
		upsertNewsletterSection:"NewsletterSectionUpsertResult",
		createNewsletter:"NewsletterCreateResult",
		deleteNewsletter:"NewsletterDeleteResult",
		updateNewsletter:"NewsletterUpdateResult",
		upsertNewsletter:"NewsletterUpsertResult",
		createOnlineSection:"OnlineSectionCreateResult",
		deleteOnlineSection:"OnlineSectionDeleteResult",
		updateOnlineSection:"OnlineSectionUpdateResult",
		upsertOnlineSection:"OnlineSectionUpsertResult",
		createAppLink:"AppLinkCreateResult",
		deleteAppLink:"AppLinkDeleteResult",
		updateAppLink:"AppLinkUpdateResult",
		upsertAppLink:"AppLinkUpsertResult",
		createAppLinkList:"AppLinkListCreateResult",
		deleteAppLinkList:"AppLinkListDeleteResult",
		updateAppLinkList:"AppLinkListUpdateResult",
		upsertAppLinkList:"AppLinkListUpsertResult",
		createAppLinkItem:"AppLinkItemCreateResult",
		deleteAppLinkItem:"AppLinkItemDeleteResult",
		updateAppLinkItem:"AppLinkItemUpdateResult",
		upsertAppLinkItem:"AppLinkItemUpsertResult",
		createSocialSection:"SocialSectionCreateResult",
		deleteSocialSection:"SocialSectionDeleteResult",
		updateSocialSection:"SocialSectionUpdateResult",
		upsertSocialSection:"SocialSectionUpsertResult",
		createSocialLink:"SocialLinkCreateResult",
		deleteSocialLink:"SocialLinkDeleteResult",
		updateSocialLink:"SocialLinkUpdateResult",
		upsertSocialLink:"SocialLinkUpsertResult",
		createSocialLinkList:"SocialLinkListCreateResult",
		deleteSocialLinkList:"SocialLinkListDeleteResult",
		updateSocialLinkList:"SocialLinkListUpdateResult",
		upsertSocialLinkList:"SocialLinkListUpsertResult",
		createSocialLinkItem:"SocialLinkItemCreateResult",
		deleteSocialLinkItem:"SocialLinkItemDeleteResult",
		updateSocialLinkItem:"SocialLinkItemUpdateResult",
		upsertSocialLinkItem:"SocialLinkItemUpsertResult",
		createSharedContent:"SharedContentCreateResult",
		deleteSharedContent:"SharedContentDeleteResult",
		updateSharedContent:"SharedContentUpdateResult",
		upsertSharedContent:"SharedContentUpsertResult",
		transaction:"MutationTransaction",
		query:"Query",
		generateUploadUrl:"S3SignedUpload",
		generateReadUrl:"S3SignedRead"
	},
	ArticleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Article",
		validation:"_ValidationResult"
	},
	MutationResult:{
		"...on ArticleCreateResult": "ArticleCreateResult",
		"...on ArticleDeleteResult": "ArticleDeleteResult",
		"...on ArticleUpdateResult": "ArticleUpdateResult",
		"...on ArticleUpsertResult": "ArticleUpsertResult",
		"...on ArticleAuthorCreateResult": "ArticleAuthorCreateResult",
		"...on ArticleAuthorDeleteResult": "ArticleAuthorDeleteResult",
		"...on ArticleAuthorUpdateResult": "ArticleAuthorUpdateResult",
		"...on ArticleAuthorUpsertResult": "ArticleAuthorUpsertResult",
		"...on AuthorCreateResult": "AuthorCreateResult",
		"...on AuthorDeleteResult": "AuthorDeleteResult",
		"...on AuthorUpdateResult": "AuthorUpdateResult",
		"...on AuthorUpsertResult": "AuthorUpsertResult",
		"...on AuthorTopArticleCreateResult": "AuthorTopArticleCreateResult",
		"...on AuthorTopArticleDeleteResult": "AuthorTopArticleDeleteResult",
		"...on AuthorTopArticleUpdateResult": "AuthorTopArticleUpdateResult",
		"...on AuthorTopArticleUpsertResult": "AuthorTopArticleUpsertResult",
		"...on ContentCreateResult": "ContentCreateResult",
		"...on ContentDeleteResult": "ContentDeleteResult",
		"...on ContentUpdateResult": "ContentUpdateResult",
		"...on ContentUpsertResult": "ContentUpsertResult",
		"...on ContentPartCreateResult": "ContentPartCreateResult",
		"...on ContentPartDeleteResult": "ContentPartDeleteResult",
		"...on ContentPartUpdateResult": "ContentPartUpdateResult",
		"...on ContentPartUpsertResult": "ContentPartUpsertResult",
		"...on ContentReferenceCreateResult": "ContentReferenceCreateResult",
		"...on ContentReferenceDeleteResult": "ContentReferenceDeleteResult",
		"...on ContentReferenceUpdateResult": "ContentReferenceUpdateResult",
		"...on ContentReferenceUpsertResult": "ContentReferenceUpsertResult",
		"...on HomepageArticleCreateResult": "HomepageArticleCreateResult",
		"...on HomepageArticleDeleteResult": "HomepageArticleDeleteResult",
		"...on HomepageArticleUpdateResult": "HomepageArticleUpdateResult",
		"...on HomepageArticleUpsertResult": "HomepageArticleUpsertResult",
		"...on ImageCreateResult": "ImageCreateResult",
		"...on ImageDeleteResult": "ImageDeleteResult",
		"...on ImageUpdateResult": "ImageUpdateResult",
		"...on ImageUpsertResult": "ImageUpsertResult",
		"...on ImageUseCreateResult": "ImageUseCreateResult",
		"...on ImageUseDeleteResult": "ImageUseDeleteResult",
		"...on ImageUseUpdateResult": "ImageUseUpdateResult",
		"...on ImageUseUpsertResult": "ImageUseUpsertResult",
		"...on ImageTagCreateResult": "ImageTagCreateResult",
		"...on ImageTagDeleteResult": "ImageTagDeleteResult",
		"...on ImageTagUpdateResult": "ImageTagUpdateResult",
		"...on ImageTagUpsertResult": "ImageTagUpsertResult",
		"...on IssueCreateResult": "IssueCreateResult",
		"...on IssueDeleteResult": "IssueDeleteResult",
		"...on IssueUpdateResult": "IssueUpdateResult",
		"...on IssueUpsertResult": "IssueUpsertResult",
		"...on IssueArticleCreateResult": "IssueArticleCreateResult",
		"...on IssueArticleDeleteResult": "IssueArticleDeleteResult",
		"...on IssueArticleUpdateResult": "IssueArticleUpdateResult",
		"...on IssueArticleUpsertResult": "IssueArticleUpsertResult",
		"...on LinkCreateResult": "LinkCreateResult",
		"...on LinkDeleteResult": "LinkDeleteResult",
		"...on LinkUpdateResult": "LinkUpdateResult",
		"...on LinkUpsertResult": "LinkUpsertResult",
		"...on TextContentCreateResult": "TextContentCreateResult",
		"...on TextContentDeleteResult": "TextContentDeleteResult",
		"...on TextContentUpdateResult": "TextContentUpdateResult",
		"...on TextContentUpsertResult": "TextContentUpsertResult",
		"...on TextContentPartCreateResult": "TextContentPartCreateResult",
		"...on TextContentPartDeleteResult": "TextContentPartDeleteResult",
		"...on TextContentPartUpdateResult": "TextContentPartUpdateResult",
		"...on TextContentPartUpsertResult": "TextContentPartUpsertResult",
		"...on TextContentReferenceCreateResult": "TextContentReferenceCreateResult",
		"...on TextContentReferenceDeleteResult": "TextContentReferenceDeleteResult",
		"...on TextContentReferenceUpdateResult": "TextContentReferenceUpdateResult",
		"...on TextContentReferenceUpsertResult": "TextContentReferenceUpsertResult",
		"...on UrlCreateResult": "UrlCreateResult",
		"...on UrlDeleteResult": "UrlDeleteResult",
		"...on UrlUpdateResult": "UrlUpdateResult",
		"...on UrlUpsertResult": "UrlUpsertResult",
		"...on ArticleTagCreateResult": "ArticleTagCreateResult",
		"...on ArticleTagDeleteResult": "ArticleTagDeleteResult",
		"...on ArticleTagUpdateResult": "ArticleTagUpdateResult",
		"...on ArticleTagUpsertResult": "ArticleTagUpsertResult",
		"...on CategoryCreateResult": "CategoryCreateResult",
		"...on CategoryDeleteResult": "CategoryDeleteResult",
		"...on CategoryUpdateResult": "CategoryUpdateResult",
		"...on CategoryUpsertResult": "CategoryUpsertResult",
		"...on ArticleCategoryCreateResult": "ArticleCategoryCreateResult",
		"...on ArticleCategoryDeleteResult": "ArticleCategoryDeleteResult",
		"...on ArticleCategoryUpdateResult": "ArticleCategoryUpdateResult",
		"...on ArticleCategoryUpsertResult": "ArticleCategoryUpsertResult",
		"...on AudioCreateResult": "AudioCreateResult",
		"...on AudioDeleteResult": "AudioDeleteResult",
		"...on AudioUpdateResult": "AudioUpdateResult",
		"...on AudioUpsertResult": "AudioUpsertResult",
		"...on AudioUseCreateResult": "AudioUseCreateResult",
		"...on AudioUseDeleteResult": "AudioUseDeleteResult",
		"...on AudioUseUpdateResult": "AudioUseUpdateResult",
		"...on AudioUseUpsertResult": "AudioUseUpsertResult",
		"...on EmbedCreateResult": "EmbedCreateResult",
		"...on EmbedDeleteResult": "EmbedDeleteResult",
		"...on EmbedUpdateResult": "EmbedUpdateResult",
		"...on EmbedUpsertResult": "EmbedUpsertResult",
		"...on ImageContentCreateResult": "ImageContentCreateResult",
		"...on ImageContentDeleteResult": "ImageContentDeleteResult",
		"...on ImageContentUpdateResult": "ImageContentUpdateResult",
		"...on ImageContentUpsertResult": "ImageContentUpsertResult",
		"...on ListicleCreateResult": "ListicleCreateResult",
		"...on ListicleDeleteResult": "ListicleDeleteResult",
		"...on ListicleUpdateResult": "ListicleUpdateResult",
		"...on ListicleUpsertResult": "ListicleUpsertResult",
		"...on PollAnswerCreateResult": "PollAnswerCreateResult",
		"...on PollAnswerDeleteResult": "PollAnswerDeleteResult",
		"...on PollAnswerUpdateResult": "PollAnswerUpdateResult",
		"...on PollAnswerUpsertResult": "PollAnswerUpsertResult",
		"...on TagCreateResult": "TagCreateResult",
		"...on TagDeleteResult": "TagDeleteResult",
		"...on TagUpdateResult": "TagUpdateResult",
		"...on TagUpsertResult": "TagUpsertResult",
		"...on FAQCreateResult": "FAQCreateResult",
		"...on FAQDeleteResult": "FAQDeleteResult",
		"...on FAQUpdateResult": "FAQUpdateResult",
		"...on FAQUpsertResult": "FAQUpsertResult",
		"...on LinkContentCreateResult": "LinkContentCreateResult",
		"...on LinkContentDeleteResult": "LinkContentDeleteResult",
		"...on LinkContentUpdateResult": "LinkContentUpdateResult",
		"...on LinkContentUpsertResult": "LinkContentUpsertResult",
		"...on AwardContentCreateResult": "AwardContentCreateResult",
		"...on AwardContentDeleteResult": "AwardContentDeleteResult",
		"...on AwardContentUpdateResult": "AwardContentUpdateResult",
		"...on AwardContentUpsertResult": "AwardContentUpsertResult",
		"...on ReviewContentCreateResult": "ReviewContentCreateResult",
		"...on ReviewContentDeleteResult": "ReviewContentDeleteResult",
		"...on ReviewContentUpdateResult": "ReviewContentUpdateResult",
		"...on ReviewContentUpsertResult": "ReviewContentUpsertResult",
		"...on PageCreateResult": "PageCreateResult",
		"...on PageDeleteResult": "PageDeleteResult",
		"...on PageUpdateResult": "PageUpdateResult",
		"...on PageUpsertResult": "PageUpsertResult",
		"...on TextTranslationCreateResult": "TextTranslationCreateResult",
		"...on TextTranslationDeleteResult": "TextTranslationDeleteResult",
		"...on TextTranslationUpdateResult": "TextTranslationUpdateResult",
		"...on TextTranslationUpsertResult": "TextTranslationUpsertResult",
		"...on SeoCreateResult": "SeoCreateResult",
		"...on SeoDeleteResult": "SeoDeleteResult",
		"...on SeoUpdateResult": "SeoUpdateResult",
		"...on SeoUpsertResult": "SeoUpsertResult",
		"...on FileCreateResult": "FileCreateResult",
		"...on FileDeleteResult": "FileDeleteResult",
		"...on FileUpdateResult": "FileUpdateResult",
		"...on FileUpsertResult": "FileUpsertResult",
		"...on FileUseCreateResult": "FileUseCreateResult",
		"...on FileUseDeleteResult": "FileUseDeleteResult",
		"...on FileUseUpdateResult": "FileUseUpdateResult",
		"...on FileUseUpsertResult": "FileUseUpsertResult",
		"...on ContentBlockCreateResult": "ContentBlockCreateResult",
		"...on ContentBlockDeleteResult": "ContentBlockDeleteResult",
		"...on ContentBlockUpdateResult": "ContentBlockUpdateResult",
		"...on ContentBlockUpsertResult": "ContentBlockUpsertResult",
		"...on ContentArticleCreateResult": "ContentArticleCreateResult",
		"...on ContentArticleDeleteResult": "ContentArticleDeleteResult",
		"...on ContentArticleUpdateResult": "ContentArticleUpdateResult",
		"...on ContentArticleUpsertResult": "ContentArticleUpsertResult",
		"...on UnlockedArticleCreateResult": "UnlockedArticleCreateResult",
		"...on UnlockedArticleDeleteResult": "UnlockedArticleDeleteResult",
		"...on UnlockedArticleUpdateResult": "UnlockedArticleUpdateResult",
		"...on UnlockedArticleUpsertResult": "UnlockedArticleUpsertResult",
		"...on UserCreateResult": "UserCreateResult",
		"...on UserDeleteResult": "UserDeleteResult",
		"...on UserUpdateResult": "UserUpdateResult",
		"...on UserUpsertResult": "UserUpsertResult",
		"...on NotificationCreateResult": "NotificationCreateResult",
		"...on NotificationDeleteResult": "NotificationDeleteResult",
		"...on NotificationUpdateResult": "NotificationUpdateResult",
		"...on NotificationUpsertResult": "NotificationUpsertResult",
		"...on AppReviewCreateResult": "AppReviewCreateResult",
		"...on AppReviewDeleteResult": "AppReviewDeleteResult",
		"...on AppReviewUpdateResult": "AppReviewUpdateResult",
		"...on AppReviewUpsertResult": "AppReviewUpsertResult",
		"...on ProductCreateResult": "ProductCreateResult",
		"...on ProductDeleteResult": "ProductDeleteResult",
		"...on ProductUpdateResult": "ProductUpdateResult",
		"...on ProductUpsertResult": "ProductUpsertResult",
		"...on SubscriptionFormCreateResult": "SubscriptionFormCreateResult",
		"...on SubscriptionFormDeleteResult": "SubscriptionFormDeleteResult",
		"...on SubscriptionFormUpdateResult": "SubscriptionFormUpdateResult",
		"...on SubscriptionFormUpsertResult": "SubscriptionFormUpsertResult",
		"...on SubscriptionFormSectionCreateResult": "SubscriptionFormSectionCreateResult",
		"...on SubscriptionFormSectionDeleteResult": "SubscriptionFormSectionDeleteResult",
		"...on SubscriptionFormSectionUpdateResult": "SubscriptionFormSectionUpdateResult",
		"...on SubscriptionFormSectionUpsertResult": "SubscriptionFormSectionUpsertResult",
		"...on SubscriptionFormInputCreateResult": "SubscriptionFormInputCreateResult",
		"...on SubscriptionFormInputDeleteResult": "SubscriptionFormInputDeleteResult",
		"...on SubscriptionFormInputUpdateResult": "SubscriptionFormInputUpdateResult",
		"...on SubscriptionFormInputUpsertResult": "SubscriptionFormInputUpsertResult",
		"...on SubscriptionFormOptionCreateResult": "SubscriptionFormOptionCreateResult",
		"...on SubscriptionFormOptionDeleteResult": "SubscriptionFormOptionDeleteResult",
		"...on SubscriptionFormOptionUpdateResult": "SubscriptionFormOptionUpdateResult",
		"...on SubscriptionFormOptionUpsertResult": "SubscriptionFormOptionUpsertResult",
		"...on ButtonCreateResult": "ButtonCreateResult",
		"...on ButtonDeleteResult": "ButtonDeleteResult",
		"...on ButtonUpdateResult": "ButtonUpdateResult",
		"...on ButtonUpsertResult": "ButtonUpsertResult",
		"...on ArticleHistoryTagCreateResult": "ArticleHistoryTagCreateResult",
		"...on ArticleHistoryTagDeleteResult": "ArticleHistoryTagDeleteResult",
		"...on ArticleHistoryTagUpdateResult": "ArticleHistoryTagUpdateResult",
		"...on ArticleHistoryTagUpsertResult": "ArticleHistoryTagUpsertResult",
		"...on ArticleHistoryPeriodCreateResult": "ArticleHistoryPeriodCreateResult",
		"...on ArticleHistoryPeriodDeleteResult": "ArticleHistoryPeriodDeleteResult",
		"...on ArticleHistoryPeriodUpdateResult": "ArticleHistoryPeriodUpdateResult",
		"...on ArticleHistoryPeriodUpsertResult": "ArticleHistoryPeriodUpsertResult",
		"...on HistoryTagCreateResult": "HistoryTagCreateResult",
		"...on HistoryTagDeleteResult": "HistoryTagDeleteResult",
		"...on HistoryTagUpdateResult": "HistoryTagUpdateResult",
		"...on HistoryTagUpsertResult": "HistoryTagUpsertResult",
		"...on HistoryPeriodCreateResult": "HistoryPeriodCreateResult",
		"...on HistoryPeriodDeleteResult": "HistoryPeriodDeleteResult",
		"...on HistoryPeriodUpdateResult": "HistoryPeriodUpdateResult",
		"...on HistoryPeriodUpsertResult": "HistoryPeriodUpsertResult",
		"...on HistoryHomePageCreateResult": "HistoryHomePageCreateResult",
		"...on HistoryHomePageDeleteResult": "HistoryHomePageDeleteResult",
		"...on HistoryHomePageUpdateResult": "HistoryHomePageUpdateResult",
		"...on HistoryHomePageUpsertResult": "HistoryHomePageUpsertResult",
		"...on HistoryCoverCreateResult": "HistoryCoverCreateResult",
		"...on HistoryCoverDeleteResult": "HistoryCoverDeleteResult",
		"...on HistoryCoverUpdateResult": "HistoryCoverUpdateResult",
		"...on HistoryCoverUpsertResult": "HistoryCoverUpsertResult",
		"...on HistoryTextListCreateResult": "HistoryTextListCreateResult",
		"...on HistoryTextListDeleteResult": "HistoryTextListDeleteResult",
		"...on HistoryTextListUpdateResult": "HistoryTextListUpdateResult",
		"...on HistoryTextListUpsertResult": "HistoryTextListUpsertResult",
		"...on HistoryTextItemCreateResult": "HistoryTextItemCreateResult",
		"...on HistoryTextItemDeleteResult": "HistoryTextItemDeleteResult",
		"...on HistoryTextItemUpdateResult": "HistoryTextItemUpdateResult",
		"...on HistoryTextItemUpsertResult": "HistoryTextItemUpsertResult",
		"...on FooterMenuCreateResult": "FooterMenuCreateResult",
		"...on FooterMenuDeleteResult": "FooterMenuDeleteResult",
		"...on FooterMenuUpdateResult": "FooterMenuUpdateResult",
		"...on FooterMenuUpsertResult": "FooterMenuUpsertResult",
		"...on LinkSectionCreateResult": "LinkSectionCreateResult",
		"...on LinkSectionDeleteResult": "LinkSectionDeleteResult",
		"...on LinkSectionUpdateResult": "LinkSectionUpdateResult",
		"...on LinkSectionUpsertResult": "LinkSectionUpsertResult",
		"...on LinkListCreateResult": "LinkListCreateResult",
		"...on LinkListDeleteResult": "LinkListDeleteResult",
		"...on LinkListUpdateResult": "LinkListUpdateResult",
		"...on LinkListUpsertResult": "LinkListUpsertResult",
		"...on LinkItemCreateResult": "LinkItemCreateResult",
		"...on LinkItemDeleteResult": "LinkItemDeleteResult",
		"...on LinkItemUpdateResult": "LinkItemUpdateResult",
		"...on LinkItemUpsertResult": "LinkItemUpsertResult",
		"...on NewsletterSectionCreateResult": "NewsletterSectionCreateResult",
		"...on NewsletterSectionDeleteResult": "NewsletterSectionDeleteResult",
		"...on NewsletterSectionUpdateResult": "NewsletterSectionUpdateResult",
		"...on NewsletterSectionUpsertResult": "NewsletterSectionUpsertResult",
		"...on NewsletterCreateResult": "NewsletterCreateResult",
		"...on NewsletterDeleteResult": "NewsletterDeleteResult",
		"...on NewsletterUpdateResult": "NewsletterUpdateResult",
		"...on NewsletterUpsertResult": "NewsletterUpsertResult",
		"...on OnlineSectionCreateResult": "OnlineSectionCreateResult",
		"...on OnlineSectionDeleteResult": "OnlineSectionDeleteResult",
		"...on OnlineSectionUpdateResult": "OnlineSectionUpdateResult",
		"...on OnlineSectionUpsertResult": "OnlineSectionUpsertResult",
		"...on AppLinkCreateResult": "AppLinkCreateResult",
		"...on AppLinkDeleteResult": "AppLinkDeleteResult",
		"...on AppLinkUpdateResult": "AppLinkUpdateResult",
		"...on AppLinkUpsertResult": "AppLinkUpsertResult",
		"...on AppLinkListCreateResult": "AppLinkListCreateResult",
		"...on AppLinkListDeleteResult": "AppLinkListDeleteResult",
		"...on AppLinkListUpdateResult": "AppLinkListUpdateResult",
		"...on AppLinkListUpsertResult": "AppLinkListUpsertResult",
		"...on AppLinkItemCreateResult": "AppLinkItemCreateResult",
		"...on AppLinkItemDeleteResult": "AppLinkItemDeleteResult",
		"...on AppLinkItemUpdateResult": "AppLinkItemUpdateResult",
		"...on AppLinkItemUpsertResult": "AppLinkItemUpsertResult",
		"...on SocialSectionCreateResult": "SocialSectionCreateResult",
		"...on SocialSectionDeleteResult": "SocialSectionDeleteResult",
		"...on SocialSectionUpdateResult": "SocialSectionUpdateResult",
		"...on SocialSectionUpsertResult": "SocialSectionUpsertResult",
		"...on SocialLinkCreateResult": "SocialLinkCreateResult",
		"...on SocialLinkDeleteResult": "SocialLinkDeleteResult",
		"...on SocialLinkUpdateResult": "SocialLinkUpdateResult",
		"...on SocialLinkUpsertResult": "SocialLinkUpsertResult",
		"...on SocialLinkListCreateResult": "SocialLinkListCreateResult",
		"...on SocialLinkListDeleteResult": "SocialLinkListDeleteResult",
		"...on SocialLinkListUpdateResult": "SocialLinkListUpdateResult",
		"...on SocialLinkListUpsertResult": "SocialLinkListUpsertResult",
		"...on SocialLinkItemCreateResult": "SocialLinkItemCreateResult",
		"...on SocialLinkItemDeleteResult": "SocialLinkItemDeleteResult",
		"...on SocialLinkItemUpdateResult": "SocialLinkItemUpdateResult",
		"...on SocialLinkItemUpsertResult": "SocialLinkItemUpsertResult",
		"...on SharedContentCreateResult": "SharedContentCreateResult",
		"...on SharedContentDeleteResult": "SharedContentDeleteResult",
		"...on SharedContentUpdateResult": "SharedContentUpdateResult",
		"...on SharedContentUpsertResult": "SharedContentUpsertResult",
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError"
	},
	_MutationError:{
		path:"_PathFragment",
		paths:"_PathFragment",
		type:"_MutationErrorType",
		message:"String"
	},
	ArticleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Article"
	},
	ArticleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Article",
		validation:"_ValidationResult"
	},
	ArticleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Article",
		validation:"_ValidationResult"
	},
	ArticleAuthorCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArticleAuthor",
		validation:"_ValidationResult"
	},
	ArticleAuthorDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArticleAuthor"
	},
	ArticleAuthorUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArticleAuthor",
		validation:"_ValidationResult"
	},
	ArticleAuthorUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArticleAuthor",
		validation:"_ValidationResult"
	},
	AuthorCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Author",
		validation:"_ValidationResult"
	},
	AuthorDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Author"
	},
	AuthorUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Author",
		validation:"_ValidationResult"
	},
	AuthorUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Author",
		validation:"_ValidationResult"
	},
	AuthorTopArticleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AuthorTopArticle",
		validation:"_ValidationResult"
	},
	AuthorTopArticleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AuthorTopArticle"
	},
	AuthorTopArticleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AuthorTopArticle",
		validation:"_ValidationResult"
	},
	AuthorTopArticleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AuthorTopArticle",
		validation:"_ValidationResult"
	},
	ContentCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content",
		validation:"_ValidationResult"
	},
	ContentDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content"
	},
	ContentUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content",
		validation:"_ValidationResult"
	},
	ContentUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content",
		validation:"_ValidationResult"
	},
	ContentPartCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentPart",
		validation:"_ValidationResult"
	},
	ContentPartDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentPart"
	},
	ContentPartUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentPart",
		validation:"_ValidationResult"
	},
	ContentPartUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentPart",
		validation:"_ValidationResult"
	},
	ContentReferenceCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference",
		validation:"_ValidationResult"
	},
	ContentReferenceDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference"
	},
	ContentReferenceUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference",
		validation:"_ValidationResult"
	},
	ContentReferenceUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference",
		validation:"_ValidationResult"
	},
	HomepageArticleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomepageArticle",
		validation:"_ValidationResult"
	},
	HomepageArticleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomepageArticle"
	},
	HomepageArticleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomepageArticle",
		validation:"_ValidationResult"
	},
	HomepageArticleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomepageArticle",
		validation:"_ValidationResult"
	},
	ImageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image",
		validation:"_ValidationResult"
	},
	ImageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image"
	},
	ImageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image",
		validation:"_ValidationResult"
	},
	ImageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image",
		validation:"_ValidationResult"
	},
	ImageUseCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageUse",
		validation:"_ValidationResult"
	},
	ImageUseDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageUse"
	},
	ImageUseUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageUse",
		validation:"_ValidationResult"
	},
	ImageUseUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageUse",
		validation:"_ValidationResult"
	},
	ImageTagCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageTag",
		validation:"_ValidationResult"
	},
	ImageTagDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageTag"
	},
	ImageTagUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageTag",
		validation:"_ValidationResult"
	},
	ImageTagUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageTag",
		validation:"_ValidationResult"
	},
	IssueCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Issue",
		validation:"_ValidationResult"
	},
	IssueDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Issue"
	},
	IssueUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Issue",
		validation:"_ValidationResult"
	},
	IssueUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Issue",
		validation:"_ValidationResult"
	},
	IssueArticleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"IssueArticle",
		validation:"_ValidationResult"
	},
	IssueArticleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"IssueArticle"
	},
	IssueArticleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"IssueArticle",
		validation:"_ValidationResult"
	},
	IssueArticleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"IssueArticle",
		validation:"_ValidationResult"
	},
	LinkCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link",
		validation:"_ValidationResult"
	},
	LinkDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link"
	},
	LinkUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link",
		validation:"_ValidationResult"
	},
	LinkUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link",
		validation:"_ValidationResult"
	},
	TextContentCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextContent",
		validation:"_ValidationResult"
	},
	TextContentDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextContent"
	},
	TextContentUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextContent",
		validation:"_ValidationResult"
	},
	TextContentUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextContent",
		validation:"_ValidationResult"
	},
	TextContentPartCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextContentPart",
		validation:"_ValidationResult"
	},
	TextContentPartDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextContentPart"
	},
	TextContentPartUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextContentPart",
		validation:"_ValidationResult"
	},
	TextContentPartUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextContentPart",
		validation:"_ValidationResult"
	},
	TextContentReferenceCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextContentReference",
		validation:"_ValidationResult"
	},
	TextContentReferenceDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextContentReference"
	},
	TextContentReferenceUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextContentReference",
		validation:"_ValidationResult"
	},
	TextContentReferenceUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextContentReference",
		validation:"_ValidationResult"
	},
	UrlCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Url",
		validation:"_ValidationResult"
	},
	UrlDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Url"
	},
	UrlUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Url",
		validation:"_ValidationResult"
	},
	UrlUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Url",
		validation:"_ValidationResult"
	},
	ArticleTagCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArticleTag",
		validation:"_ValidationResult"
	},
	ArticleTagDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArticleTag"
	},
	ArticleTagUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArticleTag",
		validation:"_ValidationResult"
	},
	ArticleTagUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArticleTag",
		validation:"_ValidationResult"
	},
	CategoryCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Category",
		validation:"_ValidationResult"
	},
	CategoryDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Category"
	},
	CategoryUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Category",
		validation:"_ValidationResult"
	},
	CategoryUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Category",
		validation:"_ValidationResult"
	},
	ArticleCategoryCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArticleCategory",
		validation:"_ValidationResult"
	},
	ArticleCategoryDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArticleCategory"
	},
	ArticleCategoryUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArticleCategory",
		validation:"_ValidationResult"
	},
	ArticleCategoryUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArticleCategory",
		validation:"_ValidationResult"
	},
	AudioCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Audio",
		validation:"_ValidationResult"
	},
	AudioDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Audio"
	},
	AudioUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Audio",
		validation:"_ValidationResult"
	},
	AudioUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Audio",
		validation:"_ValidationResult"
	},
	AudioUseCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AudioUse",
		validation:"_ValidationResult"
	},
	AudioUseDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AudioUse"
	},
	AudioUseUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AudioUse",
		validation:"_ValidationResult"
	},
	AudioUseUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AudioUse",
		validation:"_ValidationResult"
	},
	EmbedCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Embed",
		validation:"_ValidationResult"
	},
	EmbedDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Embed"
	},
	EmbedUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Embed",
		validation:"_ValidationResult"
	},
	EmbedUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Embed",
		validation:"_ValidationResult"
	},
	ImageContentCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageContent",
		validation:"_ValidationResult"
	},
	ImageContentDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageContent"
	},
	ImageContentUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageContent",
		validation:"_ValidationResult"
	},
	ImageContentUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageContent",
		validation:"_ValidationResult"
	},
	ListicleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Listicle",
		validation:"_ValidationResult"
	},
	ListicleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Listicle"
	},
	ListicleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Listicle",
		validation:"_ValidationResult"
	},
	ListicleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Listicle",
		validation:"_ValidationResult"
	},
	PollAnswerCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PollAnswer",
		validation:"_ValidationResult"
	},
	PollAnswerDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PollAnswer"
	},
	PollAnswerUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PollAnswer",
		validation:"_ValidationResult"
	},
	PollAnswerUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PollAnswer",
		validation:"_ValidationResult"
	},
	TagCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Tag",
		validation:"_ValidationResult"
	},
	TagDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Tag"
	},
	TagUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Tag",
		validation:"_ValidationResult"
	},
	TagUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Tag",
		validation:"_ValidationResult"
	},
	FAQCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FAQ",
		validation:"_ValidationResult"
	},
	FAQDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FAQ"
	},
	FAQUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FAQ",
		validation:"_ValidationResult"
	},
	FAQUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FAQ",
		validation:"_ValidationResult"
	},
	LinkContentCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkContent",
		validation:"_ValidationResult"
	},
	LinkContentDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkContent"
	},
	LinkContentUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkContent",
		validation:"_ValidationResult"
	},
	LinkContentUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkContent",
		validation:"_ValidationResult"
	},
	AwardContentCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AwardContent",
		validation:"_ValidationResult"
	},
	AwardContentDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AwardContent"
	},
	AwardContentUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AwardContent",
		validation:"_ValidationResult"
	},
	AwardContentUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AwardContent",
		validation:"_ValidationResult"
	},
	ReviewContentCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ReviewContent",
		validation:"_ValidationResult"
	},
	ReviewContentDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ReviewContent"
	},
	ReviewContentUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ReviewContent",
		validation:"_ValidationResult"
	},
	ReviewContentUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ReviewContent",
		validation:"_ValidationResult"
	},
	PageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Page",
		validation:"_ValidationResult"
	},
	PageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Page"
	},
	PageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Page",
		validation:"_ValidationResult"
	},
	PageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Page",
		validation:"_ValidationResult"
	},
	TextTranslationCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextTranslation",
		validation:"_ValidationResult"
	},
	TextTranslationDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextTranslation"
	},
	TextTranslationUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextTranslation",
		validation:"_ValidationResult"
	},
	TextTranslationUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TextTranslation",
		validation:"_ValidationResult"
	},
	SeoCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo",
		validation:"_ValidationResult"
	},
	SeoDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo"
	},
	SeoUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo",
		validation:"_ValidationResult"
	},
	SeoUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo",
		validation:"_ValidationResult"
	},
	FileCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"File",
		validation:"_ValidationResult"
	},
	FileDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"File"
	},
	FileUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"File",
		validation:"_ValidationResult"
	},
	FileUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"File",
		validation:"_ValidationResult"
	},
	FileUseCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FileUse",
		validation:"_ValidationResult"
	},
	FileUseDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FileUse"
	},
	FileUseUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FileUse",
		validation:"_ValidationResult"
	},
	FileUseUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FileUse",
		validation:"_ValidationResult"
	},
	ContentBlockCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock",
		validation:"_ValidationResult"
	},
	ContentBlockDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock"
	},
	ContentBlockUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock",
		validation:"_ValidationResult"
	},
	ContentBlockUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock",
		validation:"_ValidationResult"
	},
	ContentArticleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentArticle",
		validation:"_ValidationResult"
	},
	ContentArticleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentArticle"
	},
	ContentArticleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentArticle",
		validation:"_ValidationResult"
	},
	ContentArticleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentArticle",
		validation:"_ValidationResult"
	},
	UnlockedArticleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UnlockedArticle",
		validation:"_ValidationResult"
	},
	UnlockedArticleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UnlockedArticle"
	},
	UnlockedArticleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UnlockedArticle",
		validation:"_ValidationResult"
	},
	UnlockedArticleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"UnlockedArticle",
		validation:"_ValidationResult"
	},
	UserCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"User",
		validation:"_ValidationResult"
	},
	UserDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"User"
	},
	UserUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"User",
		validation:"_ValidationResult"
	},
	UserUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"User",
		validation:"_ValidationResult"
	},
	NotificationCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Notification",
		validation:"_ValidationResult"
	},
	NotificationDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Notification"
	},
	NotificationUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Notification",
		validation:"_ValidationResult"
	},
	NotificationUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Notification",
		validation:"_ValidationResult"
	},
	AppReviewCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AppReview",
		validation:"_ValidationResult"
	},
	AppReviewDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AppReview"
	},
	AppReviewUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AppReview",
		validation:"_ValidationResult"
	},
	AppReviewUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AppReview",
		validation:"_ValidationResult"
	},
	ProductCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Product",
		validation:"_ValidationResult"
	},
	ProductDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Product"
	},
	ProductUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Product",
		validation:"_ValidationResult"
	},
	ProductUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Product",
		validation:"_ValidationResult"
	},
	SubscriptionFormCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SubscriptionForm",
		validation:"_ValidationResult"
	},
	SubscriptionFormDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SubscriptionForm"
	},
	SubscriptionFormUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SubscriptionForm",
		validation:"_ValidationResult"
	},
	SubscriptionFormUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SubscriptionForm",
		validation:"_ValidationResult"
	},
	SubscriptionFormSectionCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SubscriptionFormSection",
		validation:"_ValidationResult"
	},
	SubscriptionFormSectionDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SubscriptionFormSection"
	},
	SubscriptionFormSectionUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SubscriptionFormSection",
		validation:"_ValidationResult"
	},
	SubscriptionFormSectionUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SubscriptionFormSection",
		validation:"_ValidationResult"
	},
	SubscriptionFormInputCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SubscriptionFormInput",
		validation:"_ValidationResult"
	},
	SubscriptionFormInputDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SubscriptionFormInput"
	},
	SubscriptionFormInputUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SubscriptionFormInput",
		validation:"_ValidationResult"
	},
	SubscriptionFormInputUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SubscriptionFormInput",
		validation:"_ValidationResult"
	},
	SubscriptionFormOptionCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SubscriptionFormOption",
		validation:"_ValidationResult"
	},
	SubscriptionFormOptionDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SubscriptionFormOption"
	},
	SubscriptionFormOptionUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SubscriptionFormOption",
		validation:"_ValidationResult"
	},
	SubscriptionFormOptionUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SubscriptionFormOption",
		validation:"_ValidationResult"
	},
	ButtonCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Button",
		validation:"_ValidationResult"
	},
	ButtonDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Button"
	},
	ButtonUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Button",
		validation:"_ValidationResult"
	},
	ButtonUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Button",
		validation:"_ValidationResult"
	},
	ArticleHistoryTagCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArticleHistoryTag",
		validation:"_ValidationResult"
	},
	ArticleHistoryTagDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArticleHistoryTag"
	},
	ArticleHistoryTagUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArticleHistoryTag",
		validation:"_ValidationResult"
	},
	ArticleHistoryTagUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArticleHistoryTag",
		validation:"_ValidationResult"
	},
	ArticleHistoryPeriodCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArticleHistoryPeriod",
		validation:"_ValidationResult"
	},
	ArticleHistoryPeriodDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArticleHistoryPeriod"
	},
	ArticleHistoryPeriodUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArticleHistoryPeriod",
		validation:"_ValidationResult"
	},
	ArticleHistoryPeriodUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArticleHistoryPeriod",
		validation:"_ValidationResult"
	},
	HistoryTagCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HistoryTag",
		validation:"_ValidationResult"
	},
	HistoryTagDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HistoryTag"
	},
	HistoryTagUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HistoryTag",
		validation:"_ValidationResult"
	},
	HistoryTagUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HistoryTag",
		validation:"_ValidationResult"
	},
	HistoryPeriodCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HistoryPeriod",
		validation:"_ValidationResult"
	},
	HistoryPeriodDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HistoryPeriod"
	},
	HistoryPeriodUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HistoryPeriod",
		validation:"_ValidationResult"
	},
	HistoryPeriodUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HistoryPeriod",
		validation:"_ValidationResult"
	},
	HistoryHomePageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HistoryHomePage",
		validation:"_ValidationResult"
	},
	HistoryHomePageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HistoryHomePage"
	},
	HistoryHomePageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HistoryHomePage",
		validation:"_ValidationResult"
	},
	HistoryHomePageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HistoryHomePage",
		validation:"_ValidationResult"
	},
	HistoryCoverCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HistoryCover",
		validation:"_ValidationResult"
	},
	HistoryCoverDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HistoryCover"
	},
	HistoryCoverUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HistoryCover",
		validation:"_ValidationResult"
	},
	HistoryCoverUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HistoryCover",
		validation:"_ValidationResult"
	},
	HistoryTextListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HistoryTextList",
		validation:"_ValidationResult"
	},
	HistoryTextListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HistoryTextList"
	},
	HistoryTextListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HistoryTextList",
		validation:"_ValidationResult"
	},
	HistoryTextListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HistoryTextList",
		validation:"_ValidationResult"
	},
	HistoryTextItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HistoryTextItem",
		validation:"_ValidationResult"
	},
	HistoryTextItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HistoryTextItem"
	},
	HistoryTextItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HistoryTextItem",
		validation:"_ValidationResult"
	},
	HistoryTextItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HistoryTextItem",
		validation:"_ValidationResult"
	},
	FooterMenuCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterMenu",
		validation:"_ValidationResult"
	},
	FooterMenuDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterMenu"
	},
	FooterMenuUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterMenu",
		validation:"_ValidationResult"
	},
	FooterMenuUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterMenu",
		validation:"_ValidationResult"
	},
	LinkSectionCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkSection",
		validation:"_ValidationResult"
	},
	LinkSectionDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkSection"
	},
	LinkSectionUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkSection",
		validation:"_ValidationResult"
	},
	LinkSectionUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkSection",
		validation:"_ValidationResult"
	},
	LinkListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkList",
		validation:"_ValidationResult"
	},
	LinkListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkList"
	},
	LinkListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkList",
		validation:"_ValidationResult"
	},
	LinkListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkList",
		validation:"_ValidationResult"
	},
	LinkItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkItem",
		validation:"_ValidationResult"
	},
	LinkItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkItem"
	},
	LinkItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkItem",
		validation:"_ValidationResult"
	},
	LinkItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkItem",
		validation:"_ValidationResult"
	},
	NewsletterSectionCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"NewsletterSection",
		validation:"_ValidationResult"
	},
	NewsletterSectionDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"NewsletterSection"
	},
	NewsletterSectionUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"NewsletterSection",
		validation:"_ValidationResult"
	},
	NewsletterSectionUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"NewsletterSection",
		validation:"_ValidationResult"
	},
	NewsletterCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Newsletter",
		validation:"_ValidationResult"
	},
	NewsletterDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Newsletter"
	},
	NewsletterUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Newsletter",
		validation:"_ValidationResult"
	},
	NewsletterUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Newsletter",
		validation:"_ValidationResult"
	},
	OnlineSectionCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OnlineSection",
		validation:"_ValidationResult"
	},
	OnlineSectionDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OnlineSection"
	},
	OnlineSectionUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OnlineSection",
		validation:"_ValidationResult"
	},
	OnlineSectionUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"OnlineSection",
		validation:"_ValidationResult"
	},
	AppLinkCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AppLink",
		validation:"_ValidationResult"
	},
	AppLinkDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AppLink"
	},
	AppLinkUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AppLink",
		validation:"_ValidationResult"
	},
	AppLinkUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AppLink",
		validation:"_ValidationResult"
	},
	AppLinkListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AppLinkList",
		validation:"_ValidationResult"
	},
	AppLinkListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AppLinkList"
	},
	AppLinkListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AppLinkList",
		validation:"_ValidationResult"
	},
	AppLinkListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AppLinkList",
		validation:"_ValidationResult"
	},
	AppLinkItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AppLinkItem",
		validation:"_ValidationResult"
	},
	AppLinkItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AppLinkItem"
	},
	AppLinkItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AppLinkItem",
		validation:"_ValidationResult"
	},
	AppLinkItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"AppLinkItem",
		validation:"_ValidationResult"
	},
	SocialSectionCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialSection",
		validation:"_ValidationResult"
	},
	SocialSectionDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialSection"
	},
	SocialSectionUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialSection",
		validation:"_ValidationResult"
	},
	SocialSectionUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialSection",
		validation:"_ValidationResult"
	},
	SocialLinkCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLink",
		validation:"_ValidationResult"
	},
	SocialLinkDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLink"
	},
	SocialLinkUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLink",
		validation:"_ValidationResult"
	},
	SocialLinkUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLink",
		validation:"_ValidationResult"
	},
	SocialLinkListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLinkList",
		validation:"_ValidationResult"
	},
	SocialLinkListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLinkList"
	},
	SocialLinkListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLinkList",
		validation:"_ValidationResult"
	},
	SocialLinkListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLinkList",
		validation:"_ValidationResult"
	},
	SocialLinkItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLinkItem",
		validation:"_ValidationResult"
	},
	SocialLinkItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLinkItem"
	},
	SocialLinkItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLinkItem",
		validation:"_ValidationResult"
	},
	SocialLinkItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLinkItem",
		validation:"_ValidationResult"
	},
	SharedContentCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SharedContent",
		validation:"_ValidationResult"
	},
	SharedContentDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SharedContent"
	},
	SharedContentUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SharedContent",
		validation:"_ValidationResult"
	},
	SharedContentUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SharedContent",
		validation:"_ValidationResult"
	},
	MutationTransaction:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		validation:"_ValidationResult",
		createArticle:"ArticleCreateResult",
		deleteArticle:"ArticleDeleteResult",
		updateArticle:"ArticleUpdateResult",
		upsertArticle:"ArticleUpsertResult",
		createArticleAuthor:"ArticleAuthorCreateResult",
		deleteArticleAuthor:"ArticleAuthorDeleteResult",
		updateArticleAuthor:"ArticleAuthorUpdateResult",
		upsertArticleAuthor:"ArticleAuthorUpsertResult",
		createAuthor:"AuthorCreateResult",
		deleteAuthor:"AuthorDeleteResult",
		updateAuthor:"AuthorUpdateResult",
		upsertAuthor:"AuthorUpsertResult",
		createAuthorTopArticle:"AuthorTopArticleCreateResult",
		deleteAuthorTopArticle:"AuthorTopArticleDeleteResult",
		updateAuthorTopArticle:"AuthorTopArticleUpdateResult",
		upsertAuthorTopArticle:"AuthorTopArticleUpsertResult",
		createContent:"ContentCreateResult",
		deleteContent:"ContentDeleteResult",
		updateContent:"ContentUpdateResult",
		upsertContent:"ContentUpsertResult",
		createContentPart:"ContentPartCreateResult",
		deleteContentPart:"ContentPartDeleteResult",
		updateContentPart:"ContentPartUpdateResult",
		upsertContentPart:"ContentPartUpsertResult",
		createContentReference:"ContentReferenceCreateResult",
		deleteContentReference:"ContentReferenceDeleteResult",
		updateContentReference:"ContentReferenceUpdateResult",
		upsertContentReference:"ContentReferenceUpsertResult",
		createHomepageArticle:"HomepageArticleCreateResult",
		deleteHomepageArticle:"HomepageArticleDeleteResult",
		updateHomepageArticle:"HomepageArticleUpdateResult",
		upsertHomepageArticle:"HomepageArticleUpsertResult",
		createImage:"ImageCreateResult",
		deleteImage:"ImageDeleteResult",
		updateImage:"ImageUpdateResult",
		upsertImage:"ImageUpsertResult",
		createImageUse:"ImageUseCreateResult",
		deleteImageUse:"ImageUseDeleteResult",
		updateImageUse:"ImageUseUpdateResult",
		upsertImageUse:"ImageUseUpsertResult",
		createImageTag:"ImageTagCreateResult",
		deleteImageTag:"ImageTagDeleteResult",
		updateImageTag:"ImageTagUpdateResult",
		upsertImageTag:"ImageTagUpsertResult",
		createIssue:"IssueCreateResult",
		deleteIssue:"IssueDeleteResult",
		updateIssue:"IssueUpdateResult",
		upsertIssue:"IssueUpsertResult",
		createIssueArticle:"IssueArticleCreateResult",
		deleteIssueArticle:"IssueArticleDeleteResult",
		updateIssueArticle:"IssueArticleUpdateResult",
		upsertIssueArticle:"IssueArticleUpsertResult",
		createLink:"LinkCreateResult",
		deleteLink:"LinkDeleteResult",
		updateLink:"LinkUpdateResult",
		upsertLink:"LinkUpsertResult",
		createTextContent:"TextContentCreateResult",
		deleteTextContent:"TextContentDeleteResult",
		updateTextContent:"TextContentUpdateResult",
		upsertTextContent:"TextContentUpsertResult",
		createTextContentPart:"TextContentPartCreateResult",
		deleteTextContentPart:"TextContentPartDeleteResult",
		updateTextContentPart:"TextContentPartUpdateResult",
		upsertTextContentPart:"TextContentPartUpsertResult",
		createTextContentReference:"TextContentReferenceCreateResult",
		deleteTextContentReference:"TextContentReferenceDeleteResult",
		updateTextContentReference:"TextContentReferenceUpdateResult",
		upsertTextContentReference:"TextContentReferenceUpsertResult",
		createUrl:"UrlCreateResult",
		deleteUrl:"UrlDeleteResult",
		updateUrl:"UrlUpdateResult",
		upsertUrl:"UrlUpsertResult",
		createArticleTag:"ArticleTagCreateResult",
		deleteArticleTag:"ArticleTagDeleteResult",
		updateArticleTag:"ArticleTagUpdateResult",
		upsertArticleTag:"ArticleTagUpsertResult",
		createCategory:"CategoryCreateResult",
		deleteCategory:"CategoryDeleteResult",
		updateCategory:"CategoryUpdateResult",
		upsertCategory:"CategoryUpsertResult",
		createArticleCategory:"ArticleCategoryCreateResult",
		deleteArticleCategory:"ArticleCategoryDeleteResult",
		updateArticleCategory:"ArticleCategoryUpdateResult",
		upsertArticleCategory:"ArticleCategoryUpsertResult",
		createAudio:"AudioCreateResult",
		deleteAudio:"AudioDeleteResult",
		updateAudio:"AudioUpdateResult",
		upsertAudio:"AudioUpsertResult",
		createAudioUse:"AudioUseCreateResult",
		deleteAudioUse:"AudioUseDeleteResult",
		updateAudioUse:"AudioUseUpdateResult",
		upsertAudioUse:"AudioUseUpsertResult",
		createEmbed:"EmbedCreateResult",
		deleteEmbed:"EmbedDeleteResult",
		updateEmbed:"EmbedUpdateResult",
		upsertEmbed:"EmbedUpsertResult",
		createImageContent:"ImageContentCreateResult",
		deleteImageContent:"ImageContentDeleteResult",
		updateImageContent:"ImageContentUpdateResult",
		upsertImageContent:"ImageContentUpsertResult",
		createListicle:"ListicleCreateResult",
		deleteListicle:"ListicleDeleteResult",
		updateListicle:"ListicleUpdateResult",
		upsertListicle:"ListicleUpsertResult",
		createPollAnswer:"PollAnswerCreateResult",
		deletePollAnswer:"PollAnswerDeleteResult",
		updatePollAnswer:"PollAnswerUpdateResult",
		upsertPollAnswer:"PollAnswerUpsertResult",
		createTag:"TagCreateResult",
		deleteTag:"TagDeleteResult",
		updateTag:"TagUpdateResult",
		upsertTag:"TagUpsertResult",
		createFAQ:"FAQCreateResult",
		deleteFAQ:"FAQDeleteResult",
		updateFAQ:"FAQUpdateResult",
		upsertFAQ:"FAQUpsertResult",
		createLinkContent:"LinkContentCreateResult",
		deleteLinkContent:"LinkContentDeleteResult",
		updateLinkContent:"LinkContentUpdateResult",
		upsertLinkContent:"LinkContentUpsertResult",
		createAwardContent:"AwardContentCreateResult",
		deleteAwardContent:"AwardContentDeleteResult",
		updateAwardContent:"AwardContentUpdateResult",
		upsertAwardContent:"AwardContentUpsertResult",
		createReviewContent:"ReviewContentCreateResult",
		deleteReviewContent:"ReviewContentDeleteResult",
		updateReviewContent:"ReviewContentUpdateResult",
		upsertReviewContent:"ReviewContentUpsertResult",
		createPage:"PageCreateResult",
		deletePage:"PageDeleteResult",
		updatePage:"PageUpdateResult",
		upsertPage:"PageUpsertResult",
		createTextTranslation:"TextTranslationCreateResult",
		deleteTextTranslation:"TextTranslationDeleteResult",
		updateTextTranslation:"TextTranslationUpdateResult",
		upsertTextTranslation:"TextTranslationUpsertResult",
		createSeo:"SeoCreateResult",
		deleteSeo:"SeoDeleteResult",
		updateSeo:"SeoUpdateResult",
		upsertSeo:"SeoUpsertResult",
		createFile:"FileCreateResult",
		deleteFile:"FileDeleteResult",
		updateFile:"FileUpdateResult",
		upsertFile:"FileUpsertResult",
		createFileUse:"FileUseCreateResult",
		deleteFileUse:"FileUseDeleteResult",
		updateFileUse:"FileUseUpdateResult",
		upsertFileUse:"FileUseUpsertResult",
		createContentBlock:"ContentBlockCreateResult",
		deleteContentBlock:"ContentBlockDeleteResult",
		updateContentBlock:"ContentBlockUpdateResult",
		upsertContentBlock:"ContentBlockUpsertResult",
		createContentArticle:"ContentArticleCreateResult",
		deleteContentArticle:"ContentArticleDeleteResult",
		updateContentArticle:"ContentArticleUpdateResult",
		upsertContentArticle:"ContentArticleUpsertResult",
		createUnlockedArticle:"UnlockedArticleCreateResult",
		deleteUnlockedArticle:"UnlockedArticleDeleteResult",
		updateUnlockedArticle:"UnlockedArticleUpdateResult",
		upsertUnlockedArticle:"UnlockedArticleUpsertResult",
		createUser:"UserCreateResult",
		deleteUser:"UserDeleteResult",
		updateUser:"UserUpdateResult",
		upsertUser:"UserUpsertResult",
		createNotification:"NotificationCreateResult",
		deleteNotification:"NotificationDeleteResult",
		updateNotification:"NotificationUpdateResult",
		upsertNotification:"NotificationUpsertResult",
		createAppReview:"AppReviewCreateResult",
		deleteAppReview:"AppReviewDeleteResult",
		updateAppReview:"AppReviewUpdateResult",
		upsertAppReview:"AppReviewUpsertResult",
		createProduct:"ProductCreateResult",
		deleteProduct:"ProductDeleteResult",
		updateProduct:"ProductUpdateResult",
		upsertProduct:"ProductUpsertResult",
		createSubscriptionForm:"SubscriptionFormCreateResult",
		deleteSubscriptionForm:"SubscriptionFormDeleteResult",
		updateSubscriptionForm:"SubscriptionFormUpdateResult",
		upsertSubscriptionForm:"SubscriptionFormUpsertResult",
		createSubscriptionFormSection:"SubscriptionFormSectionCreateResult",
		deleteSubscriptionFormSection:"SubscriptionFormSectionDeleteResult",
		updateSubscriptionFormSection:"SubscriptionFormSectionUpdateResult",
		upsertSubscriptionFormSection:"SubscriptionFormSectionUpsertResult",
		createSubscriptionFormInput:"SubscriptionFormInputCreateResult",
		deleteSubscriptionFormInput:"SubscriptionFormInputDeleteResult",
		updateSubscriptionFormInput:"SubscriptionFormInputUpdateResult",
		upsertSubscriptionFormInput:"SubscriptionFormInputUpsertResult",
		createSubscriptionFormOption:"SubscriptionFormOptionCreateResult",
		deleteSubscriptionFormOption:"SubscriptionFormOptionDeleteResult",
		updateSubscriptionFormOption:"SubscriptionFormOptionUpdateResult",
		upsertSubscriptionFormOption:"SubscriptionFormOptionUpsertResult",
		createButton:"ButtonCreateResult",
		deleteButton:"ButtonDeleteResult",
		updateButton:"ButtonUpdateResult",
		upsertButton:"ButtonUpsertResult",
		createArticleHistoryTag:"ArticleHistoryTagCreateResult",
		deleteArticleHistoryTag:"ArticleHistoryTagDeleteResult",
		updateArticleHistoryTag:"ArticleHistoryTagUpdateResult",
		upsertArticleHistoryTag:"ArticleHistoryTagUpsertResult",
		createArticleHistoryPeriod:"ArticleHistoryPeriodCreateResult",
		deleteArticleHistoryPeriod:"ArticleHistoryPeriodDeleteResult",
		updateArticleHistoryPeriod:"ArticleHistoryPeriodUpdateResult",
		upsertArticleHistoryPeriod:"ArticleHistoryPeriodUpsertResult",
		createHistoryTag:"HistoryTagCreateResult",
		deleteHistoryTag:"HistoryTagDeleteResult",
		updateHistoryTag:"HistoryTagUpdateResult",
		upsertHistoryTag:"HistoryTagUpsertResult",
		createHistoryPeriod:"HistoryPeriodCreateResult",
		deleteHistoryPeriod:"HistoryPeriodDeleteResult",
		updateHistoryPeriod:"HistoryPeriodUpdateResult",
		upsertHistoryPeriod:"HistoryPeriodUpsertResult",
		createHistoryHomePage:"HistoryHomePageCreateResult",
		deleteHistoryHomePage:"HistoryHomePageDeleteResult",
		updateHistoryHomePage:"HistoryHomePageUpdateResult",
		upsertHistoryHomePage:"HistoryHomePageUpsertResult",
		createHistoryCover:"HistoryCoverCreateResult",
		deleteHistoryCover:"HistoryCoverDeleteResult",
		updateHistoryCover:"HistoryCoverUpdateResult",
		upsertHistoryCover:"HistoryCoverUpsertResult",
		createHistoryTextList:"HistoryTextListCreateResult",
		deleteHistoryTextList:"HistoryTextListDeleteResult",
		updateHistoryTextList:"HistoryTextListUpdateResult",
		upsertHistoryTextList:"HistoryTextListUpsertResult",
		createHistoryTextItem:"HistoryTextItemCreateResult",
		deleteHistoryTextItem:"HistoryTextItemDeleteResult",
		updateHistoryTextItem:"HistoryTextItemUpdateResult",
		upsertHistoryTextItem:"HistoryTextItemUpsertResult",
		createFooterMenu:"FooterMenuCreateResult",
		deleteFooterMenu:"FooterMenuDeleteResult",
		updateFooterMenu:"FooterMenuUpdateResult",
		upsertFooterMenu:"FooterMenuUpsertResult",
		createLinkSection:"LinkSectionCreateResult",
		deleteLinkSection:"LinkSectionDeleteResult",
		updateLinkSection:"LinkSectionUpdateResult",
		upsertLinkSection:"LinkSectionUpsertResult",
		createLinkList:"LinkListCreateResult",
		deleteLinkList:"LinkListDeleteResult",
		updateLinkList:"LinkListUpdateResult",
		upsertLinkList:"LinkListUpsertResult",
		createLinkItem:"LinkItemCreateResult",
		deleteLinkItem:"LinkItemDeleteResult",
		updateLinkItem:"LinkItemUpdateResult",
		upsertLinkItem:"LinkItemUpsertResult",
		createNewsletterSection:"NewsletterSectionCreateResult",
		deleteNewsletterSection:"NewsletterSectionDeleteResult",
		updateNewsletterSection:"NewsletterSectionUpdateResult",
		upsertNewsletterSection:"NewsletterSectionUpsertResult",
		createNewsletter:"NewsletterCreateResult",
		deleteNewsletter:"NewsletterDeleteResult",
		updateNewsletter:"NewsletterUpdateResult",
		upsertNewsletter:"NewsletterUpsertResult",
		createOnlineSection:"OnlineSectionCreateResult",
		deleteOnlineSection:"OnlineSectionDeleteResult",
		updateOnlineSection:"OnlineSectionUpdateResult",
		upsertOnlineSection:"OnlineSectionUpsertResult",
		createAppLink:"AppLinkCreateResult",
		deleteAppLink:"AppLinkDeleteResult",
		updateAppLink:"AppLinkUpdateResult",
		upsertAppLink:"AppLinkUpsertResult",
		createAppLinkList:"AppLinkListCreateResult",
		deleteAppLinkList:"AppLinkListDeleteResult",
		updateAppLinkList:"AppLinkListUpdateResult",
		upsertAppLinkList:"AppLinkListUpsertResult",
		createAppLinkItem:"AppLinkItemCreateResult",
		deleteAppLinkItem:"AppLinkItemDeleteResult",
		updateAppLinkItem:"AppLinkItemUpdateResult",
		upsertAppLinkItem:"AppLinkItemUpsertResult",
		createSocialSection:"SocialSectionCreateResult",
		deleteSocialSection:"SocialSectionDeleteResult",
		updateSocialSection:"SocialSectionUpdateResult",
		upsertSocialSection:"SocialSectionUpsertResult",
		createSocialLink:"SocialLinkCreateResult",
		deleteSocialLink:"SocialLinkDeleteResult",
		updateSocialLink:"SocialLinkUpdateResult",
		upsertSocialLink:"SocialLinkUpsertResult",
		createSocialLinkList:"SocialLinkListCreateResult",
		deleteSocialLinkList:"SocialLinkListDeleteResult",
		updateSocialLinkList:"SocialLinkListUpdateResult",
		upsertSocialLinkList:"SocialLinkListUpsertResult",
		createSocialLinkItem:"SocialLinkItemCreateResult",
		deleteSocialLinkItem:"SocialLinkItemDeleteResult",
		updateSocialLinkItem:"SocialLinkItemUpdateResult",
		upsertSocialLinkItem:"SocialLinkItemUpsertResult",
		createSharedContent:"SharedContentCreateResult",
		deleteSharedContent:"SharedContentDeleteResult",
		updateSharedContent:"SharedContentUpdateResult",
		upsertSharedContent:"SharedContentUpsertResult",
		query:"Query"
	},
	_Schema:{
		enums:"_Enum",
		entities:"_Entity"
	},
	_Entity:{
		name:"String",
		customPrimaryAllowed:"Boolean",
		fields:"_Field",
		unique:"_UniqueConstraint"
	},
	_UniqueConstraint:{
		fields:"String"
	},
	_Field:{
		"...on _Column": "_Column",
		"...on _Relation": "_Relation",
		name:"String",
		type:"String",
		nullable:"Boolean",
		rules:"_Rule",
		validators:"_Validator"
	},
	_Column:{
		name:"String",
		type:"String",
		enumName:"String",
		defaultValue:"Json",
		nullable:"Boolean",
		rules:"_Rule",
		validators:"_Validator"
	},
	_OrderBy:{
		path:"String",
		direction:"_OrderByDirection"
	},
	_Relation:{
		name:"String",
		type:"String",
		side:"_RelationSide",
		targetEntity:"String",
		ownedBy:"String",
		inversedBy:"String",
		nullable:"Boolean",
		onDelete:"_OnDeleteBehaviour",
		orphanRemoval:"Boolean",
		orderBy:"_OrderBy",
		rules:"_Rule",
		validators:"_Validator"
	},
	_Rule:{
		message:"_RuleMessage",
		validator:"Int"
	},
	_Validator:{
		operation:"String",
		arguments:"_Argument"
	},
	_Argument:{
		"...on _ValidatorArgument":"_ValidatorArgument",
		"...on _PathArgument":"_PathArgument",
		"...on _LiteralArgument":"_LiteralArgument"
	},
	_ValidatorArgument:{
		validator:"Int"
	},
	_PathArgument:{
		path:"String"
	},
	_LiteralArgument:{
		value:"Json"
	},
	_RuleMessage:{
		text:"String"
	},
	_Enum:{
		name:"String",
		values:"String"
	},
	S3SignedUpload:{
		url:"String",
		headers:"S3Header",
		method:"String",
		objectKey:"String",
		bucket:"String",
		publicUrl:"String"
	},
	S3Header:{
		key:"String",
		value:"String"
	},
	S3SignedRead:{
		url:"String",
		headers:"S3Header",
		method:"String",
		objectKey:"String",
		bucket:"String"
	}
}
type ZEUS_INTERFACES = GraphQLTypes["MutationResult"] | GraphQLTypes["_Field"]
type ZEUS_UNIONS = GraphQLTypes["_PathFragment"] | GraphQLTypes["_Argument"]

export type ValueTypes = {
    ["Query"]: AliasType<{
getArticle?: [{	by:ValueTypes["ArticleUniqueWhere"],	filter?:ValueTypes["ArticleWhere"] | null},ValueTypes["Article"]],
listArticle?: [{	filter?:ValueTypes["ArticleWhere"] | null,	orderBy?:ValueTypes["ArticleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Article"]],
paginateArticle?: [{	filter?:ValueTypes["ArticleWhere"] | null,	orderBy?:ValueTypes["ArticleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArticleConnection"]],
validateCreateArticle?: [{	data:ValueTypes["ArticleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateArticle?: [{	by:ValueTypes["ArticleUniqueWhere"],	data:ValueTypes["ArticleUpdateInput"]},ValueTypes["_ValidationResult"]],
getArticleAuthor?: [{	by:ValueTypes["ArticleAuthorUniqueWhere"],	filter?:ValueTypes["ArticleAuthorWhere"] | null},ValueTypes["ArticleAuthor"]],
listArticleAuthor?: [{	filter?:ValueTypes["ArticleAuthorWhere"] | null,	orderBy?:ValueTypes["ArticleAuthorOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArticleAuthor"]],
paginateArticleAuthor?: [{	filter?:ValueTypes["ArticleAuthorWhere"] | null,	orderBy?:ValueTypes["ArticleAuthorOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArticleAuthorConnection"]],
validateCreateArticleAuthor?: [{	data:ValueTypes["ArticleAuthorCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateArticleAuthor?: [{	by:ValueTypes["ArticleAuthorUniqueWhere"],	data:ValueTypes["ArticleAuthorUpdateInput"]},ValueTypes["_ValidationResult"]],
getAuthor?: [{	by:ValueTypes["AuthorUniqueWhere"],	filter?:ValueTypes["AuthorWhere"] | null},ValueTypes["Author"]],
listAuthor?: [{	filter?:ValueTypes["AuthorWhere"] | null,	orderBy?:ValueTypes["AuthorOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Author"]],
paginateAuthor?: [{	filter?:ValueTypes["AuthorWhere"] | null,	orderBy?:ValueTypes["AuthorOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AuthorConnection"]],
validateCreateAuthor?: [{	data:ValueTypes["AuthorCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateAuthor?: [{	by:ValueTypes["AuthorUniqueWhere"],	data:ValueTypes["AuthorUpdateInput"]},ValueTypes["_ValidationResult"]],
getAuthorTopArticle?: [{	by:ValueTypes["AuthorTopArticleUniqueWhere"],	filter?:ValueTypes["AuthorTopArticleWhere"] | null},ValueTypes["AuthorTopArticle"]],
listAuthorTopArticle?: [{	filter?:ValueTypes["AuthorTopArticleWhere"] | null,	orderBy?:ValueTypes["AuthorTopArticleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["AuthorTopArticle"]],
paginateAuthorTopArticle?: [{	filter?:ValueTypes["AuthorTopArticleWhere"] | null,	orderBy?:ValueTypes["AuthorTopArticleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AuthorTopArticleConnection"]],
validateCreateAuthorTopArticle?: [{	data:ValueTypes["AuthorTopArticleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateAuthorTopArticle?: [{	by:ValueTypes["AuthorTopArticleUniqueWhere"],	data:ValueTypes["AuthorTopArticleUpdateInput"]},ValueTypes["_ValidationResult"]],
getContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
listContent?: [{	filter?:ValueTypes["ContentWhere"] | null,	orderBy?:ValueTypes["ContentOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Content"]],
paginateContent?: [{	filter?:ValueTypes["ContentWhere"] | null,	orderBy?:ValueTypes["ContentOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentConnection"]],
validateCreateContent?: [{	data:ValueTypes["ContentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContent?: [{	by:ValueTypes["ContentUniqueWhere"],	data:ValueTypes["ContentUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentPart?: [{	by:ValueTypes["ContentPartUniqueWhere"],	filter?:ValueTypes["ContentPartWhere"] | null},ValueTypes["ContentPart"]],
listContentPart?: [{	filter?:ValueTypes["ContentPartWhere"] | null,	orderBy?:ValueTypes["ContentPartOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentPart"]],
paginateContentPart?: [{	filter?:ValueTypes["ContentPartWhere"] | null,	orderBy?:ValueTypes["ContentPartOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentPartConnection"]],
validateCreateContentPart?: [{	data:ValueTypes["ContentPartCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentPart?: [{	by:ValueTypes["ContentPartUniqueWhere"],	data:ValueTypes["ContentPartUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
listContentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentReference"]],
paginateContentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentReferenceConnection"]],
validateCreateContentReference?: [{	data:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	data:ValueTypes["ContentReferenceUpdateInput"]},ValueTypes["_ValidationResult"]],
getHomepageArticle?: [{	by:ValueTypes["HomepageArticleUniqueWhere"],	filter?:ValueTypes["HomepageArticleWhere"] | null},ValueTypes["HomepageArticle"]],
listHomepageArticle?: [{	filter?:ValueTypes["HomepageArticleWhere"] | null,	orderBy?:ValueTypes["HomepageArticleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HomepageArticle"]],
paginateHomepageArticle?: [{	filter?:ValueTypes["HomepageArticleWhere"] | null,	orderBy?:ValueTypes["HomepageArticleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HomepageArticleConnection"]],
validateCreateHomepageArticle?: [{	data:ValueTypes["HomepageArticleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHomepageArticle?: [{	by:ValueTypes["HomepageArticleUniqueWhere"],	data:ValueTypes["HomepageArticleUpdateInput"]},ValueTypes["_ValidationResult"]],
getImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
listImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Image"]],
paginateImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageConnection"]],
validateCreateImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	data:ValueTypes["ImageUpdateInput"]},ValueTypes["_ValidationResult"]],
getImageUse?: [{	by:ValueTypes["ImageUseUniqueWhere"],	filter?:ValueTypes["ImageUseWhere"] | null},ValueTypes["ImageUse"]],
listImageUse?: [{	filter?:ValueTypes["ImageUseWhere"] | null,	orderBy?:ValueTypes["ImageUseOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ImageUse"]],
paginateImageUse?: [{	filter?:ValueTypes["ImageUseWhere"] | null,	orderBy?:ValueTypes["ImageUseOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageUseConnection"]],
validateCreateImageUse?: [{	data:ValueTypes["ImageUseCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImageUse?: [{	by:ValueTypes["ImageUseUniqueWhere"],	data:ValueTypes["ImageUseUpdateInput"]},ValueTypes["_ValidationResult"]],
getImageTag?: [{	by:ValueTypes["ImageTagUniqueWhere"],	filter?:ValueTypes["ImageTagWhere"] | null},ValueTypes["ImageTag"]],
listImageTag?: [{	filter?:ValueTypes["ImageTagWhere"] | null,	orderBy?:ValueTypes["ImageTagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ImageTag"]],
paginateImageTag?: [{	filter?:ValueTypes["ImageTagWhere"] | null,	orderBy?:ValueTypes["ImageTagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageTagConnection"]],
validateCreateImageTag?: [{	data:ValueTypes["ImageTagCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImageTag?: [{	by:ValueTypes["ImageTagUniqueWhere"],	data:ValueTypes["ImageTagUpdateInput"]},ValueTypes["_ValidationResult"]],
getIssue?: [{	by:ValueTypes["IssueUniqueWhere"],	filter?:ValueTypes["IssueWhere"] | null},ValueTypes["Issue"]],
listIssue?: [{	filter?:ValueTypes["IssueWhere"] | null,	orderBy?:ValueTypes["IssueOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Issue"]],
paginateIssue?: [{	filter?:ValueTypes["IssueWhere"] | null,	orderBy?:ValueTypes["IssueOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["IssueConnection"]],
validateCreateIssue?: [{	data:ValueTypes["IssueCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateIssue?: [{	by:ValueTypes["IssueUniqueWhere"],	data:ValueTypes["IssueUpdateInput"]},ValueTypes["_ValidationResult"]],
getIssueArticle?: [{	by:ValueTypes["IssueArticleUniqueWhere"],	filter?:ValueTypes["IssueArticleWhere"] | null},ValueTypes["IssueArticle"]],
listIssueArticle?: [{	filter?:ValueTypes["IssueArticleWhere"] | null,	orderBy?:ValueTypes["IssueArticleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["IssueArticle"]],
paginateIssueArticle?: [{	filter?:ValueTypes["IssueArticleWhere"] | null,	orderBy?:ValueTypes["IssueArticleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["IssueArticleConnection"]],
validateCreateIssueArticle?: [{	data:ValueTypes["IssueArticleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateIssueArticle?: [{	by:ValueTypes["IssueArticleUniqueWhere"],	data:ValueTypes["IssueArticleUpdateInput"]},ValueTypes["_ValidationResult"]],
getLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
listLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Link"]],
paginateLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkConnection"]],
validateCreateLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	data:ValueTypes["LinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getTextContent?: [{	by:ValueTypes["TextContentUniqueWhere"],	filter?:ValueTypes["TextContentWhere"] | null},ValueTypes["TextContent"]],
listTextContent?: [{	filter?:ValueTypes["TextContentWhere"] | null,	orderBy?:ValueTypes["TextContentOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TextContent"]],
paginateTextContent?: [{	filter?:ValueTypes["TextContentWhere"] | null,	orderBy?:ValueTypes["TextContentOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TextContentConnection"]],
validateCreateTextContent?: [{	data:ValueTypes["TextContentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTextContent?: [{	by:ValueTypes["TextContentUniqueWhere"],	data:ValueTypes["TextContentUpdateInput"]},ValueTypes["_ValidationResult"]],
getTextContentPart?: [{	by:ValueTypes["TextContentPartUniqueWhere"],	filter?:ValueTypes["TextContentPartWhere"] | null},ValueTypes["TextContentPart"]],
listTextContentPart?: [{	filter?:ValueTypes["TextContentPartWhere"] | null,	orderBy?:ValueTypes["TextContentPartOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TextContentPart"]],
paginateTextContentPart?: [{	filter?:ValueTypes["TextContentPartWhere"] | null,	orderBy?:ValueTypes["TextContentPartOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TextContentPartConnection"]],
validateCreateTextContentPart?: [{	data:ValueTypes["TextContentPartCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTextContentPart?: [{	by:ValueTypes["TextContentPartUniqueWhere"],	data:ValueTypes["TextContentPartUpdateInput"]},ValueTypes["_ValidationResult"]],
getTextContentReference?: [{	by:ValueTypes["TextContentReferenceUniqueWhere"],	filter?:ValueTypes["TextContentReferenceWhere"] | null},ValueTypes["TextContentReference"]],
listTextContentReference?: [{	filter?:ValueTypes["TextContentReferenceWhere"] | null,	orderBy?:ValueTypes["TextContentReferenceOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TextContentReference"]],
paginateTextContentReference?: [{	filter?:ValueTypes["TextContentReferenceWhere"] | null,	orderBy?:ValueTypes["TextContentReferenceOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TextContentReferenceConnection"]],
validateCreateTextContentReference?: [{	data:ValueTypes["TextContentReferenceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTextContentReference?: [{	by:ValueTypes["TextContentReferenceUniqueWhere"],	data:ValueTypes["TextContentReferenceUpdateInput"]},ValueTypes["_ValidationResult"]],
getUrl?: [{	by:ValueTypes["UrlUniqueWhere"],	filter?:ValueTypes["UrlWhere"] | null},ValueTypes["Url"]],
listUrl?: [{	filter?:ValueTypes["UrlWhere"] | null,	orderBy?:ValueTypes["UrlOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Url"]],
paginateUrl?: [{	filter?:ValueTypes["UrlWhere"] | null,	orderBy?:ValueTypes["UrlOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["UrlConnection"]],
validateCreateUrl?: [{	data:ValueTypes["UrlCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateUrl?: [{	by:ValueTypes["UrlUniqueWhere"],	data:ValueTypes["UrlUpdateInput"]},ValueTypes["_ValidationResult"]],
getArticleTag?: [{	by:ValueTypes["ArticleTagUniqueWhere"],	filter?:ValueTypes["ArticleTagWhere"] | null},ValueTypes["ArticleTag"]],
listArticleTag?: [{	filter?:ValueTypes["ArticleTagWhere"] | null,	orderBy?:ValueTypes["ArticleTagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArticleTag"]],
paginateArticleTag?: [{	filter?:ValueTypes["ArticleTagWhere"] | null,	orderBy?:ValueTypes["ArticleTagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArticleTagConnection"]],
validateCreateArticleTag?: [{	data:ValueTypes["ArticleTagCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateArticleTag?: [{	by:ValueTypes["ArticleTagUniqueWhere"],	data:ValueTypes["ArticleTagUpdateInput"]},ValueTypes["_ValidationResult"]],
getCategory?: [{	by:ValueTypes["CategoryUniqueWhere"],	filter?:ValueTypes["CategoryWhere"] | null},ValueTypes["Category"]],
listCategory?: [{	filter?:ValueTypes["CategoryWhere"] | null,	orderBy?:ValueTypes["CategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Category"]],
paginateCategory?: [{	filter?:ValueTypes["CategoryWhere"] | null,	orderBy?:ValueTypes["CategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["CategoryConnection"]],
validateCreateCategory?: [{	data:ValueTypes["CategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCategory?: [{	by:ValueTypes["CategoryUniqueWhere"],	data:ValueTypes["CategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getArticleCategory?: [{	by:ValueTypes["ArticleCategoryUniqueWhere"],	filter?:ValueTypes["ArticleCategoryWhere"] | null},ValueTypes["ArticleCategory"]],
listArticleCategory?: [{	filter?:ValueTypes["ArticleCategoryWhere"] | null,	orderBy?:ValueTypes["ArticleCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArticleCategory"]],
paginateArticleCategory?: [{	filter?:ValueTypes["ArticleCategoryWhere"] | null,	orderBy?:ValueTypes["ArticleCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArticleCategoryConnection"]],
validateCreateArticleCategory?: [{	data:ValueTypes["ArticleCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateArticleCategory?: [{	by:ValueTypes["ArticleCategoryUniqueWhere"],	data:ValueTypes["ArticleCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getAudio?: [{	by:ValueTypes["AudioUniqueWhere"],	filter?:ValueTypes["AudioWhere"] | null},ValueTypes["Audio"]],
listAudio?: [{	filter?:ValueTypes["AudioWhere"] | null,	orderBy?:ValueTypes["AudioOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Audio"]],
paginateAudio?: [{	filter?:ValueTypes["AudioWhere"] | null,	orderBy?:ValueTypes["AudioOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AudioConnection"]],
validateCreateAudio?: [{	data:ValueTypes["AudioCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateAudio?: [{	by:ValueTypes["AudioUniqueWhere"],	data:ValueTypes["AudioUpdateInput"]},ValueTypes["_ValidationResult"]],
getAudioUse?: [{	by:ValueTypes["AudioUseUniqueWhere"],	filter?:ValueTypes["AudioUseWhere"] | null},ValueTypes["AudioUse"]],
listAudioUse?: [{	filter?:ValueTypes["AudioUseWhere"] | null,	orderBy?:ValueTypes["AudioUseOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["AudioUse"]],
paginateAudioUse?: [{	filter?:ValueTypes["AudioUseWhere"] | null,	orderBy?:ValueTypes["AudioUseOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AudioUseConnection"]],
validateCreateAudioUse?: [{	data:ValueTypes["AudioUseCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateAudioUse?: [{	by:ValueTypes["AudioUseUniqueWhere"],	data:ValueTypes["AudioUseUpdateInput"]},ValueTypes["_ValidationResult"]],
getEmbed?: [{	by:ValueTypes["EmbedUniqueWhere"],	filter?:ValueTypes["EmbedWhere"] | null},ValueTypes["Embed"]],
listEmbed?: [{	filter?:ValueTypes["EmbedWhere"] | null,	orderBy?:ValueTypes["EmbedOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Embed"]],
paginateEmbed?: [{	filter?:ValueTypes["EmbedWhere"] | null,	orderBy?:ValueTypes["EmbedOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EmbedConnection"]],
validateCreateEmbed?: [{	data:ValueTypes["EmbedCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEmbed?: [{	by:ValueTypes["EmbedUniqueWhere"],	data:ValueTypes["EmbedUpdateInput"]},ValueTypes["_ValidationResult"]],
getImageContent?: [{	by:ValueTypes["ImageContentUniqueWhere"],	filter?:ValueTypes["ImageContentWhere"] | null},ValueTypes["ImageContent"]],
listImageContent?: [{	filter?:ValueTypes["ImageContentWhere"] | null,	orderBy?:ValueTypes["ImageContentOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ImageContent"]],
paginateImageContent?: [{	filter?:ValueTypes["ImageContentWhere"] | null,	orderBy?:ValueTypes["ImageContentOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageContentConnection"]],
validateCreateImageContent?: [{	data:ValueTypes["ImageContentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImageContent?: [{	by:ValueTypes["ImageContentUniqueWhere"],	data:ValueTypes["ImageContentUpdateInput"]},ValueTypes["_ValidationResult"]],
getListicle?: [{	by:ValueTypes["ListicleUniqueWhere"],	filter?:ValueTypes["ListicleWhere"] | null},ValueTypes["Listicle"]],
listListicle?: [{	filter?:ValueTypes["ListicleWhere"] | null,	orderBy?:ValueTypes["ListicleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Listicle"]],
paginateListicle?: [{	filter?:ValueTypes["ListicleWhere"] | null,	orderBy?:ValueTypes["ListicleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ListicleConnection"]],
validateCreateListicle?: [{	data:ValueTypes["ListicleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateListicle?: [{	by:ValueTypes["ListicleUniqueWhere"],	data:ValueTypes["ListicleUpdateInput"]},ValueTypes["_ValidationResult"]],
getPollAnswer?: [{	by:ValueTypes["PollAnswerUniqueWhere"],	filter?:ValueTypes["PollAnswerWhere"] | null},ValueTypes["PollAnswer"]],
listPollAnswer?: [{	filter?:ValueTypes["PollAnswerWhere"] | null,	orderBy?:ValueTypes["PollAnswerOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["PollAnswer"]],
paginatePollAnswer?: [{	filter?:ValueTypes["PollAnswerWhere"] | null,	orderBy?:ValueTypes["PollAnswerOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PollAnswerConnection"]],
validateCreatePollAnswer?: [{	data:ValueTypes["PollAnswerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePollAnswer?: [{	by:ValueTypes["PollAnswerUniqueWhere"],	data:ValueTypes["PollAnswerUpdateInput"]},ValueTypes["_ValidationResult"]],
getTag?: [{	by:ValueTypes["TagUniqueWhere"],	filter?:ValueTypes["TagWhere"] | null},ValueTypes["Tag"]],
listTag?: [{	filter?:ValueTypes["TagWhere"] | null,	orderBy?:ValueTypes["TagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Tag"]],
paginateTag?: [{	filter?:ValueTypes["TagWhere"] | null,	orderBy?:ValueTypes["TagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TagConnection"]],
validateCreateTag?: [{	data:ValueTypes["TagCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTag?: [{	by:ValueTypes["TagUniqueWhere"],	data:ValueTypes["TagUpdateInput"]},ValueTypes["_ValidationResult"]],
getFAQ?: [{	by:ValueTypes["FAQUniqueWhere"],	filter?:ValueTypes["FAQWhere"] | null},ValueTypes["FAQ"]],
listFAQ?: [{	filter?:ValueTypes["FAQWhere"] | null,	orderBy?:ValueTypes["FAQOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FAQ"]],
paginateFAQ?: [{	filter?:ValueTypes["FAQWhere"] | null,	orderBy?:ValueTypes["FAQOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FAQConnection"]],
validateCreateFAQ?: [{	data:ValueTypes["FAQCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFAQ?: [{	by:ValueTypes["FAQUniqueWhere"],	data:ValueTypes["FAQUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkContent?: [{	by:ValueTypes["LinkContentUniqueWhere"],	filter?:ValueTypes["LinkContentWhere"] | null},ValueTypes["LinkContent"]],
listLinkContent?: [{	filter?:ValueTypes["LinkContentWhere"] | null,	orderBy?:ValueTypes["LinkContentOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["LinkContent"]],
paginateLinkContent?: [{	filter?:ValueTypes["LinkContentWhere"] | null,	orderBy?:ValueTypes["LinkContentOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkContentConnection"]],
validateCreateLinkContent?: [{	data:ValueTypes["LinkContentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkContent?: [{	by:ValueTypes["LinkContentUniqueWhere"],	data:ValueTypes["LinkContentUpdateInput"]},ValueTypes["_ValidationResult"]],
getAwardContent?: [{	by:ValueTypes["AwardContentUniqueWhere"],	filter?:ValueTypes["AwardContentWhere"] | null},ValueTypes["AwardContent"]],
listAwardContent?: [{	filter?:ValueTypes["AwardContentWhere"] | null,	orderBy?:ValueTypes["AwardContentOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["AwardContent"]],
paginateAwardContent?: [{	filter?:ValueTypes["AwardContentWhere"] | null,	orderBy?:ValueTypes["AwardContentOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AwardContentConnection"]],
validateCreateAwardContent?: [{	data:ValueTypes["AwardContentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateAwardContent?: [{	by:ValueTypes["AwardContentUniqueWhere"],	data:ValueTypes["AwardContentUpdateInput"]},ValueTypes["_ValidationResult"]],
getReviewContent?: [{	by:ValueTypes["ReviewContentUniqueWhere"],	filter?:ValueTypes["ReviewContentWhere"] | null},ValueTypes["ReviewContent"]],
listReviewContent?: [{	filter?:ValueTypes["ReviewContentWhere"] | null,	orderBy?:ValueTypes["ReviewContentOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ReviewContent"]],
paginateReviewContent?: [{	filter?:ValueTypes["ReviewContentWhere"] | null,	orderBy?:ValueTypes["ReviewContentOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ReviewContentConnection"]],
validateCreateReviewContent?: [{	data:ValueTypes["ReviewContentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateReviewContent?: [{	by:ValueTypes["ReviewContentUniqueWhere"],	data:ValueTypes["ReviewContentUpdateInput"]},ValueTypes["_ValidationResult"]],
getPage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null},ValueTypes["Page"]],
listPage?: [{	filter?:ValueTypes["PageWhere"] | null,	orderBy?:ValueTypes["PageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Page"]],
paginatePage?: [{	filter?:ValueTypes["PageWhere"] | null,	orderBy?:ValueTypes["PageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PageConnection"]],
validateCreatePage?: [{	data:ValueTypes["PageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePage?: [{	by:ValueTypes["PageUniqueWhere"],	data:ValueTypes["PageUpdateInput"]},ValueTypes["_ValidationResult"]],
getTextTranslation?: [{	by:ValueTypes["TextTranslationUniqueWhere"],	filter?:ValueTypes["TextTranslationWhere"] | null},ValueTypes["TextTranslation"]],
listTextTranslation?: [{	filter?:ValueTypes["TextTranslationWhere"] | null,	orderBy?:ValueTypes["TextTranslationOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TextTranslation"]],
paginateTextTranslation?: [{	filter?:ValueTypes["TextTranslationWhere"] | null,	orderBy?:ValueTypes["TextTranslationOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TextTranslationConnection"]],
validateCreateTextTranslation?: [{	data:ValueTypes["TextTranslationCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTextTranslation?: [{	by:ValueTypes["TextTranslationUniqueWhere"],	data:ValueTypes["TextTranslationUpdateInput"]},ValueTypes["_ValidationResult"]],
getSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
listSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Seo"]],
paginateSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SeoConnection"]],
validateCreateSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	data:ValueTypes["SeoUpdateInput"]},ValueTypes["_ValidationResult"]],
getFile?: [{	by:ValueTypes["FileUniqueWhere"],	filter?:ValueTypes["FileWhere"] | null},ValueTypes["File"]],
listFile?: [{	filter?:ValueTypes["FileWhere"] | null,	orderBy?:ValueTypes["FileOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["File"]],
paginateFile?: [{	filter?:ValueTypes["FileWhere"] | null,	orderBy?:ValueTypes["FileOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FileConnection"]],
validateCreateFile?: [{	data:ValueTypes["FileCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFile?: [{	by:ValueTypes["FileUniqueWhere"],	data:ValueTypes["FileUpdateInput"]},ValueTypes["_ValidationResult"]],
getFileUse?: [{	by:ValueTypes["FileUseUniqueWhere"],	filter?:ValueTypes["FileUseWhere"] | null},ValueTypes["FileUse"]],
listFileUse?: [{	filter?:ValueTypes["FileUseWhere"] | null,	orderBy?:ValueTypes["FileUseOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FileUse"]],
paginateFileUse?: [{	filter?:ValueTypes["FileUseWhere"] | null,	orderBy?:ValueTypes["FileUseOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FileUseConnection"]],
validateCreateFileUse?: [{	data:ValueTypes["FileUseCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFileUse?: [{	by:ValueTypes["FileUseUniqueWhere"],	data:ValueTypes["FileUseUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
listContentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentBlock"]],
paginateContentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentBlockConnection"]],
validateCreateContentBlock?: [{	data:ValueTypes["ContentBlockCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	data:ValueTypes["ContentBlockUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentArticle?: [{	by:ValueTypes["ContentArticleUniqueWhere"],	filter?:ValueTypes["ContentArticleWhere"] | null},ValueTypes["ContentArticle"]],
listContentArticle?: [{	filter?:ValueTypes["ContentArticleWhere"] | null,	orderBy?:ValueTypes["ContentArticleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentArticle"]],
paginateContentArticle?: [{	filter?:ValueTypes["ContentArticleWhere"] | null,	orderBy?:ValueTypes["ContentArticleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentArticleConnection"]],
validateCreateContentArticle?: [{	data:ValueTypes["ContentArticleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentArticle?: [{	by:ValueTypes["ContentArticleUniqueWhere"],	data:ValueTypes["ContentArticleUpdateInput"]},ValueTypes["_ValidationResult"]],
getUnlockedArticle?: [{	by:ValueTypes["UnlockedArticleUniqueWhere"],	filter?:ValueTypes["UnlockedArticleWhere"] | null},ValueTypes["UnlockedArticle"]],
listUnlockedArticle?: [{	filter?:ValueTypes["UnlockedArticleWhere"] | null,	orderBy?:ValueTypes["UnlockedArticleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["UnlockedArticle"]],
paginateUnlockedArticle?: [{	filter?:ValueTypes["UnlockedArticleWhere"] | null,	orderBy?:ValueTypes["UnlockedArticleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["UnlockedArticleConnection"]],
validateCreateUnlockedArticle?: [{	data:ValueTypes["UnlockedArticleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateUnlockedArticle?: [{	by:ValueTypes["UnlockedArticleUniqueWhere"],	data:ValueTypes["UnlockedArticleUpdateInput"]},ValueTypes["_ValidationResult"]],
getUser?: [{	by:ValueTypes["UserUniqueWhere"],	filter?:ValueTypes["UserWhere"] | null},ValueTypes["User"]],
listUser?: [{	filter?:ValueTypes["UserWhere"] | null,	orderBy?:ValueTypes["UserOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["User"]],
paginateUser?: [{	filter?:ValueTypes["UserWhere"] | null,	orderBy?:ValueTypes["UserOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["UserConnection"]],
validateCreateUser?: [{	data:ValueTypes["UserCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateUser?: [{	by:ValueTypes["UserUniqueWhere"],	data:ValueTypes["UserUpdateInput"]},ValueTypes["_ValidationResult"]],
getNotification?: [{	by:ValueTypes["NotificationUniqueWhere"],	filter?:ValueTypes["NotificationWhere"] | null},ValueTypes["Notification"]],
listNotification?: [{	filter?:ValueTypes["NotificationWhere"] | null,	orderBy?:ValueTypes["NotificationOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Notification"]],
paginateNotification?: [{	filter?:ValueTypes["NotificationWhere"] | null,	orderBy?:ValueTypes["NotificationOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["NotificationConnection"]],
validateCreateNotification?: [{	data:ValueTypes["NotificationCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateNotification?: [{	by:ValueTypes["NotificationUniqueWhere"],	data:ValueTypes["NotificationUpdateInput"]},ValueTypes["_ValidationResult"]],
getAppReview?: [{	by:ValueTypes["AppReviewUniqueWhere"],	filter?:ValueTypes["AppReviewWhere"] | null},ValueTypes["AppReview"]],
listAppReview?: [{	filter?:ValueTypes["AppReviewWhere"] | null,	orderBy?:ValueTypes["AppReviewOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["AppReview"]],
paginateAppReview?: [{	filter?:ValueTypes["AppReviewWhere"] | null,	orderBy?:ValueTypes["AppReviewOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AppReviewConnection"]],
validateCreateAppReview?: [{	data:ValueTypes["AppReviewCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateAppReview?: [{	by:ValueTypes["AppReviewUniqueWhere"],	data:ValueTypes["AppReviewUpdateInput"]},ValueTypes["_ValidationResult"]],
getProduct?: [{	by:ValueTypes["ProductUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
listProduct?: [{	filter?:ValueTypes["ProductWhere"] | null,	orderBy?:ValueTypes["ProductOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Product"]],
paginateProduct?: [{	filter?:ValueTypes["ProductWhere"] | null,	orderBy?:ValueTypes["ProductOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductConnection"]],
validateCreateProduct?: [{	data:ValueTypes["ProductCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProduct?: [{	by:ValueTypes["ProductUniqueWhere"],	data:ValueTypes["ProductUpdateInput"]},ValueTypes["_ValidationResult"]],
getSubscriptionForm?: [{	by:ValueTypes["SubscriptionFormUniqueWhere"],	filter?:ValueTypes["SubscriptionFormWhere"] | null},ValueTypes["SubscriptionForm"]],
listSubscriptionForm?: [{	filter?:ValueTypes["SubscriptionFormWhere"] | null,	orderBy?:ValueTypes["SubscriptionFormOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SubscriptionForm"]],
paginateSubscriptionForm?: [{	filter?:ValueTypes["SubscriptionFormWhere"] | null,	orderBy?:ValueTypes["SubscriptionFormOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SubscriptionFormConnection"]],
validateCreateSubscriptionForm?: [{	data:ValueTypes["SubscriptionFormCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSubscriptionForm?: [{	by:ValueTypes["SubscriptionFormUniqueWhere"],	data:ValueTypes["SubscriptionFormUpdateInput"]},ValueTypes["_ValidationResult"]],
getSubscriptionFormSection?: [{	by:ValueTypes["SubscriptionFormSectionUniqueWhere"],	filter?:ValueTypes["SubscriptionFormSectionWhere"] | null},ValueTypes["SubscriptionFormSection"]],
listSubscriptionFormSection?: [{	filter?:ValueTypes["SubscriptionFormSectionWhere"] | null,	orderBy?:ValueTypes["SubscriptionFormSectionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SubscriptionFormSection"]],
paginateSubscriptionFormSection?: [{	filter?:ValueTypes["SubscriptionFormSectionWhere"] | null,	orderBy?:ValueTypes["SubscriptionFormSectionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SubscriptionFormSectionConnection"]],
validateCreateSubscriptionFormSection?: [{	data:ValueTypes["SubscriptionFormSectionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSubscriptionFormSection?: [{	by:ValueTypes["SubscriptionFormSectionUniqueWhere"],	data:ValueTypes["SubscriptionFormSectionUpdateInput"]},ValueTypes["_ValidationResult"]],
getSubscriptionFormInput?: [{	by:ValueTypes["SubscriptionFormInputUniqueWhere"],	filter?:ValueTypes["SubscriptionFormInputWhere"] | null},ValueTypes["SubscriptionFormInput"]],
listSubscriptionFormInput?: [{	filter?:ValueTypes["SubscriptionFormInputWhere"] | null,	orderBy?:ValueTypes["SubscriptionFormInputOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SubscriptionFormInput"]],
paginateSubscriptionFormInput?: [{	filter?:ValueTypes["SubscriptionFormInputWhere"] | null,	orderBy?:ValueTypes["SubscriptionFormInputOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SubscriptionFormInputConnection"]],
validateCreateSubscriptionFormInput?: [{	data:ValueTypes["SubscriptionFormInputCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSubscriptionFormInput?: [{	by:ValueTypes["SubscriptionFormInputUniqueWhere"],	data:ValueTypes["SubscriptionFormInputUpdateInput"]},ValueTypes["_ValidationResult"]],
getSubscriptionFormOption?: [{	by:ValueTypes["SubscriptionFormOptionUniqueWhere"],	filter?:ValueTypes["SubscriptionFormOptionWhere"] | null},ValueTypes["SubscriptionFormOption"]],
listSubscriptionFormOption?: [{	filter?:ValueTypes["SubscriptionFormOptionWhere"] | null,	orderBy?:ValueTypes["SubscriptionFormOptionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SubscriptionFormOption"]],
paginateSubscriptionFormOption?: [{	filter?:ValueTypes["SubscriptionFormOptionWhere"] | null,	orderBy?:ValueTypes["SubscriptionFormOptionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SubscriptionFormOptionConnection"]],
validateCreateSubscriptionFormOption?: [{	data:ValueTypes["SubscriptionFormOptionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSubscriptionFormOption?: [{	by:ValueTypes["SubscriptionFormOptionUniqueWhere"],	data:ValueTypes["SubscriptionFormOptionUpdateInput"]},ValueTypes["_ValidationResult"]],
getButton?: [{	by:ValueTypes["ButtonUniqueWhere"],	filter?:ValueTypes["ButtonWhere"] | null},ValueTypes["Button"]],
listButton?: [{	filter?:ValueTypes["ButtonWhere"] | null,	orderBy?:ValueTypes["ButtonOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Button"]],
paginateButton?: [{	filter?:ValueTypes["ButtonWhere"] | null,	orderBy?:ValueTypes["ButtonOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ButtonConnection"]],
validateCreateButton?: [{	data:ValueTypes["ButtonCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateButton?: [{	by:ValueTypes["ButtonUniqueWhere"],	data:ValueTypes["ButtonUpdateInput"]},ValueTypes["_ValidationResult"]],
getArticleHistoryTag?: [{	by:ValueTypes["ArticleHistoryTagUniqueWhere"],	filter?:ValueTypes["ArticleHistoryTagWhere"] | null},ValueTypes["ArticleHistoryTag"]],
listArticleHistoryTag?: [{	filter?:ValueTypes["ArticleHistoryTagWhere"] | null,	orderBy?:ValueTypes["ArticleHistoryTagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArticleHistoryTag"]],
paginateArticleHistoryTag?: [{	filter?:ValueTypes["ArticleHistoryTagWhere"] | null,	orderBy?:ValueTypes["ArticleHistoryTagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArticleHistoryTagConnection"]],
validateCreateArticleHistoryTag?: [{	data:ValueTypes["ArticleHistoryTagCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateArticleHistoryTag?: [{	by:ValueTypes["ArticleHistoryTagUniqueWhere"],	data:ValueTypes["ArticleHistoryTagUpdateInput"]},ValueTypes["_ValidationResult"]],
getArticleHistoryPeriod?: [{	by:ValueTypes["ArticleHistoryPeriodUniqueWhere"],	filter?:ValueTypes["ArticleHistoryPeriodWhere"] | null},ValueTypes["ArticleHistoryPeriod"]],
listArticleHistoryPeriod?: [{	filter?:ValueTypes["ArticleHistoryPeriodWhere"] | null,	orderBy?:ValueTypes["ArticleHistoryPeriodOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArticleHistoryPeriod"]],
paginateArticleHistoryPeriod?: [{	filter?:ValueTypes["ArticleHistoryPeriodWhere"] | null,	orderBy?:ValueTypes["ArticleHistoryPeriodOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArticleHistoryPeriodConnection"]],
validateCreateArticleHistoryPeriod?: [{	data:ValueTypes["ArticleHistoryPeriodCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateArticleHistoryPeriod?: [{	by:ValueTypes["ArticleHistoryPeriodUniqueWhere"],	data:ValueTypes["ArticleHistoryPeriodUpdateInput"]},ValueTypes["_ValidationResult"]],
getHistoryTag?: [{	by:ValueTypes["HistoryTagUniqueWhere"],	filter?:ValueTypes["HistoryTagWhere"] | null},ValueTypes["HistoryTag"]],
listHistoryTag?: [{	filter?:ValueTypes["HistoryTagWhere"] | null,	orderBy?:ValueTypes["HistoryTagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HistoryTag"]],
paginateHistoryTag?: [{	filter?:ValueTypes["HistoryTagWhere"] | null,	orderBy?:ValueTypes["HistoryTagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HistoryTagConnection"]],
validateCreateHistoryTag?: [{	data:ValueTypes["HistoryTagCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHistoryTag?: [{	by:ValueTypes["HistoryTagUniqueWhere"],	data:ValueTypes["HistoryTagUpdateInput"]},ValueTypes["_ValidationResult"]],
getHistoryPeriod?: [{	by:ValueTypes["HistoryPeriodUniqueWhere"],	filter?:ValueTypes["HistoryPeriodWhere"] | null},ValueTypes["HistoryPeriod"]],
listHistoryPeriod?: [{	filter?:ValueTypes["HistoryPeriodWhere"] | null,	orderBy?:ValueTypes["HistoryPeriodOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HistoryPeriod"]],
paginateHistoryPeriod?: [{	filter?:ValueTypes["HistoryPeriodWhere"] | null,	orderBy?:ValueTypes["HistoryPeriodOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HistoryPeriodConnection"]],
validateCreateHistoryPeriod?: [{	data:ValueTypes["HistoryPeriodCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHistoryPeriod?: [{	by:ValueTypes["HistoryPeriodUniqueWhere"],	data:ValueTypes["HistoryPeriodUpdateInput"]},ValueTypes["_ValidationResult"]],
getHistoryHomePage?: [{	by:ValueTypes["HistoryHomePageUniqueWhere"],	filter?:ValueTypes["HistoryHomePageWhere"] | null},ValueTypes["HistoryHomePage"]],
listHistoryHomePage?: [{	filter?:ValueTypes["HistoryHomePageWhere"] | null,	orderBy?:ValueTypes["HistoryHomePageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HistoryHomePage"]],
paginateHistoryHomePage?: [{	filter?:ValueTypes["HistoryHomePageWhere"] | null,	orderBy?:ValueTypes["HistoryHomePageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HistoryHomePageConnection"]],
validateCreateHistoryHomePage?: [{	data:ValueTypes["HistoryHomePageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHistoryHomePage?: [{	by:ValueTypes["HistoryHomePageUniqueWhere"],	data:ValueTypes["HistoryHomePageUpdateInput"]},ValueTypes["_ValidationResult"]],
getHistoryCover?: [{	by:ValueTypes["HistoryCoverUniqueWhere"],	filter?:ValueTypes["HistoryCoverWhere"] | null},ValueTypes["HistoryCover"]],
listHistoryCover?: [{	filter?:ValueTypes["HistoryCoverWhere"] | null,	orderBy?:ValueTypes["HistoryCoverOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HistoryCover"]],
paginateHistoryCover?: [{	filter?:ValueTypes["HistoryCoverWhere"] | null,	orderBy?:ValueTypes["HistoryCoverOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HistoryCoverConnection"]],
validateCreateHistoryCover?: [{	data:ValueTypes["HistoryCoverCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHistoryCover?: [{	by:ValueTypes["HistoryCoverUniqueWhere"],	data:ValueTypes["HistoryCoverUpdateInput"]},ValueTypes["_ValidationResult"]],
getHistoryTextList?: [{	by:ValueTypes["HistoryTextListUniqueWhere"],	filter?:ValueTypes["HistoryTextListWhere"] | null},ValueTypes["HistoryTextList"]],
listHistoryTextList?: [{	filter?:ValueTypes["HistoryTextListWhere"] | null,	orderBy?:ValueTypes["HistoryTextListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HistoryTextList"]],
paginateHistoryTextList?: [{	filter?:ValueTypes["HistoryTextListWhere"] | null,	orderBy?:ValueTypes["HistoryTextListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HistoryTextListConnection"]],
validateCreateHistoryTextList?: [{	data:ValueTypes["HistoryTextListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHistoryTextList?: [{	by:ValueTypes["HistoryTextListUniqueWhere"],	data:ValueTypes["HistoryTextListUpdateInput"]},ValueTypes["_ValidationResult"]],
getHistoryTextItem?: [{	by:ValueTypes["HistoryTextItemUniqueWhere"],	filter?:ValueTypes["HistoryTextItemWhere"] | null},ValueTypes["HistoryTextItem"]],
listHistoryTextItem?: [{	filter?:ValueTypes["HistoryTextItemWhere"] | null,	orderBy?:ValueTypes["HistoryTextItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HistoryTextItem"]],
paginateHistoryTextItem?: [{	filter?:ValueTypes["HistoryTextItemWhere"] | null,	orderBy?:ValueTypes["HistoryTextItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HistoryTextItemConnection"]],
validateCreateHistoryTextItem?: [{	data:ValueTypes["HistoryTextItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHistoryTextItem?: [{	by:ValueTypes["HistoryTextItemUniqueWhere"],	data:ValueTypes["HistoryTextItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooterMenu?: [{	by:ValueTypes["FooterMenuUniqueWhere"],	filter?:ValueTypes["FooterMenuWhere"] | null},ValueTypes["FooterMenu"]],
listFooterMenu?: [{	filter?:ValueTypes["FooterMenuWhere"] | null,	orderBy?:ValueTypes["FooterMenuOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FooterMenu"]],
paginateFooterMenu?: [{	filter?:ValueTypes["FooterMenuWhere"] | null,	orderBy?:ValueTypes["FooterMenuOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterMenuConnection"]],
validateCreateFooterMenu?: [{	data:ValueTypes["FooterMenuCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooterMenu?: [{	by:ValueTypes["FooterMenuUniqueWhere"],	data:ValueTypes["FooterMenuUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkSection?: [{	by:ValueTypes["LinkSectionUniqueWhere"],	filter?:ValueTypes["LinkSectionWhere"] | null},ValueTypes["LinkSection"]],
listLinkSection?: [{	filter?:ValueTypes["LinkSectionWhere"] | null,	orderBy?:ValueTypes["LinkSectionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["LinkSection"]],
paginateLinkSection?: [{	filter?:ValueTypes["LinkSectionWhere"] | null,	orderBy?:ValueTypes["LinkSectionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkSectionConnection"]],
validateCreateLinkSection?: [{	data:ValueTypes["LinkSectionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkSection?: [{	by:ValueTypes["LinkSectionUniqueWhere"],	data:ValueTypes["LinkSectionUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkList?: [{	by:ValueTypes["LinkListUniqueWhere"],	filter?:ValueTypes["LinkListWhere"] | null},ValueTypes["LinkList"]],
listLinkList?: [{	filter?:ValueTypes["LinkListWhere"] | null,	orderBy?:ValueTypes["LinkListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["LinkList"]],
paginateLinkList?: [{	filter?:ValueTypes["LinkListWhere"] | null,	orderBy?:ValueTypes["LinkListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkListConnection"]],
validateCreateLinkList?: [{	data:ValueTypes["LinkListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkList?: [{	by:ValueTypes["LinkListUniqueWhere"],	data:ValueTypes["LinkListUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkItem?: [{	by:ValueTypes["LinkItemUniqueWhere"],	filter?:ValueTypes["LinkItemWhere"] | null},ValueTypes["LinkItem"]],
listLinkItem?: [{	filter?:ValueTypes["LinkItemWhere"] | null,	orderBy?:ValueTypes["LinkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["LinkItem"]],
paginateLinkItem?: [{	filter?:ValueTypes["LinkItemWhere"] | null,	orderBy?:ValueTypes["LinkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkItemConnection"]],
validateCreateLinkItem?: [{	data:ValueTypes["LinkItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkItem?: [{	by:ValueTypes["LinkItemUniqueWhere"],	data:ValueTypes["LinkItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getNewsletterSection?: [{	by:ValueTypes["NewsletterSectionUniqueWhere"],	filter?:ValueTypes["NewsletterSectionWhere"] | null},ValueTypes["NewsletterSection"]],
listNewsletterSection?: [{	filter?:ValueTypes["NewsletterSectionWhere"] | null,	orderBy?:ValueTypes["NewsletterSectionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["NewsletterSection"]],
paginateNewsletterSection?: [{	filter?:ValueTypes["NewsletterSectionWhere"] | null,	orderBy?:ValueTypes["NewsletterSectionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["NewsletterSectionConnection"]],
validateCreateNewsletterSection?: [{	data:ValueTypes["NewsletterSectionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateNewsletterSection?: [{	by:ValueTypes["NewsletterSectionUniqueWhere"],	data:ValueTypes["NewsletterSectionUpdateInput"]},ValueTypes["_ValidationResult"]],
getNewsletter?: [{	by:ValueTypes["NewsletterUniqueWhere"],	filter?:ValueTypes["NewsletterWhere"] | null},ValueTypes["Newsletter"]],
listNewsletter?: [{	filter?:ValueTypes["NewsletterWhere"] | null,	orderBy?:ValueTypes["NewsletterOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Newsletter"]],
paginateNewsletter?: [{	filter?:ValueTypes["NewsletterWhere"] | null,	orderBy?:ValueTypes["NewsletterOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["NewsletterConnection"]],
validateCreateNewsletter?: [{	data:ValueTypes["NewsletterCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateNewsletter?: [{	by:ValueTypes["NewsletterUniqueWhere"],	data:ValueTypes["NewsletterUpdateInput"]},ValueTypes["_ValidationResult"]],
getOnlineSection?: [{	by:ValueTypes["OnlineSectionUniqueWhere"],	filter?:ValueTypes["OnlineSectionWhere"] | null},ValueTypes["OnlineSection"]],
listOnlineSection?: [{	filter?:ValueTypes["OnlineSectionWhere"] | null,	orderBy?:ValueTypes["OnlineSectionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["OnlineSection"]],
paginateOnlineSection?: [{	filter?:ValueTypes["OnlineSectionWhere"] | null,	orderBy?:ValueTypes["OnlineSectionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["OnlineSectionConnection"]],
validateCreateOnlineSection?: [{	data:ValueTypes["OnlineSectionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateOnlineSection?: [{	by:ValueTypes["OnlineSectionUniqueWhere"],	data:ValueTypes["OnlineSectionUpdateInput"]},ValueTypes["_ValidationResult"]],
getAppLink?: [{	by:ValueTypes["AppLinkUniqueWhere"],	filter?:ValueTypes["AppLinkWhere"] | null},ValueTypes["AppLink"]],
listAppLink?: [{	filter?:ValueTypes["AppLinkWhere"] | null,	orderBy?:ValueTypes["AppLinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["AppLink"]],
paginateAppLink?: [{	filter?:ValueTypes["AppLinkWhere"] | null,	orderBy?:ValueTypes["AppLinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AppLinkConnection"]],
validateCreateAppLink?: [{	data:ValueTypes["AppLinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateAppLink?: [{	by:ValueTypes["AppLinkUniqueWhere"],	data:ValueTypes["AppLinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getAppLinkList?: [{	by:ValueTypes["AppLinkListUniqueWhere"],	filter?:ValueTypes["AppLinkListWhere"] | null},ValueTypes["AppLinkList"]],
listAppLinkList?: [{	filter?:ValueTypes["AppLinkListWhere"] | null,	orderBy?:ValueTypes["AppLinkListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["AppLinkList"]],
paginateAppLinkList?: [{	filter?:ValueTypes["AppLinkListWhere"] | null,	orderBy?:ValueTypes["AppLinkListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AppLinkListConnection"]],
validateCreateAppLinkList?: [{	data:ValueTypes["AppLinkListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateAppLinkList?: [{	by:ValueTypes["AppLinkListUniqueWhere"],	data:ValueTypes["AppLinkListUpdateInput"]},ValueTypes["_ValidationResult"]],
getAppLinkItem?: [{	by:ValueTypes["AppLinkItemUniqueWhere"],	filter?:ValueTypes["AppLinkItemWhere"] | null},ValueTypes["AppLinkItem"]],
listAppLinkItem?: [{	filter?:ValueTypes["AppLinkItemWhere"] | null,	orderBy?:ValueTypes["AppLinkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["AppLinkItem"]],
paginateAppLinkItem?: [{	filter?:ValueTypes["AppLinkItemWhere"] | null,	orderBy?:ValueTypes["AppLinkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AppLinkItemConnection"]],
validateCreateAppLinkItem?: [{	data:ValueTypes["AppLinkItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateAppLinkItem?: [{	by:ValueTypes["AppLinkItemUniqueWhere"],	data:ValueTypes["AppLinkItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getSocialSection?: [{	by:ValueTypes["SocialSectionUniqueWhere"],	filter?:ValueTypes["SocialSectionWhere"] | null},ValueTypes["SocialSection"]],
listSocialSection?: [{	filter?:ValueTypes["SocialSectionWhere"] | null,	orderBy?:ValueTypes["SocialSectionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SocialSection"]],
paginateSocialSection?: [{	filter?:ValueTypes["SocialSectionWhere"] | null,	orderBy?:ValueTypes["SocialSectionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SocialSectionConnection"]],
validateCreateSocialSection?: [{	data:ValueTypes["SocialSectionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSocialSection?: [{	by:ValueTypes["SocialSectionUniqueWhere"],	data:ValueTypes["SocialSectionUpdateInput"]},ValueTypes["_ValidationResult"]],
getSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkWhere"] | null},ValueTypes["SocialLink"]],
listSocialLink?: [{	filter?:ValueTypes["SocialLinkWhere"] | null,	orderBy?:ValueTypes["SocialLinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SocialLink"]],
paginateSocialLink?: [{	filter?:ValueTypes["SocialLinkWhere"] | null,	orderBy?:ValueTypes["SocialLinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SocialLinkConnection"]],
validateCreateSocialLink?: [{	data:ValueTypes["SocialLinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	data:ValueTypes["SocialLinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getSocialLinkList?: [{	by:ValueTypes["SocialLinkListUniqueWhere"],	filter?:ValueTypes["SocialLinkListWhere"] | null},ValueTypes["SocialLinkList"]],
listSocialLinkList?: [{	filter?:ValueTypes["SocialLinkListWhere"] | null,	orderBy?:ValueTypes["SocialLinkListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SocialLinkList"]],
paginateSocialLinkList?: [{	filter?:ValueTypes["SocialLinkListWhere"] | null,	orderBy?:ValueTypes["SocialLinkListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SocialLinkListConnection"]],
validateCreateSocialLinkList?: [{	data:ValueTypes["SocialLinkListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSocialLinkList?: [{	by:ValueTypes["SocialLinkListUniqueWhere"],	data:ValueTypes["SocialLinkListUpdateInput"]},ValueTypes["_ValidationResult"]],
getSocialLinkItem?: [{	by:ValueTypes["SocialLinkItemUniqueWhere"],	filter?:ValueTypes["SocialLinkItemWhere"] | null},ValueTypes["SocialLinkItem"]],
listSocialLinkItem?: [{	filter?:ValueTypes["SocialLinkItemWhere"] | null,	orderBy?:ValueTypes["SocialLinkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SocialLinkItem"]],
paginateSocialLinkItem?: [{	filter?:ValueTypes["SocialLinkItemWhere"] | null,	orderBy?:ValueTypes["SocialLinkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SocialLinkItemConnection"]],
validateCreateSocialLinkItem?: [{	data:ValueTypes["SocialLinkItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSocialLinkItem?: [{	by:ValueTypes["SocialLinkItemUniqueWhere"],	data:ValueTypes["SocialLinkItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getSharedContent?: [{	by:ValueTypes["SharedContentUniqueWhere"],	filter?:ValueTypes["SharedContentWhere"] | null},ValueTypes["SharedContent"]],
listSharedContent?: [{	filter?:ValueTypes["SharedContentWhere"] | null,	orderBy?:ValueTypes["SharedContentOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SharedContent"]],
paginateSharedContent?: [{	filter?:ValueTypes["SharedContentWhere"] | null,	orderBy?:ValueTypes["SharedContentOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SharedContentConnection"]],
validateCreateSharedContent?: [{	data:ValueTypes["SharedContentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSharedContent?: [{	by:ValueTypes["SharedContentUniqueWhere"],	data:ValueTypes["SharedContentUpdateInput"]},ValueTypes["_ValidationResult"]],
	transaction?:ValueTypes["QueryTransaction"],
	_info?:ValueTypes["Info"],
	schema?:ValueTypes["_Schema"],
	s3DummyQuery?:boolean,
		__typename?: boolean
}>;
	["Article"]: AliasType<{
	_meta?:ValueTypes["ArticleMeta"],
	id?:boolean,
	title?:boolean,
url?: [{	filter?:ValueTypes["UrlWhere"] | null},ValueTypes["Url"]],
authors?: [{	filter?:ValueTypes["ArticleAuthorWhere"] | null,	orderBy?:ValueTypes["ArticleAuthorOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArticleAuthor"]],
	hideInMostRead?:boolean,
	hideAds?:boolean,
	state?:boolean,
	locked?:boolean,
	publishAt?:boolean,
	template?:boolean,
subtitle?: [{	filter?:ValueTypes["TextContentWhere"] | null},ValueTypes["TextContent"]],
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
coverPhoto?: [{	filter?:ValueTypes["ImageUseWhere"] | null},ValueTypes["ImageUse"]],
	titleAlignment?:boolean,
	tagline?:boolean,
	createdAt?:boolean,
previewContent?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
audio?: [{	filter?:ValueTypes["AudioUseWhere"] | null},ValueTypes["AudioUse"]],
categories?: [{	filter?:ValueTypes["ArticleCategoryWhere"] | null,	orderBy?:ValueTypes["ArticleCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArticleCategory"]],
issues?: [{	filter?:ValueTypes["IssueArticleWhere"] | null,	orderBy?:ValueTypes["IssueArticleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["IssueArticle"]],
contentBlocks?: [{	filter?:ValueTypes["ContentArticleWhere"] | null,	orderBy?:ValueTypes["ContentArticleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentArticle"]],
unlocked?: [{	filter?:ValueTypes["UnlockedArticleWhere"] | null,	orderBy?:ValueTypes["UnlockedArticleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["UnlockedArticle"]],
coverPhotoVertical?: [{	filter?:ValueTypes["ImageUseWhere"] | null},ValueTypes["ImageUse"]],
	legacyId?:boolean,
tags?: [{	filter?:ValueTypes["ArticleTagWhere"] | null,	orderBy?:ValueTypes["ArticleTagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArticleTag"]],
	isHistory?:boolean,
historyTags?: [{	filter?:ValueTypes["ArticleHistoryTagWhere"] | null,	orderBy?:ValueTypes["ArticleHistoryTagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArticleHistoryTag"]],
historyPeriods?: [{	filter?:ValueTypes["ArticleHistoryPeriodWhere"] | null,	orderBy?:ValueTypes["ArticleHistoryPeriodOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArticleHistoryPeriod"]],
authorsByAuthor?: [{	by:ValueTypes["ArticleAuthorsByAuthorUniqueWhere"],	filter?:ValueTypes["ArticleAuthorWhere"] | null},ValueTypes["ArticleAuthor"]],
authorsByLegacyStringAuthor?: [{	by:ValueTypes["ArticleAuthorsByLegacyStringAuthorUniqueWhere"],	filter?:ValueTypes["ArticleAuthorWhere"] | null},ValueTypes["ArticleAuthor"]],
categoriesByCategory?: [{	by:ValueTypes["ArticleCategoriesByCategoryUniqueWhere"],	filter?:ValueTypes["ArticleCategoryWhere"] | null},ValueTypes["ArticleCategory"]],
issuesByIssue?: [{	by:ValueTypes["ArticleIssuesByIssueUniqueWhere"],	filter?:ValueTypes["IssueArticleWhere"] | null},ValueTypes["IssueArticle"]],
tagsByTag?: [{	by:ValueTypes["ArticleTagsByTagUniqueWhere"],	filter?:ValueTypes["ArticleTagWhere"] | null},ValueTypes["ArticleTag"]],
historyTagsByHistoryTag?: [{	by:ValueTypes["ArticleHistoryTagsByHistoryTagUniqueWhere"],	filter?:ValueTypes["ArticleHistoryTagWhere"] | null},ValueTypes["ArticleHistoryTag"]],
historyPeriodsByHistoryPeriod?: [{	by:ValueTypes["ArticleHistoryPeriodsByHistoryPeriodUniqueWhere"],	filter?:ValueTypes["ArticleHistoryPeriodWhere"] | null},ValueTypes["ArticleHistoryPeriod"]],
paginateAuthors?: [{	filter?:ValueTypes["ArticleAuthorWhere"] | null,	orderBy?:ValueTypes["ArticleAuthorOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArticleAuthorConnection"]],
paginateCategories?: [{	filter?:ValueTypes["ArticleCategoryWhere"] | null,	orderBy?:ValueTypes["ArticleCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArticleCategoryConnection"]],
paginateIssues?: [{	filter?:ValueTypes["IssueArticleWhere"] | null,	orderBy?:ValueTypes["IssueArticleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["IssueArticleConnection"]],
paginateContentBlocks?: [{	filter?:ValueTypes["ContentArticleWhere"] | null,	orderBy?:ValueTypes["ContentArticleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentArticleConnection"]],
paginateUnlocked?: [{	filter?:ValueTypes["UnlockedArticleWhere"] | null,	orderBy?:ValueTypes["UnlockedArticleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["UnlockedArticleConnection"]],
paginateTags?: [{	filter?:ValueTypes["ArticleTagWhere"] | null,	orderBy?:ValueTypes["ArticleTagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArticleTagConnection"]],
paginateHistoryTags?: [{	filter?:ValueTypes["ArticleHistoryTagWhere"] | null,	orderBy?:ValueTypes["ArticleHistoryTagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArticleHistoryTagConnection"]],
paginateHistoryPeriods?: [{	filter?:ValueTypes["ArticleHistoryPeriodWhere"] | null,	orderBy?:ValueTypes["ArticleHistoryPeriodOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArticleHistoryPeriodConnection"]],
		__typename?: boolean
}>;
	["ArticleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	authors?:ValueTypes["FieldMeta"],
	hideInMostRead?:ValueTypes["FieldMeta"],
	hideAds?:ValueTypes["FieldMeta"],
	state?:ValueTypes["FieldMeta"],
	locked?:ValueTypes["FieldMeta"],
	publishAt?:ValueTypes["FieldMeta"],
	template?:ValueTypes["FieldMeta"],
	subtitle?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	coverPhoto?:ValueTypes["FieldMeta"],
	titleAlignment?:ValueTypes["FieldMeta"],
	tagline?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	previewContent?:ValueTypes["FieldMeta"],
	audio?:ValueTypes["FieldMeta"],
	categories?:ValueTypes["FieldMeta"],
	issues?:ValueTypes["FieldMeta"],
	contentBlocks?:ValueTypes["FieldMeta"],
	unlocked?:ValueTypes["FieldMeta"],
	coverPhotoVertical?:ValueTypes["FieldMeta"],
	legacyId?:ValueTypes["FieldMeta"],
	tags?:ValueTypes["FieldMeta"],
	isHistory?:ValueTypes["FieldMeta"],
	historyTags?:ValueTypes["FieldMeta"],
	historyPeriods?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["FieldMeta"]: AliasType<{
	readable?:boolean,
	updatable?:boolean,
		__typename?: boolean
}>;
	["UUID"]:unknown;
	["Url"]: AliasType<{
	_meta?:ValueTypes["UrlMeta"],
	id?:boolean,
	url?:boolean,
article?: [{	filter?:ValueTypes["ArticleWhere"] | null},ValueTypes["Article"]],
author?: [{	filter?:ValueTypes["AuthorWhere"] | null},ValueTypes["Author"]],
issue?: [{	filter?:ValueTypes["IssueWhere"] | null},ValueTypes["Issue"]],
page?: [{	filter?:ValueTypes["PageWhere"] | null},ValueTypes["Page"]],
category?: [{	filter?:ValueTypes["CategoryWhere"] | null},ValueTypes["Category"]],
tag?: [{	filter?:ValueTypes["TagWhere"] | null},ValueTypes["Tag"]],
	redirect?:boolean,
		__typename?: boolean
}>;
	["UrlMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	article?:ValueTypes["FieldMeta"],
	author?:ValueTypes["FieldMeta"],
	issue?:ValueTypes["FieldMeta"],
	page?:ValueTypes["FieldMeta"],
	category?:ValueTypes["FieldMeta"],
	tag?:ValueTypes["FieldMeta"],
	redirect?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ArticleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	url?:ValueTypes["UrlWhere"] | null,
	authors?:ValueTypes["ArticleAuthorWhere"] | null,
	hideInMostRead?:ValueTypes["BooleanCondition"] | null,
	hideAds?:ValueTypes["BooleanCondition"] | null,
	state?:ValueTypes["ArticleStateCondition"] | null,
	locked?:ValueTypes["BooleanCondition"] | null,
	publishAt?:ValueTypes["DateTimeCondition"] | null,
	template?:ValueTypes["TemplateCondition"] | null,
	subtitle?:ValueTypes["TextContentWhere"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	coverPhoto?:ValueTypes["ImageUseWhere"] | null,
	titleAlignment?:ValueTypes["ArticleTitleAlignmentCondition"] | null,
	tagline?:ValueTypes["StringCondition"] | null,
	createdAt?:ValueTypes["DateTimeCondition"] | null,
	previewContent?:ValueTypes["ContentWhere"] | null,
	audio?:ValueTypes["AudioUseWhere"] | null,
	categories?:ValueTypes["ArticleCategoryWhere"] | null,
	issues?:ValueTypes["IssueArticleWhere"] | null,
	contentBlocks?:ValueTypes["ContentArticleWhere"] | null,
	unlocked?:ValueTypes["UnlockedArticleWhere"] | null,
	coverPhotoVertical?:ValueTypes["ImageUseWhere"] | null,
	legacyId?:ValueTypes["StringCondition"] | null,
	tags?:ValueTypes["ArticleTagWhere"] | null,
	isHistory?:ValueTypes["BooleanCondition"] | null,
	historyTags?:ValueTypes["ArticleHistoryTagWhere"] | null,
	historyPeriods?:ValueTypes["ArticleHistoryPeriodWhere"] | null,
	and?:(ValueTypes["ArticleWhere"] | undefined | null)[],
	or?:(ValueTypes["ArticleWhere"] | undefined | null)[],
	not?:ValueTypes["ArticleWhere"] | null
};
	["UUIDCondition"]: {
	and?:ValueTypes["UUIDCondition"][],
	or?:ValueTypes["UUIDCondition"][],
	not?:ValueTypes["UUIDCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["UUID"] | null,
	notEq?:ValueTypes["UUID"] | null,
	in?:ValueTypes["UUID"][],
	notIn?:ValueTypes["UUID"][],
	lt?:ValueTypes["UUID"] | null,
	lte?:ValueTypes["UUID"] | null,
	gt?:ValueTypes["UUID"] | null,
	gte?:ValueTypes["UUID"] | null
};
	["StringCondition"]: {
	and?:ValueTypes["StringCondition"][],
	or?:ValueTypes["StringCondition"][],
	not?:ValueTypes["StringCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:string | null,
	notEq?:string | null,
	in?:string[],
	notIn?:string[],
	lt?:string | null,
	lte?:string | null,
	gt?:string | null,
	gte?:string | null,
	contains?:string | null,
	startsWith?:string | null,
	endsWith?:string | null,
	containsCI?:string | null,
	startsWithCI?:string | null,
	endsWithCI?:string | null
};
	["UrlWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	url?:ValueTypes["StringCondition"] | null,
	article?:ValueTypes["ArticleWhere"] | null,
	author?:ValueTypes["AuthorWhere"] | null,
	issue?:ValueTypes["IssueWhere"] | null,
	page?:ValueTypes["PageWhere"] | null,
	category?:ValueTypes["CategoryWhere"] | null,
	tag?:ValueTypes["TagWhere"] | null,
	redirect?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["UrlWhere"] | undefined | null)[],
	or?:(ValueTypes["UrlWhere"] | undefined | null)[],
	not?:ValueTypes["UrlWhere"] | null
};
	["AuthorWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	position?:ValueTypes["StringCondition"] | null,
	twitterHandle?:ValueTypes["StringCondition"] | null,
	facebookId?:ValueTypes["StringCondition"] | null,
	email?:ValueTypes["StringCondition"] | null,
	photographer?:ValueTypes["BooleanCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	about?:ValueTypes["ContentWhere"] | null,
	topArticles?:ValueTypes["AuthorTopArticleWhere"] | null,
	users?:ValueTypes["UserWhere"] | null,
	startOfCooperation?:ValueTypes["DateCondition"] | null,
	photo?:ValueTypes["ImageUseWhere"] | null,
	illustration?:ValueTypes["ImageUseWhere"] | null,
	legacyId?:ValueTypes["StringCondition"] | null,
	category?:ValueTypes["AuthorCategoryCondition"] | null,
	url?:ValueTypes["UrlWhere"] | null,
	instagramUsername?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["AuthorWhere"] | undefined | null)[],
	or?:(ValueTypes["AuthorWhere"] | undefined | null)[],
	not?:ValueTypes["AuthorWhere"] | null
};
	["BooleanCondition"]: {
	and?:ValueTypes["BooleanCondition"][],
	or?:ValueTypes["BooleanCondition"][],
	not?:ValueTypes["BooleanCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:boolean | null,
	notEq?:boolean | null,
	in?:boolean[],
	notIn?:boolean[],
	lt?:boolean | null,
	lte?:boolean | null,
	gt?:boolean | null,
	gte?:boolean | null
};
	["IntCondition"]: {
	and?:ValueTypes["IntCondition"][],
	or?:ValueTypes["IntCondition"][],
	not?:ValueTypes["IntCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:number | null,
	notEq?:number | null,
	in?:number[],
	notIn?:number[],
	lt?:number | null,
	lte?:number | null,
	gt?:number | null,
	gte?:number | null
};
	["ContentWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	parts?:ValueTypes["ContentPartWhere"] | null,
	and?:(ValueTypes["ContentWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentWhere"] | undefined | null)[],
	not?:ValueTypes["ContentWhere"] | null
};
	["ContentPartWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	json?:ValueTypes["StringCondition"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	references?:ValueTypes["ContentReferenceWhere"] | null,
	and?:(ValueTypes["ContentPartWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentPartWhere"] | undefined | null)[],
	not?:ValueTypes["ContentPartWhere"] | null
};
	["ContentReferenceWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	type?:ValueTypes["ContentReferenceTypeCondition"] | null,
	contentPart?:ValueTypes["ContentPartWhere"] | null,
	primaryText?:ValueTypes["StringCondition"] | null,
	secondaryText?:ValueTypes["StringCondition"] | null,
	variant?:ValueTypes["ContentReferenceVariantCondition"] | null,
	color?:ValueTypes["StringCondition"] | null,
	embed?:ValueTypes["EmbedWhere"] | null,
	article?:ValueTypes["ArticleWhere"] | null,
	audio?:ValueTypes["AudioUseWhere"] | null,
	image?:ValueTypes["ImageUseWhere"] | null,
	images?:ValueTypes["ImageContentWhere"] | null,
	pollAnswer?:ValueTypes["PollAnswerWhere"] | null,
	listicle?:ValueTypes["ListicleWhere"] | null,
	faq?:ValueTypes["FAQWhere"] | null,
	links?:ValueTypes["LinkContentWhere"] | null,
	awards?:ValueTypes["AwardContentWhere"] | null,
	reviews?:ValueTypes["ReviewContentWhere"] | null,
	target?:ValueTypes["LinkWhere"] | null,
	subscriptionForm?:ValueTypes["SubscriptionFormWhere"] | null,
	buttons?:ValueTypes["ButtonWhere"] | null,
	sharedContent?:ValueTypes["SharedContentWhere"] | null,
	and?:(ValueTypes["ContentReferenceWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentReferenceWhere"] | undefined | null)[],
	not?:ValueTypes["ContentReferenceWhere"] | null
};
	["ContentReferenceTypeCondition"]: {
	and?:ValueTypes["ContentReferenceTypeCondition"][],
	or?:ValueTypes["ContentReferenceTypeCondition"][],
	not?:ValueTypes["ContentReferenceTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["ContentReferenceType"] | null,
	notEq?:ValueTypes["ContentReferenceType"] | null,
	in?:ValueTypes["ContentReferenceType"][],
	notIn?:ValueTypes["ContentReferenceType"][],
	lt?:ValueTypes["ContentReferenceType"] | null,
	lte?:ValueTypes["ContentReferenceType"] | null,
	gt?:ValueTypes["ContentReferenceType"] | null,
	gte?:ValueTypes["ContentReferenceType"] | null
};
	["ContentReferenceType"]:ContentReferenceType;
	["ContentReferenceVariantCondition"]: {
	and?:ValueTypes["ContentReferenceVariantCondition"][],
	or?:ValueTypes["ContentReferenceVariantCondition"][],
	not?:ValueTypes["ContentReferenceVariantCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["ContentReferenceVariant"] | null,
	notEq?:ValueTypes["ContentReferenceVariant"] | null,
	in?:ValueTypes["ContentReferenceVariant"][],
	notIn?:ValueTypes["ContentReferenceVariant"][],
	lt?:ValueTypes["ContentReferenceVariant"] | null,
	lte?:ValueTypes["ContentReferenceVariant"] | null,
	gt?:ValueTypes["ContentReferenceVariant"] | null,
	gte?:ValueTypes["ContentReferenceVariant"] | null
};
	["ContentReferenceVariant"]:ContentReferenceVariant;
	["EmbedWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	type?:ValueTypes["EmbedTypeCondition"] | null,
	youtubeId?:ValueTypes["StringCondition"] | null,
	vimeoId?:ValueTypes["StringCondition"] | null,
	spotifyId?:ValueTypes["StringCondition"] | null,
	spotifyType?:ValueTypes["StringCondition"] | null,
	soundCloudId?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["EmbedWhere"] | undefined | null)[],
	or?:(ValueTypes["EmbedWhere"] | undefined | null)[],
	not?:ValueTypes["EmbedWhere"] | null
};
	["EmbedTypeCondition"]: {
	and?:ValueTypes["EmbedTypeCondition"][],
	or?:ValueTypes["EmbedTypeCondition"][],
	not?:ValueTypes["EmbedTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["EmbedType"] | null,
	notEq?:ValueTypes["EmbedType"] | null,
	in?:ValueTypes["EmbedType"][],
	notIn?:ValueTypes["EmbedType"][],
	lt?:ValueTypes["EmbedType"] | null,
	lte?:ValueTypes["EmbedType"] | null,
	gt?:ValueTypes["EmbedType"] | null,
	gte?:ValueTypes["EmbedType"] | null
};
	["EmbedType"]:EmbedType;
	["AudioUseWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	audio?:ValueTypes["AudioWhere"] | null,
	and?:(ValueTypes["AudioUseWhere"] | undefined | null)[],
	or?:(ValueTypes["AudioUseWhere"] | undefined | null)[],
	not?:ValueTypes["AudioUseWhere"] | null
};
	["AudioWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	url?:ValueTypes["StringCondition"] | null,
	type?:ValueTypes["StringCondition"] | null,
	author?:ValueTypes["AuthorWhere"] | null,
	uses?:ValueTypes["AudioUseWhere"] | null,
	and?:(ValueTypes["AudioWhere"] | undefined | null)[],
	or?:(ValueTypes["AudioWhere"] | undefined | null)[],
	not?:ValueTypes["AudioWhere"] | null
};
	["ImageUseWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	and?:(ValueTypes["ImageUseWhere"] | undefined | null)[],
	or?:(ValueTypes["ImageUseWhere"] | undefined | null)[],
	not?:ValueTypes["ImageUseWhere"] | null
};
	["ImageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	url?:ValueTypes["StringCondition"] | null,
	width?:ValueTypes["IntCondition"] | null,
	height?:ValueTypes["IntCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	text?:ValueTypes["StringCondition"] | null,
	author?:ValueTypes["AuthorWhere"] | null,
	tags?:ValueTypes["ImageTagWhere"] | null,
	uses?:ValueTypes["ImageUseWhere"] | null,
	align?:ValueTypes["ImageAlignCondition"] | null,
	legacyId?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["ImageWhere"] | undefined | null)[],
	or?:(ValueTypes["ImageWhere"] | undefined | null)[],
	not?:ValueTypes["ImageWhere"] | null
};
	["ImageTagWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	images?:ValueTypes["ImageWhere"] | null,
	and?:(ValueTypes["ImageTagWhere"] | undefined | null)[],
	or?:(ValueTypes["ImageTagWhere"] | undefined | null)[],
	not?:ValueTypes["ImageTagWhere"] | null
};
	["ImageAlignCondition"]: {
	and?:ValueTypes["ImageAlignCondition"][],
	or?:ValueTypes["ImageAlignCondition"][],
	not?:ValueTypes["ImageAlignCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["ImageAlign"] | null,
	notEq?:ValueTypes["ImageAlign"] | null,
	in?:ValueTypes["ImageAlign"][],
	notIn?:ValueTypes["ImageAlign"][],
	lt?:ValueTypes["ImageAlign"] | null,
	lte?:ValueTypes["ImageAlign"] | null,
	gt?:ValueTypes["ImageAlign"] | null,
	gte?:ValueTypes["ImageAlign"] | null
};
	["ImageAlign"]:ImageAlign;
	["ImageContentWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	contentReference?:ValueTypes["ContentReferenceWhere"] | null,
	image?:ValueTypes["ImageUseWhere"] | null,
	and?:(ValueTypes["ImageContentWhere"] | undefined | null)[],
	or?:(ValueTypes["ImageContentWhere"] | undefined | null)[],
	not?:ValueTypes["ImageContentWhere"] | null
};
	["PollAnswerWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	authorName?:ValueTypes["StringCondition"] | null,
	authorPosition?:ValueTypes["StringCondition"] | null,
	text?:ValueTypes["StringCondition"] | null,
	authorImage?:ValueTypes["ImageUseWhere"] | null,
	and?:(ValueTypes["PollAnswerWhere"] | undefined | null)[],
	or?:(ValueTypes["PollAnswerWhere"] | undefined | null)[],
	not?:ValueTypes["PollAnswerWhere"] | null
};
	["ListicleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	primaryText?:ValueTypes["StringCondition"] | null,
	image?:ValueTypes["ImageUseWhere"] | null,
	contentReference?:ValueTypes["ContentReferenceWhere"] | null,
	target?:ValueTypes["LinkWhere"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	and?:(ValueTypes["ListicleWhere"] | undefined | null)[],
	or?:(ValueTypes["ListicleWhere"] | undefined | null)[],
	not?:ValueTypes["ListicleWhere"] | null
};
	["LinkWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	type?:ValueTypes["LinkTypeCondition"] | null,
	externalTarget?:ValueTypes["StringCondition"] | null,
	internalTarget?:ValueTypes["UrlWhere"] | null,
	queryParameters?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["LinkWhere"] | undefined | null)[],
	or?:(ValueTypes["LinkWhere"] | undefined | null)[],
	not?:ValueTypes["LinkWhere"] | null
};
	["LinkTypeCondition"]: {
	and?:ValueTypes["LinkTypeCondition"][],
	or?:ValueTypes["LinkTypeCondition"][],
	not?:ValueTypes["LinkTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["LinkType"] | null,
	notEq?:ValueTypes["LinkType"] | null,
	in?:ValueTypes["LinkType"][],
	notIn?:ValueTypes["LinkType"][],
	lt?:ValueTypes["LinkType"] | null,
	lte?:ValueTypes["LinkType"] | null,
	gt?:ValueTypes["LinkType"] | null,
	gte?:ValueTypes["LinkType"] | null
};
	["LinkType"]:LinkType;
	["FAQWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	answer?:ValueTypes["StringCondition"] | null,
	question?:ValueTypes["StringCondition"] | null,
	contentReference?:ValueTypes["ContentReferenceWhere"] | null,
	and?:(ValueTypes["FAQWhere"] | undefined | null)[],
	or?:(ValueTypes["FAQWhere"] | undefined | null)[],
	not?:ValueTypes["FAQWhere"] | null
};
	["LinkContentWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	contentReference?:ValueTypes["ContentReferenceWhere"] | null,
	text?:ValueTypes["StringCondition"] | null,
	target?:ValueTypes["LinkWhere"] | null,
	and?:(ValueTypes["LinkContentWhere"] | undefined | null)[],
	or?:(ValueTypes["LinkContentWhere"] | undefined | null)[],
	not?:ValueTypes["LinkContentWhere"] | null
};
	["AwardContentWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	image?:ValueTypes["ImageUseWhere"] | null,
	contentReference?:ValueTypes["ContentReferenceWhere"] | null,
	target?:ValueTypes["LinkWhere"] | null,
	and?:(ValueTypes["AwardContentWhere"] | undefined | null)[],
	or?:(ValueTypes["AwardContentWhere"] | undefined | null)[],
	not?:ValueTypes["AwardContentWhere"] | null
};
	["ReviewContentWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	text?:ValueTypes["StringCondition"] | null,
	contentReference?:ValueTypes["ContentReferenceWhere"] | null,
	and?:(ValueTypes["ReviewContentWhere"] | undefined | null)[],
	or?:(ValueTypes["ReviewContentWhere"] | undefined | null)[],
	not?:ValueTypes["ReviewContentWhere"] | null
};
	["SubscriptionFormWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	code?:ValueTypes["StringCondition"] | null,
	createdAt?:ValueTypes["DateTimeCondition"] | null,
	sections?:ValueTypes["SubscriptionFormSectionWhere"] | null,
	contentBlock?:ValueTypes["ContentBlockWhere"] | null,
	products?:ValueTypes["ProductWhere"] | null,
	contentReferences?:ValueTypes["ContentReferenceWhere"] | null,
	validity?:ValueTypes["DateTimeCondition"] | null,
	and?:(ValueTypes["SubscriptionFormWhere"] | undefined | null)[],
	or?:(ValueTypes["SubscriptionFormWhere"] | undefined | null)[],
	not?:ValueTypes["SubscriptionFormWhere"] | null
};
	["DateTimeCondition"]: {
	and?:ValueTypes["DateTimeCondition"][],
	or?:ValueTypes["DateTimeCondition"][],
	not?:ValueTypes["DateTimeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["DateTime"] | null,
	notEq?:ValueTypes["DateTime"] | null,
	in?:ValueTypes["DateTime"][],
	notIn?:ValueTypes["DateTime"][],
	lt?:ValueTypes["DateTime"] | null,
	lte?:ValueTypes["DateTime"] | null,
	gt?:ValueTypes["DateTime"] | null,
	gte?:ValueTypes["DateTime"] | null
};
	["DateTime"]:unknown;
	["SubscriptionFormSectionWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	form?:ValueTypes["SubscriptionFormWhere"] | null,
	inputs?:ValueTypes["SubscriptionFormInputWhere"] | null,
	and?:(ValueTypes["SubscriptionFormSectionWhere"] | undefined | null)[],
	or?:(ValueTypes["SubscriptionFormSectionWhere"] | undefined | null)[],
	not?:ValueTypes["SubscriptionFormSectionWhere"] | null
};
	["SubscriptionFormInputWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	type?:ValueTypes["SubscriptionFormInputTypeCondition"] | null,
	image?:ValueTypes["ImageUseWhere"] | null,
	section?:ValueTypes["SubscriptionFormSectionWhere"] | null,
	options?:ValueTypes["SubscriptionFormOptionWhere"] | null,
	description?:ValueTypes["ContentWhere"] | null,
	required?:ValueTypes["BooleanCondition"] | null,
	and?:(ValueTypes["SubscriptionFormInputWhere"] | undefined | null)[],
	or?:(ValueTypes["SubscriptionFormInputWhere"] | undefined | null)[],
	not?:ValueTypes["SubscriptionFormInputWhere"] | null
};
	["SubscriptionFormInputTypeCondition"]: {
	and?:ValueTypes["SubscriptionFormInputTypeCondition"][],
	or?:ValueTypes["SubscriptionFormInputTypeCondition"][],
	not?:ValueTypes["SubscriptionFormInputTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["SubscriptionFormInputType"] | null,
	notEq?:ValueTypes["SubscriptionFormInputType"] | null,
	in?:ValueTypes["SubscriptionFormInputType"][],
	notIn?:ValueTypes["SubscriptionFormInputType"][],
	lt?:ValueTypes["SubscriptionFormInputType"] | null,
	lte?:ValueTypes["SubscriptionFormInputType"] | null,
	gt?:ValueTypes["SubscriptionFormInputType"] | null,
	gte?:ValueTypes["SubscriptionFormInputType"] | null
};
	["SubscriptionFormInputType"]:SubscriptionFormInputType;
	["SubscriptionFormOptionWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	hasProductId?:ValueTypes["BooleanCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	label?:ValueTypes["StringCondition"] | null,
	priceTag?:ValueTypes["StringCondition"] | null,
	priceTagWithDiscount?:ValueTypes["StringCondition"] | null,
	products?:ValueTypes["ProductWhere"] | null,
	formInput?:ValueTypes["SubscriptionFormInputWhere"] | null,
	value?:ValueTypes["StringCondition"] | null,
	internalLabel?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["SubscriptionFormOptionWhere"] | undefined | null)[],
	or?:(ValueTypes["SubscriptionFormOptionWhere"] | undefined | null)[],
	not?:ValueTypes["SubscriptionFormOptionWhere"] | null
};
	["ProductWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	price?:ValueTypes["IntCondition"] | null,
	type?:ValueTypes["TypesCondition"] | null,
	formOptions?:ValueTypes["SubscriptionFormOptionWhere"] | null,
	form?:ValueTypes["SubscriptionFormWhere"] | null,
	productId?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["ProductWhere"] | undefined | null)[],
	or?:(ValueTypes["ProductWhere"] | undefined | null)[],
	not?:ValueTypes["ProductWhere"] | null
};
	["TypesCondition"]: {
	and?:ValueTypes["TypesCondition"][],
	or?:ValueTypes["TypesCondition"][],
	not?:ValueTypes["TypesCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["Types"] | null,
	notEq?:ValueTypes["Types"] | null,
	in?:ValueTypes["Types"][],
	notIn?:ValueTypes["Types"][],
	lt?:ValueTypes["Types"] | null,
	lte?:ValueTypes["Types"] | null,
	gt?:ValueTypes["Types"] | null,
	gte?:ValueTypes["Types"] | null
};
	["Types"]:Types;
	["ContentBlockWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	type?:ValueTypes["ContentBlockTypeCondition"] | null,
	youtubeId?:ValueTypes["StringCondition"] | null,
	text?:ValueTypes["StringCondition"] | null,
	targetLabel?:ValueTypes["StringCondition"] | null,
	issue?:ValueTypes["IssueWhere"] | null,
	target?:ValueTypes["LinkWhere"] | null,
	articles?:ValueTypes["ContentArticleWhere"] | null,
	subscriptionForm?:ValueTypes["SubscriptionFormWhere"] | null,
	and?:(ValueTypes["ContentBlockWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentBlockWhere"] | undefined | null)[],
	not?:ValueTypes["ContentBlockWhere"] | null
};
	["ContentBlockTypeCondition"]: {
	and?:ValueTypes["ContentBlockTypeCondition"][],
	or?:ValueTypes["ContentBlockTypeCondition"][],
	not?:ValueTypes["ContentBlockTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["ContentBlockType"] | null,
	notEq?:ValueTypes["ContentBlockType"] | null,
	in?:ValueTypes["ContentBlockType"][],
	notIn?:ValueTypes["ContentBlockType"][],
	lt?:ValueTypes["ContentBlockType"] | null,
	lte?:ValueTypes["ContentBlockType"] | null,
	gt?:ValueTypes["ContentBlockType"] | null,
	gte?:ValueTypes["ContentBlockType"] | null
};
	["ContentBlockType"]:ContentBlockType;
	["IssueWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	closed?:ValueTypes["BooleanCondition"] | null,
	free?:ValueTypes["BooleanCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	subtitle?:ValueTypes["StringCondition"] | null,
	year?:ValueTypes["IntCondition"] | null,
	issue?:ValueTypes["IntCondition"] | null,
	publishedSince?:ValueTypes["DateCondition"] | null,
	publishedUntil?:ValueTypes["DateCondition"] | null,
	publishDigital?:ValueTypes["DateTimeCondition"] | null,
	mobileAppsKey?:ValueTypes["StringCondition"] | null,
	url?:ValueTypes["UrlWhere"] | null,
	articles?:ValueTypes["IssueArticleWhere"] | null,
	kind?:ValueTypes["IssueKindCondition"] | null,
	notificationTitle?:ValueTypes["StringCondition"] | null,
	notificationMessage?:ValueTypes["StringCondition"] | null,
	pdf?:ValueTypes["FileUseWhere"] | null,
	printBuy?:ValueTypes["BooleanCondition"] | null,
	printText?:ValueTypes["StringCondition"] | null,
	blocks?:ValueTypes["ContentBlockWhere"] | null,
	coverPhoto?:ValueTypes["ImageUseWhere"] | null,
	printTarget?:ValueTypes["LinkWhere"] | null,
	backgroundPhoto?:ValueTypes["ImageUseWhere"] | null,
	legacyId?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["IssueWhere"] | undefined | null)[],
	or?:(ValueTypes["IssueWhere"] | undefined | null)[],
	not?:ValueTypes["IssueWhere"] | null
};
	["DateCondition"]: {
	and?:ValueTypes["DateCondition"][],
	or?:ValueTypes["DateCondition"][],
	not?:ValueTypes["DateCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["Date"] | null,
	notEq?:ValueTypes["Date"] | null,
	in?:ValueTypes["Date"][],
	notIn?:ValueTypes["Date"][],
	lt?:ValueTypes["Date"] | null,
	lte?:ValueTypes["Date"] | null,
	gt?:ValueTypes["Date"] | null,
	gte?:ValueTypes["Date"] | null
};
	["Date"]:unknown;
	["IssueArticleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	issue?:ValueTypes["IssueWhere"] | null,
	article?:ValueTypes["ArticleWhere"] | null,
	order?:ValueTypes["IntCondition"] | null,
	and?:(ValueTypes["IssueArticleWhere"] | undefined | null)[],
	or?:(ValueTypes["IssueArticleWhere"] | undefined | null)[],
	not?:ValueTypes["IssueArticleWhere"] | null
};
	["IssueKindCondition"]: {
	and?:ValueTypes["IssueKindCondition"][],
	or?:ValueTypes["IssueKindCondition"][],
	not?:ValueTypes["IssueKindCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["IssueKind"] | null,
	notEq?:ValueTypes["IssueKind"] | null,
	in?:ValueTypes["IssueKind"][],
	notIn?:ValueTypes["IssueKind"][],
	lt?:ValueTypes["IssueKind"] | null,
	lte?:ValueTypes["IssueKind"] | null,
	gt?:ValueTypes["IssueKind"] | null,
	gte?:ValueTypes["IssueKind"] | null
};
	["IssueKind"]:IssueKind;
	["FileUseWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	file?:ValueTypes["FileWhere"] | null,
	and?:(ValueTypes["FileUseWhere"] | undefined | null)[],
	or?:(ValueTypes["FileUseWhere"] | undefined | null)[],
	not?:ValueTypes["FileUseWhere"] | null
};
	["FileWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	url?:ValueTypes["StringCondition"] | null,
	uses?:ValueTypes["FileUseWhere"] | null,
	and?:(ValueTypes["FileWhere"] | undefined | null)[],
	or?:(ValueTypes["FileWhere"] | undefined | null)[],
	not?:ValueTypes["FileWhere"] | null
};
	["ContentArticleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	contentBlock?:ValueTypes["ContentBlockWhere"] | null,
	article?:ValueTypes["ArticleWhere"] | null,
	and?:(ValueTypes["ContentArticleWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentArticleWhere"] | undefined | null)[],
	not?:ValueTypes["ContentArticleWhere"] | null
};
	["ButtonWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	type?:ValueTypes["ButtonTypeCondition"] | null,
	label?:ValueTypes["StringCondition"] | null,
	target?:ValueTypes["LinkWhere"] | null,
	contentReference?:ValueTypes["ContentReferenceWhere"] | null,
	and?:(ValueTypes["ButtonWhere"] | undefined | null)[],
	or?:(ValueTypes["ButtonWhere"] | undefined | null)[],
	not?:ValueTypes["ButtonWhere"] | null
};
	["ButtonTypeCondition"]: {
	and?:ValueTypes["ButtonTypeCondition"][],
	or?:ValueTypes["ButtonTypeCondition"][],
	not?:ValueTypes["ButtonTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["ButtonType"] | null,
	notEq?:ValueTypes["ButtonType"] | null,
	in?:ValueTypes["ButtonType"][],
	notIn?:ValueTypes["ButtonType"][],
	lt?:ValueTypes["ButtonType"] | null,
	lte?:ValueTypes["ButtonType"] | null,
	gt?:ValueTypes["ButtonType"] | null,
	gte?:ValueTypes["ButtonType"] | null
};
	["ButtonType"]:ButtonType;
	["SharedContentWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	contentReference?:ValueTypes["ContentReferenceWhere"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	and?:(ValueTypes["SharedContentWhere"] | undefined | null)[],
	or?:(ValueTypes["SharedContentWhere"] | undefined | null)[],
	not?:ValueTypes["SharedContentWhere"] | null
};
	["AuthorTopArticleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	author?:ValueTypes["AuthorWhere"] | null,
	article?:ValueTypes["ArticleWhere"] | null,
	and?:(ValueTypes["AuthorTopArticleWhere"] | undefined | null)[],
	or?:(ValueTypes["AuthorTopArticleWhere"] | undefined | null)[],
	not?:ValueTypes["AuthorTopArticleWhere"] | null
};
	["UserWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	ihnedId?:ValueTypes["StringCondition"] | null,
	email?:ValueTypes["StringCondition"] | null,
	authors?:ValueTypes["AuthorWhere"] | null,
	unlockedArticles?:ValueTypes["UnlockedArticleWhere"] | null,
	appReviews?:ValueTypes["AppReviewWhere"] | null,
	and?:(ValueTypes["UserWhere"] | undefined | null)[],
	or?:(ValueTypes["UserWhere"] | undefined | null)[],
	not?:ValueTypes["UserWhere"] | null
};
	["UnlockedArticleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	createdAt?:ValueTypes["DateTimeCondition"] | null,
	code?:ValueTypes["StringCondition"] | null,
	views?:ValueTypes["IntCondition"] | null,
	user?:ValueTypes["UserWhere"] | null,
	article?:ValueTypes["ArticleWhere"] | null,
	and?:(ValueTypes["UnlockedArticleWhere"] | undefined | null)[],
	or?:(ValueTypes["UnlockedArticleWhere"] | undefined | null)[],
	not?:ValueTypes["UnlockedArticleWhere"] | null
};
	["AppReviewWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	done?:ValueTypes["BooleanCondition"] | null,
	deviceId?:ValueTypes["StringCondition"] | null,
	createdAt?:ValueTypes["DateTimeCondition"] | null,
	rating?:ValueTypes["IntCondition"] | null,
	note?:ValueTypes["StringCondition"] | null,
	user?:ValueTypes["UserWhere"] | null,
	and?:(ValueTypes["AppReviewWhere"] | undefined | null)[],
	or?:(ValueTypes["AppReviewWhere"] | undefined | null)[],
	not?:ValueTypes["AppReviewWhere"] | null
};
	["AuthorCategoryCondition"]: {
	and?:ValueTypes["AuthorCategoryCondition"][],
	or?:ValueTypes["AuthorCategoryCondition"][],
	not?:ValueTypes["AuthorCategoryCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["AuthorCategory"] | null,
	notEq?:ValueTypes["AuthorCategory"] | null,
	in?:ValueTypes["AuthorCategory"][],
	notIn?:ValueTypes["AuthorCategory"][],
	lt?:ValueTypes["AuthorCategory"] | null,
	lte?:ValueTypes["AuthorCategory"] | null,
	gt?:ValueTypes["AuthorCategory"] | null,
	gte?:ValueTypes["AuthorCategory"] | null
};
	["AuthorCategory"]:AuthorCategory;
	["PageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	publishAt?:ValueTypes["DateTimeCondition"] | null,
	createdAt?:ValueTypes["DateTimeCondition"] | null,
	template?:ValueTypes["PageTemplateCondition"] | null,
	url?:ValueTypes["UrlWhere"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	subscriptionValidity?:ValueTypes["DateTimeCondition"] | null,
	and?:(ValueTypes["PageWhere"] | undefined | null)[],
	or?:(ValueTypes["PageWhere"] | undefined | null)[],
	not?:ValueTypes["PageWhere"] | null
};
	["PageTemplateCondition"]: {
	and?:ValueTypes["PageTemplateCondition"][],
	or?:ValueTypes["PageTemplateCondition"][],
	not?:ValueTypes["PageTemplateCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["PageTemplate"] | null,
	notEq?:ValueTypes["PageTemplate"] | null,
	in?:ValueTypes["PageTemplate"][],
	notIn?:ValueTypes["PageTemplate"][],
	lt?:ValueTypes["PageTemplate"] | null,
	lte?:ValueTypes["PageTemplate"] | null,
	gt?:ValueTypes["PageTemplate"] | null,
	gte?:ValueTypes["PageTemplate"] | null
};
	["PageTemplate"]:PageTemplate;
	["SeoWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	description?:ValueTypes["StringCondition"] | null,
	ogTitle?:ValueTypes["StringCondition"] | null,
	ogDescription?:ValueTypes["StringCondition"] | null,
	page?:ValueTypes["PageWhere"] | null,
	twCard?:ValueTypes["SeoTwCardCondition"] | null,
	ogImage?:ValueTypes["ImageUseWhere"] | null,
	and?:(ValueTypes["SeoWhere"] | undefined | null)[],
	or?:(ValueTypes["SeoWhere"] | undefined | null)[],
	not?:ValueTypes["SeoWhere"] | null
};
	["SeoTwCardCondition"]: {
	and?:ValueTypes["SeoTwCardCondition"][],
	or?:ValueTypes["SeoTwCardCondition"][],
	not?:ValueTypes["SeoTwCardCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["SeoTwCard"] | null,
	notEq?:ValueTypes["SeoTwCard"] | null,
	in?:ValueTypes["SeoTwCard"][],
	notIn?:ValueTypes["SeoTwCard"][],
	lt?:ValueTypes["SeoTwCard"] | null,
	lte?:ValueTypes["SeoTwCard"] | null,
	gt?:ValueTypes["SeoTwCard"] | null,
	gte?:ValueTypes["SeoTwCard"] | null
};
	["SeoTwCard"]:SeoTwCard;
	["CategoryWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	articleCategory?:ValueTypes["ArticleCategoryWhere"] | null,
	url?:ValueTypes["UrlWhere"] | null,
	legacyId?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["CategoryWhere"] | undefined | null)[],
	or?:(ValueTypes["CategoryWhere"] | undefined | null)[],
	not?:ValueTypes["CategoryWhere"] | null
};
	["ArticleCategoryWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	article?:ValueTypes["ArticleWhere"] | null,
	category?:ValueTypes["CategoryWhere"] | null,
	and?:(ValueTypes["ArticleCategoryWhere"] | undefined | null)[],
	or?:(ValueTypes["ArticleCategoryWhere"] | undefined | null)[],
	not?:ValueTypes["ArticleCategoryWhere"] | null
};
	["TagWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	useAsTagline?:ValueTypes["BooleanCondition"] | null,
	articleTag?:ValueTypes["ArticleTagWhere"] | null,
	url?:ValueTypes["UrlWhere"] | null,
	order?:ValueTypes["StringCondition"] | null,
	legacyId?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["TagWhere"] | undefined | null)[],
	or?:(ValueTypes["TagWhere"] | undefined | null)[],
	not?:ValueTypes["TagWhere"] | null
};
	["ArticleTagWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	tag?:ValueTypes["TagWhere"] | null,
	article?:ValueTypes["ArticleWhere"] | null,
	and?:(ValueTypes["ArticleTagWhere"] | undefined | null)[],
	or?:(ValueTypes["ArticleTagWhere"] | undefined | null)[],
	not?:ValueTypes["ArticleTagWhere"] | null
};
	["ArticleAuthorWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	article?:ValueTypes["ArticleWhere"] | null,
	author?:ValueTypes["AuthorWhere"] | null,
	legacyStringAuthor?:ValueTypes["ArticleAuthorLegacyStringAuthorCondition"] | null,
	and?:(ValueTypes["ArticleAuthorWhere"] | undefined | null)[],
	or?:(ValueTypes["ArticleAuthorWhere"] | undefined | null)[],
	not?:ValueTypes["ArticleAuthorWhere"] | null
};
	["ArticleAuthorLegacyStringAuthorCondition"]: {
	and?:ValueTypes["ArticleAuthorLegacyStringAuthorCondition"][],
	or?:ValueTypes["ArticleAuthorLegacyStringAuthorCondition"][],
	not?:ValueTypes["ArticleAuthorLegacyStringAuthorCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["ArticleAuthorLegacyStringAuthor"] | null,
	notEq?:ValueTypes["ArticleAuthorLegacyStringAuthor"] | null,
	in?:ValueTypes["ArticleAuthorLegacyStringAuthor"][],
	notIn?:ValueTypes["ArticleAuthorLegacyStringAuthor"][],
	lt?:ValueTypes["ArticleAuthorLegacyStringAuthor"] | null,
	lte?:ValueTypes["ArticleAuthorLegacyStringAuthor"] | null,
	gt?:ValueTypes["ArticleAuthorLegacyStringAuthor"] | null,
	gte?:ValueTypes["ArticleAuthorLegacyStringAuthor"] | null
};
	["ArticleAuthorLegacyStringAuthor"]:ArticleAuthorLegacyStringAuthor;
	["ArticleStateCondition"]: {
	and?:ValueTypes["ArticleStateCondition"][],
	or?:ValueTypes["ArticleStateCondition"][],
	not?:ValueTypes["ArticleStateCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["ArticleState"] | null,
	notEq?:ValueTypes["ArticleState"] | null,
	in?:ValueTypes["ArticleState"][],
	notIn?:ValueTypes["ArticleState"][],
	lt?:ValueTypes["ArticleState"] | null,
	lte?:ValueTypes["ArticleState"] | null,
	gt?:ValueTypes["ArticleState"] | null,
	gte?:ValueTypes["ArticleState"] | null
};
	["ArticleState"]:ArticleState;
	["TemplateCondition"]: {
	and?:ValueTypes["TemplateCondition"][],
	or?:ValueTypes["TemplateCondition"][],
	not?:ValueTypes["TemplateCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["Template"] | null,
	notEq?:ValueTypes["Template"] | null,
	in?:ValueTypes["Template"][],
	notIn?:ValueTypes["Template"][],
	lt?:ValueTypes["Template"] | null,
	lte?:ValueTypes["Template"] | null,
	gt?:ValueTypes["Template"] | null,
	gte?:ValueTypes["Template"] | null
};
	["Template"]:Template;
	["TextContentWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	parts?:ValueTypes["TextContentPartWhere"] | null,
	and?:(ValueTypes["TextContentWhere"] | undefined | null)[],
	or?:(ValueTypes["TextContentWhere"] | undefined | null)[],
	not?:ValueTypes["TextContentWhere"] | null
};
	["TextContentPartWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	json?:ValueTypes["StringCondition"] | null,
	content?:ValueTypes["TextContentWhere"] | null,
	references?:ValueTypes["TextContentReferenceWhere"] | null,
	and?:(ValueTypes["TextContentPartWhere"] | undefined | null)[],
	or?:(ValueTypes["TextContentPartWhere"] | undefined | null)[],
	not?:ValueTypes["TextContentPartWhere"] | null
};
	["TextContentReferenceWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	type?:ValueTypes["TextContentReferenceTypeCondition"] | null,
	contentPart?:ValueTypes["TextContentPartWhere"] | null,
	target?:ValueTypes["LinkWhere"] | null,
	and?:(ValueTypes["TextContentReferenceWhere"] | undefined | null)[],
	or?:(ValueTypes["TextContentReferenceWhere"] | undefined | null)[],
	not?:ValueTypes["TextContentReferenceWhere"] | null
};
	["TextContentReferenceTypeCondition"]: {
	and?:ValueTypes["TextContentReferenceTypeCondition"][],
	or?:ValueTypes["TextContentReferenceTypeCondition"][],
	not?:ValueTypes["TextContentReferenceTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["TextContentReferenceType"] | null,
	notEq?:ValueTypes["TextContentReferenceType"] | null,
	in?:ValueTypes["TextContentReferenceType"][],
	notIn?:ValueTypes["TextContentReferenceType"][],
	lt?:ValueTypes["TextContentReferenceType"] | null,
	lte?:ValueTypes["TextContentReferenceType"] | null,
	gt?:ValueTypes["TextContentReferenceType"] | null,
	gte?:ValueTypes["TextContentReferenceType"] | null
};
	["TextContentReferenceType"]:TextContentReferenceType;
	["ArticleTitleAlignmentCondition"]: {
	and?:ValueTypes["ArticleTitleAlignmentCondition"][],
	or?:ValueTypes["ArticleTitleAlignmentCondition"][],
	not?:ValueTypes["ArticleTitleAlignmentCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["ArticleTitleAlignment"] | null,
	notEq?:ValueTypes["ArticleTitleAlignment"] | null,
	in?:ValueTypes["ArticleTitleAlignment"][],
	notIn?:ValueTypes["ArticleTitleAlignment"][],
	lt?:ValueTypes["ArticleTitleAlignment"] | null,
	lte?:ValueTypes["ArticleTitleAlignment"] | null,
	gt?:ValueTypes["ArticleTitleAlignment"] | null,
	gte?:ValueTypes["ArticleTitleAlignment"] | null
};
	["ArticleTitleAlignment"]:ArticleTitleAlignment;
	["ArticleHistoryTagWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	article?:ValueTypes["ArticleWhere"] | null,
	historyTag?:ValueTypes["HistoryTagWhere"] | null,
	and?:(ValueTypes["ArticleHistoryTagWhere"] | undefined | null)[],
	or?:(ValueTypes["ArticleHistoryTagWhere"] | undefined | null)[],
	not?:ValueTypes["ArticleHistoryTagWhere"] | null
};
	["HistoryTagWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	articleHistoryTag?:ValueTypes["ArticleHistoryTagWhere"] | null,
	slug?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["HistoryTagWhere"] | undefined | null)[],
	or?:(ValueTypes["HistoryTagWhere"] | undefined | null)[],
	not?:ValueTypes["HistoryTagWhere"] | null
};
	["ArticleHistoryPeriodWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	article?:ValueTypes["ArticleWhere"] | null,
	historyPeriod?:ValueTypes["HistoryPeriodWhere"] | null,
	and?:(ValueTypes["ArticleHistoryPeriodWhere"] | undefined | null)[],
	or?:(ValueTypes["ArticleHistoryPeriodWhere"] | undefined | null)[],
	not?:ValueTypes["ArticleHistoryPeriodWhere"] | null
};
	["HistoryPeriodWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	articleHistoryPeriod?:ValueTypes["ArticleHistoryPeriodWhere"] | null,
	slug?:ValueTypes["StringCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	cover?:ValueTypes["HistoryCoverWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	and?:(ValueTypes["HistoryPeriodWhere"] | undefined | null)[],
	or?:(ValueTypes["HistoryPeriodWhere"] | undefined | null)[],
	not?:ValueTypes["HistoryPeriodWhere"] | null
};
	["HistoryCoverWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	tileParagraph?:ValueTypes["StringCondition"] | null,
	coverImage?:ValueTypes["ImageUseWhere"] | null,
	tileImage?:ValueTypes["ImageUseWhere"] | null,
	mobileImage?:ValueTypes["ImageUseWhere"] | null,
	leadContent?:ValueTypes["ContentWhere"] | null,
	annotations?:ValueTypes["HistoryTextListWhere"] | null,
	and?:(ValueTypes["HistoryCoverWhere"] | undefined | null)[],
	or?:(ValueTypes["HistoryCoverWhere"] | undefined | null)[],
	not?:ValueTypes["HistoryCoverWhere"] | null
};
	["HistoryTextListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["HistoryTextItemWhere"] | null,
	and?:(ValueTypes["HistoryTextListWhere"] | undefined | null)[],
	or?:(ValueTypes["HistoryTextListWhere"] | undefined | null)[],
	not?:ValueTypes["HistoryTextListWhere"] | null
};
	["HistoryTextItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	key?:ValueTypes["StringCondition"] | null,
	text?:ValueTypes["StringCondition"] | null,
	list?:ValueTypes["HistoryTextListWhere"] | null,
	image?:ValueTypes["ImageUseWhere"] | null,
	and?:(ValueTypes["HistoryTextItemWhere"] | undefined | null)[],
	or?:(ValueTypes["HistoryTextItemWhere"] | undefined | null)[],
	not?:ValueTypes["HistoryTextItemWhere"] | null
};
	["Author"]: AliasType<{
	_meta?:ValueTypes["AuthorMeta"],
	id?:boolean,
	name?:boolean,
	position?:boolean,
	twitterHandle?:boolean,
	facebookId?:boolean,
	email?:boolean,
	photographer?:boolean,
	order?:boolean,
about?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
topArticles?: [{	filter?:ValueTypes["AuthorTopArticleWhere"] | null,	orderBy?:ValueTypes["AuthorTopArticleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["AuthorTopArticle"]],
users?: [{	filter?:ValueTypes["UserWhere"] | null,	orderBy?:ValueTypes["UserOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["User"]],
	startOfCooperation?:boolean,
photo?: [{	filter?:ValueTypes["ImageUseWhere"] | null},ValueTypes["ImageUse"]],
illustration?: [{	filter?:ValueTypes["ImageUseWhere"] | null},ValueTypes["ImageUse"]],
	legacyId?:boolean,
	category?:boolean,
url?: [{	filter?:ValueTypes["UrlWhere"] | null},ValueTypes["Url"]],
	instagramUsername?:boolean,
paginateTopArticles?: [{	filter?:ValueTypes["AuthorTopArticleWhere"] | null,	orderBy?:ValueTypes["AuthorTopArticleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AuthorTopArticleConnection"]],
paginateUsers?: [{	filter?:ValueTypes["UserWhere"] | null,	orderBy?:ValueTypes["UserOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["UserConnection"]],
		__typename?: boolean
}>;
	["AuthorMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	position?:ValueTypes["FieldMeta"],
	twitterHandle?:ValueTypes["FieldMeta"],
	facebookId?:ValueTypes["FieldMeta"],
	email?:ValueTypes["FieldMeta"],
	photographer?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	about?:ValueTypes["FieldMeta"],
	topArticles?:ValueTypes["FieldMeta"],
	users?:ValueTypes["FieldMeta"],
	startOfCooperation?:ValueTypes["FieldMeta"],
	photo?:ValueTypes["FieldMeta"],
	illustration?:ValueTypes["FieldMeta"],
	legacyId?:ValueTypes["FieldMeta"],
	category?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	instagramUsername?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Content"]: AliasType<{
	_meta?:ValueTypes["ContentMeta"],
	id?:boolean,
parts?: [{	filter?:ValueTypes["ContentPartWhere"] | null,	orderBy?:ValueTypes["ContentPartOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentPart"]],
partsByReferences?: [{	by:ValueTypes["ContentPartsByReferencesUniqueWhere"],	filter?:ValueTypes["ContentPartWhere"] | null},ValueTypes["ContentPart"]],
paginateParts?: [{	filter?:ValueTypes["ContentPartWhere"] | null,	orderBy?:ValueTypes["ContentPartOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentPartConnection"]],
		__typename?: boolean
}>;
	["ContentMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	parts?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ContentPart"]: AliasType<{
	_meta?:ValueTypes["ContentPartMeta"],
	id?:boolean,
	order?:boolean,
	json?:boolean,
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
references?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentReference"]],
referencesByEmbed?: [{	by:ValueTypes["ContentPartReferencesByEmbedUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
referencesByAudio?: [{	by:ValueTypes["ContentPartReferencesByAudioUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
referencesByImage?: [{	by:ValueTypes["ContentPartReferencesByImageUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
referencesByPollAnswer?: [{	by:ValueTypes["ContentPartReferencesByPollAnswerUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
referencesByListicle?: [{	by:ValueTypes["ContentPartReferencesByListicleUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
referencesByFaq?: [{	by:ValueTypes["ContentPartReferencesByFaqUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
referencesByLinks?: [{	by:ValueTypes["ContentPartReferencesByLinksUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
referencesByAwards?: [{	by:ValueTypes["ContentPartReferencesByAwardsUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
referencesByReviews?: [{	by:ValueTypes["ContentPartReferencesByReviewsUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
referencesByTarget?: [{	by:ValueTypes["ContentPartReferencesByTargetUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
referencesByButtons?: [{	by:ValueTypes["ContentPartReferencesByButtonsUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
paginateReferences?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentReferenceConnection"]],
		__typename?: boolean
}>;
	["ContentPartMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	json?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	references?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ContentReference"]: AliasType<{
	_meta?:ValueTypes["ContentReferenceMeta"],
	id?:boolean,
	type?:boolean,
contentPart?: [{	filter?:ValueTypes["ContentPartWhere"] | null},ValueTypes["ContentPart"]],
	primaryText?:boolean,
	secondaryText?:boolean,
	variant?:boolean,
	color?:boolean,
embed?: [{	filter?:ValueTypes["EmbedWhere"] | null},ValueTypes["Embed"]],
article?: [{	filter?:ValueTypes["ArticleWhere"] | null},ValueTypes["Article"]],
audio?: [{	filter?:ValueTypes["AudioUseWhere"] | null},ValueTypes["AudioUse"]],
image?: [{	filter?:ValueTypes["ImageUseWhere"] | null},ValueTypes["ImageUse"]],
images?: [{	filter?:ValueTypes["ImageContentWhere"] | null,	orderBy?:ValueTypes["ImageContentOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ImageContent"]],
pollAnswer?: [{	filter?:ValueTypes["PollAnswerWhere"] | null},ValueTypes["PollAnswer"]],
listicle?: [{	filter?:ValueTypes["ListicleWhere"] | null,	orderBy?:ValueTypes["ListicleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Listicle"]],
faq?: [{	filter?:ValueTypes["FAQWhere"] | null,	orderBy?:ValueTypes["FAQOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FAQ"]],
links?: [{	filter?:ValueTypes["LinkContentWhere"] | null,	orderBy?:ValueTypes["LinkContentOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["LinkContent"]],
awards?: [{	filter?:ValueTypes["AwardContentWhere"] | null,	orderBy?:ValueTypes["AwardContentOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["AwardContent"]],
reviews?: [{	filter?:ValueTypes["ReviewContentWhere"] | null,	orderBy?:ValueTypes["ReviewContentOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ReviewContent"]],
target?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
subscriptionForm?: [{	filter?:ValueTypes["SubscriptionFormWhere"] | null},ValueTypes["SubscriptionForm"]],
buttons?: [{	filter?:ValueTypes["ButtonWhere"] | null,	orderBy?:ValueTypes["ButtonOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Button"]],
sharedContent?: [{	filter?:ValueTypes["SharedContentWhere"] | null},ValueTypes["SharedContent"]],
buttonsByTarget?: [{	by:ValueTypes["ContentReferenceButtonsByTargetUniqueWhere"],	filter?:ValueTypes["ButtonWhere"] | null},ValueTypes["Button"]],
paginateImages?: [{	filter?:ValueTypes["ImageContentWhere"] | null,	orderBy?:ValueTypes["ImageContentOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageContentConnection"]],
paginateListicle?: [{	filter?:ValueTypes["ListicleWhere"] | null,	orderBy?:ValueTypes["ListicleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ListicleConnection"]],
paginateFaq?: [{	filter?:ValueTypes["FAQWhere"] | null,	orderBy?:ValueTypes["FAQOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FAQConnection"]],
paginateLinks?: [{	filter?:ValueTypes["LinkContentWhere"] | null,	orderBy?:ValueTypes["LinkContentOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkContentConnection"]],
paginateAwards?: [{	filter?:ValueTypes["AwardContentWhere"] | null,	orderBy?:ValueTypes["AwardContentOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AwardContentConnection"]],
paginateReviews?: [{	filter?:ValueTypes["ReviewContentWhere"] | null,	orderBy?:ValueTypes["ReviewContentOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ReviewContentConnection"]],
paginateButtons?: [{	filter?:ValueTypes["ButtonWhere"] | null,	orderBy?:ValueTypes["ButtonOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ButtonConnection"]],
		__typename?: boolean
}>;
	["ContentReferenceMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	contentPart?:ValueTypes["FieldMeta"],
	primaryText?:ValueTypes["FieldMeta"],
	secondaryText?:ValueTypes["FieldMeta"],
	variant?:ValueTypes["FieldMeta"],
	color?:ValueTypes["FieldMeta"],
	embed?:ValueTypes["FieldMeta"],
	article?:ValueTypes["FieldMeta"],
	audio?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	images?:ValueTypes["FieldMeta"],
	pollAnswer?:ValueTypes["FieldMeta"],
	listicle?:ValueTypes["FieldMeta"],
	faq?:ValueTypes["FieldMeta"],
	links?:ValueTypes["FieldMeta"],
	awards?:ValueTypes["FieldMeta"],
	reviews?:ValueTypes["FieldMeta"],
	target?:ValueTypes["FieldMeta"],
	subscriptionForm?:ValueTypes["FieldMeta"],
	buttons?:ValueTypes["FieldMeta"],
	sharedContent?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Embed"]: AliasType<{
	_meta?:ValueTypes["EmbedMeta"],
	id?:boolean,
	type?:boolean,
	youtubeId?:boolean,
	vimeoId?:boolean,
	spotifyId?:boolean,
	spotifyType?:boolean,
	soundCloudId?:boolean,
		__typename?: boolean
}>;
	["EmbedMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	youtubeId?:ValueTypes["FieldMeta"],
	vimeoId?:ValueTypes["FieldMeta"],
	spotifyId?:ValueTypes["FieldMeta"],
	spotifyType?:ValueTypes["FieldMeta"],
	soundCloudId?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["AudioUse"]: AliasType<{
	_meta?:ValueTypes["AudioUseMeta"],
	id?:boolean,
audio?: [{	filter?:ValueTypes["AudioWhere"] | null},ValueTypes["Audio"]],
		__typename?: boolean
}>;
	["AudioUseMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	audio?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Audio"]: AliasType<{
	_meta?:ValueTypes["AudioMeta"],
	id?:boolean,
	url?:boolean,
	type?:boolean,
author?: [{	filter?:ValueTypes["AuthorWhere"] | null},ValueTypes["Author"]],
uses?: [{	filter?:ValueTypes["AudioUseWhere"] | null,	orderBy?:ValueTypes["AudioUseOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["AudioUse"]],
paginateUses?: [{	filter?:ValueTypes["AudioUseWhere"] | null,	orderBy?:ValueTypes["AudioUseOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AudioUseConnection"]],
		__typename?: boolean
}>;
	["AudioMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	author?:ValueTypes["FieldMeta"],
	uses?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["AudioUseOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	audio?:ValueTypes["AudioOrderBy"] | null
};
	["OrderDirection"]:OrderDirection;
	["AudioOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	author?:ValueTypes["AuthorOrderBy"] | null
};
	["AuthorOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	position?:ValueTypes["OrderDirection"] | null,
	twitterHandle?:ValueTypes["OrderDirection"] | null,
	facebookId?:ValueTypes["OrderDirection"] | null,
	email?:ValueTypes["OrderDirection"] | null,
	photographer?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	about?:ValueTypes["ContentOrderBy"] | null,
	startOfCooperation?:ValueTypes["OrderDirection"] | null,
	photo?:ValueTypes["ImageUseOrderBy"] | null,
	illustration?:ValueTypes["ImageUseOrderBy"] | null,
	legacyId?:ValueTypes["OrderDirection"] | null,
	category?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["UrlOrderBy"] | null,
	instagramUsername?:ValueTypes["OrderDirection"] | null
};
	["ContentOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["ImageUseOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	image?:ValueTypes["ImageOrderBy"] | null
};
	["ImageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["OrderDirection"] | null,
	width?:ValueTypes["OrderDirection"] | null,
	height?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	text?:ValueTypes["OrderDirection"] | null,
	author?:ValueTypes["AuthorOrderBy"] | null,
	align?:ValueTypes["OrderDirection"] | null,
	legacyId?:ValueTypes["OrderDirection"] | null
};
	["UrlOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["OrderDirection"] | null,
	article?:ValueTypes["ArticleOrderBy"] | null,
	author?:ValueTypes["AuthorOrderBy"] | null,
	issue?:ValueTypes["IssueOrderBy"] | null,
	page?:ValueTypes["PageOrderBy"] | null,
	category?:ValueTypes["CategoryOrderBy"] | null,
	tag?:ValueTypes["TagOrderBy"] | null,
	redirect?:ValueTypes["OrderDirection"] | null
};
	["ArticleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["UrlOrderBy"] | null,
	hideInMostRead?:ValueTypes["OrderDirection"] | null,
	hideAds?:ValueTypes["OrderDirection"] | null,
	state?:ValueTypes["OrderDirection"] | null,
	locked?:ValueTypes["OrderDirection"] | null,
	publishAt?:ValueTypes["OrderDirection"] | null,
	template?:ValueTypes["OrderDirection"] | null,
	subtitle?:ValueTypes["TextContentOrderBy"] | null,
	content?:ValueTypes["ContentOrderBy"] | null,
	coverPhoto?:ValueTypes["ImageUseOrderBy"] | null,
	titleAlignment?:ValueTypes["OrderDirection"] | null,
	tagline?:ValueTypes["OrderDirection"] | null,
	createdAt?:ValueTypes["OrderDirection"] | null,
	previewContent?:ValueTypes["ContentOrderBy"] | null,
	audio?:ValueTypes["AudioUseOrderBy"] | null,
	coverPhotoVertical?:ValueTypes["ImageUseOrderBy"] | null,
	legacyId?:ValueTypes["OrderDirection"] | null,
	isHistory?:ValueTypes["OrderDirection"] | null
};
	["TextContentOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["IssueOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	closed?:ValueTypes["OrderDirection"] | null,
	free?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	subtitle?:ValueTypes["OrderDirection"] | null,
	year?:ValueTypes["OrderDirection"] | null,
	issue?:ValueTypes["OrderDirection"] | null,
	publishedSince?:ValueTypes["OrderDirection"] | null,
	publishedUntil?:ValueTypes["OrderDirection"] | null,
	publishDigital?:ValueTypes["OrderDirection"] | null,
	mobileAppsKey?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["UrlOrderBy"] | null,
	kind?:ValueTypes["OrderDirection"] | null,
	notificationTitle?:ValueTypes["OrderDirection"] | null,
	notificationMessage?:ValueTypes["OrderDirection"] | null,
	pdf?:ValueTypes["FileUseOrderBy"] | null,
	printBuy?:ValueTypes["OrderDirection"] | null,
	printText?:ValueTypes["OrderDirection"] | null,
	coverPhoto?:ValueTypes["ImageUseOrderBy"] | null,
	printTarget?:ValueTypes["LinkOrderBy"] | null,
	backgroundPhoto?:ValueTypes["ImageUseOrderBy"] | null,
	legacyId?:ValueTypes["OrderDirection"] | null
};
	["FileUseOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	file?:ValueTypes["FileOrderBy"] | null
};
	["FileOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["OrderDirection"] | null
};
	["LinkOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	externalTarget?:ValueTypes["OrderDirection"] | null,
	internalTarget?:ValueTypes["UrlOrderBy"] | null,
	queryParameters?:ValueTypes["OrderDirection"] | null
};
	["PageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	publishAt?:ValueTypes["OrderDirection"] | null,
	createdAt?:ValueTypes["OrderDirection"] | null,
	template?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["UrlOrderBy"] | null,
	content?:ValueTypes["ContentOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	subscriptionValidity?:ValueTypes["OrderDirection"] | null
};
	["SeoOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	description?:ValueTypes["OrderDirection"] | null,
	ogTitle?:ValueTypes["OrderDirection"] | null,
	ogDescription?:ValueTypes["OrderDirection"] | null,
	page?:ValueTypes["PageOrderBy"] | null,
	twCard?:ValueTypes["OrderDirection"] | null,
	ogImage?:ValueTypes["ImageUseOrderBy"] | null
};
	["CategoryOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["UrlOrderBy"] | null,
	legacyId?:ValueTypes["OrderDirection"] | null
};
	["TagOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	useAsTagline?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["UrlOrderBy"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	legacyId?:ValueTypes["OrderDirection"] | null
};
	["AudioUseConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["AudioUseEdge"],
		__typename?: boolean
}>;
	["PageInfo"]: AliasType<{
	totalCount?:boolean,
		__typename?: boolean
}>;
	["AudioUseEdge"]: AliasType<{
	node?:ValueTypes["AudioUse"],
		__typename?: boolean
}>;
	["ImageUse"]: AliasType<{
	_meta?:ValueTypes["ImageUseMeta"],
	id?:boolean,
	title?:boolean,
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
		__typename?: boolean
}>;
	["ImageUseMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Image"]: AliasType<{
	_meta?:ValueTypes["ImageMeta"],
	id?:boolean,
	url?:boolean,
	width?:boolean,
	height?:boolean,
	title?:boolean,
	text?:boolean,
author?: [{	filter?:ValueTypes["AuthorWhere"] | null},ValueTypes["Author"]],
tags?: [{	filter?:ValueTypes["ImageTagWhere"] | null,	orderBy?:ValueTypes["ImageTagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ImageTag"]],
uses?: [{	filter?:ValueTypes["ImageUseWhere"] | null,	orderBy?:ValueTypes["ImageUseOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ImageUse"]],
	align?:boolean,
	legacyId?:boolean,
paginateTags?: [{	filter?:ValueTypes["ImageTagWhere"] | null,	orderBy?:ValueTypes["ImageTagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageTagConnection"]],
paginateUses?: [{	filter?:ValueTypes["ImageUseWhere"] | null,	orderBy?:ValueTypes["ImageUseOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageUseConnection"]],
		__typename?: boolean
}>;
	["ImageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	width?:ValueTypes["FieldMeta"],
	height?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	author?:ValueTypes["FieldMeta"],
	tags?:ValueTypes["FieldMeta"],
	uses?:ValueTypes["FieldMeta"],
	align?:ValueTypes["FieldMeta"],
	legacyId?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ImageTag"]: AliasType<{
	_meta?:ValueTypes["ImageTagMeta"],
	id?:boolean,
	name?:boolean,
images?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Image"]],
paginateImages?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageConnection"]],
		__typename?: boolean
}>;
	["ImageTagMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	images?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ImageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ImageEdge"],
		__typename?: boolean
}>;
	["ImageEdge"]: AliasType<{
	node?:ValueTypes["Image"],
		__typename?: boolean
}>;
	["ImageTagOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null
};
	["ImageTagConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ImageTagEdge"],
		__typename?: boolean
}>;
	["ImageTagEdge"]: AliasType<{
	node?:ValueTypes["ImageTag"],
		__typename?: boolean
}>;
	["ImageUseConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ImageUseEdge"],
		__typename?: boolean
}>;
	["ImageUseEdge"]: AliasType<{
	node?:ValueTypes["ImageUse"],
		__typename?: boolean
}>;
	["ImageContent"]: AliasType<{
	_meta?:ValueTypes["ImageContentMeta"],
	id?:boolean,
	order?:boolean,
contentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentReference"]],
image?: [{	filter?:ValueTypes["ImageUseWhere"] | null},ValueTypes["ImageUse"]],
paginateContentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentReferenceConnection"]],
		__typename?: boolean
}>;
	["ImageContentMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	contentReference?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ContentReferenceOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	contentPart?:ValueTypes["ContentPartOrderBy"] | null,
	primaryText?:ValueTypes["OrderDirection"] | null,
	secondaryText?:ValueTypes["OrderDirection"] | null,
	variant?:ValueTypes["OrderDirection"] | null,
	color?:ValueTypes["OrderDirection"] | null,
	embed?:ValueTypes["EmbedOrderBy"] | null,
	article?:ValueTypes["ArticleOrderBy"] | null,
	audio?:ValueTypes["AudioUseOrderBy"] | null,
	image?:ValueTypes["ImageUseOrderBy"] | null,
	pollAnswer?:ValueTypes["PollAnswerOrderBy"] | null,
	target?:ValueTypes["LinkOrderBy"] | null,
	subscriptionForm?:ValueTypes["SubscriptionFormOrderBy"] | null,
	sharedContent?:ValueTypes["SharedContentOrderBy"] | null
};
	["ContentPartOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	json?:ValueTypes["OrderDirection"] | null,
	content?:ValueTypes["ContentOrderBy"] | null
};
	["EmbedOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	youtubeId?:ValueTypes["OrderDirection"] | null,
	vimeoId?:ValueTypes["OrderDirection"] | null,
	spotifyId?:ValueTypes["OrderDirection"] | null,
	spotifyType?:ValueTypes["OrderDirection"] | null,
	soundCloudId?:ValueTypes["OrderDirection"] | null
};
	["PollAnswerOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	authorName?:ValueTypes["OrderDirection"] | null,
	authorPosition?:ValueTypes["OrderDirection"] | null,
	text?:ValueTypes["OrderDirection"] | null,
	authorImage?:ValueTypes["ImageUseOrderBy"] | null
};
	["SubscriptionFormOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	code?:ValueTypes["OrderDirection"] | null,
	createdAt?:ValueTypes["OrderDirection"] | null,
	validity?:ValueTypes["OrderDirection"] | null
};
	["SharedContentOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	content?:ValueTypes["ContentOrderBy"] | null
};
	["ContentReferenceConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentReferenceEdge"],
		__typename?: boolean
}>;
	["ContentReferenceEdge"]: AliasType<{
	node?:ValueTypes["ContentReference"],
		__typename?: boolean
}>;
	["ImageContentOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	image?:ValueTypes["ImageUseOrderBy"] | null
};
	["PollAnswer"]: AliasType<{
	_meta?:ValueTypes["PollAnswerMeta"],
	id?:boolean,
	authorName?:boolean,
	authorPosition?:boolean,
	text?:boolean,
authorImage?: [{	filter?:ValueTypes["ImageUseWhere"] | null},ValueTypes["ImageUse"]],
		__typename?: boolean
}>;
	["PollAnswerMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	authorName?:ValueTypes["FieldMeta"],
	authorPosition?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	authorImage?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Listicle"]: AliasType<{
	_meta?:ValueTypes["ListicleMeta"],
	id?:boolean,
	order?:boolean,
	primaryText?:boolean,
image?: [{	filter?:ValueTypes["ImageUseWhere"] | null},ValueTypes["ImageUse"]],
contentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
target?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
		__typename?: boolean
}>;
	["ListicleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	primaryText?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	contentReference?:ValueTypes["FieldMeta"],
	target?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Link"]: AliasType<{
	_meta?:ValueTypes["LinkMeta"],
	id?:boolean,
	type?:boolean,
	externalTarget?:boolean,
internalTarget?: [{	filter?:ValueTypes["UrlWhere"] | null},ValueTypes["Url"]],
	queryParameters?:boolean,
		__typename?: boolean
}>;
	["LinkMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	externalTarget?:ValueTypes["FieldMeta"],
	internalTarget?:ValueTypes["FieldMeta"],
	queryParameters?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ListicleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	primaryText?:ValueTypes["OrderDirection"] | null,
	image?:ValueTypes["ImageUseOrderBy"] | null,
	contentReference?:ValueTypes["ContentReferenceOrderBy"] | null,
	target?:ValueTypes["LinkOrderBy"] | null,
	content?:ValueTypes["ContentOrderBy"] | null
};
	["FAQ"]: AliasType<{
	_meta?:ValueTypes["FAQMeta"],
	id?:boolean,
	order?:boolean,
	answer?:boolean,
	question?:boolean,
contentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
		__typename?: boolean
}>;
	["FAQMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	answer?:ValueTypes["FieldMeta"],
	question?:ValueTypes["FieldMeta"],
	contentReference?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["FAQOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	answer?:ValueTypes["OrderDirection"] | null,
	question?:ValueTypes["OrderDirection"] | null,
	contentReference?:ValueTypes["ContentReferenceOrderBy"] | null
};
	["LinkContent"]: AliasType<{
	_meta?:ValueTypes["LinkContentMeta"],
	id?:boolean,
	order?:boolean,
contentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
	text?:boolean,
target?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
		__typename?: boolean
}>;
	["LinkContentMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	contentReference?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	target?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["LinkContentOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	contentReference?:ValueTypes["ContentReferenceOrderBy"] | null,
	text?:ValueTypes["OrderDirection"] | null,
	target?:ValueTypes["LinkOrderBy"] | null
};
	["AwardContent"]: AliasType<{
	_meta?:ValueTypes["AwardContentMeta"],
	id?:boolean,
	order?:boolean,
image?: [{	filter?:ValueTypes["ImageUseWhere"] | null},ValueTypes["ImageUse"]],
contentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
target?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
		__typename?: boolean
}>;
	["AwardContentMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	contentReference?:ValueTypes["FieldMeta"],
	target?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["AwardContentOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	image?:ValueTypes["ImageUseOrderBy"] | null,
	contentReference?:ValueTypes["ContentReferenceOrderBy"] | null,
	target?:ValueTypes["LinkOrderBy"] | null
};
	["ReviewContent"]: AliasType<{
	_meta?:ValueTypes["ReviewContentMeta"],
	id?:boolean,
	order?:boolean,
	text?:boolean,
contentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
		__typename?: boolean
}>;
	["ReviewContentMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	contentReference?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ReviewContentOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	text?:ValueTypes["OrderDirection"] | null,
	contentReference?:ValueTypes["ContentReferenceOrderBy"] | null
};
	["SubscriptionForm"]: AliasType<{
	_meta?:ValueTypes["SubscriptionFormMeta"],
	id?:boolean,
	name?:boolean,
	code?:boolean,
	createdAt?:boolean,
sections?: [{	filter?:ValueTypes["SubscriptionFormSectionWhere"] | null,	orderBy?:ValueTypes["SubscriptionFormSectionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SubscriptionFormSection"]],
contentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentBlock"]],
products?: [{	filter?:ValueTypes["ProductWhere"] | null,	orderBy?:ValueTypes["ProductOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Product"]],
contentReferences?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentReference"]],
	validity?:boolean,
sectionsByInputs?: [{	by:ValueTypes["SubscriptionFormSectionsByInputsUniqueWhere"],	filter?:ValueTypes["SubscriptionFormSectionWhere"] | null},ValueTypes["SubscriptionFormSection"]],
contentBlockByTarget?: [{	by:ValueTypes["SubscriptionFormContentBlockByTargetUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
contentBlockByArticles?: [{	by:ValueTypes["SubscriptionFormContentBlockByArticlesUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
contentReferencesByEmbed?: [{	by:ValueTypes["SubscriptionFormContentReferencesByEmbedUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
contentReferencesByAudio?: [{	by:ValueTypes["SubscriptionFormContentReferencesByAudioUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
contentReferencesByImage?: [{	by:ValueTypes["SubscriptionFormContentReferencesByImageUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
contentReferencesByPollAnswer?: [{	by:ValueTypes["SubscriptionFormContentReferencesByPollAnswerUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
contentReferencesByListicle?: [{	by:ValueTypes["SubscriptionFormContentReferencesByListicleUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
contentReferencesByFaq?: [{	by:ValueTypes["SubscriptionFormContentReferencesByFaqUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
contentReferencesByLinks?: [{	by:ValueTypes["SubscriptionFormContentReferencesByLinksUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
contentReferencesByAwards?: [{	by:ValueTypes["SubscriptionFormContentReferencesByAwardsUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
contentReferencesByReviews?: [{	by:ValueTypes["SubscriptionFormContentReferencesByReviewsUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
contentReferencesByTarget?: [{	by:ValueTypes["SubscriptionFormContentReferencesByTargetUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
contentReferencesByButtons?: [{	by:ValueTypes["SubscriptionFormContentReferencesByButtonsUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
paginateSections?: [{	filter?:ValueTypes["SubscriptionFormSectionWhere"] | null,	orderBy?:ValueTypes["SubscriptionFormSectionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SubscriptionFormSectionConnection"]],
paginateContentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentBlockConnection"]],
paginateProducts?: [{	filter?:ValueTypes["ProductWhere"] | null,	orderBy?:ValueTypes["ProductOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductConnection"]],
paginateContentReferences?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentReferenceConnection"]],
		__typename?: boolean
}>;
	["SubscriptionFormMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	code?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	sections?:ValueTypes["FieldMeta"],
	contentBlock?:ValueTypes["FieldMeta"],
	products?:ValueTypes["FieldMeta"],
	contentReferences?:ValueTypes["FieldMeta"],
	validity?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["SubscriptionFormSection"]: AliasType<{
	_meta?:ValueTypes["SubscriptionFormSectionMeta"],
	id?:boolean,
	order?:boolean,
	title?:boolean,
form?: [{	filter?:ValueTypes["SubscriptionFormWhere"] | null},ValueTypes["SubscriptionForm"]],
inputs?: [{	filter?:ValueTypes["SubscriptionFormInputWhere"] | null,	orderBy?:ValueTypes["SubscriptionFormInputOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SubscriptionFormInput"]],
inputsByImage?: [{	by:ValueTypes["SubscriptionFormSectionInputsByImageUniqueWhere"],	filter?:ValueTypes["SubscriptionFormInputWhere"] | null},ValueTypes["SubscriptionFormInput"]],
inputsByOptions?: [{	by:ValueTypes["SubscriptionFormSectionInputsByOptionsUniqueWhere"],	filter?:ValueTypes["SubscriptionFormInputWhere"] | null},ValueTypes["SubscriptionFormInput"]],
inputsByDescription?: [{	by:ValueTypes["SubscriptionFormSectionInputsByDescriptionUniqueWhere"],	filter?:ValueTypes["SubscriptionFormInputWhere"] | null},ValueTypes["SubscriptionFormInput"]],
paginateInputs?: [{	filter?:ValueTypes["SubscriptionFormInputWhere"] | null,	orderBy?:ValueTypes["SubscriptionFormInputOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SubscriptionFormInputConnection"]],
		__typename?: boolean
}>;
	["SubscriptionFormSectionMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	form?:ValueTypes["FieldMeta"],
	inputs?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["SubscriptionFormInput"]: AliasType<{
	_meta?:ValueTypes["SubscriptionFormInputMeta"],
	id?:boolean,
	order?:boolean,
	type?:boolean,
image?: [{	filter?:ValueTypes["ImageUseWhere"] | null},ValueTypes["ImageUse"]],
section?: [{	filter?:ValueTypes["SubscriptionFormSectionWhere"] | null},ValueTypes["SubscriptionFormSection"]],
options?: [{	filter?:ValueTypes["SubscriptionFormOptionWhere"] | null,	orderBy?:ValueTypes["SubscriptionFormOptionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SubscriptionFormOption"]],
description?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
	required?:boolean,
paginateOptions?: [{	filter?:ValueTypes["SubscriptionFormOptionWhere"] | null,	orderBy?:ValueTypes["SubscriptionFormOptionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SubscriptionFormOptionConnection"]],
		__typename?: boolean
}>;
	["SubscriptionFormInputMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	section?:ValueTypes["FieldMeta"],
	options?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	required?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["SubscriptionFormOption"]: AliasType<{
	_meta?:ValueTypes["SubscriptionFormOptionMeta"],
	id?:boolean,
	hasProductId?:boolean,
	order?:boolean,
	label?:boolean,
	priceTag?:boolean,
	priceTagWithDiscount?:boolean,
products?: [{	filter?:ValueTypes["ProductWhere"] | null,	orderBy?:ValueTypes["ProductOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Product"]],
formInput?: [{	filter?:ValueTypes["SubscriptionFormInputWhere"] | null},ValueTypes["SubscriptionFormInput"]],
	value?:boolean,
	internalLabel?:boolean,
paginateProducts?: [{	filter?:ValueTypes["ProductWhere"] | null,	orderBy?:ValueTypes["ProductOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductConnection"]],
		__typename?: boolean
}>;
	["SubscriptionFormOptionMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	hasProductId?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	label?:ValueTypes["FieldMeta"],
	priceTag?:ValueTypes["FieldMeta"],
	priceTagWithDiscount?:ValueTypes["FieldMeta"],
	products?:ValueTypes["FieldMeta"],
	formInput?:ValueTypes["FieldMeta"],
	value?:ValueTypes["FieldMeta"],
	internalLabel?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Product"]: AliasType<{
	_meta?:ValueTypes["ProductMeta"],
	id?:boolean,
	price?:boolean,
	type?:boolean,
formOptions?: [{	filter?:ValueTypes["SubscriptionFormOptionWhere"] | null,	orderBy?:ValueTypes["SubscriptionFormOptionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SubscriptionFormOption"]],
form?: [{	filter?:ValueTypes["SubscriptionFormWhere"] | null},ValueTypes["SubscriptionForm"]],
	productId?:boolean,
paginateFormOptions?: [{	filter?:ValueTypes["SubscriptionFormOptionWhere"] | null,	orderBy?:ValueTypes["SubscriptionFormOptionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SubscriptionFormOptionConnection"]],
		__typename?: boolean
}>;
	["ProductMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	price?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	formOptions?:ValueTypes["FieldMeta"],
	form?:ValueTypes["FieldMeta"],
	productId?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["SubscriptionFormOptionOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	hasProductId?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	label?:ValueTypes["OrderDirection"] | null,
	priceTag?:ValueTypes["OrderDirection"] | null,
	priceTagWithDiscount?:ValueTypes["OrderDirection"] | null,
	formInput?:ValueTypes["SubscriptionFormInputOrderBy"] | null,
	value?:ValueTypes["OrderDirection"] | null,
	internalLabel?:ValueTypes["OrderDirection"] | null
};
	["SubscriptionFormInputOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	image?:ValueTypes["ImageUseOrderBy"] | null,
	section?:ValueTypes["SubscriptionFormSectionOrderBy"] | null,
	description?:ValueTypes["ContentOrderBy"] | null,
	required?:ValueTypes["OrderDirection"] | null
};
	["SubscriptionFormSectionOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	form?:ValueTypes["SubscriptionFormOrderBy"] | null
};
	["SubscriptionFormOptionConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SubscriptionFormOptionEdge"],
		__typename?: boolean
}>;
	["SubscriptionFormOptionEdge"]: AliasType<{
	node?:ValueTypes["SubscriptionFormOption"],
		__typename?: boolean
}>;
	["ProductOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	price?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	form?:ValueTypes["SubscriptionFormOrderBy"] | null,
	productId?:ValueTypes["OrderDirection"] | null
};
	["ProductConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ProductEdge"],
		__typename?: boolean
}>;
	["ProductEdge"]: AliasType<{
	node?:ValueTypes["Product"],
		__typename?: boolean
}>;
	["SubscriptionFormSectionInputsByImageUniqueWhere"]: {
	image?:ValueTypes["ImageUseUniqueWhere"] | null
};
	["ImageUseUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["SubscriptionFormSectionInputsByOptionsUniqueWhere"]: {
	options?:ValueTypes["SubscriptionFormOptionUniqueWhere"] | null
};
	["SubscriptionFormOptionUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["SubscriptionFormSectionInputsByDescriptionUniqueWhere"]: {
	description?:ValueTypes["ContentUniqueWhere"] | null
};
	["ContentUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	parts?:ValueTypes["ContentPartUniqueWhere"] | null
};
	["ContentPartUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	references?:ValueTypes["ContentReferenceUniqueWhere"] | null
};
	["ContentReferenceUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	embed?:ValueTypes["EmbedUniqueWhere"] | null,
	audio?:ValueTypes["AudioUseUniqueWhere"] | null,
	image?:ValueTypes["ImageUseUniqueWhere"] | null,
	pollAnswer?:ValueTypes["PollAnswerUniqueWhere"] | null,
	listicle?:ValueTypes["ListicleUniqueWhere"] | null,
	faq?:ValueTypes["FAQUniqueWhere"] | null,
	links?:ValueTypes["LinkContentUniqueWhere"] | null,
	awards?:ValueTypes["AwardContentUniqueWhere"] | null,
	reviews?:ValueTypes["ReviewContentUniqueWhere"] | null,
	target?:ValueTypes["LinkUniqueWhere"] | null,
	buttons?:ValueTypes["ButtonUniqueWhere"] | null
};
	["EmbedUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["AudioUseUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["PollAnswerUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ListicleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["FAQUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["LinkContentUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["AwardContentUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ReviewContentUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["LinkUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ButtonUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	target?:ValueTypes["LinkUniqueWhere"] | null
};
	["SubscriptionFormInputConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SubscriptionFormInputEdge"],
		__typename?: boolean
}>;
	["SubscriptionFormInputEdge"]: AliasType<{
	node?:ValueTypes["SubscriptionFormInput"],
		__typename?: boolean
}>;
	["ContentBlock"]: AliasType<{
	_meta?:ValueTypes["ContentBlockMeta"],
	id?:boolean,
	order?:boolean,
	type?:boolean,
	youtubeId?:boolean,
	text?:boolean,
	targetLabel?:boolean,
issue?: [{	filter?:ValueTypes["IssueWhere"] | null},ValueTypes["Issue"]],
target?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
articles?: [{	filter?:ValueTypes["ContentArticleWhere"] | null,	orderBy?:ValueTypes["ContentArticleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentArticle"]],
subscriptionForm?: [{	filter?:ValueTypes["SubscriptionFormWhere"] | null},ValueTypes["SubscriptionForm"]],
paginateArticles?: [{	filter?:ValueTypes["ContentArticleWhere"] | null,	orderBy?:ValueTypes["ContentArticleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentArticleConnection"]],
		__typename?: boolean
}>;
	["ContentBlockMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	youtubeId?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	targetLabel?:ValueTypes["FieldMeta"],
	issue?:ValueTypes["FieldMeta"],
	target?:ValueTypes["FieldMeta"],
	articles?:ValueTypes["FieldMeta"],
	subscriptionForm?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Issue"]: AliasType<{
	_meta?:ValueTypes["IssueMeta"],
	id?:boolean,
	closed?:boolean,
	free?:boolean,
	title?:boolean,
	subtitle?:boolean,
	year?:boolean,
	issue?:boolean,
	publishedSince?:boolean,
	publishedUntil?:boolean,
	publishDigital?:boolean,
	mobileAppsKey?:boolean,
url?: [{	filter?:ValueTypes["UrlWhere"] | null},ValueTypes["Url"]],
articles?: [{	filter?:ValueTypes["IssueArticleWhere"] | null,	orderBy?:ValueTypes["IssueArticleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["IssueArticle"]],
	kind?:boolean,
	notificationTitle?:boolean,
	notificationMessage?:boolean,
pdf?: [{	filter?:ValueTypes["FileUseWhere"] | null},ValueTypes["FileUse"]],
	printBuy?:boolean,
	printText?:boolean,
blocks?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentBlock"]],
coverPhoto?: [{	filter?:ValueTypes["ImageUseWhere"] | null},ValueTypes["ImageUse"]],
printTarget?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
backgroundPhoto?: [{	filter?:ValueTypes["ImageUseWhere"] | null},ValueTypes["ImageUse"]],
	legacyId?:boolean,
articlesByArticle?: [{	by:ValueTypes["IssueArticlesByArticleUniqueWhere"],	filter?:ValueTypes["IssueArticleWhere"] | null},ValueTypes["IssueArticle"]],
blocksByTarget?: [{	by:ValueTypes["IssueBlocksByTargetUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
blocksByArticles?: [{	by:ValueTypes["IssueBlocksByArticlesUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
paginateArticles?: [{	filter?:ValueTypes["IssueArticleWhere"] | null,	orderBy?:ValueTypes["IssueArticleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["IssueArticleConnection"]],
paginateBlocks?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentBlockConnection"]],
		__typename?: boolean
}>;
	["IssueMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	closed?:ValueTypes["FieldMeta"],
	free?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	subtitle?:ValueTypes["FieldMeta"],
	year?:ValueTypes["FieldMeta"],
	issue?:ValueTypes["FieldMeta"],
	publishedSince?:ValueTypes["FieldMeta"],
	publishedUntil?:ValueTypes["FieldMeta"],
	publishDigital?:ValueTypes["FieldMeta"],
	mobileAppsKey?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	articles?:ValueTypes["FieldMeta"],
	kind?:ValueTypes["FieldMeta"],
	notificationTitle?:ValueTypes["FieldMeta"],
	notificationMessage?:ValueTypes["FieldMeta"],
	pdf?:ValueTypes["FieldMeta"],
	printBuy?:ValueTypes["FieldMeta"],
	printText?:ValueTypes["FieldMeta"],
	blocks?:ValueTypes["FieldMeta"],
	coverPhoto?:ValueTypes["FieldMeta"],
	printTarget?:ValueTypes["FieldMeta"],
	backgroundPhoto?:ValueTypes["FieldMeta"],
	legacyId?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["IssueArticle"]: AliasType<{
	_meta?:ValueTypes["IssueArticleMeta"],
	id?:boolean,
issue?: [{	filter?:ValueTypes["IssueWhere"] | null},ValueTypes["Issue"]],
article?: [{	filter?:ValueTypes["ArticleWhere"] | null},ValueTypes["Article"]],
	order?:boolean,
		__typename?: boolean
}>;
	["IssueArticleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	issue?:ValueTypes["FieldMeta"],
	article?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["IssueArticleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	issue?:ValueTypes["IssueOrderBy"] | null,
	article?:ValueTypes["ArticleOrderBy"] | null,
	order?:ValueTypes["OrderDirection"] | null
};
	["FileUse"]: AliasType<{
	_meta?:ValueTypes["FileUseMeta"],
	id?:boolean,
file?: [{	filter?:ValueTypes["FileWhere"] | null},ValueTypes["File"]],
		__typename?: boolean
}>;
	["FileUseMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	file?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["File"]: AliasType<{
	_meta?:ValueTypes["FileMeta"],
	id?:boolean,
	url?:boolean,
uses?: [{	filter?:ValueTypes["FileUseWhere"] | null,	orderBy?:ValueTypes["FileUseOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FileUse"]],
paginateUses?: [{	filter?:ValueTypes["FileUseWhere"] | null,	orderBy?:ValueTypes["FileUseOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FileUseConnection"]],
		__typename?: boolean
}>;
	["FileMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	uses?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["FileUseConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FileUseEdge"],
		__typename?: boolean
}>;
	["FileUseEdge"]: AliasType<{
	node?:ValueTypes["FileUse"],
		__typename?: boolean
}>;
	["ContentBlockOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	youtubeId?:ValueTypes["OrderDirection"] | null,
	text?:ValueTypes["OrderDirection"] | null,
	targetLabel?:ValueTypes["OrderDirection"] | null,
	issue?:ValueTypes["IssueOrderBy"] | null,
	target?:ValueTypes["LinkOrderBy"] | null,
	subscriptionForm?:ValueTypes["SubscriptionFormOrderBy"] | null
};
	["IssueArticlesByArticleUniqueWhere"]: {
	article?:ValueTypes["ArticleUniqueWhere"] | null
};
	["ArticleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	legacyId?:string | null,
	url?:ValueTypes["UrlUniqueWhere"] | null,
	authors?:ValueTypes["ArticleAuthorUniqueWhere"] | null,
	subtitle?:ValueTypes["TextContentUniqueWhere"] | null,
	content?:ValueTypes["ContentUniqueWhere"] | null,
	coverPhoto?:ValueTypes["ImageUseUniqueWhere"] | null,
	previewContent?:ValueTypes["ContentUniqueWhere"] | null,
	audio?:ValueTypes["AudioUseUniqueWhere"] | null,
	categories?:ValueTypes["ArticleCategoryUniqueWhere"] | null,
	issues?:ValueTypes["IssueArticleUniqueWhere"] | null,
	contentBlocks?:ValueTypes["ContentArticleUniqueWhere"] | null,
	unlocked?:ValueTypes["UnlockedArticleUniqueWhere"] | null,
	coverPhotoVertical?:ValueTypes["ImageUseUniqueWhere"] | null,
	tags?:ValueTypes["ArticleTagUniqueWhere"] | null,
	historyTags?:ValueTypes["ArticleHistoryTagUniqueWhere"] | null,
	historyPeriods?:ValueTypes["ArticleHistoryPeriodUniqueWhere"] | null
};
	["UrlUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	article?:ValueTypes["ArticleUniqueWhere"] | null,
	author?:ValueTypes["AuthorUniqueWhere"] | null,
	issue?:ValueTypes["IssueUniqueWhere"] | null,
	page?:ValueTypes["PageUniqueWhere"] | null,
	category?:ValueTypes["CategoryUniqueWhere"] | null,
	tag?:ValueTypes["TagUniqueWhere"] | null
};
	["AuthorUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	legacyId?:string | null,
	about?:ValueTypes["ContentUniqueWhere"] | null,
	topArticles?:ValueTypes["AuthorTopArticleUniqueWhere"] | null,
	photo?:ValueTypes["ImageUseUniqueWhere"] | null,
	illustration?:ValueTypes["ImageUseUniqueWhere"] | null,
	url?:ValueTypes["UrlUniqueWhere"] | null
};
	["AuthorTopArticleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["IssueUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	kind?:ValueTypes["IssueKind"] | null,
	year?:number | null,
	issue?:number | null,
	legacyId?:string | null,
	url?:ValueTypes["UrlUniqueWhere"] | null,
	articles?:ValueTypes["IssueArticleUniqueWhere"] | null,
	pdf?:ValueTypes["FileUseUniqueWhere"] | null,
	blocks?:ValueTypes["ContentBlockUniqueWhere"] | null,
	coverPhoto?:ValueTypes["ImageUseUniqueWhere"] | null,
	printTarget?:ValueTypes["LinkUniqueWhere"] | null,
	backgroundPhoto?:ValueTypes["ImageUseUniqueWhere"] | null
};
	["IssueArticleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	issue?:ValueTypes["IssueUniqueWhere"] | null,
	article?:ValueTypes["ArticleUniqueWhere"] | null
};
	["FileUseUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ContentBlockUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	target?:ValueTypes["LinkUniqueWhere"] | null,
	articles?:ValueTypes["ContentArticleUniqueWhere"] | null
};
	["ContentArticleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["PageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	url?:ValueTypes["UrlUniqueWhere"] | null,
	content?:ValueTypes["ContentUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["SeoUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	page?:ValueTypes["PageUniqueWhere"] | null
};
	["CategoryUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	legacyId?:string | null,
	articleCategory?:ValueTypes["ArticleCategoryUniqueWhere"] | null,
	url?:ValueTypes["UrlUniqueWhere"] | null
};
	["ArticleCategoryUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	article?:ValueTypes["ArticleUniqueWhere"] | null,
	category?:ValueTypes["CategoryUniqueWhere"] | null
};
	["TagUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	legacyId?:string | null,
	articleTag?:ValueTypes["ArticleTagUniqueWhere"] | null,
	url?:ValueTypes["UrlUniqueWhere"] | null
};
	["ArticleTagUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	article?:ValueTypes["ArticleUniqueWhere"] | null,
	tag?:ValueTypes["TagUniqueWhere"] | null
};
	["ArticleAuthorUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	article?:ValueTypes["ArticleUniqueWhere"] | null,
	author?:ValueTypes["AuthorUniqueWhere"] | null,
	legacyStringAuthor?:ValueTypes["ArticleAuthorLegacyStringAuthor"] | null
};
	["TextContentUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	parts?:ValueTypes["TextContentPartUniqueWhere"] | null
};
	["TextContentPartUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	references?:ValueTypes["TextContentReferenceUniqueWhere"] | null
};
	["TextContentReferenceUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	target?:ValueTypes["LinkUniqueWhere"] | null
};
	["UnlockedArticleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ArticleHistoryTagUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	article?:ValueTypes["ArticleUniqueWhere"] | null,
	historyTag?:ValueTypes["HistoryTagUniqueWhere"] | null
};
	["HistoryTagUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	slug?:string | null,
	articleHistoryTag?:ValueTypes["ArticleHistoryTagUniqueWhere"] | null
};
	["ArticleHistoryPeriodUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	article?:ValueTypes["ArticleUniqueWhere"] | null,
	historyPeriod?:ValueTypes["HistoryPeriodUniqueWhere"] | null
};
	["HistoryPeriodUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	slug?:string | null,
	articleHistoryPeriod?:ValueTypes["ArticleHistoryPeriodUniqueWhere"] | null,
	cover?:ValueTypes["HistoryCoverUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["HistoryCoverUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	coverImage?:ValueTypes["ImageUseUniqueWhere"] | null,
	tileImage?:ValueTypes["ImageUseUniqueWhere"] | null,
	mobileImage?:ValueTypes["ImageUseUniqueWhere"] | null,
	leadContent?:ValueTypes["ContentUniqueWhere"] | null,
	annotations?:ValueTypes["HistoryTextListUniqueWhere"] | null
};
	["HistoryTextListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["HistoryTextItemUniqueWhere"] | null
};
	["HistoryTextItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	image?:ValueTypes["ImageUseUniqueWhere"] | null
};
	["IssueBlocksByTargetUniqueWhere"]: {
	target?:ValueTypes["LinkUniqueWhere"] | null
};
	["IssueBlocksByArticlesUniqueWhere"]: {
	articles?:ValueTypes["ContentArticleUniqueWhere"] | null
};
	["IssueArticleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["IssueArticleEdge"],
		__typename?: boolean
}>;
	["IssueArticleEdge"]: AliasType<{
	node?:ValueTypes["IssueArticle"],
		__typename?: boolean
}>;
	["ContentBlockConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentBlockEdge"],
		__typename?: boolean
}>;
	["ContentBlockEdge"]: AliasType<{
	node?:ValueTypes["ContentBlock"],
		__typename?: boolean
}>;
	["ContentArticle"]: AliasType<{
	_meta?:ValueTypes["ContentArticleMeta"],
	id?:boolean,
	order?:boolean,
contentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
article?: [{	filter?:ValueTypes["ArticleWhere"] | null},ValueTypes["Article"]],
		__typename?: boolean
}>;
	["ContentArticleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	contentBlock?:ValueTypes["FieldMeta"],
	article?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ContentArticleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	contentBlock?:ValueTypes["ContentBlockOrderBy"] | null,
	article?:ValueTypes["ArticleOrderBy"] | null
};
	["ContentArticleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentArticleEdge"],
		__typename?: boolean
}>;
	["ContentArticleEdge"]: AliasType<{
	node?:ValueTypes["ContentArticle"],
		__typename?: boolean
}>;
	["SubscriptionFormSectionsByInputsUniqueWhere"]: {
	inputs?:ValueTypes["SubscriptionFormInputUniqueWhere"] | null
};
	["SubscriptionFormInputUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	image?:ValueTypes["ImageUseUniqueWhere"] | null,
	options?:ValueTypes["SubscriptionFormOptionUniqueWhere"] | null,
	description?:ValueTypes["ContentUniqueWhere"] | null
};
	["SubscriptionFormContentBlockByTargetUniqueWhere"]: {
	target?:ValueTypes["LinkUniqueWhere"] | null
};
	["SubscriptionFormContentBlockByArticlesUniqueWhere"]: {
	articles?:ValueTypes["ContentArticleUniqueWhere"] | null
};
	["SubscriptionFormContentReferencesByEmbedUniqueWhere"]: {
	embed?:ValueTypes["EmbedUniqueWhere"] | null
};
	["SubscriptionFormContentReferencesByAudioUniqueWhere"]: {
	audio?:ValueTypes["AudioUseUniqueWhere"] | null
};
	["SubscriptionFormContentReferencesByImageUniqueWhere"]: {
	image?:ValueTypes["ImageUseUniqueWhere"] | null
};
	["SubscriptionFormContentReferencesByPollAnswerUniqueWhere"]: {
	pollAnswer?:ValueTypes["PollAnswerUniqueWhere"] | null
};
	["SubscriptionFormContentReferencesByListicleUniqueWhere"]: {
	listicle?:ValueTypes["ListicleUniqueWhere"] | null
};
	["SubscriptionFormContentReferencesByFaqUniqueWhere"]: {
	faq?:ValueTypes["FAQUniqueWhere"] | null
};
	["SubscriptionFormContentReferencesByLinksUniqueWhere"]: {
	links?:ValueTypes["LinkContentUniqueWhere"] | null
};
	["SubscriptionFormContentReferencesByAwardsUniqueWhere"]: {
	awards?:ValueTypes["AwardContentUniqueWhere"] | null
};
	["SubscriptionFormContentReferencesByReviewsUniqueWhere"]: {
	reviews?:ValueTypes["ReviewContentUniqueWhere"] | null
};
	["SubscriptionFormContentReferencesByTargetUniqueWhere"]: {
	target?:ValueTypes["LinkUniqueWhere"] | null
};
	["SubscriptionFormContentReferencesByButtonsUniqueWhere"]: {
	buttons?:ValueTypes["ButtonUniqueWhere"] | null
};
	["SubscriptionFormSectionConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SubscriptionFormSectionEdge"],
		__typename?: boolean
}>;
	["SubscriptionFormSectionEdge"]: AliasType<{
	node?:ValueTypes["SubscriptionFormSection"],
		__typename?: boolean
}>;
	["Button"]: AliasType<{
	_meta?:ValueTypes["ButtonMeta"],
	id?:boolean,
	order?:boolean,
	type?:boolean,
	label?:boolean,
target?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
contentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
		__typename?: boolean
}>;
	["ButtonMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	label?:ValueTypes["FieldMeta"],
	target?:ValueTypes["FieldMeta"],
	contentReference?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ButtonOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	label?:ValueTypes["OrderDirection"] | null,
	target?:ValueTypes["LinkOrderBy"] | null,
	contentReference?:ValueTypes["ContentReferenceOrderBy"] | null
};
	["SharedContent"]: AliasType<{
	_meta?:ValueTypes["SharedContentMeta"],
	id?:boolean,
	name?:boolean,
contentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentReference"]],
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
contentReferenceByEmbed?: [{	by:ValueTypes["SharedContentContentReferenceByEmbedUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
contentReferenceByAudio?: [{	by:ValueTypes["SharedContentContentReferenceByAudioUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
contentReferenceByImage?: [{	by:ValueTypes["SharedContentContentReferenceByImageUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
contentReferenceByPollAnswer?: [{	by:ValueTypes["SharedContentContentReferenceByPollAnswerUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
contentReferenceByListicle?: [{	by:ValueTypes["SharedContentContentReferenceByListicleUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
contentReferenceByFaq?: [{	by:ValueTypes["SharedContentContentReferenceByFaqUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
contentReferenceByLinks?: [{	by:ValueTypes["SharedContentContentReferenceByLinksUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
contentReferenceByAwards?: [{	by:ValueTypes["SharedContentContentReferenceByAwardsUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
contentReferenceByReviews?: [{	by:ValueTypes["SharedContentContentReferenceByReviewsUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
contentReferenceByTarget?: [{	by:ValueTypes["SharedContentContentReferenceByTargetUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
contentReferenceByButtons?: [{	by:ValueTypes["SharedContentContentReferenceByButtonsUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
paginateContentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentReferenceConnection"]],
		__typename?: boolean
}>;
	["SharedContentMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	contentReference?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["SharedContentContentReferenceByEmbedUniqueWhere"]: {
	embed?:ValueTypes["EmbedUniqueWhere"] | null
};
	["SharedContentContentReferenceByAudioUniqueWhere"]: {
	audio?:ValueTypes["AudioUseUniqueWhere"] | null
};
	["SharedContentContentReferenceByImageUniqueWhere"]: {
	image?:ValueTypes["ImageUseUniqueWhere"] | null
};
	["SharedContentContentReferenceByPollAnswerUniqueWhere"]: {
	pollAnswer?:ValueTypes["PollAnswerUniqueWhere"] | null
};
	["SharedContentContentReferenceByListicleUniqueWhere"]: {
	listicle?:ValueTypes["ListicleUniqueWhere"] | null
};
	["SharedContentContentReferenceByFaqUniqueWhere"]: {
	faq?:ValueTypes["FAQUniqueWhere"] | null
};
	["SharedContentContentReferenceByLinksUniqueWhere"]: {
	links?:ValueTypes["LinkContentUniqueWhere"] | null
};
	["SharedContentContentReferenceByAwardsUniqueWhere"]: {
	awards?:ValueTypes["AwardContentUniqueWhere"] | null
};
	["SharedContentContentReferenceByReviewsUniqueWhere"]: {
	reviews?:ValueTypes["ReviewContentUniqueWhere"] | null
};
	["SharedContentContentReferenceByTargetUniqueWhere"]: {
	target?:ValueTypes["LinkUniqueWhere"] | null
};
	["SharedContentContentReferenceByButtonsUniqueWhere"]: {
	buttons?:ValueTypes["ButtonUniqueWhere"] | null
};
	["ContentReferenceButtonsByTargetUniqueWhere"]: {
	target?:ValueTypes["LinkUniqueWhere"] | null
};
	["ImageContentConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ImageContentEdge"],
		__typename?: boolean
}>;
	["ImageContentEdge"]: AliasType<{
	node?:ValueTypes["ImageContent"],
		__typename?: boolean
}>;
	["ListicleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ListicleEdge"],
		__typename?: boolean
}>;
	["ListicleEdge"]: AliasType<{
	node?:ValueTypes["Listicle"],
		__typename?: boolean
}>;
	["FAQConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FAQEdge"],
		__typename?: boolean
}>;
	["FAQEdge"]: AliasType<{
	node?:ValueTypes["FAQ"],
		__typename?: boolean
}>;
	["LinkContentConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkContentEdge"],
		__typename?: boolean
}>;
	["LinkContentEdge"]: AliasType<{
	node?:ValueTypes["LinkContent"],
		__typename?: boolean
}>;
	["AwardContentConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["AwardContentEdge"],
		__typename?: boolean
}>;
	["AwardContentEdge"]: AliasType<{
	node?:ValueTypes["AwardContent"],
		__typename?: boolean
}>;
	["ReviewContentConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ReviewContentEdge"],
		__typename?: boolean
}>;
	["ReviewContentEdge"]: AliasType<{
	node?:ValueTypes["ReviewContent"],
		__typename?: boolean
}>;
	["ButtonConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ButtonEdge"],
		__typename?: boolean
}>;
	["ButtonEdge"]: AliasType<{
	node?:ValueTypes["Button"],
		__typename?: boolean
}>;
	["ContentPartReferencesByEmbedUniqueWhere"]: {
	embed?:ValueTypes["EmbedUniqueWhere"] | null
};
	["ContentPartReferencesByAudioUniqueWhere"]: {
	audio?:ValueTypes["AudioUseUniqueWhere"] | null
};
	["ContentPartReferencesByImageUniqueWhere"]: {
	image?:ValueTypes["ImageUseUniqueWhere"] | null
};
	["ContentPartReferencesByPollAnswerUniqueWhere"]: {
	pollAnswer?:ValueTypes["PollAnswerUniqueWhere"] | null
};
	["ContentPartReferencesByListicleUniqueWhere"]: {
	listicle?:ValueTypes["ListicleUniqueWhere"] | null
};
	["ContentPartReferencesByFaqUniqueWhere"]: {
	faq?:ValueTypes["FAQUniqueWhere"] | null
};
	["ContentPartReferencesByLinksUniqueWhere"]: {
	links?:ValueTypes["LinkContentUniqueWhere"] | null
};
	["ContentPartReferencesByAwardsUniqueWhere"]: {
	awards?:ValueTypes["AwardContentUniqueWhere"] | null
};
	["ContentPartReferencesByReviewsUniqueWhere"]: {
	reviews?:ValueTypes["ReviewContentUniqueWhere"] | null
};
	["ContentPartReferencesByTargetUniqueWhere"]: {
	target?:ValueTypes["LinkUniqueWhere"] | null
};
	["ContentPartReferencesByButtonsUniqueWhere"]: {
	buttons?:ValueTypes["ButtonUniqueWhere"] | null
};
	["ContentPartsByReferencesUniqueWhere"]: {
	references?:ValueTypes["ContentReferenceUniqueWhere"] | null
};
	["ContentPartConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentPartEdge"],
		__typename?: boolean
}>;
	["ContentPartEdge"]: AliasType<{
	node?:ValueTypes["ContentPart"],
		__typename?: boolean
}>;
	["AuthorTopArticle"]: AliasType<{
	_meta?:ValueTypes["AuthorTopArticleMeta"],
	id?:boolean,
	order?:boolean,
author?: [{	filter?:ValueTypes["AuthorWhere"] | null},ValueTypes["Author"]],
article?: [{	filter?:ValueTypes["ArticleWhere"] | null},ValueTypes["Article"]],
		__typename?: boolean
}>;
	["AuthorTopArticleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	author?:ValueTypes["FieldMeta"],
	article?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["AuthorTopArticleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	author?:ValueTypes["AuthorOrderBy"] | null,
	article?:ValueTypes["ArticleOrderBy"] | null
};
	["User"]: AliasType<{
	_meta?:ValueTypes["UserMeta"],
	id?:boolean,
	ihnedId?:boolean,
	email?:boolean,
authors?: [{	filter?:ValueTypes["AuthorWhere"] | null,	orderBy?:ValueTypes["AuthorOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Author"]],
unlockedArticles?: [{	filter?:ValueTypes["UnlockedArticleWhere"] | null,	orderBy?:ValueTypes["UnlockedArticleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["UnlockedArticle"]],
appReviews?: [{	filter?:ValueTypes["AppReviewWhere"] | null,	orderBy?:ValueTypes["AppReviewOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["AppReview"]],
paginateAuthors?: [{	filter?:ValueTypes["AuthorWhere"] | null,	orderBy?:ValueTypes["AuthorOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AuthorConnection"]],
paginateUnlockedArticles?: [{	filter?:ValueTypes["UnlockedArticleWhere"] | null,	orderBy?:ValueTypes["UnlockedArticleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["UnlockedArticleConnection"]],
paginateAppReviews?: [{	filter?:ValueTypes["AppReviewWhere"] | null,	orderBy?:ValueTypes["AppReviewOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AppReviewConnection"]],
		__typename?: boolean
}>;
	["UserMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	ihnedId?:ValueTypes["FieldMeta"],
	email?:ValueTypes["FieldMeta"],
	authors?:ValueTypes["FieldMeta"],
	unlockedArticles?:ValueTypes["FieldMeta"],
	appReviews?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["UnlockedArticle"]: AliasType<{
	_meta?:ValueTypes["UnlockedArticleMeta"],
	id?:boolean,
	createdAt?:boolean,
	code?:boolean,
	views?:boolean,
user?: [{	filter?:ValueTypes["UserWhere"] | null},ValueTypes["User"]],
article?: [{	filter?:ValueTypes["ArticleWhere"] | null},ValueTypes["Article"]],
		__typename?: boolean
}>;
	["UnlockedArticleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	code?:ValueTypes["FieldMeta"],
	views?:ValueTypes["FieldMeta"],
	user?:ValueTypes["FieldMeta"],
	article?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["UnlockedArticleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	createdAt?:ValueTypes["OrderDirection"] | null,
	code?:ValueTypes["OrderDirection"] | null,
	views?:ValueTypes["OrderDirection"] | null,
	user?:ValueTypes["UserOrderBy"] | null,
	article?:ValueTypes["ArticleOrderBy"] | null
};
	["UserOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	ihnedId?:ValueTypes["OrderDirection"] | null,
	email?:ValueTypes["OrderDirection"] | null
};
	["AppReview"]: AliasType<{
	_meta?:ValueTypes["AppReviewMeta"],
	id?:boolean,
	done?:boolean,
	deviceId?:boolean,
	createdAt?:boolean,
	rating?:boolean,
	note?:boolean,
user?: [{	filter?:ValueTypes["UserWhere"] | null},ValueTypes["User"]],
		__typename?: boolean
}>;
	["AppReviewMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	done?:ValueTypes["FieldMeta"],
	deviceId?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	rating?:ValueTypes["FieldMeta"],
	note?:ValueTypes["FieldMeta"],
	user?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["AppReviewOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	done?:ValueTypes["OrderDirection"] | null,
	deviceId?:ValueTypes["OrderDirection"] | null,
	createdAt?:ValueTypes["OrderDirection"] | null,
	rating?:ValueTypes["OrderDirection"] | null,
	note?:ValueTypes["OrderDirection"] | null,
	user?:ValueTypes["UserOrderBy"] | null
};
	["AuthorConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["AuthorEdge"],
		__typename?: boolean
}>;
	["AuthorEdge"]: AliasType<{
	node?:ValueTypes["Author"],
		__typename?: boolean
}>;
	["UnlockedArticleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["UnlockedArticleEdge"],
		__typename?: boolean
}>;
	["UnlockedArticleEdge"]: AliasType<{
	node?:ValueTypes["UnlockedArticle"],
		__typename?: boolean
}>;
	["AppReviewConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["AppReviewEdge"],
		__typename?: boolean
}>;
	["AppReviewEdge"]: AliasType<{
	node?:ValueTypes["AppReview"],
		__typename?: boolean
}>;
	["AuthorTopArticleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["AuthorTopArticleEdge"],
		__typename?: boolean
}>;
	["AuthorTopArticleEdge"]: AliasType<{
	node?:ValueTypes["AuthorTopArticle"],
		__typename?: boolean
}>;
	["UserConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["UserEdge"],
		__typename?: boolean
}>;
	["UserEdge"]: AliasType<{
	node?:ValueTypes["User"],
		__typename?: boolean
}>;
	["Page"]: AliasType<{
	_meta?:ValueTypes["PageMeta"],
	id?:boolean,
	title?:boolean,
	publishAt?:boolean,
	createdAt?:boolean,
	template?:boolean,
url?: [{	filter?:ValueTypes["UrlWhere"] | null},ValueTypes["Url"]],
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
	subscriptionValidity?:boolean,
		__typename?: boolean
}>;
	["PageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	publishAt?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	template?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	subscriptionValidity?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Seo"]: AliasType<{
	_meta?:ValueTypes["SeoMeta"],
	id?:boolean,
	title?:boolean,
	description?:boolean,
	ogTitle?:boolean,
	ogDescription?:boolean,
page?: [{	filter?:ValueTypes["PageWhere"] | null},ValueTypes["Page"]],
	twCard?:boolean,
ogImage?: [{	filter?:ValueTypes["ImageUseWhere"] | null},ValueTypes["ImageUse"]],
		__typename?: boolean
}>;
	["SeoMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	ogTitle?:ValueTypes["FieldMeta"],
	ogDescription?:ValueTypes["FieldMeta"],
	page?:ValueTypes["FieldMeta"],
	twCard?:ValueTypes["FieldMeta"],
	ogImage?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Category"]: AliasType<{
	_meta?:ValueTypes["CategoryMeta"],
	id?:boolean,
	name?:boolean,
articleCategory?: [{	filter?:ValueTypes["ArticleCategoryWhere"] | null,	orderBy?:ValueTypes["ArticleCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArticleCategory"]],
url?: [{	filter?:ValueTypes["UrlWhere"] | null},ValueTypes["Url"]],
	legacyId?:boolean,
articleCategoryByArticle?: [{	by:ValueTypes["CategoryArticleCategoryByArticleUniqueWhere"],	filter?:ValueTypes["ArticleCategoryWhere"] | null},ValueTypes["ArticleCategory"]],
paginateArticleCategory?: [{	filter?:ValueTypes["ArticleCategoryWhere"] | null,	orderBy?:ValueTypes["ArticleCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArticleCategoryConnection"]],
		__typename?: boolean
}>;
	["CategoryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	articleCategory?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	legacyId?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ArticleCategory"]: AliasType<{
	_meta?:ValueTypes["ArticleCategoryMeta"],
	id?:boolean,
	order?:boolean,
article?: [{	filter?:ValueTypes["ArticleWhere"] | null},ValueTypes["Article"]],
category?: [{	filter?:ValueTypes["CategoryWhere"] | null},ValueTypes["Category"]],
		__typename?: boolean
}>;
	["ArticleCategoryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	article?:ValueTypes["FieldMeta"],
	category?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ArticleCategoryOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	article?:ValueTypes["ArticleOrderBy"] | null,
	category?:ValueTypes["CategoryOrderBy"] | null
};
	["CategoryArticleCategoryByArticleUniqueWhere"]: {
	article?:ValueTypes["ArticleUniqueWhere"] | null
};
	["ArticleCategoryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ArticleCategoryEdge"],
		__typename?: boolean
}>;
	["ArticleCategoryEdge"]: AliasType<{
	node?:ValueTypes["ArticleCategory"],
		__typename?: boolean
}>;
	["Tag"]: AliasType<{
	_meta?:ValueTypes["TagMeta"],
	id?:boolean,
	name?:boolean,
	useAsTagline?:boolean,
articleTag?: [{	filter?:ValueTypes["ArticleTagWhere"] | null,	orderBy?:ValueTypes["ArticleTagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArticleTag"]],
url?: [{	filter?:ValueTypes["UrlWhere"] | null},ValueTypes["Url"]],
	order?:boolean,
	legacyId?:boolean,
articleTagByArticle?: [{	by:ValueTypes["TagArticleTagByArticleUniqueWhere"],	filter?:ValueTypes["ArticleTagWhere"] | null},ValueTypes["ArticleTag"]],
paginateArticleTag?: [{	filter?:ValueTypes["ArticleTagWhere"] | null,	orderBy?:ValueTypes["ArticleTagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArticleTagConnection"]],
		__typename?: boolean
}>;
	["TagMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	useAsTagline?:ValueTypes["FieldMeta"],
	articleTag?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	legacyId?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ArticleTag"]: AliasType<{
	_meta?:ValueTypes["ArticleTagMeta"],
	id?:boolean,
	order?:boolean,
tag?: [{	filter?:ValueTypes["TagWhere"] | null},ValueTypes["Tag"]],
article?: [{	filter?:ValueTypes["ArticleWhere"] | null},ValueTypes["Article"]],
		__typename?: boolean
}>;
	["ArticleTagMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	tag?:ValueTypes["FieldMeta"],
	article?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ArticleTagOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	tag?:ValueTypes["TagOrderBy"] | null,
	article?:ValueTypes["ArticleOrderBy"] | null
};
	["TagArticleTagByArticleUniqueWhere"]: {
	article?:ValueTypes["ArticleUniqueWhere"] | null
};
	["ArticleTagConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ArticleTagEdge"],
		__typename?: boolean
}>;
	["ArticleTagEdge"]: AliasType<{
	node?:ValueTypes["ArticleTag"],
		__typename?: boolean
}>;
	["ArticleAuthor"]: AliasType<{
	_meta?:ValueTypes["ArticleAuthorMeta"],
	id?:boolean,
	order?:boolean,
article?: [{	filter?:ValueTypes["ArticleWhere"] | null},ValueTypes["Article"]],
author?: [{	filter?:ValueTypes["AuthorWhere"] | null},ValueTypes["Author"]],
	legacyStringAuthor?:boolean,
		__typename?: boolean
}>;
	["ArticleAuthorMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	article?:ValueTypes["FieldMeta"],
	author?:ValueTypes["FieldMeta"],
	legacyStringAuthor?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ArticleAuthorOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	article?:ValueTypes["ArticleOrderBy"] | null,
	author?:ValueTypes["AuthorOrderBy"] | null,
	legacyStringAuthor?:ValueTypes["OrderDirection"] | null
};
	["TextContent"]: AliasType<{
	_meta?:ValueTypes["TextContentMeta"],
	id?:boolean,
parts?: [{	filter?:ValueTypes["TextContentPartWhere"] | null,	orderBy?:ValueTypes["TextContentPartOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TextContentPart"]],
partsByReferences?: [{	by:ValueTypes["TextContentPartsByReferencesUniqueWhere"],	filter?:ValueTypes["TextContentPartWhere"] | null},ValueTypes["TextContentPart"]],
paginateParts?: [{	filter?:ValueTypes["TextContentPartWhere"] | null,	orderBy?:ValueTypes["TextContentPartOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TextContentPartConnection"]],
		__typename?: boolean
}>;
	["TextContentMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	parts?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["TextContentPart"]: AliasType<{
	_meta?:ValueTypes["TextContentPartMeta"],
	id?:boolean,
	order?:boolean,
	json?:boolean,
content?: [{	filter?:ValueTypes["TextContentWhere"] | null},ValueTypes["TextContent"]],
references?: [{	filter?:ValueTypes["TextContentReferenceWhere"] | null,	orderBy?:ValueTypes["TextContentReferenceOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TextContentReference"]],
referencesByTarget?: [{	by:ValueTypes["TextContentPartReferencesByTargetUniqueWhere"],	filter?:ValueTypes["TextContentReferenceWhere"] | null},ValueTypes["TextContentReference"]],
paginateReferences?: [{	filter?:ValueTypes["TextContentReferenceWhere"] | null,	orderBy?:ValueTypes["TextContentReferenceOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TextContentReferenceConnection"]],
		__typename?: boolean
}>;
	["TextContentPartMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	json?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	references?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["TextContentReference"]: AliasType<{
	_meta?:ValueTypes["TextContentReferenceMeta"],
	id?:boolean,
	type?:boolean,
contentPart?: [{	filter?:ValueTypes["TextContentPartWhere"] | null},ValueTypes["TextContentPart"]],
target?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
		__typename?: boolean
}>;
	["TextContentReferenceMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	contentPart?:ValueTypes["FieldMeta"],
	target?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["TextContentReferenceOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	contentPart?:ValueTypes["TextContentPartOrderBy"] | null,
	target?:ValueTypes["LinkOrderBy"] | null
};
	["TextContentPartOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	json?:ValueTypes["OrderDirection"] | null,
	content?:ValueTypes["TextContentOrderBy"] | null
};
	["TextContentPartReferencesByTargetUniqueWhere"]: {
	target?:ValueTypes["LinkUniqueWhere"] | null
};
	["TextContentReferenceConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TextContentReferenceEdge"],
		__typename?: boolean
}>;
	["TextContentReferenceEdge"]: AliasType<{
	node?:ValueTypes["TextContentReference"],
		__typename?: boolean
}>;
	["TextContentPartsByReferencesUniqueWhere"]: {
	references?:ValueTypes["TextContentReferenceUniqueWhere"] | null
};
	["TextContentPartConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TextContentPartEdge"],
		__typename?: boolean
}>;
	["TextContentPartEdge"]: AliasType<{
	node?:ValueTypes["TextContentPart"],
		__typename?: boolean
}>;
	["ArticleHistoryTag"]: AliasType<{
	_meta?:ValueTypes["ArticleHistoryTagMeta"],
	id?:boolean,
	order?:boolean,
article?: [{	filter?:ValueTypes["ArticleWhere"] | null},ValueTypes["Article"]],
historyTag?: [{	filter?:ValueTypes["HistoryTagWhere"] | null},ValueTypes["HistoryTag"]],
		__typename?: boolean
}>;
	["ArticleHistoryTagMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	article?:ValueTypes["FieldMeta"],
	historyTag?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["HistoryTag"]: AliasType<{
	_meta?:ValueTypes["HistoryTagMeta"],
	id?:boolean,
	name?:boolean,
articleHistoryTag?: [{	filter?:ValueTypes["ArticleHistoryTagWhere"] | null,	orderBy?:ValueTypes["ArticleHistoryTagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArticleHistoryTag"]],
	slug?:boolean,
articleHistoryTagByArticle?: [{	by:ValueTypes["HistoryTagArticleHistoryTagByArticleUniqueWhere"],	filter?:ValueTypes["ArticleHistoryTagWhere"] | null},ValueTypes["ArticleHistoryTag"]],
paginateArticleHistoryTag?: [{	filter?:ValueTypes["ArticleHistoryTagWhere"] | null,	orderBy?:ValueTypes["ArticleHistoryTagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArticleHistoryTagConnection"]],
		__typename?: boolean
}>;
	["HistoryTagMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	articleHistoryTag?:ValueTypes["FieldMeta"],
	slug?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ArticleHistoryTagOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	article?:ValueTypes["ArticleOrderBy"] | null,
	historyTag?:ValueTypes["HistoryTagOrderBy"] | null
};
	["HistoryTagOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	slug?:ValueTypes["OrderDirection"] | null
};
	["HistoryTagArticleHistoryTagByArticleUniqueWhere"]: {
	article?:ValueTypes["ArticleUniqueWhere"] | null
};
	["ArticleHistoryTagConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ArticleHistoryTagEdge"],
		__typename?: boolean
}>;
	["ArticleHistoryTagEdge"]: AliasType<{
	node?:ValueTypes["ArticleHistoryTag"],
		__typename?: boolean
}>;
	["ArticleHistoryPeriod"]: AliasType<{
	_meta?:ValueTypes["ArticleHistoryPeriodMeta"],
	id?:boolean,
	order?:boolean,
article?: [{	filter?:ValueTypes["ArticleWhere"] | null},ValueTypes["Article"]],
historyPeriod?: [{	filter?:ValueTypes["HistoryPeriodWhere"] | null},ValueTypes["HistoryPeriod"]],
		__typename?: boolean
}>;
	["ArticleHistoryPeriodMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	article?:ValueTypes["FieldMeta"],
	historyPeriod?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["HistoryPeriod"]: AliasType<{
	_meta?:ValueTypes["HistoryPeriodMeta"],
	id?:boolean,
	name?:boolean,
articleHistoryPeriod?: [{	filter?:ValueTypes["ArticleHistoryPeriodWhere"] | null,	orderBy?:ValueTypes["ArticleHistoryPeriodOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArticleHistoryPeriod"]],
	slug?:boolean,
	order?:boolean,
cover?: [{	filter?:ValueTypes["HistoryCoverWhere"] | null},ValueTypes["HistoryCover"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
articleHistoryPeriodByArticle?: [{	by:ValueTypes["HistoryPeriodArticleHistoryPeriodByArticleUniqueWhere"],	filter?:ValueTypes["ArticleHistoryPeriodWhere"] | null},ValueTypes["ArticleHistoryPeriod"]],
paginateArticleHistoryPeriod?: [{	filter?:ValueTypes["ArticleHistoryPeriodWhere"] | null,	orderBy?:ValueTypes["ArticleHistoryPeriodOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArticleHistoryPeriodConnection"]],
		__typename?: boolean
}>;
	["HistoryPeriodMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	articleHistoryPeriod?:ValueTypes["FieldMeta"],
	slug?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	cover?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ArticleHistoryPeriodOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	article?:ValueTypes["ArticleOrderBy"] | null,
	historyPeriod?:ValueTypes["HistoryPeriodOrderBy"] | null
};
	["HistoryPeriodOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	slug?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	cover?:ValueTypes["HistoryCoverOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null
};
	["HistoryCoverOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	tileParagraph?:ValueTypes["OrderDirection"] | null,
	coverImage?:ValueTypes["ImageUseOrderBy"] | null,
	tileImage?:ValueTypes["ImageUseOrderBy"] | null,
	mobileImage?:ValueTypes["ImageUseOrderBy"] | null,
	leadContent?:ValueTypes["ContentOrderBy"] | null,
	annotations?:ValueTypes["HistoryTextListOrderBy"] | null
};
	["HistoryTextListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["HistoryCover"]: AliasType<{
	_meta?:ValueTypes["HistoryCoverMeta"],
	id?:boolean,
	title?:boolean,
	tileParagraph?:boolean,
coverImage?: [{	filter?:ValueTypes["ImageUseWhere"] | null},ValueTypes["ImageUse"]],
tileImage?: [{	filter?:ValueTypes["ImageUseWhere"] | null},ValueTypes["ImageUse"]],
mobileImage?: [{	filter?:ValueTypes["ImageUseWhere"] | null},ValueTypes["ImageUse"]],
leadContent?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
annotations?: [{	filter?:ValueTypes["HistoryTextListWhere"] | null},ValueTypes["HistoryTextList"]],
		__typename?: boolean
}>;
	["HistoryCoverMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	tileParagraph?:ValueTypes["FieldMeta"],
	coverImage?:ValueTypes["FieldMeta"],
	tileImage?:ValueTypes["FieldMeta"],
	mobileImage?:ValueTypes["FieldMeta"],
	leadContent?:ValueTypes["FieldMeta"],
	annotations?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["HistoryTextList"]: AliasType<{
	_meta?:ValueTypes["HistoryTextListMeta"],
	id?:boolean,
items?: [{	filter?:ValueTypes["HistoryTextItemWhere"] | null,	orderBy?:ValueTypes["HistoryTextItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HistoryTextItem"]],
itemsByImage?: [{	by:ValueTypes["HistoryTextListItemsByImageUniqueWhere"],	filter?:ValueTypes["HistoryTextItemWhere"] | null},ValueTypes["HistoryTextItem"]],
paginateItems?: [{	filter?:ValueTypes["HistoryTextItemWhere"] | null,	orderBy?:ValueTypes["HistoryTextItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HistoryTextItemConnection"]],
		__typename?: boolean
}>;
	["HistoryTextListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["HistoryTextItem"]: AliasType<{
	_meta?:ValueTypes["HistoryTextItemMeta"],
	id?:boolean,
	order?:boolean,
	key?:boolean,
	text?:boolean,
list?: [{	filter?:ValueTypes["HistoryTextListWhere"] | null},ValueTypes["HistoryTextList"]],
image?: [{	filter?:ValueTypes["ImageUseWhere"] | null},ValueTypes["ImageUse"]],
		__typename?: boolean
}>;
	["HistoryTextItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	key?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["HistoryTextItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	key?:ValueTypes["OrderDirection"] | null,
	text?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["HistoryTextListOrderBy"] | null,
	image?:ValueTypes["ImageUseOrderBy"] | null
};
	["HistoryTextListItemsByImageUniqueWhere"]: {
	image?:ValueTypes["ImageUseUniqueWhere"] | null
};
	["HistoryTextItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HistoryTextItemEdge"],
		__typename?: boolean
}>;
	["HistoryTextItemEdge"]: AliasType<{
	node?:ValueTypes["HistoryTextItem"],
		__typename?: boolean
}>;
	["HistoryPeriodArticleHistoryPeriodByArticleUniqueWhere"]: {
	article?:ValueTypes["ArticleUniqueWhere"] | null
};
	["ArticleHistoryPeriodConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ArticleHistoryPeriodEdge"],
		__typename?: boolean
}>;
	["ArticleHistoryPeriodEdge"]: AliasType<{
	node?:ValueTypes["ArticleHistoryPeriod"],
		__typename?: boolean
}>;
	["ArticleAuthorsByAuthorUniqueWhere"]: {
	author?:ValueTypes["AuthorUniqueWhere"] | null
};
	["ArticleAuthorsByLegacyStringAuthorUniqueWhere"]: {
	legacyStringAuthor?:ValueTypes["ArticleAuthorLegacyStringAuthor"] | null
};
	["ArticleCategoriesByCategoryUniqueWhere"]: {
	category?:ValueTypes["CategoryUniqueWhere"] | null
};
	["ArticleIssuesByIssueUniqueWhere"]: {
	issue?:ValueTypes["IssueUniqueWhere"] | null
};
	["ArticleTagsByTagUniqueWhere"]: {
	tag?:ValueTypes["TagUniqueWhere"] | null
};
	["ArticleHistoryTagsByHistoryTagUniqueWhere"]: {
	historyTag?:ValueTypes["HistoryTagUniqueWhere"] | null
};
	["ArticleHistoryPeriodsByHistoryPeriodUniqueWhere"]: {
	historyPeriod?:ValueTypes["HistoryPeriodUniqueWhere"] | null
};
	["ArticleAuthorConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ArticleAuthorEdge"],
		__typename?: boolean
}>;
	["ArticleAuthorEdge"]: AliasType<{
	node?:ValueTypes["ArticleAuthor"],
		__typename?: boolean
}>;
	["ArticleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ArticleEdge"],
		__typename?: boolean
}>;
	["ArticleEdge"]: AliasType<{
	node?:ValueTypes["Article"],
		__typename?: boolean
}>;
	["_ValidationResult"]: AliasType<{
	valid?:boolean,
	errors?:ValueTypes["_ValidationError"],
		__typename?: boolean
}>;
	["_ValidationError"]: AliasType<{
	path?:ValueTypes["_PathFragment"],
	message?:ValueTypes["_ValidationMessage"],
		__typename?: boolean
}>;
	["_PathFragment"]: AliasType<{		["...on _FieldPathFragment"] : ValueTypes["_FieldPathFragment"],
		["...on _IndexPathFragment"] : ValueTypes["_IndexPathFragment"]
		__typename?: boolean
}>;
	["_FieldPathFragment"]: AliasType<{
	field?:boolean,
		__typename?: boolean
}>;
	["_IndexPathFragment"]: AliasType<{
	index?:boolean,
	alias?:boolean,
		__typename?: boolean
}>;
	["_ValidationMessage"]: AliasType<{
	text?:boolean,
		__typename?: boolean
}>;
	["ArticleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	url?:ValueTypes["ArticleCreateUrlEntityRelationInput"] | null,
	authors?:ValueTypes["ArticleCreateAuthorsEntityRelationInput"][],
	hideInMostRead?:boolean | null,
	hideAds?:boolean | null,
	state?:ValueTypes["ArticleState"] | null,
	locked?:boolean | null,
	publishAt?:ValueTypes["DateTime"] | null,
	template?:ValueTypes["Template"] | null,
	subtitle?:ValueTypes["ArticleCreateSubtitleEntityRelationInput"] | null,
	content?:ValueTypes["ArticleCreateContentEntityRelationInput"] | null,
	coverPhoto?:ValueTypes["ArticleCreateCoverPhotoEntityRelationInput"] | null,
	titleAlignment?:ValueTypes["ArticleTitleAlignment"] | null,
	tagline?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	previewContent?:ValueTypes["ArticleCreatePreviewContentEntityRelationInput"] | null,
	audio?:ValueTypes["ArticleCreateAudioEntityRelationInput"] | null,
	categories?:ValueTypes["ArticleCreateCategoriesEntityRelationInput"][],
	issues?:ValueTypes["ArticleCreateIssuesEntityRelationInput"][],
	contentBlocks?:ValueTypes["ArticleCreateContentBlocksEntityRelationInput"][],
	unlocked?:ValueTypes["ArticleCreateUnlockedEntityRelationInput"][],
	coverPhotoVertical?:ValueTypes["ArticleCreateCoverPhotoVerticalEntityRelationInput"] | null,
	legacyId?:string | null,
	tags?:ValueTypes["ArticleCreateTagsEntityRelationInput"][],
	isHistory?:boolean | null,
	historyTags?:ValueTypes["ArticleCreateHistoryTagsEntityRelationInput"][],
	historyPeriods?:ValueTypes["ArticleCreateHistoryPeriodsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ArticleCreateUrlEntityRelationInput"]: {
	connect?:ValueTypes["UrlUniqueWhere"] | null,
	create?:ValueTypes["UrlWithoutArticleCreateInput"] | null
};
	["UrlWithoutArticleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	author?:ValueTypes["UrlCreateAuthorEntityRelationInput"] | null,
	issue?:ValueTypes["UrlCreateIssueEntityRelationInput"] | null,
	page?:ValueTypes["UrlCreatePageEntityRelationInput"] | null,
	category?:ValueTypes["UrlCreateCategoryEntityRelationInput"] | null,
	tag?:ValueTypes["UrlCreateTagEntityRelationInput"] | null,
	redirect?:string | null,
	_dummy_field_?:boolean | null
};
	["UrlCreateAuthorEntityRelationInput"]: {
	connect?:ValueTypes["AuthorUniqueWhere"] | null,
	create?:ValueTypes["AuthorWithoutUrlCreateInput"] | null
};
	["AuthorWithoutUrlCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	position?:string | null,
	twitterHandle?:string | null,
	facebookId?:string | null,
	email?:string | null,
	photographer?:boolean | null,
	order?:number | null,
	about?:ValueTypes["AuthorCreateAboutEntityRelationInput"] | null,
	topArticles?:ValueTypes["AuthorCreateTopArticlesEntityRelationInput"][],
	users?:ValueTypes["AuthorCreateUsersEntityRelationInput"][],
	startOfCooperation?:ValueTypes["Date"] | null,
	photo?:ValueTypes["AuthorCreatePhotoEntityRelationInput"] | null,
	illustration?:ValueTypes["AuthorCreateIllustrationEntityRelationInput"] | null,
	legacyId?:string | null,
	category?:ValueTypes["AuthorCategory"] | null,
	instagramUsername?:string | null,
	_dummy_field_?:boolean | null
};
	["AuthorCreateAboutEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["ContentCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	parts?:ValueTypes["ContentCreatePartsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentCreatePartsEntityRelationInput"]: {
	connect?:ValueTypes["ContentPartUniqueWhere"] | null,
	create?:ValueTypes["ContentPartWithoutContentCreateInput"] | null,
	alias?:string | null
};
	["ContentPartWithoutContentCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	json?:string | null,
	references?:ValueTypes["ContentPartCreateReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentPartCreateReferencesEntityRelationInput"]: {
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	create?:ValueTypes["ContentReferenceWithoutContentPartCreateInput"] | null,
	alias?:string | null
};
	["ContentReferenceWithoutContentPartCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ContentReferenceType"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	variant?:ValueTypes["ContentReferenceVariant"] | null,
	color?:string | null,
	embed?:ValueTypes["ContentReferenceCreateEmbedEntityRelationInput"] | null,
	article?:ValueTypes["ContentReferenceCreateArticleEntityRelationInput"] | null,
	audio?:ValueTypes["ContentReferenceCreateAudioEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceCreateImageEntityRelationInput"] | null,
	images?:ValueTypes["ContentReferenceCreateImagesEntityRelationInput"][],
	pollAnswer?:ValueTypes["ContentReferenceCreatePollAnswerEntityRelationInput"] | null,
	listicle?:ValueTypes["ContentReferenceCreateListicleEntityRelationInput"][],
	faq?:ValueTypes["ContentReferenceCreateFaqEntityRelationInput"][],
	links?:ValueTypes["ContentReferenceCreateLinksEntityRelationInput"][],
	awards?:ValueTypes["ContentReferenceCreateAwardsEntityRelationInput"][],
	reviews?:ValueTypes["ContentReferenceCreateReviewsEntityRelationInput"][],
	target?:ValueTypes["ContentReferenceCreateTargetEntityRelationInput"] | null,
	subscriptionForm?:ValueTypes["ContentReferenceCreateSubscriptionFormEntityRelationInput"] | null,
	buttons?:ValueTypes["ContentReferenceCreateButtonsEntityRelationInput"][],
	sharedContent?:ValueTypes["ContentReferenceCreateSharedContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceCreateEmbedEntityRelationInput"]: {
	connect?:ValueTypes["EmbedUniqueWhere"] | null,
	create?:ValueTypes["EmbedCreateInput"] | null
};
	["EmbedCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["EmbedType"] | null,
	youtubeId?:string | null,
	vimeoId?:string | null,
	spotifyId?:string | null,
	spotifyType?:string | null,
	soundCloudId?:string | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceCreateArticleEntityRelationInput"]: {
	connect?:ValueTypes["ArticleUniqueWhere"] | null,
	create?:ValueTypes["ArticleCreateInput"] | null
};
	["ContentReferenceCreateAudioEntityRelationInput"]: {
	connect?:ValueTypes["AudioUseUniqueWhere"] | null,
	create?:ValueTypes["AudioUseCreateInput"] | null
};
	["AudioUseCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	audio?:ValueTypes["AudioUseCreateAudioEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["AudioUseCreateAudioEntityRelationInput"]: {
	connect?:ValueTypes["AudioUniqueWhere"] | null,
	create?:ValueTypes["AudioWithoutUsesCreateInput"] | null
};
	["AudioUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	uses?:ValueTypes["AudioUseUniqueWhere"] | null
};
	["AudioWithoutUsesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	type?:string | null,
	author?:ValueTypes["AudioCreateAuthorEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["AudioCreateAuthorEntityRelationInput"]: {
	connect?:ValueTypes["AuthorUniqueWhere"] | null,
	create?:ValueTypes["AuthorCreateInput"] | null
};
	["AuthorCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	position?:string | null,
	twitterHandle?:string | null,
	facebookId?:string | null,
	email?:string | null,
	photographer?:boolean | null,
	order?:number | null,
	about?:ValueTypes["AuthorCreateAboutEntityRelationInput"] | null,
	topArticles?:ValueTypes["AuthorCreateTopArticlesEntityRelationInput"][],
	users?:ValueTypes["AuthorCreateUsersEntityRelationInput"][],
	startOfCooperation?:ValueTypes["Date"] | null,
	photo?:ValueTypes["AuthorCreatePhotoEntityRelationInput"] | null,
	illustration?:ValueTypes["AuthorCreateIllustrationEntityRelationInput"] | null,
	legacyId?:string | null,
	category?:ValueTypes["AuthorCategory"] | null,
	url?:ValueTypes["AuthorCreateUrlEntityRelationInput"] | null,
	instagramUsername?:string | null,
	_dummy_field_?:boolean | null
};
	["AuthorCreateTopArticlesEntityRelationInput"]: {
	connect?:ValueTypes["AuthorTopArticleUniqueWhere"] | null,
	create?:ValueTypes["AuthorTopArticleWithoutAuthorCreateInput"] | null,
	alias?:string | null
};
	["AuthorTopArticleWithoutAuthorCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	article?:ValueTypes["AuthorTopArticleCreateArticleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["AuthorTopArticleCreateArticleEntityRelationInput"]: {
	connect?:ValueTypes["ArticleUniqueWhere"] | null,
	create?:ValueTypes["ArticleCreateInput"] | null
};
	["AuthorCreateUsersEntityRelationInput"]: {
	connect?:ValueTypes["UserUniqueWhere"] | null,
	create?:ValueTypes["UserWithoutAuthorsCreateInput"] | null,
	alias?:string | null
};
	["UserUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	ihnedId?:string | null,
	unlockedArticles?:ValueTypes["UnlockedArticleUniqueWhere"] | null,
	appReviews?:ValueTypes["AppReviewUniqueWhere"] | null
};
	["AppReviewUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["UserWithoutAuthorsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	ihnedId?:string | null,
	email?:string | null,
	unlockedArticles?:ValueTypes["UserCreateUnlockedArticlesEntityRelationInput"][],
	appReviews?:ValueTypes["UserCreateAppReviewsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["UserCreateUnlockedArticlesEntityRelationInput"]: {
	connect?:ValueTypes["UnlockedArticleUniqueWhere"] | null,
	create?:ValueTypes["UnlockedArticleWithoutUserCreateInput"] | null,
	alias?:string | null
};
	["UnlockedArticleWithoutUserCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	code?:string | null,
	views?:number | null,
	article?:ValueTypes["UnlockedArticleCreateArticleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["UnlockedArticleCreateArticleEntityRelationInput"]: {
	connect?:ValueTypes["ArticleUniqueWhere"] | null,
	create?:ValueTypes["ArticleWithoutUnlockedCreateInput"] | null
};
	["ArticleWithoutUnlockedCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	url?:ValueTypes["ArticleCreateUrlEntityRelationInput"] | null,
	authors?:ValueTypes["ArticleCreateAuthorsEntityRelationInput"][],
	hideInMostRead?:boolean | null,
	hideAds?:boolean | null,
	state?:ValueTypes["ArticleState"] | null,
	locked?:boolean | null,
	publishAt?:ValueTypes["DateTime"] | null,
	template?:ValueTypes["Template"] | null,
	subtitle?:ValueTypes["ArticleCreateSubtitleEntityRelationInput"] | null,
	content?:ValueTypes["ArticleCreateContentEntityRelationInput"] | null,
	coverPhoto?:ValueTypes["ArticleCreateCoverPhotoEntityRelationInput"] | null,
	titleAlignment?:ValueTypes["ArticleTitleAlignment"] | null,
	tagline?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	previewContent?:ValueTypes["ArticleCreatePreviewContentEntityRelationInput"] | null,
	audio?:ValueTypes["ArticleCreateAudioEntityRelationInput"] | null,
	categories?:ValueTypes["ArticleCreateCategoriesEntityRelationInput"][],
	issues?:ValueTypes["ArticleCreateIssuesEntityRelationInput"][],
	contentBlocks?:ValueTypes["ArticleCreateContentBlocksEntityRelationInput"][],
	coverPhotoVertical?:ValueTypes["ArticleCreateCoverPhotoVerticalEntityRelationInput"] | null,
	legacyId?:string | null,
	tags?:ValueTypes["ArticleCreateTagsEntityRelationInput"][],
	isHistory?:boolean | null,
	historyTags?:ValueTypes["ArticleCreateHistoryTagsEntityRelationInput"][],
	historyPeriods?:ValueTypes["ArticleCreateHistoryPeriodsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ArticleCreateAuthorsEntityRelationInput"]: {
	connect?:ValueTypes["ArticleAuthorUniqueWhere"] | null,
	create?:ValueTypes["ArticleAuthorWithoutArticleCreateInput"] | null,
	alias?:string | null
};
	["ArticleAuthorWithoutArticleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	author?:ValueTypes["ArticleAuthorCreateAuthorEntityRelationInput"] | null,
	legacyStringAuthor?:ValueTypes["ArticleAuthorLegacyStringAuthor"] | null,
	_dummy_field_?:boolean | null
};
	["ArticleAuthorCreateAuthorEntityRelationInput"]: {
	connect?:ValueTypes["AuthorUniqueWhere"] | null,
	create?:ValueTypes["AuthorCreateInput"] | null
};
	["ArticleCreateSubtitleEntityRelationInput"]: {
	connect?:ValueTypes["TextContentUniqueWhere"] | null,
	create?:ValueTypes["TextContentCreateInput"] | null
};
	["TextContentCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	parts?:ValueTypes["TextContentCreatePartsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TextContentCreatePartsEntityRelationInput"]: {
	connect?:ValueTypes["TextContentPartUniqueWhere"] | null,
	create?:ValueTypes["TextContentPartWithoutContentCreateInput"] | null,
	alias?:string | null
};
	["TextContentPartWithoutContentCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	json?:string | null,
	references?:ValueTypes["TextContentPartCreateReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TextContentPartCreateReferencesEntityRelationInput"]: {
	connect?:ValueTypes["TextContentReferenceUniqueWhere"] | null,
	create?:ValueTypes["TextContentReferenceWithoutContentPartCreateInput"] | null,
	alias?:string | null
};
	["TextContentReferenceWithoutContentPartCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["TextContentReferenceType"] | null,
	target?:ValueTypes["TextContentReferenceCreateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TextContentReferenceCreateTargetEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["LinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["LinkType"] | null,
	externalTarget?:string | null,
	internalTarget?:ValueTypes["LinkCreateInternalTargetEntityRelationInput"] | null,
	queryParameters?:string | null,
	_dummy_field_?:boolean | null
};
	["LinkCreateInternalTargetEntityRelationInput"]: {
	connect?:ValueTypes["UrlUniqueWhere"] | null,
	create?:ValueTypes["UrlCreateInput"] | null
};
	["UrlCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	article?:ValueTypes["UrlCreateArticleEntityRelationInput"] | null,
	author?:ValueTypes["UrlCreateAuthorEntityRelationInput"] | null,
	issue?:ValueTypes["UrlCreateIssueEntityRelationInput"] | null,
	page?:ValueTypes["UrlCreatePageEntityRelationInput"] | null,
	category?:ValueTypes["UrlCreateCategoryEntityRelationInput"] | null,
	tag?:ValueTypes["UrlCreateTagEntityRelationInput"] | null,
	redirect?:string | null,
	_dummy_field_?:boolean | null
};
	["UrlCreateArticleEntityRelationInput"]: {
	connect?:ValueTypes["ArticleUniqueWhere"] | null,
	create?:ValueTypes["ArticleWithoutUrlCreateInput"] | null
};
	["ArticleWithoutUrlCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	authors?:ValueTypes["ArticleCreateAuthorsEntityRelationInput"][],
	hideInMostRead?:boolean | null,
	hideAds?:boolean | null,
	state?:ValueTypes["ArticleState"] | null,
	locked?:boolean | null,
	publishAt?:ValueTypes["DateTime"] | null,
	template?:ValueTypes["Template"] | null,
	subtitle?:ValueTypes["ArticleCreateSubtitleEntityRelationInput"] | null,
	content?:ValueTypes["ArticleCreateContentEntityRelationInput"] | null,
	coverPhoto?:ValueTypes["ArticleCreateCoverPhotoEntityRelationInput"] | null,
	titleAlignment?:ValueTypes["ArticleTitleAlignment"] | null,
	tagline?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	previewContent?:ValueTypes["ArticleCreatePreviewContentEntityRelationInput"] | null,
	audio?:ValueTypes["ArticleCreateAudioEntityRelationInput"] | null,
	categories?:ValueTypes["ArticleCreateCategoriesEntityRelationInput"][],
	issues?:ValueTypes["ArticleCreateIssuesEntityRelationInput"][],
	contentBlocks?:ValueTypes["ArticleCreateContentBlocksEntityRelationInput"][],
	unlocked?:ValueTypes["ArticleCreateUnlockedEntityRelationInput"][],
	coverPhotoVertical?:ValueTypes["ArticleCreateCoverPhotoVerticalEntityRelationInput"] | null,
	legacyId?:string | null,
	tags?:ValueTypes["ArticleCreateTagsEntityRelationInput"][],
	isHistory?:boolean | null,
	historyTags?:ValueTypes["ArticleCreateHistoryTagsEntityRelationInput"][],
	historyPeriods?:ValueTypes["ArticleCreateHistoryPeriodsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ArticleCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["ArticleCreateCoverPhotoEntityRelationInput"]: {
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["ImageUseCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	image?:ValueTypes["ImageUseCreateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ImageUseCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageWithoutUsesCreateInput"] | null
};
	["ImageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	legacyId?:string | null,
	uses?:ValueTypes["ImageUseUniqueWhere"] | null
};
	["ImageWithoutUsesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	width?:number | null,
	height?:number | null,
	title?:string | null,
	text?:string | null,
	author?:ValueTypes["ImageCreateAuthorEntityRelationInput"] | null,
	tags?:ValueTypes["ImageCreateTagsEntityRelationInput"][],
	align?:ValueTypes["ImageAlign"] | null,
	legacyId?:string | null,
	_dummy_field_?:boolean | null
};
	["ImageCreateAuthorEntityRelationInput"]: {
	connect?:ValueTypes["AuthorUniqueWhere"] | null,
	create?:ValueTypes["AuthorCreateInput"] | null
};
	["ImageCreateTagsEntityRelationInput"]: {
	connect?:ValueTypes["ImageTagUniqueWhere"] | null,
	create?:ValueTypes["ImageTagWithoutImagesCreateInput"] | null,
	alias?:string | null
};
	["ImageTagUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ImageTagWithoutImagesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	_dummy_field_?:boolean | null
};
	["ArticleCreatePreviewContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["ArticleCreateAudioEntityRelationInput"]: {
	connect?:ValueTypes["AudioUseUniqueWhere"] | null,
	create?:ValueTypes["AudioUseCreateInput"] | null
};
	["ArticleCreateCategoriesEntityRelationInput"]: {
	connect?:ValueTypes["ArticleCategoryUniqueWhere"] | null,
	create?:ValueTypes["ArticleCategoryWithoutArticleCreateInput"] | null,
	alias?:string | null
};
	["ArticleCategoryWithoutArticleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	category?:ValueTypes["ArticleCategoryCreateCategoryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArticleCategoryCreateCategoryEntityRelationInput"]: {
	connect?:ValueTypes["CategoryUniqueWhere"] | null,
	create?:ValueTypes["CategoryWithoutArticleCategoryCreateInput"] | null
};
	["CategoryWithoutArticleCategoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	url?:ValueTypes["CategoryCreateUrlEntityRelationInput"] | null,
	legacyId?:string | null,
	_dummy_field_?:boolean | null
};
	["CategoryCreateUrlEntityRelationInput"]: {
	connect?:ValueTypes["UrlUniqueWhere"] | null,
	create?:ValueTypes["UrlWithoutCategoryCreateInput"] | null
};
	["UrlWithoutCategoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	article?:ValueTypes["UrlCreateArticleEntityRelationInput"] | null,
	author?:ValueTypes["UrlCreateAuthorEntityRelationInput"] | null,
	issue?:ValueTypes["UrlCreateIssueEntityRelationInput"] | null,
	page?:ValueTypes["UrlCreatePageEntityRelationInput"] | null,
	tag?:ValueTypes["UrlCreateTagEntityRelationInput"] | null,
	redirect?:string | null,
	_dummy_field_?:boolean | null
};
	["UrlCreateIssueEntityRelationInput"]: {
	connect?:ValueTypes["IssueUniqueWhere"] | null,
	create?:ValueTypes["IssueWithoutUrlCreateInput"] | null
};
	["IssueWithoutUrlCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	closed?:boolean | null,
	free?:boolean | null,
	title?:string | null,
	subtitle?:string | null,
	year?:number | null,
	issue?:number | null,
	publishedSince?:ValueTypes["Date"] | null,
	publishedUntil?:ValueTypes["Date"] | null,
	publishDigital?:ValueTypes["DateTime"] | null,
	mobileAppsKey?:string | null,
	articles?:ValueTypes["IssueCreateArticlesEntityRelationInput"][],
	kind?:ValueTypes["IssueKind"] | null,
	notificationTitle?:string | null,
	notificationMessage?:string | null,
	pdf?:ValueTypes["IssueCreatePdfEntityRelationInput"] | null,
	printBuy?:boolean | null,
	printText?:string | null,
	blocks?:ValueTypes["IssueCreateBlocksEntityRelationInput"][],
	coverPhoto?:ValueTypes["IssueCreateCoverPhotoEntityRelationInput"] | null,
	printTarget?:ValueTypes["IssueCreatePrintTargetEntityRelationInput"] | null,
	backgroundPhoto?:ValueTypes["IssueCreateBackgroundPhotoEntityRelationInput"] | null,
	legacyId?:string | null,
	_dummy_field_?:boolean | null
};
	["IssueCreateArticlesEntityRelationInput"]: {
	connect?:ValueTypes["IssueArticleUniqueWhere"] | null,
	create?:ValueTypes["IssueArticleWithoutIssueCreateInput"] | null,
	alias?:string | null
};
	["IssueArticleWithoutIssueCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	article?:ValueTypes["IssueArticleCreateArticleEntityRelationInput"] | null,
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["IssueArticleCreateArticleEntityRelationInput"]: {
	connect?:ValueTypes["ArticleUniqueWhere"] | null,
	create?:ValueTypes["ArticleWithoutIssuesCreateInput"] | null
};
	["ArticleWithoutIssuesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	url?:ValueTypes["ArticleCreateUrlEntityRelationInput"] | null,
	authors?:ValueTypes["ArticleCreateAuthorsEntityRelationInput"][],
	hideInMostRead?:boolean | null,
	hideAds?:boolean | null,
	state?:ValueTypes["ArticleState"] | null,
	locked?:boolean | null,
	publishAt?:ValueTypes["DateTime"] | null,
	template?:ValueTypes["Template"] | null,
	subtitle?:ValueTypes["ArticleCreateSubtitleEntityRelationInput"] | null,
	content?:ValueTypes["ArticleCreateContentEntityRelationInput"] | null,
	coverPhoto?:ValueTypes["ArticleCreateCoverPhotoEntityRelationInput"] | null,
	titleAlignment?:ValueTypes["ArticleTitleAlignment"] | null,
	tagline?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	previewContent?:ValueTypes["ArticleCreatePreviewContentEntityRelationInput"] | null,
	audio?:ValueTypes["ArticleCreateAudioEntityRelationInput"] | null,
	categories?:ValueTypes["ArticleCreateCategoriesEntityRelationInput"][],
	contentBlocks?:ValueTypes["ArticleCreateContentBlocksEntityRelationInput"][],
	unlocked?:ValueTypes["ArticleCreateUnlockedEntityRelationInput"][],
	coverPhotoVertical?:ValueTypes["ArticleCreateCoverPhotoVerticalEntityRelationInput"] | null,
	legacyId?:string | null,
	tags?:ValueTypes["ArticleCreateTagsEntityRelationInput"][],
	isHistory?:boolean | null,
	historyTags?:ValueTypes["ArticleCreateHistoryTagsEntityRelationInput"][],
	historyPeriods?:ValueTypes["ArticleCreateHistoryPeriodsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ArticleCreateContentBlocksEntityRelationInput"]: {
	connect?:ValueTypes["ContentArticleUniqueWhere"] | null,
	create?:ValueTypes["ContentArticleWithoutArticleCreateInput"] | null,
	alias?:string | null
};
	["ContentArticleWithoutArticleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	contentBlock?:ValueTypes["ContentArticleCreateContentBlockEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentArticleCreateContentBlockEntityRelationInput"]: {
	connect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	create?:ValueTypes["ContentBlockWithoutArticlesCreateInput"] | null
};
	["ContentBlockWithoutArticlesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	type?:ValueTypes["ContentBlockType"] | null,
	youtubeId?:string | null,
	text?:string | null,
	targetLabel?:string | null,
	issue?:ValueTypes["ContentBlockCreateIssueEntityRelationInput"] | null,
	target?:ValueTypes["ContentBlockCreateTargetEntityRelationInput"] | null,
	subscriptionForm?:ValueTypes["ContentBlockCreateSubscriptionFormEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentBlockCreateIssueEntityRelationInput"]: {
	connect?:ValueTypes["IssueUniqueWhere"] | null,
	create?:ValueTypes["IssueWithoutBlocksCreateInput"] | null
};
	["IssueWithoutBlocksCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	closed?:boolean | null,
	free?:boolean | null,
	title?:string | null,
	subtitle?:string | null,
	year?:number | null,
	issue?:number | null,
	publishedSince?:ValueTypes["Date"] | null,
	publishedUntil?:ValueTypes["Date"] | null,
	publishDigital?:ValueTypes["DateTime"] | null,
	mobileAppsKey?:string | null,
	url?:ValueTypes["IssueCreateUrlEntityRelationInput"] | null,
	articles?:ValueTypes["IssueCreateArticlesEntityRelationInput"][],
	kind?:ValueTypes["IssueKind"] | null,
	notificationTitle?:string | null,
	notificationMessage?:string | null,
	pdf?:ValueTypes["IssueCreatePdfEntityRelationInput"] | null,
	printBuy?:boolean | null,
	printText?:string | null,
	coverPhoto?:ValueTypes["IssueCreateCoverPhotoEntityRelationInput"] | null,
	printTarget?:ValueTypes["IssueCreatePrintTargetEntityRelationInput"] | null,
	backgroundPhoto?:ValueTypes["IssueCreateBackgroundPhotoEntityRelationInput"] | null,
	legacyId?:string | null,
	_dummy_field_?:boolean | null
};
	["IssueCreateUrlEntityRelationInput"]: {
	connect?:ValueTypes["UrlUniqueWhere"] | null,
	create?:ValueTypes["UrlWithoutIssueCreateInput"] | null
};
	["UrlWithoutIssueCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	article?:ValueTypes["UrlCreateArticleEntityRelationInput"] | null,
	author?:ValueTypes["UrlCreateAuthorEntityRelationInput"] | null,
	page?:ValueTypes["UrlCreatePageEntityRelationInput"] | null,
	category?:ValueTypes["UrlCreateCategoryEntityRelationInput"] | null,
	tag?:ValueTypes["UrlCreateTagEntityRelationInput"] | null,
	redirect?:string | null,
	_dummy_field_?:boolean | null
};
	["UrlCreatePageEntityRelationInput"]: {
	connect?:ValueTypes["PageUniqueWhere"] | null,
	create?:ValueTypes["PageWithoutUrlCreateInput"] | null
};
	["PageWithoutUrlCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	publishAt?:ValueTypes["DateTime"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	template?:ValueTypes["PageTemplate"] | null,
	content?:ValueTypes["PageCreateContentEntityRelationInput"] | null,
	seo?:ValueTypes["PageCreateSeoEntityRelationInput"] | null,
	subscriptionValidity?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["PageCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["PageCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoWithoutPageCreateInput"] | null
};
	["SeoWithoutPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	twCard?:ValueTypes["SeoTwCard"] | null,
	ogImage?:ValueTypes["SeoCreateOgImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SeoCreateOgImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["UrlCreateCategoryEntityRelationInput"]: {
	connect?:ValueTypes["CategoryUniqueWhere"] | null,
	create?:ValueTypes["CategoryWithoutUrlCreateInput"] | null
};
	["CategoryWithoutUrlCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	articleCategory?:ValueTypes["CategoryCreateArticleCategoryEntityRelationInput"][],
	legacyId?:string | null,
	_dummy_field_?:boolean | null
};
	["CategoryCreateArticleCategoryEntityRelationInput"]: {
	connect?:ValueTypes["ArticleCategoryUniqueWhere"] | null,
	create?:ValueTypes["ArticleCategoryWithoutCategoryCreateInput"] | null,
	alias?:string | null
};
	["ArticleCategoryWithoutCategoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	article?:ValueTypes["ArticleCategoryCreateArticleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArticleCategoryCreateArticleEntityRelationInput"]: {
	connect?:ValueTypes["ArticleUniqueWhere"] | null,
	create?:ValueTypes["ArticleWithoutCategoriesCreateInput"] | null
};
	["ArticleWithoutCategoriesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	url?:ValueTypes["ArticleCreateUrlEntityRelationInput"] | null,
	authors?:ValueTypes["ArticleCreateAuthorsEntityRelationInput"][],
	hideInMostRead?:boolean | null,
	hideAds?:boolean | null,
	state?:ValueTypes["ArticleState"] | null,
	locked?:boolean | null,
	publishAt?:ValueTypes["DateTime"] | null,
	template?:ValueTypes["Template"] | null,
	subtitle?:ValueTypes["ArticleCreateSubtitleEntityRelationInput"] | null,
	content?:ValueTypes["ArticleCreateContentEntityRelationInput"] | null,
	coverPhoto?:ValueTypes["ArticleCreateCoverPhotoEntityRelationInput"] | null,
	titleAlignment?:ValueTypes["ArticleTitleAlignment"] | null,
	tagline?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	previewContent?:ValueTypes["ArticleCreatePreviewContentEntityRelationInput"] | null,
	audio?:ValueTypes["ArticleCreateAudioEntityRelationInput"] | null,
	issues?:ValueTypes["ArticleCreateIssuesEntityRelationInput"][],
	contentBlocks?:ValueTypes["ArticleCreateContentBlocksEntityRelationInput"][],
	unlocked?:ValueTypes["ArticleCreateUnlockedEntityRelationInput"][],
	coverPhotoVertical?:ValueTypes["ArticleCreateCoverPhotoVerticalEntityRelationInput"] | null,
	legacyId?:string | null,
	tags?:ValueTypes["ArticleCreateTagsEntityRelationInput"][],
	isHistory?:boolean | null,
	historyTags?:ValueTypes["ArticleCreateHistoryTagsEntityRelationInput"][],
	historyPeriods?:ValueTypes["ArticleCreateHistoryPeriodsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ArticleCreateIssuesEntityRelationInput"]: {
	connect?:ValueTypes["IssueArticleUniqueWhere"] | null,
	create?:ValueTypes["IssueArticleWithoutArticleCreateInput"] | null,
	alias?:string | null
};
	["IssueArticleWithoutArticleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	issue?:ValueTypes["IssueArticleCreateIssueEntityRelationInput"] | null,
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["IssueArticleCreateIssueEntityRelationInput"]: {
	connect?:ValueTypes["IssueUniqueWhere"] | null,
	create?:ValueTypes["IssueWithoutArticlesCreateInput"] | null
};
	["IssueWithoutArticlesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	closed?:boolean | null,
	free?:boolean | null,
	title?:string | null,
	subtitle?:string | null,
	year?:number | null,
	issue?:number | null,
	publishedSince?:ValueTypes["Date"] | null,
	publishedUntil?:ValueTypes["Date"] | null,
	publishDigital?:ValueTypes["DateTime"] | null,
	mobileAppsKey?:string | null,
	url?:ValueTypes["IssueCreateUrlEntityRelationInput"] | null,
	kind?:ValueTypes["IssueKind"] | null,
	notificationTitle?:string | null,
	notificationMessage?:string | null,
	pdf?:ValueTypes["IssueCreatePdfEntityRelationInput"] | null,
	printBuy?:boolean | null,
	printText?:string | null,
	blocks?:ValueTypes["IssueCreateBlocksEntityRelationInput"][],
	coverPhoto?:ValueTypes["IssueCreateCoverPhotoEntityRelationInput"] | null,
	printTarget?:ValueTypes["IssueCreatePrintTargetEntityRelationInput"] | null,
	backgroundPhoto?:ValueTypes["IssueCreateBackgroundPhotoEntityRelationInput"] | null,
	legacyId?:string | null,
	_dummy_field_?:boolean | null
};
	["IssueCreatePdfEntityRelationInput"]: {
	connect?:ValueTypes["FileUseUniqueWhere"] | null,
	create?:ValueTypes["FileUseCreateInput"] | null
};
	["FileUseCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	file?:ValueTypes["FileUseCreateFileEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FileUseCreateFileEntityRelationInput"]: {
	connect?:ValueTypes["FileUniqueWhere"] | null,
	create?:ValueTypes["FileWithoutUsesCreateInput"] | null
};
	["FileUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	uses?:ValueTypes["FileUseUniqueWhere"] | null
};
	["FileWithoutUsesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["IssueCreateBlocksEntityRelationInput"]: {
	connect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	create?:ValueTypes["ContentBlockWithoutIssueCreateInput"] | null,
	alias?:string | null
};
	["ContentBlockWithoutIssueCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	type?:ValueTypes["ContentBlockType"] | null,
	youtubeId?:string | null,
	text?:string | null,
	targetLabel?:string | null,
	target?:ValueTypes["ContentBlockCreateTargetEntityRelationInput"] | null,
	articles?:ValueTypes["ContentBlockCreateArticlesEntityRelationInput"][],
	subscriptionForm?:ValueTypes["ContentBlockCreateSubscriptionFormEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentBlockCreateTargetEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["ContentBlockCreateArticlesEntityRelationInput"]: {
	connect?:ValueTypes["ContentArticleUniqueWhere"] | null,
	create?:ValueTypes["ContentArticleWithoutContentBlockCreateInput"] | null,
	alias?:string | null
};
	["ContentArticleWithoutContentBlockCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	article?:ValueTypes["ContentArticleCreateArticleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentArticleCreateArticleEntityRelationInput"]: {
	connect?:ValueTypes["ArticleUniqueWhere"] | null,
	create?:ValueTypes["ArticleWithoutContentBlocksCreateInput"] | null
};
	["ArticleWithoutContentBlocksCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	url?:ValueTypes["ArticleCreateUrlEntityRelationInput"] | null,
	authors?:ValueTypes["ArticleCreateAuthorsEntityRelationInput"][],
	hideInMostRead?:boolean | null,
	hideAds?:boolean | null,
	state?:ValueTypes["ArticleState"] | null,
	locked?:boolean | null,
	publishAt?:ValueTypes["DateTime"] | null,
	template?:ValueTypes["Template"] | null,
	subtitle?:ValueTypes["ArticleCreateSubtitleEntityRelationInput"] | null,
	content?:ValueTypes["ArticleCreateContentEntityRelationInput"] | null,
	coverPhoto?:ValueTypes["ArticleCreateCoverPhotoEntityRelationInput"] | null,
	titleAlignment?:ValueTypes["ArticleTitleAlignment"] | null,
	tagline?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	previewContent?:ValueTypes["ArticleCreatePreviewContentEntityRelationInput"] | null,
	audio?:ValueTypes["ArticleCreateAudioEntityRelationInput"] | null,
	categories?:ValueTypes["ArticleCreateCategoriesEntityRelationInput"][],
	issues?:ValueTypes["ArticleCreateIssuesEntityRelationInput"][],
	unlocked?:ValueTypes["ArticleCreateUnlockedEntityRelationInput"][],
	coverPhotoVertical?:ValueTypes["ArticleCreateCoverPhotoVerticalEntityRelationInput"] | null,
	legacyId?:string | null,
	tags?:ValueTypes["ArticleCreateTagsEntityRelationInput"][],
	isHistory?:boolean | null,
	historyTags?:ValueTypes["ArticleCreateHistoryTagsEntityRelationInput"][],
	historyPeriods?:ValueTypes["ArticleCreateHistoryPeriodsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ArticleCreateUnlockedEntityRelationInput"]: {
	connect?:ValueTypes["UnlockedArticleUniqueWhere"] | null,
	create?:ValueTypes["UnlockedArticleWithoutArticleCreateInput"] | null,
	alias?:string | null
};
	["UnlockedArticleWithoutArticleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	code?:string | null,
	views?:number | null,
	user?:ValueTypes["UnlockedArticleCreateUserEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["UnlockedArticleCreateUserEntityRelationInput"]: {
	connect?:ValueTypes["UserUniqueWhere"] | null,
	create?:ValueTypes["UserWithoutUnlockedArticlesCreateInput"] | null
};
	["UserWithoutUnlockedArticlesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	ihnedId?:string | null,
	email?:string | null,
	authors?:ValueTypes["UserCreateAuthorsEntityRelationInput"][],
	appReviews?:ValueTypes["UserCreateAppReviewsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["UserCreateAuthorsEntityRelationInput"]: {
	connect?:ValueTypes["AuthorUniqueWhere"] | null,
	create?:ValueTypes["AuthorWithoutUsersCreateInput"] | null,
	alias?:string | null
};
	["AuthorWithoutUsersCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	position?:string | null,
	twitterHandle?:string | null,
	facebookId?:string | null,
	email?:string | null,
	photographer?:boolean | null,
	order?:number | null,
	about?:ValueTypes["AuthorCreateAboutEntityRelationInput"] | null,
	topArticles?:ValueTypes["AuthorCreateTopArticlesEntityRelationInput"][],
	startOfCooperation?:ValueTypes["Date"] | null,
	photo?:ValueTypes["AuthorCreatePhotoEntityRelationInput"] | null,
	illustration?:ValueTypes["AuthorCreateIllustrationEntityRelationInput"] | null,
	legacyId?:string | null,
	category?:ValueTypes["AuthorCategory"] | null,
	url?:ValueTypes["AuthorCreateUrlEntityRelationInput"] | null,
	instagramUsername?:string | null,
	_dummy_field_?:boolean | null
};
	["AuthorCreatePhotoEntityRelationInput"]: {
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["AuthorCreateIllustrationEntityRelationInput"]: {
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["AuthorCreateUrlEntityRelationInput"]: {
	connect?:ValueTypes["UrlUniqueWhere"] | null,
	create?:ValueTypes["UrlWithoutAuthorCreateInput"] | null
};
	["UrlWithoutAuthorCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	article?:ValueTypes["UrlCreateArticleEntityRelationInput"] | null,
	issue?:ValueTypes["UrlCreateIssueEntityRelationInput"] | null,
	page?:ValueTypes["UrlCreatePageEntityRelationInput"] | null,
	category?:ValueTypes["UrlCreateCategoryEntityRelationInput"] | null,
	tag?:ValueTypes["UrlCreateTagEntityRelationInput"] | null,
	redirect?:string | null,
	_dummy_field_?:boolean | null
};
	["UrlCreateTagEntityRelationInput"]: {
	connect?:ValueTypes["TagUniqueWhere"] | null,
	create?:ValueTypes["TagWithoutUrlCreateInput"] | null
};
	["TagWithoutUrlCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	useAsTagline?:boolean | null,
	articleTag?:ValueTypes["TagCreateArticleTagEntityRelationInput"][],
	order?:string | null,
	legacyId?:string | null,
	_dummy_field_?:boolean | null
};
	["TagCreateArticleTagEntityRelationInput"]: {
	connect?:ValueTypes["ArticleTagUniqueWhere"] | null,
	create?:ValueTypes["ArticleTagWithoutTagCreateInput"] | null,
	alias?:string | null
};
	["ArticleTagWithoutTagCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	article?:ValueTypes["ArticleTagCreateArticleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArticleTagCreateArticleEntityRelationInput"]: {
	connect?:ValueTypes["ArticleUniqueWhere"] | null,
	create?:ValueTypes["ArticleWithoutTagsCreateInput"] | null
};
	["ArticleWithoutTagsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	url?:ValueTypes["ArticleCreateUrlEntityRelationInput"] | null,
	authors?:ValueTypes["ArticleCreateAuthorsEntityRelationInput"][],
	hideInMostRead?:boolean | null,
	hideAds?:boolean | null,
	state?:ValueTypes["ArticleState"] | null,
	locked?:boolean | null,
	publishAt?:ValueTypes["DateTime"] | null,
	template?:ValueTypes["Template"] | null,
	subtitle?:ValueTypes["ArticleCreateSubtitleEntityRelationInput"] | null,
	content?:ValueTypes["ArticleCreateContentEntityRelationInput"] | null,
	coverPhoto?:ValueTypes["ArticleCreateCoverPhotoEntityRelationInput"] | null,
	titleAlignment?:ValueTypes["ArticleTitleAlignment"] | null,
	tagline?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	previewContent?:ValueTypes["ArticleCreatePreviewContentEntityRelationInput"] | null,
	audio?:ValueTypes["ArticleCreateAudioEntityRelationInput"] | null,
	categories?:ValueTypes["ArticleCreateCategoriesEntityRelationInput"][],
	issues?:ValueTypes["ArticleCreateIssuesEntityRelationInput"][],
	contentBlocks?:ValueTypes["ArticleCreateContentBlocksEntityRelationInput"][],
	unlocked?:ValueTypes["ArticleCreateUnlockedEntityRelationInput"][],
	coverPhotoVertical?:ValueTypes["ArticleCreateCoverPhotoVerticalEntityRelationInput"] | null,
	legacyId?:string | null,
	isHistory?:boolean | null,
	historyTags?:ValueTypes["ArticleCreateHistoryTagsEntityRelationInput"][],
	historyPeriods?:ValueTypes["ArticleCreateHistoryPeriodsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ArticleCreateCoverPhotoVerticalEntityRelationInput"]: {
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["ArticleCreateHistoryTagsEntityRelationInput"]: {
	connect?:ValueTypes["ArticleHistoryTagUniqueWhere"] | null,
	create?:ValueTypes["ArticleHistoryTagWithoutArticleCreateInput"] | null,
	alias?:string | null
};
	["ArticleHistoryTagWithoutArticleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	historyTag?:ValueTypes["ArticleHistoryTagCreateHistoryTagEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArticleHistoryTagCreateHistoryTagEntityRelationInput"]: {
	connect?:ValueTypes["HistoryTagUniqueWhere"] | null,
	create?:ValueTypes["HistoryTagWithoutArticleHistoryTagCreateInput"] | null
};
	["HistoryTagWithoutArticleHistoryTagCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	slug?:string | null,
	_dummy_field_?:boolean | null
};
	["ArticleCreateHistoryPeriodsEntityRelationInput"]: {
	connect?:ValueTypes["ArticleHistoryPeriodUniqueWhere"] | null,
	create?:ValueTypes["ArticleHistoryPeriodWithoutArticleCreateInput"] | null,
	alias?:string | null
};
	["ArticleHistoryPeriodWithoutArticleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	historyPeriod?:ValueTypes["ArticleHistoryPeriodCreateHistoryPeriodEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArticleHistoryPeriodCreateHistoryPeriodEntityRelationInput"]: {
	connect?:ValueTypes["HistoryPeriodUniqueWhere"] | null,
	create?:ValueTypes["HistoryPeriodWithoutArticleHistoryPeriodCreateInput"] | null
};
	["HistoryPeriodWithoutArticleHistoryPeriodCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	slug?:string | null,
	order?:number | null,
	cover?:ValueTypes["HistoryPeriodCreateCoverEntityRelationInput"] | null,
	seo?:ValueTypes["HistoryPeriodCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HistoryPeriodCreateCoverEntityRelationInput"]: {
	connect?:ValueTypes["HistoryCoverUniqueWhere"] | null,
	create?:ValueTypes["HistoryCoverCreateInput"] | null
};
	["HistoryCoverCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	tileParagraph?:string | null,
	coverImage?:ValueTypes["HistoryCoverCreateCoverImageEntityRelationInput"] | null,
	tileImage?:ValueTypes["HistoryCoverCreateTileImageEntityRelationInput"] | null,
	mobileImage?:ValueTypes["HistoryCoverCreateMobileImageEntityRelationInput"] | null,
	leadContent?:ValueTypes["HistoryCoverCreateLeadContentEntityRelationInput"] | null,
	annotations?:ValueTypes["HistoryCoverCreateAnnotationsEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HistoryCoverCreateCoverImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["HistoryCoverCreateTileImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["HistoryCoverCreateMobileImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["HistoryCoverCreateLeadContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["HistoryCoverCreateAnnotationsEntityRelationInput"]: {
	connect?:ValueTypes["HistoryTextListUniqueWhere"] | null,
	create?:ValueTypes["HistoryTextListCreateInput"] | null
};
	["HistoryTextListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["HistoryTextListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["HistoryTextListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["HistoryTextItemUniqueWhere"] | null,
	create?:ValueTypes["HistoryTextItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["HistoryTextItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	key?:string | null,
	text?:string | null,
	image?:ValueTypes["HistoryTextItemCreateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HistoryTextItemCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["HistoryPeriodCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["SeoCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	page?:ValueTypes["SeoCreatePageEntityRelationInput"] | null,
	twCard?:ValueTypes["SeoTwCard"] | null,
	ogImage?:ValueTypes["SeoCreateOgImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SeoCreatePageEntityRelationInput"]: {
	connect?:ValueTypes["PageUniqueWhere"] | null,
	create?:ValueTypes["PageWithoutSeoCreateInput"] | null
};
	["PageWithoutSeoCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	publishAt?:ValueTypes["DateTime"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	template?:ValueTypes["PageTemplate"] | null,
	url?:ValueTypes["PageCreateUrlEntityRelationInput"] | null,
	content?:ValueTypes["PageCreateContentEntityRelationInput"] | null,
	subscriptionValidity?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["PageCreateUrlEntityRelationInput"]: {
	connect?:ValueTypes["UrlUniqueWhere"] | null,
	create?:ValueTypes["UrlWithoutPageCreateInput"] | null
};
	["UrlWithoutPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	article?:ValueTypes["UrlCreateArticleEntityRelationInput"] | null,
	author?:ValueTypes["UrlCreateAuthorEntityRelationInput"] | null,
	issue?:ValueTypes["UrlCreateIssueEntityRelationInput"] | null,
	category?:ValueTypes["UrlCreateCategoryEntityRelationInput"] | null,
	tag?:ValueTypes["UrlCreateTagEntityRelationInput"] | null,
	redirect?:string | null,
	_dummy_field_?:boolean | null
};
	["UserCreateAppReviewsEntityRelationInput"]: {
	connect?:ValueTypes["AppReviewUniqueWhere"] | null,
	create?:ValueTypes["AppReviewWithoutUserCreateInput"] | null,
	alias?:string | null
};
	["AppReviewWithoutUserCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	done?:boolean | null,
	deviceId?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	rating?:number | null,
	note?:string | null,
	_dummy_field_?:boolean | null
};
	["ArticleCreateTagsEntityRelationInput"]: {
	connect?:ValueTypes["ArticleTagUniqueWhere"] | null,
	create?:ValueTypes["ArticleTagWithoutArticleCreateInput"] | null,
	alias?:string | null
};
	["ArticleTagWithoutArticleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	tag?:ValueTypes["ArticleTagCreateTagEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArticleTagCreateTagEntityRelationInput"]: {
	connect?:ValueTypes["TagUniqueWhere"] | null,
	create?:ValueTypes["TagWithoutArticleTagCreateInput"] | null
};
	["TagWithoutArticleTagCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	useAsTagline?:boolean | null,
	url?:ValueTypes["TagCreateUrlEntityRelationInput"] | null,
	order?:string | null,
	legacyId?:string | null,
	_dummy_field_?:boolean | null
};
	["TagCreateUrlEntityRelationInput"]: {
	connect?:ValueTypes["UrlUniqueWhere"] | null,
	create?:ValueTypes["UrlWithoutTagCreateInput"] | null
};
	["UrlWithoutTagCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	article?:ValueTypes["UrlCreateArticleEntityRelationInput"] | null,
	author?:ValueTypes["UrlCreateAuthorEntityRelationInput"] | null,
	issue?:ValueTypes["UrlCreateIssueEntityRelationInput"] | null,
	page?:ValueTypes["UrlCreatePageEntityRelationInput"] | null,
	category?:ValueTypes["UrlCreateCategoryEntityRelationInput"] | null,
	redirect?:string | null,
	_dummy_field_?:boolean | null
};
	["ContentBlockCreateSubscriptionFormEntityRelationInput"]: {
	connect?:ValueTypes["SubscriptionFormUniqueWhere"] | null,
	create?:ValueTypes["SubscriptionFormWithoutContentBlockCreateInput"] | null
};
	["SubscriptionFormUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	sections?:ValueTypes["SubscriptionFormSectionUniqueWhere"] | null,
	contentBlock?:ValueTypes["ContentBlockUniqueWhere"] | null,
	products?:ValueTypes["ProductUniqueWhere"] | null,
	contentReferences?:ValueTypes["ContentReferenceUniqueWhere"] | null
};
	["SubscriptionFormSectionUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	inputs?:ValueTypes["SubscriptionFormInputUniqueWhere"] | null
};
	["ProductUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["SubscriptionFormWithoutContentBlockCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	code?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	sections?:ValueTypes["SubscriptionFormCreateSectionsEntityRelationInput"][],
	products?:ValueTypes["SubscriptionFormCreateProductsEntityRelationInput"][],
	contentReferences?:ValueTypes["SubscriptionFormCreateContentReferencesEntityRelationInput"][],
	validity?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["SubscriptionFormCreateSectionsEntityRelationInput"]: {
	connect?:ValueTypes["SubscriptionFormSectionUniqueWhere"] | null,
	create?:ValueTypes["SubscriptionFormSectionWithoutFormCreateInput"] | null,
	alias?:string | null
};
	["SubscriptionFormSectionWithoutFormCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	title?:string | null,
	inputs?:ValueTypes["SubscriptionFormSectionCreateInputsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["SubscriptionFormSectionCreateInputsEntityRelationInput"]: {
	connect?:ValueTypes["SubscriptionFormInputUniqueWhere"] | null,
	create?:ValueTypes["SubscriptionFormInputWithoutSectionCreateInput"] | null,
	alias?:string | null
};
	["SubscriptionFormInputWithoutSectionCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	type?:ValueTypes["SubscriptionFormInputType"] | null,
	image?:ValueTypes["SubscriptionFormInputCreateImageEntityRelationInput"] | null,
	options?:ValueTypes["SubscriptionFormInputCreateOptionsEntityRelationInput"][],
	description?:ValueTypes["SubscriptionFormInputCreateDescriptionEntityRelationInput"] | null,
	required?:boolean | null,
	_dummy_field_?:boolean | null
};
	["SubscriptionFormInputCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["SubscriptionFormInputCreateOptionsEntityRelationInput"]: {
	connect?:ValueTypes["SubscriptionFormOptionUniqueWhere"] | null,
	create?:ValueTypes["SubscriptionFormOptionWithoutFormInputCreateInput"] | null,
	alias?:string | null
};
	["SubscriptionFormOptionWithoutFormInputCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	hasProductId?:boolean | null,
	order?:number | null,
	label?:string | null,
	priceTag?:string | null,
	priceTagWithDiscount?:string | null,
	products?:ValueTypes["SubscriptionFormOptionCreateProductsEntityRelationInput"][],
	value?:string | null,
	internalLabel?:string | null,
	_dummy_field_?:boolean | null
};
	["SubscriptionFormOptionCreateProductsEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductWithoutFormOptionsCreateInput"] | null,
	alias?:string | null
};
	["ProductWithoutFormOptionsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	price?:number | null,
	type?:ValueTypes["Types"] | null,
	form?:ValueTypes["ProductCreateFormEntityRelationInput"] | null,
	productId?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductCreateFormEntityRelationInput"]: {
	connect?:ValueTypes["SubscriptionFormUniqueWhere"] | null,
	create?:ValueTypes["SubscriptionFormWithoutProductsCreateInput"] | null
};
	["SubscriptionFormWithoutProductsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	code?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	sections?:ValueTypes["SubscriptionFormCreateSectionsEntityRelationInput"][],
	contentBlock?:ValueTypes["SubscriptionFormCreateContentBlockEntityRelationInput"][],
	contentReferences?:ValueTypes["SubscriptionFormCreateContentReferencesEntityRelationInput"][],
	validity?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["SubscriptionFormCreateContentBlockEntityRelationInput"]: {
	connect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	create?:ValueTypes["ContentBlockWithoutSubscriptionFormCreateInput"] | null,
	alias?:string | null
};
	["ContentBlockWithoutSubscriptionFormCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	type?:ValueTypes["ContentBlockType"] | null,
	youtubeId?:string | null,
	text?:string | null,
	targetLabel?:string | null,
	issue?:ValueTypes["ContentBlockCreateIssueEntityRelationInput"] | null,
	target?:ValueTypes["ContentBlockCreateTargetEntityRelationInput"] | null,
	articles?:ValueTypes["ContentBlockCreateArticlesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["SubscriptionFormCreateContentReferencesEntityRelationInput"]: {
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	create?:ValueTypes["ContentReferenceWithoutSubscriptionFormCreateInput"] | null,
	alias?:string | null
};
	["ContentReferenceWithoutSubscriptionFormCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ContentReferenceType"] | null,
	contentPart?:ValueTypes["ContentReferenceCreateContentPartEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	variant?:ValueTypes["ContentReferenceVariant"] | null,
	color?:string | null,
	embed?:ValueTypes["ContentReferenceCreateEmbedEntityRelationInput"] | null,
	article?:ValueTypes["ContentReferenceCreateArticleEntityRelationInput"] | null,
	audio?:ValueTypes["ContentReferenceCreateAudioEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceCreateImageEntityRelationInput"] | null,
	images?:ValueTypes["ContentReferenceCreateImagesEntityRelationInput"][],
	pollAnswer?:ValueTypes["ContentReferenceCreatePollAnswerEntityRelationInput"] | null,
	listicle?:ValueTypes["ContentReferenceCreateListicleEntityRelationInput"][],
	faq?:ValueTypes["ContentReferenceCreateFaqEntityRelationInput"][],
	links?:ValueTypes["ContentReferenceCreateLinksEntityRelationInput"][],
	awards?:ValueTypes["ContentReferenceCreateAwardsEntityRelationInput"][],
	reviews?:ValueTypes["ContentReferenceCreateReviewsEntityRelationInput"][],
	target?:ValueTypes["ContentReferenceCreateTargetEntityRelationInput"] | null,
	buttons?:ValueTypes["ContentReferenceCreateButtonsEntityRelationInput"][],
	sharedContent?:ValueTypes["ContentReferenceCreateSharedContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceCreateContentPartEntityRelationInput"]: {
	connect?:ValueTypes["ContentPartUniqueWhere"] | null,
	create?:ValueTypes["ContentPartWithoutReferencesCreateInput"] | null
};
	["ContentPartWithoutReferencesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["ContentPartCreateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentPartCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentWithoutPartsCreateInput"] | null
};
	["ContentWithoutPartsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["ContentReferenceCreateImagesEntityRelationInput"]: {
	connect?:ValueTypes["ImageContentUniqueWhere"] | null,
	create?:ValueTypes["ImageContentWithoutContentReferenceCreateInput"] | null,
	alias?:string | null
};
	["ImageContentUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ImageContentWithoutContentReferenceCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	image?:ValueTypes["ImageContentCreateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ImageContentCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["ContentReferenceCreatePollAnswerEntityRelationInput"]: {
	connect?:ValueTypes["PollAnswerUniqueWhere"] | null,
	create?:ValueTypes["PollAnswerCreateInput"] | null
};
	["PollAnswerCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	authorName?:string | null,
	authorPosition?:string | null,
	text?:string | null,
	authorImage?:ValueTypes["PollAnswerCreateAuthorImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PollAnswerCreateAuthorImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["ContentReferenceCreateListicleEntityRelationInput"]: {
	connect?:ValueTypes["ListicleUniqueWhere"] | null,
	create?:ValueTypes["ListicleWithoutContentReferenceCreateInput"] | null,
	alias?:string | null
};
	["ListicleWithoutContentReferenceCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	primaryText?:string | null,
	image?:ValueTypes["ListicleCreateImageEntityRelationInput"] | null,
	target?:ValueTypes["ListicleCreateTargetEntityRelationInput"] | null,
	content?:ValueTypes["ListicleCreateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ListicleCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["ListicleCreateTargetEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["ListicleCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["ContentReferenceCreateFaqEntityRelationInput"]: {
	connect?:ValueTypes["FAQUniqueWhere"] | null,
	create?:ValueTypes["FAQWithoutContentReferenceCreateInput"] | null,
	alias?:string | null
};
	["FAQWithoutContentReferenceCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	answer?:string | null,
	question?:string | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceCreateLinksEntityRelationInput"]: {
	connect?:ValueTypes["LinkContentUniqueWhere"] | null,
	create?:ValueTypes["LinkContentWithoutContentReferenceCreateInput"] | null,
	alias?:string | null
};
	["LinkContentWithoutContentReferenceCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	text?:string | null,
	target?:ValueTypes["LinkContentCreateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkContentCreateTargetEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["ContentReferenceCreateAwardsEntityRelationInput"]: {
	connect?:ValueTypes["AwardContentUniqueWhere"] | null,
	create?:ValueTypes["AwardContentWithoutContentReferenceCreateInput"] | null,
	alias?:string | null
};
	["AwardContentWithoutContentReferenceCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	image?:ValueTypes["AwardContentCreateImageEntityRelationInput"] | null,
	target?:ValueTypes["AwardContentCreateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["AwardContentCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["AwardContentCreateTargetEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["ContentReferenceCreateReviewsEntityRelationInput"]: {
	connect?:ValueTypes["ReviewContentUniqueWhere"] | null,
	create?:ValueTypes["ReviewContentWithoutContentReferenceCreateInput"] | null,
	alias?:string | null
};
	["ReviewContentWithoutContentReferenceCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	text?:string | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceCreateTargetEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["ContentReferenceCreateButtonsEntityRelationInput"]: {
	connect?:ValueTypes["ButtonUniqueWhere"] | null,
	create?:ValueTypes["ButtonWithoutContentReferenceCreateInput"] | null,
	alias?:string | null
};
	["ButtonWithoutContentReferenceCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	type?:ValueTypes["ButtonType"] | null,
	label?:string | null,
	target?:ValueTypes["ButtonCreateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ButtonCreateTargetEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["ContentReferenceCreateSharedContentEntityRelationInput"]: {
	connect?:ValueTypes["SharedContentUniqueWhere"] | null,
	create?:ValueTypes["SharedContentWithoutContentReferenceCreateInput"] | null
};
	["SharedContentUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	contentReference?:ValueTypes["ContentReferenceUniqueWhere"] | null
};
	["SharedContentWithoutContentReferenceCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	content?:ValueTypes["SharedContentCreateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SharedContentCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["SubscriptionFormInputCreateDescriptionEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["SubscriptionFormCreateProductsEntityRelationInput"]: {
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	create?:ValueTypes["ProductWithoutFormCreateInput"] | null,
	alias?:string | null
};
	["ProductWithoutFormCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	price?:number | null,
	type?:ValueTypes["Types"] | null,
	formOptions?:ValueTypes["ProductCreateFormOptionsEntityRelationInput"][],
	productId?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductCreateFormOptionsEntityRelationInput"]: {
	connect?:ValueTypes["SubscriptionFormOptionUniqueWhere"] | null,
	create?:ValueTypes["SubscriptionFormOptionWithoutProductsCreateInput"] | null,
	alias?:string | null
};
	["SubscriptionFormOptionWithoutProductsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	hasProductId?:boolean | null,
	order?:number | null,
	label?:string | null,
	priceTag?:string | null,
	priceTagWithDiscount?:string | null,
	formInput?:ValueTypes["SubscriptionFormOptionCreateFormInputEntityRelationInput"] | null,
	value?:string | null,
	internalLabel?:string | null,
	_dummy_field_?:boolean | null
};
	["SubscriptionFormOptionCreateFormInputEntityRelationInput"]: {
	connect?:ValueTypes["SubscriptionFormInputUniqueWhere"] | null,
	create?:ValueTypes["SubscriptionFormInputWithoutOptionsCreateInput"] | null
};
	["SubscriptionFormInputWithoutOptionsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	type?:ValueTypes["SubscriptionFormInputType"] | null,
	image?:ValueTypes["SubscriptionFormInputCreateImageEntityRelationInput"] | null,
	section?:ValueTypes["SubscriptionFormInputCreateSectionEntityRelationInput"] | null,
	description?:ValueTypes["SubscriptionFormInputCreateDescriptionEntityRelationInput"] | null,
	required?:boolean | null,
	_dummy_field_?:boolean | null
};
	["SubscriptionFormInputCreateSectionEntityRelationInput"]: {
	connect?:ValueTypes["SubscriptionFormSectionUniqueWhere"] | null,
	create?:ValueTypes["SubscriptionFormSectionWithoutInputsCreateInput"] | null
};
	["SubscriptionFormSectionWithoutInputsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	title?:string | null,
	form?:ValueTypes["SubscriptionFormSectionCreateFormEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SubscriptionFormSectionCreateFormEntityRelationInput"]: {
	connect?:ValueTypes["SubscriptionFormUniqueWhere"] | null,
	create?:ValueTypes["SubscriptionFormWithoutSectionsCreateInput"] | null
};
	["SubscriptionFormWithoutSectionsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	code?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	contentBlock?:ValueTypes["SubscriptionFormCreateContentBlockEntityRelationInput"][],
	products?:ValueTypes["SubscriptionFormCreateProductsEntityRelationInput"][],
	contentReferences?:ValueTypes["SubscriptionFormCreateContentReferencesEntityRelationInput"][],
	validity?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["IssueCreateCoverPhotoEntityRelationInput"]: {
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["IssueCreatePrintTargetEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["IssueCreateBackgroundPhotoEntityRelationInput"]: {
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["ContentReferenceCreateSubscriptionFormEntityRelationInput"]: {
	connect?:ValueTypes["SubscriptionFormUniqueWhere"] | null,
	create?:ValueTypes["SubscriptionFormWithoutContentReferencesCreateInput"] | null
};
	["SubscriptionFormWithoutContentReferencesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	code?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	sections?:ValueTypes["SubscriptionFormCreateSectionsEntityRelationInput"][],
	contentBlock?:ValueTypes["SubscriptionFormCreateContentBlockEntityRelationInput"][],
	products?:ValueTypes["SubscriptionFormCreateProductsEntityRelationInput"][],
	validity?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["ArticleUpdateInput"]: {
	title?:string | null,
	url?:ValueTypes["ArticleUpdateUrlEntityRelationInput"] | null,
	authors?:ValueTypes["ArticleUpdateAuthorsEntityRelationInput"][],
	hideInMostRead?:boolean | null,
	hideAds?:boolean | null,
	state?:ValueTypes["ArticleState"] | null,
	locked?:boolean | null,
	publishAt?:ValueTypes["DateTime"] | null,
	template?:ValueTypes["Template"] | null,
	subtitle?:ValueTypes["ArticleUpdateSubtitleEntityRelationInput"] | null,
	content?:ValueTypes["ArticleUpdateContentEntityRelationInput"] | null,
	coverPhoto?:ValueTypes["ArticleUpdateCoverPhotoEntityRelationInput"] | null,
	titleAlignment?:ValueTypes["ArticleTitleAlignment"] | null,
	tagline?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	previewContent?:ValueTypes["ArticleUpdatePreviewContentEntityRelationInput"] | null,
	audio?:ValueTypes["ArticleUpdateAudioEntityRelationInput"] | null,
	categories?:ValueTypes["ArticleUpdateCategoriesEntityRelationInput"][],
	issues?:ValueTypes["ArticleUpdateIssuesEntityRelationInput"][],
	contentBlocks?:ValueTypes["ArticleUpdateContentBlocksEntityRelationInput"][],
	unlocked?:ValueTypes["ArticleUpdateUnlockedEntityRelationInput"][],
	coverPhotoVertical?:ValueTypes["ArticleUpdateCoverPhotoVerticalEntityRelationInput"] | null,
	legacyId?:string | null,
	tags?:ValueTypes["ArticleUpdateTagsEntityRelationInput"][],
	isHistory?:boolean | null,
	historyTags?:ValueTypes["ArticleUpdateHistoryTagsEntityRelationInput"][],
	historyPeriods?:ValueTypes["ArticleUpdateHistoryPeriodsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ArticleUpdateUrlEntityRelationInput"]: {
	create?:ValueTypes["UrlWithoutArticleCreateInput"] | null,
	update?:ValueTypes["UrlWithoutArticleUpdateInput"] | null,
	upsert?:ValueTypes["ArticleUpsertUrlRelationInput"] | null,
	connect?:ValueTypes["UrlUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["UrlWithoutArticleUpdateInput"]: {
	url?:string | null,
	author?:ValueTypes["UrlUpdateAuthorEntityRelationInput"] | null,
	issue?:ValueTypes["UrlUpdateIssueEntityRelationInput"] | null,
	page?:ValueTypes["UrlUpdatePageEntityRelationInput"] | null,
	category?:ValueTypes["UrlUpdateCategoryEntityRelationInput"] | null,
	tag?:ValueTypes["UrlUpdateTagEntityRelationInput"] | null,
	redirect?:string | null,
	_dummy_field_?:boolean | null
};
	["UrlUpdateAuthorEntityRelationInput"]: {
	create?:ValueTypes["AuthorWithoutUrlCreateInput"] | null,
	update?:ValueTypes["AuthorWithoutUrlUpdateInput"] | null,
	upsert?:ValueTypes["UrlUpsertAuthorRelationInput"] | null,
	connect?:ValueTypes["AuthorUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["AuthorWithoutUrlUpdateInput"]: {
	name?:string | null,
	position?:string | null,
	twitterHandle?:string | null,
	facebookId?:string | null,
	email?:string | null,
	photographer?:boolean | null,
	order?:number | null,
	about?:ValueTypes["AuthorUpdateAboutEntityRelationInput"] | null,
	topArticles?:ValueTypes["AuthorUpdateTopArticlesEntityRelationInput"][],
	users?:ValueTypes["AuthorUpdateUsersEntityRelationInput"][],
	startOfCooperation?:ValueTypes["Date"] | null,
	photo?:ValueTypes["AuthorUpdatePhotoEntityRelationInput"] | null,
	illustration?:ValueTypes["AuthorUpdateIllustrationEntityRelationInput"] | null,
	legacyId?:string | null,
	category?:ValueTypes["AuthorCategory"] | null,
	instagramUsername?:string | null,
	_dummy_field_?:boolean | null
};
	["AuthorUpdateAboutEntityRelationInput"]: {
	create?:ValueTypes["ContentCreateInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["AuthorUpsertAboutRelationInput"] | null,
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentUpdateInput"]: {
	parts?:ValueTypes["ContentUpdatePartsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentUpdatePartsEntityRelationInput"]: {
	create?:ValueTypes["ContentPartWithoutContentCreateInput"] | null,
	update?:ValueTypes["ContentUpdatePartsRelationInput"] | null,
	upsert?:ValueTypes["ContentUpsertPartsRelationInput"] | null,
	connect?:ValueTypes["ContentPartUniqueWhere"] | null,
	disconnect?:ValueTypes["ContentPartUniqueWhere"] | null,
	delete?:ValueTypes["ContentPartUniqueWhere"] | null,
	alias?:string | null
};
	["ContentUpdatePartsRelationInput"]: {
	by?:ValueTypes["ContentPartUniqueWhere"] | null,
	data?:ValueTypes["ContentPartWithoutContentUpdateInput"] | null
};
	["ContentPartWithoutContentUpdateInput"]: {
	order?:number | null,
	json?:string | null,
	references?:ValueTypes["ContentPartUpdateReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentPartUpdateReferencesEntityRelationInput"]: {
	create?:ValueTypes["ContentReferenceWithoutContentPartCreateInput"] | null,
	update?:ValueTypes["ContentPartUpdateReferencesRelationInput"] | null,
	upsert?:ValueTypes["ContentPartUpsertReferencesRelationInput"] | null,
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	disconnect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	delete?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	alias?:string | null
};
	["ContentPartUpdateReferencesRelationInput"]: {
	by?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	data?:ValueTypes["ContentReferenceWithoutContentPartUpdateInput"] | null
};
	["ContentReferenceWithoutContentPartUpdateInput"]: {
	type?:ValueTypes["ContentReferenceType"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	variant?:ValueTypes["ContentReferenceVariant"] | null,
	color?:string | null,
	embed?:ValueTypes["ContentReferenceUpdateEmbedEntityRelationInput"] | null,
	article?:ValueTypes["ContentReferenceUpdateArticleEntityRelationInput"] | null,
	audio?:ValueTypes["ContentReferenceUpdateAudioEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceUpdateImageEntityRelationInput"] | null,
	images?:ValueTypes["ContentReferenceUpdateImagesEntityRelationInput"][],
	pollAnswer?:ValueTypes["ContentReferenceUpdatePollAnswerEntityRelationInput"] | null,
	listicle?:ValueTypes["ContentReferenceUpdateListicleEntityRelationInput"][],
	faq?:ValueTypes["ContentReferenceUpdateFaqEntityRelationInput"][],
	links?:ValueTypes["ContentReferenceUpdateLinksEntityRelationInput"][],
	awards?:ValueTypes["ContentReferenceUpdateAwardsEntityRelationInput"][],
	reviews?:ValueTypes["ContentReferenceUpdateReviewsEntityRelationInput"][],
	target?:ValueTypes["ContentReferenceUpdateTargetEntityRelationInput"] | null,
	subscriptionForm?:ValueTypes["ContentReferenceUpdateSubscriptionFormEntityRelationInput"] | null,
	buttons?:ValueTypes["ContentReferenceUpdateButtonsEntityRelationInput"][],
	sharedContent?:ValueTypes["ContentReferenceUpdateSharedContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpdateEmbedEntityRelationInput"]: {
	create?:ValueTypes["EmbedCreateInput"] | null,
	update?:ValueTypes["EmbedUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertEmbedRelationInput"] | null,
	connect?:ValueTypes["EmbedUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["EmbedUpdateInput"]: {
	type?:ValueTypes["EmbedType"] | null,
	youtubeId?:string | null,
	vimeoId?:string | null,
	spotifyId?:string | null,
	spotifyType?:string | null,
	soundCloudId?:string | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpsertEmbedRelationInput"]: {
	update?:ValueTypes["EmbedUpdateInput"] | null,
	create?:ValueTypes["EmbedCreateInput"] | null
};
	["ContentReferenceUpdateArticleEntityRelationInput"]: {
	create?:ValueTypes["ArticleCreateInput"] | null,
	update?:ValueTypes["ArticleUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertArticleRelationInput"] | null,
	connect?:ValueTypes["ArticleUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentReferenceUpsertArticleRelationInput"]: {
	update?:ValueTypes["ArticleUpdateInput"] | null,
	create?:ValueTypes["ArticleCreateInput"] | null
};
	["ContentReferenceUpdateAudioEntityRelationInput"]: {
	create?:ValueTypes["AudioUseCreateInput"] | null,
	update?:ValueTypes["AudioUseUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertAudioRelationInput"] | null,
	connect?:ValueTypes["AudioUseUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["AudioUseUpdateInput"]: {
	audio?:ValueTypes["AudioUseUpdateAudioEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["AudioUseUpdateAudioEntityRelationInput"]: {
	create?:ValueTypes["AudioWithoutUsesCreateInput"] | null,
	update?:ValueTypes["AudioWithoutUsesUpdateInput"] | null,
	upsert?:ValueTypes["AudioUseUpsertAudioRelationInput"] | null,
	connect?:ValueTypes["AudioUniqueWhere"] | null,
	delete?:boolean | null
};
	["AudioWithoutUsesUpdateInput"]: {
	url?:string | null,
	type?:string | null,
	author?:ValueTypes["AudioUpdateAuthorEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["AudioUpdateAuthorEntityRelationInput"]: {
	create?:ValueTypes["AuthorCreateInput"] | null,
	update?:ValueTypes["AuthorUpdateInput"] | null,
	upsert?:ValueTypes["AudioUpsertAuthorRelationInput"] | null,
	connect?:ValueTypes["AuthorUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["AuthorUpdateInput"]: {
	name?:string | null,
	position?:string | null,
	twitterHandle?:string | null,
	facebookId?:string | null,
	email?:string | null,
	photographer?:boolean | null,
	order?:number | null,
	about?:ValueTypes["AuthorUpdateAboutEntityRelationInput"] | null,
	topArticles?:ValueTypes["AuthorUpdateTopArticlesEntityRelationInput"][],
	users?:ValueTypes["AuthorUpdateUsersEntityRelationInput"][],
	startOfCooperation?:ValueTypes["Date"] | null,
	photo?:ValueTypes["AuthorUpdatePhotoEntityRelationInput"] | null,
	illustration?:ValueTypes["AuthorUpdateIllustrationEntityRelationInput"] | null,
	legacyId?:string | null,
	category?:ValueTypes["AuthorCategory"] | null,
	url?:ValueTypes["AuthorUpdateUrlEntityRelationInput"] | null,
	instagramUsername?:string | null,
	_dummy_field_?:boolean | null
};
	["AuthorUpdateTopArticlesEntityRelationInput"]: {
	create?:ValueTypes["AuthorTopArticleWithoutAuthorCreateInput"] | null,
	update?:ValueTypes["AuthorUpdateTopArticlesRelationInput"] | null,
	upsert?:ValueTypes["AuthorUpsertTopArticlesRelationInput"] | null,
	connect?:ValueTypes["AuthorTopArticleUniqueWhere"] | null,
	disconnect?:ValueTypes["AuthorTopArticleUniqueWhere"] | null,
	delete?:ValueTypes["AuthorTopArticleUniqueWhere"] | null,
	alias?:string | null
};
	["AuthorUpdateTopArticlesRelationInput"]: {
	by?:ValueTypes["AuthorTopArticleUniqueWhere"] | null,
	data?:ValueTypes["AuthorTopArticleWithoutAuthorUpdateInput"] | null
};
	["AuthorTopArticleWithoutAuthorUpdateInput"]: {
	order?:number | null,
	article?:ValueTypes["AuthorTopArticleUpdateArticleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["AuthorTopArticleUpdateArticleEntityRelationInput"]: {
	create?:ValueTypes["ArticleCreateInput"] | null,
	update?:ValueTypes["ArticleUpdateInput"] | null,
	upsert?:ValueTypes["AuthorTopArticleUpsertArticleRelationInput"] | null,
	connect?:ValueTypes["ArticleUniqueWhere"] | null,
	delete?:boolean | null
};
	["AuthorTopArticleUpsertArticleRelationInput"]: {
	update?:ValueTypes["ArticleUpdateInput"] | null,
	create?:ValueTypes["ArticleCreateInput"] | null
};
	["AuthorUpsertTopArticlesRelationInput"]: {
	by?:ValueTypes["AuthorTopArticleUniqueWhere"] | null,
	update?:ValueTypes["AuthorTopArticleWithoutAuthorUpdateInput"] | null,
	create?:ValueTypes["AuthorTopArticleWithoutAuthorCreateInput"] | null
};
	["AuthorUpdateUsersEntityRelationInput"]: {
	create?:ValueTypes["UserWithoutAuthorsCreateInput"] | null,
	update?:ValueTypes["AuthorUpdateUsersRelationInput"] | null,
	upsert?:ValueTypes["AuthorUpsertUsersRelationInput"] | null,
	connect?:ValueTypes["UserUniqueWhere"] | null,
	disconnect?:ValueTypes["UserUniqueWhere"] | null,
	delete?:ValueTypes["UserUniqueWhere"] | null,
	alias?:string | null
};
	["AuthorUpdateUsersRelationInput"]: {
	by?:ValueTypes["UserUniqueWhere"] | null,
	data?:ValueTypes["UserWithoutAuthorsUpdateInput"] | null
};
	["UserWithoutAuthorsUpdateInput"]: {
	ihnedId?:string | null,
	email?:string | null,
	unlockedArticles?:ValueTypes["UserUpdateUnlockedArticlesEntityRelationInput"][],
	appReviews?:ValueTypes["UserUpdateAppReviewsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["UserUpdateUnlockedArticlesEntityRelationInput"]: {
	create?:ValueTypes["UnlockedArticleWithoutUserCreateInput"] | null,
	update?:ValueTypes["UserUpdateUnlockedArticlesRelationInput"] | null,
	upsert?:ValueTypes["UserUpsertUnlockedArticlesRelationInput"] | null,
	connect?:ValueTypes["UnlockedArticleUniqueWhere"] | null,
	disconnect?:ValueTypes["UnlockedArticleUniqueWhere"] | null,
	delete?:ValueTypes["UnlockedArticleUniqueWhere"] | null,
	alias?:string | null
};
	["UserUpdateUnlockedArticlesRelationInput"]: {
	by?:ValueTypes["UnlockedArticleUniqueWhere"] | null,
	data?:ValueTypes["UnlockedArticleWithoutUserUpdateInput"] | null
};
	["UnlockedArticleWithoutUserUpdateInput"]: {
	createdAt?:ValueTypes["DateTime"] | null,
	code?:string | null,
	views?:number | null,
	article?:ValueTypes["UnlockedArticleUpdateArticleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["UnlockedArticleUpdateArticleEntityRelationInput"]: {
	create?:ValueTypes["ArticleWithoutUnlockedCreateInput"] | null,
	update?:ValueTypes["ArticleWithoutUnlockedUpdateInput"] | null,
	upsert?:ValueTypes["UnlockedArticleUpsertArticleRelationInput"] | null,
	connect?:ValueTypes["ArticleUniqueWhere"] | null,
	delete?:boolean | null
};
	["ArticleWithoutUnlockedUpdateInput"]: {
	title?:string | null,
	url?:ValueTypes["ArticleUpdateUrlEntityRelationInput"] | null,
	authors?:ValueTypes["ArticleUpdateAuthorsEntityRelationInput"][],
	hideInMostRead?:boolean | null,
	hideAds?:boolean | null,
	state?:ValueTypes["ArticleState"] | null,
	locked?:boolean | null,
	publishAt?:ValueTypes["DateTime"] | null,
	template?:ValueTypes["Template"] | null,
	subtitle?:ValueTypes["ArticleUpdateSubtitleEntityRelationInput"] | null,
	content?:ValueTypes["ArticleUpdateContentEntityRelationInput"] | null,
	coverPhoto?:ValueTypes["ArticleUpdateCoverPhotoEntityRelationInput"] | null,
	titleAlignment?:ValueTypes["ArticleTitleAlignment"] | null,
	tagline?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	previewContent?:ValueTypes["ArticleUpdatePreviewContentEntityRelationInput"] | null,
	audio?:ValueTypes["ArticleUpdateAudioEntityRelationInput"] | null,
	categories?:ValueTypes["ArticleUpdateCategoriesEntityRelationInput"][],
	issues?:ValueTypes["ArticleUpdateIssuesEntityRelationInput"][],
	contentBlocks?:ValueTypes["ArticleUpdateContentBlocksEntityRelationInput"][],
	coverPhotoVertical?:ValueTypes["ArticleUpdateCoverPhotoVerticalEntityRelationInput"] | null,
	legacyId?:string | null,
	tags?:ValueTypes["ArticleUpdateTagsEntityRelationInput"][],
	isHistory?:boolean | null,
	historyTags?:ValueTypes["ArticleUpdateHistoryTagsEntityRelationInput"][],
	historyPeriods?:ValueTypes["ArticleUpdateHistoryPeriodsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ArticleUpdateAuthorsEntityRelationInput"]: {
	create?:ValueTypes["ArticleAuthorWithoutArticleCreateInput"] | null,
	update?:ValueTypes["ArticleUpdateAuthorsRelationInput"] | null,
	upsert?:ValueTypes["ArticleUpsertAuthorsRelationInput"] | null,
	connect?:ValueTypes["ArticleAuthorUniqueWhere"] | null,
	disconnect?:ValueTypes["ArticleAuthorUniqueWhere"] | null,
	delete?:ValueTypes["ArticleAuthorUniqueWhere"] | null,
	alias?:string | null
};
	["ArticleUpdateAuthorsRelationInput"]: {
	by?:ValueTypes["ArticleAuthorUniqueWhere"] | null,
	data?:ValueTypes["ArticleAuthorWithoutArticleUpdateInput"] | null
};
	["ArticleAuthorWithoutArticleUpdateInput"]: {
	order?:number | null,
	author?:ValueTypes["ArticleAuthorUpdateAuthorEntityRelationInput"] | null,
	legacyStringAuthor?:ValueTypes["ArticleAuthorLegacyStringAuthor"] | null,
	_dummy_field_?:boolean | null
};
	["ArticleAuthorUpdateAuthorEntityRelationInput"]: {
	create?:ValueTypes["AuthorCreateInput"] | null,
	update?:ValueTypes["AuthorUpdateInput"] | null,
	upsert?:ValueTypes["ArticleAuthorUpsertAuthorRelationInput"] | null,
	connect?:ValueTypes["AuthorUniqueWhere"] | null,
	delete?:boolean | null
};
	["ArticleAuthorUpsertAuthorRelationInput"]: {
	update?:ValueTypes["AuthorUpdateInput"] | null,
	create?:ValueTypes["AuthorCreateInput"] | null
};
	["ArticleUpsertAuthorsRelationInput"]: {
	by?:ValueTypes["ArticleAuthorUniqueWhere"] | null,
	update?:ValueTypes["ArticleAuthorWithoutArticleUpdateInput"] | null,
	create?:ValueTypes["ArticleAuthorWithoutArticleCreateInput"] | null
};
	["ArticleUpdateSubtitleEntityRelationInput"]: {
	create?:ValueTypes["TextContentCreateInput"] | null,
	update?:ValueTypes["TextContentUpdateInput"] | null,
	upsert?:ValueTypes["ArticleUpsertSubtitleRelationInput"] | null,
	connect?:ValueTypes["TextContentUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["TextContentUpdateInput"]: {
	parts?:ValueTypes["TextContentUpdatePartsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TextContentUpdatePartsEntityRelationInput"]: {
	create?:ValueTypes["TextContentPartWithoutContentCreateInput"] | null,
	update?:ValueTypes["TextContentUpdatePartsRelationInput"] | null,
	upsert?:ValueTypes["TextContentUpsertPartsRelationInput"] | null,
	connect?:ValueTypes["TextContentPartUniqueWhere"] | null,
	disconnect?:ValueTypes["TextContentPartUniqueWhere"] | null,
	delete?:ValueTypes["TextContentPartUniqueWhere"] | null,
	alias?:string | null
};
	["TextContentUpdatePartsRelationInput"]: {
	by?:ValueTypes["TextContentPartUniqueWhere"] | null,
	data?:ValueTypes["TextContentPartWithoutContentUpdateInput"] | null
};
	["TextContentPartWithoutContentUpdateInput"]: {
	order?:number | null,
	json?:string | null,
	references?:ValueTypes["TextContentPartUpdateReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TextContentPartUpdateReferencesEntityRelationInput"]: {
	create?:ValueTypes["TextContentReferenceWithoutContentPartCreateInput"] | null,
	update?:ValueTypes["TextContentPartUpdateReferencesRelationInput"] | null,
	upsert?:ValueTypes["TextContentPartUpsertReferencesRelationInput"] | null,
	connect?:ValueTypes["TextContentReferenceUniqueWhere"] | null,
	disconnect?:ValueTypes["TextContentReferenceUniqueWhere"] | null,
	delete?:ValueTypes["TextContentReferenceUniqueWhere"] | null,
	alias?:string | null
};
	["TextContentPartUpdateReferencesRelationInput"]: {
	by?:ValueTypes["TextContentReferenceUniqueWhere"] | null,
	data?:ValueTypes["TextContentReferenceWithoutContentPartUpdateInput"] | null
};
	["TextContentReferenceWithoutContentPartUpdateInput"]: {
	type?:ValueTypes["TextContentReferenceType"] | null,
	target?:ValueTypes["TextContentReferenceUpdateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TextContentReferenceUpdateTargetEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["TextContentReferenceUpsertTargetRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkUpdateInput"]: {
	type?:ValueTypes["LinkType"] | null,
	externalTarget?:string | null,
	internalTarget?:ValueTypes["LinkUpdateInternalTargetEntityRelationInput"] | null,
	queryParameters?:string | null,
	_dummy_field_?:boolean | null
};
	["LinkUpdateInternalTargetEntityRelationInput"]: {
	create?:ValueTypes["UrlCreateInput"] | null,
	update?:ValueTypes["UrlUpdateInput"] | null,
	upsert?:ValueTypes["LinkUpsertInternalTargetRelationInput"] | null,
	connect?:ValueTypes["UrlUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["UrlUpdateInput"]: {
	url?:string | null,
	article?:ValueTypes["UrlUpdateArticleEntityRelationInput"] | null,
	author?:ValueTypes["UrlUpdateAuthorEntityRelationInput"] | null,
	issue?:ValueTypes["UrlUpdateIssueEntityRelationInput"] | null,
	page?:ValueTypes["UrlUpdatePageEntityRelationInput"] | null,
	category?:ValueTypes["UrlUpdateCategoryEntityRelationInput"] | null,
	tag?:ValueTypes["UrlUpdateTagEntityRelationInput"] | null,
	redirect?:string | null,
	_dummy_field_?:boolean | null
};
	["UrlUpdateArticleEntityRelationInput"]: {
	create?:ValueTypes["ArticleWithoutUrlCreateInput"] | null,
	update?:ValueTypes["ArticleWithoutUrlUpdateInput"] | null,
	upsert?:ValueTypes["UrlUpsertArticleRelationInput"] | null,
	connect?:ValueTypes["ArticleUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ArticleWithoutUrlUpdateInput"]: {
	title?:string | null,
	authors?:ValueTypes["ArticleUpdateAuthorsEntityRelationInput"][],
	hideInMostRead?:boolean | null,
	hideAds?:boolean | null,
	state?:ValueTypes["ArticleState"] | null,
	locked?:boolean | null,
	publishAt?:ValueTypes["DateTime"] | null,
	template?:ValueTypes["Template"] | null,
	subtitle?:ValueTypes["ArticleUpdateSubtitleEntityRelationInput"] | null,
	content?:ValueTypes["ArticleUpdateContentEntityRelationInput"] | null,
	coverPhoto?:ValueTypes["ArticleUpdateCoverPhotoEntityRelationInput"] | null,
	titleAlignment?:ValueTypes["ArticleTitleAlignment"] | null,
	tagline?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	previewContent?:ValueTypes["ArticleUpdatePreviewContentEntityRelationInput"] | null,
	audio?:ValueTypes["ArticleUpdateAudioEntityRelationInput"] | null,
	categories?:ValueTypes["ArticleUpdateCategoriesEntityRelationInput"][],
	issues?:ValueTypes["ArticleUpdateIssuesEntityRelationInput"][],
	contentBlocks?:ValueTypes["ArticleUpdateContentBlocksEntityRelationInput"][],
	unlocked?:ValueTypes["ArticleUpdateUnlockedEntityRelationInput"][],
	coverPhotoVertical?:ValueTypes["ArticleUpdateCoverPhotoVerticalEntityRelationInput"] | null,
	legacyId?:string | null,
	tags?:ValueTypes["ArticleUpdateTagsEntityRelationInput"][],
	isHistory?:boolean | null,
	historyTags?:ValueTypes["ArticleUpdateHistoryTagsEntityRelationInput"][],
	historyPeriods?:ValueTypes["ArticleUpdateHistoryPeriodsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ArticleUpdateContentEntityRelationInput"]: {
	create?:ValueTypes["ContentCreateInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["ArticleUpsertContentRelationInput"] | null,
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ArticleUpsertContentRelationInput"]: {
	update?:ValueTypes["ContentUpdateInput"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["ArticleUpdateCoverPhotoEntityRelationInput"]: {
	create?:ValueTypes["ImageUseCreateInput"] | null,
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	upsert?:ValueTypes["ArticleUpsertCoverPhotoRelationInput"] | null,
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ImageUseUpdateInput"]: {
	title?:string | null,
	image?:ValueTypes["ImageUseUpdateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ImageUseUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageWithoutUsesCreateInput"] | null,
	update?:ValueTypes["ImageWithoutUsesUpdateInput"] | null,
	upsert?:ValueTypes["ImageUseUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	delete?:boolean | null
};
	["ImageWithoutUsesUpdateInput"]: {
	url?:string | null,
	width?:number | null,
	height?:number | null,
	title?:string | null,
	text?:string | null,
	author?:ValueTypes["ImageUpdateAuthorEntityRelationInput"] | null,
	tags?:ValueTypes["ImageUpdateTagsEntityRelationInput"][],
	align?:ValueTypes["ImageAlign"] | null,
	legacyId?:string | null,
	_dummy_field_?:boolean | null
};
	["ImageUpdateAuthorEntityRelationInput"]: {
	create?:ValueTypes["AuthorCreateInput"] | null,
	update?:ValueTypes["AuthorUpdateInput"] | null,
	upsert?:ValueTypes["ImageUpsertAuthorRelationInput"] | null,
	connect?:ValueTypes["AuthorUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ImageUpsertAuthorRelationInput"]: {
	update?:ValueTypes["AuthorUpdateInput"] | null,
	create?:ValueTypes["AuthorCreateInput"] | null
};
	["ImageUpdateTagsEntityRelationInput"]: {
	create?:ValueTypes["ImageTagWithoutImagesCreateInput"] | null,
	update?:ValueTypes["ImageUpdateTagsRelationInput"] | null,
	upsert?:ValueTypes["ImageUpsertTagsRelationInput"] | null,
	connect?:ValueTypes["ImageTagUniqueWhere"] | null,
	disconnect?:ValueTypes["ImageTagUniqueWhere"] | null,
	delete?:ValueTypes["ImageTagUniqueWhere"] | null,
	alias?:string | null
};
	["ImageUpdateTagsRelationInput"]: {
	by?:ValueTypes["ImageTagUniqueWhere"] | null,
	data?:ValueTypes["ImageTagWithoutImagesUpdateInput"] | null
};
	["ImageTagWithoutImagesUpdateInput"]: {
	name?:string | null,
	_dummy_field_?:boolean | null
};
	["ImageUpsertTagsRelationInput"]: {
	by?:ValueTypes["ImageTagUniqueWhere"] | null,
	update?:ValueTypes["ImageTagWithoutImagesUpdateInput"] | null,
	create?:ValueTypes["ImageTagWithoutImagesCreateInput"] | null
};
	["ImageUseUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageWithoutUsesUpdateInput"] | null,
	create?:ValueTypes["ImageWithoutUsesCreateInput"] | null
};
	["ArticleUpsertCoverPhotoRelationInput"]: {
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["ArticleUpdatePreviewContentEntityRelationInput"]: {
	create?:ValueTypes["ContentCreateInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["ArticleUpsertPreviewContentRelationInput"] | null,
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ArticleUpsertPreviewContentRelationInput"]: {
	update?:ValueTypes["ContentUpdateInput"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["ArticleUpdateAudioEntityRelationInput"]: {
	create?:ValueTypes["AudioUseCreateInput"] | null,
	update?:ValueTypes["AudioUseUpdateInput"] | null,
	upsert?:ValueTypes["ArticleUpsertAudioRelationInput"] | null,
	connect?:ValueTypes["AudioUseUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ArticleUpsertAudioRelationInput"]: {
	update?:ValueTypes["AudioUseUpdateInput"] | null,
	create?:ValueTypes["AudioUseCreateInput"] | null
};
	["ArticleUpdateCategoriesEntityRelationInput"]: {
	create?:ValueTypes["ArticleCategoryWithoutArticleCreateInput"] | null,
	update?:ValueTypes["ArticleUpdateCategoriesRelationInput"] | null,
	upsert?:ValueTypes["ArticleUpsertCategoriesRelationInput"] | null,
	connect?:ValueTypes["ArticleCategoryUniqueWhere"] | null,
	disconnect?:ValueTypes["ArticleCategoryUniqueWhere"] | null,
	delete?:ValueTypes["ArticleCategoryUniqueWhere"] | null,
	alias?:string | null
};
	["ArticleUpdateCategoriesRelationInput"]: {
	by?:ValueTypes["ArticleCategoryUniqueWhere"] | null,
	data?:ValueTypes["ArticleCategoryWithoutArticleUpdateInput"] | null
};
	["ArticleCategoryWithoutArticleUpdateInput"]: {
	order?:number | null,
	category?:ValueTypes["ArticleCategoryUpdateCategoryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArticleCategoryUpdateCategoryEntityRelationInput"]: {
	create?:ValueTypes["CategoryWithoutArticleCategoryCreateInput"] | null,
	update?:ValueTypes["CategoryWithoutArticleCategoryUpdateInput"] | null,
	upsert?:ValueTypes["ArticleCategoryUpsertCategoryRelationInput"] | null,
	connect?:ValueTypes["CategoryUniqueWhere"] | null,
	delete?:boolean | null
};
	["CategoryWithoutArticleCategoryUpdateInput"]: {
	name?:string | null,
	url?:ValueTypes["CategoryUpdateUrlEntityRelationInput"] | null,
	legacyId?:string | null,
	_dummy_field_?:boolean | null
};
	["CategoryUpdateUrlEntityRelationInput"]: {
	create?:ValueTypes["UrlWithoutCategoryCreateInput"] | null,
	update?:ValueTypes["UrlWithoutCategoryUpdateInput"] | null,
	upsert?:ValueTypes["CategoryUpsertUrlRelationInput"] | null,
	connect?:ValueTypes["UrlUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["UrlWithoutCategoryUpdateInput"]: {
	url?:string | null,
	article?:ValueTypes["UrlUpdateArticleEntityRelationInput"] | null,
	author?:ValueTypes["UrlUpdateAuthorEntityRelationInput"] | null,
	issue?:ValueTypes["UrlUpdateIssueEntityRelationInput"] | null,
	page?:ValueTypes["UrlUpdatePageEntityRelationInput"] | null,
	tag?:ValueTypes["UrlUpdateTagEntityRelationInput"] | null,
	redirect?:string | null,
	_dummy_field_?:boolean | null
};
	["UrlUpdateIssueEntityRelationInput"]: {
	create?:ValueTypes["IssueWithoutUrlCreateInput"] | null,
	update?:ValueTypes["IssueWithoutUrlUpdateInput"] | null,
	upsert?:ValueTypes["UrlUpsertIssueRelationInput"] | null,
	connect?:ValueTypes["IssueUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["IssueWithoutUrlUpdateInput"]: {
	closed?:boolean | null,
	free?:boolean | null,
	title?:string | null,
	subtitle?:string | null,
	year?:number | null,
	issue?:number | null,
	publishedSince?:ValueTypes["Date"] | null,
	publishedUntil?:ValueTypes["Date"] | null,
	publishDigital?:ValueTypes["DateTime"] | null,
	mobileAppsKey?:string | null,
	articles?:ValueTypes["IssueUpdateArticlesEntityRelationInput"][],
	kind?:ValueTypes["IssueKind"] | null,
	notificationTitle?:string | null,
	notificationMessage?:string | null,
	pdf?:ValueTypes["IssueUpdatePdfEntityRelationInput"] | null,
	printBuy?:boolean | null,
	printText?:string | null,
	blocks?:ValueTypes["IssueUpdateBlocksEntityRelationInput"][],
	coverPhoto?:ValueTypes["IssueUpdateCoverPhotoEntityRelationInput"] | null,
	printTarget?:ValueTypes["IssueUpdatePrintTargetEntityRelationInput"] | null,
	backgroundPhoto?:ValueTypes["IssueUpdateBackgroundPhotoEntityRelationInput"] | null,
	legacyId?:string | null,
	_dummy_field_?:boolean | null
};
	["IssueUpdateArticlesEntityRelationInput"]: {
	create?:ValueTypes["IssueArticleWithoutIssueCreateInput"] | null,
	update?:ValueTypes["IssueUpdateArticlesRelationInput"] | null,
	upsert?:ValueTypes["IssueUpsertArticlesRelationInput"] | null,
	connect?:ValueTypes["IssueArticleUniqueWhere"] | null,
	disconnect?:ValueTypes["IssueArticleUniqueWhere"] | null,
	delete?:ValueTypes["IssueArticleUniqueWhere"] | null,
	alias?:string | null
};
	["IssueUpdateArticlesRelationInput"]: {
	by?:ValueTypes["IssueArticleUniqueWhere"] | null,
	data?:ValueTypes["IssueArticleWithoutIssueUpdateInput"] | null
};
	["IssueArticleWithoutIssueUpdateInput"]: {
	article?:ValueTypes["IssueArticleUpdateArticleEntityRelationInput"] | null,
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["IssueArticleUpdateArticleEntityRelationInput"]: {
	create?:ValueTypes["ArticleWithoutIssuesCreateInput"] | null,
	update?:ValueTypes["ArticleWithoutIssuesUpdateInput"] | null,
	upsert?:ValueTypes["IssueArticleUpsertArticleRelationInput"] | null,
	connect?:ValueTypes["ArticleUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ArticleWithoutIssuesUpdateInput"]: {
	title?:string | null,
	url?:ValueTypes["ArticleUpdateUrlEntityRelationInput"] | null,
	authors?:ValueTypes["ArticleUpdateAuthorsEntityRelationInput"][],
	hideInMostRead?:boolean | null,
	hideAds?:boolean | null,
	state?:ValueTypes["ArticleState"] | null,
	locked?:boolean | null,
	publishAt?:ValueTypes["DateTime"] | null,
	template?:ValueTypes["Template"] | null,
	subtitle?:ValueTypes["ArticleUpdateSubtitleEntityRelationInput"] | null,
	content?:ValueTypes["ArticleUpdateContentEntityRelationInput"] | null,
	coverPhoto?:ValueTypes["ArticleUpdateCoverPhotoEntityRelationInput"] | null,
	titleAlignment?:ValueTypes["ArticleTitleAlignment"] | null,
	tagline?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	previewContent?:ValueTypes["ArticleUpdatePreviewContentEntityRelationInput"] | null,
	audio?:ValueTypes["ArticleUpdateAudioEntityRelationInput"] | null,
	categories?:ValueTypes["ArticleUpdateCategoriesEntityRelationInput"][],
	contentBlocks?:ValueTypes["ArticleUpdateContentBlocksEntityRelationInput"][],
	unlocked?:ValueTypes["ArticleUpdateUnlockedEntityRelationInput"][],
	coverPhotoVertical?:ValueTypes["ArticleUpdateCoverPhotoVerticalEntityRelationInput"] | null,
	legacyId?:string | null,
	tags?:ValueTypes["ArticleUpdateTagsEntityRelationInput"][],
	isHistory?:boolean | null,
	historyTags?:ValueTypes["ArticleUpdateHistoryTagsEntityRelationInput"][],
	historyPeriods?:ValueTypes["ArticleUpdateHistoryPeriodsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ArticleUpdateContentBlocksEntityRelationInput"]: {
	create?:ValueTypes["ContentArticleWithoutArticleCreateInput"] | null,
	update?:ValueTypes["ArticleUpdateContentBlocksRelationInput"] | null,
	upsert?:ValueTypes["ArticleUpsertContentBlocksRelationInput"] | null,
	connect?:ValueTypes["ContentArticleUniqueWhere"] | null,
	disconnect?:ValueTypes["ContentArticleUniqueWhere"] | null,
	delete?:ValueTypes["ContentArticleUniqueWhere"] | null,
	alias?:string | null
};
	["ArticleUpdateContentBlocksRelationInput"]: {
	by?:ValueTypes["ContentArticleUniqueWhere"] | null,
	data?:ValueTypes["ContentArticleWithoutArticleUpdateInput"] | null
};
	["ContentArticleWithoutArticleUpdateInput"]: {
	order?:number | null,
	contentBlock?:ValueTypes["ContentArticleUpdateContentBlockEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentArticleUpdateContentBlockEntityRelationInput"]: {
	create?:ValueTypes["ContentBlockWithoutArticlesCreateInput"] | null,
	update?:ValueTypes["ContentBlockWithoutArticlesUpdateInput"] | null,
	upsert?:ValueTypes["ContentArticleUpsertContentBlockRelationInput"] | null,
	connect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	delete?:boolean | null
};
	["ContentBlockWithoutArticlesUpdateInput"]: {
	order?:number | null,
	type?:ValueTypes["ContentBlockType"] | null,
	youtubeId?:string | null,
	text?:string | null,
	targetLabel?:string | null,
	issue?:ValueTypes["ContentBlockUpdateIssueEntityRelationInput"] | null,
	target?:ValueTypes["ContentBlockUpdateTargetEntityRelationInput"] | null,
	subscriptionForm?:ValueTypes["ContentBlockUpdateSubscriptionFormEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentBlockUpdateIssueEntityRelationInput"]: {
	create?:ValueTypes["IssueWithoutBlocksCreateInput"] | null,
	update?:ValueTypes["IssueWithoutBlocksUpdateInput"] | null,
	upsert?:ValueTypes["ContentBlockUpsertIssueRelationInput"] | null,
	connect?:ValueTypes["IssueUniqueWhere"] | null,
	delete?:boolean | null
};
	["IssueWithoutBlocksUpdateInput"]: {
	closed?:boolean | null,
	free?:boolean | null,
	title?:string | null,
	subtitle?:string | null,
	year?:number | null,
	issue?:number | null,
	publishedSince?:ValueTypes["Date"] | null,
	publishedUntil?:ValueTypes["Date"] | null,
	publishDigital?:ValueTypes["DateTime"] | null,
	mobileAppsKey?:string | null,
	url?:ValueTypes["IssueUpdateUrlEntityRelationInput"] | null,
	articles?:ValueTypes["IssueUpdateArticlesEntityRelationInput"][],
	kind?:ValueTypes["IssueKind"] | null,
	notificationTitle?:string | null,
	notificationMessage?:string | null,
	pdf?:ValueTypes["IssueUpdatePdfEntityRelationInput"] | null,
	printBuy?:boolean | null,
	printText?:string | null,
	coverPhoto?:ValueTypes["IssueUpdateCoverPhotoEntityRelationInput"] | null,
	printTarget?:ValueTypes["IssueUpdatePrintTargetEntityRelationInput"] | null,
	backgroundPhoto?:ValueTypes["IssueUpdateBackgroundPhotoEntityRelationInput"] | null,
	legacyId?:string | null,
	_dummy_field_?:boolean | null
};
	["IssueUpdateUrlEntityRelationInput"]: {
	create?:ValueTypes["UrlWithoutIssueCreateInput"] | null,
	update?:ValueTypes["UrlWithoutIssueUpdateInput"] | null,
	upsert?:ValueTypes["IssueUpsertUrlRelationInput"] | null,
	connect?:ValueTypes["UrlUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["UrlWithoutIssueUpdateInput"]: {
	url?:string | null,
	article?:ValueTypes["UrlUpdateArticleEntityRelationInput"] | null,
	author?:ValueTypes["UrlUpdateAuthorEntityRelationInput"] | null,
	page?:ValueTypes["UrlUpdatePageEntityRelationInput"] | null,
	category?:ValueTypes["UrlUpdateCategoryEntityRelationInput"] | null,
	tag?:ValueTypes["UrlUpdateTagEntityRelationInput"] | null,
	redirect?:string | null,
	_dummy_field_?:boolean | null
};
	["UrlUpdatePageEntityRelationInput"]: {
	create?:ValueTypes["PageWithoutUrlCreateInput"] | null,
	update?:ValueTypes["PageWithoutUrlUpdateInput"] | null,
	upsert?:ValueTypes["UrlUpsertPageRelationInput"] | null,
	connect?:ValueTypes["PageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["PageWithoutUrlUpdateInput"]: {
	title?:string | null,
	publishAt?:ValueTypes["DateTime"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	template?:ValueTypes["PageTemplate"] | null,
	content?:ValueTypes["PageUpdateContentEntityRelationInput"] | null,
	seo?:ValueTypes["PageUpdateSeoEntityRelationInput"] | null,
	subscriptionValidity?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["PageUpdateContentEntityRelationInput"]: {
	create?:ValueTypes["ContentCreateInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["PageUpsertContentRelationInput"] | null,
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["PageUpsertContentRelationInput"]: {
	update?:ValueTypes["ContentUpdateInput"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["PageUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoWithoutPageCreateInput"] | null,
	update?:ValueTypes["SeoWithoutPageUpdateInput"] | null,
	upsert?:ValueTypes["PageUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SeoWithoutPageUpdateInput"]: {
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	twCard?:ValueTypes["SeoTwCard"] | null,
	ogImage?:ValueTypes["SeoUpdateOgImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SeoUpdateOgImageEntityRelationInput"]: {
	create?:ValueTypes["ImageUseCreateInput"] | null,
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	upsert?:ValueTypes["SeoUpsertOgImageRelationInput"] | null,
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SeoUpsertOgImageRelationInput"]: {
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["PageUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoWithoutPageUpdateInput"] | null,
	create?:ValueTypes["SeoWithoutPageCreateInput"] | null
};
	["UrlUpsertPageRelationInput"]: {
	update?:ValueTypes["PageWithoutUrlUpdateInput"] | null,
	create?:ValueTypes["PageWithoutUrlCreateInput"] | null
};
	["UrlUpdateCategoryEntityRelationInput"]: {
	create?:ValueTypes["CategoryWithoutUrlCreateInput"] | null,
	update?:ValueTypes["CategoryWithoutUrlUpdateInput"] | null,
	upsert?:ValueTypes["UrlUpsertCategoryRelationInput"] | null,
	connect?:ValueTypes["CategoryUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["CategoryWithoutUrlUpdateInput"]: {
	name?:string | null,
	articleCategory?:ValueTypes["CategoryUpdateArticleCategoryEntityRelationInput"][],
	legacyId?:string | null,
	_dummy_field_?:boolean | null
};
	["CategoryUpdateArticleCategoryEntityRelationInput"]: {
	create?:ValueTypes["ArticleCategoryWithoutCategoryCreateInput"] | null,
	update?:ValueTypes["CategoryUpdateArticleCategoryRelationInput"] | null,
	upsert?:ValueTypes["CategoryUpsertArticleCategoryRelationInput"] | null,
	connect?:ValueTypes["ArticleCategoryUniqueWhere"] | null,
	disconnect?:ValueTypes["ArticleCategoryUniqueWhere"] | null,
	delete?:ValueTypes["ArticleCategoryUniqueWhere"] | null,
	alias?:string | null
};
	["CategoryUpdateArticleCategoryRelationInput"]: {
	by?:ValueTypes["ArticleCategoryUniqueWhere"] | null,
	data?:ValueTypes["ArticleCategoryWithoutCategoryUpdateInput"] | null
};
	["ArticleCategoryWithoutCategoryUpdateInput"]: {
	order?:number | null,
	article?:ValueTypes["ArticleCategoryUpdateArticleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArticleCategoryUpdateArticleEntityRelationInput"]: {
	create?:ValueTypes["ArticleWithoutCategoriesCreateInput"] | null,
	update?:ValueTypes["ArticleWithoutCategoriesUpdateInput"] | null,
	upsert?:ValueTypes["ArticleCategoryUpsertArticleRelationInput"] | null,
	connect?:ValueTypes["ArticleUniqueWhere"] | null,
	delete?:boolean | null
};
	["ArticleWithoutCategoriesUpdateInput"]: {
	title?:string | null,
	url?:ValueTypes["ArticleUpdateUrlEntityRelationInput"] | null,
	authors?:ValueTypes["ArticleUpdateAuthorsEntityRelationInput"][],
	hideInMostRead?:boolean | null,
	hideAds?:boolean | null,
	state?:ValueTypes["ArticleState"] | null,
	locked?:boolean | null,
	publishAt?:ValueTypes["DateTime"] | null,
	template?:ValueTypes["Template"] | null,
	subtitle?:ValueTypes["ArticleUpdateSubtitleEntityRelationInput"] | null,
	content?:ValueTypes["ArticleUpdateContentEntityRelationInput"] | null,
	coverPhoto?:ValueTypes["ArticleUpdateCoverPhotoEntityRelationInput"] | null,
	titleAlignment?:ValueTypes["ArticleTitleAlignment"] | null,
	tagline?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	previewContent?:ValueTypes["ArticleUpdatePreviewContentEntityRelationInput"] | null,
	audio?:ValueTypes["ArticleUpdateAudioEntityRelationInput"] | null,
	issues?:ValueTypes["ArticleUpdateIssuesEntityRelationInput"][],
	contentBlocks?:ValueTypes["ArticleUpdateContentBlocksEntityRelationInput"][],
	unlocked?:ValueTypes["ArticleUpdateUnlockedEntityRelationInput"][],
	coverPhotoVertical?:ValueTypes["ArticleUpdateCoverPhotoVerticalEntityRelationInput"] | null,
	legacyId?:string | null,
	tags?:ValueTypes["ArticleUpdateTagsEntityRelationInput"][],
	isHistory?:boolean | null,
	historyTags?:ValueTypes["ArticleUpdateHistoryTagsEntityRelationInput"][],
	historyPeriods?:ValueTypes["ArticleUpdateHistoryPeriodsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ArticleUpdateIssuesEntityRelationInput"]: {
	create?:ValueTypes["IssueArticleWithoutArticleCreateInput"] | null,
	update?:ValueTypes["ArticleUpdateIssuesRelationInput"] | null,
	upsert?:ValueTypes["ArticleUpsertIssuesRelationInput"] | null,
	connect?:ValueTypes["IssueArticleUniqueWhere"] | null,
	disconnect?:ValueTypes["IssueArticleUniqueWhere"] | null,
	delete?:ValueTypes["IssueArticleUniqueWhere"] | null,
	alias?:string | null
};
	["ArticleUpdateIssuesRelationInput"]: {
	by?:ValueTypes["IssueArticleUniqueWhere"] | null,
	data?:ValueTypes["IssueArticleWithoutArticleUpdateInput"] | null
};
	["IssueArticleWithoutArticleUpdateInput"]: {
	issue?:ValueTypes["IssueArticleUpdateIssueEntityRelationInput"] | null,
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["IssueArticleUpdateIssueEntityRelationInput"]: {
	create?:ValueTypes["IssueWithoutArticlesCreateInput"] | null,
	update?:ValueTypes["IssueWithoutArticlesUpdateInput"] | null,
	upsert?:ValueTypes["IssueArticleUpsertIssueRelationInput"] | null,
	connect?:ValueTypes["IssueUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["IssueWithoutArticlesUpdateInput"]: {
	closed?:boolean | null,
	free?:boolean | null,
	title?:string | null,
	subtitle?:string | null,
	year?:number | null,
	issue?:number | null,
	publishedSince?:ValueTypes["Date"] | null,
	publishedUntil?:ValueTypes["Date"] | null,
	publishDigital?:ValueTypes["DateTime"] | null,
	mobileAppsKey?:string | null,
	url?:ValueTypes["IssueUpdateUrlEntityRelationInput"] | null,
	kind?:ValueTypes["IssueKind"] | null,
	notificationTitle?:string | null,
	notificationMessage?:string | null,
	pdf?:ValueTypes["IssueUpdatePdfEntityRelationInput"] | null,
	printBuy?:boolean | null,
	printText?:string | null,
	blocks?:ValueTypes["IssueUpdateBlocksEntityRelationInput"][],
	coverPhoto?:ValueTypes["IssueUpdateCoverPhotoEntityRelationInput"] | null,
	printTarget?:ValueTypes["IssueUpdatePrintTargetEntityRelationInput"] | null,
	backgroundPhoto?:ValueTypes["IssueUpdateBackgroundPhotoEntityRelationInput"] | null,
	legacyId?:string | null,
	_dummy_field_?:boolean | null
};
	["IssueUpdatePdfEntityRelationInput"]: {
	create?:ValueTypes["FileUseCreateInput"] | null,
	update?:ValueTypes["FileUseUpdateInput"] | null,
	upsert?:ValueTypes["IssueUpsertPdfRelationInput"] | null,
	connect?:ValueTypes["FileUseUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FileUseUpdateInput"]: {
	file?:ValueTypes["FileUseUpdateFileEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FileUseUpdateFileEntityRelationInput"]: {
	create?:ValueTypes["FileWithoutUsesCreateInput"] | null,
	update?:ValueTypes["FileWithoutUsesUpdateInput"] | null,
	upsert?:ValueTypes["FileUseUpsertFileRelationInput"] | null,
	connect?:ValueTypes["FileUniqueWhere"] | null,
	delete?:boolean | null
};
	["FileWithoutUsesUpdateInput"]: {
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["FileUseUpsertFileRelationInput"]: {
	update?:ValueTypes["FileWithoutUsesUpdateInput"] | null,
	create?:ValueTypes["FileWithoutUsesCreateInput"] | null
};
	["IssueUpsertPdfRelationInput"]: {
	update?:ValueTypes["FileUseUpdateInput"] | null,
	create?:ValueTypes["FileUseCreateInput"] | null
};
	["IssueUpdateBlocksEntityRelationInput"]: {
	create?:ValueTypes["ContentBlockWithoutIssueCreateInput"] | null,
	update?:ValueTypes["IssueUpdateBlocksRelationInput"] | null,
	upsert?:ValueTypes["IssueUpsertBlocksRelationInput"] | null,
	connect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	disconnect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	delete?:ValueTypes["ContentBlockUniqueWhere"] | null,
	alias?:string | null
};
	["IssueUpdateBlocksRelationInput"]: {
	by?:ValueTypes["ContentBlockUniqueWhere"] | null,
	data?:ValueTypes["ContentBlockWithoutIssueUpdateInput"] | null
};
	["ContentBlockWithoutIssueUpdateInput"]: {
	order?:number | null,
	type?:ValueTypes["ContentBlockType"] | null,
	youtubeId?:string | null,
	text?:string | null,
	targetLabel?:string | null,
	target?:ValueTypes["ContentBlockUpdateTargetEntityRelationInput"] | null,
	articles?:ValueTypes["ContentBlockUpdateArticlesEntityRelationInput"][],
	subscriptionForm?:ValueTypes["ContentBlockUpdateSubscriptionFormEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentBlockUpdateTargetEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["ContentBlockUpsertTargetRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentBlockUpsertTargetRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["ContentBlockUpdateArticlesEntityRelationInput"]: {
	create?:ValueTypes["ContentArticleWithoutContentBlockCreateInput"] | null,
	update?:ValueTypes["ContentBlockUpdateArticlesRelationInput"] | null,
	upsert?:ValueTypes["ContentBlockUpsertArticlesRelationInput"] | null,
	connect?:ValueTypes["ContentArticleUniqueWhere"] | null,
	disconnect?:ValueTypes["ContentArticleUniqueWhere"] | null,
	delete?:ValueTypes["ContentArticleUniqueWhere"] | null,
	alias?:string | null
};
	["ContentBlockUpdateArticlesRelationInput"]: {
	by?:ValueTypes["ContentArticleUniqueWhere"] | null,
	data?:ValueTypes["ContentArticleWithoutContentBlockUpdateInput"] | null
};
	["ContentArticleWithoutContentBlockUpdateInput"]: {
	order?:number | null,
	article?:ValueTypes["ContentArticleUpdateArticleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentArticleUpdateArticleEntityRelationInput"]: {
	create?:ValueTypes["ArticleWithoutContentBlocksCreateInput"] | null,
	update?:ValueTypes["ArticleWithoutContentBlocksUpdateInput"] | null,
	upsert?:ValueTypes["ContentArticleUpsertArticleRelationInput"] | null,
	connect?:ValueTypes["ArticleUniqueWhere"] | null,
	delete?:boolean | null
};
	["ArticleWithoutContentBlocksUpdateInput"]: {
	title?:string | null,
	url?:ValueTypes["ArticleUpdateUrlEntityRelationInput"] | null,
	authors?:ValueTypes["ArticleUpdateAuthorsEntityRelationInput"][],
	hideInMostRead?:boolean | null,
	hideAds?:boolean | null,
	state?:ValueTypes["ArticleState"] | null,
	locked?:boolean | null,
	publishAt?:ValueTypes["DateTime"] | null,
	template?:ValueTypes["Template"] | null,
	subtitle?:ValueTypes["ArticleUpdateSubtitleEntityRelationInput"] | null,
	content?:ValueTypes["ArticleUpdateContentEntityRelationInput"] | null,
	coverPhoto?:ValueTypes["ArticleUpdateCoverPhotoEntityRelationInput"] | null,
	titleAlignment?:ValueTypes["ArticleTitleAlignment"] | null,
	tagline?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	previewContent?:ValueTypes["ArticleUpdatePreviewContentEntityRelationInput"] | null,
	audio?:ValueTypes["ArticleUpdateAudioEntityRelationInput"] | null,
	categories?:ValueTypes["ArticleUpdateCategoriesEntityRelationInput"][],
	issues?:ValueTypes["ArticleUpdateIssuesEntityRelationInput"][],
	unlocked?:ValueTypes["ArticleUpdateUnlockedEntityRelationInput"][],
	coverPhotoVertical?:ValueTypes["ArticleUpdateCoverPhotoVerticalEntityRelationInput"] | null,
	legacyId?:string | null,
	tags?:ValueTypes["ArticleUpdateTagsEntityRelationInput"][],
	isHistory?:boolean | null,
	historyTags?:ValueTypes["ArticleUpdateHistoryTagsEntityRelationInput"][],
	historyPeriods?:ValueTypes["ArticleUpdateHistoryPeriodsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ArticleUpdateUnlockedEntityRelationInput"]: {
	create?:ValueTypes["UnlockedArticleWithoutArticleCreateInput"] | null,
	update?:ValueTypes["ArticleUpdateUnlockedRelationInput"] | null,
	upsert?:ValueTypes["ArticleUpsertUnlockedRelationInput"] | null,
	connect?:ValueTypes["UnlockedArticleUniqueWhere"] | null,
	disconnect?:ValueTypes["UnlockedArticleUniqueWhere"] | null,
	delete?:ValueTypes["UnlockedArticleUniqueWhere"] | null,
	alias?:string | null
};
	["ArticleUpdateUnlockedRelationInput"]: {
	by?:ValueTypes["UnlockedArticleUniqueWhere"] | null,
	data?:ValueTypes["UnlockedArticleWithoutArticleUpdateInput"] | null
};
	["UnlockedArticleWithoutArticleUpdateInput"]: {
	createdAt?:ValueTypes["DateTime"] | null,
	code?:string | null,
	views?:number | null,
	user?:ValueTypes["UnlockedArticleUpdateUserEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["UnlockedArticleUpdateUserEntityRelationInput"]: {
	create?:ValueTypes["UserWithoutUnlockedArticlesCreateInput"] | null,
	update?:ValueTypes["UserWithoutUnlockedArticlesUpdateInput"] | null,
	upsert?:ValueTypes["UnlockedArticleUpsertUserRelationInput"] | null,
	connect?:ValueTypes["UserUniqueWhere"] | null,
	delete?:boolean | null
};
	["UserWithoutUnlockedArticlesUpdateInput"]: {
	ihnedId?:string | null,
	email?:string | null,
	authors?:ValueTypes["UserUpdateAuthorsEntityRelationInput"][],
	appReviews?:ValueTypes["UserUpdateAppReviewsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["UserUpdateAuthorsEntityRelationInput"]: {
	create?:ValueTypes["AuthorWithoutUsersCreateInput"] | null,
	update?:ValueTypes["UserUpdateAuthorsRelationInput"] | null,
	upsert?:ValueTypes["UserUpsertAuthorsRelationInput"] | null,
	connect?:ValueTypes["AuthorUniqueWhere"] | null,
	disconnect?:ValueTypes["AuthorUniqueWhere"] | null,
	delete?:ValueTypes["AuthorUniqueWhere"] | null,
	alias?:string | null
};
	["UserUpdateAuthorsRelationInput"]: {
	by?:ValueTypes["AuthorUniqueWhere"] | null,
	data?:ValueTypes["AuthorWithoutUsersUpdateInput"] | null
};
	["AuthorWithoutUsersUpdateInput"]: {
	name?:string | null,
	position?:string | null,
	twitterHandle?:string | null,
	facebookId?:string | null,
	email?:string | null,
	photographer?:boolean | null,
	order?:number | null,
	about?:ValueTypes["AuthorUpdateAboutEntityRelationInput"] | null,
	topArticles?:ValueTypes["AuthorUpdateTopArticlesEntityRelationInput"][],
	startOfCooperation?:ValueTypes["Date"] | null,
	photo?:ValueTypes["AuthorUpdatePhotoEntityRelationInput"] | null,
	illustration?:ValueTypes["AuthorUpdateIllustrationEntityRelationInput"] | null,
	legacyId?:string | null,
	category?:ValueTypes["AuthorCategory"] | null,
	url?:ValueTypes["AuthorUpdateUrlEntityRelationInput"] | null,
	instagramUsername?:string | null,
	_dummy_field_?:boolean | null
};
	["AuthorUpdatePhotoEntityRelationInput"]: {
	create?:ValueTypes["ImageUseCreateInput"] | null,
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	upsert?:ValueTypes["AuthorUpsertPhotoRelationInput"] | null,
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["AuthorUpsertPhotoRelationInput"]: {
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["AuthorUpdateIllustrationEntityRelationInput"]: {
	create?:ValueTypes["ImageUseCreateInput"] | null,
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	upsert?:ValueTypes["AuthorUpsertIllustrationRelationInput"] | null,
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["AuthorUpsertIllustrationRelationInput"]: {
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["AuthorUpdateUrlEntityRelationInput"]: {
	create?:ValueTypes["UrlWithoutAuthorCreateInput"] | null,
	update?:ValueTypes["UrlWithoutAuthorUpdateInput"] | null,
	upsert?:ValueTypes["AuthorUpsertUrlRelationInput"] | null,
	connect?:ValueTypes["UrlUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["UrlWithoutAuthorUpdateInput"]: {
	url?:string | null,
	article?:ValueTypes["UrlUpdateArticleEntityRelationInput"] | null,
	issue?:ValueTypes["UrlUpdateIssueEntityRelationInput"] | null,
	page?:ValueTypes["UrlUpdatePageEntityRelationInput"] | null,
	category?:ValueTypes["UrlUpdateCategoryEntityRelationInput"] | null,
	tag?:ValueTypes["UrlUpdateTagEntityRelationInput"] | null,
	redirect?:string | null,
	_dummy_field_?:boolean | null
};
	["UrlUpdateTagEntityRelationInput"]: {
	create?:ValueTypes["TagWithoutUrlCreateInput"] | null,
	update?:ValueTypes["TagWithoutUrlUpdateInput"] | null,
	upsert?:ValueTypes["UrlUpsertTagRelationInput"] | null,
	connect?:ValueTypes["TagUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["TagWithoutUrlUpdateInput"]: {
	name?:string | null,
	useAsTagline?:boolean | null,
	articleTag?:ValueTypes["TagUpdateArticleTagEntityRelationInput"][],
	order?:string | null,
	legacyId?:string | null,
	_dummy_field_?:boolean | null
};
	["TagUpdateArticleTagEntityRelationInput"]: {
	create?:ValueTypes["ArticleTagWithoutTagCreateInput"] | null,
	update?:ValueTypes["TagUpdateArticleTagRelationInput"] | null,
	upsert?:ValueTypes["TagUpsertArticleTagRelationInput"] | null,
	connect?:ValueTypes["ArticleTagUniqueWhere"] | null,
	disconnect?:ValueTypes["ArticleTagUniqueWhere"] | null,
	delete?:ValueTypes["ArticleTagUniqueWhere"] | null,
	alias?:string | null
};
	["TagUpdateArticleTagRelationInput"]: {
	by?:ValueTypes["ArticleTagUniqueWhere"] | null,
	data?:ValueTypes["ArticleTagWithoutTagUpdateInput"] | null
};
	["ArticleTagWithoutTagUpdateInput"]: {
	order?:number | null,
	article?:ValueTypes["ArticleTagUpdateArticleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArticleTagUpdateArticleEntityRelationInput"]: {
	create?:ValueTypes["ArticleWithoutTagsCreateInput"] | null,
	update?:ValueTypes["ArticleWithoutTagsUpdateInput"] | null,
	upsert?:ValueTypes["ArticleTagUpsertArticleRelationInput"] | null,
	connect?:ValueTypes["ArticleUniqueWhere"] | null,
	delete?:boolean | null
};
	["ArticleWithoutTagsUpdateInput"]: {
	title?:string | null,
	url?:ValueTypes["ArticleUpdateUrlEntityRelationInput"] | null,
	authors?:ValueTypes["ArticleUpdateAuthorsEntityRelationInput"][],
	hideInMostRead?:boolean | null,
	hideAds?:boolean | null,
	state?:ValueTypes["ArticleState"] | null,
	locked?:boolean | null,
	publishAt?:ValueTypes["DateTime"] | null,
	template?:ValueTypes["Template"] | null,
	subtitle?:ValueTypes["ArticleUpdateSubtitleEntityRelationInput"] | null,
	content?:ValueTypes["ArticleUpdateContentEntityRelationInput"] | null,
	coverPhoto?:ValueTypes["ArticleUpdateCoverPhotoEntityRelationInput"] | null,
	titleAlignment?:ValueTypes["ArticleTitleAlignment"] | null,
	tagline?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	previewContent?:ValueTypes["ArticleUpdatePreviewContentEntityRelationInput"] | null,
	audio?:ValueTypes["ArticleUpdateAudioEntityRelationInput"] | null,
	categories?:ValueTypes["ArticleUpdateCategoriesEntityRelationInput"][],
	issues?:ValueTypes["ArticleUpdateIssuesEntityRelationInput"][],
	contentBlocks?:ValueTypes["ArticleUpdateContentBlocksEntityRelationInput"][],
	unlocked?:ValueTypes["ArticleUpdateUnlockedEntityRelationInput"][],
	coverPhotoVertical?:ValueTypes["ArticleUpdateCoverPhotoVerticalEntityRelationInput"] | null,
	legacyId?:string | null,
	isHistory?:boolean | null,
	historyTags?:ValueTypes["ArticleUpdateHistoryTagsEntityRelationInput"][],
	historyPeriods?:ValueTypes["ArticleUpdateHistoryPeriodsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ArticleUpdateCoverPhotoVerticalEntityRelationInput"]: {
	create?:ValueTypes["ImageUseCreateInput"] | null,
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	upsert?:ValueTypes["ArticleUpsertCoverPhotoVerticalRelationInput"] | null,
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ArticleUpsertCoverPhotoVerticalRelationInput"]: {
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["ArticleUpdateHistoryTagsEntityRelationInput"]: {
	create?:ValueTypes["ArticleHistoryTagWithoutArticleCreateInput"] | null,
	update?:ValueTypes["ArticleUpdateHistoryTagsRelationInput"] | null,
	upsert?:ValueTypes["ArticleUpsertHistoryTagsRelationInput"] | null,
	connect?:ValueTypes["ArticleHistoryTagUniqueWhere"] | null,
	disconnect?:ValueTypes["ArticleHistoryTagUniqueWhere"] | null,
	delete?:ValueTypes["ArticleHistoryTagUniqueWhere"] | null,
	alias?:string | null
};
	["ArticleUpdateHistoryTagsRelationInput"]: {
	by?:ValueTypes["ArticleHistoryTagUniqueWhere"] | null,
	data?:ValueTypes["ArticleHistoryTagWithoutArticleUpdateInput"] | null
};
	["ArticleHistoryTagWithoutArticleUpdateInput"]: {
	order?:number | null,
	historyTag?:ValueTypes["ArticleHistoryTagUpdateHistoryTagEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArticleHistoryTagUpdateHistoryTagEntityRelationInput"]: {
	create?:ValueTypes["HistoryTagWithoutArticleHistoryTagCreateInput"] | null,
	update?:ValueTypes["HistoryTagWithoutArticleHistoryTagUpdateInput"] | null,
	upsert?:ValueTypes["ArticleHistoryTagUpsertHistoryTagRelationInput"] | null,
	connect?:ValueTypes["HistoryTagUniqueWhere"] | null,
	delete?:boolean | null
};
	["HistoryTagWithoutArticleHistoryTagUpdateInput"]: {
	name?:string | null,
	slug?:string | null,
	_dummy_field_?:boolean | null
};
	["ArticleHistoryTagUpsertHistoryTagRelationInput"]: {
	update?:ValueTypes["HistoryTagWithoutArticleHistoryTagUpdateInput"] | null,
	create?:ValueTypes["HistoryTagWithoutArticleHistoryTagCreateInput"] | null
};
	["ArticleUpsertHistoryTagsRelationInput"]: {
	by?:ValueTypes["ArticleHistoryTagUniqueWhere"] | null,
	update?:ValueTypes["ArticleHistoryTagWithoutArticleUpdateInput"] | null,
	create?:ValueTypes["ArticleHistoryTagWithoutArticleCreateInput"] | null
};
	["ArticleUpdateHistoryPeriodsEntityRelationInput"]: {
	create?:ValueTypes["ArticleHistoryPeriodWithoutArticleCreateInput"] | null,
	update?:ValueTypes["ArticleUpdateHistoryPeriodsRelationInput"] | null,
	upsert?:ValueTypes["ArticleUpsertHistoryPeriodsRelationInput"] | null,
	connect?:ValueTypes["ArticleHistoryPeriodUniqueWhere"] | null,
	disconnect?:ValueTypes["ArticleHistoryPeriodUniqueWhere"] | null,
	delete?:ValueTypes["ArticleHistoryPeriodUniqueWhere"] | null,
	alias?:string | null
};
	["ArticleUpdateHistoryPeriodsRelationInput"]: {
	by?:ValueTypes["ArticleHistoryPeriodUniqueWhere"] | null,
	data?:ValueTypes["ArticleHistoryPeriodWithoutArticleUpdateInput"] | null
};
	["ArticleHistoryPeriodWithoutArticleUpdateInput"]: {
	order?:number | null,
	historyPeriod?:ValueTypes["ArticleHistoryPeriodUpdateHistoryPeriodEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArticleHistoryPeriodUpdateHistoryPeriodEntityRelationInput"]: {
	create?:ValueTypes["HistoryPeriodWithoutArticleHistoryPeriodCreateInput"] | null,
	update?:ValueTypes["HistoryPeriodWithoutArticleHistoryPeriodUpdateInput"] | null,
	upsert?:ValueTypes["ArticleHistoryPeriodUpsertHistoryPeriodRelationInput"] | null,
	connect?:ValueTypes["HistoryPeriodUniqueWhere"] | null,
	delete?:boolean | null
};
	["HistoryPeriodWithoutArticleHistoryPeriodUpdateInput"]: {
	name?:string | null,
	slug?:string | null,
	order?:number | null,
	cover?:ValueTypes["HistoryPeriodUpdateCoverEntityRelationInput"] | null,
	seo?:ValueTypes["HistoryPeriodUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HistoryPeriodUpdateCoverEntityRelationInput"]: {
	create?:ValueTypes["HistoryCoverCreateInput"] | null,
	update?:ValueTypes["HistoryCoverUpdateInput"] | null,
	upsert?:ValueTypes["HistoryPeriodUpsertCoverRelationInput"] | null,
	connect?:ValueTypes["HistoryCoverUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HistoryCoverUpdateInput"]: {
	title?:string | null,
	tileParagraph?:string | null,
	coverImage?:ValueTypes["HistoryCoverUpdateCoverImageEntityRelationInput"] | null,
	tileImage?:ValueTypes["HistoryCoverUpdateTileImageEntityRelationInput"] | null,
	mobileImage?:ValueTypes["HistoryCoverUpdateMobileImageEntityRelationInput"] | null,
	leadContent?:ValueTypes["HistoryCoverUpdateLeadContentEntityRelationInput"] | null,
	annotations?:ValueTypes["HistoryCoverUpdateAnnotationsEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HistoryCoverUpdateCoverImageEntityRelationInput"]: {
	create?:ValueTypes["ImageUseCreateInput"] | null,
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	upsert?:ValueTypes["HistoryCoverUpsertCoverImageRelationInput"] | null,
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HistoryCoverUpsertCoverImageRelationInput"]: {
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["HistoryCoverUpdateTileImageEntityRelationInput"]: {
	create?:ValueTypes["ImageUseCreateInput"] | null,
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	upsert?:ValueTypes["HistoryCoverUpsertTileImageRelationInput"] | null,
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HistoryCoverUpsertTileImageRelationInput"]: {
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["HistoryCoverUpdateMobileImageEntityRelationInput"]: {
	create?:ValueTypes["ImageUseCreateInput"] | null,
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	upsert?:ValueTypes["HistoryCoverUpsertMobileImageRelationInput"] | null,
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HistoryCoverUpsertMobileImageRelationInput"]: {
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["HistoryCoverUpdateLeadContentEntityRelationInput"]: {
	create?:ValueTypes["ContentCreateInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["HistoryCoverUpsertLeadContentRelationInput"] | null,
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HistoryCoverUpsertLeadContentRelationInput"]: {
	update?:ValueTypes["ContentUpdateInput"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["HistoryCoverUpdateAnnotationsEntityRelationInput"]: {
	create?:ValueTypes["HistoryTextListCreateInput"] | null,
	update?:ValueTypes["HistoryTextListUpdateInput"] | null,
	upsert?:ValueTypes["HistoryCoverUpsertAnnotationsRelationInput"] | null,
	connect?:ValueTypes["HistoryTextListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HistoryTextListUpdateInput"]: {
	items?:ValueTypes["HistoryTextListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["HistoryTextListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["HistoryTextItemWithoutListCreateInput"] | null,
	update?:ValueTypes["HistoryTextListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["HistoryTextListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["HistoryTextItemUniqueWhere"] | null,
	disconnect?:ValueTypes["HistoryTextItemUniqueWhere"] | null,
	delete?:ValueTypes["HistoryTextItemUniqueWhere"] | null,
	alias?:string | null
};
	["HistoryTextListUpdateItemsRelationInput"]: {
	by?:ValueTypes["HistoryTextItemUniqueWhere"] | null,
	data?:ValueTypes["HistoryTextItemWithoutListUpdateInput"] | null
};
	["HistoryTextItemWithoutListUpdateInput"]: {
	order?:number | null,
	key?:string | null,
	text?:string | null,
	image?:ValueTypes["HistoryTextItemUpdateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HistoryTextItemUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageUseCreateInput"] | null,
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	upsert?:ValueTypes["HistoryTextItemUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HistoryTextItemUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["HistoryTextListUpsertItemsRelationInput"]: {
	by?:ValueTypes["HistoryTextItemUniqueWhere"] | null,
	update?:ValueTypes["HistoryTextItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["HistoryTextItemWithoutListCreateInput"] | null
};
	["HistoryCoverUpsertAnnotationsRelationInput"]: {
	update?:ValueTypes["HistoryTextListUpdateInput"] | null,
	create?:ValueTypes["HistoryTextListCreateInput"] | null
};
	["HistoryPeriodUpsertCoverRelationInput"]: {
	update?:ValueTypes["HistoryCoverUpdateInput"] | null,
	create?:ValueTypes["HistoryCoverCreateInput"] | null
};
	["HistoryPeriodUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["HistoryPeriodUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SeoUpdateInput"]: {
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	page?:ValueTypes["SeoUpdatePageEntityRelationInput"] | null,
	twCard?:ValueTypes["SeoTwCard"] | null,
	ogImage?:ValueTypes["SeoUpdateOgImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SeoUpdatePageEntityRelationInput"]: {
	create?:ValueTypes["PageWithoutSeoCreateInput"] | null,
	update?:ValueTypes["PageWithoutSeoUpdateInput"] | null,
	upsert?:ValueTypes["SeoUpsertPageRelationInput"] | null,
	connect?:ValueTypes["PageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["PageWithoutSeoUpdateInput"]: {
	title?:string | null,
	publishAt?:ValueTypes["DateTime"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	template?:ValueTypes["PageTemplate"] | null,
	url?:ValueTypes["PageUpdateUrlEntityRelationInput"] | null,
	content?:ValueTypes["PageUpdateContentEntityRelationInput"] | null,
	subscriptionValidity?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["PageUpdateUrlEntityRelationInput"]: {
	create?:ValueTypes["UrlWithoutPageCreateInput"] | null,
	update?:ValueTypes["UrlWithoutPageUpdateInput"] | null,
	upsert?:ValueTypes["PageUpsertUrlRelationInput"] | null,
	connect?:ValueTypes["UrlUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["UrlWithoutPageUpdateInput"]: {
	url?:string | null,
	article?:ValueTypes["UrlUpdateArticleEntityRelationInput"] | null,
	author?:ValueTypes["UrlUpdateAuthorEntityRelationInput"] | null,
	issue?:ValueTypes["UrlUpdateIssueEntityRelationInput"] | null,
	category?:ValueTypes["UrlUpdateCategoryEntityRelationInput"] | null,
	tag?:ValueTypes["UrlUpdateTagEntityRelationInput"] | null,
	redirect?:string | null,
	_dummy_field_?:boolean | null
};
	["PageUpsertUrlRelationInput"]: {
	update?:ValueTypes["UrlWithoutPageUpdateInput"] | null,
	create?:ValueTypes["UrlWithoutPageCreateInput"] | null
};
	["SeoUpsertPageRelationInput"]: {
	update?:ValueTypes["PageWithoutSeoUpdateInput"] | null,
	create?:ValueTypes["PageWithoutSeoCreateInput"] | null
};
	["HistoryPeriodUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["ArticleHistoryPeriodUpsertHistoryPeriodRelationInput"]: {
	update?:ValueTypes["HistoryPeriodWithoutArticleHistoryPeriodUpdateInput"] | null,
	create?:ValueTypes["HistoryPeriodWithoutArticleHistoryPeriodCreateInput"] | null
};
	["ArticleUpsertHistoryPeriodsRelationInput"]: {
	by?:ValueTypes["ArticleHistoryPeriodUniqueWhere"] | null,
	update?:ValueTypes["ArticleHistoryPeriodWithoutArticleUpdateInput"] | null,
	create?:ValueTypes["ArticleHistoryPeriodWithoutArticleCreateInput"] | null
};
	["ArticleTagUpsertArticleRelationInput"]: {
	update?:ValueTypes["ArticleWithoutTagsUpdateInput"] | null,
	create?:ValueTypes["ArticleWithoutTagsCreateInput"] | null
};
	["TagUpsertArticleTagRelationInput"]: {
	by?:ValueTypes["ArticleTagUniqueWhere"] | null,
	update?:ValueTypes["ArticleTagWithoutTagUpdateInput"] | null,
	create?:ValueTypes["ArticleTagWithoutTagCreateInput"] | null
};
	["UrlUpsertTagRelationInput"]: {
	update?:ValueTypes["TagWithoutUrlUpdateInput"] | null,
	create?:ValueTypes["TagWithoutUrlCreateInput"] | null
};
	["AuthorUpsertUrlRelationInput"]: {
	update?:ValueTypes["UrlWithoutAuthorUpdateInput"] | null,
	create?:ValueTypes["UrlWithoutAuthorCreateInput"] | null
};
	["UserUpsertAuthorsRelationInput"]: {
	by?:ValueTypes["AuthorUniqueWhere"] | null,
	update?:ValueTypes["AuthorWithoutUsersUpdateInput"] | null,
	create?:ValueTypes["AuthorWithoutUsersCreateInput"] | null
};
	["UserUpdateAppReviewsEntityRelationInput"]: {
	create?:ValueTypes["AppReviewWithoutUserCreateInput"] | null,
	update?:ValueTypes["UserUpdateAppReviewsRelationInput"] | null,
	upsert?:ValueTypes["UserUpsertAppReviewsRelationInput"] | null,
	connect?:ValueTypes["AppReviewUniqueWhere"] | null,
	disconnect?:ValueTypes["AppReviewUniqueWhere"] | null,
	delete?:ValueTypes["AppReviewUniqueWhere"] | null,
	alias?:string | null
};
	["UserUpdateAppReviewsRelationInput"]: {
	by?:ValueTypes["AppReviewUniqueWhere"] | null,
	data?:ValueTypes["AppReviewWithoutUserUpdateInput"] | null
};
	["AppReviewWithoutUserUpdateInput"]: {
	done?:boolean | null,
	deviceId?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	rating?:number | null,
	note?:string | null,
	_dummy_field_?:boolean | null
};
	["UserUpsertAppReviewsRelationInput"]: {
	by?:ValueTypes["AppReviewUniqueWhere"] | null,
	update?:ValueTypes["AppReviewWithoutUserUpdateInput"] | null,
	create?:ValueTypes["AppReviewWithoutUserCreateInput"] | null
};
	["UnlockedArticleUpsertUserRelationInput"]: {
	update?:ValueTypes["UserWithoutUnlockedArticlesUpdateInput"] | null,
	create?:ValueTypes["UserWithoutUnlockedArticlesCreateInput"] | null
};
	["ArticleUpsertUnlockedRelationInput"]: {
	by?:ValueTypes["UnlockedArticleUniqueWhere"] | null,
	update?:ValueTypes["UnlockedArticleWithoutArticleUpdateInput"] | null,
	create?:ValueTypes["UnlockedArticleWithoutArticleCreateInput"] | null
};
	["ArticleUpdateTagsEntityRelationInput"]: {
	create?:ValueTypes["ArticleTagWithoutArticleCreateInput"] | null,
	update?:ValueTypes["ArticleUpdateTagsRelationInput"] | null,
	upsert?:ValueTypes["ArticleUpsertTagsRelationInput"] | null,
	connect?:ValueTypes["ArticleTagUniqueWhere"] | null,
	disconnect?:ValueTypes["ArticleTagUniqueWhere"] | null,
	delete?:ValueTypes["ArticleTagUniqueWhere"] | null,
	alias?:string | null
};
	["ArticleUpdateTagsRelationInput"]: {
	by?:ValueTypes["ArticleTagUniqueWhere"] | null,
	data?:ValueTypes["ArticleTagWithoutArticleUpdateInput"] | null
};
	["ArticleTagWithoutArticleUpdateInput"]: {
	order?:number | null,
	tag?:ValueTypes["ArticleTagUpdateTagEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArticleTagUpdateTagEntityRelationInput"]: {
	create?:ValueTypes["TagWithoutArticleTagCreateInput"] | null,
	update?:ValueTypes["TagWithoutArticleTagUpdateInput"] | null,
	upsert?:ValueTypes["ArticleTagUpsertTagRelationInput"] | null,
	connect?:ValueTypes["TagUniqueWhere"] | null,
	delete?:boolean | null
};
	["TagWithoutArticleTagUpdateInput"]: {
	name?:string | null,
	useAsTagline?:boolean | null,
	url?:ValueTypes["TagUpdateUrlEntityRelationInput"] | null,
	order?:string | null,
	legacyId?:string | null,
	_dummy_field_?:boolean | null
};
	["TagUpdateUrlEntityRelationInput"]: {
	create?:ValueTypes["UrlWithoutTagCreateInput"] | null,
	update?:ValueTypes["UrlWithoutTagUpdateInput"] | null,
	upsert?:ValueTypes["TagUpsertUrlRelationInput"] | null,
	connect?:ValueTypes["UrlUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["UrlWithoutTagUpdateInput"]: {
	url?:string | null,
	article?:ValueTypes["UrlUpdateArticleEntityRelationInput"] | null,
	author?:ValueTypes["UrlUpdateAuthorEntityRelationInput"] | null,
	issue?:ValueTypes["UrlUpdateIssueEntityRelationInput"] | null,
	page?:ValueTypes["UrlUpdatePageEntityRelationInput"] | null,
	category?:ValueTypes["UrlUpdateCategoryEntityRelationInput"] | null,
	redirect?:string | null,
	_dummy_field_?:boolean | null
};
	["TagUpsertUrlRelationInput"]: {
	update?:ValueTypes["UrlWithoutTagUpdateInput"] | null,
	create?:ValueTypes["UrlWithoutTagCreateInput"] | null
};
	["ArticleTagUpsertTagRelationInput"]: {
	update?:ValueTypes["TagWithoutArticleTagUpdateInput"] | null,
	create?:ValueTypes["TagWithoutArticleTagCreateInput"] | null
};
	["ArticleUpsertTagsRelationInput"]: {
	by?:ValueTypes["ArticleTagUniqueWhere"] | null,
	update?:ValueTypes["ArticleTagWithoutArticleUpdateInput"] | null,
	create?:ValueTypes["ArticleTagWithoutArticleCreateInput"] | null
};
	["ContentArticleUpsertArticleRelationInput"]: {
	update?:ValueTypes["ArticleWithoutContentBlocksUpdateInput"] | null,
	create?:ValueTypes["ArticleWithoutContentBlocksCreateInput"] | null
};
	["ContentBlockUpsertArticlesRelationInput"]: {
	by?:ValueTypes["ContentArticleUniqueWhere"] | null,
	update?:ValueTypes["ContentArticleWithoutContentBlockUpdateInput"] | null,
	create?:ValueTypes["ContentArticleWithoutContentBlockCreateInput"] | null
};
	["ContentBlockUpdateSubscriptionFormEntityRelationInput"]: {
	create?:ValueTypes["SubscriptionFormWithoutContentBlockCreateInput"] | null,
	update?:ValueTypes["SubscriptionFormWithoutContentBlockUpdateInput"] | null,
	upsert?:ValueTypes["ContentBlockUpsertSubscriptionFormRelationInput"] | null,
	connect?:ValueTypes["SubscriptionFormUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SubscriptionFormWithoutContentBlockUpdateInput"]: {
	name?:string | null,
	code?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	sections?:ValueTypes["SubscriptionFormUpdateSectionsEntityRelationInput"][],
	products?:ValueTypes["SubscriptionFormUpdateProductsEntityRelationInput"][],
	contentReferences?:ValueTypes["SubscriptionFormUpdateContentReferencesEntityRelationInput"][],
	validity?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["SubscriptionFormUpdateSectionsEntityRelationInput"]: {
	create?:ValueTypes["SubscriptionFormSectionWithoutFormCreateInput"] | null,
	update?:ValueTypes["SubscriptionFormUpdateSectionsRelationInput"] | null,
	upsert?:ValueTypes["SubscriptionFormUpsertSectionsRelationInput"] | null,
	connect?:ValueTypes["SubscriptionFormSectionUniqueWhere"] | null,
	disconnect?:ValueTypes["SubscriptionFormSectionUniqueWhere"] | null,
	delete?:ValueTypes["SubscriptionFormSectionUniqueWhere"] | null,
	alias?:string | null
};
	["SubscriptionFormUpdateSectionsRelationInput"]: {
	by?:ValueTypes["SubscriptionFormSectionUniqueWhere"] | null,
	data?:ValueTypes["SubscriptionFormSectionWithoutFormUpdateInput"] | null
};
	["SubscriptionFormSectionWithoutFormUpdateInput"]: {
	order?:number | null,
	title?:string | null,
	inputs?:ValueTypes["SubscriptionFormSectionUpdateInputsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["SubscriptionFormSectionUpdateInputsEntityRelationInput"]: {
	create?:ValueTypes["SubscriptionFormInputWithoutSectionCreateInput"] | null,
	update?:ValueTypes["SubscriptionFormSectionUpdateInputsRelationInput"] | null,
	upsert?:ValueTypes["SubscriptionFormSectionUpsertInputsRelationInput"] | null,
	connect?:ValueTypes["SubscriptionFormInputUniqueWhere"] | null,
	disconnect?:ValueTypes["SubscriptionFormInputUniqueWhere"] | null,
	delete?:ValueTypes["SubscriptionFormInputUniqueWhere"] | null,
	alias?:string | null
};
	["SubscriptionFormSectionUpdateInputsRelationInput"]: {
	by?:ValueTypes["SubscriptionFormInputUniqueWhere"] | null,
	data?:ValueTypes["SubscriptionFormInputWithoutSectionUpdateInput"] | null
};
	["SubscriptionFormInputWithoutSectionUpdateInput"]: {
	order?:number | null,
	type?:ValueTypes["SubscriptionFormInputType"] | null,
	image?:ValueTypes["SubscriptionFormInputUpdateImageEntityRelationInput"] | null,
	options?:ValueTypes["SubscriptionFormInputUpdateOptionsEntityRelationInput"][],
	description?:ValueTypes["SubscriptionFormInputUpdateDescriptionEntityRelationInput"] | null,
	required?:boolean | null,
	_dummy_field_?:boolean | null
};
	["SubscriptionFormInputUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageUseCreateInput"] | null,
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	upsert?:ValueTypes["SubscriptionFormInputUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SubscriptionFormInputUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["SubscriptionFormInputUpdateOptionsEntityRelationInput"]: {
	create?:ValueTypes["SubscriptionFormOptionWithoutFormInputCreateInput"] | null,
	update?:ValueTypes["SubscriptionFormInputUpdateOptionsRelationInput"] | null,
	upsert?:ValueTypes["SubscriptionFormInputUpsertOptionsRelationInput"] | null,
	connect?:ValueTypes["SubscriptionFormOptionUniqueWhere"] | null,
	disconnect?:ValueTypes["SubscriptionFormOptionUniqueWhere"] | null,
	delete?:ValueTypes["SubscriptionFormOptionUniqueWhere"] | null,
	alias?:string | null
};
	["SubscriptionFormInputUpdateOptionsRelationInput"]: {
	by?:ValueTypes["SubscriptionFormOptionUniqueWhere"] | null,
	data?:ValueTypes["SubscriptionFormOptionWithoutFormInputUpdateInput"] | null
};
	["SubscriptionFormOptionWithoutFormInputUpdateInput"]: {
	hasProductId?:boolean | null,
	order?:number | null,
	label?:string | null,
	priceTag?:string | null,
	priceTagWithDiscount?:string | null,
	products?:ValueTypes["SubscriptionFormOptionUpdateProductsEntityRelationInput"][],
	value?:string | null,
	internalLabel?:string | null,
	_dummy_field_?:boolean | null
};
	["SubscriptionFormOptionUpdateProductsEntityRelationInput"]: {
	create?:ValueTypes["ProductWithoutFormOptionsCreateInput"] | null,
	update?:ValueTypes["SubscriptionFormOptionUpdateProductsRelationInput"] | null,
	upsert?:ValueTypes["SubscriptionFormOptionUpsertProductsRelationInput"] | null,
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductUniqueWhere"] | null,
	delete?:ValueTypes["ProductUniqueWhere"] | null,
	alias?:string | null
};
	["SubscriptionFormOptionUpdateProductsRelationInput"]: {
	by?:ValueTypes["ProductUniqueWhere"] | null,
	data?:ValueTypes["ProductWithoutFormOptionsUpdateInput"] | null
};
	["ProductWithoutFormOptionsUpdateInput"]: {
	price?:number | null,
	type?:ValueTypes["Types"] | null,
	form?:ValueTypes["ProductUpdateFormEntityRelationInput"] | null,
	productId?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductUpdateFormEntityRelationInput"]: {
	create?:ValueTypes["SubscriptionFormWithoutProductsCreateInput"] | null,
	update?:ValueTypes["SubscriptionFormWithoutProductsUpdateInput"] | null,
	upsert?:ValueTypes["ProductUpsertFormRelationInput"] | null,
	connect?:ValueTypes["SubscriptionFormUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SubscriptionFormWithoutProductsUpdateInput"]: {
	name?:string | null,
	code?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	sections?:ValueTypes["SubscriptionFormUpdateSectionsEntityRelationInput"][],
	contentBlock?:ValueTypes["SubscriptionFormUpdateContentBlockEntityRelationInput"][],
	contentReferences?:ValueTypes["SubscriptionFormUpdateContentReferencesEntityRelationInput"][],
	validity?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["SubscriptionFormUpdateContentBlockEntityRelationInput"]: {
	create?:ValueTypes["ContentBlockWithoutSubscriptionFormCreateInput"] | null,
	update?:ValueTypes["SubscriptionFormUpdateContentBlockRelationInput"] | null,
	upsert?:ValueTypes["SubscriptionFormUpsertContentBlockRelationInput"] | null,
	connect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	disconnect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	delete?:ValueTypes["ContentBlockUniqueWhere"] | null,
	alias?:string | null
};
	["SubscriptionFormUpdateContentBlockRelationInput"]: {
	by?:ValueTypes["ContentBlockUniqueWhere"] | null,
	data?:ValueTypes["ContentBlockWithoutSubscriptionFormUpdateInput"] | null
};
	["ContentBlockWithoutSubscriptionFormUpdateInput"]: {
	order?:number | null,
	type?:ValueTypes["ContentBlockType"] | null,
	youtubeId?:string | null,
	text?:string | null,
	targetLabel?:string | null,
	issue?:ValueTypes["ContentBlockUpdateIssueEntityRelationInput"] | null,
	target?:ValueTypes["ContentBlockUpdateTargetEntityRelationInput"] | null,
	articles?:ValueTypes["ContentBlockUpdateArticlesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["SubscriptionFormUpsertContentBlockRelationInput"]: {
	by?:ValueTypes["ContentBlockUniqueWhere"] | null,
	update?:ValueTypes["ContentBlockWithoutSubscriptionFormUpdateInput"] | null,
	create?:ValueTypes["ContentBlockWithoutSubscriptionFormCreateInput"] | null
};
	["SubscriptionFormUpdateContentReferencesEntityRelationInput"]: {
	create?:ValueTypes["ContentReferenceWithoutSubscriptionFormCreateInput"] | null,
	update?:ValueTypes["SubscriptionFormUpdateContentReferencesRelationInput"] | null,
	upsert?:ValueTypes["SubscriptionFormUpsertContentReferencesRelationInput"] | null,
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	disconnect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	delete?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	alias?:string | null
};
	["SubscriptionFormUpdateContentReferencesRelationInput"]: {
	by?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	data?:ValueTypes["ContentReferenceWithoutSubscriptionFormUpdateInput"] | null
};
	["ContentReferenceWithoutSubscriptionFormUpdateInput"]: {
	type?:ValueTypes["ContentReferenceType"] | null,
	contentPart?:ValueTypes["ContentReferenceUpdateContentPartEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	variant?:ValueTypes["ContentReferenceVariant"] | null,
	color?:string | null,
	embed?:ValueTypes["ContentReferenceUpdateEmbedEntityRelationInput"] | null,
	article?:ValueTypes["ContentReferenceUpdateArticleEntityRelationInput"] | null,
	audio?:ValueTypes["ContentReferenceUpdateAudioEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceUpdateImageEntityRelationInput"] | null,
	images?:ValueTypes["ContentReferenceUpdateImagesEntityRelationInput"][],
	pollAnswer?:ValueTypes["ContentReferenceUpdatePollAnswerEntityRelationInput"] | null,
	listicle?:ValueTypes["ContentReferenceUpdateListicleEntityRelationInput"][],
	faq?:ValueTypes["ContentReferenceUpdateFaqEntityRelationInput"][],
	links?:ValueTypes["ContentReferenceUpdateLinksEntityRelationInput"][],
	awards?:ValueTypes["ContentReferenceUpdateAwardsEntityRelationInput"][],
	reviews?:ValueTypes["ContentReferenceUpdateReviewsEntityRelationInput"][],
	target?:ValueTypes["ContentReferenceUpdateTargetEntityRelationInput"] | null,
	buttons?:ValueTypes["ContentReferenceUpdateButtonsEntityRelationInput"][],
	sharedContent?:ValueTypes["ContentReferenceUpdateSharedContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpdateContentPartEntityRelationInput"]: {
	create?:ValueTypes["ContentPartWithoutReferencesCreateInput"] | null,
	update?:ValueTypes["ContentPartWithoutReferencesUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertContentPartRelationInput"] | null,
	connect?:ValueTypes["ContentPartUniqueWhere"] | null,
	delete?:boolean | null
};
	["ContentPartWithoutReferencesUpdateInput"]: {
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["ContentPartUpdateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentPartUpdateContentEntityRelationInput"]: {
	create?:ValueTypes["ContentWithoutPartsCreateInput"] | null,
	update?:ValueTypes["ContentWithoutPartsUpdateInput"] | null,
	upsert?:ValueTypes["ContentPartUpsertContentRelationInput"] | null,
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	delete?:boolean | null
};
	["ContentWithoutPartsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["ContentPartUpsertContentRelationInput"]: {
	update?:ValueTypes["ContentWithoutPartsUpdateInput"] | null,
	create?:ValueTypes["ContentWithoutPartsCreateInput"] | null
};
	["ContentReferenceUpsertContentPartRelationInput"]: {
	update?:ValueTypes["ContentPartWithoutReferencesUpdateInput"] | null,
	create?:ValueTypes["ContentPartWithoutReferencesCreateInput"] | null
};
	["ContentReferenceUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageUseCreateInput"] | null,
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentReferenceUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["ContentReferenceUpdateImagesEntityRelationInput"]: {
	create?:ValueTypes["ImageContentWithoutContentReferenceCreateInput"] | null,
	update?:ValueTypes["ContentReferenceUpdateImagesRelationInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertImagesRelationInput"] | null,
	connect?:ValueTypes["ImageContentUniqueWhere"] | null,
	disconnect?:ValueTypes["ImageContentUniqueWhere"] | null,
	delete?:ValueTypes["ImageContentUniqueWhere"] | null,
	alias?:string | null
};
	["ContentReferenceUpdateImagesRelationInput"]: {
	by?:ValueTypes["ImageContentUniqueWhere"] | null,
	data?:ValueTypes["ImageContentWithoutContentReferenceUpdateInput"] | null
};
	["ImageContentWithoutContentReferenceUpdateInput"]: {
	order?:number | null,
	image?:ValueTypes["ImageContentUpdateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ImageContentUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageUseCreateInput"] | null,
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	upsert?:ValueTypes["ImageContentUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	delete?:boolean | null
};
	["ImageContentUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["ContentReferenceUpsertImagesRelationInput"]: {
	by?:ValueTypes["ImageContentUniqueWhere"] | null,
	update?:ValueTypes["ImageContentWithoutContentReferenceUpdateInput"] | null,
	create?:ValueTypes["ImageContentWithoutContentReferenceCreateInput"] | null
};
	["ContentReferenceUpdatePollAnswerEntityRelationInput"]: {
	create?:ValueTypes["PollAnswerCreateInput"] | null,
	update?:ValueTypes["PollAnswerUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertPollAnswerRelationInput"] | null,
	connect?:ValueTypes["PollAnswerUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["PollAnswerUpdateInput"]: {
	authorName?:string | null,
	authorPosition?:string | null,
	text?:string | null,
	authorImage?:ValueTypes["PollAnswerUpdateAuthorImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PollAnswerUpdateAuthorImageEntityRelationInput"]: {
	create?:ValueTypes["ImageUseCreateInput"] | null,
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	upsert?:ValueTypes["PollAnswerUpsertAuthorImageRelationInput"] | null,
	connect?:ValueTypes["ImageUseUniqueWhere"] | null
};
	["PollAnswerUpsertAuthorImageRelationInput"]: {
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["ContentReferenceUpsertPollAnswerRelationInput"]: {
	update?:ValueTypes["PollAnswerUpdateInput"] | null,
	create?:ValueTypes["PollAnswerCreateInput"] | null
};
	["ContentReferenceUpdateListicleEntityRelationInput"]: {
	create?:ValueTypes["ListicleWithoutContentReferenceCreateInput"] | null,
	update?:ValueTypes["ContentReferenceUpdateListicleRelationInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertListicleRelationInput"] | null,
	connect?:ValueTypes["ListicleUniqueWhere"] | null,
	disconnect?:ValueTypes["ListicleUniqueWhere"] | null,
	delete?:ValueTypes["ListicleUniqueWhere"] | null,
	alias?:string | null
};
	["ContentReferenceUpdateListicleRelationInput"]: {
	by?:ValueTypes["ListicleUniqueWhere"] | null,
	data?:ValueTypes["ListicleWithoutContentReferenceUpdateInput"] | null
};
	["ListicleWithoutContentReferenceUpdateInput"]: {
	order?:number | null,
	primaryText?:string | null,
	image?:ValueTypes["ListicleUpdateImageEntityRelationInput"] | null,
	target?:ValueTypes["ListicleUpdateTargetEntityRelationInput"] | null,
	content?:ValueTypes["ListicleUpdateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ListicleUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageUseCreateInput"] | null,
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	upsert?:ValueTypes["ListicleUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ListicleUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["ListicleUpdateTargetEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["ListicleUpsertTargetRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ListicleUpsertTargetRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["ListicleUpdateContentEntityRelationInput"]: {
	create?:ValueTypes["ContentCreateInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["ListicleUpsertContentRelationInput"] | null,
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ListicleUpsertContentRelationInput"]: {
	update?:ValueTypes["ContentUpdateInput"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["ContentReferenceUpsertListicleRelationInput"]: {
	by?:ValueTypes["ListicleUniqueWhere"] | null,
	update?:ValueTypes["ListicleWithoutContentReferenceUpdateInput"] | null,
	create?:ValueTypes["ListicleWithoutContentReferenceCreateInput"] | null
};
	["ContentReferenceUpdateFaqEntityRelationInput"]: {
	create?:ValueTypes["FAQWithoutContentReferenceCreateInput"] | null,
	update?:ValueTypes["ContentReferenceUpdateFaqRelationInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertFaqRelationInput"] | null,
	connect?:ValueTypes["FAQUniqueWhere"] | null,
	disconnect?:ValueTypes["FAQUniqueWhere"] | null,
	delete?:ValueTypes["FAQUniqueWhere"] | null,
	alias?:string | null
};
	["ContentReferenceUpdateFaqRelationInput"]: {
	by?:ValueTypes["FAQUniqueWhere"] | null,
	data?:ValueTypes["FAQWithoutContentReferenceUpdateInput"] | null
};
	["FAQWithoutContentReferenceUpdateInput"]: {
	order?:number | null,
	answer?:string | null,
	question?:string | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpsertFaqRelationInput"]: {
	by?:ValueTypes["FAQUniqueWhere"] | null,
	update?:ValueTypes["FAQWithoutContentReferenceUpdateInput"] | null,
	create?:ValueTypes["FAQWithoutContentReferenceCreateInput"] | null
};
	["ContentReferenceUpdateLinksEntityRelationInput"]: {
	create?:ValueTypes["LinkContentWithoutContentReferenceCreateInput"] | null,
	update?:ValueTypes["ContentReferenceUpdateLinksRelationInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertLinksRelationInput"] | null,
	connect?:ValueTypes["LinkContentUniqueWhere"] | null,
	disconnect?:ValueTypes["LinkContentUniqueWhere"] | null,
	delete?:ValueTypes["LinkContentUniqueWhere"] | null,
	alias?:string | null
};
	["ContentReferenceUpdateLinksRelationInput"]: {
	by?:ValueTypes["LinkContentUniqueWhere"] | null,
	data?:ValueTypes["LinkContentWithoutContentReferenceUpdateInput"] | null
};
	["LinkContentWithoutContentReferenceUpdateInput"]: {
	order?:number | null,
	text?:string | null,
	target?:ValueTypes["LinkContentUpdateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkContentUpdateTargetEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkContentUpsertTargetRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null
};
	["LinkContentUpsertTargetRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["ContentReferenceUpsertLinksRelationInput"]: {
	by?:ValueTypes["LinkContentUniqueWhere"] | null,
	update?:ValueTypes["LinkContentWithoutContentReferenceUpdateInput"] | null,
	create?:ValueTypes["LinkContentWithoutContentReferenceCreateInput"] | null
};
	["ContentReferenceUpdateAwardsEntityRelationInput"]: {
	create?:ValueTypes["AwardContentWithoutContentReferenceCreateInput"] | null,
	update?:ValueTypes["ContentReferenceUpdateAwardsRelationInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertAwardsRelationInput"] | null,
	connect?:ValueTypes["AwardContentUniqueWhere"] | null,
	disconnect?:ValueTypes["AwardContentUniqueWhere"] | null,
	delete?:ValueTypes["AwardContentUniqueWhere"] | null,
	alias?:string | null
};
	["ContentReferenceUpdateAwardsRelationInput"]: {
	by?:ValueTypes["AwardContentUniqueWhere"] | null,
	data?:ValueTypes["AwardContentWithoutContentReferenceUpdateInput"] | null
};
	["AwardContentWithoutContentReferenceUpdateInput"]: {
	order?:number | null,
	image?:ValueTypes["AwardContentUpdateImageEntityRelationInput"] | null,
	target?:ValueTypes["AwardContentUpdateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["AwardContentUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageUseCreateInput"] | null,
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	upsert?:ValueTypes["AwardContentUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUseUniqueWhere"] | null
};
	["AwardContentUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["AwardContentUpdateTargetEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["AwardContentUpsertTargetRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null
};
	["AwardContentUpsertTargetRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["ContentReferenceUpsertAwardsRelationInput"]: {
	by?:ValueTypes["AwardContentUniqueWhere"] | null,
	update?:ValueTypes["AwardContentWithoutContentReferenceUpdateInput"] | null,
	create?:ValueTypes["AwardContentWithoutContentReferenceCreateInput"] | null
};
	["ContentReferenceUpdateReviewsEntityRelationInput"]: {
	create?:ValueTypes["ReviewContentWithoutContentReferenceCreateInput"] | null,
	update?:ValueTypes["ContentReferenceUpdateReviewsRelationInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertReviewsRelationInput"] | null,
	connect?:ValueTypes["ReviewContentUniqueWhere"] | null,
	disconnect?:ValueTypes["ReviewContentUniqueWhere"] | null,
	delete?:ValueTypes["ReviewContentUniqueWhere"] | null,
	alias?:string | null
};
	["ContentReferenceUpdateReviewsRelationInput"]: {
	by?:ValueTypes["ReviewContentUniqueWhere"] | null,
	data?:ValueTypes["ReviewContentWithoutContentReferenceUpdateInput"] | null
};
	["ReviewContentWithoutContentReferenceUpdateInput"]: {
	order?:number | null,
	text?:string | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpsertReviewsRelationInput"]: {
	by?:ValueTypes["ReviewContentUniqueWhere"] | null,
	update?:ValueTypes["ReviewContentWithoutContentReferenceUpdateInput"] | null,
	create?:ValueTypes["ReviewContentWithoutContentReferenceCreateInput"] | null
};
	["ContentReferenceUpdateTargetEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertTargetRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentReferenceUpsertTargetRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["ContentReferenceUpdateButtonsEntityRelationInput"]: {
	create?:ValueTypes["ButtonWithoutContentReferenceCreateInput"] | null,
	update?:ValueTypes["ContentReferenceUpdateButtonsRelationInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertButtonsRelationInput"] | null,
	connect?:ValueTypes["ButtonUniqueWhere"] | null,
	disconnect?:ValueTypes["ButtonUniqueWhere"] | null,
	delete?:ValueTypes["ButtonUniqueWhere"] | null,
	alias?:string | null
};
	["ContentReferenceUpdateButtonsRelationInput"]: {
	by?:ValueTypes["ButtonUniqueWhere"] | null,
	data?:ValueTypes["ButtonWithoutContentReferenceUpdateInput"] | null
};
	["ButtonWithoutContentReferenceUpdateInput"]: {
	order?:number | null,
	type?:ValueTypes["ButtonType"] | null,
	label?:string | null,
	target?:ValueTypes["ButtonUpdateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ButtonUpdateTargetEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["ButtonUpsertTargetRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ButtonUpsertTargetRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["ContentReferenceUpsertButtonsRelationInput"]: {
	by?:ValueTypes["ButtonUniqueWhere"] | null,
	update?:ValueTypes["ButtonWithoutContentReferenceUpdateInput"] | null,
	create?:ValueTypes["ButtonWithoutContentReferenceCreateInput"] | null
};
	["ContentReferenceUpdateSharedContentEntityRelationInput"]: {
	create?:ValueTypes["SharedContentWithoutContentReferenceCreateInput"] | null,
	update?:ValueTypes["SharedContentWithoutContentReferenceUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertSharedContentRelationInput"] | null,
	connect?:ValueTypes["SharedContentUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SharedContentWithoutContentReferenceUpdateInput"]: {
	name?:string | null,
	content?:ValueTypes["SharedContentUpdateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SharedContentUpdateContentEntityRelationInput"]: {
	create?:ValueTypes["ContentCreateInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["SharedContentUpsertContentRelationInput"] | null,
	connect?:ValueTypes["ContentUniqueWhere"] | null
};
	["SharedContentUpsertContentRelationInput"]: {
	update?:ValueTypes["ContentUpdateInput"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["ContentReferenceUpsertSharedContentRelationInput"]: {
	update?:ValueTypes["SharedContentWithoutContentReferenceUpdateInput"] | null,
	create?:ValueTypes["SharedContentWithoutContentReferenceCreateInput"] | null
};
	["SubscriptionFormUpsertContentReferencesRelationInput"]: {
	by?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	update?:ValueTypes["ContentReferenceWithoutSubscriptionFormUpdateInput"] | null,
	create?:ValueTypes["ContentReferenceWithoutSubscriptionFormCreateInput"] | null
};
	["ProductUpsertFormRelationInput"]: {
	update?:ValueTypes["SubscriptionFormWithoutProductsUpdateInput"] | null,
	create?:ValueTypes["SubscriptionFormWithoutProductsCreateInput"] | null
};
	["SubscriptionFormOptionUpsertProductsRelationInput"]: {
	by?:ValueTypes["ProductUniqueWhere"] | null,
	update?:ValueTypes["ProductWithoutFormOptionsUpdateInput"] | null,
	create?:ValueTypes["ProductWithoutFormOptionsCreateInput"] | null
};
	["SubscriptionFormInputUpsertOptionsRelationInput"]: {
	by?:ValueTypes["SubscriptionFormOptionUniqueWhere"] | null,
	update?:ValueTypes["SubscriptionFormOptionWithoutFormInputUpdateInput"] | null,
	create?:ValueTypes["SubscriptionFormOptionWithoutFormInputCreateInput"] | null
};
	["SubscriptionFormInputUpdateDescriptionEntityRelationInput"]: {
	create?:ValueTypes["ContentCreateInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["SubscriptionFormInputUpsertDescriptionRelationInput"] | null,
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SubscriptionFormInputUpsertDescriptionRelationInput"]: {
	update?:ValueTypes["ContentUpdateInput"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["SubscriptionFormSectionUpsertInputsRelationInput"]: {
	by?:ValueTypes["SubscriptionFormInputUniqueWhere"] | null,
	update?:ValueTypes["SubscriptionFormInputWithoutSectionUpdateInput"] | null,
	create?:ValueTypes["SubscriptionFormInputWithoutSectionCreateInput"] | null
};
	["SubscriptionFormUpsertSectionsRelationInput"]: {
	by?:ValueTypes["SubscriptionFormSectionUniqueWhere"] | null,
	update?:ValueTypes["SubscriptionFormSectionWithoutFormUpdateInput"] | null,
	create?:ValueTypes["SubscriptionFormSectionWithoutFormCreateInput"] | null
};
	["SubscriptionFormUpdateProductsEntityRelationInput"]: {
	create?:ValueTypes["ProductWithoutFormCreateInput"] | null,
	update?:ValueTypes["SubscriptionFormUpdateProductsRelationInput"] | null,
	upsert?:ValueTypes["SubscriptionFormUpsertProductsRelationInput"] | null,
	connect?:ValueTypes["ProductUniqueWhere"] | null,
	disconnect?:ValueTypes["ProductUniqueWhere"] | null,
	delete?:ValueTypes["ProductUniqueWhere"] | null,
	alias?:string | null
};
	["SubscriptionFormUpdateProductsRelationInput"]: {
	by?:ValueTypes["ProductUniqueWhere"] | null,
	data?:ValueTypes["ProductWithoutFormUpdateInput"] | null
};
	["ProductWithoutFormUpdateInput"]: {
	price?:number | null,
	type?:ValueTypes["Types"] | null,
	formOptions?:ValueTypes["ProductUpdateFormOptionsEntityRelationInput"][],
	productId?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductUpdateFormOptionsEntityRelationInput"]: {
	create?:ValueTypes["SubscriptionFormOptionWithoutProductsCreateInput"] | null,
	update?:ValueTypes["ProductUpdateFormOptionsRelationInput"] | null,
	upsert?:ValueTypes["ProductUpsertFormOptionsRelationInput"] | null,
	connect?:ValueTypes["SubscriptionFormOptionUniqueWhere"] | null,
	disconnect?:ValueTypes["SubscriptionFormOptionUniqueWhere"] | null,
	delete?:ValueTypes["SubscriptionFormOptionUniqueWhere"] | null,
	alias?:string | null
};
	["ProductUpdateFormOptionsRelationInput"]: {
	by?:ValueTypes["SubscriptionFormOptionUniqueWhere"] | null,
	data?:ValueTypes["SubscriptionFormOptionWithoutProductsUpdateInput"] | null
};
	["SubscriptionFormOptionWithoutProductsUpdateInput"]: {
	hasProductId?:boolean | null,
	order?:number | null,
	label?:string | null,
	priceTag?:string | null,
	priceTagWithDiscount?:string | null,
	formInput?:ValueTypes["SubscriptionFormOptionUpdateFormInputEntityRelationInput"] | null,
	value?:string | null,
	internalLabel?:string | null,
	_dummy_field_?:boolean | null
};
	["SubscriptionFormOptionUpdateFormInputEntityRelationInput"]: {
	create?:ValueTypes["SubscriptionFormInputWithoutOptionsCreateInput"] | null,
	update?:ValueTypes["SubscriptionFormInputWithoutOptionsUpdateInput"] | null,
	upsert?:ValueTypes["SubscriptionFormOptionUpsertFormInputRelationInput"] | null,
	connect?:ValueTypes["SubscriptionFormInputUniqueWhere"] | null,
	delete?:boolean | null
};
	["SubscriptionFormInputWithoutOptionsUpdateInput"]: {
	order?:number | null,
	type?:ValueTypes["SubscriptionFormInputType"] | null,
	image?:ValueTypes["SubscriptionFormInputUpdateImageEntityRelationInput"] | null,
	section?:ValueTypes["SubscriptionFormInputUpdateSectionEntityRelationInput"] | null,
	description?:ValueTypes["SubscriptionFormInputUpdateDescriptionEntityRelationInput"] | null,
	required?:boolean | null,
	_dummy_field_?:boolean | null
};
	["SubscriptionFormInputUpdateSectionEntityRelationInput"]: {
	create?:ValueTypes["SubscriptionFormSectionWithoutInputsCreateInput"] | null,
	update?:ValueTypes["SubscriptionFormSectionWithoutInputsUpdateInput"] | null,
	upsert?:ValueTypes["SubscriptionFormInputUpsertSectionRelationInput"] | null,
	connect?:ValueTypes["SubscriptionFormSectionUniqueWhere"] | null,
	delete?:boolean | null
};
	["SubscriptionFormSectionWithoutInputsUpdateInput"]: {
	order?:number | null,
	title?:string | null,
	form?:ValueTypes["SubscriptionFormSectionUpdateFormEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SubscriptionFormSectionUpdateFormEntityRelationInput"]: {
	create?:ValueTypes["SubscriptionFormWithoutSectionsCreateInput"] | null,
	update?:ValueTypes["SubscriptionFormWithoutSectionsUpdateInput"] | null,
	upsert?:ValueTypes["SubscriptionFormSectionUpsertFormRelationInput"] | null,
	connect?:ValueTypes["SubscriptionFormUniqueWhere"] | null,
	delete?:boolean | null
};
	["SubscriptionFormWithoutSectionsUpdateInput"]: {
	name?:string | null,
	code?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	contentBlock?:ValueTypes["SubscriptionFormUpdateContentBlockEntityRelationInput"][],
	products?:ValueTypes["SubscriptionFormUpdateProductsEntityRelationInput"][],
	contentReferences?:ValueTypes["SubscriptionFormUpdateContentReferencesEntityRelationInput"][],
	validity?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["SubscriptionFormSectionUpsertFormRelationInput"]: {
	update?:ValueTypes["SubscriptionFormWithoutSectionsUpdateInput"] | null,
	create?:ValueTypes["SubscriptionFormWithoutSectionsCreateInput"] | null
};
	["SubscriptionFormInputUpsertSectionRelationInput"]: {
	update?:ValueTypes["SubscriptionFormSectionWithoutInputsUpdateInput"] | null,
	create?:ValueTypes["SubscriptionFormSectionWithoutInputsCreateInput"] | null
};
	["SubscriptionFormOptionUpsertFormInputRelationInput"]: {
	update?:ValueTypes["SubscriptionFormInputWithoutOptionsUpdateInput"] | null,
	create?:ValueTypes["SubscriptionFormInputWithoutOptionsCreateInput"] | null
};
	["ProductUpsertFormOptionsRelationInput"]: {
	by?:ValueTypes["SubscriptionFormOptionUniqueWhere"] | null,
	update?:ValueTypes["SubscriptionFormOptionWithoutProductsUpdateInput"] | null,
	create?:ValueTypes["SubscriptionFormOptionWithoutProductsCreateInput"] | null
};
	["SubscriptionFormUpsertProductsRelationInput"]: {
	by?:ValueTypes["ProductUniqueWhere"] | null,
	update?:ValueTypes["ProductWithoutFormUpdateInput"] | null,
	create?:ValueTypes["ProductWithoutFormCreateInput"] | null
};
	["ContentBlockUpsertSubscriptionFormRelationInput"]: {
	update?:ValueTypes["SubscriptionFormWithoutContentBlockUpdateInput"] | null,
	create?:ValueTypes["SubscriptionFormWithoutContentBlockCreateInput"] | null
};
	["IssueUpsertBlocksRelationInput"]: {
	by?:ValueTypes["ContentBlockUniqueWhere"] | null,
	update?:ValueTypes["ContentBlockWithoutIssueUpdateInput"] | null,
	create?:ValueTypes["ContentBlockWithoutIssueCreateInput"] | null
};
	["IssueUpdateCoverPhotoEntityRelationInput"]: {
	create?:ValueTypes["ImageUseCreateInput"] | null,
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	upsert?:ValueTypes["IssueUpsertCoverPhotoRelationInput"] | null,
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["IssueUpsertCoverPhotoRelationInput"]: {
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["IssueUpdatePrintTargetEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["IssueUpsertPrintTargetRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["IssueUpsertPrintTargetRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["IssueUpdateBackgroundPhotoEntityRelationInput"]: {
	create?:ValueTypes["ImageUseCreateInput"] | null,
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	upsert?:ValueTypes["IssueUpsertBackgroundPhotoRelationInput"] | null,
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["IssueUpsertBackgroundPhotoRelationInput"]: {
	update?:ValueTypes["ImageUseUpdateInput"] | null,
	create?:ValueTypes["ImageUseCreateInput"] | null
};
	["IssueArticleUpsertIssueRelationInput"]: {
	update?:ValueTypes["IssueWithoutArticlesUpdateInput"] | null,
	create?:ValueTypes["IssueWithoutArticlesCreateInput"] | null
};
	["ArticleUpsertIssuesRelationInput"]: {
	by?:ValueTypes["IssueArticleUniqueWhere"] | null,
	update?:ValueTypes["IssueArticleWithoutArticleUpdateInput"] | null,
	create?:ValueTypes["IssueArticleWithoutArticleCreateInput"] | null
};
	["ArticleCategoryUpsertArticleRelationInput"]: {
	update?:ValueTypes["ArticleWithoutCategoriesUpdateInput"] | null,
	create?:ValueTypes["ArticleWithoutCategoriesCreateInput"] | null
};
	["CategoryUpsertArticleCategoryRelationInput"]: {
	by?:ValueTypes["ArticleCategoryUniqueWhere"] | null,
	update?:ValueTypes["ArticleCategoryWithoutCategoryUpdateInput"] | null,
	create?:ValueTypes["ArticleCategoryWithoutCategoryCreateInput"] | null
};
	["UrlUpsertCategoryRelationInput"]: {
	update?:ValueTypes["CategoryWithoutUrlUpdateInput"] | null,
	create?:ValueTypes["CategoryWithoutUrlCreateInput"] | null
};
	["IssueUpsertUrlRelationInput"]: {
	update?:ValueTypes["UrlWithoutIssueUpdateInput"] | null,
	create?:ValueTypes["UrlWithoutIssueCreateInput"] | null
};
	["ContentBlockUpsertIssueRelationInput"]: {
	update?:ValueTypes["IssueWithoutBlocksUpdateInput"] | null,
	create?:ValueTypes["IssueWithoutBlocksCreateInput"] | null
};
	["ContentArticleUpsertContentBlockRelationInput"]: {
	update?:ValueTypes["ContentBlockWithoutArticlesUpdateInput"] | null,
	create?:ValueTypes["ContentBlockWithoutArticlesCreateInput"] | null
};
	["ArticleUpsertContentBlocksRelationInput"]: {
	by?:ValueTypes["ContentArticleUniqueWhere"] | null,
	update?:ValueTypes["ContentArticleWithoutArticleUpdateInput"] | null,
	create?:ValueTypes["ContentArticleWithoutArticleCreateInput"] | null
};
	["IssueArticleUpsertArticleRelationInput"]: {
	update?:ValueTypes["ArticleWithoutIssuesUpdateInput"] | null,
	create?:ValueTypes["ArticleWithoutIssuesCreateInput"] | null
};
	["IssueUpsertArticlesRelationInput"]: {
	by?:ValueTypes["IssueArticleUniqueWhere"] | null,
	update?:ValueTypes["IssueArticleWithoutIssueUpdateInput"] | null,
	create?:ValueTypes["IssueArticleWithoutIssueCreateInput"] | null
};
	["UrlUpsertIssueRelationInput"]: {
	update?:ValueTypes["IssueWithoutUrlUpdateInput"] | null,
	create?:ValueTypes["IssueWithoutUrlCreateInput"] | null
};
	["CategoryUpsertUrlRelationInput"]: {
	update?:ValueTypes["UrlWithoutCategoryUpdateInput"] | null,
	create?:ValueTypes["UrlWithoutCategoryCreateInput"] | null
};
	["ArticleCategoryUpsertCategoryRelationInput"]: {
	update?:ValueTypes["CategoryWithoutArticleCategoryUpdateInput"] | null,
	create?:ValueTypes["CategoryWithoutArticleCategoryCreateInput"] | null
};
	["ArticleUpsertCategoriesRelationInput"]: {
	by?:ValueTypes["ArticleCategoryUniqueWhere"] | null,
	update?:ValueTypes["ArticleCategoryWithoutArticleUpdateInput"] | null,
	create?:ValueTypes["ArticleCategoryWithoutArticleCreateInput"] | null
};
	["UrlUpsertArticleRelationInput"]: {
	update?:ValueTypes["ArticleWithoutUrlUpdateInput"] | null,
	create?:ValueTypes["ArticleWithoutUrlCreateInput"] | null
};
	["LinkUpsertInternalTargetRelationInput"]: {
	update?:ValueTypes["UrlUpdateInput"] | null,
	create?:ValueTypes["UrlCreateInput"] | null
};
	["TextContentReferenceUpsertTargetRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["TextContentPartUpsertReferencesRelationInput"]: {
	by?:ValueTypes["TextContentReferenceUniqueWhere"] | null,
	update?:ValueTypes["TextContentReferenceWithoutContentPartUpdateInput"] | null,
	create?:ValueTypes["TextContentReferenceWithoutContentPartCreateInput"] | null
};
	["TextContentUpsertPartsRelationInput"]: {
	by?:ValueTypes["TextContentPartUniqueWhere"] | null,
	update?:ValueTypes["TextContentPartWithoutContentUpdateInput"] | null,
	create?:ValueTypes["TextContentPartWithoutContentCreateInput"] | null
};
	["ArticleUpsertSubtitleRelationInput"]: {
	update?:ValueTypes["TextContentUpdateInput"] | null,
	create?:ValueTypes["TextContentCreateInput"] | null
};
	["UnlockedArticleUpsertArticleRelationInput"]: {
	update?:ValueTypes["ArticleWithoutUnlockedUpdateInput"] | null,
	create?:ValueTypes["ArticleWithoutUnlockedCreateInput"] | null
};
	["UserUpsertUnlockedArticlesRelationInput"]: {
	by?:ValueTypes["UnlockedArticleUniqueWhere"] | null,
	update?:ValueTypes["UnlockedArticleWithoutUserUpdateInput"] | null,
	create?:ValueTypes["UnlockedArticleWithoutUserCreateInput"] | null
};
	["AuthorUpsertUsersRelationInput"]: {
	by?:ValueTypes["UserUniqueWhere"] | null,
	update?:ValueTypes["UserWithoutAuthorsUpdateInput"] | null,
	create?:ValueTypes["UserWithoutAuthorsCreateInput"] | null
};
	["AudioUpsertAuthorRelationInput"]: {
	update?:ValueTypes["AuthorUpdateInput"] | null,
	create?:ValueTypes["AuthorCreateInput"] | null
};
	["AudioUseUpsertAudioRelationInput"]: {
	update?:ValueTypes["AudioWithoutUsesUpdateInput"] | null,
	create?:ValueTypes["AudioWithoutUsesCreateInput"] | null
};
	["ContentReferenceUpsertAudioRelationInput"]: {
	update?:ValueTypes["AudioUseUpdateInput"] | null,
	create?:ValueTypes["AudioUseCreateInput"] | null
};
	["ContentReferenceUpdateSubscriptionFormEntityRelationInput"]: {
	create?:ValueTypes["SubscriptionFormWithoutContentReferencesCreateInput"] | null,
	update?:ValueTypes["SubscriptionFormWithoutContentReferencesUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertSubscriptionFormRelationInput"] | null,
	connect?:ValueTypes["SubscriptionFormUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SubscriptionFormWithoutContentReferencesUpdateInput"]: {
	name?:string | null,
	code?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	sections?:ValueTypes["SubscriptionFormUpdateSectionsEntityRelationInput"][],
	contentBlock?:ValueTypes["SubscriptionFormUpdateContentBlockEntityRelationInput"][],
	products?:ValueTypes["SubscriptionFormUpdateProductsEntityRelationInput"][],
	validity?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpsertSubscriptionFormRelationInput"]: {
	update?:ValueTypes["SubscriptionFormWithoutContentReferencesUpdateInput"] | null,
	create?:ValueTypes["SubscriptionFormWithoutContentReferencesCreateInput"] | null
};
	["ContentPartUpsertReferencesRelationInput"]: {
	by?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	update?:ValueTypes["ContentReferenceWithoutContentPartUpdateInput"] | null,
	create?:ValueTypes["ContentReferenceWithoutContentPartCreateInput"] | null
};
	["ContentUpsertPartsRelationInput"]: {
	by?:ValueTypes["ContentPartUniqueWhere"] | null,
	update?:ValueTypes["ContentPartWithoutContentUpdateInput"] | null,
	create?:ValueTypes["ContentPartWithoutContentCreateInput"] | null
};
	["AuthorUpsertAboutRelationInput"]: {
	update?:ValueTypes["ContentUpdateInput"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["UrlUpsertAuthorRelationInput"]: {
	update?:ValueTypes["AuthorWithoutUrlUpdateInput"] | null,
	create?:ValueTypes["AuthorWithoutUrlCreateInput"] | null
};
	["ArticleUpsertUrlRelationInput"]: {
	update?:ValueTypes["UrlWithoutArticleUpdateInput"] | null,
	create?:ValueTypes["UrlWithoutArticleCreateInput"] | null
};
	["ArticleAuthorCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	article?:ValueTypes["ArticleAuthorCreateArticleEntityRelationInput"] | null,
	author?:ValueTypes["ArticleAuthorCreateAuthorEntityRelationInput"] | null,
	legacyStringAuthor?:ValueTypes["ArticleAuthorLegacyStringAuthor"] | null,
	_dummy_field_?:boolean | null
};
	["ArticleAuthorCreateArticleEntityRelationInput"]: {
	connect?:ValueTypes["ArticleUniqueWhere"] | null,
	create?:ValueTypes["ArticleWithoutAuthorsCreateInput"] | null
};
	["ArticleWithoutAuthorsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	url?:ValueTypes["ArticleCreateUrlEntityRelationInput"] | null,
	hideInMostRead?:boolean | null,
	hideAds?:boolean | null,
	state?:ValueTypes["ArticleState"] | null,
	locked?:boolean | null,
	publishAt?:ValueTypes["DateTime"] | null,
	template?:ValueTypes["Template"] | null,
	subtitle?:ValueTypes["ArticleCreateSubtitleEntityRelationInput"] | null,
	content?:ValueTypes["ArticleCreateContentEntityRelationInput"] | null,
	coverPhoto?:ValueTypes["ArticleCreateCoverPhotoEntityRelationInput"] | null,
	titleAlignment?:ValueTypes["ArticleTitleAlignment"] | null,
	tagline?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	previewContent?:ValueTypes["ArticleCreatePreviewContentEntityRelationInput"] | null,
	audio?:ValueTypes["ArticleCreateAudioEntityRelationInput"] | null,
	categories?:ValueTypes["ArticleCreateCategoriesEntityRelationInput"][],
	issues?:ValueTypes["ArticleCreateIssuesEntityRelationInput"][],
	contentBlocks?:ValueTypes["ArticleCreateContentBlocksEntityRelationInput"][],
	unlocked?:ValueTypes["ArticleCreateUnlockedEntityRelationInput"][],
	coverPhotoVertical?:ValueTypes["ArticleCreateCoverPhotoVerticalEntityRelationInput"] | null,
	legacyId?:string | null,
	tags?:ValueTypes["ArticleCreateTagsEntityRelationInput"][],
	isHistory?:boolean | null,
	historyTags?:ValueTypes["ArticleCreateHistoryTagsEntityRelationInput"][],
	historyPeriods?:ValueTypes["ArticleCreateHistoryPeriodsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ArticleAuthorUpdateInput"]: {
	order?:number | null,
	article?:ValueTypes["ArticleAuthorUpdateArticleEntityRelationInput"] | null,
	author?:ValueTypes["ArticleAuthorUpdateAuthorEntityRelationInput"] | null,
	legacyStringAuthor?:ValueTypes["ArticleAuthorLegacyStringAuthor"] | null,
	_dummy_field_?:boolean | null
};
	["ArticleAuthorUpdateArticleEntityRelationInput"]: {
	create?:ValueTypes["ArticleWithoutAuthorsCreateInput"] | null,
	update?:ValueTypes["ArticleWithoutAuthorsUpdateInput"] | null,
	upsert?:ValueTypes["ArticleAuthorUpsertArticleRelationInput"] | null,
	connect?:ValueTypes["ArticleUniqueWhere"] | null,
	delete?:boolean | null
};
	["ArticleWithoutAuthorsUpdateInput"]: {
	title?:string | null,
	url?:ValueTypes["ArticleUpdateUrlEntityRelationInput"] | null,
	hideInMostRead?:boolean | null,
	hideAds?:boolean | null,
	state?:ValueTypes["ArticleState"] | null,
	locked?:boolean | null,
	publishAt?:ValueTypes["DateTime"] | null,
	template?:ValueTypes["Template"] | null,
	subtitle?:ValueTypes["ArticleUpdateSubtitleEntityRelationInput"] | null,
	content?:ValueTypes["ArticleUpdateContentEntityRelationInput"] | null,
	coverPhoto?:ValueTypes["ArticleUpdateCoverPhotoEntityRelationInput"] | null,
	titleAlignment?:ValueTypes["ArticleTitleAlignment"] | null,
	tagline?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	previewContent?:ValueTypes["ArticleUpdatePreviewContentEntityRelationInput"] | null,
	audio?:ValueTypes["ArticleUpdateAudioEntityRelationInput"] | null,
	categories?:ValueTypes["ArticleUpdateCategoriesEntityRelationInput"][],
	issues?:ValueTypes["ArticleUpdateIssuesEntityRelationInput"][],
	contentBlocks?:ValueTypes["ArticleUpdateContentBlocksEntityRelationInput"][],
	unlocked?:ValueTypes["ArticleUpdateUnlockedEntityRelationInput"][],
	coverPhotoVertical?:ValueTypes["ArticleUpdateCoverPhotoVerticalEntityRelationInput"] | null,
	legacyId?:string | null,
	tags?:ValueTypes["ArticleUpdateTagsEntityRelationInput"][],
	isHistory?:boolean | null,
	historyTags?:ValueTypes["ArticleUpdateHistoryTagsEntityRelationInput"][],
	historyPeriods?:ValueTypes["ArticleUpdateHistoryPeriodsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ArticleAuthorUpsertArticleRelationInput"]: {
	update?:ValueTypes["ArticleWithoutAuthorsUpdateInput"] | null,
	create?:ValueTypes["ArticleWithoutAuthorsCreateInput"] | null
};
	["AuthorTopArticleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	author?:ValueTypes["AuthorTopArticleCreateAuthorEntityRelationInput"] | null,
	article?:ValueTypes["AuthorTopArticleCreateArticleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["AuthorTopArticleCreateAuthorEntityRelationInput"]: {
	connect?:ValueTypes["AuthorUniqueWhere"] | null,
	create?:ValueTypes["AuthorWithoutTopArticlesCreateInput"] | null
};
	["AuthorWithoutTopArticlesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	position?:string | null,
	twitterHandle?:string | null,
	facebookId?:string | null,
	email?:string | null,
	photographer?:boolean | null,
	order?:number | null,
	about?:ValueTypes["AuthorCreateAboutEntityRelationInput"] | null,
	users?:ValueTypes["AuthorCreateUsersEntityRelationInput"][],
	startOfCooperation?:ValueTypes["Date"] | null,
	photo?:ValueTypes["AuthorCreatePhotoEntityRelationInput"] | null,
	illustration?:ValueTypes["AuthorCreateIllustrationEntityRelationInput"] | null,
	legacyId?:string | null,
	category?:ValueTypes["AuthorCategory"] | null,
	url?:ValueTypes["AuthorCreateUrlEntityRelationInput"] | null,
	instagramUsername?:string | null,
	_dummy_field_?:boolean | null
};
	["AuthorTopArticleUpdateInput"]: {
	order?:number | null,
	author?:ValueTypes["AuthorTopArticleUpdateAuthorEntityRelationInput"] | null,
	article?:ValueTypes["AuthorTopArticleUpdateArticleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["AuthorTopArticleUpdateAuthorEntityRelationInput"]: {
	create?:ValueTypes["AuthorWithoutTopArticlesCreateInput"] | null,
	update?:ValueTypes["AuthorWithoutTopArticlesUpdateInput"] | null,
	upsert?:ValueTypes["AuthorTopArticleUpsertAuthorRelationInput"] | null,
	connect?:ValueTypes["AuthorUniqueWhere"] | null,
	delete?:boolean | null
};
	["AuthorWithoutTopArticlesUpdateInput"]: {
	name?:string | null,
	position?:string | null,
	twitterHandle?:string | null,
	facebookId?:string | null,
	email?:string | null,
	photographer?:boolean | null,
	order?:number | null,
	about?:ValueTypes["AuthorUpdateAboutEntityRelationInput"] | null,
	users?:ValueTypes["AuthorUpdateUsersEntityRelationInput"][],
	startOfCooperation?:ValueTypes["Date"] | null,
	photo?:ValueTypes["AuthorUpdatePhotoEntityRelationInput"] | null,
	illustration?:ValueTypes["AuthorUpdateIllustrationEntityRelationInput"] | null,
	legacyId?:string | null,
	category?:ValueTypes["AuthorCategory"] | null,
	url?:ValueTypes["AuthorUpdateUrlEntityRelationInput"] | null,
	instagramUsername?:string | null,
	_dummy_field_?:boolean | null
};
	["AuthorTopArticleUpsertAuthorRelationInput"]: {
	update?:ValueTypes["AuthorWithoutTopArticlesUpdateInput"] | null,
	create?:ValueTypes["AuthorWithoutTopArticlesCreateInput"] | null
};
	["ContentConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentEdge"],
		__typename?: boolean
}>;
	["ContentEdge"]: AliasType<{
	node?:ValueTypes["Content"],
		__typename?: boolean
}>;
	["ContentPartCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["ContentPartCreateContentEntityRelationInput"] | null,
	references?:ValueTypes["ContentPartCreateReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentPartUpdateInput"]: {
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["ContentPartUpdateContentEntityRelationInput"] | null,
	references?:ValueTypes["ContentPartUpdateReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentReferenceCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ContentReferenceType"] | null,
	contentPart?:ValueTypes["ContentReferenceCreateContentPartEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	variant?:ValueTypes["ContentReferenceVariant"] | null,
	color?:string | null,
	embed?:ValueTypes["ContentReferenceCreateEmbedEntityRelationInput"] | null,
	article?:ValueTypes["ContentReferenceCreateArticleEntityRelationInput"] | null,
	audio?:ValueTypes["ContentReferenceCreateAudioEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceCreateImageEntityRelationInput"] | null,
	images?:ValueTypes["ContentReferenceCreateImagesEntityRelationInput"][],
	pollAnswer?:ValueTypes["ContentReferenceCreatePollAnswerEntityRelationInput"] | null,
	listicle?:ValueTypes["ContentReferenceCreateListicleEntityRelationInput"][],
	faq?:ValueTypes["ContentReferenceCreateFaqEntityRelationInput"][],
	links?:ValueTypes["ContentReferenceCreateLinksEntityRelationInput"][],
	awards?:ValueTypes["ContentReferenceCreateAwardsEntityRelationInput"][],
	reviews?:ValueTypes["ContentReferenceCreateReviewsEntityRelationInput"][],
	target?:ValueTypes["ContentReferenceCreateTargetEntityRelationInput"] | null,
	subscriptionForm?:ValueTypes["ContentReferenceCreateSubscriptionFormEntityRelationInput"] | null,
	buttons?:ValueTypes["ContentReferenceCreateButtonsEntityRelationInput"][],
	sharedContent?:ValueTypes["ContentReferenceCreateSharedContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpdateInput"]: {
	type?:ValueTypes["ContentReferenceType"] | null,
	contentPart?:ValueTypes["ContentReferenceUpdateContentPartEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	variant?:ValueTypes["ContentReferenceVariant"] | null,
	color?:string | null,
	embed?:ValueTypes["ContentReferenceUpdateEmbedEntityRelationInput"] | null,
	article?:ValueTypes["ContentReferenceUpdateArticleEntityRelationInput"] | null,
	audio?:ValueTypes["ContentReferenceUpdateAudioEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceUpdateImageEntityRelationInput"] | null,
	images?:ValueTypes["ContentReferenceUpdateImagesEntityRelationInput"][],
	pollAnswer?:ValueTypes["ContentReferenceUpdatePollAnswerEntityRelationInput"] | null,
	listicle?:ValueTypes["ContentReferenceUpdateListicleEntityRelationInput"][],
	faq?:ValueTypes["ContentReferenceUpdateFaqEntityRelationInput"][],
	links?:ValueTypes["ContentReferenceUpdateLinksEntityRelationInput"][],
	awards?:ValueTypes["ContentReferenceUpdateAwardsEntityRelationInput"][],
	reviews?:ValueTypes["ContentReferenceUpdateReviewsEntityRelationInput"][],
	target?:ValueTypes["ContentReferenceUpdateTargetEntityRelationInput"] | null,
	subscriptionForm?:ValueTypes["ContentReferenceUpdateSubscriptionFormEntityRelationInput"] | null,
	buttons?:ValueTypes["ContentReferenceUpdateButtonsEntityRelationInput"][],
	sharedContent?:ValueTypes["ContentReferenceUpdateSharedContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HomepageArticle"]: AliasType<{
	_meta?:ValueTypes["HomepageArticleMeta"],
	id?:boolean,
	order?:boolean,
	tag?:boolean,
article?: [{	filter?:ValueTypes["ArticleWhere"] | null},ValueTypes["Article"]],
		__typename?: boolean
}>;
	["HomepageArticleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	tag?:ValueTypes["FieldMeta"],
	article?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["HomepageArticleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["HomepageArticleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	tag?:ValueTypes["StringCondition"] | null,
	article?:ValueTypes["ArticleWhere"] | null,
	and?:(ValueTypes["HomepageArticleWhere"] | undefined | null)[],
	or?:(ValueTypes["HomepageArticleWhere"] | undefined | null)[],
	not?:ValueTypes["HomepageArticleWhere"] | null
};
	["HomepageArticleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	tag?:ValueTypes["OrderDirection"] | null,
	article?:ValueTypes["ArticleOrderBy"] | null
};
	["HomepageArticleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HomepageArticleEdge"],
		__typename?: boolean
}>;
	["HomepageArticleEdge"]: AliasType<{
	node?:ValueTypes["HomepageArticle"],
		__typename?: boolean
}>;
	["HomepageArticleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	tag?:string | null,
	article?:ValueTypes["HomepageArticleCreateArticleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HomepageArticleCreateArticleEntityRelationInput"]: {
	connect?:ValueTypes["ArticleUniqueWhere"] | null,
	create?:ValueTypes["ArticleCreateInput"] | null
};
	["HomepageArticleUpdateInput"]: {
	order?:number | null,
	tag?:string | null,
	article?:ValueTypes["HomepageArticleUpdateArticleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HomepageArticleUpdateArticleEntityRelationInput"]: {
	create?:ValueTypes["ArticleCreateInput"] | null,
	update?:ValueTypes["ArticleUpdateInput"] | null,
	upsert?:ValueTypes["HomepageArticleUpsertArticleRelationInput"] | null,
	connect?:ValueTypes["ArticleUniqueWhere"] | null,
	delete?:boolean | null
};
	["HomepageArticleUpsertArticleRelationInput"]: {
	update?:ValueTypes["ArticleUpdateInput"] | null,
	create?:ValueTypes["ArticleCreateInput"] | null
};
	["ImageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	width?:number | null,
	height?:number | null,
	title?:string | null,
	text?:string | null,
	author?:ValueTypes["ImageCreateAuthorEntityRelationInput"] | null,
	tags?:ValueTypes["ImageCreateTagsEntityRelationInput"][],
	uses?:ValueTypes["ImageCreateUsesEntityRelationInput"][],
	align?:ValueTypes["ImageAlign"] | null,
	legacyId?:string | null,
	_dummy_field_?:boolean | null
};
	["ImageCreateUsesEntityRelationInput"]: {
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	create?:ValueTypes["ImageUseWithoutImageCreateInput"] | null,
	alias?:string | null
};
	["ImageUseWithoutImageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	_dummy_field_?:boolean | null
};
	["ImageUpdateInput"]: {
	url?:string | null,
	width?:number | null,
	height?:number | null,
	title?:string | null,
	text?:string | null,
	author?:ValueTypes["ImageUpdateAuthorEntityRelationInput"] | null,
	tags?:ValueTypes["ImageUpdateTagsEntityRelationInput"][],
	uses?:ValueTypes["ImageUpdateUsesEntityRelationInput"][],
	align?:ValueTypes["ImageAlign"] | null,
	legacyId?:string | null,
	_dummy_field_?:boolean | null
};
	["ImageUpdateUsesEntityRelationInput"]: {
	create?:ValueTypes["ImageUseWithoutImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateUsesRelationInput"] | null,
	upsert?:ValueTypes["ImageUpsertUsesRelationInput"] | null,
	connect?:ValueTypes["ImageUseUniqueWhere"] | null,
	disconnect?:ValueTypes["ImageUseUniqueWhere"] | null,
	delete?:ValueTypes["ImageUseUniqueWhere"] | null,
	alias?:string | null
};
	["ImageUpdateUsesRelationInput"]: {
	by?:ValueTypes["ImageUseUniqueWhere"] | null,
	data?:ValueTypes["ImageUseWithoutImageUpdateInput"] | null
};
	["ImageUseWithoutImageUpdateInput"]: {
	title?:string | null,
	_dummy_field_?:boolean | null
};
	["ImageUpsertUsesRelationInput"]: {
	by?:ValueTypes["ImageUseUniqueWhere"] | null,
	update?:ValueTypes["ImageUseWithoutImageUpdateInput"] | null,
	create?:ValueTypes["ImageUseWithoutImageCreateInput"] | null
};
	["ImageTagCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	images?:ValueTypes["ImageTagCreateImagesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ImageTagCreateImagesEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageWithoutTagsCreateInput"] | null,
	alias?:string | null
};
	["ImageWithoutTagsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	width?:number | null,
	height?:number | null,
	title?:string | null,
	text?:string | null,
	author?:ValueTypes["ImageCreateAuthorEntityRelationInput"] | null,
	uses?:ValueTypes["ImageCreateUsesEntityRelationInput"][],
	align?:ValueTypes["ImageAlign"] | null,
	legacyId?:string | null,
	_dummy_field_?:boolean | null
};
	["ImageTagUpdateInput"]: {
	name?:string | null,
	images?:ValueTypes["ImageTagUpdateImagesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ImageTagUpdateImagesEntityRelationInput"]: {
	create?:ValueTypes["ImageWithoutTagsCreateInput"] | null,
	update?:ValueTypes["ImageTagUpdateImagesRelationInput"] | null,
	upsert?:ValueTypes["ImageTagUpsertImagesRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:ValueTypes["ImageUniqueWhere"] | null,
	delete?:ValueTypes["ImageUniqueWhere"] | null,
	alias?:string | null
};
	["ImageTagUpdateImagesRelationInput"]: {
	by?:ValueTypes["ImageUniqueWhere"] | null,
	data?:ValueTypes["ImageWithoutTagsUpdateInput"] | null
};
	["ImageWithoutTagsUpdateInput"]: {
	url?:string | null,
	width?:number | null,
	height?:number | null,
	title?:string | null,
	text?:string | null,
	author?:ValueTypes["ImageUpdateAuthorEntityRelationInput"] | null,
	uses?:ValueTypes["ImageUpdateUsesEntityRelationInput"][],
	align?:ValueTypes["ImageAlign"] | null,
	legacyId?:string | null,
	_dummy_field_?:boolean | null
};
	["ImageTagUpsertImagesRelationInput"]: {
	by?:ValueTypes["ImageUniqueWhere"] | null,
	update?:ValueTypes["ImageWithoutTagsUpdateInput"] | null,
	create?:ValueTypes["ImageWithoutTagsCreateInput"] | null
};
	["IssueConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["IssueEdge"],
		__typename?: boolean
}>;
	["IssueEdge"]: AliasType<{
	node?:ValueTypes["Issue"],
		__typename?: boolean
}>;
	["IssueCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	closed?:boolean | null,
	free?:boolean | null,
	title?:string | null,
	subtitle?:string | null,
	year?:number | null,
	issue?:number | null,
	publishedSince?:ValueTypes["Date"] | null,
	publishedUntil?:ValueTypes["Date"] | null,
	publishDigital?:ValueTypes["DateTime"] | null,
	mobileAppsKey?:string | null,
	url?:ValueTypes["IssueCreateUrlEntityRelationInput"] | null,
	articles?:ValueTypes["IssueCreateArticlesEntityRelationInput"][],
	kind?:ValueTypes["IssueKind"] | null,
	notificationTitle?:string | null,
	notificationMessage?:string | null,
	pdf?:ValueTypes["IssueCreatePdfEntityRelationInput"] | null,
	printBuy?:boolean | null,
	printText?:string | null,
	blocks?:ValueTypes["IssueCreateBlocksEntityRelationInput"][],
	coverPhoto?:ValueTypes["IssueCreateCoverPhotoEntityRelationInput"] | null,
	printTarget?:ValueTypes["IssueCreatePrintTargetEntityRelationInput"] | null,
	backgroundPhoto?:ValueTypes["IssueCreateBackgroundPhotoEntityRelationInput"] | null,
	legacyId?:string | null,
	_dummy_field_?:boolean | null
};
	["IssueUpdateInput"]: {
	closed?:boolean | null,
	free?:boolean | null,
	title?:string | null,
	subtitle?:string | null,
	year?:number | null,
	issue?:number | null,
	publishedSince?:ValueTypes["Date"] | null,
	publishedUntil?:ValueTypes["Date"] | null,
	publishDigital?:ValueTypes["DateTime"] | null,
	mobileAppsKey?:string | null,
	url?:ValueTypes["IssueUpdateUrlEntityRelationInput"] | null,
	articles?:ValueTypes["IssueUpdateArticlesEntityRelationInput"][],
	kind?:ValueTypes["IssueKind"] | null,
	notificationTitle?:string | null,
	notificationMessage?:string | null,
	pdf?:ValueTypes["IssueUpdatePdfEntityRelationInput"] | null,
	printBuy?:boolean | null,
	printText?:string | null,
	blocks?:ValueTypes["IssueUpdateBlocksEntityRelationInput"][],
	coverPhoto?:ValueTypes["IssueUpdateCoverPhotoEntityRelationInput"] | null,
	printTarget?:ValueTypes["IssueUpdatePrintTargetEntityRelationInput"] | null,
	backgroundPhoto?:ValueTypes["IssueUpdateBackgroundPhotoEntityRelationInput"] | null,
	legacyId?:string | null,
	_dummy_field_?:boolean | null
};
	["IssueArticleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	issue?:ValueTypes["IssueArticleCreateIssueEntityRelationInput"] | null,
	article?:ValueTypes["IssueArticleCreateArticleEntityRelationInput"] | null,
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["IssueArticleUpdateInput"]: {
	issue?:ValueTypes["IssueArticleUpdateIssueEntityRelationInput"] | null,
	article?:ValueTypes["IssueArticleUpdateArticleEntityRelationInput"] | null,
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["LinkConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkEdge"],
		__typename?: boolean
}>;
	["LinkEdge"]: AliasType<{
	node?:ValueTypes["Link"],
		__typename?: boolean
}>;
	["TextContentConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TextContentEdge"],
		__typename?: boolean
}>;
	["TextContentEdge"]: AliasType<{
	node?:ValueTypes["TextContent"],
		__typename?: boolean
}>;
	["TextContentPartCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["TextContentPartCreateContentEntityRelationInput"] | null,
	references?:ValueTypes["TextContentPartCreateReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TextContentPartCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["TextContentUniqueWhere"] | null,
	create?:ValueTypes["TextContentWithoutPartsCreateInput"] | null
};
	["TextContentWithoutPartsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["TextContentPartUpdateInput"]: {
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["TextContentPartUpdateContentEntityRelationInput"] | null,
	references?:ValueTypes["TextContentPartUpdateReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TextContentPartUpdateContentEntityRelationInput"]: {
	create?:ValueTypes["TextContentWithoutPartsCreateInput"] | null,
	update?:ValueTypes["TextContentWithoutPartsUpdateInput"] | null,
	upsert?:ValueTypes["TextContentPartUpsertContentRelationInput"] | null,
	connect?:ValueTypes["TextContentUniqueWhere"] | null,
	delete?:boolean | null
};
	["TextContentWithoutPartsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["TextContentPartUpsertContentRelationInput"]: {
	update?:ValueTypes["TextContentWithoutPartsUpdateInput"] | null,
	create?:ValueTypes["TextContentWithoutPartsCreateInput"] | null
};
	["TextContentReferenceCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["TextContentReferenceType"] | null,
	contentPart?:ValueTypes["TextContentReferenceCreateContentPartEntityRelationInput"] | null,
	target?:ValueTypes["TextContentReferenceCreateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TextContentReferenceCreateContentPartEntityRelationInput"]: {
	connect?:ValueTypes["TextContentPartUniqueWhere"] | null,
	create?:ValueTypes["TextContentPartWithoutReferencesCreateInput"] | null
};
	["TextContentPartWithoutReferencesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["TextContentPartCreateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TextContentReferenceUpdateInput"]: {
	type?:ValueTypes["TextContentReferenceType"] | null,
	contentPart?:ValueTypes["TextContentReferenceUpdateContentPartEntityRelationInput"] | null,
	target?:ValueTypes["TextContentReferenceUpdateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TextContentReferenceUpdateContentPartEntityRelationInput"]: {
	create?:ValueTypes["TextContentPartWithoutReferencesCreateInput"] | null,
	update?:ValueTypes["TextContentPartWithoutReferencesUpdateInput"] | null,
	upsert?:ValueTypes["TextContentReferenceUpsertContentPartRelationInput"] | null,
	connect?:ValueTypes["TextContentPartUniqueWhere"] | null,
	delete?:boolean | null
};
	["TextContentPartWithoutReferencesUpdateInput"]: {
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["TextContentPartUpdateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TextContentReferenceUpsertContentPartRelationInput"]: {
	update?:ValueTypes["TextContentPartWithoutReferencesUpdateInput"] | null,
	create?:ValueTypes["TextContentPartWithoutReferencesCreateInput"] | null
};
	["UrlConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["UrlEdge"],
		__typename?: boolean
}>;
	["UrlEdge"]: AliasType<{
	node?:ValueTypes["Url"],
		__typename?: boolean
}>;
	["ArticleTagCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	tag?:ValueTypes["ArticleTagCreateTagEntityRelationInput"] | null,
	article?:ValueTypes["ArticleTagCreateArticleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArticleTagUpdateInput"]: {
	order?:number | null,
	tag?:ValueTypes["ArticleTagUpdateTagEntityRelationInput"] | null,
	article?:ValueTypes["ArticleTagUpdateArticleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["CategoryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CategoryEdge"],
		__typename?: boolean
}>;
	["CategoryEdge"]: AliasType<{
	node?:ValueTypes["Category"],
		__typename?: boolean
}>;
	["CategoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	articleCategory?:ValueTypes["CategoryCreateArticleCategoryEntityRelationInput"][],
	url?:ValueTypes["CategoryCreateUrlEntityRelationInput"] | null,
	legacyId?:string | null,
	_dummy_field_?:boolean | null
};
	["CategoryUpdateInput"]: {
	name?:string | null,
	articleCategory?:ValueTypes["CategoryUpdateArticleCategoryEntityRelationInput"][],
	url?:ValueTypes["CategoryUpdateUrlEntityRelationInput"] | null,
	legacyId?:string | null,
	_dummy_field_?:boolean | null
};
	["ArticleCategoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	article?:ValueTypes["ArticleCategoryCreateArticleEntityRelationInput"] | null,
	category?:ValueTypes["ArticleCategoryCreateCategoryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArticleCategoryUpdateInput"]: {
	order?:number | null,
	article?:ValueTypes["ArticleCategoryUpdateArticleEntityRelationInput"] | null,
	category?:ValueTypes["ArticleCategoryUpdateCategoryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["AudioConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["AudioEdge"],
		__typename?: boolean
}>;
	["AudioEdge"]: AliasType<{
	node?:ValueTypes["Audio"],
		__typename?: boolean
}>;
	["AudioCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	type?:string | null,
	author?:ValueTypes["AudioCreateAuthorEntityRelationInput"] | null,
	uses?:ValueTypes["AudioCreateUsesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["AudioCreateUsesEntityRelationInput"]: {
	connect?:ValueTypes["AudioUseUniqueWhere"] | null,
	create?:ValueTypes["AudioUseWithoutAudioCreateInput"] | null,
	alias?:string | null
};
	["AudioUseWithoutAudioCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["AudioUpdateInput"]: {
	url?:string | null,
	type?:string | null,
	author?:ValueTypes["AudioUpdateAuthorEntityRelationInput"] | null,
	uses?:ValueTypes["AudioUpdateUsesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["AudioUpdateUsesEntityRelationInput"]: {
	create?:ValueTypes["AudioUseWithoutAudioCreateInput"] | null,
	update?:ValueTypes["AudioUpdateUsesRelationInput"] | null,
	upsert?:ValueTypes["AudioUpsertUsesRelationInput"] | null,
	connect?:ValueTypes["AudioUseUniqueWhere"] | null,
	disconnect?:ValueTypes["AudioUseUniqueWhere"] | null,
	delete?:ValueTypes["AudioUseUniqueWhere"] | null,
	alias?:string | null
};
	["AudioUpdateUsesRelationInput"]: {
	by?:ValueTypes["AudioUseUniqueWhere"] | null,
	data?:ValueTypes["AudioUseWithoutAudioUpdateInput"] | null
};
	["AudioUseWithoutAudioUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["AudioUpsertUsesRelationInput"]: {
	by?:ValueTypes["AudioUseUniqueWhere"] | null,
	update?:ValueTypes["AudioUseWithoutAudioUpdateInput"] | null,
	create?:ValueTypes["AudioUseWithoutAudioCreateInput"] | null
};
	["EmbedConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["EmbedEdge"],
		__typename?: boolean
}>;
	["EmbedEdge"]: AliasType<{
	node?:ValueTypes["Embed"],
		__typename?: boolean
}>;
	["ImageContentCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	contentReference?:ValueTypes["ImageContentCreateContentReferenceEntityRelationInput"][],
	image?:ValueTypes["ImageContentCreateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ImageContentCreateContentReferenceEntityRelationInput"]: {
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	create?:ValueTypes["ContentReferenceWithoutImagesCreateInput"] | null,
	alias?:string | null
};
	["ContentReferenceWithoutImagesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ContentReferenceType"] | null,
	contentPart?:ValueTypes["ContentReferenceCreateContentPartEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	variant?:ValueTypes["ContentReferenceVariant"] | null,
	color?:string | null,
	embed?:ValueTypes["ContentReferenceCreateEmbedEntityRelationInput"] | null,
	article?:ValueTypes["ContentReferenceCreateArticleEntityRelationInput"] | null,
	audio?:ValueTypes["ContentReferenceCreateAudioEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceCreateImageEntityRelationInput"] | null,
	pollAnswer?:ValueTypes["ContentReferenceCreatePollAnswerEntityRelationInput"] | null,
	listicle?:ValueTypes["ContentReferenceCreateListicleEntityRelationInput"][],
	faq?:ValueTypes["ContentReferenceCreateFaqEntityRelationInput"][],
	links?:ValueTypes["ContentReferenceCreateLinksEntityRelationInput"][],
	awards?:ValueTypes["ContentReferenceCreateAwardsEntityRelationInput"][],
	reviews?:ValueTypes["ContentReferenceCreateReviewsEntityRelationInput"][],
	target?:ValueTypes["ContentReferenceCreateTargetEntityRelationInput"] | null,
	subscriptionForm?:ValueTypes["ContentReferenceCreateSubscriptionFormEntityRelationInput"] | null,
	buttons?:ValueTypes["ContentReferenceCreateButtonsEntityRelationInput"][],
	sharedContent?:ValueTypes["ContentReferenceCreateSharedContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ImageContentUpdateInput"]: {
	order?:number | null,
	contentReference?:ValueTypes["ImageContentUpdateContentReferenceEntityRelationInput"][],
	image?:ValueTypes["ImageContentUpdateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ImageContentUpdateContentReferenceEntityRelationInput"]: {
	create?:ValueTypes["ContentReferenceWithoutImagesCreateInput"] | null,
	update?:ValueTypes["ImageContentUpdateContentReferenceRelationInput"] | null,
	upsert?:ValueTypes["ImageContentUpsertContentReferenceRelationInput"] | null,
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	disconnect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	delete?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	alias?:string | null
};
	["ImageContentUpdateContentReferenceRelationInput"]: {
	by?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	data?:ValueTypes["ContentReferenceWithoutImagesUpdateInput"] | null
};
	["ContentReferenceWithoutImagesUpdateInput"]: {
	type?:ValueTypes["ContentReferenceType"] | null,
	contentPart?:ValueTypes["ContentReferenceUpdateContentPartEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	variant?:ValueTypes["ContentReferenceVariant"] | null,
	color?:string | null,
	embed?:ValueTypes["ContentReferenceUpdateEmbedEntityRelationInput"] | null,
	article?:ValueTypes["ContentReferenceUpdateArticleEntityRelationInput"] | null,
	audio?:ValueTypes["ContentReferenceUpdateAudioEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceUpdateImageEntityRelationInput"] | null,
	pollAnswer?:ValueTypes["ContentReferenceUpdatePollAnswerEntityRelationInput"] | null,
	listicle?:ValueTypes["ContentReferenceUpdateListicleEntityRelationInput"][],
	faq?:ValueTypes["ContentReferenceUpdateFaqEntityRelationInput"][],
	links?:ValueTypes["ContentReferenceUpdateLinksEntityRelationInput"][],
	awards?:ValueTypes["ContentReferenceUpdateAwardsEntityRelationInput"][],
	reviews?:ValueTypes["ContentReferenceUpdateReviewsEntityRelationInput"][],
	target?:ValueTypes["ContentReferenceUpdateTargetEntityRelationInput"] | null,
	subscriptionForm?:ValueTypes["ContentReferenceUpdateSubscriptionFormEntityRelationInput"] | null,
	buttons?:ValueTypes["ContentReferenceUpdateButtonsEntityRelationInput"][],
	sharedContent?:ValueTypes["ContentReferenceUpdateSharedContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ImageContentUpsertContentReferenceRelationInput"]: {
	by?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	update?:ValueTypes["ContentReferenceWithoutImagesUpdateInput"] | null,
	create?:ValueTypes["ContentReferenceWithoutImagesCreateInput"] | null
};
	["ListicleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	primaryText?:string | null,
	image?:ValueTypes["ListicleCreateImageEntityRelationInput"] | null,
	contentReference?:ValueTypes["ListicleCreateContentReferenceEntityRelationInput"] | null,
	target?:ValueTypes["ListicleCreateTargetEntityRelationInput"] | null,
	content?:ValueTypes["ListicleCreateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ListicleCreateContentReferenceEntityRelationInput"]: {
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	create?:ValueTypes["ContentReferenceWithoutListicleCreateInput"] | null
};
	["ContentReferenceWithoutListicleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ContentReferenceType"] | null,
	contentPart?:ValueTypes["ContentReferenceCreateContentPartEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	variant?:ValueTypes["ContentReferenceVariant"] | null,
	color?:string | null,
	embed?:ValueTypes["ContentReferenceCreateEmbedEntityRelationInput"] | null,
	article?:ValueTypes["ContentReferenceCreateArticleEntityRelationInput"] | null,
	audio?:ValueTypes["ContentReferenceCreateAudioEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceCreateImageEntityRelationInput"] | null,
	images?:ValueTypes["ContentReferenceCreateImagesEntityRelationInput"][],
	pollAnswer?:ValueTypes["ContentReferenceCreatePollAnswerEntityRelationInput"] | null,
	faq?:ValueTypes["ContentReferenceCreateFaqEntityRelationInput"][],
	links?:ValueTypes["ContentReferenceCreateLinksEntityRelationInput"][],
	awards?:ValueTypes["ContentReferenceCreateAwardsEntityRelationInput"][],
	reviews?:ValueTypes["ContentReferenceCreateReviewsEntityRelationInput"][],
	target?:ValueTypes["ContentReferenceCreateTargetEntityRelationInput"] | null,
	subscriptionForm?:ValueTypes["ContentReferenceCreateSubscriptionFormEntityRelationInput"] | null,
	buttons?:ValueTypes["ContentReferenceCreateButtonsEntityRelationInput"][],
	sharedContent?:ValueTypes["ContentReferenceCreateSharedContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ListicleUpdateInput"]: {
	order?:number | null,
	primaryText?:string | null,
	image?:ValueTypes["ListicleUpdateImageEntityRelationInput"] | null,
	contentReference?:ValueTypes["ListicleUpdateContentReferenceEntityRelationInput"] | null,
	target?:ValueTypes["ListicleUpdateTargetEntityRelationInput"] | null,
	content?:ValueTypes["ListicleUpdateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ListicleUpdateContentReferenceEntityRelationInput"]: {
	create?:ValueTypes["ContentReferenceWithoutListicleCreateInput"] | null,
	update?:ValueTypes["ContentReferenceWithoutListicleUpdateInput"] | null,
	upsert?:ValueTypes["ListicleUpsertContentReferenceRelationInput"] | null,
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	delete?:boolean | null
};
	["ContentReferenceWithoutListicleUpdateInput"]: {
	type?:ValueTypes["ContentReferenceType"] | null,
	contentPart?:ValueTypes["ContentReferenceUpdateContentPartEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	variant?:ValueTypes["ContentReferenceVariant"] | null,
	color?:string | null,
	embed?:ValueTypes["ContentReferenceUpdateEmbedEntityRelationInput"] | null,
	article?:ValueTypes["ContentReferenceUpdateArticleEntityRelationInput"] | null,
	audio?:ValueTypes["ContentReferenceUpdateAudioEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceUpdateImageEntityRelationInput"] | null,
	images?:ValueTypes["ContentReferenceUpdateImagesEntityRelationInput"][],
	pollAnswer?:ValueTypes["ContentReferenceUpdatePollAnswerEntityRelationInput"] | null,
	faq?:ValueTypes["ContentReferenceUpdateFaqEntityRelationInput"][],
	links?:ValueTypes["ContentReferenceUpdateLinksEntityRelationInput"][],
	awards?:ValueTypes["ContentReferenceUpdateAwardsEntityRelationInput"][],
	reviews?:ValueTypes["ContentReferenceUpdateReviewsEntityRelationInput"][],
	target?:ValueTypes["ContentReferenceUpdateTargetEntityRelationInput"] | null,
	subscriptionForm?:ValueTypes["ContentReferenceUpdateSubscriptionFormEntityRelationInput"] | null,
	buttons?:ValueTypes["ContentReferenceUpdateButtonsEntityRelationInput"][],
	sharedContent?:ValueTypes["ContentReferenceUpdateSharedContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ListicleUpsertContentReferenceRelationInput"]: {
	update?:ValueTypes["ContentReferenceWithoutListicleUpdateInput"] | null,
	create?:ValueTypes["ContentReferenceWithoutListicleCreateInput"] | null
};
	["PollAnswerConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PollAnswerEdge"],
		__typename?: boolean
}>;
	["PollAnswerEdge"]: AliasType<{
	node?:ValueTypes["PollAnswer"],
		__typename?: boolean
}>;
	["TagConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TagEdge"],
		__typename?: boolean
}>;
	["TagEdge"]: AliasType<{
	node?:ValueTypes["Tag"],
		__typename?: boolean
}>;
	["TagCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	useAsTagline?:boolean | null,
	articleTag?:ValueTypes["TagCreateArticleTagEntityRelationInput"][],
	url?:ValueTypes["TagCreateUrlEntityRelationInput"] | null,
	order?:string | null,
	legacyId?:string | null,
	_dummy_field_?:boolean | null
};
	["TagUpdateInput"]: {
	name?:string | null,
	useAsTagline?:boolean | null,
	articleTag?:ValueTypes["TagUpdateArticleTagEntityRelationInput"][],
	url?:ValueTypes["TagUpdateUrlEntityRelationInput"] | null,
	order?:string | null,
	legacyId?:string | null,
	_dummy_field_?:boolean | null
};
	["FAQCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	answer?:string | null,
	question?:string | null,
	contentReference?:ValueTypes["FAQCreateContentReferenceEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FAQCreateContentReferenceEntityRelationInput"]: {
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	create?:ValueTypes["ContentReferenceWithoutFaqCreateInput"] | null
};
	["ContentReferenceWithoutFaqCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ContentReferenceType"] | null,
	contentPart?:ValueTypes["ContentReferenceCreateContentPartEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	variant?:ValueTypes["ContentReferenceVariant"] | null,
	color?:string | null,
	embed?:ValueTypes["ContentReferenceCreateEmbedEntityRelationInput"] | null,
	article?:ValueTypes["ContentReferenceCreateArticleEntityRelationInput"] | null,
	audio?:ValueTypes["ContentReferenceCreateAudioEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceCreateImageEntityRelationInput"] | null,
	images?:ValueTypes["ContentReferenceCreateImagesEntityRelationInput"][],
	pollAnswer?:ValueTypes["ContentReferenceCreatePollAnswerEntityRelationInput"] | null,
	listicle?:ValueTypes["ContentReferenceCreateListicleEntityRelationInput"][],
	links?:ValueTypes["ContentReferenceCreateLinksEntityRelationInput"][],
	awards?:ValueTypes["ContentReferenceCreateAwardsEntityRelationInput"][],
	reviews?:ValueTypes["ContentReferenceCreateReviewsEntityRelationInput"][],
	target?:ValueTypes["ContentReferenceCreateTargetEntityRelationInput"] | null,
	subscriptionForm?:ValueTypes["ContentReferenceCreateSubscriptionFormEntityRelationInput"] | null,
	buttons?:ValueTypes["ContentReferenceCreateButtonsEntityRelationInput"][],
	sharedContent?:ValueTypes["ContentReferenceCreateSharedContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FAQUpdateInput"]: {
	order?:number | null,
	answer?:string | null,
	question?:string | null,
	contentReference?:ValueTypes["FAQUpdateContentReferenceEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FAQUpdateContentReferenceEntityRelationInput"]: {
	create?:ValueTypes["ContentReferenceWithoutFaqCreateInput"] | null,
	update?:ValueTypes["ContentReferenceWithoutFaqUpdateInput"] | null,
	upsert?:ValueTypes["FAQUpsertContentReferenceRelationInput"] | null,
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	delete?:boolean | null
};
	["ContentReferenceWithoutFaqUpdateInput"]: {
	type?:ValueTypes["ContentReferenceType"] | null,
	contentPart?:ValueTypes["ContentReferenceUpdateContentPartEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	variant?:ValueTypes["ContentReferenceVariant"] | null,
	color?:string | null,
	embed?:ValueTypes["ContentReferenceUpdateEmbedEntityRelationInput"] | null,
	article?:ValueTypes["ContentReferenceUpdateArticleEntityRelationInput"] | null,
	audio?:ValueTypes["ContentReferenceUpdateAudioEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceUpdateImageEntityRelationInput"] | null,
	images?:ValueTypes["ContentReferenceUpdateImagesEntityRelationInput"][],
	pollAnswer?:ValueTypes["ContentReferenceUpdatePollAnswerEntityRelationInput"] | null,
	listicle?:ValueTypes["ContentReferenceUpdateListicleEntityRelationInput"][],
	links?:ValueTypes["ContentReferenceUpdateLinksEntityRelationInput"][],
	awards?:ValueTypes["ContentReferenceUpdateAwardsEntityRelationInput"][],
	reviews?:ValueTypes["ContentReferenceUpdateReviewsEntityRelationInput"][],
	target?:ValueTypes["ContentReferenceUpdateTargetEntityRelationInput"] | null,
	subscriptionForm?:ValueTypes["ContentReferenceUpdateSubscriptionFormEntityRelationInput"] | null,
	buttons?:ValueTypes["ContentReferenceUpdateButtonsEntityRelationInput"][],
	sharedContent?:ValueTypes["ContentReferenceUpdateSharedContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FAQUpsertContentReferenceRelationInput"]: {
	update?:ValueTypes["ContentReferenceWithoutFaqUpdateInput"] | null,
	create?:ValueTypes["ContentReferenceWithoutFaqCreateInput"] | null
};
	["LinkContentCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	contentReference?:ValueTypes["LinkContentCreateContentReferenceEntityRelationInput"] | null,
	text?:string | null,
	target?:ValueTypes["LinkContentCreateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkContentCreateContentReferenceEntityRelationInput"]: {
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	create?:ValueTypes["ContentReferenceWithoutLinksCreateInput"] | null
};
	["ContentReferenceWithoutLinksCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ContentReferenceType"] | null,
	contentPart?:ValueTypes["ContentReferenceCreateContentPartEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	variant?:ValueTypes["ContentReferenceVariant"] | null,
	color?:string | null,
	embed?:ValueTypes["ContentReferenceCreateEmbedEntityRelationInput"] | null,
	article?:ValueTypes["ContentReferenceCreateArticleEntityRelationInput"] | null,
	audio?:ValueTypes["ContentReferenceCreateAudioEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceCreateImageEntityRelationInput"] | null,
	images?:ValueTypes["ContentReferenceCreateImagesEntityRelationInput"][],
	pollAnswer?:ValueTypes["ContentReferenceCreatePollAnswerEntityRelationInput"] | null,
	listicle?:ValueTypes["ContentReferenceCreateListicleEntityRelationInput"][],
	faq?:ValueTypes["ContentReferenceCreateFaqEntityRelationInput"][],
	awards?:ValueTypes["ContentReferenceCreateAwardsEntityRelationInput"][],
	reviews?:ValueTypes["ContentReferenceCreateReviewsEntityRelationInput"][],
	target?:ValueTypes["ContentReferenceCreateTargetEntityRelationInput"] | null,
	subscriptionForm?:ValueTypes["ContentReferenceCreateSubscriptionFormEntityRelationInput"] | null,
	buttons?:ValueTypes["ContentReferenceCreateButtonsEntityRelationInput"][],
	sharedContent?:ValueTypes["ContentReferenceCreateSharedContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkContentUpdateInput"]: {
	order?:number | null,
	contentReference?:ValueTypes["LinkContentUpdateContentReferenceEntityRelationInput"] | null,
	text?:string | null,
	target?:ValueTypes["LinkContentUpdateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkContentUpdateContentReferenceEntityRelationInput"]: {
	create?:ValueTypes["ContentReferenceWithoutLinksCreateInput"] | null,
	update?:ValueTypes["ContentReferenceWithoutLinksUpdateInput"] | null,
	upsert?:ValueTypes["LinkContentUpsertContentReferenceRelationInput"] | null,
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	delete?:boolean | null
};
	["ContentReferenceWithoutLinksUpdateInput"]: {
	type?:ValueTypes["ContentReferenceType"] | null,
	contentPart?:ValueTypes["ContentReferenceUpdateContentPartEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	variant?:ValueTypes["ContentReferenceVariant"] | null,
	color?:string | null,
	embed?:ValueTypes["ContentReferenceUpdateEmbedEntityRelationInput"] | null,
	article?:ValueTypes["ContentReferenceUpdateArticleEntityRelationInput"] | null,
	audio?:ValueTypes["ContentReferenceUpdateAudioEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceUpdateImageEntityRelationInput"] | null,
	images?:ValueTypes["ContentReferenceUpdateImagesEntityRelationInput"][],
	pollAnswer?:ValueTypes["ContentReferenceUpdatePollAnswerEntityRelationInput"] | null,
	listicle?:ValueTypes["ContentReferenceUpdateListicleEntityRelationInput"][],
	faq?:ValueTypes["ContentReferenceUpdateFaqEntityRelationInput"][],
	awards?:ValueTypes["ContentReferenceUpdateAwardsEntityRelationInput"][],
	reviews?:ValueTypes["ContentReferenceUpdateReviewsEntityRelationInput"][],
	target?:ValueTypes["ContentReferenceUpdateTargetEntityRelationInput"] | null,
	subscriptionForm?:ValueTypes["ContentReferenceUpdateSubscriptionFormEntityRelationInput"] | null,
	buttons?:ValueTypes["ContentReferenceUpdateButtonsEntityRelationInput"][],
	sharedContent?:ValueTypes["ContentReferenceUpdateSharedContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkContentUpsertContentReferenceRelationInput"]: {
	update?:ValueTypes["ContentReferenceWithoutLinksUpdateInput"] | null,
	create?:ValueTypes["ContentReferenceWithoutLinksCreateInput"] | null
};
	["AwardContentCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	image?:ValueTypes["AwardContentCreateImageEntityRelationInput"] | null,
	contentReference?:ValueTypes["AwardContentCreateContentReferenceEntityRelationInput"] | null,
	target?:ValueTypes["AwardContentCreateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["AwardContentCreateContentReferenceEntityRelationInput"]: {
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	create?:ValueTypes["ContentReferenceWithoutAwardsCreateInput"] | null
};
	["ContentReferenceWithoutAwardsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ContentReferenceType"] | null,
	contentPart?:ValueTypes["ContentReferenceCreateContentPartEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	variant?:ValueTypes["ContentReferenceVariant"] | null,
	color?:string | null,
	embed?:ValueTypes["ContentReferenceCreateEmbedEntityRelationInput"] | null,
	article?:ValueTypes["ContentReferenceCreateArticleEntityRelationInput"] | null,
	audio?:ValueTypes["ContentReferenceCreateAudioEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceCreateImageEntityRelationInput"] | null,
	images?:ValueTypes["ContentReferenceCreateImagesEntityRelationInput"][],
	pollAnswer?:ValueTypes["ContentReferenceCreatePollAnswerEntityRelationInput"] | null,
	listicle?:ValueTypes["ContentReferenceCreateListicleEntityRelationInput"][],
	faq?:ValueTypes["ContentReferenceCreateFaqEntityRelationInput"][],
	links?:ValueTypes["ContentReferenceCreateLinksEntityRelationInput"][],
	reviews?:ValueTypes["ContentReferenceCreateReviewsEntityRelationInput"][],
	target?:ValueTypes["ContentReferenceCreateTargetEntityRelationInput"] | null,
	subscriptionForm?:ValueTypes["ContentReferenceCreateSubscriptionFormEntityRelationInput"] | null,
	buttons?:ValueTypes["ContentReferenceCreateButtonsEntityRelationInput"][],
	sharedContent?:ValueTypes["ContentReferenceCreateSharedContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["AwardContentUpdateInput"]: {
	order?:number | null,
	image?:ValueTypes["AwardContentUpdateImageEntityRelationInput"] | null,
	contentReference?:ValueTypes["AwardContentUpdateContentReferenceEntityRelationInput"] | null,
	target?:ValueTypes["AwardContentUpdateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["AwardContentUpdateContentReferenceEntityRelationInput"]: {
	create?:ValueTypes["ContentReferenceWithoutAwardsCreateInput"] | null,
	update?:ValueTypes["ContentReferenceWithoutAwardsUpdateInput"] | null,
	upsert?:ValueTypes["AwardContentUpsertContentReferenceRelationInput"] | null,
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	delete?:boolean | null
};
	["ContentReferenceWithoutAwardsUpdateInput"]: {
	type?:ValueTypes["ContentReferenceType"] | null,
	contentPart?:ValueTypes["ContentReferenceUpdateContentPartEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	variant?:ValueTypes["ContentReferenceVariant"] | null,
	color?:string | null,
	embed?:ValueTypes["ContentReferenceUpdateEmbedEntityRelationInput"] | null,
	article?:ValueTypes["ContentReferenceUpdateArticleEntityRelationInput"] | null,
	audio?:ValueTypes["ContentReferenceUpdateAudioEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceUpdateImageEntityRelationInput"] | null,
	images?:ValueTypes["ContentReferenceUpdateImagesEntityRelationInput"][],
	pollAnswer?:ValueTypes["ContentReferenceUpdatePollAnswerEntityRelationInput"] | null,
	listicle?:ValueTypes["ContentReferenceUpdateListicleEntityRelationInput"][],
	faq?:ValueTypes["ContentReferenceUpdateFaqEntityRelationInput"][],
	links?:ValueTypes["ContentReferenceUpdateLinksEntityRelationInput"][],
	reviews?:ValueTypes["ContentReferenceUpdateReviewsEntityRelationInput"][],
	target?:ValueTypes["ContentReferenceUpdateTargetEntityRelationInput"] | null,
	subscriptionForm?:ValueTypes["ContentReferenceUpdateSubscriptionFormEntityRelationInput"] | null,
	buttons?:ValueTypes["ContentReferenceUpdateButtonsEntityRelationInput"][],
	sharedContent?:ValueTypes["ContentReferenceUpdateSharedContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["AwardContentUpsertContentReferenceRelationInput"]: {
	update?:ValueTypes["ContentReferenceWithoutAwardsUpdateInput"] | null,
	create?:ValueTypes["ContentReferenceWithoutAwardsCreateInput"] | null
};
	["ReviewContentCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	text?:string | null,
	contentReference?:ValueTypes["ReviewContentCreateContentReferenceEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ReviewContentCreateContentReferenceEntityRelationInput"]: {
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	create?:ValueTypes["ContentReferenceWithoutReviewsCreateInput"] | null
};
	["ContentReferenceWithoutReviewsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ContentReferenceType"] | null,
	contentPart?:ValueTypes["ContentReferenceCreateContentPartEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	variant?:ValueTypes["ContentReferenceVariant"] | null,
	color?:string | null,
	embed?:ValueTypes["ContentReferenceCreateEmbedEntityRelationInput"] | null,
	article?:ValueTypes["ContentReferenceCreateArticleEntityRelationInput"] | null,
	audio?:ValueTypes["ContentReferenceCreateAudioEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceCreateImageEntityRelationInput"] | null,
	images?:ValueTypes["ContentReferenceCreateImagesEntityRelationInput"][],
	pollAnswer?:ValueTypes["ContentReferenceCreatePollAnswerEntityRelationInput"] | null,
	listicle?:ValueTypes["ContentReferenceCreateListicleEntityRelationInput"][],
	faq?:ValueTypes["ContentReferenceCreateFaqEntityRelationInput"][],
	links?:ValueTypes["ContentReferenceCreateLinksEntityRelationInput"][],
	awards?:ValueTypes["ContentReferenceCreateAwardsEntityRelationInput"][],
	target?:ValueTypes["ContentReferenceCreateTargetEntityRelationInput"] | null,
	subscriptionForm?:ValueTypes["ContentReferenceCreateSubscriptionFormEntityRelationInput"] | null,
	buttons?:ValueTypes["ContentReferenceCreateButtonsEntityRelationInput"][],
	sharedContent?:ValueTypes["ContentReferenceCreateSharedContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ReviewContentUpdateInput"]: {
	order?:number | null,
	text?:string | null,
	contentReference?:ValueTypes["ReviewContentUpdateContentReferenceEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ReviewContentUpdateContentReferenceEntityRelationInput"]: {
	create?:ValueTypes["ContentReferenceWithoutReviewsCreateInput"] | null,
	update?:ValueTypes["ContentReferenceWithoutReviewsUpdateInput"] | null,
	upsert?:ValueTypes["ReviewContentUpsertContentReferenceRelationInput"] | null,
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	delete?:boolean | null
};
	["ContentReferenceWithoutReviewsUpdateInput"]: {
	type?:ValueTypes["ContentReferenceType"] | null,
	contentPart?:ValueTypes["ContentReferenceUpdateContentPartEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	variant?:ValueTypes["ContentReferenceVariant"] | null,
	color?:string | null,
	embed?:ValueTypes["ContentReferenceUpdateEmbedEntityRelationInput"] | null,
	article?:ValueTypes["ContentReferenceUpdateArticleEntityRelationInput"] | null,
	audio?:ValueTypes["ContentReferenceUpdateAudioEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceUpdateImageEntityRelationInput"] | null,
	images?:ValueTypes["ContentReferenceUpdateImagesEntityRelationInput"][],
	pollAnswer?:ValueTypes["ContentReferenceUpdatePollAnswerEntityRelationInput"] | null,
	listicle?:ValueTypes["ContentReferenceUpdateListicleEntityRelationInput"][],
	faq?:ValueTypes["ContentReferenceUpdateFaqEntityRelationInput"][],
	links?:ValueTypes["ContentReferenceUpdateLinksEntityRelationInput"][],
	awards?:ValueTypes["ContentReferenceUpdateAwardsEntityRelationInput"][],
	target?:ValueTypes["ContentReferenceUpdateTargetEntityRelationInput"] | null,
	subscriptionForm?:ValueTypes["ContentReferenceUpdateSubscriptionFormEntityRelationInput"] | null,
	buttons?:ValueTypes["ContentReferenceUpdateButtonsEntityRelationInput"][],
	sharedContent?:ValueTypes["ContentReferenceUpdateSharedContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ReviewContentUpsertContentReferenceRelationInput"]: {
	update?:ValueTypes["ContentReferenceWithoutReviewsUpdateInput"] | null,
	create?:ValueTypes["ContentReferenceWithoutReviewsCreateInput"] | null
};
	["PageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PageEdge"],
		__typename?: boolean
}>;
	["PageEdge"]: AliasType<{
	node?:ValueTypes["Page"],
		__typename?: boolean
}>;
	["PageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	publishAt?:ValueTypes["DateTime"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	template?:ValueTypes["PageTemplate"] | null,
	url?:ValueTypes["PageCreateUrlEntityRelationInput"] | null,
	content?:ValueTypes["PageCreateContentEntityRelationInput"] | null,
	seo?:ValueTypes["PageCreateSeoEntityRelationInput"] | null,
	subscriptionValidity?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["PageUpdateInput"]: {
	title?:string | null,
	publishAt?:ValueTypes["DateTime"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	template?:ValueTypes["PageTemplate"] | null,
	url?:ValueTypes["PageUpdateUrlEntityRelationInput"] | null,
	content?:ValueTypes["PageUpdateContentEntityRelationInput"] | null,
	seo?:ValueTypes["PageUpdateSeoEntityRelationInput"] | null,
	subscriptionValidity?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["TextTranslation"]: AliasType<{
	_meta?:ValueTypes["TextTranslationMeta"],
	id?:boolean,
	key?:boolean,
	description?:boolean,
	value?:boolean,
	draft?:boolean,
		__typename?: boolean
}>;
	["TextTranslationMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	key?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	value?:ValueTypes["FieldMeta"],
	draft?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["TextTranslationUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	key?:string | null
};
	["TextTranslationWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	key?:ValueTypes["StringCondition"] | null,
	description?:ValueTypes["StringCondition"] | null,
	value?:ValueTypes["StringCondition"] | null,
	draft?:ValueTypes["BooleanCondition"] | null,
	and?:(ValueTypes["TextTranslationWhere"] | undefined | null)[],
	or?:(ValueTypes["TextTranslationWhere"] | undefined | null)[],
	not?:ValueTypes["TextTranslationWhere"] | null
};
	["TextTranslationOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	key?:ValueTypes["OrderDirection"] | null,
	description?:ValueTypes["OrderDirection"] | null,
	value?:ValueTypes["OrderDirection"] | null,
	draft?:ValueTypes["OrderDirection"] | null
};
	["TextTranslationConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TextTranslationEdge"],
		__typename?: boolean
}>;
	["TextTranslationEdge"]: AliasType<{
	node?:ValueTypes["TextTranslation"],
		__typename?: boolean
}>;
	["TextTranslationCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	key?:string | null,
	description?:string | null,
	value?:string | null,
	draft?:boolean | null,
	_dummy_field_?:boolean | null
};
	["TextTranslationUpdateInput"]: {
	key?:string | null,
	description?:string | null,
	value?:string | null,
	draft?:boolean | null,
	_dummy_field_?:boolean | null
};
	["SeoConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SeoEdge"],
		__typename?: boolean
}>;
	["SeoEdge"]: AliasType<{
	node?:ValueTypes["Seo"],
		__typename?: boolean
}>;
	["FileConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FileEdge"],
		__typename?: boolean
}>;
	["FileEdge"]: AliasType<{
	node?:ValueTypes["File"],
		__typename?: boolean
}>;
	["FileCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	uses?:ValueTypes["FileCreateUsesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["FileCreateUsesEntityRelationInput"]: {
	connect?:ValueTypes["FileUseUniqueWhere"] | null,
	create?:ValueTypes["FileUseWithoutFileCreateInput"] | null,
	alias?:string | null
};
	["FileUseWithoutFileCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["FileUpdateInput"]: {
	url?:string | null,
	uses?:ValueTypes["FileUpdateUsesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["FileUpdateUsesEntityRelationInput"]: {
	create?:ValueTypes["FileUseWithoutFileCreateInput"] | null,
	update?:ValueTypes["FileUpdateUsesRelationInput"] | null,
	upsert?:ValueTypes["FileUpsertUsesRelationInput"] | null,
	connect?:ValueTypes["FileUseUniqueWhere"] | null,
	disconnect?:ValueTypes["FileUseUniqueWhere"] | null,
	delete?:ValueTypes["FileUseUniqueWhere"] | null,
	alias?:string | null
};
	["FileUpdateUsesRelationInput"]: {
	by?:ValueTypes["FileUseUniqueWhere"] | null,
	data?:ValueTypes["FileUseWithoutFileUpdateInput"] | null
};
	["FileUseWithoutFileUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["FileUpsertUsesRelationInput"]: {
	by?:ValueTypes["FileUseUniqueWhere"] | null,
	update?:ValueTypes["FileUseWithoutFileUpdateInput"] | null,
	create?:ValueTypes["FileUseWithoutFileCreateInput"] | null
};
	["ContentBlockCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	type?:ValueTypes["ContentBlockType"] | null,
	youtubeId?:string | null,
	text?:string | null,
	targetLabel?:string | null,
	issue?:ValueTypes["ContentBlockCreateIssueEntityRelationInput"] | null,
	target?:ValueTypes["ContentBlockCreateTargetEntityRelationInput"] | null,
	articles?:ValueTypes["ContentBlockCreateArticlesEntityRelationInput"][],
	subscriptionForm?:ValueTypes["ContentBlockCreateSubscriptionFormEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentBlockUpdateInput"]: {
	order?:number | null,
	type?:ValueTypes["ContentBlockType"] | null,
	youtubeId?:string | null,
	text?:string | null,
	targetLabel?:string | null,
	issue?:ValueTypes["ContentBlockUpdateIssueEntityRelationInput"] | null,
	target?:ValueTypes["ContentBlockUpdateTargetEntityRelationInput"] | null,
	articles?:ValueTypes["ContentBlockUpdateArticlesEntityRelationInput"][],
	subscriptionForm?:ValueTypes["ContentBlockUpdateSubscriptionFormEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentArticleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	contentBlock?:ValueTypes["ContentArticleCreateContentBlockEntityRelationInput"] | null,
	article?:ValueTypes["ContentArticleCreateArticleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentArticleUpdateInput"]: {
	order?:number | null,
	contentBlock?:ValueTypes["ContentArticleUpdateContentBlockEntityRelationInput"] | null,
	article?:ValueTypes["ContentArticleUpdateArticleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["UnlockedArticleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	code?:string | null,
	views?:number | null,
	user?:ValueTypes["UnlockedArticleCreateUserEntityRelationInput"] | null,
	article?:ValueTypes["UnlockedArticleCreateArticleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["UnlockedArticleUpdateInput"]: {
	createdAt?:ValueTypes["DateTime"] | null,
	code?:string | null,
	views?:number | null,
	user?:ValueTypes["UnlockedArticleUpdateUserEntityRelationInput"] | null,
	article?:ValueTypes["UnlockedArticleUpdateArticleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["UserCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	ihnedId?:string | null,
	email?:string | null,
	authors?:ValueTypes["UserCreateAuthorsEntityRelationInput"][],
	unlockedArticles?:ValueTypes["UserCreateUnlockedArticlesEntityRelationInput"][],
	appReviews?:ValueTypes["UserCreateAppReviewsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["UserUpdateInput"]: {
	ihnedId?:string | null,
	email?:string | null,
	authors?:ValueTypes["UserUpdateAuthorsEntityRelationInput"][],
	unlockedArticles?:ValueTypes["UserUpdateUnlockedArticlesEntityRelationInput"][],
	appReviews?:ValueTypes["UserUpdateAppReviewsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["Notification"]: AliasType<{
	_meta?:ValueTypes["NotificationMeta"],
	id?:boolean,
	title?:boolean,
	message?:boolean,
	sendAt?:boolean,
	sent?:boolean,
		__typename?: boolean
}>;
	["NotificationMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	message?:ValueTypes["FieldMeta"],
	sendAt?:ValueTypes["FieldMeta"],
	sent?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["NotificationUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["NotificationWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	message?:ValueTypes["StringCondition"] | null,
	sendAt?:ValueTypes["DateTimeCondition"] | null,
	sent?:ValueTypes["DateTimeCondition"] | null,
	and?:(ValueTypes["NotificationWhere"] | undefined | null)[],
	or?:(ValueTypes["NotificationWhere"] | undefined | null)[],
	not?:ValueTypes["NotificationWhere"] | null
};
	["NotificationOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	message?:ValueTypes["OrderDirection"] | null,
	sendAt?:ValueTypes["OrderDirection"] | null,
	sent?:ValueTypes["OrderDirection"] | null
};
	["NotificationConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["NotificationEdge"],
		__typename?: boolean
}>;
	["NotificationEdge"]: AliasType<{
	node?:ValueTypes["Notification"],
		__typename?: boolean
}>;
	["NotificationCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	message?:string | null,
	sendAt?:ValueTypes["DateTime"] | null,
	sent?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["NotificationUpdateInput"]: {
	title?:string | null,
	message?:string | null,
	sendAt?:ValueTypes["DateTime"] | null,
	sent?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["AppReviewCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	done?:boolean | null,
	deviceId?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	rating?:number | null,
	note?:string | null,
	user?:ValueTypes["AppReviewCreateUserEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["AppReviewCreateUserEntityRelationInput"]: {
	connect?:ValueTypes["UserUniqueWhere"] | null,
	create?:ValueTypes["UserWithoutAppReviewsCreateInput"] | null
};
	["UserWithoutAppReviewsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	ihnedId?:string | null,
	email?:string | null,
	authors?:ValueTypes["UserCreateAuthorsEntityRelationInput"][],
	unlockedArticles?:ValueTypes["UserCreateUnlockedArticlesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["AppReviewUpdateInput"]: {
	done?:boolean | null,
	deviceId?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	rating?:number | null,
	note?:string | null,
	user?:ValueTypes["AppReviewUpdateUserEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["AppReviewUpdateUserEntityRelationInput"]: {
	create?:ValueTypes["UserWithoutAppReviewsCreateInput"] | null,
	update?:ValueTypes["UserWithoutAppReviewsUpdateInput"] | null,
	upsert?:ValueTypes["AppReviewUpsertUserRelationInput"] | null,
	connect?:ValueTypes["UserUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["UserWithoutAppReviewsUpdateInput"]: {
	ihnedId?:string | null,
	email?:string | null,
	authors?:ValueTypes["UserUpdateAuthorsEntityRelationInput"][],
	unlockedArticles?:ValueTypes["UserUpdateUnlockedArticlesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["AppReviewUpsertUserRelationInput"]: {
	update?:ValueTypes["UserWithoutAppReviewsUpdateInput"] | null,
	create?:ValueTypes["UserWithoutAppReviewsCreateInput"] | null
};
	["ProductCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	price?:number | null,
	type?:ValueTypes["Types"] | null,
	formOptions?:ValueTypes["ProductCreateFormOptionsEntityRelationInput"][],
	form?:ValueTypes["ProductCreateFormEntityRelationInput"] | null,
	productId?:string | null,
	_dummy_field_?:boolean | null
};
	["ProductUpdateInput"]: {
	price?:number | null,
	type?:ValueTypes["Types"] | null,
	formOptions?:ValueTypes["ProductUpdateFormOptionsEntityRelationInput"][],
	form?:ValueTypes["ProductUpdateFormEntityRelationInput"] | null,
	productId?:string | null,
	_dummy_field_?:boolean | null
};
	["SubscriptionFormConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SubscriptionFormEdge"],
		__typename?: boolean
}>;
	["SubscriptionFormEdge"]: AliasType<{
	node?:ValueTypes["SubscriptionForm"],
		__typename?: boolean
}>;
	["SubscriptionFormCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	code?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	sections?:ValueTypes["SubscriptionFormCreateSectionsEntityRelationInput"][],
	contentBlock?:ValueTypes["SubscriptionFormCreateContentBlockEntityRelationInput"][],
	products?:ValueTypes["SubscriptionFormCreateProductsEntityRelationInput"][],
	contentReferences?:ValueTypes["SubscriptionFormCreateContentReferencesEntityRelationInput"][],
	validity?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["SubscriptionFormUpdateInput"]: {
	name?:string | null,
	code?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	sections?:ValueTypes["SubscriptionFormUpdateSectionsEntityRelationInput"][],
	contentBlock?:ValueTypes["SubscriptionFormUpdateContentBlockEntityRelationInput"][],
	products?:ValueTypes["SubscriptionFormUpdateProductsEntityRelationInput"][],
	contentReferences?:ValueTypes["SubscriptionFormUpdateContentReferencesEntityRelationInput"][],
	validity?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["SubscriptionFormSectionCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	title?:string | null,
	form?:ValueTypes["SubscriptionFormSectionCreateFormEntityRelationInput"] | null,
	inputs?:ValueTypes["SubscriptionFormSectionCreateInputsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["SubscriptionFormSectionUpdateInput"]: {
	order?:number | null,
	title?:string | null,
	form?:ValueTypes["SubscriptionFormSectionUpdateFormEntityRelationInput"] | null,
	inputs?:ValueTypes["SubscriptionFormSectionUpdateInputsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["SubscriptionFormInputCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	type?:ValueTypes["SubscriptionFormInputType"] | null,
	image?:ValueTypes["SubscriptionFormInputCreateImageEntityRelationInput"] | null,
	section?:ValueTypes["SubscriptionFormInputCreateSectionEntityRelationInput"] | null,
	options?:ValueTypes["SubscriptionFormInputCreateOptionsEntityRelationInput"][],
	description?:ValueTypes["SubscriptionFormInputCreateDescriptionEntityRelationInput"] | null,
	required?:boolean | null,
	_dummy_field_?:boolean | null
};
	["SubscriptionFormInputUpdateInput"]: {
	order?:number | null,
	type?:ValueTypes["SubscriptionFormInputType"] | null,
	image?:ValueTypes["SubscriptionFormInputUpdateImageEntityRelationInput"] | null,
	section?:ValueTypes["SubscriptionFormInputUpdateSectionEntityRelationInput"] | null,
	options?:ValueTypes["SubscriptionFormInputUpdateOptionsEntityRelationInput"][],
	description?:ValueTypes["SubscriptionFormInputUpdateDescriptionEntityRelationInput"] | null,
	required?:boolean | null,
	_dummy_field_?:boolean | null
};
	["SubscriptionFormOptionCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	hasProductId?:boolean | null,
	order?:number | null,
	label?:string | null,
	priceTag?:string | null,
	priceTagWithDiscount?:string | null,
	products?:ValueTypes["SubscriptionFormOptionCreateProductsEntityRelationInput"][],
	formInput?:ValueTypes["SubscriptionFormOptionCreateFormInputEntityRelationInput"] | null,
	value?:string | null,
	internalLabel?:string | null,
	_dummy_field_?:boolean | null
};
	["SubscriptionFormOptionUpdateInput"]: {
	hasProductId?:boolean | null,
	order?:number | null,
	label?:string | null,
	priceTag?:string | null,
	priceTagWithDiscount?:string | null,
	products?:ValueTypes["SubscriptionFormOptionUpdateProductsEntityRelationInput"][],
	formInput?:ValueTypes["SubscriptionFormOptionUpdateFormInputEntityRelationInput"] | null,
	value?:string | null,
	internalLabel?:string | null,
	_dummy_field_?:boolean | null
};
	["ButtonCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	type?:ValueTypes["ButtonType"] | null,
	label?:string | null,
	target?:ValueTypes["ButtonCreateTargetEntityRelationInput"] | null,
	contentReference?:ValueTypes["ButtonCreateContentReferenceEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ButtonCreateContentReferenceEntityRelationInput"]: {
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	create?:ValueTypes["ContentReferenceWithoutButtonsCreateInput"] | null
};
	["ContentReferenceWithoutButtonsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ContentReferenceType"] | null,
	contentPart?:ValueTypes["ContentReferenceCreateContentPartEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	variant?:ValueTypes["ContentReferenceVariant"] | null,
	color?:string | null,
	embed?:ValueTypes["ContentReferenceCreateEmbedEntityRelationInput"] | null,
	article?:ValueTypes["ContentReferenceCreateArticleEntityRelationInput"] | null,
	audio?:ValueTypes["ContentReferenceCreateAudioEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceCreateImageEntityRelationInput"] | null,
	images?:ValueTypes["ContentReferenceCreateImagesEntityRelationInput"][],
	pollAnswer?:ValueTypes["ContentReferenceCreatePollAnswerEntityRelationInput"] | null,
	listicle?:ValueTypes["ContentReferenceCreateListicleEntityRelationInput"][],
	faq?:ValueTypes["ContentReferenceCreateFaqEntityRelationInput"][],
	links?:ValueTypes["ContentReferenceCreateLinksEntityRelationInput"][],
	awards?:ValueTypes["ContentReferenceCreateAwardsEntityRelationInput"][],
	reviews?:ValueTypes["ContentReferenceCreateReviewsEntityRelationInput"][],
	target?:ValueTypes["ContentReferenceCreateTargetEntityRelationInput"] | null,
	subscriptionForm?:ValueTypes["ContentReferenceCreateSubscriptionFormEntityRelationInput"] | null,
	sharedContent?:ValueTypes["ContentReferenceCreateSharedContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ButtonUpdateInput"]: {
	order?:number | null,
	type?:ValueTypes["ButtonType"] | null,
	label?:string | null,
	target?:ValueTypes["ButtonUpdateTargetEntityRelationInput"] | null,
	contentReference?:ValueTypes["ButtonUpdateContentReferenceEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ButtonUpdateContentReferenceEntityRelationInput"]: {
	create?:ValueTypes["ContentReferenceWithoutButtonsCreateInput"] | null,
	update?:ValueTypes["ContentReferenceWithoutButtonsUpdateInput"] | null,
	upsert?:ValueTypes["ButtonUpsertContentReferenceRelationInput"] | null,
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	delete?:boolean | null
};
	["ContentReferenceWithoutButtonsUpdateInput"]: {
	type?:ValueTypes["ContentReferenceType"] | null,
	contentPart?:ValueTypes["ContentReferenceUpdateContentPartEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	variant?:ValueTypes["ContentReferenceVariant"] | null,
	color?:string | null,
	embed?:ValueTypes["ContentReferenceUpdateEmbedEntityRelationInput"] | null,
	article?:ValueTypes["ContentReferenceUpdateArticleEntityRelationInput"] | null,
	audio?:ValueTypes["ContentReferenceUpdateAudioEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceUpdateImageEntityRelationInput"] | null,
	images?:ValueTypes["ContentReferenceUpdateImagesEntityRelationInput"][],
	pollAnswer?:ValueTypes["ContentReferenceUpdatePollAnswerEntityRelationInput"] | null,
	listicle?:ValueTypes["ContentReferenceUpdateListicleEntityRelationInput"][],
	faq?:ValueTypes["ContentReferenceUpdateFaqEntityRelationInput"][],
	links?:ValueTypes["ContentReferenceUpdateLinksEntityRelationInput"][],
	awards?:ValueTypes["ContentReferenceUpdateAwardsEntityRelationInput"][],
	reviews?:ValueTypes["ContentReferenceUpdateReviewsEntityRelationInput"][],
	target?:ValueTypes["ContentReferenceUpdateTargetEntityRelationInput"] | null,
	subscriptionForm?:ValueTypes["ContentReferenceUpdateSubscriptionFormEntityRelationInput"] | null,
	sharedContent?:ValueTypes["ContentReferenceUpdateSharedContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ButtonUpsertContentReferenceRelationInput"]: {
	update?:ValueTypes["ContentReferenceWithoutButtonsUpdateInput"] | null,
	create?:ValueTypes["ContentReferenceWithoutButtonsCreateInput"] | null
};
	["ArticleHistoryTagCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	article?:ValueTypes["ArticleHistoryTagCreateArticleEntityRelationInput"] | null,
	historyTag?:ValueTypes["ArticleHistoryTagCreateHistoryTagEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArticleHistoryTagCreateArticleEntityRelationInput"]: {
	connect?:ValueTypes["ArticleUniqueWhere"] | null,
	create?:ValueTypes["ArticleWithoutHistoryTagsCreateInput"] | null
};
	["ArticleWithoutHistoryTagsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	url?:ValueTypes["ArticleCreateUrlEntityRelationInput"] | null,
	authors?:ValueTypes["ArticleCreateAuthorsEntityRelationInput"][],
	hideInMostRead?:boolean | null,
	hideAds?:boolean | null,
	state?:ValueTypes["ArticleState"] | null,
	locked?:boolean | null,
	publishAt?:ValueTypes["DateTime"] | null,
	template?:ValueTypes["Template"] | null,
	subtitle?:ValueTypes["ArticleCreateSubtitleEntityRelationInput"] | null,
	content?:ValueTypes["ArticleCreateContentEntityRelationInput"] | null,
	coverPhoto?:ValueTypes["ArticleCreateCoverPhotoEntityRelationInput"] | null,
	titleAlignment?:ValueTypes["ArticleTitleAlignment"] | null,
	tagline?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	previewContent?:ValueTypes["ArticleCreatePreviewContentEntityRelationInput"] | null,
	audio?:ValueTypes["ArticleCreateAudioEntityRelationInput"] | null,
	categories?:ValueTypes["ArticleCreateCategoriesEntityRelationInput"][],
	issues?:ValueTypes["ArticleCreateIssuesEntityRelationInput"][],
	contentBlocks?:ValueTypes["ArticleCreateContentBlocksEntityRelationInput"][],
	unlocked?:ValueTypes["ArticleCreateUnlockedEntityRelationInput"][],
	coverPhotoVertical?:ValueTypes["ArticleCreateCoverPhotoVerticalEntityRelationInput"] | null,
	legacyId?:string | null,
	tags?:ValueTypes["ArticleCreateTagsEntityRelationInput"][],
	isHistory?:boolean | null,
	historyPeriods?:ValueTypes["ArticleCreateHistoryPeriodsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ArticleHistoryTagUpdateInput"]: {
	order?:number | null,
	article?:ValueTypes["ArticleHistoryTagUpdateArticleEntityRelationInput"] | null,
	historyTag?:ValueTypes["ArticleHistoryTagUpdateHistoryTagEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArticleHistoryTagUpdateArticleEntityRelationInput"]: {
	create?:ValueTypes["ArticleWithoutHistoryTagsCreateInput"] | null,
	update?:ValueTypes["ArticleWithoutHistoryTagsUpdateInput"] | null,
	upsert?:ValueTypes["ArticleHistoryTagUpsertArticleRelationInput"] | null,
	connect?:ValueTypes["ArticleUniqueWhere"] | null,
	delete?:boolean | null
};
	["ArticleWithoutHistoryTagsUpdateInput"]: {
	title?:string | null,
	url?:ValueTypes["ArticleUpdateUrlEntityRelationInput"] | null,
	authors?:ValueTypes["ArticleUpdateAuthorsEntityRelationInput"][],
	hideInMostRead?:boolean | null,
	hideAds?:boolean | null,
	state?:ValueTypes["ArticleState"] | null,
	locked?:boolean | null,
	publishAt?:ValueTypes["DateTime"] | null,
	template?:ValueTypes["Template"] | null,
	subtitle?:ValueTypes["ArticleUpdateSubtitleEntityRelationInput"] | null,
	content?:ValueTypes["ArticleUpdateContentEntityRelationInput"] | null,
	coverPhoto?:ValueTypes["ArticleUpdateCoverPhotoEntityRelationInput"] | null,
	titleAlignment?:ValueTypes["ArticleTitleAlignment"] | null,
	tagline?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	previewContent?:ValueTypes["ArticleUpdatePreviewContentEntityRelationInput"] | null,
	audio?:ValueTypes["ArticleUpdateAudioEntityRelationInput"] | null,
	categories?:ValueTypes["ArticleUpdateCategoriesEntityRelationInput"][],
	issues?:ValueTypes["ArticleUpdateIssuesEntityRelationInput"][],
	contentBlocks?:ValueTypes["ArticleUpdateContentBlocksEntityRelationInput"][],
	unlocked?:ValueTypes["ArticleUpdateUnlockedEntityRelationInput"][],
	coverPhotoVertical?:ValueTypes["ArticleUpdateCoverPhotoVerticalEntityRelationInput"] | null,
	legacyId?:string | null,
	tags?:ValueTypes["ArticleUpdateTagsEntityRelationInput"][],
	isHistory?:boolean | null,
	historyPeriods?:ValueTypes["ArticleUpdateHistoryPeriodsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ArticleHistoryTagUpsertArticleRelationInput"]: {
	update?:ValueTypes["ArticleWithoutHistoryTagsUpdateInput"] | null,
	create?:ValueTypes["ArticleWithoutHistoryTagsCreateInput"] | null
};
	["ArticleHistoryPeriodCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	article?:ValueTypes["ArticleHistoryPeriodCreateArticleEntityRelationInput"] | null,
	historyPeriod?:ValueTypes["ArticleHistoryPeriodCreateHistoryPeriodEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArticleHistoryPeriodCreateArticleEntityRelationInput"]: {
	connect?:ValueTypes["ArticleUniqueWhere"] | null,
	create?:ValueTypes["ArticleWithoutHistoryPeriodsCreateInput"] | null
};
	["ArticleWithoutHistoryPeriodsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	url?:ValueTypes["ArticleCreateUrlEntityRelationInput"] | null,
	authors?:ValueTypes["ArticleCreateAuthorsEntityRelationInput"][],
	hideInMostRead?:boolean | null,
	hideAds?:boolean | null,
	state?:ValueTypes["ArticleState"] | null,
	locked?:boolean | null,
	publishAt?:ValueTypes["DateTime"] | null,
	template?:ValueTypes["Template"] | null,
	subtitle?:ValueTypes["ArticleCreateSubtitleEntityRelationInput"] | null,
	content?:ValueTypes["ArticleCreateContentEntityRelationInput"] | null,
	coverPhoto?:ValueTypes["ArticleCreateCoverPhotoEntityRelationInput"] | null,
	titleAlignment?:ValueTypes["ArticleTitleAlignment"] | null,
	tagline?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	previewContent?:ValueTypes["ArticleCreatePreviewContentEntityRelationInput"] | null,
	audio?:ValueTypes["ArticleCreateAudioEntityRelationInput"] | null,
	categories?:ValueTypes["ArticleCreateCategoriesEntityRelationInput"][],
	issues?:ValueTypes["ArticleCreateIssuesEntityRelationInput"][],
	contentBlocks?:ValueTypes["ArticleCreateContentBlocksEntityRelationInput"][],
	unlocked?:ValueTypes["ArticleCreateUnlockedEntityRelationInput"][],
	coverPhotoVertical?:ValueTypes["ArticleCreateCoverPhotoVerticalEntityRelationInput"] | null,
	legacyId?:string | null,
	tags?:ValueTypes["ArticleCreateTagsEntityRelationInput"][],
	isHistory?:boolean | null,
	historyTags?:ValueTypes["ArticleCreateHistoryTagsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ArticleHistoryPeriodUpdateInput"]: {
	order?:number | null,
	article?:ValueTypes["ArticleHistoryPeriodUpdateArticleEntityRelationInput"] | null,
	historyPeriod?:ValueTypes["ArticleHistoryPeriodUpdateHistoryPeriodEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArticleHistoryPeriodUpdateArticleEntityRelationInput"]: {
	create?:ValueTypes["ArticleWithoutHistoryPeriodsCreateInput"] | null,
	update?:ValueTypes["ArticleWithoutHistoryPeriodsUpdateInput"] | null,
	upsert?:ValueTypes["ArticleHistoryPeriodUpsertArticleRelationInput"] | null,
	connect?:ValueTypes["ArticleUniqueWhere"] | null,
	delete?:boolean | null
};
	["ArticleWithoutHistoryPeriodsUpdateInput"]: {
	title?:string | null,
	url?:ValueTypes["ArticleUpdateUrlEntityRelationInput"] | null,
	authors?:ValueTypes["ArticleUpdateAuthorsEntityRelationInput"][],
	hideInMostRead?:boolean | null,
	hideAds?:boolean | null,
	state?:ValueTypes["ArticleState"] | null,
	locked?:boolean | null,
	publishAt?:ValueTypes["DateTime"] | null,
	template?:ValueTypes["Template"] | null,
	subtitle?:ValueTypes["ArticleUpdateSubtitleEntityRelationInput"] | null,
	content?:ValueTypes["ArticleUpdateContentEntityRelationInput"] | null,
	coverPhoto?:ValueTypes["ArticleUpdateCoverPhotoEntityRelationInput"] | null,
	titleAlignment?:ValueTypes["ArticleTitleAlignment"] | null,
	tagline?:string | null,
	createdAt?:ValueTypes["DateTime"] | null,
	previewContent?:ValueTypes["ArticleUpdatePreviewContentEntityRelationInput"] | null,
	audio?:ValueTypes["ArticleUpdateAudioEntityRelationInput"] | null,
	categories?:ValueTypes["ArticleUpdateCategoriesEntityRelationInput"][],
	issues?:ValueTypes["ArticleUpdateIssuesEntityRelationInput"][],
	contentBlocks?:ValueTypes["ArticleUpdateContentBlocksEntityRelationInput"][],
	unlocked?:ValueTypes["ArticleUpdateUnlockedEntityRelationInput"][],
	coverPhotoVertical?:ValueTypes["ArticleUpdateCoverPhotoVerticalEntityRelationInput"] | null,
	legacyId?:string | null,
	tags?:ValueTypes["ArticleUpdateTagsEntityRelationInput"][],
	isHistory?:boolean | null,
	historyTags?:ValueTypes["ArticleUpdateHistoryTagsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ArticleHistoryPeriodUpsertArticleRelationInput"]: {
	update?:ValueTypes["ArticleWithoutHistoryPeriodsUpdateInput"] | null,
	create?:ValueTypes["ArticleWithoutHistoryPeriodsCreateInput"] | null
};
	["HistoryTagConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HistoryTagEdge"],
		__typename?: boolean
}>;
	["HistoryTagEdge"]: AliasType<{
	node?:ValueTypes["HistoryTag"],
		__typename?: boolean
}>;
	["HistoryTagCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	articleHistoryTag?:ValueTypes["HistoryTagCreateArticleHistoryTagEntityRelationInput"][],
	slug?:string | null,
	_dummy_field_?:boolean | null
};
	["HistoryTagCreateArticleHistoryTagEntityRelationInput"]: {
	connect?:ValueTypes["ArticleHistoryTagUniqueWhere"] | null,
	create?:ValueTypes["ArticleHistoryTagWithoutHistoryTagCreateInput"] | null,
	alias?:string | null
};
	["ArticleHistoryTagWithoutHistoryTagCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	article?:ValueTypes["ArticleHistoryTagCreateArticleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HistoryTagUpdateInput"]: {
	name?:string | null,
	articleHistoryTag?:ValueTypes["HistoryTagUpdateArticleHistoryTagEntityRelationInput"][],
	slug?:string | null,
	_dummy_field_?:boolean | null
};
	["HistoryTagUpdateArticleHistoryTagEntityRelationInput"]: {
	create?:ValueTypes["ArticleHistoryTagWithoutHistoryTagCreateInput"] | null,
	update?:ValueTypes["HistoryTagUpdateArticleHistoryTagRelationInput"] | null,
	upsert?:ValueTypes["HistoryTagUpsertArticleHistoryTagRelationInput"] | null,
	connect?:ValueTypes["ArticleHistoryTagUniqueWhere"] | null,
	disconnect?:ValueTypes["ArticleHistoryTagUniqueWhere"] | null,
	delete?:ValueTypes["ArticleHistoryTagUniqueWhere"] | null,
	alias?:string | null
};
	["HistoryTagUpdateArticleHistoryTagRelationInput"]: {
	by?:ValueTypes["ArticleHistoryTagUniqueWhere"] | null,
	data?:ValueTypes["ArticleHistoryTagWithoutHistoryTagUpdateInput"] | null
};
	["ArticleHistoryTagWithoutHistoryTagUpdateInput"]: {
	order?:number | null,
	article?:ValueTypes["ArticleHistoryTagUpdateArticleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HistoryTagUpsertArticleHistoryTagRelationInput"]: {
	by?:ValueTypes["ArticleHistoryTagUniqueWhere"] | null,
	update?:ValueTypes["ArticleHistoryTagWithoutHistoryTagUpdateInput"] | null,
	create?:ValueTypes["ArticleHistoryTagWithoutHistoryTagCreateInput"] | null
};
	["HistoryPeriodConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HistoryPeriodEdge"],
		__typename?: boolean
}>;
	["HistoryPeriodEdge"]: AliasType<{
	node?:ValueTypes["HistoryPeriod"],
		__typename?: boolean
}>;
	["HistoryPeriodCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	articleHistoryPeriod?:ValueTypes["HistoryPeriodCreateArticleHistoryPeriodEntityRelationInput"][],
	slug?:string | null,
	order?:number | null,
	cover?:ValueTypes["HistoryPeriodCreateCoverEntityRelationInput"] | null,
	seo?:ValueTypes["HistoryPeriodCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HistoryPeriodCreateArticleHistoryPeriodEntityRelationInput"]: {
	connect?:ValueTypes["ArticleHistoryPeriodUniqueWhere"] | null,
	create?:ValueTypes["ArticleHistoryPeriodWithoutHistoryPeriodCreateInput"] | null,
	alias?:string | null
};
	["ArticleHistoryPeriodWithoutHistoryPeriodCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	article?:ValueTypes["ArticleHistoryPeriodCreateArticleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HistoryPeriodUpdateInput"]: {
	name?:string | null,
	articleHistoryPeriod?:ValueTypes["HistoryPeriodUpdateArticleHistoryPeriodEntityRelationInput"][],
	slug?:string | null,
	order?:number | null,
	cover?:ValueTypes["HistoryPeriodUpdateCoverEntityRelationInput"] | null,
	seo?:ValueTypes["HistoryPeriodUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HistoryPeriodUpdateArticleHistoryPeriodEntityRelationInput"]: {
	create?:ValueTypes["ArticleHistoryPeriodWithoutHistoryPeriodCreateInput"] | null,
	update?:ValueTypes["HistoryPeriodUpdateArticleHistoryPeriodRelationInput"] | null,
	upsert?:ValueTypes["HistoryPeriodUpsertArticleHistoryPeriodRelationInput"] | null,
	connect?:ValueTypes["ArticleHistoryPeriodUniqueWhere"] | null,
	disconnect?:ValueTypes["ArticleHistoryPeriodUniqueWhere"] | null,
	delete?:ValueTypes["ArticleHistoryPeriodUniqueWhere"] | null,
	alias?:string | null
};
	["HistoryPeriodUpdateArticleHistoryPeriodRelationInput"]: {
	by?:ValueTypes["ArticleHistoryPeriodUniqueWhere"] | null,
	data?:ValueTypes["ArticleHistoryPeriodWithoutHistoryPeriodUpdateInput"] | null
};
	["ArticleHistoryPeriodWithoutHistoryPeriodUpdateInput"]: {
	order?:number | null,
	article?:ValueTypes["ArticleHistoryPeriodUpdateArticleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HistoryPeriodUpsertArticleHistoryPeriodRelationInput"]: {
	by?:ValueTypes["ArticleHistoryPeriodUniqueWhere"] | null,
	update?:ValueTypes["ArticleHistoryPeriodWithoutHistoryPeriodUpdateInput"] | null,
	create?:ValueTypes["ArticleHistoryPeriodWithoutHistoryPeriodCreateInput"] | null
};
	["HistoryHomePage"]: AliasType<{
	_meta?:ValueTypes["HistoryHomePageMeta"],
	id?:boolean,
	unique?:boolean,
	timePeriodTitle?:boolean,
	personalitiesTitle?:boolean,
cover?: [{	filter?:ValueTypes["HistoryCoverWhere"] | null},ValueTypes["HistoryCover"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
	slug?:boolean,
		__typename?: boolean
}>;
	["HistoryHomePageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	timePeriodTitle?:ValueTypes["FieldMeta"],
	personalitiesTitle?:ValueTypes["FieldMeta"],
	cover?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	slug?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["HistoryHomePageUnique"]:HistoryHomePageUnique;
	["HistoryHomePageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["HistoryHomePageUnique"] | null,
	slug?:string | null,
	cover?:ValueTypes["HistoryCoverUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["HistoryHomePageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["HistoryHomePageUniqueCondition"] | null,
	timePeriodTitle?:ValueTypes["StringCondition"] | null,
	personalitiesTitle?:ValueTypes["StringCondition"] | null,
	cover?:ValueTypes["HistoryCoverWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	slug?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["HistoryHomePageWhere"] | undefined | null)[],
	or?:(ValueTypes["HistoryHomePageWhere"] | undefined | null)[],
	not?:ValueTypes["HistoryHomePageWhere"] | null
};
	["HistoryHomePageUniqueCondition"]: {
	and?:ValueTypes["HistoryHomePageUniqueCondition"][],
	or?:ValueTypes["HistoryHomePageUniqueCondition"][],
	not?:ValueTypes["HistoryHomePageUniqueCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["HistoryHomePageUnique"] | null,
	notEq?:ValueTypes["HistoryHomePageUnique"] | null,
	in?:ValueTypes["HistoryHomePageUnique"][],
	notIn?:ValueTypes["HistoryHomePageUnique"][],
	lt?:ValueTypes["HistoryHomePageUnique"] | null,
	lte?:ValueTypes["HistoryHomePageUnique"] | null,
	gt?:ValueTypes["HistoryHomePageUnique"] | null,
	gte?:ValueTypes["HistoryHomePageUnique"] | null
};
	["HistoryHomePageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	timePeriodTitle?:ValueTypes["OrderDirection"] | null,
	personalitiesTitle?:ValueTypes["OrderDirection"] | null,
	cover?:ValueTypes["HistoryCoverOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	slug?:ValueTypes["OrderDirection"] | null
};
	["HistoryHomePageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HistoryHomePageEdge"],
		__typename?: boolean
}>;
	["HistoryHomePageEdge"]: AliasType<{
	node?:ValueTypes["HistoryHomePage"],
		__typename?: boolean
}>;
	["HistoryHomePageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["HistoryHomePageUnique"] | null,
	timePeriodTitle?:string | null,
	personalitiesTitle?:string | null,
	cover?:ValueTypes["HistoryHomePageCreateCoverEntityRelationInput"] | null,
	seo?:ValueTypes["HistoryHomePageCreateSeoEntityRelationInput"] | null,
	slug?:string | null,
	_dummy_field_?:boolean | null
};
	["HistoryHomePageCreateCoverEntityRelationInput"]: {
	connect?:ValueTypes["HistoryCoverUniqueWhere"] | null,
	create?:ValueTypes["HistoryCoverCreateInput"] | null
};
	["HistoryHomePageCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["HistoryHomePageUpdateInput"]: {
	unique?:ValueTypes["HistoryHomePageUnique"] | null,
	timePeriodTitle?:string | null,
	personalitiesTitle?:string | null,
	cover?:ValueTypes["HistoryHomePageUpdateCoverEntityRelationInput"] | null,
	seo?:ValueTypes["HistoryHomePageUpdateSeoEntityRelationInput"] | null,
	slug?:string | null,
	_dummy_field_?:boolean | null
};
	["HistoryHomePageUpdateCoverEntityRelationInput"]: {
	create?:ValueTypes["HistoryCoverCreateInput"] | null,
	update?:ValueTypes["HistoryCoverUpdateInput"] | null,
	upsert?:ValueTypes["HistoryHomePageUpsertCoverRelationInput"] | null,
	connect?:ValueTypes["HistoryCoverUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HistoryHomePageUpsertCoverRelationInput"]: {
	update?:ValueTypes["HistoryCoverUpdateInput"] | null,
	create?:ValueTypes["HistoryCoverCreateInput"] | null
};
	["HistoryHomePageUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["HistoryHomePageUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HistoryHomePageUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["HistoryCoverConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HistoryCoverEdge"],
		__typename?: boolean
}>;
	["HistoryCoverEdge"]: AliasType<{
	node?:ValueTypes["HistoryCover"],
		__typename?: boolean
}>;
	["HistoryTextListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HistoryTextListEdge"],
		__typename?: boolean
}>;
	["HistoryTextListEdge"]: AliasType<{
	node?:ValueTypes["HistoryTextList"],
		__typename?: boolean
}>;
	["HistoryTextItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	key?:string | null,
	text?:string | null,
	list?:ValueTypes["HistoryTextItemCreateListEntityRelationInput"] | null,
	image?:ValueTypes["HistoryTextItemCreateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HistoryTextItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["HistoryTextListUniqueWhere"] | null,
	create?:ValueTypes["HistoryTextListWithoutItemsCreateInput"] | null
};
	["HistoryTextListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["HistoryTextItemUpdateInput"]: {
	order?:number | null,
	key?:string | null,
	text?:string | null,
	list?:ValueTypes["HistoryTextItemUpdateListEntityRelationInput"] | null,
	image?:ValueTypes["HistoryTextItemUpdateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HistoryTextItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["HistoryTextListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["HistoryTextListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["HistoryTextItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["HistoryTextListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HistoryTextListWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["HistoryTextItemUpsertListRelationInput"]: {
	update?:ValueTypes["HistoryTextListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["HistoryTextListWithoutItemsCreateInput"] | null
};
	["FooterMenu"]: AliasType<{
	_meta?:ValueTypes["FooterMenuMeta"],
	id?:boolean,
	unique?:boolean,
	copyright?:boolean,
online?: [{	filter?:ValueTypes["OnlineSectionWhere"] | null},ValueTypes["OnlineSection"]],
links?: [{	filter?:ValueTypes["LinkSectionWhere"] | null},ValueTypes["LinkSection"]],
linksTwo?: [{	filter?:ValueTypes["LinkSectionWhere"] | null},ValueTypes["LinkSection"]],
social?: [{	filter?:ValueTypes["SocialSectionWhere"] | null},ValueTypes["SocialSection"]],
newsletter?: [{	filter?:ValueTypes["NewsletterSectionWhere"] | null},ValueTypes["NewsletterSection"]],
		__typename?: boolean
}>;
	["FooterMenuMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	copyright?:ValueTypes["FieldMeta"],
	online?:ValueTypes["FieldMeta"],
	links?:ValueTypes["FieldMeta"],
	linksTwo?:ValueTypes["FieldMeta"],
	social?:ValueTypes["FieldMeta"],
	newsletter?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["FooterMenuUnique"]:FooterMenuUnique;
	["OnlineSection"]: AliasType<{
	_meta?:ValueTypes["OnlineSectionMeta"],
	id?:boolean,
	title?:boolean,
appLinks?: [{	filter?:ValueTypes["AppLinkListWhere"] | null},ValueTypes["AppLinkList"]],
links?: [{	filter?:ValueTypes["LinkListWhere"] | null},ValueTypes["LinkList"]],
		__typename?: boolean
}>;
	["OnlineSectionMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	appLinks?:ValueTypes["FieldMeta"],
	links?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["AppLinkList"]: AliasType<{
	_meta?:ValueTypes["AppLinkListMeta"],
	id?:boolean,
items?: [{	filter?:ValueTypes["AppLinkItemWhere"] | null,	orderBy?:ValueTypes["AppLinkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["AppLinkItem"]],
itemsByAppLink?: [{	by:ValueTypes["AppLinkListItemsByAppLinkUniqueWhere"],	filter?:ValueTypes["AppLinkItemWhere"] | null},ValueTypes["AppLinkItem"]],
paginateItems?: [{	filter?:ValueTypes["AppLinkItemWhere"] | null,	orderBy?:ValueTypes["AppLinkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AppLinkItemConnection"]],
		__typename?: boolean
}>;
	["AppLinkListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["AppLinkItem"]: AliasType<{
	_meta?:ValueTypes["AppLinkItemMeta"],
	id?:boolean,
	order?:boolean,
list?: [{	filter?:ValueTypes["AppLinkListWhere"] | null},ValueTypes["AppLinkList"]],
appLink?: [{	filter?:ValueTypes["AppLinkWhere"] | null},ValueTypes["AppLink"]],
		__typename?: boolean
}>;
	["AppLinkItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	appLink?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["AppLinkListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["AppLinkItemWhere"] | null,
	and?:(ValueTypes["AppLinkListWhere"] | undefined | null)[],
	or?:(ValueTypes["AppLinkListWhere"] | undefined | null)[],
	not?:ValueTypes["AppLinkListWhere"] | null
};
	["AppLinkItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	list?:ValueTypes["AppLinkListWhere"] | null,
	appLink?:ValueTypes["AppLinkWhere"] | null,
	and?:(ValueTypes["AppLinkItemWhere"] | undefined | null)[],
	or?:(ValueTypes["AppLinkItemWhere"] | undefined | null)[],
	not?:ValueTypes["AppLinkItemWhere"] | null
};
	["AppLinkWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	type?:ValueTypes["AppLinkTypeCondition"] | null,
	url?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["AppLinkWhere"] | undefined | null)[],
	or?:(ValueTypes["AppLinkWhere"] | undefined | null)[],
	not?:ValueTypes["AppLinkWhere"] | null
};
	["AppLinkTypeCondition"]: {
	and?:ValueTypes["AppLinkTypeCondition"][],
	or?:ValueTypes["AppLinkTypeCondition"][],
	not?:ValueTypes["AppLinkTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["AppLinkType"] | null,
	notEq?:ValueTypes["AppLinkType"] | null,
	in?:ValueTypes["AppLinkType"][],
	notIn?:ValueTypes["AppLinkType"][],
	lt?:ValueTypes["AppLinkType"] | null,
	lte?:ValueTypes["AppLinkType"] | null,
	gt?:ValueTypes["AppLinkType"] | null,
	gte?:ValueTypes["AppLinkType"] | null
};
	["AppLinkType"]:AppLinkType;
	["AppLink"]: AliasType<{
	_meta?:ValueTypes["AppLinkMeta"],
	id?:boolean,
	type?:boolean,
	url?:boolean,
		__typename?: boolean
}>;
	["AppLinkMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["AppLinkItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["AppLinkListOrderBy"] | null,
	appLink?:ValueTypes["AppLinkOrderBy"] | null
};
	["AppLinkListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["AppLinkOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["OrderDirection"] | null
};
	["AppLinkListItemsByAppLinkUniqueWhere"]: {
	appLink?:ValueTypes["AppLinkUniqueWhere"] | null
};
	["AppLinkUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["AppLinkItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["AppLinkItemEdge"],
		__typename?: boolean
}>;
	["AppLinkItemEdge"]: AliasType<{
	node?:ValueTypes["AppLinkItem"],
		__typename?: boolean
}>;
	["LinkList"]: AliasType<{
	_meta?:ValueTypes["LinkListMeta"],
	id?:boolean,
items?: [{	filter?:ValueTypes["LinkItemWhere"] | null,	orderBy?:ValueTypes["LinkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["LinkItem"]],
paginateItems?: [{	filter?:ValueTypes["LinkItemWhere"] | null,	orderBy?:ValueTypes["LinkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkItemConnection"]],
		__typename?: boolean
}>;
	["LinkListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["LinkItem"]: AliasType<{
	_meta?:ValueTypes["LinkItemMeta"],
	id?:boolean,
	order?:boolean,
list?: [{	filter?:ValueTypes["LinkListWhere"] | null},ValueTypes["LinkList"]],
link?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
	title?:boolean,
		__typename?: boolean
}>;
	["LinkItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["LinkListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["LinkItemWhere"] | null,
	and?:(ValueTypes["LinkListWhere"] | undefined | null)[],
	or?:(ValueTypes["LinkListWhere"] | undefined | null)[],
	not?:ValueTypes["LinkListWhere"] | null
};
	["LinkItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	list?:ValueTypes["LinkListWhere"] | null,
	link?:ValueTypes["LinkWhere"] | null,
	title?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["LinkItemWhere"] | undefined | null)[],
	or?:(ValueTypes["LinkItemWhere"] | undefined | null)[],
	not?:ValueTypes["LinkItemWhere"] | null
};
	["LinkItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["LinkListOrderBy"] | null,
	link?:ValueTypes["LinkOrderBy"] | null,
	title?:ValueTypes["OrderDirection"] | null
};
	["LinkListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["LinkItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkItemEdge"],
		__typename?: boolean
}>;
	["LinkItemEdge"]: AliasType<{
	node?:ValueTypes["LinkItem"],
		__typename?: boolean
}>;
	["OnlineSectionWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	appLinks?:ValueTypes["AppLinkListWhere"] | null,
	links?:ValueTypes["LinkListWhere"] | null,
	and?:(ValueTypes["OnlineSectionWhere"] | undefined | null)[],
	or?:(ValueTypes["OnlineSectionWhere"] | undefined | null)[],
	not?:ValueTypes["OnlineSectionWhere"] | null
};
	["LinkSection"]: AliasType<{
	_meta?:ValueTypes["LinkSectionMeta"],
	id?:boolean,
	title?:boolean,
links?: [{	filter?:ValueTypes["LinkListWhere"] | null},ValueTypes["LinkList"]],
		__typename?: boolean
}>;
	["LinkSectionMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	links?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["LinkSectionWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	links?:ValueTypes["LinkListWhere"] | null,
	and?:(ValueTypes["LinkSectionWhere"] | undefined | null)[],
	or?:(ValueTypes["LinkSectionWhere"] | undefined | null)[],
	not?:ValueTypes["LinkSectionWhere"] | null
};
	["SocialSection"]: AliasType<{
	_meta?:ValueTypes["SocialSectionMeta"],
	id?:boolean,
	title?:boolean,
socialLinks?: [{	filter?:ValueTypes["SocialLinkListWhere"] | null},ValueTypes["SocialLinkList"]],
		__typename?: boolean
}>;
	["SocialSectionMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	socialLinks?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["SocialLinkList"]: AliasType<{
	_meta?:ValueTypes["SocialLinkListMeta"],
	id?:boolean,
items?: [{	filter?:ValueTypes["SocialLinkItemWhere"] | null,	orderBy?:ValueTypes["SocialLinkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SocialLinkItem"]],
itemsBySocialLink?: [{	by:ValueTypes["SocialLinkListItemsBySocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkItemWhere"] | null},ValueTypes["SocialLinkItem"]],
paginateItems?: [{	filter?:ValueTypes["SocialLinkItemWhere"] | null,	orderBy?:ValueTypes["SocialLinkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SocialLinkItemConnection"]],
		__typename?: boolean
}>;
	["SocialLinkListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["SocialLinkItem"]: AliasType<{
	_meta?:ValueTypes["SocialLinkItemMeta"],
	id?:boolean,
	order?:boolean,
list?: [{	filter?:ValueTypes["SocialLinkListWhere"] | null},ValueTypes["SocialLinkList"]],
socialLink?: [{	filter?:ValueTypes["SocialLinkWhere"] | null},ValueTypes["SocialLink"]],
		__typename?: boolean
}>;
	["SocialLinkItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	socialLink?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["SocialLinkListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["SocialLinkItemWhere"] | null,
	and?:(ValueTypes["SocialLinkListWhere"] | undefined | null)[],
	or?:(ValueTypes["SocialLinkListWhere"] | undefined | null)[],
	not?:ValueTypes["SocialLinkListWhere"] | null
};
	["SocialLinkItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	list?:ValueTypes["SocialLinkListWhere"] | null,
	socialLink?:ValueTypes["SocialLinkWhere"] | null,
	and?:(ValueTypes["SocialLinkItemWhere"] | undefined | null)[],
	or?:(ValueTypes["SocialLinkItemWhere"] | undefined | null)[],
	not?:ValueTypes["SocialLinkItemWhere"] | null
};
	["SocialLinkWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	type?:ValueTypes["SocialLinkTypeCondition"] | null,
	url?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["SocialLinkWhere"] | undefined | null)[],
	or?:(ValueTypes["SocialLinkWhere"] | undefined | null)[],
	not?:ValueTypes["SocialLinkWhere"] | null
};
	["SocialLinkTypeCondition"]: {
	and?:ValueTypes["SocialLinkTypeCondition"][],
	or?:ValueTypes["SocialLinkTypeCondition"][],
	not?:ValueTypes["SocialLinkTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["SocialLinkType"] | null,
	notEq?:ValueTypes["SocialLinkType"] | null,
	in?:ValueTypes["SocialLinkType"][],
	notIn?:ValueTypes["SocialLinkType"][],
	lt?:ValueTypes["SocialLinkType"] | null,
	lte?:ValueTypes["SocialLinkType"] | null,
	gt?:ValueTypes["SocialLinkType"] | null,
	gte?:ValueTypes["SocialLinkType"] | null
};
	["SocialLinkType"]:SocialLinkType;
	["SocialLink"]: AliasType<{
	_meta?:ValueTypes["SocialLinkMeta"],
	id?:boolean,
	type?:boolean,
	url?:boolean,
		__typename?: boolean
}>;
	["SocialLinkMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["SocialLinkItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["SocialLinkListOrderBy"] | null,
	socialLink?:ValueTypes["SocialLinkOrderBy"] | null
};
	["SocialLinkListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["SocialLinkOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["OrderDirection"] | null
};
	["SocialLinkListItemsBySocialLinkUniqueWhere"]: {
	socialLink?:ValueTypes["SocialLinkUniqueWhere"] | null
};
	["SocialLinkUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["SocialLinkItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SocialLinkItemEdge"],
		__typename?: boolean
}>;
	["SocialLinkItemEdge"]: AliasType<{
	node?:ValueTypes["SocialLinkItem"],
		__typename?: boolean
}>;
	["SocialSectionWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	socialLinks?:ValueTypes["SocialLinkListWhere"] | null,
	and?:(ValueTypes["SocialSectionWhere"] | undefined | null)[],
	or?:(ValueTypes["SocialSectionWhere"] | undefined | null)[],
	not?:ValueTypes["SocialSectionWhere"] | null
};
	["NewsletterSection"]: AliasType<{
	_meta?:ValueTypes["NewsletterSectionMeta"],
	id?:boolean,
	title?:boolean,
newsletter?: [{	filter?:ValueTypes["NewsletterWhere"] | null},ValueTypes["Newsletter"]],
		__typename?: boolean
}>;
	["NewsletterSectionMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	newsletter?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Newsletter"]: AliasType<{
	_meta?:ValueTypes["NewsletterMeta"],
	id?:boolean,
	input?:boolean,
	button?:boolean,
		__typename?: boolean
}>;
	["NewsletterMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	input?:ValueTypes["FieldMeta"],
	button?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["NewsletterWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	input?:ValueTypes["StringCondition"] | null,
	button?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["NewsletterWhere"] | undefined | null)[],
	or?:(ValueTypes["NewsletterWhere"] | undefined | null)[],
	not?:ValueTypes["NewsletterWhere"] | null
};
	["NewsletterSectionWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	newsletter?:ValueTypes["NewsletterWhere"] | null,
	and?:(ValueTypes["NewsletterSectionWhere"] | undefined | null)[],
	or?:(ValueTypes["NewsletterSectionWhere"] | undefined | null)[],
	not?:ValueTypes["NewsletterSectionWhere"] | null
};
	["FooterMenuUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["FooterMenuUnique"] | null,
	online?:ValueTypes["OnlineSectionUniqueWhere"] | null,
	links?:ValueTypes["LinkSectionUniqueWhere"] | null,
	linksTwo?:ValueTypes["LinkSectionUniqueWhere"] | null,
	social?:ValueTypes["SocialSectionUniqueWhere"] | null,
	newsletter?:ValueTypes["NewsletterSectionUniqueWhere"] | null
};
	["OnlineSectionUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	appLinks?:ValueTypes["AppLinkListUniqueWhere"] | null,
	links?:ValueTypes["LinkListUniqueWhere"] | null
};
	["AppLinkListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["AppLinkItemUniqueWhere"] | null
};
	["AppLinkItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	appLink?:ValueTypes["AppLinkUniqueWhere"] | null
};
	["LinkListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["LinkItemUniqueWhere"] | null
};
	["LinkItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["LinkSectionUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	links?:ValueTypes["LinkListUniqueWhere"] | null
};
	["SocialSectionUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	socialLinks?:ValueTypes["SocialLinkListUniqueWhere"] | null
};
	["SocialLinkListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["SocialLinkItemUniqueWhere"] | null
};
	["SocialLinkItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	socialLink?:ValueTypes["SocialLinkUniqueWhere"] | null
};
	["NewsletterSectionUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	newsletter?:ValueTypes["NewsletterUniqueWhere"] | null
};
	["NewsletterUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["FooterMenuWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["FooterMenuUniqueCondition"] | null,
	copyright?:ValueTypes["StringCondition"] | null,
	online?:ValueTypes["OnlineSectionWhere"] | null,
	links?:ValueTypes["LinkSectionWhere"] | null,
	linksTwo?:ValueTypes["LinkSectionWhere"] | null,
	social?:ValueTypes["SocialSectionWhere"] | null,
	newsletter?:ValueTypes["NewsletterSectionWhere"] | null,
	and?:(ValueTypes["FooterMenuWhere"] | undefined | null)[],
	or?:(ValueTypes["FooterMenuWhere"] | undefined | null)[],
	not?:ValueTypes["FooterMenuWhere"] | null
};
	["FooterMenuUniqueCondition"]: {
	and?:ValueTypes["FooterMenuUniqueCondition"][],
	or?:ValueTypes["FooterMenuUniqueCondition"][],
	not?:ValueTypes["FooterMenuUniqueCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["FooterMenuUnique"] | null,
	notEq?:ValueTypes["FooterMenuUnique"] | null,
	in?:ValueTypes["FooterMenuUnique"][],
	notIn?:ValueTypes["FooterMenuUnique"][],
	lt?:ValueTypes["FooterMenuUnique"] | null,
	lte?:ValueTypes["FooterMenuUnique"] | null,
	gt?:ValueTypes["FooterMenuUnique"] | null,
	gte?:ValueTypes["FooterMenuUnique"] | null
};
	["FooterMenuOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	copyright?:ValueTypes["OrderDirection"] | null,
	online?:ValueTypes["OnlineSectionOrderBy"] | null,
	links?:ValueTypes["LinkSectionOrderBy"] | null,
	linksTwo?:ValueTypes["LinkSectionOrderBy"] | null,
	social?:ValueTypes["SocialSectionOrderBy"] | null,
	newsletter?:ValueTypes["NewsletterSectionOrderBy"] | null
};
	["OnlineSectionOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	appLinks?:ValueTypes["AppLinkListOrderBy"] | null,
	links?:ValueTypes["LinkListOrderBy"] | null
};
	["LinkSectionOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	links?:ValueTypes["LinkListOrderBy"] | null
};
	["SocialSectionOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	socialLinks?:ValueTypes["SocialLinkListOrderBy"] | null
};
	["NewsletterSectionOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	newsletter?:ValueTypes["NewsletterOrderBy"] | null
};
	["NewsletterOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	input?:ValueTypes["OrderDirection"] | null,
	button?:ValueTypes["OrderDirection"] | null
};
	["FooterMenuConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FooterMenuEdge"],
		__typename?: boolean
}>;
	["FooterMenuEdge"]: AliasType<{
	node?:ValueTypes["FooterMenu"],
		__typename?: boolean
}>;
	["FooterMenuCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["FooterMenuUnique"] | null,
	copyright?:string | null,
	online?:ValueTypes["FooterMenuCreateOnlineEntityRelationInput"] | null,
	links?:ValueTypes["FooterMenuCreateLinksEntityRelationInput"] | null,
	linksTwo?:ValueTypes["FooterMenuCreateLinksTwoEntityRelationInput"] | null,
	social?:ValueTypes["FooterMenuCreateSocialEntityRelationInput"] | null,
	newsletter?:ValueTypes["FooterMenuCreateNewsletterEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FooterMenuCreateOnlineEntityRelationInput"]: {
	connect?:ValueTypes["OnlineSectionUniqueWhere"] | null,
	create?:ValueTypes["OnlineSectionCreateInput"] | null
};
	["OnlineSectionCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	appLinks?:ValueTypes["OnlineSectionCreateAppLinksEntityRelationInput"] | null,
	links?:ValueTypes["OnlineSectionCreateLinksEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["OnlineSectionCreateAppLinksEntityRelationInput"]: {
	connect?:ValueTypes["AppLinkListUniqueWhere"] | null,
	create?:ValueTypes["AppLinkListCreateInput"] | null
};
	["AppLinkListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["AppLinkListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["AppLinkListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["AppLinkItemUniqueWhere"] | null,
	create?:ValueTypes["AppLinkItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["AppLinkItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	appLink?:ValueTypes["AppLinkItemCreateAppLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["AppLinkItemCreateAppLinkEntityRelationInput"]: {
	connect?:ValueTypes["AppLinkUniqueWhere"] | null,
	create?:ValueTypes["AppLinkCreateInput"] | null
};
	["AppLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["AppLinkType"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["OnlineSectionCreateLinksEntityRelationInput"]: {
	connect?:ValueTypes["LinkListUniqueWhere"] | null,
	create?:ValueTypes["LinkListCreateInput"] | null
};
	["LinkListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["LinkListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LinkListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["LinkItemUniqueWhere"] | null,
	create?:ValueTypes["LinkItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["LinkItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	link?:ValueTypes["LinkItemCreateLinkEntityRelationInput"] | null,
	title?:string | null,
	_dummy_field_?:boolean | null
};
	["LinkItemCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["FooterMenuCreateLinksEntityRelationInput"]: {
	connect?:ValueTypes["LinkSectionUniqueWhere"] | null,
	create?:ValueTypes["LinkSectionCreateInput"] | null
};
	["LinkSectionCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	links?:ValueTypes["LinkSectionCreateLinksEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkSectionCreateLinksEntityRelationInput"]: {
	connect?:ValueTypes["LinkListUniqueWhere"] | null,
	create?:ValueTypes["LinkListCreateInput"] | null
};
	["FooterMenuCreateLinksTwoEntityRelationInput"]: {
	connect?:ValueTypes["LinkSectionUniqueWhere"] | null,
	create?:ValueTypes["LinkSectionCreateInput"] | null
};
	["FooterMenuCreateSocialEntityRelationInput"]: {
	connect?:ValueTypes["SocialSectionUniqueWhere"] | null,
	create?:ValueTypes["SocialSectionCreateInput"] | null
};
	["SocialSectionCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	socialLinks?:ValueTypes["SocialSectionCreateSocialLinksEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SocialSectionCreateSocialLinksEntityRelationInput"]: {
	connect?:ValueTypes["SocialLinkListUniqueWhere"] | null,
	create?:ValueTypes["SocialLinkListCreateInput"] | null
};
	["SocialLinkListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["SocialLinkListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["SocialLinkListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["SocialLinkItemUniqueWhere"] | null,
	create?:ValueTypes["SocialLinkItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["SocialLinkItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	socialLink?:ValueTypes["SocialLinkItemCreateSocialLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SocialLinkItemCreateSocialLinkEntityRelationInput"]: {
	connect?:ValueTypes["SocialLinkUniqueWhere"] | null,
	create?:ValueTypes["SocialLinkCreateInput"] | null
};
	["SocialLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["SocialLinkType"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["FooterMenuCreateNewsletterEntityRelationInput"]: {
	connect?:ValueTypes["NewsletterSectionUniqueWhere"] | null,
	create?:ValueTypes["NewsletterSectionCreateInput"] | null
};
	["NewsletterSectionCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	newsletter?:ValueTypes["NewsletterSectionCreateNewsletterEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["NewsletterSectionCreateNewsletterEntityRelationInput"]: {
	connect?:ValueTypes["NewsletterUniqueWhere"] | null,
	create?:ValueTypes["NewsletterCreateInput"] | null
};
	["NewsletterCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	input?:string | null,
	button?:string | null,
	_dummy_field_?:boolean | null
};
	["FooterMenuUpdateInput"]: {
	unique?:ValueTypes["FooterMenuUnique"] | null,
	copyright?:string | null,
	online?:ValueTypes["FooterMenuUpdateOnlineEntityRelationInput"] | null,
	links?:ValueTypes["FooterMenuUpdateLinksEntityRelationInput"] | null,
	linksTwo?:ValueTypes["FooterMenuUpdateLinksTwoEntityRelationInput"] | null,
	social?:ValueTypes["FooterMenuUpdateSocialEntityRelationInput"] | null,
	newsletter?:ValueTypes["FooterMenuUpdateNewsletterEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FooterMenuUpdateOnlineEntityRelationInput"]: {
	create?:ValueTypes["OnlineSectionCreateInput"] | null,
	update?:ValueTypes["OnlineSectionUpdateInput"] | null,
	upsert?:ValueTypes["FooterMenuUpsertOnlineRelationInput"] | null,
	connect?:ValueTypes["OnlineSectionUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["OnlineSectionUpdateInput"]: {
	title?:string | null,
	appLinks?:ValueTypes["OnlineSectionUpdateAppLinksEntityRelationInput"] | null,
	links?:ValueTypes["OnlineSectionUpdateLinksEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["OnlineSectionUpdateAppLinksEntityRelationInput"]: {
	create?:ValueTypes["AppLinkListCreateInput"] | null,
	update?:ValueTypes["AppLinkListUpdateInput"] | null,
	upsert?:ValueTypes["OnlineSectionUpsertAppLinksRelationInput"] | null,
	connect?:ValueTypes["AppLinkListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["AppLinkListUpdateInput"]: {
	items?:ValueTypes["AppLinkListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["AppLinkListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["AppLinkItemWithoutListCreateInput"] | null,
	update?:ValueTypes["AppLinkListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["AppLinkListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["AppLinkItemUniqueWhere"] | null,
	disconnect?:ValueTypes["AppLinkItemUniqueWhere"] | null,
	delete?:ValueTypes["AppLinkItemUniqueWhere"] | null,
	alias?:string | null
};
	["AppLinkListUpdateItemsRelationInput"]: {
	by?:ValueTypes["AppLinkItemUniqueWhere"] | null,
	data?:ValueTypes["AppLinkItemWithoutListUpdateInput"] | null
};
	["AppLinkItemWithoutListUpdateInput"]: {
	order?:number | null,
	appLink?:ValueTypes["AppLinkItemUpdateAppLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["AppLinkItemUpdateAppLinkEntityRelationInput"]: {
	create?:ValueTypes["AppLinkCreateInput"] | null,
	update?:ValueTypes["AppLinkUpdateInput"] | null,
	upsert?:ValueTypes["AppLinkItemUpsertAppLinkRelationInput"] | null,
	connect?:ValueTypes["AppLinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["AppLinkUpdateInput"]: {
	type?:ValueTypes["AppLinkType"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["AppLinkItemUpsertAppLinkRelationInput"]: {
	update?:ValueTypes["AppLinkUpdateInput"] | null,
	create?:ValueTypes["AppLinkCreateInput"] | null
};
	["AppLinkListUpsertItemsRelationInput"]: {
	by?:ValueTypes["AppLinkItemUniqueWhere"] | null,
	update?:ValueTypes["AppLinkItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["AppLinkItemWithoutListCreateInput"] | null
};
	["OnlineSectionUpsertAppLinksRelationInput"]: {
	update?:ValueTypes["AppLinkListUpdateInput"] | null,
	create?:ValueTypes["AppLinkListCreateInput"] | null
};
	["OnlineSectionUpdateLinksEntityRelationInput"]: {
	create?:ValueTypes["LinkListCreateInput"] | null,
	update?:ValueTypes["LinkListUpdateInput"] | null,
	upsert?:ValueTypes["OnlineSectionUpsertLinksRelationInput"] | null,
	connect?:ValueTypes["LinkListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkListUpdateInput"]: {
	items?:ValueTypes["LinkListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LinkListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["LinkItemWithoutListCreateInput"] | null,
	update?:ValueTypes["LinkListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["LinkListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["LinkItemUniqueWhere"] | null,
	disconnect?:ValueTypes["LinkItemUniqueWhere"] | null,
	delete?:ValueTypes["LinkItemUniqueWhere"] | null,
	alias?:string | null
};
	["LinkListUpdateItemsRelationInput"]: {
	by?:ValueTypes["LinkItemUniqueWhere"] | null,
	data?:ValueTypes["LinkItemWithoutListUpdateInput"] | null
};
	["LinkItemWithoutListUpdateInput"]: {
	order?:number | null,
	link?:ValueTypes["LinkItemUpdateLinkEntityRelationInput"] | null,
	title?:string | null,
	_dummy_field_?:boolean | null
};
	["LinkItemUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkItemUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkItemUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["LinkListUpsertItemsRelationInput"]: {
	by?:ValueTypes["LinkItemUniqueWhere"] | null,
	update?:ValueTypes["LinkItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["LinkItemWithoutListCreateInput"] | null
};
	["OnlineSectionUpsertLinksRelationInput"]: {
	update?:ValueTypes["LinkListUpdateInput"] | null,
	create?:ValueTypes["LinkListCreateInput"] | null
};
	["FooterMenuUpsertOnlineRelationInput"]: {
	update?:ValueTypes["OnlineSectionUpdateInput"] | null,
	create?:ValueTypes["OnlineSectionCreateInput"] | null
};
	["FooterMenuUpdateLinksEntityRelationInput"]: {
	create?:ValueTypes["LinkSectionCreateInput"] | null,
	update?:ValueTypes["LinkSectionUpdateInput"] | null,
	upsert?:ValueTypes["FooterMenuUpsertLinksRelationInput"] | null,
	connect?:ValueTypes["LinkSectionUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkSectionUpdateInput"]: {
	title?:string | null,
	links?:ValueTypes["LinkSectionUpdateLinksEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkSectionUpdateLinksEntityRelationInput"]: {
	create?:ValueTypes["LinkListCreateInput"] | null,
	update?:ValueTypes["LinkListUpdateInput"] | null,
	upsert?:ValueTypes["LinkSectionUpsertLinksRelationInput"] | null,
	connect?:ValueTypes["LinkListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkSectionUpsertLinksRelationInput"]: {
	update?:ValueTypes["LinkListUpdateInput"] | null,
	create?:ValueTypes["LinkListCreateInput"] | null
};
	["FooterMenuUpsertLinksRelationInput"]: {
	update?:ValueTypes["LinkSectionUpdateInput"] | null,
	create?:ValueTypes["LinkSectionCreateInput"] | null
};
	["FooterMenuUpdateLinksTwoEntityRelationInput"]: {
	create?:ValueTypes["LinkSectionCreateInput"] | null,
	update?:ValueTypes["LinkSectionUpdateInput"] | null,
	upsert?:ValueTypes["FooterMenuUpsertLinksTwoRelationInput"] | null,
	connect?:ValueTypes["LinkSectionUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FooterMenuUpsertLinksTwoRelationInput"]: {
	update?:ValueTypes["LinkSectionUpdateInput"] | null,
	create?:ValueTypes["LinkSectionCreateInput"] | null
};
	["FooterMenuUpdateSocialEntityRelationInput"]: {
	create?:ValueTypes["SocialSectionCreateInput"] | null,
	update?:ValueTypes["SocialSectionUpdateInput"] | null,
	upsert?:ValueTypes["FooterMenuUpsertSocialRelationInput"] | null,
	connect?:ValueTypes["SocialSectionUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SocialSectionUpdateInput"]: {
	title?:string | null,
	socialLinks?:ValueTypes["SocialSectionUpdateSocialLinksEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SocialSectionUpdateSocialLinksEntityRelationInput"]: {
	create?:ValueTypes["SocialLinkListCreateInput"] | null,
	update?:ValueTypes["SocialLinkListUpdateInput"] | null,
	upsert?:ValueTypes["SocialSectionUpsertSocialLinksRelationInput"] | null,
	connect?:ValueTypes["SocialLinkListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SocialLinkListUpdateInput"]: {
	items?:ValueTypes["SocialLinkListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["SocialLinkListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["SocialLinkItemWithoutListCreateInput"] | null,
	update?:ValueTypes["SocialLinkListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["SocialLinkListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["SocialLinkItemUniqueWhere"] | null,
	disconnect?:ValueTypes["SocialLinkItemUniqueWhere"] | null,
	delete?:ValueTypes["SocialLinkItemUniqueWhere"] | null,
	alias?:string | null
};
	["SocialLinkListUpdateItemsRelationInput"]: {
	by?:ValueTypes["SocialLinkItemUniqueWhere"] | null,
	data?:ValueTypes["SocialLinkItemWithoutListUpdateInput"] | null
};
	["SocialLinkItemWithoutListUpdateInput"]: {
	order?:number | null,
	socialLink?:ValueTypes["SocialLinkItemUpdateSocialLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SocialLinkItemUpdateSocialLinkEntityRelationInput"]: {
	create?:ValueTypes["SocialLinkCreateInput"] | null,
	update?:ValueTypes["SocialLinkUpdateInput"] | null,
	upsert?:ValueTypes["SocialLinkItemUpsertSocialLinkRelationInput"] | null,
	connect?:ValueTypes["SocialLinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SocialLinkUpdateInput"]: {
	type?:ValueTypes["SocialLinkType"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["SocialLinkItemUpsertSocialLinkRelationInput"]: {
	update?:ValueTypes["SocialLinkUpdateInput"] | null,
	create?:ValueTypes["SocialLinkCreateInput"] | null
};
	["SocialLinkListUpsertItemsRelationInput"]: {
	by?:ValueTypes["SocialLinkItemUniqueWhere"] | null,
	update?:ValueTypes["SocialLinkItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["SocialLinkItemWithoutListCreateInput"] | null
};
	["SocialSectionUpsertSocialLinksRelationInput"]: {
	update?:ValueTypes["SocialLinkListUpdateInput"] | null,
	create?:ValueTypes["SocialLinkListCreateInput"] | null
};
	["FooterMenuUpsertSocialRelationInput"]: {
	update?:ValueTypes["SocialSectionUpdateInput"] | null,
	create?:ValueTypes["SocialSectionCreateInput"] | null
};
	["FooterMenuUpdateNewsletterEntityRelationInput"]: {
	create?:ValueTypes["NewsletterSectionCreateInput"] | null,
	update?:ValueTypes["NewsletterSectionUpdateInput"] | null,
	upsert?:ValueTypes["FooterMenuUpsertNewsletterRelationInput"] | null,
	connect?:ValueTypes["NewsletterSectionUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["NewsletterSectionUpdateInput"]: {
	title?:string | null,
	newsletter?:ValueTypes["NewsletterSectionUpdateNewsletterEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["NewsletterSectionUpdateNewsletterEntityRelationInput"]: {
	create?:ValueTypes["NewsletterCreateInput"] | null,
	update?:ValueTypes["NewsletterUpdateInput"] | null,
	upsert?:ValueTypes["NewsletterSectionUpsertNewsletterRelationInput"] | null,
	connect?:ValueTypes["NewsletterUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["NewsletterUpdateInput"]: {
	input?:string | null,
	button?:string | null,
	_dummy_field_?:boolean | null
};
	["NewsletterSectionUpsertNewsletterRelationInput"]: {
	update?:ValueTypes["NewsletterUpdateInput"] | null,
	create?:ValueTypes["NewsletterCreateInput"] | null
};
	["FooterMenuUpsertNewsletterRelationInput"]: {
	update?:ValueTypes["NewsletterSectionUpdateInput"] | null,
	create?:ValueTypes["NewsletterSectionCreateInput"] | null
};
	["LinkSectionConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkSectionEdge"],
		__typename?: boolean
}>;
	["LinkSectionEdge"]: AliasType<{
	node?:ValueTypes["LinkSection"],
		__typename?: boolean
}>;
	["LinkListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkListEdge"],
		__typename?: boolean
}>;
	["LinkListEdge"]: AliasType<{
	node?:ValueTypes["LinkList"],
		__typename?: boolean
}>;
	["LinkItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	list?:ValueTypes["LinkItemCreateListEntityRelationInput"] | null,
	link?:ValueTypes["LinkItemCreateLinkEntityRelationInput"] | null,
	title?:string | null,
	_dummy_field_?:boolean | null
};
	["LinkItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["LinkListUniqueWhere"] | null,
	create?:ValueTypes["LinkListWithoutItemsCreateInput"] | null
};
	["LinkListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["LinkItemUpdateInput"]: {
	order?:number | null,
	list?:ValueTypes["LinkItemUpdateListEntityRelationInput"] | null,
	link?:ValueTypes["LinkItemUpdateLinkEntityRelationInput"] | null,
	title?:string | null,
	_dummy_field_?:boolean | null
};
	["LinkItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["LinkListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["LinkListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["LinkItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["LinkListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkListWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["LinkItemUpsertListRelationInput"]: {
	update?:ValueTypes["LinkListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["LinkListWithoutItemsCreateInput"] | null
};
	["NewsletterSectionConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["NewsletterSectionEdge"],
		__typename?: boolean
}>;
	["NewsletterSectionEdge"]: AliasType<{
	node?:ValueTypes["NewsletterSection"],
		__typename?: boolean
}>;
	["NewsletterConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["NewsletterEdge"],
		__typename?: boolean
}>;
	["NewsletterEdge"]: AliasType<{
	node?:ValueTypes["Newsletter"],
		__typename?: boolean
}>;
	["OnlineSectionConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["OnlineSectionEdge"],
		__typename?: boolean
}>;
	["OnlineSectionEdge"]: AliasType<{
	node?:ValueTypes["OnlineSection"],
		__typename?: boolean
}>;
	["AppLinkConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["AppLinkEdge"],
		__typename?: boolean
}>;
	["AppLinkEdge"]: AliasType<{
	node?:ValueTypes["AppLink"],
		__typename?: boolean
}>;
	["AppLinkListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["AppLinkListEdge"],
		__typename?: boolean
}>;
	["AppLinkListEdge"]: AliasType<{
	node?:ValueTypes["AppLinkList"],
		__typename?: boolean
}>;
	["AppLinkItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	list?:ValueTypes["AppLinkItemCreateListEntityRelationInput"] | null,
	appLink?:ValueTypes["AppLinkItemCreateAppLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["AppLinkItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["AppLinkListUniqueWhere"] | null,
	create?:ValueTypes["AppLinkListWithoutItemsCreateInput"] | null
};
	["AppLinkListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["AppLinkItemUpdateInput"]: {
	order?:number | null,
	list?:ValueTypes["AppLinkItemUpdateListEntityRelationInput"] | null,
	appLink?:ValueTypes["AppLinkItemUpdateAppLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["AppLinkItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["AppLinkListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["AppLinkListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["AppLinkItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["AppLinkListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["AppLinkListWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["AppLinkItemUpsertListRelationInput"]: {
	update?:ValueTypes["AppLinkListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["AppLinkListWithoutItemsCreateInput"] | null
};
	["SocialSectionConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SocialSectionEdge"],
		__typename?: boolean
}>;
	["SocialSectionEdge"]: AliasType<{
	node?:ValueTypes["SocialSection"],
		__typename?: boolean
}>;
	["SocialLinkConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SocialLinkEdge"],
		__typename?: boolean
}>;
	["SocialLinkEdge"]: AliasType<{
	node?:ValueTypes["SocialLink"],
		__typename?: boolean
}>;
	["SocialLinkListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SocialLinkListEdge"],
		__typename?: boolean
}>;
	["SocialLinkListEdge"]: AliasType<{
	node?:ValueTypes["SocialLinkList"],
		__typename?: boolean
}>;
	["SocialLinkItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	list?:ValueTypes["SocialLinkItemCreateListEntityRelationInput"] | null,
	socialLink?:ValueTypes["SocialLinkItemCreateSocialLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SocialLinkItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["SocialLinkListUniqueWhere"] | null,
	create?:ValueTypes["SocialLinkListWithoutItemsCreateInput"] | null
};
	["SocialLinkListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["SocialLinkItemUpdateInput"]: {
	order?:number | null,
	list?:ValueTypes["SocialLinkItemUpdateListEntityRelationInput"] | null,
	socialLink?:ValueTypes["SocialLinkItemUpdateSocialLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SocialLinkItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["SocialLinkListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["SocialLinkListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["SocialLinkItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["SocialLinkListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SocialLinkListWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["SocialLinkItemUpsertListRelationInput"]: {
	update?:ValueTypes["SocialLinkListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["SocialLinkListWithoutItemsCreateInput"] | null
};
	["SharedContentConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SharedContentEdge"],
		__typename?: boolean
}>;
	["SharedContentEdge"]: AliasType<{
	node?:ValueTypes["SharedContent"],
		__typename?: boolean
}>;
	["SharedContentCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	contentReference?:ValueTypes["SharedContentCreateContentReferenceEntityRelationInput"][],
	content?:ValueTypes["SharedContentCreateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SharedContentCreateContentReferenceEntityRelationInput"]: {
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	create?:ValueTypes["ContentReferenceWithoutSharedContentCreateInput"] | null,
	alias?:string | null
};
	["ContentReferenceWithoutSharedContentCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ContentReferenceType"] | null,
	contentPart?:ValueTypes["ContentReferenceCreateContentPartEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	variant?:ValueTypes["ContentReferenceVariant"] | null,
	color?:string | null,
	embed?:ValueTypes["ContentReferenceCreateEmbedEntityRelationInput"] | null,
	article?:ValueTypes["ContentReferenceCreateArticleEntityRelationInput"] | null,
	audio?:ValueTypes["ContentReferenceCreateAudioEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceCreateImageEntityRelationInput"] | null,
	images?:ValueTypes["ContentReferenceCreateImagesEntityRelationInput"][],
	pollAnswer?:ValueTypes["ContentReferenceCreatePollAnswerEntityRelationInput"] | null,
	listicle?:ValueTypes["ContentReferenceCreateListicleEntityRelationInput"][],
	faq?:ValueTypes["ContentReferenceCreateFaqEntityRelationInput"][],
	links?:ValueTypes["ContentReferenceCreateLinksEntityRelationInput"][],
	awards?:ValueTypes["ContentReferenceCreateAwardsEntityRelationInput"][],
	reviews?:ValueTypes["ContentReferenceCreateReviewsEntityRelationInput"][],
	target?:ValueTypes["ContentReferenceCreateTargetEntityRelationInput"] | null,
	subscriptionForm?:ValueTypes["ContentReferenceCreateSubscriptionFormEntityRelationInput"] | null,
	buttons?:ValueTypes["ContentReferenceCreateButtonsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["SharedContentUpdateInput"]: {
	name?:string | null,
	contentReference?:ValueTypes["SharedContentUpdateContentReferenceEntityRelationInput"][],
	content?:ValueTypes["SharedContentUpdateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SharedContentUpdateContentReferenceEntityRelationInput"]: {
	create?:ValueTypes["ContentReferenceWithoutSharedContentCreateInput"] | null,
	update?:ValueTypes["SharedContentUpdateContentReferenceRelationInput"] | null,
	upsert?:ValueTypes["SharedContentUpsertContentReferenceRelationInput"] | null,
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	disconnect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	delete?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	alias?:string | null
};
	["SharedContentUpdateContentReferenceRelationInput"]: {
	by?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	data?:ValueTypes["ContentReferenceWithoutSharedContentUpdateInput"] | null
};
	["ContentReferenceWithoutSharedContentUpdateInput"]: {
	type?:ValueTypes["ContentReferenceType"] | null,
	contentPart?:ValueTypes["ContentReferenceUpdateContentPartEntityRelationInput"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	variant?:ValueTypes["ContentReferenceVariant"] | null,
	color?:string | null,
	embed?:ValueTypes["ContentReferenceUpdateEmbedEntityRelationInput"] | null,
	article?:ValueTypes["ContentReferenceUpdateArticleEntityRelationInput"] | null,
	audio?:ValueTypes["ContentReferenceUpdateAudioEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceUpdateImageEntityRelationInput"] | null,
	images?:ValueTypes["ContentReferenceUpdateImagesEntityRelationInput"][],
	pollAnswer?:ValueTypes["ContentReferenceUpdatePollAnswerEntityRelationInput"] | null,
	listicle?:ValueTypes["ContentReferenceUpdateListicleEntityRelationInput"][],
	faq?:ValueTypes["ContentReferenceUpdateFaqEntityRelationInput"][],
	links?:ValueTypes["ContentReferenceUpdateLinksEntityRelationInput"][],
	awards?:ValueTypes["ContentReferenceUpdateAwardsEntityRelationInput"][],
	reviews?:ValueTypes["ContentReferenceUpdateReviewsEntityRelationInput"][],
	target?:ValueTypes["ContentReferenceUpdateTargetEntityRelationInput"] | null,
	subscriptionForm?:ValueTypes["ContentReferenceUpdateSubscriptionFormEntityRelationInput"] | null,
	buttons?:ValueTypes["ContentReferenceUpdateButtonsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["SharedContentUpsertContentReferenceRelationInput"]: {
	by?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	update?:ValueTypes["ContentReferenceWithoutSharedContentUpdateInput"] | null,
	create?:ValueTypes["ContentReferenceWithoutSharedContentCreateInput"] | null
};
	["QueryTransaction"]: AliasType<{
getArticle?: [{	by:ValueTypes["ArticleUniqueWhere"],	filter?:ValueTypes["ArticleWhere"] | null},ValueTypes["Article"]],
listArticle?: [{	filter?:ValueTypes["ArticleWhere"] | null,	orderBy?:ValueTypes["ArticleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Article"]],
paginateArticle?: [{	filter?:ValueTypes["ArticleWhere"] | null,	orderBy?:ValueTypes["ArticleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArticleConnection"]],
validateCreateArticle?: [{	data:ValueTypes["ArticleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateArticle?: [{	by:ValueTypes["ArticleUniqueWhere"],	data:ValueTypes["ArticleUpdateInput"]},ValueTypes["_ValidationResult"]],
getArticleAuthor?: [{	by:ValueTypes["ArticleAuthorUniqueWhere"],	filter?:ValueTypes["ArticleAuthorWhere"] | null},ValueTypes["ArticleAuthor"]],
listArticleAuthor?: [{	filter?:ValueTypes["ArticleAuthorWhere"] | null,	orderBy?:ValueTypes["ArticleAuthorOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArticleAuthor"]],
paginateArticleAuthor?: [{	filter?:ValueTypes["ArticleAuthorWhere"] | null,	orderBy?:ValueTypes["ArticleAuthorOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArticleAuthorConnection"]],
validateCreateArticleAuthor?: [{	data:ValueTypes["ArticleAuthorCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateArticleAuthor?: [{	by:ValueTypes["ArticleAuthorUniqueWhere"],	data:ValueTypes["ArticleAuthorUpdateInput"]},ValueTypes["_ValidationResult"]],
getAuthor?: [{	by:ValueTypes["AuthorUniqueWhere"],	filter?:ValueTypes["AuthorWhere"] | null},ValueTypes["Author"]],
listAuthor?: [{	filter?:ValueTypes["AuthorWhere"] | null,	orderBy?:ValueTypes["AuthorOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Author"]],
paginateAuthor?: [{	filter?:ValueTypes["AuthorWhere"] | null,	orderBy?:ValueTypes["AuthorOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AuthorConnection"]],
validateCreateAuthor?: [{	data:ValueTypes["AuthorCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateAuthor?: [{	by:ValueTypes["AuthorUniqueWhere"],	data:ValueTypes["AuthorUpdateInput"]},ValueTypes["_ValidationResult"]],
getAuthorTopArticle?: [{	by:ValueTypes["AuthorTopArticleUniqueWhere"],	filter?:ValueTypes["AuthorTopArticleWhere"] | null},ValueTypes["AuthorTopArticle"]],
listAuthorTopArticle?: [{	filter?:ValueTypes["AuthorTopArticleWhere"] | null,	orderBy?:ValueTypes["AuthorTopArticleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["AuthorTopArticle"]],
paginateAuthorTopArticle?: [{	filter?:ValueTypes["AuthorTopArticleWhere"] | null,	orderBy?:ValueTypes["AuthorTopArticleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AuthorTopArticleConnection"]],
validateCreateAuthorTopArticle?: [{	data:ValueTypes["AuthorTopArticleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateAuthorTopArticle?: [{	by:ValueTypes["AuthorTopArticleUniqueWhere"],	data:ValueTypes["AuthorTopArticleUpdateInput"]},ValueTypes["_ValidationResult"]],
getContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
listContent?: [{	filter?:ValueTypes["ContentWhere"] | null,	orderBy?:ValueTypes["ContentOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Content"]],
paginateContent?: [{	filter?:ValueTypes["ContentWhere"] | null,	orderBy?:ValueTypes["ContentOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentConnection"]],
validateCreateContent?: [{	data:ValueTypes["ContentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContent?: [{	by:ValueTypes["ContentUniqueWhere"],	data:ValueTypes["ContentUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentPart?: [{	by:ValueTypes["ContentPartUniqueWhere"],	filter?:ValueTypes["ContentPartWhere"] | null},ValueTypes["ContentPart"]],
listContentPart?: [{	filter?:ValueTypes["ContentPartWhere"] | null,	orderBy?:ValueTypes["ContentPartOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentPart"]],
paginateContentPart?: [{	filter?:ValueTypes["ContentPartWhere"] | null,	orderBy?:ValueTypes["ContentPartOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentPartConnection"]],
validateCreateContentPart?: [{	data:ValueTypes["ContentPartCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentPart?: [{	by:ValueTypes["ContentPartUniqueWhere"],	data:ValueTypes["ContentPartUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
listContentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentReference"]],
paginateContentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentReferenceConnection"]],
validateCreateContentReference?: [{	data:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	data:ValueTypes["ContentReferenceUpdateInput"]},ValueTypes["_ValidationResult"]],
getHomepageArticle?: [{	by:ValueTypes["HomepageArticleUniqueWhere"],	filter?:ValueTypes["HomepageArticleWhere"] | null},ValueTypes["HomepageArticle"]],
listHomepageArticle?: [{	filter?:ValueTypes["HomepageArticleWhere"] | null,	orderBy?:ValueTypes["HomepageArticleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HomepageArticle"]],
paginateHomepageArticle?: [{	filter?:ValueTypes["HomepageArticleWhere"] | null,	orderBy?:ValueTypes["HomepageArticleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HomepageArticleConnection"]],
validateCreateHomepageArticle?: [{	data:ValueTypes["HomepageArticleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHomepageArticle?: [{	by:ValueTypes["HomepageArticleUniqueWhere"],	data:ValueTypes["HomepageArticleUpdateInput"]},ValueTypes["_ValidationResult"]],
getImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
listImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Image"]],
paginateImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageConnection"]],
validateCreateImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	data:ValueTypes["ImageUpdateInput"]},ValueTypes["_ValidationResult"]],
getImageUse?: [{	by:ValueTypes["ImageUseUniqueWhere"],	filter?:ValueTypes["ImageUseWhere"] | null},ValueTypes["ImageUse"]],
listImageUse?: [{	filter?:ValueTypes["ImageUseWhere"] | null,	orderBy?:ValueTypes["ImageUseOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ImageUse"]],
paginateImageUse?: [{	filter?:ValueTypes["ImageUseWhere"] | null,	orderBy?:ValueTypes["ImageUseOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageUseConnection"]],
validateCreateImageUse?: [{	data:ValueTypes["ImageUseCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImageUse?: [{	by:ValueTypes["ImageUseUniqueWhere"],	data:ValueTypes["ImageUseUpdateInput"]},ValueTypes["_ValidationResult"]],
getImageTag?: [{	by:ValueTypes["ImageTagUniqueWhere"],	filter?:ValueTypes["ImageTagWhere"] | null},ValueTypes["ImageTag"]],
listImageTag?: [{	filter?:ValueTypes["ImageTagWhere"] | null,	orderBy?:ValueTypes["ImageTagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ImageTag"]],
paginateImageTag?: [{	filter?:ValueTypes["ImageTagWhere"] | null,	orderBy?:ValueTypes["ImageTagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageTagConnection"]],
validateCreateImageTag?: [{	data:ValueTypes["ImageTagCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImageTag?: [{	by:ValueTypes["ImageTagUniqueWhere"],	data:ValueTypes["ImageTagUpdateInput"]},ValueTypes["_ValidationResult"]],
getIssue?: [{	by:ValueTypes["IssueUniqueWhere"],	filter?:ValueTypes["IssueWhere"] | null},ValueTypes["Issue"]],
listIssue?: [{	filter?:ValueTypes["IssueWhere"] | null,	orderBy?:ValueTypes["IssueOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Issue"]],
paginateIssue?: [{	filter?:ValueTypes["IssueWhere"] | null,	orderBy?:ValueTypes["IssueOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["IssueConnection"]],
validateCreateIssue?: [{	data:ValueTypes["IssueCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateIssue?: [{	by:ValueTypes["IssueUniqueWhere"],	data:ValueTypes["IssueUpdateInput"]},ValueTypes["_ValidationResult"]],
getIssueArticle?: [{	by:ValueTypes["IssueArticleUniqueWhere"],	filter?:ValueTypes["IssueArticleWhere"] | null},ValueTypes["IssueArticle"]],
listIssueArticle?: [{	filter?:ValueTypes["IssueArticleWhere"] | null,	orderBy?:ValueTypes["IssueArticleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["IssueArticle"]],
paginateIssueArticle?: [{	filter?:ValueTypes["IssueArticleWhere"] | null,	orderBy?:ValueTypes["IssueArticleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["IssueArticleConnection"]],
validateCreateIssueArticle?: [{	data:ValueTypes["IssueArticleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateIssueArticle?: [{	by:ValueTypes["IssueArticleUniqueWhere"],	data:ValueTypes["IssueArticleUpdateInput"]},ValueTypes["_ValidationResult"]],
getLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
listLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Link"]],
paginateLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkConnection"]],
validateCreateLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	data:ValueTypes["LinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getTextContent?: [{	by:ValueTypes["TextContentUniqueWhere"],	filter?:ValueTypes["TextContentWhere"] | null},ValueTypes["TextContent"]],
listTextContent?: [{	filter?:ValueTypes["TextContentWhere"] | null,	orderBy?:ValueTypes["TextContentOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TextContent"]],
paginateTextContent?: [{	filter?:ValueTypes["TextContentWhere"] | null,	orderBy?:ValueTypes["TextContentOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TextContentConnection"]],
validateCreateTextContent?: [{	data:ValueTypes["TextContentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTextContent?: [{	by:ValueTypes["TextContentUniqueWhere"],	data:ValueTypes["TextContentUpdateInput"]},ValueTypes["_ValidationResult"]],
getTextContentPart?: [{	by:ValueTypes["TextContentPartUniqueWhere"],	filter?:ValueTypes["TextContentPartWhere"] | null},ValueTypes["TextContentPart"]],
listTextContentPart?: [{	filter?:ValueTypes["TextContentPartWhere"] | null,	orderBy?:ValueTypes["TextContentPartOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TextContentPart"]],
paginateTextContentPart?: [{	filter?:ValueTypes["TextContentPartWhere"] | null,	orderBy?:ValueTypes["TextContentPartOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TextContentPartConnection"]],
validateCreateTextContentPart?: [{	data:ValueTypes["TextContentPartCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTextContentPart?: [{	by:ValueTypes["TextContentPartUniqueWhere"],	data:ValueTypes["TextContentPartUpdateInput"]},ValueTypes["_ValidationResult"]],
getTextContentReference?: [{	by:ValueTypes["TextContentReferenceUniqueWhere"],	filter?:ValueTypes["TextContentReferenceWhere"] | null},ValueTypes["TextContentReference"]],
listTextContentReference?: [{	filter?:ValueTypes["TextContentReferenceWhere"] | null,	orderBy?:ValueTypes["TextContentReferenceOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TextContentReference"]],
paginateTextContentReference?: [{	filter?:ValueTypes["TextContentReferenceWhere"] | null,	orderBy?:ValueTypes["TextContentReferenceOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TextContentReferenceConnection"]],
validateCreateTextContentReference?: [{	data:ValueTypes["TextContentReferenceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTextContentReference?: [{	by:ValueTypes["TextContentReferenceUniqueWhere"],	data:ValueTypes["TextContentReferenceUpdateInput"]},ValueTypes["_ValidationResult"]],
getUrl?: [{	by:ValueTypes["UrlUniqueWhere"],	filter?:ValueTypes["UrlWhere"] | null},ValueTypes["Url"]],
listUrl?: [{	filter?:ValueTypes["UrlWhere"] | null,	orderBy?:ValueTypes["UrlOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Url"]],
paginateUrl?: [{	filter?:ValueTypes["UrlWhere"] | null,	orderBy?:ValueTypes["UrlOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["UrlConnection"]],
validateCreateUrl?: [{	data:ValueTypes["UrlCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateUrl?: [{	by:ValueTypes["UrlUniqueWhere"],	data:ValueTypes["UrlUpdateInput"]},ValueTypes["_ValidationResult"]],
getArticleTag?: [{	by:ValueTypes["ArticleTagUniqueWhere"],	filter?:ValueTypes["ArticleTagWhere"] | null},ValueTypes["ArticleTag"]],
listArticleTag?: [{	filter?:ValueTypes["ArticleTagWhere"] | null,	orderBy?:ValueTypes["ArticleTagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArticleTag"]],
paginateArticleTag?: [{	filter?:ValueTypes["ArticleTagWhere"] | null,	orderBy?:ValueTypes["ArticleTagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArticleTagConnection"]],
validateCreateArticleTag?: [{	data:ValueTypes["ArticleTagCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateArticleTag?: [{	by:ValueTypes["ArticleTagUniqueWhere"],	data:ValueTypes["ArticleTagUpdateInput"]},ValueTypes["_ValidationResult"]],
getCategory?: [{	by:ValueTypes["CategoryUniqueWhere"],	filter?:ValueTypes["CategoryWhere"] | null},ValueTypes["Category"]],
listCategory?: [{	filter?:ValueTypes["CategoryWhere"] | null,	orderBy?:ValueTypes["CategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Category"]],
paginateCategory?: [{	filter?:ValueTypes["CategoryWhere"] | null,	orderBy?:ValueTypes["CategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["CategoryConnection"]],
validateCreateCategory?: [{	data:ValueTypes["CategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCategory?: [{	by:ValueTypes["CategoryUniqueWhere"],	data:ValueTypes["CategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getArticleCategory?: [{	by:ValueTypes["ArticleCategoryUniqueWhere"],	filter?:ValueTypes["ArticleCategoryWhere"] | null},ValueTypes["ArticleCategory"]],
listArticleCategory?: [{	filter?:ValueTypes["ArticleCategoryWhere"] | null,	orderBy?:ValueTypes["ArticleCategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArticleCategory"]],
paginateArticleCategory?: [{	filter?:ValueTypes["ArticleCategoryWhere"] | null,	orderBy?:ValueTypes["ArticleCategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArticleCategoryConnection"]],
validateCreateArticleCategory?: [{	data:ValueTypes["ArticleCategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateArticleCategory?: [{	by:ValueTypes["ArticleCategoryUniqueWhere"],	data:ValueTypes["ArticleCategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getAudio?: [{	by:ValueTypes["AudioUniqueWhere"],	filter?:ValueTypes["AudioWhere"] | null},ValueTypes["Audio"]],
listAudio?: [{	filter?:ValueTypes["AudioWhere"] | null,	orderBy?:ValueTypes["AudioOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Audio"]],
paginateAudio?: [{	filter?:ValueTypes["AudioWhere"] | null,	orderBy?:ValueTypes["AudioOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AudioConnection"]],
validateCreateAudio?: [{	data:ValueTypes["AudioCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateAudio?: [{	by:ValueTypes["AudioUniqueWhere"],	data:ValueTypes["AudioUpdateInput"]},ValueTypes["_ValidationResult"]],
getAudioUse?: [{	by:ValueTypes["AudioUseUniqueWhere"],	filter?:ValueTypes["AudioUseWhere"] | null},ValueTypes["AudioUse"]],
listAudioUse?: [{	filter?:ValueTypes["AudioUseWhere"] | null,	orderBy?:ValueTypes["AudioUseOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["AudioUse"]],
paginateAudioUse?: [{	filter?:ValueTypes["AudioUseWhere"] | null,	orderBy?:ValueTypes["AudioUseOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AudioUseConnection"]],
validateCreateAudioUse?: [{	data:ValueTypes["AudioUseCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateAudioUse?: [{	by:ValueTypes["AudioUseUniqueWhere"],	data:ValueTypes["AudioUseUpdateInput"]},ValueTypes["_ValidationResult"]],
getEmbed?: [{	by:ValueTypes["EmbedUniqueWhere"],	filter?:ValueTypes["EmbedWhere"] | null},ValueTypes["Embed"]],
listEmbed?: [{	filter?:ValueTypes["EmbedWhere"] | null,	orderBy?:ValueTypes["EmbedOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Embed"]],
paginateEmbed?: [{	filter?:ValueTypes["EmbedWhere"] | null,	orderBy?:ValueTypes["EmbedOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EmbedConnection"]],
validateCreateEmbed?: [{	data:ValueTypes["EmbedCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEmbed?: [{	by:ValueTypes["EmbedUniqueWhere"],	data:ValueTypes["EmbedUpdateInput"]},ValueTypes["_ValidationResult"]],
getImageContent?: [{	by:ValueTypes["ImageContentUniqueWhere"],	filter?:ValueTypes["ImageContentWhere"] | null},ValueTypes["ImageContent"]],
listImageContent?: [{	filter?:ValueTypes["ImageContentWhere"] | null,	orderBy?:ValueTypes["ImageContentOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ImageContent"]],
paginateImageContent?: [{	filter?:ValueTypes["ImageContentWhere"] | null,	orderBy?:ValueTypes["ImageContentOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageContentConnection"]],
validateCreateImageContent?: [{	data:ValueTypes["ImageContentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImageContent?: [{	by:ValueTypes["ImageContentUniqueWhere"],	data:ValueTypes["ImageContentUpdateInput"]},ValueTypes["_ValidationResult"]],
getListicle?: [{	by:ValueTypes["ListicleUniqueWhere"],	filter?:ValueTypes["ListicleWhere"] | null},ValueTypes["Listicle"]],
listListicle?: [{	filter?:ValueTypes["ListicleWhere"] | null,	orderBy?:ValueTypes["ListicleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Listicle"]],
paginateListicle?: [{	filter?:ValueTypes["ListicleWhere"] | null,	orderBy?:ValueTypes["ListicleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ListicleConnection"]],
validateCreateListicle?: [{	data:ValueTypes["ListicleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateListicle?: [{	by:ValueTypes["ListicleUniqueWhere"],	data:ValueTypes["ListicleUpdateInput"]},ValueTypes["_ValidationResult"]],
getPollAnswer?: [{	by:ValueTypes["PollAnswerUniqueWhere"],	filter?:ValueTypes["PollAnswerWhere"] | null},ValueTypes["PollAnswer"]],
listPollAnswer?: [{	filter?:ValueTypes["PollAnswerWhere"] | null,	orderBy?:ValueTypes["PollAnswerOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["PollAnswer"]],
paginatePollAnswer?: [{	filter?:ValueTypes["PollAnswerWhere"] | null,	orderBy?:ValueTypes["PollAnswerOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PollAnswerConnection"]],
validateCreatePollAnswer?: [{	data:ValueTypes["PollAnswerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePollAnswer?: [{	by:ValueTypes["PollAnswerUniqueWhere"],	data:ValueTypes["PollAnswerUpdateInput"]},ValueTypes["_ValidationResult"]],
getTag?: [{	by:ValueTypes["TagUniqueWhere"],	filter?:ValueTypes["TagWhere"] | null},ValueTypes["Tag"]],
listTag?: [{	filter?:ValueTypes["TagWhere"] | null,	orderBy?:ValueTypes["TagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Tag"]],
paginateTag?: [{	filter?:ValueTypes["TagWhere"] | null,	orderBy?:ValueTypes["TagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TagConnection"]],
validateCreateTag?: [{	data:ValueTypes["TagCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTag?: [{	by:ValueTypes["TagUniqueWhere"],	data:ValueTypes["TagUpdateInput"]},ValueTypes["_ValidationResult"]],
getFAQ?: [{	by:ValueTypes["FAQUniqueWhere"],	filter?:ValueTypes["FAQWhere"] | null},ValueTypes["FAQ"]],
listFAQ?: [{	filter?:ValueTypes["FAQWhere"] | null,	orderBy?:ValueTypes["FAQOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FAQ"]],
paginateFAQ?: [{	filter?:ValueTypes["FAQWhere"] | null,	orderBy?:ValueTypes["FAQOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FAQConnection"]],
validateCreateFAQ?: [{	data:ValueTypes["FAQCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFAQ?: [{	by:ValueTypes["FAQUniqueWhere"],	data:ValueTypes["FAQUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkContent?: [{	by:ValueTypes["LinkContentUniqueWhere"],	filter?:ValueTypes["LinkContentWhere"] | null},ValueTypes["LinkContent"]],
listLinkContent?: [{	filter?:ValueTypes["LinkContentWhere"] | null,	orderBy?:ValueTypes["LinkContentOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["LinkContent"]],
paginateLinkContent?: [{	filter?:ValueTypes["LinkContentWhere"] | null,	orderBy?:ValueTypes["LinkContentOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkContentConnection"]],
validateCreateLinkContent?: [{	data:ValueTypes["LinkContentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkContent?: [{	by:ValueTypes["LinkContentUniqueWhere"],	data:ValueTypes["LinkContentUpdateInput"]},ValueTypes["_ValidationResult"]],
getAwardContent?: [{	by:ValueTypes["AwardContentUniqueWhere"],	filter?:ValueTypes["AwardContentWhere"] | null},ValueTypes["AwardContent"]],
listAwardContent?: [{	filter?:ValueTypes["AwardContentWhere"] | null,	orderBy?:ValueTypes["AwardContentOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["AwardContent"]],
paginateAwardContent?: [{	filter?:ValueTypes["AwardContentWhere"] | null,	orderBy?:ValueTypes["AwardContentOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AwardContentConnection"]],
validateCreateAwardContent?: [{	data:ValueTypes["AwardContentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateAwardContent?: [{	by:ValueTypes["AwardContentUniqueWhere"],	data:ValueTypes["AwardContentUpdateInput"]},ValueTypes["_ValidationResult"]],
getReviewContent?: [{	by:ValueTypes["ReviewContentUniqueWhere"],	filter?:ValueTypes["ReviewContentWhere"] | null},ValueTypes["ReviewContent"]],
listReviewContent?: [{	filter?:ValueTypes["ReviewContentWhere"] | null,	orderBy?:ValueTypes["ReviewContentOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ReviewContent"]],
paginateReviewContent?: [{	filter?:ValueTypes["ReviewContentWhere"] | null,	orderBy?:ValueTypes["ReviewContentOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ReviewContentConnection"]],
validateCreateReviewContent?: [{	data:ValueTypes["ReviewContentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateReviewContent?: [{	by:ValueTypes["ReviewContentUniqueWhere"],	data:ValueTypes["ReviewContentUpdateInput"]},ValueTypes["_ValidationResult"]],
getPage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null},ValueTypes["Page"]],
listPage?: [{	filter?:ValueTypes["PageWhere"] | null,	orderBy?:ValueTypes["PageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Page"]],
paginatePage?: [{	filter?:ValueTypes["PageWhere"] | null,	orderBy?:ValueTypes["PageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PageConnection"]],
validateCreatePage?: [{	data:ValueTypes["PageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePage?: [{	by:ValueTypes["PageUniqueWhere"],	data:ValueTypes["PageUpdateInput"]},ValueTypes["_ValidationResult"]],
getTextTranslation?: [{	by:ValueTypes["TextTranslationUniqueWhere"],	filter?:ValueTypes["TextTranslationWhere"] | null},ValueTypes["TextTranslation"]],
listTextTranslation?: [{	filter?:ValueTypes["TextTranslationWhere"] | null,	orderBy?:ValueTypes["TextTranslationOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TextTranslation"]],
paginateTextTranslation?: [{	filter?:ValueTypes["TextTranslationWhere"] | null,	orderBy?:ValueTypes["TextTranslationOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TextTranslationConnection"]],
validateCreateTextTranslation?: [{	data:ValueTypes["TextTranslationCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTextTranslation?: [{	by:ValueTypes["TextTranslationUniqueWhere"],	data:ValueTypes["TextTranslationUpdateInput"]},ValueTypes["_ValidationResult"]],
getSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
listSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Seo"]],
paginateSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SeoConnection"]],
validateCreateSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	data:ValueTypes["SeoUpdateInput"]},ValueTypes["_ValidationResult"]],
getFile?: [{	by:ValueTypes["FileUniqueWhere"],	filter?:ValueTypes["FileWhere"] | null},ValueTypes["File"]],
listFile?: [{	filter?:ValueTypes["FileWhere"] | null,	orderBy?:ValueTypes["FileOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["File"]],
paginateFile?: [{	filter?:ValueTypes["FileWhere"] | null,	orderBy?:ValueTypes["FileOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FileConnection"]],
validateCreateFile?: [{	data:ValueTypes["FileCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFile?: [{	by:ValueTypes["FileUniqueWhere"],	data:ValueTypes["FileUpdateInput"]},ValueTypes["_ValidationResult"]],
getFileUse?: [{	by:ValueTypes["FileUseUniqueWhere"],	filter?:ValueTypes["FileUseWhere"] | null},ValueTypes["FileUse"]],
listFileUse?: [{	filter?:ValueTypes["FileUseWhere"] | null,	orderBy?:ValueTypes["FileUseOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FileUse"]],
paginateFileUse?: [{	filter?:ValueTypes["FileUseWhere"] | null,	orderBy?:ValueTypes["FileUseOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FileUseConnection"]],
validateCreateFileUse?: [{	data:ValueTypes["FileUseCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFileUse?: [{	by:ValueTypes["FileUseUniqueWhere"],	data:ValueTypes["FileUseUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
listContentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentBlock"]],
paginateContentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentBlockConnection"]],
validateCreateContentBlock?: [{	data:ValueTypes["ContentBlockCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	data:ValueTypes["ContentBlockUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentArticle?: [{	by:ValueTypes["ContentArticleUniqueWhere"],	filter?:ValueTypes["ContentArticleWhere"] | null},ValueTypes["ContentArticle"]],
listContentArticle?: [{	filter?:ValueTypes["ContentArticleWhere"] | null,	orderBy?:ValueTypes["ContentArticleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentArticle"]],
paginateContentArticle?: [{	filter?:ValueTypes["ContentArticleWhere"] | null,	orderBy?:ValueTypes["ContentArticleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentArticleConnection"]],
validateCreateContentArticle?: [{	data:ValueTypes["ContentArticleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentArticle?: [{	by:ValueTypes["ContentArticleUniqueWhere"],	data:ValueTypes["ContentArticleUpdateInput"]},ValueTypes["_ValidationResult"]],
getUnlockedArticle?: [{	by:ValueTypes["UnlockedArticleUniqueWhere"],	filter?:ValueTypes["UnlockedArticleWhere"] | null},ValueTypes["UnlockedArticle"]],
listUnlockedArticle?: [{	filter?:ValueTypes["UnlockedArticleWhere"] | null,	orderBy?:ValueTypes["UnlockedArticleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["UnlockedArticle"]],
paginateUnlockedArticle?: [{	filter?:ValueTypes["UnlockedArticleWhere"] | null,	orderBy?:ValueTypes["UnlockedArticleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["UnlockedArticleConnection"]],
validateCreateUnlockedArticle?: [{	data:ValueTypes["UnlockedArticleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateUnlockedArticle?: [{	by:ValueTypes["UnlockedArticleUniqueWhere"],	data:ValueTypes["UnlockedArticleUpdateInput"]},ValueTypes["_ValidationResult"]],
getUser?: [{	by:ValueTypes["UserUniqueWhere"],	filter?:ValueTypes["UserWhere"] | null},ValueTypes["User"]],
listUser?: [{	filter?:ValueTypes["UserWhere"] | null,	orderBy?:ValueTypes["UserOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["User"]],
paginateUser?: [{	filter?:ValueTypes["UserWhere"] | null,	orderBy?:ValueTypes["UserOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["UserConnection"]],
validateCreateUser?: [{	data:ValueTypes["UserCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateUser?: [{	by:ValueTypes["UserUniqueWhere"],	data:ValueTypes["UserUpdateInput"]},ValueTypes["_ValidationResult"]],
getNotification?: [{	by:ValueTypes["NotificationUniqueWhere"],	filter?:ValueTypes["NotificationWhere"] | null},ValueTypes["Notification"]],
listNotification?: [{	filter?:ValueTypes["NotificationWhere"] | null,	orderBy?:ValueTypes["NotificationOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Notification"]],
paginateNotification?: [{	filter?:ValueTypes["NotificationWhere"] | null,	orderBy?:ValueTypes["NotificationOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["NotificationConnection"]],
validateCreateNotification?: [{	data:ValueTypes["NotificationCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateNotification?: [{	by:ValueTypes["NotificationUniqueWhere"],	data:ValueTypes["NotificationUpdateInput"]},ValueTypes["_ValidationResult"]],
getAppReview?: [{	by:ValueTypes["AppReviewUniqueWhere"],	filter?:ValueTypes["AppReviewWhere"] | null},ValueTypes["AppReview"]],
listAppReview?: [{	filter?:ValueTypes["AppReviewWhere"] | null,	orderBy?:ValueTypes["AppReviewOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["AppReview"]],
paginateAppReview?: [{	filter?:ValueTypes["AppReviewWhere"] | null,	orderBy?:ValueTypes["AppReviewOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AppReviewConnection"]],
validateCreateAppReview?: [{	data:ValueTypes["AppReviewCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateAppReview?: [{	by:ValueTypes["AppReviewUniqueWhere"],	data:ValueTypes["AppReviewUpdateInput"]},ValueTypes["_ValidationResult"]],
getProduct?: [{	by:ValueTypes["ProductUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["Product"]],
listProduct?: [{	filter?:ValueTypes["ProductWhere"] | null,	orderBy?:ValueTypes["ProductOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Product"]],
paginateProduct?: [{	filter?:ValueTypes["ProductWhere"] | null,	orderBy?:ValueTypes["ProductOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ProductConnection"]],
validateCreateProduct?: [{	data:ValueTypes["ProductCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateProduct?: [{	by:ValueTypes["ProductUniqueWhere"],	data:ValueTypes["ProductUpdateInput"]},ValueTypes["_ValidationResult"]],
getSubscriptionForm?: [{	by:ValueTypes["SubscriptionFormUniqueWhere"],	filter?:ValueTypes["SubscriptionFormWhere"] | null},ValueTypes["SubscriptionForm"]],
listSubscriptionForm?: [{	filter?:ValueTypes["SubscriptionFormWhere"] | null,	orderBy?:ValueTypes["SubscriptionFormOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SubscriptionForm"]],
paginateSubscriptionForm?: [{	filter?:ValueTypes["SubscriptionFormWhere"] | null,	orderBy?:ValueTypes["SubscriptionFormOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SubscriptionFormConnection"]],
validateCreateSubscriptionForm?: [{	data:ValueTypes["SubscriptionFormCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSubscriptionForm?: [{	by:ValueTypes["SubscriptionFormUniqueWhere"],	data:ValueTypes["SubscriptionFormUpdateInput"]},ValueTypes["_ValidationResult"]],
getSubscriptionFormSection?: [{	by:ValueTypes["SubscriptionFormSectionUniqueWhere"],	filter?:ValueTypes["SubscriptionFormSectionWhere"] | null},ValueTypes["SubscriptionFormSection"]],
listSubscriptionFormSection?: [{	filter?:ValueTypes["SubscriptionFormSectionWhere"] | null,	orderBy?:ValueTypes["SubscriptionFormSectionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SubscriptionFormSection"]],
paginateSubscriptionFormSection?: [{	filter?:ValueTypes["SubscriptionFormSectionWhere"] | null,	orderBy?:ValueTypes["SubscriptionFormSectionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SubscriptionFormSectionConnection"]],
validateCreateSubscriptionFormSection?: [{	data:ValueTypes["SubscriptionFormSectionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSubscriptionFormSection?: [{	by:ValueTypes["SubscriptionFormSectionUniqueWhere"],	data:ValueTypes["SubscriptionFormSectionUpdateInput"]},ValueTypes["_ValidationResult"]],
getSubscriptionFormInput?: [{	by:ValueTypes["SubscriptionFormInputUniqueWhere"],	filter?:ValueTypes["SubscriptionFormInputWhere"] | null},ValueTypes["SubscriptionFormInput"]],
listSubscriptionFormInput?: [{	filter?:ValueTypes["SubscriptionFormInputWhere"] | null,	orderBy?:ValueTypes["SubscriptionFormInputOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SubscriptionFormInput"]],
paginateSubscriptionFormInput?: [{	filter?:ValueTypes["SubscriptionFormInputWhere"] | null,	orderBy?:ValueTypes["SubscriptionFormInputOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SubscriptionFormInputConnection"]],
validateCreateSubscriptionFormInput?: [{	data:ValueTypes["SubscriptionFormInputCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSubscriptionFormInput?: [{	by:ValueTypes["SubscriptionFormInputUniqueWhere"],	data:ValueTypes["SubscriptionFormInputUpdateInput"]},ValueTypes["_ValidationResult"]],
getSubscriptionFormOption?: [{	by:ValueTypes["SubscriptionFormOptionUniqueWhere"],	filter?:ValueTypes["SubscriptionFormOptionWhere"] | null},ValueTypes["SubscriptionFormOption"]],
listSubscriptionFormOption?: [{	filter?:ValueTypes["SubscriptionFormOptionWhere"] | null,	orderBy?:ValueTypes["SubscriptionFormOptionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SubscriptionFormOption"]],
paginateSubscriptionFormOption?: [{	filter?:ValueTypes["SubscriptionFormOptionWhere"] | null,	orderBy?:ValueTypes["SubscriptionFormOptionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SubscriptionFormOptionConnection"]],
validateCreateSubscriptionFormOption?: [{	data:ValueTypes["SubscriptionFormOptionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSubscriptionFormOption?: [{	by:ValueTypes["SubscriptionFormOptionUniqueWhere"],	data:ValueTypes["SubscriptionFormOptionUpdateInput"]},ValueTypes["_ValidationResult"]],
getButton?: [{	by:ValueTypes["ButtonUniqueWhere"],	filter?:ValueTypes["ButtonWhere"] | null},ValueTypes["Button"]],
listButton?: [{	filter?:ValueTypes["ButtonWhere"] | null,	orderBy?:ValueTypes["ButtonOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Button"]],
paginateButton?: [{	filter?:ValueTypes["ButtonWhere"] | null,	orderBy?:ValueTypes["ButtonOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ButtonConnection"]],
validateCreateButton?: [{	data:ValueTypes["ButtonCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateButton?: [{	by:ValueTypes["ButtonUniqueWhere"],	data:ValueTypes["ButtonUpdateInput"]},ValueTypes["_ValidationResult"]],
getArticleHistoryTag?: [{	by:ValueTypes["ArticleHistoryTagUniqueWhere"],	filter?:ValueTypes["ArticleHistoryTagWhere"] | null},ValueTypes["ArticleHistoryTag"]],
listArticleHistoryTag?: [{	filter?:ValueTypes["ArticleHistoryTagWhere"] | null,	orderBy?:ValueTypes["ArticleHistoryTagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArticleHistoryTag"]],
paginateArticleHistoryTag?: [{	filter?:ValueTypes["ArticleHistoryTagWhere"] | null,	orderBy?:ValueTypes["ArticleHistoryTagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArticleHistoryTagConnection"]],
validateCreateArticleHistoryTag?: [{	data:ValueTypes["ArticleHistoryTagCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateArticleHistoryTag?: [{	by:ValueTypes["ArticleHistoryTagUniqueWhere"],	data:ValueTypes["ArticleHistoryTagUpdateInput"]},ValueTypes["_ValidationResult"]],
getArticleHistoryPeriod?: [{	by:ValueTypes["ArticleHistoryPeriodUniqueWhere"],	filter?:ValueTypes["ArticleHistoryPeriodWhere"] | null},ValueTypes["ArticleHistoryPeriod"]],
listArticleHistoryPeriod?: [{	filter?:ValueTypes["ArticleHistoryPeriodWhere"] | null,	orderBy?:ValueTypes["ArticleHistoryPeriodOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArticleHistoryPeriod"]],
paginateArticleHistoryPeriod?: [{	filter?:ValueTypes["ArticleHistoryPeriodWhere"] | null,	orderBy?:ValueTypes["ArticleHistoryPeriodOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArticleHistoryPeriodConnection"]],
validateCreateArticleHistoryPeriod?: [{	data:ValueTypes["ArticleHistoryPeriodCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateArticleHistoryPeriod?: [{	by:ValueTypes["ArticleHistoryPeriodUniqueWhere"],	data:ValueTypes["ArticleHistoryPeriodUpdateInput"]},ValueTypes["_ValidationResult"]],
getHistoryTag?: [{	by:ValueTypes["HistoryTagUniqueWhere"],	filter?:ValueTypes["HistoryTagWhere"] | null},ValueTypes["HistoryTag"]],
listHistoryTag?: [{	filter?:ValueTypes["HistoryTagWhere"] | null,	orderBy?:ValueTypes["HistoryTagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HistoryTag"]],
paginateHistoryTag?: [{	filter?:ValueTypes["HistoryTagWhere"] | null,	orderBy?:ValueTypes["HistoryTagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HistoryTagConnection"]],
validateCreateHistoryTag?: [{	data:ValueTypes["HistoryTagCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHistoryTag?: [{	by:ValueTypes["HistoryTagUniqueWhere"],	data:ValueTypes["HistoryTagUpdateInput"]},ValueTypes["_ValidationResult"]],
getHistoryPeriod?: [{	by:ValueTypes["HistoryPeriodUniqueWhere"],	filter?:ValueTypes["HistoryPeriodWhere"] | null},ValueTypes["HistoryPeriod"]],
listHistoryPeriod?: [{	filter?:ValueTypes["HistoryPeriodWhere"] | null,	orderBy?:ValueTypes["HistoryPeriodOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HistoryPeriod"]],
paginateHistoryPeriod?: [{	filter?:ValueTypes["HistoryPeriodWhere"] | null,	orderBy?:ValueTypes["HistoryPeriodOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HistoryPeriodConnection"]],
validateCreateHistoryPeriod?: [{	data:ValueTypes["HistoryPeriodCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHistoryPeriod?: [{	by:ValueTypes["HistoryPeriodUniqueWhere"],	data:ValueTypes["HistoryPeriodUpdateInput"]},ValueTypes["_ValidationResult"]],
getHistoryHomePage?: [{	by:ValueTypes["HistoryHomePageUniqueWhere"],	filter?:ValueTypes["HistoryHomePageWhere"] | null},ValueTypes["HistoryHomePage"]],
listHistoryHomePage?: [{	filter?:ValueTypes["HistoryHomePageWhere"] | null,	orderBy?:ValueTypes["HistoryHomePageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HistoryHomePage"]],
paginateHistoryHomePage?: [{	filter?:ValueTypes["HistoryHomePageWhere"] | null,	orderBy?:ValueTypes["HistoryHomePageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HistoryHomePageConnection"]],
validateCreateHistoryHomePage?: [{	data:ValueTypes["HistoryHomePageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHistoryHomePage?: [{	by:ValueTypes["HistoryHomePageUniqueWhere"],	data:ValueTypes["HistoryHomePageUpdateInput"]},ValueTypes["_ValidationResult"]],
getHistoryCover?: [{	by:ValueTypes["HistoryCoverUniqueWhere"],	filter?:ValueTypes["HistoryCoverWhere"] | null},ValueTypes["HistoryCover"]],
listHistoryCover?: [{	filter?:ValueTypes["HistoryCoverWhere"] | null,	orderBy?:ValueTypes["HistoryCoverOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HistoryCover"]],
paginateHistoryCover?: [{	filter?:ValueTypes["HistoryCoverWhere"] | null,	orderBy?:ValueTypes["HistoryCoverOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HistoryCoverConnection"]],
validateCreateHistoryCover?: [{	data:ValueTypes["HistoryCoverCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHistoryCover?: [{	by:ValueTypes["HistoryCoverUniqueWhere"],	data:ValueTypes["HistoryCoverUpdateInput"]},ValueTypes["_ValidationResult"]],
getHistoryTextList?: [{	by:ValueTypes["HistoryTextListUniqueWhere"],	filter?:ValueTypes["HistoryTextListWhere"] | null},ValueTypes["HistoryTextList"]],
listHistoryTextList?: [{	filter?:ValueTypes["HistoryTextListWhere"] | null,	orderBy?:ValueTypes["HistoryTextListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HistoryTextList"]],
paginateHistoryTextList?: [{	filter?:ValueTypes["HistoryTextListWhere"] | null,	orderBy?:ValueTypes["HistoryTextListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HistoryTextListConnection"]],
validateCreateHistoryTextList?: [{	data:ValueTypes["HistoryTextListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHistoryTextList?: [{	by:ValueTypes["HistoryTextListUniqueWhere"],	data:ValueTypes["HistoryTextListUpdateInput"]},ValueTypes["_ValidationResult"]],
getHistoryTextItem?: [{	by:ValueTypes["HistoryTextItemUniqueWhere"],	filter?:ValueTypes["HistoryTextItemWhere"] | null},ValueTypes["HistoryTextItem"]],
listHistoryTextItem?: [{	filter?:ValueTypes["HistoryTextItemWhere"] | null,	orderBy?:ValueTypes["HistoryTextItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HistoryTextItem"]],
paginateHistoryTextItem?: [{	filter?:ValueTypes["HistoryTextItemWhere"] | null,	orderBy?:ValueTypes["HistoryTextItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HistoryTextItemConnection"]],
validateCreateHistoryTextItem?: [{	data:ValueTypes["HistoryTextItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHistoryTextItem?: [{	by:ValueTypes["HistoryTextItemUniqueWhere"],	data:ValueTypes["HistoryTextItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooterMenu?: [{	by:ValueTypes["FooterMenuUniqueWhere"],	filter?:ValueTypes["FooterMenuWhere"] | null},ValueTypes["FooterMenu"]],
listFooterMenu?: [{	filter?:ValueTypes["FooterMenuWhere"] | null,	orderBy?:ValueTypes["FooterMenuOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FooterMenu"]],
paginateFooterMenu?: [{	filter?:ValueTypes["FooterMenuWhere"] | null,	orderBy?:ValueTypes["FooterMenuOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterMenuConnection"]],
validateCreateFooterMenu?: [{	data:ValueTypes["FooterMenuCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooterMenu?: [{	by:ValueTypes["FooterMenuUniqueWhere"],	data:ValueTypes["FooterMenuUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkSection?: [{	by:ValueTypes["LinkSectionUniqueWhere"],	filter?:ValueTypes["LinkSectionWhere"] | null},ValueTypes["LinkSection"]],
listLinkSection?: [{	filter?:ValueTypes["LinkSectionWhere"] | null,	orderBy?:ValueTypes["LinkSectionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["LinkSection"]],
paginateLinkSection?: [{	filter?:ValueTypes["LinkSectionWhere"] | null,	orderBy?:ValueTypes["LinkSectionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkSectionConnection"]],
validateCreateLinkSection?: [{	data:ValueTypes["LinkSectionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkSection?: [{	by:ValueTypes["LinkSectionUniqueWhere"],	data:ValueTypes["LinkSectionUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkList?: [{	by:ValueTypes["LinkListUniqueWhere"],	filter?:ValueTypes["LinkListWhere"] | null},ValueTypes["LinkList"]],
listLinkList?: [{	filter?:ValueTypes["LinkListWhere"] | null,	orderBy?:ValueTypes["LinkListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["LinkList"]],
paginateLinkList?: [{	filter?:ValueTypes["LinkListWhere"] | null,	orderBy?:ValueTypes["LinkListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkListConnection"]],
validateCreateLinkList?: [{	data:ValueTypes["LinkListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkList?: [{	by:ValueTypes["LinkListUniqueWhere"],	data:ValueTypes["LinkListUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkItem?: [{	by:ValueTypes["LinkItemUniqueWhere"],	filter?:ValueTypes["LinkItemWhere"] | null},ValueTypes["LinkItem"]],
listLinkItem?: [{	filter?:ValueTypes["LinkItemWhere"] | null,	orderBy?:ValueTypes["LinkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["LinkItem"]],
paginateLinkItem?: [{	filter?:ValueTypes["LinkItemWhere"] | null,	orderBy?:ValueTypes["LinkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkItemConnection"]],
validateCreateLinkItem?: [{	data:ValueTypes["LinkItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkItem?: [{	by:ValueTypes["LinkItemUniqueWhere"],	data:ValueTypes["LinkItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getNewsletterSection?: [{	by:ValueTypes["NewsletterSectionUniqueWhere"],	filter?:ValueTypes["NewsletterSectionWhere"] | null},ValueTypes["NewsletterSection"]],
listNewsletterSection?: [{	filter?:ValueTypes["NewsletterSectionWhere"] | null,	orderBy?:ValueTypes["NewsletterSectionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["NewsletterSection"]],
paginateNewsletterSection?: [{	filter?:ValueTypes["NewsletterSectionWhere"] | null,	orderBy?:ValueTypes["NewsletterSectionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["NewsletterSectionConnection"]],
validateCreateNewsletterSection?: [{	data:ValueTypes["NewsletterSectionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateNewsletterSection?: [{	by:ValueTypes["NewsletterSectionUniqueWhere"],	data:ValueTypes["NewsletterSectionUpdateInput"]},ValueTypes["_ValidationResult"]],
getNewsletter?: [{	by:ValueTypes["NewsletterUniqueWhere"],	filter?:ValueTypes["NewsletterWhere"] | null},ValueTypes["Newsletter"]],
listNewsletter?: [{	filter?:ValueTypes["NewsletterWhere"] | null,	orderBy?:ValueTypes["NewsletterOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Newsletter"]],
paginateNewsletter?: [{	filter?:ValueTypes["NewsletterWhere"] | null,	orderBy?:ValueTypes["NewsletterOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["NewsletterConnection"]],
validateCreateNewsletter?: [{	data:ValueTypes["NewsletterCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateNewsletter?: [{	by:ValueTypes["NewsletterUniqueWhere"],	data:ValueTypes["NewsletterUpdateInput"]},ValueTypes["_ValidationResult"]],
getOnlineSection?: [{	by:ValueTypes["OnlineSectionUniqueWhere"],	filter?:ValueTypes["OnlineSectionWhere"] | null},ValueTypes["OnlineSection"]],
listOnlineSection?: [{	filter?:ValueTypes["OnlineSectionWhere"] | null,	orderBy?:ValueTypes["OnlineSectionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["OnlineSection"]],
paginateOnlineSection?: [{	filter?:ValueTypes["OnlineSectionWhere"] | null,	orderBy?:ValueTypes["OnlineSectionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["OnlineSectionConnection"]],
validateCreateOnlineSection?: [{	data:ValueTypes["OnlineSectionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateOnlineSection?: [{	by:ValueTypes["OnlineSectionUniqueWhere"],	data:ValueTypes["OnlineSectionUpdateInput"]},ValueTypes["_ValidationResult"]],
getAppLink?: [{	by:ValueTypes["AppLinkUniqueWhere"],	filter?:ValueTypes["AppLinkWhere"] | null},ValueTypes["AppLink"]],
listAppLink?: [{	filter?:ValueTypes["AppLinkWhere"] | null,	orderBy?:ValueTypes["AppLinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["AppLink"]],
paginateAppLink?: [{	filter?:ValueTypes["AppLinkWhere"] | null,	orderBy?:ValueTypes["AppLinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AppLinkConnection"]],
validateCreateAppLink?: [{	data:ValueTypes["AppLinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateAppLink?: [{	by:ValueTypes["AppLinkUniqueWhere"],	data:ValueTypes["AppLinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getAppLinkList?: [{	by:ValueTypes["AppLinkListUniqueWhere"],	filter?:ValueTypes["AppLinkListWhere"] | null},ValueTypes["AppLinkList"]],
listAppLinkList?: [{	filter?:ValueTypes["AppLinkListWhere"] | null,	orderBy?:ValueTypes["AppLinkListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["AppLinkList"]],
paginateAppLinkList?: [{	filter?:ValueTypes["AppLinkListWhere"] | null,	orderBy?:ValueTypes["AppLinkListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AppLinkListConnection"]],
validateCreateAppLinkList?: [{	data:ValueTypes["AppLinkListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateAppLinkList?: [{	by:ValueTypes["AppLinkListUniqueWhere"],	data:ValueTypes["AppLinkListUpdateInput"]},ValueTypes["_ValidationResult"]],
getAppLinkItem?: [{	by:ValueTypes["AppLinkItemUniqueWhere"],	filter?:ValueTypes["AppLinkItemWhere"] | null},ValueTypes["AppLinkItem"]],
listAppLinkItem?: [{	filter?:ValueTypes["AppLinkItemWhere"] | null,	orderBy?:ValueTypes["AppLinkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["AppLinkItem"]],
paginateAppLinkItem?: [{	filter?:ValueTypes["AppLinkItemWhere"] | null,	orderBy?:ValueTypes["AppLinkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["AppLinkItemConnection"]],
validateCreateAppLinkItem?: [{	data:ValueTypes["AppLinkItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateAppLinkItem?: [{	by:ValueTypes["AppLinkItemUniqueWhere"],	data:ValueTypes["AppLinkItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getSocialSection?: [{	by:ValueTypes["SocialSectionUniqueWhere"],	filter?:ValueTypes["SocialSectionWhere"] | null},ValueTypes["SocialSection"]],
listSocialSection?: [{	filter?:ValueTypes["SocialSectionWhere"] | null,	orderBy?:ValueTypes["SocialSectionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SocialSection"]],
paginateSocialSection?: [{	filter?:ValueTypes["SocialSectionWhere"] | null,	orderBy?:ValueTypes["SocialSectionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SocialSectionConnection"]],
validateCreateSocialSection?: [{	data:ValueTypes["SocialSectionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSocialSection?: [{	by:ValueTypes["SocialSectionUniqueWhere"],	data:ValueTypes["SocialSectionUpdateInput"]},ValueTypes["_ValidationResult"]],
getSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkWhere"] | null},ValueTypes["SocialLink"]],
listSocialLink?: [{	filter?:ValueTypes["SocialLinkWhere"] | null,	orderBy?:ValueTypes["SocialLinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SocialLink"]],
paginateSocialLink?: [{	filter?:ValueTypes["SocialLinkWhere"] | null,	orderBy?:ValueTypes["SocialLinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SocialLinkConnection"]],
validateCreateSocialLink?: [{	data:ValueTypes["SocialLinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	data:ValueTypes["SocialLinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getSocialLinkList?: [{	by:ValueTypes["SocialLinkListUniqueWhere"],	filter?:ValueTypes["SocialLinkListWhere"] | null},ValueTypes["SocialLinkList"]],
listSocialLinkList?: [{	filter?:ValueTypes["SocialLinkListWhere"] | null,	orderBy?:ValueTypes["SocialLinkListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SocialLinkList"]],
paginateSocialLinkList?: [{	filter?:ValueTypes["SocialLinkListWhere"] | null,	orderBy?:ValueTypes["SocialLinkListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SocialLinkListConnection"]],
validateCreateSocialLinkList?: [{	data:ValueTypes["SocialLinkListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSocialLinkList?: [{	by:ValueTypes["SocialLinkListUniqueWhere"],	data:ValueTypes["SocialLinkListUpdateInput"]},ValueTypes["_ValidationResult"]],
getSocialLinkItem?: [{	by:ValueTypes["SocialLinkItemUniqueWhere"],	filter?:ValueTypes["SocialLinkItemWhere"] | null},ValueTypes["SocialLinkItem"]],
listSocialLinkItem?: [{	filter?:ValueTypes["SocialLinkItemWhere"] | null,	orderBy?:ValueTypes["SocialLinkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SocialLinkItem"]],
paginateSocialLinkItem?: [{	filter?:ValueTypes["SocialLinkItemWhere"] | null,	orderBy?:ValueTypes["SocialLinkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SocialLinkItemConnection"]],
validateCreateSocialLinkItem?: [{	data:ValueTypes["SocialLinkItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSocialLinkItem?: [{	by:ValueTypes["SocialLinkItemUniqueWhere"],	data:ValueTypes["SocialLinkItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getSharedContent?: [{	by:ValueTypes["SharedContentUniqueWhere"],	filter?:ValueTypes["SharedContentWhere"] | null},ValueTypes["SharedContent"]],
listSharedContent?: [{	filter?:ValueTypes["SharedContentWhere"] | null,	orderBy?:ValueTypes["SharedContentOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SharedContent"]],
paginateSharedContent?: [{	filter?:ValueTypes["SharedContentWhere"] | null,	orderBy?:ValueTypes["SharedContentOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SharedContentConnection"]],
validateCreateSharedContent?: [{	data:ValueTypes["SharedContentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSharedContent?: [{	by:ValueTypes["SharedContentUniqueWhere"],	data:ValueTypes["SharedContentUpdateInput"]},ValueTypes["_ValidationResult"]],
		__typename?: boolean
}>;
	["Info"]: AliasType<{
	description?:boolean,
		__typename?: boolean
}>;
	["Mutation"]: AliasType<{
createArticle?: [{	data:ValueTypes["ArticleCreateInput"]},ValueTypes["ArticleCreateResult"]],
deleteArticle?: [{	by:ValueTypes["ArticleUniqueWhere"],	filter?:ValueTypes["ArticleWhere"] | null},ValueTypes["ArticleDeleteResult"]],
updateArticle?: [{	by:ValueTypes["ArticleUniqueWhere"],	filter?:ValueTypes["ArticleWhere"] | null,	data:ValueTypes["ArticleUpdateInput"]},ValueTypes["ArticleUpdateResult"]],
upsertArticle?: [{	by:ValueTypes["ArticleUniqueWhere"],	filter?:ValueTypes["ArticleWhere"] | null,	update:ValueTypes["ArticleUpdateInput"],	create:ValueTypes["ArticleCreateInput"]},ValueTypes["ArticleUpsertResult"]],
createArticleAuthor?: [{	data:ValueTypes["ArticleAuthorCreateInput"]},ValueTypes["ArticleAuthorCreateResult"]],
deleteArticleAuthor?: [{	by:ValueTypes["ArticleAuthorUniqueWhere"],	filter?:ValueTypes["ArticleAuthorWhere"] | null},ValueTypes["ArticleAuthorDeleteResult"]],
updateArticleAuthor?: [{	by:ValueTypes["ArticleAuthorUniqueWhere"],	filter?:ValueTypes["ArticleAuthorWhere"] | null,	data:ValueTypes["ArticleAuthorUpdateInput"]},ValueTypes["ArticleAuthorUpdateResult"]],
upsertArticleAuthor?: [{	by:ValueTypes["ArticleAuthorUniqueWhere"],	filter?:ValueTypes["ArticleAuthorWhere"] | null,	update:ValueTypes["ArticleAuthorUpdateInput"],	create:ValueTypes["ArticleAuthorCreateInput"]},ValueTypes["ArticleAuthorUpsertResult"]],
createAuthor?: [{	data:ValueTypes["AuthorCreateInput"]},ValueTypes["AuthorCreateResult"]],
deleteAuthor?: [{	by:ValueTypes["AuthorUniqueWhere"],	filter?:ValueTypes["AuthorWhere"] | null},ValueTypes["AuthorDeleteResult"]],
updateAuthor?: [{	by:ValueTypes["AuthorUniqueWhere"],	filter?:ValueTypes["AuthorWhere"] | null,	data:ValueTypes["AuthorUpdateInput"]},ValueTypes["AuthorUpdateResult"]],
upsertAuthor?: [{	by:ValueTypes["AuthorUniqueWhere"],	filter?:ValueTypes["AuthorWhere"] | null,	update:ValueTypes["AuthorUpdateInput"],	create:ValueTypes["AuthorCreateInput"]},ValueTypes["AuthorUpsertResult"]],
createAuthorTopArticle?: [{	data:ValueTypes["AuthorTopArticleCreateInput"]},ValueTypes["AuthorTopArticleCreateResult"]],
deleteAuthorTopArticle?: [{	by:ValueTypes["AuthorTopArticleUniqueWhere"],	filter?:ValueTypes["AuthorTopArticleWhere"] | null},ValueTypes["AuthorTopArticleDeleteResult"]],
updateAuthorTopArticle?: [{	by:ValueTypes["AuthorTopArticleUniqueWhere"],	filter?:ValueTypes["AuthorTopArticleWhere"] | null,	data:ValueTypes["AuthorTopArticleUpdateInput"]},ValueTypes["AuthorTopArticleUpdateResult"]],
upsertAuthorTopArticle?: [{	by:ValueTypes["AuthorTopArticleUniqueWhere"],	filter?:ValueTypes["AuthorTopArticleWhere"] | null,	update:ValueTypes["AuthorTopArticleUpdateInput"],	create:ValueTypes["AuthorTopArticleCreateInput"]},ValueTypes["AuthorTopArticleUpsertResult"]],
createContent?: [{	data:ValueTypes["ContentCreateInput"]},ValueTypes["ContentCreateResult"]],
deleteContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["ContentDeleteResult"]],
updateContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null,	data:ValueTypes["ContentUpdateInput"]},ValueTypes["ContentUpdateResult"]],
upsertContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null,	update:ValueTypes["ContentUpdateInput"],	create:ValueTypes["ContentCreateInput"]},ValueTypes["ContentUpsertResult"]],
createContentPart?: [{	data:ValueTypes["ContentPartCreateInput"]},ValueTypes["ContentPartCreateResult"]],
deleteContentPart?: [{	by:ValueTypes["ContentPartUniqueWhere"],	filter?:ValueTypes["ContentPartWhere"] | null},ValueTypes["ContentPartDeleteResult"]],
updateContentPart?: [{	by:ValueTypes["ContentPartUniqueWhere"],	filter?:ValueTypes["ContentPartWhere"] | null,	data:ValueTypes["ContentPartUpdateInput"]},ValueTypes["ContentPartUpdateResult"]],
upsertContentPart?: [{	by:ValueTypes["ContentPartUniqueWhere"],	filter?:ValueTypes["ContentPartWhere"] | null,	update:ValueTypes["ContentPartUpdateInput"],	create:ValueTypes["ContentPartCreateInput"]},ValueTypes["ContentPartUpsertResult"]],
createContentReference?: [{	data:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["ContentReferenceCreateResult"]],
deleteContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReferenceDeleteResult"]],
updateContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null,	data:ValueTypes["ContentReferenceUpdateInput"]},ValueTypes["ContentReferenceUpdateResult"]],
upsertContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null,	update:ValueTypes["ContentReferenceUpdateInput"],	create:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["ContentReferenceUpsertResult"]],
createHomepageArticle?: [{	data:ValueTypes["HomepageArticleCreateInput"]},ValueTypes["HomepageArticleCreateResult"]],
deleteHomepageArticle?: [{	by:ValueTypes["HomepageArticleUniqueWhere"],	filter?:ValueTypes["HomepageArticleWhere"] | null},ValueTypes["HomepageArticleDeleteResult"]],
updateHomepageArticle?: [{	by:ValueTypes["HomepageArticleUniqueWhere"],	filter?:ValueTypes["HomepageArticleWhere"] | null,	data:ValueTypes["HomepageArticleUpdateInput"]},ValueTypes["HomepageArticleUpdateResult"]],
upsertHomepageArticle?: [{	by:ValueTypes["HomepageArticleUniqueWhere"],	filter?:ValueTypes["HomepageArticleWhere"] | null,	update:ValueTypes["HomepageArticleUpdateInput"],	create:ValueTypes["HomepageArticleCreateInput"]},ValueTypes["HomepageArticleUpsertResult"]],
createImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["ImageCreateResult"]],
deleteImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["ImageDeleteResult"]],
updateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	data:ValueTypes["ImageUpdateInput"]},ValueTypes["ImageUpdateResult"]],
upsertImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	update:ValueTypes["ImageUpdateInput"],	create:ValueTypes["ImageCreateInput"]},ValueTypes["ImageUpsertResult"]],
createImageUse?: [{	data:ValueTypes["ImageUseCreateInput"]},ValueTypes["ImageUseCreateResult"]],
deleteImageUse?: [{	by:ValueTypes["ImageUseUniqueWhere"],	filter?:ValueTypes["ImageUseWhere"] | null},ValueTypes["ImageUseDeleteResult"]],
updateImageUse?: [{	by:ValueTypes["ImageUseUniqueWhere"],	filter?:ValueTypes["ImageUseWhere"] | null,	data:ValueTypes["ImageUseUpdateInput"]},ValueTypes["ImageUseUpdateResult"]],
upsertImageUse?: [{	by:ValueTypes["ImageUseUniqueWhere"],	filter?:ValueTypes["ImageUseWhere"] | null,	update:ValueTypes["ImageUseUpdateInput"],	create:ValueTypes["ImageUseCreateInput"]},ValueTypes["ImageUseUpsertResult"]],
createImageTag?: [{	data:ValueTypes["ImageTagCreateInput"]},ValueTypes["ImageTagCreateResult"]],
deleteImageTag?: [{	by:ValueTypes["ImageTagUniqueWhere"],	filter?:ValueTypes["ImageTagWhere"] | null},ValueTypes["ImageTagDeleteResult"]],
updateImageTag?: [{	by:ValueTypes["ImageTagUniqueWhere"],	filter?:ValueTypes["ImageTagWhere"] | null,	data:ValueTypes["ImageTagUpdateInput"]},ValueTypes["ImageTagUpdateResult"]],
upsertImageTag?: [{	by:ValueTypes["ImageTagUniqueWhere"],	filter?:ValueTypes["ImageTagWhere"] | null,	update:ValueTypes["ImageTagUpdateInput"],	create:ValueTypes["ImageTagCreateInput"]},ValueTypes["ImageTagUpsertResult"]],
createIssue?: [{	data:ValueTypes["IssueCreateInput"]},ValueTypes["IssueCreateResult"]],
deleteIssue?: [{	by:ValueTypes["IssueUniqueWhere"],	filter?:ValueTypes["IssueWhere"] | null},ValueTypes["IssueDeleteResult"]],
updateIssue?: [{	by:ValueTypes["IssueUniqueWhere"],	filter?:ValueTypes["IssueWhere"] | null,	data:ValueTypes["IssueUpdateInput"]},ValueTypes["IssueUpdateResult"]],
upsertIssue?: [{	by:ValueTypes["IssueUniqueWhere"],	filter?:ValueTypes["IssueWhere"] | null,	update:ValueTypes["IssueUpdateInput"],	create:ValueTypes["IssueCreateInput"]},ValueTypes["IssueUpsertResult"]],
createIssueArticle?: [{	data:ValueTypes["IssueArticleCreateInput"]},ValueTypes["IssueArticleCreateResult"]],
deleteIssueArticle?: [{	by:ValueTypes["IssueArticleUniqueWhere"],	filter?:ValueTypes["IssueArticleWhere"] | null},ValueTypes["IssueArticleDeleteResult"]],
updateIssueArticle?: [{	by:ValueTypes["IssueArticleUniqueWhere"],	filter?:ValueTypes["IssueArticleWhere"] | null,	data:ValueTypes["IssueArticleUpdateInput"]},ValueTypes["IssueArticleUpdateResult"]],
upsertIssueArticle?: [{	by:ValueTypes["IssueArticleUniqueWhere"],	filter?:ValueTypes["IssueArticleWhere"] | null,	update:ValueTypes["IssueArticleUpdateInput"],	create:ValueTypes["IssueArticleCreateInput"]},ValueTypes["IssueArticleUpsertResult"]],
createLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["LinkCreateResult"]],
deleteLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["LinkDeleteResult"]],
updateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	data:ValueTypes["LinkUpdateInput"]},ValueTypes["LinkUpdateResult"]],
upsertLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	update:ValueTypes["LinkUpdateInput"],	create:ValueTypes["LinkCreateInput"]},ValueTypes["LinkUpsertResult"]],
createTextContent?: [{	data:ValueTypes["TextContentCreateInput"]},ValueTypes["TextContentCreateResult"]],
deleteTextContent?: [{	by:ValueTypes["TextContentUniqueWhere"],	filter?:ValueTypes["TextContentWhere"] | null},ValueTypes["TextContentDeleteResult"]],
updateTextContent?: [{	by:ValueTypes["TextContentUniqueWhere"],	filter?:ValueTypes["TextContentWhere"] | null,	data:ValueTypes["TextContentUpdateInput"]},ValueTypes["TextContentUpdateResult"]],
upsertTextContent?: [{	by:ValueTypes["TextContentUniqueWhere"],	filter?:ValueTypes["TextContentWhere"] | null,	update:ValueTypes["TextContentUpdateInput"],	create:ValueTypes["TextContentCreateInput"]},ValueTypes["TextContentUpsertResult"]],
createTextContentPart?: [{	data:ValueTypes["TextContentPartCreateInput"]},ValueTypes["TextContentPartCreateResult"]],
deleteTextContentPart?: [{	by:ValueTypes["TextContentPartUniqueWhere"],	filter?:ValueTypes["TextContentPartWhere"] | null},ValueTypes["TextContentPartDeleteResult"]],
updateTextContentPart?: [{	by:ValueTypes["TextContentPartUniqueWhere"],	filter?:ValueTypes["TextContentPartWhere"] | null,	data:ValueTypes["TextContentPartUpdateInput"]},ValueTypes["TextContentPartUpdateResult"]],
upsertTextContentPart?: [{	by:ValueTypes["TextContentPartUniqueWhere"],	filter?:ValueTypes["TextContentPartWhere"] | null,	update:ValueTypes["TextContentPartUpdateInput"],	create:ValueTypes["TextContentPartCreateInput"]},ValueTypes["TextContentPartUpsertResult"]],
createTextContentReference?: [{	data:ValueTypes["TextContentReferenceCreateInput"]},ValueTypes["TextContentReferenceCreateResult"]],
deleteTextContentReference?: [{	by:ValueTypes["TextContentReferenceUniqueWhere"],	filter?:ValueTypes["TextContentReferenceWhere"] | null},ValueTypes["TextContentReferenceDeleteResult"]],
updateTextContentReference?: [{	by:ValueTypes["TextContentReferenceUniqueWhere"],	filter?:ValueTypes["TextContentReferenceWhere"] | null,	data:ValueTypes["TextContentReferenceUpdateInput"]},ValueTypes["TextContentReferenceUpdateResult"]],
upsertTextContentReference?: [{	by:ValueTypes["TextContentReferenceUniqueWhere"],	filter?:ValueTypes["TextContentReferenceWhere"] | null,	update:ValueTypes["TextContentReferenceUpdateInput"],	create:ValueTypes["TextContentReferenceCreateInput"]},ValueTypes["TextContentReferenceUpsertResult"]],
createUrl?: [{	data:ValueTypes["UrlCreateInput"]},ValueTypes["UrlCreateResult"]],
deleteUrl?: [{	by:ValueTypes["UrlUniqueWhere"],	filter?:ValueTypes["UrlWhere"] | null},ValueTypes["UrlDeleteResult"]],
updateUrl?: [{	by:ValueTypes["UrlUniqueWhere"],	filter?:ValueTypes["UrlWhere"] | null,	data:ValueTypes["UrlUpdateInput"]},ValueTypes["UrlUpdateResult"]],
upsertUrl?: [{	by:ValueTypes["UrlUniqueWhere"],	filter?:ValueTypes["UrlWhere"] | null,	update:ValueTypes["UrlUpdateInput"],	create:ValueTypes["UrlCreateInput"]},ValueTypes["UrlUpsertResult"]],
createArticleTag?: [{	data:ValueTypes["ArticleTagCreateInput"]},ValueTypes["ArticleTagCreateResult"]],
deleteArticleTag?: [{	by:ValueTypes["ArticleTagUniqueWhere"],	filter?:ValueTypes["ArticleTagWhere"] | null},ValueTypes["ArticleTagDeleteResult"]],
updateArticleTag?: [{	by:ValueTypes["ArticleTagUniqueWhere"],	filter?:ValueTypes["ArticleTagWhere"] | null,	data:ValueTypes["ArticleTagUpdateInput"]},ValueTypes["ArticleTagUpdateResult"]],
upsertArticleTag?: [{	by:ValueTypes["ArticleTagUniqueWhere"],	filter?:ValueTypes["ArticleTagWhere"] | null,	update:ValueTypes["ArticleTagUpdateInput"],	create:ValueTypes["ArticleTagCreateInput"]},ValueTypes["ArticleTagUpsertResult"]],
createCategory?: [{	data:ValueTypes["CategoryCreateInput"]},ValueTypes["CategoryCreateResult"]],
deleteCategory?: [{	by:ValueTypes["CategoryUniqueWhere"],	filter?:ValueTypes["CategoryWhere"] | null},ValueTypes["CategoryDeleteResult"]],
updateCategory?: [{	by:ValueTypes["CategoryUniqueWhere"],	filter?:ValueTypes["CategoryWhere"] | null,	data:ValueTypes["CategoryUpdateInput"]},ValueTypes["CategoryUpdateResult"]],
upsertCategory?: [{	by:ValueTypes["CategoryUniqueWhere"],	filter?:ValueTypes["CategoryWhere"] | null,	update:ValueTypes["CategoryUpdateInput"],	create:ValueTypes["CategoryCreateInput"]},ValueTypes["CategoryUpsertResult"]],
createArticleCategory?: [{	data:ValueTypes["ArticleCategoryCreateInput"]},ValueTypes["ArticleCategoryCreateResult"]],
deleteArticleCategory?: [{	by:ValueTypes["ArticleCategoryUniqueWhere"],	filter?:ValueTypes["ArticleCategoryWhere"] | null},ValueTypes["ArticleCategoryDeleteResult"]],
updateArticleCategory?: [{	by:ValueTypes["ArticleCategoryUniqueWhere"],	filter?:ValueTypes["ArticleCategoryWhere"] | null,	data:ValueTypes["ArticleCategoryUpdateInput"]},ValueTypes["ArticleCategoryUpdateResult"]],
upsertArticleCategory?: [{	by:ValueTypes["ArticleCategoryUniqueWhere"],	filter?:ValueTypes["ArticleCategoryWhere"] | null,	update:ValueTypes["ArticleCategoryUpdateInput"],	create:ValueTypes["ArticleCategoryCreateInput"]},ValueTypes["ArticleCategoryUpsertResult"]],
createAudio?: [{	data:ValueTypes["AudioCreateInput"]},ValueTypes["AudioCreateResult"]],
deleteAudio?: [{	by:ValueTypes["AudioUniqueWhere"],	filter?:ValueTypes["AudioWhere"] | null},ValueTypes["AudioDeleteResult"]],
updateAudio?: [{	by:ValueTypes["AudioUniqueWhere"],	filter?:ValueTypes["AudioWhere"] | null,	data:ValueTypes["AudioUpdateInput"]},ValueTypes["AudioUpdateResult"]],
upsertAudio?: [{	by:ValueTypes["AudioUniqueWhere"],	filter?:ValueTypes["AudioWhere"] | null,	update:ValueTypes["AudioUpdateInput"],	create:ValueTypes["AudioCreateInput"]},ValueTypes["AudioUpsertResult"]],
createAudioUse?: [{	data:ValueTypes["AudioUseCreateInput"]},ValueTypes["AudioUseCreateResult"]],
deleteAudioUse?: [{	by:ValueTypes["AudioUseUniqueWhere"],	filter?:ValueTypes["AudioUseWhere"] | null},ValueTypes["AudioUseDeleteResult"]],
updateAudioUse?: [{	by:ValueTypes["AudioUseUniqueWhere"],	filter?:ValueTypes["AudioUseWhere"] | null,	data:ValueTypes["AudioUseUpdateInput"]},ValueTypes["AudioUseUpdateResult"]],
upsertAudioUse?: [{	by:ValueTypes["AudioUseUniqueWhere"],	filter?:ValueTypes["AudioUseWhere"] | null,	update:ValueTypes["AudioUseUpdateInput"],	create:ValueTypes["AudioUseCreateInput"]},ValueTypes["AudioUseUpsertResult"]],
createEmbed?: [{	data:ValueTypes["EmbedCreateInput"]},ValueTypes["EmbedCreateResult"]],
deleteEmbed?: [{	by:ValueTypes["EmbedUniqueWhere"],	filter?:ValueTypes["EmbedWhere"] | null},ValueTypes["EmbedDeleteResult"]],
updateEmbed?: [{	by:ValueTypes["EmbedUniqueWhere"],	filter?:ValueTypes["EmbedWhere"] | null,	data:ValueTypes["EmbedUpdateInput"]},ValueTypes["EmbedUpdateResult"]],
upsertEmbed?: [{	by:ValueTypes["EmbedUniqueWhere"],	filter?:ValueTypes["EmbedWhere"] | null,	update:ValueTypes["EmbedUpdateInput"],	create:ValueTypes["EmbedCreateInput"]},ValueTypes["EmbedUpsertResult"]],
createImageContent?: [{	data:ValueTypes["ImageContentCreateInput"]},ValueTypes["ImageContentCreateResult"]],
deleteImageContent?: [{	by:ValueTypes["ImageContentUniqueWhere"],	filter?:ValueTypes["ImageContentWhere"] | null},ValueTypes["ImageContentDeleteResult"]],
updateImageContent?: [{	by:ValueTypes["ImageContentUniqueWhere"],	filter?:ValueTypes["ImageContentWhere"] | null,	data:ValueTypes["ImageContentUpdateInput"]},ValueTypes["ImageContentUpdateResult"]],
upsertImageContent?: [{	by:ValueTypes["ImageContentUniqueWhere"],	filter?:ValueTypes["ImageContentWhere"] | null,	update:ValueTypes["ImageContentUpdateInput"],	create:ValueTypes["ImageContentCreateInput"]},ValueTypes["ImageContentUpsertResult"]],
createListicle?: [{	data:ValueTypes["ListicleCreateInput"]},ValueTypes["ListicleCreateResult"]],
deleteListicle?: [{	by:ValueTypes["ListicleUniqueWhere"],	filter?:ValueTypes["ListicleWhere"] | null},ValueTypes["ListicleDeleteResult"]],
updateListicle?: [{	by:ValueTypes["ListicleUniqueWhere"],	filter?:ValueTypes["ListicleWhere"] | null,	data:ValueTypes["ListicleUpdateInput"]},ValueTypes["ListicleUpdateResult"]],
upsertListicle?: [{	by:ValueTypes["ListicleUniqueWhere"],	filter?:ValueTypes["ListicleWhere"] | null,	update:ValueTypes["ListicleUpdateInput"],	create:ValueTypes["ListicleCreateInput"]},ValueTypes["ListicleUpsertResult"]],
createPollAnswer?: [{	data:ValueTypes["PollAnswerCreateInput"]},ValueTypes["PollAnswerCreateResult"]],
deletePollAnswer?: [{	by:ValueTypes["PollAnswerUniqueWhere"],	filter?:ValueTypes["PollAnswerWhere"] | null},ValueTypes["PollAnswerDeleteResult"]],
updatePollAnswer?: [{	by:ValueTypes["PollAnswerUniqueWhere"],	filter?:ValueTypes["PollAnswerWhere"] | null,	data:ValueTypes["PollAnswerUpdateInput"]},ValueTypes["PollAnswerUpdateResult"]],
upsertPollAnswer?: [{	by:ValueTypes["PollAnswerUniqueWhere"],	filter?:ValueTypes["PollAnswerWhere"] | null,	update:ValueTypes["PollAnswerUpdateInput"],	create:ValueTypes["PollAnswerCreateInput"]},ValueTypes["PollAnswerUpsertResult"]],
createTag?: [{	data:ValueTypes["TagCreateInput"]},ValueTypes["TagCreateResult"]],
deleteTag?: [{	by:ValueTypes["TagUniqueWhere"],	filter?:ValueTypes["TagWhere"] | null},ValueTypes["TagDeleteResult"]],
updateTag?: [{	by:ValueTypes["TagUniqueWhere"],	filter?:ValueTypes["TagWhere"] | null,	data:ValueTypes["TagUpdateInput"]},ValueTypes["TagUpdateResult"]],
upsertTag?: [{	by:ValueTypes["TagUniqueWhere"],	filter?:ValueTypes["TagWhere"] | null,	update:ValueTypes["TagUpdateInput"],	create:ValueTypes["TagCreateInput"]},ValueTypes["TagUpsertResult"]],
createFAQ?: [{	data:ValueTypes["FAQCreateInput"]},ValueTypes["FAQCreateResult"]],
deleteFAQ?: [{	by:ValueTypes["FAQUniqueWhere"],	filter?:ValueTypes["FAQWhere"] | null},ValueTypes["FAQDeleteResult"]],
updateFAQ?: [{	by:ValueTypes["FAQUniqueWhere"],	filter?:ValueTypes["FAQWhere"] | null,	data:ValueTypes["FAQUpdateInput"]},ValueTypes["FAQUpdateResult"]],
upsertFAQ?: [{	by:ValueTypes["FAQUniqueWhere"],	filter?:ValueTypes["FAQWhere"] | null,	update:ValueTypes["FAQUpdateInput"],	create:ValueTypes["FAQCreateInput"]},ValueTypes["FAQUpsertResult"]],
createLinkContent?: [{	data:ValueTypes["LinkContentCreateInput"]},ValueTypes["LinkContentCreateResult"]],
deleteLinkContent?: [{	by:ValueTypes["LinkContentUniqueWhere"],	filter?:ValueTypes["LinkContentWhere"] | null},ValueTypes["LinkContentDeleteResult"]],
updateLinkContent?: [{	by:ValueTypes["LinkContentUniqueWhere"],	filter?:ValueTypes["LinkContentWhere"] | null,	data:ValueTypes["LinkContentUpdateInput"]},ValueTypes["LinkContentUpdateResult"]],
upsertLinkContent?: [{	by:ValueTypes["LinkContentUniqueWhere"],	filter?:ValueTypes["LinkContentWhere"] | null,	update:ValueTypes["LinkContentUpdateInput"],	create:ValueTypes["LinkContentCreateInput"]},ValueTypes["LinkContentUpsertResult"]],
createAwardContent?: [{	data:ValueTypes["AwardContentCreateInput"]},ValueTypes["AwardContentCreateResult"]],
deleteAwardContent?: [{	by:ValueTypes["AwardContentUniqueWhere"],	filter?:ValueTypes["AwardContentWhere"] | null},ValueTypes["AwardContentDeleteResult"]],
updateAwardContent?: [{	by:ValueTypes["AwardContentUniqueWhere"],	filter?:ValueTypes["AwardContentWhere"] | null,	data:ValueTypes["AwardContentUpdateInput"]},ValueTypes["AwardContentUpdateResult"]],
upsertAwardContent?: [{	by:ValueTypes["AwardContentUniqueWhere"],	filter?:ValueTypes["AwardContentWhere"] | null,	update:ValueTypes["AwardContentUpdateInput"],	create:ValueTypes["AwardContentCreateInput"]},ValueTypes["AwardContentUpsertResult"]],
createReviewContent?: [{	data:ValueTypes["ReviewContentCreateInput"]},ValueTypes["ReviewContentCreateResult"]],
deleteReviewContent?: [{	by:ValueTypes["ReviewContentUniqueWhere"],	filter?:ValueTypes["ReviewContentWhere"] | null},ValueTypes["ReviewContentDeleteResult"]],
updateReviewContent?: [{	by:ValueTypes["ReviewContentUniqueWhere"],	filter?:ValueTypes["ReviewContentWhere"] | null,	data:ValueTypes["ReviewContentUpdateInput"]},ValueTypes["ReviewContentUpdateResult"]],
upsertReviewContent?: [{	by:ValueTypes["ReviewContentUniqueWhere"],	filter?:ValueTypes["ReviewContentWhere"] | null,	update:ValueTypes["ReviewContentUpdateInput"],	create:ValueTypes["ReviewContentCreateInput"]},ValueTypes["ReviewContentUpsertResult"]],
createPage?: [{	data:ValueTypes["PageCreateInput"]},ValueTypes["PageCreateResult"]],
deletePage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null},ValueTypes["PageDeleteResult"]],
updatePage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null,	data:ValueTypes["PageUpdateInput"]},ValueTypes["PageUpdateResult"]],
upsertPage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null,	update:ValueTypes["PageUpdateInput"],	create:ValueTypes["PageCreateInput"]},ValueTypes["PageUpsertResult"]],
createTextTranslation?: [{	data:ValueTypes["TextTranslationCreateInput"]},ValueTypes["TextTranslationCreateResult"]],
deleteTextTranslation?: [{	by:ValueTypes["TextTranslationUniqueWhere"],	filter?:ValueTypes["TextTranslationWhere"] | null},ValueTypes["TextTranslationDeleteResult"]],
updateTextTranslation?: [{	by:ValueTypes["TextTranslationUniqueWhere"],	filter?:ValueTypes["TextTranslationWhere"] | null,	data:ValueTypes["TextTranslationUpdateInput"]},ValueTypes["TextTranslationUpdateResult"]],
upsertTextTranslation?: [{	by:ValueTypes["TextTranslationUniqueWhere"],	filter?:ValueTypes["TextTranslationWhere"] | null,	update:ValueTypes["TextTranslationUpdateInput"],	create:ValueTypes["TextTranslationCreateInput"]},ValueTypes["TextTranslationUpsertResult"]],
createSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["SeoCreateResult"]],
deleteSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["SeoDeleteResult"]],
updateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	data:ValueTypes["SeoUpdateInput"]},ValueTypes["SeoUpdateResult"]],
upsertSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	update:ValueTypes["SeoUpdateInput"],	create:ValueTypes["SeoCreateInput"]},ValueTypes["SeoUpsertResult"]],
createFile?: [{	data:ValueTypes["FileCreateInput"]},ValueTypes["FileCreateResult"]],
deleteFile?: [{	by:ValueTypes["FileUniqueWhere"],	filter?:ValueTypes["FileWhere"] | null},ValueTypes["FileDeleteResult"]],
updateFile?: [{	by:ValueTypes["FileUniqueWhere"],	filter?:ValueTypes["FileWhere"] | null,	data:ValueTypes["FileUpdateInput"]},ValueTypes["FileUpdateResult"]],
upsertFile?: [{	by:ValueTypes["FileUniqueWhere"],	filter?:ValueTypes["FileWhere"] | null,	update:ValueTypes["FileUpdateInput"],	create:ValueTypes["FileCreateInput"]},ValueTypes["FileUpsertResult"]],
createFileUse?: [{	data:ValueTypes["FileUseCreateInput"]},ValueTypes["FileUseCreateResult"]],
deleteFileUse?: [{	by:ValueTypes["FileUseUniqueWhere"],	filter?:ValueTypes["FileUseWhere"] | null},ValueTypes["FileUseDeleteResult"]],
updateFileUse?: [{	by:ValueTypes["FileUseUniqueWhere"],	filter?:ValueTypes["FileUseWhere"] | null,	data:ValueTypes["FileUseUpdateInput"]},ValueTypes["FileUseUpdateResult"]],
upsertFileUse?: [{	by:ValueTypes["FileUseUniqueWhere"],	filter?:ValueTypes["FileUseWhere"] | null,	update:ValueTypes["FileUseUpdateInput"],	create:ValueTypes["FileUseCreateInput"]},ValueTypes["FileUseUpsertResult"]],
createContentBlock?: [{	data:ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockCreateResult"]],
deleteContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlockDeleteResult"]],
updateContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null,	data:ValueTypes["ContentBlockUpdateInput"]},ValueTypes["ContentBlockUpdateResult"]],
upsertContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null,	update:ValueTypes["ContentBlockUpdateInput"],	create:ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockUpsertResult"]],
createContentArticle?: [{	data:ValueTypes["ContentArticleCreateInput"]},ValueTypes["ContentArticleCreateResult"]],
deleteContentArticle?: [{	by:ValueTypes["ContentArticleUniqueWhere"],	filter?:ValueTypes["ContentArticleWhere"] | null},ValueTypes["ContentArticleDeleteResult"]],
updateContentArticle?: [{	by:ValueTypes["ContentArticleUniqueWhere"],	filter?:ValueTypes["ContentArticleWhere"] | null,	data:ValueTypes["ContentArticleUpdateInput"]},ValueTypes["ContentArticleUpdateResult"]],
upsertContentArticle?: [{	by:ValueTypes["ContentArticleUniqueWhere"],	filter?:ValueTypes["ContentArticleWhere"] | null,	update:ValueTypes["ContentArticleUpdateInput"],	create:ValueTypes["ContentArticleCreateInput"]},ValueTypes["ContentArticleUpsertResult"]],
createUnlockedArticle?: [{	data:ValueTypes["UnlockedArticleCreateInput"]},ValueTypes["UnlockedArticleCreateResult"]],
deleteUnlockedArticle?: [{	by:ValueTypes["UnlockedArticleUniqueWhere"],	filter?:ValueTypes["UnlockedArticleWhere"] | null},ValueTypes["UnlockedArticleDeleteResult"]],
updateUnlockedArticle?: [{	by:ValueTypes["UnlockedArticleUniqueWhere"],	filter?:ValueTypes["UnlockedArticleWhere"] | null,	data:ValueTypes["UnlockedArticleUpdateInput"]},ValueTypes["UnlockedArticleUpdateResult"]],
upsertUnlockedArticle?: [{	by:ValueTypes["UnlockedArticleUniqueWhere"],	filter?:ValueTypes["UnlockedArticleWhere"] | null,	update:ValueTypes["UnlockedArticleUpdateInput"],	create:ValueTypes["UnlockedArticleCreateInput"]},ValueTypes["UnlockedArticleUpsertResult"]],
createUser?: [{	data:ValueTypes["UserCreateInput"]},ValueTypes["UserCreateResult"]],
deleteUser?: [{	by:ValueTypes["UserUniqueWhere"],	filter?:ValueTypes["UserWhere"] | null},ValueTypes["UserDeleteResult"]],
updateUser?: [{	by:ValueTypes["UserUniqueWhere"],	filter?:ValueTypes["UserWhere"] | null,	data:ValueTypes["UserUpdateInput"]},ValueTypes["UserUpdateResult"]],
upsertUser?: [{	by:ValueTypes["UserUniqueWhere"],	filter?:ValueTypes["UserWhere"] | null,	update:ValueTypes["UserUpdateInput"],	create:ValueTypes["UserCreateInput"]},ValueTypes["UserUpsertResult"]],
createNotification?: [{	data:ValueTypes["NotificationCreateInput"]},ValueTypes["NotificationCreateResult"]],
deleteNotification?: [{	by:ValueTypes["NotificationUniqueWhere"],	filter?:ValueTypes["NotificationWhere"] | null},ValueTypes["NotificationDeleteResult"]],
updateNotification?: [{	by:ValueTypes["NotificationUniqueWhere"],	filter?:ValueTypes["NotificationWhere"] | null,	data:ValueTypes["NotificationUpdateInput"]},ValueTypes["NotificationUpdateResult"]],
upsertNotification?: [{	by:ValueTypes["NotificationUniqueWhere"],	filter?:ValueTypes["NotificationWhere"] | null,	update:ValueTypes["NotificationUpdateInput"],	create:ValueTypes["NotificationCreateInput"]},ValueTypes["NotificationUpsertResult"]],
createAppReview?: [{	data:ValueTypes["AppReviewCreateInput"]},ValueTypes["AppReviewCreateResult"]],
deleteAppReview?: [{	by:ValueTypes["AppReviewUniqueWhere"],	filter?:ValueTypes["AppReviewWhere"] | null},ValueTypes["AppReviewDeleteResult"]],
updateAppReview?: [{	by:ValueTypes["AppReviewUniqueWhere"],	filter?:ValueTypes["AppReviewWhere"] | null,	data:ValueTypes["AppReviewUpdateInput"]},ValueTypes["AppReviewUpdateResult"]],
upsertAppReview?: [{	by:ValueTypes["AppReviewUniqueWhere"],	filter?:ValueTypes["AppReviewWhere"] | null,	update:ValueTypes["AppReviewUpdateInput"],	create:ValueTypes["AppReviewCreateInput"]},ValueTypes["AppReviewUpsertResult"]],
createProduct?: [{	data:ValueTypes["ProductCreateInput"]},ValueTypes["ProductCreateResult"]],
deleteProduct?: [{	by:ValueTypes["ProductUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["ProductDeleteResult"]],
updateProduct?: [{	by:ValueTypes["ProductUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null,	data:ValueTypes["ProductUpdateInput"]},ValueTypes["ProductUpdateResult"]],
upsertProduct?: [{	by:ValueTypes["ProductUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null,	update:ValueTypes["ProductUpdateInput"],	create:ValueTypes["ProductCreateInput"]},ValueTypes["ProductUpsertResult"]],
createSubscriptionForm?: [{	data:ValueTypes["SubscriptionFormCreateInput"]},ValueTypes["SubscriptionFormCreateResult"]],
deleteSubscriptionForm?: [{	by:ValueTypes["SubscriptionFormUniqueWhere"],	filter?:ValueTypes["SubscriptionFormWhere"] | null},ValueTypes["SubscriptionFormDeleteResult"]],
updateSubscriptionForm?: [{	by:ValueTypes["SubscriptionFormUniqueWhere"],	filter?:ValueTypes["SubscriptionFormWhere"] | null,	data:ValueTypes["SubscriptionFormUpdateInput"]},ValueTypes["SubscriptionFormUpdateResult"]],
upsertSubscriptionForm?: [{	by:ValueTypes["SubscriptionFormUniqueWhere"],	filter?:ValueTypes["SubscriptionFormWhere"] | null,	update:ValueTypes["SubscriptionFormUpdateInput"],	create:ValueTypes["SubscriptionFormCreateInput"]},ValueTypes["SubscriptionFormUpsertResult"]],
createSubscriptionFormSection?: [{	data:ValueTypes["SubscriptionFormSectionCreateInput"]},ValueTypes["SubscriptionFormSectionCreateResult"]],
deleteSubscriptionFormSection?: [{	by:ValueTypes["SubscriptionFormSectionUniqueWhere"],	filter?:ValueTypes["SubscriptionFormSectionWhere"] | null},ValueTypes["SubscriptionFormSectionDeleteResult"]],
updateSubscriptionFormSection?: [{	by:ValueTypes["SubscriptionFormSectionUniqueWhere"],	filter?:ValueTypes["SubscriptionFormSectionWhere"] | null,	data:ValueTypes["SubscriptionFormSectionUpdateInput"]},ValueTypes["SubscriptionFormSectionUpdateResult"]],
upsertSubscriptionFormSection?: [{	by:ValueTypes["SubscriptionFormSectionUniqueWhere"],	filter?:ValueTypes["SubscriptionFormSectionWhere"] | null,	update:ValueTypes["SubscriptionFormSectionUpdateInput"],	create:ValueTypes["SubscriptionFormSectionCreateInput"]},ValueTypes["SubscriptionFormSectionUpsertResult"]],
createSubscriptionFormInput?: [{	data:ValueTypes["SubscriptionFormInputCreateInput"]},ValueTypes["SubscriptionFormInputCreateResult"]],
deleteSubscriptionFormInput?: [{	by:ValueTypes["SubscriptionFormInputUniqueWhere"],	filter?:ValueTypes["SubscriptionFormInputWhere"] | null},ValueTypes["SubscriptionFormInputDeleteResult"]],
updateSubscriptionFormInput?: [{	by:ValueTypes["SubscriptionFormInputUniqueWhere"],	filter?:ValueTypes["SubscriptionFormInputWhere"] | null,	data:ValueTypes["SubscriptionFormInputUpdateInput"]},ValueTypes["SubscriptionFormInputUpdateResult"]],
upsertSubscriptionFormInput?: [{	by:ValueTypes["SubscriptionFormInputUniqueWhere"],	filter?:ValueTypes["SubscriptionFormInputWhere"] | null,	update:ValueTypes["SubscriptionFormInputUpdateInput"],	create:ValueTypes["SubscriptionFormInputCreateInput"]},ValueTypes["SubscriptionFormInputUpsertResult"]],
createSubscriptionFormOption?: [{	data:ValueTypes["SubscriptionFormOptionCreateInput"]},ValueTypes["SubscriptionFormOptionCreateResult"]],
deleteSubscriptionFormOption?: [{	by:ValueTypes["SubscriptionFormOptionUniqueWhere"],	filter?:ValueTypes["SubscriptionFormOptionWhere"] | null},ValueTypes["SubscriptionFormOptionDeleteResult"]],
updateSubscriptionFormOption?: [{	by:ValueTypes["SubscriptionFormOptionUniqueWhere"],	filter?:ValueTypes["SubscriptionFormOptionWhere"] | null,	data:ValueTypes["SubscriptionFormOptionUpdateInput"]},ValueTypes["SubscriptionFormOptionUpdateResult"]],
upsertSubscriptionFormOption?: [{	by:ValueTypes["SubscriptionFormOptionUniqueWhere"],	filter?:ValueTypes["SubscriptionFormOptionWhere"] | null,	update:ValueTypes["SubscriptionFormOptionUpdateInput"],	create:ValueTypes["SubscriptionFormOptionCreateInput"]},ValueTypes["SubscriptionFormOptionUpsertResult"]],
createButton?: [{	data:ValueTypes["ButtonCreateInput"]},ValueTypes["ButtonCreateResult"]],
deleteButton?: [{	by:ValueTypes["ButtonUniqueWhere"],	filter?:ValueTypes["ButtonWhere"] | null},ValueTypes["ButtonDeleteResult"]],
updateButton?: [{	by:ValueTypes["ButtonUniqueWhere"],	filter?:ValueTypes["ButtonWhere"] | null,	data:ValueTypes["ButtonUpdateInput"]},ValueTypes["ButtonUpdateResult"]],
upsertButton?: [{	by:ValueTypes["ButtonUniqueWhere"],	filter?:ValueTypes["ButtonWhere"] | null,	update:ValueTypes["ButtonUpdateInput"],	create:ValueTypes["ButtonCreateInput"]},ValueTypes["ButtonUpsertResult"]],
createArticleHistoryTag?: [{	data:ValueTypes["ArticleHistoryTagCreateInput"]},ValueTypes["ArticleHistoryTagCreateResult"]],
deleteArticleHistoryTag?: [{	by:ValueTypes["ArticleHistoryTagUniqueWhere"],	filter?:ValueTypes["ArticleHistoryTagWhere"] | null},ValueTypes["ArticleHistoryTagDeleteResult"]],
updateArticleHistoryTag?: [{	by:ValueTypes["ArticleHistoryTagUniqueWhere"],	filter?:ValueTypes["ArticleHistoryTagWhere"] | null,	data:ValueTypes["ArticleHistoryTagUpdateInput"]},ValueTypes["ArticleHistoryTagUpdateResult"]],
upsertArticleHistoryTag?: [{	by:ValueTypes["ArticleHistoryTagUniqueWhere"],	filter?:ValueTypes["ArticleHistoryTagWhere"] | null,	update:ValueTypes["ArticleHistoryTagUpdateInput"],	create:ValueTypes["ArticleHistoryTagCreateInput"]},ValueTypes["ArticleHistoryTagUpsertResult"]],
createArticleHistoryPeriod?: [{	data:ValueTypes["ArticleHistoryPeriodCreateInput"]},ValueTypes["ArticleHistoryPeriodCreateResult"]],
deleteArticleHistoryPeriod?: [{	by:ValueTypes["ArticleHistoryPeriodUniqueWhere"],	filter?:ValueTypes["ArticleHistoryPeriodWhere"] | null},ValueTypes["ArticleHistoryPeriodDeleteResult"]],
updateArticleHistoryPeriod?: [{	by:ValueTypes["ArticleHistoryPeriodUniqueWhere"],	filter?:ValueTypes["ArticleHistoryPeriodWhere"] | null,	data:ValueTypes["ArticleHistoryPeriodUpdateInput"]},ValueTypes["ArticleHistoryPeriodUpdateResult"]],
upsertArticleHistoryPeriod?: [{	by:ValueTypes["ArticleHistoryPeriodUniqueWhere"],	filter?:ValueTypes["ArticleHistoryPeriodWhere"] | null,	update:ValueTypes["ArticleHistoryPeriodUpdateInput"],	create:ValueTypes["ArticleHistoryPeriodCreateInput"]},ValueTypes["ArticleHistoryPeriodUpsertResult"]],
createHistoryTag?: [{	data:ValueTypes["HistoryTagCreateInput"]},ValueTypes["HistoryTagCreateResult"]],
deleteHistoryTag?: [{	by:ValueTypes["HistoryTagUniqueWhere"],	filter?:ValueTypes["HistoryTagWhere"] | null},ValueTypes["HistoryTagDeleteResult"]],
updateHistoryTag?: [{	by:ValueTypes["HistoryTagUniqueWhere"],	filter?:ValueTypes["HistoryTagWhere"] | null,	data:ValueTypes["HistoryTagUpdateInput"]},ValueTypes["HistoryTagUpdateResult"]],
upsertHistoryTag?: [{	by:ValueTypes["HistoryTagUniqueWhere"],	filter?:ValueTypes["HistoryTagWhere"] | null,	update:ValueTypes["HistoryTagUpdateInput"],	create:ValueTypes["HistoryTagCreateInput"]},ValueTypes["HistoryTagUpsertResult"]],
createHistoryPeriod?: [{	data:ValueTypes["HistoryPeriodCreateInput"]},ValueTypes["HistoryPeriodCreateResult"]],
deleteHistoryPeriod?: [{	by:ValueTypes["HistoryPeriodUniqueWhere"],	filter?:ValueTypes["HistoryPeriodWhere"] | null},ValueTypes["HistoryPeriodDeleteResult"]],
updateHistoryPeriod?: [{	by:ValueTypes["HistoryPeriodUniqueWhere"],	filter?:ValueTypes["HistoryPeriodWhere"] | null,	data:ValueTypes["HistoryPeriodUpdateInput"]},ValueTypes["HistoryPeriodUpdateResult"]],
upsertHistoryPeriod?: [{	by:ValueTypes["HistoryPeriodUniqueWhere"],	filter?:ValueTypes["HistoryPeriodWhere"] | null,	update:ValueTypes["HistoryPeriodUpdateInput"],	create:ValueTypes["HistoryPeriodCreateInput"]},ValueTypes["HistoryPeriodUpsertResult"]],
createHistoryHomePage?: [{	data:ValueTypes["HistoryHomePageCreateInput"]},ValueTypes["HistoryHomePageCreateResult"]],
deleteHistoryHomePage?: [{	by:ValueTypes["HistoryHomePageUniqueWhere"],	filter?:ValueTypes["HistoryHomePageWhere"] | null},ValueTypes["HistoryHomePageDeleteResult"]],
updateHistoryHomePage?: [{	by:ValueTypes["HistoryHomePageUniqueWhere"],	filter?:ValueTypes["HistoryHomePageWhere"] | null,	data:ValueTypes["HistoryHomePageUpdateInput"]},ValueTypes["HistoryHomePageUpdateResult"]],
upsertHistoryHomePage?: [{	by:ValueTypes["HistoryHomePageUniqueWhere"],	filter?:ValueTypes["HistoryHomePageWhere"] | null,	update:ValueTypes["HistoryHomePageUpdateInput"],	create:ValueTypes["HistoryHomePageCreateInput"]},ValueTypes["HistoryHomePageUpsertResult"]],
createHistoryCover?: [{	data:ValueTypes["HistoryCoverCreateInput"]},ValueTypes["HistoryCoverCreateResult"]],
deleteHistoryCover?: [{	by:ValueTypes["HistoryCoverUniqueWhere"],	filter?:ValueTypes["HistoryCoverWhere"] | null},ValueTypes["HistoryCoverDeleteResult"]],
updateHistoryCover?: [{	by:ValueTypes["HistoryCoverUniqueWhere"],	filter?:ValueTypes["HistoryCoverWhere"] | null,	data:ValueTypes["HistoryCoverUpdateInput"]},ValueTypes["HistoryCoverUpdateResult"]],
upsertHistoryCover?: [{	by:ValueTypes["HistoryCoverUniqueWhere"],	filter?:ValueTypes["HistoryCoverWhere"] | null,	update:ValueTypes["HistoryCoverUpdateInput"],	create:ValueTypes["HistoryCoverCreateInput"]},ValueTypes["HistoryCoverUpsertResult"]],
createHistoryTextList?: [{	data:ValueTypes["HistoryTextListCreateInput"]},ValueTypes["HistoryTextListCreateResult"]],
deleteHistoryTextList?: [{	by:ValueTypes["HistoryTextListUniqueWhere"],	filter?:ValueTypes["HistoryTextListWhere"] | null},ValueTypes["HistoryTextListDeleteResult"]],
updateHistoryTextList?: [{	by:ValueTypes["HistoryTextListUniqueWhere"],	filter?:ValueTypes["HistoryTextListWhere"] | null,	data:ValueTypes["HistoryTextListUpdateInput"]},ValueTypes["HistoryTextListUpdateResult"]],
upsertHistoryTextList?: [{	by:ValueTypes["HistoryTextListUniqueWhere"],	filter?:ValueTypes["HistoryTextListWhere"] | null,	update:ValueTypes["HistoryTextListUpdateInput"],	create:ValueTypes["HistoryTextListCreateInput"]},ValueTypes["HistoryTextListUpsertResult"]],
createHistoryTextItem?: [{	data:ValueTypes["HistoryTextItemCreateInput"]},ValueTypes["HistoryTextItemCreateResult"]],
deleteHistoryTextItem?: [{	by:ValueTypes["HistoryTextItemUniqueWhere"],	filter?:ValueTypes["HistoryTextItemWhere"] | null},ValueTypes["HistoryTextItemDeleteResult"]],
updateHistoryTextItem?: [{	by:ValueTypes["HistoryTextItemUniqueWhere"],	filter?:ValueTypes["HistoryTextItemWhere"] | null,	data:ValueTypes["HistoryTextItemUpdateInput"]},ValueTypes["HistoryTextItemUpdateResult"]],
upsertHistoryTextItem?: [{	by:ValueTypes["HistoryTextItemUniqueWhere"],	filter?:ValueTypes["HistoryTextItemWhere"] | null,	update:ValueTypes["HistoryTextItemUpdateInput"],	create:ValueTypes["HistoryTextItemCreateInput"]},ValueTypes["HistoryTextItemUpsertResult"]],
createFooterMenu?: [{	data:ValueTypes["FooterMenuCreateInput"]},ValueTypes["FooterMenuCreateResult"]],
deleteFooterMenu?: [{	by:ValueTypes["FooterMenuUniqueWhere"],	filter?:ValueTypes["FooterMenuWhere"] | null},ValueTypes["FooterMenuDeleteResult"]],
updateFooterMenu?: [{	by:ValueTypes["FooterMenuUniqueWhere"],	filter?:ValueTypes["FooterMenuWhere"] | null,	data:ValueTypes["FooterMenuUpdateInput"]},ValueTypes["FooterMenuUpdateResult"]],
upsertFooterMenu?: [{	by:ValueTypes["FooterMenuUniqueWhere"],	filter?:ValueTypes["FooterMenuWhere"] | null,	update:ValueTypes["FooterMenuUpdateInput"],	create:ValueTypes["FooterMenuCreateInput"]},ValueTypes["FooterMenuUpsertResult"]],
createLinkSection?: [{	data:ValueTypes["LinkSectionCreateInput"]},ValueTypes["LinkSectionCreateResult"]],
deleteLinkSection?: [{	by:ValueTypes["LinkSectionUniqueWhere"],	filter?:ValueTypes["LinkSectionWhere"] | null},ValueTypes["LinkSectionDeleteResult"]],
updateLinkSection?: [{	by:ValueTypes["LinkSectionUniqueWhere"],	filter?:ValueTypes["LinkSectionWhere"] | null,	data:ValueTypes["LinkSectionUpdateInput"]},ValueTypes["LinkSectionUpdateResult"]],
upsertLinkSection?: [{	by:ValueTypes["LinkSectionUniqueWhere"],	filter?:ValueTypes["LinkSectionWhere"] | null,	update:ValueTypes["LinkSectionUpdateInput"],	create:ValueTypes["LinkSectionCreateInput"]},ValueTypes["LinkSectionUpsertResult"]],
createLinkList?: [{	data:ValueTypes["LinkListCreateInput"]},ValueTypes["LinkListCreateResult"]],
deleteLinkList?: [{	by:ValueTypes["LinkListUniqueWhere"],	filter?:ValueTypes["LinkListWhere"] | null},ValueTypes["LinkListDeleteResult"]],
updateLinkList?: [{	by:ValueTypes["LinkListUniqueWhere"],	filter?:ValueTypes["LinkListWhere"] | null,	data:ValueTypes["LinkListUpdateInput"]},ValueTypes["LinkListUpdateResult"]],
upsertLinkList?: [{	by:ValueTypes["LinkListUniqueWhere"],	filter?:ValueTypes["LinkListWhere"] | null,	update:ValueTypes["LinkListUpdateInput"],	create:ValueTypes["LinkListCreateInput"]},ValueTypes["LinkListUpsertResult"]],
createLinkItem?: [{	data:ValueTypes["LinkItemCreateInput"]},ValueTypes["LinkItemCreateResult"]],
deleteLinkItem?: [{	by:ValueTypes["LinkItemUniqueWhere"],	filter?:ValueTypes["LinkItemWhere"] | null},ValueTypes["LinkItemDeleteResult"]],
updateLinkItem?: [{	by:ValueTypes["LinkItemUniqueWhere"],	filter?:ValueTypes["LinkItemWhere"] | null,	data:ValueTypes["LinkItemUpdateInput"]},ValueTypes["LinkItemUpdateResult"]],
upsertLinkItem?: [{	by:ValueTypes["LinkItemUniqueWhere"],	filter?:ValueTypes["LinkItemWhere"] | null,	update:ValueTypes["LinkItemUpdateInput"],	create:ValueTypes["LinkItemCreateInput"]},ValueTypes["LinkItemUpsertResult"]],
createNewsletterSection?: [{	data:ValueTypes["NewsletterSectionCreateInput"]},ValueTypes["NewsletterSectionCreateResult"]],
deleteNewsletterSection?: [{	by:ValueTypes["NewsletterSectionUniqueWhere"],	filter?:ValueTypes["NewsletterSectionWhere"] | null},ValueTypes["NewsletterSectionDeleteResult"]],
updateNewsletterSection?: [{	by:ValueTypes["NewsletterSectionUniqueWhere"],	filter?:ValueTypes["NewsletterSectionWhere"] | null,	data:ValueTypes["NewsletterSectionUpdateInput"]},ValueTypes["NewsletterSectionUpdateResult"]],
upsertNewsletterSection?: [{	by:ValueTypes["NewsletterSectionUniqueWhere"],	filter?:ValueTypes["NewsletterSectionWhere"] | null,	update:ValueTypes["NewsletterSectionUpdateInput"],	create:ValueTypes["NewsletterSectionCreateInput"]},ValueTypes["NewsletterSectionUpsertResult"]],
createNewsletter?: [{	data:ValueTypes["NewsletterCreateInput"]},ValueTypes["NewsletterCreateResult"]],
deleteNewsletter?: [{	by:ValueTypes["NewsletterUniqueWhere"],	filter?:ValueTypes["NewsletterWhere"] | null},ValueTypes["NewsletterDeleteResult"]],
updateNewsletter?: [{	by:ValueTypes["NewsletterUniqueWhere"],	filter?:ValueTypes["NewsletterWhere"] | null,	data:ValueTypes["NewsletterUpdateInput"]},ValueTypes["NewsletterUpdateResult"]],
upsertNewsletter?: [{	by:ValueTypes["NewsletterUniqueWhere"],	filter?:ValueTypes["NewsletterWhere"] | null,	update:ValueTypes["NewsletterUpdateInput"],	create:ValueTypes["NewsletterCreateInput"]},ValueTypes["NewsletterUpsertResult"]],
createOnlineSection?: [{	data:ValueTypes["OnlineSectionCreateInput"]},ValueTypes["OnlineSectionCreateResult"]],
deleteOnlineSection?: [{	by:ValueTypes["OnlineSectionUniqueWhere"],	filter?:ValueTypes["OnlineSectionWhere"] | null},ValueTypes["OnlineSectionDeleteResult"]],
updateOnlineSection?: [{	by:ValueTypes["OnlineSectionUniqueWhere"],	filter?:ValueTypes["OnlineSectionWhere"] | null,	data:ValueTypes["OnlineSectionUpdateInput"]},ValueTypes["OnlineSectionUpdateResult"]],
upsertOnlineSection?: [{	by:ValueTypes["OnlineSectionUniqueWhere"],	filter?:ValueTypes["OnlineSectionWhere"] | null,	update:ValueTypes["OnlineSectionUpdateInput"],	create:ValueTypes["OnlineSectionCreateInput"]},ValueTypes["OnlineSectionUpsertResult"]],
createAppLink?: [{	data:ValueTypes["AppLinkCreateInput"]},ValueTypes["AppLinkCreateResult"]],
deleteAppLink?: [{	by:ValueTypes["AppLinkUniqueWhere"],	filter?:ValueTypes["AppLinkWhere"] | null},ValueTypes["AppLinkDeleteResult"]],
updateAppLink?: [{	by:ValueTypes["AppLinkUniqueWhere"],	filter?:ValueTypes["AppLinkWhere"] | null,	data:ValueTypes["AppLinkUpdateInput"]},ValueTypes["AppLinkUpdateResult"]],
upsertAppLink?: [{	by:ValueTypes["AppLinkUniqueWhere"],	filter?:ValueTypes["AppLinkWhere"] | null,	update:ValueTypes["AppLinkUpdateInput"],	create:ValueTypes["AppLinkCreateInput"]},ValueTypes["AppLinkUpsertResult"]],
createAppLinkList?: [{	data:ValueTypes["AppLinkListCreateInput"]},ValueTypes["AppLinkListCreateResult"]],
deleteAppLinkList?: [{	by:ValueTypes["AppLinkListUniqueWhere"],	filter?:ValueTypes["AppLinkListWhere"] | null},ValueTypes["AppLinkListDeleteResult"]],
updateAppLinkList?: [{	by:ValueTypes["AppLinkListUniqueWhere"],	filter?:ValueTypes["AppLinkListWhere"] | null,	data:ValueTypes["AppLinkListUpdateInput"]},ValueTypes["AppLinkListUpdateResult"]],
upsertAppLinkList?: [{	by:ValueTypes["AppLinkListUniqueWhere"],	filter?:ValueTypes["AppLinkListWhere"] | null,	update:ValueTypes["AppLinkListUpdateInput"],	create:ValueTypes["AppLinkListCreateInput"]},ValueTypes["AppLinkListUpsertResult"]],
createAppLinkItem?: [{	data:ValueTypes["AppLinkItemCreateInput"]},ValueTypes["AppLinkItemCreateResult"]],
deleteAppLinkItem?: [{	by:ValueTypes["AppLinkItemUniqueWhere"],	filter?:ValueTypes["AppLinkItemWhere"] | null},ValueTypes["AppLinkItemDeleteResult"]],
updateAppLinkItem?: [{	by:ValueTypes["AppLinkItemUniqueWhere"],	filter?:ValueTypes["AppLinkItemWhere"] | null,	data:ValueTypes["AppLinkItemUpdateInput"]},ValueTypes["AppLinkItemUpdateResult"]],
upsertAppLinkItem?: [{	by:ValueTypes["AppLinkItemUniqueWhere"],	filter?:ValueTypes["AppLinkItemWhere"] | null,	update:ValueTypes["AppLinkItemUpdateInput"],	create:ValueTypes["AppLinkItemCreateInput"]},ValueTypes["AppLinkItemUpsertResult"]],
createSocialSection?: [{	data:ValueTypes["SocialSectionCreateInput"]},ValueTypes["SocialSectionCreateResult"]],
deleteSocialSection?: [{	by:ValueTypes["SocialSectionUniqueWhere"],	filter?:ValueTypes["SocialSectionWhere"] | null},ValueTypes["SocialSectionDeleteResult"]],
updateSocialSection?: [{	by:ValueTypes["SocialSectionUniqueWhere"],	filter?:ValueTypes["SocialSectionWhere"] | null,	data:ValueTypes["SocialSectionUpdateInput"]},ValueTypes["SocialSectionUpdateResult"]],
upsertSocialSection?: [{	by:ValueTypes["SocialSectionUniqueWhere"],	filter?:ValueTypes["SocialSectionWhere"] | null,	update:ValueTypes["SocialSectionUpdateInput"],	create:ValueTypes["SocialSectionCreateInput"]},ValueTypes["SocialSectionUpsertResult"]],
createSocialLink?: [{	data:ValueTypes["SocialLinkCreateInput"]},ValueTypes["SocialLinkCreateResult"]],
deleteSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkWhere"] | null},ValueTypes["SocialLinkDeleteResult"]],
updateSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkWhere"] | null,	data:ValueTypes["SocialLinkUpdateInput"]},ValueTypes["SocialLinkUpdateResult"]],
upsertSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkWhere"] | null,	update:ValueTypes["SocialLinkUpdateInput"],	create:ValueTypes["SocialLinkCreateInput"]},ValueTypes["SocialLinkUpsertResult"]],
createSocialLinkList?: [{	data:ValueTypes["SocialLinkListCreateInput"]},ValueTypes["SocialLinkListCreateResult"]],
deleteSocialLinkList?: [{	by:ValueTypes["SocialLinkListUniqueWhere"],	filter?:ValueTypes["SocialLinkListWhere"] | null},ValueTypes["SocialLinkListDeleteResult"]],
updateSocialLinkList?: [{	by:ValueTypes["SocialLinkListUniqueWhere"],	filter?:ValueTypes["SocialLinkListWhere"] | null,	data:ValueTypes["SocialLinkListUpdateInput"]},ValueTypes["SocialLinkListUpdateResult"]],
upsertSocialLinkList?: [{	by:ValueTypes["SocialLinkListUniqueWhere"],	filter?:ValueTypes["SocialLinkListWhere"] | null,	update:ValueTypes["SocialLinkListUpdateInput"],	create:ValueTypes["SocialLinkListCreateInput"]},ValueTypes["SocialLinkListUpsertResult"]],
createSocialLinkItem?: [{	data:ValueTypes["SocialLinkItemCreateInput"]},ValueTypes["SocialLinkItemCreateResult"]],
deleteSocialLinkItem?: [{	by:ValueTypes["SocialLinkItemUniqueWhere"],	filter?:ValueTypes["SocialLinkItemWhere"] | null},ValueTypes["SocialLinkItemDeleteResult"]],
updateSocialLinkItem?: [{	by:ValueTypes["SocialLinkItemUniqueWhere"],	filter?:ValueTypes["SocialLinkItemWhere"] | null,	data:ValueTypes["SocialLinkItemUpdateInput"]},ValueTypes["SocialLinkItemUpdateResult"]],
upsertSocialLinkItem?: [{	by:ValueTypes["SocialLinkItemUniqueWhere"],	filter?:ValueTypes["SocialLinkItemWhere"] | null,	update:ValueTypes["SocialLinkItemUpdateInput"],	create:ValueTypes["SocialLinkItemCreateInput"]},ValueTypes["SocialLinkItemUpsertResult"]],
createSharedContent?: [{	data:ValueTypes["SharedContentCreateInput"]},ValueTypes["SharedContentCreateResult"]],
deleteSharedContent?: [{	by:ValueTypes["SharedContentUniqueWhere"],	filter?:ValueTypes["SharedContentWhere"] | null},ValueTypes["SharedContentDeleteResult"]],
updateSharedContent?: [{	by:ValueTypes["SharedContentUniqueWhere"],	filter?:ValueTypes["SharedContentWhere"] | null,	data:ValueTypes["SharedContentUpdateInput"]},ValueTypes["SharedContentUpdateResult"]],
upsertSharedContent?: [{	by:ValueTypes["SharedContentUniqueWhere"],	filter?:ValueTypes["SharedContentWhere"] | null,	update:ValueTypes["SharedContentUpdateInput"],	create:ValueTypes["SharedContentCreateInput"]},ValueTypes["SharedContentUpsertResult"]],
transaction?: [{	options?:ValueTypes["MutationTransactionOptions"] | null},ValueTypes["MutationTransaction"]],
	query?:ValueTypes["Query"],
generateUploadUrl?: [{	contentType:string,	expiration?:number | null,	prefix?:string | null,	acl?:ValueTypes["S3Acl"] | null},ValueTypes["S3SignedUpload"]],
generateReadUrl?: [{	objectKey:string,	expiration?:number | null},ValueTypes["S3SignedRead"]],
		__typename?: boolean
}>;
	["ArticleCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Article"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["MutationResult"]:AliasType<{
		ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"];
		['...on ArticleCreateResult']?: Omit<ValueTypes["ArticleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArticleDeleteResult']?: Omit<ValueTypes["ArticleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArticleUpdateResult']?: Omit<ValueTypes["ArticleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArticleUpsertResult']?: Omit<ValueTypes["ArticleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArticleAuthorCreateResult']?: Omit<ValueTypes["ArticleAuthorCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArticleAuthorDeleteResult']?: Omit<ValueTypes["ArticleAuthorDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArticleAuthorUpdateResult']?: Omit<ValueTypes["ArticleAuthorUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArticleAuthorUpsertResult']?: Omit<ValueTypes["ArticleAuthorUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on AuthorCreateResult']?: Omit<ValueTypes["AuthorCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AuthorDeleteResult']?: Omit<ValueTypes["AuthorDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on AuthorUpdateResult']?: Omit<ValueTypes["AuthorUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AuthorUpsertResult']?: Omit<ValueTypes["AuthorUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on AuthorTopArticleCreateResult']?: Omit<ValueTypes["AuthorTopArticleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AuthorTopArticleDeleteResult']?: Omit<ValueTypes["AuthorTopArticleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on AuthorTopArticleUpdateResult']?: Omit<ValueTypes["AuthorTopArticleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AuthorTopArticleUpsertResult']?: Omit<ValueTypes["AuthorTopArticleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentCreateResult']?: Omit<ValueTypes["ContentCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentDeleteResult']?: Omit<ValueTypes["ContentDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentUpdateResult']?: Omit<ValueTypes["ContentUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentUpsertResult']?: Omit<ValueTypes["ContentUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentPartCreateResult']?: Omit<ValueTypes["ContentPartCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentPartDeleteResult']?: Omit<ValueTypes["ContentPartDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentPartUpdateResult']?: Omit<ValueTypes["ContentPartUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentPartUpsertResult']?: Omit<ValueTypes["ContentPartUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceCreateResult']?: Omit<ValueTypes["ContentReferenceCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceDeleteResult']?: Omit<ValueTypes["ContentReferenceDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceUpdateResult']?: Omit<ValueTypes["ContentReferenceUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceUpsertResult']?: Omit<ValueTypes["ContentReferenceUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomepageArticleCreateResult']?: Omit<ValueTypes["HomepageArticleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomepageArticleDeleteResult']?: Omit<ValueTypes["HomepageArticleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomepageArticleUpdateResult']?: Omit<ValueTypes["HomepageArticleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomepageArticleUpsertResult']?: Omit<ValueTypes["HomepageArticleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageCreateResult']?: Omit<ValueTypes["ImageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageDeleteResult']?: Omit<ValueTypes["ImageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageUpdateResult']?: Omit<ValueTypes["ImageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageUpsertResult']?: Omit<ValueTypes["ImageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageUseCreateResult']?: Omit<ValueTypes["ImageUseCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageUseDeleteResult']?: Omit<ValueTypes["ImageUseDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageUseUpdateResult']?: Omit<ValueTypes["ImageUseUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageUseUpsertResult']?: Omit<ValueTypes["ImageUseUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageTagCreateResult']?: Omit<ValueTypes["ImageTagCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageTagDeleteResult']?: Omit<ValueTypes["ImageTagDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageTagUpdateResult']?: Omit<ValueTypes["ImageTagUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageTagUpsertResult']?: Omit<ValueTypes["ImageTagUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on IssueCreateResult']?: Omit<ValueTypes["IssueCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on IssueDeleteResult']?: Omit<ValueTypes["IssueDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on IssueUpdateResult']?: Omit<ValueTypes["IssueUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on IssueUpsertResult']?: Omit<ValueTypes["IssueUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on IssueArticleCreateResult']?: Omit<ValueTypes["IssueArticleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on IssueArticleDeleteResult']?: Omit<ValueTypes["IssueArticleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on IssueArticleUpdateResult']?: Omit<ValueTypes["IssueArticleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on IssueArticleUpsertResult']?: Omit<ValueTypes["IssueArticleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkCreateResult']?: Omit<ValueTypes["LinkCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkDeleteResult']?: Omit<ValueTypes["LinkDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkUpdateResult']?: Omit<ValueTypes["LinkUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkUpsertResult']?: Omit<ValueTypes["LinkUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextContentCreateResult']?: Omit<ValueTypes["TextContentCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextContentDeleteResult']?: Omit<ValueTypes["TextContentDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextContentUpdateResult']?: Omit<ValueTypes["TextContentUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextContentUpsertResult']?: Omit<ValueTypes["TextContentUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextContentPartCreateResult']?: Omit<ValueTypes["TextContentPartCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextContentPartDeleteResult']?: Omit<ValueTypes["TextContentPartDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextContentPartUpdateResult']?: Omit<ValueTypes["TextContentPartUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextContentPartUpsertResult']?: Omit<ValueTypes["TextContentPartUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextContentReferenceCreateResult']?: Omit<ValueTypes["TextContentReferenceCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextContentReferenceDeleteResult']?: Omit<ValueTypes["TextContentReferenceDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextContentReferenceUpdateResult']?: Omit<ValueTypes["TextContentReferenceUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextContentReferenceUpsertResult']?: Omit<ValueTypes["TextContentReferenceUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on UrlCreateResult']?: Omit<ValueTypes["UrlCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on UrlDeleteResult']?: Omit<ValueTypes["UrlDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on UrlUpdateResult']?: Omit<ValueTypes["UrlUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on UrlUpsertResult']?: Omit<ValueTypes["UrlUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArticleTagCreateResult']?: Omit<ValueTypes["ArticleTagCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArticleTagDeleteResult']?: Omit<ValueTypes["ArticleTagDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArticleTagUpdateResult']?: Omit<ValueTypes["ArticleTagUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArticleTagUpsertResult']?: Omit<ValueTypes["ArticleTagUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CategoryCreateResult']?: Omit<ValueTypes["CategoryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CategoryDeleteResult']?: Omit<ValueTypes["CategoryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CategoryUpdateResult']?: Omit<ValueTypes["CategoryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CategoryUpsertResult']?: Omit<ValueTypes["CategoryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArticleCategoryCreateResult']?: Omit<ValueTypes["ArticleCategoryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArticleCategoryDeleteResult']?: Omit<ValueTypes["ArticleCategoryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArticleCategoryUpdateResult']?: Omit<ValueTypes["ArticleCategoryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArticleCategoryUpsertResult']?: Omit<ValueTypes["ArticleCategoryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on AudioCreateResult']?: Omit<ValueTypes["AudioCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AudioDeleteResult']?: Omit<ValueTypes["AudioDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on AudioUpdateResult']?: Omit<ValueTypes["AudioUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AudioUpsertResult']?: Omit<ValueTypes["AudioUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on AudioUseCreateResult']?: Omit<ValueTypes["AudioUseCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AudioUseDeleteResult']?: Omit<ValueTypes["AudioUseDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on AudioUseUpdateResult']?: Omit<ValueTypes["AudioUseUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AudioUseUpsertResult']?: Omit<ValueTypes["AudioUseUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on EmbedCreateResult']?: Omit<ValueTypes["EmbedCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EmbedDeleteResult']?: Omit<ValueTypes["EmbedDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on EmbedUpdateResult']?: Omit<ValueTypes["EmbedUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EmbedUpsertResult']?: Omit<ValueTypes["EmbedUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageContentCreateResult']?: Omit<ValueTypes["ImageContentCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageContentDeleteResult']?: Omit<ValueTypes["ImageContentDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageContentUpdateResult']?: Omit<ValueTypes["ImageContentUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageContentUpsertResult']?: Omit<ValueTypes["ImageContentUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ListicleCreateResult']?: Omit<ValueTypes["ListicleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ListicleDeleteResult']?: Omit<ValueTypes["ListicleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ListicleUpdateResult']?: Omit<ValueTypes["ListicleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ListicleUpsertResult']?: Omit<ValueTypes["ListicleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PollAnswerCreateResult']?: Omit<ValueTypes["PollAnswerCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PollAnswerDeleteResult']?: Omit<ValueTypes["PollAnswerDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PollAnswerUpdateResult']?: Omit<ValueTypes["PollAnswerUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PollAnswerUpsertResult']?: Omit<ValueTypes["PollAnswerUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TagCreateResult']?: Omit<ValueTypes["TagCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TagDeleteResult']?: Omit<ValueTypes["TagDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TagUpdateResult']?: Omit<ValueTypes["TagUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TagUpsertResult']?: Omit<ValueTypes["TagUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FAQCreateResult']?: Omit<ValueTypes["FAQCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FAQDeleteResult']?: Omit<ValueTypes["FAQDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FAQUpdateResult']?: Omit<ValueTypes["FAQUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FAQUpsertResult']?: Omit<ValueTypes["FAQUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkContentCreateResult']?: Omit<ValueTypes["LinkContentCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkContentDeleteResult']?: Omit<ValueTypes["LinkContentDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkContentUpdateResult']?: Omit<ValueTypes["LinkContentUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkContentUpsertResult']?: Omit<ValueTypes["LinkContentUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on AwardContentCreateResult']?: Omit<ValueTypes["AwardContentCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AwardContentDeleteResult']?: Omit<ValueTypes["AwardContentDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on AwardContentUpdateResult']?: Omit<ValueTypes["AwardContentUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AwardContentUpsertResult']?: Omit<ValueTypes["AwardContentUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReviewContentCreateResult']?: Omit<ValueTypes["ReviewContentCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReviewContentDeleteResult']?: Omit<ValueTypes["ReviewContentDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReviewContentUpdateResult']?: Omit<ValueTypes["ReviewContentUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ReviewContentUpsertResult']?: Omit<ValueTypes["ReviewContentUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageCreateResult']?: Omit<ValueTypes["PageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageDeleteResult']?: Omit<ValueTypes["PageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageUpdateResult']?: Omit<ValueTypes["PageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageUpsertResult']?: Omit<ValueTypes["PageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextTranslationCreateResult']?: Omit<ValueTypes["TextTranslationCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextTranslationDeleteResult']?: Omit<ValueTypes["TextTranslationDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextTranslationUpdateResult']?: Omit<ValueTypes["TextTranslationUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TextTranslationUpsertResult']?: Omit<ValueTypes["TextTranslationUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoCreateResult']?: Omit<ValueTypes["SeoCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoDeleteResult']?: Omit<ValueTypes["SeoDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoUpdateResult']?: Omit<ValueTypes["SeoUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoUpsertResult']?: Omit<ValueTypes["SeoUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FileCreateResult']?: Omit<ValueTypes["FileCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FileDeleteResult']?: Omit<ValueTypes["FileDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FileUpdateResult']?: Omit<ValueTypes["FileUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FileUpsertResult']?: Omit<ValueTypes["FileUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FileUseCreateResult']?: Omit<ValueTypes["FileUseCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FileUseDeleteResult']?: Omit<ValueTypes["FileUseDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FileUseUpdateResult']?: Omit<ValueTypes["FileUseUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FileUseUpsertResult']?: Omit<ValueTypes["FileUseUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockCreateResult']?: Omit<ValueTypes["ContentBlockCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockDeleteResult']?: Omit<ValueTypes["ContentBlockDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockUpdateResult']?: Omit<ValueTypes["ContentBlockUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockUpsertResult']?: Omit<ValueTypes["ContentBlockUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentArticleCreateResult']?: Omit<ValueTypes["ContentArticleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentArticleDeleteResult']?: Omit<ValueTypes["ContentArticleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentArticleUpdateResult']?: Omit<ValueTypes["ContentArticleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentArticleUpsertResult']?: Omit<ValueTypes["ContentArticleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on UnlockedArticleCreateResult']?: Omit<ValueTypes["UnlockedArticleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on UnlockedArticleDeleteResult']?: Omit<ValueTypes["UnlockedArticleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on UnlockedArticleUpdateResult']?: Omit<ValueTypes["UnlockedArticleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on UnlockedArticleUpsertResult']?: Omit<ValueTypes["UnlockedArticleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserCreateResult']?: Omit<ValueTypes["UserCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserDeleteResult']?: Omit<ValueTypes["UserDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserUpdateResult']?: Omit<ValueTypes["UserUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on UserUpsertResult']?: Omit<ValueTypes["UserUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on NotificationCreateResult']?: Omit<ValueTypes["NotificationCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on NotificationDeleteResult']?: Omit<ValueTypes["NotificationDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on NotificationUpdateResult']?: Omit<ValueTypes["NotificationUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on NotificationUpsertResult']?: Omit<ValueTypes["NotificationUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on AppReviewCreateResult']?: Omit<ValueTypes["AppReviewCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AppReviewDeleteResult']?: Omit<ValueTypes["AppReviewDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on AppReviewUpdateResult']?: Omit<ValueTypes["AppReviewUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AppReviewUpsertResult']?: Omit<ValueTypes["AppReviewUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductCreateResult']?: Omit<ValueTypes["ProductCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductDeleteResult']?: Omit<ValueTypes["ProductDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductUpdateResult']?: Omit<ValueTypes["ProductUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ProductUpsertResult']?: Omit<ValueTypes["ProductUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SubscriptionFormCreateResult']?: Omit<ValueTypes["SubscriptionFormCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SubscriptionFormDeleteResult']?: Omit<ValueTypes["SubscriptionFormDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SubscriptionFormUpdateResult']?: Omit<ValueTypes["SubscriptionFormUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SubscriptionFormUpsertResult']?: Omit<ValueTypes["SubscriptionFormUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SubscriptionFormSectionCreateResult']?: Omit<ValueTypes["SubscriptionFormSectionCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SubscriptionFormSectionDeleteResult']?: Omit<ValueTypes["SubscriptionFormSectionDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SubscriptionFormSectionUpdateResult']?: Omit<ValueTypes["SubscriptionFormSectionUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SubscriptionFormSectionUpsertResult']?: Omit<ValueTypes["SubscriptionFormSectionUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SubscriptionFormInputCreateResult']?: Omit<ValueTypes["SubscriptionFormInputCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SubscriptionFormInputDeleteResult']?: Omit<ValueTypes["SubscriptionFormInputDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SubscriptionFormInputUpdateResult']?: Omit<ValueTypes["SubscriptionFormInputUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SubscriptionFormInputUpsertResult']?: Omit<ValueTypes["SubscriptionFormInputUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SubscriptionFormOptionCreateResult']?: Omit<ValueTypes["SubscriptionFormOptionCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SubscriptionFormOptionDeleteResult']?: Omit<ValueTypes["SubscriptionFormOptionDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SubscriptionFormOptionUpdateResult']?: Omit<ValueTypes["SubscriptionFormOptionUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SubscriptionFormOptionUpsertResult']?: Omit<ValueTypes["SubscriptionFormOptionUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ButtonCreateResult']?: Omit<ValueTypes["ButtonCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ButtonDeleteResult']?: Omit<ValueTypes["ButtonDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ButtonUpdateResult']?: Omit<ValueTypes["ButtonUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ButtonUpsertResult']?: Omit<ValueTypes["ButtonUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArticleHistoryTagCreateResult']?: Omit<ValueTypes["ArticleHistoryTagCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArticleHistoryTagDeleteResult']?: Omit<ValueTypes["ArticleHistoryTagDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArticleHistoryTagUpdateResult']?: Omit<ValueTypes["ArticleHistoryTagUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArticleHistoryTagUpsertResult']?: Omit<ValueTypes["ArticleHistoryTagUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArticleHistoryPeriodCreateResult']?: Omit<ValueTypes["ArticleHistoryPeriodCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArticleHistoryPeriodDeleteResult']?: Omit<ValueTypes["ArticleHistoryPeriodDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArticleHistoryPeriodUpdateResult']?: Omit<ValueTypes["ArticleHistoryPeriodUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArticleHistoryPeriodUpsertResult']?: Omit<ValueTypes["ArticleHistoryPeriodUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HistoryTagCreateResult']?: Omit<ValueTypes["HistoryTagCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HistoryTagDeleteResult']?: Omit<ValueTypes["HistoryTagDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HistoryTagUpdateResult']?: Omit<ValueTypes["HistoryTagUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HistoryTagUpsertResult']?: Omit<ValueTypes["HistoryTagUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HistoryPeriodCreateResult']?: Omit<ValueTypes["HistoryPeriodCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HistoryPeriodDeleteResult']?: Omit<ValueTypes["HistoryPeriodDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HistoryPeriodUpdateResult']?: Omit<ValueTypes["HistoryPeriodUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HistoryPeriodUpsertResult']?: Omit<ValueTypes["HistoryPeriodUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HistoryHomePageCreateResult']?: Omit<ValueTypes["HistoryHomePageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HistoryHomePageDeleteResult']?: Omit<ValueTypes["HistoryHomePageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HistoryHomePageUpdateResult']?: Omit<ValueTypes["HistoryHomePageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HistoryHomePageUpsertResult']?: Omit<ValueTypes["HistoryHomePageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HistoryCoverCreateResult']?: Omit<ValueTypes["HistoryCoverCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HistoryCoverDeleteResult']?: Omit<ValueTypes["HistoryCoverDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HistoryCoverUpdateResult']?: Omit<ValueTypes["HistoryCoverUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HistoryCoverUpsertResult']?: Omit<ValueTypes["HistoryCoverUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HistoryTextListCreateResult']?: Omit<ValueTypes["HistoryTextListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HistoryTextListDeleteResult']?: Omit<ValueTypes["HistoryTextListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HistoryTextListUpdateResult']?: Omit<ValueTypes["HistoryTextListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HistoryTextListUpsertResult']?: Omit<ValueTypes["HistoryTextListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HistoryTextItemCreateResult']?: Omit<ValueTypes["HistoryTextItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HistoryTextItemDeleteResult']?: Omit<ValueTypes["HistoryTextItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HistoryTextItemUpdateResult']?: Omit<ValueTypes["HistoryTextItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HistoryTextItemUpsertResult']?: Omit<ValueTypes["HistoryTextItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterMenuCreateResult']?: Omit<ValueTypes["FooterMenuCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterMenuDeleteResult']?: Omit<ValueTypes["FooterMenuDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterMenuUpdateResult']?: Omit<ValueTypes["FooterMenuUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterMenuUpsertResult']?: Omit<ValueTypes["FooterMenuUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkSectionCreateResult']?: Omit<ValueTypes["LinkSectionCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkSectionDeleteResult']?: Omit<ValueTypes["LinkSectionDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkSectionUpdateResult']?: Omit<ValueTypes["LinkSectionUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkSectionUpsertResult']?: Omit<ValueTypes["LinkSectionUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkListCreateResult']?: Omit<ValueTypes["LinkListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkListDeleteResult']?: Omit<ValueTypes["LinkListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkListUpdateResult']?: Omit<ValueTypes["LinkListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkListUpsertResult']?: Omit<ValueTypes["LinkListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkItemCreateResult']?: Omit<ValueTypes["LinkItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkItemDeleteResult']?: Omit<ValueTypes["LinkItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkItemUpdateResult']?: Omit<ValueTypes["LinkItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkItemUpsertResult']?: Omit<ValueTypes["LinkItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on NewsletterSectionCreateResult']?: Omit<ValueTypes["NewsletterSectionCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on NewsletterSectionDeleteResult']?: Omit<ValueTypes["NewsletterSectionDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on NewsletterSectionUpdateResult']?: Omit<ValueTypes["NewsletterSectionUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on NewsletterSectionUpsertResult']?: Omit<ValueTypes["NewsletterSectionUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on NewsletterCreateResult']?: Omit<ValueTypes["NewsletterCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on NewsletterDeleteResult']?: Omit<ValueTypes["NewsletterDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on NewsletterUpdateResult']?: Omit<ValueTypes["NewsletterUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on NewsletterUpsertResult']?: Omit<ValueTypes["NewsletterUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on OnlineSectionCreateResult']?: Omit<ValueTypes["OnlineSectionCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on OnlineSectionDeleteResult']?: Omit<ValueTypes["OnlineSectionDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on OnlineSectionUpdateResult']?: Omit<ValueTypes["OnlineSectionUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on OnlineSectionUpsertResult']?: Omit<ValueTypes["OnlineSectionUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on AppLinkCreateResult']?: Omit<ValueTypes["AppLinkCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AppLinkDeleteResult']?: Omit<ValueTypes["AppLinkDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on AppLinkUpdateResult']?: Omit<ValueTypes["AppLinkUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AppLinkUpsertResult']?: Omit<ValueTypes["AppLinkUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on AppLinkListCreateResult']?: Omit<ValueTypes["AppLinkListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AppLinkListDeleteResult']?: Omit<ValueTypes["AppLinkListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on AppLinkListUpdateResult']?: Omit<ValueTypes["AppLinkListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AppLinkListUpsertResult']?: Omit<ValueTypes["AppLinkListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on AppLinkItemCreateResult']?: Omit<ValueTypes["AppLinkItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AppLinkItemDeleteResult']?: Omit<ValueTypes["AppLinkItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on AppLinkItemUpdateResult']?: Omit<ValueTypes["AppLinkItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on AppLinkItemUpsertResult']?: Omit<ValueTypes["AppLinkItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialSectionCreateResult']?: Omit<ValueTypes["SocialSectionCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialSectionDeleteResult']?: Omit<ValueTypes["SocialSectionDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialSectionUpdateResult']?: Omit<ValueTypes["SocialSectionUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialSectionUpsertResult']?: Omit<ValueTypes["SocialSectionUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkCreateResult']?: Omit<ValueTypes["SocialLinkCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkDeleteResult']?: Omit<ValueTypes["SocialLinkDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkUpdateResult']?: Omit<ValueTypes["SocialLinkUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkUpsertResult']?: Omit<ValueTypes["SocialLinkUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkListCreateResult']?: Omit<ValueTypes["SocialLinkListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkListDeleteResult']?: Omit<ValueTypes["SocialLinkListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkListUpdateResult']?: Omit<ValueTypes["SocialLinkListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkListUpsertResult']?: Omit<ValueTypes["SocialLinkListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkItemCreateResult']?: Omit<ValueTypes["SocialLinkItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkItemDeleteResult']?: Omit<ValueTypes["SocialLinkItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkItemUpdateResult']?: Omit<ValueTypes["SocialLinkItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkItemUpsertResult']?: Omit<ValueTypes["SocialLinkItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SharedContentCreateResult']?: Omit<ValueTypes["SharedContentCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SharedContentDeleteResult']?: Omit<ValueTypes["SharedContentDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SharedContentUpdateResult']?: Omit<ValueTypes["SharedContentUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SharedContentUpsertResult']?: Omit<ValueTypes["SharedContentUpsertResult"],keyof ValueTypes["MutationResult"]>;
		__typename?: boolean
}>;
	["_MutationError"]: AliasType<{
	path?:ValueTypes["_PathFragment"],
	paths?:ValueTypes["_PathFragment"],
	type?:boolean,
	message?:boolean,
		__typename?: boolean
}>;
	["_MutationErrorType"]:_MutationErrorType;
	["ArticleDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Article"],
		__typename?: boolean
}>;
	["ArticleUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Article"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ArticleUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Article"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ArticleAuthorCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArticleAuthor"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ArticleAuthorDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArticleAuthor"],
		__typename?: boolean
}>;
	["ArticleAuthorUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArticleAuthor"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ArticleAuthorUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArticleAuthor"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AuthorCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Author"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AuthorDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Author"],
		__typename?: boolean
}>;
	["AuthorUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Author"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AuthorUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Author"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AuthorTopArticleCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AuthorTopArticle"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AuthorTopArticleDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AuthorTopArticle"],
		__typename?: boolean
}>;
	["AuthorTopArticleUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AuthorTopArticle"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AuthorTopArticleUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AuthorTopArticle"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
		__typename?: boolean
}>;
	["ContentUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentPartCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentPart"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentPartDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentPart"],
		__typename?: boolean
}>;
	["ContentPartUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentPart"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentPartUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentPart"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentReferenceCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentReferenceDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
		__typename?: boolean
}>;
	["ContentReferenceUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentReferenceUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["HomepageArticleCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomepageArticle"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["HomepageArticleDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomepageArticle"],
		__typename?: boolean
}>;
	["HomepageArticleUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomepageArticle"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["HomepageArticleUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomepageArticle"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ImageCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ImageDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
		__typename?: boolean
}>;
	["ImageUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ImageUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ImageUseCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageUse"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ImageUseDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageUse"],
		__typename?: boolean
}>;
	["ImageUseUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageUse"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ImageUseUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageUse"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ImageTagCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageTag"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ImageTagDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageTag"],
		__typename?: boolean
}>;
	["ImageTagUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageTag"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ImageTagUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageTag"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["IssueCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Issue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["IssueDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Issue"],
		__typename?: boolean
}>;
	["IssueUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Issue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["IssueUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Issue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["IssueArticleCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IssueArticle"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["IssueArticleDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IssueArticle"],
		__typename?: boolean
}>;
	["IssueArticleUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IssueArticle"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["IssueArticleUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["IssueArticle"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LinkCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LinkDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
		__typename?: boolean
}>;
	["LinkUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LinkUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TextContentCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextContent"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TextContentDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextContent"],
		__typename?: boolean
}>;
	["TextContentUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextContent"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TextContentUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextContent"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TextContentPartCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextContentPart"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TextContentPartDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextContentPart"],
		__typename?: boolean
}>;
	["TextContentPartUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextContentPart"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TextContentPartUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextContentPart"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TextContentReferenceCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextContentReference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TextContentReferenceDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextContentReference"],
		__typename?: boolean
}>;
	["TextContentReferenceUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextContentReference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TextContentReferenceUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextContentReference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["UrlCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Url"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["UrlDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Url"],
		__typename?: boolean
}>;
	["UrlUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Url"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["UrlUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Url"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ArticleTagCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArticleTag"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ArticleTagDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArticleTag"],
		__typename?: boolean
}>;
	["ArticleTagUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArticleTag"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ArticleTagUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArticleTag"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["CategoryCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Category"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["CategoryDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Category"],
		__typename?: boolean
}>;
	["CategoryUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Category"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["CategoryUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Category"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ArticleCategoryCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArticleCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ArticleCategoryDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArticleCategory"],
		__typename?: boolean
}>;
	["ArticleCategoryUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArticleCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ArticleCategoryUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArticleCategory"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AudioCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Audio"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AudioDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Audio"],
		__typename?: boolean
}>;
	["AudioUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Audio"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AudioUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Audio"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AudioUseCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AudioUse"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AudioUseDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AudioUse"],
		__typename?: boolean
}>;
	["AudioUseUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AudioUse"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AudioUseUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AudioUse"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["EmbedCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Embed"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["EmbedDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Embed"],
		__typename?: boolean
}>;
	["EmbedUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Embed"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["EmbedUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Embed"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ImageContentCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageContent"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ImageContentDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageContent"],
		__typename?: boolean
}>;
	["ImageContentUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageContent"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ImageContentUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageContent"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ListicleCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Listicle"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ListicleDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Listicle"],
		__typename?: boolean
}>;
	["ListicleUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Listicle"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ListicleUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Listicle"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["PollAnswerCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PollAnswer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["PollAnswerDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PollAnswer"],
		__typename?: boolean
}>;
	["PollAnswerUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PollAnswer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["PollAnswerUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PollAnswer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TagCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Tag"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TagDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Tag"],
		__typename?: boolean
}>;
	["TagUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Tag"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TagUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Tag"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FAQCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FAQ"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FAQDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FAQ"],
		__typename?: boolean
}>;
	["FAQUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FAQ"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FAQUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FAQ"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LinkContentCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkContent"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LinkContentDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkContent"],
		__typename?: boolean
}>;
	["LinkContentUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkContent"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LinkContentUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkContent"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AwardContentCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AwardContent"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AwardContentDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AwardContent"],
		__typename?: boolean
}>;
	["AwardContentUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AwardContent"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AwardContentUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AwardContent"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ReviewContentCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ReviewContent"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ReviewContentDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ReviewContent"],
		__typename?: boolean
}>;
	["ReviewContentUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ReviewContent"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ReviewContentUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ReviewContent"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["PageCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Page"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["PageDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Page"],
		__typename?: boolean
}>;
	["PageUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Page"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["PageUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Page"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TextTranslationCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextTranslation"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TextTranslationDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextTranslation"],
		__typename?: boolean
}>;
	["TextTranslationUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextTranslation"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TextTranslationUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TextTranslation"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SeoCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SeoDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
		__typename?: boolean
}>;
	["SeoUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SeoUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FileCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["File"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FileDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["File"],
		__typename?: boolean
}>;
	["FileUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["File"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FileUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["File"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FileUseCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FileUse"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FileUseDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FileUse"],
		__typename?: boolean
}>;
	["FileUseUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FileUse"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FileUseUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FileUse"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentBlockCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentBlockDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
		__typename?: boolean
}>;
	["ContentBlockUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentBlockUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentArticleCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentArticle"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentArticleDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentArticle"],
		__typename?: boolean
}>;
	["ContentArticleUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentArticle"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ContentArticleUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentArticle"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["UnlockedArticleCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UnlockedArticle"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["UnlockedArticleDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UnlockedArticle"],
		__typename?: boolean
}>;
	["UnlockedArticleUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UnlockedArticle"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["UnlockedArticleUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["UnlockedArticle"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["UserCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["User"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["UserDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["User"],
		__typename?: boolean
}>;
	["UserUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["User"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["UserUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["User"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["NotificationCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Notification"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["NotificationDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Notification"],
		__typename?: boolean
}>;
	["NotificationUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Notification"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["NotificationUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Notification"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AppReviewCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AppReview"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AppReviewDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AppReview"],
		__typename?: boolean
}>;
	["AppReviewUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AppReview"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AppReviewUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AppReview"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Product"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Product"],
		__typename?: boolean
}>;
	["ProductUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Product"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ProductUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Product"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SubscriptionFormCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SubscriptionForm"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SubscriptionFormDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SubscriptionForm"],
		__typename?: boolean
}>;
	["SubscriptionFormUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SubscriptionForm"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SubscriptionFormUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SubscriptionForm"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SubscriptionFormSectionCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SubscriptionFormSection"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SubscriptionFormSectionDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SubscriptionFormSection"],
		__typename?: boolean
}>;
	["SubscriptionFormSectionUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SubscriptionFormSection"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SubscriptionFormSectionUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SubscriptionFormSection"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SubscriptionFormInputCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SubscriptionFormInput"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SubscriptionFormInputDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SubscriptionFormInput"],
		__typename?: boolean
}>;
	["SubscriptionFormInputUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SubscriptionFormInput"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SubscriptionFormInputUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SubscriptionFormInput"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SubscriptionFormOptionCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SubscriptionFormOption"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SubscriptionFormOptionDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SubscriptionFormOption"],
		__typename?: boolean
}>;
	["SubscriptionFormOptionUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SubscriptionFormOption"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SubscriptionFormOptionUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SubscriptionFormOption"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ButtonCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Button"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ButtonDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Button"],
		__typename?: boolean
}>;
	["ButtonUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Button"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ButtonUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Button"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ArticleHistoryTagCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArticleHistoryTag"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ArticleHistoryTagDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArticleHistoryTag"],
		__typename?: boolean
}>;
	["ArticleHistoryTagUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArticleHistoryTag"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ArticleHistoryTagUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArticleHistoryTag"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ArticleHistoryPeriodCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArticleHistoryPeriod"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ArticleHistoryPeriodDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArticleHistoryPeriod"],
		__typename?: boolean
}>;
	["ArticleHistoryPeriodUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArticleHistoryPeriod"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ArticleHistoryPeriodUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArticleHistoryPeriod"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["HistoryTagCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HistoryTag"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["HistoryTagDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HistoryTag"],
		__typename?: boolean
}>;
	["HistoryTagUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HistoryTag"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["HistoryTagUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HistoryTag"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["HistoryPeriodCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HistoryPeriod"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["HistoryPeriodDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HistoryPeriod"],
		__typename?: boolean
}>;
	["HistoryPeriodUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HistoryPeriod"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["HistoryPeriodUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HistoryPeriod"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["HistoryHomePageCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HistoryHomePage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["HistoryHomePageDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HistoryHomePage"],
		__typename?: boolean
}>;
	["HistoryHomePageUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HistoryHomePage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["HistoryHomePageUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HistoryHomePage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["HistoryCoverCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HistoryCover"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["HistoryCoverDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HistoryCover"],
		__typename?: boolean
}>;
	["HistoryCoverUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HistoryCover"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["HistoryCoverUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HistoryCover"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["HistoryTextListCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HistoryTextList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["HistoryTextListDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HistoryTextList"],
		__typename?: boolean
}>;
	["HistoryTextListUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HistoryTextList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["HistoryTextListUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HistoryTextList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["HistoryTextItemCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HistoryTextItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["HistoryTextItemDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HistoryTextItem"],
		__typename?: boolean
}>;
	["HistoryTextItemUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HistoryTextItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["HistoryTextItemUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HistoryTextItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FooterMenuCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterMenu"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FooterMenuDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterMenu"],
		__typename?: boolean
}>;
	["FooterMenuUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterMenu"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FooterMenuUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterMenu"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LinkSectionCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkSection"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LinkSectionDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkSection"],
		__typename?: boolean
}>;
	["LinkSectionUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkSection"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LinkSectionUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkSection"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LinkListCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LinkListDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkList"],
		__typename?: boolean
}>;
	["LinkListUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LinkListUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LinkItemCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LinkItemDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkItem"],
		__typename?: boolean
}>;
	["LinkItemUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LinkItemUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["NewsletterSectionCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NewsletterSection"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["NewsletterSectionDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NewsletterSection"],
		__typename?: boolean
}>;
	["NewsletterSectionUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NewsletterSection"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["NewsletterSectionUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NewsletterSection"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["NewsletterCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Newsletter"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["NewsletterDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Newsletter"],
		__typename?: boolean
}>;
	["NewsletterUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Newsletter"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["NewsletterUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Newsletter"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["OnlineSectionCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OnlineSection"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["OnlineSectionDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OnlineSection"],
		__typename?: boolean
}>;
	["OnlineSectionUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OnlineSection"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["OnlineSectionUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["OnlineSection"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AppLinkCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AppLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AppLinkDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AppLink"],
		__typename?: boolean
}>;
	["AppLinkUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AppLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AppLinkUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AppLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AppLinkListCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AppLinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AppLinkListDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AppLinkList"],
		__typename?: boolean
}>;
	["AppLinkListUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AppLinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AppLinkListUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AppLinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AppLinkItemCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AppLinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AppLinkItemDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AppLinkItem"],
		__typename?: boolean
}>;
	["AppLinkItemUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AppLinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["AppLinkItemUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["AppLinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SocialSectionCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialSection"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SocialSectionDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialSection"],
		__typename?: boolean
}>;
	["SocialSectionUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialSection"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SocialSectionUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialSection"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SocialLinkCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SocialLinkDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLink"],
		__typename?: boolean
}>;
	["SocialLinkUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SocialLinkUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SocialLinkListCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SocialLinkListDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLinkList"],
		__typename?: boolean
}>;
	["SocialLinkListUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SocialLinkListUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SocialLinkItemCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SocialLinkItemDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLinkItem"],
		__typename?: boolean
}>;
	["SocialLinkItemUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SocialLinkItemUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SharedContentCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SharedContent"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SharedContentDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SharedContent"],
		__typename?: boolean
}>;
	["SharedContentUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SharedContent"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SharedContentUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SharedContent"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["MutationTransaction"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	validation?:ValueTypes["_ValidationResult"],
createArticle?: [{	data:ValueTypes["ArticleCreateInput"]},ValueTypes["ArticleCreateResult"]],
deleteArticle?: [{	by:ValueTypes["ArticleUniqueWhere"],	filter?:ValueTypes["ArticleWhere"] | null},ValueTypes["ArticleDeleteResult"]],
updateArticle?: [{	by:ValueTypes["ArticleUniqueWhere"],	filter?:ValueTypes["ArticleWhere"] | null,	data:ValueTypes["ArticleUpdateInput"]},ValueTypes["ArticleUpdateResult"]],
upsertArticle?: [{	by:ValueTypes["ArticleUniqueWhere"],	filter?:ValueTypes["ArticleWhere"] | null,	update:ValueTypes["ArticleUpdateInput"],	create:ValueTypes["ArticleCreateInput"]},ValueTypes["ArticleUpsertResult"]],
createArticleAuthor?: [{	data:ValueTypes["ArticleAuthorCreateInput"]},ValueTypes["ArticleAuthorCreateResult"]],
deleteArticleAuthor?: [{	by:ValueTypes["ArticleAuthorUniqueWhere"],	filter?:ValueTypes["ArticleAuthorWhere"] | null},ValueTypes["ArticleAuthorDeleteResult"]],
updateArticleAuthor?: [{	by:ValueTypes["ArticleAuthorUniqueWhere"],	filter?:ValueTypes["ArticleAuthorWhere"] | null,	data:ValueTypes["ArticleAuthorUpdateInput"]},ValueTypes["ArticleAuthorUpdateResult"]],
upsertArticleAuthor?: [{	by:ValueTypes["ArticleAuthorUniqueWhere"],	filter?:ValueTypes["ArticleAuthorWhere"] | null,	update:ValueTypes["ArticleAuthorUpdateInput"],	create:ValueTypes["ArticleAuthorCreateInput"]},ValueTypes["ArticleAuthorUpsertResult"]],
createAuthor?: [{	data:ValueTypes["AuthorCreateInput"]},ValueTypes["AuthorCreateResult"]],
deleteAuthor?: [{	by:ValueTypes["AuthorUniqueWhere"],	filter?:ValueTypes["AuthorWhere"] | null},ValueTypes["AuthorDeleteResult"]],
updateAuthor?: [{	by:ValueTypes["AuthorUniqueWhere"],	filter?:ValueTypes["AuthorWhere"] | null,	data:ValueTypes["AuthorUpdateInput"]},ValueTypes["AuthorUpdateResult"]],
upsertAuthor?: [{	by:ValueTypes["AuthorUniqueWhere"],	filter?:ValueTypes["AuthorWhere"] | null,	update:ValueTypes["AuthorUpdateInput"],	create:ValueTypes["AuthorCreateInput"]},ValueTypes["AuthorUpsertResult"]],
createAuthorTopArticle?: [{	data:ValueTypes["AuthorTopArticleCreateInput"]},ValueTypes["AuthorTopArticleCreateResult"]],
deleteAuthorTopArticle?: [{	by:ValueTypes["AuthorTopArticleUniqueWhere"],	filter?:ValueTypes["AuthorTopArticleWhere"] | null},ValueTypes["AuthorTopArticleDeleteResult"]],
updateAuthorTopArticle?: [{	by:ValueTypes["AuthorTopArticleUniqueWhere"],	filter?:ValueTypes["AuthorTopArticleWhere"] | null,	data:ValueTypes["AuthorTopArticleUpdateInput"]},ValueTypes["AuthorTopArticleUpdateResult"]],
upsertAuthorTopArticle?: [{	by:ValueTypes["AuthorTopArticleUniqueWhere"],	filter?:ValueTypes["AuthorTopArticleWhere"] | null,	update:ValueTypes["AuthorTopArticleUpdateInput"],	create:ValueTypes["AuthorTopArticleCreateInput"]},ValueTypes["AuthorTopArticleUpsertResult"]],
createContent?: [{	data:ValueTypes["ContentCreateInput"]},ValueTypes["ContentCreateResult"]],
deleteContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["ContentDeleteResult"]],
updateContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null,	data:ValueTypes["ContentUpdateInput"]},ValueTypes["ContentUpdateResult"]],
upsertContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null,	update:ValueTypes["ContentUpdateInput"],	create:ValueTypes["ContentCreateInput"]},ValueTypes["ContentUpsertResult"]],
createContentPart?: [{	data:ValueTypes["ContentPartCreateInput"]},ValueTypes["ContentPartCreateResult"]],
deleteContentPart?: [{	by:ValueTypes["ContentPartUniqueWhere"],	filter?:ValueTypes["ContentPartWhere"] | null},ValueTypes["ContentPartDeleteResult"]],
updateContentPart?: [{	by:ValueTypes["ContentPartUniqueWhere"],	filter?:ValueTypes["ContentPartWhere"] | null,	data:ValueTypes["ContentPartUpdateInput"]},ValueTypes["ContentPartUpdateResult"]],
upsertContentPart?: [{	by:ValueTypes["ContentPartUniqueWhere"],	filter?:ValueTypes["ContentPartWhere"] | null,	update:ValueTypes["ContentPartUpdateInput"],	create:ValueTypes["ContentPartCreateInput"]},ValueTypes["ContentPartUpsertResult"]],
createContentReference?: [{	data:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["ContentReferenceCreateResult"]],
deleteContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReferenceDeleteResult"]],
updateContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null,	data:ValueTypes["ContentReferenceUpdateInput"]},ValueTypes["ContentReferenceUpdateResult"]],
upsertContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null,	update:ValueTypes["ContentReferenceUpdateInput"],	create:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["ContentReferenceUpsertResult"]],
createHomepageArticle?: [{	data:ValueTypes["HomepageArticleCreateInput"]},ValueTypes["HomepageArticleCreateResult"]],
deleteHomepageArticle?: [{	by:ValueTypes["HomepageArticleUniqueWhere"],	filter?:ValueTypes["HomepageArticleWhere"] | null},ValueTypes["HomepageArticleDeleteResult"]],
updateHomepageArticle?: [{	by:ValueTypes["HomepageArticleUniqueWhere"],	filter?:ValueTypes["HomepageArticleWhere"] | null,	data:ValueTypes["HomepageArticleUpdateInput"]},ValueTypes["HomepageArticleUpdateResult"]],
upsertHomepageArticle?: [{	by:ValueTypes["HomepageArticleUniqueWhere"],	filter?:ValueTypes["HomepageArticleWhere"] | null,	update:ValueTypes["HomepageArticleUpdateInput"],	create:ValueTypes["HomepageArticleCreateInput"]},ValueTypes["HomepageArticleUpsertResult"]],
createImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["ImageCreateResult"]],
deleteImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["ImageDeleteResult"]],
updateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	data:ValueTypes["ImageUpdateInput"]},ValueTypes["ImageUpdateResult"]],
upsertImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	update:ValueTypes["ImageUpdateInput"],	create:ValueTypes["ImageCreateInput"]},ValueTypes["ImageUpsertResult"]],
createImageUse?: [{	data:ValueTypes["ImageUseCreateInput"]},ValueTypes["ImageUseCreateResult"]],
deleteImageUse?: [{	by:ValueTypes["ImageUseUniqueWhere"],	filter?:ValueTypes["ImageUseWhere"] | null},ValueTypes["ImageUseDeleteResult"]],
updateImageUse?: [{	by:ValueTypes["ImageUseUniqueWhere"],	filter?:ValueTypes["ImageUseWhere"] | null,	data:ValueTypes["ImageUseUpdateInput"]},ValueTypes["ImageUseUpdateResult"]],
upsertImageUse?: [{	by:ValueTypes["ImageUseUniqueWhere"],	filter?:ValueTypes["ImageUseWhere"] | null,	update:ValueTypes["ImageUseUpdateInput"],	create:ValueTypes["ImageUseCreateInput"]},ValueTypes["ImageUseUpsertResult"]],
createImageTag?: [{	data:ValueTypes["ImageTagCreateInput"]},ValueTypes["ImageTagCreateResult"]],
deleteImageTag?: [{	by:ValueTypes["ImageTagUniqueWhere"],	filter?:ValueTypes["ImageTagWhere"] | null},ValueTypes["ImageTagDeleteResult"]],
updateImageTag?: [{	by:ValueTypes["ImageTagUniqueWhere"],	filter?:ValueTypes["ImageTagWhere"] | null,	data:ValueTypes["ImageTagUpdateInput"]},ValueTypes["ImageTagUpdateResult"]],
upsertImageTag?: [{	by:ValueTypes["ImageTagUniqueWhere"],	filter?:ValueTypes["ImageTagWhere"] | null,	update:ValueTypes["ImageTagUpdateInput"],	create:ValueTypes["ImageTagCreateInput"]},ValueTypes["ImageTagUpsertResult"]],
createIssue?: [{	data:ValueTypes["IssueCreateInput"]},ValueTypes["IssueCreateResult"]],
deleteIssue?: [{	by:ValueTypes["IssueUniqueWhere"],	filter?:ValueTypes["IssueWhere"] | null},ValueTypes["IssueDeleteResult"]],
updateIssue?: [{	by:ValueTypes["IssueUniqueWhere"],	filter?:ValueTypes["IssueWhere"] | null,	data:ValueTypes["IssueUpdateInput"]},ValueTypes["IssueUpdateResult"]],
upsertIssue?: [{	by:ValueTypes["IssueUniqueWhere"],	filter?:ValueTypes["IssueWhere"] | null,	update:ValueTypes["IssueUpdateInput"],	create:ValueTypes["IssueCreateInput"]},ValueTypes["IssueUpsertResult"]],
createIssueArticle?: [{	data:ValueTypes["IssueArticleCreateInput"]},ValueTypes["IssueArticleCreateResult"]],
deleteIssueArticle?: [{	by:ValueTypes["IssueArticleUniqueWhere"],	filter?:ValueTypes["IssueArticleWhere"] | null},ValueTypes["IssueArticleDeleteResult"]],
updateIssueArticle?: [{	by:ValueTypes["IssueArticleUniqueWhere"],	filter?:ValueTypes["IssueArticleWhere"] | null,	data:ValueTypes["IssueArticleUpdateInput"]},ValueTypes["IssueArticleUpdateResult"]],
upsertIssueArticle?: [{	by:ValueTypes["IssueArticleUniqueWhere"],	filter?:ValueTypes["IssueArticleWhere"] | null,	update:ValueTypes["IssueArticleUpdateInput"],	create:ValueTypes["IssueArticleCreateInput"]},ValueTypes["IssueArticleUpsertResult"]],
createLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["LinkCreateResult"]],
deleteLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["LinkDeleteResult"]],
updateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	data:ValueTypes["LinkUpdateInput"]},ValueTypes["LinkUpdateResult"]],
upsertLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	update:ValueTypes["LinkUpdateInput"],	create:ValueTypes["LinkCreateInput"]},ValueTypes["LinkUpsertResult"]],
createTextContent?: [{	data:ValueTypes["TextContentCreateInput"]},ValueTypes["TextContentCreateResult"]],
deleteTextContent?: [{	by:ValueTypes["TextContentUniqueWhere"],	filter?:ValueTypes["TextContentWhere"] | null},ValueTypes["TextContentDeleteResult"]],
updateTextContent?: [{	by:ValueTypes["TextContentUniqueWhere"],	filter?:ValueTypes["TextContentWhere"] | null,	data:ValueTypes["TextContentUpdateInput"]},ValueTypes["TextContentUpdateResult"]],
upsertTextContent?: [{	by:ValueTypes["TextContentUniqueWhere"],	filter?:ValueTypes["TextContentWhere"] | null,	update:ValueTypes["TextContentUpdateInput"],	create:ValueTypes["TextContentCreateInput"]},ValueTypes["TextContentUpsertResult"]],
createTextContentPart?: [{	data:ValueTypes["TextContentPartCreateInput"]},ValueTypes["TextContentPartCreateResult"]],
deleteTextContentPart?: [{	by:ValueTypes["TextContentPartUniqueWhere"],	filter?:ValueTypes["TextContentPartWhere"] | null},ValueTypes["TextContentPartDeleteResult"]],
updateTextContentPart?: [{	by:ValueTypes["TextContentPartUniqueWhere"],	filter?:ValueTypes["TextContentPartWhere"] | null,	data:ValueTypes["TextContentPartUpdateInput"]},ValueTypes["TextContentPartUpdateResult"]],
upsertTextContentPart?: [{	by:ValueTypes["TextContentPartUniqueWhere"],	filter?:ValueTypes["TextContentPartWhere"] | null,	update:ValueTypes["TextContentPartUpdateInput"],	create:ValueTypes["TextContentPartCreateInput"]},ValueTypes["TextContentPartUpsertResult"]],
createTextContentReference?: [{	data:ValueTypes["TextContentReferenceCreateInput"]},ValueTypes["TextContentReferenceCreateResult"]],
deleteTextContentReference?: [{	by:ValueTypes["TextContentReferenceUniqueWhere"],	filter?:ValueTypes["TextContentReferenceWhere"] | null},ValueTypes["TextContentReferenceDeleteResult"]],
updateTextContentReference?: [{	by:ValueTypes["TextContentReferenceUniqueWhere"],	filter?:ValueTypes["TextContentReferenceWhere"] | null,	data:ValueTypes["TextContentReferenceUpdateInput"]},ValueTypes["TextContentReferenceUpdateResult"]],
upsertTextContentReference?: [{	by:ValueTypes["TextContentReferenceUniqueWhere"],	filter?:ValueTypes["TextContentReferenceWhere"] | null,	update:ValueTypes["TextContentReferenceUpdateInput"],	create:ValueTypes["TextContentReferenceCreateInput"]},ValueTypes["TextContentReferenceUpsertResult"]],
createUrl?: [{	data:ValueTypes["UrlCreateInput"]},ValueTypes["UrlCreateResult"]],
deleteUrl?: [{	by:ValueTypes["UrlUniqueWhere"],	filter?:ValueTypes["UrlWhere"] | null},ValueTypes["UrlDeleteResult"]],
updateUrl?: [{	by:ValueTypes["UrlUniqueWhere"],	filter?:ValueTypes["UrlWhere"] | null,	data:ValueTypes["UrlUpdateInput"]},ValueTypes["UrlUpdateResult"]],
upsertUrl?: [{	by:ValueTypes["UrlUniqueWhere"],	filter?:ValueTypes["UrlWhere"] | null,	update:ValueTypes["UrlUpdateInput"],	create:ValueTypes["UrlCreateInput"]},ValueTypes["UrlUpsertResult"]],
createArticleTag?: [{	data:ValueTypes["ArticleTagCreateInput"]},ValueTypes["ArticleTagCreateResult"]],
deleteArticleTag?: [{	by:ValueTypes["ArticleTagUniqueWhere"],	filter?:ValueTypes["ArticleTagWhere"] | null},ValueTypes["ArticleTagDeleteResult"]],
updateArticleTag?: [{	by:ValueTypes["ArticleTagUniqueWhere"],	filter?:ValueTypes["ArticleTagWhere"] | null,	data:ValueTypes["ArticleTagUpdateInput"]},ValueTypes["ArticleTagUpdateResult"]],
upsertArticleTag?: [{	by:ValueTypes["ArticleTagUniqueWhere"],	filter?:ValueTypes["ArticleTagWhere"] | null,	update:ValueTypes["ArticleTagUpdateInput"],	create:ValueTypes["ArticleTagCreateInput"]},ValueTypes["ArticleTagUpsertResult"]],
createCategory?: [{	data:ValueTypes["CategoryCreateInput"]},ValueTypes["CategoryCreateResult"]],
deleteCategory?: [{	by:ValueTypes["CategoryUniqueWhere"],	filter?:ValueTypes["CategoryWhere"] | null},ValueTypes["CategoryDeleteResult"]],
updateCategory?: [{	by:ValueTypes["CategoryUniqueWhere"],	filter?:ValueTypes["CategoryWhere"] | null,	data:ValueTypes["CategoryUpdateInput"]},ValueTypes["CategoryUpdateResult"]],
upsertCategory?: [{	by:ValueTypes["CategoryUniqueWhere"],	filter?:ValueTypes["CategoryWhere"] | null,	update:ValueTypes["CategoryUpdateInput"],	create:ValueTypes["CategoryCreateInput"]},ValueTypes["CategoryUpsertResult"]],
createArticleCategory?: [{	data:ValueTypes["ArticleCategoryCreateInput"]},ValueTypes["ArticleCategoryCreateResult"]],
deleteArticleCategory?: [{	by:ValueTypes["ArticleCategoryUniqueWhere"],	filter?:ValueTypes["ArticleCategoryWhere"] | null},ValueTypes["ArticleCategoryDeleteResult"]],
updateArticleCategory?: [{	by:ValueTypes["ArticleCategoryUniqueWhere"],	filter?:ValueTypes["ArticleCategoryWhere"] | null,	data:ValueTypes["ArticleCategoryUpdateInput"]},ValueTypes["ArticleCategoryUpdateResult"]],
upsertArticleCategory?: [{	by:ValueTypes["ArticleCategoryUniqueWhere"],	filter?:ValueTypes["ArticleCategoryWhere"] | null,	update:ValueTypes["ArticleCategoryUpdateInput"],	create:ValueTypes["ArticleCategoryCreateInput"]},ValueTypes["ArticleCategoryUpsertResult"]],
createAudio?: [{	data:ValueTypes["AudioCreateInput"]},ValueTypes["AudioCreateResult"]],
deleteAudio?: [{	by:ValueTypes["AudioUniqueWhere"],	filter?:ValueTypes["AudioWhere"] | null},ValueTypes["AudioDeleteResult"]],
updateAudio?: [{	by:ValueTypes["AudioUniqueWhere"],	filter?:ValueTypes["AudioWhere"] | null,	data:ValueTypes["AudioUpdateInput"]},ValueTypes["AudioUpdateResult"]],
upsertAudio?: [{	by:ValueTypes["AudioUniqueWhere"],	filter?:ValueTypes["AudioWhere"] | null,	update:ValueTypes["AudioUpdateInput"],	create:ValueTypes["AudioCreateInput"]},ValueTypes["AudioUpsertResult"]],
createAudioUse?: [{	data:ValueTypes["AudioUseCreateInput"]},ValueTypes["AudioUseCreateResult"]],
deleteAudioUse?: [{	by:ValueTypes["AudioUseUniqueWhere"],	filter?:ValueTypes["AudioUseWhere"] | null},ValueTypes["AudioUseDeleteResult"]],
updateAudioUse?: [{	by:ValueTypes["AudioUseUniqueWhere"],	filter?:ValueTypes["AudioUseWhere"] | null,	data:ValueTypes["AudioUseUpdateInput"]},ValueTypes["AudioUseUpdateResult"]],
upsertAudioUse?: [{	by:ValueTypes["AudioUseUniqueWhere"],	filter?:ValueTypes["AudioUseWhere"] | null,	update:ValueTypes["AudioUseUpdateInput"],	create:ValueTypes["AudioUseCreateInput"]},ValueTypes["AudioUseUpsertResult"]],
createEmbed?: [{	data:ValueTypes["EmbedCreateInput"]},ValueTypes["EmbedCreateResult"]],
deleteEmbed?: [{	by:ValueTypes["EmbedUniqueWhere"],	filter?:ValueTypes["EmbedWhere"] | null},ValueTypes["EmbedDeleteResult"]],
updateEmbed?: [{	by:ValueTypes["EmbedUniqueWhere"],	filter?:ValueTypes["EmbedWhere"] | null,	data:ValueTypes["EmbedUpdateInput"]},ValueTypes["EmbedUpdateResult"]],
upsertEmbed?: [{	by:ValueTypes["EmbedUniqueWhere"],	filter?:ValueTypes["EmbedWhere"] | null,	update:ValueTypes["EmbedUpdateInput"],	create:ValueTypes["EmbedCreateInput"]},ValueTypes["EmbedUpsertResult"]],
createImageContent?: [{	data:ValueTypes["ImageContentCreateInput"]},ValueTypes["ImageContentCreateResult"]],
deleteImageContent?: [{	by:ValueTypes["ImageContentUniqueWhere"],	filter?:ValueTypes["ImageContentWhere"] | null},ValueTypes["ImageContentDeleteResult"]],
updateImageContent?: [{	by:ValueTypes["ImageContentUniqueWhere"],	filter?:ValueTypes["ImageContentWhere"] | null,	data:ValueTypes["ImageContentUpdateInput"]},ValueTypes["ImageContentUpdateResult"]],
upsertImageContent?: [{	by:ValueTypes["ImageContentUniqueWhere"],	filter?:ValueTypes["ImageContentWhere"] | null,	update:ValueTypes["ImageContentUpdateInput"],	create:ValueTypes["ImageContentCreateInput"]},ValueTypes["ImageContentUpsertResult"]],
createListicle?: [{	data:ValueTypes["ListicleCreateInput"]},ValueTypes["ListicleCreateResult"]],
deleteListicle?: [{	by:ValueTypes["ListicleUniqueWhere"],	filter?:ValueTypes["ListicleWhere"] | null},ValueTypes["ListicleDeleteResult"]],
updateListicle?: [{	by:ValueTypes["ListicleUniqueWhere"],	filter?:ValueTypes["ListicleWhere"] | null,	data:ValueTypes["ListicleUpdateInput"]},ValueTypes["ListicleUpdateResult"]],
upsertListicle?: [{	by:ValueTypes["ListicleUniqueWhere"],	filter?:ValueTypes["ListicleWhere"] | null,	update:ValueTypes["ListicleUpdateInput"],	create:ValueTypes["ListicleCreateInput"]},ValueTypes["ListicleUpsertResult"]],
createPollAnswer?: [{	data:ValueTypes["PollAnswerCreateInput"]},ValueTypes["PollAnswerCreateResult"]],
deletePollAnswer?: [{	by:ValueTypes["PollAnswerUniqueWhere"],	filter?:ValueTypes["PollAnswerWhere"] | null},ValueTypes["PollAnswerDeleteResult"]],
updatePollAnswer?: [{	by:ValueTypes["PollAnswerUniqueWhere"],	filter?:ValueTypes["PollAnswerWhere"] | null,	data:ValueTypes["PollAnswerUpdateInput"]},ValueTypes["PollAnswerUpdateResult"]],
upsertPollAnswer?: [{	by:ValueTypes["PollAnswerUniqueWhere"],	filter?:ValueTypes["PollAnswerWhere"] | null,	update:ValueTypes["PollAnswerUpdateInput"],	create:ValueTypes["PollAnswerCreateInput"]},ValueTypes["PollAnswerUpsertResult"]],
createTag?: [{	data:ValueTypes["TagCreateInput"]},ValueTypes["TagCreateResult"]],
deleteTag?: [{	by:ValueTypes["TagUniqueWhere"],	filter?:ValueTypes["TagWhere"] | null},ValueTypes["TagDeleteResult"]],
updateTag?: [{	by:ValueTypes["TagUniqueWhere"],	filter?:ValueTypes["TagWhere"] | null,	data:ValueTypes["TagUpdateInput"]},ValueTypes["TagUpdateResult"]],
upsertTag?: [{	by:ValueTypes["TagUniqueWhere"],	filter?:ValueTypes["TagWhere"] | null,	update:ValueTypes["TagUpdateInput"],	create:ValueTypes["TagCreateInput"]},ValueTypes["TagUpsertResult"]],
createFAQ?: [{	data:ValueTypes["FAQCreateInput"]},ValueTypes["FAQCreateResult"]],
deleteFAQ?: [{	by:ValueTypes["FAQUniqueWhere"],	filter?:ValueTypes["FAQWhere"] | null},ValueTypes["FAQDeleteResult"]],
updateFAQ?: [{	by:ValueTypes["FAQUniqueWhere"],	filter?:ValueTypes["FAQWhere"] | null,	data:ValueTypes["FAQUpdateInput"]},ValueTypes["FAQUpdateResult"]],
upsertFAQ?: [{	by:ValueTypes["FAQUniqueWhere"],	filter?:ValueTypes["FAQWhere"] | null,	update:ValueTypes["FAQUpdateInput"],	create:ValueTypes["FAQCreateInput"]},ValueTypes["FAQUpsertResult"]],
createLinkContent?: [{	data:ValueTypes["LinkContentCreateInput"]},ValueTypes["LinkContentCreateResult"]],
deleteLinkContent?: [{	by:ValueTypes["LinkContentUniqueWhere"],	filter?:ValueTypes["LinkContentWhere"] | null},ValueTypes["LinkContentDeleteResult"]],
updateLinkContent?: [{	by:ValueTypes["LinkContentUniqueWhere"],	filter?:ValueTypes["LinkContentWhere"] | null,	data:ValueTypes["LinkContentUpdateInput"]},ValueTypes["LinkContentUpdateResult"]],
upsertLinkContent?: [{	by:ValueTypes["LinkContentUniqueWhere"],	filter?:ValueTypes["LinkContentWhere"] | null,	update:ValueTypes["LinkContentUpdateInput"],	create:ValueTypes["LinkContentCreateInput"]},ValueTypes["LinkContentUpsertResult"]],
createAwardContent?: [{	data:ValueTypes["AwardContentCreateInput"]},ValueTypes["AwardContentCreateResult"]],
deleteAwardContent?: [{	by:ValueTypes["AwardContentUniqueWhere"],	filter?:ValueTypes["AwardContentWhere"] | null},ValueTypes["AwardContentDeleteResult"]],
updateAwardContent?: [{	by:ValueTypes["AwardContentUniqueWhere"],	filter?:ValueTypes["AwardContentWhere"] | null,	data:ValueTypes["AwardContentUpdateInput"]},ValueTypes["AwardContentUpdateResult"]],
upsertAwardContent?: [{	by:ValueTypes["AwardContentUniqueWhere"],	filter?:ValueTypes["AwardContentWhere"] | null,	update:ValueTypes["AwardContentUpdateInput"],	create:ValueTypes["AwardContentCreateInput"]},ValueTypes["AwardContentUpsertResult"]],
createReviewContent?: [{	data:ValueTypes["ReviewContentCreateInput"]},ValueTypes["ReviewContentCreateResult"]],
deleteReviewContent?: [{	by:ValueTypes["ReviewContentUniqueWhere"],	filter?:ValueTypes["ReviewContentWhere"] | null},ValueTypes["ReviewContentDeleteResult"]],
updateReviewContent?: [{	by:ValueTypes["ReviewContentUniqueWhere"],	filter?:ValueTypes["ReviewContentWhere"] | null,	data:ValueTypes["ReviewContentUpdateInput"]},ValueTypes["ReviewContentUpdateResult"]],
upsertReviewContent?: [{	by:ValueTypes["ReviewContentUniqueWhere"],	filter?:ValueTypes["ReviewContentWhere"] | null,	update:ValueTypes["ReviewContentUpdateInput"],	create:ValueTypes["ReviewContentCreateInput"]},ValueTypes["ReviewContentUpsertResult"]],
createPage?: [{	data:ValueTypes["PageCreateInput"]},ValueTypes["PageCreateResult"]],
deletePage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null},ValueTypes["PageDeleteResult"]],
updatePage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null,	data:ValueTypes["PageUpdateInput"]},ValueTypes["PageUpdateResult"]],
upsertPage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null,	update:ValueTypes["PageUpdateInput"],	create:ValueTypes["PageCreateInput"]},ValueTypes["PageUpsertResult"]],
createTextTranslation?: [{	data:ValueTypes["TextTranslationCreateInput"]},ValueTypes["TextTranslationCreateResult"]],
deleteTextTranslation?: [{	by:ValueTypes["TextTranslationUniqueWhere"],	filter?:ValueTypes["TextTranslationWhere"] | null},ValueTypes["TextTranslationDeleteResult"]],
updateTextTranslation?: [{	by:ValueTypes["TextTranslationUniqueWhere"],	filter?:ValueTypes["TextTranslationWhere"] | null,	data:ValueTypes["TextTranslationUpdateInput"]},ValueTypes["TextTranslationUpdateResult"]],
upsertTextTranslation?: [{	by:ValueTypes["TextTranslationUniqueWhere"],	filter?:ValueTypes["TextTranslationWhere"] | null,	update:ValueTypes["TextTranslationUpdateInput"],	create:ValueTypes["TextTranslationCreateInput"]},ValueTypes["TextTranslationUpsertResult"]],
createSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["SeoCreateResult"]],
deleteSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["SeoDeleteResult"]],
updateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	data:ValueTypes["SeoUpdateInput"]},ValueTypes["SeoUpdateResult"]],
upsertSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	update:ValueTypes["SeoUpdateInput"],	create:ValueTypes["SeoCreateInput"]},ValueTypes["SeoUpsertResult"]],
createFile?: [{	data:ValueTypes["FileCreateInput"]},ValueTypes["FileCreateResult"]],
deleteFile?: [{	by:ValueTypes["FileUniqueWhere"],	filter?:ValueTypes["FileWhere"] | null},ValueTypes["FileDeleteResult"]],
updateFile?: [{	by:ValueTypes["FileUniqueWhere"],	filter?:ValueTypes["FileWhere"] | null,	data:ValueTypes["FileUpdateInput"]},ValueTypes["FileUpdateResult"]],
upsertFile?: [{	by:ValueTypes["FileUniqueWhere"],	filter?:ValueTypes["FileWhere"] | null,	update:ValueTypes["FileUpdateInput"],	create:ValueTypes["FileCreateInput"]},ValueTypes["FileUpsertResult"]],
createFileUse?: [{	data:ValueTypes["FileUseCreateInput"]},ValueTypes["FileUseCreateResult"]],
deleteFileUse?: [{	by:ValueTypes["FileUseUniqueWhere"],	filter?:ValueTypes["FileUseWhere"] | null},ValueTypes["FileUseDeleteResult"]],
updateFileUse?: [{	by:ValueTypes["FileUseUniqueWhere"],	filter?:ValueTypes["FileUseWhere"] | null,	data:ValueTypes["FileUseUpdateInput"]},ValueTypes["FileUseUpdateResult"]],
upsertFileUse?: [{	by:ValueTypes["FileUseUniqueWhere"],	filter?:ValueTypes["FileUseWhere"] | null,	update:ValueTypes["FileUseUpdateInput"],	create:ValueTypes["FileUseCreateInput"]},ValueTypes["FileUseUpsertResult"]],
createContentBlock?: [{	data:ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockCreateResult"]],
deleteContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlockDeleteResult"]],
updateContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null,	data:ValueTypes["ContentBlockUpdateInput"]},ValueTypes["ContentBlockUpdateResult"]],
upsertContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null,	update:ValueTypes["ContentBlockUpdateInput"],	create:ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockUpsertResult"]],
createContentArticle?: [{	data:ValueTypes["ContentArticleCreateInput"]},ValueTypes["ContentArticleCreateResult"]],
deleteContentArticle?: [{	by:ValueTypes["ContentArticleUniqueWhere"],	filter?:ValueTypes["ContentArticleWhere"] | null},ValueTypes["ContentArticleDeleteResult"]],
updateContentArticle?: [{	by:ValueTypes["ContentArticleUniqueWhere"],	filter?:ValueTypes["ContentArticleWhere"] | null,	data:ValueTypes["ContentArticleUpdateInput"]},ValueTypes["ContentArticleUpdateResult"]],
upsertContentArticle?: [{	by:ValueTypes["ContentArticleUniqueWhere"],	filter?:ValueTypes["ContentArticleWhere"] | null,	update:ValueTypes["ContentArticleUpdateInput"],	create:ValueTypes["ContentArticleCreateInput"]},ValueTypes["ContentArticleUpsertResult"]],
createUnlockedArticle?: [{	data:ValueTypes["UnlockedArticleCreateInput"]},ValueTypes["UnlockedArticleCreateResult"]],
deleteUnlockedArticle?: [{	by:ValueTypes["UnlockedArticleUniqueWhere"],	filter?:ValueTypes["UnlockedArticleWhere"] | null},ValueTypes["UnlockedArticleDeleteResult"]],
updateUnlockedArticle?: [{	by:ValueTypes["UnlockedArticleUniqueWhere"],	filter?:ValueTypes["UnlockedArticleWhere"] | null,	data:ValueTypes["UnlockedArticleUpdateInput"]},ValueTypes["UnlockedArticleUpdateResult"]],
upsertUnlockedArticle?: [{	by:ValueTypes["UnlockedArticleUniqueWhere"],	filter?:ValueTypes["UnlockedArticleWhere"] | null,	update:ValueTypes["UnlockedArticleUpdateInput"],	create:ValueTypes["UnlockedArticleCreateInput"]},ValueTypes["UnlockedArticleUpsertResult"]],
createUser?: [{	data:ValueTypes["UserCreateInput"]},ValueTypes["UserCreateResult"]],
deleteUser?: [{	by:ValueTypes["UserUniqueWhere"],	filter?:ValueTypes["UserWhere"] | null},ValueTypes["UserDeleteResult"]],
updateUser?: [{	by:ValueTypes["UserUniqueWhere"],	filter?:ValueTypes["UserWhere"] | null,	data:ValueTypes["UserUpdateInput"]},ValueTypes["UserUpdateResult"]],
upsertUser?: [{	by:ValueTypes["UserUniqueWhere"],	filter?:ValueTypes["UserWhere"] | null,	update:ValueTypes["UserUpdateInput"],	create:ValueTypes["UserCreateInput"]},ValueTypes["UserUpsertResult"]],
createNotification?: [{	data:ValueTypes["NotificationCreateInput"]},ValueTypes["NotificationCreateResult"]],
deleteNotification?: [{	by:ValueTypes["NotificationUniqueWhere"],	filter?:ValueTypes["NotificationWhere"] | null},ValueTypes["NotificationDeleteResult"]],
updateNotification?: [{	by:ValueTypes["NotificationUniqueWhere"],	filter?:ValueTypes["NotificationWhere"] | null,	data:ValueTypes["NotificationUpdateInput"]},ValueTypes["NotificationUpdateResult"]],
upsertNotification?: [{	by:ValueTypes["NotificationUniqueWhere"],	filter?:ValueTypes["NotificationWhere"] | null,	update:ValueTypes["NotificationUpdateInput"],	create:ValueTypes["NotificationCreateInput"]},ValueTypes["NotificationUpsertResult"]],
createAppReview?: [{	data:ValueTypes["AppReviewCreateInput"]},ValueTypes["AppReviewCreateResult"]],
deleteAppReview?: [{	by:ValueTypes["AppReviewUniqueWhere"],	filter?:ValueTypes["AppReviewWhere"] | null},ValueTypes["AppReviewDeleteResult"]],
updateAppReview?: [{	by:ValueTypes["AppReviewUniqueWhere"],	filter?:ValueTypes["AppReviewWhere"] | null,	data:ValueTypes["AppReviewUpdateInput"]},ValueTypes["AppReviewUpdateResult"]],
upsertAppReview?: [{	by:ValueTypes["AppReviewUniqueWhere"],	filter?:ValueTypes["AppReviewWhere"] | null,	update:ValueTypes["AppReviewUpdateInput"],	create:ValueTypes["AppReviewCreateInput"]},ValueTypes["AppReviewUpsertResult"]],
createProduct?: [{	data:ValueTypes["ProductCreateInput"]},ValueTypes["ProductCreateResult"]],
deleteProduct?: [{	by:ValueTypes["ProductUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null},ValueTypes["ProductDeleteResult"]],
updateProduct?: [{	by:ValueTypes["ProductUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null,	data:ValueTypes["ProductUpdateInput"]},ValueTypes["ProductUpdateResult"]],
upsertProduct?: [{	by:ValueTypes["ProductUniqueWhere"],	filter?:ValueTypes["ProductWhere"] | null,	update:ValueTypes["ProductUpdateInput"],	create:ValueTypes["ProductCreateInput"]},ValueTypes["ProductUpsertResult"]],
createSubscriptionForm?: [{	data:ValueTypes["SubscriptionFormCreateInput"]},ValueTypes["SubscriptionFormCreateResult"]],
deleteSubscriptionForm?: [{	by:ValueTypes["SubscriptionFormUniqueWhere"],	filter?:ValueTypes["SubscriptionFormWhere"] | null},ValueTypes["SubscriptionFormDeleteResult"]],
updateSubscriptionForm?: [{	by:ValueTypes["SubscriptionFormUniqueWhere"],	filter?:ValueTypes["SubscriptionFormWhere"] | null,	data:ValueTypes["SubscriptionFormUpdateInput"]},ValueTypes["SubscriptionFormUpdateResult"]],
upsertSubscriptionForm?: [{	by:ValueTypes["SubscriptionFormUniqueWhere"],	filter?:ValueTypes["SubscriptionFormWhere"] | null,	update:ValueTypes["SubscriptionFormUpdateInput"],	create:ValueTypes["SubscriptionFormCreateInput"]},ValueTypes["SubscriptionFormUpsertResult"]],
createSubscriptionFormSection?: [{	data:ValueTypes["SubscriptionFormSectionCreateInput"]},ValueTypes["SubscriptionFormSectionCreateResult"]],
deleteSubscriptionFormSection?: [{	by:ValueTypes["SubscriptionFormSectionUniqueWhere"],	filter?:ValueTypes["SubscriptionFormSectionWhere"] | null},ValueTypes["SubscriptionFormSectionDeleteResult"]],
updateSubscriptionFormSection?: [{	by:ValueTypes["SubscriptionFormSectionUniqueWhere"],	filter?:ValueTypes["SubscriptionFormSectionWhere"] | null,	data:ValueTypes["SubscriptionFormSectionUpdateInput"]},ValueTypes["SubscriptionFormSectionUpdateResult"]],
upsertSubscriptionFormSection?: [{	by:ValueTypes["SubscriptionFormSectionUniqueWhere"],	filter?:ValueTypes["SubscriptionFormSectionWhere"] | null,	update:ValueTypes["SubscriptionFormSectionUpdateInput"],	create:ValueTypes["SubscriptionFormSectionCreateInput"]},ValueTypes["SubscriptionFormSectionUpsertResult"]],
createSubscriptionFormInput?: [{	data:ValueTypes["SubscriptionFormInputCreateInput"]},ValueTypes["SubscriptionFormInputCreateResult"]],
deleteSubscriptionFormInput?: [{	by:ValueTypes["SubscriptionFormInputUniqueWhere"],	filter?:ValueTypes["SubscriptionFormInputWhere"] | null},ValueTypes["SubscriptionFormInputDeleteResult"]],
updateSubscriptionFormInput?: [{	by:ValueTypes["SubscriptionFormInputUniqueWhere"],	filter?:ValueTypes["SubscriptionFormInputWhere"] | null,	data:ValueTypes["SubscriptionFormInputUpdateInput"]},ValueTypes["SubscriptionFormInputUpdateResult"]],
upsertSubscriptionFormInput?: [{	by:ValueTypes["SubscriptionFormInputUniqueWhere"],	filter?:ValueTypes["SubscriptionFormInputWhere"] | null,	update:ValueTypes["SubscriptionFormInputUpdateInput"],	create:ValueTypes["SubscriptionFormInputCreateInput"]},ValueTypes["SubscriptionFormInputUpsertResult"]],
createSubscriptionFormOption?: [{	data:ValueTypes["SubscriptionFormOptionCreateInput"]},ValueTypes["SubscriptionFormOptionCreateResult"]],
deleteSubscriptionFormOption?: [{	by:ValueTypes["SubscriptionFormOptionUniqueWhere"],	filter?:ValueTypes["SubscriptionFormOptionWhere"] | null},ValueTypes["SubscriptionFormOptionDeleteResult"]],
updateSubscriptionFormOption?: [{	by:ValueTypes["SubscriptionFormOptionUniqueWhere"],	filter?:ValueTypes["SubscriptionFormOptionWhere"] | null,	data:ValueTypes["SubscriptionFormOptionUpdateInput"]},ValueTypes["SubscriptionFormOptionUpdateResult"]],
upsertSubscriptionFormOption?: [{	by:ValueTypes["SubscriptionFormOptionUniqueWhere"],	filter?:ValueTypes["SubscriptionFormOptionWhere"] | null,	update:ValueTypes["SubscriptionFormOptionUpdateInput"],	create:ValueTypes["SubscriptionFormOptionCreateInput"]},ValueTypes["SubscriptionFormOptionUpsertResult"]],
createButton?: [{	data:ValueTypes["ButtonCreateInput"]},ValueTypes["ButtonCreateResult"]],
deleteButton?: [{	by:ValueTypes["ButtonUniqueWhere"],	filter?:ValueTypes["ButtonWhere"] | null},ValueTypes["ButtonDeleteResult"]],
updateButton?: [{	by:ValueTypes["ButtonUniqueWhere"],	filter?:ValueTypes["ButtonWhere"] | null,	data:ValueTypes["ButtonUpdateInput"]},ValueTypes["ButtonUpdateResult"]],
upsertButton?: [{	by:ValueTypes["ButtonUniqueWhere"],	filter?:ValueTypes["ButtonWhere"] | null,	update:ValueTypes["ButtonUpdateInput"],	create:ValueTypes["ButtonCreateInput"]},ValueTypes["ButtonUpsertResult"]],
createArticleHistoryTag?: [{	data:ValueTypes["ArticleHistoryTagCreateInput"]},ValueTypes["ArticleHistoryTagCreateResult"]],
deleteArticleHistoryTag?: [{	by:ValueTypes["ArticleHistoryTagUniqueWhere"],	filter?:ValueTypes["ArticleHistoryTagWhere"] | null},ValueTypes["ArticleHistoryTagDeleteResult"]],
updateArticleHistoryTag?: [{	by:ValueTypes["ArticleHistoryTagUniqueWhere"],	filter?:ValueTypes["ArticleHistoryTagWhere"] | null,	data:ValueTypes["ArticleHistoryTagUpdateInput"]},ValueTypes["ArticleHistoryTagUpdateResult"]],
upsertArticleHistoryTag?: [{	by:ValueTypes["ArticleHistoryTagUniqueWhere"],	filter?:ValueTypes["ArticleHistoryTagWhere"] | null,	update:ValueTypes["ArticleHistoryTagUpdateInput"],	create:ValueTypes["ArticleHistoryTagCreateInput"]},ValueTypes["ArticleHistoryTagUpsertResult"]],
createArticleHistoryPeriod?: [{	data:ValueTypes["ArticleHistoryPeriodCreateInput"]},ValueTypes["ArticleHistoryPeriodCreateResult"]],
deleteArticleHistoryPeriod?: [{	by:ValueTypes["ArticleHistoryPeriodUniqueWhere"],	filter?:ValueTypes["ArticleHistoryPeriodWhere"] | null},ValueTypes["ArticleHistoryPeriodDeleteResult"]],
updateArticleHistoryPeriod?: [{	by:ValueTypes["ArticleHistoryPeriodUniqueWhere"],	filter?:ValueTypes["ArticleHistoryPeriodWhere"] | null,	data:ValueTypes["ArticleHistoryPeriodUpdateInput"]},ValueTypes["ArticleHistoryPeriodUpdateResult"]],
upsertArticleHistoryPeriod?: [{	by:ValueTypes["ArticleHistoryPeriodUniqueWhere"],	filter?:ValueTypes["ArticleHistoryPeriodWhere"] | null,	update:ValueTypes["ArticleHistoryPeriodUpdateInput"],	create:ValueTypes["ArticleHistoryPeriodCreateInput"]},ValueTypes["ArticleHistoryPeriodUpsertResult"]],
createHistoryTag?: [{	data:ValueTypes["HistoryTagCreateInput"]},ValueTypes["HistoryTagCreateResult"]],
deleteHistoryTag?: [{	by:ValueTypes["HistoryTagUniqueWhere"],	filter?:ValueTypes["HistoryTagWhere"] | null},ValueTypes["HistoryTagDeleteResult"]],
updateHistoryTag?: [{	by:ValueTypes["HistoryTagUniqueWhere"],	filter?:ValueTypes["HistoryTagWhere"] | null,	data:ValueTypes["HistoryTagUpdateInput"]},ValueTypes["HistoryTagUpdateResult"]],
upsertHistoryTag?: [{	by:ValueTypes["HistoryTagUniqueWhere"],	filter?:ValueTypes["HistoryTagWhere"] | null,	update:ValueTypes["HistoryTagUpdateInput"],	create:ValueTypes["HistoryTagCreateInput"]},ValueTypes["HistoryTagUpsertResult"]],
createHistoryPeriod?: [{	data:ValueTypes["HistoryPeriodCreateInput"]},ValueTypes["HistoryPeriodCreateResult"]],
deleteHistoryPeriod?: [{	by:ValueTypes["HistoryPeriodUniqueWhere"],	filter?:ValueTypes["HistoryPeriodWhere"] | null},ValueTypes["HistoryPeriodDeleteResult"]],
updateHistoryPeriod?: [{	by:ValueTypes["HistoryPeriodUniqueWhere"],	filter?:ValueTypes["HistoryPeriodWhere"] | null,	data:ValueTypes["HistoryPeriodUpdateInput"]},ValueTypes["HistoryPeriodUpdateResult"]],
upsertHistoryPeriod?: [{	by:ValueTypes["HistoryPeriodUniqueWhere"],	filter?:ValueTypes["HistoryPeriodWhere"] | null,	update:ValueTypes["HistoryPeriodUpdateInput"],	create:ValueTypes["HistoryPeriodCreateInput"]},ValueTypes["HistoryPeriodUpsertResult"]],
createHistoryHomePage?: [{	data:ValueTypes["HistoryHomePageCreateInput"]},ValueTypes["HistoryHomePageCreateResult"]],
deleteHistoryHomePage?: [{	by:ValueTypes["HistoryHomePageUniqueWhere"],	filter?:ValueTypes["HistoryHomePageWhere"] | null},ValueTypes["HistoryHomePageDeleteResult"]],
updateHistoryHomePage?: [{	by:ValueTypes["HistoryHomePageUniqueWhere"],	filter?:ValueTypes["HistoryHomePageWhere"] | null,	data:ValueTypes["HistoryHomePageUpdateInput"]},ValueTypes["HistoryHomePageUpdateResult"]],
upsertHistoryHomePage?: [{	by:ValueTypes["HistoryHomePageUniqueWhere"],	filter?:ValueTypes["HistoryHomePageWhere"] | null,	update:ValueTypes["HistoryHomePageUpdateInput"],	create:ValueTypes["HistoryHomePageCreateInput"]},ValueTypes["HistoryHomePageUpsertResult"]],
createHistoryCover?: [{	data:ValueTypes["HistoryCoverCreateInput"]},ValueTypes["HistoryCoverCreateResult"]],
deleteHistoryCover?: [{	by:ValueTypes["HistoryCoverUniqueWhere"],	filter?:ValueTypes["HistoryCoverWhere"] | null},ValueTypes["HistoryCoverDeleteResult"]],
updateHistoryCover?: [{	by:ValueTypes["HistoryCoverUniqueWhere"],	filter?:ValueTypes["HistoryCoverWhere"] | null,	data:ValueTypes["HistoryCoverUpdateInput"]},ValueTypes["HistoryCoverUpdateResult"]],
upsertHistoryCover?: [{	by:ValueTypes["HistoryCoverUniqueWhere"],	filter?:ValueTypes["HistoryCoverWhere"] | null,	update:ValueTypes["HistoryCoverUpdateInput"],	create:ValueTypes["HistoryCoverCreateInput"]},ValueTypes["HistoryCoverUpsertResult"]],
createHistoryTextList?: [{	data:ValueTypes["HistoryTextListCreateInput"]},ValueTypes["HistoryTextListCreateResult"]],
deleteHistoryTextList?: [{	by:ValueTypes["HistoryTextListUniqueWhere"],	filter?:ValueTypes["HistoryTextListWhere"] | null},ValueTypes["HistoryTextListDeleteResult"]],
updateHistoryTextList?: [{	by:ValueTypes["HistoryTextListUniqueWhere"],	filter?:ValueTypes["HistoryTextListWhere"] | null,	data:ValueTypes["HistoryTextListUpdateInput"]},ValueTypes["HistoryTextListUpdateResult"]],
upsertHistoryTextList?: [{	by:ValueTypes["HistoryTextListUniqueWhere"],	filter?:ValueTypes["HistoryTextListWhere"] | null,	update:ValueTypes["HistoryTextListUpdateInput"],	create:ValueTypes["HistoryTextListCreateInput"]},ValueTypes["HistoryTextListUpsertResult"]],
createHistoryTextItem?: [{	data:ValueTypes["HistoryTextItemCreateInput"]},ValueTypes["HistoryTextItemCreateResult"]],
deleteHistoryTextItem?: [{	by:ValueTypes["HistoryTextItemUniqueWhere"],	filter?:ValueTypes["HistoryTextItemWhere"] | null},ValueTypes["HistoryTextItemDeleteResult"]],
updateHistoryTextItem?: [{	by:ValueTypes["HistoryTextItemUniqueWhere"],	filter?:ValueTypes["HistoryTextItemWhere"] | null,	data:ValueTypes["HistoryTextItemUpdateInput"]},ValueTypes["HistoryTextItemUpdateResult"]],
upsertHistoryTextItem?: [{	by:ValueTypes["HistoryTextItemUniqueWhere"],	filter?:ValueTypes["HistoryTextItemWhere"] | null,	update:ValueTypes["HistoryTextItemUpdateInput"],	create:ValueTypes["HistoryTextItemCreateInput"]},ValueTypes["HistoryTextItemUpsertResult"]],
createFooterMenu?: [{	data:ValueTypes["FooterMenuCreateInput"]},ValueTypes["FooterMenuCreateResult"]],
deleteFooterMenu?: [{	by:ValueTypes["FooterMenuUniqueWhere"],	filter?:ValueTypes["FooterMenuWhere"] | null},ValueTypes["FooterMenuDeleteResult"]],
updateFooterMenu?: [{	by:ValueTypes["FooterMenuUniqueWhere"],	filter?:ValueTypes["FooterMenuWhere"] | null,	data:ValueTypes["FooterMenuUpdateInput"]},ValueTypes["FooterMenuUpdateResult"]],
upsertFooterMenu?: [{	by:ValueTypes["FooterMenuUniqueWhere"],	filter?:ValueTypes["FooterMenuWhere"] | null,	update:ValueTypes["FooterMenuUpdateInput"],	create:ValueTypes["FooterMenuCreateInput"]},ValueTypes["FooterMenuUpsertResult"]],
createLinkSection?: [{	data:ValueTypes["LinkSectionCreateInput"]},ValueTypes["LinkSectionCreateResult"]],
deleteLinkSection?: [{	by:ValueTypes["LinkSectionUniqueWhere"],	filter?:ValueTypes["LinkSectionWhere"] | null},ValueTypes["LinkSectionDeleteResult"]],
updateLinkSection?: [{	by:ValueTypes["LinkSectionUniqueWhere"],	filter?:ValueTypes["LinkSectionWhere"] | null,	data:ValueTypes["LinkSectionUpdateInput"]},ValueTypes["LinkSectionUpdateResult"]],
upsertLinkSection?: [{	by:ValueTypes["LinkSectionUniqueWhere"],	filter?:ValueTypes["LinkSectionWhere"] | null,	update:ValueTypes["LinkSectionUpdateInput"],	create:ValueTypes["LinkSectionCreateInput"]},ValueTypes["LinkSectionUpsertResult"]],
createLinkList?: [{	data:ValueTypes["LinkListCreateInput"]},ValueTypes["LinkListCreateResult"]],
deleteLinkList?: [{	by:ValueTypes["LinkListUniqueWhere"],	filter?:ValueTypes["LinkListWhere"] | null},ValueTypes["LinkListDeleteResult"]],
updateLinkList?: [{	by:ValueTypes["LinkListUniqueWhere"],	filter?:ValueTypes["LinkListWhere"] | null,	data:ValueTypes["LinkListUpdateInput"]},ValueTypes["LinkListUpdateResult"]],
upsertLinkList?: [{	by:ValueTypes["LinkListUniqueWhere"],	filter?:ValueTypes["LinkListWhere"] | null,	update:ValueTypes["LinkListUpdateInput"],	create:ValueTypes["LinkListCreateInput"]},ValueTypes["LinkListUpsertResult"]],
createLinkItem?: [{	data:ValueTypes["LinkItemCreateInput"]},ValueTypes["LinkItemCreateResult"]],
deleteLinkItem?: [{	by:ValueTypes["LinkItemUniqueWhere"],	filter?:ValueTypes["LinkItemWhere"] | null},ValueTypes["LinkItemDeleteResult"]],
updateLinkItem?: [{	by:ValueTypes["LinkItemUniqueWhere"],	filter?:ValueTypes["LinkItemWhere"] | null,	data:ValueTypes["LinkItemUpdateInput"]},ValueTypes["LinkItemUpdateResult"]],
upsertLinkItem?: [{	by:ValueTypes["LinkItemUniqueWhere"],	filter?:ValueTypes["LinkItemWhere"] | null,	update:ValueTypes["LinkItemUpdateInput"],	create:ValueTypes["LinkItemCreateInput"]},ValueTypes["LinkItemUpsertResult"]],
createNewsletterSection?: [{	data:ValueTypes["NewsletterSectionCreateInput"]},ValueTypes["NewsletterSectionCreateResult"]],
deleteNewsletterSection?: [{	by:ValueTypes["NewsletterSectionUniqueWhere"],	filter?:ValueTypes["NewsletterSectionWhere"] | null},ValueTypes["NewsletterSectionDeleteResult"]],
updateNewsletterSection?: [{	by:ValueTypes["NewsletterSectionUniqueWhere"],	filter?:ValueTypes["NewsletterSectionWhere"] | null,	data:ValueTypes["NewsletterSectionUpdateInput"]},ValueTypes["NewsletterSectionUpdateResult"]],
upsertNewsletterSection?: [{	by:ValueTypes["NewsletterSectionUniqueWhere"],	filter?:ValueTypes["NewsletterSectionWhere"] | null,	update:ValueTypes["NewsletterSectionUpdateInput"],	create:ValueTypes["NewsletterSectionCreateInput"]},ValueTypes["NewsletterSectionUpsertResult"]],
createNewsletter?: [{	data:ValueTypes["NewsletterCreateInput"]},ValueTypes["NewsletterCreateResult"]],
deleteNewsletter?: [{	by:ValueTypes["NewsletterUniqueWhere"],	filter?:ValueTypes["NewsletterWhere"] | null},ValueTypes["NewsletterDeleteResult"]],
updateNewsletter?: [{	by:ValueTypes["NewsletterUniqueWhere"],	filter?:ValueTypes["NewsletterWhere"] | null,	data:ValueTypes["NewsletterUpdateInput"]},ValueTypes["NewsletterUpdateResult"]],
upsertNewsletter?: [{	by:ValueTypes["NewsletterUniqueWhere"],	filter?:ValueTypes["NewsletterWhere"] | null,	update:ValueTypes["NewsletterUpdateInput"],	create:ValueTypes["NewsletterCreateInput"]},ValueTypes["NewsletterUpsertResult"]],
createOnlineSection?: [{	data:ValueTypes["OnlineSectionCreateInput"]},ValueTypes["OnlineSectionCreateResult"]],
deleteOnlineSection?: [{	by:ValueTypes["OnlineSectionUniqueWhere"],	filter?:ValueTypes["OnlineSectionWhere"] | null},ValueTypes["OnlineSectionDeleteResult"]],
updateOnlineSection?: [{	by:ValueTypes["OnlineSectionUniqueWhere"],	filter?:ValueTypes["OnlineSectionWhere"] | null,	data:ValueTypes["OnlineSectionUpdateInput"]},ValueTypes["OnlineSectionUpdateResult"]],
upsertOnlineSection?: [{	by:ValueTypes["OnlineSectionUniqueWhere"],	filter?:ValueTypes["OnlineSectionWhere"] | null,	update:ValueTypes["OnlineSectionUpdateInput"],	create:ValueTypes["OnlineSectionCreateInput"]},ValueTypes["OnlineSectionUpsertResult"]],
createAppLink?: [{	data:ValueTypes["AppLinkCreateInput"]},ValueTypes["AppLinkCreateResult"]],
deleteAppLink?: [{	by:ValueTypes["AppLinkUniqueWhere"],	filter?:ValueTypes["AppLinkWhere"] | null},ValueTypes["AppLinkDeleteResult"]],
updateAppLink?: [{	by:ValueTypes["AppLinkUniqueWhere"],	filter?:ValueTypes["AppLinkWhere"] | null,	data:ValueTypes["AppLinkUpdateInput"]},ValueTypes["AppLinkUpdateResult"]],
upsertAppLink?: [{	by:ValueTypes["AppLinkUniqueWhere"],	filter?:ValueTypes["AppLinkWhere"] | null,	update:ValueTypes["AppLinkUpdateInput"],	create:ValueTypes["AppLinkCreateInput"]},ValueTypes["AppLinkUpsertResult"]],
createAppLinkList?: [{	data:ValueTypes["AppLinkListCreateInput"]},ValueTypes["AppLinkListCreateResult"]],
deleteAppLinkList?: [{	by:ValueTypes["AppLinkListUniqueWhere"],	filter?:ValueTypes["AppLinkListWhere"] | null},ValueTypes["AppLinkListDeleteResult"]],
updateAppLinkList?: [{	by:ValueTypes["AppLinkListUniqueWhere"],	filter?:ValueTypes["AppLinkListWhere"] | null,	data:ValueTypes["AppLinkListUpdateInput"]},ValueTypes["AppLinkListUpdateResult"]],
upsertAppLinkList?: [{	by:ValueTypes["AppLinkListUniqueWhere"],	filter?:ValueTypes["AppLinkListWhere"] | null,	update:ValueTypes["AppLinkListUpdateInput"],	create:ValueTypes["AppLinkListCreateInput"]},ValueTypes["AppLinkListUpsertResult"]],
createAppLinkItem?: [{	data:ValueTypes["AppLinkItemCreateInput"]},ValueTypes["AppLinkItemCreateResult"]],
deleteAppLinkItem?: [{	by:ValueTypes["AppLinkItemUniqueWhere"],	filter?:ValueTypes["AppLinkItemWhere"] | null},ValueTypes["AppLinkItemDeleteResult"]],
updateAppLinkItem?: [{	by:ValueTypes["AppLinkItemUniqueWhere"],	filter?:ValueTypes["AppLinkItemWhere"] | null,	data:ValueTypes["AppLinkItemUpdateInput"]},ValueTypes["AppLinkItemUpdateResult"]],
upsertAppLinkItem?: [{	by:ValueTypes["AppLinkItemUniqueWhere"],	filter?:ValueTypes["AppLinkItemWhere"] | null,	update:ValueTypes["AppLinkItemUpdateInput"],	create:ValueTypes["AppLinkItemCreateInput"]},ValueTypes["AppLinkItemUpsertResult"]],
createSocialSection?: [{	data:ValueTypes["SocialSectionCreateInput"]},ValueTypes["SocialSectionCreateResult"]],
deleteSocialSection?: [{	by:ValueTypes["SocialSectionUniqueWhere"],	filter?:ValueTypes["SocialSectionWhere"] | null},ValueTypes["SocialSectionDeleteResult"]],
updateSocialSection?: [{	by:ValueTypes["SocialSectionUniqueWhere"],	filter?:ValueTypes["SocialSectionWhere"] | null,	data:ValueTypes["SocialSectionUpdateInput"]},ValueTypes["SocialSectionUpdateResult"]],
upsertSocialSection?: [{	by:ValueTypes["SocialSectionUniqueWhere"],	filter?:ValueTypes["SocialSectionWhere"] | null,	update:ValueTypes["SocialSectionUpdateInput"],	create:ValueTypes["SocialSectionCreateInput"]},ValueTypes["SocialSectionUpsertResult"]],
createSocialLink?: [{	data:ValueTypes["SocialLinkCreateInput"]},ValueTypes["SocialLinkCreateResult"]],
deleteSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkWhere"] | null},ValueTypes["SocialLinkDeleteResult"]],
updateSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkWhere"] | null,	data:ValueTypes["SocialLinkUpdateInput"]},ValueTypes["SocialLinkUpdateResult"]],
upsertSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkWhere"] | null,	update:ValueTypes["SocialLinkUpdateInput"],	create:ValueTypes["SocialLinkCreateInput"]},ValueTypes["SocialLinkUpsertResult"]],
createSocialLinkList?: [{	data:ValueTypes["SocialLinkListCreateInput"]},ValueTypes["SocialLinkListCreateResult"]],
deleteSocialLinkList?: [{	by:ValueTypes["SocialLinkListUniqueWhere"],	filter?:ValueTypes["SocialLinkListWhere"] | null},ValueTypes["SocialLinkListDeleteResult"]],
updateSocialLinkList?: [{	by:ValueTypes["SocialLinkListUniqueWhere"],	filter?:ValueTypes["SocialLinkListWhere"] | null,	data:ValueTypes["SocialLinkListUpdateInput"]},ValueTypes["SocialLinkListUpdateResult"]],
upsertSocialLinkList?: [{	by:ValueTypes["SocialLinkListUniqueWhere"],	filter?:ValueTypes["SocialLinkListWhere"] | null,	update:ValueTypes["SocialLinkListUpdateInput"],	create:ValueTypes["SocialLinkListCreateInput"]},ValueTypes["SocialLinkListUpsertResult"]],
createSocialLinkItem?: [{	data:ValueTypes["SocialLinkItemCreateInput"]},ValueTypes["SocialLinkItemCreateResult"]],
deleteSocialLinkItem?: [{	by:ValueTypes["SocialLinkItemUniqueWhere"],	filter?:ValueTypes["SocialLinkItemWhere"] | null},ValueTypes["SocialLinkItemDeleteResult"]],
updateSocialLinkItem?: [{	by:ValueTypes["SocialLinkItemUniqueWhere"],	filter?:ValueTypes["SocialLinkItemWhere"] | null,	data:ValueTypes["SocialLinkItemUpdateInput"]},ValueTypes["SocialLinkItemUpdateResult"]],
upsertSocialLinkItem?: [{	by:ValueTypes["SocialLinkItemUniqueWhere"],	filter?:ValueTypes["SocialLinkItemWhere"] | null,	update:ValueTypes["SocialLinkItemUpdateInput"],	create:ValueTypes["SocialLinkItemCreateInput"]},ValueTypes["SocialLinkItemUpsertResult"]],
createSharedContent?: [{	data:ValueTypes["SharedContentCreateInput"]},ValueTypes["SharedContentCreateResult"]],
deleteSharedContent?: [{	by:ValueTypes["SharedContentUniqueWhere"],	filter?:ValueTypes["SharedContentWhere"] | null},ValueTypes["SharedContentDeleteResult"]],
updateSharedContent?: [{	by:ValueTypes["SharedContentUniqueWhere"],	filter?:ValueTypes["SharedContentWhere"] | null,	data:ValueTypes["SharedContentUpdateInput"]},ValueTypes["SharedContentUpdateResult"]],
upsertSharedContent?: [{	by:ValueTypes["SharedContentUniqueWhere"],	filter?:ValueTypes["SharedContentWhere"] | null,	update:ValueTypes["SharedContentUpdateInput"],	create:ValueTypes["SharedContentCreateInput"]},ValueTypes["SharedContentUpsertResult"]],
	query?:ValueTypes["Query"],
		__typename?: boolean
}>;
	["MutationTransactionOptions"]: {
	deferForeignKeyConstraints?:boolean | null
};
	/** Json custom scalar type */
["Json"]:unknown;
	["_Schema"]: AliasType<{
	enums?:ValueTypes["_Enum"],
	entities?:ValueTypes["_Entity"],
		__typename?: boolean
}>;
	["_Entity"]: AliasType<{
	name?:boolean,
	customPrimaryAllowed?:boolean,
	fields?:ValueTypes["_Field"],
	unique?:ValueTypes["_UniqueConstraint"],
		__typename?: boolean
}>;
	["_UniqueConstraint"]: AliasType<{
	fields?:boolean,
		__typename?: boolean
}>;
	["_Field"]:AliasType<{
		name?:boolean,
	type?:boolean,
	nullable?:boolean,
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"];
		['...on _Column']?: Omit<ValueTypes["_Column"],keyof ValueTypes["_Field"]>;
		['...on _Relation']?: Omit<ValueTypes["_Relation"],keyof ValueTypes["_Field"]>;
		__typename?: boolean
}>;
	["_Column"]: AliasType<{
	name?:boolean,
	type?:boolean,
	enumName?:boolean,
	defaultValue?:boolean,
	nullable?:boolean,
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"],
		__typename?: boolean
}>;
	["_OnDeleteBehaviour"]:_OnDeleteBehaviour;
	["_RelationSide"]:_RelationSide;
	["_OrderByDirection"]:_OrderByDirection;
	["_OrderBy"]: AliasType<{
	path?:boolean,
	direction?:boolean,
		__typename?: boolean
}>;
	["_Relation"]: AliasType<{
	name?:boolean,
	type?:boolean,
	side?:boolean,
	targetEntity?:boolean,
	ownedBy?:boolean,
	inversedBy?:boolean,
	nullable?:boolean,
	onDelete?:boolean,
	orphanRemoval?:boolean,
	orderBy?:ValueTypes["_OrderBy"],
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"],
		__typename?: boolean
}>;
	["_Rule"]: AliasType<{
	message?:ValueTypes["_RuleMessage"],
	validator?:boolean,
		__typename?: boolean
}>;
	["_Validator"]: AliasType<{
	operation?:boolean,
	arguments?:ValueTypes["_Argument"],
		__typename?: boolean
}>;
	["_Argument"]: AliasType<{		["...on _ValidatorArgument"] : ValueTypes["_ValidatorArgument"],
		["...on _PathArgument"] : ValueTypes["_PathArgument"],
		["...on _LiteralArgument"] : ValueTypes["_LiteralArgument"]
		__typename?: boolean
}>;
	["_ValidatorArgument"]: AliasType<{
	validator?:boolean,
		__typename?: boolean
}>;
	["_PathArgument"]: AliasType<{
	path?:boolean,
		__typename?: boolean
}>;
	["_LiteralArgument"]: AliasType<{
	value?:boolean,
		__typename?: boolean
}>;
	["_RuleMessage"]: AliasType<{
	text?:boolean,
		__typename?: boolean
}>;
	["_Enum"]: AliasType<{
	name?:boolean,
	values?:boolean,
		__typename?: boolean
}>;
	["S3SignedUpload"]: AliasType<{
	url?:boolean,
	headers?:ValueTypes["S3Header"],
	method?:boolean,
	/** Allowed patterns:
** */
	objectKey?:boolean,
	bucket?:boolean,
	publicUrl?:boolean,
		__typename?: boolean
}>;
	["S3Header"]: AliasType<{
	key?:boolean,
	value?:boolean,
		__typename?: boolean
}>;
	["S3Acl"]:S3Acl;
	["S3SignedRead"]: AliasType<{
	url?:boolean,
	headers?:ValueTypes["S3Header"],
	method?:boolean,
	/** Allowed patterns:
** */
	objectKey?:boolean,
	bucket?:boolean,
		__typename?: boolean
}>
  }

export type ModelTypes = {
    ["Query"]: {
		getArticle?:ModelTypes["Article"],
	listArticle:ModelTypes["Article"][],
	paginateArticle:ModelTypes["ArticleConnection"],
	validateCreateArticle:ModelTypes["_ValidationResult"],
	validateUpdateArticle:ModelTypes["_ValidationResult"],
	getArticleAuthor?:ModelTypes["ArticleAuthor"],
	listArticleAuthor:ModelTypes["ArticleAuthor"][],
	paginateArticleAuthor:ModelTypes["ArticleAuthorConnection"],
	validateCreateArticleAuthor:ModelTypes["_ValidationResult"],
	validateUpdateArticleAuthor:ModelTypes["_ValidationResult"],
	getAuthor?:ModelTypes["Author"],
	listAuthor:ModelTypes["Author"][],
	paginateAuthor:ModelTypes["AuthorConnection"],
	validateCreateAuthor:ModelTypes["_ValidationResult"],
	validateUpdateAuthor:ModelTypes["_ValidationResult"],
	getAuthorTopArticle?:ModelTypes["AuthorTopArticle"],
	listAuthorTopArticle:ModelTypes["AuthorTopArticle"][],
	paginateAuthorTopArticle:ModelTypes["AuthorTopArticleConnection"],
	validateCreateAuthorTopArticle:ModelTypes["_ValidationResult"],
	validateUpdateAuthorTopArticle:ModelTypes["_ValidationResult"],
	getContent?:ModelTypes["Content"],
	listContent:ModelTypes["Content"][],
	paginateContent:ModelTypes["ContentConnection"],
	validateCreateContent:ModelTypes["_ValidationResult"],
	validateUpdateContent:ModelTypes["_ValidationResult"],
	getContentPart?:ModelTypes["ContentPart"],
	listContentPart:ModelTypes["ContentPart"][],
	paginateContentPart:ModelTypes["ContentPartConnection"],
	validateCreateContentPart:ModelTypes["_ValidationResult"],
	validateUpdateContentPart:ModelTypes["_ValidationResult"],
	getContentReference?:ModelTypes["ContentReference"],
	listContentReference:ModelTypes["ContentReference"][],
	paginateContentReference:ModelTypes["ContentReferenceConnection"],
	validateCreateContentReference:ModelTypes["_ValidationResult"],
	validateUpdateContentReference:ModelTypes["_ValidationResult"],
	getHomepageArticle?:ModelTypes["HomepageArticle"],
	listHomepageArticle:ModelTypes["HomepageArticle"][],
	paginateHomepageArticle:ModelTypes["HomepageArticleConnection"],
	validateCreateHomepageArticle:ModelTypes["_ValidationResult"],
	validateUpdateHomepageArticle:ModelTypes["_ValidationResult"],
	getImage?:ModelTypes["Image"],
	listImage:ModelTypes["Image"][],
	paginateImage:ModelTypes["ImageConnection"],
	validateCreateImage:ModelTypes["_ValidationResult"],
	validateUpdateImage:ModelTypes["_ValidationResult"],
	getImageUse?:ModelTypes["ImageUse"],
	listImageUse:ModelTypes["ImageUse"][],
	paginateImageUse:ModelTypes["ImageUseConnection"],
	validateCreateImageUse:ModelTypes["_ValidationResult"],
	validateUpdateImageUse:ModelTypes["_ValidationResult"],
	getImageTag?:ModelTypes["ImageTag"],
	listImageTag:ModelTypes["ImageTag"][],
	paginateImageTag:ModelTypes["ImageTagConnection"],
	validateCreateImageTag:ModelTypes["_ValidationResult"],
	validateUpdateImageTag:ModelTypes["_ValidationResult"],
	getIssue?:ModelTypes["Issue"],
	listIssue:ModelTypes["Issue"][],
	paginateIssue:ModelTypes["IssueConnection"],
	validateCreateIssue:ModelTypes["_ValidationResult"],
	validateUpdateIssue:ModelTypes["_ValidationResult"],
	getIssueArticle?:ModelTypes["IssueArticle"],
	listIssueArticle:ModelTypes["IssueArticle"][],
	paginateIssueArticle:ModelTypes["IssueArticleConnection"],
	validateCreateIssueArticle:ModelTypes["_ValidationResult"],
	validateUpdateIssueArticle:ModelTypes["_ValidationResult"],
	getLink?:ModelTypes["Link"],
	listLink:ModelTypes["Link"][],
	paginateLink:ModelTypes["LinkConnection"],
	validateCreateLink:ModelTypes["_ValidationResult"],
	validateUpdateLink:ModelTypes["_ValidationResult"],
	getTextContent?:ModelTypes["TextContent"],
	listTextContent:ModelTypes["TextContent"][],
	paginateTextContent:ModelTypes["TextContentConnection"],
	validateCreateTextContent:ModelTypes["_ValidationResult"],
	validateUpdateTextContent:ModelTypes["_ValidationResult"],
	getTextContentPart?:ModelTypes["TextContentPart"],
	listTextContentPart:ModelTypes["TextContentPart"][],
	paginateTextContentPart:ModelTypes["TextContentPartConnection"],
	validateCreateTextContentPart:ModelTypes["_ValidationResult"],
	validateUpdateTextContentPart:ModelTypes["_ValidationResult"],
	getTextContentReference?:ModelTypes["TextContentReference"],
	listTextContentReference:ModelTypes["TextContentReference"][],
	paginateTextContentReference:ModelTypes["TextContentReferenceConnection"],
	validateCreateTextContentReference:ModelTypes["_ValidationResult"],
	validateUpdateTextContentReference:ModelTypes["_ValidationResult"],
	getUrl?:ModelTypes["Url"],
	listUrl:ModelTypes["Url"][],
	paginateUrl:ModelTypes["UrlConnection"],
	validateCreateUrl:ModelTypes["_ValidationResult"],
	validateUpdateUrl:ModelTypes["_ValidationResult"],
	getArticleTag?:ModelTypes["ArticleTag"],
	listArticleTag:ModelTypes["ArticleTag"][],
	paginateArticleTag:ModelTypes["ArticleTagConnection"],
	validateCreateArticleTag:ModelTypes["_ValidationResult"],
	validateUpdateArticleTag:ModelTypes["_ValidationResult"],
	getCategory?:ModelTypes["Category"],
	listCategory:ModelTypes["Category"][],
	paginateCategory:ModelTypes["CategoryConnection"],
	validateCreateCategory:ModelTypes["_ValidationResult"],
	validateUpdateCategory:ModelTypes["_ValidationResult"],
	getArticleCategory?:ModelTypes["ArticleCategory"],
	listArticleCategory:ModelTypes["ArticleCategory"][],
	paginateArticleCategory:ModelTypes["ArticleCategoryConnection"],
	validateCreateArticleCategory:ModelTypes["_ValidationResult"],
	validateUpdateArticleCategory:ModelTypes["_ValidationResult"],
	getAudio?:ModelTypes["Audio"],
	listAudio:ModelTypes["Audio"][],
	paginateAudio:ModelTypes["AudioConnection"],
	validateCreateAudio:ModelTypes["_ValidationResult"],
	validateUpdateAudio:ModelTypes["_ValidationResult"],
	getAudioUse?:ModelTypes["AudioUse"],
	listAudioUse:ModelTypes["AudioUse"][],
	paginateAudioUse:ModelTypes["AudioUseConnection"],
	validateCreateAudioUse:ModelTypes["_ValidationResult"],
	validateUpdateAudioUse:ModelTypes["_ValidationResult"],
	getEmbed?:ModelTypes["Embed"],
	listEmbed:ModelTypes["Embed"][],
	paginateEmbed:ModelTypes["EmbedConnection"],
	validateCreateEmbed:ModelTypes["_ValidationResult"],
	validateUpdateEmbed:ModelTypes["_ValidationResult"],
	getImageContent?:ModelTypes["ImageContent"],
	listImageContent:ModelTypes["ImageContent"][],
	paginateImageContent:ModelTypes["ImageContentConnection"],
	validateCreateImageContent:ModelTypes["_ValidationResult"],
	validateUpdateImageContent:ModelTypes["_ValidationResult"],
	getListicle?:ModelTypes["Listicle"],
	listListicle:ModelTypes["Listicle"][],
	paginateListicle:ModelTypes["ListicleConnection"],
	validateCreateListicle:ModelTypes["_ValidationResult"],
	validateUpdateListicle:ModelTypes["_ValidationResult"],
	getPollAnswer?:ModelTypes["PollAnswer"],
	listPollAnswer:ModelTypes["PollAnswer"][],
	paginatePollAnswer:ModelTypes["PollAnswerConnection"],
	validateCreatePollAnswer:ModelTypes["_ValidationResult"],
	validateUpdatePollAnswer:ModelTypes["_ValidationResult"],
	getTag?:ModelTypes["Tag"],
	listTag:ModelTypes["Tag"][],
	paginateTag:ModelTypes["TagConnection"],
	validateCreateTag:ModelTypes["_ValidationResult"],
	validateUpdateTag:ModelTypes["_ValidationResult"],
	getFAQ?:ModelTypes["FAQ"],
	listFAQ:ModelTypes["FAQ"][],
	paginateFAQ:ModelTypes["FAQConnection"],
	validateCreateFAQ:ModelTypes["_ValidationResult"],
	validateUpdateFAQ:ModelTypes["_ValidationResult"],
	getLinkContent?:ModelTypes["LinkContent"],
	listLinkContent:ModelTypes["LinkContent"][],
	paginateLinkContent:ModelTypes["LinkContentConnection"],
	validateCreateLinkContent:ModelTypes["_ValidationResult"],
	validateUpdateLinkContent:ModelTypes["_ValidationResult"],
	getAwardContent?:ModelTypes["AwardContent"],
	listAwardContent:ModelTypes["AwardContent"][],
	paginateAwardContent:ModelTypes["AwardContentConnection"],
	validateCreateAwardContent:ModelTypes["_ValidationResult"],
	validateUpdateAwardContent:ModelTypes["_ValidationResult"],
	getReviewContent?:ModelTypes["ReviewContent"],
	listReviewContent:ModelTypes["ReviewContent"][],
	paginateReviewContent:ModelTypes["ReviewContentConnection"],
	validateCreateReviewContent:ModelTypes["_ValidationResult"],
	validateUpdateReviewContent:ModelTypes["_ValidationResult"],
	getPage?:ModelTypes["Page"],
	listPage:ModelTypes["Page"][],
	paginatePage:ModelTypes["PageConnection"],
	validateCreatePage:ModelTypes["_ValidationResult"],
	validateUpdatePage:ModelTypes["_ValidationResult"],
	getTextTranslation?:ModelTypes["TextTranslation"],
	listTextTranslation:ModelTypes["TextTranslation"][],
	paginateTextTranslation:ModelTypes["TextTranslationConnection"],
	validateCreateTextTranslation:ModelTypes["_ValidationResult"],
	validateUpdateTextTranslation:ModelTypes["_ValidationResult"],
	getSeo?:ModelTypes["Seo"],
	listSeo:ModelTypes["Seo"][],
	paginateSeo:ModelTypes["SeoConnection"],
	validateCreateSeo:ModelTypes["_ValidationResult"],
	validateUpdateSeo:ModelTypes["_ValidationResult"],
	getFile?:ModelTypes["File"],
	listFile:ModelTypes["File"][],
	paginateFile:ModelTypes["FileConnection"],
	validateCreateFile:ModelTypes["_ValidationResult"],
	validateUpdateFile:ModelTypes["_ValidationResult"],
	getFileUse?:ModelTypes["FileUse"],
	listFileUse:ModelTypes["FileUse"][],
	paginateFileUse:ModelTypes["FileUseConnection"],
	validateCreateFileUse:ModelTypes["_ValidationResult"],
	validateUpdateFileUse:ModelTypes["_ValidationResult"],
	getContentBlock?:ModelTypes["ContentBlock"],
	listContentBlock:ModelTypes["ContentBlock"][],
	paginateContentBlock:ModelTypes["ContentBlockConnection"],
	validateCreateContentBlock:ModelTypes["_ValidationResult"],
	validateUpdateContentBlock:ModelTypes["_ValidationResult"],
	getContentArticle?:ModelTypes["ContentArticle"],
	listContentArticle:ModelTypes["ContentArticle"][],
	paginateContentArticle:ModelTypes["ContentArticleConnection"],
	validateCreateContentArticle:ModelTypes["_ValidationResult"],
	validateUpdateContentArticle:ModelTypes["_ValidationResult"],
	getUnlockedArticle?:ModelTypes["UnlockedArticle"],
	listUnlockedArticle:ModelTypes["UnlockedArticle"][],
	paginateUnlockedArticle:ModelTypes["UnlockedArticleConnection"],
	validateCreateUnlockedArticle:ModelTypes["_ValidationResult"],
	validateUpdateUnlockedArticle:ModelTypes["_ValidationResult"],
	getUser?:ModelTypes["User"],
	listUser:ModelTypes["User"][],
	paginateUser:ModelTypes["UserConnection"],
	validateCreateUser:ModelTypes["_ValidationResult"],
	validateUpdateUser:ModelTypes["_ValidationResult"],
	getNotification?:ModelTypes["Notification"],
	listNotification:ModelTypes["Notification"][],
	paginateNotification:ModelTypes["NotificationConnection"],
	validateCreateNotification:ModelTypes["_ValidationResult"],
	validateUpdateNotification:ModelTypes["_ValidationResult"],
	getAppReview?:ModelTypes["AppReview"],
	listAppReview:ModelTypes["AppReview"][],
	paginateAppReview:ModelTypes["AppReviewConnection"],
	validateCreateAppReview:ModelTypes["_ValidationResult"],
	validateUpdateAppReview:ModelTypes["_ValidationResult"],
	getProduct?:ModelTypes["Product"],
	listProduct:ModelTypes["Product"][],
	paginateProduct:ModelTypes["ProductConnection"],
	validateCreateProduct:ModelTypes["_ValidationResult"],
	validateUpdateProduct:ModelTypes["_ValidationResult"],
	getSubscriptionForm?:ModelTypes["SubscriptionForm"],
	listSubscriptionForm:ModelTypes["SubscriptionForm"][],
	paginateSubscriptionForm:ModelTypes["SubscriptionFormConnection"],
	validateCreateSubscriptionForm:ModelTypes["_ValidationResult"],
	validateUpdateSubscriptionForm:ModelTypes["_ValidationResult"],
	getSubscriptionFormSection?:ModelTypes["SubscriptionFormSection"],
	listSubscriptionFormSection:ModelTypes["SubscriptionFormSection"][],
	paginateSubscriptionFormSection:ModelTypes["SubscriptionFormSectionConnection"],
	validateCreateSubscriptionFormSection:ModelTypes["_ValidationResult"],
	validateUpdateSubscriptionFormSection:ModelTypes["_ValidationResult"],
	getSubscriptionFormInput?:ModelTypes["SubscriptionFormInput"],
	listSubscriptionFormInput:ModelTypes["SubscriptionFormInput"][],
	paginateSubscriptionFormInput:ModelTypes["SubscriptionFormInputConnection"],
	validateCreateSubscriptionFormInput:ModelTypes["_ValidationResult"],
	validateUpdateSubscriptionFormInput:ModelTypes["_ValidationResult"],
	getSubscriptionFormOption?:ModelTypes["SubscriptionFormOption"],
	listSubscriptionFormOption:ModelTypes["SubscriptionFormOption"][],
	paginateSubscriptionFormOption:ModelTypes["SubscriptionFormOptionConnection"],
	validateCreateSubscriptionFormOption:ModelTypes["_ValidationResult"],
	validateUpdateSubscriptionFormOption:ModelTypes["_ValidationResult"],
	getButton?:ModelTypes["Button"],
	listButton:ModelTypes["Button"][],
	paginateButton:ModelTypes["ButtonConnection"],
	validateCreateButton:ModelTypes["_ValidationResult"],
	validateUpdateButton:ModelTypes["_ValidationResult"],
	getArticleHistoryTag?:ModelTypes["ArticleHistoryTag"],
	listArticleHistoryTag:ModelTypes["ArticleHistoryTag"][],
	paginateArticleHistoryTag:ModelTypes["ArticleHistoryTagConnection"],
	validateCreateArticleHistoryTag:ModelTypes["_ValidationResult"],
	validateUpdateArticleHistoryTag:ModelTypes["_ValidationResult"],
	getArticleHistoryPeriod?:ModelTypes["ArticleHistoryPeriod"],
	listArticleHistoryPeriod:ModelTypes["ArticleHistoryPeriod"][],
	paginateArticleHistoryPeriod:ModelTypes["ArticleHistoryPeriodConnection"],
	validateCreateArticleHistoryPeriod:ModelTypes["_ValidationResult"],
	validateUpdateArticleHistoryPeriod:ModelTypes["_ValidationResult"],
	getHistoryTag?:ModelTypes["HistoryTag"],
	listHistoryTag:ModelTypes["HistoryTag"][],
	paginateHistoryTag:ModelTypes["HistoryTagConnection"],
	validateCreateHistoryTag:ModelTypes["_ValidationResult"],
	validateUpdateHistoryTag:ModelTypes["_ValidationResult"],
	getHistoryPeriod?:ModelTypes["HistoryPeriod"],
	listHistoryPeriod:ModelTypes["HistoryPeriod"][],
	paginateHistoryPeriod:ModelTypes["HistoryPeriodConnection"],
	validateCreateHistoryPeriod:ModelTypes["_ValidationResult"],
	validateUpdateHistoryPeriod:ModelTypes["_ValidationResult"],
	getHistoryHomePage?:ModelTypes["HistoryHomePage"],
	listHistoryHomePage:ModelTypes["HistoryHomePage"][],
	paginateHistoryHomePage:ModelTypes["HistoryHomePageConnection"],
	validateCreateHistoryHomePage:ModelTypes["_ValidationResult"],
	validateUpdateHistoryHomePage:ModelTypes["_ValidationResult"],
	getHistoryCover?:ModelTypes["HistoryCover"],
	listHistoryCover:ModelTypes["HistoryCover"][],
	paginateHistoryCover:ModelTypes["HistoryCoverConnection"],
	validateCreateHistoryCover:ModelTypes["_ValidationResult"],
	validateUpdateHistoryCover:ModelTypes["_ValidationResult"],
	getHistoryTextList?:ModelTypes["HistoryTextList"],
	listHistoryTextList:ModelTypes["HistoryTextList"][],
	paginateHistoryTextList:ModelTypes["HistoryTextListConnection"],
	validateCreateHistoryTextList:ModelTypes["_ValidationResult"],
	validateUpdateHistoryTextList:ModelTypes["_ValidationResult"],
	getHistoryTextItem?:ModelTypes["HistoryTextItem"],
	listHistoryTextItem:ModelTypes["HistoryTextItem"][],
	paginateHistoryTextItem:ModelTypes["HistoryTextItemConnection"],
	validateCreateHistoryTextItem:ModelTypes["_ValidationResult"],
	validateUpdateHistoryTextItem:ModelTypes["_ValidationResult"],
	getFooterMenu?:ModelTypes["FooterMenu"],
	listFooterMenu:ModelTypes["FooterMenu"][],
	paginateFooterMenu:ModelTypes["FooterMenuConnection"],
	validateCreateFooterMenu:ModelTypes["_ValidationResult"],
	validateUpdateFooterMenu:ModelTypes["_ValidationResult"],
	getLinkSection?:ModelTypes["LinkSection"],
	listLinkSection:ModelTypes["LinkSection"][],
	paginateLinkSection:ModelTypes["LinkSectionConnection"],
	validateCreateLinkSection:ModelTypes["_ValidationResult"],
	validateUpdateLinkSection:ModelTypes["_ValidationResult"],
	getLinkList?:ModelTypes["LinkList"],
	listLinkList:ModelTypes["LinkList"][],
	paginateLinkList:ModelTypes["LinkListConnection"],
	validateCreateLinkList:ModelTypes["_ValidationResult"],
	validateUpdateLinkList:ModelTypes["_ValidationResult"],
	getLinkItem?:ModelTypes["LinkItem"],
	listLinkItem:ModelTypes["LinkItem"][],
	paginateLinkItem:ModelTypes["LinkItemConnection"],
	validateCreateLinkItem:ModelTypes["_ValidationResult"],
	validateUpdateLinkItem:ModelTypes["_ValidationResult"],
	getNewsletterSection?:ModelTypes["NewsletterSection"],
	listNewsletterSection:ModelTypes["NewsletterSection"][],
	paginateNewsletterSection:ModelTypes["NewsletterSectionConnection"],
	validateCreateNewsletterSection:ModelTypes["_ValidationResult"],
	validateUpdateNewsletterSection:ModelTypes["_ValidationResult"],
	getNewsletter?:ModelTypes["Newsletter"],
	listNewsletter:ModelTypes["Newsletter"][],
	paginateNewsletter:ModelTypes["NewsletterConnection"],
	validateCreateNewsletter:ModelTypes["_ValidationResult"],
	validateUpdateNewsletter:ModelTypes["_ValidationResult"],
	getOnlineSection?:ModelTypes["OnlineSection"],
	listOnlineSection:ModelTypes["OnlineSection"][],
	paginateOnlineSection:ModelTypes["OnlineSectionConnection"],
	validateCreateOnlineSection:ModelTypes["_ValidationResult"],
	validateUpdateOnlineSection:ModelTypes["_ValidationResult"],
	getAppLink?:ModelTypes["AppLink"],
	listAppLink:ModelTypes["AppLink"][],
	paginateAppLink:ModelTypes["AppLinkConnection"],
	validateCreateAppLink:ModelTypes["_ValidationResult"],
	validateUpdateAppLink:ModelTypes["_ValidationResult"],
	getAppLinkList?:ModelTypes["AppLinkList"],
	listAppLinkList:ModelTypes["AppLinkList"][],
	paginateAppLinkList:ModelTypes["AppLinkListConnection"],
	validateCreateAppLinkList:ModelTypes["_ValidationResult"],
	validateUpdateAppLinkList:ModelTypes["_ValidationResult"],
	getAppLinkItem?:ModelTypes["AppLinkItem"],
	listAppLinkItem:ModelTypes["AppLinkItem"][],
	paginateAppLinkItem:ModelTypes["AppLinkItemConnection"],
	validateCreateAppLinkItem:ModelTypes["_ValidationResult"],
	validateUpdateAppLinkItem:ModelTypes["_ValidationResult"],
	getSocialSection?:ModelTypes["SocialSection"],
	listSocialSection:ModelTypes["SocialSection"][],
	paginateSocialSection:ModelTypes["SocialSectionConnection"],
	validateCreateSocialSection:ModelTypes["_ValidationResult"],
	validateUpdateSocialSection:ModelTypes["_ValidationResult"],
	getSocialLink?:ModelTypes["SocialLink"],
	listSocialLink:ModelTypes["SocialLink"][],
	paginateSocialLink:ModelTypes["SocialLinkConnection"],
	validateCreateSocialLink:ModelTypes["_ValidationResult"],
	validateUpdateSocialLink:ModelTypes["_ValidationResult"],
	getSocialLinkList?:ModelTypes["SocialLinkList"],
	listSocialLinkList:ModelTypes["SocialLinkList"][],
	paginateSocialLinkList:ModelTypes["SocialLinkListConnection"],
	validateCreateSocialLinkList:ModelTypes["_ValidationResult"],
	validateUpdateSocialLinkList:ModelTypes["_ValidationResult"],
	getSocialLinkItem?:ModelTypes["SocialLinkItem"],
	listSocialLinkItem:ModelTypes["SocialLinkItem"][],
	paginateSocialLinkItem:ModelTypes["SocialLinkItemConnection"],
	validateCreateSocialLinkItem:ModelTypes["_ValidationResult"],
	validateUpdateSocialLinkItem:ModelTypes["_ValidationResult"],
	getSharedContent?:ModelTypes["SharedContent"],
	listSharedContent:ModelTypes["SharedContent"][],
	paginateSharedContent:ModelTypes["SharedContentConnection"],
	validateCreateSharedContent:ModelTypes["_ValidationResult"],
	validateUpdateSharedContent:ModelTypes["_ValidationResult"],
	transaction?:ModelTypes["QueryTransaction"],
	_info?:ModelTypes["Info"],
	schema?:ModelTypes["_Schema"],
	s3DummyQuery?:string
};
	["Article"]: {
		_meta?:ModelTypes["ArticleMeta"],
	id:ModelTypes["UUID"],
	title:string,
	url?:ModelTypes["Url"],
	authors:ModelTypes["ArticleAuthor"][],
	hideInMostRead:boolean,
	hideAds:boolean,
	state:ModelTypes["ArticleState"],
	locked:boolean,
	publishAt?:ModelTypes["DateTime"],
	template:ModelTypes["Template"],
	subtitle?:ModelTypes["TextContent"],
	content?:ModelTypes["Content"],
	coverPhoto?:ModelTypes["ImageUse"],
	titleAlignment:ModelTypes["ArticleTitleAlignment"],
	tagline?:string,
	createdAt:ModelTypes["DateTime"],
	previewContent?:ModelTypes["Content"],
	audio?:ModelTypes["AudioUse"],
	categories:ModelTypes["ArticleCategory"][],
	issues:ModelTypes["IssueArticle"][],
	contentBlocks:ModelTypes["ContentArticle"][],
	unlocked:ModelTypes["UnlockedArticle"][],
	coverPhotoVertical?:ModelTypes["ImageUse"],
	legacyId?:string,
	tags:ModelTypes["ArticleTag"][],
	isHistory:boolean,
	historyTags:ModelTypes["ArticleHistoryTag"][],
	historyPeriods:ModelTypes["ArticleHistoryPeriod"][],
	authorsByAuthor?:ModelTypes["ArticleAuthor"],
	authorsByLegacyStringAuthor?:ModelTypes["ArticleAuthor"],
	categoriesByCategory?:ModelTypes["ArticleCategory"],
	issuesByIssue?:ModelTypes["IssueArticle"],
	tagsByTag?:ModelTypes["ArticleTag"],
	historyTagsByHistoryTag?:ModelTypes["ArticleHistoryTag"],
	historyPeriodsByHistoryPeriod?:ModelTypes["ArticleHistoryPeriod"],
	paginateAuthors:ModelTypes["ArticleAuthorConnection"],
	paginateCategories:ModelTypes["ArticleCategoryConnection"],
	paginateIssues:ModelTypes["IssueArticleConnection"],
	paginateContentBlocks:ModelTypes["ContentArticleConnection"],
	paginateUnlocked:ModelTypes["UnlockedArticleConnection"],
	paginateTags:ModelTypes["ArticleTagConnection"],
	paginateHistoryTags:ModelTypes["ArticleHistoryTagConnection"],
	paginateHistoryPeriods:ModelTypes["ArticleHistoryPeriodConnection"]
};
	["ArticleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"],
	authors?:ModelTypes["FieldMeta"],
	hideInMostRead?:ModelTypes["FieldMeta"],
	hideAds?:ModelTypes["FieldMeta"],
	state?:ModelTypes["FieldMeta"],
	locked?:ModelTypes["FieldMeta"],
	publishAt?:ModelTypes["FieldMeta"],
	template?:ModelTypes["FieldMeta"],
	subtitle?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	coverPhoto?:ModelTypes["FieldMeta"],
	titleAlignment?:ModelTypes["FieldMeta"],
	tagline?:ModelTypes["FieldMeta"],
	createdAt?:ModelTypes["FieldMeta"],
	previewContent?:ModelTypes["FieldMeta"],
	audio?:ModelTypes["FieldMeta"],
	categories?:ModelTypes["FieldMeta"],
	issues?:ModelTypes["FieldMeta"],
	contentBlocks?:ModelTypes["FieldMeta"],
	unlocked?:ModelTypes["FieldMeta"],
	coverPhotoVertical?:ModelTypes["FieldMeta"],
	legacyId?:ModelTypes["FieldMeta"],
	tags?:ModelTypes["FieldMeta"],
	isHistory?:ModelTypes["FieldMeta"],
	historyTags?:ModelTypes["FieldMeta"],
	historyPeriods?:ModelTypes["FieldMeta"]
};
	["FieldMeta"]: {
		readable?:boolean,
	updatable?:boolean
};
	["UUID"]:any;
	["Url"]: {
		_meta?:ModelTypes["UrlMeta"],
	id:ModelTypes["UUID"],
	url:string,
	article?:ModelTypes["Article"],
	author?:ModelTypes["Author"],
	issue?:ModelTypes["Issue"],
	page?:ModelTypes["Page"],
	category?:ModelTypes["Category"],
	tag?:ModelTypes["Tag"],
	redirect?:string
};
	["UrlMeta"]: {
		id?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"],
	article?:ModelTypes["FieldMeta"],
	author?:ModelTypes["FieldMeta"],
	issue?:ModelTypes["FieldMeta"],
	page?:ModelTypes["FieldMeta"],
	category?:ModelTypes["FieldMeta"],
	tag?:ModelTypes["FieldMeta"],
	redirect?:ModelTypes["FieldMeta"]
};
	["ArticleWhere"]: GraphQLTypes["ArticleWhere"];
	["UUIDCondition"]: GraphQLTypes["UUIDCondition"];
	["StringCondition"]: GraphQLTypes["StringCondition"];
	["UrlWhere"]: GraphQLTypes["UrlWhere"];
	["AuthorWhere"]: GraphQLTypes["AuthorWhere"];
	["BooleanCondition"]: GraphQLTypes["BooleanCondition"];
	["IntCondition"]: GraphQLTypes["IntCondition"];
	["ContentWhere"]: GraphQLTypes["ContentWhere"];
	["ContentPartWhere"]: GraphQLTypes["ContentPartWhere"];
	["ContentReferenceWhere"]: GraphQLTypes["ContentReferenceWhere"];
	["ContentReferenceTypeCondition"]: GraphQLTypes["ContentReferenceTypeCondition"];
	["ContentReferenceType"]: GraphQLTypes["ContentReferenceType"];
	["ContentReferenceVariantCondition"]: GraphQLTypes["ContentReferenceVariantCondition"];
	["ContentReferenceVariant"]: GraphQLTypes["ContentReferenceVariant"];
	["EmbedWhere"]: GraphQLTypes["EmbedWhere"];
	["EmbedTypeCondition"]: GraphQLTypes["EmbedTypeCondition"];
	["EmbedType"]: GraphQLTypes["EmbedType"];
	["AudioUseWhere"]: GraphQLTypes["AudioUseWhere"];
	["AudioWhere"]: GraphQLTypes["AudioWhere"];
	["ImageUseWhere"]: GraphQLTypes["ImageUseWhere"];
	["ImageWhere"]: GraphQLTypes["ImageWhere"];
	["ImageTagWhere"]: GraphQLTypes["ImageTagWhere"];
	["ImageAlignCondition"]: GraphQLTypes["ImageAlignCondition"];
	["ImageAlign"]: GraphQLTypes["ImageAlign"];
	["ImageContentWhere"]: GraphQLTypes["ImageContentWhere"];
	["PollAnswerWhere"]: GraphQLTypes["PollAnswerWhere"];
	["ListicleWhere"]: GraphQLTypes["ListicleWhere"];
	["LinkWhere"]: GraphQLTypes["LinkWhere"];
	["LinkTypeCondition"]: GraphQLTypes["LinkTypeCondition"];
	["LinkType"]: GraphQLTypes["LinkType"];
	["FAQWhere"]: GraphQLTypes["FAQWhere"];
	["LinkContentWhere"]: GraphQLTypes["LinkContentWhere"];
	["AwardContentWhere"]: GraphQLTypes["AwardContentWhere"];
	["ReviewContentWhere"]: GraphQLTypes["ReviewContentWhere"];
	["SubscriptionFormWhere"]: GraphQLTypes["SubscriptionFormWhere"];
	["DateTimeCondition"]: GraphQLTypes["DateTimeCondition"];
	["DateTime"]:any;
	["SubscriptionFormSectionWhere"]: GraphQLTypes["SubscriptionFormSectionWhere"];
	["SubscriptionFormInputWhere"]: GraphQLTypes["SubscriptionFormInputWhere"];
	["SubscriptionFormInputTypeCondition"]: GraphQLTypes["SubscriptionFormInputTypeCondition"];
	["SubscriptionFormInputType"]: GraphQLTypes["SubscriptionFormInputType"];
	["SubscriptionFormOptionWhere"]: GraphQLTypes["SubscriptionFormOptionWhere"];
	["ProductWhere"]: GraphQLTypes["ProductWhere"];
	["TypesCondition"]: GraphQLTypes["TypesCondition"];
	["Types"]: GraphQLTypes["Types"];
	["ContentBlockWhere"]: GraphQLTypes["ContentBlockWhere"];
	["ContentBlockTypeCondition"]: GraphQLTypes["ContentBlockTypeCondition"];
	["ContentBlockType"]: GraphQLTypes["ContentBlockType"];
	["IssueWhere"]: GraphQLTypes["IssueWhere"];
	["DateCondition"]: GraphQLTypes["DateCondition"];
	["Date"]:any;
	["IssueArticleWhere"]: GraphQLTypes["IssueArticleWhere"];
	["IssueKindCondition"]: GraphQLTypes["IssueKindCondition"];
	["IssueKind"]: GraphQLTypes["IssueKind"];
	["FileUseWhere"]: GraphQLTypes["FileUseWhere"];
	["FileWhere"]: GraphQLTypes["FileWhere"];
	["ContentArticleWhere"]: GraphQLTypes["ContentArticleWhere"];
	["ButtonWhere"]: GraphQLTypes["ButtonWhere"];
	["ButtonTypeCondition"]: GraphQLTypes["ButtonTypeCondition"];
	["ButtonType"]: GraphQLTypes["ButtonType"];
	["SharedContentWhere"]: GraphQLTypes["SharedContentWhere"];
	["AuthorTopArticleWhere"]: GraphQLTypes["AuthorTopArticleWhere"];
	["UserWhere"]: GraphQLTypes["UserWhere"];
	["UnlockedArticleWhere"]: GraphQLTypes["UnlockedArticleWhere"];
	["AppReviewWhere"]: GraphQLTypes["AppReviewWhere"];
	["AuthorCategoryCondition"]: GraphQLTypes["AuthorCategoryCondition"];
	["AuthorCategory"]: GraphQLTypes["AuthorCategory"];
	["PageWhere"]: GraphQLTypes["PageWhere"];
	["PageTemplateCondition"]: GraphQLTypes["PageTemplateCondition"];
	["PageTemplate"]: GraphQLTypes["PageTemplate"];
	["SeoWhere"]: GraphQLTypes["SeoWhere"];
	["SeoTwCardCondition"]: GraphQLTypes["SeoTwCardCondition"];
	["SeoTwCard"]: GraphQLTypes["SeoTwCard"];
	["CategoryWhere"]: GraphQLTypes["CategoryWhere"];
	["ArticleCategoryWhere"]: GraphQLTypes["ArticleCategoryWhere"];
	["TagWhere"]: GraphQLTypes["TagWhere"];
	["ArticleTagWhere"]: GraphQLTypes["ArticleTagWhere"];
	["ArticleAuthorWhere"]: GraphQLTypes["ArticleAuthorWhere"];
	["ArticleAuthorLegacyStringAuthorCondition"]: GraphQLTypes["ArticleAuthorLegacyStringAuthorCondition"];
	["ArticleAuthorLegacyStringAuthor"]: GraphQLTypes["ArticleAuthorLegacyStringAuthor"];
	["ArticleStateCondition"]: GraphQLTypes["ArticleStateCondition"];
	["ArticleState"]: GraphQLTypes["ArticleState"];
	["TemplateCondition"]: GraphQLTypes["TemplateCondition"];
	["Template"]: GraphQLTypes["Template"];
	["TextContentWhere"]: GraphQLTypes["TextContentWhere"];
	["TextContentPartWhere"]: GraphQLTypes["TextContentPartWhere"];
	["TextContentReferenceWhere"]: GraphQLTypes["TextContentReferenceWhere"];
	["TextContentReferenceTypeCondition"]: GraphQLTypes["TextContentReferenceTypeCondition"];
	["TextContentReferenceType"]: GraphQLTypes["TextContentReferenceType"];
	["ArticleTitleAlignmentCondition"]: GraphQLTypes["ArticleTitleAlignmentCondition"];
	["ArticleTitleAlignment"]: GraphQLTypes["ArticleTitleAlignment"];
	["ArticleHistoryTagWhere"]: GraphQLTypes["ArticleHistoryTagWhere"];
	["HistoryTagWhere"]: GraphQLTypes["HistoryTagWhere"];
	["ArticleHistoryPeriodWhere"]: GraphQLTypes["ArticleHistoryPeriodWhere"];
	["HistoryPeriodWhere"]: GraphQLTypes["HistoryPeriodWhere"];
	["HistoryCoverWhere"]: GraphQLTypes["HistoryCoverWhere"];
	["HistoryTextListWhere"]: GraphQLTypes["HistoryTextListWhere"];
	["HistoryTextItemWhere"]: GraphQLTypes["HistoryTextItemWhere"];
	["Author"]: {
		_meta?:ModelTypes["AuthorMeta"],
	id:ModelTypes["UUID"],
	name:string,
	position:string,
	twitterHandle?:string,
	facebookId?:string,
	email?:string,
	photographer:boolean,
	order:number,
	about?:ModelTypes["Content"],
	topArticles:ModelTypes["AuthorTopArticle"][],
	users:ModelTypes["User"][],
	startOfCooperation?:ModelTypes["Date"],
	photo?:ModelTypes["ImageUse"],
	illustration?:ModelTypes["ImageUse"],
	legacyId?:string,
	category?:ModelTypes["AuthorCategory"],
	url?:ModelTypes["Url"],
	instagramUsername?:string,
	paginateTopArticles:ModelTypes["AuthorTopArticleConnection"],
	paginateUsers:ModelTypes["UserConnection"]
};
	["AuthorMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	position?:ModelTypes["FieldMeta"],
	twitterHandle?:ModelTypes["FieldMeta"],
	facebookId?:ModelTypes["FieldMeta"],
	email?:ModelTypes["FieldMeta"],
	photographer?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	about?:ModelTypes["FieldMeta"],
	topArticles?:ModelTypes["FieldMeta"],
	users?:ModelTypes["FieldMeta"],
	startOfCooperation?:ModelTypes["FieldMeta"],
	photo?:ModelTypes["FieldMeta"],
	illustration?:ModelTypes["FieldMeta"],
	legacyId?:ModelTypes["FieldMeta"],
	category?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"],
	instagramUsername?:ModelTypes["FieldMeta"]
};
	["Content"]: {
		_meta?:ModelTypes["ContentMeta"],
	id:ModelTypes["UUID"],
	parts:ModelTypes["ContentPart"][],
	partsByReferences?:ModelTypes["ContentPart"],
	paginateParts:ModelTypes["ContentPartConnection"]
};
	["ContentMeta"]: {
		id?:ModelTypes["FieldMeta"],
	parts?:ModelTypes["FieldMeta"]
};
	["ContentPart"]: {
		_meta?:ModelTypes["ContentPartMeta"],
	id:ModelTypes["UUID"],
	order:number,
	json:string,
	content?:ModelTypes["Content"],
	references:ModelTypes["ContentReference"][],
	referencesByEmbed?:ModelTypes["ContentReference"],
	referencesByAudio?:ModelTypes["ContentReference"],
	referencesByImage?:ModelTypes["ContentReference"],
	referencesByPollAnswer?:ModelTypes["ContentReference"],
	referencesByListicle?:ModelTypes["ContentReference"],
	referencesByFaq?:ModelTypes["ContentReference"],
	referencesByLinks?:ModelTypes["ContentReference"],
	referencesByAwards?:ModelTypes["ContentReference"],
	referencesByReviews?:ModelTypes["ContentReference"],
	referencesByTarget?:ModelTypes["ContentReference"],
	referencesByButtons?:ModelTypes["ContentReference"],
	paginateReferences:ModelTypes["ContentReferenceConnection"]
};
	["ContentPartMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	json?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	references?:ModelTypes["FieldMeta"]
};
	["ContentReference"]: {
		_meta?:ModelTypes["ContentReferenceMeta"],
	id:ModelTypes["UUID"],
	type:ModelTypes["ContentReferenceType"],
	contentPart?:ModelTypes["ContentPart"],
	primaryText?:string,
	secondaryText?:string,
	variant?:ModelTypes["ContentReferenceVariant"],
	color?:string,
	embed?:ModelTypes["Embed"],
	article?:ModelTypes["Article"],
	audio?:ModelTypes["AudioUse"],
	image?:ModelTypes["ImageUse"],
	images:ModelTypes["ImageContent"][],
	pollAnswer?:ModelTypes["PollAnswer"],
	listicle:ModelTypes["Listicle"][],
	faq:ModelTypes["FAQ"][],
	links:ModelTypes["LinkContent"][],
	awards:ModelTypes["AwardContent"][],
	reviews:ModelTypes["ReviewContent"][],
	target?:ModelTypes["Link"],
	subscriptionForm?:ModelTypes["SubscriptionForm"],
	buttons:ModelTypes["Button"][],
	sharedContent?:ModelTypes["SharedContent"],
	buttonsByTarget?:ModelTypes["Button"],
	paginateImages:ModelTypes["ImageContentConnection"],
	paginateListicle:ModelTypes["ListicleConnection"],
	paginateFaq:ModelTypes["FAQConnection"],
	paginateLinks:ModelTypes["LinkContentConnection"],
	paginateAwards:ModelTypes["AwardContentConnection"],
	paginateReviews:ModelTypes["ReviewContentConnection"],
	paginateButtons:ModelTypes["ButtonConnection"]
};
	["ContentReferenceMeta"]: {
		id?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	contentPart?:ModelTypes["FieldMeta"],
	primaryText?:ModelTypes["FieldMeta"],
	secondaryText?:ModelTypes["FieldMeta"],
	variant?:ModelTypes["FieldMeta"],
	color?:ModelTypes["FieldMeta"],
	embed?:ModelTypes["FieldMeta"],
	article?:ModelTypes["FieldMeta"],
	audio?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	images?:ModelTypes["FieldMeta"],
	pollAnswer?:ModelTypes["FieldMeta"],
	listicle?:ModelTypes["FieldMeta"],
	faq?:ModelTypes["FieldMeta"],
	links?:ModelTypes["FieldMeta"],
	awards?:ModelTypes["FieldMeta"],
	reviews?:ModelTypes["FieldMeta"],
	target?:ModelTypes["FieldMeta"],
	subscriptionForm?:ModelTypes["FieldMeta"],
	buttons?:ModelTypes["FieldMeta"],
	sharedContent?:ModelTypes["FieldMeta"]
};
	["Embed"]: {
		_meta?:ModelTypes["EmbedMeta"],
	id:ModelTypes["UUID"],
	type:ModelTypes["EmbedType"],
	youtubeId?:string,
	vimeoId?:string,
	spotifyId?:string,
	spotifyType?:string,
	soundCloudId?:string
};
	["EmbedMeta"]: {
		id?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	youtubeId?:ModelTypes["FieldMeta"],
	vimeoId?:ModelTypes["FieldMeta"],
	spotifyId?:ModelTypes["FieldMeta"],
	spotifyType?:ModelTypes["FieldMeta"],
	soundCloudId?:ModelTypes["FieldMeta"]
};
	["AudioUse"]: {
		_meta?:ModelTypes["AudioUseMeta"],
	id:ModelTypes["UUID"],
	audio?:ModelTypes["Audio"]
};
	["AudioUseMeta"]: {
		id?:ModelTypes["FieldMeta"],
	audio?:ModelTypes["FieldMeta"]
};
	["Audio"]: {
		_meta?:ModelTypes["AudioMeta"],
	id:ModelTypes["UUID"],
	url:string,
	type:string,
	author?:ModelTypes["Author"],
	uses:ModelTypes["AudioUse"][],
	paginateUses:ModelTypes["AudioUseConnection"]
};
	["AudioMeta"]: {
		id?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	author?:ModelTypes["FieldMeta"],
	uses?:ModelTypes["FieldMeta"]
};
	["AudioUseOrderBy"]: GraphQLTypes["AudioUseOrderBy"];
	["OrderDirection"]: GraphQLTypes["OrderDirection"];
	["AudioOrderBy"]: GraphQLTypes["AudioOrderBy"];
	["AuthorOrderBy"]: GraphQLTypes["AuthorOrderBy"];
	["ContentOrderBy"]: GraphQLTypes["ContentOrderBy"];
	["ImageUseOrderBy"]: GraphQLTypes["ImageUseOrderBy"];
	["ImageOrderBy"]: GraphQLTypes["ImageOrderBy"];
	["UrlOrderBy"]: GraphQLTypes["UrlOrderBy"];
	["ArticleOrderBy"]: GraphQLTypes["ArticleOrderBy"];
	["TextContentOrderBy"]: GraphQLTypes["TextContentOrderBy"];
	["IssueOrderBy"]: GraphQLTypes["IssueOrderBy"];
	["FileUseOrderBy"]: GraphQLTypes["FileUseOrderBy"];
	["FileOrderBy"]: GraphQLTypes["FileOrderBy"];
	["LinkOrderBy"]: GraphQLTypes["LinkOrderBy"];
	["PageOrderBy"]: GraphQLTypes["PageOrderBy"];
	["SeoOrderBy"]: GraphQLTypes["SeoOrderBy"];
	["CategoryOrderBy"]: GraphQLTypes["CategoryOrderBy"];
	["TagOrderBy"]: GraphQLTypes["TagOrderBy"];
	["AudioUseConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["AudioUseEdge"][]
};
	["PageInfo"]: {
		totalCount:number
};
	["AudioUseEdge"]: {
		node:ModelTypes["AudioUse"]
};
	["ImageUse"]: {
		_meta?:ModelTypes["ImageUseMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	image?:ModelTypes["Image"]
};
	["ImageUseMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"]
};
	["Image"]: {
		_meta?:ModelTypes["ImageMeta"],
	id:ModelTypes["UUID"],
	url:string,
	width?:number,
	height?:number,
	title:string,
	text:string,
	author?:ModelTypes["Author"],
	tags:ModelTypes["ImageTag"][],
	uses:ModelTypes["ImageUse"][],
	align?:ModelTypes["ImageAlign"],
	legacyId?:string,
	paginateTags:ModelTypes["ImageTagConnection"],
	paginateUses:ModelTypes["ImageUseConnection"]
};
	["ImageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"],
	width?:ModelTypes["FieldMeta"],
	height?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	text?:ModelTypes["FieldMeta"],
	author?:ModelTypes["FieldMeta"],
	tags?:ModelTypes["FieldMeta"],
	uses?:ModelTypes["FieldMeta"],
	align?:ModelTypes["FieldMeta"],
	legacyId?:ModelTypes["FieldMeta"]
};
	["ImageTag"]: {
		_meta?:ModelTypes["ImageTagMeta"],
	id:ModelTypes["UUID"],
	name:string,
	images:ModelTypes["Image"][],
	paginateImages:ModelTypes["ImageConnection"]
};
	["ImageTagMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	images?:ModelTypes["FieldMeta"]
};
	["ImageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ImageEdge"][]
};
	["ImageEdge"]: {
		node:ModelTypes["Image"]
};
	["ImageTagOrderBy"]: GraphQLTypes["ImageTagOrderBy"];
	["ImageTagConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ImageTagEdge"][]
};
	["ImageTagEdge"]: {
		node:ModelTypes["ImageTag"]
};
	["ImageUseConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ImageUseEdge"][]
};
	["ImageUseEdge"]: {
		node:ModelTypes["ImageUse"]
};
	["ImageContent"]: {
		_meta?:ModelTypes["ImageContentMeta"],
	id:ModelTypes["UUID"],
	order:number,
	contentReference:ModelTypes["ContentReference"][],
	image?:ModelTypes["ImageUse"],
	paginateContentReference:ModelTypes["ContentReferenceConnection"]
};
	["ImageContentMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	contentReference?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"]
};
	["ContentReferenceOrderBy"]: GraphQLTypes["ContentReferenceOrderBy"];
	["ContentPartOrderBy"]: GraphQLTypes["ContentPartOrderBy"];
	["EmbedOrderBy"]: GraphQLTypes["EmbedOrderBy"];
	["PollAnswerOrderBy"]: GraphQLTypes["PollAnswerOrderBy"];
	["SubscriptionFormOrderBy"]: GraphQLTypes["SubscriptionFormOrderBy"];
	["SharedContentOrderBy"]: GraphQLTypes["SharedContentOrderBy"];
	["ContentReferenceConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentReferenceEdge"][]
};
	["ContentReferenceEdge"]: {
		node:ModelTypes["ContentReference"]
};
	["ImageContentOrderBy"]: GraphQLTypes["ImageContentOrderBy"];
	["PollAnswer"]: {
		_meta?:ModelTypes["PollAnswerMeta"],
	id:ModelTypes["UUID"],
	authorName:string,
	authorPosition?:string,
	text:string,
	authorImage?:ModelTypes["ImageUse"]
};
	["PollAnswerMeta"]: {
		id?:ModelTypes["FieldMeta"],
	authorName?:ModelTypes["FieldMeta"],
	authorPosition?:ModelTypes["FieldMeta"],
	text?:ModelTypes["FieldMeta"],
	authorImage?:ModelTypes["FieldMeta"]
};
	["Listicle"]: {
		_meta?:ModelTypes["ListicleMeta"],
	id:ModelTypes["UUID"],
	order:number,
	primaryText:string,
	image?:ModelTypes["ImageUse"],
	contentReference?:ModelTypes["ContentReference"],
	target?:ModelTypes["Link"],
	content?:ModelTypes["Content"]
};
	["ListicleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	primaryText?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	contentReference?:ModelTypes["FieldMeta"],
	target?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"]
};
	["Link"]: {
		_meta?:ModelTypes["LinkMeta"],
	id:ModelTypes["UUID"],
	type:ModelTypes["LinkType"],
	externalTarget?:string,
	internalTarget?:ModelTypes["Url"],
	queryParameters?:string
};
	["LinkMeta"]: {
		id?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	externalTarget?:ModelTypes["FieldMeta"],
	internalTarget?:ModelTypes["FieldMeta"],
	queryParameters?:ModelTypes["FieldMeta"]
};
	["ListicleOrderBy"]: GraphQLTypes["ListicleOrderBy"];
	["FAQ"]: {
		_meta?:ModelTypes["FAQMeta"],
	id:ModelTypes["UUID"],
	order:number,
	answer:string,
	question:string,
	contentReference?:ModelTypes["ContentReference"]
};
	["FAQMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	answer?:ModelTypes["FieldMeta"],
	question?:ModelTypes["FieldMeta"],
	contentReference?:ModelTypes["FieldMeta"]
};
	["FAQOrderBy"]: GraphQLTypes["FAQOrderBy"];
	["LinkContent"]: {
		_meta?:ModelTypes["LinkContentMeta"],
	id:ModelTypes["UUID"],
	order:number,
	contentReference?:ModelTypes["ContentReference"],
	text:string,
	target?:ModelTypes["Link"]
};
	["LinkContentMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	contentReference?:ModelTypes["FieldMeta"],
	text?:ModelTypes["FieldMeta"],
	target?:ModelTypes["FieldMeta"]
};
	["LinkContentOrderBy"]: GraphQLTypes["LinkContentOrderBy"];
	["AwardContent"]: {
		_meta?:ModelTypes["AwardContentMeta"],
	id:ModelTypes["UUID"],
	order:number,
	image?:ModelTypes["ImageUse"],
	contentReference?:ModelTypes["ContentReference"],
	target?:ModelTypes["Link"]
};
	["AwardContentMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	contentReference?:ModelTypes["FieldMeta"],
	target?:ModelTypes["FieldMeta"]
};
	["AwardContentOrderBy"]: GraphQLTypes["AwardContentOrderBy"];
	["ReviewContent"]: {
		_meta?:ModelTypes["ReviewContentMeta"],
	id:ModelTypes["UUID"],
	order:number,
	text:string,
	contentReference?:ModelTypes["ContentReference"]
};
	["ReviewContentMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	text?:ModelTypes["FieldMeta"],
	contentReference?:ModelTypes["FieldMeta"]
};
	["ReviewContentOrderBy"]: GraphQLTypes["ReviewContentOrderBy"];
	["SubscriptionForm"]: {
		_meta?:ModelTypes["SubscriptionFormMeta"],
	id:ModelTypes["UUID"],
	name:string,
	code?:string,
	createdAt:ModelTypes["DateTime"],
	sections:ModelTypes["SubscriptionFormSection"][],
	contentBlock:ModelTypes["ContentBlock"][],
	products:ModelTypes["Product"][],
	contentReferences:ModelTypes["ContentReference"][],
	validity?:ModelTypes["DateTime"],
	sectionsByInputs?:ModelTypes["SubscriptionFormSection"],
	contentBlockByTarget?:ModelTypes["ContentBlock"],
	contentBlockByArticles?:ModelTypes["ContentBlock"],
	contentReferencesByEmbed?:ModelTypes["ContentReference"],
	contentReferencesByAudio?:ModelTypes["ContentReference"],
	contentReferencesByImage?:ModelTypes["ContentReference"],
	contentReferencesByPollAnswer?:ModelTypes["ContentReference"],
	contentReferencesByListicle?:ModelTypes["ContentReference"],
	contentReferencesByFaq?:ModelTypes["ContentReference"],
	contentReferencesByLinks?:ModelTypes["ContentReference"],
	contentReferencesByAwards?:ModelTypes["ContentReference"],
	contentReferencesByReviews?:ModelTypes["ContentReference"],
	contentReferencesByTarget?:ModelTypes["ContentReference"],
	contentReferencesByButtons?:ModelTypes["ContentReference"],
	paginateSections:ModelTypes["SubscriptionFormSectionConnection"],
	paginateContentBlock:ModelTypes["ContentBlockConnection"],
	paginateProducts:ModelTypes["ProductConnection"],
	paginateContentReferences:ModelTypes["ContentReferenceConnection"]
};
	["SubscriptionFormMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	code?:ModelTypes["FieldMeta"],
	createdAt?:ModelTypes["FieldMeta"],
	sections?:ModelTypes["FieldMeta"],
	contentBlock?:ModelTypes["FieldMeta"],
	products?:ModelTypes["FieldMeta"],
	contentReferences?:ModelTypes["FieldMeta"],
	validity?:ModelTypes["FieldMeta"]
};
	["SubscriptionFormSection"]: {
		_meta?:ModelTypes["SubscriptionFormSectionMeta"],
	id:ModelTypes["UUID"],
	order:number,
	title?:string,
	form?:ModelTypes["SubscriptionForm"],
	inputs:ModelTypes["SubscriptionFormInput"][],
	inputsByImage?:ModelTypes["SubscriptionFormInput"],
	inputsByOptions?:ModelTypes["SubscriptionFormInput"],
	inputsByDescription?:ModelTypes["SubscriptionFormInput"],
	paginateInputs:ModelTypes["SubscriptionFormInputConnection"]
};
	["SubscriptionFormSectionMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	form?:ModelTypes["FieldMeta"],
	inputs?:ModelTypes["FieldMeta"]
};
	["SubscriptionFormInput"]: {
		_meta?:ModelTypes["SubscriptionFormInputMeta"],
	id:ModelTypes["UUID"],
	order:number,
	type:ModelTypes["SubscriptionFormInputType"],
	image?:ModelTypes["ImageUse"],
	section?:ModelTypes["SubscriptionFormSection"],
	options:ModelTypes["SubscriptionFormOption"][],
	description?:ModelTypes["Content"],
	required:boolean,
	paginateOptions:ModelTypes["SubscriptionFormOptionConnection"]
};
	["SubscriptionFormInputMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	section?:ModelTypes["FieldMeta"],
	options?:ModelTypes["FieldMeta"],
	description?:ModelTypes["FieldMeta"],
	required?:ModelTypes["FieldMeta"]
};
	["SubscriptionFormOption"]: {
		_meta?:ModelTypes["SubscriptionFormOptionMeta"],
	id:ModelTypes["UUID"],
	hasProductId:boolean,
	order:number,
	label?:string,
	priceTag?:string,
	priceTagWithDiscount?:string,
	products:ModelTypes["Product"][],
	formInput?:ModelTypes["SubscriptionFormInput"],
	value?:string,
	internalLabel?:string,
	paginateProducts:ModelTypes["ProductConnection"]
};
	["SubscriptionFormOptionMeta"]: {
		id?:ModelTypes["FieldMeta"],
	hasProductId?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	label?:ModelTypes["FieldMeta"],
	priceTag?:ModelTypes["FieldMeta"],
	priceTagWithDiscount?:ModelTypes["FieldMeta"],
	products?:ModelTypes["FieldMeta"],
	formInput?:ModelTypes["FieldMeta"],
	value?:ModelTypes["FieldMeta"],
	internalLabel?:ModelTypes["FieldMeta"]
};
	["Product"]: {
		_meta?:ModelTypes["ProductMeta"],
	id:ModelTypes["UUID"],
	price?:number,
	type?:ModelTypes["Types"],
	formOptions:ModelTypes["SubscriptionFormOption"][],
	form?:ModelTypes["SubscriptionForm"],
	productId:string,
	paginateFormOptions:ModelTypes["SubscriptionFormOptionConnection"]
};
	["ProductMeta"]: {
		id?:ModelTypes["FieldMeta"],
	price?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	formOptions?:ModelTypes["FieldMeta"],
	form?:ModelTypes["FieldMeta"],
	productId?:ModelTypes["FieldMeta"]
};
	["SubscriptionFormOptionOrderBy"]: GraphQLTypes["SubscriptionFormOptionOrderBy"];
	["SubscriptionFormInputOrderBy"]: GraphQLTypes["SubscriptionFormInputOrderBy"];
	["SubscriptionFormSectionOrderBy"]: GraphQLTypes["SubscriptionFormSectionOrderBy"];
	["SubscriptionFormOptionConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SubscriptionFormOptionEdge"][]
};
	["SubscriptionFormOptionEdge"]: {
		node:ModelTypes["SubscriptionFormOption"]
};
	["ProductOrderBy"]: GraphQLTypes["ProductOrderBy"];
	["ProductConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ProductEdge"][]
};
	["ProductEdge"]: {
		node:ModelTypes["Product"]
};
	["SubscriptionFormSectionInputsByImageUniqueWhere"]: GraphQLTypes["SubscriptionFormSectionInputsByImageUniqueWhere"];
	["ImageUseUniqueWhere"]: GraphQLTypes["ImageUseUniqueWhere"];
	["SubscriptionFormSectionInputsByOptionsUniqueWhere"]: GraphQLTypes["SubscriptionFormSectionInputsByOptionsUniqueWhere"];
	["SubscriptionFormOptionUniqueWhere"]: GraphQLTypes["SubscriptionFormOptionUniqueWhere"];
	["SubscriptionFormSectionInputsByDescriptionUniqueWhere"]: GraphQLTypes["SubscriptionFormSectionInputsByDescriptionUniqueWhere"];
	["ContentUniqueWhere"]: GraphQLTypes["ContentUniqueWhere"];
	["ContentPartUniqueWhere"]: GraphQLTypes["ContentPartUniqueWhere"];
	["ContentReferenceUniqueWhere"]: GraphQLTypes["ContentReferenceUniqueWhere"];
	["EmbedUniqueWhere"]: GraphQLTypes["EmbedUniqueWhere"];
	["AudioUseUniqueWhere"]: GraphQLTypes["AudioUseUniqueWhere"];
	["PollAnswerUniqueWhere"]: GraphQLTypes["PollAnswerUniqueWhere"];
	["ListicleUniqueWhere"]: GraphQLTypes["ListicleUniqueWhere"];
	["FAQUniqueWhere"]: GraphQLTypes["FAQUniqueWhere"];
	["LinkContentUniqueWhere"]: GraphQLTypes["LinkContentUniqueWhere"];
	["AwardContentUniqueWhere"]: GraphQLTypes["AwardContentUniqueWhere"];
	["ReviewContentUniqueWhere"]: GraphQLTypes["ReviewContentUniqueWhere"];
	["LinkUniqueWhere"]: GraphQLTypes["LinkUniqueWhere"];
	["ButtonUniqueWhere"]: GraphQLTypes["ButtonUniqueWhere"];
	["SubscriptionFormInputConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SubscriptionFormInputEdge"][]
};
	["SubscriptionFormInputEdge"]: {
		node:ModelTypes["SubscriptionFormInput"]
};
	["ContentBlock"]: {
		_meta?:ModelTypes["ContentBlockMeta"],
	id:ModelTypes["UUID"],
	order:number,
	type:ModelTypes["ContentBlockType"],
	youtubeId?:string,
	text?:string,
	targetLabel?:string,
	issue?:ModelTypes["Issue"],
	target?:ModelTypes["Link"],
	articles:ModelTypes["ContentArticle"][],
	subscriptionForm?:ModelTypes["SubscriptionForm"],
	paginateArticles:ModelTypes["ContentArticleConnection"]
};
	["ContentBlockMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	youtubeId?:ModelTypes["FieldMeta"],
	text?:ModelTypes["FieldMeta"],
	targetLabel?:ModelTypes["FieldMeta"],
	issue?:ModelTypes["FieldMeta"],
	target?:ModelTypes["FieldMeta"],
	articles?:ModelTypes["FieldMeta"],
	subscriptionForm?:ModelTypes["FieldMeta"]
};
	["Issue"]: {
		_meta?:ModelTypes["IssueMeta"],
	id:ModelTypes["UUID"],
	closed:boolean,
	free:boolean,
	title?:string,
	subtitle?:string,
	year:number,
	issue:number,
	publishedSince:ModelTypes["Date"],
	publishedUntil:ModelTypes["Date"],
	publishDigital:ModelTypes["DateTime"],
	mobileAppsKey?:string,
	url?:ModelTypes["Url"],
	articles:ModelTypes["IssueArticle"][],
	kind:ModelTypes["IssueKind"],
	notificationTitle?:string,
	notificationMessage?:string,
	pdf?:ModelTypes["FileUse"],
	printBuy:boolean,
	printText?:string,
	blocks:ModelTypes["ContentBlock"][],
	coverPhoto?:ModelTypes["ImageUse"],
	printTarget?:ModelTypes["Link"],
	backgroundPhoto?:ModelTypes["ImageUse"],
	legacyId?:string,
	articlesByArticle?:ModelTypes["IssueArticle"],
	blocksByTarget?:ModelTypes["ContentBlock"],
	blocksByArticles?:ModelTypes["ContentBlock"],
	paginateArticles:ModelTypes["IssueArticleConnection"],
	paginateBlocks:ModelTypes["ContentBlockConnection"]
};
	["IssueMeta"]: {
		id?:ModelTypes["FieldMeta"],
	closed?:ModelTypes["FieldMeta"],
	free?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	subtitle?:ModelTypes["FieldMeta"],
	year?:ModelTypes["FieldMeta"],
	issue?:ModelTypes["FieldMeta"],
	publishedSince?:ModelTypes["FieldMeta"],
	publishedUntil?:ModelTypes["FieldMeta"],
	publishDigital?:ModelTypes["FieldMeta"],
	mobileAppsKey?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"],
	articles?:ModelTypes["FieldMeta"],
	kind?:ModelTypes["FieldMeta"],
	notificationTitle?:ModelTypes["FieldMeta"],
	notificationMessage?:ModelTypes["FieldMeta"],
	pdf?:ModelTypes["FieldMeta"],
	printBuy?:ModelTypes["FieldMeta"],
	printText?:ModelTypes["FieldMeta"],
	blocks?:ModelTypes["FieldMeta"],
	coverPhoto?:ModelTypes["FieldMeta"],
	printTarget?:ModelTypes["FieldMeta"],
	backgroundPhoto?:ModelTypes["FieldMeta"],
	legacyId?:ModelTypes["FieldMeta"]
};
	["IssueArticle"]: {
		_meta?:ModelTypes["IssueArticleMeta"],
	id:ModelTypes["UUID"],
	issue?:ModelTypes["Issue"],
	article?:ModelTypes["Article"],
	order?:number
};
	["IssueArticleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	issue?:ModelTypes["FieldMeta"],
	article?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"]
};
	["IssueArticleOrderBy"]: GraphQLTypes["IssueArticleOrderBy"];
	["FileUse"]: {
		_meta?:ModelTypes["FileUseMeta"],
	id:ModelTypes["UUID"],
	file?:ModelTypes["File"]
};
	["FileUseMeta"]: {
		id?:ModelTypes["FieldMeta"],
	file?:ModelTypes["FieldMeta"]
};
	["File"]: {
		_meta?:ModelTypes["FileMeta"],
	id:ModelTypes["UUID"],
	url:string,
	uses:ModelTypes["FileUse"][],
	paginateUses:ModelTypes["FileUseConnection"]
};
	["FileMeta"]: {
		id?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"],
	uses?:ModelTypes["FieldMeta"]
};
	["FileUseConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["FileUseEdge"][]
};
	["FileUseEdge"]: {
		node:ModelTypes["FileUse"]
};
	["ContentBlockOrderBy"]: GraphQLTypes["ContentBlockOrderBy"];
	["IssueArticlesByArticleUniqueWhere"]: GraphQLTypes["IssueArticlesByArticleUniqueWhere"];
	["ArticleUniqueWhere"]: GraphQLTypes["ArticleUniqueWhere"];
	["UrlUniqueWhere"]: GraphQLTypes["UrlUniqueWhere"];
	["AuthorUniqueWhere"]: GraphQLTypes["AuthorUniqueWhere"];
	["AuthorTopArticleUniqueWhere"]: GraphQLTypes["AuthorTopArticleUniqueWhere"];
	["IssueUniqueWhere"]: GraphQLTypes["IssueUniqueWhere"];
	["IssueArticleUniqueWhere"]: GraphQLTypes["IssueArticleUniqueWhere"];
	["FileUseUniqueWhere"]: GraphQLTypes["FileUseUniqueWhere"];
	["ContentBlockUniqueWhere"]: GraphQLTypes["ContentBlockUniqueWhere"];
	["ContentArticleUniqueWhere"]: GraphQLTypes["ContentArticleUniqueWhere"];
	["PageUniqueWhere"]: GraphQLTypes["PageUniqueWhere"];
	["SeoUniqueWhere"]: GraphQLTypes["SeoUniqueWhere"];
	["CategoryUniqueWhere"]: GraphQLTypes["CategoryUniqueWhere"];
	["ArticleCategoryUniqueWhere"]: GraphQLTypes["ArticleCategoryUniqueWhere"];
	["TagUniqueWhere"]: GraphQLTypes["TagUniqueWhere"];
	["ArticleTagUniqueWhere"]: GraphQLTypes["ArticleTagUniqueWhere"];
	["ArticleAuthorUniqueWhere"]: GraphQLTypes["ArticleAuthorUniqueWhere"];
	["TextContentUniqueWhere"]: GraphQLTypes["TextContentUniqueWhere"];
	["TextContentPartUniqueWhere"]: GraphQLTypes["TextContentPartUniqueWhere"];
	["TextContentReferenceUniqueWhere"]: GraphQLTypes["TextContentReferenceUniqueWhere"];
	["UnlockedArticleUniqueWhere"]: GraphQLTypes["UnlockedArticleUniqueWhere"];
	["ArticleHistoryTagUniqueWhere"]: GraphQLTypes["ArticleHistoryTagUniqueWhere"];
	["HistoryTagUniqueWhere"]: GraphQLTypes["HistoryTagUniqueWhere"];
	["ArticleHistoryPeriodUniqueWhere"]: GraphQLTypes["ArticleHistoryPeriodUniqueWhere"];
	["HistoryPeriodUniqueWhere"]: GraphQLTypes["HistoryPeriodUniqueWhere"];
	["HistoryCoverUniqueWhere"]: GraphQLTypes["HistoryCoverUniqueWhere"];
	["HistoryTextListUniqueWhere"]: GraphQLTypes["HistoryTextListUniqueWhere"];
	["HistoryTextItemUniqueWhere"]: GraphQLTypes["HistoryTextItemUniqueWhere"];
	["IssueBlocksByTargetUniqueWhere"]: GraphQLTypes["IssueBlocksByTargetUniqueWhere"];
	["IssueBlocksByArticlesUniqueWhere"]: GraphQLTypes["IssueBlocksByArticlesUniqueWhere"];
	["IssueArticleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["IssueArticleEdge"][]
};
	["IssueArticleEdge"]: {
		node:ModelTypes["IssueArticle"]
};
	["ContentBlockConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentBlockEdge"][]
};
	["ContentBlockEdge"]: {
		node:ModelTypes["ContentBlock"]
};
	["ContentArticle"]: {
		_meta?:ModelTypes["ContentArticleMeta"],
	id:ModelTypes["UUID"],
	order:number,
	contentBlock?:ModelTypes["ContentBlock"],
	article?:ModelTypes["Article"]
};
	["ContentArticleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	contentBlock?:ModelTypes["FieldMeta"],
	article?:ModelTypes["FieldMeta"]
};
	["ContentArticleOrderBy"]: GraphQLTypes["ContentArticleOrderBy"];
	["ContentArticleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentArticleEdge"][]
};
	["ContentArticleEdge"]: {
		node:ModelTypes["ContentArticle"]
};
	["SubscriptionFormSectionsByInputsUniqueWhere"]: GraphQLTypes["SubscriptionFormSectionsByInputsUniqueWhere"];
	["SubscriptionFormInputUniqueWhere"]: GraphQLTypes["SubscriptionFormInputUniqueWhere"];
	["SubscriptionFormContentBlockByTargetUniqueWhere"]: GraphQLTypes["SubscriptionFormContentBlockByTargetUniqueWhere"];
	["SubscriptionFormContentBlockByArticlesUniqueWhere"]: GraphQLTypes["SubscriptionFormContentBlockByArticlesUniqueWhere"];
	["SubscriptionFormContentReferencesByEmbedUniqueWhere"]: GraphQLTypes["SubscriptionFormContentReferencesByEmbedUniqueWhere"];
	["SubscriptionFormContentReferencesByAudioUniqueWhere"]: GraphQLTypes["SubscriptionFormContentReferencesByAudioUniqueWhere"];
	["SubscriptionFormContentReferencesByImageUniqueWhere"]: GraphQLTypes["SubscriptionFormContentReferencesByImageUniqueWhere"];
	["SubscriptionFormContentReferencesByPollAnswerUniqueWhere"]: GraphQLTypes["SubscriptionFormContentReferencesByPollAnswerUniqueWhere"];
	["SubscriptionFormContentReferencesByListicleUniqueWhere"]: GraphQLTypes["SubscriptionFormContentReferencesByListicleUniqueWhere"];
	["SubscriptionFormContentReferencesByFaqUniqueWhere"]: GraphQLTypes["SubscriptionFormContentReferencesByFaqUniqueWhere"];
	["SubscriptionFormContentReferencesByLinksUniqueWhere"]: GraphQLTypes["SubscriptionFormContentReferencesByLinksUniqueWhere"];
	["SubscriptionFormContentReferencesByAwardsUniqueWhere"]: GraphQLTypes["SubscriptionFormContentReferencesByAwardsUniqueWhere"];
	["SubscriptionFormContentReferencesByReviewsUniqueWhere"]: GraphQLTypes["SubscriptionFormContentReferencesByReviewsUniqueWhere"];
	["SubscriptionFormContentReferencesByTargetUniqueWhere"]: GraphQLTypes["SubscriptionFormContentReferencesByTargetUniqueWhere"];
	["SubscriptionFormContentReferencesByButtonsUniqueWhere"]: GraphQLTypes["SubscriptionFormContentReferencesByButtonsUniqueWhere"];
	["SubscriptionFormSectionConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SubscriptionFormSectionEdge"][]
};
	["SubscriptionFormSectionEdge"]: {
		node:ModelTypes["SubscriptionFormSection"]
};
	["Button"]: {
		_meta?:ModelTypes["ButtonMeta"],
	id:ModelTypes["UUID"],
	order:number,
	type?:ModelTypes["ButtonType"],
	label?:string,
	target?:ModelTypes["Link"],
	contentReference?:ModelTypes["ContentReference"]
};
	["ButtonMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	label?:ModelTypes["FieldMeta"],
	target?:ModelTypes["FieldMeta"],
	contentReference?:ModelTypes["FieldMeta"]
};
	["ButtonOrderBy"]: GraphQLTypes["ButtonOrderBy"];
	["SharedContent"]: {
		_meta?:ModelTypes["SharedContentMeta"],
	id:ModelTypes["UUID"],
	name:string,
	contentReference:ModelTypes["ContentReference"][],
	content?:ModelTypes["Content"],
	contentReferenceByEmbed?:ModelTypes["ContentReference"],
	contentReferenceByAudio?:ModelTypes["ContentReference"],
	contentReferenceByImage?:ModelTypes["ContentReference"],
	contentReferenceByPollAnswer?:ModelTypes["ContentReference"],
	contentReferenceByListicle?:ModelTypes["ContentReference"],
	contentReferenceByFaq?:ModelTypes["ContentReference"],
	contentReferenceByLinks?:ModelTypes["ContentReference"],
	contentReferenceByAwards?:ModelTypes["ContentReference"],
	contentReferenceByReviews?:ModelTypes["ContentReference"],
	contentReferenceByTarget?:ModelTypes["ContentReference"],
	contentReferenceByButtons?:ModelTypes["ContentReference"],
	paginateContentReference:ModelTypes["ContentReferenceConnection"]
};
	["SharedContentMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	contentReference?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"]
};
	["SharedContentContentReferenceByEmbedUniqueWhere"]: GraphQLTypes["SharedContentContentReferenceByEmbedUniqueWhere"];
	["SharedContentContentReferenceByAudioUniqueWhere"]: GraphQLTypes["SharedContentContentReferenceByAudioUniqueWhere"];
	["SharedContentContentReferenceByImageUniqueWhere"]: GraphQLTypes["SharedContentContentReferenceByImageUniqueWhere"];
	["SharedContentContentReferenceByPollAnswerUniqueWhere"]: GraphQLTypes["SharedContentContentReferenceByPollAnswerUniqueWhere"];
	["SharedContentContentReferenceByListicleUniqueWhere"]: GraphQLTypes["SharedContentContentReferenceByListicleUniqueWhere"];
	["SharedContentContentReferenceByFaqUniqueWhere"]: GraphQLTypes["SharedContentContentReferenceByFaqUniqueWhere"];
	["SharedContentContentReferenceByLinksUniqueWhere"]: GraphQLTypes["SharedContentContentReferenceByLinksUniqueWhere"];
	["SharedContentContentReferenceByAwardsUniqueWhere"]: GraphQLTypes["SharedContentContentReferenceByAwardsUniqueWhere"];
	["SharedContentContentReferenceByReviewsUniqueWhere"]: GraphQLTypes["SharedContentContentReferenceByReviewsUniqueWhere"];
	["SharedContentContentReferenceByTargetUniqueWhere"]: GraphQLTypes["SharedContentContentReferenceByTargetUniqueWhere"];
	["SharedContentContentReferenceByButtonsUniqueWhere"]: GraphQLTypes["SharedContentContentReferenceByButtonsUniqueWhere"];
	["ContentReferenceButtonsByTargetUniqueWhere"]: GraphQLTypes["ContentReferenceButtonsByTargetUniqueWhere"];
	["ImageContentConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ImageContentEdge"][]
};
	["ImageContentEdge"]: {
		node:ModelTypes["ImageContent"]
};
	["ListicleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ListicleEdge"][]
};
	["ListicleEdge"]: {
		node:ModelTypes["Listicle"]
};
	["FAQConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["FAQEdge"][]
};
	["FAQEdge"]: {
		node:ModelTypes["FAQ"]
};
	["LinkContentConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["LinkContentEdge"][]
};
	["LinkContentEdge"]: {
		node:ModelTypes["LinkContent"]
};
	["AwardContentConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["AwardContentEdge"][]
};
	["AwardContentEdge"]: {
		node:ModelTypes["AwardContent"]
};
	["ReviewContentConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ReviewContentEdge"][]
};
	["ReviewContentEdge"]: {
		node:ModelTypes["ReviewContent"]
};
	["ButtonConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ButtonEdge"][]
};
	["ButtonEdge"]: {
		node:ModelTypes["Button"]
};
	["ContentPartReferencesByEmbedUniqueWhere"]: GraphQLTypes["ContentPartReferencesByEmbedUniqueWhere"];
	["ContentPartReferencesByAudioUniqueWhere"]: GraphQLTypes["ContentPartReferencesByAudioUniqueWhere"];
	["ContentPartReferencesByImageUniqueWhere"]: GraphQLTypes["ContentPartReferencesByImageUniqueWhere"];
	["ContentPartReferencesByPollAnswerUniqueWhere"]: GraphQLTypes["ContentPartReferencesByPollAnswerUniqueWhere"];
	["ContentPartReferencesByListicleUniqueWhere"]: GraphQLTypes["ContentPartReferencesByListicleUniqueWhere"];
	["ContentPartReferencesByFaqUniqueWhere"]: GraphQLTypes["ContentPartReferencesByFaqUniqueWhere"];
	["ContentPartReferencesByLinksUniqueWhere"]: GraphQLTypes["ContentPartReferencesByLinksUniqueWhere"];
	["ContentPartReferencesByAwardsUniqueWhere"]: GraphQLTypes["ContentPartReferencesByAwardsUniqueWhere"];
	["ContentPartReferencesByReviewsUniqueWhere"]: GraphQLTypes["ContentPartReferencesByReviewsUniqueWhere"];
	["ContentPartReferencesByTargetUniqueWhere"]: GraphQLTypes["ContentPartReferencesByTargetUniqueWhere"];
	["ContentPartReferencesByButtonsUniqueWhere"]: GraphQLTypes["ContentPartReferencesByButtonsUniqueWhere"];
	["ContentPartsByReferencesUniqueWhere"]: GraphQLTypes["ContentPartsByReferencesUniqueWhere"];
	["ContentPartConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentPartEdge"][]
};
	["ContentPartEdge"]: {
		node:ModelTypes["ContentPart"]
};
	["AuthorTopArticle"]: {
		_meta?:ModelTypes["AuthorTopArticleMeta"],
	id:ModelTypes["UUID"],
	order:number,
	author?:ModelTypes["Author"],
	article?:ModelTypes["Article"]
};
	["AuthorTopArticleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	author?:ModelTypes["FieldMeta"],
	article?:ModelTypes["FieldMeta"]
};
	["AuthorTopArticleOrderBy"]: GraphQLTypes["AuthorTopArticleOrderBy"];
	["User"]: {
		_meta?:ModelTypes["UserMeta"],
	id:ModelTypes["UUID"],
	ihnedId:string,
	email:string,
	authors:ModelTypes["Author"][],
	unlockedArticles:ModelTypes["UnlockedArticle"][],
	appReviews:ModelTypes["AppReview"][],
	paginateAuthors:ModelTypes["AuthorConnection"],
	paginateUnlockedArticles:ModelTypes["UnlockedArticleConnection"],
	paginateAppReviews:ModelTypes["AppReviewConnection"]
};
	["UserMeta"]: {
		id?:ModelTypes["FieldMeta"],
	ihnedId?:ModelTypes["FieldMeta"],
	email?:ModelTypes["FieldMeta"],
	authors?:ModelTypes["FieldMeta"],
	unlockedArticles?:ModelTypes["FieldMeta"],
	appReviews?:ModelTypes["FieldMeta"]
};
	["UnlockedArticle"]: {
		_meta?:ModelTypes["UnlockedArticleMeta"],
	id:ModelTypes["UUID"],
	createdAt:ModelTypes["DateTime"],
	code:string,
	views:number,
	user?:ModelTypes["User"],
	article?:ModelTypes["Article"]
};
	["UnlockedArticleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	createdAt?:ModelTypes["FieldMeta"],
	code?:ModelTypes["FieldMeta"],
	views?:ModelTypes["FieldMeta"],
	user?:ModelTypes["FieldMeta"],
	article?:ModelTypes["FieldMeta"]
};
	["UnlockedArticleOrderBy"]: GraphQLTypes["UnlockedArticleOrderBy"];
	["UserOrderBy"]: GraphQLTypes["UserOrderBy"];
	["AppReview"]: {
		_meta?:ModelTypes["AppReviewMeta"],
	id:ModelTypes["UUID"],
	done:boolean,
	deviceId:string,
	createdAt:ModelTypes["DateTime"],
	rating:number,
	note?:string,
	user?:ModelTypes["User"]
};
	["AppReviewMeta"]: {
		id?:ModelTypes["FieldMeta"],
	done?:ModelTypes["FieldMeta"],
	deviceId?:ModelTypes["FieldMeta"],
	createdAt?:ModelTypes["FieldMeta"],
	rating?:ModelTypes["FieldMeta"],
	note?:ModelTypes["FieldMeta"],
	user?:ModelTypes["FieldMeta"]
};
	["AppReviewOrderBy"]: GraphQLTypes["AppReviewOrderBy"];
	["AuthorConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["AuthorEdge"][]
};
	["AuthorEdge"]: {
		node:ModelTypes["Author"]
};
	["UnlockedArticleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["UnlockedArticleEdge"][]
};
	["UnlockedArticleEdge"]: {
		node:ModelTypes["UnlockedArticle"]
};
	["AppReviewConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["AppReviewEdge"][]
};
	["AppReviewEdge"]: {
		node:ModelTypes["AppReview"]
};
	["AuthorTopArticleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["AuthorTopArticleEdge"][]
};
	["AuthorTopArticleEdge"]: {
		node:ModelTypes["AuthorTopArticle"]
};
	["UserConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["UserEdge"][]
};
	["UserEdge"]: {
		node:ModelTypes["User"]
};
	["Page"]: {
		_meta?:ModelTypes["PageMeta"],
	id:ModelTypes["UUID"],
	title:string,
	publishAt?:ModelTypes["DateTime"],
	createdAt:ModelTypes["DateTime"],
	template:ModelTypes["PageTemplate"],
	url?:ModelTypes["Url"],
	content?:ModelTypes["Content"],
	seo?:ModelTypes["Seo"],
	subscriptionValidity?:ModelTypes["DateTime"]
};
	["PageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	publishAt?:ModelTypes["FieldMeta"],
	createdAt?:ModelTypes["FieldMeta"],
	template?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	subscriptionValidity?:ModelTypes["FieldMeta"]
};
	["Seo"]: {
		_meta?:ModelTypes["SeoMeta"],
	id:ModelTypes["UUID"],
	title:string,
	description?:string,
	ogTitle?:string,
	ogDescription?:string,
	page?:ModelTypes["Page"],
	twCard?:ModelTypes["SeoTwCard"],
	ogImage?:ModelTypes["ImageUse"]
};
	["SeoMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	description?:ModelTypes["FieldMeta"],
	ogTitle?:ModelTypes["FieldMeta"],
	ogDescription?:ModelTypes["FieldMeta"],
	page?:ModelTypes["FieldMeta"],
	twCard?:ModelTypes["FieldMeta"],
	ogImage?:ModelTypes["FieldMeta"]
};
	["Category"]: {
		_meta?:ModelTypes["CategoryMeta"],
	id:ModelTypes["UUID"],
	name:string,
	articleCategory:ModelTypes["ArticleCategory"][],
	url?:ModelTypes["Url"],
	legacyId?:string,
	articleCategoryByArticle?:ModelTypes["ArticleCategory"],
	paginateArticleCategory:ModelTypes["ArticleCategoryConnection"]
};
	["CategoryMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	articleCategory?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"],
	legacyId?:ModelTypes["FieldMeta"]
};
	["ArticleCategory"]: {
		_meta?:ModelTypes["ArticleCategoryMeta"],
	id:ModelTypes["UUID"],
	order:number,
	article?:ModelTypes["Article"],
	category?:ModelTypes["Category"]
};
	["ArticleCategoryMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	article?:ModelTypes["FieldMeta"],
	category?:ModelTypes["FieldMeta"]
};
	["ArticleCategoryOrderBy"]: GraphQLTypes["ArticleCategoryOrderBy"];
	["CategoryArticleCategoryByArticleUniqueWhere"]: GraphQLTypes["CategoryArticleCategoryByArticleUniqueWhere"];
	["ArticleCategoryConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ArticleCategoryEdge"][]
};
	["ArticleCategoryEdge"]: {
		node:ModelTypes["ArticleCategory"]
};
	["Tag"]: {
		_meta?:ModelTypes["TagMeta"],
	id:ModelTypes["UUID"],
	name:string,
	useAsTagline:boolean,
	articleTag:ModelTypes["ArticleTag"][],
	url?:ModelTypes["Url"],
	order?:string,
	legacyId?:string,
	articleTagByArticle?:ModelTypes["ArticleTag"],
	paginateArticleTag:ModelTypes["ArticleTagConnection"]
};
	["TagMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	useAsTagline?:ModelTypes["FieldMeta"],
	articleTag?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	legacyId?:ModelTypes["FieldMeta"]
};
	["ArticleTag"]: {
		_meta?:ModelTypes["ArticleTagMeta"],
	id:ModelTypes["UUID"],
	order:number,
	tag?:ModelTypes["Tag"],
	article?:ModelTypes["Article"]
};
	["ArticleTagMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	tag?:ModelTypes["FieldMeta"],
	article?:ModelTypes["FieldMeta"]
};
	["ArticleTagOrderBy"]: GraphQLTypes["ArticleTagOrderBy"];
	["TagArticleTagByArticleUniqueWhere"]: GraphQLTypes["TagArticleTagByArticleUniqueWhere"];
	["ArticleTagConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ArticleTagEdge"][]
};
	["ArticleTagEdge"]: {
		node:ModelTypes["ArticleTag"]
};
	["ArticleAuthor"]: {
		_meta?:ModelTypes["ArticleAuthorMeta"],
	id:ModelTypes["UUID"],
	order:number,
	article?:ModelTypes["Article"],
	author?:ModelTypes["Author"],
	legacyStringAuthor?:ModelTypes["ArticleAuthorLegacyStringAuthor"]
};
	["ArticleAuthorMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	article?:ModelTypes["FieldMeta"],
	author?:ModelTypes["FieldMeta"],
	legacyStringAuthor?:ModelTypes["FieldMeta"]
};
	["ArticleAuthorOrderBy"]: GraphQLTypes["ArticleAuthorOrderBy"];
	["TextContent"]: {
		_meta?:ModelTypes["TextContentMeta"],
	id:ModelTypes["UUID"],
	parts:ModelTypes["TextContentPart"][],
	partsByReferences?:ModelTypes["TextContentPart"],
	paginateParts:ModelTypes["TextContentPartConnection"]
};
	["TextContentMeta"]: {
		id?:ModelTypes["FieldMeta"],
	parts?:ModelTypes["FieldMeta"]
};
	["TextContentPart"]: {
		_meta?:ModelTypes["TextContentPartMeta"],
	id:ModelTypes["UUID"],
	order:number,
	json:string,
	content?:ModelTypes["TextContent"],
	references:ModelTypes["TextContentReference"][],
	referencesByTarget?:ModelTypes["TextContentReference"],
	paginateReferences:ModelTypes["TextContentReferenceConnection"]
};
	["TextContentPartMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	json?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	references?:ModelTypes["FieldMeta"]
};
	["TextContentReference"]: {
		_meta?:ModelTypes["TextContentReferenceMeta"],
	id:ModelTypes["UUID"],
	type:ModelTypes["TextContentReferenceType"],
	contentPart?:ModelTypes["TextContentPart"],
	target?:ModelTypes["Link"]
};
	["TextContentReferenceMeta"]: {
		id?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	contentPart?:ModelTypes["FieldMeta"],
	target?:ModelTypes["FieldMeta"]
};
	["TextContentReferenceOrderBy"]: GraphQLTypes["TextContentReferenceOrderBy"];
	["TextContentPartOrderBy"]: GraphQLTypes["TextContentPartOrderBy"];
	["TextContentPartReferencesByTargetUniqueWhere"]: GraphQLTypes["TextContentPartReferencesByTargetUniqueWhere"];
	["TextContentReferenceConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["TextContentReferenceEdge"][]
};
	["TextContentReferenceEdge"]: {
		node:ModelTypes["TextContentReference"]
};
	["TextContentPartsByReferencesUniqueWhere"]: GraphQLTypes["TextContentPartsByReferencesUniqueWhere"];
	["TextContentPartConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["TextContentPartEdge"][]
};
	["TextContentPartEdge"]: {
		node:ModelTypes["TextContentPart"]
};
	["ArticleHistoryTag"]: {
		_meta?:ModelTypes["ArticleHistoryTagMeta"],
	id:ModelTypes["UUID"],
	order:number,
	article?:ModelTypes["Article"],
	historyTag?:ModelTypes["HistoryTag"]
};
	["ArticleHistoryTagMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	article?:ModelTypes["FieldMeta"],
	historyTag?:ModelTypes["FieldMeta"]
};
	["HistoryTag"]: {
		_meta?:ModelTypes["HistoryTagMeta"],
	id:ModelTypes["UUID"],
	name:string,
	articleHistoryTag:ModelTypes["ArticleHistoryTag"][],
	slug:string,
	articleHistoryTagByArticle?:ModelTypes["ArticleHistoryTag"],
	paginateArticleHistoryTag:ModelTypes["ArticleHistoryTagConnection"]
};
	["HistoryTagMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	articleHistoryTag?:ModelTypes["FieldMeta"],
	slug?:ModelTypes["FieldMeta"]
};
	["ArticleHistoryTagOrderBy"]: GraphQLTypes["ArticleHistoryTagOrderBy"];
	["HistoryTagOrderBy"]: GraphQLTypes["HistoryTagOrderBy"];
	["HistoryTagArticleHistoryTagByArticleUniqueWhere"]: GraphQLTypes["HistoryTagArticleHistoryTagByArticleUniqueWhere"];
	["ArticleHistoryTagConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ArticleHistoryTagEdge"][]
};
	["ArticleHistoryTagEdge"]: {
		node:ModelTypes["ArticleHistoryTag"]
};
	["ArticleHistoryPeriod"]: {
		_meta?:ModelTypes["ArticleHistoryPeriodMeta"],
	id:ModelTypes["UUID"],
	order:number,
	article?:ModelTypes["Article"],
	historyPeriod?:ModelTypes["HistoryPeriod"]
};
	["ArticleHistoryPeriodMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	article?:ModelTypes["FieldMeta"],
	historyPeriod?:ModelTypes["FieldMeta"]
};
	["HistoryPeriod"]: {
		_meta?:ModelTypes["HistoryPeriodMeta"],
	id:ModelTypes["UUID"],
	name:string,
	articleHistoryPeriod:ModelTypes["ArticleHistoryPeriod"][],
	slug:string,
	order?:number,
	cover?:ModelTypes["HistoryCover"],
	seo?:ModelTypes["Seo"],
	articleHistoryPeriodByArticle?:ModelTypes["ArticleHistoryPeriod"],
	paginateArticleHistoryPeriod:ModelTypes["ArticleHistoryPeriodConnection"]
};
	["HistoryPeriodMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	articleHistoryPeriod?:ModelTypes["FieldMeta"],
	slug?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	cover?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"]
};
	["ArticleHistoryPeriodOrderBy"]: GraphQLTypes["ArticleHistoryPeriodOrderBy"];
	["HistoryPeriodOrderBy"]: GraphQLTypes["HistoryPeriodOrderBy"];
	["HistoryCoverOrderBy"]: GraphQLTypes["HistoryCoverOrderBy"];
	["HistoryTextListOrderBy"]: GraphQLTypes["HistoryTextListOrderBy"];
	["HistoryCover"]: {
		_meta?:ModelTypes["HistoryCoverMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	tileParagraph?:string,
	coverImage?:ModelTypes["ImageUse"],
	tileImage?:ModelTypes["ImageUse"],
	mobileImage?:ModelTypes["ImageUse"],
	leadContent?:ModelTypes["Content"],
	annotations?:ModelTypes["HistoryTextList"]
};
	["HistoryCoverMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	tileParagraph?:ModelTypes["FieldMeta"],
	coverImage?:ModelTypes["FieldMeta"],
	tileImage?:ModelTypes["FieldMeta"],
	mobileImage?:ModelTypes["FieldMeta"],
	leadContent?:ModelTypes["FieldMeta"],
	annotations?:ModelTypes["FieldMeta"]
};
	["HistoryTextList"]: {
		_meta?:ModelTypes["HistoryTextListMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["HistoryTextItem"][],
	itemsByImage?:ModelTypes["HistoryTextItem"],
	paginateItems:ModelTypes["HistoryTextItemConnection"]
};
	["HistoryTextListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["HistoryTextItem"]: {
		_meta?:ModelTypes["HistoryTextItemMeta"],
	id:ModelTypes["UUID"],
	order?:number,
	key?:string,
	text?:string,
	list?:ModelTypes["HistoryTextList"],
	image?:ModelTypes["ImageUse"]
};
	["HistoryTextItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	key?:ModelTypes["FieldMeta"],
	text?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"]
};
	["HistoryTextItemOrderBy"]: GraphQLTypes["HistoryTextItemOrderBy"];
	["HistoryTextListItemsByImageUniqueWhere"]: GraphQLTypes["HistoryTextListItemsByImageUniqueWhere"];
	["HistoryTextItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["HistoryTextItemEdge"][]
};
	["HistoryTextItemEdge"]: {
		node:ModelTypes["HistoryTextItem"]
};
	["HistoryPeriodArticleHistoryPeriodByArticleUniqueWhere"]: GraphQLTypes["HistoryPeriodArticleHistoryPeriodByArticleUniqueWhere"];
	["ArticleHistoryPeriodConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ArticleHistoryPeriodEdge"][]
};
	["ArticleHistoryPeriodEdge"]: {
		node:ModelTypes["ArticleHistoryPeriod"]
};
	["ArticleAuthorsByAuthorUniqueWhere"]: GraphQLTypes["ArticleAuthorsByAuthorUniqueWhere"];
	["ArticleAuthorsByLegacyStringAuthorUniqueWhere"]: GraphQLTypes["ArticleAuthorsByLegacyStringAuthorUniqueWhere"];
	["ArticleCategoriesByCategoryUniqueWhere"]: GraphQLTypes["ArticleCategoriesByCategoryUniqueWhere"];
	["ArticleIssuesByIssueUniqueWhere"]: GraphQLTypes["ArticleIssuesByIssueUniqueWhere"];
	["ArticleTagsByTagUniqueWhere"]: GraphQLTypes["ArticleTagsByTagUniqueWhere"];
	["ArticleHistoryTagsByHistoryTagUniqueWhere"]: GraphQLTypes["ArticleHistoryTagsByHistoryTagUniqueWhere"];
	["ArticleHistoryPeriodsByHistoryPeriodUniqueWhere"]: GraphQLTypes["ArticleHistoryPeriodsByHistoryPeriodUniqueWhere"];
	["ArticleAuthorConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ArticleAuthorEdge"][]
};
	["ArticleAuthorEdge"]: {
		node:ModelTypes["ArticleAuthor"]
};
	["ArticleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ArticleEdge"][]
};
	["ArticleEdge"]: {
		node:ModelTypes["Article"]
};
	["_ValidationResult"]: {
		valid:boolean,
	errors:ModelTypes["_ValidationError"][]
};
	["_ValidationError"]: {
		path:ModelTypes["_PathFragment"][],
	message:ModelTypes["_ValidationMessage"]
};
	["_PathFragment"]:ModelTypes["_FieldPathFragment"] | ModelTypes["_IndexPathFragment"];
	["_FieldPathFragment"]: {
		field:string
};
	["_IndexPathFragment"]: {
		index:number,
	alias?:string
};
	["_ValidationMessage"]: {
		text:string
};
	["ArticleCreateInput"]: GraphQLTypes["ArticleCreateInput"];
	["ArticleCreateUrlEntityRelationInput"]: GraphQLTypes["ArticleCreateUrlEntityRelationInput"];
	["UrlWithoutArticleCreateInput"]: GraphQLTypes["UrlWithoutArticleCreateInput"];
	["UrlCreateAuthorEntityRelationInput"]: GraphQLTypes["UrlCreateAuthorEntityRelationInput"];
	["AuthorWithoutUrlCreateInput"]: GraphQLTypes["AuthorWithoutUrlCreateInput"];
	["AuthorCreateAboutEntityRelationInput"]: GraphQLTypes["AuthorCreateAboutEntityRelationInput"];
	["ContentCreateInput"]: GraphQLTypes["ContentCreateInput"];
	["ContentCreatePartsEntityRelationInput"]: GraphQLTypes["ContentCreatePartsEntityRelationInput"];
	["ContentPartWithoutContentCreateInput"]: GraphQLTypes["ContentPartWithoutContentCreateInput"];
	["ContentPartCreateReferencesEntityRelationInput"]: GraphQLTypes["ContentPartCreateReferencesEntityRelationInput"];
	["ContentReferenceWithoutContentPartCreateInput"]: GraphQLTypes["ContentReferenceWithoutContentPartCreateInput"];
	["ContentReferenceCreateEmbedEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateEmbedEntityRelationInput"];
	["EmbedCreateInput"]: GraphQLTypes["EmbedCreateInput"];
	["ContentReferenceCreateArticleEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateArticleEntityRelationInput"];
	["ContentReferenceCreateAudioEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateAudioEntityRelationInput"];
	["AudioUseCreateInput"]: GraphQLTypes["AudioUseCreateInput"];
	["AudioUseCreateAudioEntityRelationInput"]: GraphQLTypes["AudioUseCreateAudioEntityRelationInput"];
	["AudioUniqueWhere"]: GraphQLTypes["AudioUniqueWhere"];
	["AudioWithoutUsesCreateInput"]: GraphQLTypes["AudioWithoutUsesCreateInput"];
	["AudioCreateAuthorEntityRelationInput"]: GraphQLTypes["AudioCreateAuthorEntityRelationInput"];
	["AuthorCreateInput"]: GraphQLTypes["AuthorCreateInput"];
	["AuthorCreateTopArticlesEntityRelationInput"]: GraphQLTypes["AuthorCreateTopArticlesEntityRelationInput"];
	["AuthorTopArticleWithoutAuthorCreateInput"]: GraphQLTypes["AuthorTopArticleWithoutAuthorCreateInput"];
	["AuthorTopArticleCreateArticleEntityRelationInput"]: GraphQLTypes["AuthorTopArticleCreateArticleEntityRelationInput"];
	["AuthorCreateUsersEntityRelationInput"]: GraphQLTypes["AuthorCreateUsersEntityRelationInput"];
	["UserUniqueWhere"]: GraphQLTypes["UserUniqueWhere"];
	["AppReviewUniqueWhere"]: GraphQLTypes["AppReviewUniqueWhere"];
	["UserWithoutAuthorsCreateInput"]: GraphQLTypes["UserWithoutAuthorsCreateInput"];
	["UserCreateUnlockedArticlesEntityRelationInput"]: GraphQLTypes["UserCreateUnlockedArticlesEntityRelationInput"];
	["UnlockedArticleWithoutUserCreateInput"]: GraphQLTypes["UnlockedArticleWithoutUserCreateInput"];
	["UnlockedArticleCreateArticleEntityRelationInput"]: GraphQLTypes["UnlockedArticleCreateArticleEntityRelationInput"];
	["ArticleWithoutUnlockedCreateInput"]: GraphQLTypes["ArticleWithoutUnlockedCreateInput"];
	["ArticleCreateAuthorsEntityRelationInput"]: GraphQLTypes["ArticleCreateAuthorsEntityRelationInput"];
	["ArticleAuthorWithoutArticleCreateInput"]: GraphQLTypes["ArticleAuthorWithoutArticleCreateInput"];
	["ArticleAuthorCreateAuthorEntityRelationInput"]: GraphQLTypes["ArticleAuthorCreateAuthorEntityRelationInput"];
	["ArticleCreateSubtitleEntityRelationInput"]: GraphQLTypes["ArticleCreateSubtitleEntityRelationInput"];
	["TextContentCreateInput"]: GraphQLTypes["TextContentCreateInput"];
	["TextContentCreatePartsEntityRelationInput"]: GraphQLTypes["TextContentCreatePartsEntityRelationInput"];
	["TextContentPartWithoutContentCreateInput"]: GraphQLTypes["TextContentPartWithoutContentCreateInput"];
	["TextContentPartCreateReferencesEntityRelationInput"]: GraphQLTypes["TextContentPartCreateReferencesEntityRelationInput"];
	["TextContentReferenceWithoutContentPartCreateInput"]: GraphQLTypes["TextContentReferenceWithoutContentPartCreateInput"];
	["TextContentReferenceCreateTargetEntityRelationInput"]: GraphQLTypes["TextContentReferenceCreateTargetEntityRelationInput"];
	["LinkCreateInput"]: GraphQLTypes["LinkCreateInput"];
	["LinkCreateInternalTargetEntityRelationInput"]: GraphQLTypes["LinkCreateInternalTargetEntityRelationInput"];
	["UrlCreateInput"]: GraphQLTypes["UrlCreateInput"];
	["UrlCreateArticleEntityRelationInput"]: GraphQLTypes["UrlCreateArticleEntityRelationInput"];
	["ArticleWithoutUrlCreateInput"]: GraphQLTypes["ArticleWithoutUrlCreateInput"];
	["ArticleCreateContentEntityRelationInput"]: GraphQLTypes["ArticleCreateContentEntityRelationInput"];
	["ArticleCreateCoverPhotoEntityRelationInput"]: GraphQLTypes["ArticleCreateCoverPhotoEntityRelationInput"];
	["ImageUseCreateInput"]: GraphQLTypes["ImageUseCreateInput"];
	["ImageUseCreateImageEntityRelationInput"]: GraphQLTypes["ImageUseCreateImageEntityRelationInput"];
	["ImageUniqueWhere"]: GraphQLTypes["ImageUniqueWhere"];
	["ImageWithoutUsesCreateInput"]: GraphQLTypes["ImageWithoutUsesCreateInput"];
	["ImageCreateAuthorEntityRelationInput"]: GraphQLTypes["ImageCreateAuthorEntityRelationInput"];
	["ImageCreateTagsEntityRelationInput"]: GraphQLTypes["ImageCreateTagsEntityRelationInput"];
	["ImageTagUniqueWhere"]: GraphQLTypes["ImageTagUniqueWhere"];
	["ImageTagWithoutImagesCreateInput"]: GraphQLTypes["ImageTagWithoutImagesCreateInput"];
	["ArticleCreatePreviewContentEntityRelationInput"]: GraphQLTypes["ArticleCreatePreviewContentEntityRelationInput"];
	["ArticleCreateAudioEntityRelationInput"]: GraphQLTypes["ArticleCreateAudioEntityRelationInput"];
	["ArticleCreateCategoriesEntityRelationInput"]: GraphQLTypes["ArticleCreateCategoriesEntityRelationInput"];
	["ArticleCategoryWithoutArticleCreateInput"]: GraphQLTypes["ArticleCategoryWithoutArticleCreateInput"];
	["ArticleCategoryCreateCategoryEntityRelationInput"]: GraphQLTypes["ArticleCategoryCreateCategoryEntityRelationInput"];
	["CategoryWithoutArticleCategoryCreateInput"]: GraphQLTypes["CategoryWithoutArticleCategoryCreateInput"];
	["CategoryCreateUrlEntityRelationInput"]: GraphQLTypes["CategoryCreateUrlEntityRelationInput"];
	["UrlWithoutCategoryCreateInput"]: GraphQLTypes["UrlWithoutCategoryCreateInput"];
	["UrlCreateIssueEntityRelationInput"]: GraphQLTypes["UrlCreateIssueEntityRelationInput"];
	["IssueWithoutUrlCreateInput"]: GraphQLTypes["IssueWithoutUrlCreateInput"];
	["IssueCreateArticlesEntityRelationInput"]: GraphQLTypes["IssueCreateArticlesEntityRelationInput"];
	["IssueArticleWithoutIssueCreateInput"]: GraphQLTypes["IssueArticleWithoutIssueCreateInput"];
	["IssueArticleCreateArticleEntityRelationInput"]: GraphQLTypes["IssueArticleCreateArticleEntityRelationInput"];
	["ArticleWithoutIssuesCreateInput"]: GraphQLTypes["ArticleWithoutIssuesCreateInput"];
	["ArticleCreateContentBlocksEntityRelationInput"]: GraphQLTypes["ArticleCreateContentBlocksEntityRelationInput"];
	["ContentArticleWithoutArticleCreateInput"]: GraphQLTypes["ContentArticleWithoutArticleCreateInput"];
	["ContentArticleCreateContentBlockEntityRelationInput"]: GraphQLTypes["ContentArticleCreateContentBlockEntityRelationInput"];
	["ContentBlockWithoutArticlesCreateInput"]: GraphQLTypes["ContentBlockWithoutArticlesCreateInput"];
	["ContentBlockCreateIssueEntityRelationInput"]: GraphQLTypes["ContentBlockCreateIssueEntityRelationInput"];
	["IssueWithoutBlocksCreateInput"]: GraphQLTypes["IssueWithoutBlocksCreateInput"];
	["IssueCreateUrlEntityRelationInput"]: GraphQLTypes["IssueCreateUrlEntityRelationInput"];
	["UrlWithoutIssueCreateInput"]: GraphQLTypes["UrlWithoutIssueCreateInput"];
	["UrlCreatePageEntityRelationInput"]: GraphQLTypes["UrlCreatePageEntityRelationInput"];
	["PageWithoutUrlCreateInput"]: GraphQLTypes["PageWithoutUrlCreateInput"];
	["PageCreateContentEntityRelationInput"]: GraphQLTypes["PageCreateContentEntityRelationInput"];
	["PageCreateSeoEntityRelationInput"]: GraphQLTypes["PageCreateSeoEntityRelationInput"];
	["SeoWithoutPageCreateInput"]: GraphQLTypes["SeoWithoutPageCreateInput"];
	["SeoCreateOgImageEntityRelationInput"]: GraphQLTypes["SeoCreateOgImageEntityRelationInput"];
	["UrlCreateCategoryEntityRelationInput"]: GraphQLTypes["UrlCreateCategoryEntityRelationInput"];
	["CategoryWithoutUrlCreateInput"]: GraphQLTypes["CategoryWithoutUrlCreateInput"];
	["CategoryCreateArticleCategoryEntityRelationInput"]: GraphQLTypes["CategoryCreateArticleCategoryEntityRelationInput"];
	["ArticleCategoryWithoutCategoryCreateInput"]: GraphQLTypes["ArticleCategoryWithoutCategoryCreateInput"];
	["ArticleCategoryCreateArticleEntityRelationInput"]: GraphQLTypes["ArticleCategoryCreateArticleEntityRelationInput"];
	["ArticleWithoutCategoriesCreateInput"]: GraphQLTypes["ArticleWithoutCategoriesCreateInput"];
	["ArticleCreateIssuesEntityRelationInput"]: GraphQLTypes["ArticleCreateIssuesEntityRelationInput"];
	["IssueArticleWithoutArticleCreateInput"]: GraphQLTypes["IssueArticleWithoutArticleCreateInput"];
	["IssueArticleCreateIssueEntityRelationInput"]: GraphQLTypes["IssueArticleCreateIssueEntityRelationInput"];
	["IssueWithoutArticlesCreateInput"]: GraphQLTypes["IssueWithoutArticlesCreateInput"];
	["IssueCreatePdfEntityRelationInput"]: GraphQLTypes["IssueCreatePdfEntityRelationInput"];
	["FileUseCreateInput"]: GraphQLTypes["FileUseCreateInput"];
	["FileUseCreateFileEntityRelationInput"]: GraphQLTypes["FileUseCreateFileEntityRelationInput"];
	["FileUniqueWhere"]: GraphQLTypes["FileUniqueWhere"];
	["FileWithoutUsesCreateInput"]: GraphQLTypes["FileWithoutUsesCreateInput"];
	["IssueCreateBlocksEntityRelationInput"]: GraphQLTypes["IssueCreateBlocksEntityRelationInput"];
	["ContentBlockWithoutIssueCreateInput"]: GraphQLTypes["ContentBlockWithoutIssueCreateInput"];
	["ContentBlockCreateTargetEntityRelationInput"]: GraphQLTypes["ContentBlockCreateTargetEntityRelationInput"];
	["ContentBlockCreateArticlesEntityRelationInput"]: GraphQLTypes["ContentBlockCreateArticlesEntityRelationInput"];
	["ContentArticleWithoutContentBlockCreateInput"]: GraphQLTypes["ContentArticleWithoutContentBlockCreateInput"];
	["ContentArticleCreateArticleEntityRelationInput"]: GraphQLTypes["ContentArticleCreateArticleEntityRelationInput"];
	["ArticleWithoutContentBlocksCreateInput"]: GraphQLTypes["ArticleWithoutContentBlocksCreateInput"];
	["ArticleCreateUnlockedEntityRelationInput"]: GraphQLTypes["ArticleCreateUnlockedEntityRelationInput"];
	["UnlockedArticleWithoutArticleCreateInput"]: GraphQLTypes["UnlockedArticleWithoutArticleCreateInput"];
	["UnlockedArticleCreateUserEntityRelationInput"]: GraphQLTypes["UnlockedArticleCreateUserEntityRelationInput"];
	["UserWithoutUnlockedArticlesCreateInput"]: GraphQLTypes["UserWithoutUnlockedArticlesCreateInput"];
	["UserCreateAuthorsEntityRelationInput"]: GraphQLTypes["UserCreateAuthorsEntityRelationInput"];
	["AuthorWithoutUsersCreateInput"]: GraphQLTypes["AuthorWithoutUsersCreateInput"];
	["AuthorCreatePhotoEntityRelationInput"]: GraphQLTypes["AuthorCreatePhotoEntityRelationInput"];
	["AuthorCreateIllustrationEntityRelationInput"]: GraphQLTypes["AuthorCreateIllustrationEntityRelationInput"];
	["AuthorCreateUrlEntityRelationInput"]: GraphQLTypes["AuthorCreateUrlEntityRelationInput"];
	["UrlWithoutAuthorCreateInput"]: GraphQLTypes["UrlWithoutAuthorCreateInput"];
	["UrlCreateTagEntityRelationInput"]: GraphQLTypes["UrlCreateTagEntityRelationInput"];
	["TagWithoutUrlCreateInput"]: GraphQLTypes["TagWithoutUrlCreateInput"];
	["TagCreateArticleTagEntityRelationInput"]: GraphQLTypes["TagCreateArticleTagEntityRelationInput"];
	["ArticleTagWithoutTagCreateInput"]: GraphQLTypes["ArticleTagWithoutTagCreateInput"];
	["ArticleTagCreateArticleEntityRelationInput"]: GraphQLTypes["ArticleTagCreateArticleEntityRelationInput"];
	["ArticleWithoutTagsCreateInput"]: GraphQLTypes["ArticleWithoutTagsCreateInput"];
	["ArticleCreateCoverPhotoVerticalEntityRelationInput"]: GraphQLTypes["ArticleCreateCoverPhotoVerticalEntityRelationInput"];
	["ArticleCreateHistoryTagsEntityRelationInput"]: GraphQLTypes["ArticleCreateHistoryTagsEntityRelationInput"];
	["ArticleHistoryTagWithoutArticleCreateInput"]: GraphQLTypes["ArticleHistoryTagWithoutArticleCreateInput"];
	["ArticleHistoryTagCreateHistoryTagEntityRelationInput"]: GraphQLTypes["ArticleHistoryTagCreateHistoryTagEntityRelationInput"];
	["HistoryTagWithoutArticleHistoryTagCreateInput"]: GraphQLTypes["HistoryTagWithoutArticleHistoryTagCreateInput"];
	["ArticleCreateHistoryPeriodsEntityRelationInput"]: GraphQLTypes["ArticleCreateHistoryPeriodsEntityRelationInput"];
	["ArticleHistoryPeriodWithoutArticleCreateInput"]: GraphQLTypes["ArticleHistoryPeriodWithoutArticleCreateInput"];
	["ArticleHistoryPeriodCreateHistoryPeriodEntityRelationInput"]: GraphQLTypes["ArticleHistoryPeriodCreateHistoryPeriodEntityRelationInput"];
	["HistoryPeriodWithoutArticleHistoryPeriodCreateInput"]: GraphQLTypes["HistoryPeriodWithoutArticleHistoryPeriodCreateInput"];
	["HistoryPeriodCreateCoverEntityRelationInput"]: GraphQLTypes["HistoryPeriodCreateCoverEntityRelationInput"];
	["HistoryCoverCreateInput"]: GraphQLTypes["HistoryCoverCreateInput"];
	["HistoryCoverCreateCoverImageEntityRelationInput"]: GraphQLTypes["HistoryCoverCreateCoverImageEntityRelationInput"];
	["HistoryCoverCreateTileImageEntityRelationInput"]: GraphQLTypes["HistoryCoverCreateTileImageEntityRelationInput"];
	["HistoryCoverCreateMobileImageEntityRelationInput"]: GraphQLTypes["HistoryCoverCreateMobileImageEntityRelationInput"];
	["HistoryCoverCreateLeadContentEntityRelationInput"]: GraphQLTypes["HistoryCoverCreateLeadContentEntityRelationInput"];
	["HistoryCoverCreateAnnotationsEntityRelationInput"]: GraphQLTypes["HistoryCoverCreateAnnotationsEntityRelationInput"];
	["HistoryTextListCreateInput"]: GraphQLTypes["HistoryTextListCreateInput"];
	["HistoryTextListCreateItemsEntityRelationInput"]: GraphQLTypes["HistoryTextListCreateItemsEntityRelationInput"];
	["HistoryTextItemWithoutListCreateInput"]: GraphQLTypes["HistoryTextItemWithoutListCreateInput"];
	["HistoryTextItemCreateImageEntityRelationInput"]: GraphQLTypes["HistoryTextItemCreateImageEntityRelationInput"];
	["HistoryPeriodCreateSeoEntityRelationInput"]: GraphQLTypes["HistoryPeriodCreateSeoEntityRelationInput"];
	["SeoCreateInput"]: GraphQLTypes["SeoCreateInput"];
	["SeoCreatePageEntityRelationInput"]: GraphQLTypes["SeoCreatePageEntityRelationInput"];
	["PageWithoutSeoCreateInput"]: GraphQLTypes["PageWithoutSeoCreateInput"];
	["PageCreateUrlEntityRelationInput"]: GraphQLTypes["PageCreateUrlEntityRelationInput"];
	["UrlWithoutPageCreateInput"]: GraphQLTypes["UrlWithoutPageCreateInput"];
	["UserCreateAppReviewsEntityRelationInput"]: GraphQLTypes["UserCreateAppReviewsEntityRelationInput"];
	["AppReviewWithoutUserCreateInput"]: GraphQLTypes["AppReviewWithoutUserCreateInput"];
	["ArticleCreateTagsEntityRelationInput"]: GraphQLTypes["ArticleCreateTagsEntityRelationInput"];
	["ArticleTagWithoutArticleCreateInput"]: GraphQLTypes["ArticleTagWithoutArticleCreateInput"];
	["ArticleTagCreateTagEntityRelationInput"]: GraphQLTypes["ArticleTagCreateTagEntityRelationInput"];
	["TagWithoutArticleTagCreateInput"]: GraphQLTypes["TagWithoutArticleTagCreateInput"];
	["TagCreateUrlEntityRelationInput"]: GraphQLTypes["TagCreateUrlEntityRelationInput"];
	["UrlWithoutTagCreateInput"]: GraphQLTypes["UrlWithoutTagCreateInput"];
	["ContentBlockCreateSubscriptionFormEntityRelationInput"]: GraphQLTypes["ContentBlockCreateSubscriptionFormEntityRelationInput"];
	["SubscriptionFormUniqueWhere"]: GraphQLTypes["SubscriptionFormUniqueWhere"];
	["SubscriptionFormSectionUniqueWhere"]: GraphQLTypes["SubscriptionFormSectionUniqueWhere"];
	["ProductUniqueWhere"]: GraphQLTypes["ProductUniqueWhere"];
	["SubscriptionFormWithoutContentBlockCreateInput"]: GraphQLTypes["SubscriptionFormWithoutContentBlockCreateInput"];
	["SubscriptionFormCreateSectionsEntityRelationInput"]: GraphQLTypes["SubscriptionFormCreateSectionsEntityRelationInput"];
	["SubscriptionFormSectionWithoutFormCreateInput"]: GraphQLTypes["SubscriptionFormSectionWithoutFormCreateInput"];
	["SubscriptionFormSectionCreateInputsEntityRelationInput"]: GraphQLTypes["SubscriptionFormSectionCreateInputsEntityRelationInput"];
	["SubscriptionFormInputWithoutSectionCreateInput"]: GraphQLTypes["SubscriptionFormInputWithoutSectionCreateInput"];
	["SubscriptionFormInputCreateImageEntityRelationInput"]: GraphQLTypes["SubscriptionFormInputCreateImageEntityRelationInput"];
	["SubscriptionFormInputCreateOptionsEntityRelationInput"]: GraphQLTypes["SubscriptionFormInputCreateOptionsEntityRelationInput"];
	["SubscriptionFormOptionWithoutFormInputCreateInput"]: GraphQLTypes["SubscriptionFormOptionWithoutFormInputCreateInput"];
	["SubscriptionFormOptionCreateProductsEntityRelationInput"]: GraphQLTypes["SubscriptionFormOptionCreateProductsEntityRelationInput"];
	["ProductWithoutFormOptionsCreateInput"]: GraphQLTypes["ProductWithoutFormOptionsCreateInput"];
	["ProductCreateFormEntityRelationInput"]: GraphQLTypes["ProductCreateFormEntityRelationInput"];
	["SubscriptionFormWithoutProductsCreateInput"]: GraphQLTypes["SubscriptionFormWithoutProductsCreateInput"];
	["SubscriptionFormCreateContentBlockEntityRelationInput"]: GraphQLTypes["SubscriptionFormCreateContentBlockEntityRelationInput"];
	["ContentBlockWithoutSubscriptionFormCreateInput"]: GraphQLTypes["ContentBlockWithoutSubscriptionFormCreateInput"];
	["SubscriptionFormCreateContentReferencesEntityRelationInput"]: GraphQLTypes["SubscriptionFormCreateContentReferencesEntityRelationInput"];
	["ContentReferenceWithoutSubscriptionFormCreateInput"]: GraphQLTypes["ContentReferenceWithoutSubscriptionFormCreateInput"];
	["ContentReferenceCreateContentPartEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateContentPartEntityRelationInput"];
	["ContentPartWithoutReferencesCreateInput"]: GraphQLTypes["ContentPartWithoutReferencesCreateInput"];
	["ContentPartCreateContentEntityRelationInput"]: GraphQLTypes["ContentPartCreateContentEntityRelationInput"];
	["ContentWithoutPartsCreateInput"]: GraphQLTypes["ContentWithoutPartsCreateInput"];
	["ContentReferenceCreateImageEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"];
	["ContentReferenceCreateImagesEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateImagesEntityRelationInput"];
	["ImageContentUniqueWhere"]: GraphQLTypes["ImageContentUniqueWhere"];
	["ImageContentWithoutContentReferenceCreateInput"]: GraphQLTypes["ImageContentWithoutContentReferenceCreateInput"];
	["ImageContentCreateImageEntityRelationInput"]: GraphQLTypes["ImageContentCreateImageEntityRelationInput"];
	["ContentReferenceCreatePollAnswerEntityRelationInput"]: GraphQLTypes["ContentReferenceCreatePollAnswerEntityRelationInput"];
	["PollAnswerCreateInput"]: GraphQLTypes["PollAnswerCreateInput"];
	["PollAnswerCreateAuthorImageEntityRelationInput"]: GraphQLTypes["PollAnswerCreateAuthorImageEntityRelationInput"];
	["ContentReferenceCreateListicleEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateListicleEntityRelationInput"];
	["ListicleWithoutContentReferenceCreateInput"]: GraphQLTypes["ListicleWithoutContentReferenceCreateInput"];
	["ListicleCreateImageEntityRelationInput"]: GraphQLTypes["ListicleCreateImageEntityRelationInput"];
	["ListicleCreateTargetEntityRelationInput"]: GraphQLTypes["ListicleCreateTargetEntityRelationInput"];
	["ListicleCreateContentEntityRelationInput"]: GraphQLTypes["ListicleCreateContentEntityRelationInput"];
	["ContentReferenceCreateFaqEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateFaqEntityRelationInput"];
	["FAQWithoutContentReferenceCreateInput"]: GraphQLTypes["FAQWithoutContentReferenceCreateInput"];
	["ContentReferenceCreateLinksEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateLinksEntityRelationInput"];
	["LinkContentWithoutContentReferenceCreateInput"]: GraphQLTypes["LinkContentWithoutContentReferenceCreateInput"];
	["LinkContentCreateTargetEntityRelationInput"]: GraphQLTypes["LinkContentCreateTargetEntityRelationInput"];
	["ContentReferenceCreateAwardsEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateAwardsEntityRelationInput"];
	["AwardContentWithoutContentReferenceCreateInput"]: GraphQLTypes["AwardContentWithoutContentReferenceCreateInput"];
	["AwardContentCreateImageEntityRelationInput"]: GraphQLTypes["AwardContentCreateImageEntityRelationInput"];
	["AwardContentCreateTargetEntityRelationInput"]: GraphQLTypes["AwardContentCreateTargetEntityRelationInput"];
	["ContentReferenceCreateReviewsEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateReviewsEntityRelationInput"];
	["ReviewContentWithoutContentReferenceCreateInput"]: GraphQLTypes["ReviewContentWithoutContentReferenceCreateInput"];
	["ContentReferenceCreateTargetEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateTargetEntityRelationInput"];
	["ContentReferenceCreateButtonsEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateButtonsEntityRelationInput"];
	["ButtonWithoutContentReferenceCreateInput"]: GraphQLTypes["ButtonWithoutContentReferenceCreateInput"];
	["ButtonCreateTargetEntityRelationInput"]: GraphQLTypes["ButtonCreateTargetEntityRelationInput"];
	["ContentReferenceCreateSharedContentEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateSharedContentEntityRelationInput"];
	["SharedContentUniqueWhere"]: GraphQLTypes["SharedContentUniqueWhere"];
	["SharedContentWithoutContentReferenceCreateInput"]: GraphQLTypes["SharedContentWithoutContentReferenceCreateInput"];
	["SharedContentCreateContentEntityRelationInput"]: GraphQLTypes["SharedContentCreateContentEntityRelationInput"];
	["SubscriptionFormInputCreateDescriptionEntityRelationInput"]: GraphQLTypes["SubscriptionFormInputCreateDescriptionEntityRelationInput"];
	["SubscriptionFormCreateProductsEntityRelationInput"]: GraphQLTypes["SubscriptionFormCreateProductsEntityRelationInput"];
	["ProductWithoutFormCreateInput"]: GraphQLTypes["ProductWithoutFormCreateInput"];
	["ProductCreateFormOptionsEntityRelationInput"]: GraphQLTypes["ProductCreateFormOptionsEntityRelationInput"];
	["SubscriptionFormOptionWithoutProductsCreateInput"]: GraphQLTypes["SubscriptionFormOptionWithoutProductsCreateInput"];
	["SubscriptionFormOptionCreateFormInputEntityRelationInput"]: GraphQLTypes["SubscriptionFormOptionCreateFormInputEntityRelationInput"];
	["SubscriptionFormInputWithoutOptionsCreateInput"]: GraphQLTypes["SubscriptionFormInputWithoutOptionsCreateInput"];
	["SubscriptionFormInputCreateSectionEntityRelationInput"]: GraphQLTypes["SubscriptionFormInputCreateSectionEntityRelationInput"];
	["SubscriptionFormSectionWithoutInputsCreateInput"]: GraphQLTypes["SubscriptionFormSectionWithoutInputsCreateInput"];
	["SubscriptionFormSectionCreateFormEntityRelationInput"]: GraphQLTypes["SubscriptionFormSectionCreateFormEntityRelationInput"];
	["SubscriptionFormWithoutSectionsCreateInput"]: GraphQLTypes["SubscriptionFormWithoutSectionsCreateInput"];
	["IssueCreateCoverPhotoEntityRelationInput"]: GraphQLTypes["IssueCreateCoverPhotoEntityRelationInput"];
	["IssueCreatePrintTargetEntityRelationInput"]: GraphQLTypes["IssueCreatePrintTargetEntityRelationInput"];
	["IssueCreateBackgroundPhotoEntityRelationInput"]: GraphQLTypes["IssueCreateBackgroundPhotoEntityRelationInput"];
	["ContentReferenceCreateSubscriptionFormEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateSubscriptionFormEntityRelationInput"];
	["SubscriptionFormWithoutContentReferencesCreateInput"]: GraphQLTypes["SubscriptionFormWithoutContentReferencesCreateInput"];
	["ArticleUpdateInput"]: GraphQLTypes["ArticleUpdateInput"];
	["ArticleUpdateUrlEntityRelationInput"]: GraphQLTypes["ArticleUpdateUrlEntityRelationInput"];
	["UrlWithoutArticleUpdateInput"]: GraphQLTypes["UrlWithoutArticleUpdateInput"];
	["UrlUpdateAuthorEntityRelationInput"]: GraphQLTypes["UrlUpdateAuthorEntityRelationInput"];
	["AuthorWithoutUrlUpdateInput"]: GraphQLTypes["AuthorWithoutUrlUpdateInput"];
	["AuthorUpdateAboutEntityRelationInput"]: GraphQLTypes["AuthorUpdateAboutEntityRelationInput"];
	["ContentUpdateInput"]: GraphQLTypes["ContentUpdateInput"];
	["ContentUpdatePartsEntityRelationInput"]: GraphQLTypes["ContentUpdatePartsEntityRelationInput"];
	["ContentUpdatePartsRelationInput"]: GraphQLTypes["ContentUpdatePartsRelationInput"];
	["ContentPartWithoutContentUpdateInput"]: GraphQLTypes["ContentPartWithoutContentUpdateInput"];
	["ContentPartUpdateReferencesEntityRelationInput"]: GraphQLTypes["ContentPartUpdateReferencesEntityRelationInput"];
	["ContentPartUpdateReferencesRelationInput"]: GraphQLTypes["ContentPartUpdateReferencesRelationInput"];
	["ContentReferenceWithoutContentPartUpdateInput"]: GraphQLTypes["ContentReferenceWithoutContentPartUpdateInput"];
	["ContentReferenceUpdateEmbedEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateEmbedEntityRelationInput"];
	["EmbedUpdateInput"]: GraphQLTypes["EmbedUpdateInput"];
	["ContentReferenceUpsertEmbedRelationInput"]: GraphQLTypes["ContentReferenceUpsertEmbedRelationInput"];
	["ContentReferenceUpdateArticleEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateArticleEntityRelationInput"];
	["ContentReferenceUpsertArticleRelationInput"]: GraphQLTypes["ContentReferenceUpsertArticleRelationInput"];
	["ContentReferenceUpdateAudioEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateAudioEntityRelationInput"];
	["AudioUseUpdateInput"]: GraphQLTypes["AudioUseUpdateInput"];
	["AudioUseUpdateAudioEntityRelationInput"]: GraphQLTypes["AudioUseUpdateAudioEntityRelationInput"];
	["AudioWithoutUsesUpdateInput"]: GraphQLTypes["AudioWithoutUsesUpdateInput"];
	["AudioUpdateAuthorEntityRelationInput"]: GraphQLTypes["AudioUpdateAuthorEntityRelationInput"];
	["AuthorUpdateInput"]: GraphQLTypes["AuthorUpdateInput"];
	["AuthorUpdateTopArticlesEntityRelationInput"]: GraphQLTypes["AuthorUpdateTopArticlesEntityRelationInput"];
	["AuthorUpdateTopArticlesRelationInput"]: GraphQLTypes["AuthorUpdateTopArticlesRelationInput"];
	["AuthorTopArticleWithoutAuthorUpdateInput"]: GraphQLTypes["AuthorTopArticleWithoutAuthorUpdateInput"];
	["AuthorTopArticleUpdateArticleEntityRelationInput"]: GraphQLTypes["AuthorTopArticleUpdateArticleEntityRelationInput"];
	["AuthorTopArticleUpsertArticleRelationInput"]: GraphQLTypes["AuthorTopArticleUpsertArticleRelationInput"];
	["AuthorUpsertTopArticlesRelationInput"]: GraphQLTypes["AuthorUpsertTopArticlesRelationInput"];
	["AuthorUpdateUsersEntityRelationInput"]: GraphQLTypes["AuthorUpdateUsersEntityRelationInput"];
	["AuthorUpdateUsersRelationInput"]: GraphQLTypes["AuthorUpdateUsersRelationInput"];
	["UserWithoutAuthorsUpdateInput"]: GraphQLTypes["UserWithoutAuthorsUpdateInput"];
	["UserUpdateUnlockedArticlesEntityRelationInput"]: GraphQLTypes["UserUpdateUnlockedArticlesEntityRelationInput"];
	["UserUpdateUnlockedArticlesRelationInput"]: GraphQLTypes["UserUpdateUnlockedArticlesRelationInput"];
	["UnlockedArticleWithoutUserUpdateInput"]: GraphQLTypes["UnlockedArticleWithoutUserUpdateInput"];
	["UnlockedArticleUpdateArticleEntityRelationInput"]: GraphQLTypes["UnlockedArticleUpdateArticleEntityRelationInput"];
	["ArticleWithoutUnlockedUpdateInput"]: GraphQLTypes["ArticleWithoutUnlockedUpdateInput"];
	["ArticleUpdateAuthorsEntityRelationInput"]: GraphQLTypes["ArticleUpdateAuthorsEntityRelationInput"];
	["ArticleUpdateAuthorsRelationInput"]: GraphQLTypes["ArticleUpdateAuthorsRelationInput"];
	["ArticleAuthorWithoutArticleUpdateInput"]: GraphQLTypes["ArticleAuthorWithoutArticleUpdateInput"];
	["ArticleAuthorUpdateAuthorEntityRelationInput"]: GraphQLTypes["ArticleAuthorUpdateAuthorEntityRelationInput"];
	["ArticleAuthorUpsertAuthorRelationInput"]: GraphQLTypes["ArticleAuthorUpsertAuthorRelationInput"];
	["ArticleUpsertAuthorsRelationInput"]: GraphQLTypes["ArticleUpsertAuthorsRelationInput"];
	["ArticleUpdateSubtitleEntityRelationInput"]: GraphQLTypes["ArticleUpdateSubtitleEntityRelationInput"];
	["TextContentUpdateInput"]: GraphQLTypes["TextContentUpdateInput"];
	["TextContentUpdatePartsEntityRelationInput"]: GraphQLTypes["TextContentUpdatePartsEntityRelationInput"];
	["TextContentUpdatePartsRelationInput"]: GraphQLTypes["TextContentUpdatePartsRelationInput"];
	["TextContentPartWithoutContentUpdateInput"]: GraphQLTypes["TextContentPartWithoutContentUpdateInput"];
	["TextContentPartUpdateReferencesEntityRelationInput"]: GraphQLTypes["TextContentPartUpdateReferencesEntityRelationInput"];
	["TextContentPartUpdateReferencesRelationInput"]: GraphQLTypes["TextContentPartUpdateReferencesRelationInput"];
	["TextContentReferenceWithoutContentPartUpdateInput"]: GraphQLTypes["TextContentReferenceWithoutContentPartUpdateInput"];
	["TextContentReferenceUpdateTargetEntityRelationInput"]: GraphQLTypes["TextContentReferenceUpdateTargetEntityRelationInput"];
	["LinkUpdateInput"]: GraphQLTypes["LinkUpdateInput"];
	["LinkUpdateInternalTargetEntityRelationInput"]: GraphQLTypes["LinkUpdateInternalTargetEntityRelationInput"];
	["UrlUpdateInput"]: GraphQLTypes["UrlUpdateInput"];
	["UrlUpdateArticleEntityRelationInput"]: GraphQLTypes["UrlUpdateArticleEntityRelationInput"];
	["ArticleWithoutUrlUpdateInput"]: GraphQLTypes["ArticleWithoutUrlUpdateInput"];
	["ArticleUpdateContentEntityRelationInput"]: GraphQLTypes["ArticleUpdateContentEntityRelationInput"];
	["ArticleUpsertContentRelationInput"]: GraphQLTypes["ArticleUpsertContentRelationInput"];
	["ArticleUpdateCoverPhotoEntityRelationInput"]: GraphQLTypes["ArticleUpdateCoverPhotoEntityRelationInput"];
	["ImageUseUpdateInput"]: GraphQLTypes["ImageUseUpdateInput"];
	["ImageUseUpdateImageEntityRelationInput"]: GraphQLTypes["ImageUseUpdateImageEntityRelationInput"];
	["ImageWithoutUsesUpdateInput"]: GraphQLTypes["ImageWithoutUsesUpdateInput"];
	["ImageUpdateAuthorEntityRelationInput"]: GraphQLTypes["ImageUpdateAuthorEntityRelationInput"];
	["ImageUpsertAuthorRelationInput"]: GraphQLTypes["ImageUpsertAuthorRelationInput"];
	["ImageUpdateTagsEntityRelationInput"]: GraphQLTypes["ImageUpdateTagsEntityRelationInput"];
	["ImageUpdateTagsRelationInput"]: GraphQLTypes["ImageUpdateTagsRelationInput"];
	["ImageTagWithoutImagesUpdateInput"]: GraphQLTypes["ImageTagWithoutImagesUpdateInput"];
	["ImageUpsertTagsRelationInput"]: GraphQLTypes["ImageUpsertTagsRelationInput"];
	["ImageUseUpsertImageRelationInput"]: GraphQLTypes["ImageUseUpsertImageRelationInput"];
	["ArticleUpsertCoverPhotoRelationInput"]: GraphQLTypes["ArticleUpsertCoverPhotoRelationInput"];
	["ArticleUpdatePreviewContentEntityRelationInput"]: GraphQLTypes["ArticleUpdatePreviewContentEntityRelationInput"];
	["ArticleUpsertPreviewContentRelationInput"]: GraphQLTypes["ArticleUpsertPreviewContentRelationInput"];
	["ArticleUpdateAudioEntityRelationInput"]: GraphQLTypes["ArticleUpdateAudioEntityRelationInput"];
	["ArticleUpsertAudioRelationInput"]: GraphQLTypes["ArticleUpsertAudioRelationInput"];
	["ArticleUpdateCategoriesEntityRelationInput"]: GraphQLTypes["ArticleUpdateCategoriesEntityRelationInput"];
	["ArticleUpdateCategoriesRelationInput"]: GraphQLTypes["ArticleUpdateCategoriesRelationInput"];
	["ArticleCategoryWithoutArticleUpdateInput"]: GraphQLTypes["ArticleCategoryWithoutArticleUpdateInput"];
	["ArticleCategoryUpdateCategoryEntityRelationInput"]: GraphQLTypes["ArticleCategoryUpdateCategoryEntityRelationInput"];
	["CategoryWithoutArticleCategoryUpdateInput"]: GraphQLTypes["CategoryWithoutArticleCategoryUpdateInput"];
	["CategoryUpdateUrlEntityRelationInput"]: GraphQLTypes["CategoryUpdateUrlEntityRelationInput"];
	["UrlWithoutCategoryUpdateInput"]: GraphQLTypes["UrlWithoutCategoryUpdateInput"];
	["UrlUpdateIssueEntityRelationInput"]: GraphQLTypes["UrlUpdateIssueEntityRelationInput"];
	["IssueWithoutUrlUpdateInput"]: GraphQLTypes["IssueWithoutUrlUpdateInput"];
	["IssueUpdateArticlesEntityRelationInput"]: GraphQLTypes["IssueUpdateArticlesEntityRelationInput"];
	["IssueUpdateArticlesRelationInput"]: GraphQLTypes["IssueUpdateArticlesRelationInput"];
	["IssueArticleWithoutIssueUpdateInput"]: GraphQLTypes["IssueArticleWithoutIssueUpdateInput"];
	["IssueArticleUpdateArticleEntityRelationInput"]: GraphQLTypes["IssueArticleUpdateArticleEntityRelationInput"];
	["ArticleWithoutIssuesUpdateInput"]: GraphQLTypes["ArticleWithoutIssuesUpdateInput"];
	["ArticleUpdateContentBlocksEntityRelationInput"]: GraphQLTypes["ArticleUpdateContentBlocksEntityRelationInput"];
	["ArticleUpdateContentBlocksRelationInput"]: GraphQLTypes["ArticleUpdateContentBlocksRelationInput"];
	["ContentArticleWithoutArticleUpdateInput"]: GraphQLTypes["ContentArticleWithoutArticleUpdateInput"];
	["ContentArticleUpdateContentBlockEntityRelationInput"]: GraphQLTypes["ContentArticleUpdateContentBlockEntityRelationInput"];
	["ContentBlockWithoutArticlesUpdateInput"]: GraphQLTypes["ContentBlockWithoutArticlesUpdateInput"];
	["ContentBlockUpdateIssueEntityRelationInput"]: GraphQLTypes["ContentBlockUpdateIssueEntityRelationInput"];
	["IssueWithoutBlocksUpdateInput"]: GraphQLTypes["IssueWithoutBlocksUpdateInput"];
	["IssueUpdateUrlEntityRelationInput"]: GraphQLTypes["IssueUpdateUrlEntityRelationInput"];
	["UrlWithoutIssueUpdateInput"]: GraphQLTypes["UrlWithoutIssueUpdateInput"];
	["UrlUpdatePageEntityRelationInput"]: GraphQLTypes["UrlUpdatePageEntityRelationInput"];
	["PageWithoutUrlUpdateInput"]: GraphQLTypes["PageWithoutUrlUpdateInput"];
	["PageUpdateContentEntityRelationInput"]: GraphQLTypes["PageUpdateContentEntityRelationInput"];
	["PageUpsertContentRelationInput"]: GraphQLTypes["PageUpsertContentRelationInput"];
	["PageUpdateSeoEntityRelationInput"]: GraphQLTypes["PageUpdateSeoEntityRelationInput"];
	["SeoWithoutPageUpdateInput"]: GraphQLTypes["SeoWithoutPageUpdateInput"];
	["SeoUpdateOgImageEntityRelationInput"]: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"];
	["SeoUpsertOgImageRelationInput"]: GraphQLTypes["SeoUpsertOgImageRelationInput"];
	["PageUpsertSeoRelationInput"]: GraphQLTypes["PageUpsertSeoRelationInput"];
	["UrlUpsertPageRelationInput"]: GraphQLTypes["UrlUpsertPageRelationInput"];
	["UrlUpdateCategoryEntityRelationInput"]: GraphQLTypes["UrlUpdateCategoryEntityRelationInput"];
	["CategoryWithoutUrlUpdateInput"]: GraphQLTypes["CategoryWithoutUrlUpdateInput"];
	["CategoryUpdateArticleCategoryEntityRelationInput"]: GraphQLTypes["CategoryUpdateArticleCategoryEntityRelationInput"];
	["CategoryUpdateArticleCategoryRelationInput"]: GraphQLTypes["CategoryUpdateArticleCategoryRelationInput"];
	["ArticleCategoryWithoutCategoryUpdateInput"]: GraphQLTypes["ArticleCategoryWithoutCategoryUpdateInput"];
	["ArticleCategoryUpdateArticleEntityRelationInput"]: GraphQLTypes["ArticleCategoryUpdateArticleEntityRelationInput"];
	["ArticleWithoutCategoriesUpdateInput"]: GraphQLTypes["ArticleWithoutCategoriesUpdateInput"];
	["ArticleUpdateIssuesEntityRelationInput"]: GraphQLTypes["ArticleUpdateIssuesEntityRelationInput"];
	["ArticleUpdateIssuesRelationInput"]: GraphQLTypes["ArticleUpdateIssuesRelationInput"];
	["IssueArticleWithoutArticleUpdateInput"]: GraphQLTypes["IssueArticleWithoutArticleUpdateInput"];
	["IssueArticleUpdateIssueEntityRelationInput"]: GraphQLTypes["IssueArticleUpdateIssueEntityRelationInput"];
	["IssueWithoutArticlesUpdateInput"]: GraphQLTypes["IssueWithoutArticlesUpdateInput"];
	["IssueUpdatePdfEntityRelationInput"]: GraphQLTypes["IssueUpdatePdfEntityRelationInput"];
	["FileUseUpdateInput"]: GraphQLTypes["FileUseUpdateInput"];
	["FileUseUpdateFileEntityRelationInput"]: GraphQLTypes["FileUseUpdateFileEntityRelationInput"];
	["FileWithoutUsesUpdateInput"]: GraphQLTypes["FileWithoutUsesUpdateInput"];
	["FileUseUpsertFileRelationInput"]: GraphQLTypes["FileUseUpsertFileRelationInput"];
	["IssueUpsertPdfRelationInput"]: GraphQLTypes["IssueUpsertPdfRelationInput"];
	["IssueUpdateBlocksEntityRelationInput"]: GraphQLTypes["IssueUpdateBlocksEntityRelationInput"];
	["IssueUpdateBlocksRelationInput"]: GraphQLTypes["IssueUpdateBlocksRelationInput"];
	["ContentBlockWithoutIssueUpdateInput"]: GraphQLTypes["ContentBlockWithoutIssueUpdateInput"];
	["ContentBlockUpdateTargetEntityRelationInput"]: GraphQLTypes["ContentBlockUpdateTargetEntityRelationInput"];
	["ContentBlockUpsertTargetRelationInput"]: GraphQLTypes["ContentBlockUpsertTargetRelationInput"];
	["ContentBlockUpdateArticlesEntityRelationInput"]: GraphQLTypes["ContentBlockUpdateArticlesEntityRelationInput"];
	["ContentBlockUpdateArticlesRelationInput"]: GraphQLTypes["ContentBlockUpdateArticlesRelationInput"];
	["ContentArticleWithoutContentBlockUpdateInput"]: GraphQLTypes["ContentArticleWithoutContentBlockUpdateInput"];
	["ContentArticleUpdateArticleEntityRelationInput"]: GraphQLTypes["ContentArticleUpdateArticleEntityRelationInput"];
	["ArticleWithoutContentBlocksUpdateInput"]: GraphQLTypes["ArticleWithoutContentBlocksUpdateInput"];
	["ArticleUpdateUnlockedEntityRelationInput"]: GraphQLTypes["ArticleUpdateUnlockedEntityRelationInput"];
	["ArticleUpdateUnlockedRelationInput"]: GraphQLTypes["ArticleUpdateUnlockedRelationInput"];
	["UnlockedArticleWithoutArticleUpdateInput"]: GraphQLTypes["UnlockedArticleWithoutArticleUpdateInput"];
	["UnlockedArticleUpdateUserEntityRelationInput"]: GraphQLTypes["UnlockedArticleUpdateUserEntityRelationInput"];
	["UserWithoutUnlockedArticlesUpdateInput"]: GraphQLTypes["UserWithoutUnlockedArticlesUpdateInput"];
	["UserUpdateAuthorsEntityRelationInput"]: GraphQLTypes["UserUpdateAuthorsEntityRelationInput"];
	["UserUpdateAuthorsRelationInput"]: GraphQLTypes["UserUpdateAuthorsRelationInput"];
	["AuthorWithoutUsersUpdateInput"]: GraphQLTypes["AuthorWithoutUsersUpdateInput"];
	["AuthorUpdatePhotoEntityRelationInput"]: GraphQLTypes["AuthorUpdatePhotoEntityRelationInput"];
	["AuthorUpsertPhotoRelationInput"]: GraphQLTypes["AuthorUpsertPhotoRelationInput"];
	["AuthorUpdateIllustrationEntityRelationInput"]: GraphQLTypes["AuthorUpdateIllustrationEntityRelationInput"];
	["AuthorUpsertIllustrationRelationInput"]: GraphQLTypes["AuthorUpsertIllustrationRelationInput"];
	["AuthorUpdateUrlEntityRelationInput"]: GraphQLTypes["AuthorUpdateUrlEntityRelationInput"];
	["UrlWithoutAuthorUpdateInput"]: GraphQLTypes["UrlWithoutAuthorUpdateInput"];
	["UrlUpdateTagEntityRelationInput"]: GraphQLTypes["UrlUpdateTagEntityRelationInput"];
	["TagWithoutUrlUpdateInput"]: GraphQLTypes["TagWithoutUrlUpdateInput"];
	["TagUpdateArticleTagEntityRelationInput"]: GraphQLTypes["TagUpdateArticleTagEntityRelationInput"];
	["TagUpdateArticleTagRelationInput"]: GraphQLTypes["TagUpdateArticleTagRelationInput"];
	["ArticleTagWithoutTagUpdateInput"]: GraphQLTypes["ArticleTagWithoutTagUpdateInput"];
	["ArticleTagUpdateArticleEntityRelationInput"]: GraphQLTypes["ArticleTagUpdateArticleEntityRelationInput"];
	["ArticleWithoutTagsUpdateInput"]: GraphQLTypes["ArticleWithoutTagsUpdateInput"];
	["ArticleUpdateCoverPhotoVerticalEntityRelationInput"]: GraphQLTypes["ArticleUpdateCoverPhotoVerticalEntityRelationInput"];
	["ArticleUpsertCoverPhotoVerticalRelationInput"]: GraphQLTypes["ArticleUpsertCoverPhotoVerticalRelationInput"];
	["ArticleUpdateHistoryTagsEntityRelationInput"]: GraphQLTypes["ArticleUpdateHistoryTagsEntityRelationInput"];
	["ArticleUpdateHistoryTagsRelationInput"]: GraphQLTypes["ArticleUpdateHistoryTagsRelationInput"];
	["ArticleHistoryTagWithoutArticleUpdateInput"]: GraphQLTypes["ArticleHistoryTagWithoutArticleUpdateInput"];
	["ArticleHistoryTagUpdateHistoryTagEntityRelationInput"]: GraphQLTypes["ArticleHistoryTagUpdateHistoryTagEntityRelationInput"];
	["HistoryTagWithoutArticleHistoryTagUpdateInput"]: GraphQLTypes["HistoryTagWithoutArticleHistoryTagUpdateInput"];
	["ArticleHistoryTagUpsertHistoryTagRelationInput"]: GraphQLTypes["ArticleHistoryTagUpsertHistoryTagRelationInput"];
	["ArticleUpsertHistoryTagsRelationInput"]: GraphQLTypes["ArticleUpsertHistoryTagsRelationInput"];
	["ArticleUpdateHistoryPeriodsEntityRelationInput"]: GraphQLTypes["ArticleUpdateHistoryPeriodsEntityRelationInput"];
	["ArticleUpdateHistoryPeriodsRelationInput"]: GraphQLTypes["ArticleUpdateHistoryPeriodsRelationInput"];
	["ArticleHistoryPeriodWithoutArticleUpdateInput"]: GraphQLTypes["ArticleHistoryPeriodWithoutArticleUpdateInput"];
	["ArticleHistoryPeriodUpdateHistoryPeriodEntityRelationInput"]: GraphQLTypes["ArticleHistoryPeriodUpdateHistoryPeriodEntityRelationInput"];
	["HistoryPeriodWithoutArticleHistoryPeriodUpdateInput"]: GraphQLTypes["HistoryPeriodWithoutArticleHistoryPeriodUpdateInput"];
	["HistoryPeriodUpdateCoverEntityRelationInput"]: GraphQLTypes["HistoryPeriodUpdateCoverEntityRelationInput"];
	["HistoryCoverUpdateInput"]: GraphQLTypes["HistoryCoverUpdateInput"];
	["HistoryCoverUpdateCoverImageEntityRelationInput"]: GraphQLTypes["HistoryCoverUpdateCoverImageEntityRelationInput"];
	["HistoryCoverUpsertCoverImageRelationInput"]: GraphQLTypes["HistoryCoverUpsertCoverImageRelationInput"];
	["HistoryCoverUpdateTileImageEntityRelationInput"]: GraphQLTypes["HistoryCoverUpdateTileImageEntityRelationInput"];
	["HistoryCoverUpsertTileImageRelationInput"]: GraphQLTypes["HistoryCoverUpsertTileImageRelationInput"];
	["HistoryCoverUpdateMobileImageEntityRelationInput"]: GraphQLTypes["HistoryCoverUpdateMobileImageEntityRelationInput"];
	["HistoryCoverUpsertMobileImageRelationInput"]: GraphQLTypes["HistoryCoverUpsertMobileImageRelationInput"];
	["HistoryCoverUpdateLeadContentEntityRelationInput"]: GraphQLTypes["HistoryCoverUpdateLeadContentEntityRelationInput"];
	["HistoryCoverUpsertLeadContentRelationInput"]: GraphQLTypes["HistoryCoverUpsertLeadContentRelationInput"];
	["HistoryCoverUpdateAnnotationsEntityRelationInput"]: GraphQLTypes["HistoryCoverUpdateAnnotationsEntityRelationInput"];
	["HistoryTextListUpdateInput"]: GraphQLTypes["HistoryTextListUpdateInput"];
	["HistoryTextListUpdateItemsEntityRelationInput"]: GraphQLTypes["HistoryTextListUpdateItemsEntityRelationInput"];
	["HistoryTextListUpdateItemsRelationInput"]: GraphQLTypes["HistoryTextListUpdateItemsRelationInput"];
	["HistoryTextItemWithoutListUpdateInput"]: GraphQLTypes["HistoryTextItemWithoutListUpdateInput"];
	["HistoryTextItemUpdateImageEntityRelationInput"]: GraphQLTypes["HistoryTextItemUpdateImageEntityRelationInput"];
	["HistoryTextItemUpsertImageRelationInput"]: GraphQLTypes["HistoryTextItemUpsertImageRelationInput"];
	["HistoryTextListUpsertItemsRelationInput"]: GraphQLTypes["HistoryTextListUpsertItemsRelationInput"];
	["HistoryCoverUpsertAnnotationsRelationInput"]: GraphQLTypes["HistoryCoverUpsertAnnotationsRelationInput"];
	["HistoryPeriodUpsertCoverRelationInput"]: GraphQLTypes["HistoryPeriodUpsertCoverRelationInput"];
	["HistoryPeriodUpdateSeoEntityRelationInput"]: GraphQLTypes["HistoryPeriodUpdateSeoEntityRelationInput"];
	["SeoUpdateInput"]: GraphQLTypes["SeoUpdateInput"];
	["SeoUpdatePageEntityRelationInput"]: GraphQLTypes["SeoUpdatePageEntityRelationInput"];
	["PageWithoutSeoUpdateInput"]: GraphQLTypes["PageWithoutSeoUpdateInput"];
	["PageUpdateUrlEntityRelationInput"]: GraphQLTypes["PageUpdateUrlEntityRelationInput"];
	["UrlWithoutPageUpdateInput"]: GraphQLTypes["UrlWithoutPageUpdateInput"];
	["PageUpsertUrlRelationInput"]: GraphQLTypes["PageUpsertUrlRelationInput"];
	["SeoUpsertPageRelationInput"]: GraphQLTypes["SeoUpsertPageRelationInput"];
	["HistoryPeriodUpsertSeoRelationInput"]: GraphQLTypes["HistoryPeriodUpsertSeoRelationInput"];
	["ArticleHistoryPeriodUpsertHistoryPeriodRelationInput"]: GraphQLTypes["ArticleHistoryPeriodUpsertHistoryPeriodRelationInput"];
	["ArticleUpsertHistoryPeriodsRelationInput"]: GraphQLTypes["ArticleUpsertHistoryPeriodsRelationInput"];
	["ArticleTagUpsertArticleRelationInput"]: GraphQLTypes["ArticleTagUpsertArticleRelationInput"];
	["TagUpsertArticleTagRelationInput"]: GraphQLTypes["TagUpsertArticleTagRelationInput"];
	["UrlUpsertTagRelationInput"]: GraphQLTypes["UrlUpsertTagRelationInput"];
	["AuthorUpsertUrlRelationInput"]: GraphQLTypes["AuthorUpsertUrlRelationInput"];
	["UserUpsertAuthorsRelationInput"]: GraphQLTypes["UserUpsertAuthorsRelationInput"];
	["UserUpdateAppReviewsEntityRelationInput"]: GraphQLTypes["UserUpdateAppReviewsEntityRelationInput"];
	["UserUpdateAppReviewsRelationInput"]: GraphQLTypes["UserUpdateAppReviewsRelationInput"];
	["AppReviewWithoutUserUpdateInput"]: GraphQLTypes["AppReviewWithoutUserUpdateInput"];
	["UserUpsertAppReviewsRelationInput"]: GraphQLTypes["UserUpsertAppReviewsRelationInput"];
	["UnlockedArticleUpsertUserRelationInput"]: GraphQLTypes["UnlockedArticleUpsertUserRelationInput"];
	["ArticleUpsertUnlockedRelationInput"]: GraphQLTypes["ArticleUpsertUnlockedRelationInput"];
	["ArticleUpdateTagsEntityRelationInput"]: GraphQLTypes["ArticleUpdateTagsEntityRelationInput"];
	["ArticleUpdateTagsRelationInput"]: GraphQLTypes["ArticleUpdateTagsRelationInput"];
	["ArticleTagWithoutArticleUpdateInput"]: GraphQLTypes["ArticleTagWithoutArticleUpdateInput"];
	["ArticleTagUpdateTagEntityRelationInput"]: GraphQLTypes["ArticleTagUpdateTagEntityRelationInput"];
	["TagWithoutArticleTagUpdateInput"]: GraphQLTypes["TagWithoutArticleTagUpdateInput"];
	["TagUpdateUrlEntityRelationInput"]: GraphQLTypes["TagUpdateUrlEntityRelationInput"];
	["UrlWithoutTagUpdateInput"]: GraphQLTypes["UrlWithoutTagUpdateInput"];
	["TagUpsertUrlRelationInput"]: GraphQLTypes["TagUpsertUrlRelationInput"];
	["ArticleTagUpsertTagRelationInput"]: GraphQLTypes["ArticleTagUpsertTagRelationInput"];
	["ArticleUpsertTagsRelationInput"]: GraphQLTypes["ArticleUpsertTagsRelationInput"];
	["ContentArticleUpsertArticleRelationInput"]: GraphQLTypes["ContentArticleUpsertArticleRelationInput"];
	["ContentBlockUpsertArticlesRelationInput"]: GraphQLTypes["ContentBlockUpsertArticlesRelationInput"];
	["ContentBlockUpdateSubscriptionFormEntityRelationInput"]: GraphQLTypes["ContentBlockUpdateSubscriptionFormEntityRelationInput"];
	["SubscriptionFormWithoutContentBlockUpdateInput"]: GraphQLTypes["SubscriptionFormWithoutContentBlockUpdateInput"];
	["SubscriptionFormUpdateSectionsEntityRelationInput"]: GraphQLTypes["SubscriptionFormUpdateSectionsEntityRelationInput"];
	["SubscriptionFormUpdateSectionsRelationInput"]: GraphQLTypes["SubscriptionFormUpdateSectionsRelationInput"];
	["SubscriptionFormSectionWithoutFormUpdateInput"]: GraphQLTypes["SubscriptionFormSectionWithoutFormUpdateInput"];
	["SubscriptionFormSectionUpdateInputsEntityRelationInput"]: GraphQLTypes["SubscriptionFormSectionUpdateInputsEntityRelationInput"];
	["SubscriptionFormSectionUpdateInputsRelationInput"]: GraphQLTypes["SubscriptionFormSectionUpdateInputsRelationInput"];
	["SubscriptionFormInputWithoutSectionUpdateInput"]: GraphQLTypes["SubscriptionFormInputWithoutSectionUpdateInput"];
	["SubscriptionFormInputUpdateImageEntityRelationInput"]: GraphQLTypes["SubscriptionFormInputUpdateImageEntityRelationInput"];
	["SubscriptionFormInputUpsertImageRelationInput"]: GraphQLTypes["SubscriptionFormInputUpsertImageRelationInput"];
	["SubscriptionFormInputUpdateOptionsEntityRelationInput"]: GraphQLTypes["SubscriptionFormInputUpdateOptionsEntityRelationInput"];
	["SubscriptionFormInputUpdateOptionsRelationInput"]: GraphQLTypes["SubscriptionFormInputUpdateOptionsRelationInput"];
	["SubscriptionFormOptionWithoutFormInputUpdateInput"]: GraphQLTypes["SubscriptionFormOptionWithoutFormInputUpdateInput"];
	["SubscriptionFormOptionUpdateProductsEntityRelationInput"]: GraphQLTypes["SubscriptionFormOptionUpdateProductsEntityRelationInput"];
	["SubscriptionFormOptionUpdateProductsRelationInput"]: GraphQLTypes["SubscriptionFormOptionUpdateProductsRelationInput"];
	["ProductWithoutFormOptionsUpdateInput"]: GraphQLTypes["ProductWithoutFormOptionsUpdateInput"];
	["ProductUpdateFormEntityRelationInput"]: GraphQLTypes["ProductUpdateFormEntityRelationInput"];
	["SubscriptionFormWithoutProductsUpdateInput"]: GraphQLTypes["SubscriptionFormWithoutProductsUpdateInput"];
	["SubscriptionFormUpdateContentBlockEntityRelationInput"]: GraphQLTypes["SubscriptionFormUpdateContentBlockEntityRelationInput"];
	["SubscriptionFormUpdateContentBlockRelationInput"]: GraphQLTypes["SubscriptionFormUpdateContentBlockRelationInput"];
	["ContentBlockWithoutSubscriptionFormUpdateInput"]: GraphQLTypes["ContentBlockWithoutSubscriptionFormUpdateInput"];
	["SubscriptionFormUpsertContentBlockRelationInput"]: GraphQLTypes["SubscriptionFormUpsertContentBlockRelationInput"];
	["SubscriptionFormUpdateContentReferencesEntityRelationInput"]: GraphQLTypes["SubscriptionFormUpdateContentReferencesEntityRelationInput"];
	["SubscriptionFormUpdateContentReferencesRelationInput"]: GraphQLTypes["SubscriptionFormUpdateContentReferencesRelationInput"];
	["ContentReferenceWithoutSubscriptionFormUpdateInput"]: GraphQLTypes["ContentReferenceWithoutSubscriptionFormUpdateInput"];
	["ContentReferenceUpdateContentPartEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateContentPartEntityRelationInput"];
	["ContentPartWithoutReferencesUpdateInput"]: GraphQLTypes["ContentPartWithoutReferencesUpdateInput"];
	["ContentPartUpdateContentEntityRelationInput"]: GraphQLTypes["ContentPartUpdateContentEntityRelationInput"];
	["ContentWithoutPartsUpdateInput"]: GraphQLTypes["ContentWithoutPartsUpdateInput"];
	["ContentPartUpsertContentRelationInput"]: GraphQLTypes["ContentPartUpsertContentRelationInput"];
	["ContentReferenceUpsertContentPartRelationInput"]: GraphQLTypes["ContentReferenceUpsertContentPartRelationInput"];
	["ContentReferenceUpdateImageEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"];
	["ContentReferenceUpsertImageRelationInput"]: GraphQLTypes["ContentReferenceUpsertImageRelationInput"];
	["ContentReferenceUpdateImagesEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateImagesEntityRelationInput"];
	["ContentReferenceUpdateImagesRelationInput"]: GraphQLTypes["ContentReferenceUpdateImagesRelationInput"];
	["ImageContentWithoutContentReferenceUpdateInput"]: GraphQLTypes["ImageContentWithoutContentReferenceUpdateInput"];
	["ImageContentUpdateImageEntityRelationInput"]: GraphQLTypes["ImageContentUpdateImageEntityRelationInput"];
	["ImageContentUpsertImageRelationInput"]: GraphQLTypes["ImageContentUpsertImageRelationInput"];
	["ContentReferenceUpsertImagesRelationInput"]: GraphQLTypes["ContentReferenceUpsertImagesRelationInput"];
	["ContentReferenceUpdatePollAnswerEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdatePollAnswerEntityRelationInput"];
	["PollAnswerUpdateInput"]: GraphQLTypes["PollAnswerUpdateInput"];
	["PollAnswerUpdateAuthorImageEntityRelationInput"]: GraphQLTypes["PollAnswerUpdateAuthorImageEntityRelationInput"];
	["PollAnswerUpsertAuthorImageRelationInput"]: GraphQLTypes["PollAnswerUpsertAuthorImageRelationInput"];
	["ContentReferenceUpsertPollAnswerRelationInput"]: GraphQLTypes["ContentReferenceUpsertPollAnswerRelationInput"];
	["ContentReferenceUpdateListicleEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateListicleEntityRelationInput"];
	["ContentReferenceUpdateListicleRelationInput"]: GraphQLTypes["ContentReferenceUpdateListicleRelationInput"];
	["ListicleWithoutContentReferenceUpdateInput"]: GraphQLTypes["ListicleWithoutContentReferenceUpdateInput"];
	["ListicleUpdateImageEntityRelationInput"]: GraphQLTypes["ListicleUpdateImageEntityRelationInput"];
	["ListicleUpsertImageRelationInput"]: GraphQLTypes["ListicleUpsertImageRelationInput"];
	["ListicleUpdateTargetEntityRelationInput"]: GraphQLTypes["ListicleUpdateTargetEntityRelationInput"];
	["ListicleUpsertTargetRelationInput"]: GraphQLTypes["ListicleUpsertTargetRelationInput"];
	["ListicleUpdateContentEntityRelationInput"]: GraphQLTypes["ListicleUpdateContentEntityRelationInput"];
	["ListicleUpsertContentRelationInput"]: GraphQLTypes["ListicleUpsertContentRelationInput"];
	["ContentReferenceUpsertListicleRelationInput"]: GraphQLTypes["ContentReferenceUpsertListicleRelationInput"];
	["ContentReferenceUpdateFaqEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateFaqEntityRelationInput"];
	["ContentReferenceUpdateFaqRelationInput"]: GraphQLTypes["ContentReferenceUpdateFaqRelationInput"];
	["FAQWithoutContentReferenceUpdateInput"]: GraphQLTypes["FAQWithoutContentReferenceUpdateInput"];
	["ContentReferenceUpsertFaqRelationInput"]: GraphQLTypes["ContentReferenceUpsertFaqRelationInput"];
	["ContentReferenceUpdateLinksEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateLinksEntityRelationInput"];
	["ContentReferenceUpdateLinksRelationInput"]: GraphQLTypes["ContentReferenceUpdateLinksRelationInput"];
	["LinkContentWithoutContentReferenceUpdateInput"]: GraphQLTypes["LinkContentWithoutContentReferenceUpdateInput"];
	["LinkContentUpdateTargetEntityRelationInput"]: GraphQLTypes["LinkContentUpdateTargetEntityRelationInput"];
	["LinkContentUpsertTargetRelationInput"]: GraphQLTypes["LinkContentUpsertTargetRelationInput"];
	["ContentReferenceUpsertLinksRelationInput"]: GraphQLTypes["ContentReferenceUpsertLinksRelationInput"];
	["ContentReferenceUpdateAwardsEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateAwardsEntityRelationInput"];
	["ContentReferenceUpdateAwardsRelationInput"]: GraphQLTypes["ContentReferenceUpdateAwardsRelationInput"];
	["AwardContentWithoutContentReferenceUpdateInput"]: GraphQLTypes["AwardContentWithoutContentReferenceUpdateInput"];
	["AwardContentUpdateImageEntityRelationInput"]: GraphQLTypes["AwardContentUpdateImageEntityRelationInput"];
	["AwardContentUpsertImageRelationInput"]: GraphQLTypes["AwardContentUpsertImageRelationInput"];
	["AwardContentUpdateTargetEntityRelationInput"]: GraphQLTypes["AwardContentUpdateTargetEntityRelationInput"];
	["AwardContentUpsertTargetRelationInput"]: GraphQLTypes["AwardContentUpsertTargetRelationInput"];
	["ContentReferenceUpsertAwardsRelationInput"]: GraphQLTypes["ContentReferenceUpsertAwardsRelationInput"];
	["ContentReferenceUpdateReviewsEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateReviewsEntityRelationInput"];
	["ContentReferenceUpdateReviewsRelationInput"]: GraphQLTypes["ContentReferenceUpdateReviewsRelationInput"];
	["ReviewContentWithoutContentReferenceUpdateInput"]: GraphQLTypes["ReviewContentWithoutContentReferenceUpdateInput"];
	["ContentReferenceUpsertReviewsRelationInput"]: GraphQLTypes["ContentReferenceUpsertReviewsRelationInput"];
	["ContentReferenceUpdateTargetEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateTargetEntityRelationInput"];
	["ContentReferenceUpsertTargetRelationInput"]: GraphQLTypes["ContentReferenceUpsertTargetRelationInput"];
	["ContentReferenceUpdateButtonsEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateButtonsEntityRelationInput"];
	["ContentReferenceUpdateButtonsRelationInput"]: GraphQLTypes["ContentReferenceUpdateButtonsRelationInput"];
	["ButtonWithoutContentReferenceUpdateInput"]: GraphQLTypes["ButtonWithoutContentReferenceUpdateInput"];
	["ButtonUpdateTargetEntityRelationInput"]: GraphQLTypes["ButtonUpdateTargetEntityRelationInput"];
	["ButtonUpsertTargetRelationInput"]: GraphQLTypes["ButtonUpsertTargetRelationInput"];
	["ContentReferenceUpsertButtonsRelationInput"]: GraphQLTypes["ContentReferenceUpsertButtonsRelationInput"];
	["ContentReferenceUpdateSharedContentEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateSharedContentEntityRelationInput"];
	["SharedContentWithoutContentReferenceUpdateInput"]: GraphQLTypes["SharedContentWithoutContentReferenceUpdateInput"];
	["SharedContentUpdateContentEntityRelationInput"]: GraphQLTypes["SharedContentUpdateContentEntityRelationInput"];
	["SharedContentUpsertContentRelationInput"]: GraphQLTypes["SharedContentUpsertContentRelationInput"];
	["ContentReferenceUpsertSharedContentRelationInput"]: GraphQLTypes["ContentReferenceUpsertSharedContentRelationInput"];
	["SubscriptionFormUpsertContentReferencesRelationInput"]: GraphQLTypes["SubscriptionFormUpsertContentReferencesRelationInput"];
	["ProductUpsertFormRelationInput"]: GraphQLTypes["ProductUpsertFormRelationInput"];
	["SubscriptionFormOptionUpsertProductsRelationInput"]: GraphQLTypes["SubscriptionFormOptionUpsertProductsRelationInput"];
	["SubscriptionFormInputUpsertOptionsRelationInput"]: GraphQLTypes["SubscriptionFormInputUpsertOptionsRelationInput"];
	["SubscriptionFormInputUpdateDescriptionEntityRelationInput"]: GraphQLTypes["SubscriptionFormInputUpdateDescriptionEntityRelationInput"];
	["SubscriptionFormInputUpsertDescriptionRelationInput"]: GraphQLTypes["SubscriptionFormInputUpsertDescriptionRelationInput"];
	["SubscriptionFormSectionUpsertInputsRelationInput"]: GraphQLTypes["SubscriptionFormSectionUpsertInputsRelationInput"];
	["SubscriptionFormUpsertSectionsRelationInput"]: GraphQLTypes["SubscriptionFormUpsertSectionsRelationInput"];
	["SubscriptionFormUpdateProductsEntityRelationInput"]: GraphQLTypes["SubscriptionFormUpdateProductsEntityRelationInput"];
	["SubscriptionFormUpdateProductsRelationInput"]: GraphQLTypes["SubscriptionFormUpdateProductsRelationInput"];
	["ProductWithoutFormUpdateInput"]: GraphQLTypes["ProductWithoutFormUpdateInput"];
	["ProductUpdateFormOptionsEntityRelationInput"]: GraphQLTypes["ProductUpdateFormOptionsEntityRelationInput"];
	["ProductUpdateFormOptionsRelationInput"]: GraphQLTypes["ProductUpdateFormOptionsRelationInput"];
	["SubscriptionFormOptionWithoutProductsUpdateInput"]: GraphQLTypes["SubscriptionFormOptionWithoutProductsUpdateInput"];
	["SubscriptionFormOptionUpdateFormInputEntityRelationInput"]: GraphQLTypes["SubscriptionFormOptionUpdateFormInputEntityRelationInput"];
	["SubscriptionFormInputWithoutOptionsUpdateInput"]: GraphQLTypes["SubscriptionFormInputWithoutOptionsUpdateInput"];
	["SubscriptionFormInputUpdateSectionEntityRelationInput"]: GraphQLTypes["SubscriptionFormInputUpdateSectionEntityRelationInput"];
	["SubscriptionFormSectionWithoutInputsUpdateInput"]: GraphQLTypes["SubscriptionFormSectionWithoutInputsUpdateInput"];
	["SubscriptionFormSectionUpdateFormEntityRelationInput"]: GraphQLTypes["SubscriptionFormSectionUpdateFormEntityRelationInput"];
	["SubscriptionFormWithoutSectionsUpdateInput"]: GraphQLTypes["SubscriptionFormWithoutSectionsUpdateInput"];
	["SubscriptionFormSectionUpsertFormRelationInput"]: GraphQLTypes["SubscriptionFormSectionUpsertFormRelationInput"];
	["SubscriptionFormInputUpsertSectionRelationInput"]: GraphQLTypes["SubscriptionFormInputUpsertSectionRelationInput"];
	["SubscriptionFormOptionUpsertFormInputRelationInput"]: GraphQLTypes["SubscriptionFormOptionUpsertFormInputRelationInput"];
	["ProductUpsertFormOptionsRelationInput"]: GraphQLTypes["ProductUpsertFormOptionsRelationInput"];
	["SubscriptionFormUpsertProductsRelationInput"]: GraphQLTypes["SubscriptionFormUpsertProductsRelationInput"];
	["ContentBlockUpsertSubscriptionFormRelationInput"]: GraphQLTypes["ContentBlockUpsertSubscriptionFormRelationInput"];
	["IssueUpsertBlocksRelationInput"]: GraphQLTypes["IssueUpsertBlocksRelationInput"];
	["IssueUpdateCoverPhotoEntityRelationInput"]: GraphQLTypes["IssueUpdateCoverPhotoEntityRelationInput"];
	["IssueUpsertCoverPhotoRelationInput"]: GraphQLTypes["IssueUpsertCoverPhotoRelationInput"];
	["IssueUpdatePrintTargetEntityRelationInput"]: GraphQLTypes["IssueUpdatePrintTargetEntityRelationInput"];
	["IssueUpsertPrintTargetRelationInput"]: GraphQLTypes["IssueUpsertPrintTargetRelationInput"];
	["IssueUpdateBackgroundPhotoEntityRelationInput"]: GraphQLTypes["IssueUpdateBackgroundPhotoEntityRelationInput"];
	["IssueUpsertBackgroundPhotoRelationInput"]: GraphQLTypes["IssueUpsertBackgroundPhotoRelationInput"];
	["IssueArticleUpsertIssueRelationInput"]: GraphQLTypes["IssueArticleUpsertIssueRelationInput"];
	["ArticleUpsertIssuesRelationInput"]: GraphQLTypes["ArticleUpsertIssuesRelationInput"];
	["ArticleCategoryUpsertArticleRelationInput"]: GraphQLTypes["ArticleCategoryUpsertArticleRelationInput"];
	["CategoryUpsertArticleCategoryRelationInput"]: GraphQLTypes["CategoryUpsertArticleCategoryRelationInput"];
	["UrlUpsertCategoryRelationInput"]: GraphQLTypes["UrlUpsertCategoryRelationInput"];
	["IssueUpsertUrlRelationInput"]: GraphQLTypes["IssueUpsertUrlRelationInput"];
	["ContentBlockUpsertIssueRelationInput"]: GraphQLTypes["ContentBlockUpsertIssueRelationInput"];
	["ContentArticleUpsertContentBlockRelationInput"]: GraphQLTypes["ContentArticleUpsertContentBlockRelationInput"];
	["ArticleUpsertContentBlocksRelationInput"]: GraphQLTypes["ArticleUpsertContentBlocksRelationInput"];
	["IssueArticleUpsertArticleRelationInput"]: GraphQLTypes["IssueArticleUpsertArticleRelationInput"];
	["IssueUpsertArticlesRelationInput"]: GraphQLTypes["IssueUpsertArticlesRelationInput"];
	["UrlUpsertIssueRelationInput"]: GraphQLTypes["UrlUpsertIssueRelationInput"];
	["CategoryUpsertUrlRelationInput"]: GraphQLTypes["CategoryUpsertUrlRelationInput"];
	["ArticleCategoryUpsertCategoryRelationInput"]: GraphQLTypes["ArticleCategoryUpsertCategoryRelationInput"];
	["ArticleUpsertCategoriesRelationInput"]: GraphQLTypes["ArticleUpsertCategoriesRelationInput"];
	["UrlUpsertArticleRelationInput"]: GraphQLTypes["UrlUpsertArticleRelationInput"];
	["LinkUpsertInternalTargetRelationInput"]: GraphQLTypes["LinkUpsertInternalTargetRelationInput"];
	["TextContentReferenceUpsertTargetRelationInput"]: GraphQLTypes["TextContentReferenceUpsertTargetRelationInput"];
	["TextContentPartUpsertReferencesRelationInput"]: GraphQLTypes["TextContentPartUpsertReferencesRelationInput"];
	["TextContentUpsertPartsRelationInput"]: GraphQLTypes["TextContentUpsertPartsRelationInput"];
	["ArticleUpsertSubtitleRelationInput"]: GraphQLTypes["ArticleUpsertSubtitleRelationInput"];
	["UnlockedArticleUpsertArticleRelationInput"]: GraphQLTypes["UnlockedArticleUpsertArticleRelationInput"];
	["UserUpsertUnlockedArticlesRelationInput"]: GraphQLTypes["UserUpsertUnlockedArticlesRelationInput"];
	["AuthorUpsertUsersRelationInput"]: GraphQLTypes["AuthorUpsertUsersRelationInput"];
	["AudioUpsertAuthorRelationInput"]: GraphQLTypes["AudioUpsertAuthorRelationInput"];
	["AudioUseUpsertAudioRelationInput"]: GraphQLTypes["AudioUseUpsertAudioRelationInput"];
	["ContentReferenceUpsertAudioRelationInput"]: GraphQLTypes["ContentReferenceUpsertAudioRelationInput"];
	["ContentReferenceUpdateSubscriptionFormEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateSubscriptionFormEntityRelationInput"];
	["SubscriptionFormWithoutContentReferencesUpdateInput"]: GraphQLTypes["SubscriptionFormWithoutContentReferencesUpdateInput"];
	["ContentReferenceUpsertSubscriptionFormRelationInput"]: GraphQLTypes["ContentReferenceUpsertSubscriptionFormRelationInput"];
	["ContentPartUpsertReferencesRelationInput"]: GraphQLTypes["ContentPartUpsertReferencesRelationInput"];
	["ContentUpsertPartsRelationInput"]: GraphQLTypes["ContentUpsertPartsRelationInput"];
	["AuthorUpsertAboutRelationInput"]: GraphQLTypes["AuthorUpsertAboutRelationInput"];
	["UrlUpsertAuthorRelationInput"]: GraphQLTypes["UrlUpsertAuthorRelationInput"];
	["ArticleUpsertUrlRelationInput"]: GraphQLTypes["ArticleUpsertUrlRelationInput"];
	["ArticleAuthorCreateInput"]: GraphQLTypes["ArticleAuthorCreateInput"];
	["ArticleAuthorCreateArticleEntityRelationInput"]: GraphQLTypes["ArticleAuthorCreateArticleEntityRelationInput"];
	["ArticleWithoutAuthorsCreateInput"]: GraphQLTypes["ArticleWithoutAuthorsCreateInput"];
	["ArticleAuthorUpdateInput"]: GraphQLTypes["ArticleAuthorUpdateInput"];
	["ArticleAuthorUpdateArticleEntityRelationInput"]: GraphQLTypes["ArticleAuthorUpdateArticleEntityRelationInput"];
	["ArticleWithoutAuthorsUpdateInput"]: GraphQLTypes["ArticleWithoutAuthorsUpdateInput"];
	["ArticleAuthorUpsertArticleRelationInput"]: GraphQLTypes["ArticleAuthorUpsertArticleRelationInput"];
	["AuthorTopArticleCreateInput"]: GraphQLTypes["AuthorTopArticleCreateInput"];
	["AuthorTopArticleCreateAuthorEntityRelationInput"]: GraphQLTypes["AuthorTopArticleCreateAuthorEntityRelationInput"];
	["AuthorWithoutTopArticlesCreateInput"]: GraphQLTypes["AuthorWithoutTopArticlesCreateInput"];
	["AuthorTopArticleUpdateInput"]: GraphQLTypes["AuthorTopArticleUpdateInput"];
	["AuthorTopArticleUpdateAuthorEntityRelationInput"]: GraphQLTypes["AuthorTopArticleUpdateAuthorEntityRelationInput"];
	["AuthorWithoutTopArticlesUpdateInput"]: GraphQLTypes["AuthorWithoutTopArticlesUpdateInput"];
	["AuthorTopArticleUpsertAuthorRelationInput"]: GraphQLTypes["AuthorTopArticleUpsertAuthorRelationInput"];
	["ContentConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentEdge"][]
};
	["ContentEdge"]: {
		node:ModelTypes["Content"]
};
	["ContentPartCreateInput"]: GraphQLTypes["ContentPartCreateInput"];
	["ContentPartUpdateInput"]: GraphQLTypes["ContentPartUpdateInput"];
	["ContentReferenceCreateInput"]: GraphQLTypes["ContentReferenceCreateInput"];
	["ContentReferenceUpdateInput"]: GraphQLTypes["ContentReferenceUpdateInput"];
	["HomepageArticle"]: {
		_meta?:ModelTypes["HomepageArticleMeta"],
	id:ModelTypes["UUID"],
	order:number,
	tag:string,
	article?:ModelTypes["Article"]
};
	["HomepageArticleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	tag?:ModelTypes["FieldMeta"],
	article?:ModelTypes["FieldMeta"]
};
	["HomepageArticleUniqueWhere"]: GraphQLTypes["HomepageArticleUniqueWhere"];
	["HomepageArticleWhere"]: GraphQLTypes["HomepageArticleWhere"];
	["HomepageArticleOrderBy"]: GraphQLTypes["HomepageArticleOrderBy"];
	["HomepageArticleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["HomepageArticleEdge"][]
};
	["HomepageArticleEdge"]: {
		node:ModelTypes["HomepageArticle"]
};
	["HomepageArticleCreateInput"]: GraphQLTypes["HomepageArticleCreateInput"];
	["HomepageArticleCreateArticleEntityRelationInput"]: GraphQLTypes["HomepageArticleCreateArticleEntityRelationInput"];
	["HomepageArticleUpdateInput"]: GraphQLTypes["HomepageArticleUpdateInput"];
	["HomepageArticleUpdateArticleEntityRelationInput"]: GraphQLTypes["HomepageArticleUpdateArticleEntityRelationInput"];
	["HomepageArticleUpsertArticleRelationInput"]: GraphQLTypes["HomepageArticleUpsertArticleRelationInput"];
	["ImageCreateInput"]: GraphQLTypes["ImageCreateInput"];
	["ImageCreateUsesEntityRelationInput"]: GraphQLTypes["ImageCreateUsesEntityRelationInput"];
	["ImageUseWithoutImageCreateInput"]: GraphQLTypes["ImageUseWithoutImageCreateInput"];
	["ImageUpdateInput"]: GraphQLTypes["ImageUpdateInput"];
	["ImageUpdateUsesEntityRelationInput"]: GraphQLTypes["ImageUpdateUsesEntityRelationInput"];
	["ImageUpdateUsesRelationInput"]: GraphQLTypes["ImageUpdateUsesRelationInput"];
	["ImageUseWithoutImageUpdateInput"]: GraphQLTypes["ImageUseWithoutImageUpdateInput"];
	["ImageUpsertUsesRelationInput"]: GraphQLTypes["ImageUpsertUsesRelationInput"];
	["ImageTagCreateInput"]: GraphQLTypes["ImageTagCreateInput"];
	["ImageTagCreateImagesEntityRelationInput"]: GraphQLTypes["ImageTagCreateImagesEntityRelationInput"];
	["ImageWithoutTagsCreateInput"]: GraphQLTypes["ImageWithoutTagsCreateInput"];
	["ImageTagUpdateInput"]: GraphQLTypes["ImageTagUpdateInput"];
	["ImageTagUpdateImagesEntityRelationInput"]: GraphQLTypes["ImageTagUpdateImagesEntityRelationInput"];
	["ImageTagUpdateImagesRelationInput"]: GraphQLTypes["ImageTagUpdateImagesRelationInput"];
	["ImageWithoutTagsUpdateInput"]: GraphQLTypes["ImageWithoutTagsUpdateInput"];
	["ImageTagUpsertImagesRelationInput"]: GraphQLTypes["ImageTagUpsertImagesRelationInput"];
	["IssueConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["IssueEdge"][]
};
	["IssueEdge"]: {
		node:ModelTypes["Issue"]
};
	["IssueCreateInput"]: GraphQLTypes["IssueCreateInput"];
	["IssueUpdateInput"]: GraphQLTypes["IssueUpdateInput"];
	["IssueArticleCreateInput"]: GraphQLTypes["IssueArticleCreateInput"];
	["IssueArticleUpdateInput"]: GraphQLTypes["IssueArticleUpdateInput"];
	["LinkConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["LinkEdge"][]
};
	["LinkEdge"]: {
		node:ModelTypes["Link"]
};
	["TextContentConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["TextContentEdge"][]
};
	["TextContentEdge"]: {
		node:ModelTypes["TextContent"]
};
	["TextContentPartCreateInput"]: GraphQLTypes["TextContentPartCreateInput"];
	["TextContentPartCreateContentEntityRelationInput"]: GraphQLTypes["TextContentPartCreateContentEntityRelationInput"];
	["TextContentWithoutPartsCreateInput"]: GraphQLTypes["TextContentWithoutPartsCreateInput"];
	["TextContentPartUpdateInput"]: GraphQLTypes["TextContentPartUpdateInput"];
	["TextContentPartUpdateContentEntityRelationInput"]: GraphQLTypes["TextContentPartUpdateContentEntityRelationInput"];
	["TextContentWithoutPartsUpdateInput"]: GraphQLTypes["TextContentWithoutPartsUpdateInput"];
	["TextContentPartUpsertContentRelationInput"]: GraphQLTypes["TextContentPartUpsertContentRelationInput"];
	["TextContentReferenceCreateInput"]: GraphQLTypes["TextContentReferenceCreateInput"];
	["TextContentReferenceCreateContentPartEntityRelationInput"]: GraphQLTypes["TextContentReferenceCreateContentPartEntityRelationInput"];
	["TextContentPartWithoutReferencesCreateInput"]: GraphQLTypes["TextContentPartWithoutReferencesCreateInput"];
	["TextContentReferenceUpdateInput"]: GraphQLTypes["TextContentReferenceUpdateInput"];
	["TextContentReferenceUpdateContentPartEntityRelationInput"]: GraphQLTypes["TextContentReferenceUpdateContentPartEntityRelationInput"];
	["TextContentPartWithoutReferencesUpdateInput"]: GraphQLTypes["TextContentPartWithoutReferencesUpdateInput"];
	["TextContentReferenceUpsertContentPartRelationInput"]: GraphQLTypes["TextContentReferenceUpsertContentPartRelationInput"];
	["UrlConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["UrlEdge"][]
};
	["UrlEdge"]: {
		node:ModelTypes["Url"]
};
	["ArticleTagCreateInput"]: GraphQLTypes["ArticleTagCreateInput"];
	["ArticleTagUpdateInput"]: GraphQLTypes["ArticleTagUpdateInput"];
	["CategoryConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["CategoryEdge"][]
};
	["CategoryEdge"]: {
		node:ModelTypes["Category"]
};
	["CategoryCreateInput"]: GraphQLTypes["CategoryCreateInput"];
	["CategoryUpdateInput"]: GraphQLTypes["CategoryUpdateInput"];
	["ArticleCategoryCreateInput"]: GraphQLTypes["ArticleCategoryCreateInput"];
	["ArticleCategoryUpdateInput"]: GraphQLTypes["ArticleCategoryUpdateInput"];
	["AudioConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["AudioEdge"][]
};
	["AudioEdge"]: {
		node:ModelTypes["Audio"]
};
	["AudioCreateInput"]: GraphQLTypes["AudioCreateInput"];
	["AudioCreateUsesEntityRelationInput"]: GraphQLTypes["AudioCreateUsesEntityRelationInput"];
	["AudioUseWithoutAudioCreateInput"]: GraphQLTypes["AudioUseWithoutAudioCreateInput"];
	["AudioUpdateInput"]: GraphQLTypes["AudioUpdateInput"];
	["AudioUpdateUsesEntityRelationInput"]: GraphQLTypes["AudioUpdateUsesEntityRelationInput"];
	["AudioUpdateUsesRelationInput"]: GraphQLTypes["AudioUpdateUsesRelationInput"];
	["AudioUseWithoutAudioUpdateInput"]: GraphQLTypes["AudioUseWithoutAudioUpdateInput"];
	["AudioUpsertUsesRelationInput"]: GraphQLTypes["AudioUpsertUsesRelationInput"];
	["EmbedConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["EmbedEdge"][]
};
	["EmbedEdge"]: {
		node:ModelTypes["Embed"]
};
	["ImageContentCreateInput"]: GraphQLTypes["ImageContentCreateInput"];
	["ImageContentCreateContentReferenceEntityRelationInput"]: GraphQLTypes["ImageContentCreateContentReferenceEntityRelationInput"];
	["ContentReferenceWithoutImagesCreateInput"]: GraphQLTypes["ContentReferenceWithoutImagesCreateInput"];
	["ImageContentUpdateInput"]: GraphQLTypes["ImageContentUpdateInput"];
	["ImageContentUpdateContentReferenceEntityRelationInput"]: GraphQLTypes["ImageContentUpdateContentReferenceEntityRelationInput"];
	["ImageContentUpdateContentReferenceRelationInput"]: GraphQLTypes["ImageContentUpdateContentReferenceRelationInput"];
	["ContentReferenceWithoutImagesUpdateInput"]: GraphQLTypes["ContentReferenceWithoutImagesUpdateInput"];
	["ImageContentUpsertContentReferenceRelationInput"]: GraphQLTypes["ImageContentUpsertContentReferenceRelationInput"];
	["ListicleCreateInput"]: GraphQLTypes["ListicleCreateInput"];
	["ListicleCreateContentReferenceEntityRelationInput"]: GraphQLTypes["ListicleCreateContentReferenceEntityRelationInput"];
	["ContentReferenceWithoutListicleCreateInput"]: GraphQLTypes["ContentReferenceWithoutListicleCreateInput"];
	["ListicleUpdateInput"]: GraphQLTypes["ListicleUpdateInput"];
	["ListicleUpdateContentReferenceEntityRelationInput"]: GraphQLTypes["ListicleUpdateContentReferenceEntityRelationInput"];
	["ContentReferenceWithoutListicleUpdateInput"]: GraphQLTypes["ContentReferenceWithoutListicleUpdateInput"];
	["ListicleUpsertContentReferenceRelationInput"]: GraphQLTypes["ListicleUpsertContentReferenceRelationInput"];
	["PollAnswerConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["PollAnswerEdge"][]
};
	["PollAnswerEdge"]: {
		node:ModelTypes["PollAnswer"]
};
	["TagConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["TagEdge"][]
};
	["TagEdge"]: {
		node:ModelTypes["Tag"]
};
	["TagCreateInput"]: GraphQLTypes["TagCreateInput"];
	["TagUpdateInput"]: GraphQLTypes["TagUpdateInput"];
	["FAQCreateInput"]: GraphQLTypes["FAQCreateInput"];
	["FAQCreateContentReferenceEntityRelationInput"]: GraphQLTypes["FAQCreateContentReferenceEntityRelationInput"];
	["ContentReferenceWithoutFaqCreateInput"]: GraphQLTypes["ContentReferenceWithoutFaqCreateInput"];
	["FAQUpdateInput"]: GraphQLTypes["FAQUpdateInput"];
	["FAQUpdateContentReferenceEntityRelationInput"]: GraphQLTypes["FAQUpdateContentReferenceEntityRelationInput"];
	["ContentReferenceWithoutFaqUpdateInput"]: GraphQLTypes["ContentReferenceWithoutFaqUpdateInput"];
	["FAQUpsertContentReferenceRelationInput"]: GraphQLTypes["FAQUpsertContentReferenceRelationInput"];
	["LinkContentCreateInput"]: GraphQLTypes["LinkContentCreateInput"];
	["LinkContentCreateContentReferenceEntityRelationInput"]: GraphQLTypes["LinkContentCreateContentReferenceEntityRelationInput"];
	["ContentReferenceWithoutLinksCreateInput"]: GraphQLTypes["ContentReferenceWithoutLinksCreateInput"];
	["LinkContentUpdateInput"]: GraphQLTypes["LinkContentUpdateInput"];
	["LinkContentUpdateContentReferenceEntityRelationInput"]: GraphQLTypes["LinkContentUpdateContentReferenceEntityRelationInput"];
	["ContentReferenceWithoutLinksUpdateInput"]: GraphQLTypes["ContentReferenceWithoutLinksUpdateInput"];
	["LinkContentUpsertContentReferenceRelationInput"]: GraphQLTypes["LinkContentUpsertContentReferenceRelationInput"];
	["AwardContentCreateInput"]: GraphQLTypes["AwardContentCreateInput"];
	["AwardContentCreateContentReferenceEntityRelationInput"]: GraphQLTypes["AwardContentCreateContentReferenceEntityRelationInput"];
	["ContentReferenceWithoutAwardsCreateInput"]: GraphQLTypes["ContentReferenceWithoutAwardsCreateInput"];
	["AwardContentUpdateInput"]: GraphQLTypes["AwardContentUpdateInput"];
	["AwardContentUpdateContentReferenceEntityRelationInput"]: GraphQLTypes["AwardContentUpdateContentReferenceEntityRelationInput"];
	["ContentReferenceWithoutAwardsUpdateInput"]: GraphQLTypes["ContentReferenceWithoutAwardsUpdateInput"];
	["AwardContentUpsertContentReferenceRelationInput"]: GraphQLTypes["AwardContentUpsertContentReferenceRelationInput"];
	["ReviewContentCreateInput"]: GraphQLTypes["ReviewContentCreateInput"];
	["ReviewContentCreateContentReferenceEntityRelationInput"]: GraphQLTypes["ReviewContentCreateContentReferenceEntityRelationInput"];
	["ContentReferenceWithoutReviewsCreateInput"]: GraphQLTypes["ContentReferenceWithoutReviewsCreateInput"];
	["ReviewContentUpdateInput"]: GraphQLTypes["ReviewContentUpdateInput"];
	["ReviewContentUpdateContentReferenceEntityRelationInput"]: GraphQLTypes["ReviewContentUpdateContentReferenceEntityRelationInput"];
	["ContentReferenceWithoutReviewsUpdateInput"]: GraphQLTypes["ContentReferenceWithoutReviewsUpdateInput"];
	["ReviewContentUpsertContentReferenceRelationInput"]: GraphQLTypes["ReviewContentUpsertContentReferenceRelationInput"];
	["PageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["PageEdge"][]
};
	["PageEdge"]: {
		node:ModelTypes["Page"]
};
	["PageCreateInput"]: GraphQLTypes["PageCreateInput"];
	["PageUpdateInput"]: GraphQLTypes["PageUpdateInput"];
	["TextTranslation"]: {
		_meta?:ModelTypes["TextTranslationMeta"],
	id:ModelTypes["UUID"],
	key:string,
	description?:string,
	value:string,
	draft:boolean
};
	["TextTranslationMeta"]: {
		id?:ModelTypes["FieldMeta"],
	key?:ModelTypes["FieldMeta"],
	description?:ModelTypes["FieldMeta"],
	value?:ModelTypes["FieldMeta"],
	draft?:ModelTypes["FieldMeta"]
};
	["TextTranslationUniqueWhere"]: GraphQLTypes["TextTranslationUniqueWhere"];
	["TextTranslationWhere"]: GraphQLTypes["TextTranslationWhere"];
	["TextTranslationOrderBy"]: GraphQLTypes["TextTranslationOrderBy"];
	["TextTranslationConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["TextTranslationEdge"][]
};
	["TextTranslationEdge"]: {
		node:ModelTypes["TextTranslation"]
};
	["TextTranslationCreateInput"]: GraphQLTypes["TextTranslationCreateInput"];
	["TextTranslationUpdateInput"]: GraphQLTypes["TextTranslationUpdateInput"];
	["SeoConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SeoEdge"][]
};
	["SeoEdge"]: {
		node:ModelTypes["Seo"]
};
	["FileConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["FileEdge"][]
};
	["FileEdge"]: {
		node:ModelTypes["File"]
};
	["FileCreateInput"]: GraphQLTypes["FileCreateInput"];
	["FileCreateUsesEntityRelationInput"]: GraphQLTypes["FileCreateUsesEntityRelationInput"];
	["FileUseWithoutFileCreateInput"]: GraphQLTypes["FileUseWithoutFileCreateInput"];
	["FileUpdateInput"]: GraphQLTypes["FileUpdateInput"];
	["FileUpdateUsesEntityRelationInput"]: GraphQLTypes["FileUpdateUsesEntityRelationInput"];
	["FileUpdateUsesRelationInput"]: GraphQLTypes["FileUpdateUsesRelationInput"];
	["FileUseWithoutFileUpdateInput"]: GraphQLTypes["FileUseWithoutFileUpdateInput"];
	["FileUpsertUsesRelationInput"]: GraphQLTypes["FileUpsertUsesRelationInput"];
	["ContentBlockCreateInput"]: GraphQLTypes["ContentBlockCreateInput"];
	["ContentBlockUpdateInput"]: GraphQLTypes["ContentBlockUpdateInput"];
	["ContentArticleCreateInput"]: GraphQLTypes["ContentArticleCreateInput"];
	["ContentArticleUpdateInput"]: GraphQLTypes["ContentArticleUpdateInput"];
	["UnlockedArticleCreateInput"]: GraphQLTypes["UnlockedArticleCreateInput"];
	["UnlockedArticleUpdateInput"]: GraphQLTypes["UnlockedArticleUpdateInput"];
	["UserCreateInput"]: GraphQLTypes["UserCreateInput"];
	["UserUpdateInput"]: GraphQLTypes["UserUpdateInput"];
	["Notification"]: {
		_meta?:ModelTypes["NotificationMeta"],
	id:ModelTypes["UUID"],
	title:string,
	message:string,
	sendAt:ModelTypes["DateTime"],
	sent?:ModelTypes["DateTime"]
};
	["NotificationMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	message?:ModelTypes["FieldMeta"],
	sendAt?:ModelTypes["FieldMeta"],
	sent?:ModelTypes["FieldMeta"]
};
	["NotificationUniqueWhere"]: GraphQLTypes["NotificationUniqueWhere"];
	["NotificationWhere"]: GraphQLTypes["NotificationWhere"];
	["NotificationOrderBy"]: GraphQLTypes["NotificationOrderBy"];
	["NotificationConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["NotificationEdge"][]
};
	["NotificationEdge"]: {
		node:ModelTypes["Notification"]
};
	["NotificationCreateInput"]: GraphQLTypes["NotificationCreateInput"];
	["NotificationUpdateInput"]: GraphQLTypes["NotificationUpdateInput"];
	["AppReviewCreateInput"]: GraphQLTypes["AppReviewCreateInput"];
	["AppReviewCreateUserEntityRelationInput"]: GraphQLTypes["AppReviewCreateUserEntityRelationInput"];
	["UserWithoutAppReviewsCreateInput"]: GraphQLTypes["UserWithoutAppReviewsCreateInput"];
	["AppReviewUpdateInput"]: GraphQLTypes["AppReviewUpdateInput"];
	["AppReviewUpdateUserEntityRelationInput"]: GraphQLTypes["AppReviewUpdateUserEntityRelationInput"];
	["UserWithoutAppReviewsUpdateInput"]: GraphQLTypes["UserWithoutAppReviewsUpdateInput"];
	["AppReviewUpsertUserRelationInput"]: GraphQLTypes["AppReviewUpsertUserRelationInput"];
	["ProductCreateInput"]: GraphQLTypes["ProductCreateInput"];
	["ProductUpdateInput"]: GraphQLTypes["ProductUpdateInput"];
	["SubscriptionFormConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SubscriptionFormEdge"][]
};
	["SubscriptionFormEdge"]: {
		node:ModelTypes["SubscriptionForm"]
};
	["SubscriptionFormCreateInput"]: GraphQLTypes["SubscriptionFormCreateInput"];
	["SubscriptionFormUpdateInput"]: GraphQLTypes["SubscriptionFormUpdateInput"];
	["SubscriptionFormSectionCreateInput"]: GraphQLTypes["SubscriptionFormSectionCreateInput"];
	["SubscriptionFormSectionUpdateInput"]: GraphQLTypes["SubscriptionFormSectionUpdateInput"];
	["SubscriptionFormInputCreateInput"]: GraphQLTypes["SubscriptionFormInputCreateInput"];
	["SubscriptionFormInputUpdateInput"]: GraphQLTypes["SubscriptionFormInputUpdateInput"];
	["SubscriptionFormOptionCreateInput"]: GraphQLTypes["SubscriptionFormOptionCreateInput"];
	["SubscriptionFormOptionUpdateInput"]: GraphQLTypes["SubscriptionFormOptionUpdateInput"];
	["ButtonCreateInput"]: GraphQLTypes["ButtonCreateInput"];
	["ButtonCreateContentReferenceEntityRelationInput"]: GraphQLTypes["ButtonCreateContentReferenceEntityRelationInput"];
	["ContentReferenceWithoutButtonsCreateInput"]: GraphQLTypes["ContentReferenceWithoutButtonsCreateInput"];
	["ButtonUpdateInput"]: GraphQLTypes["ButtonUpdateInput"];
	["ButtonUpdateContentReferenceEntityRelationInput"]: GraphQLTypes["ButtonUpdateContentReferenceEntityRelationInput"];
	["ContentReferenceWithoutButtonsUpdateInput"]: GraphQLTypes["ContentReferenceWithoutButtonsUpdateInput"];
	["ButtonUpsertContentReferenceRelationInput"]: GraphQLTypes["ButtonUpsertContentReferenceRelationInput"];
	["ArticleHistoryTagCreateInput"]: GraphQLTypes["ArticleHistoryTagCreateInput"];
	["ArticleHistoryTagCreateArticleEntityRelationInput"]: GraphQLTypes["ArticleHistoryTagCreateArticleEntityRelationInput"];
	["ArticleWithoutHistoryTagsCreateInput"]: GraphQLTypes["ArticleWithoutHistoryTagsCreateInput"];
	["ArticleHistoryTagUpdateInput"]: GraphQLTypes["ArticleHistoryTagUpdateInput"];
	["ArticleHistoryTagUpdateArticleEntityRelationInput"]: GraphQLTypes["ArticleHistoryTagUpdateArticleEntityRelationInput"];
	["ArticleWithoutHistoryTagsUpdateInput"]: GraphQLTypes["ArticleWithoutHistoryTagsUpdateInput"];
	["ArticleHistoryTagUpsertArticleRelationInput"]: GraphQLTypes["ArticleHistoryTagUpsertArticleRelationInput"];
	["ArticleHistoryPeriodCreateInput"]: GraphQLTypes["ArticleHistoryPeriodCreateInput"];
	["ArticleHistoryPeriodCreateArticleEntityRelationInput"]: GraphQLTypes["ArticleHistoryPeriodCreateArticleEntityRelationInput"];
	["ArticleWithoutHistoryPeriodsCreateInput"]: GraphQLTypes["ArticleWithoutHistoryPeriodsCreateInput"];
	["ArticleHistoryPeriodUpdateInput"]: GraphQLTypes["ArticleHistoryPeriodUpdateInput"];
	["ArticleHistoryPeriodUpdateArticleEntityRelationInput"]: GraphQLTypes["ArticleHistoryPeriodUpdateArticleEntityRelationInput"];
	["ArticleWithoutHistoryPeriodsUpdateInput"]: GraphQLTypes["ArticleWithoutHistoryPeriodsUpdateInput"];
	["ArticleHistoryPeriodUpsertArticleRelationInput"]: GraphQLTypes["ArticleHistoryPeriodUpsertArticleRelationInput"];
	["HistoryTagConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["HistoryTagEdge"][]
};
	["HistoryTagEdge"]: {
		node:ModelTypes["HistoryTag"]
};
	["HistoryTagCreateInput"]: GraphQLTypes["HistoryTagCreateInput"];
	["HistoryTagCreateArticleHistoryTagEntityRelationInput"]: GraphQLTypes["HistoryTagCreateArticleHistoryTagEntityRelationInput"];
	["ArticleHistoryTagWithoutHistoryTagCreateInput"]: GraphQLTypes["ArticleHistoryTagWithoutHistoryTagCreateInput"];
	["HistoryTagUpdateInput"]: GraphQLTypes["HistoryTagUpdateInput"];
	["HistoryTagUpdateArticleHistoryTagEntityRelationInput"]: GraphQLTypes["HistoryTagUpdateArticleHistoryTagEntityRelationInput"];
	["HistoryTagUpdateArticleHistoryTagRelationInput"]: GraphQLTypes["HistoryTagUpdateArticleHistoryTagRelationInput"];
	["ArticleHistoryTagWithoutHistoryTagUpdateInput"]: GraphQLTypes["ArticleHistoryTagWithoutHistoryTagUpdateInput"];
	["HistoryTagUpsertArticleHistoryTagRelationInput"]: GraphQLTypes["HistoryTagUpsertArticleHistoryTagRelationInput"];
	["HistoryPeriodConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["HistoryPeriodEdge"][]
};
	["HistoryPeriodEdge"]: {
		node:ModelTypes["HistoryPeriod"]
};
	["HistoryPeriodCreateInput"]: GraphQLTypes["HistoryPeriodCreateInput"];
	["HistoryPeriodCreateArticleHistoryPeriodEntityRelationInput"]: GraphQLTypes["HistoryPeriodCreateArticleHistoryPeriodEntityRelationInput"];
	["ArticleHistoryPeriodWithoutHistoryPeriodCreateInput"]: GraphQLTypes["ArticleHistoryPeriodWithoutHistoryPeriodCreateInput"];
	["HistoryPeriodUpdateInput"]: GraphQLTypes["HistoryPeriodUpdateInput"];
	["HistoryPeriodUpdateArticleHistoryPeriodEntityRelationInput"]: GraphQLTypes["HistoryPeriodUpdateArticleHistoryPeriodEntityRelationInput"];
	["HistoryPeriodUpdateArticleHistoryPeriodRelationInput"]: GraphQLTypes["HistoryPeriodUpdateArticleHistoryPeriodRelationInput"];
	["ArticleHistoryPeriodWithoutHistoryPeriodUpdateInput"]: GraphQLTypes["ArticleHistoryPeriodWithoutHistoryPeriodUpdateInput"];
	["HistoryPeriodUpsertArticleHistoryPeriodRelationInput"]: GraphQLTypes["HistoryPeriodUpsertArticleHistoryPeriodRelationInput"];
	["HistoryHomePage"]: {
		_meta?:ModelTypes["HistoryHomePageMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["HistoryHomePageUnique"],
	timePeriodTitle?:string,
	personalitiesTitle?:string,
	cover?:ModelTypes["HistoryCover"],
	seo?:ModelTypes["Seo"],
	slug:string
};
	["HistoryHomePageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	timePeriodTitle?:ModelTypes["FieldMeta"],
	personalitiesTitle?:ModelTypes["FieldMeta"],
	cover?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	slug?:ModelTypes["FieldMeta"]
};
	["HistoryHomePageUnique"]: GraphQLTypes["HistoryHomePageUnique"];
	["HistoryHomePageUniqueWhere"]: GraphQLTypes["HistoryHomePageUniqueWhere"];
	["HistoryHomePageWhere"]: GraphQLTypes["HistoryHomePageWhere"];
	["HistoryHomePageUniqueCondition"]: GraphQLTypes["HistoryHomePageUniqueCondition"];
	["HistoryHomePageOrderBy"]: GraphQLTypes["HistoryHomePageOrderBy"];
	["HistoryHomePageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["HistoryHomePageEdge"][]
};
	["HistoryHomePageEdge"]: {
		node:ModelTypes["HistoryHomePage"]
};
	["HistoryHomePageCreateInput"]: GraphQLTypes["HistoryHomePageCreateInput"];
	["HistoryHomePageCreateCoverEntityRelationInput"]: GraphQLTypes["HistoryHomePageCreateCoverEntityRelationInput"];
	["HistoryHomePageCreateSeoEntityRelationInput"]: GraphQLTypes["HistoryHomePageCreateSeoEntityRelationInput"];
	["HistoryHomePageUpdateInput"]: GraphQLTypes["HistoryHomePageUpdateInput"];
	["HistoryHomePageUpdateCoverEntityRelationInput"]: GraphQLTypes["HistoryHomePageUpdateCoverEntityRelationInput"];
	["HistoryHomePageUpsertCoverRelationInput"]: GraphQLTypes["HistoryHomePageUpsertCoverRelationInput"];
	["HistoryHomePageUpdateSeoEntityRelationInput"]: GraphQLTypes["HistoryHomePageUpdateSeoEntityRelationInput"];
	["HistoryHomePageUpsertSeoRelationInput"]: GraphQLTypes["HistoryHomePageUpsertSeoRelationInput"];
	["HistoryCoverConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["HistoryCoverEdge"][]
};
	["HistoryCoverEdge"]: {
		node:ModelTypes["HistoryCover"]
};
	["HistoryTextListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["HistoryTextListEdge"][]
};
	["HistoryTextListEdge"]: {
		node:ModelTypes["HistoryTextList"]
};
	["HistoryTextItemCreateInput"]: GraphQLTypes["HistoryTextItemCreateInput"];
	["HistoryTextItemCreateListEntityRelationInput"]: GraphQLTypes["HistoryTextItemCreateListEntityRelationInput"];
	["HistoryTextListWithoutItemsCreateInput"]: GraphQLTypes["HistoryTextListWithoutItemsCreateInput"];
	["HistoryTextItemUpdateInput"]: GraphQLTypes["HistoryTextItemUpdateInput"];
	["HistoryTextItemUpdateListEntityRelationInput"]: GraphQLTypes["HistoryTextItemUpdateListEntityRelationInput"];
	["HistoryTextListWithoutItemsUpdateInput"]: GraphQLTypes["HistoryTextListWithoutItemsUpdateInput"];
	["HistoryTextItemUpsertListRelationInput"]: GraphQLTypes["HistoryTextItemUpsertListRelationInput"];
	["FooterMenu"]: {
		_meta?:ModelTypes["FooterMenuMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["FooterMenuUnique"],
	copyright?:string,
	online?:ModelTypes["OnlineSection"],
	links?:ModelTypes["LinkSection"],
	linksTwo?:ModelTypes["LinkSection"],
	social?:ModelTypes["SocialSection"],
	newsletter?:ModelTypes["NewsletterSection"]
};
	["FooterMenuMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	copyright?:ModelTypes["FieldMeta"],
	online?:ModelTypes["FieldMeta"],
	links?:ModelTypes["FieldMeta"],
	linksTwo?:ModelTypes["FieldMeta"],
	social?:ModelTypes["FieldMeta"],
	newsletter?:ModelTypes["FieldMeta"]
};
	["FooterMenuUnique"]: GraphQLTypes["FooterMenuUnique"];
	["OnlineSection"]: {
		_meta?:ModelTypes["OnlineSectionMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	appLinks?:ModelTypes["AppLinkList"],
	links?:ModelTypes["LinkList"]
};
	["OnlineSectionMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	appLinks?:ModelTypes["FieldMeta"],
	links?:ModelTypes["FieldMeta"]
};
	["AppLinkList"]: {
		_meta?:ModelTypes["AppLinkListMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["AppLinkItem"][],
	itemsByAppLink?:ModelTypes["AppLinkItem"],
	paginateItems:ModelTypes["AppLinkItemConnection"]
};
	["AppLinkListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["AppLinkItem"]: {
		_meta?:ModelTypes["AppLinkItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	list?:ModelTypes["AppLinkList"],
	appLink?:ModelTypes["AppLink"]
};
	["AppLinkItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	appLink?:ModelTypes["FieldMeta"]
};
	["AppLinkListWhere"]: GraphQLTypes["AppLinkListWhere"];
	["AppLinkItemWhere"]: GraphQLTypes["AppLinkItemWhere"];
	["AppLinkWhere"]: GraphQLTypes["AppLinkWhere"];
	["AppLinkTypeCondition"]: GraphQLTypes["AppLinkTypeCondition"];
	["AppLinkType"]: GraphQLTypes["AppLinkType"];
	["AppLink"]: {
		_meta?:ModelTypes["AppLinkMeta"],
	id:ModelTypes["UUID"],
	type?:ModelTypes["AppLinkType"],
	url?:string
};
	["AppLinkMeta"]: {
		id?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"]
};
	["AppLinkItemOrderBy"]: GraphQLTypes["AppLinkItemOrderBy"];
	["AppLinkListOrderBy"]: GraphQLTypes["AppLinkListOrderBy"];
	["AppLinkOrderBy"]: GraphQLTypes["AppLinkOrderBy"];
	["AppLinkListItemsByAppLinkUniqueWhere"]: GraphQLTypes["AppLinkListItemsByAppLinkUniqueWhere"];
	["AppLinkUniqueWhere"]: GraphQLTypes["AppLinkUniqueWhere"];
	["AppLinkItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["AppLinkItemEdge"][]
};
	["AppLinkItemEdge"]: {
		node:ModelTypes["AppLinkItem"]
};
	["LinkList"]: {
		_meta?:ModelTypes["LinkListMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["LinkItem"][],
	paginateItems:ModelTypes["LinkItemConnection"]
};
	["LinkListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["LinkItem"]: {
		_meta?:ModelTypes["LinkItemMeta"],
	id:ModelTypes["UUID"],
	order?:number,
	list?:ModelTypes["LinkList"],
	link?:ModelTypes["Link"],
	title?:string
};
	["LinkItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"]
};
	["LinkListWhere"]: GraphQLTypes["LinkListWhere"];
	["LinkItemWhere"]: GraphQLTypes["LinkItemWhere"];
	["LinkItemOrderBy"]: GraphQLTypes["LinkItemOrderBy"];
	["LinkListOrderBy"]: GraphQLTypes["LinkListOrderBy"];
	["LinkItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["LinkItemEdge"][]
};
	["LinkItemEdge"]: {
		node:ModelTypes["LinkItem"]
};
	["OnlineSectionWhere"]: GraphQLTypes["OnlineSectionWhere"];
	["LinkSection"]: {
		_meta?:ModelTypes["LinkSectionMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	links?:ModelTypes["LinkList"]
};
	["LinkSectionMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	links?:ModelTypes["FieldMeta"]
};
	["LinkSectionWhere"]: GraphQLTypes["LinkSectionWhere"];
	["SocialSection"]: {
		_meta?:ModelTypes["SocialSectionMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	socialLinks?:ModelTypes["SocialLinkList"]
};
	["SocialSectionMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	socialLinks?:ModelTypes["FieldMeta"]
};
	["SocialLinkList"]: {
		_meta?:ModelTypes["SocialLinkListMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["SocialLinkItem"][],
	itemsBySocialLink?:ModelTypes["SocialLinkItem"],
	paginateItems:ModelTypes["SocialLinkItemConnection"]
};
	["SocialLinkListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["SocialLinkItem"]: {
		_meta?:ModelTypes["SocialLinkItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	list?:ModelTypes["SocialLinkList"],
	socialLink?:ModelTypes["SocialLink"]
};
	["SocialLinkItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	socialLink?:ModelTypes["FieldMeta"]
};
	["SocialLinkListWhere"]: GraphQLTypes["SocialLinkListWhere"];
	["SocialLinkItemWhere"]: GraphQLTypes["SocialLinkItemWhere"];
	["SocialLinkWhere"]: GraphQLTypes["SocialLinkWhere"];
	["SocialLinkTypeCondition"]: GraphQLTypes["SocialLinkTypeCondition"];
	["SocialLinkType"]: GraphQLTypes["SocialLinkType"];
	["SocialLink"]: {
		_meta?:ModelTypes["SocialLinkMeta"],
	id:ModelTypes["UUID"],
	type?:ModelTypes["SocialLinkType"],
	url?:string
};
	["SocialLinkMeta"]: {
		id?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"]
};
	["SocialLinkItemOrderBy"]: GraphQLTypes["SocialLinkItemOrderBy"];
	["SocialLinkListOrderBy"]: GraphQLTypes["SocialLinkListOrderBy"];
	["SocialLinkOrderBy"]: GraphQLTypes["SocialLinkOrderBy"];
	["SocialLinkListItemsBySocialLinkUniqueWhere"]: GraphQLTypes["SocialLinkListItemsBySocialLinkUniqueWhere"];
	["SocialLinkUniqueWhere"]: GraphQLTypes["SocialLinkUniqueWhere"];
	["SocialLinkItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SocialLinkItemEdge"][]
};
	["SocialLinkItemEdge"]: {
		node:ModelTypes["SocialLinkItem"]
};
	["SocialSectionWhere"]: GraphQLTypes["SocialSectionWhere"];
	["NewsletterSection"]: {
		_meta?:ModelTypes["NewsletterSectionMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	newsletter?:ModelTypes["Newsletter"]
};
	["NewsletterSectionMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	newsletter?:ModelTypes["FieldMeta"]
};
	["Newsletter"]: {
		_meta?:ModelTypes["NewsletterMeta"],
	id:ModelTypes["UUID"],
	input?:string,
	button?:string
};
	["NewsletterMeta"]: {
		id?:ModelTypes["FieldMeta"],
	input?:ModelTypes["FieldMeta"],
	button?:ModelTypes["FieldMeta"]
};
	["NewsletterWhere"]: GraphQLTypes["NewsletterWhere"];
	["NewsletterSectionWhere"]: GraphQLTypes["NewsletterSectionWhere"];
	["FooterMenuUniqueWhere"]: GraphQLTypes["FooterMenuUniqueWhere"];
	["OnlineSectionUniqueWhere"]: GraphQLTypes["OnlineSectionUniqueWhere"];
	["AppLinkListUniqueWhere"]: GraphQLTypes["AppLinkListUniqueWhere"];
	["AppLinkItemUniqueWhere"]: GraphQLTypes["AppLinkItemUniqueWhere"];
	["LinkListUniqueWhere"]: GraphQLTypes["LinkListUniqueWhere"];
	["LinkItemUniqueWhere"]: GraphQLTypes["LinkItemUniqueWhere"];
	["LinkSectionUniqueWhere"]: GraphQLTypes["LinkSectionUniqueWhere"];
	["SocialSectionUniqueWhere"]: GraphQLTypes["SocialSectionUniqueWhere"];
	["SocialLinkListUniqueWhere"]: GraphQLTypes["SocialLinkListUniqueWhere"];
	["SocialLinkItemUniqueWhere"]: GraphQLTypes["SocialLinkItemUniqueWhere"];
	["NewsletterSectionUniqueWhere"]: GraphQLTypes["NewsletterSectionUniqueWhere"];
	["NewsletterUniqueWhere"]: GraphQLTypes["NewsletterUniqueWhere"];
	["FooterMenuWhere"]: GraphQLTypes["FooterMenuWhere"];
	["FooterMenuUniqueCondition"]: GraphQLTypes["FooterMenuUniqueCondition"];
	["FooterMenuOrderBy"]: GraphQLTypes["FooterMenuOrderBy"];
	["OnlineSectionOrderBy"]: GraphQLTypes["OnlineSectionOrderBy"];
	["LinkSectionOrderBy"]: GraphQLTypes["LinkSectionOrderBy"];
	["SocialSectionOrderBy"]: GraphQLTypes["SocialSectionOrderBy"];
	["NewsletterSectionOrderBy"]: GraphQLTypes["NewsletterSectionOrderBy"];
	["NewsletterOrderBy"]: GraphQLTypes["NewsletterOrderBy"];
	["FooterMenuConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["FooterMenuEdge"][]
};
	["FooterMenuEdge"]: {
		node:ModelTypes["FooterMenu"]
};
	["FooterMenuCreateInput"]: GraphQLTypes["FooterMenuCreateInput"];
	["FooterMenuCreateOnlineEntityRelationInput"]: GraphQLTypes["FooterMenuCreateOnlineEntityRelationInput"];
	["OnlineSectionCreateInput"]: GraphQLTypes["OnlineSectionCreateInput"];
	["OnlineSectionCreateAppLinksEntityRelationInput"]: GraphQLTypes["OnlineSectionCreateAppLinksEntityRelationInput"];
	["AppLinkListCreateInput"]: GraphQLTypes["AppLinkListCreateInput"];
	["AppLinkListCreateItemsEntityRelationInput"]: GraphQLTypes["AppLinkListCreateItemsEntityRelationInput"];
	["AppLinkItemWithoutListCreateInput"]: GraphQLTypes["AppLinkItemWithoutListCreateInput"];
	["AppLinkItemCreateAppLinkEntityRelationInput"]: GraphQLTypes["AppLinkItemCreateAppLinkEntityRelationInput"];
	["AppLinkCreateInput"]: GraphQLTypes["AppLinkCreateInput"];
	["OnlineSectionCreateLinksEntityRelationInput"]: GraphQLTypes["OnlineSectionCreateLinksEntityRelationInput"];
	["LinkListCreateInput"]: GraphQLTypes["LinkListCreateInput"];
	["LinkListCreateItemsEntityRelationInput"]: GraphQLTypes["LinkListCreateItemsEntityRelationInput"];
	["LinkItemWithoutListCreateInput"]: GraphQLTypes["LinkItemWithoutListCreateInput"];
	["LinkItemCreateLinkEntityRelationInput"]: GraphQLTypes["LinkItemCreateLinkEntityRelationInput"];
	["FooterMenuCreateLinksEntityRelationInput"]: GraphQLTypes["FooterMenuCreateLinksEntityRelationInput"];
	["LinkSectionCreateInput"]: GraphQLTypes["LinkSectionCreateInput"];
	["LinkSectionCreateLinksEntityRelationInput"]: GraphQLTypes["LinkSectionCreateLinksEntityRelationInput"];
	["FooterMenuCreateLinksTwoEntityRelationInput"]: GraphQLTypes["FooterMenuCreateLinksTwoEntityRelationInput"];
	["FooterMenuCreateSocialEntityRelationInput"]: GraphQLTypes["FooterMenuCreateSocialEntityRelationInput"];
	["SocialSectionCreateInput"]: GraphQLTypes["SocialSectionCreateInput"];
	["SocialSectionCreateSocialLinksEntityRelationInput"]: GraphQLTypes["SocialSectionCreateSocialLinksEntityRelationInput"];
	["SocialLinkListCreateInput"]: GraphQLTypes["SocialLinkListCreateInput"];
	["SocialLinkListCreateItemsEntityRelationInput"]: GraphQLTypes["SocialLinkListCreateItemsEntityRelationInput"];
	["SocialLinkItemWithoutListCreateInput"]: GraphQLTypes["SocialLinkItemWithoutListCreateInput"];
	["SocialLinkItemCreateSocialLinkEntityRelationInput"]: GraphQLTypes["SocialLinkItemCreateSocialLinkEntityRelationInput"];
	["SocialLinkCreateInput"]: GraphQLTypes["SocialLinkCreateInput"];
	["FooterMenuCreateNewsletterEntityRelationInput"]: GraphQLTypes["FooterMenuCreateNewsletterEntityRelationInput"];
	["NewsletterSectionCreateInput"]: GraphQLTypes["NewsletterSectionCreateInput"];
	["NewsletterSectionCreateNewsletterEntityRelationInput"]: GraphQLTypes["NewsletterSectionCreateNewsletterEntityRelationInput"];
	["NewsletterCreateInput"]: GraphQLTypes["NewsletterCreateInput"];
	["FooterMenuUpdateInput"]: GraphQLTypes["FooterMenuUpdateInput"];
	["FooterMenuUpdateOnlineEntityRelationInput"]: GraphQLTypes["FooterMenuUpdateOnlineEntityRelationInput"];
	["OnlineSectionUpdateInput"]: GraphQLTypes["OnlineSectionUpdateInput"];
	["OnlineSectionUpdateAppLinksEntityRelationInput"]: GraphQLTypes["OnlineSectionUpdateAppLinksEntityRelationInput"];
	["AppLinkListUpdateInput"]: GraphQLTypes["AppLinkListUpdateInput"];
	["AppLinkListUpdateItemsEntityRelationInput"]: GraphQLTypes["AppLinkListUpdateItemsEntityRelationInput"];
	["AppLinkListUpdateItemsRelationInput"]: GraphQLTypes["AppLinkListUpdateItemsRelationInput"];
	["AppLinkItemWithoutListUpdateInput"]: GraphQLTypes["AppLinkItemWithoutListUpdateInput"];
	["AppLinkItemUpdateAppLinkEntityRelationInput"]: GraphQLTypes["AppLinkItemUpdateAppLinkEntityRelationInput"];
	["AppLinkUpdateInput"]: GraphQLTypes["AppLinkUpdateInput"];
	["AppLinkItemUpsertAppLinkRelationInput"]: GraphQLTypes["AppLinkItemUpsertAppLinkRelationInput"];
	["AppLinkListUpsertItemsRelationInput"]: GraphQLTypes["AppLinkListUpsertItemsRelationInput"];
	["OnlineSectionUpsertAppLinksRelationInput"]: GraphQLTypes["OnlineSectionUpsertAppLinksRelationInput"];
	["OnlineSectionUpdateLinksEntityRelationInput"]: GraphQLTypes["OnlineSectionUpdateLinksEntityRelationInput"];
	["LinkListUpdateInput"]: GraphQLTypes["LinkListUpdateInput"];
	["LinkListUpdateItemsEntityRelationInput"]: GraphQLTypes["LinkListUpdateItemsEntityRelationInput"];
	["LinkListUpdateItemsRelationInput"]: GraphQLTypes["LinkListUpdateItemsRelationInput"];
	["LinkItemWithoutListUpdateInput"]: GraphQLTypes["LinkItemWithoutListUpdateInput"];
	["LinkItemUpdateLinkEntityRelationInput"]: GraphQLTypes["LinkItemUpdateLinkEntityRelationInput"];
	["LinkItemUpsertLinkRelationInput"]: GraphQLTypes["LinkItemUpsertLinkRelationInput"];
	["LinkListUpsertItemsRelationInput"]: GraphQLTypes["LinkListUpsertItemsRelationInput"];
	["OnlineSectionUpsertLinksRelationInput"]: GraphQLTypes["OnlineSectionUpsertLinksRelationInput"];
	["FooterMenuUpsertOnlineRelationInput"]: GraphQLTypes["FooterMenuUpsertOnlineRelationInput"];
	["FooterMenuUpdateLinksEntityRelationInput"]: GraphQLTypes["FooterMenuUpdateLinksEntityRelationInput"];
	["LinkSectionUpdateInput"]: GraphQLTypes["LinkSectionUpdateInput"];
	["LinkSectionUpdateLinksEntityRelationInput"]: GraphQLTypes["LinkSectionUpdateLinksEntityRelationInput"];
	["LinkSectionUpsertLinksRelationInput"]: GraphQLTypes["LinkSectionUpsertLinksRelationInput"];
	["FooterMenuUpsertLinksRelationInput"]: GraphQLTypes["FooterMenuUpsertLinksRelationInput"];
	["FooterMenuUpdateLinksTwoEntityRelationInput"]: GraphQLTypes["FooterMenuUpdateLinksTwoEntityRelationInput"];
	["FooterMenuUpsertLinksTwoRelationInput"]: GraphQLTypes["FooterMenuUpsertLinksTwoRelationInput"];
	["FooterMenuUpdateSocialEntityRelationInput"]: GraphQLTypes["FooterMenuUpdateSocialEntityRelationInput"];
	["SocialSectionUpdateInput"]: GraphQLTypes["SocialSectionUpdateInput"];
	["SocialSectionUpdateSocialLinksEntityRelationInput"]: GraphQLTypes["SocialSectionUpdateSocialLinksEntityRelationInput"];
	["SocialLinkListUpdateInput"]: GraphQLTypes["SocialLinkListUpdateInput"];
	["SocialLinkListUpdateItemsEntityRelationInput"]: GraphQLTypes["SocialLinkListUpdateItemsEntityRelationInput"];
	["SocialLinkListUpdateItemsRelationInput"]: GraphQLTypes["SocialLinkListUpdateItemsRelationInput"];
	["SocialLinkItemWithoutListUpdateInput"]: GraphQLTypes["SocialLinkItemWithoutListUpdateInput"];
	["SocialLinkItemUpdateSocialLinkEntityRelationInput"]: GraphQLTypes["SocialLinkItemUpdateSocialLinkEntityRelationInput"];
	["SocialLinkUpdateInput"]: GraphQLTypes["SocialLinkUpdateInput"];
	["SocialLinkItemUpsertSocialLinkRelationInput"]: GraphQLTypes["SocialLinkItemUpsertSocialLinkRelationInput"];
	["SocialLinkListUpsertItemsRelationInput"]: GraphQLTypes["SocialLinkListUpsertItemsRelationInput"];
	["SocialSectionUpsertSocialLinksRelationInput"]: GraphQLTypes["SocialSectionUpsertSocialLinksRelationInput"];
	["FooterMenuUpsertSocialRelationInput"]: GraphQLTypes["FooterMenuUpsertSocialRelationInput"];
	["FooterMenuUpdateNewsletterEntityRelationInput"]: GraphQLTypes["FooterMenuUpdateNewsletterEntityRelationInput"];
	["NewsletterSectionUpdateInput"]: GraphQLTypes["NewsletterSectionUpdateInput"];
	["NewsletterSectionUpdateNewsletterEntityRelationInput"]: GraphQLTypes["NewsletterSectionUpdateNewsletterEntityRelationInput"];
	["NewsletterUpdateInput"]: GraphQLTypes["NewsletterUpdateInput"];
	["NewsletterSectionUpsertNewsletterRelationInput"]: GraphQLTypes["NewsletterSectionUpsertNewsletterRelationInput"];
	["FooterMenuUpsertNewsletterRelationInput"]: GraphQLTypes["FooterMenuUpsertNewsletterRelationInput"];
	["LinkSectionConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["LinkSectionEdge"][]
};
	["LinkSectionEdge"]: {
		node:ModelTypes["LinkSection"]
};
	["LinkListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["LinkListEdge"][]
};
	["LinkListEdge"]: {
		node:ModelTypes["LinkList"]
};
	["LinkItemCreateInput"]: GraphQLTypes["LinkItemCreateInput"];
	["LinkItemCreateListEntityRelationInput"]: GraphQLTypes["LinkItemCreateListEntityRelationInput"];
	["LinkListWithoutItemsCreateInput"]: GraphQLTypes["LinkListWithoutItemsCreateInput"];
	["LinkItemUpdateInput"]: GraphQLTypes["LinkItemUpdateInput"];
	["LinkItemUpdateListEntityRelationInput"]: GraphQLTypes["LinkItemUpdateListEntityRelationInput"];
	["LinkListWithoutItemsUpdateInput"]: GraphQLTypes["LinkListWithoutItemsUpdateInput"];
	["LinkItemUpsertListRelationInput"]: GraphQLTypes["LinkItemUpsertListRelationInput"];
	["NewsletterSectionConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["NewsletterSectionEdge"][]
};
	["NewsletterSectionEdge"]: {
		node:ModelTypes["NewsletterSection"]
};
	["NewsletterConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["NewsletterEdge"][]
};
	["NewsletterEdge"]: {
		node:ModelTypes["Newsletter"]
};
	["OnlineSectionConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["OnlineSectionEdge"][]
};
	["OnlineSectionEdge"]: {
		node:ModelTypes["OnlineSection"]
};
	["AppLinkConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["AppLinkEdge"][]
};
	["AppLinkEdge"]: {
		node:ModelTypes["AppLink"]
};
	["AppLinkListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["AppLinkListEdge"][]
};
	["AppLinkListEdge"]: {
		node:ModelTypes["AppLinkList"]
};
	["AppLinkItemCreateInput"]: GraphQLTypes["AppLinkItemCreateInput"];
	["AppLinkItemCreateListEntityRelationInput"]: GraphQLTypes["AppLinkItemCreateListEntityRelationInput"];
	["AppLinkListWithoutItemsCreateInput"]: GraphQLTypes["AppLinkListWithoutItemsCreateInput"];
	["AppLinkItemUpdateInput"]: GraphQLTypes["AppLinkItemUpdateInput"];
	["AppLinkItemUpdateListEntityRelationInput"]: GraphQLTypes["AppLinkItemUpdateListEntityRelationInput"];
	["AppLinkListWithoutItemsUpdateInput"]: GraphQLTypes["AppLinkListWithoutItemsUpdateInput"];
	["AppLinkItemUpsertListRelationInput"]: GraphQLTypes["AppLinkItemUpsertListRelationInput"];
	["SocialSectionConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SocialSectionEdge"][]
};
	["SocialSectionEdge"]: {
		node:ModelTypes["SocialSection"]
};
	["SocialLinkConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SocialLinkEdge"][]
};
	["SocialLinkEdge"]: {
		node:ModelTypes["SocialLink"]
};
	["SocialLinkListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SocialLinkListEdge"][]
};
	["SocialLinkListEdge"]: {
		node:ModelTypes["SocialLinkList"]
};
	["SocialLinkItemCreateInput"]: GraphQLTypes["SocialLinkItemCreateInput"];
	["SocialLinkItemCreateListEntityRelationInput"]: GraphQLTypes["SocialLinkItemCreateListEntityRelationInput"];
	["SocialLinkListWithoutItemsCreateInput"]: GraphQLTypes["SocialLinkListWithoutItemsCreateInput"];
	["SocialLinkItemUpdateInput"]: GraphQLTypes["SocialLinkItemUpdateInput"];
	["SocialLinkItemUpdateListEntityRelationInput"]: GraphQLTypes["SocialLinkItemUpdateListEntityRelationInput"];
	["SocialLinkListWithoutItemsUpdateInput"]: GraphQLTypes["SocialLinkListWithoutItemsUpdateInput"];
	["SocialLinkItemUpsertListRelationInput"]: GraphQLTypes["SocialLinkItemUpsertListRelationInput"];
	["SharedContentConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SharedContentEdge"][]
};
	["SharedContentEdge"]: {
		node:ModelTypes["SharedContent"]
};
	["SharedContentCreateInput"]: GraphQLTypes["SharedContentCreateInput"];
	["SharedContentCreateContentReferenceEntityRelationInput"]: GraphQLTypes["SharedContentCreateContentReferenceEntityRelationInput"];
	["ContentReferenceWithoutSharedContentCreateInput"]: GraphQLTypes["ContentReferenceWithoutSharedContentCreateInput"];
	["SharedContentUpdateInput"]: GraphQLTypes["SharedContentUpdateInput"];
	["SharedContentUpdateContentReferenceEntityRelationInput"]: GraphQLTypes["SharedContentUpdateContentReferenceEntityRelationInput"];
	["SharedContentUpdateContentReferenceRelationInput"]: GraphQLTypes["SharedContentUpdateContentReferenceRelationInput"];
	["ContentReferenceWithoutSharedContentUpdateInput"]: GraphQLTypes["ContentReferenceWithoutSharedContentUpdateInput"];
	["SharedContentUpsertContentReferenceRelationInput"]: GraphQLTypes["SharedContentUpsertContentReferenceRelationInput"];
	["QueryTransaction"]: {
		getArticle?:ModelTypes["Article"],
	listArticle:ModelTypes["Article"][],
	paginateArticle:ModelTypes["ArticleConnection"],
	validateCreateArticle:ModelTypes["_ValidationResult"],
	validateUpdateArticle:ModelTypes["_ValidationResult"],
	getArticleAuthor?:ModelTypes["ArticleAuthor"],
	listArticleAuthor:ModelTypes["ArticleAuthor"][],
	paginateArticleAuthor:ModelTypes["ArticleAuthorConnection"],
	validateCreateArticleAuthor:ModelTypes["_ValidationResult"],
	validateUpdateArticleAuthor:ModelTypes["_ValidationResult"],
	getAuthor?:ModelTypes["Author"],
	listAuthor:ModelTypes["Author"][],
	paginateAuthor:ModelTypes["AuthorConnection"],
	validateCreateAuthor:ModelTypes["_ValidationResult"],
	validateUpdateAuthor:ModelTypes["_ValidationResult"],
	getAuthorTopArticle?:ModelTypes["AuthorTopArticle"],
	listAuthorTopArticle:ModelTypes["AuthorTopArticle"][],
	paginateAuthorTopArticle:ModelTypes["AuthorTopArticleConnection"],
	validateCreateAuthorTopArticle:ModelTypes["_ValidationResult"],
	validateUpdateAuthorTopArticle:ModelTypes["_ValidationResult"],
	getContent?:ModelTypes["Content"],
	listContent:ModelTypes["Content"][],
	paginateContent:ModelTypes["ContentConnection"],
	validateCreateContent:ModelTypes["_ValidationResult"],
	validateUpdateContent:ModelTypes["_ValidationResult"],
	getContentPart?:ModelTypes["ContentPart"],
	listContentPart:ModelTypes["ContentPart"][],
	paginateContentPart:ModelTypes["ContentPartConnection"],
	validateCreateContentPart:ModelTypes["_ValidationResult"],
	validateUpdateContentPart:ModelTypes["_ValidationResult"],
	getContentReference?:ModelTypes["ContentReference"],
	listContentReference:ModelTypes["ContentReference"][],
	paginateContentReference:ModelTypes["ContentReferenceConnection"],
	validateCreateContentReference:ModelTypes["_ValidationResult"],
	validateUpdateContentReference:ModelTypes["_ValidationResult"],
	getHomepageArticle?:ModelTypes["HomepageArticle"],
	listHomepageArticle:ModelTypes["HomepageArticle"][],
	paginateHomepageArticle:ModelTypes["HomepageArticleConnection"],
	validateCreateHomepageArticle:ModelTypes["_ValidationResult"],
	validateUpdateHomepageArticle:ModelTypes["_ValidationResult"],
	getImage?:ModelTypes["Image"],
	listImage:ModelTypes["Image"][],
	paginateImage:ModelTypes["ImageConnection"],
	validateCreateImage:ModelTypes["_ValidationResult"],
	validateUpdateImage:ModelTypes["_ValidationResult"],
	getImageUse?:ModelTypes["ImageUse"],
	listImageUse:ModelTypes["ImageUse"][],
	paginateImageUse:ModelTypes["ImageUseConnection"],
	validateCreateImageUse:ModelTypes["_ValidationResult"],
	validateUpdateImageUse:ModelTypes["_ValidationResult"],
	getImageTag?:ModelTypes["ImageTag"],
	listImageTag:ModelTypes["ImageTag"][],
	paginateImageTag:ModelTypes["ImageTagConnection"],
	validateCreateImageTag:ModelTypes["_ValidationResult"],
	validateUpdateImageTag:ModelTypes["_ValidationResult"],
	getIssue?:ModelTypes["Issue"],
	listIssue:ModelTypes["Issue"][],
	paginateIssue:ModelTypes["IssueConnection"],
	validateCreateIssue:ModelTypes["_ValidationResult"],
	validateUpdateIssue:ModelTypes["_ValidationResult"],
	getIssueArticle?:ModelTypes["IssueArticle"],
	listIssueArticle:ModelTypes["IssueArticle"][],
	paginateIssueArticle:ModelTypes["IssueArticleConnection"],
	validateCreateIssueArticle:ModelTypes["_ValidationResult"],
	validateUpdateIssueArticle:ModelTypes["_ValidationResult"],
	getLink?:ModelTypes["Link"],
	listLink:ModelTypes["Link"][],
	paginateLink:ModelTypes["LinkConnection"],
	validateCreateLink:ModelTypes["_ValidationResult"],
	validateUpdateLink:ModelTypes["_ValidationResult"],
	getTextContent?:ModelTypes["TextContent"],
	listTextContent:ModelTypes["TextContent"][],
	paginateTextContent:ModelTypes["TextContentConnection"],
	validateCreateTextContent:ModelTypes["_ValidationResult"],
	validateUpdateTextContent:ModelTypes["_ValidationResult"],
	getTextContentPart?:ModelTypes["TextContentPart"],
	listTextContentPart:ModelTypes["TextContentPart"][],
	paginateTextContentPart:ModelTypes["TextContentPartConnection"],
	validateCreateTextContentPart:ModelTypes["_ValidationResult"],
	validateUpdateTextContentPart:ModelTypes["_ValidationResult"],
	getTextContentReference?:ModelTypes["TextContentReference"],
	listTextContentReference:ModelTypes["TextContentReference"][],
	paginateTextContentReference:ModelTypes["TextContentReferenceConnection"],
	validateCreateTextContentReference:ModelTypes["_ValidationResult"],
	validateUpdateTextContentReference:ModelTypes["_ValidationResult"],
	getUrl?:ModelTypes["Url"],
	listUrl:ModelTypes["Url"][],
	paginateUrl:ModelTypes["UrlConnection"],
	validateCreateUrl:ModelTypes["_ValidationResult"],
	validateUpdateUrl:ModelTypes["_ValidationResult"],
	getArticleTag?:ModelTypes["ArticleTag"],
	listArticleTag:ModelTypes["ArticleTag"][],
	paginateArticleTag:ModelTypes["ArticleTagConnection"],
	validateCreateArticleTag:ModelTypes["_ValidationResult"],
	validateUpdateArticleTag:ModelTypes["_ValidationResult"],
	getCategory?:ModelTypes["Category"],
	listCategory:ModelTypes["Category"][],
	paginateCategory:ModelTypes["CategoryConnection"],
	validateCreateCategory:ModelTypes["_ValidationResult"],
	validateUpdateCategory:ModelTypes["_ValidationResult"],
	getArticleCategory?:ModelTypes["ArticleCategory"],
	listArticleCategory:ModelTypes["ArticleCategory"][],
	paginateArticleCategory:ModelTypes["ArticleCategoryConnection"],
	validateCreateArticleCategory:ModelTypes["_ValidationResult"],
	validateUpdateArticleCategory:ModelTypes["_ValidationResult"],
	getAudio?:ModelTypes["Audio"],
	listAudio:ModelTypes["Audio"][],
	paginateAudio:ModelTypes["AudioConnection"],
	validateCreateAudio:ModelTypes["_ValidationResult"],
	validateUpdateAudio:ModelTypes["_ValidationResult"],
	getAudioUse?:ModelTypes["AudioUse"],
	listAudioUse:ModelTypes["AudioUse"][],
	paginateAudioUse:ModelTypes["AudioUseConnection"],
	validateCreateAudioUse:ModelTypes["_ValidationResult"],
	validateUpdateAudioUse:ModelTypes["_ValidationResult"],
	getEmbed?:ModelTypes["Embed"],
	listEmbed:ModelTypes["Embed"][],
	paginateEmbed:ModelTypes["EmbedConnection"],
	validateCreateEmbed:ModelTypes["_ValidationResult"],
	validateUpdateEmbed:ModelTypes["_ValidationResult"],
	getImageContent?:ModelTypes["ImageContent"],
	listImageContent:ModelTypes["ImageContent"][],
	paginateImageContent:ModelTypes["ImageContentConnection"],
	validateCreateImageContent:ModelTypes["_ValidationResult"],
	validateUpdateImageContent:ModelTypes["_ValidationResult"],
	getListicle?:ModelTypes["Listicle"],
	listListicle:ModelTypes["Listicle"][],
	paginateListicle:ModelTypes["ListicleConnection"],
	validateCreateListicle:ModelTypes["_ValidationResult"],
	validateUpdateListicle:ModelTypes["_ValidationResult"],
	getPollAnswer?:ModelTypes["PollAnswer"],
	listPollAnswer:ModelTypes["PollAnswer"][],
	paginatePollAnswer:ModelTypes["PollAnswerConnection"],
	validateCreatePollAnswer:ModelTypes["_ValidationResult"],
	validateUpdatePollAnswer:ModelTypes["_ValidationResult"],
	getTag?:ModelTypes["Tag"],
	listTag:ModelTypes["Tag"][],
	paginateTag:ModelTypes["TagConnection"],
	validateCreateTag:ModelTypes["_ValidationResult"],
	validateUpdateTag:ModelTypes["_ValidationResult"],
	getFAQ?:ModelTypes["FAQ"],
	listFAQ:ModelTypes["FAQ"][],
	paginateFAQ:ModelTypes["FAQConnection"],
	validateCreateFAQ:ModelTypes["_ValidationResult"],
	validateUpdateFAQ:ModelTypes["_ValidationResult"],
	getLinkContent?:ModelTypes["LinkContent"],
	listLinkContent:ModelTypes["LinkContent"][],
	paginateLinkContent:ModelTypes["LinkContentConnection"],
	validateCreateLinkContent:ModelTypes["_ValidationResult"],
	validateUpdateLinkContent:ModelTypes["_ValidationResult"],
	getAwardContent?:ModelTypes["AwardContent"],
	listAwardContent:ModelTypes["AwardContent"][],
	paginateAwardContent:ModelTypes["AwardContentConnection"],
	validateCreateAwardContent:ModelTypes["_ValidationResult"],
	validateUpdateAwardContent:ModelTypes["_ValidationResult"],
	getReviewContent?:ModelTypes["ReviewContent"],
	listReviewContent:ModelTypes["ReviewContent"][],
	paginateReviewContent:ModelTypes["ReviewContentConnection"],
	validateCreateReviewContent:ModelTypes["_ValidationResult"],
	validateUpdateReviewContent:ModelTypes["_ValidationResult"],
	getPage?:ModelTypes["Page"],
	listPage:ModelTypes["Page"][],
	paginatePage:ModelTypes["PageConnection"],
	validateCreatePage:ModelTypes["_ValidationResult"],
	validateUpdatePage:ModelTypes["_ValidationResult"],
	getTextTranslation?:ModelTypes["TextTranslation"],
	listTextTranslation:ModelTypes["TextTranslation"][],
	paginateTextTranslation:ModelTypes["TextTranslationConnection"],
	validateCreateTextTranslation:ModelTypes["_ValidationResult"],
	validateUpdateTextTranslation:ModelTypes["_ValidationResult"],
	getSeo?:ModelTypes["Seo"],
	listSeo:ModelTypes["Seo"][],
	paginateSeo:ModelTypes["SeoConnection"],
	validateCreateSeo:ModelTypes["_ValidationResult"],
	validateUpdateSeo:ModelTypes["_ValidationResult"],
	getFile?:ModelTypes["File"],
	listFile:ModelTypes["File"][],
	paginateFile:ModelTypes["FileConnection"],
	validateCreateFile:ModelTypes["_ValidationResult"],
	validateUpdateFile:ModelTypes["_ValidationResult"],
	getFileUse?:ModelTypes["FileUse"],
	listFileUse:ModelTypes["FileUse"][],
	paginateFileUse:ModelTypes["FileUseConnection"],
	validateCreateFileUse:ModelTypes["_ValidationResult"],
	validateUpdateFileUse:ModelTypes["_ValidationResult"],
	getContentBlock?:ModelTypes["ContentBlock"],
	listContentBlock:ModelTypes["ContentBlock"][],
	paginateContentBlock:ModelTypes["ContentBlockConnection"],
	validateCreateContentBlock:ModelTypes["_ValidationResult"],
	validateUpdateContentBlock:ModelTypes["_ValidationResult"],
	getContentArticle?:ModelTypes["ContentArticle"],
	listContentArticle:ModelTypes["ContentArticle"][],
	paginateContentArticle:ModelTypes["ContentArticleConnection"],
	validateCreateContentArticle:ModelTypes["_ValidationResult"],
	validateUpdateContentArticle:ModelTypes["_ValidationResult"],
	getUnlockedArticle?:ModelTypes["UnlockedArticle"],
	listUnlockedArticle:ModelTypes["UnlockedArticle"][],
	paginateUnlockedArticle:ModelTypes["UnlockedArticleConnection"],
	validateCreateUnlockedArticle:ModelTypes["_ValidationResult"],
	validateUpdateUnlockedArticle:ModelTypes["_ValidationResult"],
	getUser?:ModelTypes["User"],
	listUser:ModelTypes["User"][],
	paginateUser:ModelTypes["UserConnection"],
	validateCreateUser:ModelTypes["_ValidationResult"],
	validateUpdateUser:ModelTypes["_ValidationResult"],
	getNotification?:ModelTypes["Notification"],
	listNotification:ModelTypes["Notification"][],
	paginateNotification:ModelTypes["NotificationConnection"],
	validateCreateNotification:ModelTypes["_ValidationResult"],
	validateUpdateNotification:ModelTypes["_ValidationResult"],
	getAppReview?:ModelTypes["AppReview"],
	listAppReview:ModelTypes["AppReview"][],
	paginateAppReview:ModelTypes["AppReviewConnection"],
	validateCreateAppReview:ModelTypes["_ValidationResult"],
	validateUpdateAppReview:ModelTypes["_ValidationResult"],
	getProduct?:ModelTypes["Product"],
	listProduct:ModelTypes["Product"][],
	paginateProduct:ModelTypes["ProductConnection"],
	validateCreateProduct:ModelTypes["_ValidationResult"],
	validateUpdateProduct:ModelTypes["_ValidationResult"],
	getSubscriptionForm?:ModelTypes["SubscriptionForm"],
	listSubscriptionForm:ModelTypes["SubscriptionForm"][],
	paginateSubscriptionForm:ModelTypes["SubscriptionFormConnection"],
	validateCreateSubscriptionForm:ModelTypes["_ValidationResult"],
	validateUpdateSubscriptionForm:ModelTypes["_ValidationResult"],
	getSubscriptionFormSection?:ModelTypes["SubscriptionFormSection"],
	listSubscriptionFormSection:ModelTypes["SubscriptionFormSection"][],
	paginateSubscriptionFormSection:ModelTypes["SubscriptionFormSectionConnection"],
	validateCreateSubscriptionFormSection:ModelTypes["_ValidationResult"],
	validateUpdateSubscriptionFormSection:ModelTypes["_ValidationResult"],
	getSubscriptionFormInput?:ModelTypes["SubscriptionFormInput"],
	listSubscriptionFormInput:ModelTypes["SubscriptionFormInput"][],
	paginateSubscriptionFormInput:ModelTypes["SubscriptionFormInputConnection"],
	validateCreateSubscriptionFormInput:ModelTypes["_ValidationResult"],
	validateUpdateSubscriptionFormInput:ModelTypes["_ValidationResult"],
	getSubscriptionFormOption?:ModelTypes["SubscriptionFormOption"],
	listSubscriptionFormOption:ModelTypes["SubscriptionFormOption"][],
	paginateSubscriptionFormOption:ModelTypes["SubscriptionFormOptionConnection"],
	validateCreateSubscriptionFormOption:ModelTypes["_ValidationResult"],
	validateUpdateSubscriptionFormOption:ModelTypes["_ValidationResult"],
	getButton?:ModelTypes["Button"],
	listButton:ModelTypes["Button"][],
	paginateButton:ModelTypes["ButtonConnection"],
	validateCreateButton:ModelTypes["_ValidationResult"],
	validateUpdateButton:ModelTypes["_ValidationResult"],
	getArticleHistoryTag?:ModelTypes["ArticleHistoryTag"],
	listArticleHistoryTag:ModelTypes["ArticleHistoryTag"][],
	paginateArticleHistoryTag:ModelTypes["ArticleHistoryTagConnection"],
	validateCreateArticleHistoryTag:ModelTypes["_ValidationResult"],
	validateUpdateArticleHistoryTag:ModelTypes["_ValidationResult"],
	getArticleHistoryPeriod?:ModelTypes["ArticleHistoryPeriod"],
	listArticleHistoryPeriod:ModelTypes["ArticleHistoryPeriod"][],
	paginateArticleHistoryPeriod:ModelTypes["ArticleHistoryPeriodConnection"],
	validateCreateArticleHistoryPeriod:ModelTypes["_ValidationResult"],
	validateUpdateArticleHistoryPeriod:ModelTypes["_ValidationResult"],
	getHistoryTag?:ModelTypes["HistoryTag"],
	listHistoryTag:ModelTypes["HistoryTag"][],
	paginateHistoryTag:ModelTypes["HistoryTagConnection"],
	validateCreateHistoryTag:ModelTypes["_ValidationResult"],
	validateUpdateHistoryTag:ModelTypes["_ValidationResult"],
	getHistoryPeriod?:ModelTypes["HistoryPeriod"],
	listHistoryPeriod:ModelTypes["HistoryPeriod"][],
	paginateHistoryPeriod:ModelTypes["HistoryPeriodConnection"],
	validateCreateHistoryPeriod:ModelTypes["_ValidationResult"],
	validateUpdateHistoryPeriod:ModelTypes["_ValidationResult"],
	getHistoryHomePage?:ModelTypes["HistoryHomePage"],
	listHistoryHomePage:ModelTypes["HistoryHomePage"][],
	paginateHistoryHomePage:ModelTypes["HistoryHomePageConnection"],
	validateCreateHistoryHomePage:ModelTypes["_ValidationResult"],
	validateUpdateHistoryHomePage:ModelTypes["_ValidationResult"],
	getHistoryCover?:ModelTypes["HistoryCover"],
	listHistoryCover:ModelTypes["HistoryCover"][],
	paginateHistoryCover:ModelTypes["HistoryCoverConnection"],
	validateCreateHistoryCover:ModelTypes["_ValidationResult"],
	validateUpdateHistoryCover:ModelTypes["_ValidationResult"],
	getHistoryTextList?:ModelTypes["HistoryTextList"],
	listHistoryTextList:ModelTypes["HistoryTextList"][],
	paginateHistoryTextList:ModelTypes["HistoryTextListConnection"],
	validateCreateHistoryTextList:ModelTypes["_ValidationResult"],
	validateUpdateHistoryTextList:ModelTypes["_ValidationResult"],
	getHistoryTextItem?:ModelTypes["HistoryTextItem"],
	listHistoryTextItem:ModelTypes["HistoryTextItem"][],
	paginateHistoryTextItem:ModelTypes["HistoryTextItemConnection"],
	validateCreateHistoryTextItem:ModelTypes["_ValidationResult"],
	validateUpdateHistoryTextItem:ModelTypes["_ValidationResult"],
	getFooterMenu?:ModelTypes["FooterMenu"],
	listFooterMenu:ModelTypes["FooterMenu"][],
	paginateFooterMenu:ModelTypes["FooterMenuConnection"],
	validateCreateFooterMenu:ModelTypes["_ValidationResult"],
	validateUpdateFooterMenu:ModelTypes["_ValidationResult"],
	getLinkSection?:ModelTypes["LinkSection"],
	listLinkSection:ModelTypes["LinkSection"][],
	paginateLinkSection:ModelTypes["LinkSectionConnection"],
	validateCreateLinkSection:ModelTypes["_ValidationResult"],
	validateUpdateLinkSection:ModelTypes["_ValidationResult"],
	getLinkList?:ModelTypes["LinkList"],
	listLinkList:ModelTypes["LinkList"][],
	paginateLinkList:ModelTypes["LinkListConnection"],
	validateCreateLinkList:ModelTypes["_ValidationResult"],
	validateUpdateLinkList:ModelTypes["_ValidationResult"],
	getLinkItem?:ModelTypes["LinkItem"],
	listLinkItem:ModelTypes["LinkItem"][],
	paginateLinkItem:ModelTypes["LinkItemConnection"],
	validateCreateLinkItem:ModelTypes["_ValidationResult"],
	validateUpdateLinkItem:ModelTypes["_ValidationResult"],
	getNewsletterSection?:ModelTypes["NewsletterSection"],
	listNewsletterSection:ModelTypes["NewsletterSection"][],
	paginateNewsletterSection:ModelTypes["NewsletterSectionConnection"],
	validateCreateNewsletterSection:ModelTypes["_ValidationResult"],
	validateUpdateNewsletterSection:ModelTypes["_ValidationResult"],
	getNewsletter?:ModelTypes["Newsletter"],
	listNewsletter:ModelTypes["Newsletter"][],
	paginateNewsletter:ModelTypes["NewsletterConnection"],
	validateCreateNewsletter:ModelTypes["_ValidationResult"],
	validateUpdateNewsletter:ModelTypes["_ValidationResult"],
	getOnlineSection?:ModelTypes["OnlineSection"],
	listOnlineSection:ModelTypes["OnlineSection"][],
	paginateOnlineSection:ModelTypes["OnlineSectionConnection"],
	validateCreateOnlineSection:ModelTypes["_ValidationResult"],
	validateUpdateOnlineSection:ModelTypes["_ValidationResult"],
	getAppLink?:ModelTypes["AppLink"],
	listAppLink:ModelTypes["AppLink"][],
	paginateAppLink:ModelTypes["AppLinkConnection"],
	validateCreateAppLink:ModelTypes["_ValidationResult"],
	validateUpdateAppLink:ModelTypes["_ValidationResult"],
	getAppLinkList?:ModelTypes["AppLinkList"],
	listAppLinkList:ModelTypes["AppLinkList"][],
	paginateAppLinkList:ModelTypes["AppLinkListConnection"],
	validateCreateAppLinkList:ModelTypes["_ValidationResult"],
	validateUpdateAppLinkList:ModelTypes["_ValidationResult"],
	getAppLinkItem?:ModelTypes["AppLinkItem"],
	listAppLinkItem:ModelTypes["AppLinkItem"][],
	paginateAppLinkItem:ModelTypes["AppLinkItemConnection"],
	validateCreateAppLinkItem:ModelTypes["_ValidationResult"],
	validateUpdateAppLinkItem:ModelTypes["_ValidationResult"],
	getSocialSection?:ModelTypes["SocialSection"],
	listSocialSection:ModelTypes["SocialSection"][],
	paginateSocialSection:ModelTypes["SocialSectionConnection"],
	validateCreateSocialSection:ModelTypes["_ValidationResult"],
	validateUpdateSocialSection:ModelTypes["_ValidationResult"],
	getSocialLink?:ModelTypes["SocialLink"],
	listSocialLink:ModelTypes["SocialLink"][],
	paginateSocialLink:ModelTypes["SocialLinkConnection"],
	validateCreateSocialLink:ModelTypes["_ValidationResult"],
	validateUpdateSocialLink:ModelTypes["_ValidationResult"],
	getSocialLinkList?:ModelTypes["SocialLinkList"],
	listSocialLinkList:ModelTypes["SocialLinkList"][],
	paginateSocialLinkList:ModelTypes["SocialLinkListConnection"],
	validateCreateSocialLinkList:ModelTypes["_ValidationResult"],
	validateUpdateSocialLinkList:ModelTypes["_ValidationResult"],
	getSocialLinkItem?:ModelTypes["SocialLinkItem"],
	listSocialLinkItem:ModelTypes["SocialLinkItem"][],
	paginateSocialLinkItem:ModelTypes["SocialLinkItemConnection"],
	validateCreateSocialLinkItem:ModelTypes["_ValidationResult"],
	validateUpdateSocialLinkItem:ModelTypes["_ValidationResult"],
	getSharedContent?:ModelTypes["SharedContent"],
	listSharedContent:ModelTypes["SharedContent"][],
	paginateSharedContent:ModelTypes["SharedContentConnection"],
	validateCreateSharedContent:ModelTypes["_ValidationResult"],
	validateUpdateSharedContent:ModelTypes["_ValidationResult"]
};
	["Info"]: {
		description?:string
};
	["Mutation"]: {
		createArticle:ModelTypes["ArticleCreateResult"],
	deleteArticle:ModelTypes["ArticleDeleteResult"],
	updateArticle:ModelTypes["ArticleUpdateResult"],
	upsertArticle:ModelTypes["ArticleUpsertResult"],
	createArticleAuthor:ModelTypes["ArticleAuthorCreateResult"],
	deleteArticleAuthor:ModelTypes["ArticleAuthorDeleteResult"],
	updateArticleAuthor:ModelTypes["ArticleAuthorUpdateResult"],
	upsertArticleAuthor:ModelTypes["ArticleAuthorUpsertResult"],
	createAuthor:ModelTypes["AuthorCreateResult"],
	deleteAuthor:ModelTypes["AuthorDeleteResult"],
	updateAuthor:ModelTypes["AuthorUpdateResult"],
	upsertAuthor:ModelTypes["AuthorUpsertResult"],
	createAuthorTopArticle:ModelTypes["AuthorTopArticleCreateResult"],
	deleteAuthorTopArticle:ModelTypes["AuthorTopArticleDeleteResult"],
	updateAuthorTopArticle:ModelTypes["AuthorTopArticleUpdateResult"],
	upsertAuthorTopArticle:ModelTypes["AuthorTopArticleUpsertResult"],
	createContent:ModelTypes["ContentCreateResult"],
	deleteContent:ModelTypes["ContentDeleteResult"],
	updateContent:ModelTypes["ContentUpdateResult"],
	upsertContent:ModelTypes["ContentUpsertResult"],
	createContentPart:ModelTypes["ContentPartCreateResult"],
	deleteContentPart:ModelTypes["ContentPartDeleteResult"],
	updateContentPart:ModelTypes["ContentPartUpdateResult"],
	upsertContentPart:ModelTypes["ContentPartUpsertResult"],
	createContentReference:ModelTypes["ContentReferenceCreateResult"],
	deleteContentReference:ModelTypes["ContentReferenceDeleteResult"],
	updateContentReference:ModelTypes["ContentReferenceUpdateResult"],
	upsertContentReference:ModelTypes["ContentReferenceUpsertResult"],
	createHomepageArticle:ModelTypes["HomepageArticleCreateResult"],
	deleteHomepageArticle:ModelTypes["HomepageArticleDeleteResult"],
	updateHomepageArticle:ModelTypes["HomepageArticleUpdateResult"],
	upsertHomepageArticle:ModelTypes["HomepageArticleUpsertResult"],
	createImage:ModelTypes["ImageCreateResult"],
	deleteImage:ModelTypes["ImageDeleteResult"],
	updateImage:ModelTypes["ImageUpdateResult"],
	upsertImage:ModelTypes["ImageUpsertResult"],
	createImageUse:ModelTypes["ImageUseCreateResult"],
	deleteImageUse:ModelTypes["ImageUseDeleteResult"],
	updateImageUse:ModelTypes["ImageUseUpdateResult"],
	upsertImageUse:ModelTypes["ImageUseUpsertResult"],
	createImageTag:ModelTypes["ImageTagCreateResult"],
	deleteImageTag:ModelTypes["ImageTagDeleteResult"],
	updateImageTag:ModelTypes["ImageTagUpdateResult"],
	upsertImageTag:ModelTypes["ImageTagUpsertResult"],
	createIssue:ModelTypes["IssueCreateResult"],
	deleteIssue:ModelTypes["IssueDeleteResult"],
	updateIssue:ModelTypes["IssueUpdateResult"],
	upsertIssue:ModelTypes["IssueUpsertResult"],
	createIssueArticle:ModelTypes["IssueArticleCreateResult"],
	deleteIssueArticle:ModelTypes["IssueArticleDeleteResult"],
	updateIssueArticle:ModelTypes["IssueArticleUpdateResult"],
	upsertIssueArticle:ModelTypes["IssueArticleUpsertResult"],
	createLink:ModelTypes["LinkCreateResult"],
	deleteLink:ModelTypes["LinkDeleteResult"],
	updateLink:ModelTypes["LinkUpdateResult"],
	upsertLink:ModelTypes["LinkUpsertResult"],
	createTextContent:ModelTypes["TextContentCreateResult"],
	deleteTextContent:ModelTypes["TextContentDeleteResult"],
	updateTextContent:ModelTypes["TextContentUpdateResult"],
	upsertTextContent:ModelTypes["TextContentUpsertResult"],
	createTextContentPart:ModelTypes["TextContentPartCreateResult"],
	deleteTextContentPart:ModelTypes["TextContentPartDeleteResult"],
	updateTextContentPart:ModelTypes["TextContentPartUpdateResult"],
	upsertTextContentPart:ModelTypes["TextContentPartUpsertResult"],
	createTextContentReference:ModelTypes["TextContentReferenceCreateResult"],
	deleteTextContentReference:ModelTypes["TextContentReferenceDeleteResult"],
	updateTextContentReference:ModelTypes["TextContentReferenceUpdateResult"],
	upsertTextContentReference:ModelTypes["TextContentReferenceUpsertResult"],
	createUrl:ModelTypes["UrlCreateResult"],
	deleteUrl:ModelTypes["UrlDeleteResult"],
	updateUrl:ModelTypes["UrlUpdateResult"],
	upsertUrl:ModelTypes["UrlUpsertResult"],
	createArticleTag:ModelTypes["ArticleTagCreateResult"],
	deleteArticleTag:ModelTypes["ArticleTagDeleteResult"],
	updateArticleTag:ModelTypes["ArticleTagUpdateResult"],
	upsertArticleTag:ModelTypes["ArticleTagUpsertResult"],
	createCategory:ModelTypes["CategoryCreateResult"],
	deleteCategory:ModelTypes["CategoryDeleteResult"],
	updateCategory:ModelTypes["CategoryUpdateResult"],
	upsertCategory:ModelTypes["CategoryUpsertResult"],
	createArticleCategory:ModelTypes["ArticleCategoryCreateResult"],
	deleteArticleCategory:ModelTypes["ArticleCategoryDeleteResult"],
	updateArticleCategory:ModelTypes["ArticleCategoryUpdateResult"],
	upsertArticleCategory:ModelTypes["ArticleCategoryUpsertResult"],
	createAudio:ModelTypes["AudioCreateResult"],
	deleteAudio:ModelTypes["AudioDeleteResult"],
	updateAudio:ModelTypes["AudioUpdateResult"],
	upsertAudio:ModelTypes["AudioUpsertResult"],
	createAudioUse:ModelTypes["AudioUseCreateResult"],
	deleteAudioUse:ModelTypes["AudioUseDeleteResult"],
	updateAudioUse:ModelTypes["AudioUseUpdateResult"],
	upsertAudioUse:ModelTypes["AudioUseUpsertResult"],
	createEmbed:ModelTypes["EmbedCreateResult"],
	deleteEmbed:ModelTypes["EmbedDeleteResult"],
	updateEmbed:ModelTypes["EmbedUpdateResult"],
	upsertEmbed:ModelTypes["EmbedUpsertResult"],
	createImageContent:ModelTypes["ImageContentCreateResult"],
	deleteImageContent:ModelTypes["ImageContentDeleteResult"],
	updateImageContent:ModelTypes["ImageContentUpdateResult"],
	upsertImageContent:ModelTypes["ImageContentUpsertResult"],
	createListicle:ModelTypes["ListicleCreateResult"],
	deleteListicle:ModelTypes["ListicleDeleteResult"],
	updateListicle:ModelTypes["ListicleUpdateResult"],
	upsertListicle:ModelTypes["ListicleUpsertResult"],
	createPollAnswer:ModelTypes["PollAnswerCreateResult"],
	deletePollAnswer:ModelTypes["PollAnswerDeleteResult"],
	updatePollAnswer:ModelTypes["PollAnswerUpdateResult"],
	upsertPollAnswer:ModelTypes["PollAnswerUpsertResult"],
	createTag:ModelTypes["TagCreateResult"],
	deleteTag:ModelTypes["TagDeleteResult"],
	updateTag:ModelTypes["TagUpdateResult"],
	upsertTag:ModelTypes["TagUpsertResult"],
	createFAQ:ModelTypes["FAQCreateResult"],
	deleteFAQ:ModelTypes["FAQDeleteResult"],
	updateFAQ:ModelTypes["FAQUpdateResult"],
	upsertFAQ:ModelTypes["FAQUpsertResult"],
	createLinkContent:ModelTypes["LinkContentCreateResult"],
	deleteLinkContent:ModelTypes["LinkContentDeleteResult"],
	updateLinkContent:ModelTypes["LinkContentUpdateResult"],
	upsertLinkContent:ModelTypes["LinkContentUpsertResult"],
	createAwardContent:ModelTypes["AwardContentCreateResult"],
	deleteAwardContent:ModelTypes["AwardContentDeleteResult"],
	updateAwardContent:ModelTypes["AwardContentUpdateResult"],
	upsertAwardContent:ModelTypes["AwardContentUpsertResult"],
	createReviewContent:ModelTypes["ReviewContentCreateResult"],
	deleteReviewContent:ModelTypes["ReviewContentDeleteResult"],
	updateReviewContent:ModelTypes["ReviewContentUpdateResult"],
	upsertReviewContent:ModelTypes["ReviewContentUpsertResult"],
	createPage:ModelTypes["PageCreateResult"],
	deletePage:ModelTypes["PageDeleteResult"],
	updatePage:ModelTypes["PageUpdateResult"],
	upsertPage:ModelTypes["PageUpsertResult"],
	createTextTranslation:ModelTypes["TextTranslationCreateResult"],
	deleteTextTranslation:ModelTypes["TextTranslationDeleteResult"],
	updateTextTranslation:ModelTypes["TextTranslationUpdateResult"],
	upsertTextTranslation:ModelTypes["TextTranslationUpsertResult"],
	createSeo:ModelTypes["SeoCreateResult"],
	deleteSeo:ModelTypes["SeoDeleteResult"],
	updateSeo:ModelTypes["SeoUpdateResult"],
	upsertSeo:ModelTypes["SeoUpsertResult"],
	createFile:ModelTypes["FileCreateResult"],
	deleteFile:ModelTypes["FileDeleteResult"],
	updateFile:ModelTypes["FileUpdateResult"],
	upsertFile:ModelTypes["FileUpsertResult"],
	createFileUse:ModelTypes["FileUseCreateResult"],
	deleteFileUse:ModelTypes["FileUseDeleteResult"],
	updateFileUse:ModelTypes["FileUseUpdateResult"],
	upsertFileUse:ModelTypes["FileUseUpsertResult"],
	createContentBlock:ModelTypes["ContentBlockCreateResult"],
	deleteContentBlock:ModelTypes["ContentBlockDeleteResult"],
	updateContentBlock:ModelTypes["ContentBlockUpdateResult"],
	upsertContentBlock:ModelTypes["ContentBlockUpsertResult"],
	createContentArticle:ModelTypes["ContentArticleCreateResult"],
	deleteContentArticle:ModelTypes["ContentArticleDeleteResult"],
	updateContentArticle:ModelTypes["ContentArticleUpdateResult"],
	upsertContentArticle:ModelTypes["ContentArticleUpsertResult"],
	createUnlockedArticle:ModelTypes["UnlockedArticleCreateResult"],
	deleteUnlockedArticle:ModelTypes["UnlockedArticleDeleteResult"],
	updateUnlockedArticle:ModelTypes["UnlockedArticleUpdateResult"],
	upsertUnlockedArticle:ModelTypes["UnlockedArticleUpsertResult"],
	createUser:ModelTypes["UserCreateResult"],
	deleteUser:ModelTypes["UserDeleteResult"],
	updateUser:ModelTypes["UserUpdateResult"],
	upsertUser:ModelTypes["UserUpsertResult"],
	createNotification:ModelTypes["NotificationCreateResult"],
	deleteNotification:ModelTypes["NotificationDeleteResult"],
	updateNotification:ModelTypes["NotificationUpdateResult"],
	upsertNotification:ModelTypes["NotificationUpsertResult"],
	createAppReview:ModelTypes["AppReviewCreateResult"],
	deleteAppReview:ModelTypes["AppReviewDeleteResult"],
	updateAppReview:ModelTypes["AppReviewUpdateResult"],
	upsertAppReview:ModelTypes["AppReviewUpsertResult"],
	createProduct:ModelTypes["ProductCreateResult"],
	deleteProduct:ModelTypes["ProductDeleteResult"],
	updateProduct:ModelTypes["ProductUpdateResult"],
	upsertProduct:ModelTypes["ProductUpsertResult"],
	createSubscriptionForm:ModelTypes["SubscriptionFormCreateResult"],
	deleteSubscriptionForm:ModelTypes["SubscriptionFormDeleteResult"],
	updateSubscriptionForm:ModelTypes["SubscriptionFormUpdateResult"],
	upsertSubscriptionForm:ModelTypes["SubscriptionFormUpsertResult"],
	createSubscriptionFormSection:ModelTypes["SubscriptionFormSectionCreateResult"],
	deleteSubscriptionFormSection:ModelTypes["SubscriptionFormSectionDeleteResult"],
	updateSubscriptionFormSection:ModelTypes["SubscriptionFormSectionUpdateResult"],
	upsertSubscriptionFormSection:ModelTypes["SubscriptionFormSectionUpsertResult"],
	createSubscriptionFormInput:ModelTypes["SubscriptionFormInputCreateResult"],
	deleteSubscriptionFormInput:ModelTypes["SubscriptionFormInputDeleteResult"],
	updateSubscriptionFormInput:ModelTypes["SubscriptionFormInputUpdateResult"],
	upsertSubscriptionFormInput:ModelTypes["SubscriptionFormInputUpsertResult"],
	createSubscriptionFormOption:ModelTypes["SubscriptionFormOptionCreateResult"],
	deleteSubscriptionFormOption:ModelTypes["SubscriptionFormOptionDeleteResult"],
	updateSubscriptionFormOption:ModelTypes["SubscriptionFormOptionUpdateResult"],
	upsertSubscriptionFormOption:ModelTypes["SubscriptionFormOptionUpsertResult"],
	createButton:ModelTypes["ButtonCreateResult"],
	deleteButton:ModelTypes["ButtonDeleteResult"],
	updateButton:ModelTypes["ButtonUpdateResult"],
	upsertButton:ModelTypes["ButtonUpsertResult"],
	createArticleHistoryTag:ModelTypes["ArticleHistoryTagCreateResult"],
	deleteArticleHistoryTag:ModelTypes["ArticleHistoryTagDeleteResult"],
	updateArticleHistoryTag:ModelTypes["ArticleHistoryTagUpdateResult"],
	upsertArticleHistoryTag:ModelTypes["ArticleHistoryTagUpsertResult"],
	createArticleHistoryPeriod:ModelTypes["ArticleHistoryPeriodCreateResult"],
	deleteArticleHistoryPeriod:ModelTypes["ArticleHistoryPeriodDeleteResult"],
	updateArticleHistoryPeriod:ModelTypes["ArticleHistoryPeriodUpdateResult"],
	upsertArticleHistoryPeriod:ModelTypes["ArticleHistoryPeriodUpsertResult"],
	createHistoryTag:ModelTypes["HistoryTagCreateResult"],
	deleteHistoryTag:ModelTypes["HistoryTagDeleteResult"],
	updateHistoryTag:ModelTypes["HistoryTagUpdateResult"],
	upsertHistoryTag:ModelTypes["HistoryTagUpsertResult"],
	createHistoryPeriod:ModelTypes["HistoryPeriodCreateResult"],
	deleteHistoryPeriod:ModelTypes["HistoryPeriodDeleteResult"],
	updateHistoryPeriod:ModelTypes["HistoryPeriodUpdateResult"],
	upsertHistoryPeriod:ModelTypes["HistoryPeriodUpsertResult"],
	createHistoryHomePage:ModelTypes["HistoryHomePageCreateResult"],
	deleteHistoryHomePage:ModelTypes["HistoryHomePageDeleteResult"],
	updateHistoryHomePage:ModelTypes["HistoryHomePageUpdateResult"],
	upsertHistoryHomePage:ModelTypes["HistoryHomePageUpsertResult"],
	createHistoryCover:ModelTypes["HistoryCoverCreateResult"],
	deleteHistoryCover:ModelTypes["HistoryCoverDeleteResult"],
	updateHistoryCover:ModelTypes["HistoryCoverUpdateResult"],
	upsertHistoryCover:ModelTypes["HistoryCoverUpsertResult"],
	createHistoryTextList:ModelTypes["HistoryTextListCreateResult"],
	deleteHistoryTextList:ModelTypes["HistoryTextListDeleteResult"],
	updateHistoryTextList:ModelTypes["HistoryTextListUpdateResult"],
	upsertHistoryTextList:ModelTypes["HistoryTextListUpsertResult"],
	createHistoryTextItem:ModelTypes["HistoryTextItemCreateResult"],
	deleteHistoryTextItem:ModelTypes["HistoryTextItemDeleteResult"],
	updateHistoryTextItem:ModelTypes["HistoryTextItemUpdateResult"],
	upsertHistoryTextItem:ModelTypes["HistoryTextItemUpsertResult"],
	createFooterMenu:ModelTypes["FooterMenuCreateResult"],
	deleteFooterMenu:ModelTypes["FooterMenuDeleteResult"],
	updateFooterMenu:ModelTypes["FooterMenuUpdateResult"],
	upsertFooterMenu:ModelTypes["FooterMenuUpsertResult"],
	createLinkSection:ModelTypes["LinkSectionCreateResult"],
	deleteLinkSection:ModelTypes["LinkSectionDeleteResult"],
	updateLinkSection:ModelTypes["LinkSectionUpdateResult"],
	upsertLinkSection:ModelTypes["LinkSectionUpsertResult"],
	createLinkList:ModelTypes["LinkListCreateResult"],
	deleteLinkList:ModelTypes["LinkListDeleteResult"],
	updateLinkList:ModelTypes["LinkListUpdateResult"],
	upsertLinkList:ModelTypes["LinkListUpsertResult"],
	createLinkItem:ModelTypes["LinkItemCreateResult"],
	deleteLinkItem:ModelTypes["LinkItemDeleteResult"],
	updateLinkItem:ModelTypes["LinkItemUpdateResult"],
	upsertLinkItem:ModelTypes["LinkItemUpsertResult"],
	createNewsletterSection:ModelTypes["NewsletterSectionCreateResult"],
	deleteNewsletterSection:ModelTypes["NewsletterSectionDeleteResult"],
	updateNewsletterSection:ModelTypes["NewsletterSectionUpdateResult"],
	upsertNewsletterSection:ModelTypes["NewsletterSectionUpsertResult"],
	createNewsletter:ModelTypes["NewsletterCreateResult"],
	deleteNewsletter:ModelTypes["NewsletterDeleteResult"],
	updateNewsletter:ModelTypes["NewsletterUpdateResult"],
	upsertNewsletter:ModelTypes["NewsletterUpsertResult"],
	createOnlineSection:ModelTypes["OnlineSectionCreateResult"],
	deleteOnlineSection:ModelTypes["OnlineSectionDeleteResult"],
	updateOnlineSection:ModelTypes["OnlineSectionUpdateResult"],
	upsertOnlineSection:ModelTypes["OnlineSectionUpsertResult"],
	createAppLink:ModelTypes["AppLinkCreateResult"],
	deleteAppLink:ModelTypes["AppLinkDeleteResult"],
	updateAppLink:ModelTypes["AppLinkUpdateResult"],
	upsertAppLink:ModelTypes["AppLinkUpsertResult"],
	createAppLinkList:ModelTypes["AppLinkListCreateResult"],
	deleteAppLinkList:ModelTypes["AppLinkListDeleteResult"],
	updateAppLinkList:ModelTypes["AppLinkListUpdateResult"],
	upsertAppLinkList:ModelTypes["AppLinkListUpsertResult"],
	createAppLinkItem:ModelTypes["AppLinkItemCreateResult"],
	deleteAppLinkItem:ModelTypes["AppLinkItemDeleteResult"],
	updateAppLinkItem:ModelTypes["AppLinkItemUpdateResult"],
	upsertAppLinkItem:ModelTypes["AppLinkItemUpsertResult"],
	createSocialSection:ModelTypes["SocialSectionCreateResult"],
	deleteSocialSection:ModelTypes["SocialSectionDeleteResult"],
	updateSocialSection:ModelTypes["SocialSectionUpdateResult"],
	upsertSocialSection:ModelTypes["SocialSectionUpsertResult"],
	createSocialLink:ModelTypes["SocialLinkCreateResult"],
	deleteSocialLink:ModelTypes["SocialLinkDeleteResult"],
	updateSocialLink:ModelTypes["SocialLinkUpdateResult"],
	upsertSocialLink:ModelTypes["SocialLinkUpsertResult"],
	createSocialLinkList:ModelTypes["SocialLinkListCreateResult"],
	deleteSocialLinkList:ModelTypes["SocialLinkListDeleteResult"],
	updateSocialLinkList:ModelTypes["SocialLinkListUpdateResult"],
	upsertSocialLinkList:ModelTypes["SocialLinkListUpsertResult"],
	createSocialLinkItem:ModelTypes["SocialLinkItemCreateResult"],
	deleteSocialLinkItem:ModelTypes["SocialLinkItemDeleteResult"],
	updateSocialLinkItem:ModelTypes["SocialLinkItemUpdateResult"],
	upsertSocialLinkItem:ModelTypes["SocialLinkItemUpsertResult"],
	createSharedContent:ModelTypes["SharedContentCreateResult"],
	deleteSharedContent:ModelTypes["SharedContentDeleteResult"],
	updateSharedContent:ModelTypes["SharedContentUpdateResult"],
	upsertSharedContent:ModelTypes["SharedContentUpsertResult"],
	transaction:ModelTypes["MutationTransaction"],
	query:ModelTypes["Query"],
	generateUploadUrl:ModelTypes["S3SignedUpload"],
	generateReadUrl:ModelTypes["S3SignedRead"]
};
	["ArticleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Article"],
	validation:ModelTypes["_ValidationResult"]
};
	["MutationResult"]: ModelTypes["ArticleCreateResult"] | ModelTypes["ArticleDeleteResult"] | ModelTypes["ArticleUpdateResult"] | ModelTypes["ArticleUpsertResult"] | ModelTypes["ArticleAuthorCreateResult"] | ModelTypes["ArticleAuthorDeleteResult"] | ModelTypes["ArticleAuthorUpdateResult"] | ModelTypes["ArticleAuthorUpsertResult"] | ModelTypes["AuthorCreateResult"] | ModelTypes["AuthorDeleteResult"] | ModelTypes["AuthorUpdateResult"] | ModelTypes["AuthorUpsertResult"] | ModelTypes["AuthorTopArticleCreateResult"] | ModelTypes["AuthorTopArticleDeleteResult"] | ModelTypes["AuthorTopArticleUpdateResult"] | ModelTypes["AuthorTopArticleUpsertResult"] | ModelTypes["ContentCreateResult"] | ModelTypes["ContentDeleteResult"] | ModelTypes["ContentUpdateResult"] | ModelTypes["ContentUpsertResult"] | ModelTypes["ContentPartCreateResult"] | ModelTypes["ContentPartDeleteResult"] | ModelTypes["ContentPartUpdateResult"] | ModelTypes["ContentPartUpsertResult"] | ModelTypes["ContentReferenceCreateResult"] | ModelTypes["ContentReferenceDeleteResult"] | ModelTypes["ContentReferenceUpdateResult"] | ModelTypes["ContentReferenceUpsertResult"] | ModelTypes["HomepageArticleCreateResult"] | ModelTypes["HomepageArticleDeleteResult"] | ModelTypes["HomepageArticleUpdateResult"] | ModelTypes["HomepageArticleUpsertResult"] | ModelTypes["ImageCreateResult"] | ModelTypes["ImageDeleteResult"] | ModelTypes["ImageUpdateResult"] | ModelTypes["ImageUpsertResult"] | ModelTypes["ImageUseCreateResult"] | ModelTypes["ImageUseDeleteResult"] | ModelTypes["ImageUseUpdateResult"] | ModelTypes["ImageUseUpsertResult"] | ModelTypes["ImageTagCreateResult"] | ModelTypes["ImageTagDeleteResult"] | ModelTypes["ImageTagUpdateResult"] | ModelTypes["ImageTagUpsertResult"] | ModelTypes["IssueCreateResult"] | ModelTypes["IssueDeleteResult"] | ModelTypes["IssueUpdateResult"] | ModelTypes["IssueUpsertResult"] | ModelTypes["IssueArticleCreateResult"] | ModelTypes["IssueArticleDeleteResult"] | ModelTypes["IssueArticleUpdateResult"] | ModelTypes["IssueArticleUpsertResult"] | ModelTypes["LinkCreateResult"] | ModelTypes["LinkDeleteResult"] | ModelTypes["LinkUpdateResult"] | ModelTypes["LinkUpsertResult"] | ModelTypes["TextContentCreateResult"] | ModelTypes["TextContentDeleteResult"] | ModelTypes["TextContentUpdateResult"] | ModelTypes["TextContentUpsertResult"] | ModelTypes["TextContentPartCreateResult"] | ModelTypes["TextContentPartDeleteResult"] | ModelTypes["TextContentPartUpdateResult"] | ModelTypes["TextContentPartUpsertResult"] | ModelTypes["TextContentReferenceCreateResult"] | ModelTypes["TextContentReferenceDeleteResult"] | ModelTypes["TextContentReferenceUpdateResult"] | ModelTypes["TextContentReferenceUpsertResult"] | ModelTypes["UrlCreateResult"] | ModelTypes["UrlDeleteResult"] | ModelTypes["UrlUpdateResult"] | ModelTypes["UrlUpsertResult"] | ModelTypes["ArticleTagCreateResult"] | ModelTypes["ArticleTagDeleteResult"] | ModelTypes["ArticleTagUpdateResult"] | ModelTypes["ArticleTagUpsertResult"] | ModelTypes["CategoryCreateResult"] | ModelTypes["CategoryDeleteResult"] | ModelTypes["CategoryUpdateResult"] | ModelTypes["CategoryUpsertResult"] | ModelTypes["ArticleCategoryCreateResult"] | ModelTypes["ArticleCategoryDeleteResult"] | ModelTypes["ArticleCategoryUpdateResult"] | ModelTypes["ArticleCategoryUpsertResult"] | ModelTypes["AudioCreateResult"] | ModelTypes["AudioDeleteResult"] | ModelTypes["AudioUpdateResult"] | ModelTypes["AudioUpsertResult"] | ModelTypes["AudioUseCreateResult"] | ModelTypes["AudioUseDeleteResult"] | ModelTypes["AudioUseUpdateResult"] | ModelTypes["AudioUseUpsertResult"] | ModelTypes["EmbedCreateResult"] | ModelTypes["EmbedDeleteResult"] | ModelTypes["EmbedUpdateResult"] | ModelTypes["EmbedUpsertResult"] | ModelTypes["ImageContentCreateResult"] | ModelTypes["ImageContentDeleteResult"] | ModelTypes["ImageContentUpdateResult"] | ModelTypes["ImageContentUpsertResult"] | ModelTypes["ListicleCreateResult"] | ModelTypes["ListicleDeleteResult"] | ModelTypes["ListicleUpdateResult"] | ModelTypes["ListicleUpsertResult"] | ModelTypes["PollAnswerCreateResult"] | ModelTypes["PollAnswerDeleteResult"] | ModelTypes["PollAnswerUpdateResult"] | ModelTypes["PollAnswerUpsertResult"] | ModelTypes["TagCreateResult"] | ModelTypes["TagDeleteResult"] | ModelTypes["TagUpdateResult"] | ModelTypes["TagUpsertResult"] | ModelTypes["FAQCreateResult"] | ModelTypes["FAQDeleteResult"] | ModelTypes["FAQUpdateResult"] | ModelTypes["FAQUpsertResult"] | ModelTypes["LinkContentCreateResult"] | ModelTypes["LinkContentDeleteResult"] | ModelTypes["LinkContentUpdateResult"] | ModelTypes["LinkContentUpsertResult"] | ModelTypes["AwardContentCreateResult"] | ModelTypes["AwardContentDeleteResult"] | ModelTypes["AwardContentUpdateResult"] | ModelTypes["AwardContentUpsertResult"] | ModelTypes["ReviewContentCreateResult"] | ModelTypes["ReviewContentDeleteResult"] | ModelTypes["ReviewContentUpdateResult"] | ModelTypes["ReviewContentUpsertResult"] | ModelTypes["PageCreateResult"] | ModelTypes["PageDeleteResult"] | ModelTypes["PageUpdateResult"] | ModelTypes["PageUpsertResult"] | ModelTypes["TextTranslationCreateResult"] | ModelTypes["TextTranslationDeleteResult"] | ModelTypes["TextTranslationUpdateResult"] | ModelTypes["TextTranslationUpsertResult"] | ModelTypes["SeoCreateResult"] | ModelTypes["SeoDeleteResult"] | ModelTypes["SeoUpdateResult"] | ModelTypes["SeoUpsertResult"] | ModelTypes["FileCreateResult"] | ModelTypes["FileDeleteResult"] | ModelTypes["FileUpdateResult"] | ModelTypes["FileUpsertResult"] | ModelTypes["FileUseCreateResult"] | ModelTypes["FileUseDeleteResult"] | ModelTypes["FileUseUpdateResult"] | ModelTypes["FileUseUpsertResult"] | ModelTypes["ContentBlockCreateResult"] | ModelTypes["ContentBlockDeleteResult"] | ModelTypes["ContentBlockUpdateResult"] | ModelTypes["ContentBlockUpsertResult"] | ModelTypes["ContentArticleCreateResult"] | ModelTypes["ContentArticleDeleteResult"] | ModelTypes["ContentArticleUpdateResult"] | ModelTypes["ContentArticleUpsertResult"] | ModelTypes["UnlockedArticleCreateResult"] | ModelTypes["UnlockedArticleDeleteResult"] | ModelTypes["UnlockedArticleUpdateResult"] | ModelTypes["UnlockedArticleUpsertResult"] | ModelTypes["UserCreateResult"] | ModelTypes["UserDeleteResult"] | ModelTypes["UserUpdateResult"] | ModelTypes["UserUpsertResult"] | ModelTypes["NotificationCreateResult"] | ModelTypes["NotificationDeleteResult"] | ModelTypes["NotificationUpdateResult"] | ModelTypes["NotificationUpsertResult"] | ModelTypes["AppReviewCreateResult"] | ModelTypes["AppReviewDeleteResult"] | ModelTypes["AppReviewUpdateResult"] | ModelTypes["AppReviewUpsertResult"] | ModelTypes["ProductCreateResult"] | ModelTypes["ProductDeleteResult"] | ModelTypes["ProductUpdateResult"] | ModelTypes["ProductUpsertResult"] | ModelTypes["SubscriptionFormCreateResult"] | ModelTypes["SubscriptionFormDeleteResult"] | ModelTypes["SubscriptionFormUpdateResult"] | ModelTypes["SubscriptionFormUpsertResult"] | ModelTypes["SubscriptionFormSectionCreateResult"] | ModelTypes["SubscriptionFormSectionDeleteResult"] | ModelTypes["SubscriptionFormSectionUpdateResult"] | ModelTypes["SubscriptionFormSectionUpsertResult"] | ModelTypes["SubscriptionFormInputCreateResult"] | ModelTypes["SubscriptionFormInputDeleteResult"] | ModelTypes["SubscriptionFormInputUpdateResult"] | ModelTypes["SubscriptionFormInputUpsertResult"] | ModelTypes["SubscriptionFormOptionCreateResult"] | ModelTypes["SubscriptionFormOptionDeleteResult"] | ModelTypes["SubscriptionFormOptionUpdateResult"] | ModelTypes["SubscriptionFormOptionUpsertResult"] | ModelTypes["ButtonCreateResult"] | ModelTypes["ButtonDeleteResult"] | ModelTypes["ButtonUpdateResult"] | ModelTypes["ButtonUpsertResult"] | ModelTypes["ArticleHistoryTagCreateResult"] | ModelTypes["ArticleHistoryTagDeleteResult"] | ModelTypes["ArticleHistoryTagUpdateResult"] | ModelTypes["ArticleHistoryTagUpsertResult"] | ModelTypes["ArticleHistoryPeriodCreateResult"] | ModelTypes["ArticleHistoryPeriodDeleteResult"] | ModelTypes["ArticleHistoryPeriodUpdateResult"] | ModelTypes["ArticleHistoryPeriodUpsertResult"] | ModelTypes["HistoryTagCreateResult"] | ModelTypes["HistoryTagDeleteResult"] | ModelTypes["HistoryTagUpdateResult"] | ModelTypes["HistoryTagUpsertResult"] | ModelTypes["HistoryPeriodCreateResult"] | ModelTypes["HistoryPeriodDeleteResult"] | ModelTypes["HistoryPeriodUpdateResult"] | ModelTypes["HistoryPeriodUpsertResult"] | ModelTypes["HistoryHomePageCreateResult"] | ModelTypes["HistoryHomePageDeleteResult"] | ModelTypes["HistoryHomePageUpdateResult"] | ModelTypes["HistoryHomePageUpsertResult"] | ModelTypes["HistoryCoverCreateResult"] | ModelTypes["HistoryCoverDeleteResult"] | ModelTypes["HistoryCoverUpdateResult"] | ModelTypes["HistoryCoverUpsertResult"] | ModelTypes["HistoryTextListCreateResult"] | ModelTypes["HistoryTextListDeleteResult"] | ModelTypes["HistoryTextListUpdateResult"] | ModelTypes["HistoryTextListUpsertResult"] | ModelTypes["HistoryTextItemCreateResult"] | ModelTypes["HistoryTextItemDeleteResult"] | ModelTypes["HistoryTextItemUpdateResult"] | ModelTypes["HistoryTextItemUpsertResult"] | ModelTypes["FooterMenuCreateResult"] | ModelTypes["FooterMenuDeleteResult"] | ModelTypes["FooterMenuUpdateResult"] | ModelTypes["FooterMenuUpsertResult"] | ModelTypes["LinkSectionCreateResult"] | ModelTypes["LinkSectionDeleteResult"] | ModelTypes["LinkSectionUpdateResult"] | ModelTypes["LinkSectionUpsertResult"] | ModelTypes["LinkListCreateResult"] | ModelTypes["LinkListDeleteResult"] | ModelTypes["LinkListUpdateResult"] | ModelTypes["LinkListUpsertResult"] | ModelTypes["LinkItemCreateResult"] | ModelTypes["LinkItemDeleteResult"] | ModelTypes["LinkItemUpdateResult"] | ModelTypes["LinkItemUpsertResult"] | ModelTypes["NewsletterSectionCreateResult"] | ModelTypes["NewsletterSectionDeleteResult"] | ModelTypes["NewsletterSectionUpdateResult"] | ModelTypes["NewsletterSectionUpsertResult"] | ModelTypes["NewsletterCreateResult"] | ModelTypes["NewsletterDeleteResult"] | ModelTypes["NewsletterUpdateResult"] | ModelTypes["NewsletterUpsertResult"] | ModelTypes["OnlineSectionCreateResult"] | ModelTypes["OnlineSectionDeleteResult"] | ModelTypes["OnlineSectionUpdateResult"] | ModelTypes["OnlineSectionUpsertResult"] | ModelTypes["AppLinkCreateResult"] | ModelTypes["AppLinkDeleteResult"] | ModelTypes["AppLinkUpdateResult"] | ModelTypes["AppLinkUpsertResult"] | ModelTypes["AppLinkListCreateResult"] | ModelTypes["AppLinkListDeleteResult"] | ModelTypes["AppLinkListUpdateResult"] | ModelTypes["AppLinkListUpsertResult"] | ModelTypes["AppLinkItemCreateResult"] | ModelTypes["AppLinkItemDeleteResult"] | ModelTypes["AppLinkItemUpdateResult"] | ModelTypes["AppLinkItemUpsertResult"] | ModelTypes["SocialSectionCreateResult"] | ModelTypes["SocialSectionDeleteResult"] | ModelTypes["SocialSectionUpdateResult"] | ModelTypes["SocialSectionUpsertResult"] | ModelTypes["SocialLinkCreateResult"] | ModelTypes["SocialLinkDeleteResult"] | ModelTypes["SocialLinkUpdateResult"] | ModelTypes["SocialLinkUpsertResult"] | ModelTypes["SocialLinkListCreateResult"] | ModelTypes["SocialLinkListDeleteResult"] | ModelTypes["SocialLinkListUpdateResult"] | ModelTypes["SocialLinkListUpsertResult"] | ModelTypes["SocialLinkItemCreateResult"] | ModelTypes["SocialLinkItemDeleteResult"] | ModelTypes["SocialLinkItemUpdateResult"] | ModelTypes["SocialLinkItemUpsertResult"] | ModelTypes["SharedContentCreateResult"] | ModelTypes["SharedContentDeleteResult"] | ModelTypes["SharedContentUpdateResult"] | ModelTypes["SharedContentUpsertResult"];
	["_MutationError"]: {
		path:ModelTypes["_PathFragment"][],
	paths:ModelTypes["_PathFragment"][],
	type:ModelTypes["_MutationErrorType"],
	message?:string
};
	["_MutationErrorType"]: GraphQLTypes["_MutationErrorType"];
	["ArticleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Article"]
};
	["ArticleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Article"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArticleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Article"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArticleAuthorCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArticleAuthor"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArticleAuthorDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArticleAuthor"]
};
	["ArticleAuthorUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArticleAuthor"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArticleAuthorUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArticleAuthor"],
	validation:ModelTypes["_ValidationResult"]
};
	["AuthorCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Author"],
	validation:ModelTypes["_ValidationResult"]
};
	["AuthorDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Author"]
};
	["AuthorUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Author"],
	validation:ModelTypes["_ValidationResult"]
};
	["AuthorUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Author"],
	validation:ModelTypes["_ValidationResult"]
};
	["AuthorTopArticleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["AuthorTopArticle"],
	validation:ModelTypes["_ValidationResult"]
};
	["AuthorTopArticleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["AuthorTopArticle"]
};
	["AuthorTopArticleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["AuthorTopArticle"],
	validation:ModelTypes["_ValidationResult"]
};
	["AuthorTopArticleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["AuthorTopArticle"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Content"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Content"]
};
	["ContentUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Content"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Content"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentPartCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentPart"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentPartDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentPart"]
};
	["ContentPartUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentPart"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentPartUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentPart"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentReferenceCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReference"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentReferenceDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReference"]
};
	["ContentReferenceUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReference"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentReferenceUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReference"],
	validation:ModelTypes["_ValidationResult"]
};
	["HomepageArticleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HomepageArticle"],
	validation:ModelTypes["_ValidationResult"]
};
	["HomepageArticleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HomepageArticle"]
};
	["HomepageArticleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HomepageArticle"],
	validation:ModelTypes["_ValidationResult"]
};
	["HomepageArticleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HomepageArticle"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"]
};
	["ImageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageUseCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageUse"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageUseDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageUse"]
};
	["ImageUseUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageUse"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageUseUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageUse"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageTagCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageTag"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageTagDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageTag"]
};
	["ImageTagUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageTag"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageTagUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageTag"],
	validation:ModelTypes["_ValidationResult"]
};
	["IssueCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Issue"],
	validation:ModelTypes["_ValidationResult"]
};
	["IssueDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Issue"]
};
	["IssueUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Issue"],
	validation:ModelTypes["_ValidationResult"]
};
	["IssueUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Issue"],
	validation:ModelTypes["_ValidationResult"]
};
	["IssueArticleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["IssueArticle"],
	validation:ModelTypes["_ValidationResult"]
};
	["IssueArticleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["IssueArticle"]
};
	["IssueArticleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["IssueArticle"],
	validation:ModelTypes["_ValidationResult"]
};
	["IssueArticleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["IssueArticle"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"]
};
	["LinkUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"],
	validation:ModelTypes["_ValidationResult"]
};
	["TextContentCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TextContent"],
	validation:ModelTypes["_ValidationResult"]
};
	["TextContentDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TextContent"]
};
	["TextContentUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TextContent"],
	validation:ModelTypes["_ValidationResult"]
};
	["TextContentUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TextContent"],
	validation:ModelTypes["_ValidationResult"]
};
	["TextContentPartCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TextContentPart"],
	validation:ModelTypes["_ValidationResult"]
};
	["TextContentPartDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TextContentPart"]
};
	["TextContentPartUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TextContentPart"],
	validation:ModelTypes["_ValidationResult"]
};
	["TextContentPartUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TextContentPart"],
	validation:ModelTypes["_ValidationResult"]
};
	["TextContentReferenceCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TextContentReference"],
	validation:ModelTypes["_ValidationResult"]
};
	["TextContentReferenceDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TextContentReference"]
};
	["TextContentReferenceUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TextContentReference"],
	validation:ModelTypes["_ValidationResult"]
};
	["TextContentReferenceUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TextContentReference"],
	validation:ModelTypes["_ValidationResult"]
};
	["UrlCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Url"],
	validation:ModelTypes["_ValidationResult"]
};
	["UrlDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Url"]
};
	["UrlUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Url"],
	validation:ModelTypes["_ValidationResult"]
};
	["UrlUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Url"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArticleTagCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArticleTag"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArticleTagDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArticleTag"]
};
	["ArticleTagUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArticleTag"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArticleTagUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArticleTag"],
	validation:ModelTypes["_ValidationResult"]
};
	["CategoryCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Category"],
	validation:ModelTypes["_ValidationResult"]
};
	["CategoryDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Category"]
};
	["CategoryUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Category"],
	validation:ModelTypes["_ValidationResult"]
};
	["CategoryUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Category"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArticleCategoryCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArticleCategory"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArticleCategoryDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArticleCategory"]
};
	["ArticleCategoryUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArticleCategory"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArticleCategoryUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArticleCategory"],
	validation:ModelTypes["_ValidationResult"]
};
	["AudioCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Audio"],
	validation:ModelTypes["_ValidationResult"]
};
	["AudioDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Audio"]
};
	["AudioUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Audio"],
	validation:ModelTypes["_ValidationResult"]
};
	["AudioUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Audio"],
	validation:ModelTypes["_ValidationResult"]
};
	["AudioUseCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["AudioUse"],
	validation:ModelTypes["_ValidationResult"]
};
	["AudioUseDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["AudioUse"]
};
	["AudioUseUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["AudioUse"],
	validation:ModelTypes["_ValidationResult"]
};
	["AudioUseUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["AudioUse"],
	validation:ModelTypes["_ValidationResult"]
};
	["EmbedCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Embed"],
	validation:ModelTypes["_ValidationResult"]
};
	["EmbedDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Embed"]
};
	["EmbedUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Embed"],
	validation:ModelTypes["_ValidationResult"]
};
	["EmbedUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Embed"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageContentCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageContent"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageContentDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageContent"]
};
	["ImageContentUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageContent"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageContentUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageContent"],
	validation:ModelTypes["_ValidationResult"]
};
	["ListicleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Listicle"],
	validation:ModelTypes["_ValidationResult"]
};
	["ListicleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Listicle"]
};
	["ListicleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Listicle"],
	validation:ModelTypes["_ValidationResult"]
};
	["ListicleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Listicle"],
	validation:ModelTypes["_ValidationResult"]
};
	["PollAnswerCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PollAnswer"],
	validation:ModelTypes["_ValidationResult"]
};
	["PollAnswerDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PollAnswer"]
};
	["PollAnswerUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PollAnswer"],
	validation:ModelTypes["_ValidationResult"]
};
	["PollAnswerUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PollAnswer"],
	validation:ModelTypes["_ValidationResult"]
};
	["TagCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Tag"],
	validation:ModelTypes["_ValidationResult"]
};
	["TagDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Tag"]
};
	["TagUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Tag"],
	validation:ModelTypes["_ValidationResult"]
};
	["TagUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Tag"],
	validation:ModelTypes["_ValidationResult"]
};
	["FAQCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FAQ"],
	validation:ModelTypes["_ValidationResult"]
};
	["FAQDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FAQ"]
};
	["FAQUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FAQ"],
	validation:ModelTypes["_ValidationResult"]
};
	["FAQUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FAQ"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkContentCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkContent"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkContentDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkContent"]
};
	["LinkContentUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkContent"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkContentUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkContent"],
	validation:ModelTypes["_ValidationResult"]
};
	["AwardContentCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["AwardContent"],
	validation:ModelTypes["_ValidationResult"]
};
	["AwardContentDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["AwardContent"]
};
	["AwardContentUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["AwardContent"],
	validation:ModelTypes["_ValidationResult"]
};
	["AwardContentUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["AwardContent"],
	validation:ModelTypes["_ValidationResult"]
};
	["ReviewContentCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ReviewContent"],
	validation:ModelTypes["_ValidationResult"]
};
	["ReviewContentDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ReviewContent"]
};
	["ReviewContentUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ReviewContent"],
	validation:ModelTypes["_ValidationResult"]
};
	["ReviewContentUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ReviewContent"],
	validation:ModelTypes["_ValidationResult"]
};
	["PageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Page"],
	validation:ModelTypes["_ValidationResult"]
};
	["PageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Page"]
};
	["PageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Page"],
	validation:ModelTypes["_ValidationResult"]
};
	["PageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Page"],
	validation:ModelTypes["_ValidationResult"]
};
	["TextTranslationCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TextTranslation"],
	validation:ModelTypes["_ValidationResult"]
};
	["TextTranslationDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TextTranslation"]
};
	["TextTranslationUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TextTranslation"],
	validation:ModelTypes["_ValidationResult"]
};
	["TextTranslationUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TextTranslation"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"]
};
	["SeoUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"],
	validation:ModelTypes["_ValidationResult"]
};
	["FileCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["File"],
	validation:ModelTypes["_ValidationResult"]
};
	["FileDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["File"]
};
	["FileUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["File"],
	validation:ModelTypes["_ValidationResult"]
};
	["FileUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["File"],
	validation:ModelTypes["_ValidationResult"]
};
	["FileUseCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FileUse"],
	validation:ModelTypes["_ValidationResult"]
};
	["FileUseDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FileUse"]
};
	["FileUseUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FileUse"],
	validation:ModelTypes["_ValidationResult"]
};
	["FileUseUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FileUse"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentBlockCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentBlock"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentBlockDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentBlock"]
};
	["ContentBlockUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentBlock"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentBlockUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentBlock"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentArticleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentArticle"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentArticleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentArticle"]
};
	["ContentArticleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentArticle"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentArticleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentArticle"],
	validation:ModelTypes["_ValidationResult"]
};
	["UnlockedArticleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["UnlockedArticle"],
	validation:ModelTypes["_ValidationResult"]
};
	["UnlockedArticleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["UnlockedArticle"]
};
	["UnlockedArticleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["UnlockedArticle"],
	validation:ModelTypes["_ValidationResult"]
};
	["UnlockedArticleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["UnlockedArticle"],
	validation:ModelTypes["_ValidationResult"]
};
	["UserCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["User"],
	validation:ModelTypes["_ValidationResult"]
};
	["UserDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["User"]
};
	["UserUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["User"],
	validation:ModelTypes["_ValidationResult"]
};
	["UserUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["User"],
	validation:ModelTypes["_ValidationResult"]
};
	["NotificationCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Notification"],
	validation:ModelTypes["_ValidationResult"]
};
	["NotificationDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Notification"]
};
	["NotificationUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Notification"],
	validation:ModelTypes["_ValidationResult"]
};
	["NotificationUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Notification"],
	validation:ModelTypes["_ValidationResult"]
};
	["AppReviewCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["AppReview"],
	validation:ModelTypes["_ValidationResult"]
};
	["AppReviewDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["AppReview"]
};
	["AppReviewUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["AppReview"],
	validation:ModelTypes["_ValidationResult"]
};
	["AppReviewUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["AppReview"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Product"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Product"]
};
	["ProductUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Product"],
	validation:ModelTypes["_ValidationResult"]
};
	["ProductUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Product"],
	validation:ModelTypes["_ValidationResult"]
};
	["SubscriptionFormCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SubscriptionForm"],
	validation:ModelTypes["_ValidationResult"]
};
	["SubscriptionFormDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SubscriptionForm"]
};
	["SubscriptionFormUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SubscriptionForm"],
	validation:ModelTypes["_ValidationResult"]
};
	["SubscriptionFormUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SubscriptionForm"],
	validation:ModelTypes["_ValidationResult"]
};
	["SubscriptionFormSectionCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SubscriptionFormSection"],
	validation:ModelTypes["_ValidationResult"]
};
	["SubscriptionFormSectionDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SubscriptionFormSection"]
};
	["SubscriptionFormSectionUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SubscriptionFormSection"],
	validation:ModelTypes["_ValidationResult"]
};
	["SubscriptionFormSectionUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SubscriptionFormSection"],
	validation:ModelTypes["_ValidationResult"]
};
	["SubscriptionFormInputCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SubscriptionFormInput"],
	validation:ModelTypes["_ValidationResult"]
};
	["SubscriptionFormInputDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SubscriptionFormInput"]
};
	["SubscriptionFormInputUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SubscriptionFormInput"],
	validation:ModelTypes["_ValidationResult"]
};
	["SubscriptionFormInputUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SubscriptionFormInput"],
	validation:ModelTypes["_ValidationResult"]
};
	["SubscriptionFormOptionCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SubscriptionFormOption"],
	validation:ModelTypes["_ValidationResult"]
};
	["SubscriptionFormOptionDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SubscriptionFormOption"]
};
	["SubscriptionFormOptionUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SubscriptionFormOption"],
	validation:ModelTypes["_ValidationResult"]
};
	["SubscriptionFormOptionUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SubscriptionFormOption"],
	validation:ModelTypes["_ValidationResult"]
};
	["ButtonCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Button"],
	validation:ModelTypes["_ValidationResult"]
};
	["ButtonDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Button"]
};
	["ButtonUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Button"],
	validation:ModelTypes["_ValidationResult"]
};
	["ButtonUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Button"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArticleHistoryTagCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArticleHistoryTag"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArticleHistoryTagDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArticleHistoryTag"]
};
	["ArticleHistoryTagUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArticleHistoryTag"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArticleHistoryTagUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArticleHistoryTag"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArticleHistoryPeriodCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArticleHistoryPeriod"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArticleHistoryPeriodDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArticleHistoryPeriod"]
};
	["ArticleHistoryPeriodUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArticleHistoryPeriod"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArticleHistoryPeriodUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArticleHistoryPeriod"],
	validation:ModelTypes["_ValidationResult"]
};
	["HistoryTagCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HistoryTag"],
	validation:ModelTypes["_ValidationResult"]
};
	["HistoryTagDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HistoryTag"]
};
	["HistoryTagUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HistoryTag"],
	validation:ModelTypes["_ValidationResult"]
};
	["HistoryTagUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HistoryTag"],
	validation:ModelTypes["_ValidationResult"]
};
	["HistoryPeriodCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HistoryPeriod"],
	validation:ModelTypes["_ValidationResult"]
};
	["HistoryPeriodDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HistoryPeriod"]
};
	["HistoryPeriodUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HistoryPeriod"],
	validation:ModelTypes["_ValidationResult"]
};
	["HistoryPeriodUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HistoryPeriod"],
	validation:ModelTypes["_ValidationResult"]
};
	["HistoryHomePageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HistoryHomePage"],
	validation:ModelTypes["_ValidationResult"]
};
	["HistoryHomePageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HistoryHomePage"]
};
	["HistoryHomePageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HistoryHomePage"],
	validation:ModelTypes["_ValidationResult"]
};
	["HistoryHomePageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HistoryHomePage"],
	validation:ModelTypes["_ValidationResult"]
};
	["HistoryCoverCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HistoryCover"],
	validation:ModelTypes["_ValidationResult"]
};
	["HistoryCoverDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HistoryCover"]
};
	["HistoryCoverUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HistoryCover"],
	validation:ModelTypes["_ValidationResult"]
};
	["HistoryCoverUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HistoryCover"],
	validation:ModelTypes["_ValidationResult"]
};
	["HistoryTextListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HistoryTextList"],
	validation:ModelTypes["_ValidationResult"]
};
	["HistoryTextListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HistoryTextList"]
};
	["HistoryTextListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HistoryTextList"],
	validation:ModelTypes["_ValidationResult"]
};
	["HistoryTextListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HistoryTextList"],
	validation:ModelTypes["_ValidationResult"]
};
	["HistoryTextItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HistoryTextItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["HistoryTextItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HistoryTextItem"]
};
	["HistoryTextItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HistoryTextItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["HistoryTextItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HistoryTextItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterMenuCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterMenu"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterMenuDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterMenu"]
};
	["FooterMenuUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterMenu"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterMenuUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterMenu"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkSectionCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkSection"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkSectionDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkSection"]
};
	["LinkSectionUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkSection"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkSectionUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkSection"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkList"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkList"]
};
	["LinkListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkList"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkList"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkItem"]
};
	["LinkItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["NewsletterSectionCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NewsletterSection"],
	validation:ModelTypes["_ValidationResult"]
};
	["NewsletterSectionDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NewsletterSection"]
};
	["NewsletterSectionUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NewsletterSection"],
	validation:ModelTypes["_ValidationResult"]
};
	["NewsletterSectionUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NewsletterSection"],
	validation:ModelTypes["_ValidationResult"]
};
	["NewsletterCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Newsletter"],
	validation:ModelTypes["_ValidationResult"]
};
	["NewsletterDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Newsletter"]
};
	["NewsletterUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Newsletter"],
	validation:ModelTypes["_ValidationResult"]
};
	["NewsletterUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Newsletter"],
	validation:ModelTypes["_ValidationResult"]
};
	["OnlineSectionCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["OnlineSection"],
	validation:ModelTypes["_ValidationResult"]
};
	["OnlineSectionDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["OnlineSection"]
};
	["OnlineSectionUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["OnlineSection"],
	validation:ModelTypes["_ValidationResult"]
};
	["OnlineSectionUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["OnlineSection"],
	validation:ModelTypes["_ValidationResult"]
};
	["AppLinkCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["AppLink"],
	validation:ModelTypes["_ValidationResult"]
};
	["AppLinkDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["AppLink"]
};
	["AppLinkUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["AppLink"],
	validation:ModelTypes["_ValidationResult"]
};
	["AppLinkUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["AppLink"],
	validation:ModelTypes["_ValidationResult"]
};
	["AppLinkListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["AppLinkList"],
	validation:ModelTypes["_ValidationResult"]
};
	["AppLinkListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["AppLinkList"]
};
	["AppLinkListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["AppLinkList"],
	validation:ModelTypes["_ValidationResult"]
};
	["AppLinkListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["AppLinkList"],
	validation:ModelTypes["_ValidationResult"]
};
	["AppLinkItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["AppLinkItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["AppLinkItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["AppLinkItem"]
};
	["AppLinkItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["AppLinkItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["AppLinkItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["AppLinkItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialSectionCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialSection"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialSectionDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialSection"]
};
	["SocialSectionUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialSection"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialSectionUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialSection"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialLinkCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLink"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialLinkDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLink"]
};
	["SocialLinkUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLink"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialLinkUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLink"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialLinkListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLinkList"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialLinkListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLinkList"]
};
	["SocialLinkListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLinkList"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialLinkListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLinkList"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialLinkItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLinkItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialLinkItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLinkItem"]
};
	["SocialLinkItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLinkItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialLinkItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLinkItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["SharedContentCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SharedContent"],
	validation:ModelTypes["_ValidationResult"]
};
	["SharedContentDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SharedContent"]
};
	["SharedContentUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SharedContent"],
	validation:ModelTypes["_ValidationResult"]
};
	["SharedContentUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SharedContent"],
	validation:ModelTypes["_ValidationResult"]
};
	["MutationTransaction"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	validation:ModelTypes["_ValidationResult"],
	createArticle:ModelTypes["ArticleCreateResult"],
	deleteArticle:ModelTypes["ArticleDeleteResult"],
	updateArticle:ModelTypes["ArticleUpdateResult"],
	upsertArticle:ModelTypes["ArticleUpsertResult"],
	createArticleAuthor:ModelTypes["ArticleAuthorCreateResult"],
	deleteArticleAuthor:ModelTypes["ArticleAuthorDeleteResult"],
	updateArticleAuthor:ModelTypes["ArticleAuthorUpdateResult"],
	upsertArticleAuthor:ModelTypes["ArticleAuthorUpsertResult"],
	createAuthor:ModelTypes["AuthorCreateResult"],
	deleteAuthor:ModelTypes["AuthorDeleteResult"],
	updateAuthor:ModelTypes["AuthorUpdateResult"],
	upsertAuthor:ModelTypes["AuthorUpsertResult"],
	createAuthorTopArticle:ModelTypes["AuthorTopArticleCreateResult"],
	deleteAuthorTopArticle:ModelTypes["AuthorTopArticleDeleteResult"],
	updateAuthorTopArticle:ModelTypes["AuthorTopArticleUpdateResult"],
	upsertAuthorTopArticle:ModelTypes["AuthorTopArticleUpsertResult"],
	createContent:ModelTypes["ContentCreateResult"],
	deleteContent:ModelTypes["ContentDeleteResult"],
	updateContent:ModelTypes["ContentUpdateResult"],
	upsertContent:ModelTypes["ContentUpsertResult"],
	createContentPart:ModelTypes["ContentPartCreateResult"],
	deleteContentPart:ModelTypes["ContentPartDeleteResult"],
	updateContentPart:ModelTypes["ContentPartUpdateResult"],
	upsertContentPart:ModelTypes["ContentPartUpsertResult"],
	createContentReference:ModelTypes["ContentReferenceCreateResult"],
	deleteContentReference:ModelTypes["ContentReferenceDeleteResult"],
	updateContentReference:ModelTypes["ContentReferenceUpdateResult"],
	upsertContentReference:ModelTypes["ContentReferenceUpsertResult"],
	createHomepageArticle:ModelTypes["HomepageArticleCreateResult"],
	deleteHomepageArticle:ModelTypes["HomepageArticleDeleteResult"],
	updateHomepageArticle:ModelTypes["HomepageArticleUpdateResult"],
	upsertHomepageArticle:ModelTypes["HomepageArticleUpsertResult"],
	createImage:ModelTypes["ImageCreateResult"],
	deleteImage:ModelTypes["ImageDeleteResult"],
	updateImage:ModelTypes["ImageUpdateResult"],
	upsertImage:ModelTypes["ImageUpsertResult"],
	createImageUse:ModelTypes["ImageUseCreateResult"],
	deleteImageUse:ModelTypes["ImageUseDeleteResult"],
	updateImageUse:ModelTypes["ImageUseUpdateResult"],
	upsertImageUse:ModelTypes["ImageUseUpsertResult"],
	createImageTag:ModelTypes["ImageTagCreateResult"],
	deleteImageTag:ModelTypes["ImageTagDeleteResult"],
	updateImageTag:ModelTypes["ImageTagUpdateResult"],
	upsertImageTag:ModelTypes["ImageTagUpsertResult"],
	createIssue:ModelTypes["IssueCreateResult"],
	deleteIssue:ModelTypes["IssueDeleteResult"],
	updateIssue:ModelTypes["IssueUpdateResult"],
	upsertIssue:ModelTypes["IssueUpsertResult"],
	createIssueArticle:ModelTypes["IssueArticleCreateResult"],
	deleteIssueArticle:ModelTypes["IssueArticleDeleteResult"],
	updateIssueArticle:ModelTypes["IssueArticleUpdateResult"],
	upsertIssueArticle:ModelTypes["IssueArticleUpsertResult"],
	createLink:ModelTypes["LinkCreateResult"],
	deleteLink:ModelTypes["LinkDeleteResult"],
	updateLink:ModelTypes["LinkUpdateResult"],
	upsertLink:ModelTypes["LinkUpsertResult"],
	createTextContent:ModelTypes["TextContentCreateResult"],
	deleteTextContent:ModelTypes["TextContentDeleteResult"],
	updateTextContent:ModelTypes["TextContentUpdateResult"],
	upsertTextContent:ModelTypes["TextContentUpsertResult"],
	createTextContentPart:ModelTypes["TextContentPartCreateResult"],
	deleteTextContentPart:ModelTypes["TextContentPartDeleteResult"],
	updateTextContentPart:ModelTypes["TextContentPartUpdateResult"],
	upsertTextContentPart:ModelTypes["TextContentPartUpsertResult"],
	createTextContentReference:ModelTypes["TextContentReferenceCreateResult"],
	deleteTextContentReference:ModelTypes["TextContentReferenceDeleteResult"],
	updateTextContentReference:ModelTypes["TextContentReferenceUpdateResult"],
	upsertTextContentReference:ModelTypes["TextContentReferenceUpsertResult"],
	createUrl:ModelTypes["UrlCreateResult"],
	deleteUrl:ModelTypes["UrlDeleteResult"],
	updateUrl:ModelTypes["UrlUpdateResult"],
	upsertUrl:ModelTypes["UrlUpsertResult"],
	createArticleTag:ModelTypes["ArticleTagCreateResult"],
	deleteArticleTag:ModelTypes["ArticleTagDeleteResult"],
	updateArticleTag:ModelTypes["ArticleTagUpdateResult"],
	upsertArticleTag:ModelTypes["ArticleTagUpsertResult"],
	createCategory:ModelTypes["CategoryCreateResult"],
	deleteCategory:ModelTypes["CategoryDeleteResult"],
	updateCategory:ModelTypes["CategoryUpdateResult"],
	upsertCategory:ModelTypes["CategoryUpsertResult"],
	createArticleCategory:ModelTypes["ArticleCategoryCreateResult"],
	deleteArticleCategory:ModelTypes["ArticleCategoryDeleteResult"],
	updateArticleCategory:ModelTypes["ArticleCategoryUpdateResult"],
	upsertArticleCategory:ModelTypes["ArticleCategoryUpsertResult"],
	createAudio:ModelTypes["AudioCreateResult"],
	deleteAudio:ModelTypes["AudioDeleteResult"],
	updateAudio:ModelTypes["AudioUpdateResult"],
	upsertAudio:ModelTypes["AudioUpsertResult"],
	createAudioUse:ModelTypes["AudioUseCreateResult"],
	deleteAudioUse:ModelTypes["AudioUseDeleteResult"],
	updateAudioUse:ModelTypes["AudioUseUpdateResult"],
	upsertAudioUse:ModelTypes["AudioUseUpsertResult"],
	createEmbed:ModelTypes["EmbedCreateResult"],
	deleteEmbed:ModelTypes["EmbedDeleteResult"],
	updateEmbed:ModelTypes["EmbedUpdateResult"],
	upsertEmbed:ModelTypes["EmbedUpsertResult"],
	createImageContent:ModelTypes["ImageContentCreateResult"],
	deleteImageContent:ModelTypes["ImageContentDeleteResult"],
	updateImageContent:ModelTypes["ImageContentUpdateResult"],
	upsertImageContent:ModelTypes["ImageContentUpsertResult"],
	createListicle:ModelTypes["ListicleCreateResult"],
	deleteListicle:ModelTypes["ListicleDeleteResult"],
	updateListicle:ModelTypes["ListicleUpdateResult"],
	upsertListicle:ModelTypes["ListicleUpsertResult"],
	createPollAnswer:ModelTypes["PollAnswerCreateResult"],
	deletePollAnswer:ModelTypes["PollAnswerDeleteResult"],
	updatePollAnswer:ModelTypes["PollAnswerUpdateResult"],
	upsertPollAnswer:ModelTypes["PollAnswerUpsertResult"],
	createTag:ModelTypes["TagCreateResult"],
	deleteTag:ModelTypes["TagDeleteResult"],
	updateTag:ModelTypes["TagUpdateResult"],
	upsertTag:ModelTypes["TagUpsertResult"],
	createFAQ:ModelTypes["FAQCreateResult"],
	deleteFAQ:ModelTypes["FAQDeleteResult"],
	updateFAQ:ModelTypes["FAQUpdateResult"],
	upsertFAQ:ModelTypes["FAQUpsertResult"],
	createLinkContent:ModelTypes["LinkContentCreateResult"],
	deleteLinkContent:ModelTypes["LinkContentDeleteResult"],
	updateLinkContent:ModelTypes["LinkContentUpdateResult"],
	upsertLinkContent:ModelTypes["LinkContentUpsertResult"],
	createAwardContent:ModelTypes["AwardContentCreateResult"],
	deleteAwardContent:ModelTypes["AwardContentDeleteResult"],
	updateAwardContent:ModelTypes["AwardContentUpdateResult"],
	upsertAwardContent:ModelTypes["AwardContentUpsertResult"],
	createReviewContent:ModelTypes["ReviewContentCreateResult"],
	deleteReviewContent:ModelTypes["ReviewContentDeleteResult"],
	updateReviewContent:ModelTypes["ReviewContentUpdateResult"],
	upsertReviewContent:ModelTypes["ReviewContentUpsertResult"],
	createPage:ModelTypes["PageCreateResult"],
	deletePage:ModelTypes["PageDeleteResult"],
	updatePage:ModelTypes["PageUpdateResult"],
	upsertPage:ModelTypes["PageUpsertResult"],
	createTextTranslation:ModelTypes["TextTranslationCreateResult"],
	deleteTextTranslation:ModelTypes["TextTranslationDeleteResult"],
	updateTextTranslation:ModelTypes["TextTranslationUpdateResult"],
	upsertTextTranslation:ModelTypes["TextTranslationUpsertResult"],
	createSeo:ModelTypes["SeoCreateResult"],
	deleteSeo:ModelTypes["SeoDeleteResult"],
	updateSeo:ModelTypes["SeoUpdateResult"],
	upsertSeo:ModelTypes["SeoUpsertResult"],
	createFile:ModelTypes["FileCreateResult"],
	deleteFile:ModelTypes["FileDeleteResult"],
	updateFile:ModelTypes["FileUpdateResult"],
	upsertFile:ModelTypes["FileUpsertResult"],
	createFileUse:ModelTypes["FileUseCreateResult"],
	deleteFileUse:ModelTypes["FileUseDeleteResult"],
	updateFileUse:ModelTypes["FileUseUpdateResult"],
	upsertFileUse:ModelTypes["FileUseUpsertResult"],
	createContentBlock:ModelTypes["ContentBlockCreateResult"],
	deleteContentBlock:ModelTypes["ContentBlockDeleteResult"],
	updateContentBlock:ModelTypes["ContentBlockUpdateResult"],
	upsertContentBlock:ModelTypes["ContentBlockUpsertResult"],
	createContentArticle:ModelTypes["ContentArticleCreateResult"],
	deleteContentArticle:ModelTypes["ContentArticleDeleteResult"],
	updateContentArticle:ModelTypes["ContentArticleUpdateResult"],
	upsertContentArticle:ModelTypes["ContentArticleUpsertResult"],
	createUnlockedArticle:ModelTypes["UnlockedArticleCreateResult"],
	deleteUnlockedArticle:ModelTypes["UnlockedArticleDeleteResult"],
	updateUnlockedArticle:ModelTypes["UnlockedArticleUpdateResult"],
	upsertUnlockedArticle:ModelTypes["UnlockedArticleUpsertResult"],
	createUser:ModelTypes["UserCreateResult"],
	deleteUser:ModelTypes["UserDeleteResult"],
	updateUser:ModelTypes["UserUpdateResult"],
	upsertUser:ModelTypes["UserUpsertResult"],
	createNotification:ModelTypes["NotificationCreateResult"],
	deleteNotification:ModelTypes["NotificationDeleteResult"],
	updateNotification:ModelTypes["NotificationUpdateResult"],
	upsertNotification:ModelTypes["NotificationUpsertResult"],
	createAppReview:ModelTypes["AppReviewCreateResult"],
	deleteAppReview:ModelTypes["AppReviewDeleteResult"],
	updateAppReview:ModelTypes["AppReviewUpdateResult"],
	upsertAppReview:ModelTypes["AppReviewUpsertResult"],
	createProduct:ModelTypes["ProductCreateResult"],
	deleteProduct:ModelTypes["ProductDeleteResult"],
	updateProduct:ModelTypes["ProductUpdateResult"],
	upsertProduct:ModelTypes["ProductUpsertResult"],
	createSubscriptionForm:ModelTypes["SubscriptionFormCreateResult"],
	deleteSubscriptionForm:ModelTypes["SubscriptionFormDeleteResult"],
	updateSubscriptionForm:ModelTypes["SubscriptionFormUpdateResult"],
	upsertSubscriptionForm:ModelTypes["SubscriptionFormUpsertResult"],
	createSubscriptionFormSection:ModelTypes["SubscriptionFormSectionCreateResult"],
	deleteSubscriptionFormSection:ModelTypes["SubscriptionFormSectionDeleteResult"],
	updateSubscriptionFormSection:ModelTypes["SubscriptionFormSectionUpdateResult"],
	upsertSubscriptionFormSection:ModelTypes["SubscriptionFormSectionUpsertResult"],
	createSubscriptionFormInput:ModelTypes["SubscriptionFormInputCreateResult"],
	deleteSubscriptionFormInput:ModelTypes["SubscriptionFormInputDeleteResult"],
	updateSubscriptionFormInput:ModelTypes["SubscriptionFormInputUpdateResult"],
	upsertSubscriptionFormInput:ModelTypes["SubscriptionFormInputUpsertResult"],
	createSubscriptionFormOption:ModelTypes["SubscriptionFormOptionCreateResult"],
	deleteSubscriptionFormOption:ModelTypes["SubscriptionFormOptionDeleteResult"],
	updateSubscriptionFormOption:ModelTypes["SubscriptionFormOptionUpdateResult"],
	upsertSubscriptionFormOption:ModelTypes["SubscriptionFormOptionUpsertResult"],
	createButton:ModelTypes["ButtonCreateResult"],
	deleteButton:ModelTypes["ButtonDeleteResult"],
	updateButton:ModelTypes["ButtonUpdateResult"],
	upsertButton:ModelTypes["ButtonUpsertResult"],
	createArticleHistoryTag:ModelTypes["ArticleHistoryTagCreateResult"],
	deleteArticleHistoryTag:ModelTypes["ArticleHistoryTagDeleteResult"],
	updateArticleHistoryTag:ModelTypes["ArticleHistoryTagUpdateResult"],
	upsertArticleHistoryTag:ModelTypes["ArticleHistoryTagUpsertResult"],
	createArticleHistoryPeriod:ModelTypes["ArticleHistoryPeriodCreateResult"],
	deleteArticleHistoryPeriod:ModelTypes["ArticleHistoryPeriodDeleteResult"],
	updateArticleHistoryPeriod:ModelTypes["ArticleHistoryPeriodUpdateResult"],
	upsertArticleHistoryPeriod:ModelTypes["ArticleHistoryPeriodUpsertResult"],
	createHistoryTag:ModelTypes["HistoryTagCreateResult"],
	deleteHistoryTag:ModelTypes["HistoryTagDeleteResult"],
	updateHistoryTag:ModelTypes["HistoryTagUpdateResult"],
	upsertHistoryTag:ModelTypes["HistoryTagUpsertResult"],
	createHistoryPeriod:ModelTypes["HistoryPeriodCreateResult"],
	deleteHistoryPeriod:ModelTypes["HistoryPeriodDeleteResult"],
	updateHistoryPeriod:ModelTypes["HistoryPeriodUpdateResult"],
	upsertHistoryPeriod:ModelTypes["HistoryPeriodUpsertResult"],
	createHistoryHomePage:ModelTypes["HistoryHomePageCreateResult"],
	deleteHistoryHomePage:ModelTypes["HistoryHomePageDeleteResult"],
	updateHistoryHomePage:ModelTypes["HistoryHomePageUpdateResult"],
	upsertHistoryHomePage:ModelTypes["HistoryHomePageUpsertResult"],
	createHistoryCover:ModelTypes["HistoryCoverCreateResult"],
	deleteHistoryCover:ModelTypes["HistoryCoverDeleteResult"],
	updateHistoryCover:ModelTypes["HistoryCoverUpdateResult"],
	upsertHistoryCover:ModelTypes["HistoryCoverUpsertResult"],
	createHistoryTextList:ModelTypes["HistoryTextListCreateResult"],
	deleteHistoryTextList:ModelTypes["HistoryTextListDeleteResult"],
	updateHistoryTextList:ModelTypes["HistoryTextListUpdateResult"],
	upsertHistoryTextList:ModelTypes["HistoryTextListUpsertResult"],
	createHistoryTextItem:ModelTypes["HistoryTextItemCreateResult"],
	deleteHistoryTextItem:ModelTypes["HistoryTextItemDeleteResult"],
	updateHistoryTextItem:ModelTypes["HistoryTextItemUpdateResult"],
	upsertHistoryTextItem:ModelTypes["HistoryTextItemUpsertResult"],
	createFooterMenu:ModelTypes["FooterMenuCreateResult"],
	deleteFooterMenu:ModelTypes["FooterMenuDeleteResult"],
	updateFooterMenu:ModelTypes["FooterMenuUpdateResult"],
	upsertFooterMenu:ModelTypes["FooterMenuUpsertResult"],
	createLinkSection:ModelTypes["LinkSectionCreateResult"],
	deleteLinkSection:ModelTypes["LinkSectionDeleteResult"],
	updateLinkSection:ModelTypes["LinkSectionUpdateResult"],
	upsertLinkSection:ModelTypes["LinkSectionUpsertResult"],
	createLinkList:ModelTypes["LinkListCreateResult"],
	deleteLinkList:ModelTypes["LinkListDeleteResult"],
	updateLinkList:ModelTypes["LinkListUpdateResult"],
	upsertLinkList:ModelTypes["LinkListUpsertResult"],
	createLinkItem:ModelTypes["LinkItemCreateResult"],
	deleteLinkItem:ModelTypes["LinkItemDeleteResult"],
	updateLinkItem:ModelTypes["LinkItemUpdateResult"],
	upsertLinkItem:ModelTypes["LinkItemUpsertResult"],
	createNewsletterSection:ModelTypes["NewsletterSectionCreateResult"],
	deleteNewsletterSection:ModelTypes["NewsletterSectionDeleteResult"],
	updateNewsletterSection:ModelTypes["NewsletterSectionUpdateResult"],
	upsertNewsletterSection:ModelTypes["NewsletterSectionUpsertResult"],
	createNewsletter:ModelTypes["NewsletterCreateResult"],
	deleteNewsletter:ModelTypes["NewsletterDeleteResult"],
	updateNewsletter:ModelTypes["NewsletterUpdateResult"],
	upsertNewsletter:ModelTypes["NewsletterUpsertResult"],
	createOnlineSection:ModelTypes["OnlineSectionCreateResult"],
	deleteOnlineSection:ModelTypes["OnlineSectionDeleteResult"],
	updateOnlineSection:ModelTypes["OnlineSectionUpdateResult"],
	upsertOnlineSection:ModelTypes["OnlineSectionUpsertResult"],
	createAppLink:ModelTypes["AppLinkCreateResult"],
	deleteAppLink:ModelTypes["AppLinkDeleteResult"],
	updateAppLink:ModelTypes["AppLinkUpdateResult"],
	upsertAppLink:ModelTypes["AppLinkUpsertResult"],
	createAppLinkList:ModelTypes["AppLinkListCreateResult"],
	deleteAppLinkList:ModelTypes["AppLinkListDeleteResult"],
	updateAppLinkList:ModelTypes["AppLinkListUpdateResult"],
	upsertAppLinkList:ModelTypes["AppLinkListUpsertResult"],
	createAppLinkItem:ModelTypes["AppLinkItemCreateResult"],
	deleteAppLinkItem:ModelTypes["AppLinkItemDeleteResult"],
	updateAppLinkItem:ModelTypes["AppLinkItemUpdateResult"],
	upsertAppLinkItem:ModelTypes["AppLinkItemUpsertResult"],
	createSocialSection:ModelTypes["SocialSectionCreateResult"],
	deleteSocialSection:ModelTypes["SocialSectionDeleteResult"],
	updateSocialSection:ModelTypes["SocialSectionUpdateResult"],
	upsertSocialSection:ModelTypes["SocialSectionUpsertResult"],
	createSocialLink:ModelTypes["SocialLinkCreateResult"],
	deleteSocialLink:ModelTypes["SocialLinkDeleteResult"],
	updateSocialLink:ModelTypes["SocialLinkUpdateResult"],
	upsertSocialLink:ModelTypes["SocialLinkUpsertResult"],
	createSocialLinkList:ModelTypes["SocialLinkListCreateResult"],
	deleteSocialLinkList:ModelTypes["SocialLinkListDeleteResult"],
	updateSocialLinkList:ModelTypes["SocialLinkListUpdateResult"],
	upsertSocialLinkList:ModelTypes["SocialLinkListUpsertResult"],
	createSocialLinkItem:ModelTypes["SocialLinkItemCreateResult"],
	deleteSocialLinkItem:ModelTypes["SocialLinkItemDeleteResult"],
	updateSocialLinkItem:ModelTypes["SocialLinkItemUpdateResult"],
	upsertSocialLinkItem:ModelTypes["SocialLinkItemUpsertResult"],
	createSharedContent:ModelTypes["SharedContentCreateResult"],
	deleteSharedContent:ModelTypes["SharedContentDeleteResult"],
	updateSharedContent:ModelTypes["SharedContentUpdateResult"],
	upsertSharedContent:ModelTypes["SharedContentUpsertResult"],
	query?:ModelTypes["Query"]
};
	["MutationTransactionOptions"]: GraphQLTypes["MutationTransactionOptions"];
	/** Json custom scalar type */
["Json"]:any;
	["_Schema"]: {
		enums:ModelTypes["_Enum"][],
	entities:ModelTypes["_Entity"][]
};
	["_Entity"]: {
		name:string,
	customPrimaryAllowed:boolean,
	fields:ModelTypes["_Field"][],
	unique:ModelTypes["_UniqueConstraint"][]
};
	["_UniqueConstraint"]: {
		fields:string[]
};
	["_Field"]: ModelTypes["_Column"] | ModelTypes["_Relation"];
	["_Column"]: {
		name:string,
	type:string,
	enumName?:string,
	defaultValue?:ModelTypes["Json"],
	nullable:boolean,
	rules:ModelTypes["_Rule"][],
	validators:ModelTypes["_Validator"][]
};
	["_OnDeleteBehaviour"]: GraphQLTypes["_OnDeleteBehaviour"];
	["_RelationSide"]: GraphQLTypes["_RelationSide"];
	["_OrderByDirection"]: GraphQLTypes["_OrderByDirection"];
	["_OrderBy"]: {
		path:string[],
	direction:ModelTypes["_OrderByDirection"]
};
	["_Relation"]: {
		name:string,
	type:string,
	side:ModelTypes["_RelationSide"],
	targetEntity:string,
	ownedBy?:string,
	inversedBy?:string,
	nullable?:boolean,
	onDelete?:ModelTypes["_OnDeleteBehaviour"],
	orphanRemoval?:boolean,
	orderBy?:ModelTypes["_OrderBy"][],
	rules:ModelTypes["_Rule"][],
	validators:ModelTypes["_Validator"][]
};
	["_Rule"]: {
		message?:ModelTypes["_RuleMessage"],
	validator:number
};
	["_Validator"]: {
		operation:string,
	arguments:ModelTypes["_Argument"][]
};
	["_Argument"]:ModelTypes["_ValidatorArgument"] | ModelTypes["_PathArgument"] | ModelTypes["_LiteralArgument"];
	["_ValidatorArgument"]: {
		validator:number
};
	["_PathArgument"]: {
		path:string[]
};
	["_LiteralArgument"]: {
		value?:ModelTypes["Json"]
};
	["_RuleMessage"]: {
		text?:string
};
	["_Enum"]: {
		name:string,
	values:string[]
};
	["S3SignedUpload"]: {
		url:string,
	headers:ModelTypes["S3Header"][],
	method:string,
	/** Allowed patterns:
** */
	objectKey:string,
	bucket:string,
	publicUrl:string
};
	["S3Header"]: {
		key:string,
	value:string
};
	["S3Acl"]: GraphQLTypes["S3Acl"];
	["S3SignedRead"]: {
		url:string,
	headers:ModelTypes["S3Header"][],
	method:string,
	/** Allowed patterns:
** */
	objectKey:string,
	bucket:string
}
    }

export type GraphQLTypes = {
    ["Query"]: {
	__typename: "Query",
	getArticle?: GraphQLTypes["Article"],
	listArticle: Array<GraphQLTypes["Article"]>,
	paginateArticle: GraphQLTypes["ArticleConnection"],
	validateCreateArticle: GraphQLTypes["_ValidationResult"],
	validateUpdateArticle: GraphQLTypes["_ValidationResult"],
	getArticleAuthor?: GraphQLTypes["ArticleAuthor"],
	listArticleAuthor: Array<GraphQLTypes["ArticleAuthor"]>,
	paginateArticleAuthor: GraphQLTypes["ArticleAuthorConnection"],
	validateCreateArticleAuthor: GraphQLTypes["_ValidationResult"],
	validateUpdateArticleAuthor: GraphQLTypes["_ValidationResult"],
	getAuthor?: GraphQLTypes["Author"],
	listAuthor: Array<GraphQLTypes["Author"]>,
	paginateAuthor: GraphQLTypes["AuthorConnection"],
	validateCreateAuthor: GraphQLTypes["_ValidationResult"],
	validateUpdateAuthor: GraphQLTypes["_ValidationResult"],
	getAuthorTopArticle?: GraphQLTypes["AuthorTopArticle"],
	listAuthorTopArticle: Array<GraphQLTypes["AuthorTopArticle"]>,
	paginateAuthorTopArticle: GraphQLTypes["AuthorTopArticleConnection"],
	validateCreateAuthorTopArticle: GraphQLTypes["_ValidationResult"],
	validateUpdateAuthorTopArticle: GraphQLTypes["_ValidationResult"],
	getContent?: GraphQLTypes["Content"],
	listContent: Array<GraphQLTypes["Content"]>,
	paginateContent: GraphQLTypes["ContentConnection"],
	validateCreateContent: GraphQLTypes["_ValidationResult"],
	validateUpdateContent: GraphQLTypes["_ValidationResult"],
	getContentPart?: GraphQLTypes["ContentPart"],
	listContentPart: Array<GraphQLTypes["ContentPart"]>,
	paginateContentPart: GraphQLTypes["ContentPartConnection"],
	validateCreateContentPart: GraphQLTypes["_ValidationResult"],
	validateUpdateContentPart: GraphQLTypes["_ValidationResult"],
	getContentReference?: GraphQLTypes["ContentReference"],
	listContentReference: Array<GraphQLTypes["ContentReference"]>,
	paginateContentReference: GraphQLTypes["ContentReferenceConnection"],
	validateCreateContentReference: GraphQLTypes["_ValidationResult"],
	validateUpdateContentReference: GraphQLTypes["_ValidationResult"],
	getHomepageArticle?: GraphQLTypes["HomepageArticle"],
	listHomepageArticle: Array<GraphQLTypes["HomepageArticle"]>,
	paginateHomepageArticle: GraphQLTypes["HomepageArticleConnection"],
	validateCreateHomepageArticle: GraphQLTypes["_ValidationResult"],
	validateUpdateHomepageArticle: GraphQLTypes["_ValidationResult"],
	getImage?: GraphQLTypes["Image"],
	listImage: Array<GraphQLTypes["Image"]>,
	paginateImage: GraphQLTypes["ImageConnection"],
	validateCreateImage: GraphQLTypes["_ValidationResult"],
	validateUpdateImage: GraphQLTypes["_ValidationResult"],
	getImageUse?: GraphQLTypes["ImageUse"],
	listImageUse: Array<GraphQLTypes["ImageUse"]>,
	paginateImageUse: GraphQLTypes["ImageUseConnection"],
	validateCreateImageUse: GraphQLTypes["_ValidationResult"],
	validateUpdateImageUse: GraphQLTypes["_ValidationResult"],
	getImageTag?: GraphQLTypes["ImageTag"],
	listImageTag: Array<GraphQLTypes["ImageTag"]>,
	paginateImageTag: GraphQLTypes["ImageTagConnection"],
	validateCreateImageTag: GraphQLTypes["_ValidationResult"],
	validateUpdateImageTag: GraphQLTypes["_ValidationResult"],
	getIssue?: GraphQLTypes["Issue"],
	listIssue: Array<GraphQLTypes["Issue"]>,
	paginateIssue: GraphQLTypes["IssueConnection"],
	validateCreateIssue: GraphQLTypes["_ValidationResult"],
	validateUpdateIssue: GraphQLTypes["_ValidationResult"],
	getIssueArticle?: GraphQLTypes["IssueArticle"],
	listIssueArticle: Array<GraphQLTypes["IssueArticle"]>,
	paginateIssueArticle: GraphQLTypes["IssueArticleConnection"],
	validateCreateIssueArticle: GraphQLTypes["_ValidationResult"],
	validateUpdateIssueArticle: GraphQLTypes["_ValidationResult"],
	getLink?: GraphQLTypes["Link"],
	listLink: Array<GraphQLTypes["Link"]>,
	paginateLink: GraphQLTypes["LinkConnection"],
	validateCreateLink: GraphQLTypes["_ValidationResult"],
	validateUpdateLink: GraphQLTypes["_ValidationResult"],
	getTextContent?: GraphQLTypes["TextContent"],
	listTextContent: Array<GraphQLTypes["TextContent"]>,
	paginateTextContent: GraphQLTypes["TextContentConnection"],
	validateCreateTextContent: GraphQLTypes["_ValidationResult"],
	validateUpdateTextContent: GraphQLTypes["_ValidationResult"],
	getTextContentPart?: GraphQLTypes["TextContentPart"],
	listTextContentPart: Array<GraphQLTypes["TextContentPart"]>,
	paginateTextContentPart: GraphQLTypes["TextContentPartConnection"],
	validateCreateTextContentPart: GraphQLTypes["_ValidationResult"],
	validateUpdateTextContentPart: GraphQLTypes["_ValidationResult"],
	getTextContentReference?: GraphQLTypes["TextContentReference"],
	listTextContentReference: Array<GraphQLTypes["TextContentReference"]>,
	paginateTextContentReference: GraphQLTypes["TextContentReferenceConnection"],
	validateCreateTextContentReference: GraphQLTypes["_ValidationResult"],
	validateUpdateTextContentReference: GraphQLTypes["_ValidationResult"],
	getUrl?: GraphQLTypes["Url"],
	listUrl: Array<GraphQLTypes["Url"]>,
	paginateUrl: GraphQLTypes["UrlConnection"],
	validateCreateUrl: GraphQLTypes["_ValidationResult"],
	validateUpdateUrl: GraphQLTypes["_ValidationResult"],
	getArticleTag?: GraphQLTypes["ArticleTag"],
	listArticleTag: Array<GraphQLTypes["ArticleTag"]>,
	paginateArticleTag: GraphQLTypes["ArticleTagConnection"],
	validateCreateArticleTag: GraphQLTypes["_ValidationResult"],
	validateUpdateArticleTag: GraphQLTypes["_ValidationResult"],
	getCategory?: GraphQLTypes["Category"],
	listCategory: Array<GraphQLTypes["Category"]>,
	paginateCategory: GraphQLTypes["CategoryConnection"],
	validateCreateCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateCategory: GraphQLTypes["_ValidationResult"],
	getArticleCategory?: GraphQLTypes["ArticleCategory"],
	listArticleCategory: Array<GraphQLTypes["ArticleCategory"]>,
	paginateArticleCategory: GraphQLTypes["ArticleCategoryConnection"],
	validateCreateArticleCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateArticleCategory: GraphQLTypes["_ValidationResult"],
	getAudio?: GraphQLTypes["Audio"],
	listAudio: Array<GraphQLTypes["Audio"]>,
	paginateAudio: GraphQLTypes["AudioConnection"],
	validateCreateAudio: GraphQLTypes["_ValidationResult"],
	validateUpdateAudio: GraphQLTypes["_ValidationResult"],
	getAudioUse?: GraphQLTypes["AudioUse"],
	listAudioUse: Array<GraphQLTypes["AudioUse"]>,
	paginateAudioUse: GraphQLTypes["AudioUseConnection"],
	validateCreateAudioUse: GraphQLTypes["_ValidationResult"],
	validateUpdateAudioUse: GraphQLTypes["_ValidationResult"],
	getEmbed?: GraphQLTypes["Embed"],
	listEmbed: Array<GraphQLTypes["Embed"]>,
	paginateEmbed: GraphQLTypes["EmbedConnection"],
	validateCreateEmbed: GraphQLTypes["_ValidationResult"],
	validateUpdateEmbed: GraphQLTypes["_ValidationResult"],
	getImageContent?: GraphQLTypes["ImageContent"],
	listImageContent: Array<GraphQLTypes["ImageContent"]>,
	paginateImageContent: GraphQLTypes["ImageContentConnection"],
	validateCreateImageContent: GraphQLTypes["_ValidationResult"],
	validateUpdateImageContent: GraphQLTypes["_ValidationResult"],
	getListicle?: GraphQLTypes["Listicle"],
	listListicle: Array<GraphQLTypes["Listicle"]>,
	paginateListicle: GraphQLTypes["ListicleConnection"],
	validateCreateListicle: GraphQLTypes["_ValidationResult"],
	validateUpdateListicle: GraphQLTypes["_ValidationResult"],
	getPollAnswer?: GraphQLTypes["PollAnswer"],
	listPollAnswer: Array<GraphQLTypes["PollAnswer"]>,
	paginatePollAnswer: GraphQLTypes["PollAnswerConnection"],
	validateCreatePollAnswer: GraphQLTypes["_ValidationResult"],
	validateUpdatePollAnswer: GraphQLTypes["_ValidationResult"],
	getTag?: GraphQLTypes["Tag"],
	listTag: Array<GraphQLTypes["Tag"]>,
	paginateTag: GraphQLTypes["TagConnection"],
	validateCreateTag: GraphQLTypes["_ValidationResult"],
	validateUpdateTag: GraphQLTypes["_ValidationResult"],
	getFAQ?: GraphQLTypes["FAQ"],
	listFAQ: Array<GraphQLTypes["FAQ"]>,
	paginateFAQ: GraphQLTypes["FAQConnection"],
	validateCreateFAQ: GraphQLTypes["_ValidationResult"],
	validateUpdateFAQ: GraphQLTypes["_ValidationResult"],
	getLinkContent?: GraphQLTypes["LinkContent"],
	listLinkContent: Array<GraphQLTypes["LinkContent"]>,
	paginateLinkContent: GraphQLTypes["LinkContentConnection"],
	validateCreateLinkContent: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkContent: GraphQLTypes["_ValidationResult"],
	getAwardContent?: GraphQLTypes["AwardContent"],
	listAwardContent: Array<GraphQLTypes["AwardContent"]>,
	paginateAwardContent: GraphQLTypes["AwardContentConnection"],
	validateCreateAwardContent: GraphQLTypes["_ValidationResult"],
	validateUpdateAwardContent: GraphQLTypes["_ValidationResult"],
	getReviewContent?: GraphQLTypes["ReviewContent"],
	listReviewContent: Array<GraphQLTypes["ReviewContent"]>,
	paginateReviewContent: GraphQLTypes["ReviewContentConnection"],
	validateCreateReviewContent: GraphQLTypes["_ValidationResult"],
	validateUpdateReviewContent: GraphQLTypes["_ValidationResult"],
	getPage?: GraphQLTypes["Page"],
	listPage: Array<GraphQLTypes["Page"]>,
	paginatePage: GraphQLTypes["PageConnection"],
	validateCreatePage: GraphQLTypes["_ValidationResult"],
	validateUpdatePage: GraphQLTypes["_ValidationResult"],
	getTextTranslation?: GraphQLTypes["TextTranslation"],
	listTextTranslation: Array<GraphQLTypes["TextTranslation"]>,
	paginateTextTranslation: GraphQLTypes["TextTranslationConnection"],
	validateCreateTextTranslation: GraphQLTypes["_ValidationResult"],
	validateUpdateTextTranslation: GraphQLTypes["_ValidationResult"],
	getSeo?: GraphQLTypes["Seo"],
	listSeo: Array<GraphQLTypes["Seo"]>,
	paginateSeo: GraphQLTypes["SeoConnection"],
	validateCreateSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateSeo: GraphQLTypes["_ValidationResult"],
	getFile?: GraphQLTypes["File"],
	listFile: Array<GraphQLTypes["File"]>,
	paginateFile: GraphQLTypes["FileConnection"],
	validateCreateFile: GraphQLTypes["_ValidationResult"],
	validateUpdateFile: GraphQLTypes["_ValidationResult"],
	getFileUse?: GraphQLTypes["FileUse"],
	listFileUse: Array<GraphQLTypes["FileUse"]>,
	paginateFileUse: GraphQLTypes["FileUseConnection"],
	validateCreateFileUse: GraphQLTypes["_ValidationResult"],
	validateUpdateFileUse: GraphQLTypes["_ValidationResult"],
	getContentBlock?: GraphQLTypes["ContentBlock"],
	listContentBlock: Array<GraphQLTypes["ContentBlock"]>,
	paginateContentBlock: GraphQLTypes["ContentBlockConnection"],
	validateCreateContentBlock: GraphQLTypes["_ValidationResult"],
	validateUpdateContentBlock: GraphQLTypes["_ValidationResult"],
	getContentArticle?: GraphQLTypes["ContentArticle"],
	listContentArticle: Array<GraphQLTypes["ContentArticle"]>,
	paginateContentArticle: GraphQLTypes["ContentArticleConnection"],
	validateCreateContentArticle: GraphQLTypes["_ValidationResult"],
	validateUpdateContentArticle: GraphQLTypes["_ValidationResult"],
	getUnlockedArticle?: GraphQLTypes["UnlockedArticle"],
	listUnlockedArticle: Array<GraphQLTypes["UnlockedArticle"]>,
	paginateUnlockedArticle: GraphQLTypes["UnlockedArticleConnection"],
	validateCreateUnlockedArticle: GraphQLTypes["_ValidationResult"],
	validateUpdateUnlockedArticle: GraphQLTypes["_ValidationResult"],
	getUser?: GraphQLTypes["User"],
	listUser: Array<GraphQLTypes["User"]>,
	paginateUser: GraphQLTypes["UserConnection"],
	validateCreateUser: GraphQLTypes["_ValidationResult"],
	validateUpdateUser: GraphQLTypes["_ValidationResult"],
	getNotification?: GraphQLTypes["Notification"],
	listNotification: Array<GraphQLTypes["Notification"]>,
	paginateNotification: GraphQLTypes["NotificationConnection"],
	validateCreateNotification: GraphQLTypes["_ValidationResult"],
	validateUpdateNotification: GraphQLTypes["_ValidationResult"],
	getAppReview?: GraphQLTypes["AppReview"],
	listAppReview: Array<GraphQLTypes["AppReview"]>,
	paginateAppReview: GraphQLTypes["AppReviewConnection"],
	validateCreateAppReview: GraphQLTypes["_ValidationResult"],
	validateUpdateAppReview: GraphQLTypes["_ValidationResult"],
	getProduct?: GraphQLTypes["Product"],
	listProduct: Array<GraphQLTypes["Product"]>,
	paginateProduct: GraphQLTypes["ProductConnection"],
	validateCreateProduct: GraphQLTypes["_ValidationResult"],
	validateUpdateProduct: GraphQLTypes["_ValidationResult"],
	getSubscriptionForm?: GraphQLTypes["SubscriptionForm"],
	listSubscriptionForm: Array<GraphQLTypes["SubscriptionForm"]>,
	paginateSubscriptionForm: GraphQLTypes["SubscriptionFormConnection"],
	validateCreateSubscriptionForm: GraphQLTypes["_ValidationResult"],
	validateUpdateSubscriptionForm: GraphQLTypes["_ValidationResult"],
	getSubscriptionFormSection?: GraphQLTypes["SubscriptionFormSection"],
	listSubscriptionFormSection: Array<GraphQLTypes["SubscriptionFormSection"]>,
	paginateSubscriptionFormSection: GraphQLTypes["SubscriptionFormSectionConnection"],
	validateCreateSubscriptionFormSection: GraphQLTypes["_ValidationResult"],
	validateUpdateSubscriptionFormSection: GraphQLTypes["_ValidationResult"],
	getSubscriptionFormInput?: GraphQLTypes["SubscriptionFormInput"],
	listSubscriptionFormInput: Array<GraphQLTypes["SubscriptionFormInput"]>,
	paginateSubscriptionFormInput: GraphQLTypes["SubscriptionFormInputConnection"],
	validateCreateSubscriptionFormInput: GraphQLTypes["_ValidationResult"],
	validateUpdateSubscriptionFormInput: GraphQLTypes["_ValidationResult"],
	getSubscriptionFormOption?: GraphQLTypes["SubscriptionFormOption"],
	listSubscriptionFormOption: Array<GraphQLTypes["SubscriptionFormOption"]>,
	paginateSubscriptionFormOption: GraphQLTypes["SubscriptionFormOptionConnection"],
	validateCreateSubscriptionFormOption: GraphQLTypes["_ValidationResult"],
	validateUpdateSubscriptionFormOption: GraphQLTypes["_ValidationResult"],
	getButton?: GraphQLTypes["Button"],
	listButton: Array<GraphQLTypes["Button"]>,
	paginateButton: GraphQLTypes["ButtonConnection"],
	validateCreateButton: GraphQLTypes["_ValidationResult"],
	validateUpdateButton: GraphQLTypes["_ValidationResult"],
	getArticleHistoryTag?: GraphQLTypes["ArticleHistoryTag"],
	listArticleHistoryTag: Array<GraphQLTypes["ArticleHistoryTag"]>,
	paginateArticleHistoryTag: GraphQLTypes["ArticleHistoryTagConnection"],
	validateCreateArticleHistoryTag: GraphQLTypes["_ValidationResult"],
	validateUpdateArticleHistoryTag: GraphQLTypes["_ValidationResult"],
	getArticleHistoryPeriod?: GraphQLTypes["ArticleHistoryPeriod"],
	listArticleHistoryPeriod: Array<GraphQLTypes["ArticleHistoryPeriod"]>,
	paginateArticleHistoryPeriod: GraphQLTypes["ArticleHistoryPeriodConnection"],
	validateCreateArticleHistoryPeriod: GraphQLTypes["_ValidationResult"],
	validateUpdateArticleHistoryPeriod: GraphQLTypes["_ValidationResult"],
	getHistoryTag?: GraphQLTypes["HistoryTag"],
	listHistoryTag: Array<GraphQLTypes["HistoryTag"]>,
	paginateHistoryTag: GraphQLTypes["HistoryTagConnection"],
	validateCreateHistoryTag: GraphQLTypes["_ValidationResult"],
	validateUpdateHistoryTag: GraphQLTypes["_ValidationResult"],
	getHistoryPeriod?: GraphQLTypes["HistoryPeriod"],
	listHistoryPeriod: Array<GraphQLTypes["HistoryPeriod"]>,
	paginateHistoryPeriod: GraphQLTypes["HistoryPeriodConnection"],
	validateCreateHistoryPeriod: GraphQLTypes["_ValidationResult"],
	validateUpdateHistoryPeriod: GraphQLTypes["_ValidationResult"],
	getHistoryHomePage?: GraphQLTypes["HistoryHomePage"],
	listHistoryHomePage: Array<GraphQLTypes["HistoryHomePage"]>,
	paginateHistoryHomePage: GraphQLTypes["HistoryHomePageConnection"],
	validateCreateHistoryHomePage: GraphQLTypes["_ValidationResult"],
	validateUpdateHistoryHomePage: GraphQLTypes["_ValidationResult"],
	getHistoryCover?: GraphQLTypes["HistoryCover"],
	listHistoryCover: Array<GraphQLTypes["HistoryCover"]>,
	paginateHistoryCover: GraphQLTypes["HistoryCoverConnection"],
	validateCreateHistoryCover: GraphQLTypes["_ValidationResult"],
	validateUpdateHistoryCover: GraphQLTypes["_ValidationResult"],
	getHistoryTextList?: GraphQLTypes["HistoryTextList"],
	listHistoryTextList: Array<GraphQLTypes["HistoryTextList"]>,
	paginateHistoryTextList: GraphQLTypes["HistoryTextListConnection"],
	validateCreateHistoryTextList: GraphQLTypes["_ValidationResult"],
	validateUpdateHistoryTextList: GraphQLTypes["_ValidationResult"],
	getHistoryTextItem?: GraphQLTypes["HistoryTextItem"],
	listHistoryTextItem: Array<GraphQLTypes["HistoryTextItem"]>,
	paginateHistoryTextItem: GraphQLTypes["HistoryTextItemConnection"],
	validateCreateHistoryTextItem: GraphQLTypes["_ValidationResult"],
	validateUpdateHistoryTextItem: GraphQLTypes["_ValidationResult"],
	getFooterMenu?: GraphQLTypes["FooterMenu"],
	listFooterMenu: Array<GraphQLTypes["FooterMenu"]>,
	paginateFooterMenu: GraphQLTypes["FooterMenuConnection"],
	validateCreateFooterMenu: GraphQLTypes["_ValidationResult"],
	validateUpdateFooterMenu: GraphQLTypes["_ValidationResult"],
	getLinkSection?: GraphQLTypes["LinkSection"],
	listLinkSection: Array<GraphQLTypes["LinkSection"]>,
	paginateLinkSection: GraphQLTypes["LinkSectionConnection"],
	validateCreateLinkSection: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkSection: GraphQLTypes["_ValidationResult"],
	getLinkList?: GraphQLTypes["LinkList"],
	listLinkList: Array<GraphQLTypes["LinkList"]>,
	paginateLinkList: GraphQLTypes["LinkListConnection"],
	validateCreateLinkList: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkList: GraphQLTypes["_ValidationResult"],
	getLinkItem?: GraphQLTypes["LinkItem"],
	listLinkItem: Array<GraphQLTypes["LinkItem"]>,
	paginateLinkItem: GraphQLTypes["LinkItemConnection"],
	validateCreateLinkItem: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkItem: GraphQLTypes["_ValidationResult"],
	getNewsletterSection?: GraphQLTypes["NewsletterSection"],
	listNewsletterSection: Array<GraphQLTypes["NewsletterSection"]>,
	paginateNewsletterSection: GraphQLTypes["NewsletterSectionConnection"],
	validateCreateNewsletterSection: GraphQLTypes["_ValidationResult"],
	validateUpdateNewsletterSection: GraphQLTypes["_ValidationResult"],
	getNewsletter?: GraphQLTypes["Newsletter"],
	listNewsletter: Array<GraphQLTypes["Newsletter"]>,
	paginateNewsletter: GraphQLTypes["NewsletterConnection"],
	validateCreateNewsletter: GraphQLTypes["_ValidationResult"],
	validateUpdateNewsletter: GraphQLTypes["_ValidationResult"],
	getOnlineSection?: GraphQLTypes["OnlineSection"],
	listOnlineSection: Array<GraphQLTypes["OnlineSection"]>,
	paginateOnlineSection: GraphQLTypes["OnlineSectionConnection"],
	validateCreateOnlineSection: GraphQLTypes["_ValidationResult"],
	validateUpdateOnlineSection: GraphQLTypes["_ValidationResult"],
	getAppLink?: GraphQLTypes["AppLink"],
	listAppLink: Array<GraphQLTypes["AppLink"]>,
	paginateAppLink: GraphQLTypes["AppLinkConnection"],
	validateCreateAppLink: GraphQLTypes["_ValidationResult"],
	validateUpdateAppLink: GraphQLTypes["_ValidationResult"],
	getAppLinkList?: GraphQLTypes["AppLinkList"],
	listAppLinkList: Array<GraphQLTypes["AppLinkList"]>,
	paginateAppLinkList: GraphQLTypes["AppLinkListConnection"],
	validateCreateAppLinkList: GraphQLTypes["_ValidationResult"],
	validateUpdateAppLinkList: GraphQLTypes["_ValidationResult"],
	getAppLinkItem?: GraphQLTypes["AppLinkItem"],
	listAppLinkItem: Array<GraphQLTypes["AppLinkItem"]>,
	paginateAppLinkItem: GraphQLTypes["AppLinkItemConnection"],
	validateCreateAppLinkItem: GraphQLTypes["_ValidationResult"],
	validateUpdateAppLinkItem: GraphQLTypes["_ValidationResult"],
	getSocialSection?: GraphQLTypes["SocialSection"],
	listSocialSection: Array<GraphQLTypes["SocialSection"]>,
	paginateSocialSection: GraphQLTypes["SocialSectionConnection"],
	validateCreateSocialSection: GraphQLTypes["_ValidationResult"],
	validateUpdateSocialSection: GraphQLTypes["_ValidationResult"],
	getSocialLink?: GraphQLTypes["SocialLink"],
	listSocialLink: Array<GraphQLTypes["SocialLink"]>,
	paginateSocialLink: GraphQLTypes["SocialLinkConnection"],
	validateCreateSocialLink: GraphQLTypes["_ValidationResult"],
	validateUpdateSocialLink: GraphQLTypes["_ValidationResult"],
	getSocialLinkList?: GraphQLTypes["SocialLinkList"],
	listSocialLinkList: Array<GraphQLTypes["SocialLinkList"]>,
	paginateSocialLinkList: GraphQLTypes["SocialLinkListConnection"],
	validateCreateSocialLinkList: GraphQLTypes["_ValidationResult"],
	validateUpdateSocialLinkList: GraphQLTypes["_ValidationResult"],
	getSocialLinkItem?: GraphQLTypes["SocialLinkItem"],
	listSocialLinkItem: Array<GraphQLTypes["SocialLinkItem"]>,
	paginateSocialLinkItem: GraphQLTypes["SocialLinkItemConnection"],
	validateCreateSocialLinkItem: GraphQLTypes["_ValidationResult"],
	validateUpdateSocialLinkItem: GraphQLTypes["_ValidationResult"],
	getSharedContent?: GraphQLTypes["SharedContent"],
	listSharedContent: Array<GraphQLTypes["SharedContent"]>,
	paginateSharedContent: GraphQLTypes["SharedContentConnection"],
	validateCreateSharedContent: GraphQLTypes["_ValidationResult"],
	validateUpdateSharedContent: GraphQLTypes["_ValidationResult"],
	transaction?: GraphQLTypes["QueryTransaction"],
	_info?: GraphQLTypes["Info"],
	schema?: GraphQLTypes["_Schema"],
	s3DummyQuery?: string
};
	["Article"]: {
	__typename: "Article",
	_meta?: GraphQLTypes["ArticleMeta"],
	id: GraphQLTypes["UUID"],
	title: string,
	url?: GraphQLTypes["Url"],
	authors: Array<GraphQLTypes["ArticleAuthor"]>,
	hideInMostRead: boolean,
	hideAds: boolean,
	state: GraphQLTypes["ArticleState"],
	locked: boolean,
	publishAt?: GraphQLTypes["DateTime"],
	template: GraphQLTypes["Template"],
	subtitle?: GraphQLTypes["TextContent"],
	content?: GraphQLTypes["Content"],
	coverPhoto?: GraphQLTypes["ImageUse"],
	titleAlignment: GraphQLTypes["ArticleTitleAlignment"],
	tagline?: string,
	createdAt: GraphQLTypes["DateTime"],
	previewContent?: GraphQLTypes["Content"],
	audio?: GraphQLTypes["AudioUse"],
	categories: Array<GraphQLTypes["ArticleCategory"]>,
	issues: Array<GraphQLTypes["IssueArticle"]>,
	contentBlocks: Array<GraphQLTypes["ContentArticle"]>,
	unlocked: Array<GraphQLTypes["UnlockedArticle"]>,
	coverPhotoVertical?: GraphQLTypes["ImageUse"],
	legacyId?: string,
	tags: Array<GraphQLTypes["ArticleTag"]>,
	isHistory: boolean,
	historyTags: Array<GraphQLTypes["ArticleHistoryTag"]>,
	historyPeriods: Array<GraphQLTypes["ArticleHistoryPeriod"]>,
	authorsByAuthor?: GraphQLTypes["ArticleAuthor"],
	authorsByLegacyStringAuthor?: GraphQLTypes["ArticleAuthor"],
	categoriesByCategory?: GraphQLTypes["ArticleCategory"],
	issuesByIssue?: GraphQLTypes["IssueArticle"],
	tagsByTag?: GraphQLTypes["ArticleTag"],
	historyTagsByHistoryTag?: GraphQLTypes["ArticleHistoryTag"],
	historyPeriodsByHistoryPeriod?: GraphQLTypes["ArticleHistoryPeriod"],
	paginateAuthors: GraphQLTypes["ArticleAuthorConnection"],
	paginateCategories: GraphQLTypes["ArticleCategoryConnection"],
	paginateIssues: GraphQLTypes["IssueArticleConnection"],
	paginateContentBlocks: GraphQLTypes["ContentArticleConnection"],
	paginateUnlocked: GraphQLTypes["UnlockedArticleConnection"],
	paginateTags: GraphQLTypes["ArticleTagConnection"],
	paginateHistoryTags: GraphQLTypes["ArticleHistoryTagConnection"],
	paginateHistoryPeriods: GraphQLTypes["ArticleHistoryPeriodConnection"]
};
	["ArticleMeta"]: {
	__typename: "ArticleMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"],
	authors?: GraphQLTypes["FieldMeta"],
	hideInMostRead?: GraphQLTypes["FieldMeta"],
	hideAds?: GraphQLTypes["FieldMeta"],
	state?: GraphQLTypes["FieldMeta"],
	locked?: GraphQLTypes["FieldMeta"],
	publishAt?: GraphQLTypes["FieldMeta"],
	template?: GraphQLTypes["FieldMeta"],
	subtitle?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	coverPhoto?: GraphQLTypes["FieldMeta"],
	titleAlignment?: GraphQLTypes["FieldMeta"],
	tagline?: GraphQLTypes["FieldMeta"],
	createdAt?: GraphQLTypes["FieldMeta"],
	previewContent?: GraphQLTypes["FieldMeta"],
	audio?: GraphQLTypes["FieldMeta"],
	categories?: GraphQLTypes["FieldMeta"],
	issues?: GraphQLTypes["FieldMeta"],
	contentBlocks?: GraphQLTypes["FieldMeta"],
	unlocked?: GraphQLTypes["FieldMeta"],
	coverPhotoVertical?: GraphQLTypes["FieldMeta"],
	legacyId?: GraphQLTypes["FieldMeta"],
	tags?: GraphQLTypes["FieldMeta"],
	isHistory?: GraphQLTypes["FieldMeta"],
	historyTags?: GraphQLTypes["FieldMeta"],
	historyPeriods?: GraphQLTypes["FieldMeta"]
};
	["FieldMeta"]: {
	__typename: "FieldMeta",
	readable?: boolean,
	updatable?: boolean
};
	["UUID"]:any;
	["Url"]: {
	__typename: "Url",
	_meta?: GraphQLTypes["UrlMeta"],
	id: GraphQLTypes["UUID"],
	url: string,
	article?: GraphQLTypes["Article"],
	author?: GraphQLTypes["Author"],
	issue?: GraphQLTypes["Issue"],
	page?: GraphQLTypes["Page"],
	category?: GraphQLTypes["Category"],
	tag?: GraphQLTypes["Tag"],
	redirect?: string
};
	["UrlMeta"]: {
	__typename: "UrlMeta",
	id?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"],
	article?: GraphQLTypes["FieldMeta"],
	author?: GraphQLTypes["FieldMeta"],
	issue?: GraphQLTypes["FieldMeta"],
	page?: GraphQLTypes["FieldMeta"],
	category?: GraphQLTypes["FieldMeta"],
	tag?: GraphQLTypes["FieldMeta"],
	redirect?: GraphQLTypes["FieldMeta"]
};
	["ArticleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	url?: GraphQLTypes["UrlWhere"],
	authors?: GraphQLTypes["ArticleAuthorWhere"],
	hideInMostRead?: GraphQLTypes["BooleanCondition"],
	hideAds?: GraphQLTypes["BooleanCondition"],
	state?: GraphQLTypes["ArticleStateCondition"],
	locked?: GraphQLTypes["BooleanCondition"],
	publishAt?: GraphQLTypes["DateTimeCondition"],
	template?: GraphQLTypes["TemplateCondition"],
	subtitle?: GraphQLTypes["TextContentWhere"],
	content?: GraphQLTypes["ContentWhere"],
	coverPhoto?: GraphQLTypes["ImageUseWhere"],
	titleAlignment?: GraphQLTypes["ArticleTitleAlignmentCondition"],
	tagline?: GraphQLTypes["StringCondition"],
	createdAt?: GraphQLTypes["DateTimeCondition"],
	previewContent?: GraphQLTypes["ContentWhere"],
	audio?: GraphQLTypes["AudioUseWhere"],
	categories?: GraphQLTypes["ArticleCategoryWhere"],
	issues?: GraphQLTypes["IssueArticleWhere"],
	contentBlocks?: GraphQLTypes["ContentArticleWhere"],
	unlocked?: GraphQLTypes["UnlockedArticleWhere"],
	coverPhotoVertical?: GraphQLTypes["ImageUseWhere"],
	legacyId?: GraphQLTypes["StringCondition"],
	tags?: GraphQLTypes["ArticleTagWhere"],
	isHistory?: GraphQLTypes["BooleanCondition"],
	historyTags?: GraphQLTypes["ArticleHistoryTagWhere"],
	historyPeriods?: GraphQLTypes["ArticleHistoryPeriodWhere"],
	and?: Array<GraphQLTypes["ArticleWhere"] | undefined>,
	or?: Array<GraphQLTypes["ArticleWhere"] | undefined>,
	not?: GraphQLTypes["ArticleWhere"]
};
	["UUIDCondition"]: {
		and?: Array<GraphQLTypes["UUIDCondition"]>,
	or?: Array<GraphQLTypes["UUIDCondition"]>,
	not?: GraphQLTypes["UUIDCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["UUID"],
	notEq?: GraphQLTypes["UUID"],
	in?: Array<GraphQLTypes["UUID"]>,
	notIn?: Array<GraphQLTypes["UUID"]>,
	lt?: GraphQLTypes["UUID"],
	lte?: GraphQLTypes["UUID"],
	gt?: GraphQLTypes["UUID"],
	gte?: GraphQLTypes["UUID"]
};
	["StringCondition"]: {
		and?: Array<GraphQLTypes["StringCondition"]>,
	or?: Array<GraphQLTypes["StringCondition"]>,
	not?: GraphQLTypes["StringCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: string,
	notEq?: string,
	in?: Array<string>,
	notIn?: Array<string>,
	lt?: string,
	lte?: string,
	gt?: string,
	gte?: string,
	contains?: string,
	startsWith?: string,
	endsWith?: string,
	containsCI?: string,
	startsWithCI?: string,
	endsWithCI?: string
};
	["UrlWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	url?: GraphQLTypes["StringCondition"],
	article?: GraphQLTypes["ArticleWhere"],
	author?: GraphQLTypes["AuthorWhere"],
	issue?: GraphQLTypes["IssueWhere"],
	page?: GraphQLTypes["PageWhere"],
	category?: GraphQLTypes["CategoryWhere"],
	tag?: GraphQLTypes["TagWhere"],
	redirect?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["UrlWhere"] | undefined>,
	or?: Array<GraphQLTypes["UrlWhere"] | undefined>,
	not?: GraphQLTypes["UrlWhere"]
};
	["AuthorWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	position?: GraphQLTypes["StringCondition"],
	twitterHandle?: GraphQLTypes["StringCondition"],
	facebookId?: GraphQLTypes["StringCondition"],
	email?: GraphQLTypes["StringCondition"],
	photographer?: GraphQLTypes["BooleanCondition"],
	order?: GraphQLTypes["IntCondition"],
	about?: GraphQLTypes["ContentWhere"],
	topArticles?: GraphQLTypes["AuthorTopArticleWhere"],
	users?: GraphQLTypes["UserWhere"],
	startOfCooperation?: GraphQLTypes["DateCondition"],
	photo?: GraphQLTypes["ImageUseWhere"],
	illustration?: GraphQLTypes["ImageUseWhere"],
	legacyId?: GraphQLTypes["StringCondition"],
	category?: GraphQLTypes["AuthorCategoryCondition"],
	url?: GraphQLTypes["UrlWhere"],
	instagramUsername?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["AuthorWhere"] | undefined>,
	or?: Array<GraphQLTypes["AuthorWhere"] | undefined>,
	not?: GraphQLTypes["AuthorWhere"]
};
	["BooleanCondition"]: {
		and?: Array<GraphQLTypes["BooleanCondition"]>,
	or?: Array<GraphQLTypes["BooleanCondition"]>,
	not?: GraphQLTypes["BooleanCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: boolean,
	notEq?: boolean,
	in?: Array<boolean>,
	notIn?: Array<boolean>,
	lt?: boolean,
	lte?: boolean,
	gt?: boolean,
	gte?: boolean
};
	["IntCondition"]: {
		and?: Array<GraphQLTypes["IntCondition"]>,
	or?: Array<GraphQLTypes["IntCondition"]>,
	not?: GraphQLTypes["IntCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: number,
	notEq?: number,
	in?: Array<number>,
	notIn?: Array<number>,
	lt?: number,
	lte?: number,
	gt?: number,
	gte?: number
};
	["ContentWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	parts?: GraphQLTypes["ContentPartWhere"],
	and?: Array<GraphQLTypes["ContentWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentWhere"] | undefined>,
	not?: GraphQLTypes["ContentWhere"]
};
	["ContentPartWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	json?: GraphQLTypes["StringCondition"],
	content?: GraphQLTypes["ContentWhere"],
	references?: GraphQLTypes["ContentReferenceWhere"],
	and?: Array<GraphQLTypes["ContentPartWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentPartWhere"] | undefined>,
	not?: GraphQLTypes["ContentPartWhere"]
};
	["ContentReferenceWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	type?: GraphQLTypes["ContentReferenceTypeCondition"],
	contentPart?: GraphQLTypes["ContentPartWhere"],
	primaryText?: GraphQLTypes["StringCondition"],
	secondaryText?: GraphQLTypes["StringCondition"],
	variant?: GraphQLTypes["ContentReferenceVariantCondition"],
	color?: GraphQLTypes["StringCondition"],
	embed?: GraphQLTypes["EmbedWhere"],
	article?: GraphQLTypes["ArticleWhere"],
	audio?: GraphQLTypes["AudioUseWhere"],
	image?: GraphQLTypes["ImageUseWhere"],
	images?: GraphQLTypes["ImageContentWhere"],
	pollAnswer?: GraphQLTypes["PollAnswerWhere"],
	listicle?: GraphQLTypes["ListicleWhere"],
	faq?: GraphQLTypes["FAQWhere"],
	links?: GraphQLTypes["LinkContentWhere"],
	awards?: GraphQLTypes["AwardContentWhere"],
	reviews?: GraphQLTypes["ReviewContentWhere"],
	target?: GraphQLTypes["LinkWhere"],
	subscriptionForm?: GraphQLTypes["SubscriptionFormWhere"],
	buttons?: GraphQLTypes["ButtonWhere"],
	sharedContent?: GraphQLTypes["SharedContentWhere"],
	and?: Array<GraphQLTypes["ContentReferenceWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentReferenceWhere"] | undefined>,
	not?: GraphQLTypes["ContentReferenceWhere"]
};
	["ContentReferenceTypeCondition"]: {
		and?: Array<GraphQLTypes["ContentReferenceTypeCondition"]>,
	or?: Array<GraphQLTypes["ContentReferenceTypeCondition"]>,
	not?: GraphQLTypes["ContentReferenceTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["ContentReferenceType"],
	notEq?: GraphQLTypes["ContentReferenceType"],
	in?: Array<GraphQLTypes["ContentReferenceType"]>,
	notIn?: Array<GraphQLTypes["ContentReferenceType"]>,
	lt?: GraphQLTypes["ContentReferenceType"],
	lte?: GraphQLTypes["ContentReferenceType"],
	gt?: GraphQLTypes["ContentReferenceType"],
	gte?: GraphQLTypes["ContentReferenceType"]
};
	["ContentReferenceType"]: ContentReferenceType;
	["ContentReferenceVariantCondition"]: {
		and?: Array<GraphQLTypes["ContentReferenceVariantCondition"]>,
	or?: Array<GraphQLTypes["ContentReferenceVariantCondition"]>,
	not?: GraphQLTypes["ContentReferenceVariantCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["ContentReferenceVariant"],
	notEq?: GraphQLTypes["ContentReferenceVariant"],
	in?: Array<GraphQLTypes["ContentReferenceVariant"]>,
	notIn?: Array<GraphQLTypes["ContentReferenceVariant"]>,
	lt?: GraphQLTypes["ContentReferenceVariant"],
	lte?: GraphQLTypes["ContentReferenceVariant"],
	gt?: GraphQLTypes["ContentReferenceVariant"],
	gte?: GraphQLTypes["ContentReferenceVariant"]
};
	["ContentReferenceVariant"]: ContentReferenceVariant;
	["EmbedWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	type?: GraphQLTypes["EmbedTypeCondition"],
	youtubeId?: GraphQLTypes["StringCondition"],
	vimeoId?: GraphQLTypes["StringCondition"],
	spotifyId?: GraphQLTypes["StringCondition"],
	spotifyType?: GraphQLTypes["StringCondition"],
	soundCloudId?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["EmbedWhere"] | undefined>,
	or?: Array<GraphQLTypes["EmbedWhere"] | undefined>,
	not?: GraphQLTypes["EmbedWhere"]
};
	["EmbedTypeCondition"]: {
		and?: Array<GraphQLTypes["EmbedTypeCondition"]>,
	or?: Array<GraphQLTypes["EmbedTypeCondition"]>,
	not?: GraphQLTypes["EmbedTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["EmbedType"],
	notEq?: GraphQLTypes["EmbedType"],
	in?: Array<GraphQLTypes["EmbedType"]>,
	notIn?: Array<GraphQLTypes["EmbedType"]>,
	lt?: GraphQLTypes["EmbedType"],
	lte?: GraphQLTypes["EmbedType"],
	gt?: GraphQLTypes["EmbedType"],
	gte?: GraphQLTypes["EmbedType"]
};
	["EmbedType"]: EmbedType;
	["AudioUseWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	audio?: GraphQLTypes["AudioWhere"],
	and?: Array<GraphQLTypes["AudioUseWhere"] | undefined>,
	or?: Array<GraphQLTypes["AudioUseWhere"] | undefined>,
	not?: GraphQLTypes["AudioUseWhere"]
};
	["AudioWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	url?: GraphQLTypes["StringCondition"],
	type?: GraphQLTypes["StringCondition"],
	author?: GraphQLTypes["AuthorWhere"],
	uses?: GraphQLTypes["AudioUseWhere"],
	and?: Array<GraphQLTypes["AudioWhere"] | undefined>,
	or?: Array<GraphQLTypes["AudioWhere"] | undefined>,
	not?: GraphQLTypes["AudioWhere"]
};
	["ImageUseWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	image?: GraphQLTypes["ImageWhere"],
	and?: Array<GraphQLTypes["ImageUseWhere"] | undefined>,
	or?: Array<GraphQLTypes["ImageUseWhere"] | undefined>,
	not?: GraphQLTypes["ImageUseWhere"]
};
	["ImageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	url?: GraphQLTypes["StringCondition"],
	width?: GraphQLTypes["IntCondition"],
	height?: GraphQLTypes["IntCondition"],
	title?: GraphQLTypes["StringCondition"],
	text?: GraphQLTypes["StringCondition"],
	author?: GraphQLTypes["AuthorWhere"],
	tags?: GraphQLTypes["ImageTagWhere"],
	uses?: GraphQLTypes["ImageUseWhere"],
	align?: GraphQLTypes["ImageAlignCondition"],
	legacyId?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["ImageWhere"] | undefined>,
	or?: Array<GraphQLTypes["ImageWhere"] | undefined>,
	not?: GraphQLTypes["ImageWhere"]
};
	["ImageTagWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	images?: GraphQLTypes["ImageWhere"],
	and?: Array<GraphQLTypes["ImageTagWhere"] | undefined>,
	or?: Array<GraphQLTypes["ImageTagWhere"] | undefined>,
	not?: GraphQLTypes["ImageTagWhere"]
};
	["ImageAlignCondition"]: {
		and?: Array<GraphQLTypes["ImageAlignCondition"]>,
	or?: Array<GraphQLTypes["ImageAlignCondition"]>,
	not?: GraphQLTypes["ImageAlignCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["ImageAlign"],
	notEq?: GraphQLTypes["ImageAlign"],
	in?: Array<GraphQLTypes["ImageAlign"]>,
	notIn?: Array<GraphQLTypes["ImageAlign"]>,
	lt?: GraphQLTypes["ImageAlign"],
	lte?: GraphQLTypes["ImageAlign"],
	gt?: GraphQLTypes["ImageAlign"],
	gte?: GraphQLTypes["ImageAlign"]
};
	["ImageAlign"]: ImageAlign;
	["ImageContentWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	contentReference?: GraphQLTypes["ContentReferenceWhere"],
	image?: GraphQLTypes["ImageUseWhere"],
	and?: Array<GraphQLTypes["ImageContentWhere"] | undefined>,
	or?: Array<GraphQLTypes["ImageContentWhere"] | undefined>,
	not?: GraphQLTypes["ImageContentWhere"]
};
	["PollAnswerWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	authorName?: GraphQLTypes["StringCondition"],
	authorPosition?: GraphQLTypes["StringCondition"],
	text?: GraphQLTypes["StringCondition"],
	authorImage?: GraphQLTypes["ImageUseWhere"],
	and?: Array<GraphQLTypes["PollAnswerWhere"] | undefined>,
	or?: Array<GraphQLTypes["PollAnswerWhere"] | undefined>,
	not?: GraphQLTypes["PollAnswerWhere"]
};
	["ListicleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	primaryText?: GraphQLTypes["StringCondition"],
	image?: GraphQLTypes["ImageUseWhere"],
	contentReference?: GraphQLTypes["ContentReferenceWhere"],
	target?: GraphQLTypes["LinkWhere"],
	content?: GraphQLTypes["ContentWhere"],
	and?: Array<GraphQLTypes["ListicleWhere"] | undefined>,
	or?: Array<GraphQLTypes["ListicleWhere"] | undefined>,
	not?: GraphQLTypes["ListicleWhere"]
};
	["LinkWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	type?: GraphQLTypes["LinkTypeCondition"],
	externalTarget?: GraphQLTypes["StringCondition"],
	internalTarget?: GraphQLTypes["UrlWhere"],
	queryParameters?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["LinkWhere"] | undefined>,
	or?: Array<GraphQLTypes["LinkWhere"] | undefined>,
	not?: GraphQLTypes["LinkWhere"]
};
	["LinkTypeCondition"]: {
		and?: Array<GraphQLTypes["LinkTypeCondition"]>,
	or?: Array<GraphQLTypes["LinkTypeCondition"]>,
	not?: GraphQLTypes["LinkTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["LinkType"],
	notEq?: GraphQLTypes["LinkType"],
	in?: Array<GraphQLTypes["LinkType"]>,
	notIn?: Array<GraphQLTypes["LinkType"]>,
	lt?: GraphQLTypes["LinkType"],
	lte?: GraphQLTypes["LinkType"],
	gt?: GraphQLTypes["LinkType"],
	gte?: GraphQLTypes["LinkType"]
};
	["LinkType"]: LinkType;
	["FAQWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	answer?: GraphQLTypes["StringCondition"],
	question?: GraphQLTypes["StringCondition"],
	contentReference?: GraphQLTypes["ContentReferenceWhere"],
	and?: Array<GraphQLTypes["FAQWhere"] | undefined>,
	or?: Array<GraphQLTypes["FAQWhere"] | undefined>,
	not?: GraphQLTypes["FAQWhere"]
};
	["LinkContentWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	contentReference?: GraphQLTypes["ContentReferenceWhere"],
	text?: GraphQLTypes["StringCondition"],
	target?: GraphQLTypes["LinkWhere"],
	and?: Array<GraphQLTypes["LinkContentWhere"] | undefined>,
	or?: Array<GraphQLTypes["LinkContentWhere"] | undefined>,
	not?: GraphQLTypes["LinkContentWhere"]
};
	["AwardContentWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	image?: GraphQLTypes["ImageUseWhere"],
	contentReference?: GraphQLTypes["ContentReferenceWhere"],
	target?: GraphQLTypes["LinkWhere"],
	and?: Array<GraphQLTypes["AwardContentWhere"] | undefined>,
	or?: Array<GraphQLTypes["AwardContentWhere"] | undefined>,
	not?: GraphQLTypes["AwardContentWhere"]
};
	["ReviewContentWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	text?: GraphQLTypes["StringCondition"],
	contentReference?: GraphQLTypes["ContentReferenceWhere"],
	and?: Array<GraphQLTypes["ReviewContentWhere"] | undefined>,
	or?: Array<GraphQLTypes["ReviewContentWhere"] | undefined>,
	not?: GraphQLTypes["ReviewContentWhere"]
};
	["SubscriptionFormWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	code?: GraphQLTypes["StringCondition"],
	createdAt?: GraphQLTypes["DateTimeCondition"],
	sections?: GraphQLTypes["SubscriptionFormSectionWhere"],
	contentBlock?: GraphQLTypes["ContentBlockWhere"],
	products?: GraphQLTypes["ProductWhere"],
	contentReferences?: GraphQLTypes["ContentReferenceWhere"],
	validity?: GraphQLTypes["DateTimeCondition"],
	and?: Array<GraphQLTypes["SubscriptionFormWhere"] | undefined>,
	or?: Array<GraphQLTypes["SubscriptionFormWhere"] | undefined>,
	not?: GraphQLTypes["SubscriptionFormWhere"]
};
	["DateTimeCondition"]: {
		and?: Array<GraphQLTypes["DateTimeCondition"]>,
	or?: Array<GraphQLTypes["DateTimeCondition"]>,
	not?: GraphQLTypes["DateTimeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["DateTime"],
	notEq?: GraphQLTypes["DateTime"],
	in?: Array<GraphQLTypes["DateTime"]>,
	notIn?: Array<GraphQLTypes["DateTime"]>,
	lt?: GraphQLTypes["DateTime"],
	lte?: GraphQLTypes["DateTime"],
	gt?: GraphQLTypes["DateTime"],
	gte?: GraphQLTypes["DateTime"]
};
	["DateTime"]:any;
	["SubscriptionFormSectionWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	title?: GraphQLTypes["StringCondition"],
	form?: GraphQLTypes["SubscriptionFormWhere"],
	inputs?: GraphQLTypes["SubscriptionFormInputWhere"],
	and?: Array<GraphQLTypes["SubscriptionFormSectionWhere"] | undefined>,
	or?: Array<GraphQLTypes["SubscriptionFormSectionWhere"] | undefined>,
	not?: GraphQLTypes["SubscriptionFormSectionWhere"]
};
	["SubscriptionFormInputWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	type?: GraphQLTypes["SubscriptionFormInputTypeCondition"],
	image?: GraphQLTypes["ImageUseWhere"],
	section?: GraphQLTypes["SubscriptionFormSectionWhere"],
	options?: GraphQLTypes["SubscriptionFormOptionWhere"],
	description?: GraphQLTypes["ContentWhere"],
	required?: GraphQLTypes["BooleanCondition"],
	and?: Array<GraphQLTypes["SubscriptionFormInputWhere"] | undefined>,
	or?: Array<GraphQLTypes["SubscriptionFormInputWhere"] | undefined>,
	not?: GraphQLTypes["SubscriptionFormInputWhere"]
};
	["SubscriptionFormInputTypeCondition"]: {
		and?: Array<GraphQLTypes["SubscriptionFormInputTypeCondition"]>,
	or?: Array<GraphQLTypes["SubscriptionFormInputTypeCondition"]>,
	not?: GraphQLTypes["SubscriptionFormInputTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["SubscriptionFormInputType"],
	notEq?: GraphQLTypes["SubscriptionFormInputType"],
	in?: Array<GraphQLTypes["SubscriptionFormInputType"]>,
	notIn?: Array<GraphQLTypes["SubscriptionFormInputType"]>,
	lt?: GraphQLTypes["SubscriptionFormInputType"],
	lte?: GraphQLTypes["SubscriptionFormInputType"],
	gt?: GraphQLTypes["SubscriptionFormInputType"],
	gte?: GraphQLTypes["SubscriptionFormInputType"]
};
	["SubscriptionFormInputType"]: SubscriptionFormInputType;
	["SubscriptionFormOptionWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	hasProductId?: GraphQLTypes["BooleanCondition"],
	order?: GraphQLTypes["IntCondition"],
	label?: GraphQLTypes["StringCondition"],
	priceTag?: GraphQLTypes["StringCondition"],
	priceTagWithDiscount?: GraphQLTypes["StringCondition"],
	products?: GraphQLTypes["ProductWhere"],
	formInput?: GraphQLTypes["SubscriptionFormInputWhere"],
	value?: GraphQLTypes["StringCondition"],
	internalLabel?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["SubscriptionFormOptionWhere"] | undefined>,
	or?: Array<GraphQLTypes["SubscriptionFormOptionWhere"] | undefined>,
	not?: GraphQLTypes["SubscriptionFormOptionWhere"]
};
	["ProductWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	price?: GraphQLTypes["IntCondition"],
	type?: GraphQLTypes["TypesCondition"],
	formOptions?: GraphQLTypes["SubscriptionFormOptionWhere"],
	form?: GraphQLTypes["SubscriptionFormWhere"],
	productId?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["ProductWhere"] | undefined>,
	or?: Array<GraphQLTypes["ProductWhere"] | undefined>,
	not?: GraphQLTypes["ProductWhere"]
};
	["TypesCondition"]: {
		and?: Array<GraphQLTypes["TypesCondition"]>,
	or?: Array<GraphQLTypes["TypesCondition"]>,
	not?: GraphQLTypes["TypesCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["Types"],
	notEq?: GraphQLTypes["Types"],
	in?: Array<GraphQLTypes["Types"]>,
	notIn?: Array<GraphQLTypes["Types"]>,
	lt?: GraphQLTypes["Types"],
	lte?: GraphQLTypes["Types"],
	gt?: GraphQLTypes["Types"],
	gte?: GraphQLTypes["Types"]
};
	["Types"]: Types;
	["ContentBlockWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	type?: GraphQLTypes["ContentBlockTypeCondition"],
	youtubeId?: GraphQLTypes["StringCondition"],
	text?: GraphQLTypes["StringCondition"],
	targetLabel?: GraphQLTypes["StringCondition"],
	issue?: GraphQLTypes["IssueWhere"],
	target?: GraphQLTypes["LinkWhere"],
	articles?: GraphQLTypes["ContentArticleWhere"],
	subscriptionForm?: GraphQLTypes["SubscriptionFormWhere"],
	and?: Array<GraphQLTypes["ContentBlockWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentBlockWhere"] | undefined>,
	not?: GraphQLTypes["ContentBlockWhere"]
};
	["ContentBlockTypeCondition"]: {
		and?: Array<GraphQLTypes["ContentBlockTypeCondition"]>,
	or?: Array<GraphQLTypes["ContentBlockTypeCondition"]>,
	not?: GraphQLTypes["ContentBlockTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["ContentBlockType"],
	notEq?: GraphQLTypes["ContentBlockType"],
	in?: Array<GraphQLTypes["ContentBlockType"]>,
	notIn?: Array<GraphQLTypes["ContentBlockType"]>,
	lt?: GraphQLTypes["ContentBlockType"],
	lte?: GraphQLTypes["ContentBlockType"],
	gt?: GraphQLTypes["ContentBlockType"],
	gte?: GraphQLTypes["ContentBlockType"]
};
	["ContentBlockType"]: ContentBlockType;
	["IssueWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	closed?: GraphQLTypes["BooleanCondition"],
	free?: GraphQLTypes["BooleanCondition"],
	title?: GraphQLTypes["StringCondition"],
	subtitle?: GraphQLTypes["StringCondition"],
	year?: GraphQLTypes["IntCondition"],
	issue?: GraphQLTypes["IntCondition"],
	publishedSince?: GraphQLTypes["DateCondition"],
	publishedUntil?: GraphQLTypes["DateCondition"],
	publishDigital?: GraphQLTypes["DateTimeCondition"],
	mobileAppsKey?: GraphQLTypes["StringCondition"],
	url?: GraphQLTypes["UrlWhere"],
	articles?: GraphQLTypes["IssueArticleWhere"],
	kind?: GraphQLTypes["IssueKindCondition"],
	notificationTitle?: GraphQLTypes["StringCondition"],
	notificationMessage?: GraphQLTypes["StringCondition"],
	pdf?: GraphQLTypes["FileUseWhere"],
	printBuy?: GraphQLTypes["BooleanCondition"],
	printText?: GraphQLTypes["StringCondition"],
	blocks?: GraphQLTypes["ContentBlockWhere"],
	coverPhoto?: GraphQLTypes["ImageUseWhere"],
	printTarget?: GraphQLTypes["LinkWhere"],
	backgroundPhoto?: GraphQLTypes["ImageUseWhere"],
	legacyId?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["IssueWhere"] | undefined>,
	or?: Array<GraphQLTypes["IssueWhere"] | undefined>,
	not?: GraphQLTypes["IssueWhere"]
};
	["DateCondition"]: {
		and?: Array<GraphQLTypes["DateCondition"]>,
	or?: Array<GraphQLTypes["DateCondition"]>,
	not?: GraphQLTypes["DateCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["Date"],
	notEq?: GraphQLTypes["Date"],
	in?: Array<GraphQLTypes["Date"]>,
	notIn?: Array<GraphQLTypes["Date"]>,
	lt?: GraphQLTypes["Date"],
	lte?: GraphQLTypes["Date"],
	gt?: GraphQLTypes["Date"],
	gte?: GraphQLTypes["Date"]
};
	["Date"]:any;
	["IssueArticleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	issue?: GraphQLTypes["IssueWhere"],
	article?: GraphQLTypes["ArticleWhere"],
	order?: GraphQLTypes["IntCondition"],
	and?: Array<GraphQLTypes["IssueArticleWhere"] | undefined>,
	or?: Array<GraphQLTypes["IssueArticleWhere"] | undefined>,
	not?: GraphQLTypes["IssueArticleWhere"]
};
	["IssueKindCondition"]: {
		and?: Array<GraphQLTypes["IssueKindCondition"]>,
	or?: Array<GraphQLTypes["IssueKindCondition"]>,
	not?: GraphQLTypes["IssueKindCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["IssueKind"],
	notEq?: GraphQLTypes["IssueKind"],
	in?: Array<GraphQLTypes["IssueKind"]>,
	notIn?: Array<GraphQLTypes["IssueKind"]>,
	lt?: GraphQLTypes["IssueKind"],
	lte?: GraphQLTypes["IssueKind"],
	gt?: GraphQLTypes["IssueKind"],
	gte?: GraphQLTypes["IssueKind"]
};
	["IssueKind"]: IssueKind;
	["FileUseWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	file?: GraphQLTypes["FileWhere"],
	and?: Array<GraphQLTypes["FileUseWhere"] | undefined>,
	or?: Array<GraphQLTypes["FileUseWhere"] | undefined>,
	not?: GraphQLTypes["FileUseWhere"]
};
	["FileWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	url?: GraphQLTypes["StringCondition"],
	uses?: GraphQLTypes["FileUseWhere"],
	and?: Array<GraphQLTypes["FileWhere"] | undefined>,
	or?: Array<GraphQLTypes["FileWhere"] | undefined>,
	not?: GraphQLTypes["FileWhere"]
};
	["ContentArticleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	contentBlock?: GraphQLTypes["ContentBlockWhere"],
	article?: GraphQLTypes["ArticleWhere"],
	and?: Array<GraphQLTypes["ContentArticleWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentArticleWhere"] | undefined>,
	not?: GraphQLTypes["ContentArticleWhere"]
};
	["ButtonWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	type?: GraphQLTypes["ButtonTypeCondition"],
	label?: GraphQLTypes["StringCondition"],
	target?: GraphQLTypes["LinkWhere"],
	contentReference?: GraphQLTypes["ContentReferenceWhere"],
	and?: Array<GraphQLTypes["ButtonWhere"] | undefined>,
	or?: Array<GraphQLTypes["ButtonWhere"] | undefined>,
	not?: GraphQLTypes["ButtonWhere"]
};
	["ButtonTypeCondition"]: {
		and?: Array<GraphQLTypes["ButtonTypeCondition"]>,
	or?: Array<GraphQLTypes["ButtonTypeCondition"]>,
	not?: GraphQLTypes["ButtonTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["ButtonType"],
	notEq?: GraphQLTypes["ButtonType"],
	in?: Array<GraphQLTypes["ButtonType"]>,
	notIn?: Array<GraphQLTypes["ButtonType"]>,
	lt?: GraphQLTypes["ButtonType"],
	lte?: GraphQLTypes["ButtonType"],
	gt?: GraphQLTypes["ButtonType"],
	gte?: GraphQLTypes["ButtonType"]
};
	["ButtonType"]: ButtonType;
	["SharedContentWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	contentReference?: GraphQLTypes["ContentReferenceWhere"],
	content?: GraphQLTypes["ContentWhere"],
	and?: Array<GraphQLTypes["SharedContentWhere"] | undefined>,
	or?: Array<GraphQLTypes["SharedContentWhere"] | undefined>,
	not?: GraphQLTypes["SharedContentWhere"]
};
	["AuthorTopArticleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	author?: GraphQLTypes["AuthorWhere"],
	article?: GraphQLTypes["ArticleWhere"],
	and?: Array<GraphQLTypes["AuthorTopArticleWhere"] | undefined>,
	or?: Array<GraphQLTypes["AuthorTopArticleWhere"] | undefined>,
	not?: GraphQLTypes["AuthorTopArticleWhere"]
};
	["UserWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	ihnedId?: GraphQLTypes["StringCondition"],
	email?: GraphQLTypes["StringCondition"],
	authors?: GraphQLTypes["AuthorWhere"],
	unlockedArticles?: GraphQLTypes["UnlockedArticleWhere"],
	appReviews?: GraphQLTypes["AppReviewWhere"],
	and?: Array<GraphQLTypes["UserWhere"] | undefined>,
	or?: Array<GraphQLTypes["UserWhere"] | undefined>,
	not?: GraphQLTypes["UserWhere"]
};
	["UnlockedArticleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	createdAt?: GraphQLTypes["DateTimeCondition"],
	code?: GraphQLTypes["StringCondition"],
	views?: GraphQLTypes["IntCondition"],
	user?: GraphQLTypes["UserWhere"],
	article?: GraphQLTypes["ArticleWhere"],
	and?: Array<GraphQLTypes["UnlockedArticleWhere"] | undefined>,
	or?: Array<GraphQLTypes["UnlockedArticleWhere"] | undefined>,
	not?: GraphQLTypes["UnlockedArticleWhere"]
};
	["AppReviewWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	done?: GraphQLTypes["BooleanCondition"],
	deviceId?: GraphQLTypes["StringCondition"],
	createdAt?: GraphQLTypes["DateTimeCondition"],
	rating?: GraphQLTypes["IntCondition"],
	note?: GraphQLTypes["StringCondition"],
	user?: GraphQLTypes["UserWhere"],
	and?: Array<GraphQLTypes["AppReviewWhere"] | undefined>,
	or?: Array<GraphQLTypes["AppReviewWhere"] | undefined>,
	not?: GraphQLTypes["AppReviewWhere"]
};
	["AuthorCategoryCondition"]: {
		and?: Array<GraphQLTypes["AuthorCategoryCondition"]>,
	or?: Array<GraphQLTypes["AuthorCategoryCondition"]>,
	not?: GraphQLTypes["AuthorCategoryCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["AuthorCategory"],
	notEq?: GraphQLTypes["AuthorCategory"],
	in?: Array<GraphQLTypes["AuthorCategory"]>,
	notIn?: Array<GraphQLTypes["AuthorCategory"]>,
	lt?: GraphQLTypes["AuthorCategory"],
	lte?: GraphQLTypes["AuthorCategory"],
	gt?: GraphQLTypes["AuthorCategory"],
	gte?: GraphQLTypes["AuthorCategory"]
};
	["AuthorCategory"]: AuthorCategory;
	["PageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	publishAt?: GraphQLTypes["DateTimeCondition"],
	createdAt?: GraphQLTypes["DateTimeCondition"],
	template?: GraphQLTypes["PageTemplateCondition"],
	url?: GraphQLTypes["UrlWhere"],
	content?: GraphQLTypes["ContentWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	subscriptionValidity?: GraphQLTypes["DateTimeCondition"],
	and?: Array<GraphQLTypes["PageWhere"] | undefined>,
	or?: Array<GraphQLTypes["PageWhere"] | undefined>,
	not?: GraphQLTypes["PageWhere"]
};
	["PageTemplateCondition"]: {
		and?: Array<GraphQLTypes["PageTemplateCondition"]>,
	or?: Array<GraphQLTypes["PageTemplateCondition"]>,
	not?: GraphQLTypes["PageTemplateCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["PageTemplate"],
	notEq?: GraphQLTypes["PageTemplate"],
	in?: Array<GraphQLTypes["PageTemplate"]>,
	notIn?: Array<GraphQLTypes["PageTemplate"]>,
	lt?: GraphQLTypes["PageTemplate"],
	lte?: GraphQLTypes["PageTemplate"],
	gt?: GraphQLTypes["PageTemplate"],
	gte?: GraphQLTypes["PageTemplate"]
};
	["PageTemplate"]: PageTemplate;
	["SeoWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	description?: GraphQLTypes["StringCondition"],
	ogTitle?: GraphQLTypes["StringCondition"],
	ogDescription?: GraphQLTypes["StringCondition"],
	page?: GraphQLTypes["PageWhere"],
	twCard?: GraphQLTypes["SeoTwCardCondition"],
	ogImage?: GraphQLTypes["ImageUseWhere"],
	and?: Array<GraphQLTypes["SeoWhere"] | undefined>,
	or?: Array<GraphQLTypes["SeoWhere"] | undefined>,
	not?: GraphQLTypes["SeoWhere"]
};
	["SeoTwCardCondition"]: {
		and?: Array<GraphQLTypes["SeoTwCardCondition"]>,
	or?: Array<GraphQLTypes["SeoTwCardCondition"]>,
	not?: GraphQLTypes["SeoTwCardCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["SeoTwCard"],
	notEq?: GraphQLTypes["SeoTwCard"],
	in?: Array<GraphQLTypes["SeoTwCard"]>,
	notIn?: Array<GraphQLTypes["SeoTwCard"]>,
	lt?: GraphQLTypes["SeoTwCard"],
	lte?: GraphQLTypes["SeoTwCard"],
	gt?: GraphQLTypes["SeoTwCard"],
	gte?: GraphQLTypes["SeoTwCard"]
};
	["SeoTwCard"]: SeoTwCard;
	["CategoryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	articleCategory?: GraphQLTypes["ArticleCategoryWhere"],
	url?: GraphQLTypes["UrlWhere"],
	legacyId?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["CategoryWhere"] | undefined>,
	or?: Array<GraphQLTypes["CategoryWhere"] | undefined>,
	not?: GraphQLTypes["CategoryWhere"]
};
	["ArticleCategoryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	article?: GraphQLTypes["ArticleWhere"],
	category?: GraphQLTypes["CategoryWhere"],
	and?: Array<GraphQLTypes["ArticleCategoryWhere"] | undefined>,
	or?: Array<GraphQLTypes["ArticleCategoryWhere"] | undefined>,
	not?: GraphQLTypes["ArticleCategoryWhere"]
};
	["TagWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	useAsTagline?: GraphQLTypes["BooleanCondition"],
	articleTag?: GraphQLTypes["ArticleTagWhere"],
	url?: GraphQLTypes["UrlWhere"],
	order?: GraphQLTypes["StringCondition"],
	legacyId?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["TagWhere"] | undefined>,
	or?: Array<GraphQLTypes["TagWhere"] | undefined>,
	not?: GraphQLTypes["TagWhere"]
};
	["ArticleTagWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	tag?: GraphQLTypes["TagWhere"],
	article?: GraphQLTypes["ArticleWhere"],
	and?: Array<GraphQLTypes["ArticleTagWhere"] | undefined>,
	or?: Array<GraphQLTypes["ArticleTagWhere"] | undefined>,
	not?: GraphQLTypes["ArticleTagWhere"]
};
	["ArticleAuthorWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	article?: GraphQLTypes["ArticleWhere"],
	author?: GraphQLTypes["AuthorWhere"],
	legacyStringAuthor?: GraphQLTypes["ArticleAuthorLegacyStringAuthorCondition"],
	and?: Array<GraphQLTypes["ArticleAuthorWhere"] | undefined>,
	or?: Array<GraphQLTypes["ArticleAuthorWhere"] | undefined>,
	not?: GraphQLTypes["ArticleAuthorWhere"]
};
	["ArticleAuthorLegacyStringAuthorCondition"]: {
		and?: Array<GraphQLTypes["ArticleAuthorLegacyStringAuthorCondition"]>,
	or?: Array<GraphQLTypes["ArticleAuthorLegacyStringAuthorCondition"]>,
	not?: GraphQLTypes["ArticleAuthorLegacyStringAuthorCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["ArticleAuthorLegacyStringAuthor"],
	notEq?: GraphQLTypes["ArticleAuthorLegacyStringAuthor"],
	in?: Array<GraphQLTypes["ArticleAuthorLegacyStringAuthor"]>,
	notIn?: Array<GraphQLTypes["ArticleAuthorLegacyStringAuthor"]>,
	lt?: GraphQLTypes["ArticleAuthorLegacyStringAuthor"],
	lte?: GraphQLTypes["ArticleAuthorLegacyStringAuthor"],
	gt?: GraphQLTypes["ArticleAuthorLegacyStringAuthor"],
	gte?: GraphQLTypes["ArticleAuthorLegacyStringAuthor"]
};
	["ArticleAuthorLegacyStringAuthor"]: ArticleAuthorLegacyStringAuthor;
	["ArticleStateCondition"]: {
		and?: Array<GraphQLTypes["ArticleStateCondition"]>,
	or?: Array<GraphQLTypes["ArticleStateCondition"]>,
	not?: GraphQLTypes["ArticleStateCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["ArticleState"],
	notEq?: GraphQLTypes["ArticleState"],
	in?: Array<GraphQLTypes["ArticleState"]>,
	notIn?: Array<GraphQLTypes["ArticleState"]>,
	lt?: GraphQLTypes["ArticleState"],
	lte?: GraphQLTypes["ArticleState"],
	gt?: GraphQLTypes["ArticleState"],
	gte?: GraphQLTypes["ArticleState"]
};
	["ArticleState"]: ArticleState;
	["TemplateCondition"]: {
		and?: Array<GraphQLTypes["TemplateCondition"]>,
	or?: Array<GraphQLTypes["TemplateCondition"]>,
	not?: GraphQLTypes["TemplateCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["Template"],
	notEq?: GraphQLTypes["Template"],
	in?: Array<GraphQLTypes["Template"]>,
	notIn?: Array<GraphQLTypes["Template"]>,
	lt?: GraphQLTypes["Template"],
	lte?: GraphQLTypes["Template"],
	gt?: GraphQLTypes["Template"],
	gte?: GraphQLTypes["Template"]
};
	["Template"]: Template;
	["TextContentWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	parts?: GraphQLTypes["TextContentPartWhere"],
	and?: Array<GraphQLTypes["TextContentWhere"] | undefined>,
	or?: Array<GraphQLTypes["TextContentWhere"] | undefined>,
	not?: GraphQLTypes["TextContentWhere"]
};
	["TextContentPartWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	json?: GraphQLTypes["StringCondition"],
	content?: GraphQLTypes["TextContentWhere"],
	references?: GraphQLTypes["TextContentReferenceWhere"],
	and?: Array<GraphQLTypes["TextContentPartWhere"] | undefined>,
	or?: Array<GraphQLTypes["TextContentPartWhere"] | undefined>,
	not?: GraphQLTypes["TextContentPartWhere"]
};
	["TextContentReferenceWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	type?: GraphQLTypes["TextContentReferenceTypeCondition"],
	contentPart?: GraphQLTypes["TextContentPartWhere"],
	target?: GraphQLTypes["LinkWhere"],
	and?: Array<GraphQLTypes["TextContentReferenceWhere"] | undefined>,
	or?: Array<GraphQLTypes["TextContentReferenceWhere"] | undefined>,
	not?: GraphQLTypes["TextContentReferenceWhere"]
};
	["TextContentReferenceTypeCondition"]: {
		and?: Array<GraphQLTypes["TextContentReferenceTypeCondition"]>,
	or?: Array<GraphQLTypes["TextContentReferenceTypeCondition"]>,
	not?: GraphQLTypes["TextContentReferenceTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["TextContentReferenceType"],
	notEq?: GraphQLTypes["TextContentReferenceType"],
	in?: Array<GraphQLTypes["TextContentReferenceType"]>,
	notIn?: Array<GraphQLTypes["TextContentReferenceType"]>,
	lt?: GraphQLTypes["TextContentReferenceType"],
	lte?: GraphQLTypes["TextContentReferenceType"],
	gt?: GraphQLTypes["TextContentReferenceType"],
	gte?: GraphQLTypes["TextContentReferenceType"]
};
	["TextContentReferenceType"]: TextContentReferenceType;
	["ArticleTitleAlignmentCondition"]: {
		and?: Array<GraphQLTypes["ArticleTitleAlignmentCondition"]>,
	or?: Array<GraphQLTypes["ArticleTitleAlignmentCondition"]>,
	not?: GraphQLTypes["ArticleTitleAlignmentCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["ArticleTitleAlignment"],
	notEq?: GraphQLTypes["ArticleTitleAlignment"],
	in?: Array<GraphQLTypes["ArticleTitleAlignment"]>,
	notIn?: Array<GraphQLTypes["ArticleTitleAlignment"]>,
	lt?: GraphQLTypes["ArticleTitleAlignment"],
	lte?: GraphQLTypes["ArticleTitleAlignment"],
	gt?: GraphQLTypes["ArticleTitleAlignment"],
	gte?: GraphQLTypes["ArticleTitleAlignment"]
};
	["ArticleTitleAlignment"]: ArticleTitleAlignment;
	["ArticleHistoryTagWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	article?: GraphQLTypes["ArticleWhere"],
	historyTag?: GraphQLTypes["HistoryTagWhere"],
	and?: Array<GraphQLTypes["ArticleHistoryTagWhere"] | undefined>,
	or?: Array<GraphQLTypes["ArticleHistoryTagWhere"] | undefined>,
	not?: GraphQLTypes["ArticleHistoryTagWhere"]
};
	["HistoryTagWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	articleHistoryTag?: GraphQLTypes["ArticleHistoryTagWhere"],
	slug?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["HistoryTagWhere"] | undefined>,
	or?: Array<GraphQLTypes["HistoryTagWhere"] | undefined>,
	not?: GraphQLTypes["HistoryTagWhere"]
};
	["ArticleHistoryPeriodWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	article?: GraphQLTypes["ArticleWhere"],
	historyPeriod?: GraphQLTypes["HistoryPeriodWhere"],
	and?: Array<GraphQLTypes["ArticleHistoryPeriodWhere"] | undefined>,
	or?: Array<GraphQLTypes["ArticleHistoryPeriodWhere"] | undefined>,
	not?: GraphQLTypes["ArticleHistoryPeriodWhere"]
};
	["HistoryPeriodWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	articleHistoryPeriod?: GraphQLTypes["ArticleHistoryPeriodWhere"],
	slug?: GraphQLTypes["StringCondition"],
	order?: GraphQLTypes["IntCondition"],
	cover?: GraphQLTypes["HistoryCoverWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	and?: Array<GraphQLTypes["HistoryPeriodWhere"] | undefined>,
	or?: Array<GraphQLTypes["HistoryPeriodWhere"] | undefined>,
	not?: GraphQLTypes["HistoryPeriodWhere"]
};
	["HistoryCoverWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	tileParagraph?: GraphQLTypes["StringCondition"],
	coverImage?: GraphQLTypes["ImageUseWhere"],
	tileImage?: GraphQLTypes["ImageUseWhere"],
	mobileImage?: GraphQLTypes["ImageUseWhere"],
	leadContent?: GraphQLTypes["ContentWhere"],
	annotations?: GraphQLTypes["HistoryTextListWhere"],
	and?: Array<GraphQLTypes["HistoryCoverWhere"] | undefined>,
	or?: Array<GraphQLTypes["HistoryCoverWhere"] | undefined>,
	not?: GraphQLTypes["HistoryCoverWhere"]
};
	["HistoryTextListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["HistoryTextItemWhere"],
	and?: Array<GraphQLTypes["HistoryTextListWhere"] | undefined>,
	or?: Array<GraphQLTypes["HistoryTextListWhere"] | undefined>,
	not?: GraphQLTypes["HistoryTextListWhere"]
};
	["HistoryTextItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	key?: GraphQLTypes["StringCondition"],
	text?: GraphQLTypes["StringCondition"],
	list?: GraphQLTypes["HistoryTextListWhere"],
	image?: GraphQLTypes["ImageUseWhere"],
	and?: Array<GraphQLTypes["HistoryTextItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["HistoryTextItemWhere"] | undefined>,
	not?: GraphQLTypes["HistoryTextItemWhere"]
};
	["Author"]: {
	__typename: "Author",
	_meta?: GraphQLTypes["AuthorMeta"],
	id: GraphQLTypes["UUID"],
	name: string,
	position: string,
	twitterHandle?: string,
	facebookId?: string,
	email?: string,
	photographer: boolean,
	order: number,
	about?: GraphQLTypes["Content"],
	topArticles: Array<GraphQLTypes["AuthorTopArticle"]>,
	users: Array<GraphQLTypes["User"]>,
	startOfCooperation?: GraphQLTypes["Date"],
	photo?: GraphQLTypes["ImageUse"],
	illustration?: GraphQLTypes["ImageUse"],
	legacyId?: string,
	category?: GraphQLTypes["AuthorCategory"],
	url?: GraphQLTypes["Url"],
	instagramUsername?: string,
	paginateTopArticles: GraphQLTypes["AuthorTopArticleConnection"],
	paginateUsers: GraphQLTypes["UserConnection"]
};
	["AuthorMeta"]: {
	__typename: "AuthorMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	position?: GraphQLTypes["FieldMeta"],
	twitterHandle?: GraphQLTypes["FieldMeta"],
	facebookId?: GraphQLTypes["FieldMeta"],
	email?: GraphQLTypes["FieldMeta"],
	photographer?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	about?: GraphQLTypes["FieldMeta"],
	topArticles?: GraphQLTypes["FieldMeta"],
	users?: GraphQLTypes["FieldMeta"],
	startOfCooperation?: GraphQLTypes["FieldMeta"],
	photo?: GraphQLTypes["FieldMeta"],
	illustration?: GraphQLTypes["FieldMeta"],
	legacyId?: GraphQLTypes["FieldMeta"],
	category?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"],
	instagramUsername?: GraphQLTypes["FieldMeta"]
};
	["Content"]: {
	__typename: "Content",
	_meta?: GraphQLTypes["ContentMeta"],
	id: GraphQLTypes["UUID"],
	parts: Array<GraphQLTypes["ContentPart"]>,
	partsByReferences?: GraphQLTypes["ContentPart"],
	paginateParts: GraphQLTypes["ContentPartConnection"]
};
	["ContentMeta"]: {
	__typename: "ContentMeta",
	id?: GraphQLTypes["FieldMeta"],
	parts?: GraphQLTypes["FieldMeta"]
};
	["ContentPart"]: {
	__typename: "ContentPart",
	_meta?: GraphQLTypes["ContentPartMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	json: string,
	content?: GraphQLTypes["Content"],
	references: Array<GraphQLTypes["ContentReference"]>,
	referencesByEmbed?: GraphQLTypes["ContentReference"],
	referencesByAudio?: GraphQLTypes["ContentReference"],
	referencesByImage?: GraphQLTypes["ContentReference"],
	referencesByPollAnswer?: GraphQLTypes["ContentReference"],
	referencesByListicle?: GraphQLTypes["ContentReference"],
	referencesByFaq?: GraphQLTypes["ContentReference"],
	referencesByLinks?: GraphQLTypes["ContentReference"],
	referencesByAwards?: GraphQLTypes["ContentReference"],
	referencesByReviews?: GraphQLTypes["ContentReference"],
	referencesByTarget?: GraphQLTypes["ContentReference"],
	referencesByButtons?: GraphQLTypes["ContentReference"],
	paginateReferences: GraphQLTypes["ContentReferenceConnection"]
};
	["ContentPartMeta"]: {
	__typename: "ContentPartMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	json?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	references?: GraphQLTypes["FieldMeta"]
};
	["ContentReference"]: {
	__typename: "ContentReference",
	_meta?: GraphQLTypes["ContentReferenceMeta"],
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["ContentReferenceType"],
	contentPart?: GraphQLTypes["ContentPart"],
	primaryText?: string,
	secondaryText?: string,
	variant?: GraphQLTypes["ContentReferenceVariant"],
	color?: string,
	embed?: GraphQLTypes["Embed"],
	article?: GraphQLTypes["Article"],
	audio?: GraphQLTypes["AudioUse"],
	image?: GraphQLTypes["ImageUse"],
	images: Array<GraphQLTypes["ImageContent"]>,
	pollAnswer?: GraphQLTypes["PollAnswer"],
	listicle: Array<GraphQLTypes["Listicle"]>,
	faq: Array<GraphQLTypes["FAQ"]>,
	links: Array<GraphQLTypes["LinkContent"]>,
	awards: Array<GraphQLTypes["AwardContent"]>,
	reviews: Array<GraphQLTypes["ReviewContent"]>,
	target?: GraphQLTypes["Link"],
	subscriptionForm?: GraphQLTypes["SubscriptionForm"],
	buttons: Array<GraphQLTypes["Button"]>,
	sharedContent?: GraphQLTypes["SharedContent"],
	buttonsByTarget?: GraphQLTypes["Button"],
	paginateImages: GraphQLTypes["ImageContentConnection"],
	paginateListicle: GraphQLTypes["ListicleConnection"],
	paginateFaq: GraphQLTypes["FAQConnection"],
	paginateLinks: GraphQLTypes["LinkContentConnection"],
	paginateAwards: GraphQLTypes["AwardContentConnection"],
	paginateReviews: GraphQLTypes["ReviewContentConnection"],
	paginateButtons: GraphQLTypes["ButtonConnection"]
};
	["ContentReferenceMeta"]: {
	__typename: "ContentReferenceMeta",
	id?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	contentPart?: GraphQLTypes["FieldMeta"],
	primaryText?: GraphQLTypes["FieldMeta"],
	secondaryText?: GraphQLTypes["FieldMeta"],
	variant?: GraphQLTypes["FieldMeta"],
	color?: GraphQLTypes["FieldMeta"],
	embed?: GraphQLTypes["FieldMeta"],
	article?: GraphQLTypes["FieldMeta"],
	audio?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	images?: GraphQLTypes["FieldMeta"],
	pollAnswer?: GraphQLTypes["FieldMeta"],
	listicle?: GraphQLTypes["FieldMeta"],
	faq?: GraphQLTypes["FieldMeta"],
	links?: GraphQLTypes["FieldMeta"],
	awards?: GraphQLTypes["FieldMeta"],
	reviews?: GraphQLTypes["FieldMeta"],
	target?: GraphQLTypes["FieldMeta"],
	subscriptionForm?: GraphQLTypes["FieldMeta"],
	buttons?: GraphQLTypes["FieldMeta"],
	sharedContent?: GraphQLTypes["FieldMeta"]
};
	["Embed"]: {
	__typename: "Embed",
	_meta?: GraphQLTypes["EmbedMeta"],
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["EmbedType"],
	youtubeId?: string,
	vimeoId?: string,
	spotifyId?: string,
	spotifyType?: string,
	soundCloudId?: string
};
	["EmbedMeta"]: {
	__typename: "EmbedMeta",
	id?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	youtubeId?: GraphQLTypes["FieldMeta"],
	vimeoId?: GraphQLTypes["FieldMeta"],
	spotifyId?: GraphQLTypes["FieldMeta"],
	spotifyType?: GraphQLTypes["FieldMeta"],
	soundCloudId?: GraphQLTypes["FieldMeta"]
};
	["AudioUse"]: {
	__typename: "AudioUse",
	_meta?: GraphQLTypes["AudioUseMeta"],
	id: GraphQLTypes["UUID"],
	audio?: GraphQLTypes["Audio"]
};
	["AudioUseMeta"]: {
	__typename: "AudioUseMeta",
	id?: GraphQLTypes["FieldMeta"],
	audio?: GraphQLTypes["FieldMeta"]
};
	["Audio"]: {
	__typename: "Audio",
	_meta?: GraphQLTypes["AudioMeta"],
	id: GraphQLTypes["UUID"],
	url: string,
	type: string,
	author?: GraphQLTypes["Author"],
	uses: Array<GraphQLTypes["AudioUse"]>,
	paginateUses: GraphQLTypes["AudioUseConnection"]
};
	["AudioMeta"]: {
	__typename: "AudioMeta",
	id?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	author?: GraphQLTypes["FieldMeta"],
	uses?: GraphQLTypes["FieldMeta"]
};
	["AudioUseOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	audio?: GraphQLTypes["AudioOrderBy"]
};
	["OrderDirection"]: OrderDirection;
	["AudioOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	author?: GraphQLTypes["AuthorOrderBy"]
};
	["AuthorOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	position?: GraphQLTypes["OrderDirection"],
	twitterHandle?: GraphQLTypes["OrderDirection"],
	facebookId?: GraphQLTypes["OrderDirection"],
	email?: GraphQLTypes["OrderDirection"],
	photographer?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	about?: GraphQLTypes["ContentOrderBy"],
	startOfCooperation?: GraphQLTypes["OrderDirection"],
	photo?: GraphQLTypes["ImageUseOrderBy"],
	illustration?: GraphQLTypes["ImageUseOrderBy"],
	legacyId?: GraphQLTypes["OrderDirection"],
	category?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["UrlOrderBy"],
	instagramUsername?: GraphQLTypes["OrderDirection"]
};
	["ContentOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["ImageUseOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	image?: GraphQLTypes["ImageOrderBy"]
};
	["ImageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["OrderDirection"],
	width?: GraphQLTypes["OrderDirection"],
	height?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	text?: GraphQLTypes["OrderDirection"],
	author?: GraphQLTypes["AuthorOrderBy"],
	align?: GraphQLTypes["OrderDirection"],
	legacyId?: GraphQLTypes["OrderDirection"]
};
	["UrlOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["OrderDirection"],
	article?: GraphQLTypes["ArticleOrderBy"],
	author?: GraphQLTypes["AuthorOrderBy"],
	issue?: GraphQLTypes["IssueOrderBy"],
	page?: GraphQLTypes["PageOrderBy"],
	category?: GraphQLTypes["CategoryOrderBy"],
	tag?: GraphQLTypes["TagOrderBy"],
	redirect?: GraphQLTypes["OrderDirection"]
};
	["ArticleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["UrlOrderBy"],
	hideInMostRead?: GraphQLTypes["OrderDirection"],
	hideAds?: GraphQLTypes["OrderDirection"],
	state?: GraphQLTypes["OrderDirection"],
	locked?: GraphQLTypes["OrderDirection"],
	publishAt?: GraphQLTypes["OrderDirection"],
	template?: GraphQLTypes["OrderDirection"],
	subtitle?: GraphQLTypes["TextContentOrderBy"],
	content?: GraphQLTypes["ContentOrderBy"],
	coverPhoto?: GraphQLTypes["ImageUseOrderBy"],
	titleAlignment?: GraphQLTypes["OrderDirection"],
	tagline?: GraphQLTypes["OrderDirection"],
	createdAt?: GraphQLTypes["OrderDirection"],
	previewContent?: GraphQLTypes["ContentOrderBy"],
	audio?: GraphQLTypes["AudioUseOrderBy"],
	coverPhotoVertical?: GraphQLTypes["ImageUseOrderBy"],
	legacyId?: GraphQLTypes["OrderDirection"],
	isHistory?: GraphQLTypes["OrderDirection"]
};
	["TextContentOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["IssueOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	closed?: GraphQLTypes["OrderDirection"],
	free?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	subtitle?: GraphQLTypes["OrderDirection"],
	year?: GraphQLTypes["OrderDirection"],
	issue?: GraphQLTypes["OrderDirection"],
	publishedSince?: GraphQLTypes["OrderDirection"],
	publishedUntil?: GraphQLTypes["OrderDirection"],
	publishDigital?: GraphQLTypes["OrderDirection"],
	mobileAppsKey?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["UrlOrderBy"],
	kind?: GraphQLTypes["OrderDirection"],
	notificationTitle?: GraphQLTypes["OrderDirection"],
	notificationMessage?: GraphQLTypes["OrderDirection"],
	pdf?: GraphQLTypes["FileUseOrderBy"],
	printBuy?: GraphQLTypes["OrderDirection"],
	printText?: GraphQLTypes["OrderDirection"],
	coverPhoto?: GraphQLTypes["ImageUseOrderBy"],
	printTarget?: GraphQLTypes["LinkOrderBy"],
	backgroundPhoto?: GraphQLTypes["ImageUseOrderBy"],
	legacyId?: GraphQLTypes["OrderDirection"]
};
	["FileUseOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	file?: GraphQLTypes["FileOrderBy"]
};
	["FileOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["OrderDirection"]
};
	["LinkOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	externalTarget?: GraphQLTypes["OrderDirection"],
	internalTarget?: GraphQLTypes["UrlOrderBy"],
	queryParameters?: GraphQLTypes["OrderDirection"]
};
	["PageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	publishAt?: GraphQLTypes["OrderDirection"],
	createdAt?: GraphQLTypes["OrderDirection"],
	template?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["UrlOrderBy"],
	content?: GraphQLTypes["ContentOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"],
	subscriptionValidity?: GraphQLTypes["OrderDirection"]
};
	["SeoOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	description?: GraphQLTypes["OrderDirection"],
	ogTitle?: GraphQLTypes["OrderDirection"],
	ogDescription?: GraphQLTypes["OrderDirection"],
	page?: GraphQLTypes["PageOrderBy"],
	twCard?: GraphQLTypes["OrderDirection"],
	ogImage?: GraphQLTypes["ImageUseOrderBy"]
};
	["CategoryOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["UrlOrderBy"],
	legacyId?: GraphQLTypes["OrderDirection"]
};
	["TagOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	useAsTagline?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["UrlOrderBy"],
	order?: GraphQLTypes["OrderDirection"],
	legacyId?: GraphQLTypes["OrderDirection"]
};
	["AudioUseConnection"]: {
	__typename: "AudioUseConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["AudioUseEdge"]>
};
	["PageInfo"]: {
	__typename: "PageInfo",
	totalCount: number
};
	["AudioUseEdge"]: {
	__typename: "AudioUseEdge",
	node: GraphQLTypes["AudioUse"]
};
	["ImageUse"]: {
	__typename: "ImageUse",
	_meta?: GraphQLTypes["ImageUseMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	image?: GraphQLTypes["Image"]
};
	["ImageUseMeta"]: {
	__typename: "ImageUseMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"]
};
	["Image"]: {
	__typename: "Image",
	_meta?: GraphQLTypes["ImageMeta"],
	id: GraphQLTypes["UUID"],
	url: string,
	width?: number,
	height?: number,
	title: string,
	text: string,
	author?: GraphQLTypes["Author"],
	tags: Array<GraphQLTypes["ImageTag"]>,
	uses: Array<GraphQLTypes["ImageUse"]>,
	align?: GraphQLTypes["ImageAlign"],
	legacyId?: string,
	paginateTags: GraphQLTypes["ImageTagConnection"],
	paginateUses: GraphQLTypes["ImageUseConnection"]
};
	["ImageMeta"]: {
	__typename: "ImageMeta",
	id?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"],
	width?: GraphQLTypes["FieldMeta"],
	height?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	text?: GraphQLTypes["FieldMeta"],
	author?: GraphQLTypes["FieldMeta"],
	tags?: GraphQLTypes["FieldMeta"],
	uses?: GraphQLTypes["FieldMeta"],
	align?: GraphQLTypes["FieldMeta"],
	legacyId?: GraphQLTypes["FieldMeta"]
};
	["ImageTag"]: {
	__typename: "ImageTag",
	_meta?: GraphQLTypes["ImageTagMeta"],
	id: GraphQLTypes["UUID"],
	name: string,
	images: Array<GraphQLTypes["Image"]>,
	paginateImages: GraphQLTypes["ImageConnection"]
};
	["ImageTagMeta"]: {
	__typename: "ImageTagMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	images?: GraphQLTypes["FieldMeta"]
};
	["ImageConnection"]: {
	__typename: "ImageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImageEdge"]>
};
	["ImageEdge"]: {
	__typename: "ImageEdge",
	node: GraphQLTypes["Image"]
};
	["ImageTagOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"]
};
	["ImageTagConnection"]: {
	__typename: "ImageTagConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImageTagEdge"]>
};
	["ImageTagEdge"]: {
	__typename: "ImageTagEdge",
	node: GraphQLTypes["ImageTag"]
};
	["ImageUseConnection"]: {
	__typename: "ImageUseConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImageUseEdge"]>
};
	["ImageUseEdge"]: {
	__typename: "ImageUseEdge",
	node: GraphQLTypes["ImageUse"]
};
	["ImageContent"]: {
	__typename: "ImageContent",
	_meta?: GraphQLTypes["ImageContentMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	contentReference: Array<GraphQLTypes["ContentReference"]>,
	image?: GraphQLTypes["ImageUse"],
	paginateContentReference: GraphQLTypes["ContentReferenceConnection"]
};
	["ImageContentMeta"]: {
	__typename: "ImageContentMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	contentReference?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"]
};
	["ContentReferenceOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	contentPart?: GraphQLTypes["ContentPartOrderBy"],
	primaryText?: GraphQLTypes["OrderDirection"],
	secondaryText?: GraphQLTypes["OrderDirection"],
	variant?: GraphQLTypes["OrderDirection"],
	color?: GraphQLTypes["OrderDirection"],
	embed?: GraphQLTypes["EmbedOrderBy"],
	article?: GraphQLTypes["ArticleOrderBy"],
	audio?: GraphQLTypes["AudioUseOrderBy"],
	image?: GraphQLTypes["ImageUseOrderBy"],
	pollAnswer?: GraphQLTypes["PollAnswerOrderBy"],
	target?: GraphQLTypes["LinkOrderBy"],
	subscriptionForm?: GraphQLTypes["SubscriptionFormOrderBy"],
	sharedContent?: GraphQLTypes["SharedContentOrderBy"]
};
	["ContentPartOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	json?: GraphQLTypes["OrderDirection"],
	content?: GraphQLTypes["ContentOrderBy"]
};
	["EmbedOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	youtubeId?: GraphQLTypes["OrderDirection"],
	vimeoId?: GraphQLTypes["OrderDirection"],
	spotifyId?: GraphQLTypes["OrderDirection"],
	spotifyType?: GraphQLTypes["OrderDirection"],
	soundCloudId?: GraphQLTypes["OrderDirection"]
};
	["PollAnswerOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	authorName?: GraphQLTypes["OrderDirection"],
	authorPosition?: GraphQLTypes["OrderDirection"],
	text?: GraphQLTypes["OrderDirection"],
	authorImage?: GraphQLTypes["ImageUseOrderBy"]
};
	["SubscriptionFormOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	code?: GraphQLTypes["OrderDirection"],
	createdAt?: GraphQLTypes["OrderDirection"],
	validity?: GraphQLTypes["OrderDirection"]
};
	["SharedContentOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	content?: GraphQLTypes["ContentOrderBy"]
};
	["ContentReferenceConnection"]: {
	__typename: "ContentReferenceConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentReferenceEdge"]>
};
	["ContentReferenceEdge"]: {
	__typename: "ContentReferenceEdge",
	node: GraphQLTypes["ContentReference"]
};
	["ImageContentOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	image?: GraphQLTypes["ImageUseOrderBy"]
};
	["PollAnswer"]: {
	__typename: "PollAnswer",
	_meta?: GraphQLTypes["PollAnswerMeta"],
	id: GraphQLTypes["UUID"],
	authorName: string,
	authorPosition?: string,
	text: string,
	authorImage?: GraphQLTypes["ImageUse"]
};
	["PollAnswerMeta"]: {
	__typename: "PollAnswerMeta",
	id?: GraphQLTypes["FieldMeta"],
	authorName?: GraphQLTypes["FieldMeta"],
	authorPosition?: GraphQLTypes["FieldMeta"],
	text?: GraphQLTypes["FieldMeta"],
	authorImage?: GraphQLTypes["FieldMeta"]
};
	["Listicle"]: {
	__typename: "Listicle",
	_meta?: GraphQLTypes["ListicleMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	primaryText: string,
	image?: GraphQLTypes["ImageUse"],
	contentReference?: GraphQLTypes["ContentReference"],
	target?: GraphQLTypes["Link"],
	content?: GraphQLTypes["Content"]
};
	["ListicleMeta"]: {
	__typename: "ListicleMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	primaryText?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	contentReference?: GraphQLTypes["FieldMeta"],
	target?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"]
};
	["Link"]: {
	__typename: "Link",
	_meta?: GraphQLTypes["LinkMeta"],
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["LinkType"],
	externalTarget?: string,
	internalTarget?: GraphQLTypes["Url"],
	queryParameters?: string
};
	["LinkMeta"]: {
	__typename: "LinkMeta",
	id?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	externalTarget?: GraphQLTypes["FieldMeta"],
	internalTarget?: GraphQLTypes["FieldMeta"],
	queryParameters?: GraphQLTypes["FieldMeta"]
};
	["ListicleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	primaryText?: GraphQLTypes["OrderDirection"],
	image?: GraphQLTypes["ImageUseOrderBy"],
	contentReference?: GraphQLTypes["ContentReferenceOrderBy"],
	target?: GraphQLTypes["LinkOrderBy"],
	content?: GraphQLTypes["ContentOrderBy"]
};
	["FAQ"]: {
	__typename: "FAQ",
	_meta?: GraphQLTypes["FAQMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	answer: string,
	question: string,
	contentReference?: GraphQLTypes["ContentReference"]
};
	["FAQMeta"]: {
	__typename: "FAQMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	answer?: GraphQLTypes["FieldMeta"],
	question?: GraphQLTypes["FieldMeta"],
	contentReference?: GraphQLTypes["FieldMeta"]
};
	["FAQOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	answer?: GraphQLTypes["OrderDirection"],
	question?: GraphQLTypes["OrderDirection"],
	contentReference?: GraphQLTypes["ContentReferenceOrderBy"]
};
	["LinkContent"]: {
	__typename: "LinkContent",
	_meta?: GraphQLTypes["LinkContentMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	contentReference?: GraphQLTypes["ContentReference"],
	text: string,
	target?: GraphQLTypes["Link"]
};
	["LinkContentMeta"]: {
	__typename: "LinkContentMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	contentReference?: GraphQLTypes["FieldMeta"],
	text?: GraphQLTypes["FieldMeta"],
	target?: GraphQLTypes["FieldMeta"]
};
	["LinkContentOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	contentReference?: GraphQLTypes["ContentReferenceOrderBy"],
	text?: GraphQLTypes["OrderDirection"],
	target?: GraphQLTypes["LinkOrderBy"]
};
	["AwardContent"]: {
	__typename: "AwardContent",
	_meta?: GraphQLTypes["AwardContentMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	image?: GraphQLTypes["ImageUse"],
	contentReference?: GraphQLTypes["ContentReference"],
	target?: GraphQLTypes["Link"]
};
	["AwardContentMeta"]: {
	__typename: "AwardContentMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	contentReference?: GraphQLTypes["FieldMeta"],
	target?: GraphQLTypes["FieldMeta"]
};
	["AwardContentOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	image?: GraphQLTypes["ImageUseOrderBy"],
	contentReference?: GraphQLTypes["ContentReferenceOrderBy"],
	target?: GraphQLTypes["LinkOrderBy"]
};
	["ReviewContent"]: {
	__typename: "ReviewContent",
	_meta?: GraphQLTypes["ReviewContentMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	text: string,
	contentReference?: GraphQLTypes["ContentReference"]
};
	["ReviewContentMeta"]: {
	__typename: "ReviewContentMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	text?: GraphQLTypes["FieldMeta"],
	contentReference?: GraphQLTypes["FieldMeta"]
};
	["ReviewContentOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	text?: GraphQLTypes["OrderDirection"],
	contentReference?: GraphQLTypes["ContentReferenceOrderBy"]
};
	["SubscriptionForm"]: {
	__typename: "SubscriptionForm",
	_meta?: GraphQLTypes["SubscriptionFormMeta"],
	id: GraphQLTypes["UUID"],
	name: string,
	code?: string,
	createdAt: GraphQLTypes["DateTime"],
	sections: Array<GraphQLTypes["SubscriptionFormSection"]>,
	contentBlock: Array<GraphQLTypes["ContentBlock"]>,
	products: Array<GraphQLTypes["Product"]>,
	contentReferences: Array<GraphQLTypes["ContentReference"]>,
	validity?: GraphQLTypes["DateTime"],
	sectionsByInputs?: GraphQLTypes["SubscriptionFormSection"],
	contentBlockByTarget?: GraphQLTypes["ContentBlock"],
	contentBlockByArticles?: GraphQLTypes["ContentBlock"],
	contentReferencesByEmbed?: GraphQLTypes["ContentReference"],
	contentReferencesByAudio?: GraphQLTypes["ContentReference"],
	contentReferencesByImage?: GraphQLTypes["ContentReference"],
	contentReferencesByPollAnswer?: GraphQLTypes["ContentReference"],
	contentReferencesByListicle?: GraphQLTypes["ContentReference"],
	contentReferencesByFaq?: GraphQLTypes["ContentReference"],
	contentReferencesByLinks?: GraphQLTypes["ContentReference"],
	contentReferencesByAwards?: GraphQLTypes["ContentReference"],
	contentReferencesByReviews?: GraphQLTypes["ContentReference"],
	contentReferencesByTarget?: GraphQLTypes["ContentReference"],
	contentReferencesByButtons?: GraphQLTypes["ContentReference"],
	paginateSections: GraphQLTypes["SubscriptionFormSectionConnection"],
	paginateContentBlock: GraphQLTypes["ContentBlockConnection"],
	paginateProducts: GraphQLTypes["ProductConnection"],
	paginateContentReferences: GraphQLTypes["ContentReferenceConnection"]
};
	["SubscriptionFormMeta"]: {
	__typename: "SubscriptionFormMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	code?: GraphQLTypes["FieldMeta"],
	createdAt?: GraphQLTypes["FieldMeta"],
	sections?: GraphQLTypes["FieldMeta"],
	contentBlock?: GraphQLTypes["FieldMeta"],
	products?: GraphQLTypes["FieldMeta"],
	contentReferences?: GraphQLTypes["FieldMeta"],
	validity?: GraphQLTypes["FieldMeta"]
};
	["SubscriptionFormSection"]: {
	__typename: "SubscriptionFormSection",
	_meta?: GraphQLTypes["SubscriptionFormSectionMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	title?: string,
	form?: GraphQLTypes["SubscriptionForm"],
	inputs: Array<GraphQLTypes["SubscriptionFormInput"]>,
	inputsByImage?: GraphQLTypes["SubscriptionFormInput"],
	inputsByOptions?: GraphQLTypes["SubscriptionFormInput"],
	inputsByDescription?: GraphQLTypes["SubscriptionFormInput"],
	paginateInputs: GraphQLTypes["SubscriptionFormInputConnection"]
};
	["SubscriptionFormSectionMeta"]: {
	__typename: "SubscriptionFormSectionMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	form?: GraphQLTypes["FieldMeta"],
	inputs?: GraphQLTypes["FieldMeta"]
};
	["SubscriptionFormInput"]: {
	__typename: "SubscriptionFormInput",
	_meta?: GraphQLTypes["SubscriptionFormInputMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	type: GraphQLTypes["SubscriptionFormInputType"],
	image?: GraphQLTypes["ImageUse"],
	section?: GraphQLTypes["SubscriptionFormSection"],
	options: Array<GraphQLTypes["SubscriptionFormOption"]>,
	description?: GraphQLTypes["Content"],
	required: boolean,
	paginateOptions: GraphQLTypes["SubscriptionFormOptionConnection"]
};
	["SubscriptionFormInputMeta"]: {
	__typename: "SubscriptionFormInputMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	section?: GraphQLTypes["FieldMeta"],
	options?: GraphQLTypes["FieldMeta"],
	description?: GraphQLTypes["FieldMeta"],
	required?: GraphQLTypes["FieldMeta"]
};
	["SubscriptionFormOption"]: {
	__typename: "SubscriptionFormOption",
	_meta?: GraphQLTypes["SubscriptionFormOptionMeta"],
	id: GraphQLTypes["UUID"],
	hasProductId: boolean,
	order: number,
	label?: string,
	priceTag?: string,
	priceTagWithDiscount?: string,
	products: Array<GraphQLTypes["Product"]>,
	formInput?: GraphQLTypes["SubscriptionFormInput"],
	value?: string,
	internalLabel?: string,
	paginateProducts: GraphQLTypes["ProductConnection"]
};
	["SubscriptionFormOptionMeta"]: {
	__typename: "SubscriptionFormOptionMeta",
	id?: GraphQLTypes["FieldMeta"],
	hasProductId?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	label?: GraphQLTypes["FieldMeta"],
	priceTag?: GraphQLTypes["FieldMeta"],
	priceTagWithDiscount?: GraphQLTypes["FieldMeta"],
	products?: GraphQLTypes["FieldMeta"],
	formInput?: GraphQLTypes["FieldMeta"],
	value?: GraphQLTypes["FieldMeta"],
	internalLabel?: GraphQLTypes["FieldMeta"]
};
	["Product"]: {
	__typename: "Product",
	_meta?: GraphQLTypes["ProductMeta"],
	id: GraphQLTypes["UUID"],
	price?: number,
	type?: GraphQLTypes["Types"],
	formOptions: Array<GraphQLTypes["SubscriptionFormOption"]>,
	form?: GraphQLTypes["SubscriptionForm"],
	productId: string,
	paginateFormOptions: GraphQLTypes["SubscriptionFormOptionConnection"]
};
	["ProductMeta"]: {
	__typename: "ProductMeta",
	id?: GraphQLTypes["FieldMeta"],
	price?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	formOptions?: GraphQLTypes["FieldMeta"],
	form?: GraphQLTypes["FieldMeta"],
	productId?: GraphQLTypes["FieldMeta"]
};
	["SubscriptionFormOptionOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	hasProductId?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	label?: GraphQLTypes["OrderDirection"],
	priceTag?: GraphQLTypes["OrderDirection"],
	priceTagWithDiscount?: GraphQLTypes["OrderDirection"],
	formInput?: GraphQLTypes["SubscriptionFormInputOrderBy"],
	value?: GraphQLTypes["OrderDirection"],
	internalLabel?: GraphQLTypes["OrderDirection"]
};
	["SubscriptionFormInputOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	image?: GraphQLTypes["ImageUseOrderBy"],
	section?: GraphQLTypes["SubscriptionFormSectionOrderBy"],
	description?: GraphQLTypes["ContentOrderBy"],
	required?: GraphQLTypes["OrderDirection"]
};
	["SubscriptionFormSectionOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	form?: GraphQLTypes["SubscriptionFormOrderBy"]
};
	["SubscriptionFormOptionConnection"]: {
	__typename: "SubscriptionFormOptionConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SubscriptionFormOptionEdge"]>
};
	["SubscriptionFormOptionEdge"]: {
	__typename: "SubscriptionFormOptionEdge",
	node: GraphQLTypes["SubscriptionFormOption"]
};
	["ProductOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	price?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	form?: GraphQLTypes["SubscriptionFormOrderBy"],
	productId?: GraphQLTypes["OrderDirection"]
};
	["ProductConnection"]: {
	__typename: "ProductConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ProductEdge"]>
};
	["ProductEdge"]: {
	__typename: "ProductEdge",
	node: GraphQLTypes["Product"]
};
	["SubscriptionFormSectionInputsByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUseUniqueWhere"]
};
	["ImageUseUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["SubscriptionFormSectionInputsByOptionsUniqueWhere"]: {
		options?: GraphQLTypes["SubscriptionFormOptionUniqueWhere"]
};
	["SubscriptionFormOptionUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["SubscriptionFormSectionInputsByDescriptionUniqueWhere"]: {
		description?: GraphQLTypes["ContentUniqueWhere"]
};
	["ContentUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	parts?: GraphQLTypes["ContentPartUniqueWhere"]
};
	["ContentPartUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	references?: GraphQLTypes["ContentReferenceUniqueWhere"]
};
	["ContentReferenceUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	embed?: GraphQLTypes["EmbedUniqueWhere"],
	audio?: GraphQLTypes["AudioUseUniqueWhere"],
	image?: GraphQLTypes["ImageUseUniqueWhere"],
	pollAnswer?: GraphQLTypes["PollAnswerUniqueWhere"],
	listicle?: GraphQLTypes["ListicleUniqueWhere"],
	faq?: GraphQLTypes["FAQUniqueWhere"],
	links?: GraphQLTypes["LinkContentUniqueWhere"],
	awards?: GraphQLTypes["AwardContentUniqueWhere"],
	reviews?: GraphQLTypes["ReviewContentUniqueWhere"],
	target?: GraphQLTypes["LinkUniqueWhere"],
	buttons?: GraphQLTypes["ButtonUniqueWhere"]
};
	["EmbedUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["AudioUseUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["PollAnswerUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ListicleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["FAQUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["LinkContentUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["AwardContentUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ReviewContentUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["LinkUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ButtonUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	target?: GraphQLTypes["LinkUniqueWhere"]
};
	["SubscriptionFormInputConnection"]: {
	__typename: "SubscriptionFormInputConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SubscriptionFormInputEdge"]>
};
	["SubscriptionFormInputEdge"]: {
	__typename: "SubscriptionFormInputEdge",
	node: GraphQLTypes["SubscriptionFormInput"]
};
	["ContentBlock"]: {
	__typename: "ContentBlock",
	_meta?: GraphQLTypes["ContentBlockMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	type: GraphQLTypes["ContentBlockType"],
	youtubeId?: string,
	text?: string,
	targetLabel?: string,
	issue?: GraphQLTypes["Issue"],
	target?: GraphQLTypes["Link"],
	articles: Array<GraphQLTypes["ContentArticle"]>,
	subscriptionForm?: GraphQLTypes["SubscriptionForm"],
	paginateArticles: GraphQLTypes["ContentArticleConnection"]
};
	["ContentBlockMeta"]: {
	__typename: "ContentBlockMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	youtubeId?: GraphQLTypes["FieldMeta"],
	text?: GraphQLTypes["FieldMeta"],
	targetLabel?: GraphQLTypes["FieldMeta"],
	issue?: GraphQLTypes["FieldMeta"],
	target?: GraphQLTypes["FieldMeta"],
	articles?: GraphQLTypes["FieldMeta"],
	subscriptionForm?: GraphQLTypes["FieldMeta"]
};
	["Issue"]: {
	__typename: "Issue",
	_meta?: GraphQLTypes["IssueMeta"],
	id: GraphQLTypes["UUID"],
	closed: boolean,
	free: boolean,
	title?: string,
	subtitle?: string,
	year: number,
	issue: number,
	publishedSince: GraphQLTypes["Date"],
	publishedUntil: GraphQLTypes["Date"],
	publishDigital: GraphQLTypes["DateTime"],
	mobileAppsKey?: string,
	url?: GraphQLTypes["Url"],
	articles: Array<GraphQLTypes["IssueArticle"]>,
	kind: GraphQLTypes["IssueKind"],
	notificationTitle?: string,
	notificationMessage?: string,
	pdf?: GraphQLTypes["FileUse"],
	printBuy: boolean,
	printText?: string,
	blocks: Array<GraphQLTypes["ContentBlock"]>,
	coverPhoto?: GraphQLTypes["ImageUse"],
	printTarget?: GraphQLTypes["Link"],
	backgroundPhoto?: GraphQLTypes["ImageUse"],
	legacyId?: string,
	articlesByArticle?: GraphQLTypes["IssueArticle"],
	blocksByTarget?: GraphQLTypes["ContentBlock"],
	blocksByArticles?: GraphQLTypes["ContentBlock"],
	paginateArticles: GraphQLTypes["IssueArticleConnection"],
	paginateBlocks: GraphQLTypes["ContentBlockConnection"]
};
	["IssueMeta"]: {
	__typename: "IssueMeta",
	id?: GraphQLTypes["FieldMeta"],
	closed?: GraphQLTypes["FieldMeta"],
	free?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	subtitle?: GraphQLTypes["FieldMeta"],
	year?: GraphQLTypes["FieldMeta"],
	issue?: GraphQLTypes["FieldMeta"],
	publishedSince?: GraphQLTypes["FieldMeta"],
	publishedUntil?: GraphQLTypes["FieldMeta"],
	publishDigital?: GraphQLTypes["FieldMeta"],
	mobileAppsKey?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"],
	articles?: GraphQLTypes["FieldMeta"],
	kind?: GraphQLTypes["FieldMeta"],
	notificationTitle?: GraphQLTypes["FieldMeta"],
	notificationMessage?: GraphQLTypes["FieldMeta"],
	pdf?: GraphQLTypes["FieldMeta"],
	printBuy?: GraphQLTypes["FieldMeta"],
	printText?: GraphQLTypes["FieldMeta"],
	blocks?: GraphQLTypes["FieldMeta"],
	coverPhoto?: GraphQLTypes["FieldMeta"],
	printTarget?: GraphQLTypes["FieldMeta"],
	backgroundPhoto?: GraphQLTypes["FieldMeta"],
	legacyId?: GraphQLTypes["FieldMeta"]
};
	["IssueArticle"]: {
	__typename: "IssueArticle",
	_meta?: GraphQLTypes["IssueArticleMeta"],
	id: GraphQLTypes["UUID"],
	issue?: GraphQLTypes["Issue"],
	article?: GraphQLTypes["Article"],
	order?: number
};
	["IssueArticleMeta"]: {
	__typename: "IssueArticleMeta",
	id?: GraphQLTypes["FieldMeta"],
	issue?: GraphQLTypes["FieldMeta"],
	article?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"]
};
	["IssueArticleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	issue?: GraphQLTypes["IssueOrderBy"],
	article?: GraphQLTypes["ArticleOrderBy"],
	order?: GraphQLTypes["OrderDirection"]
};
	["FileUse"]: {
	__typename: "FileUse",
	_meta?: GraphQLTypes["FileUseMeta"],
	id: GraphQLTypes["UUID"],
	file?: GraphQLTypes["File"]
};
	["FileUseMeta"]: {
	__typename: "FileUseMeta",
	id?: GraphQLTypes["FieldMeta"],
	file?: GraphQLTypes["FieldMeta"]
};
	["File"]: {
	__typename: "File",
	_meta?: GraphQLTypes["FileMeta"],
	id: GraphQLTypes["UUID"],
	url: string,
	uses: Array<GraphQLTypes["FileUse"]>,
	paginateUses: GraphQLTypes["FileUseConnection"]
};
	["FileMeta"]: {
	__typename: "FileMeta",
	id?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"],
	uses?: GraphQLTypes["FieldMeta"]
};
	["FileUseConnection"]: {
	__typename: "FileUseConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FileUseEdge"]>
};
	["FileUseEdge"]: {
	__typename: "FileUseEdge",
	node: GraphQLTypes["FileUse"]
};
	["ContentBlockOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	youtubeId?: GraphQLTypes["OrderDirection"],
	text?: GraphQLTypes["OrderDirection"],
	targetLabel?: GraphQLTypes["OrderDirection"],
	issue?: GraphQLTypes["IssueOrderBy"],
	target?: GraphQLTypes["LinkOrderBy"],
	subscriptionForm?: GraphQLTypes["SubscriptionFormOrderBy"]
};
	["IssueArticlesByArticleUniqueWhere"]: {
		article?: GraphQLTypes["ArticleUniqueWhere"]
};
	["ArticleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	legacyId?: string,
	url?: GraphQLTypes["UrlUniqueWhere"],
	authors?: GraphQLTypes["ArticleAuthorUniqueWhere"],
	subtitle?: GraphQLTypes["TextContentUniqueWhere"],
	content?: GraphQLTypes["ContentUniqueWhere"],
	coverPhoto?: GraphQLTypes["ImageUseUniqueWhere"],
	previewContent?: GraphQLTypes["ContentUniqueWhere"],
	audio?: GraphQLTypes["AudioUseUniqueWhere"],
	categories?: GraphQLTypes["ArticleCategoryUniqueWhere"],
	issues?: GraphQLTypes["IssueArticleUniqueWhere"],
	contentBlocks?: GraphQLTypes["ContentArticleUniqueWhere"],
	unlocked?: GraphQLTypes["UnlockedArticleUniqueWhere"],
	coverPhotoVertical?: GraphQLTypes["ImageUseUniqueWhere"],
	tags?: GraphQLTypes["ArticleTagUniqueWhere"],
	historyTags?: GraphQLTypes["ArticleHistoryTagUniqueWhere"],
	historyPeriods?: GraphQLTypes["ArticleHistoryPeriodUniqueWhere"]
};
	["UrlUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	article?: GraphQLTypes["ArticleUniqueWhere"],
	author?: GraphQLTypes["AuthorUniqueWhere"],
	issue?: GraphQLTypes["IssueUniqueWhere"],
	page?: GraphQLTypes["PageUniqueWhere"],
	category?: GraphQLTypes["CategoryUniqueWhere"],
	tag?: GraphQLTypes["TagUniqueWhere"]
};
	["AuthorUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	legacyId?: string,
	about?: GraphQLTypes["ContentUniqueWhere"],
	topArticles?: GraphQLTypes["AuthorTopArticleUniqueWhere"],
	photo?: GraphQLTypes["ImageUseUniqueWhere"],
	illustration?: GraphQLTypes["ImageUseUniqueWhere"],
	url?: GraphQLTypes["UrlUniqueWhere"]
};
	["AuthorTopArticleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["IssueUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	kind?: GraphQLTypes["IssueKind"],
	year?: number,
	issue?: number,
	legacyId?: string,
	url?: GraphQLTypes["UrlUniqueWhere"],
	articles?: GraphQLTypes["IssueArticleUniqueWhere"],
	pdf?: GraphQLTypes["FileUseUniqueWhere"],
	blocks?: GraphQLTypes["ContentBlockUniqueWhere"],
	coverPhoto?: GraphQLTypes["ImageUseUniqueWhere"],
	printTarget?: GraphQLTypes["LinkUniqueWhere"],
	backgroundPhoto?: GraphQLTypes["ImageUseUniqueWhere"]
};
	["IssueArticleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	issue?: GraphQLTypes["IssueUniqueWhere"],
	article?: GraphQLTypes["ArticleUniqueWhere"]
};
	["FileUseUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ContentBlockUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	target?: GraphQLTypes["LinkUniqueWhere"],
	articles?: GraphQLTypes["ContentArticleUniqueWhere"]
};
	["ContentArticleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["PageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	url?: GraphQLTypes["UrlUniqueWhere"],
	content?: GraphQLTypes["ContentUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["SeoUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	page?: GraphQLTypes["PageUniqueWhere"]
};
	["CategoryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	legacyId?: string,
	articleCategory?: GraphQLTypes["ArticleCategoryUniqueWhere"],
	url?: GraphQLTypes["UrlUniqueWhere"]
};
	["ArticleCategoryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	article?: GraphQLTypes["ArticleUniqueWhere"],
	category?: GraphQLTypes["CategoryUniqueWhere"]
};
	["TagUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	legacyId?: string,
	articleTag?: GraphQLTypes["ArticleTagUniqueWhere"],
	url?: GraphQLTypes["UrlUniqueWhere"]
};
	["ArticleTagUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	article?: GraphQLTypes["ArticleUniqueWhere"],
	tag?: GraphQLTypes["TagUniqueWhere"]
};
	["ArticleAuthorUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	article?: GraphQLTypes["ArticleUniqueWhere"],
	author?: GraphQLTypes["AuthorUniqueWhere"],
	legacyStringAuthor?: GraphQLTypes["ArticleAuthorLegacyStringAuthor"]
};
	["TextContentUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	parts?: GraphQLTypes["TextContentPartUniqueWhere"]
};
	["TextContentPartUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	references?: GraphQLTypes["TextContentReferenceUniqueWhere"]
};
	["TextContentReferenceUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	target?: GraphQLTypes["LinkUniqueWhere"]
};
	["UnlockedArticleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ArticleHistoryTagUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	article?: GraphQLTypes["ArticleUniqueWhere"],
	historyTag?: GraphQLTypes["HistoryTagUniqueWhere"]
};
	["HistoryTagUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	slug?: string,
	articleHistoryTag?: GraphQLTypes["ArticleHistoryTagUniqueWhere"]
};
	["ArticleHistoryPeriodUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	article?: GraphQLTypes["ArticleUniqueWhere"],
	historyPeriod?: GraphQLTypes["HistoryPeriodUniqueWhere"]
};
	["HistoryPeriodUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	slug?: string,
	articleHistoryPeriod?: GraphQLTypes["ArticleHistoryPeriodUniqueWhere"],
	cover?: GraphQLTypes["HistoryCoverUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["HistoryCoverUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	coverImage?: GraphQLTypes["ImageUseUniqueWhere"],
	tileImage?: GraphQLTypes["ImageUseUniqueWhere"],
	mobileImage?: GraphQLTypes["ImageUseUniqueWhere"],
	leadContent?: GraphQLTypes["ContentUniqueWhere"],
	annotations?: GraphQLTypes["HistoryTextListUniqueWhere"]
};
	["HistoryTextListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["HistoryTextItemUniqueWhere"]
};
	["HistoryTextItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	image?: GraphQLTypes["ImageUseUniqueWhere"]
};
	["IssueBlocksByTargetUniqueWhere"]: {
		target?: GraphQLTypes["LinkUniqueWhere"]
};
	["IssueBlocksByArticlesUniqueWhere"]: {
		articles?: GraphQLTypes["ContentArticleUniqueWhere"]
};
	["IssueArticleConnection"]: {
	__typename: "IssueArticleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["IssueArticleEdge"]>
};
	["IssueArticleEdge"]: {
	__typename: "IssueArticleEdge",
	node: GraphQLTypes["IssueArticle"]
};
	["ContentBlockConnection"]: {
	__typename: "ContentBlockConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentBlockEdge"]>
};
	["ContentBlockEdge"]: {
	__typename: "ContentBlockEdge",
	node: GraphQLTypes["ContentBlock"]
};
	["ContentArticle"]: {
	__typename: "ContentArticle",
	_meta?: GraphQLTypes["ContentArticleMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	contentBlock?: GraphQLTypes["ContentBlock"],
	article?: GraphQLTypes["Article"]
};
	["ContentArticleMeta"]: {
	__typename: "ContentArticleMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	contentBlock?: GraphQLTypes["FieldMeta"],
	article?: GraphQLTypes["FieldMeta"]
};
	["ContentArticleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	contentBlock?: GraphQLTypes["ContentBlockOrderBy"],
	article?: GraphQLTypes["ArticleOrderBy"]
};
	["ContentArticleConnection"]: {
	__typename: "ContentArticleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentArticleEdge"]>
};
	["ContentArticleEdge"]: {
	__typename: "ContentArticleEdge",
	node: GraphQLTypes["ContentArticle"]
};
	["SubscriptionFormSectionsByInputsUniqueWhere"]: {
		inputs?: GraphQLTypes["SubscriptionFormInputUniqueWhere"]
};
	["SubscriptionFormInputUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	image?: GraphQLTypes["ImageUseUniqueWhere"],
	options?: GraphQLTypes["SubscriptionFormOptionUniqueWhere"],
	description?: GraphQLTypes["ContentUniqueWhere"]
};
	["SubscriptionFormContentBlockByTargetUniqueWhere"]: {
		target?: GraphQLTypes["LinkUniqueWhere"]
};
	["SubscriptionFormContentBlockByArticlesUniqueWhere"]: {
		articles?: GraphQLTypes["ContentArticleUniqueWhere"]
};
	["SubscriptionFormContentReferencesByEmbedUniqueWhere"]: {
		embed?: GraphQLTypes["EmbedUniqueWhere"]
};
	["SubscriptionFormContentReferencesByAudioUniqueWhere"]: {
		audio?: GraphQLTypes["AudioUseUniqueWhere"]
};
	["SubscriptionFormContentReferencesByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUseUniqueWhere"]
};
	["SubscriptionFormContentReferencesByPollAnswerUniqueWhere"]: {
		pollAnswer?: GraphQLTypes["PollAnswerUniqueWhere"]
};
	["SubscriptionFormContentReferencesByListicleUniqueWhere"]: {
		listicle?: GraphQLTypes["ListicleUniqueWhere"]
};
	["SubscriptionFormContentReferencesByFaqUniqueWhere"]: {
		faq?: GraphQLTypes["FAQUniqueWhere"]
};
	["SubscriptionFormContentReferencesByLinksUniqueWhere"]: {
		links?: GraphQLTypes["LinkContentUniqueWhere"]
};
	["SubscriptionFormContentReferencesByAwardsUniqueWhere"]: {
		awards?: GraphQLTypes["AwardContentUniqueWhere"]
};
	["SubscriptionFormContentReferencesByReviewsUniqueWhere"]: {
		reviews?: GraphQLTypes["ReviewContentUniqueWhere"]
};
	["SubscriptionFormContentReferencesByTargetUniqueWhere"]: {
		target?: GraphQLTypes["LinkUniqueWhere"]
};
	["SubscriptionFormContentReferencesByButtonsUniqueWhere"]: {
		buttons?: GraphQLTypes["ButtonUniqueWhere"]
};
	["SubscriptionFormSectionConnection"]: {
	__typename: "SubscriptionFormSectionConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SubscriptionFormSectionEdge"]>
};
	["SubscriptionFormSectionEdge"]: {
	__typename: "SubscriptionFormSectionEdge",
	node: GraphQLTypes["SubscriptionFormSection"]
};
	["Button"]: {
	__typename: "Button",
	_meta?: GraphQLTypes["ButtonMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	type?: GraphQLTypes["ButtonType"],
	label?: string,
	target?: GraphQLTypes["Link"],
	contentReference?: GraphQLTypes["ContentReference"]
};
	["ButtonMeta"]: {
	__typename: "ButtonMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	label?: GraphQLTypes["FieldMeta"],
	target?: GraphQLTypes["FieldMeta"],
	contentReference?: GraphQLTypes["FieldMeta"]
};
	["ButtonOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	label?: GraphQLTypes["OrderDirection"],
	target?: GraphQLTypes["LinkOrderBy"],
	contentReference?: GraphQLTypes["ContentReferenceOrderBy"]
};
	["SharedContent"]: {
	__typename: "SharedContent",
	_meta?: GraphQLTypes["SharedContentMeta"],
	id: GraphQLTypes["UUID"],
	name: string,
	contentReference: Array<GraphQLTypes["ContentReference"]>,
	content?: GraphQLTypes["Content"],
	contentReferenceByEmbed?: GraphQLTypes["ContentReference"],
	contentReferenceByAudio?: GraphQLTypes["ContentReference"],
	contentReferenceByImage?: GraphQLTypes["ContentReference"],
	contentReferenceByPollAnswer?: GraphQLTypes["ContentReference"],
	contentReferenceByListicle?: GraphQLTypes["ContentReference"],
	contentReferenceByFaq?: GraphQLTypes["ContentReference"],
	contentReferenceByLinks?: GraphQLTypes["ContentReference"],
	contentReferenceByAwards?: GraphQLTypes["ContentReference"],
	contentReferenceByReviews?: GraphQLTypes["ContentReference"],
	contentReferenceByTarget?: GraphQLTypes["ContentReference"],
	contentReferenceByButtons?: GraphQLTypes["ContentReference"],
	paginateContentReference: GraphQLTypes["ContentReferenceConnection"]
};
	["SharedContentMeta"]: {
	__typename: "SharedContentMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	contentReference?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"]
};
	["SharedContentContentReferenceByEmbedUniqueWhere"]: {
		embed?: GraphQLTypes["EmbedUniqueWhere"]
};
	["SharedContentContentReferenceByAudioUniqueWhere"]: {
		audio?: GraphQLTypes["AudioUseUniqueWhere"]
};
	["SharedContentContentReferenceByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUseUniqueWhere"]
};
	["SharedContentContentReferenceByPollAnswerUniqueWhere"]: {
		pollAnswer?: GraphQLTypes["PollAnswerUniqueWhere"]
};
	["SharedContentContentReferenceByListicleUniqueWhere"]: {
		listicle?: GraphQLTypes["ListicleUniqueWhere"]
};
	["SharedContentContentReferenceByFaqUniqueWhere"]: {
		faq?: GraphQLTypes["FAQUniqueWhere"]
};
	["SharedContentContentReferenceByLinksUniqueWhere"]: {
		links?: GraphQLTypes["LinkContentUniqueWhere"]
};
	["SharedContentContentReferenceByAwardsUniqueWhere"]: {
		awards?: GraphQLTypes["AwardContentUniqueWhere"]
};
	["SharedContentContentReferenceByReviewsUniqueWhere"]: {
		reviews?: GraphQLTypes["ReviewContentUniqueWhere"]
};
	["SharedContentContentReferenceByTargetUniqueWhere"]: {
		target?: GraphQLTypes["LinkUniqueWhere"]
};
	["SharedContentContentReferenceByButtonsUniqueWhere"]: {
		buttons?: GraphQLTypes["ButtonUniqueWhere"]
};
	["ContentReferenceButtonsByTargetUniqueWhere"]: {
		target?: GraphQLTypes["LinkUniqueWhere"]
};
	["ImageContentConnection"]: {
	__typename: "ImageContentConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImageContentEdge"]>
};
	["ImageContentEdge"]: {
	__typename: "ImageContentEdge",
	node: GraphQLTypes["ImageContent"]
};
	["ListicleConnection"]: {
	__typename: "ListicleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ListicleEdge"]>
};
	["ListicleEdge"]: {
	__typename: "ListicleEdge",
	node: GraphQLTypes["Listicle"]
};
	["FAQConnection"]: {
	__typename: "FAQConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FAQEdge"]>
};
	["FAQEdge"]: {
	__typename: "FAQEdge",
	node: GraphQLTypes["FAQ"]
};
	["LinkContentConnection"]: {
	__typename: "LinkContentConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkContentEdge"]>
};
	["LinkContentEdge"]: {
	__typename: "LinkContentEdge",
	node: GraphQLTypes["LinkContent"]
};
	["AwardContentConnection"]: {
	__typename: "AwardContentConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["AwardContentEdge"]>
};
	["AwardContentEdge"]: {
	__typename: "AwardContentEdge",
	node: GraphQLTypes["AwardContent"]
};
	["ReviewContentConnection"]: {
	__typename: "ReviewContentConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ReviewContentEdge"]>
};
	["ReviewContentEdge"]: {
	__typename: "ReviewContentEdge",
	node: GraphQLTypes["ReviewContent"]
};
	["ButtonConnection"]: {
	__typename: "ButtonConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ButtonEdge"]>
};
	["ButtonEdge"]: {
	__typename: "ButtonEdge",
	node: GraphQLTypes["Button"]
};
	["ContentPartReferencesByEmbedUniqueWhere"]: {
		embed?: GraphQLTypes["EmbedUniqueWhere"]
};
	["ContentPartReferencesByAudioUniqueWhere"]: {
		audio?: GraphQLTypes["AudioUseUniqueWhere"]
};
	["ContentPartReferencesByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUseUniqueWhere"]
};
	["ContentPartReferencesByPollAnswerUniqueWhere"]: {
		pollAnswer?: GraphQLTypes["PollAnswerUniqueWhere"]
};
	["ContentPartReferencesByListicleUniqueWhere"]: {
		listicle?: GraphQLTypes["ListicleUniqueWhere"]
};
	["ContentPartReferencesByFaqUniqueWhere"]: {
		faq?: GraphQLTypes["FAQUniqueWhere"]
};
	["ContentPartReferencesByLinksUniqueWhere"]: {
		links?: GraphQLTypes["LinkContentUniqueWhere"]
};
	["ContentPartReferencesByAwardsUniqueWhere"]: {
		awards?: GraphQLTypes["AwardContentUniqueWhere"]
};
	["ContentPartReferencesByReviewsUniqueWhere"]: {
		reviews?: GraphQLTypes["ReviewContentUniqueWhere"]
};
	["ContentPartReferencesByTargetUniqueWhere"]: {
		target?: GraphQLTypes["LinkUniqueWhere"]
};
	["ContentPartReferencesByButtonsUniqueWhere"]: {
		buttons?: GraphQLTypes["ButtonUniqueWhere"]
};
	["ContentPartsByReferencesUniqueWhere"]: {
		references?: GraphQLTypes["ContentReferenceUniqueWhere"]
};
	["ContentPartConnection"]: {
	__typename: "ContentPartConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentPartEdge"]>
};
	["ContentPartEdge"]: {
	__typename: "ContentPartEdge",
	node: GraphQLTypes["ContentPart"]
};
	["AuthorTopArticle"]: {
	__typename: "AuthorTopArticle",
	_meta?: GraphQLTypes["AuthorTopArticleMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	author?: GraphQLTypes["Author"],
	article?: GraphQLTypes["Article"]
};
	["AuthorTopArticleMeta"]: {
	__typename: "AuthorTopArticleMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	author?: GraphQLTypes["FieldMeta"],
	article?: GraphQLTypes["FieldMeta"]
};
	["AuthorTopArticleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	author?: GraphQLTypes["AuthorOrderBy"],
	article?: GraphQLTypes["ArticleOrderBy"]
};
	["User"]: {
	__typename: "User",
	_meta?: GraphQLTypes["UserMeta"],
	id: GraphQLTypes["UUID"],
	ihnedId: string,
	email: string,
	authors: Array<GraphQLTypes["Author"]>,
	unlockedArticles: Array<GraphQLTypes["UnlockedArticle"]>,
	appReviews: Array<GraphQLTypes["AppReview"]>,
	paginateAuthors: GraphQLTypes["AuthorConnection"],
	paginateUnlockedArticles: GraphQLTypes["UnlockedArticleConnection"],
	paginateAppReviews: GraphQLTypes["AppReviewConnection"]
};
	["UserMeta"]: {
	__typename: "UserMeta",
	id?: GraphQLTypes["FieldMeta"],
	ihnedId?: GraphQLTypes["FieldMeta"],
	email?: GraphQLTypes["FieldMeta"],
	authors?: GraphQLTypes["FieldMeta"],
	unlockedArticles?: GraphQLTypes["FieldMeta"],
	appReviews?: GraphQLTypes["FieldMeta"]
};
	["UnlockedArticle"]: {
	__typename: "UnlockedArticle",
	_meta?: GraphQLTypes["UnlockedArticleMeta"],
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	code: string,
	views: number,
	user?: GraphQLTypes["User"],
	article?: GraphQLTypes["Article"]
};
	["UnlockedArticleMeta"]: {
	__typename: "UnlockedArticleMeta",
	id?: GraphQLTypes["FieldMeta"],
	createdAt?: GraphQLTypes["FieldMeta"],
	code?: GraphQLTypes["FieldMeta"],
	views?: GraphQLTypes["FieldMeta"],
	user?: GraphQLTypes["FieldMeta"],
	article?: GraphQLTypes["FieldMeta"]
};
	["UnlockedArticleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	createdAt?: GraphQLTypes["OrderDirection"],
	code?: GraphQLTypes["OrderDirection"],
	views?: GraphQLTypes["OrderDirection"],
	user?: GraphQLTypes["UserOrderBy"],
	article?: GraphQLTypes["ArticleOrderBy"]
};
	["UserOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	ihnedId?: GraphQLTypes["OrderDirection"],
	email?: GraphQLTypes["OrderDirection"]
};
	["AppReview"]: {
	__typename: "AppReview",
	_meta?: GraphQLTypes["AppReviewMeta"],
	id: GraphQLTypes["UUID"],
	done: boolean,
	deviceId: string,
	createdAt: GraphQLTypes["DateTime"],
	rating: number,
	note?: string,
	user?: GraphQLTypes["User"]
};
	["AppReviewMeta"]: {
	__typename: "AppReviewMeta",
	id?: GraphQLTypes["FieldMeta"],
	done?: GraphQLTypes["FieldMeta"],
	deviceId?: GraphQLTypes["FieldMeta"],
	createdAt?: GraphQLTypes["FieldMeta"],
	rating?: GraphQLTypes["FieldMeta"],
	note?: GraphQLTypes["FieldMeta"],
	user?: GraphQLTypes["FieldMeta"]
};
	["AppReviewOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	done?: GraphQLTypes["OrderDirection"],
	deviceId?: GraphQLTypes["OrderDirection"],
	createdAt?: GraphQLTypes["OrderDirection"],
	rating?: GraphQLTypes["OrderDirection"],
	note?: GraphQLTypes["OrderDirection"],
	user?: GraphQLTypes["UserOrderBy"]
};
	["AuthorConnection"]: {
	__typename: "AuthorConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["AuthorEdge"]>
};
	["AuthorEdge"]: {
	__typename: "AuthorEdge",
	node: GraphQLTypes["Author"]
};
	["UnlockedArticleConnection"]: {
	__typename: "UnlockedArticleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["UnlockedArticleEdge"]>
};
	["UnlockedArticleEdge"]: {
	__typename: "UnlockedArticleEdge",
	node: GraphQLTypes["UnlockedArticle"]
};
	["AppReviewConnection"]: {
	__typename: "AppReviewConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["AppReviewEdge"]>
};
	["AppReviewEdge"]: {
	__typename: "AppReviewEdge",
	node: GraphQLTypes["AppReview"]
};
	["AuthorTopArticleConnection"]: {
	__typename: "AuthorTopArticleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["AuthorTopArticleEdge"]>
};
	["AuthorTopArticleEdge"]: {
	__typename: "AuthorTopArticleEdge",
	node: GraphQLTypes["AuthorTopArticle"]
};
	["UserConnection"]: {
	__typename: "UserConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["UserEdge"]>
};
	["UserEdge"]: {
	__typename: "UserEdge",
	node: GraphQLTypes["User"]
};
	["Page"]: {
	__typename: "Page",
	_meta?: GraphQLTypes["PageMeta"],
	id: GraphQLTypes["UUID"],
	title: string,
	publishAt?: GraphQLTypes["DateTime"],
	createdAt: GraphQLTypes["DateTime"],
	template: GraphQLTypes["PageTemplate"],
	url?: GraphQLTypes["Url"],
	content?: GraphQLTypes["Content"],
	seo?: GraphQLTypes["Seo"],
	subscriptionValidity?: GraphQLTypes["DateTime"]
};
	["PageMeta"]: {
	__typename: "PageMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	publishAt?: GraphQLTypes["FieldMeta"],
	createdAt?: GraphQLTypes["FieldMeta"],
	template?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	subscriptionValidity?: GraphQLTypes["FieldMeta"]
};
	["Seo"]: {
	__typename: "Seo",
	_meta?: GraphQLTypes["SeoMeta"],
	id: GraphQLTypes["UUID"],
	title: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	page?: GraphQLTypes["Page"],
	twCard?: GraphQLTypes["SeoTwCard"],
	ogImage?: GraphQLTypes["ImageUse"]
};
	["SeoMeta"]: {
	__typename: "SeoMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	description?: GraphQLTypes["FieldMeta"],
	ogTitle?: GraphQLTypes["FieldMeta"],
	ogDescription?: GraphQLTypes["FieldMeta"],
	page?: GraphQLTypes["FieldMeta"],
	twCard?: GraphQLTypes["FieldMeta"],
	ogImage?: GraphQLTypes["FieldMeta"]
};
	["Category"]: {
	__typename: "Category",
	_meta?: GraphQLTypes["CategoryMeta"],
	id: GraphQLTypes["UUID"],
	name: string,
	articleCategory: Array<GraphQLTypes["ArticleCategory"]>,
	url?: GraphQLTypes["Url"],
	legacyId?: string,
	articleCategoryByArticle?: GraphQLTypes["ArticleCategory"],
	paginateArticleCategory: GraphQLTypes["ArticleCategoryConnection"]
};
	["CategoryMeta"]: {
	__typename: "CategoryMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	articleCategory?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"],
	legacyId?: GraphQLTypes["FieldMeta"]
};
	["ArticleCategory"]: {
	__typename: "ArticleCategory",
	_meta?: GraphQLTypes["ArticleCategoryMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	article?: GraphQLTypes["Article"],
	category?: GraphQLTypes["Category"]
};
	["ArticleCategoryMeta"]: {
	__typename: "ArticleCategoryMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	article?: GraphQLTypes["FieldMeta"],
	category?: GraphQLTypes["FieldMeta"]
};
	["ArticleCategoryOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	article?: GraphQLTypes["ArticleOrderBy"],
	category?: GraphQLTypes["CategoryOrderBy"]
};
	["CategoryArticleCategoryByArticleUniqueWhere"]: {
		article?: GraphQLTypes["ArticleUniqueWhere"]
};
	["ArticleCategoryConnection"]: {
	__typename: "ArticleCategoryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ArticleCategoryEdge"]>
};
	["ArticleCategoryEdge"]: {
	__typename: "ArticleCategoryEdge",
	node: GraphQLTypes["ArticleCategory"]
};
	["Tag"]: {
	__typename: "Tag",
	_meta?: GraphQLTypes["TagMeta"],
	id: GraphQLTypes["UUID"],
	name: string,
	useAsTagline: boolean,
	articleTag: Array<GraphQLTypes["ArticleTag"]>,
	url?: GraphQLTypes["Url"],
	order?: string,
	legacyId?: string,
	articleTagByArticle?: GraphQLTypes["ArticleTag"],
	paginateArticleTag: GraphQLTypes["ArticleTagConnection"]
};
	["TagMeta"]: {
	__typename: "TagMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	useAsTagline?: GraphQLTypes["FieldMeta"],
	articleTag?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	legacyId?: GraphQLTypes["FieldMeta"]
};
	["ArticleTag"]: {
	__typename: "ArticleTag",
	_meta?: GraphQLTypes["ArticleTagMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	tag?: GraphQLTypes["Tag"],
	article?: GraphQLTypes["Article"]
};
	["ArticleTagMeta"]: {
	__typename: "ArticleTagMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	tag?: GraphQLTypes["FieldMeta"],
	article?: GraphQLTypes["FieldMeta"]
};
	["ArticleTagOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	tag?: GraphQLTypes["TagOrderBy"],
	article?: GraphQLTypes["ArticleOrderBy"]
};
	["TagArticleTagByArticleUniqueWhere"]: {
		article?: GraphQLTypes["ArticleUniqueWhere"]
};
	["ArticleTagConnection"]: {
	__typename: "ArticleTagConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ArticleTagEdge"]>
};
	["ArticleTagEdge"]: {
	__typename: "ArticleTagEdge",
	node: GraphQLTypes["ArticleTag"]
};
	["ArticleAuthor"]: {
	__typename: "ArticleAuthor",
	_meta?: GraphQLTypes["ArticleAuthorMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	article?: GraphQLTypes["Article"],
	author?: GraphQLTypes["Author"],
	legacyStringAuthor?: GraphQLTypes["ArticleAuthorLegacyStringAuthor"]
};
	["ArticleAuthorMeta"]: {
	__typename: "ArticleAuthorMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	article?: GraphQLTypes["FieldMeta"],
	author?: GraphQLTypes["FieldMeta"],
	legacyStringAuthor?: GraphQLTypes["FieldMeta"]
};
	["ArticleAuthorOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	article?: GraphQLTypes["ArticleOrderBy"],
	author?: GraphQLTypes["AuthorOrderBy"],
	legacyStringAuthor?: GraphQLTypes["OrderDirection"]
};
	["TextContent"]: {
	__typename: "TextContent",
	_meta?: GraphQLTypes["TextContentMeta"],
	id: GraphQLTypes["UUID"],
	parts: Array<GraphQLTypes["TextContentPart"]>,
	partsByReferences?: GraphQLTypes["TextContentPart"],
	paginateParts: GraphQLTypes["TextContentPartConnection"]
};
	["TextContentMeta"]: {
	__typename: "TextContentMeta",
	id?: GraphQLTypes["FieldMeta"],
	parts?: GraphQLTypes["FieldMeta"]
};
	["TextContentPart"]: {
	__typename: "TextContentPart",
	_meta?: GraphQLTypes["TextContentPartMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	json: string,
	content?: GraphQLTypes["TextContent"],
	references: Array<GraphQLTypes["TextContentReference"]>,
	referencesByTarget?: GraphQLTypes["TextContentReference"],
	paginateReferences: GraphQLTypes["TextContentReferenceConnection"]
};
	["TextContentPartMeta"]: {
	__typename: "TextContentPartMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	json?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	references?: GraphQLTypes["FieldMeta"]
};
	["TextContentReference"]: {
	__typename: "TextContentReference",
	_meta?: GraphQLTypes["TextContentReferenceMeta"],
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["TextContentReferenceType"],
	contentPart?: GraphQLTypes["TextContentPart"],
	target?: GraphQLTypes["Link"]
};
	["TextContentReferenceMeta"]: {
	__typename: "TextContentReferenceMeta",
	id?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	contentPart?: GraphQLTypes["FieldMeta"],
	target?: GraphQLTypes["FieldMeta"]
};
	["TextContentReferenceOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	contentPart?: GraphQLTypes["TextContentPartOrderBy"],
	target?: GraphQLTypes["LinkOrderBy"]
};
	["TextContentPartOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	json?: GraphQLTypes["OrderDirection"],
	content?: GraphQLTypes["TextContentOrderBy"]
};
	["TextContentPartReferencesByTargetUniqueWhere"]: {
		target?: GraphQLTypes["LinkUniqueWhere"]
};
	["TextContentReferenceConnection"]: {
	__typename: "TextContentReferenceConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TextContentReferenceEdge"]>
};
	["TextContentReferenceEdge"]: {
	__typename: "TextContentReferenceEdge",
	node: GraphQLTypes["TextContentReference"]
};
	["TextContentPartsByReferencesUniqueWhere"]: {
		references?: GraphQLTypes["TextContentReferenceUniqueWhere"]
};
	["TextContentPartConnection"]: {
	__typename: "TextContentPartConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TextContentPartEdge"]>
};
	["TextContentPartEdge"]: {
	__typename: "TextContentPartEdge",
	node: GraphQLTypes["TextContentPart"]
};
	["ArticleHistoryTag"]: {
	__typename: "ArticleHistoryTag",
	_meta?: GraphQLTypes["ArticleHistoryTagMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	article?: GraphQLTypes["Article"],
	historyTag?: GraphQLTypes["HistoryTag"]
};
	["ArticleHistoryTagMeta"]: {
	__typename: "ArticleHistoryTagMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	article?: GraphQLTypes["FieldMeta"],
	historyTag?: GraphQLTypes["FieldMeta"]
};
	["HistoryTag"]: {
	__typename: "HistoryTag",
	_meta?: GraphQLTypes["HistoryTagMeta"],
	id: GraphQLTypes["UUID"],
	name: string,
	articleHistoryTag: Array<GraphQLTypes["ArticleHistoryTag"]>,
	slug: string,
	articleHistoryTagByArticle?: GraphQLTypes["ArticleHistoryTag"],
	paginateArticleHistoryTag: GraphQLTypes["ArticleHistoryTagConnection"]
};
	["HistoryTagMeta"]: {
	__typename: "HistoryTagMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	articleHistoryTag?: GraphQLTypes["FieldMeta"],
	slug?: GraphQLTypes["FieldMeta"]
};
	["ArticleHistoryTagOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	article?: GraphQLTypes["ArticleOrderBy"],
	historyTag?: GraphQLTypes["HistoryTagOrderBy"]
};
	["HistoryTagOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	slug?: GraphQLTypes["OrderDirection"]
};
	["HistoryTagArticleHistoryTagByArticleUniqueWhere"]: {
		article?: GraphQLTypes["ArticleUniqueWhere"]
};
	["ArticleHistoryTagConnection"]: {
	__typename: "ArticleHistoryTagConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ArticleHistoryTagEdge"]>
};
	["ArticleHistoryTagEdge"]: {
	__typename: "ArticleHistoryTagEdge",
	node: GraphQLTypes["ArticleHistoryTag"]
};
	["ArticleHistoryPeriod"]: {
	__typename: "ArticleHistoryPeriod",
	_meta?: GraphQLTypes["ArticleHistoryPeriodMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	article?: GraphQLTypes["Article"],
	historyPeriod?: GraphQLTypes["HistoryPeriod"]
};
	["ArticleHistoryPeriodMeta"]: {
	__typename: "ArticleHistoryPeriodMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	article?: GraphQLTypes["FieldMeta"],
	historyPeriod?: GraphQLTypes["FieldMeta"]
};
	["HistoryPeriod"]: {
	__typename: "HistoryPeriod",
	_meta?: GraphQLTypes["HistoryPeriodMeta"],
	id: GraphQLTypes["UUID"],
	name: string,
	articleHistoryPeriod: Array<GraphQLTypes["ArticleHistoryPeriod"]>,
	slug: string,
	order?: number,
	cover?: GraphQLTypes["HistoryCover"],
	seo?: GraphQLTypes["Seo"],
	articleHistoryPeriodByArticle?: GraphQLTypes["ArticleHistoryPeriod"],
	paginateArticleHistoryPeriod: GraphQLTypes["ArticleHistoryPeriodConnection"]
};
	["HistoryPeriodMeta"]: {
	__typename: "HistoryPeriodMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	articleHistoryPeriod?: GraphQLTypes["FieldMeta"],
	slug?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	cover?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"]
};
	["ArticleHistoryPeriodOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	article?: GraphQLTypes["ArticleOrderBy"],
	historyPeriod?: GraphQLTypes["HistoryPeriodOrderBy"]
};
	["HistoryPeriodOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	slug?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	cover?: GraphQLTypes["HistoryCoverOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"]
};
	["HistoryCoverOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	tileParagraph?: GraphQLTypes["OrderDirection"],
	coverImage?: GraphQLTypes["ImageUseOrderBy"],
	tileImage?: GraphQLTypes["ImageUseOrderBy"],
	mobileImage?: GraphQLTypes["ImageUseOrderBy"],
	leadContent?: GraphQLTypes["ContentOrderBy"],
	annotations?: GraphQLTypes["HistoryTextListOrderBy"]
};
	["HistoryTextListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["HistoryCover"]: {
	__typename: "HistoryCover",
	_meta?: GraphQLTypes["HistoryCoverMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	tileParagraph?: string,
	coverImage?: GraphQLTypes["ImageUse"],
	tileImage?: GraphQLTypes["ImageUse"],
	mobileImage?: GraphQLTypes["ImageUse"],
	leadContent?: GraphQLTypes["Content"],
	annotations?: GraphQLTypes["HistoryTextList"]
};
	["HistoryCoverMeta"]: {
	__typename: "HistoryCoverMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	tileParagraph?: GraphQLTypes["FieldMeta"],
	coverImage?: GraphQLTypes["FieldMeta"],
	tileImage?: GraphQLTypes["FieldMeta"],
	mobileImage?: GraphQLTypes["FieldMeta"],
	leadContent?: GraphQLTypes["FieldMeta"],
	annotations?: GraphQLTypes["FieldMeta"]
};
	["HistoryTextList"]: {
	__typename: "HistoryTextList",
	_meta?: GraphQLTypes["HistoryTextListMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["HistoryTextItem"]>,
	itemsByImage?: GraphQLTypes["HistoryTextItem"],
	paginateItems: GraphQLTypes["HistoryTextItemConnection"]
};
	["HistoryTextListMeta"]: {
	__typename: "HistoryTextListMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["HistoryTextItem"]: {
	__typename: "HistoryTextItem",
	_meta?: GraphQLTypes["HistoryTextItemMeta"],
	id: GraphQLTypes["UUID"],
	order?: number,
	key?: string,
	text?: string,
	list?: GraphQLTypes["HistoryTextList"],
	image?: GraphQLTypes["ImageUse"]
};
	["HistoryTextItemMeta"]: {
	__typename: "HistoryTextItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	key?: GraphQLTypes["FieldMeta"],
	text?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"]
};
	["HistoryTextItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	key?: GraphQLTypes["OrderDirection"],
	text?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["HistoryTextListOrderBy"],
	image?: GraphQLTypes["ImageUseOrderBy"]
};
	["HistoryTextListItemsByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUseUniqueWhere"]
};
	["HistoryTextItemConnection"]: {
	__typename: "HistoryTextItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HistoryTextItemEdge"]>
};
	["HistoryTextItemEdge"]: {
	__typename: "HistoryTextItemEdge",
	node: GraphQLTypes["HistoryTextItem"]
};
	["HistoryPeriodArticleHistoryPeriodByArticleUniqueWhere"]: {
		article?: GraphQLTypes["ArticleUniqueWhere"]
};
	["ArticleHistoryPeriodConnection"]: {
	__typename: "ArticleHistoryPeriodConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ArticleHistoryPeriodEdge"]>
};
	["ArticleHistoryPeriodEdge"]: {
	__typename: "ArticleHistoryPeriodEdge",
	node: GraphQLTypes["ArticleHistoryPeriod"]
};
	["ArticleAuthorsByAuthorUniqueWhere"]: {
		author?: GraphQLTypes["AuthorUniqueWhere"]
};
	["ArticleAuthorsByLegacyStringAuthorUniqueWhere"]: {
		legacyStringAuthor?: GraphQLTypes["ArticleAuthorLegacyStringAuthor"]
};
	["ArticleCategoriesByCategoryUniqueWhere"]: {
		category?: GraphQLTypes["CategoryUniqueWhere"]
};
	["ArticleIssuesByIssueUniqueWhere"]: {
		issue?: GraphQLTypes["IssueUniqueWhere"]
};
	["ArticleTagsByTagUniqueWhere"]: {
		tag?: GraphQLTypes["TagUniqueWhere"]
};
	["ArticleHistoryTagsByHistoryTagUniqueWhere"]: {
		historyTag?: GraphQLTypes["HistoryTagUniqueWhere"]
};
	["ArticleHistoryPeriodsByHistoryPeriodUniqueWhere"]: {
		historyPeriod?: GraphQLTypes["HistoryPeriodUniqueWhere"]
};
	["ArticleAuthorConnection"]: {
	__typename: "ArticleAuthorConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ArticleAuthorEdge"]>
};
	["ArticleAuthorEdge"]: {
	__typename: "ArticleAuthorEdge",
	node: GraphQLTypes["ArticleAuthor"]
};
	["ArticleConnection"]: {
	__typename: "ArticleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ArticleEdge"]>
};
	["ArticleEdge"]: {
	__typename: "ArticleEdge",
	node: GraphQLTypes["Article"]
};
	["_ValidationResult"]: {
	__typename: "_ValidationResult",
	valid: boolean,
	errors: Array<GraphQLTypes["_ValidationError"]>
};
	["_ValidationError"]: {
	__typename: "_ValidationError",
	path: Array<GraphQLTypes["_PathFragment"]>,
	message: GraphQLTypes["_ValidationMessage"]
};
	["_PathFragment"]:{
	__typename:"_FieldPathFragment" | "_IndexPathFragment"
	['...on _FieldPathFragment']: '__union' & GraphQLTypes["_FieldPathFragment"];
	['...on _IndexPathFragment']: '__union' & GraphQLTypes["_IndexPathFragment"];
};
	["_FieldPathFragment"]: {
	__typename: "_FieldPathFragment",
	field: string
};
	["_IndexPathFragment"]: {
	__typename: "_IndexPathFragment",
	index: number,
	alias?: string
};
	["_ValidationMessage"]: {
	__typename: "_ValidationMessage",
	text: string
};
	["ArticleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	url?: GraphQLTypes["ArticleCreateUrlEntityRelationInput"],
	authors?: Array<GraphQLTypes["ArticleCreateAuthorsEntityRelationInput"]>,
	hideInMostRead?: boolean,
	hideAds?: boolean,
	state?: GraphQLTypes["ArticleState"],
	locked?: boolean,
	publishAt?: GraphQLTypes["DateTime"],
	template?: GraphQLTypes["Template"],
	subtitle?: GraphQLTypes["ArticleCreateSubtitleEntityRelationInput"],
	content?: GraphQLTypes["ArticleCreateContentEntityRelationInput"],
	coverPhoto?: GraphQLTypes["ArticleCreateCoverPhotoEntityRelationInput"],
	titleAlignment?: GraphQLTypes["ArticleTitleAlignment"],
	tagline?: string,
	createdAt?: GraphQLTypes["DateTime"],
	previewContent?: GraphQLTypes["ArticleCreatePreviewContentEntityRelationInput"],
	audio?: GraphQLTypes["ArticleCreateAudioEntityRelationInput"],
	categories?: Array<GraphQLTypes["ArticleCreateCategoriesEntityRelationInput"]>,
	issues?: Array<GraphQLTypes["ArticleCreateIssuesEntityRelationInput"]>,
	contentBlocks?: Array<GraphQLTypes["ArticleCreateContentBlocksEntityRelationInput"]>,
	unlocked?: Array<GraphQLTypes["ArticleCreateUnlockedEntityRelationInput"]>,
	coverPhotoVertical?: GraphQLTypes["ArticleCreateCoverPhotoVerticalEntityRelationInput"],
	legacyId?: string,
	tags?: Array<GraphQLTypes["ArticleCreateTagsEntityRelationInput"]>,
	isHistory?: boolean,
	historyTags?: Array<GraphQLTypes["ArticleCreateHistoryTagsEntityRelationInput"]>,
	historyPeriods?: Array<GraphQLTypes["ArticleCreateHistoryPeriodsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ArticleCreateUrlEntityRelationInput"]: {
		connect?: GraphQLTypes["UrlUniqueWhere"],
	create?: GraphQLTypes["UrlWithoutArticleCreateInput"]
};
	["UrlWithoutArticleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	author?: GraphQLTypes["UrlCreateAuthorEntityRelationInput"],
	issue?: GraphQLTypes["UrlCreateIssueEntityRelationInput"],
	page?: GraphQLTypes["UrlCreatePageEntityRelationInput"],
	category?: GraphQLTypes["UrlCreateCategoryEntityRelationInput"],
	tag?: GraphQLTypes["UrlCreateTagEntityRelationInput"],
	redirect?: string,
	_dummy_field_?: boolean
};
	["UrlCreateAuthorEntityRelationInput"]: {
		connect?: GraphQLTypes["AuthorUniqueWhere"],
	create?: GraphQLTypes["AuthorWithoutUrlCreateInput"]
};
	["AuthorWithoutUrlCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	position?: string,
	twitterHandle?: string,
	facebookId?: string,
	email?: string,
	photographer?: boolean,
	order?: number,
	about?: GraphQLTypes["AuthorCreateAboutEntityRelationInput"],
	topArticles?: Array<GraphQLTypes["AuthorCreateTopArticlesEntityRelationInput"]>,
	users?: Array<GraphQLTypes["AuthorCreateUsersEntityRelationInput"]>,
	startOfCooperation?: GraphQLTypes["Date"],
	photo?: GraphQLTypes["AuthorCreatePhotoEntityRelationInput"],
	illustration?: GraphQLTypes["AuthorCreateIllustrationEntityRelationInput"],
	legacyId?: string,
	category?: GraphQLTypes["AuthorCategory"],
	instagramUsername?: string,
	_dummy_field_?: boolean
};
	["AuthorCreateAboutEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["ContentCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	parts?: Array<GraphQLTypes["ContentCreatePartsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentCreatePartsEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentPartUniqueWhere"],
	create?: GraphQLTypes["ContentPartWithoutContentCreateInput"],
	alias?: string
};
	["ContentPartWithoutContentCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	json?: string,
	references?: Array<GraphQLTypes["ContentPartCreateReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentPartCreateReferencesEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	create?: GraphQLTypes["ContentReferenceWithoutContentPartCreateInput"],
	alias?: string
};
	["ContentReferenceWithoutContentPartCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ContentReferenceType"],
	primaryText?: string,
	secondaryText?: string,
	variant?: GraphQLTypes["ContentReferenceVariant"],
	color?: string,
	embed?: GraphQLTypes["ContentReferenceCreateEmbedEntityRelationInput"],
	article?: GraphQLTypes["ContentReferenceCreateArticleEntityRelationInput"],
	audio?: GraphQLTypes["ContentReferenceCreateAudioEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"],
	images?: Array<GraphQLTypes["ContentReferenceCreateImagesEntityRelationInput"]>,
	pollAnswer?: GraphQLTypes["ContentReferenceCreatePollAnswerEntityRelationInput"],
	listicle?: Array<GraphQLTypes["ContentReferenceCreateListicleEntityRelationInput"]>,
	faq?: Array<GraphQLTypes["ContentReferenceCreateFaqEntityRelationInput"]>,
	links?: Array<GraphQLTypes["ContentReferenceCreateLinksEntityRelationInput"]>,
	awards?: Array<GraphQLTypes["ContentReferenceCreateAwardsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ContentReferenceCreateReviewsEntityRelationInput"]>,
	target?: GraphQLTypes["ContentReferenceCreateTargetEntityRelationInput"],
	subscriptionForm?: GraphQLTypes["ContentReferenceCreateSubscriptionFormEntityRelationInput"],
	buttons?: Array<GraphQLTypes["ContentReferenceCreateButtonsEntityRelationInput"]>,
	sharedContent?: GraphQLTypes["ContentReferenceCreateSharedContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceCreateEmbedEntityRelationInput"]: {
		connect?: GraphQLTypes["EmbedUniqueWhere"],
	create?: GraphQLTypes["EmbedCreateInput"]
};
	["EmbedCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["EmbedType"],
	youtubeId?: string,
	vimeoId?: string,
	spotifyId?: string,
	spotifyType?: string,
	soundCloudId?: string,
	_dummy_field_?: boolean
};
	["ContentReferenceCreateArticleEntityRelationInput"]: {
		connect?: GraphQLTypes["ArticleUniqueWhere"],
	create?: GraphQLTypes["ArticleCreateInput"]
};
	["ContentReferenceCreateAudioEntityRelationInput"]: {
		connect?: GraphQLTypes["AudioUseUniqueWhere"],
	create?: GraphQLTypes["AudioUseCreateInput"]
};
	["AudioUseCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	audio?: GraphQLTypes["AudioUseCreateAudioEntityRelationInput"],
	_dummy_field_?: boolean
};
	["AudioUseCreateAudioEntityRelationInput"]: {
		connect?: GraphQLTypes["AudioUniqueWhere"],
	create?: GraphQLTypes["AudioWithoutUsesCreateInput"]
};
	["AudioUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	uses?: GraphQLTypes["AudioUseUniqueWhere"]
};
	["AudioWithoutUsesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	type?: string,
	author?: GraphQLTypes["AudioCreateAuthorEntityRelationInput"],
	_dummy_field_?: boolean
};
	["AudioCreateAuthorEntityRelationInput"]: {
		connect?: GraphQLTypes["AuthorUniqueWhere"],
	create?: GraphQLTypes["AuthorCreateInput"]
};
	["AuthorCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	position?: string,
	twitterHandle?: string,
	facebookId?: string,
	email?: string,
	photographer?: boolean,
	order?: number,
	about?: GraphQLTypes["AuthorCreateAboutEntityRelationInput"],
	topArticles?: Array<GraphQLTypes["AuthorCreateTopArticlesEntityRelationInput"]>,
	users?: Array<GraphQLTypes["AuthorCreateUsersEntityRelationInput"]>,
	startOfCooperation?: GraphQLTypes["Date"],
	photo?: GraphQLTypes["AuthorCreatePhotoEntityRelationInput"],
	illustration?: GraphQLTypes["AuthorCreateIllustrationEntityRelationInput"],
	legacyId?: string,
	category?: GraphQLTypes["AuthorCategory"],
	url?: GraphQLTypes["AuthorCreateUrlEntityRelationInput"],
	instagramUsername?: string,
	_dummy_field_?: boolean
};
	["AuthorCreateTopArticlesEntityRelationInput"]: {
		connect?: GraphQLTypes["AuthorTopArticleUniqueWhere"],
	create?: GraphQLTypes["AuthorTopArticleWithoutAuthorCreateInput"],
	alias?: string
};
	["AuthorTopArticleWithoutAuthorCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	article?: GraphQLTypes["AuthorTopArticleCreateArticleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["AuthorTopArticleCreateArticleEntityRelationInput"]: {
		connect?: GraphQLTypes["ArticleUniqueWhere"],
	create?: GraphQLTypes["ArticleCreateInput"]
};
	["AuthorCreateUsersEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"],
	create?: GraphQLTypes["UserWithoutAuthorsCreateInput"],
	alias?: string
};
	["UserUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	ihnedId?: string,
	unlockedArticles?: GraphQLTypes["UnlockedArticleUniqueWhere"],
	appReviews?: GraphQLTypes["AppReviewUniqueWhere"]
};
	["AppReviewUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["UserWithoutAuthorsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	ihnedId?: string,
	email?: string,
	unlockedArticles?: Array<GraphQLTypes["UserCreateUnlockedArticlesEntityRelationInput"]>,
	appReviews?: Array<GraphQLTypes["UserCreateAppReviewsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["UserCreateUnlockedArticlesEntityRelationInput"]: {
		connect?: GraphQLTypes["UnlockedArticleUniqueWhere"],
	create?: GraphQLTypes["UnlockedArticleWithoutUserCreateInput"],
	alias?: string
};
	["UnlockedArticleWithoutUserCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	createdAt?: GraphQLTypes["DateTime"],
	code?: string,
	views?: number,
	article?: GraphQLTypes["UnlockedArticleCreateArticleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["UnlockedArticleCreateArticleEntityRelationInput"]: {
		connect?: GraphQLTypes["ArticleUniqueWhere"],
	create?: GraphQLTypes["ArticleWithoutUnlockedCreateInput"]
};
	["ArticleWithoutUnlockedCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	url?: GraphQLTypes["ArticleCreateUrlEntityRelationInput"],
	authors?: Array<GraphQLTypes["ArticleCreateAuthorsEntityRelationInput"]>,
	hideInMostRead?: boolean,
	hideAds?: boolean,
	state?: GraphQLTypes["ArticleState"],
	locked?: boolean,
	publishAt?: GraphQLTypes["DateTime"],
	template?: GraphQLTypes["Template"],
	subtitle?: GraphQLTypes["ArticleCreateSubtitleEntityRelationInput"],
	content?: GraphQLTypes["ArticleCreateContentEntityRelationInput"],
	coverPhoto?: GraphQLTypes["ArticleCreateCoverPhotoEntityRelationInput"],
	titleAlignment?: GraphQLTypes["ArticleTitleAlignment"],
	tagline?: string,
	createdAt?: GraphQLTypes["DateTime"],
	previewContent?: GraphQLTypes["ArticleCreatePreviewContentEntityRelationInput"],
	audio?: GraphQLTypes["ArticleCreateAudioEntityRelationInput"],
	categories?: Array<GraphQLTypes["ArticleCreateCategoriesEntityRelationInput"]>,
	issues?: Array<GraphQLTypes["ArticleCreateIssuesEntityRelationInput"]>,
	contentBlocks?: Array<GraphQLTypes["ArticleCreateContentBlocksEntityRelationInput"]>,
	coverPhotoVertical?: GraphQLTypes["ArticleCreateCoverPhotoVerticalEntityRelationInput"],
	legacyId?: string,
	tags?: Array<GraphQLTypes["ArticleCreateTagsEntityRelationInput"]>,
	isHistory?: boolean,
	historyTags?: Array<GraphQLTypes["ArticleCreateHistoryTagsEntityRelationInput"]>,
	historyPeriods?: Array<GraphQLTypes["ArticleCreateHistoryPeriodsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ArticleCreateAuthorsEntityRelationInput"]: {
		connect?: GraphQLTypes["ArticleAuthorUniqueWhere"],
	create?: GraphQLTypes["ArticleAuthorWithoutArticleCreateInput"],
	alias?: string
};
	["ArticleAuthorWithoutArticleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	author?: GraphQLTypes["ArticleAuthorCreateAuthorEntityRelationInput"],
	legacyStringAuthor?: GraphQLTypes["ArticleAuthorLegacyStringAuthor"],
	_dummy_field_?: boolean
};
	["ArticleAuthorCreateAuthorEntityRelationInput"]: {
		connect?: GraphQLTypes["AuthorUniqueWhere"],
	create?: GraphQLTypes["AuthorCreateInput"]
};
	["ArticleCreateSubtitleEntityRelationInput"]: {
		connect?: GraphQLTypes["TextContentUniqueWhere"],
	create?: GraphQLTypes["TextContentCreateInput"]
};
	["TextContentCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	parts?: Array<GraphQLTypes["TextContentCreatePartsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TextContentCreatePartsEntityRelationInput"]: {
		connect?: GraphQLTypes["TextContentPartUniqueWhere"],
	create?: GraphQLTypes["TextContentPartWithoutContentCreateInput"],
	alias?: string
};
	["TextContentPartWithoutContentCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	json?: string,
	references?: Array<GraphQLTypes["TextContentPartCreateReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TextContentPartCreateReferencesEntityRelationInput"]: {
		connect?: GraphQLTypes["TextContentReferenceUniqueWhere"],
	create?: GraphQLTypes["TextContentReferenceWithoutContentPartCreateInput"],
	alias?: string
};
	["TextContentReferenceWithoutContentPartCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["TextContentReferenceType"],
	target?: GraphQLTypes["TextContentReferenceCreateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TextContentReferenceCreateTargetEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["LinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["LinkType"],
	externalTarget?: string,
	internalTarget?: GraphQLTypes["LinkCreateInternalTargetEntityRelationInput"],
	queryParameters?: string,
	_dummy_field_?: boolean
};
	["LinkCreateInternalTargetEntityRelationInput"]: {
		connect?: GraphQLTypes["UrlUniqueWhere"],
	create?: GraphQLTypes["UrlCreateInput"]
};
	["UrlCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	article?: GraphQLTypes["UrlCreateArticleEntityRelationInput"],
	author?: GraphQLTypes["UrlCreateAuthorEntityRelationInput"],
	issue?: GraphQLTypes["UrlCreateIssueEntityRelationInput"],
	page?: GraphQLTypes["UrlCreatePageEntityRelationInput"],
	category?: GraphQLTypes["UrlCreateCategoryEntityRelationInput"],
	tag?: GraphQLTypes["UrlCreateTagEntityRelationInput"],
	redirect?: string,
	_dummy_field_?: boolean
};
	["UrlCreateArticleEntityRelationInput"]: {
		connect?: GraphQLTypes["ArticleUniqueWhere"],
	create?: GraphQLTypes["ArticleWithoutUrlCreateInput"]
};
	["ArticleWithoutUrlCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	authors?: Array<GraphQLTypes["ArticleCreateAuthorsEntityRelationInput"]>,
	hideInMostRead?: boolean,
	hideAds?: boolean,
	state?: GraphQLTypes["ArticleState"],
	locked?: boolean,
	publishAt?: GraphQLTypes["DateTime"],
	template?: GraphQLTypes["Template"],
	subtitle?: GraphQLTypes["ArticleCreateSubtitleEntityRelationInput"],
	content?: GraphQLTypes["ArticleCreateContentEntityRelationInput"],
	coverPhoto?: GraphQLTypes["ArticleCreateCoverPhotoEntityRelationInput"],
	titleAlignment?: GraphQLTypes["ArticleTitleAlignment"],
	tagline?: string,
	createdAt?: GraphQLTypes["DateTime"],
	previewContent?: GraphQLTypes["ArticleCreatePreviewContentEntityRelationInput"],
	audio?: GraphQLTypes["ArticleCreateAudioEntityRelationInput"],
	categories?: Array<GraphQLTypes["ArticleCreateCategoriesEntityRelationInput"]>,
	issues?: Array<GraphQLTypes["ArticleCreateIssuesEntityRelationInput"]>,
	contentBlocks?: Array<GraphQLTypes["ArticleCreateContentBlocksEntityRelationInput"]>,
	unlocked?: Array<GraphQLTypes["ArticleCreateUnlockedEntityRelationInput"]>,
	coverPhotoVertical?: GraphQLTypes["ArticleCreateCoverPhotoVerticalEntityRelationInput"],
	legacyId?: string,
	tags?: Array<GraphQLTypes["ArticleCreateTagsEntityRelationInput"]>,
	isHistory?: boolean,
	historyTags?: Array<GraphQLTypes["ArticleCreateHistoryTagsEntityRelationInput"]>,
	historyPeriods?: Array<GraphQLTypes["ArticleCreateHistoryPeriodsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ArticleCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["ArticleCreateCoverPhotoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUseUniqueWhere"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["ImageUseCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	image?: GraphQLTypes["ImageUseCreateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ImageUseCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageWithoutUsesCreateInput"]
};
	["ImageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	legacyId?: string,
	uses?: GraphQLTypes["ImageUseUniqueWhere"]
};
	["ImageWithoutUsesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	width?: number,
	height?: number,
	title?: string,
	text?: string,
	author?: GraphQLTypes["ImageCreateAuthorEntityRelationInput"],
	tags?: Array<GraphQLTypes["ImageCreateTagsEntityRelationInput"]>,
	align?: GraphQLTypes["ImageAlign"],
	legacyId?: string,
	_dummy_field_?: boolean
};
	["ImageCreateAuthorEntityRelationInput"]: {
		connect?: GraphQLTypes["AuthorUniqueWhere"],
	create?: GraphQLTypes["AuthorCreateInput"]
};
	["ImageCreateTagsEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageTagUniqueWhere"],
	create?: GraphQLTypes["ImageTagWithoutImagesCreateInput"],
	alias?: string
};
	["ImageTagUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ImageTagWithoutImagesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	_dummy_field_?: boolean
};
	["ArticleCreatePreviewContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["ArticleCreateAudioEntityRelationInput"]: {
		connect?: GraphQLTypes["AudioUseUniqueWhere"],
	create?: GraphQLTypes["AudioUseCreateInput"]
};
	["ArticleCreateCategoriesEntityRelationInput"]: {
		connect?: GraphQLTypes["ArticleCategoryUniqueWhere"],
	create?: GraphQLTypes["ArticleCategoryWithoutArticleCreateInput"],
	alias?: string
};
	["ArticleCategoryWithoutArticleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	category?: GraphQLTypes["ArticleCategoryCreateCategoryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArticleCategoryCreateCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["CategoryUniqueWhere"],
	create?: GraphQLTypes["CategoryWithoutArticleCategoryCreateInput"]
};
	["CategoryWithoutArticleCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	url?: GraphQLTypes["CategoryCreateUrlEntityRelationInput"],
	legacyId?: string,
	_dummy_field_?: boolean
};
	["CategoryCreateUrlEntityRelationInput"]: {
		connect?: GraphQLTypes["UrlUniqueWhere"],
	create?: GraphQLTypes["UrlWithoutCategoryCreateInput"]
};
	["UrlWithoutCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	article?: GraphQLTypes["UrlCreateArticleEntityRelationInput"],
	author?: GraphQLTypes["UrlCreateAuthorEntityRelationInput"],
	issue?: GraphQLTypes["UrlCreateIssueEntityRelationInput"],
	page?: GraphQLTypes["UrlCreatePageEntityRelationInput"],
	tag?: GraphQLTypes["UrlCreateTagEntityRelationInput"],
	redirect?: string,
	_dummy_field_?: boolean
};
	["UrlCreateIssueEntityRelationInput"]: {
		connect?: GraphQLTypes["IssueUniqueWhere"],
	create?: GraphQLTypes["IssueWithoutUrlCreateInput"]
};
	["IssueWithoutUrlCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	closed?: boolean,
	free?: boolean,
	title?: string,
	subtitle?: string,
	year?: number,
	issue?: number,
	publishedSince?: GraphQLTypes["Date"],
	publishedUntil?: GraphQLTypes["Date"],
	publishDigital?: GraphQLTypes["DateTime"],
	mobileAppsKey?: string,
	articles?: Array<GraphQLTypes["IssueCreateArticlesEntityRelationInput"]>,
	kind?: GraphQLTypes["IssueKind"],
	notificationTitle?: string,
	notificationMessage?: string,
	pdf?: GraphQLTypes["IssueCreatePdfEntityRelationInput"],
	printBuy?: boolean,
	printText?: string,
	blocks?: Array<GraphQLTypes["IssueCreateBlocksEntityRelationInput"]>,
	coverPhoto?: GraphQLTypes["IssueCreateCoverPhotoEntityRelationInput"],
	printTarget?: GraphQLTypes["IssueCreatePrintTargetEntityRelationInput"],
	backgroundPhoto?: GraphQLTypes["IssueCreateBackgroundPhotoEntityRelationInput"],
	legacyId?: string,
	_dummy_field_?: boolean
};
	["IssueCreateArticlesEntityRelationInput"]: {
		connect?: GraphQLTypes["IssueArticleUniqueWhere"],
	create?: GraphQLTypes["IssueArticleWithoutIssueCreateInput"],
	alias?: string
};
	["IssueArticleWithoutIssueCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	article?: GraphQLTypes["IssueArticleCreateArticleEntityRelationInput"],
	order?: number,
	_dummy_field_?: boolean
};
	["IssueArticleCreateArticleEntityRelationInput"]: {
		connect?: GraphQLTypes["ArticleUniqueWhere"],
	create?: GraphQLTypes["ArticleWithoutIssuesCreateInput"]
};
	["ArticleWithoutIssuesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	url?: GraphQLTypes["ArticleCreateUrlEntityRelationInput"],
	authors?: Array<GraphQLTypes["ArticleCreateAuthorsEntityRelationInput"]>,
	hideInMostRead?: boolean,
	hideAds?: boolean,
	state?: GraphQLTypes["ArticleState"],
	locked?: boolean,
	publishAt?: GraphQLTypes["DateTime"],
	template?: GraphQLTypes["Template"],
	subtitle?: GraphQLTypes["ArticleCreateSubtitleEntityRelationInput"],
	content?: GraphQLTypes["ArticleCreateContentEntityRelationInput"],
	coverPhoto?: GraphQLTypes["ArticleCreateCoverPhotoEntityRelationInput"],
	titleAlignment?: GraphQLTypes["ArticleTitleAlignment"],
	tagline?: string,
	createdAt?: GraphQLTypes["DateTime"],
	previewContent?: GraphQLTypes["ArticleCreatePreviewContentEntityRelationInput"],
	audio?: GraphQLTypes["ArticleCreateAudioEntityRelationInput"],
	categories?: Array<GraphQLTypes["ArticleCreateCategoriesEntityRelationInput"]>,
	contentBlocks?: Array<GraphQLTypes["ArticleCreateContentBlocksEntityRelationInput"]>,
	unlocked?: Array<GraphQLTypes["ArticleCreateUnlockedEntityRelationInput"]>,
	coverPhotoVertical?: GraphQLTypes["ArticleCreateCoverPhotoVerticalEntityRelationInput"],
	legacyId?: string,
	tags?: Array<GraphQLTypes["ArticleCreateTagsEntityRelationInput"]>,
	isHistory?: boolean,
	historyTags?: Array<GraphQLTypes["ArticleCreateHistoryTagsEntityRelationInput"]>,
	historyPeriods?: Array<GraphQLTypes["ArticleCreateHistoryPeriodsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ArticleCreateContentBlocksEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentArticleUniqueWhere"],
	create?: GraphQLTypes["ContentArticleWithoutArticleCreateInput"],
	alias?: string
};
	["ContentArticleWithoutArticleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	contentBlock?: GraphQLTypes["ContentArticleCreateContentBlockEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentArticleCreateContentBlockEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentBlockUniqueWhere"],
	create?: GraphQLTypes["ContentBlockWithoutArticlesCreateInput"]
};
	["ContentBlockWithoutArticlesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	type?: GraphQLTypes["ContentBlockType"],
	youtubeId?: string,
	text?: string,
	targetLabel?: string,
	issue?: GraphQLTypes["ContentBlockCreateIssueEntityRelationInput"],
	target?: GraphQLTypes["ContentBlockCreateTargetEntityRelationInput"],
	subscriptionForm?: GraphQLTypes["ContentBlockCreateSubscriptionFormEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentBlockCreateIssueEntityRelationInput"]: {
		connect?: GraphQLTypes["IssueUniqueWhere"],
	create?: GraphQLTypes["IssueWithoutBlocksCreateInput"]
};
	["IssueWithoutBlocksCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	closed?: boolean,
	free?: boolean,
	title?: string,
	subtitle?: string,
	year?: number,
	issue?: number,
	publishedSince?: GraphQLTypes["Date"],
	publishedUntil?: GraphQLTypes["Date"],
	publishDigital?: GraphQLTypes["DateTime"],
	mobileAppsKey?: string,
	url?: GraphQLTypes["IssueCreateUrlEntityRelationInput"],
	articles?: Array<GraphQLTypes["IssueCreateArticlesEntityRelationInput"]>,
	kind?: GraphQLTypes["IssueKind"],
	notificationTitle?: string,
	notificationMessage?: string,
	pdf?: GraphQLTypes["IssueCreatePdfEntityRelationInput"],
	printBuy?: boolean,
	printText?: string,
	coverPhoto?: GraphQLTypes["IssueCreateCoverPhotoEntityRelationInput"],
	printTarget?: GraphQLTypes["IssueCreatePrintTargetEntityRelationInput"],
	backgroundPhoto?: GraphQLTypes["IssueCreateBackgroundPhotoEntityRelationInput"],
	legacyId?: string,
	_dummy_field_?: boolean
};
	["IssueCreateUrlEntityRelationInput"]: {
		connect?: GraphQLTypes["UrlUniqueWhere"],
	create?: GraphQLTypes["UrlWithoutIssueCreateInput"]
};
	["UrlWithoutIssueCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	article?: GraphQLTypes["UrlCreateArticleEntityRelationInput"],
	author?: GraphQLTypes["UrlCreateAuthorEntityRelationInput"],
	page?: GraphQLTypes["UrlCreatePageEntityRelationInput"],
	category?: GraphQLTypes["UrlCreateCategoryEntityRelationInput"],
	tag?: GraphQLTypes["UrlCreateTagEntityRelationInput"],
	redirect?: string,
	_dummy_field_?: boolean
};
	["UrlCreatePageEntityRelationInput"]: {
		connect?: GraphQLTypes["PageUniqueWhere"],
	create?: GraphQLTypes["PageWithoutUrlCreateInput"]
};
	["PageWithoutUrlCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	publishAt?: GraphQLTypes["DateTime"],
	createdAt?: GraphQLTypes["DateTime"],
	template?: GraphQLTypes["PageTemplate"],
	content?: GraphQLTypes["PageCreateContentEntityRelationInput"],
	seo?: GraphQLTypes["PageCreateSeoEntityRelationInput"],
	subscriptionValidity?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["PageCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["PageCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoWithoutPageCreateInput"]
};
	["SeoWithoutPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	twCard?: GraphQLTypes["SeoTwCard"],
	ogImage?: GraphQLTypes["SeoCreateOgImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SeoCreateOgImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUseUniqueWhere"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["UrlCreateCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["CategoryUniqueWhere"],
	create?: GraphQLTypes["CategoryWithoutUrlCreateInput"]
};
	["CategoryWithoutUrlCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	articleCategory?: Array<GraphQLTypes["CategoryCreateArticleCategoryEntityRelationInput"]>,
	legacyId?: string,
	_dummy_field_?: boolean
};
	["CategoryCreateArticleCategoryEntityRelationInput"]: {
		connect?: GraphQLTypes["ArticleCategoryUniqueWhere"],
	create?: GraphQLTypes["ArticleCategoryWithoutCategoryCreateInput"],
	alias?: string
};
	["ArticleCategoryWithoutCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	article?: GraphQLTypes["ArticleCategoryCreateArticleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArticleCategoryCreateArticleEntityRelationInput"]: {
		connect?: GraphQLTypes["ArticleUniqueWhere"],
	create?: GraphQLTypes["ArticleWithoutCategoriesCreateInput"]
};
	["ArticleWithoutCategoriesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	url?: GraphQLTypes["ArticleCreateUrlEntityRelationInput"],
	authors?: Array<GraphQLTypes["ArticleCreateAuthorsEntityRelationInput"]>,
	hideInMostRead?: boolean,
	hideAds?: boolean,
	state?: GraphQLTypes["ArticleState"],
	locked?: boolean,
	publishAt?: GraphQLTypes["DateTime"],
	template?: GraphQLTypes["Template"],
	subtitle?: GraphQLTypes["ArticleCreateSubtitleEntityRelationInput"],
	content?: GraphQLTypes["ArticleCreateContentEntityRelationInput"],
	coverPhoto?: GraphQLTypes["ArticleCreateCoverPhotoEntityRelationInput"],
	titleAlignment?: GraphQLTypes["ArticleTitleAlignment"],
	tagline?: string,
	createdAt?: GraphQLTypes["DateTime"],
	previewContent?: GraphQLTypes["ArticleCreatePreviewContentEntityRelationInput"],
	audio?: GraphQLTypes["ArticleCreateAudioEntityRelationInput"],
	issues?: Array<GraphQLTypes["ArticleCreateIssuesEntityRelationInput"]>,
	contentBlocks?: Array<GraphQLTypes["ArticleCreateContentBlocksEntityRelationInput"]>,
	unlocked?: Array<GraphQLTypes["ArticleCreateUnlockedEntityRelationInput"]>,
	coverPhotoVertical?: GraphQLTypes["ArticleCreateCoverPhotoVerticalEntityRelationInput"],
	legacyId?: string,
	tags?: Array<GraphQLTypes["ArticleCreateTagsEntityRelationInput"]>,
	isHistory?: boolean,
	historyTags?: Array<GraphQLTypes["ArticleCreateHistoryTagsEntityRelationInput"]>,
	historyPeriods?: Array<GraphQLTypes["ArticleCreateHistoryPeriodsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ArticleCreateIssuesEntityRelationInput"]: {
		connect?: GraphQLTypes["IssueArticleUniqueWhere"],
	create?: GraphQLTypes["IssueArticleWithoutArticleCreateInput"],
	alias?: string
};
	["IssueArticleWithoutArticleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	issue?: GraphQLTypes["IssueArticleCreateIssueEntityRelationInput"],
	order?: number,
	_dummy_field_?: boolean
};
	["IssueArticleCreateIssueEntityRelationInput"]: {
		connect?: GraphQLTypes["IssueUniqueWhere"],
	create?: GraphQLTypes["IssueWithoutArticlesCreateInput"]
};
	["IssueWithoutArticlesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	closed?: boolean,
	free?: boolean,
	title?: string,
	subtitle?: string,
	year?: number,
	issue?: number,
	publishedSince?: GraphQLTypes["Date"],
	publishedUntil?: GraphQLTypes["Date"],
	publishDigital?: GraphQLTypes["DateTime"],
	mobileAppsKey?: string,
	url?: GraphQLTypes["IssueCreateUrlEntityRelationInput"],
	kind?: GraphQLTypes["IssueKind"],
	notificationTitle?: string,
	notificationMessage?: string,
	pdf?: GraphQLTypes["IssueCreatePdfEntityRelationInput"],
	printBuy?: boolean,
	printText?: string,
	blocks?: Array<GraphQLTypes["IssueCreateBlocksEntityRelationInput"]>,
	coverPhoto?: GraphQLTypes["IssueCreateCoverPhotoEntityRelationInput"],
	printTarget?: GraphQLTypes["IssueCreatePrintTargetEntityRelationInput"],
	backgroundPhoto?: GraphQLTypes["IssueCreateBackgroundPhotoEntityRelationInput"],
	legacyId?: string,
	_dummy_field_?: boolean
};
	["IssueCreatePdfEntityRelationInput"]: {
		connect?: GraphQLTypes["FileUseUniqueWhere"],
	create?: GraphQLTypes["FileUseCreateInput"]
};
	["FileUseCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	file?: GraphQLTypes["FileUseCreateFileEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FileUseCreateFileEntityRelationInput"]: {
		connect?: GraphQLTypes["FileUniqueWhere"],
	create?: GraphQLTypes["FileWithoutUsesCreateInput"]
};
	["FileUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	uses?: GraphQLTypes["FileUseUniqueWhere"]
};
	["FileWithoutUsesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	_dummy_field_?: boolean
};
	["IssueCreateBlocksEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentBlockUniqueWhere"],
	create?: GraphQLTypes["ContentBlockWithoutIssueCreateInput"],
	alias?: string
};
	["ContentBlockWithoutIssueCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	type?: GraphQLTypes["ContentBlockType"],
	youtubeId?: string,
	text?: string,
	targetLabel?: string,
	target?: GraphQLTypes["ContentBlockCreateTargetEntityRelationInput"],
	articles?: Array<GraphQLTypes["ContentBlockCreateArticlesEntityRelationInput"]>,
	subscriptionForm?: GraphQLTypes["ContentBlockCreateSubscriptionFormEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentBlockCreateTargetEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["ContentBlockCreateArticlesEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentArticleUniqueWhere"],
	create?: GraphQLTypes["ContentArticleWithoutContentBlockCreateInput"],
	alias?: string
};
	["ContentArticleWithoutContentBlockCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	article?: GraphQLTypes["ContentArticleCreateArticleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentArticleCreateArticleEntityRelationInput"]: {
		connect?: GraphQLTypes["ArticleUniqueWhere"],
	create?: GraphQLTypes["ArticleWithoutContentBlocksCreateInput"]
};
	["ArticleWithoutContentBlocksCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	url?: GraphQLTypes["ArticleCreateUrlEntityRelationInput"],
	authors?: Array<GraphQLTypes["ArticleCreateAuthorsEntityRelationInput"]>,
	hideInMostRead?: boolean,
	hideAds?: boolean,
	state?: GraphQLTypes["ArticleState"],
	locked?: boolean,
	publishAt?: GraphQLTypes["DateTime"],
	template?: GraphQLTypes["Template"],
	subtitle?: GraphQLTypes["ArticleCreateSubtitleEntityRelationInput"],
	content?: GraphQLTypes["ArticleCreateContentEntityRelationInput"],
	coverPhoto?: GraphQLTypes["ArticleCreateCoverPhotoEntityRelationInput"],
	titleAlignment?: GraphQLTypes["ArticleTitleAlignment"],
	tagline?: string,
	createdAt?: GraphQLTypes["DateTime"],
	previewContent?: GraphQLTypes["ArticleCreatePreviewContentEntityRelationInput"],
	audio?: GraphQLTypes["ArticleCreateAudioEntityRelationInput"],
	categories?: Array<GraphQLTypes["ArticleCreateCategoriesEntityRelationInput"]>,
	issues?: Array<GraphQLTypes["ArticleCreateIssuesEntityRelationInput"]>,
	unlocked?: Array<GraphQLTypes["ArticleCreateUnlockedEntityRelationInput"]>,
	coverPhotoVertical?: GraphQLTypes["ArticleCreateCoverPhotoVerticalEntityRelationInput"],
	legacyId?: string,
	tags?: Array<GraphQLTypes["ArticleCreateTagsEntityRelationInput"]>,
	isHistory?: boolean,
	historyTags?: Array<GraphQLTypes["ArticleCreateHistoryTagsEntityRelationInput"]>,
	historyPeriods?: Array<GraphQLTypes["ArticleCreateHistoryPeriodsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ArticleCreateUnlockedEntityRelationInput"]: {
		connect?: GraphQLTypes["UnlockedArticleUniqueWhere"],
	create?: GraphQLTypes["UnlockedArticleWithoutArticleCreateInput"],
	alias?: string
};
	["UnlockedArticleWithoutArticleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	createdAt?: GraphQLTypes["DateTime"],
	code?: string,
	views?: number,
	user?: GraphQLTypes["UnlockedArticleCreateUserEntityRelationInput"],
	_dummy_field_?: boolean
};
	["UnlockedArticleCreateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"],
	create?: GraphQLTypes["UserWithoutUnlockedArticlesCreateInput"]
};
	["UserWithoutUnlockedArticlesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	ihnedId?: string,
	email?: string,
	authors?: Array<GraphQLTypes["UserCreateAuthorsEntityRelationInput"]>,
	appReviews?: Array<GraphQLTypes["UserCreateAppReviewsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["UserCreateAuthorsEntityRelationInput"]: {
		connect?: GraphQLTypes["AuthorUniqueWhere"],
	create?: GraphQLTypes["AuthorWithoutUsersCreateInput"],
	alias?: string
};
	["AuthorWithoutUsersCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	position?: string,
	twitterHandle?: string,
	facebookId?: string,
	email?: string,
	photographer?: boolean,
	order?: number,
	about?: GraphQLTypes["AuthorCreateAboutEntityRelationInput"],
	topArticles?: Array<GraphQLTypes["AuthorCreateTopArticlesEntityRelationInput"]>,
	startOfCooperation?: GraphQLTypes["Date"],
	photo?: GraphQLTypes["AuthorCreatePhotoEntityRelationInput"],
	illustration?: GraphQLTypes["AuthorCreateIllustrationEntityRelationInput"],
	legacyId?: string,
	category?: GraphQLTypes["AuthorCategory"],
	url?: GraphQLTypes["AuthorCreateUrlEntityRelationInput"],
	instagramUsername?: string,
	_dummy_field_?: boolean
};
	["AuthorCreatePhotoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUseUniqueWhere"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["AuthorCreateIllustrationEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUseUniqueWhere"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["AuthorCreateUrlEntityRelationInput"]: {
		connect?: GraphQLTypes["UrlUniqueWhere"],
	create?: GraphQLTypes["UrlWithoutAuthorCreateInput"]
};
	["UrlWithoutAuthorCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	article?: GraphQLTypes["UrlCreateArticleEntityRelationInput"],
	issue?: GraphQLTypes["UrlCreateIssueEntityRelationInput"],
	page?: GraphQLTypes["UrlCreatePageEntityRelationInput"],
	category?: GraphQLTypes["UrlCreateCategoryEntityRelationInput"],
	tag?: GraphQLTypes["UrlCreateTagEntityRelationInput"],
	redirect?: string,
	_dummy_field_?: boolean
};
	["UrlCreateTagEntityRelationInput"]: {
		connect?: GraphQLTypes["TagUniqueWhere"],
	create?: GraphQLTypes["TagWithoutUrlCreateInput"]
};
	["TagWithoutUrlCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	useAsTagline?: boolean,
	articleTag?: Array<GraphQLTypes["TagCreateArticleTagEntityRelationInput"]>,
	order?: string,
	legacyId?: string,
	_dummy_field_?: boolean
};
	["TagCreateArticleTagEntityRelationInput"]: {
		connect?: GraphQLTypes["ArticleTagUniqueWhere"],
	create?: GraphQLTypes["ArticleTagWithoutTagCreateInput"],
	alias?: string
};
	["ArticleTagWithoutTagCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	article?: GraphQLTypes["ArticleTagCreateArticleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArticleTagCreateArticleEntityRelationInput"]: {
		connect?: GraphQLTypes["ArticleUniqueWhere"],
	create?: GraphQLTypes["ArticleWithoutTagsCreateInput"]
};
	["ArticleWithoutTagsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	url?: GraphQLTypes["ArticleCreateUrlEntityRelationInput"],
	authors?: Array<GraphQLTypes["ArticleCreateAuthorsEntityRelationInput"]>,
	hideInMostRead?: boolean,
	hideAds?: boolean,
	state?: GraphQLTypes["ArticleState"],
	locked?: boolean,
	publishAt?: GraphQLTypes["DateTime"],
	template?: GraphQLTypes["Template"],
	subtitle?: GraphQLTypes["ArticleCreateSubtitleEntityRelationInput"],
	content?: GraphQLTypes["ArticleCreateContentEntityRelationInput"],
	coverPhoto?: GraphQLTypes["ArticleCreateCoverPhotoEntityRelationInput"],
	titleAlignment?: GraphQLTypes["ArticleTitleAlignment"],
	tagline?: string,
	createdAt?: GraphQLTypes["DateTime"],
	previewContent?: GraphQLTypes["ArticleCreatePreviewContentEntityRelationInput"],
	audio?: GraphQLTypes["ArticleCreateAudioEntityRelationInput"],
	categories?: Array<GraphQLTypes["ArticleCreateCategoriesEntityRelationInput"]>,
	issues?: Array<GraphQLTypes["ArticleCreateIssuesEntityRelationInput"]>,
	contentBlocks?: Array<GraphQLTypes["ArticleCreateContentBlocksEntityRelationInput"]>,
	unlocked?: Array<GraphQLTypes["ArticleCreateUnlockedEntityRelationInput"]>,
	coverPhotoVertical?: GraphQLTypes["ArticleCreateCoverPhotoVerticalEntityRelationInput"],
	legacyId?: string,
	isHistory?: boolean,
	historyTags?: Array<GraphQLTypes["ArticleCreateHistoryTagsEntityRelationInput"]>,
	historyPeriods?: Array<GraphQLTypes["ArticleCreateHistoryPeriodsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ArticleCreateCoverPhotoVerticalEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUseUniqueWhere"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["ArticleCreateHistoryTagsEntityRelationInput"]: {
		connect?: GraphQLTypes["ArticleHistoryTagUniqueWhere"],
	create?: GraphQLTypes["ArticleHistoryTagWithoutArticleCreateInput"],
	alias?: string
};
	["ArticleHistoryTagWithoutArticleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	historyTag?: GraphQLTypes["ArticleHistoryTagCreateHistoryTagEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArticleHistoryTagCreateHistoryTagEntityRelationInput"]: {
		connect?: GraphQLTypes["HistoryTagUniqueWhere"],
	create?: GraphQLTypes["HistoryTagWithoutArticleHistoryTagCreateInput"]
};
	["HistoryTagWithoutArticleHistoryTagCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	slug?: string,
	_dummy_field_?: boolean
};
	["ArticleCreateHistoryPeriodsEntityRelationInput"]: {
		connect?: GraphQLTypes["ArticleHistoryPeriodUniqueWhere"],
	create?: GraphQLTypes["ArticleHistoryPeriodWithoutArticleCreateInput"],
	alias?: string
};
	["ArticleHistoryPeriodWithoutArticleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	historyPeriod?: GraphQLTypes["ArticleHistoryPeriodCreateHistoryPeriodEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArticleHistoryPeriodCreateHistoryPeriodEntityRelationInput"]: {
		connect?: GraphQLTypes["HistoryPeriodUniqueWhere"],
	create?: GraphQLTypes["HistoryPeriodWithoutArticleHistoryPeriodCreateInput"]
};
	["HistoryPeriodWithoutArticleHistoryPeriodCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	slug?: string,
	order?: number,
	cover?: GraphQLTypes["HistoryPeriodCreateCoverEntityRelationInput"],
	seo?: GraphQLTypes["HistoryPeriodCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HistoryPeriodCreateCoverEntityRelationInput"]: {
		connect?: GraphQLTypes["HistoryCoverUniqueWhere"],
	create?: GraphQLTypes["HistoryCoverCreateInput"]
};
	["HistoryCoverCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	tileParagraph?: string,
	coverImage?: GraphQLTypes["HistoryCoverCreateCoverImageEntityRelationInput"],
	tileImage?: GraphQLTypes["HistoryCoverCreateTileImageEntityRelationInput"],
	mobileImage?: GraphQLTypes["HistoryCoverCreateMobileImageEntityRelationInput"],
	leadContent?: GraphQLTypes["HistoryCoverCreateLeadContentEntityRelationInput"],
	annotations?: GraphQLTypes["HistoryCoverCreateAnnotationsEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HistoryCoverCreateCoverImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUseUniqueWhere"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["HistoryCoverCreateTileImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUseUniqueWhere"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["HistoryCoverCreateMobileImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUseUniqueWhere"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["HistoryCoverCreateLeadContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["HistoryCoverCreateAnnotationsEntityRelationInput"]: {
		connect?: GraphQLTypes["HistoryTextListUniqueWhere"],
	create?: GraphQLTypes["HistoryTextListCreateInput"]
};
	["HistoryTextListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["HistoryTextListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["HistoryTextListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["HistoryTextItemUniqueWhere"],
	create?: GraphQLTypes["HistoryTextItemWithoutListCreateInput"],
	alias?: string
};
	["HistoryTextItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	key?: string,
	text?: string,
	image?: GraphQLTypes["HistoryTextItemCreateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HistoryTextItemCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUseUniqueWhere"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["HistoryPeriodCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["SeoCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	page?: GraphQLTypes["SeoCreatePageEntityRelationInput"],
	twCard?: GraphQLTypes["SeoTwCard"],
	ogImage?: GraphQLTypes["SeoCreateOgImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SeoCreatePageEntityRelationInput"]: {
		connect?: GraphQLTypes["PageUniqueWhere"],
	create?: GraphQLTypes["PageWithoutSeoCreateInput"]
};
	["PageWithoutSeoCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	publishAt?: GraphQLTypes["DateTime"],
	createdAt?: GraphQLTypes["DateTime"],
	template?: GraphQLTypes["PageTemplate"],
	url?: GraphQLTypes["PageCreateUrlEntityRelationInput"],
	content?: GraphQLTypes["PageCreateContentEntityRelationInput"],
	subscriptionValidity?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["PageCreateUrlEntityRelationInput"]: {
		connect?: GraphQLTypes["UrlUniqueWhere"],
	create?: GraphQLTypes["UrlWithoutPageCreateInput"]
};
	["UrlWithoutPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	article?: GraphQLTypes["UrlCreateArticleEntityRelationInput"],
	author?: GraphQLTypes["UrlCreateAuthorEntityRelationInput"],
	issue?: GraphQLTypes["UrlCreateIssueEntityRelationInput"],
	category?: GraphQLTypes["UrlCreateCategoryEntityRelationInput"],
	tag?: GraphQLTypes["UrlCreateTagEntityRelationInput"],
	redirect?: string,
	_dummy_field_?: boolean
};
	["UserCreateAppReviewsEntityRelationInput"]: {
		connect?: GraphQLTypes["AppReviewUniqueWhere"],
	create?: GraphQLTypes["AppReviewWithoutUserCreateInput"],
	alias?: string
};
	["AppReviewWithoutUserCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	done?: boolean,
	deviceId?: string,
	createdAt?: GraphQLTypes["DateTime"],
	rating?: number,
	note?: string,
	_dummy_field_?: boolean
};
	["ArticleCreateTagsEntityRelationInput"]: {
		connect?: GraphQLTypes["ArticleTagUniqueWhere"],
	create?: GraphQLTypes["ArticleTagWithoutArticleCreateInput"],
	alias?: string
};
	["ArticleTagWithoutArticleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	tag?: GraphQLTypes["ArticleTagCreateTagEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArticleTagCreateTagEntityRelationInput"]: {
		connect?: GraphQLTypes["TagUniqueWhere"],
	create?: GraphQLTypes["TagWithoutArticleTagCreateInput"]
};
	["TagWithoutArticleTagCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	useAsTagline?: boolean,
	url?: GraphQLTypes["TagCreateUrlEntityRelationInput"],
	order?: string,
	legacyId?: string,
	_dummy_field_?: boolean
};
	["TagCreateUrlEntityRelationInput"]: {
		connect?: GraphQLTypes["UrlUniqueWhere"],
	create?: GraphQLTypes["UrlWithoutTagCreateInput"]
};
	["UrlWithoutTagCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	article?: GraphQLTypes["UrlCreateArticleEntityRelationInput"],
	author?: GraphQLTypes["UrlCreateAuthorEntityRelationInput"],
	issue?: GraphQLTypes["UrlCreateIssueEntityRelationInput"],
	page?: GraphQLTypes["UrlCreatePageEntityRelationInput"],
	category?: GraphQLTypes["UrlCreateCategoryEntityRelationInput"],
	redirect?: string,
	_dummy_field_?: boolean
};
	["ContentBlockCreateSubscriptionFormEntityRelationInput"]: {
		connect?: GraphQLTypes["SubscriptionFormUniqueWhere"],
	create?: GraphQLTypes["SubscriptionFormWithoutContentBlockCreateInput"]
};
	["SubscriptionFormUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	sections?: GraphQLTypes["SubscriptionFormSectionUniqueWhere"],
	contentBlock?: GraphQLTypes["ContentBlockUniqueWhere"],
	products?: GraphQLTypes["ProductUniqueWhere"],
	contentReferences?: GraphQLTypes["ContentReferenceUniqueWhere"]
};
	["SubscriptionFormSectionUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	inputs?: GraphQLTypes["SubscriptionFormInputUniqueWhere"]
};
	["ProductUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["SubscriptionFormWithoutContentBlockCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	code?: string,
	createdAt?: GraphQLTypes["DateTime"],
	sections?: Array<GraphQLTypes["SubscriptionFormCreateSectionsEntityRelationInput"]>,
	products?: Array<GraphQLTypes["SubscriptionFormCreateProductsEntityRelationInput"]>,
	contentReferences?: Array<GraphQLTypes["SubscriptionFormCreateContentReferencesEntityRelationInput"]>,
	validity?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["SubscriptionFormCreateSectionsEntityRelationInput"]: {
		connect?: GraphQLTypes["SubscriptionFormSectionUniqueWhere"],
	create?: GraphQLTypes["SubscriptionFormSectionWithoutFormCreateInput"],
	alias?: string
};
	["SubscriptionFormSectionWithoutFormCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	title?: string,
	inputs?: Array<GraphQLTypes["SubscriptionFormSectionCreateInputsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["SubscriptionFormSectionCreateInputsEntityRelationInput"]: {
		connect?: GraphQLTypes["SubscriptionFormInputUniqueWhere"],
	create?: GraphQLTypes["SubscriptionFormInputWithoutSectionCreateInput"],
	alias?: string
};
	["SubscriptionFormInputWithoutSectionCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	type?: GraphQLTypes["SubscriptionFormInputType"],
	image?: GraphQLTypes["SubscriptionFormInputCreateImageEntityRelationInput"],
	options?: Array<GraphQLTypes["SubscriptionFormInputCreateOptionsEntityRelationInput"]>,
	description?: GraphQLTypes["SubscriptionFormInputCreateDescriptionEntityRelationInput"],
	required?: boolean,
	_dummy_field_?: boolean
};
	["SubscriptionFormInputCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUseUniqueWhere"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["SubscriptionFormInputCreateOptionsEntityRelationInput"]: {
		connect?: GraphQLTypes["SubscriptionFormOptionUniqueWhere"],
	create?: GraphQLTypes["SubscriptionFormOptionWithoutFormInputCreateInput"],
	alias?: string
};
	["SubscriptionFormOptionWithoutFormInputCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	hasProductId?: boolean,
	order?: number,
	label?: string,
	priceTag?: string,
	priceTagWithDiscount?: string,
	products?: Array<GraphQLTypes["SubscriptionFormOptionCreateProductsEntityRelationInput"]>,
	value?: string,
	internalLabel?: string,
	_dummy_field_?: boolean
};
	["SubscriptionFormOptionCreateProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductWithoutFormOptionsCreateInput"],
	alias?: string
};
	["ProductWithoutFormOptionsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	price?: number,
	type?: GraphQLTypes["Types"],
	form?: GraphQLTypes["ProductCreateFormEntityRelationInput"],
	productId?: string,
	_dummy_field_?: boolean
};
	["ProductCreateFormEntityRelationInput"]: {
		connect?: GraphQLTypes["SubscriptionFormUniqueWhere"],
	create?: GraphQLTypes["SubscriptionFormWithoutProductsCreateInput"]
};
	["SubscriptionFormWithoutProductsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	code?: string,
	createdAt?: GraphQLTypes["DateTime"],
	sections?: Array<GraphQLTypes["SubscriptionFormCreateSectionsEntityRelationInput"]>,
	contentBlock?: Array<GraphQLTypes["SubscriptionFormCreateContentBlockEntityRelationInput"]>,
	contentReferences?: Array<GraphQLTypes["SubscriptionFormCreateContentReferencesEntityRelationInput"]>,
	validity?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["SubscriptionFormCreateContentBlockEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentBlockUniqueWhere"],
	create?: GraphQLTypes["ContentBlockWithoutSubscriptionFormCreateInput"],
	alias?: string
};
	["ContentBlockWithoutSubscriptionFormCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	type?: GraphQLTypes["ContentBlockType"],
	youtubeId?: string,
	text?: string,
	targetLabel?: string,
	issue?: GraphQLTypes["ContentBlockCreateIssueEntityRelationInput"],
	target?: GraphQLTypes["ContentBlockCreateTargetEntityRelationInput"],
	articles?: Array<GraphQLTypes["ContentBlockCreateArticlesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["SubscriptionFormCreateContentReferencesEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	create?: GraphQLTypes["ContentReferenceWithoutSubscriptionFormCreateInput"],
	alias?: string
};
	["ContentReferenceWithoutSubscriptionFormCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ContentReferenceType"],
	contentPart?: GraphQLTypes["ContentReferenceCreateContentPartEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	variant?: GraphQLTypes["ContentReferenceVariant"],
	color?: string,
	embed?: GraphQLTypes["ContentReferenceCreateEmbedEntityRelationInput"],
	article?: GraphQLTypes["ContentReferenceCreateArticleEntityRelationInput"],
	audio?: GraphQLTypes["ContentReferenceCreateAudioEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"],
	images?: Array<GraphQLTypes["ContentReferenceCreateImagesEntityRelationInput"]>,
	pollAnswer?: GraphQLTypes["ContentReferenceCreatePollAnswerEntityRelationInput"],
	listicle?: Array<GraphQLTypes["ContentReferenceCreateListicleEntityRelationInput"]>,
	faq?: Array<GraphQLTypes["ContentReferenceCreateFaqEntityRelationInput"]>,
	links?: Array<GraphQLTypes["ContentReferenceCreateLinksEntityRelationInput"]>,
	awards?: Array<GraphQLTypes["ContentReferenceCreateAwardsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ContentReferenceCreateReviewsEntityRelationInput"]>,
	target?: GraphQLTypes["ContentReferenceCreateTargetEntityRelationInput"],
	buttons?: Array<GraphQLTypes["ContentReferenceCreateButtonsEntityRelationInput"]>,
	sharedContent?: GraphQLTypes["ContentReferenceCreateSharedContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceCreateContentPartEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentPartUniqueWhere"],
	create?: GraphQLTypes["ContentPartWithoutReferencesCreateInput"]
};
	["ContentPartWithoutReferencesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	json?: string,
	content?: GraphQLTypes["ContentPartCreateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentPartCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentWithoutPartsCreateInput"]
};
	["ContentWithoutPartsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["ContentReferenceCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUseUniqueWhere"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["ContentReferenceCreateImagesEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageContentUniqueWhere"],
	create?: GraphQLTypes["ImageContentWithoutContentReferenceCreateInput"],
	alias?: string
};
	["ImageContentUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ImageContentWithoutContentReferenceCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	image?: GraphQLTypes["ImageContentCreateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ImageContentCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUseUniqueWhere"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["ContentReferenceCreatePollAnswerEntityRelationInput"]: {
		connect?: GraphQLTypes["PollAnswerUniqueWhere"],
	create?: GraphQLTypes["PollAnswerCreateInput"]
};
	["PollAnswerCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	authorName?: string,
	authorPosition?: string,
	text?: string,
	authorImage?: GraphQLTypes["PollAnswerCreateAuthorImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PollAnswerCreateAuthorImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUseUniqueWhere"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["ContentReferenceCreateListicleEntityRelationInput"]: {
		connect?: GraphQLTypes["ListicleUniqueWhere"],
	create?: GraphQLTypes["ListicleWithoutContentReferenceCreateInput"],
	alias?: string
};
	["ListicleWithoutContentReferenceCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	primaryText?: string,
	image?: GraphQLTypes["ListicleCreateImageEntityRelationInput"],
	target?: GraphQLTypes["ListicleCreateTargetEntityRelationInput"],
	content?: GraphQLTypes["ListicleCreateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ListicleCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUseUniqueWhere"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["ListicleCreateTargetEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["ListicleCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["ContentReferenceCreateFaqEntityRelationInput"]: {
		connect?: GraphQLTypes["FAQUniqueWhere"],
	create?: GraphQLTypes["FAQWithoutContentReferenceCreateInput"],
	alias?: string
};
	["FAQWithoutContentReferenceCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	answer?: string,
	question?: string,
	_dummy_field_?: boolean
};
	["ContentReferenceCreateLinksEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkContentUniqueWhere"],
	create?: GraphQLTypes["LinkContentWithoutContentReferenceCreateInput"],
	alias?: string
};
	["LinkContentWithoutContentReferenceCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	text?: string,
	target?: GraphQLTypes["LinkContentCreateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkContentCreateTargetEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["ContentReferenceCreateAwardsEntityRelationInput"]: {
		connect?: GraphQLTypes["AwardContentUniqueWhere"],
	create?: GraphQLTypes["AwardContentWithoutContentReferenceCreateInput"],
	alias?: string
};
	["AwardContentWithoutContentReferenceCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	image?: GraphQLTypes["AwardContentCreateImageEntityRelationInput"],
	target?: GraphQLTypes["AwardContentCreateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["AwardContentCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUseUniqueWhere"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["AwardContentCreateTargetEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["ContentReferenceCreateReviewsEntityRelationInput"]: {
		connect?: GraphQLTypes["ReviewContentUniqueWhere"],
	create?: GraphQLTypes["ReviewContentWithoutContentReferenceCreateInput"],
	alias?: string
};
	["ReviewContentWithoutContentReferenceCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	text?: string,
	_dummy_field_?: boolean
};
	["ContentReferenceCreateTargetEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["ContentReferenceCreateButtonsEntityRelationInput"]: {
		connect?: GraphQLTypes["ButtonUniqueWhere"],
	create?: GraphQLTypes["ButtonWithoutContentReferenceCreateInput"],
	alias?: string
};
	["ButtonWithoutContentReferenceCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	type?: GraphQLTypes["ButtonType"],
	label?: string,
	target?: GraphQLTypes["ButtonCreateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ButtonCreateTargetEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["ContentReferenceCreateSharedContentEntityRelationInput"]: {
		connect?: GraphQLTypes["SharedContentUniqueWhere"],
	create?: GraphQLTypes["SharedContentWithoutContentReferenceCreateInput"]
};
	["SharedContentUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	contentReference?: GraphQLTypes["ContentReferenceUniqueWhere"]
};
	["SharedContentWithoutContentReferenceCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	content?: GraphQLTypes["SharedContentCreateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SharedContentCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["SubscriptionFormInputCreateDescriptionEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["SubscriptionFormCreateProductsEntityRelationInput"]: {
		connect?: GraphQLTypes["ProductUniqueWhere"],
	create?: GraphQLTypes["ProductWithoutFormCreateInput"],
	alias?: string
};
	["ProductWithoutFormCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	price?: number,
	type?: GraphQLTypes["Types"],
	formOptions?: Array<GraphQLTypes["ProductCreateFormOptionsEntityRelationInput"]>,
	productId?: string,
	_dummy_field_?: boolean
};
	["ProductCreateFormOptionsEntityRelationInput"]: {
		connect?: GraphQLTypes["SubscriptionFormOptionUniqueWhere"],
	create?: GraphQLTypes["SubscriptionFormOptionWithoutProductsCreateInput"],
	alias?: string
};
	["SubscriptionFormOptionWithoutProductsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	hasProductId?: boolean,
	order?: number,
	label?: string,
	priceTag?: string,
	priceTagWithDiscount?: string,
	formInput?: GraphQLTypes["SubscriptionFormOptionCreateFormInputEntityRelationInput"],
	value?: string,
	internalLabel?: string,
	_dummy_field_?: boolean
};
	["SubscriptionFormOptionCreateFormInputEntityRelationInput"]: {
		connect?: GraphQLTypes["SubscriptionFormInputUniqueWhere"],
	create?: GraphQLTypes["SubscriptionFormInputWithoutOptionsCreateInput"]
};
	["SubscriptionFormInputWithoutOptionsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	type?: GraphQLTypes["SubscriptionFormInputType"],
	image?: GraphQLTypes["SubscriptionFormInputCreateImageEntityRelationInput"],
	section?: GraphQLTypes["SubscriptionFormInputCreateSectionEntityRelationInput"],
	description?: GraphQLTypes["SubscriptionFormInputCreateDescriptionEntityRelationInput"],
	required?: boolean,
	_dummy_field_?: boolean
};
	["SubscriptionFormInputCreateSectionEntityRelationInput"]: {
		connect?: GraphQLTypes["SubscriptionFormSectionUniqueWhere"],
	create?: GraphQLTypes["SubscriptionFormSectionWithoutInputsCreateInput"]
};
	["SubscriptionFormSectionWithoutInputsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	title?: string,
	form?: GraphQLTypes["SubscriptionFormSectionCreateFormEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SubscriptionFormSectionCreateFormEntityRelationInput"]: {
		connect?: GraphQLTypes["SubscriptionFormUniqueWhere"],
	create?: GraphQLTypes["SubscriptionFormWithoutSectionsCreateInput"]
};
	["SubscriptionFormWithoutSectionsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	code?: string,
	createdAt?: GraphQLTypes["DateTime"],
	contentBlock?: Array<GraphQLTypes["SubscriptionFormCreateContentBlockEntityRelationInput"]>,
	products?: Array<GraphQLTypes["SubscriptionFormCreateProductsEntityRelationInput"]>,
	contentReferences?: Array<GraphQLTypes["SubscriptionFormCreateContentReferencesEntityRelationInput"]>,
	validity?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["IssueCreateCoverPhotoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUseUniqueWhere"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["IssueCreatePrintTargetEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["IssueCreateBackgroundPhotoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUseUniqueWhere"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["ContentReferenceCreateSubscriptionFormEntityRelationInput"]: {
		connect?: GraphQLTypes["SubscriptionFormUniqueWhere"],
	create?: GraphQLTypes["SubscriptionFormWithoutContentReferencesCreateInput"]
};
	["SubscriptionFormWithoutContentReferencesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	code?: string,
	createdAt?: GraphQLTypes["DateTime"],
	sections?: Array<GraphQLTypes["SubscriptionFormCreateSectionsEntityRelationInput"]>,
	contentBlock?: Array<GraphQLTypes["SubscriptionFormCreateContentBlockEntityRelationInput"]>,
	products?: Array<GraphQLTypes["SubscriptionFormCreateProductsEntityRelationInput"]>,
	validity?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["ArticleUpdateInput"]: {
		title?: string,
	url?: GraphQLTypes["ArticleUpdateUrlEntityRelationInput"],
	authors?: Array<GraphQLTypes["ArticleUpdateAuthorsEntityRelationInput"]>,
	hideInMostRead?: boolean,
	hideAds?: boolean,
	state?: GraphQLTypes["ArticleState"],
	locked?: boolean,
	publishAt?: GraphQLTypes["DateTime"],
	template?: GraphQLTypes["Template"],
	subtitle?: GraphQLTypes["ArticleUpdateSubtitleEntityRelationInput"],
	content?: GraphQLTypes["ArticleUpdateContentEntityRelationInput"],
	coverPhoto?: GraphQLTypes["ArticleUpdateCoverPhotoEntityRelationInput"],
	titleAlignment?: GraphQLTypes["ArticleTitleAlignment"],
	tagline?: string,
	createdAt?: GraphQLTypes["DateTime"],
	previewContent?: GraphQLTypes["ArticleUpdatePreviewContentEntityRelationInput"],
	audio?: GraphQLTypes["ArticleUpdateAudioEntityRelationInput"],
	categories?: Array<GraphQLTypes["ArticleUpdateCategoriesEntityRelationInput"]>,
	issues?: Array<GraphQLTypes["ArticleUpdateIssuesEntityRelationInput"]>,
	contentBlocks?: Array<GraphQLTypes["ArticleUpdateContentBlocksEntityRelationInput"]>,
	unlocked?: Array<GraphQLTypes["ArticleUpdateUnlockedEntityRelationInput"]>,
	coverPhotoVertical?: GraphQLTypes["ArticleUpdateCoverPhotoVerticalEntityRelationInput"],
	legacyId?: string,
	tags?: Array<GraphQLTypes["ArticleUpdateTagsEntityRelationInput"]>,
	isHistory?: boolean,
	historyTags?: Array<GraphQLTypes["ArticleUpdateHistoryTagsEntityRelationInput"]>,
	historyPeriods?: Array<GraphQLTypes["ArticleUpdateHistoryPeriodsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ArticleUpdateUrlEntityRelationInput"]: {
		create?: GraphQLTypes["UrlWithoutArticleCreateInput"],
	update?: GraphQLTypes["UrlWithoutArticleUpdateInput"],
	upsert?: GraphQLTypes["ArticleUpsertUrlRelationInput"],
	connect?: GraphQLTypes["UrlUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["UrlWithoutArticleUpdateInput"]: {
		url?: string,
	author?: GraphQLTypes["UrlUpdateAuthorEntityRelationInput"],
	issue?: GraphQLTypes["UrlUpdateIssueEntityRelationInput"],
	page?: GraphQLTypes["UrlUpdatePageEntityRelationInput"],
	category?: GraphQLTypes["UrlUpdateCategoryEntityRelationInput"],
	tag?: GraphQLTypes["UrlUpdateTagEntityRelationInput"],
	redirect?: string,
	_dummy_field_?: boolean
};
	["UrlUpdateAuthorEntityRelationInput"]: {
		create?: GraphQLTypes["AuthorWithoutUrlCreateInput"],
	update?: GraphQLTypes["AuthorWithoutUrlUpdateInput"],
	upsert?: GraphQLTypes["UrlUpsertAuthorRelationInput"],
	connect?: GraphQLTypes["AuthorUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["AuthorWithoutUrlUpdateInput"]: {
		name?: string,
	position?: string,
	twitterHandle?: string,
	facebookId?: string,
	email?: string,
	photographer?: boolean,
	order?: number,
	about?: GraphQLTypes["AuthorUpdateAboutEntityRelationInput"],
	topArticles?: Array<GraphQLTypes["AuthorUpdateTopArticlesEntityRelationInput"]>,
	users?: Array<GraphQLTypes["AuthorUpdateUsersEntityRelationInput"]>,
	startOfCooperation?: GraphQLTypes["Date"],
	photo?: GraphQLTypes["AuthorUpdatePhotoEntityRelationInput"],
	illustration?: GraphQLTypes["AuthorUpdateIllustrationEntityRelationInput"],
	legacyId?: string,
	category?: GraphQLTypes["AuthorCategory"],
	instagramUsername?: string,
	_dummy_field_?: boolean
};
	["AuthorUpdateAboutEntityRelationInput"]: {
		create?: GraphQLTypes["ContentCreateInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["AuthorUpsertAboutRelationInput"],
	connect?: GraphQLTypes["ContentUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentUpdateInput"]: {
		parts?: Array<GraphQLTypes["ContentUpdatePartsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentUpdatePartsEntityRelationInput"]: {
		create?: GraphQLTypes["ContentPartWithoutContentCreateInput"],
	update?: GraphQLTypes["ContentUpdatePartsRelationInput"],
	upsert?: GraphQLTypes["ContentUpsertPartsRelationInput"],
	connect?: GraphQLTypes["ContentPartUniqueWhere"],
	disconnect?: GraphQLTypes["ContentPartUniqueWhere"],
	delete?: GraphQLTypes["ContentPartUniqueWhere"],
	alias?: string
};
	["ContentUpdatePartsRelationInput"]: {
		by?: GraphQLTypes["ContentPartUniqueWhere"],
	data?: GraphQLTypes["ContentPartWithoutContentUpdateInput"]
};
	["ContentPartWithoutContentUpdateInput"]: {
		order?: number,
	json?: string,
	references?: Array<GraphQLTypes["ContentPartUpdateReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentPartUpdateReferencesEntityRelationInput"]: {
		create?: GraphQLTypes["ContentReferenceWithoutContentPartCreateInput"],
	update?: GraphQLTypes["ContentPartUpdateReferencesRelationInput"],
	upsert?: GraphQLTypes["ContentPartUpsertReferencesRelationInput"],
	connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	disconnect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	delete?: GraphQLTypes["ContentReferenceUniqueWhere"],
	alias?: string
};
	["ContentPartUpdateReferencesRelationInput"]: {
		by?: GraphQLTypes["ContentReferenceUniqueWhere"],
	data?: GraphQLTypes["ContentReferenceWithoutContentPartUpdateInput"]
};
	["ContentReferenceWithoutContentPartUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"],
	primaryText?: string,
	secondaryText?: string,
	variant?: GraphQLTypes["ContentReferenceVariant"],
	color?: string,
	embed?: GraphQLTypes["ContentReferenceUpdateEmbedEntityRelationInput"],
	article?: GraphQLTypes["ContentReferenceUpdateArticleEntityRelationInput"],
	audio?: GraphQLTypes["ContentReferenceUpdateAudioEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"],
	images?: Array<GraphQLTypes["ContentReferenceUpdateImagesEntityRelationInput"]>,
	pollAnswer?: GraphQLTypes["ContentReferenceUpdatePollAnswerEntityRelationInput"],
	listicle?: Array<GraphQLTypes["ContentReferenceUpdateListicleEntityRelationInput"]>,
	faq?: Array<GraphQLTypes["ContentReferenceUpdateFaqEntityRelationInput"]>,
	links?: Array<GraphQLTypes["ContentReferenceUpdateLinksEntityRelationInput"]>,
	awards?: Array<GraphQLTypes["ContentReferenceUpdateAwardsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ContentReferenceUpdateReviewsEntityRelationInput"]>,
	target?: GraphQLTypes["ContentReferenceUpdateTargetEntityRelationInput"],
	subscriptionForm?: GraphQLTypes["ContentReferenceUpdateSubscriptionFormEntityRelationInput"],
	buttons?: Array<GraphQLTypes["ContentReferenceUpdateButtonsEntityRelationInput"]>,
	sharedContent?: GraphQLTypes["ContentReferenceUpdateSharedContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceUpdateEmbedEntityRelationInput"]: {
		create?: GraphQLTypes["EmbedCreateInput"],
	update?: GraphQLTypes["EmbedUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertEmbedRelationInput"],
	connect?: GraphQLTypes["EmbedUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["EmbedUpdateInput"]: {
		type?: GraphQLTypes["EmbedType"],
	youtubeId?: string,
	vimeoId?: string,
	spotifyId?: string,
	spotifyType?: string,
	soundCloudId?: string,
	_dummy_field_?: boolean
};
	["ContentReferenceUpsertEmbedRelationInput"]: {
		update?: GraphQLTypes["EmbedUpdateInput"],
	create?: GraphQLTypes["EmbedCreateInput"]
};
	["ContentReferenceUpdateArticleEntityRelationInput"]: {
		create?: GraphQLTypes["ArticleCreateInput"],
	update?: GraphQLTypes["ArticleUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertArticleRelationInput"],
	connect?: GraphQLTypes["ArticleUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentReferenceUpsertArticleRelationInput"]: {
		update?: GraphQLTypes["ArticleUpdateInput"],
	create?: GraphQLTypes["ArticleCreateInput"]
};
	["ContentReferenceUpdateAudioEntityRelationInput"]: {
		create?: GraphQLTypes["AudioUseCreateInput"],
	update?: GraphQLTypes["AudioUseUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertAudioRelationInput"],
	connect?: GraphQLTypes["AudioUseUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["AudioUseUpdateInput"]: {
		audio?: GraphQLTypes["AudioUseUpdateAudioEntityRelationInput"],
	_dummy_field_?: boolean
};
	["AudioUseUpdateAudioEntityRelationInput"]: {
		create?: GraphQLTypes["AudioWithoutUsesCreateInput"],
	update?: GraphQLTypes["AudioWithoutUsesUpdateInput"],
	upsert?: GraphQLTypes["AudioUseUpsertAudioRelationInput"],
	connect?: GraphQLTypes["AudioUniqueWhere"],
	delete?: boolean
};
	["AudioWithoutUsesUpdateInput"]: {
		url?: string,
	type?: string,
	author?: GraphQLTypes["AudioUpdateAuthorEntityRelationInput"],
	_dummy_field_?: boolean
};
	["AudioUpdateAuthorEntityRelationInput"]: {
		create?: GraphQLTypes["AuthorCreateInput"],
	update?: GraphQLTypes["AuthorUpdateInput"],
	upsert?: GraphQLTypes["AudioUpsertAuthorRelationInput"],
	connect?: GraphQLTypes["AuthorUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["AuthorUpdateInput"]: {
		name?: string,
	position?: string,
	twitterHandle?: string,
	facebookId?: string,
	email?: string,
	photographer?: boolean,
	order?: number,
	about?: GraphQLTypes["AuthorUpdateAboutEntityRelationInput"],
	topArticles?: Array<GraphQLTypes["AuthorUpdateTopArticlesEntityRelationInput"]>,
	users?: Array<GraphQLTypes["AuthorUpdateUsersEntityRelationInput"]>,
	startOfCooperation?: GraphQLTypes["Date"],
	photo?: GraphQLTypes["AuthorUpdatePhotoEntityRelationInput"],
	illustration?: GraphQLTypes["AuthorUpdateIllustrationEntityRelationInput"],
	legacyId?: string,
	category?: GraphQLTypes["AuthorCategory"],
	url?: GraphQLTypes["AuthorUpdateUrlEntityRelationInput"],
	instagramUsername?: string,
	_dummy_field_?: boolean
};
	["AuthorUpdateTopArticlesEntityRelationInput"]: {
		create?: GraphQLTypes["AuthorTopArticleWithoutAuthorCreateInput"],
	update?: GraphQLTypes["AuthorUpdateTopArticlesRelationInput"],
	upsert?: GraphQLTypes["AuthorUpsertTopArticlesRelationInput"],
	connect?: GraphQLTypes["AuthorTopArticleUniqueWhere"],
	disconnect?: GraphQLTypes["AuthorTopArticleUniqueWhere"],
	delete?: GraphQLTypes["AuthorTopArticleUniqueWhere"],
	alias?: string
};
	["AuthorUpdateTopArticlesRelationInput"]: {
		by?: GraphQLTypes["AuthorTopArticleUniqueWhere"],
	data?: GraphQLTypes["AuthorTopArticleWithoutAuthorUpdateInput"]
};
	["AuthorTopArticleWithoutAuthorUpdateInput"]: {
		order?: number,
	article?: GraphQLTypes["AuthorTopArticleUpdateArticleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["AuthorTopArticleUpdateArticleEntityRelationInput"]: {
		create?: GraphQLTypes["ArticleCreateInput"],
	update?: GraphQLTypes["ArticleUpdateInput"],
	upsert?: GraphQLTypes["AuthorTopArticleUpsertArticleRelationInput"],
	connect?: GraphQLTypes["ArticleUniqueWhere"],
	delete?: boolean
};
	["AuthorTopArticleUpsertArticleRelationInput"]: {
		update?: GraphQLTypes["ArticleUpdateInput"],
	create?: GraphQLTypes["ArticleCreateInput"]
};
	["AuthorUpsertTopArticlesRelationInput"]: {
		by?: GraphQLTypes["AuthorTopArticleUniqueWhere"],
	update?: GraphQLTypes["AuthorTopArticleWithoutAuthorUpdateInput"],
	create?: GraphQLTypes["AuthorTopArticleWithoutAuthorCreateInput"]
};
	["AuthorUpdateUsersEntityRelationInput"]: {
		create?: GraphQLTypes["UserWithoutAuthorsCreateInput"],
	update?: GraphQLTypes["AuthorUpdateUsersRelationInput"],
	upsert?: GraphQLTypes["AuthorUpsertUsersRelationInput"],
	connect?: GraphQLTypes["UserUniqueWhere"],
	disconnect?: GraphQLTypes["UserUniqueWhere"],
	delete?: GraphQLTypes["UserUniqueWhere"],
	alias?: string
};
	["AuthorUpdateUsersRelationInput"]: {
		by?: GraphQLTypes["UserUniqueWhere"],
	data?: GraphQLTypes["UserWithoutAuthorsUpdateInput"]
};
	["UserWithoutAuthorsUpdateInput"]: {
		ihnedId?: string,
	email?: string,
	unlockedArticles?: Array<GraphQLTypes["UserUpdateUnlockedArticlesEntityRelationInput"]>,
	appReviews?: Array<GraphQLTypes["UserUpdateAppReviewsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["UserUpdateUnlockedArticlesEntityRelationInput"]: {
		create?: GraphQLTypes["UnlockedArticleWithoutUserCreateInput"],
	update?: GraphQLTypes["UserUpdateUnlockedArticlesRelationInput"],
	upsert?: GraphQLTypes["UserUpsertUnlockedArticlesRelationInput"],
	connect?: GraphQLTypes["UnlockedArticleUniqueWhere"],
	disconnect?: GraphQLTypes["UnlockedArticleUniqueWhere"],
	delete?: GraphQLTypes["UnlockedArticleUniqueWhere"],
	alias?: string
};
	["UserUpdateUnlockedArticlesRelationInput"]: {
		by?: GraphQLTypes["UnlockedArticleUniqueWhere"],
	data?: GraphQLTypes["UnlockedArticleWithoutUserUpdateInput"]
};
	["UnlockedArticleWithoutUserUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"],
	code?: string,
	views?: number,
	article?: GraphQLTypes["UnlockedArticleUpdateArticleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["UnlockedArticleUpdateArticleEntityRelationInput"]: {
		create?: GraphQLTypes["ArticleWithoutUnlockedCreateInput"],
	update?: GraphQLTypes["ArticleWithoutUnlockedUpdateInput"],
	upsert?: GraphQLTypes["UnlockedArticleUpsertArticleRelationInput"],
	connect?: GraphQLTypes["ArticleUniqueWhere"],
	delete?: boolean
};
	["ArticleWithoutUnlockedUpdateInput"]: {
		title?: string,
	url?: GraphQLTypes["ArticleUpdateUrlEntityRelationInput"],
	authors?: Array<GraphQLTypes["ArticleUpdateAuthorsEntityRelationInput"]>,
	hideInMostRead?: boolean,
	hideAds?: boolean,
	state?: GraphQLTypes["ArticleState"],
	locked?: boolean,
	publishAt?: GraphQLTypes["DateTime"],
	template?: GraphQLTypes["Template"],
	subtitle?: GraphQLTypes["ArticleUpdateSubtitleEntityRelationInput"],
	content?: GraphQLTypes["ArticleUpdateContentEntityRelationInput"],
	coverPhoto?: GraphQLTypes["ArticleUpdateCoverPhotoEntityRelationInput"],
	titleAlignment?: GraphQLTypes["ArticleTitleAlignment"],
	tagline?: string,
	createdAt?: GraphQLTypes["DateTime"],
	previewContent?: GraphQLTypes["ArticleUpdatePreviewContentEntityRelationInput"],
	audio?: GraphQLTypes["ArticleUpdateAudioEntityRelationInput"],
	categories?: Array<GraphQLTypes["ArticleUpdateCategoriesEntityRelationInput"]>,
	issues?: Array<GraphQLTypes["ArticleUpdateIssuesEntityRelationInput"]>,
	contentBlocks?: Array<GraphQLTypes["ArticleUpdateContentBlocksEntityRelationInput"]>,
	coverPhotoVertical?: GraphQLTypes["ArticleUpdateCoverPhotoVerticalEntityRelationInput"],
	legacyId?: string,
	tags?: Array<GraphQLTypes["ArticleUpdateTagsEntityRelationInput"]>,
	isHistory?: boolean,
	historyTags?: Array<GraphQLTypes["ArticleUpdateHistoryTagsEntityRelationInput"]>,
	historyPeriods?: Array<GraphQLTypes["ArticleUpdateHistoryPeriodsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ArticleUpdateAuthorsEntityRelationInput"]: {
		create?: GraphQLTypes["ArticleAuthorWithoutArticleCreateInput"],
	update?: GraphQLTypes["ArticleUpdateAuthorsRelationInput"],
	upsert?: GraphQLTypes["ArticleUpsertAuthorsRelationInput"],
	connect?: GraphQLTypes["ArticleAuthorUniqueWhere"],
	disconnect?: GraphQLTypes["ArticleAuthorUniqueWhere"],
	delete?: GraphQLTypes["ArticleAuthorUniqueWhere"],
	alias?: string
};
	["ArticleUpdateAuthorsRelationInput"]: {
		by?: GraphQLTypes["ArticleAuthorUniqueWhere"],
	data?: GraphQLTypes["ArticleAuthorWithoutArticleUpdateInput"]
};
	["ArticleAuthorWithoutArticleUpdateInput"]: {
		order?: number,
	author?: GraphQLTypes["ArticleAuthorUpdateAuthorEntityRelationInput"],
	legacyStringAuthor?: GraphQLTypes["ArticleAuthorLegacyStringAuthor"],
	_dummy_field_?: boolean
};
	["ArticleAuthorUpdateAuthorEntityRelationInput"]: {
		create?: GraphQLTypes["AuthorCreateInput"],
	update?: GraphQLTypes["AuthorUpdateInput"],
	upsert?: GraphQLTypes["ArticleAuthorUpsertAuthorRelationInput"],
	connect?: GraphQLTypes["AuthorUniqueWhere"],
	delete?: boolean
};
	["ArticleAuthorUpsertAuthorRelationInput"]: {
		update?: GraphQLTypes["AuthorUpdateInput"],
	create?: GraphQLTypes["AuthorCreateInput"]
};
	["ArticleUpsertAuthorsRelationInput"]: {
		by?: GraphQLTypes["ArticleAuthorUniqueWhere"],
	update?: GraphQLTypes["ArticleAuthorWithoutArticleUpdateInput"],
	create?: GraphQLTypes["ArticleAuthorWithoutArticleCreateInput"]
};
	["ArticleUpdateSubtitleEntityRelationInput"]: {
		create?: GraphQLTypes["TextContentCreateInput"],
	update?: GraphQLTypes["TextContentUpdateInput"],
	upsert?: GraphQLTypes["ArticleUpsertSubtitleRelationInput"],
	connect?: GraphQLTypes["TextContentUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["TextContentUpdateInput"]: {
		parts?: Array<GraphQLTypes["TextContentUpdatePartsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TextContentUpdatePartsEntityRelationInput"]: {
		create?: GraphQLTypes["TextContentPartWithoutContentCreateInput"],
	update?: GraphQLTypes["TextContentUpdatePartsRelationInput"],
	upsert?: GraphQLTypes["TextContentUpsertPartsRelationInput"],
	connect?: GraphQLTypes["TextContentPartUniqueWhere"],
	disconnect?: GraphQLTypes["TextContentPartUniqueWhere"],
	delete?: GraphQLTypes["TextContentPartUniqueWhere"],
	alias?: string
};
	["TextContentUpdatePartsRelationInput"]: {
		by?: GraphQLTypes["TextContentPartUniqueWhere"],
	data?: GraphQLTypes["TextContentPartWithoutContentUpdateInput"]
};
	["TextContentPartWithoutContentUpdateInput"]: {
		order?: number,
	json?: string,
	references?: Array<GraphQLTypes["TextContentPartUpdateReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TextContentPartUpdateReferencesEntityRelationInput"]: {
		create?: GraphQLTypes["TextContentReferenceWithoutContentPartCreateInput"],
	update?: GraphQLTypes["TextContentPartUpdateReferencesRelationInput"],
	upsert?: GraphQLTypes["TextContentPartUpsertReferencesRelationInput"],
	connect?: GraphQLTypes["TextContentReferenceUniqueWhere"],
	disconnect?: GraphQLTypes["TextContentReferenceUniqueWhere"],
	delete?: GraphQLTypes["TextContentReferenceUniqueWhere"],
	alias?: string
};
	["TextContentPartUpdateReferencesRelationInput"]: {
		by?: GraphQLTypes["TextContentReferenceUniqueWhere"],
	data?: GraphQLTypes["TextContentReferenceWithoutContentPartUpdateInput"]
};
	["TextContentReferenceWithoutContentPartUpdateInput"]: {
		type?: GraphQLTypes["TextContentReferenceType"],
	target?: GraphQLTypes["TextContentReferenceUpdateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TextContentReferenceUpdateTargetEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["TextContentReferenceUpsertTargetRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkUpdateInput"]: {
		type?: GraphQLTypes["LinkType"],
	externalTarget?: string,
	internalTarget?: GraphQLTypes["LinkUpdateInternalTargetEntityRelationInput"],
	queryParameters?: string,
	_dummy_field_?: boolean
};
	["LinkUpdateInternalTargetEntityRelationInput"]: {
		create?: GraphQLTypes["UrlCreateInput"],
	update?: GraphQLTypes["UrlUpdateInput"],
	upsert?: GraphQLTypes["LinkUpsertInternalTargetRelationInput"],
	connect?: GraphQLTypes["UrlUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["UrlUpdateInput"]: {
		url?: string,
	article?: GraphQLTypes["UrlUpdateArticleEntityRelationInput"],
	author?: GraphQLTypes["UrlUpdateAuthorEntityRelationInput"],
	issue?: GraphQLTypes["UrlUpdateIssueEntityRelationInput"],
	page?: GraphQLTypes["UrlUpdatePageEntityRelationInput"],
	category?: GraphQLTypes["UrlUpdateCategoryEntityRelationInput"],
	tag?: GraphQLTypes["UrlUpdateTagEntityRelationInput"],
	redirect?: string,
	_dummy_field_?: boolean
};
	["UrlUpdateArticleEntityRelationInput"]: {
		create?: GraphQLTypes["ArticleWithoutUrlCreateInput"],
	update?: GraphQLTypes["ArticleWithoutUrlUpdateInput"],
	upsert?: GraphQLTypes["UrlUpsertArticleRelationInput"],
	connect?: GraphQLTypes["ArticleUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ArticleWithoutUrlUpdateInput"]: {
		title?: string,
	authors?: Array<GraphQLTypes["ArticleUpdateAuthorsEntityRelationInput"]>,
	hideInMostRead?: boolean,
	hideAds?: boolean,
	state?: GraphQLTypes["ArticleState"],
	locked?: boolean,
	publishAt?: GraphQLTypes["DateTime"],
	template?: GraphQLTypes["Template"],
	subtitle?: GraphQLTypes["ArticleUpdateSubtitleEntityRelationInput"],
	content?: GraphQLTypes["ArticleUpdateContentEntityRelationInput"],
	coverPhoto?: GraphQLTypes["ArticleUpdateCoverPhotoEntityRelationInput"],
	titleAlignment?: GraphQLTypes["ArticleTitleAlignment"],
	tagline?: string,
	createdAt?: GraphQLTypes["DateTime"],
	previewContent?: GraphQLTypes["ArticleUpdatePreviewContentEntityRelationInput"],
	audio?: GraphQLTypes["ArticleUpdateAudioEntityRelationInput"],
	categories?: Array<GraphQLTypes["ArticleUpdateCategoriesEntityRelationInput"]>,
	issues?: Array<GraphQLTypes["ArticleUpdateIssuesEntityRelationInput"]>,
	contentBlocks?: Array<GraphQLTypes["ArticleUpdateContentBlocksEntityRelationInput"]>,
	unlocked?: Array<GraphQLTypes["ArticleUpdateUnlockedEntityRelationInput"]>,
	coverPhotoVertical?: GraphQLTypes["ArticleUpdateCoverPhotoVerticalEntityRelationInput"],
	legacyId?: string,
	tags?: Array<GraphQLTypes["ArticleUpdateTagsEntityRelationInput"]>,
	isHistory?: boolean,
	historyTags?: Array<GraphQLTypes["ArticleUpdateHistoryTagsEntityRelationInput"]>,
	historyPeriods?: Array<GraphQLTypes["ArticleUpdateHistoryPeriodsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ArticleUpdateContentEntityRelationInput"]: {
		create?: GraphQLTypes["ContentCreateInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["ArticleUpsertContentRelationInput"],
	connect?: GraphQLTypes["ContentUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ArticleUpsertContentRelationInput"]: {
		update?: GraphQLTypes["ContentUpdateInput"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["ArticleUpdateCoverPhotoEntityRelationInput"]: {
		create?: GraphQLTypes["ImageUseCreateInput"],
	update?: GraphQLTypes["ImageUseUpdateInput"],
	upsert?: GraphQLTypes["ArticleUpsertCoverPhotoRelationInput"],
	connect?: GraphQLTypes["ImageUseUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ImageUseUpdateInput"]: {
		title?: string,
	image?: GraphQLTypes["ImageUseUpdateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ImageUseUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageWithoutUsesCreateInput"],
	update?: GraphQLTypes["ImageWithoutUsesUpdateInput"],
	upsert?: GraphQLTypes["ImageUseUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	delete?: boolean
};
	["ImageWithoutUsesUpdateInput"]: {
		url?: string,
	width?: number,
	height?: number,
	title?: string,
	text?: string,
	author?: GraphQLTypes["ImageUpdateAuthorEntityRelationInput"],
	tags?: Array<GraphQLTypes["ImageUpdateTagsEntityRelationInput"]>,
	align?: GraphQLTypes["ImageAlign"],
	legacyId?: string,
	_dummy_field_?: boolean
};
	["ImageUpdateAuthorEntityRelationInput"]: {
		create?: GraphQLTypes["AuthorCreateInput"],
	update?: GraphQLTypes["AuthorUpdateInput"],
	upsert?: GraphQLTypes["ImageUpsertAuthorRelationInput"],
	connect?: GraphQLTypes["AuthorUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ImageUpsertAuthorRelationInput"]: {
		update?: GraphQLTypes["AuthorUpdateInput"],
	create?: GraphQLTypes["AuthorCreateInput"]
};
	["ImageUpdateTagsEntityRelationInput"]: {
		create?: GraphQLTypes["ImageTagWithoutImagesCreateInput"],
	update?: GraphQLTypes["ImageUpdateTagsRelationInput"],
	upsert?: GraphQLTypes["ImageUpsertTagsRelationInput"],
	connect?: GraphQLTypes["ImageTagUniqueWhere"],
	disconnect?: GraphQLTypes["ImageTagUniqueWhere"],
	delete?: GraphQLTypes["ImageTagUniqueWhere"],
	alias?: string
};
	["ImageUpdateTagsRelationInput"]: {
		by?: GraphQLTypes["ImageTagUniqueWhere"],
	data?: GraphQLTypes["ImageTagWithoutImagesUpdateInput"]
};
	["ImageTagWithoutImagesUpdateInput"]: {
		name?: string,
	_dummy_field_?: boolean
};
	["ImageUpsertTagsRelationInput"]: {
		by?: GraphQLTypes["ImageTagUniqueWhere"],
	update?: GraphQLTypes["ImageTagWithoutImagesUpdateInput"],
	create?: GraphQLTypes["ImageTagWithoutImagesCreateInput"]
};
	["ImageUseUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageWithoutUsesUpdateInput"],
	create?: GraphQLTypes["ImageWithoutUsesCreateInput"]
};
	["ArticleUpsertCoverPhotoRelationInput"]: {
		update?: GraphQLTypes["ImageUseUpdateInput"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["ArticleUpdatePreviewContentEntityRelationInput"]: {
		create?: GraphQLTypes["ContentCreateInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["ArticleUpsertPreviewContentRelationInput"],
	connect?: GraphQLTypes["ContentUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ArticleUpsertPreviewContentRelationInput"]: {
		update?: GraphQLTypes["ContentUpdateInput"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["ArticleUpdateAudioEntityRelationInput"]: {
		create?: GraphQLTypes["AudioUseCreateInput"],
	update?: GraphQLTypes["AudioUseUpdateInput"],
	upsert?: GraphQLTypes["ArticleUpsertAudioRelationInput"],
	connect?: GraphQLTypes["AudioUseUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ArticleUpsertAudioRelationInput"]: {
		update?: GraphQLTypes["AudioUseUpdateInput"],
	create?: GraphQLTypes["AudioUseCreateInput"]
};
	["ArticleUpdateCategoriesEntityRelationInput"]: {
		create?: GraphQLTypes["ArticleCategoryWithoutArticleCreateInput"],
	update?: GraphQLTypes["ArticleUpdateCategoriesRelationInput"],
	upsert?: GraphQLTypes["ArticleUpsertCategoriesRelationInput"],
	connect?: GraphQLTypes["ArticleCategoryUniqueWhere"],
	disconnect?: GraphQLTypes["ArticleCategoryUniqueWhere"],
	delete?: GraphQLTypes["ArticleCategoryUniqueWhere"],
	alias?: string
};
	["ArticleUpdateCategoriesRelationInput"]: {
		by?: GraphQLTypes["ArticleCategoryUniqueWhere"],
	data?: GraphQLTypes["ArticleCategoryWithoutArticleUpdateInput"]
};
	["ArticleCategoryWithoutArticleUpdateInput"]: {
		order?: number,
	category?: GraphQLTypes["ArticleCategoryUpdateCategoryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArticleCategoryUpdateCategoryEntityRelationInput"]: {
		create?: GraphQLTypes["CategoryWithoutArticleCategoryCreateInput"],
	update?: GraphQLTypes["CategoryWithoutArticleCategoryUpdateInput"],
	upsert?: GraphQLTypes["ArticleCategoryUpsertCategoryRelationInput"],
	connect?: GraphQLTypes["CategoryUniqueWhere"],
	delete?: boolean
};
	["CategoryWithoutArticleCategoryUpdateInput"]: {
		name?: string,
	url?: GraphQLTypes["CategoryUpdateUrlEntityRelationInput"],
	legacyId?: string,
	_dummy_field_?: boolean
};
	["CategoryUpdateUrlEntityRelationInput"]: {
		create?: GraphQLTypes["UrlWithoutCategoryCreateInput"],
	update?: GraphQLTypes["UrlWithoutCategoryUpdateInput"],
	upsert?: GraphQLTypes["CategoryUpsertUrlRelationInput"],
	connect?: GraphQLTypes["UrlUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["UrlWithoutCategoryUpdateInput"]: {
		url?: string,
	article?: GraphQLTypes["UrlUpdateArticleEntityRelationInput"],
	author?: GraphQLTypes["UrlUpdateAuthorEntityRelationInput"],
	issue?: GraphQLTypes["UrlUpdateIssueEntityRelationInput"],
	page?: GraphQLTypes["UrlUpdatePageEntityRelationInput"],
	tag?: GraphQLTypes["UrlUpdateTagEntityRelationInput"],
	redirect?: string,
	_dummy_field_?: boolean
};
	["UrlUpdateIssueEntityRelationInput"]: {
		create?: GraphQLTypes["IssueWithoutUrlCreateInput"],
	update?: GraphQLTypes["IssueWithoutUrlUpdateInput"],
	upsert?: GraphQLTypes["UrlUpsertIssueRelationInput"],
	connect?: GraphQLTypes["IssueUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["IssueWithoutUrlUpdateInput"]: {
		closed?: boolean,
	free?: boolean,
	title?: string,
	subtitle?: string,
	year?: number,
	issue?: number,
	publishedSince?: GraphQLTypes["Date"],
	publishedUntil?: GraphQLTypes["Date"],
	publishDigital?: GraphQLTypes["DateTime"],
	mobileAppsKey?: string,
	articles?: Array<GraphQLTypes["IssueUpdateArticlesEntityRelationInput"]>,
	kind?: GraphQLTypes["IssueKind"],
	notificationTitle?: string,
	notificationMessage?: string,
	pdf?: GraphQLTypes["IssueUpdatePdfEntityRelationInput"],
	printBuy?: boolean,
	printText?: string,
	blocks?: Array<GraphQLTypes["IssueUpdateBlocksEntityRelationInput"]>,
	coverPhoto?: GraphQLTypes["IssueUpdateCoverPhotoEntityRelationInput"],
	printTarget?: GraphQLTypes["IssueUpdatePrintTargetEntityRelationInput"],
	backgroundPhoto?: GraphQLTypes["IssueUpdateBackgroundPhotoEntityRelationInput"],
	legacyId?: string,
	_dummy_field_?: boolean
};
	["IssueUpdateArticlesEntityRelationInput"]: {
		create?: GraphQLTypes["IssueArticleWithoutIssueCreateInput"],
	update?: GraphQLTypes["IssueUpdateArticlesRelationInput"],
	upsert?: GraphQLTypes["IssueUpsertArticlesRelationInput"],
	connect?: GraphQLTypes["IssueArticleUniqueWhere"],
	disconnect?: GraphQLTypes["IssueArticleUniqueWhere"],
	delete?: GraphQLTypes["IssueArticleUniqueWhere"],
	alias?: string
};
	["IssueUpdateArticlesRelationInput"]: {
		by?: GraphQLTypes["IssueArticleUniqueWhere"],
	data?: GraphQLTypes["IssueArticleWithoutIssueUpdateInput"]
};
	["IssueArticleWithoutIssueUpdateInput"]: {
		article?: GraphQLTypes["IssueArticleUpdateArticleEntityRelationInput"],
	order?: number,
	_dummy_field_?: boolean
};
	["IssueArticleUpdateArticleEntityRelationInput"]: {
		create?: GraphQLTypes["ArticleWithoutIssuesCreateInput"],
	update?: GraphQLTypes["ArticleWithoutIssuesUpdateInput"],
	upsert?: GraphQLTypes["IssueArticleUpsertArticleRelationInput"],
	connect?: GraphQLTypes["ArticleUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ArticleWithoutIssuesUpdateInput"]: {
		title?: string,
	url?: GraphQLTypes["ArticleUpdateUrlEntityRelationInput"],
	authors?: Array<GraphQLTypes["ArticleUpdateAuthorsEntityRelationInput"]>,
	hideInMostRead?: boolean,
	hideAds?: boolean,
	state?: GraphQLTypes["ArticleState"],
	locked?: boolean,
	publishAt?: GraphQLTypes["DateTime"],
	template?: GraphQLTypes["Template"],
	subtitle?: GraphQLTypes["ArticleUpdateSubtitleEntityRelationInput"],
	content?: GraphQLTypes["ArticleUpdateContentEntityRelationInput"],
	coverPhoto?: GraphQLTypes["ArticleUpdateCoverPhotoEntityRelationInput"],
	titleAlignment?: GraphQLTypes["ArticleTitleAlignment"],
	tagline?: string,
	createdAt?: GraphQLTypes["DateTime"],
	previewContent?: GraphQLTypes["ArticleUpdatePreviewContentEntityRelationInput"],
	audio?: GraphQLTypes["ArticleUpdateAudioEntityRelationInput"],
	categories?: Array<GraphQLTypes["ArticleUpdateCategoriesEntityRelationInput"]>,
	contentBlocks?: Array<GraphQLTypes["ArticleUpdateContentBlocksEntityRelationInput"]>,
	unlocked?: Array<GraphQLTypes["ArticleUpdateUnlockedEntityRelationInput"]>,
	coverPhotoVertical?: GraphQLTypes["ArticleUpdateCoverPhotoVerticalEntityRelationInput"],
	legacyId?: string,
	tags?: Array<GraphQLTypes["ArticleUpdateTagsEntityRelationInput"]>,
	isHistory?: boolean,
	historyTags?: Array<GraphQLTypes["ArticleUpdateHistoryTagsEntityRelationInput"]>,
	historyPeriods?: Array<GraphQLTypes["ArticleUpdateHistoryPeriodsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ArticleUpdateContentBlocksEntityRelationInput"]: {
		create?: GraphQLTypes["ContentArticleWithoutArticleCreateInput"],
	update?: GraphQLTypes["ArticleUpdateContentBlocksRelationInput"],
	upsert?: GraphQLTypes["ArticleUpsertContentBlocksRelationInput"],
	connect?: GraphQLTypes["ContentArticleUniqueWhere"],
	disconnect?: GraphQLTypes["ContentArticleUniqueWhere"],
	delete?: GraphQLTypes["ContentArticleUniqueWhere"],
	alias?: string
};
	["ArticleUpdateContentBlocksRelationInput"]: {
		by?: GraphQLTypes["ContentArticleUniqueWhere"],
	data?: GraphQLTypes["ContentArticleWithoutArticleUpdateInput"]
};
	["ContentArticleWithoutArticleUpdateInput"]: {
		order?: number,
	contentBlock?: GraphQLTypes["ContentArticleUpdateContentBlockEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentArticleUpdateContentBlockEntityRelationInput"]: {
		create?: GraphQLTypes["ContentBlockWithoutArticlesCreateInput"],
	update?: GraphQLTypes["ContentBlockWithoutArticlesUpdateInput"],
	upsert?: GraphQLTypes["ContentArticleUpsertContentBlockRelationInput"],
	connect?: GraphQLTypes["ContentBlockUniqueWhere"],
	delete?: boolean
};
	["ContentBlockWithoutArticlesUpdateInput"]: {
		order?: number,
	type?: GraphQLTypes["ContentBlockType"],
	youtubeId?: string,
	text?: string,
	targetLabel?: string,
	issue?: GraphQLTypes["ContentBlockUpdateIssueEntityRelationInput"],
	target?: GraphQLTypes["ContentBlockUpdateTargetEntityRelationInput"],
	subscriptionForm?: GraphQLTypes["ContentBlockUpdateSubscriptionFormEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentBlockUpdateIssueEntityRelationInput"]: {
		create?: GraphQLTypes["IssueWithoutBlocksCreateInput"],
	update?: GraphQLTypes["IssueWithoutBlocksUpdateInput"],
	upsert?: GraphQLTypes["ContentBlockUpsertIssueRelationInput"],
	connect?: GraphQLTypes["IssueUniqueWhere"],
	delete?: boolean
};
	["IssueWithoutBlocksUpdateInput"]: {
		closed?: boolean,
	free?: boolean,
	title?: string,
	subtitle?: string,
	year?: number,
	issue?: number,
	publishedSince?: GraphQLTypes["Date"],
	publishedUntil?: GraphQLTypes["Date"],
	publishDigital?: GraphQLTypes["DateTime"],
	mobileAppsKey?: string,
	url?: GraphQLTypes["IssueUpdateUrlEntityRelationInput"],
	articles?: Array<GraphQLTypes["IssueUpdateArticlesEntityRelationInput"]>,
	kind?: GraphQLTypes["IssueKind"],
	notificationTitle?: string,
	notificationMessage?: string,
	pdf?: GraphQLTypes["IssueUpdatePdfEntityRelationInput"],
	printBuy?: boolean,
	printText?: string,
	coverPhoto?: GraphQLTypes["IssueUpdateCoverPhotoEntityRelationInput"],
	printTarget?: GraphQLTypes["IssueUpdatePrintTargetEntityRelationInput"],
	backgroundPhoto?: GraphQLTypes["IssueUpdateBackgroundPhotoEntityRelationInput"],
	legacyId?: string,
	_dummy_field_?: boolean
};
	["IssueUpdateUrlEntityRelationInput"]: {
		create?: GraphQLTypes["UrlWithoutIssueCreateInput"],
	update?: GraphQLTypes["UrlWithoutIssueUpdateInput"],
	upsert?: GraphQLTypes["IssueUpsertUrlRelationInput"],
	connect?: GraphQLTypes["UrlUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["UrlWithoutIssueUpdateInput"]: {
		url?: string,
	article?: GraphQLTypes["UrlUpdateArticleEntityRelationInput"],
	author?: GraphQLTypes["UrlUpdateAuthorEntityRelationInput"],
	page?: GraphQLTypes["UrlUpdatePageEntityRelationInput"],
	category?: GraphQLTypes["UrlUpdateCategoryEntityRelationInput"],
	tag?: GraphQLTypes["UrlUpdateTagEntityRelationInput"],
	redirect?: string,
	_dummy_field_?: boolean
};
	["UrlUpdatePageEntityRelationInput"]: {
		create?: GraphQLTypes["PageWithoutUrlCreateInput"],
	update?: GraphQLTypes["PageWithoutUrlUpdateInput"],
	upsert?: GraphQLTypes["UrlUpsertPageRelationInput"],
	connect?: GraphQLTypes["PageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["PageWithoutUrlUpdateInput"]: {
		title?: string,
	publishAt?: GraphQLTypes["DateTime"],
	createdAt?: GraphQLTypes["DateTime"],
	template?: GraphQLTypes["PageTemplate"],
	content?: GraphQLTypes["PageUpdateContentEntityRelationInput"],
	seo?: GraphQLTypes["PageUpdateSeoEntityRelationInput"],
	subscriptionValidity?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["PageUpdateContentEntityRelationInput"]: {
		create?: GraphQLTypes["ContentCreateInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["PageUpsertContentRelationInput"],
	connect?: GraphQLTypes["ContentUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["PageUpsertContentRelationInput"]: {
		update?: GraphQLTypes["ContentUpdateInput"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["PageUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoWithoutPageCreateInput"],
	update?: GraphQLTypes["SeoWithoutPageUpdateInput"],
	upsert?: GraphQLTypes["PageUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SeoWithoutPageUpdateInput"]: {
		title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	twCard?: GraphQLTypes["SeoTwCard"],
	ogImage?: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SeoUpdateOgImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageUseCreateInput"],
	update?: GraphQLTypes["ImageUseUpdateInput"],
	upsert?: GraphQLTypes["SeoUpsertOgImageRelationInput"],
	connect?: GraphQLTypes["ImageUseUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SeoUpsertOgImageRelationInput"]: {
		update?: GraphQLTypes["ImageUseUpdateInput"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["PageUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoWithoutPageUpdateInput"],
	create?: GraphQLTypes["SeoWithoutPageCreateInput"]
};
	["UrlUpsertPageRelationInput"]: {
		update?: GraphQLTypes["PageWithoutUrlUpdateInput"],
	create?: GraphQLTypes["PageWithoutUrlCreateInput"]
};
	["UrlUpdateCategoryEntityRelationInput"]: {
		create?: GraphQLTypes["CategoryWithoutUrlCreateInput"],
	update?: GraphQLTypes["CategoryWithoutUrlUpdateInput"],
	upsert?: GraphQLTypes["UrlUpsertCategoryRelationInput"],
	connect?: GraphQLTypes["CategoryUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["CategoryWithoutUrlUpdateInput"]: {
		name?: string,
	articleCategory?: Array<GraphQLTypes["CategoryUpdateArticleCategoryEntityRelationInput"]>,
	legacyId?: string,
	_dummy_field_?: boolean
};
	["CategoryUpdateArticleCategoryEntityRelationInput"]: {
		create?: GraphQLTypes["ArticleCategoryWithoutCategoryCreateInput"],
	update?: GraphQLTypes["CategoryUpdateArticleCategoryRelationInput"],
	upsert?: GraphQLTypes["CategoryUpsertArticleCategoryRelationInput"],
	connect?: GraphQLTypes["ArticleCategoryUniqueWhere"],
	disconnect?: GraphQLTypes["ArticleCategoryUniqueWhere"],
	delete?: GraphQLTypes["ArticleCategoryUniqueWhere"],
	alias?: string
};
	["CategoryUpdateArticleCategoryRelationInput"]: {
		by?: GraphQLTypes["ArticleCategoryUniqueWhere"],
	data?: GraphQLTypes["ArticleCategoryWithoutCategoryUpdateInput"]
};
	["ArticleCategoryWithoutCategoryUpdateInput"]: {
		order?: number,
	article?: GraphQLTypes["ArticleCategoryUpdateArticleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArticleCategoryUpdateArticleEntityRelationInput"]: {
		create?: GraphQLTypes["ArticleWithoutCategoriesCreateInput"],
	update?: GraphQLTypes["ArticleWithoutCategoriesUpdateInput"],
	upsert?: GraphQLTypes["ArticleCategoryUpsertArticleRelationInput"],
	connect?: GraphQLTypes["ArticleUniqueWhere"],
	delete?: boolean
};
	["ArticleWithoutCategoriesUpdateInput"]: {
		title?: string,
	url?: GraphQLTypes["ArticleUpdateUrlEntityRelationInput"],
	authors?: Array<GraphQLTypes["ArticleUpdateAuthorsEntityRelationInput"]>,
	hideInMostRead?: boolean,
	hideAds?: boolean,
	state?: GraphQLTypes["ArticleState"],
	locked?: boolean,
	publishAt?: GraphQLTypes["DateTime"],
	template?: GraphQLTypes["Template"],
	subtitle?: GraphQLTypes["ArticleUpdateSubtitleEntityRelationInput"],
	content?: GraphQLTypes["ArticleUpdateContentEntityRelationInput"],
	coverPhoto?: GraphQLTypes["ArticleUpdateCoverPhotoEntityRelationInput"],
	titleAlignment?: GraphQLTypes["ArticleTitleAlignment"],
	tagline?: string,
	createdAt?: GraphQLTypes["DateTime"],
	previewContent?: GraphQLTypes["ArticleUpdatePreviewContentEntityRelationInput"],
	audio?: GraphQLTypes["ArticleUpdateAudioEntityRelationInput"],
	issues?: Array<GraphQLTypes["ArticleUpdateIssuesEntityRelationInput"]>,
	contentBlocks?: Array<GraphQLTypes["ArticleUpdateContentBlocksEntityRelationInput"]>,
	unlocked?: Array<GraphQLTypes["ArticleUpdateUnlockedEntityRelationInput"]>,
	coverPhotoVertical?: GraphQLTypes["ArticleUpdateCoverPhotoVerticalEntityRelationInput"],
	legacyId?: string,
	tags?: Array<GraphQLTypes["ArticleUpdateTagsEntityRelationInput"]>,
	isHistory?: boolean,
	historyTags?: Array<GraphQLTypes["ArticleUpdateHistoryTagsEntityRelationInput"]>,
	historyPeriods?: Array<GraphQLTypes["ArticleUpdateHistoryPeriodsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ArticleUpdateIssuesEntityRelationInput"]: {
		create?: GraphQLTypes["IssueArticleWithoutArticleCreateInput"],
	update?: GraphQLTypes["ArticleUpdateIssuesRelationInput"],
	upsert?: GraphQLTypes["ArticleUpsertIssuesRelationInput"],
	connect?: GraphQLTypes["IssueArticleUniqueWhere"],
	disconnect?: GraphQLTypes["IssueArticleUniqueWhere"],
	delete?: GraphQLTypes["IssueArticleUniqueWhere"],
	alias?: string
};
	["ArticleUpdateIssuesRelationInput"]: {
		by?: GraphQLTypes["IssueArticleUniqueWhere"],
	data?: GraphQLTypes["IssueArticleWithoutArticleUpdateInput"]
};
	["IssueArticleWithoutArticleUpdateInput"]: {
		issue?: GraphQLTypes["IssueArticleUpdateIssueEntityRelationInput"],
	order?: number,
	_dummy_field_?: boolean
};
	["IssueArticleUpdateIssueEntityRelationInput"]: {
		create?: GraphQLTypes["IssueWithoutArticlesCreateInput"],
	update?: GraphQLTypes["IssueWithoutArticlesUpdateInput"],
	upsert?: GraphQLTypes["IssueArticleUpsertIssueRelationInput"],
	connect?: GraphQLTypes["IssueUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["IssueWithoutArticlesUpdateInput"]: {
		closed?: boolean,
	free?: boolean,
	title?: string,
	subtitle?: string,
	year?: number,
	issue?: number,
	publishedSince?: GraphQLTypes["Date"],
	publishedUntil?: GraphQLTypes["Date"],
	publishDigital?: GraphQLTypes["DateTime"],
	mobileAppsKey?: string,
	url?: GraphQLTypes["IssueUpdateUrlEntityRelationInput"],
	kind?: GraphQLTypes["IssueKind"],
	notificationTitle?: string,
	notificationMessage?: string,
	pdf?: GraphQLTypes["IssueUpdatePdfEntityRelationInput"],
	printBuy?: boolean,
	printText?: string,
	blocks?: Array<GraphQLTypes["IssueUpdateBlocksEntityRelationInput"]>,
	coverPhoto?: GraphQLTypes["IssueUpdateCoverPhotoEntityRelationInput"],
	printTarget?: GraphQLTypes["IssueUpdatePrintTargetEntityRelationInput"],
	backgroundPhoto?: GraphQLTypes["IssueUpdateBackgroundPhotoEntityRelationInput"],
	legacyId?: string,
	_dummy_field_?: boolean
};
	["IssueUpdatePdfEntityRelationInput"]: {
		create?: GraphQLTypes["FileUseCreateInput"],
	update?: GraphQLTypes["FileUseUpdateInput"],
	upsert?: GraphQLTypes["IssueUpsertPdfRelationInput"],
	connect?: GraphQLTypes["FileUseUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FileUseUpdateInput"]: {
		file?: GraphQLTypes["FileUseUpdateFileEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FileUseUpdateFileEntityRelationInput"]: {
		create?: GraphQLTypes["FileWithoutUsesCreateInput"],
	update?: GraphQLTypes["FileWithoutUsesUpdateInput"],
	upsert?: GraphQLTypes["FileUseUpsertFileRelationInput"],
	connect?: GraphQLTypes["FileUniqueWhere"],
	delete?: boolean
};
	["FileWithoutUsesUpdateInput"]: {
		url?: string,
	_dummy_field_?: boolean
};
	["FileUseUpsertFileRelationInput"]: {
		update?: GraphQLTypes["FileWithoutUsesUpdateInput"],
	create?: GraphQLTypes["FileWithoutUsesCreateInput"]
};
	["IssueUpsertPdfRelationInput"]: {
		update?: GraphQLTypes["FileUseUpdateInput"],
	create?: GraphQLTypes["FileUseCreateInput"]
};
	["IssueUpdateBlocksEntityRelationInput"]: {
		create?: GraphQLTypes["ContentBlockWithoutIssueCreateInput"],
	update?: GraphQLTypes["IssueUpdateBlocksRelationInput"],
	upsert?: GraphQLTypes["IssueUpsertBlocksRelationInput"],
	connect?: GraphQLTypes["ContentBlockUniqueWhere"],
	disconnect?: GraphQLTypes["ContentBlockUniqueWhere"],
	delete?: GraphQLTypes["ContentBlockUniqueWhere"],
	alias?: string
};
	["IssueUpdateBlocksRelationInput"]: {
		by?: GraphQLTypes["ContentBlockUniqueWhere"],
	data?: GraphQLTypes["ContentBlockWithoutIssueUpdateInput"]
};
	["ContentBlockWithoutIssueUpdateInput"]: {
		order?: number,
	type?: GraphQLTypes["ContentBlockType"],
	youtubeId?: string,
	text?: string,
	targetLabel?: string,
	target?: GraphQLTypes["ContentBlockUpdateTargetEntityRelationInput"],
	articles?: Array<GraphQLTypes["ContentBlockUpdateArticlesEntityRelationInput"]>,
	subscriptionForm?: GraphQLTypes["ContentBlockUpdateSubscriptionFormEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentBlockUpdateTargetEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["ContentBlockUpsertTargetRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentBlockUpsertTargetRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["ContentBlockUpdateArticlesEntityRelationInput"]: {
		create?: GraphQLTypes["ContentArticleWithoutContentBlockCreateInput"],
	update?: GraphQLTypes["ContentBlockUpdateArticlesRelationInput"],
	upsert?: GraphQLTypes["ContentBlockUpsertArticlesRelationInput"],
	connect?: GraphQLTypes["ContentArticleUniqueWhere"],
	disconnect?: GraphQLTypes["ContentArticleUniqueWhere"],
	delete?: GraphQLTypes["ContentArticleUniqueWhere"],
	alias?: string
};
	["ContentBlockUpdateArticlesRelationInput"]: {
		by?: GraphQLTypes["ContentArticleUniqueWhere"],
	data?: GraphQLTypes["ContentArticleWithoutContentBlockUpdateInput"]
};
	["ContentArticleWithoutContentBlockUpdateInput"]: {
		order?: number,
	article?: GraphQLTypes["ContentArticleUpdateArticleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentArticleUpdateArticleEntityRelationInput"]: {
		create?: GraphQLTypes["ArticleWithoutContentBlocksCreateInput"],
	update?: GraphQLTypes["ArticleWithoutContentBlocksUpdateInput"],
	upsert?: GraphQLTypes["ContentArticleUpsertArticleRelationInput"],
	connect?: GraphQLTypes["ArticleUniqueWhere"],
	delete?: boolean
};
	["ArticleWithoutContentBlocksUpdateInput"]: {
		title?: string,
	url?: GraphQLTypes["ArticleUpdateUrlEntityRelationInput"],
	authors?: Array<GraphQLTypes["ArticleUpdateAuthorsEntityRelationInput"]>,
	hideInMostRead?: boolean,
	hideAds?: boolean,
	state?: GraphQLTypes["ArticleState"],
	locked?: boolean,
	publishAt?: GraphQLTypes["DateTime"],
	template?: GraphQLTypes["Template"],
	subtitle?: GraphQLTypes["ArticleUpdateSubtitleEntityRelationInput"],
	content?: GraphQLTypes["ArticleUpdateContentEntityRelationInput"],
	coverPhoto?: GraphQLTypes["ArticleUpdateCoverPhotoEntityRelationInput"],
	titleAlignment?: GraphQLTypes["ArticleTitleAlignment"],
	tagline?: string,
	createdAt?: GraphQLTypes["DateTime"],
	previewContent?: GraphQLTypes["ArticleUpdatePreviewContentEntityRelationInput"],
	audio?: GraphQLTypes["ArticleUpdateAudioEntityRelationInput"],
	categories?: Array<GraphQLTypes["ArticleUpdateCategoriesEntityRelationInput"]>,
	issues?: Array<GraphQLTypes["ArticleUpdateIssuesEntityRelationInput"]>,
	unlocked?: Array<GraphQLTypes["ArticleUpdateUnlockedEntityRelationInput"]>,
	coverPhotoVertical?: GraphQLTypes["ArticleUpdateCoverPhotoVerticalEntityRelationInput"],
	legacyId?: string,
	tags?: Array<GraphQLTypes["ArticleUpdateTagsEntityRelationInput"]>,
	isHistory?: boolean,
	historyTags?: Array<GraphQLTypes["ArticleUpdateHistoryTagsEntityRelationInput"]>,
	historyPeriods?: Array<GraphQLTypes["ArticleUpdateHistoryPeriodsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ArticleUpdateUnlockedEntityRelationInput"]: {
		create?: GraphQLTypes["UnlockedArticleWithoutArticleCreateInput"],
	update?: GraphQLTypes["ArticleUpdateUnlockedRelationInput"],
	upsert?: GraphQLTypes["ArticleUpsertUnlockedRelationInput"],
	connect?: GraphQLTypes["UnlockedArticleUniqueWhere"],
	disconnect?: GraphQLTypes["UnlockedArticleUniqueWhere"],
	delete?: GraphQLTypes["UnlockedArticleUniqueWhere"],
	alias?: string
};
	["ArticleUpdateUnlockedRelationInput"]: {
		by?: GraphQLTypes["UnlockedArticleUniqueWhere"],
	data?: GraphQLTypes["UnlockedArticleWithoutArticleUpdateInput"]
};
	["UnlockedArticleWithoutArticleUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"],
	code?: string,
	views?: number,
	user?: GraphQLTypes["UnlockedArticleUpdateUserEntityRelationInput"],
	_dummy_field_?: boolean
};
	["UnlockedArticleUpdateUserEntityRelationInput"]: {
		create?: GraphQLTypes["UserWithoutUnlockedArticlesCreateInput"],
	update?: GraphQLTypes["UserWithoutUnlockedArticlesUpdateInput"],
	upsert?: GraphQLTypes["UnlockedArticleUpsertUserRelationInput"],
	connect?: GraphQLTypes["UserUniqueWhere"],
	delete?: boolean
};
	["UserWithoutUnlockedArticlesUpdateInput"]: {
		ihnedId?: string,
	email?: string,
	authors?: Array<GraphQLTypes["UserUpdateAuthorsEntityRelationInput"]>,
	appReviews?: Array<GraphQLTypes["UserUpdateAppReviewsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["UserUpdateAuthorsEntityRelationInput"]: {
		create?: GraphQLTypes["AuthorWithoutUsersCreateInput"],
	update?: GraphQLTypes["UserUpdateAuthorsRelationInput"],
	upsert?: GraphQLTypes["UserUpsertAuthorsRelationInput"],
	connect?: GraphQLTypes["AuthorUniqueWhere"],
	disconnect?: GraphQLTypes["AuthorUniqueWhere"],
	delete?: GraphQLTypes["AuthorUniqueWhere"],
	alias?: string
};
	["UserUpdateAuthorsRelationInput"]: {
		by?: GraphQLTypes["AuthorUniqueWhere"],
	data?: GraphQLTypes["AuthorWithoutUsersUpdateInput"]
};
	["AuthorWithoutUsersUpdateInput"]: {
		name?: string,
	position?: string,
	twitterHandle?: string,
	facebookId?: string,
	email?: string,
	photographer?: boolean,
	order?: number,
	about?: GraphQLTypes["AuthorUpdateAboutEntityRelationInput"],
	topArticles?: Array<GraphQLTypes["AuthorUpdateTopArticlesEntityRelationInput"]>,
	startOfCooperation?: GraphQLTypes["Date"],
	photo?: GraphQLTypes["AuthorUpdatePhotoEntityRelationInput"],
	illustration?: GraphQLTypes["AuthorUpdateIllustrationEntityRelationInput"],
	legacyId?: string,
	category?: GraphQLTypes["AuthorCategory"],
	url?: GraphQLTypes["AuthorUpdateUrlEntityRelationInput"],
	instagramUsername?: string,
	_dummy_field_?: boolean
};
	["AuthorUpdatePhotoEntityRelationInput"]: {
		create?: GraphQLTypes["ImageUseCreateInput"],
	update?: GraphQLTypes["ImageUseUpdateInput"],
	upsert?: GraphQLTypes["AuthorUpsertPhotoRelationInput"],
	connect?: GraphQLTypes["ImageUseUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["AuthorUpsertPhotoRelationInput"]: {
		update?: GraphQLTypes["ImageUseUpdateInput"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["AuthorUpdateIllustrationEntityRelationInput"]: {
		create?: GraphQLTypes["ImageUseCreateInput"],
	update?: GraphQLTypes["ImageUseUpdateInput"],
	upsert?: GraphQLTypes["AuthorUpsertIllustrationRelationInput"],
	connect?: GraphQLTypes["ImageUseUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["AuthorUpsertIllustrationRelationInput"]: {
		update?: GraphQLTypes["ImageUseUpdateInput"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["AuthorUpdateUrlEntityRelationInput"]: {
		create?: GraphQLTypes["UrlWithoutAuthorCreateInput"],
	update?: GraphQLTypes["UrlWithoutAuthorUpdateInput"],
	upsert?: GraphQLTypes["AuthorUpsertUrlRelationInput"],
	connect?: GraphQLTypes["UrlUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["UrlWithoutAuthorUpdateInput"]: {
		url?: string,
	article?: GraphQLTypes["UrlUpdateArticleEntityRelationInput"],
	issue?: GraphQLTypes["UrlUpdateIssueEntityRelationInput"],
	page?: GraphQLTypes["UrlUpdatePageEntityRelationInput"],
	category?: GraphQLTypes["UrlUpdateCategoryEntityRelationInput"],
	tag?: GraphQLTypes["UrlUpdateTagEntityRelationInput"],
	redirect?: string,
	_dummy_field_?: boolean
};
	["UrlUpdateTagEntityRelationInput"]: {
		create?: GraphQLTypes["TagWithoutUrlCreateInput"],
	update?: GraphQLTypes["TagWithoutUrlUpdateInput"],
	upsert?: GraphQLTypes["UrlUpsertTagRelationInput"],
	connect?: GraphQLTypes["TagUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["TagWithoutUrlUpdateInput"]: {
		name?: string,
	useAsTagline?: boolean,
	articleTag?: Array<GraphQLTypes["TagUpdateArticleTagEntityRelationInput"]>,
	order?: string,
	legacyId?: string,
	_dummy_field_?: boolean
};
	["TagUpdateArticleTagEntityRelationInput"]: {
		create?: GraphQLTypes["ArticleTagWithoutTagCreateInput"],
	update?: GraphQLTypes["TagUpdateArticleTagRelationInput"],
	upsert?: GraphQLTypes["TagUpsertArticleTagRelationInput"],
	connect?: GraphQLTypes["ArticleTagUniqueWhere"],
	disconnect?: GraphQLTypes["ArticleTagUniqueWhere"],
	delete?: GraphQLTypes["ArticleTagUniqueWhere"],
	alias?: string
};
	["TagUpdateArticleTagRelationInput"]: {
		by?: GraphQLTypes["ArticleTagUniqueWhere"],
	data?: GraphQLTypes["ArticleTagWithoutTagUpdateInput"]
};
	["ArticleTagWithoutTagUpdateInput"]: {
		order?: number,
	article?: GraphQLTypes["ArticleTagUpdateArticleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArticleTagUpdateArticleEntityRelationInput"]: {
		create?: GraphQLTypes["ArticleWithoutTagsCreateInput"],
	update?: GraphQLTypes["ArticleWithoutTagsUpdateInput"],
	upsert?: GraphQLTypes["ArticleTagUpsertArticleRelationInput"],
	connect?: GraphQLTypes["ArticleUniqueWhere"],
	delete?: boolean
};
	["ArticleWithoutTagsUpdateInput"]: {
		title?: string,
	url?: GraphQLTypes["ArticleUpdateUrlEntityRelationInput"],
	authors?: Array<GraphQLTypes["ArticleUpdateAuthorsEntityRelationInput"]>,
	hideInMostRead?: boolean,
	hideAds?: boolean,
	state?: GraphQLTypes["ArticleState"],
	locked?: boolean,
	publishAt?: GraphQLTypes["DateTime"],
	template?: GraphQLTypes["Template"],
	subtitle?: GraphQLTypes["ArticleUpdateSubtitleEntityRelationInput"],
	content?: GraphQLTypes["ArticleUpdateContentEntityRelationInput"],
	coverPhoto?: GraphQLTypes["ArticleUpdateCoverPhotoEntityRelationInput"],
	titleAlignment?: GraphQLTypes["ArticleTitleAlignment"],
	tagline?: string,
	createdAt?: GraphQLTypes["DateTime"],
	previewContent?: GraphQLTypes["ArticleUpdatePreviewContentEntityRelationInput"],
	audio?: GraphQLTypes["ArticleUpdateAudioEntityRelationInput"],
	categories?: Array<GraphQLTypes["ArticleUpdateCategoriesEntityRelationInput"]>,
	issues?: Array<GraphQLTypes["ArticleUpdateIssuesEntityRelationInput"]>,
	contentBlocks?: Array<GraphQLTypes["ArticleUpdateContentBlocksEntityRelationInput"]>,
	unlocked?: Array<GraphQLTypes["ArticleUpdateUnlockedEntityRelationInput"]>,
	coverPhotoVertical?: GraphQLTypes["ArticleUpdateCoverPhotoVerticalEntityRelationInput"],
	legacyId?: string,
	isHistory?: boolean,
	historyTags?: Array<GraphQLTypes["ArticleUpdateHistoryTagsEntityRelationInput"]>,
	historyPeriods?: Array<GraphQLTypes["ArticleUpdateHistoryPeriodsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ArticleUpdateCoverPhotoVerticalEntityRelationInput"]: {
		create?: GraphQLTypes["ImageUseCreateInput"],
	update?: GraphQLTypes["ImageUseUpdateInput"],
	upsert?: GraphQLTypes["ArticleUpsertCoverPhotoVerticalRelationInput"],
	connect?: GraphQLTypes["ImageUseUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ArticleUpsertCoverPhotoVerticalRelationInput"]: {
		update?: GraphQLTypes["ImageUseUpdateInput"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["ArticleUpdateHistoryTagsEntityRelationInput"]: {
		create?: GraphQLTypes["ArticleHistoryTagWithoutArticleCreateInput"],
	update?: GraphQLTypes["ArticleUpdateHistoryTagsRelationInput"],
	upsert?: GraphQLTypes["ArticleUpsertHistoryTagsRelationInput"],
	connect?: GraphQLTypes["ArticleHistoryTagUniqueWhere"],
	disconnect?: GraphQLTypes["ArticleHistoryTagUniqueWhere"],
	delete?: GraphQLTypes["ArticleHistoryTagUniqueWhere"],
	alias?: string
};
	["ArticleUpdateHistoryTagsRelationInput"]: {
		by?: GraphQLTypes["ArticleHistoryTagUniqueWhere"],
	data?: GraphQLTypes["ArticleHistoryTagWithoutArticleUpdateInput"]
};
	["ArticleHistoryTagWithoutArticleUpdateInput"]: {
		order?: number,
	historyTag?: GraphQLTypes["ArticleHistoryTagUpdateHistoryTagEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArticleHistoryTagUpdateHistoryTagEntityRelationInput"]: {
		create?: GraphQLTypes["HistoryTagWithoutArticleHistoryTagCreateInput"],
	update?: GraphQLTypes["HistoryTagWithoutArticleHistoryTagUpdateInput"],
	upsert?: GraphQLTypes["ArticleHistoryTagUpsertHistoryTagRelationInput"],
	connect?: GraphQLTypes["HistoryTagUniqueWhere"],
	delete?: boolean
};
	["HistoryTagWithoutArticleHistoryTagUpdateInput"]: {
		name?: string,
	slug?: string,
	_dummy_field_?: boolean
};
	["ArticleHistoryTagUpsertHistoryTagRelationInput"]: {
		update?: GraphQLTypes["HistoryTagWithoutArticleHistoryTagUpdateInput"],
	create?: GraphQLTypes["HistoryTagWithoutArticleHistoryTagCreateInput"]
};
	["ArticleUpsertHistoryTagsRelationInput"]: {
		by?: GraphQLTypes["ArticleHistoryTagUniqueWhere"],
	update?: GraphQLTypes["ArticleHistoryTagWithoutArticleUpdateInput"],
	create?: GraphQLTypes["ArticleHistoryTagWithoutArticleCreateInput"]
};
	["ArticleUpdateHistoryPeriodsEntityRelationInput"]: {
		create?: GraphQLTypes["ArticleHistoryPeriodWithoutArticleCreateInput"],
	update?: GraphQLTypes["ArticleUpdateHistoryPeriodsRelationInput"],
	upsert?: GraphQLTypes["ArticleUpsertHistoryPeriodsRelationInput"],
	connect?: GraphQLTypes["ArticleHistoryPeriodUniqueWhere"],
	disconnect?: GraphQLTypes["ArticleHistoryPeriodUniqueWhere"],
	delete?: GraphQLTypes["ArticleHistoryPeriodUniqueWhere"],
	alias?: string
};
	["ArticleUpdateHistoryPeriodsRelationInput"]: {
		by?: GraphQLTypes["ArticleHistoryPeriodUniqueWhere"],
	data?: GraphQLTypes["ArticleHistoryPeriodWithoutArticleUpdateInput"]
};
	["ArticleHistoryPeriodWithoutArticleUpdateInput"]: {
		order?: number,
	historyPeriod?: GraphQLTypes["ArticleHistoryPeriodUpdateHistoryPeriodEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArticleHistoryPeriodUpdateHistoryPeriodEntityRelationInput"]: {
		create?: GraphQLTypes["HistoryPeriodWithoutArticleHistoryPeriodCreateInput"],
	update?: GraphQLTypes["HistoryPeriodWithoutArticleHistoryPeriodUpdateInput"],
	upsert?: GraphQLTypes["ArticleHistoryPeriodUpsertHistoryPeriodRelationInput"],
	connect?: GraphQLTypes["HistoryPeriodUniqueWhere"],
	delete?: boolean
};
	["HistoryPeriodWithoutArticleHistoryPeriodUpdateInput"]: {
		name?: string,
	slug?: string,
	order?: number,
	cover?: GraphQLTypes["HistoryPeriodUpdateCoverEntityRelationInput"],
	seo?: GraphQLTypes["HistoryPeriodUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HistoryPeriodUpdateCoverEntityRelationInput"]: {
		create?: GraphQLTypes["HistoryCoverCreateInput"],
	update?: GraphQLTypes["HistoryCoverUpdateInput"],
	upsert?: GraphQLTypes["HistoryPeriodUpsertCoverRelationInput"],
	connect?: GraphQLTypes["HistoryCoverUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HistoryCoverUpdateInput"]: {
		title?: string,
	tileParagraph?: string,
	coverImage?: GraphQLTypes["HistoryCoverUpdateCoverImageEntityRelationInput"],
	tileImage?: GraphQLTypes["HistoryCoverUpdateTileImageEntityRelationInput"],
	mobileImage?: GraphQLTypes["HistoryCoverUpdateMobileImageEntityRelationInput"],
	leadContent?: GraphQLTypes["HistoryCoverUpdateLeadContentEntityRelationInput"],
	annotations?: GraphQLTypes["HistoryCoverUpdateAnnotationsEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HistoryCoverUpdateCoverImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageUseCreateInput"],
	update?: GraphQLTypes["ImageUseUpdateInput"],
	upsert?: GraphQLTypes["HistoryCoverUpsertCoverImageRelationInput"],
	connect?: GraphQLTypes["ImageUseUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HistoryCoverUpsertCoverImageRelationInput"]: {
		update?: GraphQLTypes["ImageUseUpdateInput"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["HistoryCoverUpdateTileImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageUseCreateInput"],
	update?: GraphQLTypes["ImageUseUpdateInput"],
	upsert?: GraphQLTypes["HistoryCoverUpsertTileImageRelationInput"],
	connect?: GraphQLTypes["ImageUseUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HistoryCoverUpsertTileImageRelationInput"]: {
		update?: GraphQLTypes["ImageUseUpdateInput"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["HistoryCoverUpdateMobileImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageUseCreateInput"],
	update?: GraphQLTypes["ImageUseUpdateInput"],
	upsert?: GraphQLTypes["HistoryCoverUpsertMobileImageRelationInput"],
	connect?: GraphQLTypes["ImageUseUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HistoryCoverUpsertMobileImageRelationInput"]: {
		update?: GraphQLTypes["ImageUseUpdateInput"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["HistoryCoverUpdateLeadContentEntityRelationInput"]: {
		create?: GraphQLTypes["ContentCreateInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["HistoryCoverUpsertLeadContentRelationInput"],
	connect?: GraphQLTypes["ContentUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HistoryCoverUpsertLeadContentRelationInput"]: {
		update?: GraphQLTypes["ContentUpdateInput"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["HistoryCoverUpdateAnnotationsEntityRelationInput"]: {
		create?: GraphQLTypes["HistoryTextListCreateInput"],
	update?: GraphQLTypes["HistoryTextListUpdateInput"],
	upsert?: GraphQLTypes["HistoryCoverUpsertAnnotationsRelationInput"],
	connect?: GraphQLTypes["HistoryTextListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HistoryTextListUpdateInput"]: {
		items?: Array<GraphQLTypes["HistoryTextListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["HistoryTextListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["HistoryTextItemWithoutListCreateInput"],
	update?: GraphQLTypes["HistoryTextListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["HistoryTextListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["HistoryTextItemUniqueWhere"],
	disconnect?: GraphQLTypes["HistoryTextItemUniqueWhere"],
	delete?: GraphQLTypes["HistoryTextItemUniqueWhere"],
	alias?: string
};
	["HistoryTextListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["HistoryTextItemUniqueWhere"],
	data?: GraphQLTypes["HistoryTextItemWithoutListUpdateInput"]
};
	["HistoryTextItemWithoutListUpdateInput"]: {
		order?: number,
	key?: string,
	text?: string,
	image?: GraphQLTypes["HistoryTextItemUpdateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HistoryTextItemUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageUseCreateInput"],
	update?: GraphQLTypes["ImageUseUpdateInput"],
	upsert?: GraphQLTypes["HistoryTextItemUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUseUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HistoryTextItemUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUseUpdateInput"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["HistoryTextListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["HistoryTextItemUniqueWhere"],
	update?: GraphQLTypes["HistoryTextItemWithoutListUpdateInput"],
	create?: GraphQLTypes["HistoryTextItemWithoutListCreateInput"]
};
	["HistoryCoverUpsertAnnotationsRelationInput"]: {
		update?: GraphQLTypes["HistoryTextListUpdateInput"],
	create?: GraphQLTypes["HistoryTextListCreateInput"]
};
	["HistoryPeriodUpsertCoverRelationInput"]: {
		update?: GraphQLTypes["HistoryCoverUpdateInput"],
	create?: GraphQLTypes["HistoryCoverCreateInput"]
};
	["HistoryPeriodUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["HistoryPeriodUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SeoUpdateInput"]: {
		title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	page?: GraphQLTypes["SeoUpdatePageEntityRelationInput"],
	twCard?: GraphQLTypes["SeoTwCard"],
	ogImage?: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SeoUpdatePageEntityRelationInput"]: {
		create?: GraphQLTypes["PageWithoutSeoCreateInput"],
	update?: GraphQLTypes["PageWithoutSeoUpdateInput"],
	upsert?: GraphQLTypes["SeoUpsertPageRelationInput"],
	connect?: GraphQLTypes["PageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["PageWithoutSeoUpdateInput"]: {
		title?: string,
	publishAt?: GraphQLTypes["DateTime"],
	createdAt?: GraphQLTypes["DateTime"],
	template?: GraphQLTypes["PageTemplate"],
	url?: GraphQLTypes["PageUpdateUrlEntityRelationInput"],
	content?: GraphQLTypes["PageUpdateContentEntityRelationInput"],
	subscriptionValidity?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["PageUpdateUrlEntityRelationInput"]: {
		create?: GraphQLTypes["UrlWithoutPageCreateInput"],
	update?: GraphQLTypes["UrlWithoutPageUpdateInput"],
	upsert?: GraphQLTypes["PageUpsertUrlRelationInput"],
	connect?: GraphQLTypes["UrlUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["UrlWithoutPageUpdateInput"]: {
		url?: string,
	article?: GraphQLTypes["UrlUpdateArticleEntityRelationInput"],
	author?: GraphQLTypes["UrlUpdateAuthorEntityRelationInput"],
	issue?: GraphQLTypes["UrlUpdateIssueEntityRelationInput"],
	category?: GraphQLTypes["UrlUpdateCategoryEntityRelationInput"],
	tag?: GraphQLTypes["UrlUpdateTagEntityRelationInput"],
	redirect?: string,
	_dummy_field_?: boolean
};
	["PageUpsertUrlRelationInput"]: {
		update?: GraphQLTypes["UrlWithoutPageUpdateInput"],
	create?: GraphQLTypes["UrlWithoutPageCreateInput"]
};
	["SeoUpsertPageRelationInput"]: {
		update?: GraphQLTypes["PageWithoutSeoUpdateInput"],
	create?: GraphQLTypes["PageWithoutSeoCreateInput"]
};
	["HistoryPeriodUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["ArticleHistoryPeriodUpsertHistoryPeriodRelationInput"]: {
		update?: GraphQLTypes["HistoryPeriodWithoutArticleHistoryPeriodUpdateInput"],
	create?: GraphQLTypes["HistoryPeriodWithoutArticleHistoryPeriodCreateInput"]
};
	["ArticleUpsertHistoryPeriodsRelationInput"]: {
		by?: GraphQLTypes["ArticleHistoryPeriodUniqueWhere"],
	update?: GraphQLTypes["ArticleHistoryPeriodWithoutArticleUpdateInput"],
	create?: GraphQLTypes["ArticleHistoryPeriodWithoutArticleCreateInput"]
};
	["ArticleTagUpsertArticleRelationInput"]: {
		update?: GraphQLTypes["ArticleWithoutTagsUpdateInput"],
	create?: GraphQLTypes["ArticleWithoutTagsCreateInput"]
};
	["TagUpsertArticleTagRelationInput"]: {
		by?: GraphQLTypes["ArticleTagUniqueWhere"],
	update?: GraphQLTypes["ArticleTagWithoutTagUpdateInput"],
	create?: GraphQLTypes["ArticleTagWithoutTagCreateInput"]
};
	["UrlUpsertTagRelationInput"]: {
		update?: GraphQLTypes["TagWithoutUrlUpdateInput"],
	create?: GraphQLTypes["TagWithoutUrlCreateInput"]
};
	["AuthorUpsertUrlRelationInput"]: {
		update?: GraphQLTypes["UrlWithoutAuthorUpdateInput"],
	create?: GraphQLTypes["UrlWithoutAuthorCreateInput"]
};
	["UserUpsertAuthorsRelationInput"]: {
		by?: GraphQLTypes["AuthorUniqueWhere"],
	update?: GraphQLTypes["AuthorWithoutUsersUpdateInput"],
	create?: GraphQLTypes["AuthorWithoutUsersCreateInput"]
};
	["UserUpdateAppReviewsEntityRelationInput"]: {
		create?: GraphQLTypes["AppReviewWithoutUserCreateInput"],
	update?: GraphQLTypes["UserUpdateAppReviewsRelationInput"],
	upsert?: GraphQLTypes["UserUpsertAppReviewsRelationInput"],
	connect?: GraphQLTypes["AppReviewUniqueWhere"],
	disconnect?: GraphQLTypes["AppReviewUniqueWhere"],
	delete?: GraphQLTypes["AppReviewUniqueWhere"],
	alias?: string
};
	["UserUpdateAppReviewsRelationInput"]: {
		by?: GraphQLTypes["AppReviewUniqueWhere"],
	data?: GraphQLTypes["AppReviewWithoutUserUpdateInput"]
};
	["AppReviewWithoutUserUpdateInput"]: {
		done?: boolean,
	deviceId?: string,
	createdAt?: GraphQLTypes["DateTime"],
	rating?: number,
	note?: string,
	_dummy_field_?: boolean
};
	["UserUpsertAppReviewsRelationInput"]: {
		by?: GraphQLTypes["AppReviewUniqueWhere"],
	update?: GraphQLTypes["AppReviewWithoutUserUpdateInput"],
	create?: GraphQLTypes["AppReviewWithoutUserCreateInput"]
};
	["UnlockedArticleUpsertUserRelationInput"]: {
		update?: GraphQLTypes["UserWithoutUnlockedArticlesUpdateInput"],
	create?: GraphQLTypes["UserWithoutUnlockedArticlesCreateInput"]
};
	["ArticleUpsertUnlockedRelationInput"]: {
		by?: GraphQLTypes["UnlockedArticleUniqueWhere"],
	update?: GraphQLTypes["UnlockedArticleWithoutArticleUpdateInput"],
	create?: GraphQLTypes["UnlockedArticleWithoutArticleCreateInput"]
};
	["ArticleUpdateTagsEntityRelationInput"]: {
		create?: GraphQLTypes["ArticleTagWithoutArticleCreateInput"],
	update?: GraphQLTypes["ArticleUpdateTagsRelationInput"],
	upsert?: GraphQLTypes["ArticleUpsertTagsRelationInput"],
	connect?: GraphQLTypes["ArticleTagUniqueWhere"],
	disconnect?: GraphQLTypes["ArticleTagUniqueWhere"],
	delete?: GraphQLTypes["ArticleTagUniqueWhere"],
	alias?: string
};
	["ArticleUpdateTagsRelationInput"]: {
		by?: GraphQLTypes["ArticleTagUniqueWhere"],
	data?: GraphQLTypes["ArticleTagWithoutArticleUpdateInput"]
};
	["ArticleTagWithoutArticleUpdateInput"]: {
		order?: number,
	tag?: GraphQLTypes["ArticleTagUpdateTagEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArticleTagUpdateTagEntityRelationInput"]: {
		create?: GraphQLTypes["TagWithoutArticleTagCreateInput"],
	update?: GraphQLTypes["TagWithoutArticleTagUpdateInput"],
	upsert?: GraphQLTypes["ArticleTagUpsertTagRelationInput"],
	connect?: GraphQLTypes["TagUniqueWhere"],
	delete?: boolean
};
	["TagWithoutArticleTagUpdateInput"]: {
		name?: string,
	useAsTagline?: boolean,
	url?: GraphQLTypes["TagUpdateUrlEntityRelationInput"],
	order?: string,
	legacyId?: string,
	_dummy_field_?: boolean
};
	["TagUpdateUrlEntityRelationInput"]: {
		create?: GraphQLTypes["UrlWithoutTagCreateInput"],
	update?: GraphQLTypes["UrlWithoutTagUpdateInput"],
	upsert?: GraphQLTypes["TagUpsertUrlRelationInput"],
	connect?: GraphQLTypes["UrlUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["UrlWithoutTagUpdateInput"]: {
		url?: string,
	article?: GraphQLTypes["UrlUpdateArticleEntityRelationInput"],
	author?: GraphQLTypes["UrlUpdateAuthorEntityRelationInput"],
	issue?: GraphQLTypes["UrlUpdateIssueEntityRelationInput"],
	page?: GraphQLTypes["UrlUpdatePageEntityRelationInput"],
	category?: GraphQLTypes["UrlUpdateCategoryEntityRelationInput"],
	redirect?: string,
	_dummy_field_?: boolean
};
	["TagUpsertUrlRelationInput"]: {
		update?: GraphQLTypes["UrlWithoutTagUpdateInput"],
	create?: GraphQLTypes["UrlWithoutTagCreateInput"]
};
	["ArticleTagUpsertTagRelationInput"]: {
		update?: GraphQLTypes["TagWithoutArticleTagUpdateInput"],
	create?: GraphQLTypes["TagWithoutArticleTagCreateInput"]
};
	["ArticleUpsertTagsRelationInput"]: {
		by?: GraphQLTypes["ArticleTagUniqueWhere"],
	update?: GraphQLTypes["ArticleTagWithoutArticleUpdateInput"],
	create?: GraphQLTypes["ArticleTagWithoutArticleCreateInput"]
};
	["ContentArticleUpsertArticleRelationInput"]: {
		update?: GraphQLTypes["ArticleWithoutContentBlocksUpdateInput"],
	create?: GraphQLTypes["ArticleWithoutContentBlocksCreateInput"]
};
	["ContentBlockUpsertArticlesRelationInput"]: {
		by?: GraphQLTypes["ContentArticleUniqueWhere"],
	update?: GraphQLTypes["ContentArticleWithoutContentBlockUpdateInput"],
	create?: GraphQLTypes["ContentArticleWithoutContentBlockCreateInput"]
};
	["ContentBlockUpdateSubscriptionFormEntityRelationInput"]: {
		create?: GraphQLTypes["SubscriptionFormWithoutContentBlockCreateInput"],
	update?: GraphQLTypes["SubscriptionFormWithoutContentBlockUpdateInput"],
	upsert?: GraphQLTypes["ContentBlockUpsertSubscriptionFormRelationInput"],
	connect?: GraphQLTypes["SubscriptionFormUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SubscriptionFormWithoutContentBlockUpdateInput"]: {
		name?: string,
	code?: string,
	createdAt?: GraphQLTypes["DateTime"],
	sections?: Array<GraphQLTypes["SubscriptionFormUpdateSectionsEntityRelationInput"]>,
	products?: Array<GraphQLTypes["SubscriptionFormUpdateProductsEntityRelationInput"]>,
	contentReferences?: Array<GraphQLTypes["SubscriptionFormUpdateContentReferencesEntityRelationInput"]>,
	validity?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["SubscriptionFormUpdateSectionsEntityRelationInput"]: {
		create?: GraphQLTypes["SubscriptionFormSectionWithoutFormCreateInput"],
	update?: GraphQLTypes["SubscriptionFormUpdateSectionsRelationInput"],
	upsert?: GraphQLTypes["SubscriptionFormUpsertSectionsRelationInput"],
	connect?: GraphQLTypes["SubscriptionFormSectionUniqueWhere"],
	disconnect?: GraphQLTypes["SubscriptionFormSectionUniqueWhere"],
	delete?: GraphQLTypes["SubscriptionFormSectionUniqueWhere"],
	alias?: string
};
	["SubscriptionFormUpdateSectionsRelationInput"]: {
		by?: GraphQLTypes["SubscriptionFormSectionUniqueWhere"],
	data?: GraphQLTypes["SubscriptionFormSectionWithoutFormUpdateInput"]
};
	["SubscriptionFormSectionWithoutFormUpdateInput"]: {
		order?: number,
	title?: string,
	inputs?: Array<GraphQLTypes["SubscriptionFormSectionUpdateInputsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["SubscriptionFormSectionUpdateInputsEntityRelationInput"]: {
		create?: GraphQLTypes["SubscriptionFormInputWithoutSectionCreateInput"],
	update?: GraphQLTypes["SubscriptionFormSectionUpdateInputsRelationInput"],
	upsert?: GraphQLTypes["SubscriptionFormSectionUpsertInputsRelationInput"],
	connect?: GraphQLTypes["SubscriptionFormInputUniqueWhere"],
	disconnect?: GraphQLTypes["SubscriptionFormInputUniqueWhere"],
	delete?: GraphQLTypes["SubscriptionFormInputUniqueWhere"],
	alias?: string
};
	["SubscriptionFormSectionUpdateInputsRelationInput"]: {
		by?: GraphQLTypes["SubscriptionFormInputUniqueWhere"],
	data?: GraphQLTypes["SubscriptionFormInputWithoutSectionUpdateInput"]
};
	["SubscriptionFormInputWithoutSectionUpdateInput"]: {
		order?: number,
	type?: GraphQLTypes["SubscriptionFormInputType"],
	image?: GraphQLTypes["SubscriptionFormInputUpdateImageEntityRelationInput"],
	options?: Array<GraphQLTypes["SubscriptionFormInputUpdateOptionsEntityRelationInput"]>,
	description?: GraphQLTypes["SubscriptionFormInputUpdateDescriptionEntityRelationInput"],
	required?: boolean,
	_dummy_field_?: boolean
};
	["SubscriptionFormInputUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageUseCreateInput"],
	update?: GraphQLTypes["ImageUseUpdateInput"],
	upsert?: GraphQLTypes["SubscriptionFormInputUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUseUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SubscriptionFormInputUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUseUpdateInput"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["SubscriptionFormInputUpdateOptionsEntityRelationInput"]: {
		create?: GraphQLTypes["SubscriptionFormOptionWithoutFormInputCreateInput"],
	update?: GraphQLTypes["SubscriptionFormInputUpdateOptionsRelationInput"],
	upsert?: GraphQLTypes["SubscriptionFormInputUpsertOptionsRelationInput"],
	connect?: GraphQLTypes["SubscriptionFormOptionUniqueWhere"],
	disconnect?: GraphQLTypes["SubscriptionFormOptionUniqueWhere"],
	delete?: GraphQLTypes["SubscriptionFormOptionUniqueWhere"],
	alias?: string
};
	["SubscriptionFormInputUpdateOptionsRelationInput"]: {
		by?: GraphQLTypes["SubscriptionFormOptionUniqueWhere"],
	data?: GraphQLTypes["SubscriptionFormOptionWithoutFormInputUpdateInput"]
};
	["SubscriptionFormOptionWithoutFormInputUpdateInput"]: {
		hasProductId?: boolean,
	order?: number,
	label?: string,
	priceTag?: string,
	priceTagWithDiscount?: string,
	products?: Array<GraphQLTypes["SubscriptionFormOptionUpdateProductsEntityRelationInput"]>,
	value?: string,
	internalLabel?: string,
	_dummy_field_?: boolean
};
	["SubscriptionFormOptionUpdateProductsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductWithoutFormOptionsCreateInput"],
	update?: GraphQLTypes["SubscriptionFormOptionUpdateProductsRelationInput"],
	upsert?: GraphQLTypes["SubscriptionFormOptionUpsertProductsRelationInput"],
	connect?: GraphQLTypes["ProductUniqueWhere"],
	disconnect?: GraphQLTypes["ProductUniqueWhere"],
	delete?: GraphQLTypes["ProductUniqueWhere"],
	alias?: string
};
	["SubscriptionFormOptionUpdateProductsRelationInput"]: {
		by?: GraphQLTypes["ProductUniqueWhere"],
	data?: GraphQLTypes["ProductWithoutFormOptionsUpdateInput"]
};
	["ProductWithoutFormOptionsUpdateInput"]: {
		price?: number,
	type?: GraphQLTypes["Types"],
	form?: GraphQLTypes["ProductUpdateFormEntityRelationInput"],
	productId?: string,
	_dummy_field_?: boolean
};
	["ProductUpdateFormEntityRelationInput"]: {
		create?: GraphQLTypes["SubscriptionFormWithoutProductsCreateInput"],
	update?: GraphQLTypes["SubscriptionFormWithoutProductsUpdateInput"],
	upsert?: GraphQLTypes["ProductUpsertFormRelationInput"],
	connect?: GraphQLTypes["SubscriptionFormUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SubscriptionFormWithoutProductsUpdateInput"]: {
		name?: string,
	code?: string,
	createdAt?: GraphQLTypes["DateTime"],
	sections?: Array<GraphQLTypes["SubscriptionFormUpdateSectionsEntityRelationInput"]>,
	contentBlock?: Array<GraphQLTypes["SubscriptionFormUpdateContentBlockEntityRelationInput"]>,
	contentReferences?: Array<GraphQLTypes["SubscriptionFormUpdateContentReferencesEntityRelationInput"]>,
	validity?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["SubscriptionFormUpdateContentBlockEntityRelationInput"]: {
		create?: GraphQLTypes["ContentBlockWithoutSubscriptionFormCreateInput"],
	update?: GraphQLTypes["SubscriptionFormUpdateContentBlockRelationInput"],
	upsert?: GraphQLTypes["SubscriptionFormUpsertContentBlockRelationInput"],
	connect?: GraphQLTypes["ContentBlockUniqueWhere"],
	disconnect?: GraphQLTypes["ContentBlockUniqueWhere"],
	delete?: GraphQLTypes["ContentBlockUniqueWhere"],
	alias?: string
};
	["SubscriptionFormUpdateContentBlockRelationInput"]: {
		by?: GraphQLTypes["ContentBlockUniqueWhere"],
	data?: GraphQLTypes["ContentBlockWithoutSubscriptionFormUpdateInput"]
};
	["ContentBlockWithoutSubscriptionFormUpdateInput"]: {
		order?: number,
	type?: GraphQLTypes["ContentBlockType"],
	youtubeId?: string,
	text?: string,
	targetLabel?: string,
	issue?: GraphQLTypes["ContentBlockUpdateIssueEntityRelationInput"],
	target?: GraphQLTypes["ContentBlockUpdateTargetEntityRelationInput"],
	articles?: Array<GraphQLTypes["ContentBlockUpdateArticlesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["SubscriptionFormUpsertContentBlockRelationInput"]: {
		by?: GraphQLTypes["ContentBlockUniqueWhere"],
	update?: GraphQLTypes["ContentBlockWithoutSubscriptionFormUpdateInput"],
	create?: GraphQLTypes["ContentBlockWithoutSubscriptionFormCreateInput"]
};
	["SubscriptionFormUpdateContentReferencesEntityRelationInput"]: {
		create?: GraphQLTypes["ContentReferenceWithoutSubscriptionFormCreateInput"],
	update?: GraphQLTypes["SubscriptionFormUpdateContentReferencesRelationInput"],
	upsert?: GraphQLTypes["SubscriptionFormUpsertContentReferencesRelationInput"],
	connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	disconnect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	delete?: GraphQLTypes["ContentReferenceUniqueWhere"],
	alias?: string
};
	["SubscriptionFormUpdateContentReferencesRelationInput"]: {
		by?: GraphQLTypes["ContentReferenceUniqueWhere"],
	data?: GraphQLTypes["ContentReferenceWithoutSubscriptionFormUpdateInput"]
};
	["ContentReferenceWithoutSubscriptionFormUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"],
	contentPart?: GraphQLTypes["ContentReferenceUpdateContentPartEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	variant?: GraphQLTypes["ContentReferenceVariant"],
	color?: string,
	embed?: GraphQLTypes["ContentReferenceUpdateEmbedEntityRelationInput"],
	article?: GraphQLTypes["ContentReferenceUpdateArticleEntityRelationInput"],
	audio?: GraphQLTypes["ContentReferenceUpdateAudioEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"],
	images?: Array<GraphQLTypes["ContentReferenceUpdateImagesEntityRelationInput"]>,
	pollAnswer?: GraphQLTypes["ContentReferenceUpdatePollAnswerEntityRelationInput"],
	listicle?: Array<GraphQLTypes["ContentReferenceUpdateListicleEntityRelationInput"]>,
	faq?: Array<GraphQLTypes["ContentReferenceUpdateFaqEntityRelationInput"]>,
	links?: Array<GraphQLTypes["ContentReferenceUpdateLinksEntityRelationInput"]>,
	awards?: Array<GraphQLTypes["ContentReferenceUpdateAwardsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ContentReferenceUpdateReviewsEntityRelationInput"]>,
	target?: GraphQLTypes["ContentReferenceUpdateTargetEntityRelationInput"],
	buttons?: Array<GraphQLTypes["ContentReferenceUpdateButtonsEntityRelationInput"]>,
	sharedContent?: GraphQLTypes["ContentReferenceUpdateSharedContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceUpdateContentPartEntityRelationInput"]: {
		create?: GraphQLTypes["ContentPartWithoutReferencesCreateInput"],
	update?: GraphQLTypes["ContentPartWithoutReferencesUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertContentPartRelationInput"],
	connect?: GraphQLTypes["ContentPartUniqueWhere"],
	delete?: boolean
};
	["ContentPartWithoutReferencesUpdateInput"]: {
		order?: number,
	json?: string,
	content?: GraphQLTypes["ContentPartUpdateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentPartUpdateContentEntityRelationInput"]: {
		create?: GraphQLTypes["ContentWithoutPartsCreateInput"],
	update?: GraphQLTypes["ContentWithoutPartsUpdateInput"],
	upsert?: GraphQLTypes["ContentPartUpsertContentRelationInput"],
	connect?: GraphQLTypes["ContentUniqueWhere"],
	delete?: boolean
};
	["ContentWithoutPartsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["ContentPartUpsertContentRelationInput"]: {
		update?: GraphQLTypes["ContentWithoutPartsUpdateInput"],
	create?: GraphQLTypes["ContentWithoutPartsCreateInput"]
};
	["ContentReferenceUpsertContentPartRelationInput"]: {
		update?: GraphQLTypes["ContentPartWithoutReferencesUpdateInput"],
	create?: GraphQLTypes["ContentPartWithoutReferencesCreateInput"]
};
	["ContentReferenceUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageUseCreateInput"],
	update?: GraphQLTypes["ImageUseUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUseUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentReferenceUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUseUpdateInput"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["ContentReferenceUpdateImagesEntityRelationInput"]: {
		create?: GraphQLTypes["ImageContentWithoutContentReferenceCreateInput"],
	update?: GraphQLTypes["ContentReferenceUpdateImagesRelationInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertImagesRelationInput"],
	connect?: GraphQLTypes["ImageContentUniqueWhere"],
	disconnect?: GraphQLTypes["ImageContentUniqueWhere"],
	delete?: GraphQLTypes["ImageContentUniqueWhere"],
	alias?: string
};
	["ContentReferenceUpdateImagesRelationInput"]: {
		by?: GraphQLTypes["ImageContentUniqueWhere"],
	data?: GraphQLTypes["ImageContentWithoutContentReferenceUpdateInput"]
};
	["ImageContentWithoutContentReferenceUpdateInput"]: {
		order?: number,
	image?: GraphQLTypes["ImageContentUpdateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ImageContentUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageUseCreateInput"],
	update?: GraphQLTypes["ImageUseUpdateInput"],
	upsert?: GraphQLTypes["ImageContentUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUseUniqueWhere"],
	delete?: boolean
};
	["ImageContentUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUseUpdateInput"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["ContentReferenceUpsertImagesRelationInput"]: {
		by?: GraphQLTypes["ImageContentUniqueWhere"],
	update?: GraphQLTypes["ImageContentWithoutContentReferenceUpdateInput"],
	create?: GraphQLTypes["ImageContentWithoutContentReferenceCreateInput"]
};
	["ContentReferenceUpdatePollAnswerEntityRelationInput"]: {
		create?: GraphQLTypes["PollAnswerCreateInput"],
	update?: GraphQLTypes["PollAnswerUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertPollAnswerRelationInput"],
	connect?: GraphQLTypes["PollAnswerUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["PollAnswerUpdateInput"]: {
		authorName?: string,
	authorPosition?: string,
	text?: string,
	authorImage?: GraphQLTypes["PollAnswerUpdateAuthorImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PollAnswerUpdateAuthorImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageUseCreateInput"],
	update?: GraphQLTypes["ImageUseUpdateInput"],
	upsert?: GraphQLTypes["PollAnswerUpsertAuthorImageRelationInput"],
	connect?: GraphQLTypes["ImageUseUniqueWhere"]
};
	["PollAnswerUpsertAuthorImageRelationInput"]: {
		update?: GraphQLTypes["ImageUseUpdateInput"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["ContentReferenceUpsertPollAnswerRelationInput"]: {
		update?: GraphQLTypes["PollAnswerUpdateInput"],
	create?: GraphQLTypes["PollAnswerCreateInput"]
};
	["ContentReferenceUpdateListicleEntityRelationInput"]: {
		create?: GraphQLTypes["ListicleWithoutContentReferenceCreateInput"],
	update?: GraphQLTypes["ContentReferenceUpdateListicleRelationInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertListicleRelationInput"],
	connect?: GraphQLTypes["ListicleUniqueWhere"],
	disconnect?: GraphQLTypes["ListicleUniqueWhere"],
	delete?: GraphQLTypes["ListicleUniqueWhere"],
	alias?: string
};
	["ContentReferenceUpdateListicleRelationInput"]: {
		by?: GraphQLTypes["ListicleUniqueWhere"],
	data?: GraphQLTypes["ListicleWithoutContentReferenceUpdateInput"]
};
	["ListicleWithoutContentReferenceUpdateInput"]: {
		order?: number,
	primaryText?: string,
	image?: GraphQLTypes["ListicleUpdateImageEntityRelationInput"],
	target?: GraphQLTypes["ListicleUpdateTargetEntityRelationInput"],
	content?: GraphQLTypes["ListicleUpdateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ListicleUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageUseCreateInput"],
	update?: GraphQLTypes["ImageUseUpdateInput"],
	upsert?: GraphQLTypes["ListicleUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUseUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ListicleUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUseUpdateInput"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["ListicleUpdateTargetEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["ListicleUpsertTargetRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ListicleUpsertTargetRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["ListicleUpdateContentEntityRelationInput"]: {
		create?: GraphQLTypes["ContentCreateInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["ListicleUpsertContentRelationInput"],
	connect?: GraphQLTypes["ContentUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ListicleUpsertContentRelationInput"]: {
		update?: GraphQLTypes["ContentUpdateInput"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["ContentReferenceUpsertListicleRelationInput"]: {
		by?: GraphQLTypes["ListicleUniqueWhere"],
	update?: GraphQLTypes["ListicleWithoutContentReferenceUpdateInput"],
	create?: GraphQLTypes["ListicleWithoutContentReferenceCreateInput"]
};
	["ContentReferenceUpdateFaqEntityRelationInput"]: {
		create?: GraphQLTypes["FAQWithoutContentReferenceCreateInput"],
	update?: GraphQLTypes["ContentReferenceUpdateFaqRelationInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertFaqRelationInput"],
	connect?: GraphQLTypes["FAQUniqueWhere"],
	disconnect?: GraphQLTypes["FAQUniqueWhere"],
	delete?: GraphQLTypes["FAQUniqueWhere"],
	alias?: string
};
	["ContentReferenceUpdateFaqRelationInput"]: {
		by?: GraphQLTypes["FAQUniqueWhere"],
	data?: GraphQLTypes["FAQWithoutContentReferenceUpdateInput"]
};
	["FAQWithoutContentReferenceUpdateInput"]: {
		order?: number,
	answer?: string,
	question?: string,
	_dummy_field_?: boolean
};
	["ContentReferenceUpsertFaqRelationInput"]: {
		by?: GraphQLTypes["FAQUniqueWhere"],
	update?: GraphQLTypes["FAQWithoutContentReferenceUpdateInput"],
	create?: GraphQLTypes["FAQWithoutContentReferenceCreateInput"]
};
	["ContentReferenceUpdateLinksEntityRelationInput"]: {
		create?: GraphQLTypes["LinkContentWithoutContentReferenceCreateInput"],
	update?: GraphQLTypes["ContentReferenceUpdateLinksRelationInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertLinksRelationInput"],
	connect?: GraphQLTypes["LinkContentUniqueWhere"],
	disconnect?: GraphQLTypes["LinkContentUniqueWhere"],
	delete?: GraphQLTypes["LinkContentUniqueWhere"],
	alias?: string
};
	["ContentReferenceUpdateLinksRelationInput"]: {
		by?: GraphQLTypes["LinkContentUniqueWhere"],
	data?: GraphQLTypes["LinkContentWithoutContentReferenceUpdateInput"]
};
	["LinkContentWithoutContentReferenceUpdateInput"]: {
		order?: number,
	text?: string,
	target?: GraphQLTypes["LinkContentUpdateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkContentUpdateTargetEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["LinkContentUpsertTargetRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"]
};
	["LinkContentUpsertTargetRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["ContentReferenceUpsertLinksRelationInput"]: {
		by?: GraphQLTypes["LinkContentUniqueWhere"],
	update?: GraphQLTypes["LinkContentWithoutContentReferenceUpdateInput"],
	create?: GraphQLTypes["LinkContentWithoutContentReferenceCreateInput"]
};
	["ContentReferenceUpdateAwardsEntityRelationInput"]: {
		create?: GraphQLTypes["AwardContentWithoutContentReferenceCreateInput"],
	update?: GraphQLTypes["ContentReferenceUpdateAwardsRelationInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertAwardsRelationInput"],
	connect?: GraphQLTypes["AwardContentUniqueWhere"],
	disconnect?: GraphQLTypes["AwardContentUniqueWhere"],
	delete?: GraphQLTypes["AwardContentUniqueWhere"],
	alias?: string
};
	["ContentReferenceUpdateAwardsRelationInput"]: {
		by?: GraphQLTypes["AwardContentUniqueWhere"],
	data?: GraphQLTypes["AwardContentWithoutContentReferenceUpdateInput"]
};
	["AwardContentWithoutContentReferenceUpdateInput"]: {
		order?: number,
	image?: GraphQLTypes["AwardContentUpdateImageEntityRelationInput"],
	target?: GraphQLTypes["AwardContentUpdateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["AwardContentUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageUseCreateInput"],
	update?: GraphQLTypes["ImageUseUpdateInput"],
	upsert?: GraphQLTypes["AwardContentUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUseUniqueWhere"]
};
	["AwardContentUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUseUpdateInput"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["AwardContentUpdateTargetEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["AwardContentUpsertTargetRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"]
};
	["AwardContentUpsertTargetRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["ContentReferenceUpsertAwardsRelationInput"]: {
		by?: GraphQLTypes["AwardContentUniqueWhere"],
	update?: GraphQLTypes["AwardContentWithoutContentReferenceUpdateInput"],
	create?: GraphQLTypes["AwardContentWithoutContentReferenceCreateInput"]
};
	["ContentReferenceUpdateReviewsEntityRelationInput"]: {
		create?: GraphQLTypes["ReviewContentWithoutContentReferenceCreateInput"],
	update?: GraphQLTypes["ContentReferenceUpdateReviewsRelationInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertReviewsRelationInput"],
	connect?: GraphQLTypes["ReviewContentUniqueWhere"],
	disconnect?: GraphQLTypes["ReviewContentUniqueWhere"],
	delete?: GraphQLTypes["ReviewContentUniqueWhere"],
	alias?: string
};
	["ContentReferenceUpdateReviewsRelationInput"]: {
		by?: GraphQLTypes["ReviewContentUniqueWhere"],
	data?: GraphQLTypes["ReviewContentWithoutContentReferenceUpdateInput"]
};
	["ReviewContentWithoutContentReferenceUpdateInput"]: {
		order?: number,
	text?: string,
	_dummy_field_?: boolean
};
	["ContentReferenceUpsertReviewsRelationInput"]: {
		by?: GraphQLTypes["ReviewContentUniqueWhere"],
	update?: GraphQLTypes["ReviewContentWithoutContentReferenceUpdateInput"],
	create?: GraphQLTypes["ReviewContentWithoutContentReferenceCreateInput"]
};
	["ContentReferenceUpdateTargetEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertTargetRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentReferenceUpsertTargetRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["ContentReferenceUpdateButtonsEntityRelationInput"]: {
		create?: GraphQLTypes["ButtonWithoutContentReferenceCreateInput"],
	update?: GraphQLTypes["ContentReferenceUpdateButtonsRelationInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertButtonsRelationInput"],
	connect?: GraphQLTypes["ButtonUniqueWhere"],
	disconnect?: GraphQLTypes["ButtonUniqueWhere"],
	delete?: GraphQLTypes["ButtonUniqueWhere"],
	alias?: string
};
	["ContentReferenceUpdateButtonsRelationInput"]: {
		by?: GraphQLTypes["ButtonUniqueWhere"],
	data?: GraphQLTypes["ButtonWithoutContentReferenceUpdateInput"]
};
	["ButtonWithoutContentReferenceUpdateInput"]: {
		order?: number,
	type?: GraphQLTypes["ButtonType"],
	label?: string,
	target?: GraphQLTypes["ButtonUpdateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ButtonUpdateTargetEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["ButtonUpsertTargetRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ButtonUpsertTargetRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["ContentReferenceUpsertButtonsRelationInput"]: {
		by?: GraphQLTypes["ButtonUniqueWhere"],
	update?: GraphQLTypes["ButtonWithoutContentReferenceUpdateInput"],
	create?: GraphQLTypes["ButtonWithoutContentReferenceCreateInput"]
};
	["ContentReferenceUpdateSharedContentEntityRelationInput"]: {
		create?: GraphQLTypes["SharedContentWithoutContentReferenceCreateInput"],
	update?: GraphQLTypes["SharedContentWithoutContentReferenceUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertSharedContentRelationInput"],
	connect?: GraphQLTypes["SharedContentUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SharedContentWithoutContentReferenceUpdateInput"]: {
		name?: string,
	content?: GraphQLTypes["SharedContentUpdateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SharedContentUpdateContentEntityRelationInput"]: {
		create?: GraphQLTypes["ContentCreateInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["SharedContentUpsertContentRelationInput"],
	connect?: GraphQLTypes["ContentUniqueWhere"]
};
	["SharedContentUpsertContentRelationInput"]: {
		update?: GraphQLTypes["ContentUpdateInput"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["ContentReferenceUpsertSharedContentRelationInput"]: {
		update?: GraphQLTypes["SharedContentWithoutContentReferenceUpdateInput"],
	create?: GraphQLTypes["SharedContentWithoutContentReferenceCreateInput"]
};
	["SubscriptionFormUpsertContentReferencesRelationInput"]: {
		by?: GraphQLTypes["ContentReferenceUniqueWhere"],
	update?: GraphQLTypes["ContentReferenceWithoutSubscriptionFormUpdateInput"],
	create?: GraphQLTypes["ContentReferenceWithoutSubscriptionFormCreateInput"]
};
	["ProductUpsertFormRelationInput"]: {
		update?: GraphQLTypes["SubscriptionFormWithoutProductsUpdateInput"],
	create?: GraphQLTypes["SubscriptionFormWithoutProductsCreateInput"]
};
	["SubscriptionFormOptionUpsertProductsRelationInput"]: {
		by?: GraphQLTypes["ProductUniqueWhere"],
	update?: GraphQLTypes["ProductWithoutFormOptionsUpdateInput"],
	create?: GraphQLTypes["ProductWithoutFormOptionsCreateInput"]
};
	["SubscriptionFormInputUpsertOptionsRelationInput"]: {
		by?: GraphQLTypes["SubscriptionFormOptionUniqueWhere"],
	update?: GraphQLTypes["SubscriptionFormOptionWithoutFormInputUpdateInput"],
	create?: GraphQLTypes["SubscriptionFormOptionWithoutFormInputCreateInput"]
};
	["SubscriptionFormInputUpdateDescriptionEntityRelationInput"]: {
		create?: GraphQLTypes["ContentCreateInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["SubscriptionFormInputUpsertDescriptionRelationInput"],
	connect?: GraphQLTypes["ContentUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SubscriptionFormInputUpsertDescriptionRelationInput"]: {
		update?: GraphQLTypes["ContentUpdateInput"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["SubscriptionFormSectionUpsertInputsRelationInput"]: {
		by?: GraphQLTypes["SubscriptionFormInputUniqueWhere"],
	update?: GraphQLTypes["SubscriptionFormInputWithoutSectionUpdateInput"],
	create?: GraphQLTypes["SubscriptionFormInputWithoutSectionCreateInput"]
};
	["SubscriptionFormUpsertSectionsRelationInput"]: {
		by?: GraphQLTypes["SubscriptionFormSectionUniqueWhere"],
	update?: GraphQLTypes["SubscriptionFormSectionWithoutFormUpdateInput"],
	create?: GraphQLTypes["SubscriptionFormSectionWithoutFormCreateInput"]
};
	["SubscriptionFormUpdateProductsEntityRelationInput"]: {
		create?: GraphQLTypes["ProductWithoutFormCreateInput"],
	update?: GraphQLTypes["SubscriptionFormUpdateProductsRelationInput"],
	upsert?: GraphQLTypes["SubscriptionFormUpsertProductsRelationInput"],
	connect?: GraphQLTypes["ProductUniqueWhere"],
	disconnect?: GraphQLTypes["ProductUniqueWhere"],
	delete?: GraphQLTypes["ProductUniqueWhere"],
	alias?: string
};
	["SubscriptionFormUpdateProductsRelationInput"]: {
		by?: GraphQLTypes["ProductUniqueWhere"],
	data?: GraphQLTypes["ProductWithoutFormUpdateInput"]
};
	["ProductWithoutFormUpdateInput"]: {
		price?: number,
	type?: GraphQLTypes["Types"],
	formOptions?: Array<GraphQLTypes["ProductUpdateFormOptionsEntityRelationInput"]>,
	productId?: string,
	_dummy_field_?: boolean
};
	["ProductUpdateFormOptionsEntityRelationInput"]: {
		create?: GraphQLTypes["SubscriptionFormOptionWithoutProductsCreateInput"],
	update?: GraphQLTypes["ProductUpdateFormOptionsRelationInput"],
	upsert?: GraphQLTypes["ProductUpsertFormOptionsRelationInput"],
	connect?: GraphQLTypes["SubscriptionFormOptionUniqueWhere"],
	disconnect?: GraphQLTypes["SubscriptionFormOptionUniqueWhere"],
	delete?: GraphQLTypes["SubscriptionFormOptionUniqueWhere"],
	alias?: string
};
	["ProductUpdateFormOptionsRelationInput"]: {
		by?: GraphQLTypes["SubscriptionFormOptionUniqueWhere"],
	data?: GraphQLTypes["SubscriptionFormOptionWithoutProductsUpdateInput"]
};
	["SubscriptionFormOptionWithoutProductsUpdateInput"]: {
		hasProductId?: boolean,
	order?: number,
	label?: string,
	priceTag?: string,
	priceTagWithDiscount?: string,
	formInput?: GraphQLTypes["SubscriptionFormOptionUpdateFormInputEntityRelationInput"],
	value?: string,
	internalLabel?: string,
	_dummy_field_?: boolean
};
	["SubscriptionFormOptionUpdateFormInputEntityRelationInput"]: {
		create?: GraphQLTypes["SubscriptionFormInputWithoutOptionsCreateInput"],
	update?: GraphQLTypes["SubscriptionFormInputWithoutOptionsUpdateInput"],
	upsert?: GraphQLTypes["SubscriptionFormOptionUpsertFormInputRelationInput"],
	connect?: GraphQLTypes["SubscriptionFormInputUniqueWhere"],
	delete?: boolean
};
	["SubscriptionFormInputWithoutOptionsUpdateInput"]: {
		order?: number,
	type?: GraphQLTypes["SubscriptionFormInputType"],
	image?: GraphQLTypes["SubscriptionFormInputUpdateImageEntityRelationInput"],
	section?: GraphQLTypes["SubscriptionFormInputUpdateSectionEntityRelationInput"],
	description?: GraphQLTypes["SubscriptionFormInputUpdateDescriptionEntityRelationInput"],
	required?: boolean,
	_dummy_field_?: boolean
};
	["SubscriptionFormInputUpdateSectionEntityRelationInput"]: {
		create?: GraphQLTypes["SubscriptionFormSectionWithoutInputsCreateInput"],
	update?: GraphQLTypes["SubscriptionFormSectionWithoutInputsUpdateInput"],
	upsert?: GraphQLTypes["SubscriptionFormInputUpsertSectionRelationInput"],
	connect?: GraphQLTypes["SubscriptionFormSectionUniqueWhere"],
	delete?: boolean
};
	["SubscriptionFormSectionWithoutInputsUpdateInput"]: {
		order?: number,
	title?: string,
	form?: GraphQLTypes["SubscriptionFormSectionUpdateFormEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SubscriptionFormSectionUpdateFormEntityRelationInput"]: {
		create?: GraphQLTypes["SubscriptionFormWithoutSectionsCreateInput"],
	update?: GraphQLTypes["SubscriptionFormWithoutSectionsUpdateInput"],
	upsert?: GraphQLTypes["SubscriptionFormSectionUpsertFormRelationInput"],
	connect?: GraphQLTypes["SubscriptionFormUniqueWhere"],
	delete?: boolean
};
	["SubscriptionFormWithoutSectionsUpdateInput"]: {
		name?: string,
	code?: string,
	createdAt?: GraphQLTypes["DateTime"],
	contentBlock?: Array<GraphQLTypes["SubscriptionFormUpdateContentBlockEntityRelationInput"]>,
	products?: Array<GraphQLTypes["SubscriptionFormUpdateProductsEntityRelationInput"]>,
	contentReferences?: Array<GraphQLTypes["SubscriptionFormUpdateContentReferencesEntityRelationInput"]>,
	validity?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["SubscriptionFormSectionUpsertFormRelationInput"]: {
		update?: GraphQLTypes["SubscriptionFormWithoutSectionsUpdateInput"],
	create?: GraphQLTypes["SubscriptionFormWithoutSectionsCreateInput"]
};
	["SubscriptionFormInputUpsertSectionRelationInput"]: {
		update?: GraphQLTypes["SubscriptionFormSectionWithoutInputsUpdateInput"],
	create?: GraphQLTypes["SubscriptionFormSectionWithoutInputsCreateInput"]
};
	["SubscriptionFormOptionUpsertFormInputRelationInput"]: {
		update?: GraphQLTypes["SubscriptionFormInputWithoutOptionsUpdateInput"],
	create?: GraphQLTypes["SubscriptionFormInputWithoutOptionsCreateInput"]
};
	["ProductUpsertFormOptionsRelationInput"]: {
		by?: GraphQLTypes["SubscriptionFormOptionUniqueWhere"],
	update?: GraphQLTypes["SubscriptionFormOptionWithoutProductsUpdateInput"],
	create?: GraphQLTypes["SubscriptionFormOptionWithoutProductsCreateInput"]
};
	["SubscriptionFormUpsertProductsRelationInput"]: {
		by?: GraphQLTypes["ProductUniqueWhere"],
	update?: GraphQLTypes["ProductWithoutFormUpdateInput"],
	create?: GraphQLTypes["ProductWithoutFormCreateInput"]
};
	["ContentBlockUpsertSubscriptionFormRelationInput"]: {
		update?: GraphQLTypes["SubscriptionFormWithoutContentBlockUpdateInput"],
	create?: GraphQLTypes["SubscriptionFormWithoutContentBlockCreateInput"]
};
	["IssueUpsertBlocksRelationInput"]: {
		by?: GraphQLTypes["ContentBlockUniqueWhere"],
	update?: GraphQLTypes["ContentBlockWithoutIssueUpdateInput"],
	create?: GraphQLTypes["ContentBlockWithoutIssueCreateInput"]
};
	["IssueUpdateCoverPhotoEntityRelationInput"]: {
		create?: GraphQLTypes["ImageUseCreateInput"],
	update?: GraphQLTypes["ImageUseUpdateInput"],
	upsert?: GraphQLTypes["IssueUpsertCoverPhotoRelationInput"],
	connect?: GraphQLTypes["ImageUseUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["IssueUpsertCoverPhotoRelationInput"]: {
		update?: GraphQLTypes["ImageUseUpdateInput"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["IssueUpdatePrintTargetEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["IssueUpsertPrintTargetRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["IssueUpsertPrintTargetRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["IssueUpdateBackgroundPhotoEntityRelationInput"]: {
		create?: GraphQLTypes["ImageUseCreateInput"],
	update?: GraphQLTypes["ImageUseUpdateInput"],
	upsert?: GraphQLTypes["IssueUpsertBackgroundPhotoRelationInput"],
	connect?: GraphQLTypes["ImageUseUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["IssueUpsertBackgroundPhotoRelationInput"]: {
		update?: GraphQLTypes["ImageUseUpdateInput"],
	create?: GraphQLTypes["ImageUseCreateInput"]
};
	["IssueArticleUpsertIssueRelationInput"]: {
		update?: GraphQLTypes["IssueWithoutArticlesUpdateInput"],
	create?: GraphQLTypes["IssueWithoutArticlesCreateInput"]
};
	["ArticleUpsertIssuesRelationInput"]: {
		by?: GraphQLTypes["IssueArticleUniqueWhere"],
	update?: GraphQLTypes["IssueArticleWithoutArticleUpdateInput"],
	create?: GraphQLTypes["IssueArticleWithoutArticleCreateInput"]
};
	["ArticleCategoryUpsertArticleRelationInput"]: {
		update?: GraphQLTypes["ArticleWithoutCategoriesUpdateInput"],
	create?: GraphQLTypes["ArticleWithoutCategoriesCreateInput"]
};
	["CategoryUpsertArticleCategoryRelationInput"]: {
		by?: GraphQLTypes["ArticleCategoryUniqueWhere"],
	update?: GraphQLTypes["ArticleCategoryWithoutCategoryUpdateInput"],
	create?: GraphQLTypes["ArticleCategoryWithoutCategoryCreateInput"]
};
	["UrlUpsertCategoryRelationInput"]: {
		update?: GraphQLTypes["CategoryWithoutUrlUpdateInput"],
	create?: GraphQLTypes["CategoryWithoutUrlCreateInput"]
};
	["IssueUpsertUrlRelationInput"]: {
		update?: GraphQLTypes["UrlWithoutIssueUpdateInput"],
	create?: GraphQLTypes["UrlWithoutIssueCreateInput"]
};
	["ContentBlockUpsertIssueRelationInput"]: {
		update?: GraphQLTypes["IssueWithoutBlocksUpdateInput"],
	create?: GraphQLTypes["IssueWithoutBlocksCreateInput"]
};
	["ContentArticleUpsertContentBlockRelationInput"]: {
		update?: GraphQLTypes["ContentBlockWithoutArticlesUpdateInput"],
	create?: GraphQLTypes["ContentBlockWithoutArticlesCreateInput"]
};
	["ArticleUpsertContentBlocksRelationInput"]: {
		by?: GraphQLTypes["ContentArticleUniqueWhere"],
	update?: GraphQLTypes["ContentArticleWithoutArticleUpdateInput"],
	create?: GraphQLTypes["ContentArticleWithoutArticleCreateInput"]
};
	["IssueArticleUpsertArticleRelationInput"]: {
		update?: GraphQLTypes["ArticleWithoutIssuesUpdateInput"],
	create?: GraphQLTypes["ArticleWithoutIssuesCreateInput"]
};
	["IssueUpsertArticlesRelationInput"]: {
		by?: GraphQLTypes["IssueArticleUniqueWhere"],
	update?: GraphQLTypes["IssueArticleWithoutIssueUpdateInput"],
	create?: GraphQLTypes["IssueArticleWithoutIssueCreateInput"]
};
	["UrlUpsertIssueRelationInput"]: {
		update?: GraphQLTypes["IssueWithoutUrlUpdateInput"],
	create?: GraphQLTypes["IssueWithoutUrlCreateInput"]
};
	["CategoryUpsertUrlRelationInput"]: {
		update?: GraphQLTypes["UrlWithoutCategoryUpdateInput"],
	create?: GraphQLTypes["UrlWithoutCategoryCreateInput"]
};
	["ArticleCategoryUpsertCategoryRelationInput"]: {
		update?: GraphQLTypes["CategoryWithoutArticleCategoryUpdateInput"],
	create?: GraphQLTypes["CategoryWithoutArticleCategoryCreateInput"]
};
	["ArticleUpsertCategoriesRelationInput"]: {
		by?: GraphQLTypes["ArticleCategoryUniqueWhere"],
	update?: GraphQLTypes["ArticleCategoryWithoutArticleUpdateInput"],
	create?: GraphQLTypes["ArticleCategoryWithoutArticleCreateInput"]
};
	["UrlUpsertArticleRelationInput"]: {
		update?: GraphQLTypes["ArticleWithoutUrlUpdateInput"],
	create?: GraphQLTypes["ArticleWithoutUrlCreateInput"]
};
	["LinkUpsertInternalTargetRelationInput"]: {
		update?: GraphQLTypes["UrlUpdateInput"],
	create?: GraphQLTypes["UrlCreateInput"]
};
	["TextContentReferenceUpsertTargetRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["TextContentPartUpsertReferencesRelationInput"]: {
		by?: GraphQLTypes["TextContentReferenceUniqueWhere"],
	update?: GraphQLTypes["TextContentReferenceWithoutContentPartUpdateInput"],
	create?: GraphQLTypes["TextContentReferenceWithoutContentPartCreateInput"]
};
	["TextContentUpsertPartsRelationInput"]: {
		by?: GraphQLTypes["TextContentPartUniqueWhere"],
	update?: GraphQLTypes["TextContentPartWithoutContentUpdateInput"],
	create?: GraphQLTypes["TextContentPartWithoutContentCreateInput"]
};
	["ArticleUpsertSubtitleRelationInput"]: {
		update?: GraphQLTypes["TextContentUpdateInput"],
	create?: GraphQLTypes["TextContentCreateInput"]
};
	["UnlockedArticleUpsertArticleRelationInput"]: {
		update?: GraphQLTypes["ArticleWithoutUnlockedUpdateInput"],
	create?: GraphQLTypes["ArticleWithoutUnlockedCreateInput"]
};
	["UserUpsertUnlockedArticlesRelationInput"]: {
		by?: GraphQLTypes["UnlockedArticleUniqueWhere"],
	update?: GraphQLTypes["UnlockedArticleWithoutUserUpdateInput"],
	create?: GraphQLTypes["UnlockedArticleWithoutUserCreateInput"]
};
	["AuthorUpsertUsersRelationInput"]: {
		by?: GraphQLTypes["UserUniqueWhere"],
	update?: GraphQLTypes["UserWithoutAuthorsUpdateInput"],
	create?: GraphQLTypes["UserWithoutAuthorsCreateInput"]
};
	["AudioUpsertAuthorRelationInput"]: {
		update?: GraphQLTypes["AuthorUpdateInput"],
	create?: GraphQLTypes["AuthorCreateInput"]
};
	["AudioUseUpsertAudioRelationInput"]: {
		update?: GraphQLTypes["AudioWithoutUsesUpdateInput"],
	create?: GraphQLTypes["AudioWithoutUsesCreateInput"]
};
	["ContentReferenceUpsertAudioRelationInput"]: {
		update?: GraphQLTypes["AudioUseUpdateInput"],
	create?: GraphQLTypes["AudioUseCreateInput"]
};
	["ContentReferenceUpdateSubscriptionFormEntityRelationInput"]: {
		create?: GraphQLTypes["SubscriptionFormWithoutContentReferencesCreateInput"],
	update?: GraphQLTypes["SubscriptionFormWithoutContentReferencesUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertSubscriptionFormRelationInput"],
	connect?: GraphQLTypes["SubscriptionFormUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SubscriptionFormWithoutContentReferencesUpdateInput"]: {
		name?: string,
	code?: string,
	createdAt?: GraphQLTypes["DateTime"],
	sections?: Array<GraphQLTypes["SubscriptionFormUpdateSectionsEntityRelationInput"]>,
	contentBlock?: Array<GraphQLTypes["SubscriptionFormUpdateContentBlockEntityRelationInput"]>,
	products?: Array<GraphQLTypes["SubscriptionFormUpdateProductsEntityRelationInput"]>,
	validity?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["ContentReferenceUpsertSubscriptionFormRelationInput"]: {
		update?: GraphQLTypes["SubscriptionFormWithoutContentReferencesUpdateInput"],
	create?: GraphQLTypes["SubscriptionFormWithoutContentReferencesCreateInput"]
};
	["ContentPartUpsertReferencesRelationInput"]: {
		by?: GraphQLTypes["ContentReferenceUniqueWhere"],
	update?: GraphQLTypes["ContentReferenceWithoutContentPartUpdateInput"],
	create?: GraphQLTypes["ContentReferenceWithoutContentPartCreateInput"]
};
	["ContentUpsertPartsRelationInput"]: {
		by?: GraphQLTypes["ContentPartUniqueWhere"],
	update?: GraphQLTypes["ContentPartWithoutContentUpdateInput"],
	create?: GraphQLTypes["ContentPartWithoutContentCreateInput"]
};
	["AuthorUpsertAboutRelationInput"]: {
		update?: GraphQLTypes["ContentUpdateInput"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["UrlUpsertAuthorRelationInput"]: {
		update?: GraphQLTypes["AuthorWithoutUrlUpdateInput"],
	create?: GraphQLTypes["AuthorWithoutUrlCreateInput"]
};
	["ArticleUpsertUrlRelationInput"]: {
		update?: GraphQLTypes["UrlWithoutArticleUpdateInput"],
	create?: GraphQLTypes["UrlWithoutArticleCreateInput"]
};
	["ArticleAuthorCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	article?: GraphQLTypes["ArticleAuthorCreateArticleEntityRelationInput"],
	author?: GraphQLTypes["ArticleAuthorCreateAuthorEntityRelationInput"],
	legacyStringAuthor?: GraphQLTypes["ArticleAuthorLegacyStringAuthor"],
	_dummy_field_?: boolean
};
	["ArticleAuthorCreateArticleEntityRelationInput"]: {
		connect?: GraphQLTypes["ArticleUniqueWhere"],
	create?: GraphQLTypes["ArticleWithoutAuthorsCreateInput"]
};
	["ArticleWithoutAuthorsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	url?: GraphQLTypes["ArticleCreateUrlEntityRelationInput"],
	hideInMostRead?: boolean,
	hideAds?: boolean,
	state?: GraphQLTypes["ArticleState"],
	locked?: boolean,
	publishAt?: GraphQLTypes["DateTime"],
	template?: GraphQLTypes["Template"],
	subtitle?: GraphQLTypes["ArticleCreateSubtitleEntityRelationInput"],
	content?: GraphQLTypes["ArticleCreateContentEntityRelationInput"],
	coverPhoto?: GraphQLTypes["ArticleCreateCoverPhotoEntityRelationInput"],
	titleAlignment?: GraphQLTypes["ArticleTitleAlignment"],
	tagline?: string,
	createdAt?: GraphQLTypes["DateTime"],
	previewContent?: GraphQLTypes["ArticleCreatePreviewContentEntityRelationInput"],
	audio?: GraphQLTypes["ArticleCreateAudioEntityRelationInput"],
	categories?: Array<GraphQLTypes["ArticleCreateCategoriesEntityRelationInput"]>,
	issues?: Array<GraphQLTypes["ArticleCreateIssuesEntityRelationInput"]>,
	contentBlocks?: Array<GraphQLTypes["ArticleCreateContentBlocksEntityRelationInput"]>,
	unlocked?: Array<GraphQLTypes["ArticleCreateUnlockedEntityRelationInput"]>,
	coverPhotoVertical?: GraphQLTypes["ArticleCreateCoverPhotoVerticalEntityRelationInput"],
	legacyId?: string,
	tags?: Array<GraphQLTypes["ArticleCreateTagsEntityRelationInput"]>,
	isHistory?: boolean,
	historyTags?: Array<GraphQLTypes["ArticleCreateHistoryTagsEntityRelationInput"]>,
	historyPeriods?: Array<GraphQLTypes["ArticleCreateHistoryPeriodsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ArticleAuthorUpdateInput"]: {
		order?: number,
	article?: GraphQLTypes["ArticleAuthorUpdateArticleEntityRelationInput"],
	author?: GraphQLTypes["ArticleAuthorUpdateAuthorEntityRelationInput"],
	legacyStringAuthor?: GraphQLTypes["ArticleAuthorLegacyStringAuthor"],
	_dummy_field_?: boolean
};
	["ArticleAuthorUpdateArticleEntityRelationInput"]: {
		create?: GraphQLTypes["ArticleWithoutAuthorsCreateInput"],
	update?: GraphQLTypes["ArticleWithoutAuthorsUpdateInput"],
	upsert?: GraphQLTypes["ArticleAuthorUpsertArticleRelationInput"],
	connect?: GraphQLTypes["ArticleUniqueWhere"],
	delete?: boolean
};
	["ArticleWithoutAuthorsUpdateInput"]: {
		title?: string,
	url?: GraphQLTypes["ArticleUpdateUrlEntityRelationInput"],
	hideInMostRead?: boolean,
	hideAds?: boolean,
	state?: GraphQLTypes["ArticleState"],
	locked?: boolean,
	publishAt?: GraphQLTypes["DateTime"],
	template?: GraphQLTypes["Template"],
	subtitle?: GraphQLTypes["ArticleUpdateSubtitleEntityRelationInput"],
	content?: GraphQLTypes["ArticleUpdateContentEntityRelationInput"],
	coverPhoto?: GraphQLTypes["ArticleUpdateCoverPhotoEntityRelationInput"],
	titleAlignment?: GraphQLTypes["ArticleTitleAlignment"],
	tagline?: string,
	createdAt?: GraphQLTypes["DateTime"],
	previewContent?: GraphQLTypes["ArticleUpdatePreviewContentEntityRelationInput"],
	audio?: GraphQLTypes["ArticleUpdateAudioEntityRelationInput"],
	categories?: Array<GraphQLTypes["ArticleUpdateCategoriesEntityRelationInput"]>,
	issues?: Array<GraphQLTypes["ArticleUpdateIssuesEntityRelationInput"]>,
	contentBlocks?: Array<GraphQLTypes["ArticleUpdateContentBlocksEntityRelationInput"]>,
	unlocked?: Array<GraphQLTypes["ArticleUpdateUnlockedEntityRelationInput"]>,
	coverPhotoVertical?: GraphQLTypes["ArticleUpdateCoverPhotoVerticalEntityRelationInput"],
	legacyId?: string,
	tags?: Array<GraphQLTypes["ArticleUpdateTagsEntityRelationInput"]>,
	isHistory?: boolean,
	historyTags?: Array<GraphQLTypes["ArticleUpdateHistoryTagsEntityRelationInput"]>,
	historyPeriods?: Array<GraphQLTypes["ArticleUpdateHistoryPeriodsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ArticleAuthorUpsertArticleRelationInput"]: {
		update?: GraphQLTypes["ArticleWithoutAuthorsUpdateInput"],
	create?: GraphQLTypes["ArticleWithoutAuthorsCreateInput"]
};
	["AuthorTopArticleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	author?: GraphQLTypes["AuthorTopArticleCreateAuthorEntityRelationInput"],
	article?: GraphQLTypes["AuthorTopArticleCreateArticleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["AuthorTopArticleCreateAuthorEntityRelationInput"]: {
		connect?: GraphQLTypes["AuthorUniqueWhere"],
	create?: GraphQLTypes["AuthorWithoutTopArticlesCreateInput"]
};
	["AuthorWithoutTopArticlesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	position?: string,
	twitterHandle?: string,
	facebookId?: string,
	email?: string,
	photographer?: boolean,
	order?: number,
	about?: GraphQLTypes["AuthorCreateAboutEntityRelationInput"],
	users?: Array<GraphQLTypes["AuthorCreateUsersEntityRelationInput"]>,
	startOfCooperation?: GraphQLTypes["Date"],
	photo?: GraphQLTypes["AuthorCreatePhotoEntityRelationInput"],
	illustration?: GraphQLTypes["AuthorCreateIllustrationEntityRelationInput"],
	legacyId?: string,
	category?: GraphQLTypes["AuthorCategory"],
	url?: GraphQLTypes["AuthorCreateUrlEntityRelationInput"],
	instagramUsername?: string,
	_dummy_field_?: boolean
};
	["AuthorTopArticleUpdateInput"]: {
		order?: number,
	author?: GraphQLTypes["AuthorTopArticleUpdateAuthorEntityRelationInput"],
	article?: GraphQLTypes["AuthorTopArticleUpdateArticleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["AuthorTopArticleUpdateAuthorEntityRelationInput"]: {
		create?: GraphQLTypes["AuthorWithoutTopArticlesCreateInput"],
	update?: GraphQLTypes["AuthorWithoutTopArticlesUpdateInput"],
	upsert?: GraphQLTypes["AuthorTopArticleUpsertAuthorRelationInput"],
	connect?: GraphQLTypes["AuthorUniqueWhere"],
	delete?: boolean
};
	["AuthorWithoutTopArticlesUpdateInput"]: {
		name?: string,
	position?: string,
	twitterHandle?: string,
	facebookId?: string,
	email?: string,
	photographer?: boolean,
	order?: number,
	about?: GraphQLTypes["AuthorUpdateAboutEntityRelationInput"],
	users?: Array<GraphQLTypes["AuthorUpdateUsersEntityRelationInput"]>,
	startOfCooperation?: GraphQLTypes["Date"],
	photo?: GraphQLTypes["AuthorUpdatePhotoEntityRelationInput"],
	illustration?: GraphQLTypes["AuthorUpdateIllustrationEntityRelationInput"],
	legacyId?: string,
	category?: GraphQLTypes["AuthorCategory"],
	url?: GraphQLTypes["AuthorUpdateUrlEntityRelationInput"],
	instagramUsername?: string,
	_dummy_field_?: boolean
};
	["AuthorTopArticleUpsertAuthorRelationInput"]: {
		update?: GraphQLTypes["AuthorWithoutTopArticlesUpdateInput"],
	create?: GraphQLTypes["AuthorWithoutTopArticlesCreateInput"]
};
	["ContentConnection"]: {
	__typename: "ContentConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentEdge"]>
};
	["ContentEdge"]: {
	__typename: "ContentEdge",
	node: GraphQLTypes["Content"]
};
	["ContentPartCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	json?: string,
	content?: GraphQLTypes["ContentPartCreateContentEntityRelationInput"],
	references?: Array<GraphQLTypes["ContentPartCreateReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentPartUpdateInput"]: {
		order?: number,
	json?: string,
	content?: GraphQLTypes["ContentPartUpdateContentEntityRelationInput"],
	references?: Array<GraphQLTypes["ContentPartUpdateReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentReferenceCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ContentReferenceType"],
	contentPart?: GraphQLTypes["ContentReferenceCreateContentPartEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	variant?: GraphQLTypes["ContentReferenceVariant"],
	color?: string,
	embed?: GraphQLTypes["ContentReferenceCreateEmbedEntityRelationInput"],
	article?: GraphQLTypes["ContentReferenceCreateArticleEntityRelationInput"],
	audio?: GraphQLTypes["ContentReferenceCreateAudioEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"],
	images?: Array<GraphQLTypes["ContentReferenceCreateImagesEntityRelationInput"]>,
	pollAnswer?: GraphQLTypes["ContentReferenceCreatePollAnswerEntityRelationInput"],
	listicle?: Array<GraphQLTypes["ContentReferenceCreateListicleEntityRelationInput"]>,
	faq?: Array<GraphQLTypes["ContentReferenceCreateFaqEntityRelationInput"]>,
	links?: Array<GraphQLTypes["ContentReferenceCreateLinksEntityRelationInput"]>,
	awards?: Array<GraphQLTypes["ContentReferenceCreateAwardsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ContentReferenceCreateReviewsEntityRelationInput"]>,
	target?: GraphQLTypes["ContentReferenceCreateTargetEntityRelationInput"],
	subscriptionForm?: GraphQLTypes["ContentReferenceCreateSubscriptionFormEntityRelationInput"],
	buttons?: Array<GraphQLTypes["ContentReferenceCreateButtonsEntityRelationInput"]>,
	sharedContent?: GraphQLTypes["ContentReferenceCreateSharedContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"],
	contentPart?: GraphQLTypes["ContentReferenceUpdateContentPartEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	variant?: GraphQLTypes["ContentReferenceVariant"],
	color?: string,
	embed?: GraphQLTypes["ContentReferenceUpdateEmbedEntityRelationInput"],
	article?: GraphQLTypes["ContentReferenceUpdateArticleEntityRelationInput"],
	audio?: GraphQLTypes["ContentReferenceUpdateAudioEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"],
	images?: Array<GraphQLTypes["ContentReferenceUpdateImagesEntityRelationInput"]>,
	pollAnswer?: GraphQLTypes["ContentReferenceUpdatePollAnswerEntityRelationInput"],
	listicle?: Array<GraphQLTypes["ContentReferenceUpdateListicleEntityRelationInput"]>,
	faq?: Array<GraphQLTypes["ContentReferenceUpdateFaqEntityRelationInput"]>,
	links?: Array<GraphQLTypes["ContentReferenceUpdateLinksEntityRelationInput"]>,
	awards?: Array<GraphQLTypes["ContentReferenceUpdateAwardsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ContentReferenceUpdateReviewsEntityRelationInput"]>,
	target?: GraphQLTypes["ContentReferenceUpdateTargetEntityRelationInput"],
	subscriptionForm?: GraphQLTypes["ContentReferenceUpdateSubscriptionFormEntityRelationInput"],
	buttons?: Array<GraphQLTypes["ContentReferenceUpdateButtonsEntityRelationInput"]>,
	sharedContent?: GraphQLTypes["ContentReferenceUpdateSharedContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HomepageArticle"]: {
	__typename: "HomepageArticle",
	_meta?: GraphQLTypes["HomepageArticleMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	tag: string,
	article?: GraphQLTypes["Article"]
};
	["HomepageArticleMeta"]: {
	__typename: "HomepageArticleMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	tag?: GraphQLTypes["FieldMeta"],
	article?: GraphQLTypes["FieldMeta"]
};
	["HomepageArticleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["HomepageArticleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	tag?: GraphQLTypes["StringCondition"],
	article?: GraphQLTypes["ArticleWhere"],
	and?: Array<GraphQLTypes["HomepageArticleWhere"] | undefined>,
	or?: Array<GraphQLTypes["HomepageArticleWhere"] | undefined>,
	not?: GraphQLTypes["HomepageArticleWhere"]
};
	["HomepageArticleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	tag?: GraphQLTypes["OrderDirection"],
	article?: GraphQLTypes["ArticleOrderBy"]
};
	["HomepageArticleConnection"]: {
	__typename: "HomepageArticleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HomepageArticleEdge"]>
};
	["HomepageArticleEdge"]: {
	__typename: "HomepageArticleEdge",
	node: GraphQLTypes["HomepageArticle"]
};
	["HomepageArticleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	tag?: string,
	article?: GraphQLTypes["HomepageArticleCreateArticleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HomepageArticleCreateArticleEntityRelationInput"]: {
		connect?: GraphQLTypes["ArticleUniqueWhere"],
	create?: GraphQLTypes["ArticleCreateInput"]
};
	["HomepageArticleUpdateInput"]: {
		order?: number,
	tag?: string,
	article?: GraphQLTypes["HomepageArticleUpdateArticleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HomepageArticleUpdateArticleEntityRelationInput"]: {
		create?: GraphQLTypes["ArticleCreateInput"],
	update?: GraphQLTypes["ArticleUpdateInput"],
	upsert?: GraphQLTypes["HomepageArticleUpsertArticleRelationInput"],
	connect?: GraphQLTypes["ArticleUniqueWhere"],
	delete?: boolean
};
	["HomepageArticleUpsertArticleRelationInput"]: {
		update?: GraphQLTypes["ArticleUpdateInput"],
	create?: GraphQLTypes["ArticleCreateInput"]
};
	["ImageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	width?: number,
	height?: number,
	title?: string,
	text?: string,
	author?: GraphQLTypes["ImageCreateAuthorEntityRelationInput"],
	tags?: Array<GraphQLTypes["ImageCreateTagsEntityRelationInput"]>,
	uses?: Array<GraphQLTypes["ImageCreateUsesEntityRelationInput"]>,
	align?: GraphQLTypes["ImageAlign"],
	legacyId?: string,
	_dummy_field_?: boolean
};
	["ImageCreateUsesEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUseUniqueWhere"],
	create?: GraphQLTypes["ImageUseWithoutImageCreateInput"],
	alias?: string
};
	["ImageUseWithoutImageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	_dummy_field_?: boolean
};
	["ImageUpdateInput"]: {
		url?: string,
	width?: number,
	height?: number,
	title?: string,
	text?: string,
	author?: GraphQLTypes["ImageUpdateAuthorEntityRelationInput"],
	tags?: Array<GraphQLTypes["ImageUpdateTagsEntityRelationInput"]>,
	uses?: Array<GraphQLTypes["ImageUpdateUsesEntityRelationInput"]>,
	align?: GraphQLTypes["ImageAlign"],
	legacyId?: string,
	_dummy_field_?: boolean
};
	["ImageUpdateUsesEntityRelationInput"]: {
		create?: GraphQLTypes["ImageUseWithoutImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateUsesRelationInput"],
	upsert?: GraphQLTypes["ImageUpsertUsesRelationInput"],
	connect?: GraphQLTypes["ImageUseUniqueWhere"],
	disconnect?: GraphQLTypes["ImageUseUniqueWhere"],
	delete?: GraphQLTypes["ImageUseUniqueWhere"],
	alias?: string
};
	["ImageUpdateUsesRelationInput"]: {
		by?: GraphQLTypes["ImageUseUniqueWhere"],
	data?: GraphQLTypes["ImageUseWithoutImageUpdateInput"]
};
	["ImageUseWithoutImageUpdateInput"]: {
		title?: string,
	_dummy_field_?: boolean
};
	["ImageUpsertUsesRelationInput"]: {
		by?: GraphQLTypes["ImageUseUniqueWhere"],
	update?: GraphQLTypes["ImageUseWithoutImageUpdateInput"],
	create?: GraphQLTypes["ImageUseWithoutImageCreateInput"]
};
	["ImageTagCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	images?: Array<GraphQLTypes["ImageTagCreateImagesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ImageTagCreateImagesEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageWithoutTagsCreateInput"],
	alias?: string
};
	["ImageWithoutTagsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	width?: number,
	height?: number,
	title?: string,
	text?: string,
	author?: GraphQLTypes["ImageCreateAuthorEntityRelationInput"],
	uses?: Array<GraphQLTypes["ImageCreateUsesEntityRelationInput"]>,
	align?: GraphQLTypes["ImageAlign"],
	legacyId?: string,
	_dummy_field_?: boolean
};
	["ImageTagUpdateInput"]: {
		name?: string,
	images?: Array<GraphQLTypes["ImageTagUpdateImagesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ImageTagUpdateImagesEntityRelationInput"]: {
		create?: GraphQLTypes["ImageWithoutTagsCreateInput"],
	update?: GraphQLTypes["ImageTagUpdateImagesRelationInput"],
	upsert?: GraphQLTypes["ImageTagUpsertImagesRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: GraphQLTypes["ImageUniqueWhere"],
	delete?: GraphQLTypes["ImageUniqueWhere"],
	alias?: string
};
	["ImageTagUpdateImagesRelationInput"]: {
		by?: GraphQLTypes["ImageUniqueWhere"],
	data?: GraphQLTypes["ImageWithoutTagsUpdateInput"]
};
	["ImageWithoutTagsUpdateInput"]: {
		url?: string,
	width?: number,
	height?: number,
	title?: string,
	text?: string,
	author?: GraphQLTypes["ImageUpdateAuthorEntityRelationInput"],
	uses?: Array<GraphQLTypes["ImageUpdateUsesEntityRelationInput"]>,
	align?: GraphQLTypes["ImageAlign"],
	legacyId?: string,
	_dummy_field_?: boolean
};
	["ImageTagUpsertImagesRelationInput"]: {
		by?: GraphQLTypes["ImageUniqueWhere"],
	update?: GraphQLTypes["ImageWithoutTagsUpdateInput"],
	create?: GraphQLTypes["ImageWithoutTagsCreateInput"]
};
	["IssueConnection"]: {
	__typename: "IssueConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["IssueEdge"]>
};
	["IssueEdge"]: {
	__typename: "IssueEdge",
	node: GraphQLTypes["Issue"]
};
	["IssueCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	closed?: boolean,
	free?: boolean,
	title?: string,
	subtitle?: string,
	year?: number,
	issue?: number,
	publishedSince?: GraphQLTypes["Date"],
	publishedUntil?: GraphQLTypes["Date"],
	publishDigital?: GraphQLTypes["DateTime"],
	mobileAppsKey?: string,
	url?: GraphQLTypes["IssueCreateUrlEntityRelationInput"],
	articles?: Array<GraphQLTypes["IssueCreateArticlesEntityRelationInput"]>,
	kind?: GraphQLTypes["IssueKind"],
	notificationTitle?: string,
	notificationMessage?: string,
	pdf?: GraphQLTypes["IssueCreatePdfEntityRelationInput"],
	printBuy?: boolean,
	printText?: string,
	blocks?: Array<GraphQLTypes["IssueCreateBlocksEntityRelationInput"]>,
	coverPhoto?: GraphQLTypes["IssueCreateCoverPhotoEntityRelationInput"],
	printTarget?: GraphQLTypes["IssueCreatePrintTargetEntityRelationInput"],
	backgroundPhoto?: GraphQLTypes["IssueCreateBackgroundPhotoEntityRelationInput"],
	legacyId?: string,
	_dummy_field_?: boolean
};
	["IssueUpdateInput"]: {
		closed?: boolean,
	free?: boolean,
	title?: string,
	subtitle?: string,
	year?: number,
	issue?: number,
	publishedSince?: GraphQLTypes["Date"],
	publishedUntil?: GraphQLTypes["Date"],
	publishDigital?: GraphQLTypes["DateTime"],
	mobileAppsKey?: string,
	url?: GraphQLTypes["IssueUpdateUrlEntityRelationInput"],
	articles?: Array<GraphQLTypes["IssueUpdateArticlesEntityRelationInput"]>,
	kind?: GraphQLTypes["IssueKind"],
	notificationTitle?: string,
	notificationMessage?: string,
	pdf?: GraphQLTypes["IssueUpdatePdfEntityRelationInput"],
	printBuy?: boolean,
	printText?: string,
	blocks?: Array<GraphQLTypes["IssueUpdateBlocksEntityRelationInput"]>,
	coverPhoto?: GraphQLTypes["IssueUpdateCoverPhotoEntityRelationInput"],
	printTarget?: GraphQLTypes["IssueUpdatePrintTargetEntityRelationInput"],
	backgroundPhoto?: GraphQLTypes["IssueUpdateBackgroundPhotoEntityRelationInput"],
	legacyId?: string,
	_dummy_field_?: boolean
};
	["IssueArticleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	issue?: GraphQLTypes["IssueArticleCreateIssueEntityRelationInput"],
	article?: GraphQLTypes["IssueArticleCreateArticleEntityRelationInput"],
	order?: number,
	_dummy_field_?: boolean
};
	["IssueArticleUpdateInput"]: {
		issue?: GraphQLTypes["IssueArticleUpdateIssueEntityRelationInput"],
	article?: GraphQLTypes["IssueArticleUpdateArticleEntityRelationInput"],
	order?: number,
	_dummy_field_?: boolean
};
	["LinkConnection"]: {
	__typename: "LinkConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkEdge"]>
};
	["LinkEdge"]: {
	__typename: "LinkEdge",
	node: GraphQLTypes["Link"]
};
	["TextContentConnection"]: {
	__typename: "TextContentConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TextContentEdge"]>
};
	["TextContentEdge"]: {
	__typename: "TextContentEdge",
	node: GraphQLTypes["TextContent"]
};
	["TextContentPartCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	json?: string,
	content?: GraphQLTypes["TextContentPartCreateContentEntityRelationInput"],
	references?: Array<GraphQLTypes["TextContentPartCreateReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TextContentPartCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["TextContentUniqueWhere"],
	create?: GraphQLTypes["TextContentWithoutPartsCreateInput"]
};
	["TextContentWithoutPartsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["TextContentPartUpdateInput"]: {
		order?: number,
	json?: string,
	content?: GraphQLTypes["TextContentPartUpdateContentEntityRelationInput"],
	references?: Array<GraphQLTypes["TextContentPartUpdateReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TextContentPartUpdateContentEntityRelationInput"]: {
		create?: GraphQLTypes["TextContentWithoutPartsCreateInput"],
	update?: GraphQLTypes["TextContentWithoutPartsUpdateInput"],
	upsert?: GraphQLTypes["TextContentPartUpsertContentRelationInput"],
	connect?: GraphQLTypes["TextContentUniqueWhere"],
	delete?: boolean
};
	["TextContentWithoutPartsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["TextContentPartUpsertContentRelationInput"]: {
		update?: GraphQLTypes["TextContentWithoutPartsUpdateInput"],
	create?: GraphQLTypes["TextContentWithoutPartsCreateInput"]
};
	["TextContentReferenceCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["TextContentReferenceType"],
	contentPart?: GraphQLTypes["TextContentReferenceCreateContentPartEntityRelationInput"],
	target?: GraphQLTypes["TextContentReferenceCreateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TextContentReferenceCreateContentPartEntityRelationInput"]: {
		connect?: GraphQLTypes["TextContentPartUniqueWhere"],
	create?: GraphQLTypes["TextContentPartWithoutReferencesCreateInput"]
};
	["TextContentPartWithoutReferencesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	json?: string,
	content?: GraphQLTypes["TextContentPartCreateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TextContentReferenceUpdateInput"]: {
		type?: GraphQLTypes["TextContentReferenceType"],
	contentPart?: GraphQLTypes["TextContentReferenceUpdateContentPartEntityRelationInput"],
	target?: GraphQLTypes["TextContentReferenceUpdateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TextContentReferenceUpdateContentPartEntityRelationInput"]: {
		create?: GraphQLTypes["TextContentPartWithoutReferencesCreateInput"],
	update?: GraphQLTypes["TextContentPartWithoutReferencesUpdateInput"],
	upsert?: GraphQLTypes["TextContentReferenceUpsertContentPartRelationInput"],
	connect?: GraphQLTypes["TextContentPartUniqueWhere"],
	delete?: boolean
};
	["TextContentPartWithoutReferencesUpdateInput"]: {
		order?: number,
	json?: string,
	content?: GraphQLTypes["TextContentPartUpdateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TextContentReferenceUpsertContentPartRelationInput"]: {
		update?: GraphQLTypes["TextContentPartWithoutReferencesUpdateInput"],
	create?: GraphQLTypes["TextContentPartWithoutReferencesCreateInput"]
};
	["UrlConnection"]: {
	__typename: "UrlConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["UrlEdge"]>
};
	["UrlEdge"]: {
	__typename: "UrlEdge",
	node: GraphQLTypes["Url"]
};
	["ArticleTagCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	tag?: GraphQLTypes["ArticleTagCreateTagEntityRelationInput"],
	article?: GraphQLTypes["ArticleTagCreateArticleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArticleTagUpdateInput"]: {
		order?: number,
	tag?: GraphQLTypes["ArticleTagUpdateTagEntityRelationInput"],
	article?: GraphQLTypes["ArticleTagUpdateArticleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["CategoryConnection"]: {
	__typename: "CategoryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CategoryEdge"]>
};
	["CategoryEdge"]: {
	__typename: "CategoryEdge",
	node: GraphQLTypes["Category"]
};
	["CategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	articleCategory?: Array<GraphQLTypes["CategoryCreateArticleCategoryEntityRelationInput"]>,
	url?: GraphQLTypes["CategoryCreateUrlEntityRelationInput"],
	legacyId?: string,
	_dummy_field_?: boolean
};
	["CategoryUpdateInput"]: {
		name?: string,
	articleCategory?: Array<GraphQLTypes["CategoryUpdateArticleCategoryEntityRelationInput"]>,
	url?: GraphQLTypes["CategoryUpdateUrlEntityRelationInput"],
	legacyId?: string,
	_dummy_field_?: boolean
};
	["ArticleCategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	article?: GraphQLTypes["ArticleCategoryCreateArticleEntityRelationInput"],
	category?: GraphQLTypes["ArticleCategoryCreateCategoryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArticleCategoryUpdateInput"]: {
		order?: number,
	article?: GraphQLTypes["ArticleCategoryUpdateArticleEntityRelationInput"],
	category?: GraphQLTypes["ArticleCategoryUpdateCategoryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["AudioConnection"]: {
	__typename: "AudioConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["AudioEdge"]>
};
	["AudioEdge"]: {
	__typename: "AudioEdge",
	node: GraphQLTypes["Audio"]
};
	["AudioCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	type?: string,
	author?: GraphQLTypes["AudioCreateAuthorEntityRelationInput"],
	uses?: Array<GraphQLTypes["AudioCreateUsesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["AudioCreateUsesEntityRelationInput"]: {
		connect?: GraphQLTypes["AudioUseUniqueWhere"],
	create?: GraphQLTypes["AudioUseWithoutAudioCreateInput"],
	alias?: string
};
	["AudioUseWithoutAudioCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["AudioUpdateInput"]: {
		url?: string,
	type?: string,
	author?: GraphQLTypes["AudioUpdateAuthorEntityRelationInput"],
	uses?: Array<GraphQLTypes["AudioUpdateUsesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["AudioUpdateUsesEntityRelationInput"]: {
		create?: GraphQLTypes["AudioUseWithoutAudioCreateInput"],
	update?: GraphQLTypes["AudioUpdateUsesRelationInput"],
	upsert?: GraphQLTypes["AudioUpsertUsesRelationInput"],
	connect?: GraphQLTypes["AudioUseUniqueWhere"],
	disconnect?: GraphQLTypes["AudioUseUniqueWhere"],
	delete?: GraphQLTypes["AudioUseUniqueWhere"],
	alias?: string
};
	["AudioUpdateUsesRelationInput"]: {
		by?: GraphQLTypes["AudioUseUniqueWhere"],
	data?: GraphQLTypes["AudioUseWithoutAudioUpdateInput"]
};
	["AudioUseWithoutAudioUpdateInput"]: {
		_dummy_field_?: boolean
};
	["AudioUpsertUsesRelationInput"]: {
		by?: GraphQLTypes["AudioUseUniqueWhere"],
	update?: GraphQLTypes["AudioUseWithoutAudioUpdateInput"],
	create?: GraphQLTypes["AudioUseWithoutAudioCreateInput"]
};
	["EmbedConnection"]: {
	__typename: "EmbedConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["EmbedEdge"]>
};
	["EmbedEdge"]: {
	__typename: "EmbedEdge",
	node: GraphQLTypes["Embed"]
};
	["ImageContentCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	contentReference?: Array<GraphQLTypes["ImageContentCreateContentReferenceEntityRelationInput"]>,
	image?: GraphQLTypes["ImageContentCreateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ImageContentCreateContentReferenceEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	create?: GraphQLTypes["ContentReferenceWithoutImagesCreateInput"],
	alias?: string
};
	["ContentReferenceWithoutImagesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ContentReferenceType"],
	contentPart?: GraphQLTypes["ContentReferenceCreateContentPartEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	variant?: GraphQLTypes["ContentReferenceVariant"],
	color?: string,
	embed?: GraphQLTypes["ContentReferenceCreateEmbedEntityRelationInput"],
	article?: GraphQLTypes["ContentReferenceCreateArticleEntityRelationInput"],
	audio?: GraphQLTypes["ContentReferenceCreateAudioEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"],
	pollAnswer?: GraphQLTypes["ContentReferenceCreatePollAnswerEntityRelationInput"],
	listicle?: Array<GraphQLTypes["ContentReferenceCreateListicleEntityRelationInput"]>,
	faq?: Array<GraphQLTypes["ContentReferenceCreateFaqEntityRelationInput"]>,
	links?: Array<GraphQLTypes["ContentReferenceCreateLinksEntityRelationInput"]>,
	awards?: Array<GraphQLTypes["ContentReferenceCreateAwardsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ContentReferenceCreateReviewsEntityRelationInput"]>,
	target?: GraphQLTypes["ContentReferenceCreateTargetEntityRelationInput"],
	subscriptionForm?: GraphQLTypes["ContentReferenceCreateSubscriptionFormEntityRelationInput"],
	buttons?: Array<GraphQLTypes["ContentReferenceCreateButtonsEntityRelationInput"]>,
	sharedContent?: GraphQLTypes["ContentReferenceCreateSharedContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ImageContentUpdateInput"]: {
		order?: number,
	contentReference?: Array<GraphQLTypes["ImageContentUpdateContentReferenceEntityRelationInput"]>,
	image?: GraphQLTypes["ImageContentUpdateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ImageContentUpdateContentReferenceEntityRelationInput"]: {
		create?: GraphQLTypes["ContentReferenceWithoutImagesCreateInput"],
	update?: GraphQLTypes["ImageContentUpdateContentReferenceRelationInput"],
	upsert?: GraphQLTypes["ImageContentUpsertContentReferenceRelationInput"],
	connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	disconnect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	delete?: GraphQLTypes["ContentReferenceUniqueWhere"],
	alias?: string
};
	["ImageContentUpdateContentReferenceRelationInput"]: {
		by?: GraphQLTypes["ContentReferenceUniqueWhere"],
	data?: GraphQLTypes["ContentReferenceWithoutImagesUpdateInput"]
};
	["ContentReferenceWithoutImagesUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"],
	contentPart?: GraphQLTypes["ContentReferenceUpdateContentPartEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	variant?: GraphQLTypes["ContentReferenceVariant"],
	color?: string,
	embed?: GraphQLTypes["ContentReferenceUpdateEmbedEntityRelationInput"],
	article?: GraphQLTypes["ContentReferenceUpdateArticleEntityRelationInput"],
	audio?: GraphQLTypes["ContentReferenceUpdateAudioEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"],
	pollAnswer?: GraphQLTypes["ContentReferenceUpdatePollAnswerEntityRelationInput"],
	listicle?: Array<GraphQLTypes["ContentReferenceUpdateListicleEntityRelationInput"]>,
	faq?: Array<GraphQLTypes["ContentReferenceUpdateFaqEntityRelationInput"]>,
	links?: Array<GraphQLTypes["ContentReferenceUpdateLinksEntityRelationInput"]>,
	awards?: Array<GraphQLTypes["ContentReferenceUpdateAwardsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ContentReferenceUpdateReviewsEntityRelationInput"]>,
	target?: GraphQLTypes["ContentReferenceUpdateTargetEntityRelationInput"],
	subscriptionForm?: GraphQLTypes["ContentReferenceUpdateSubscriptionFormEntityRelationInput"],
	buttons?: Array<GraphQLTypes["ContentReferenceUpdateButtonsEntityRelationInput"]>,
	sharedContent?: GraphQLTypes["ContentReferenceUpdateSharedContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ImageContentUpsertContentReferenceRelationInput"]: {
		by?: GraphQLTypes["ContentReferenceUniqueWhere"],
	update?: GraphQLTypes["ContentReferenceWithoutImagesUpdateInput"],
	create?: GraphQLTypes["ContentReferenceWithoutImagesCreateInput"]
};
	["ListicleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	primaryText?: string,
	image?: GraphQLTypes["ListicleCreateImageEntityRelationInput"],
	contentReference?: GraphQLTypes["ListicleCreateContentReferenceEntityRelationInput"],
	target?: GraphQLTypes["ListicleCreateTargetEntityRelationInput"],
	content?: GraphQLTypes["ListicleCreateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ListicleCreateContentReferenceEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	create?: GraphQLTypes["ContentReferenceWithoutListicleCreateInput"]
};
	["ContentReferenceWithoutListicleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ContentReferenceType"],
	contentPart?: GraphQLTypes["ContentReferenceCreateContentPartEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	variant?: GraphQLTypes["ContentReferenceVariant"],
	color?: string,
	embed?: GraphQLTypes["ContentReferenceCreateEmbedEntityRelationInput"],
	article?: GraphQLTypes["ContentReferenceCreateArticleEntityRelationInput"],
	audio?: GraphQLTypes["ContentReferenceCreateAudioEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"],
	images?: Array<GraphQLTypes["ContentReferenceCreateImagesEntityRelationInput"]>,
	pollAnswer?: GraphQLTypes["ContentReferenceCreatePollAnswerEntityRelationInput"],
	faq?: Array<GraphQLTypes["ContentReferenceCreateFaqEntityRelationInput"]>,
	links?: Array<GraphQLTypes["ContentReferenceCreateLinksEntityRelationInput"]>,
	awards?: Array<GraphQLTypes["ContentReferenceCreateAwardsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ContentReferenceCreateReviewsEntityRelationInput"]>,
	target?: GraphQLTypes["ContentReferenceCreateTargetEntityRelationInput"],
	subscriptionForm?: GraphQLTypes["ContentReferenceCreateSubscriptionFormEntityRelationInput"],
	buttons?: Array<GraphQLTypes["ContentReferenceCreateButtonsEntityRelationInput"]>,
	sharedContent?: GraphQLTypes["ContentReferenceCreateSharedContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ListicleUpdateInput"]: {
		order?: number,
	primaryText?: string,
	image?: GraphQLTypes["ListicleUpdateImageEntityRelationInput"],
	contentReference?: GraphQLTypes["ListicleUpdateContentReferenceEntityRelationInput"],
	target?: GraphQLTypes["ListicleUpdateTargetEntityRelationInput"],
	content?: GraphQLTypes["ListicleUpdateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ListicleUpdateContentReferenceEntityRelationInput"]: {
		create?: GraphQLTypes["ContentReferenceWithoutListicleCreateInput"],
	update?: GraphQLTypes["ContentReferenceWithoutListicleUpdateInput"],
	upsert?: GraphQLTypes["ListicleUpsertContentReferenceRelationInput"],
	connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	delete?: boolean
};
	["ContentReferenceWithoutListicleUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"],
	contentPart?: GraphQLTypes["ContentReferenceUpdateContentPartEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	variant?: GraphQLTypes["ContentReferenceVariant"],
	color?: string,
	embed?: GraphQLTypes["ContentReferenceUpdateEmbedEntityRelationInput"],
	article?: GraphQLTypes["ContentReferenceUpdateArticleEntityRelationInput"],
	audio?: GraphQLTypes["ContentReferenceUpdateAudioEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"],
	images?: Array<GraphQLTypes["ContentReferenceUpdateImagesEntityRelationInput"]>,
	pollAnswer?: GraphQLTypes["ContentReferenceUpdatePollAnswerEntityRelationInput"],
	faq?: Array<GraphQLTypes["ContentReferenceUpdateFaqEntityRelationInput"]>,
	links?: Array<GraphQLTypes["ContentReferenceUpdateLinksEntityRelationInput"]>,
	awards?: Array<GraphQLTypes["ContentReferenceUpdateAwardsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ContentReferenceUpdateReviewsEntityRelationInput"]>,
	target?: GraphQLTypes["ContentReferenceUpdateTargetEntityRelationInput"],
	subscriptionForm?: GraphQLTypes["ContentReferenceUpdateSubscriptionFormEntityRelationInput"],
	buttons?: Array<GraphQLTypes["ContentReferenceUpdateButtonsEntityRelationInput"]>,
	sharedContent?: GraphQLTypes["ContentReferenceUpdateSharedContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ListicleUpsertContentReferenceRelationInput"]: {
		update?: GraphQLTypes["ContentReferenceWithoutListicleUpdateInput"],
	create?: GraphQLTypes["ContentReferenceWithoutListicleCreateInput"]
};
	["PollAnswerConnection"]: {
	__typename: "PollAnswerConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PollAnswerEdge"]>
};
	["PollAnswerEdge"]: {
	__typename: "PollAnswerEdge",
	node: GraphQLTypes["PollAnswer"]
};
	["TagConnection"]: {
	__typename: "TagConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TagEdge"]>
};
	["TagEdge"]: {
	__typename: "TagEdge",
	node: GraphQLTypes["Tag"]
};
	["TagCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	useAsTagline?: boolean,
	articleTag?: Array<GraphQLTypes["TagCreateArticleTagEntityRelationInput"]>,
	url?: GraphQLTypes["TagCreateUrlEntityRelationInput"],
	order?: string,
	legacyId?: string,
	_dummy_field_?: boolean
};
	["TagUpdateInput"]: {
		name?: string,
	useAsTagline?: boolean,
	articleTag?: Array<GraphQLTypes["TagUpdateArticleTagEntityRelationInput"]>,
	url?: GraphQLTypes["TagUpdateUrlEntityRelationInput"],
	order?: string,
	legacyId?: string,
	_dummy_field_?: boolean
};
	["FAQCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	answer?: string,
	question?: string,
	contentReference?: GraphQLTypes["FAQCreateContentReferenceEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FAQCreateContentReferenceEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	create?: GraphQLTypes["ContentReferenceWithoutFaqCreateInput"]
};
	["ContentReferenceWithoutFaqCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ContentReferenceType"],
	contentPart?: GraphQLTypes["ContentReferenceCreateContentPartEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	variant?: GraphQLTypes["ContentReferenceVariant"],
	color?: string,
	embed?: GraphQLTypes["ContentReferenceCreateEmbedEntityRelationInput"],
	article?: GraphQLTypes["ContentReferenceCreateArticleEntityRelationInput"],
	audio?: GraphQLTypes["ContentReferenceCreateAudioEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"],
	images?: Array<GraphQLTypes["ContentReferenceCreateImagesEntityRelationInput"]>,
	pollAnswer?: GraphQLTypes["ContentReferenceCreatePollAnswerEntityRelationInput"],
	listicle?: Array<GraphQLTypes["ContentReferenceCreateListicleEntityRelationInput"]>,
	links?: Array<GraphQLTypes["ContentReferenceCreateLinksEntityRelationInput"]>,
	awards?: Array<GraphQLTypes["ContentReferenceCreateAwardsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ContentReferenceCreateReviewsEntityRelationInput"]>,
	target?: GraphQLTypes["ContentReferenceCreateTargetEntityRelationInput"],
	subscriptionForm?: GraphQLTypes["ContentReferenceCreateSubscriptionFormEntityRelationInput"],
	buttons?: Array<GraphQLTypes["ContentReferenceCreateButtonsEntityRelationInput"]>,
	sharedContent?: GraphQLTypes["ContentReferenceCreateSharedContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FAQUpdateInput"]: {
		order?: number,
	answer?: string,
	question?: string,
	contentReference?: GraphQLTypes["FAQUpdateContentReferenceEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FAQUpdateContentReferenceEntityRelationInput"]: {
		create?: GraphQLTypes["ContentReferenceWithoutFaqCreateInput"],
	update?: GraphQLTypes["ContentReferenceWithoutFaqUpdateInput"],
	upsert?: GraphQLTypes["FAQUpsertContentReferenceRelationInput"],
	connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	delete?: boolean
};
	["ContentReferenceWithoutFaqUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"],
	contentPart?: GraphQLTypes["ContentReferenceUpdateContentPartEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	variant?: GraphQLTypes["ContentReferenceVariant"],
	color?: string,
	embed?: GraphQLTypes["ContentReferenceUpdateEmbedEntityRelationInput"],
	article?: GraphQLTypes["ContentReferenceUpdateArticleEntityRelationInput"],
	audio?: GraphQLTypes["ContentReferenceUpdateAudioEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"],
	images?: Array<GraphQLTypes["ContentReferenceUpdateImagesEntityRelationInput"]>,
	pollAnswer?: GraphQLTypes["ContentReferenceUpdatePollAnswerEntityRelationInput"],
	listicle?: Array<GraphQLTypes["ContentReferenceUpdateListicleEntityRelationInput"]>,
	links?: Array<GraphQLTypes["ContentReferenceUpdateLinksEntityRelationInput"]>,
	awards?: Array<GraphQLTypes["ContentReferenceUpdateAwardsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ContentReferenceUpdateReviewsEntityRelationInput"]>,
	target?: GraphQLTypes["ContentReferenceUpdateTargetEntityRelationInput"],
	subscriptionForm?: GraphQLTypes["ContentReferenceUpdateSubscriptionFormEntityRelationInput"],
	buttons?: Array<GraphQLTypes["ContentReferenceUpdateButtonsEntityRelationInput"]>,
	sharedContent?: GraphQLTypes["ContentReferenceUpdateSharedContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FAQUpsertContentReferenceRelationInput"]: {
		update?: GraphQLTypes["ContentReferenceWithoutFaqUpdateInput"],
	create?: GraphQLTypes["ContentReferenceWithoutFaqCreateInput"]
};
	["LinkContentCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	contentReference?: GraphQLTypes["LinkContentCreateContentReferenceEntityRelationInput"],
	text?: string,
	target?: GraphQLTypes["LinkContentCreateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkContentCreateContentReferenceEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	create?: GraphQLTypes["ContentReferenceWithoutLinksCreateInput"]
};
	["ContentReferenceWithoutLinksCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ContentReferenceType"],
	contentPart?: GraphQLTypes["ContentReferenceCreateContentPartEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	variant?: GraphQLTypes["ContentReferenceVariant"],
	color?: string,
	embed?: GraphQLTypes["ContentReferenceCreateEmbedEntityRelationInput"],
	article?: GraphQLTypes["ContentReferenceCreateArticleEntityRelationInput"],
	audio?: GraphQLTypes["ContentReferenceCreateAudioEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"],
	images?: Array<GraphQLTypes["ContentReferenceCreateImagesEntityRelationInput"]>,
	pollAnswer?: GraphQLTypes["ContentReferenceCreatePollAnswerEntityRelationInput"],
	listicle?: Array<GraphQLTypes["ContentReferenceCreateListicleEntityRelationInput"]>,
	faq?: Array<GraphQLTypes["ContentReferenceCreateFaqEntityRelationInput"]>,
	awards?: Array<GraphQLTypes["ContentReferenceCreateAwardsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ContentReferenceCreateReviewsEntityRelationInput"]>,
	target?: GraphQLTypes["ContentReferenceCreateTargetEntityRelationInput"],
	subscriptionForm?: GraphQLTypes["ContentReferenceCreateSubscriptionFormEntityRelationInput"],
	buttons?: Array<GraphQLTypes["ContentReferenceCreateButtonsEntityRelationInput"]>,
	sharedContent?: GraphQLTypes["ContentReferenceCreateSharedContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkContentUpdateInput"]: {
		order?: number,
	contentReference?: GraphQLTypes["LinkContentUpdateContentReferenceEntityRelationInput"],
	text?: string,
	target?: GraphQLTypes["LinkContentUpdateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkContentUpdateContentReferenceEntityRelationInput"]: {
		create?: GraphQLTypes["ContentReferenceWithoutLinksCreateInput"],
	update?: GraphQLTypes["ContentReferenceWithoutLinksUpdateInput"],
	upsert?: GraphQLTypes["LinkContentUpsertContentReferenceRelationInput"],
	connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	delete?: boolean
};
	["ContentReferenceWithoutLinksUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"],
	contentPart?: GraphQLTypes["ContentReferenceUpdateContentPartEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	variant?: GraphQLTypes["ContentReferenceVariant"],
	color?: string,
	embed?: GraphQLTypes["ContentReferenceUpdateEmbedEntityRelationInput"],
	article?: GraphQLTypes["ContentReferenceUpdateArticleEntityRelationInput"],
	audio?: GraphQLTypes["ContentReferenceUpdateAudioEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"],
	images?: Array<GraphQLTypes["ContentReferenceUpdateImagesEntityRelationInput"]>,
	pollAnswer?: GraphQLTypes["ContentReferenceUpdatePollAnswerEntityRelationInput"],
	listicle?: Array<GraphQLTypes["ContentReferenceUpdateListicleEntityRelationInput"]>,
	faq?: Array<GraphQLTypes["ContentReferenceUpdateFaqEntityRelationInput"]>,
	awards?: Array<GraphQLTypes["ContentReferenceUpdateAwardsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ContentReferenceUpdateReviewsEntityRelationInput"]>,
	target?: GraphQLTypes["ContentReferenceUpdateTargetEntityRelationInput"],
	subscriptionForm?: GraphQLTypes["ContentReferenceUpdateSubscriptionFormEntityRelationInput"],
	buttons?: Array<GraphQLTypes["ContentReferenceUpdateButtonsEntityRelationInput"]>,
	sharedContent?: GraphQLTypes["ContentReferenceUpdateSharedContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkContentUpsertContentReferenceRelationInput"]: {
		update?: GraphQLTypes["ContentReferenceWithoutLinksUpdateInput"],
	create?: GraphQLTypes["ContentReferenceWithoutLinksCreateInput"]
};
	["AwardContentCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	image?: GraphQLTypes["AwardContentCreateImageEntityRelationInput"],
	contentReference?: GraphQLTypes["AwardContentCreateContentReferenceEntityRelationInput"],
	target?: GraphQLTypes["AwardContentCreateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["AwardContentCreateContentReferenceEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	create?: GraphQLTypes["ContentReferenceWithoutAwardsCreateInput"]
};
	["ContentReferenceWithoutAwardsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ContentReferenceType"],
	contentPart?: GraphQLTypes["ContentReferenceCreateContentPartEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	variant?: GraphQLTypes["ContentReferenceVariant"],
	color?: string,
	embed?: GraphQLTypes["ContentReferenceCreateEmbedEntityRelationInput"],
	article?: GraphQLTypes["ContentReferenceCreateArticleEntityRelationInput"],
	audio?: GraphQLTypes["ContentReferenceCreateAudioEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"],
	images?: Array<GraphQLTypes["ContentReferenceCreateImagesEntityRelationInput"]>,
	pollAnswer?: GraphQLTypes["ContentReferenceCreatePollAnswerEntityRelationInput"],
	listicle?: Array<GraphQLTypes["ContentReferenceCreateListicleEntityRelationInput"]>,
	faq?: Array<GraphQLTypes["ContentReferenceCreateFaqEntityRelationInput"]>,
	links?: Array<GraphQLTypes["ContentReferenceCreateLinksEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ContentReferenceCreateReviewsEntityRelationInput"]>,
	target?: GraphQLTypes["ContentReferenceCreateTargetEntityRelationInput"],
	subscriptionForm?: GraphQLTypes["ContentReferenceCreateSubscriptionFormEntityRelationInput"],
	buttons?: Array<GraphQLTypes["ContentReferenceCreateButtonsEntityRelationInput"]>,
	sharedContent?: GraphQLTypes["ContentReferenceCreateSharedContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["AwardContentUpdateInput"]: {
		order?: number,
	image?: GraphQLTypes["AwardContentUpdateImageEntityRelationInput"],
	contentReference?: GraphQLTypes["AwardContentUpdateContentReferenceEntityRelationInput"],
	target?: GraphQLTypes["AwardContentUpdateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["AwardContentUpdateContentReferenceEntityRelationInput"]: {
		create?: GraphQLTypes["ContentReferenceWithoutAwardsCreateInput"],
	update?: GraphQLTypes["ContentReferenceWithoutAwardsUpdateInput"],
	upsert?: GraphQLTypes["AwardContentUpsertContentReferenceRelationInput"],
	connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	delete?: boolean
};
	["ContentReferenceWithoutAwardsUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"],
	contentPart?: GraphQLTypes["ContentReferenceUpdateContentPartEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	variant?: GraphQLTypes["ContentReferenceVariant"],
	color?: string,
	embed?: GraphQLTypes["ContentReferenceUpdateEmbedEntityRelationInput"],
	article?: GraphQLTypes["ContentReferenceUpdateArticleEntityRelationInput"],
	audio?: GraphQLTypes["ContentReferenceUpdateAudioEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"],
	images?: Array<GraphQLTypes["ContentReferenceUpdateImagesEntityRelationInput"]>,
	pollAnswer?: GraphQLTypes["ContentReferenceUpdatePollAnswerEntityRelationInput"],
	listicle?: Array<GraphQLTypes["ContentReferenceUpdateListicleEntityRelationInput"]>,
	faq?: Array<GraphQLTypes["ContentReferenceUpdateFaqEntityRelationInput"]>,
	links?: Array<GraphQLTypes["ContentReferenceUpdateLinksEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ContentReferenceUpdateReviewsEntityRelationInput"]>,
	target?: GraphQLTypes["ContentReferenceUpdateTargetEntityRelationInput"],
	subscriptionForm?: GraphQLTypes["ContentReferenceUpdateSubscriptionFormEntityRelationInput"],
	buttons?: Array<GraphQLTypes["ContentReferenceUpdateButtonsEntityRelationInput"]>,
	sharedContent?: GraphQLTypes["ContentReferenceUpdateSharedContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["AwardContentUpsertContentReferenceRelationInput"]: {
		update?: GraphQLTypes["ContentReferenceWithoutAwardsUpdateInput"],
	create?: GraphQLTypes["ContentReferenceWithoutAwardsCreateInput"]
};
	["ReviewContentCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	text?: string,
	contentReference?: GraphQLTypes["ReviewContentCreateContentReferenceEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ReviewContentCreateContentReferenceEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	create?: GraphQLTypes["ContentReferenceWithoutReviewsCreateInput"]
};
	["ContentReferenceWithoutReviewsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ContentReferenceType"],
	contentPart?: GraphQLTypes["ContentReferenceCreateContentPartEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	variant?: GraphQLTypes["ContentReferenceVariant"],
	color?: string,
	embed?: GraphQLTypes["ContentReferenceCreateEmbedEntityRelationInput"],
	article?: GraphQLTypes["ContentReferenceCreateArticleEntityRelationInput"],
	audio?: GraphQLTypes["ContentReferenceCreateAudioEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"],
	images?: Array<GraphQLTypes["ContentReferenceCreateImagesEntityRelationInput"]>,
	pollAnswer?: GraphQLTypes["ContentReferenceCreatePollAnswerEntityRelationInput"],
	listicle?: Array<GraphQLTypes["ContentReferenceCreateListicleEntityRelationInput"]>,
	faq?: Array<GraphQLTypes["ContentReferenceCreateFaqEntityRelationInput"]>,
	links?: Array<GraphQLTypes["ContentReferenceCreateLinksEntityRelationInput"]>,
	awards?: Array<GraphQLTypes["ContentReferenceCreateAwardsEntityRelationInput"]>,
	target?: GraphQLTypes["ContentReferenceCreateTargetEntityRelationInput"],
	subscriptionForm?: GraphQLTypes["ContentReferenceCreateSubscriptionFormEntityRelationInput"],
	buttons?: Array<GraphQLTypes["ContentReferenceCreateButtonsEntityRelationInput"]>,
	sharedContent?: GraphQLTypes["ContentReferenceCreateSharedContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ReviewContentUpdateInput"]: {
		order?: number,
	text?: string,
	contentReference?: GraphQLTypes["ReviewContentUpdateContentReferenceEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ReviewContentUpdateContentReferenceEntityRelationInput"]: {
		create?: GraphQLTypes["ContentReferenceWithoutReviewsCreateInput"],
	update?: GraphQLTypes["ContentReferenceWithoutReviewsUpdateInput"],
	upsert?: GraphQLTypes["ReviewContentUpsertContentReferenceRelationInput"],
	connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	delete?: boolean
};
	["ContentReferenceWithoutReviewsUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"],
	contentPart?: GraphQLTypes["ContentReferenceUpdateContentPartEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	variant?: GraphQLTypes["ContentReferenceVariant"],
	color?: string,
	embed?: GraphQLTypes["ContentReferenceUpdateEmbedEntityRelationInput"],
	article?: GraphQLTypes["ContentReferenceUpdateArticleEntityRelationInput"],
	audio?: GraphQLTypes["ContentReferenceUpdateAudioEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"],
	images?: Array<GraphQLTypes["ContentReferenceUpdateImagesEntityRelationInput"]>,
	pollAnswer?: GraphQLTypes["ContentReferenceUpdatePollAnswerEntityRelationInput"],
	listicle?: Array<GraphQLTypes["ContentReferenceUpdateListicleEntityRelationInput"]>,
	faq?: Array<GraphQLTypes["ContentReferenceUpdateFaqEntityRelationInput"]>,
	links?: Array<GraphQLTypes["ContentReferenceUpdateLinksEntityRelationInput"]>,
	awards?: Array<GraphQLTypes["ContentReferenceUpdateAwardsEntityRelationInput"]>,
	target?: GraphQLTypes["ContentReferenceUpdateTargetEntityRelationInput"],
	subscriptionForm?: GraphQLTypes["ContentReferenceUpdateSubscriptionFormEntityRelationInput"],
	buttons?: Array<GraphQLTypes["ContentReferenceUpdateButtonsEntityRelationInput"]>,
	sharedContent?: GraphQLTypes["ContentReferenceUpdateSharedContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ReviewContentUpsertContentReferenceRelationInput"]: {
		update?: GraphQLTypes["ContentReferenceWithoutReviewsUpdateInput"],
	create?: GraphQLTypes["ContentReferenceWithoutReviewsCreateInput"]
};
	["PageConnection"]: {
	__typename: "PageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PageEdge"]>
};
	["PageEdge"]: {
	__typename: "PageEdge",
	node: GraphQLTypes["Page"]
};
	["PageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	publishAt?: GraphQLTypes["DateTime"],
	createdAt?: GraphQLTypes["DateTime"],
	template?: GraphQLTypes["PageTemplate"],
	url?: GraphQLTypes["PageCreateUrlEntityRelationInput"],
	content?: GraphQLTypes["PageCreateContentEntityRelationInput"],
	seo?: GraphQLTypes["PageCreateSeoEntityRelationInput"],
	subscriptionValidity?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["PageUpdateInput"]: {
		title?: string,
	publishAt?: GraphQLTypes["DateTime"],
	createdAt?: GraphQLTypes["DateTime"],
	template?: GraphQLTypes["PageTemplate"],
	url?: GraphQLTypes["PageUpdateUrlEntityRelationInput"],
	content?: GraphQLTypes["PageUpdateContentEntityRelationInput"],
	seo?: GraphQLTypes["PageUpdateSeoEntityRelationInput"],
	subscriptionValidity?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["TextTranslation"]: {
	__typename: "TextTranslation",
	_meta?: GraphQLTypes["TextTranslationMeta"],
	id: GraphQLTypes["UUID"],
	key: string,
	description?: string,
	value: string,
	draft: boolean
};
	["TextTranslationMeta"]: {
	__typename: "TextTranslationMeta",
	id?: GraphQLTypes["FieldMeta"],
	key?: GraphQLTypes["FieldMeta"],
	description?: GraphQLTypes["FieldMeta"],
	value?: GraphQLTypes["FieldMeta"],
	draft?: GraphQLTypes["FieldMeta"]
};
	["TextTranslationUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	key?: string
};
	["TextTranslationWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	key?: GraphQLTypes["StringCondition"],
	description?: GraphQLTypes["StringCondition"],
	value?: GraphQLTypes["StringCondition"],
	draft?: GraphQLTypes["BooleanCondition"],
	and?: Array<GraphQLTypes["TextTranslationWhere"] | undefined>,
	or?: Array<GraphQLTypes["TextTranslationWhere"] | undefined>,
	not?: GraphQLTypes["TextTranslationWhere"]
};
	["TextTranslationOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	key?: GraphQLTypes["OrderDirection"],
	description?: GraphQLTypes["OrderDirection"],
	value?: GraphQLTypes["OrderDirection"],
	draft?: GraphQLTypes["OrderDirection"]
};
	["TextTranslationConnection"]: {
	__typename: "TextTranslationConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TextTranslationEdge"]>
};
	["TextTranslationEdge"]: {
	__typename: "TextTranslationEdge",
	node: GraphQLTypes["TextTranslation"]
};
	["TextTranslationCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	key?: string,
	description?: string,
	value?: string,
	draft?: boolean,
	_dummy_field_?: boolean
};
	["TextTranslationUpdateInput"]: {
		key?: string,
	description?: string,
	value?: string,
	draft?: boolean,
	_dummy_field_?: boolean
};
	["SeoConnection"]: {
	__typename: "SeoConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SeoEdge"]>
};
	["SeoEdge"]: {
	__typename: "SeoEdge",
	node: GraphQLTypes["Seo"]
};
	["FileConnection"]: {
	__typename: "FileConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FileEdge"]>
};
	["FileEdge"]: {
	__typename: "FileEdge",
	node: GraphQLTypes["File"]
};
	["FileCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	uses?: Array<GraphQLTypes["FileCreateUsesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["FileCreateUsesEntityRelationInput"]: {
		connect?: GraphQLTypes["FileUseUniqueWhere"],
	create?: GraphQLTypes["FileUseWithoutFileCreateInput"],
	alias?: string
};
	["FileUseWithoutFileCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["FileUpdateInput"]: {
		url?: string,
	uses?: Array<GraphQLTypes["FileUpdateUsesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["FileUpdateUsesEntityRelationInput"]: {
		create?: GraphQLTypes["FileUseWithoutFileCreateInput"],
	update?: GraphQLTypes["FileUpdateUsesRelationInput"],
	upsert?: GraphQLTypes["FileUpsertUsesRelationInput"],
	connect?: GraphQLTypes["FileUseUniqueWhere"],
	disconnect?: GraphQLTypes["FileUseUniqueWhere"],
	delete?: GraphQLTypes["FileUseUniqueWhere"],
	alias?: string
};
	["FileUpdateUsesRelationInput"]: {
		by?: GraphQLTypes["FileUseUniqueWhere"],
	data?: GraphQLTypes["FileUseWithoutFileUpdateInput"]
};
	["FileUseWithoutFileUpdateInput"]: {
		_dummy_field_?: boolean
};
	["FileUpsertUsesRelationInput"]: {
		by?: GraphQLTypes["FileUseUniqueWhere"],
	update?: GraphQLTypes["FileUseWithoutFileUpdateInput"],
	create?: GraphQLTypes["FileUseWithoutFileCreateInput"]
};
	["ContentBlockCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	type?: GraphQLTypes["ContentBlockType"],
	youtubeId?: string,
	text?: string,
	targetLabel?: string,
	issue?: GraphQLTypes["ContentBlockCreateIssueEntityRelationInput"],
	target?: GraphQLTypes["ContentBlockCreateTargetEntityRelationInput"],
	articles?: Array<GraphQLTypes["ContentBlockCreateArticlesEntityRelationInput"]>,
	subscriptionForm?: GraphQLTypes["ContentBlockCreateSubscriptionFormEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentBlockUpdateInput"]: {
		order?: number,
	type?: GraphQLTypes["ContentBlockType"],
	youtubeId?: string,
	text?: string,
	targetLabel?: string,
	issue?: GraphQLTypes["ContentBlockUpdateIssueEntityRelationInput"],
	target?: GraphQLTypes["ContentBlockUpdateTargetEntityRelationInput"],
	articles?: Array<GraphQLTypes["ContentBlockUpdateArticlesEntityRelationInput"]>,
	subscriptionForm?: GraphQLTypes["ContentBlockUpdateSubscriptionFormEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentArticleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	contentBlock?: GraphQLTypes["ContentArticleCreateContentBlockEntityRelationInput"],
	article?: GraphQLTypes["ContentArticleCreateArticleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentArticleUpdateInput"]: {
		order?: number,
	contentBlock?: GraphQLTypes["ContentArticleUpdateContentBlockEntityRelationInput"],
	article?: GraphQLTypes["ContentArticleUpdateArticleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["UnlockedArticleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	createdAt?: GraphQLTypes["DateTime"],
	code?: string,
	views?: number,
	user?: GraphQLTypes["UnlockedArticleCreateUserEntityRelationInput"],
	article?: GraphQLTypes["UnlockedArticleCreateArticleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["UnlockedArticleUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"],
	code?: string,
	views?: number,
	user?: GraphQLTypes["UnlockedArticleUpdateUserEntityRelationInput"],
	article?: GraphQLTypes["UnlockedArticleUpdateArticleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["UserCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	ihnedId?: string,
	email?: string,
	authors?: Array<GraphQLTypes["UserCreateAuthorsEntityRelationInput"]>,
	unlockedArticles?: Array<GraphQLTypes["UserCreateUnlockedArticlesEntityRelationInput"]>,
	appReviews?: Array<GraphQLTypes["UserCreateAppReviewsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["UserUpdateInput"]: {
		ihnedId?: string,
	email?: string,
	authors?: Array<GraphQLTypes["UserUpdateAuthorsEntityRelationInput"]>,
	unlockedArticles?: Array<GraphQLTypes["UserUpdateUnlockedArticlesEntityRelationInput"]>,
	appReviews?: Array<GraphQLTypes["UserUpdateAppReviewsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["Notification"]: {
	__typename: "Notification",
	_meta?: GraphQLTypes["NotificationMeta"],
	id: GraphQLTypes["UUID"],
	title: string,
	message: string,
	sendAt: GraphQLTypes["DateTime"],
	sent?: GraphQLTypes["DateTime"]
};
	["NotificationMeta"]: {
	__typename: "NotificationMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	message?: GraphQLTypes["FieldMeta"],
	sendAt?: GraphQLTypes["FieldMeta"],
	sent?: GraphQLTypes["FieldMeta"]
};
	["NotificationUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["NotificationWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	message?: GraphQLTypes["StringCondition"],
	sendAt?: GraphQLTypes["DateTimeCondition"],
	sent?: GraphQLTypes["DateTimeCondition"],
	and?: Array<GraphQLTypes["NotificationWhere"] | undefined>,
	or?: Array<GraphQLTypes["NotificationWhere"] | undefined>,
	not?: GraphQLTypes["NotificationWhere"]
};
	["NotificationOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	message?: GraphQLTypes["OrderDirection"],
	sendAt?: GraphQLTypes["OrderDirection"],
	sent?: GraphQLTypes["OrderDirection"]
};
	["NotificationConnection"]: {
	__typename: "NotificationConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["NotificationEdge"]>
};
	["NotificationEdge"]: {
	__typename: "NotificationEdge",
	node: GraphQLTypes["Notification"]
};
	["NotificationCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	message?: string,
	sendAt?: GraphQLTypes["DateTime"],
	sent?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["NotificationUpdateInput"]: {
		title?: string,
	message?: string,
	sendAt?: GraphQLTypes["DateTime"],
	sent?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["AppReviewCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	done?: boolean,
	deviceId?: string,
	createdAt?: GraphQLTypes["DateTime"],
	rating?: number,
	note?: string,
	user?: GraphQLTypes["AppReviewCreateUserEntityRelationInput"],
	_dummy_field_?: boolean
};
	["AppReviewCreateUserEntityRelationInput"]: {
		connect?: GraphQLTypes["UserUniqueWhere"],
	create?: GraphQLTypes["UserWithoutAppReviewsCreateInput"]
};
	["UserWithoutAppReviewsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	ihnedId?: string,
	email?: string,
	authors?: Array<GraphQLTypes["UserCreateAuthorsEntityRelationInput"]>,
	unlockedArticles?: Array<GraphQLTypes["UserCreateUnlockedArticlesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["AppReviewUpdateInput"]: {
		done?: boolean,
	deviceId?: string,
	createdAt?: GraphQLTypes["DateTime"],
	rating?: number,
	note?: string,
	user?: GraphQLTypes["AppReviewUpdateUserEntityRelationInput"],
	_dummy_field_?: boolean
};
	["AppReviewUpdateUserEntityRelationInput"]: {
		create?: GraphQLTypes["UserWithoutAppReviewsCreateInput"],
	update?: GraphQLTypes["UserWithoutAppReviewsUpdateInput"],
	upsert?: GraphQLTypes["AppReviewUpsertUserRelationInput"],
	connect?: GraphQLTypes["UserUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["UserWithoutAppReviewsUpdateInput"]: {
		ihnedId?: string,
	email?: string,
	authors?: Array<GraphQLTypes["UserUpdateAuthorsEntityRelationInput"]>,
	unlockedArticles?: Array<GraphQLTypes["UserUpdateUnlockedArticlesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["AppReviewUpsertUserRelationInput"]: {
		update?: GraphQLTypes["UserWithoutAppReviewsUpdateInput"],
	create?: GraphQLTypes["UserWithoutAppReviewsCreateInput"]
};
	["ProductCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	price?: number,
	type?: GraphQLTypes["Types"],
	formOptions?: Array<GraphQLTypes["ProductCreateFormOptionsEntityRelationInput"]>,
	form?: GraphQLTypes["ProductCreateFormEntityRelationInput"],
	productId?: string,
	_dummy_field_?: boolean
};
	["ProductUpdateInput"]: {
		price?: number,
	type?: GraphQLTypes["Types"],
	formOptions?: Array<GraphQLTypes["ProductUpdateFormOptionsEntityRelationInput"]>,
	form?: GraphQLTypes["ProductUpdateFormEntityRelationInput"],
	productId?: string,
	_dummy_field_?: boolean
};
	["SubscriptionFormConnection"]: {
	__typename: "SubscriptionFormConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SubscriptionFormEdge"]>
};
	["SubscriptionFormEdge"]: {
	__typename: "SubscriptionFormEdge",
	node: GraphQLTypes["SubscriptionForm"]
};
	["SubscriptionFormCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	code?: string,
	createdAt?: GraphQLTypes["DateTime"],
	sections?: Array<GraphQLTypes["SubscriptionFormCreateSectionsEntityRelationInput"]>,
	contentBlock?: Array<GraphQLTypes["SubscriptionFormCreateContentBlockEntityRelationInput"]>,
	products?: Array<GraphQLTypes["SubscriptionFormCreateProductsEntityRelationInput"]>,
	contentReferences?: Array<GraphQLTypes["SubscriptionFormCreateContentReferencesEntityRelationInput"]>,
	validity?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["SubscriptionFormUpdateInput"]: {
		name?: string,
	code?: string,
	createdAt?: GraphQLTypes["DateTime"],
	sections?: Array<GraphQLTypes["SubscriptionFormUpdateSectionsEntityRelationInput"]>,
	contentBlock?: Array<GraphQLTypes["SubscriptionFormUpdateContentBlockEntityRelationInput"]>,
	products?: Array<GraphQLTypes["SubscriptionFormUpdateProductsEntityRelationInput"]>,
	contentReferences?: Array<GraphQLTypes["SubscriptionFormUpdateContentReferencesEntityRelationInput"]>,
	validity?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["SubscriptionFormSectionCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	title?: string,
	form?: GraphQLTypes["SubscriptionFormSectionCreateFormEntityRelationInput"],
	inputs?: Array<GraphQLTypes["SubscriptionFormSectionCreateInputsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["SubscriptionFormSectionUpdateInput"]: {
		order?: number,
	title?: string,
	form?: GraphQLTypes["SubscriptionFormSectionUpdateFormEntityRelationInput"],
	inputs?: Array<GraphQLTypes["SubscriptionFormSectionUpdateInputsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["SubscriptionFormInputCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	type?: GraphQLTypes["SubscriptionFormInputType"],
	image?: GraphQLTypes["SubscriptionFormInputCreateImageEntityRelationInput"],
	section?: GraphQLTypes["SubscriptionFormInputCreateSectionEntityRelationInput"],
	options?: Array<GraphQLTypes["SubscriptionFormInputCreateOptionsEntityRelationInput"]>,
	description?: GraphQLTypes["SubscriptionFormInputCreateDescriptionEntityRelationInput"],
	required?: boolean,
	_dummy_field_?: boolean
};
	["SubscriptionFormInputUpdateInput"]: {
		order?: number,
	type?: GraphQLTypes["SubscriptionFormInputType"],
	image?: GraphQLTypes["SubscriptionFormInputUpdateImageEntityRelationInput"],
	section?: GraphQLTypes["SubscriptionFormInputUpdateSectionEntityRelationInput"],
	options?: Array<GraphQLTypes["SubscriptionFormInputUpdateOptionsEntityRelationInput"]>,
	description?: GraphQLTypes["SubscriptionFormInputUpdateDescriptionEntityRelationInput"],
	required?: boolean,
	_dummy_field_?: boolean
};
	["SubscriptionFormOptionCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	hasProductId?: boolean,
	order?: number,
	label?: string,
	priceTag?: string,
	priceTagWithDiscount?: string,
	products?: Array<GraphQLTypes["SubscriptionFormOptionCreateProductsEntityRelationInput"]>,
	formInput?: GraphQLTypes["SubscriptionFormOptionCreateFormInputEntityRelationInput"],
	value?: string,
	internalLabel?: string,
	_dummy_field_?: boolean
};
	["SubscriptionFormOptionUpdateInput"]: {
		hasProductId?: boolean,
	order?: number,
	label?: string,
	priceTag?: string,
	priceTagWithDiscount?: string,
	products?: Array<GraphQLTypes["SubscriptionFormOptionUpdateProductsEntityRelationInput"]>,
	formInput?: GraphQLTypes["SubscriptionFormOptionUpdateFormInputEntityRelationInput"],
	value?: string,
	internalLabel?: string,
	_dummy_field_?: boolean
};
	["ButtonCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	type?: GraphQLTypes["ButtonType"],
	label?: string,
	target?: GraphQLTypes["ButtonCreateTargetEntityRelationInput"],
	contentReference?: GraphQLTypes["ButtonCreateContentReferenceEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ButtonCreateContentReferenceEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	create?: GraphQLTypes["ContentReferenceWithoutButtonsCreateInput"]
};
	["ContentReferenceWithoutButtonsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ContentReferenceType"],
	contentPart?: GraphQLTypes["ContentReferenceCreateContentPartEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	variant?: GraphQLTypes["ContentReferenceVariant"],
	color?: string,
	embed?: GraphQLTypes["ContentReferenceCreateEmbedEntityRelationInput"],
	article?: GraphQLTypes["ContentReferenceCreateArticleEntityRelationInput"],
	audio?: GraphQLTypes["ContentReferenceCreateAudioEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"],
	images?: Array<GraphQLTypes["ContentReferenceCreateImagesEntityRelationInput"]>,
	pollAnswer?: GraphQLTypes["ContentReferenceCreatePollAnswerEntityRelationInput"],
	listicle?: Array<GraphQLTypes["ContentReferenceCreateListicleEntityRelationInput"]>,
	faq?: Array<GraphQLTypes["ContentReferenceCreateFaqEntityRelationInput"]>,
	links?: Array<GraphQLTypes["ContentReferenceCreateLinksEntityRelationInput"]>,
	awards?: Array<GraphQLTypes["ContentReferenceCreateAwardsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ContentReferenceCreateReviewsEntityRelationInput"]>,
	target?: GraphQLTypes["ContentReferenceCreateTargetEntityRelationInput"],
	subscriptionForm?: GraphQLTypes["ContentReferenceCreateSubscriptionFormEntityRelationInput"],
	sharedContent?: GraphQLTypes["ContentReferenceCreateSharedContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ButtonUpdateInput"]: {
		order?: number,
	type?: GraphQLTypes["ButtonType"],
	label?: string,
	target?: GraphQLTypes["ButtonUpdateTargetEntityRelationInput"],
	contentReference?: GraphQLTypes["ButtonUpdateContentReferenceEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ButtonUpdateContentReferenceEntityRelationInput"]: {
		create?: GraphQLTypes["ContentReferenceWithoutButtonsCreateInput"],
	update?: GraphQLTypes["ContentReferenceWithoutButtonsUpdateInput"],
	upsert?: GraphQLTypes["ButtonUpsertContentReferenceRelationInput"],
	connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	delete?: boolean
};
	["ContentReferenceWithoutButtonsUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"],
	contentPart?: GraphQLTypes["ContentReferenceUpdateContentPartEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	variant?: GraphQLTypes["ContentReferenceVariant"],
	color?: string,
	embed?: GraphQLTypes["ContentReferenceUpdateEmbedEntityRelationInput"],
	article?: GraphQLTypes["ContentReferenceUpdateArticleEntityRelationInput"],
	audio?: GraphQLTypes["ContentReferenceUpdateAudioEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"],
	images?: Array<GraphQLTypes["ContentReferenceUpdateImagesEntityRelationInput"]>,
	pollAnswer?: GraphQLTypes["ContentReferenceUpdatePollAnswerEntityRelationInput"],
	listicle?: Array<GraphQLTypes["ContentReferenceUpdateListicleEntityRelationInput"]>,
	faq?: Array<GraphQLTypes["ContentReferenceUpdateFaqEntityRelationInput"]>,
	links?: Array<GraphQLTypes["ContentReferenceUpdateLinksEntityRelationInput"]>,
	awards?: Array<GraphQLTypes["ContentReferenceUpdateAwardsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ContentReferenceUpdateReviewsEntityRelationInput"]>,
	target?: GraphQLTypes["ContentReferenceUpdateTargetEntityRelationInput"],
	subscriptionForm?: GraphQLTypes["ContentReferenceUpdateSubscriptionFormEntityRelationInput"],
	sharedContent?: GraphQLTypes["ContentReferenceUpdateSharedContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ButtonUpsertContentReferenceRelationInput"]: {
		update?: GraphQLTypes["ContentReferenceWithoutButtonsUpdateInput"],
	create?: GraphQLTypes["ContentReferenceWithoutButtonsCreateInput"]
};
	["ArticleHistoryTagCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	article?: GraphQLTypes["ArticleHistoryTagCreateArticleEntityRelationInput"],
	historyTag?: GraphQLTypes["ArticleHistoryTagCreateHistoryTagEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArticleHistoryTagCreateArticleEntityRelationInput"]: {
		connect?: GraphQLTypes["ArticleUniqueWhere"],
	create?: GraphQLTypes["ArticleWithoutHistoryTagsCreateInput"]
};
	["ArticleWithoutHistoryTagsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	url?: GraphQLTypes["ArticleCreateUrlEntityRelationInput"],
	authors?: Array<GraphQLTypes["ArticleCreateAuthorsEntityRelationInput"]>,
	hideInMostRead?: boolean,
	hideAds?: boolean,
	state?: GraphQLTypes["ArticleState"],
	locked?: boolean,
	publishAt?: GraphQLTypes["DateTime"],
	template?: GraphQLTypes["Template"],
	subtitle?: GraphQLTypes["ArticleCreateSubtitleEntityRelationInput"],
	content?: GraphQLTypes["ArticleCreateContentEntityRelationInput"],
	coverPhoto?: GraphQLTypes["ArticleCreateCoverPhotoEntityRelationInput"],
	titleAlignment?: GraphQLTypes["ArticleTitleAlignment"],
	tagline?: string,
	createdAt?: GraphQLTypes["DateTime"],
	previewContent?: GraphQLTypes["ArticleCreatePreviewContentEntityRelationInput"],
	audio?: GraphQLTypes["ArticleCreateAudioEntityRelationInput"],
	categories?: Array<GraphQLTypes["ArticleCreateCategoriesEntityRelationInput"]>,
	issues?: Array<GraphQLTypes["ArticleCreateIssuesEntityRelationInput"]>,
	contentBlocks?: Array<GraphQLTypes["ArticleCreateContentBlocksEntityRelationInput"]>,
	unlocked?: Array<GraphQLTypes["ArticleCreateUnlockedEntityRelationInput"]>,
	coverPhotoVertical?: GraphQLTypes["ArticleCreateCoverPhotoVerticalEntityRelationInput"],
	legacyId?: string,
	tags?: Array<GraphQLTypes["ArticleCreateTagsEntityRelationInput"]>,
	isHistory?: boolean,
	historyPeriods?: Array<GraphQLTypes["ArticleCreateHistoryPeriodsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ArticleHistoryTagUpdateInput"]: {
		order?: number,
	article?: GraphQLTypes["ArticleHistoryTagUpdateArticleEntityRelationInput"],
	historyTag?: GraphQLTypes["ArticleHistoryTagUpdateHistoryTagEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArticleHistoryTagUpdateArticleEntityRelationInput"]: {
		create?: GraphQLTypes["ArticleWithoutHistoryTagsCreateInput"],
	update?: GraphQLTypes["ArticleWithoutHistoryTagsUpdateInput"],
	upsert?: GraphQLTypes["ArticleHistoryTagUpsertArticleRelationInput"],
	connect?: GraphQLTypes["ArticleUniqueWhere"],
	delete?: boolean
};
	["ArticleWithoutHistoryTagsUpdateInput"]: {
		title?: string,
	url?: GraphQLTypes["ArticleUpdateUrlEntityRelationInput"],
	authors?: Array<GraphQLTypes["ArticleUpdateAuthorsEntityRelationInput"]>,
	hideInMostRead?: boolean,
	hideAds?: boolean,
	state?: GraphQLTypes["ArticleState"],
	locked?: boolean,
	publishAt?: GraphQLTypes["DateTime"],
	template?: GraphQLTypes["Template"],
	subtitle?: GraphQLTypes["ArticleUpdateSubtitleEntityRelationInput"],
	content?: GraphQLTypes["ArticleUpdateContentEntityRelationInput"],
	coverPhoto?: GraphQLTypes["ArticleUpdateCoverPhotoEntityRelationInput"],
	titleAlignment?: GraphQLTypes["ArticleTitleAlignment"],
	tagline?: string,
	createdAt?: GraphQLTypes["DateTime"],
	previewContent?: GraphQLTypes["ArticleUpdatePreviewContentEntityRelationInput"],
	audio?: GraphQLTypes["ArticleUpdateAudioEntityRelationInput"],
	categories?: Array<GraphQLTypes["ArticleUpdateCategoriesEntityRelationInput"]>,
	issues?: Array<GraphQLTypes["ArticleUpdateIssuesEntityRelationInput"]>,
	contentBlocks?: Array<GraphQLTypes["ArticleUpdateContentBlocksEntityRelationInput"]>,
	unlocked?: Array<GraphQLTypes["ArticleUpdateUnlockedEntityRelationInput"]>,
	coverPhotoVertical?: GraphQLTypes["ArticleUpdateCoverPhotoVerticalEntityRelationInput"],
	legacyId?: string,
	tags?: Array<GraphQLTypes["ArticleUpdateTagsEntityRelationInput"]>,
	isHistory?: boolean,
	historyPeriods?: Array<GraphQLTypes["ArticleUpdateHistoryPeriodsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ArticleHistoryTagUpsertArticleRelationInput"]: {
		update?: GraphQLTypes["ArticleWithoutHistoryTagsUpdateInput"],
	create?: GraphQLTypes["ArticleWithoutHistoryTagsCreateInput"]
};
	["ArticleHistoryPeriodCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	article?: GraphQLTypes["ArticleHistoryPeriodCreateArticleEntityRelationInput"],
	historyPeriod?: GraphQLTypes["ArticleHistoryPeriodCreateHistoryPeriodEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArticleHistoryPeriodCreateArticleEntityRelationInput"]: {
		connect?: GraphQLTypes["ArticleUniqueWhere"],
	create?: GraphQLTypes["ArticleWithoutHistoryPeriodsCreateInput"]
};
	["ArticleWithoutHistoryPeriodsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	url?: GraphQLTypes["ArticleCreateUrlEntityRelationInput"],
	authors?: Array<GraphQLTypes["ArticleCreateAuthorsEntityRelationInput"]>,
	hideInMostRead?: boolean,
	hideAds?: boolean,
	state?: GraphQLTypes["ArticleState"],
	locked?: boolean,
	publishAt?: GraphQLTypes["DateTime"],
	template?: GraphQLTypes["Template"],
	subtitle?: GraphQLTypes["ArticleCreateSubtitleEntityRelationInput"],
	content?: GraphQLTypes["ArticleCreateContentEntityRelationInput"],
	coverPhoto?: GraphQLTypes["ArticleCreateCoverPhotoEntityRelationInput"],
	titleAlignment?: GraphQLTypes["ArticleTitleAlignment"],
	tagline?: string,
	createdAt?: GraphQLTypes["DateTime"],
	previewContent?: GraphQLTypes["ArticleCreatePreviewContentEntityRelationInput"],
	audio?: GraphQLTypes["ArticleCreateAudioEntityRelationInput"],
	categories?: Array<GraphQLTypes["ArticleCreateCategoriesEntityRelationInput"]>,
	issues?: Array<GraphQLTypes["ArticleCreateIssuesEntityRelationInput"]>,
	contentBlocks?: Array<GraphQLTypes["ArticleCreateContentBlocksEntityRelationInput"]>,
	unlocked?: Array<GraphQLTypes["ArticleCreateUnlockedEntityRelationInput"]>,
	coverPhotoVertical?: GraphQLTypes["ArticleCreateCoverPhotoVerticalEntityRelationInput"],
	legacyId?: string,
	tags?: Array<GraphQLTypes["ArticleCreateTagsEntityRelationInput"]>,
	isHistory?: boolean,
	historyTags?: Array<GraphQLTypes["ArticleCreateHistoryTagsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ArticleHistoryPeriodUpdateInput"]: {
		order?: number,
	article?: GraphQLTypes["ArticleHistoryPeriodUpdateArticleEntityRelationInput"],
	historyPeriod?: GraphQLTypes["ArticleHistoryPeriodUpdateHistoryPeriodEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArticleHistoryPeriodUpdateArticleEntityRelationInput"]: {
		create?: GraphQLTypes["ArticleWithoutHistoryPeriodsCreateInput"],
	update?: GraphQLTypes["ArticleWithoutHistoryPeriodsUpdateInput"],
	upsert?: GraphQLTypes["ArticleHistoryPeriodUpsertArticleRelationInput"],
	connect?: GraphQLTypes["ArticleUniqueWhere"],
	delete?: boolean
};
	["ArticleWithoutHistoryPeriodsUpdateInput"]: {
		title?: string,
	url?: GraphQLTypes["ArticleUpdateUrlEntityRelationInput"],
	authors?: Array<GraphQLTypes["ArticleUpdateAuthorsEntityRelationInput"]>,
	hideInMostRead?: boolean,
	hideAds?: boolean,
	state?: GraphQLTypes["ArticleState"],
	locked?: boolean,
	publishAt?: GraphQLTypes["DateTime"],
	template?: GraphQLTypes["Template"],
	subtitle?: GraphQLTypes["ArticleUpdateSubtitleEntityRelationInput"],
	content?: GraphQLTypes["ArticleUpdateContentEntityRelationInput"],
	coverPhoto?: GraphQLTypes["ArticleUpdateCoverPhotoEntityRelationInput"],
	titleAlignment?: GraphQLTypes["ArticleTitleAlignment"],
	tagline?: string,
	createdAt?: GraphQLTypes["DateTime"],
	previewContent?: GraphQLTypes["ArticleUpdatePreviewContentEntityRelationInput"],
	audio?: GraphQLTypes["ArticleUpdateAudioEntityRelationInput"],
	categories?: Array<GraphQLTypes["ArticleUpdateCategoriesEntityRelationInput"]>,
	issues?: Array<GraphQLTypes["ArticleUpdateIssuesEntityRelationInput"]>,
	contentBlocks?: Array<GraphQLTypes["ArticleUpdateContentBlocksEntityRelationInput"]>,
	unlocked?: Array<GraphQLTypes["ArticleUpdateUnlockedEntityRelationInput"]>,
	coverPhotoVertical?: GraphQLTypes["ArticleUpdateCoverPhotoVerticalEntityRelationInput"],
	legacyId?: string,
	tags?: Array<GraphQLTypes["ArticleUpdateTagsEntityRelationInput"]>,
	isHistory?: boolean,
	historyTags?: Array<GraphQLTypes["ArticleUpdateHistoryTagsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ArticleHistoryPeriodUpsertArticleRelationInput"]: {
		update?: GraphQLTypes["ArticleWithoutHistoryPeriodsUpdateInput"],
	create?: GraphQLTypes["ArticleWithoutHistoryPeriodsCreateInput"]
};
	["HistoryTagConnection"]: {
	__typename: "HistoryTagConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HistoryTagEdge"]>
};
	["HistoryTagEdge"]: {
	__typename: "HistoryTagEdge",
	node: GraphQLTypes["HistoryTag"]
};
	["HistoryTagCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	articleHistoryTag?: Array<GraphQLTypes["HistoryTagCreateArticleHistoryTagEntityRelationInput"]>,
	slug?: string,
	_dummy_field_?: boolean
};
	["HistoryTagCreateArticleHistoryTagEntityRelationInput"]: {
		connect?: GraphQLTypes["ArticleHistoryTagUniqueWhere"],
	create?: GraphQLTypes["ArticleHistoryTagWithoutHistoryTagCreateInput"],
	alias?: string
};
	["ArticleHistoryTagWithoutHistoryTagCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	article?: GraphQLTypes["ArticleHistoryTagCreateArticleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HistoryTagUpdateInput"]: {
		name?: string,
	articleHistoryTag?: Array<GraphQLTypes["HistoryTagUpdateArticleHistoryTagEntityRelationInput"]>,
	slug?: string,
	_dummy_field_?: boolean
};
	["HistoryTagUpdateArticleHistoryTagEntityRelationInput"]: {
		create?: GraphQLTypes["ArticleHistoryTagWithoutHistoryTagCreateInput"],
	update?: GraphQLTypes["HistoryTagUpdateArticleHistoryTagRelationInput"],
	upsert?: GraphQLTypes["HistoryTagUpsertArticleHistoryTagRelationInput"],
	connect?: GraphQLTypes["ArticleHistoryTagUniqueWhere"],
	disconnect?: GraphQLTypes["ArticleHistoryTagUniqueWhere"],
	delete?: GraphQLTypes["ArticleHistoryTagUniqueWhere"],
	alias?: string
};
	["HistoryTagUpdateArticleHistoryTagRelationInput"]: {
		by?: GraphQLTypes["ArticleHistoryTagUniqueWhere"],
	data?: GraphQLTypes["ArticleHistoryTagWithoutHistoryTagUpdateInput"]
};
	["ArticleHistoryTagWithoutHistoryTagUpdateInput"]: {
		order?: number,
	article?: GraphQLTypes["ArticleHistoryTagUpdateArticleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HistoryTagUpsertArticleHistoryTagRelationInput"]: {
		by?: GraphQLTypes["ArticleHistoryTagUniqueWhere"],
	update?: GraphQLTypes["ArticleHistoryTagWithoutHistoryTagUpdateInput"],
	create?: GraphQLTypes["ArticleHistoryTagWithoutHistoryTagCreateInput"]
};
	["HistoryPeriodConnection"]: {
	__typename: "HistoryPeriodConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HistoryPeriodEdge"]>
};
	["HistoryPeriodEdge"]: {
	__typename: "HistoryPeriodEdge",
	node: GraphQLTypes["HistoryPeriod"]
};
	["HistoryPeriodCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	articleHistoryPeriod?: Array<GraphQLTypes["HistoryPeriodCreateArticleHistoryPeriodEntityRelationInput"]>,
	slug?: string,
	order?: number,
	cover?: GraphQLTypes["HistoryPeriodCreateCoverEntityRelationInput"],
	seo?: GraphQLTypes["HistoryPeriodCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HistoryPeriodCreateArticleHistoryPeriodEntityRelationInput"]: {
		connect?: GraphQLTypes["ArticleHistoryPeriodUniqueWhere"],
	create?: GraphQLTypes["ArticleHistoryPeriodWithoutHistoryPeriodCreateInput"],
	alias?: string
};
	["ArticleHistoryPeriodWithoutHistoryPeriodCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	article?: GraphQLTypes["ArticleHistoryPeriodCreateArticleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HistoryPeriodUpdateInput"]: {
		name?: string,
	articleHistoryPeriod?: Array<GraphQLTypes["HistoryPeriodUpdateArticleHistoryPeriodEntityRelationInput"]>,
	slug?: string,
	order?: number,
	cover?: GraphQLTypes["HistoryPeriodUpdateCoverEntityRelationInput"],
	seo?: GraphQLTypes["HistoryPeriodUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HistoryPeriodUpdateArticleHistoryPeriodEntityRelationInput"]: {
		create?: GraphQLTypes["ArticleHistoryPeriodWithoutHistoryPeriodCreateInput"],
	update?: GraphQLTypes["HistoryPeriodUpdateArticleHistoryPeriodRelationInput"],
	upsert?: GraphQLTypes["HistoryPeriodUpsertArticleHistoryPeriodRelationInput"],
	connect?: GraphQLTypes["ArticleHistoryPeriodUniqueWhere"],
	disconnect?: GraphQLTypes["ArticleHistoryPeriodUniqueWhere"],
	delete?: GraphQLTypes["ArticleHistoryPeriodUniqueWhere"],
	alias?: string
};
	["HistoryPeriodUpdateArticleHistoryPeriodRelationInput"]: {
		by?: GraphQLTypes["ArticleHistoryPeriodUniqueWhere"],
	data?: GraphQLTypes["ArticleHistoryPeriodWithoutHistoryPeriodUpdateInput"]
};
	["ArticleHistoryPeriodWithoutHistoryPeriodUpdateInput"]: {
		order?: number,
	article?: GraphQLTypes["ArticleHistoryPeriodUpdateArticleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HistoryPeriodUpsertArticleHistoryPeriodRelationInput"]: {
		by?: GraphQLTypes["ArticleHistoryPeriodUniqueWhere"],
	update?: GraphQLTypes["ArticleHistoryPeriodWithoutHistoryPeriodUpdateInput"],
	create?: GraphQLTypes["ArticleHistoryPeriodWithoutHistoryPeriodCreateInput"]
};
	["HistoryHomePage"]: {
	__typename: "HistoryHomePage",
	_meta?: GraphQLTypes["HistoryHomePageMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["HistoryHomePageUnique"],
	timePeriodTitle?: string,
	personalitiesTitle?: string,
	cover?: GraphQLTypes["HistoryCover"],
	seo?: GraphQLTypes["Seo"],
	slug: string
};
	["HistoryHomePageMeta"]: {
	__typename: "HistoryHomePageMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	timePeriodTitle?: GraphQLTypes["FieldMeta"],
	personalitiesTitle?: GraphQLTypes["FieldMeta"],
	cover?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	slug?: GraphQLTypes["FieldMeta"]
};
	["HistoryHomePageUnique"]: HistoryHomePageUnique;
	["HistoryHomePageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["HistoryHomePageUnique"],
	slug?: string,
	cover?: GraphQLTypes["HistoryCoverUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["HistoryHomePageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["HistoryHomePageUniqueCondition"],
	timePeriodTitle?: GraphQLTypes["StringCondition"],
	personalitiesTitle?: GraphQLTypes["StringCondition"],
	cover?: GraphQLTypes["HistoryCoverWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	slug?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["HistoryHomePageWhere"] | undefined>,
	or?: Array<GraphQLTypes["HistoryHomePageWhere"] | undefined>,
	not?: GraphQLTypes["HistoryHomePageWhere"]
};
	["HistoryHomePageUniqueCondition"]: {
		and?: Array<GraphQLTypes["HistoryHomePageUniqueCondition"]>,
	or?: Array<GraphQLTypes["HistoryHomePageUniqueCondition"]>,
	not?: GraphQLTypes["HistoryHomePageUniqueCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["HistoryHomePageUnique"],
	notEq?: GraphQLTypes["HistoryHomePageUnique"],
	in?: Array<GraphQLTypes["HistoryHomePageUnique"]>,
	notIn?: Array<GraphQLTypes["HistoryHomePageUnique"]>,
	lt?: GraphQLTypes["HistoryHomePageUnique"],
	lte?: GraphQLTypes["HistoryHomePageUnique"],
	gt?: GraphQLTypes["HistoryHomePageUnique"],
	gte?: GraphQLTypes["HistoryHomePageUnique"]
};
	["HistoryHomePageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	timePeriodTitle?: GraphQLTypes["OrderDirection"],
	personalitiesTitle?: GraphQLTypes["OrderDirection"],
	cover?: GraphQLTypes["HistoryCoverOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"],
	slug?: GraphQLTypes["OrderDirection"]
};
	["HistoryHomePageConnection"]: {
	__typename: "HistoryHomePageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HistoryHomePageEdge"]>
};
	["HistoryHomePageEdge"]: {
	__typename: "HistoryHomePageEdge",
	node: GraphQLTypes["HistoryHomePage"]
};
	["HistoryHomePageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["HistoryHomePageUnique"],
	timePeriodTitle?: string,
	personalitiesTitle?: string,
	cover?: GraphQLTypes["HistoryHomePageCreateCoverEntityRelationInput"],
	seo?: GraphQLTypes["HistoryHomePageCreateSeoEntityRelationInput"],
	slug?: string,
	_dummy_field_?: boolean
};
	["HistoryHomePageCreateCoverEntityRelationInput"]: {
		connect?: GraphQLTypes["HistoryCoverUniqueWhere"],
	create?: GraphQLTypes["HistoryCoverCreateInput"]
};
	["HistoryHomePageCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["HistoryHomePageUpdateInput"]: {
		unique?: GraphQLTypes["HistoryHomePageUnique"],
	timePeriodTitle?: string,
	personalitiesTitle?: string,
	cover?: GraphQLTypes["HistoryHomePageUpdateCoverEntityRelationInput"],
	seo?: GraphQLTypes["HistoryHomePageUpdateSeoEntityRelationInput"],
	slug?: string,
	_dummy_field_?: boolean
};
	["HistoryHomePageUpdateCoverEntityRelationInput"]: {
		create?: GraphQLTypes["HistoryCoverCreateInput"],
	update?: GraphQLTypes["HistoryCoverUpdateInput"],
	upsert?: GraphQLTypes["HistoryHomePageUpsertCoverRelationInput"],
	connect?: GraphQLTypes["HistoryCoverUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HistoryHomePageUpsertCoverRelationInput"]: {
		update?: GraphQLTypes["HistoryCoverUpdateInput"],
	create?: GraphQLTypes["HistoryCoverCreateInput"]
};
	["HistoryHomePageUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["HistoryHomePageUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HistoryHomePageUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["HistoryCoverConnection"]: {
	__typename: "HistoryCoverConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HistoryCoverEdge"]>
};
	["HistoryCoverEdge"]: {
	__typename: "HistoryCoverEdge",
	node: GraphQLTypes["HistoryCover"]
};
	["HistoryTextListConnection"]: {
	__typename: "HistoryTextListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HistoryTextListEdge"]>
};
	["HistoryTextListEdge"]: {
	__typename: "HistoryTextListEdge",
	node: GraphQLTypes["HistoryTextList"]
};
	["HistoryTextItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	key?: string,
	text?: string,
	list?: GraphQLTypes["HistoryTextItemCreateListEntityRelationInput"],
	image?: GraphQLTypes["HistoryTextItemCreateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HistoryTextItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["HistoryTextListUniqueWhere"],
	create?: GraphQLTypes["HistoryTextListWithoutItemsCreateInput"]
};
	["HistoryTextListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["HistoryTextItemUpdateInput"]: {
		order?: number,
	key?: string,
	text?: string,
	list?: GraphQLTypes["HistoryTextItemUpdateListEntityRelationInput"],
	image?: GraphQLTypes["HistoryTextItemUpdateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HistoryTextItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["HistoryTextListWithoutItemsCreateInput"],
	update?: GraphQLTypes["HistoryTextListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["HistoryTextItemUpsertListRelationInput"],
	connect?: GraphQLTypes["HistoryTextListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HistoryTextListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["HistoryTextItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["HistoryTextListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["HistoryTextListWithoutItemsCreateInput"]
};
	["FooterMenu"]: {
	__typename: "FooterMenu",
	_meta?: GraphQLTypes["FooterMenuMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["FooterMenuUnique"],
	copyright?: string,
	online?: GraphQLTypes["OnlineSection"],
	links?: GraphQLTypes["LinkSection"],
	linksTwo?: GraphQLTypes["LinkSection"],
	social?: GraphQLTypes["SocialSection"],
	newsletter?: GraphQLTypes["NewsletterSection"]
};
	["FooterMenuMeta"]: {
	__typename: "FooterMenuMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	copyright?: GraphQLTypes["FieldMeta"],
	online?: GraphQLTypes["FieldMeta"],
	links?: GraphQLTypes["FieldMeta"],
	linksTwo?: GraphQLTypes["FieldMeta"],
	social?: GraphQLTypes["FieldMeta"],
	newsletter?: GraphQLTypes["FieldMeta"]
};
	["FooterMenuUnique"]: FooterMenuUnique;
	["OnlineSection"]: {
	__typename: "OnlineSection",
	_meta?: GraphQLTypes["OnlineSectionMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	appLinks?: GraphQLTypes["AppLinkList"],
	links?: GraphQLTypes["LinkList"]
};
	["OnlineSectionMeta"]: {
	__typename: "OnlineSectionMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	appLinks?: GraphQLTypes["FieldMeta"],
	links?: GraphQLTypes["FieldMeta"]
};
	["AppLinkList"]: {
	__typename: "AppLinkList",
	_meta?: GraphQLTypes["AppLinkListMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["AppLinkItem"]>,
	itemsByAppLink?: GraphQLTypes["AppLinkItem"],
	paginateItems: GraphQLTypes["AppLinkItemConnection"]
};
	["AppLinkListMeta"]: {
	__typename: "AppLinkListMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["AppLinkItem"]: {
	__typename: "AppLinkItem",
	_meta?: GraphQLTypes["AppLinkItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["AppLinkList"],
	appLink?: GraphQLTypes["AppLink"]
};
	["AppLinkItemMeta"]: {
	__typename: "AppLinkItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	appLink?: GraphQLTypes["FieldMeta"]
};
	["AppLinkListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["AppLinkItemWhere"],
	and?: Array<GraphQLTypes["AppLinkListWhere"] | undefined>,
	or?: Array<GraphQLTypes["AppLinkListWhere"] | undefined>,
	not?: GraphQLTypes["AppLinkListWhere"]
};
	["AppLinkItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	list?: GraphQLTypes["AppLinkListWhere"],
	appLink?: GraphQLTypes["AppLinkWhere"],
	and?: Array<GraphQLTypes["AppLinkItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["AppLinkItemWhere"] | undefined>,
	not?: GraphQLTypes["AppLinkItemWhere"]
};
	["AppLinkWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	type?: GraphQLTypes["AppLinkTypeCondition"],
	url?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["AppLinkWhere"] | undefined>,
	or?: Array<GraphQLTypes["AppLinkWhere"] | undefined>,
	not?: GraphQLTypes["AppLinkWhere"]
};
	["AppLinkTypeCondition"]: {
		and?: Array<GraphQLTypes["AppLinkTypeCondition"]>,
	or?: Array<GraphQLTypes["AppLinkTypeCondition"]>,
	not?: GraphQLTypes["AppLinkTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["AppLinkType"],
	notEq?: GraphQLTypes["AppLinkType"],
	in?: Array<GraphQLTypes["AppLinkType"]>,
	notIn?: Array<GraphQLTypes["AppLinkType"]>,
	lt?: GraphQLTypes["AppLinkType"],
	lte?: GraphQLTypes["AppLinkType"],
	gt?: GraphQLTypes["AppLinkType"],
	gte?: GraphQLTypes["AppLinkType"]
};
	["AppLinkType"]: AppLinkType;
	["AppLink"]: {
	__typename: "AppLink",
	_meta?: GraphQLTypes["AppLinkMeta"],
	id: GraphQLTypes["UUID"],
	type?: GraphQLTypes["AppLinkType"],
	url?: string
};
	["AppLinkMeta"]: {
	__typename: "AppLinkMeta",
	id?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"]
};
	["AppLinkItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["AppLinkListOrderBy"],
	appLink?: GraphQLTypes["AppLinkOrderBy"]
};
	["AppLinkListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["AppLinkOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["OrderDirection"]
};
	["AppLinkListItemsByAppLinkUniqueWhere"]: {
		appLink?: GraphQLTypes["AppLinkUniqueWhere"]
};
	["AppLinkUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["AppLinkItemConnection"]: {
	__typename: "AppLinkItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["AppLinkItemEdge"]>
};
	["AppLinkItemEdge"]: {
	__typename: "AppLinkItemEdge",
	node: GraphQLTypes["AppLinkItem"]
};
	["LinkList"]: {
	__typename: "LinkList",
	_meta?: GraphQLTypes["LinkListMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["LinkItem"]>,
	paginateItems: GraphQLTypes["LinkItemConnection"]
};
	["LinkListMeta"]: {
	__typename: "LinkListMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["LinkItem"]: {
	__typename: "LinkItem",
	_meta?: GraphQLTypes["LinkItemMeta"],
	id: GraphQLTypes["UUID"],
	order?: number,
	list?: GraphQLTypes["LinkList"],
	link?: GraphQLTypes["Link"],
	title?: string
};
	["LinkItemMeta"]: {
	__typename: "LinkItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"]
};
	["LinkListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["LinkItemWhere"],
	and?: Array<GraphQLTypes["LinkListWhere"] | undefined>,
	or?: Array<GraphQLTypes["LinkListWhere"] | undefined>,
	not?: GraphQLTypes["LinkListWhere"]
};
	["LinkItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	list?: GraphQLTypes["LinkListWhere"],
	link?: GraphQLTypes["LinkWhere"],
	title?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["LinkItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["LinkItemWhere"] | undefined>,
	not?: GraphQLTypes["LinkItemWhere"]
};
	["LinkItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["LinkListOrderBy"],
	link?: GraphQLTypes["LinkOrderBy"],
	title?: GraphQLTypes["OrderDirection"]
};
	["LinkListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["LinkItemConnection"]: {
	__typename: "LinkItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkItemEdge"]>
};
	["LinkItemEdge"]: {
	__typename: "LinkItemEdge",
	node: GraphQLTypes["LinkItem"]
};
	["OnlineSectionWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	appLinks?: GraphQLTypes["AppLinkListWhere"],
	links?: GraphQLTypes["LinkListWhere"],
	and?: Array<GraphQLTypes["OnlineSectionWhere"] | undefined>,
	or?: Array<GraphQLTypes["OnlineSectionWhere"] | undefined>,
	not?: GraphQLTypes["OnlineSectionWhere"]
};
	["LinkSection"]: {
	__typename: "LinkSection",
	_meta?: GraphQLTypes["LinkSectionMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	links?: GraphQLTypes["LinkList"]
};
	["LinkSectionMeta"]: {
	__typename: "LinkSectionMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	links?: GraphQLTypes["FieldMeta"]
};
	["LinkSectionWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	links?: GraphQLTypes["LinkListWhere"],
	and?: Array<GraphQLTypes["LinkSectionWhere"] | undefined>,
	or?: Array<GraphQLTypes["LinkSectionWhere"] | undefined>,
	not?: GraphQLTypes["LinkSectionWhere"]
};
	["SocialSection"]: {
	__typename: "SocialSection",
	_meta?: GraphQLTypes["SocialSectionMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	socialLinks?: GraphQLTypes["SocialLinkList"]
};
	["SocialSectionMeta"]: {
	__typename: "SocialSectionMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	socialLinks?: GraphQLTypes["FieldMeta"]
};
	["SocialLinkList"]: {
	__typename: "SocialLinkList",
	_meta?: GraphQLTypes["SocialLinkListMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["SocialLinkItem"]>,
	itemsBySocialLink?: GraphQLTypes["SocialLinkItem"],
	paginateItems: GraphQLTypes["SocialLinkItemConnection"]
};
	["SocialLinkListMeta"]: {
	__typename: "SocialLinkListMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["SocialLinkItem"]: {
	__typename: "SocialLinkItem",
	_meta?: GraphQLTypes["SocialLinkItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["SocialLinkList"],
	socialLink?: GraphQLTypes["SocialLink"]
};
	["SocialLinkItemMeta"]: {
	__typename: "SocialLinkItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	socialLink?: GraphQLTypes["FieldMeta"]
};
	["SocialLinkListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["SocialLinkItemWhere"],
	and?: Array<GraphQLTypes["SocialLinkListWhere"] | undefined>,
	or?: Array<GraphQLTypes["SocialLinkListWhere"] | undefined>,
	not?: GraphQLTypes["SocialLinkListWhere"]
};
	["SocialLinkItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	list?: GraphQLTypes["SocialLinkListWhere"],
	socialLink?: GraphQLTypes["SocialLinkWhere"],
	and?: Array<GraphQLTypes["SocialLinkItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["SocialLinkItemWhere"] | undefined>,
	not?: GraphQLTypes["SocialLinkItemWhere"]
};
	["SocialLinkWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	type?: GraphQLTypes["SocialLinkTypeCondition"],
	url?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["SocialLinkWhere"] | undefined>,
	or?: Array<GraphQLTypes["SocialLinkWhere"] | undefined>,
	not?: GraphQLTypes["SocialLinkWhere"]
};
	["SocialLinkTypeCondition"]: {
		and?: Array<GraphQLTypes["SocialLinkTypeCondition"]>,
	or?: Array<GraphQLTypes["SocialLinkTypeCondition"]>,
	not?: GraphQLTypes["SocialLinkTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["SocialLinkType"],
	notEq?: GraphQLTypes["SocialLinkType"],
	in?: Array<GraphQLTypes["SocialLinkType"]>,
	notIn?: Array<GraphQLTypes["SocialLinkType"]>,
	lt?: GraphQLTypes["SocialLinkType"],
	lte?: GraphQLTypes["SocialLinkType"],
	gt?: GraphQLTypes["SocialLinkType"],
	gte?: GraphQLTypes["SocialLinkType"]
};
	["SocialLinkType"]: SocialLinkType;
	["SocialLink"]: {
	__typename: "SocialLink",
	_meta?: GraphQLTypes["SocialLinkMeta"],
	id: GraphQLTypes["UUID"],
	type?: GraphQLTypes["SocialLinkType"],
	url?: string
};
	["SocialLinkMeta"]: {
	__typename: "SocialLinkMeta",
	id?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"]
};
	["SocialLinkItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["SocialLinkListOrderBy"],
	socialLink?: GraphQLTypes["SocialLinkOrderBy"]
};
	["SocialLinkListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["SocialLinkOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["OrderDirection"]
};
	["SocialLinkListItemsBySocialLinkUniqueWhere"]: {
		socialLink?: GraphQLTypes["SocialLinkUniqueWhere"]
};
	["SocialLinkUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["SocialLinkItemConnection"]: {
	__typename: "SocialLinkItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SocialLinkItemEdge"]>
};
	["SocialLinkItemEdge"]: {
	__typename: "SocialLinkItemEdge",
	node: GraphQLTypes["SocialLinkItem"]
};
	["SocialSectionWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	socialLinks?: GraphQLTypes["SocialLinkListWhere"],
	and?: Array<GraphQLTypes["SocialSectionWhere"] | undefined>,
	or?: Array<GraphQLTypes["SocialSectionWhere"] | undefined>,
	not?: GraphQLTypes["SocialSectionWhere"]
};
	["NewsletterSection"]: {
	__typename: "NewsletterSection",
	_meta?: GraphQLTypes["NewsletterSectionMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	newsletter?: GraphQLTypes["Newsletter"]
};
	["NewsletterSectionMeta"]: {
	__typename: "NewsletterSectionMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	newsletter?: GraphQLTypes["FieldMeta"]
};
	["Newsletter"]: {
	__typename: "Newsletter",
	_meta?: GraphQLTypes["NewsletterMeta"],
	id: GraphQLTypes["UUID"],
	input?: string,
	button?: string
};
	["NewsletterMeta"]: {
	__typename: "NewsletterMeta",
	id?: GraphQLTypes["FieldMeta"],
	input?: GraphQLTypes["FieldMeta"],
	button?: GraphQLTypes["FieldMeta"]
};
	["NewsletterWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	input?: GraphQLTypes["StringCondition"],
	button?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["NewsletterWhere"] | undefined>,
	or?: Array<GraphQLTypes["NewsletterWhere"] | undefined>,
	not?: GraphQLTypes["NewsletterWhere"]
};
	["NewsletterSectionWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	newsletter?: GraphQLTypes["NewsletterWhere"],
	and?: Array<GraphQLTypes["NewsletterSectionWhere"] | undefined>,
	or?: Array<GraphQLTypes["NewsletterSectionWhere"] | undefined>,
	not?: GraphQLTypes["NewsletterSectionWhere"]
};
	["FooterMenuUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["FooterMenuUnique"],
	online?: GraphQLTypes["OnlineSectionUniqueWhere"],
	links?: GraphQLTypes["LinkSectionUniqueWhere"],
	linksTwo?: GraphQLTypes["LinkSectionUniqueWhere"],
	social?: GraphQLTypes["SocialSectionUniqueWhere"],
	newsletter?: GraphQLTypes["NewsletterSectionUniqueWhere"]
};
	["OnlineSectionUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	appLinks?: GraphQLTypes["AppLinkListUniqueWhere"],
	links?: GraphQLTypes["LinkListUniqueWhere"]
};
	["AppLinkListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["AppLinkItemUniqueWhere"]
};
	["AppLinkItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	appLink?: GraphQLTypes["AppLinkUniqueWhere"]
};
	["LinkListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["LinkItemUniqueWhere"]
};
	["LinkItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["LinkSectionUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	links?: GraphQLTypes["LinkListUniqueWhere"]
};
	["SocialSectionUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	socialLinks?: GraphQLTypes["SocialLinkListUniqueWhere"]
};
	["SocialLinkListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["SocialLinkItemUniqueWhere"]
};
	["SocialLinkItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	socialLink?: GraphQLTypes["SocialLinkUniqueWhere"]
};
	["NewsletterSectionUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	newsletter?: GraphQLTypes["NewsletterUniqueWhere"]
};
	["NewsletterUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["FooterMenuWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["FooterMenuUniqueCondition"],
	copyright?: GraphQLTypes["StringCondition"],
	online?: GraphQLTypes["OnlineSectionWhere"],
	links?: GraphQLTypes["LinkSectionWhere"],
	linksTwo?: GraphQLTypes["LinkSectionWhere"],
	social?: GraphQLTypes["SocialSectionWhere"],
	newsletter?: GraphQLTypes["NewsletterSectionWhere"],
	and?: Array<GraphQLTypes["FooterMenuWhere"] | undefined>,
	or?: Array<GraphQLTypes["FooterMenuWhere"] | undefined>,
	not?: GraphQLTypes["FooterMenuWhere"]
};
	["FooterMenuUniqueCondition"]: {
		and?: Array<GraphQLTypes["FooterMenuUniqueCondition"]>,
	or?: Array<GraphQLTypes["FooterMenuUniqueCondition"]>,
	not?: GraphQLTypes["FooterMenuUniqueCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["FooterMenuUnique"],
	notEq?: GraphQLTypes["FooterMenuUnique"],
	in?: Array<GraphQLTypes["FooterMenuUnique"]>,
	notIn?: Array<GraphQLTypes["FooterMenuUnique"]>,
	lt?: GraphQLTypes["FooterMenuUnique"],
	lte?: GraphQLTypes["FooterMenuUnique"],
	gt?: GraphQLTypes["FooterMenuUnique"],
	gte?: GraphQLTypes["FooterMenuUnique"]
};
	["FooterMenuOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	copyright?: GraphQLTypes["OrderDirection"],
	online?: GraphQLTypes["OnlineSectionOrderBy"],
	links?: GraphQLTypes["LinkSectionOrderBy"],
	linksTwo?: GraphQLTypes["LinkSectionOrderBy"],
	social?: GraphQLTypes["SocialSectionOrderBy"],
	newsletter?: GraphQLTypes["NewsletterSectionOrderBy"]
};
	["OnlineSectionOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	appLinks?: GraphQLTypes["AppLinkListOrderBy"],
	links?: GraphQLTypes["LinkListOrderBy"]
};
	["LinkSectionOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	links?: GraphQLTypes["LinkListOrderBy"]
};
	["SocialSectionOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	socialLinks?: GraphQLTypes["SocialLinkListOrderBy"]
};
	["NewsletterSectionOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	newsletter?: GraphQLTypes["NewsletterOrderBy"]
};
	["NewsletterOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	input?: GraphQLTypes["OrderDirection"],
	button?: GraphQLTypes["OrderDirection"]
};
	["FooterMenuConnection"]: {
	__typename: "FooterMenuConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FooterMenuEdge"]>
};
	["FooterMenuEdge"]: {
	__typename: "FooterMenuEdge",
	node: GraphQLTypes["FooterMenu"]
};
	["FooterMenuCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["FooterMenuUnique"],
	copyright?: string,
	online?: GraphQLTypes["FooterMenuCreateOnlineEntityRelationInput"],
	links?: GraphQLTypes["FooterMenuCreateLinksEntityRelationInput"],
	linksTwo?: GraphQLTypes["FooterMenuCreateLinksTwoEntityRelationInput"],
	social?: GraphQLTypes["FooterMenuCreateSocialEntityRelationInput"],
	newsletter?: GraphQLTypes["FooterMenuCreateNewsletterEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FooterMenuCreateOnlineEntityRelationInput"]: {
		connect?: GraphQLTypes["OnlineSectionUniqueWhere"],
	create?: GraphQLTypes["OnlineSectionCreateInput"]
};
	["OnlineSectionCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	appLinks?: GraphQLTypes["OnlineSectionCreateAppLinksEntityRelationInput"],
	links?: GraphQLTypes["OnlineSectionCreateLinksEntityRelationInput"],
	_dummy_field_?: boolean
};
	["OnlineSectionCreateAppLinksEntityRelationInput"]: {
		connect?: GraphQLTypes["AppLinkListUniqueWhere"],
	create?: GraphQLTypes["AppLinkListCreateInput"]
};
	["AppLinkListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["AppLinkListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["AppLinkListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["AppLinkItemUniqueWhere"],
	create?: GraphQLTypes["AppLinkItemWithoutListCreateInput"],
	alias?: string
};
	["AppLinkItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	appLink?: GraphQLTypes["AppLinkItemCreateAppLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["AppLinkItemCreateAppLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["AppLinkUniqueWhere"],
	create?: GraphQLTypes["AppLinkCreateInput"]
};
	["AppLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["AppLinkType"],
	url?: string,
	_dummy_field_?: boolean
};
	["OnlineSectionCreateLinksEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkListUniqueWhere"],
	create?: GraphQLTypes["LinkListCreateInput"]
};
	["LinkListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["LinkListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LinkListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkItemUniqueWhere"],
	create?: GraphQLTypes["LinkItemWithoutListCreateInput"],
	alias?: string
};
	["LinkItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	link?: GraphQLTypes["LinkItemCreateLinkEntityRelationInput"],
	title?: string,
	_dummy_field_?: boolean
};
	["LinkItemCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["FooterMenuCreateLinksEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkSectionUniqueWhere"],
	create?: GraphQLTypes["LinkSectionCreateInput"]
};
	["LinkSectionCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	links?: GraphQLTypes["LinkSectionCreateLinksEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkSectionCreateLinksEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkListUniqueWhere"],
	create?: GraphQLTypes["LinkListCreateInput"]
};
	["FooterMenuCreateLinksTwoEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkSectionUniqueWhere"],
	create?: GraphQLTypes["LinkSectionCreateInput"]
};
	["FooterMenuCreateSocialEntityRelationInput"]: {
		connect?: GraphQLTypes["SocialSectionUniqueWhere"],
	create?: GraphQLTypes["SocialSectionCreateInput"]
};
	["SocialSectionCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	socialLinks?: GraphQLTypes["SocialSectionCreateSocialLinksEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SocialSectionCreateSocialLinksEntityRelationInput"]: {
		connect?: GraphQLTypes["SocialLinkListUniqueWhere"],
	create?: GraphQLTypes["SocialLinkListCreateInput"]
};
	["SocialLinkListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["SocialLinkListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["SocialLinkListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["SocialLinkItemUniqueWhere"],
	create?: GraphQLTypes["SocialLinkItemWithoutListCreateInput"],
	alias?: string
};
	["SocialLinkItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	socialLink?: GraphQLTypes["SocialLinkItemCreateSocialLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SocialLinkItemCreateSocialLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["SocialLinkUniqueWhere"],
	create?: GraphQLTypes["SocialLinkCreateInput"]
};
	["SocialLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["SocialLinkType"],
	url?: string,
	_dummy_field_?: boolean
};
	["FooterMenuCreateNewsletterEntityRelationInput"]: {
		connect?: GraphQLTypes["NewsletterSectionUniqueWhere"],
	create?: GraphQLTypes["NewsletterSectionCreateInput"]
};
	["NewsletterSectionCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	newsletter?: GraphQLTypes["NewsletterSectionCreateNewsletterEntityRelationInput"],
	_dummy_field_?: boolean
};
	["NewsletterSectionCreateNewsletterEntityRelationInput"]: {
		connect?: GraphQLTypes["NewsletterUniqueWhere"],
	create?: GraphQLTypes["NewsletterCreateInput"]
};
	["NewsletterCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	input?: string,
	button?: string,
	_dummy_field_?: boolean
};
	["FooterMenuUpdateInput"]: {
		unique?: GraphQLTypes["FooterMenuUnique"],
	copyright?: string,
	online?: GraphQLTypes["FooterMenuUpdateOnlineEntityRelationInput"],
	links?: GraphQLTypes["FooterMenuUpdateLinksEntityRelationInput"],
	linksTwo?: GraphQLTypes["FooterMenuUpdateLinksTwoEntityRelationInput"],
	social?: GraphQLTypes["FooterMenuUpdateSocialEntityRelationInput"],
	newsletter?: GraphQLTypes["FooterMenuUpdateNewsletterEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FooterMenuUpdateOnlineEntityRelationInput"]: {
		create?: GraphQLTypes["OnlineSectionCreateInput"],
	update?: GraphQLTypes["OnlineSectionUpdateInput"],
	upsert?: GraphQLTypes["FooterMenuUpsertOnlineRelationInput"],
	connect?: GraphQLTypes["OnlineSectionUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["OnlineSectionUpdateInput"]: {
		title?: string,
	appLinks?: GraphQLTypes["OnlineSectionUpdateAppLinksEntityRelationInput"],
	links?: GraphQLTypes["OnlineSectionUpdateLinksEntityRelationInput"],
	_dummy_field_?: boolean
};
	["OnlineSectionUpdateAppLinksEntityRelationInput"]: {
		create?: GraphQLTypes["AppLinkListCreateInput"],
	update?: GraphQLTypes["AppLinkListUpdateInput"],
	upsert?: GraphQLTypes["OnlineSectionUpsertAppLinksRelationInput"],
	connect?: GraphQLTypes["AppLinkListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["AppLinkListUpdateInput"]: {
		items?: Array<GraphQLTypes["AppLinkListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["AppLinkListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["AppLinkItemWithoutListCreateInput"],
	update?: GraphQLTypes["AppLinkListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["AppLinkListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["AppLinkItemUniqueWhere"],
	disconnect?: GraphQLTypes["AppLinkItemUniqueWhere"],
	delete?: GraphQLTypes["AppLinkItemUniqueWhere"],
	alias?: string
};
	["AppLinkListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["AppLinkItemUniqueWhere"],
	data?: GraphQLTypes["AppLinkItemWithoutListUpdateInput"]
};
	["AppLinkItemWithoutListUpdateInput"]: {
		order?: number,
	appLink?: GraphQLTypes["AppLinkItemUpdateAppLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["AppLinkItemUpdateAppLinkEntityRelationInput"]: {
		create?: GraphQLTypes["AppLinkCreateInput"],
	update?: GraphQLTypes["AppLinkUpdateInput"],
	upsert?: GraphQLTypes["AppLinkItemUpsertAppLinkRelationInput"],
	connect?: GraphQLTypes["AppLinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["AppLinkUpdateInput"]: {
		type?: GraphQLTypes["AppLinkType"],
	url?: string,
	_dummy_field_?: boolean
};
	["AppLinkItemUpsertAppLinkRelationInput"]: {
		update?: GraphQLTypes["AppLinkUpdateInput"],
	create?: GraphQLTypes["AppLinkCreateInput"]
};
	["AppLinkListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["AppLinkItemUniqueWhere"],
	update?: GraphQLTypes["AppLinkItemWithoutListUpdateInput"],
	create?: GraphQLTypes["AppLinkItemWithoutListCreateInput"]
};
	["OnlineSectionUpsertAppLinksRelationInput"]: {
		update?: GraphQLTypes["AppLinkListUpdateInput"],
	create?: GraphQLTypes["AppLinkListCreateInput"]
};
	["OnlineSectionUpdateLinksEntityRelationInput"]: {
		create?: GraphQLTypes["LinkListCreateInput"],
	update?: GraphQLTypes["LinkListUpdateInput"],
	upsert?: GraphQLTypes["OnlineSectionUpsertLinksRelationInput"],
	connect?: GraphQLTypes["LinkListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkListUpdateInput"]: {
		items?: Array<GraphQLTypes["LinkListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LinkListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["LinkItemWithoutListCreateInput"],
	update?: GraphQLTypes["LinkListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["LinkListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["LinkItemUniqueWhere"],
	disconnect?: GraphQLTypes["LinkItemUniqueWhere"],
	delete?: GraphQLTypes["LinkItemUniqueWhere"],
	alias?: string
};
	["LinkListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["LinkItemUniqueWhere"],
	data?: GraphQLTypes["LinkItemWithoutListUpdateInput"]
};
	["LinkItemWithoutListUpdateInput"]: {
		order?: number,
	link?: GraphQLTypes["LinkItemUpdateLinkEntityRelationInput"],
	title?: string,
	_dummy_field_?: boolean
};
	["LinkItemUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["LinkItemUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkItemUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["LinkListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["LinkItemUniqueWhere"],
	update?: GraphQLTypes["LinkItemWithoutListUpdateInput"],
	create?: GraphQLTypes["LinkItemWithoutListCreateInput"]
};
	["OnlineSectionUpsertLinksRelationInput"]: {
		update?: GraphQLTypes["LinkListUpdateInput"],
	create?: GraphQLTypes["LinkListCreateInput"]
};
	["FooterMenuUpsertOnlineRelationInput"]: {
		update?: GraphQLTypes["OnlineSectionUpdateInput"],
	create?: GraphQLTypes["OnlineSectionCreateInput"]
};
	["FooterMenuUpdateLinksEntityRelationInput"]: {
		create?: GraphQLTypes["LinkSectionCreateInput"],
	update?: GraphQLTypes["LinkSectionUpdateInput"],
	upsert?: GraphQLTypes["FooterMenuUpsertLinksRelationInput"],
	connect?: GraphQLTypes["LinkSectionUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkSectionUpdateInput"]: {
		title?: string,
	links?: GraphQLTypes["LinkSectionUpdateLinksEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkSectionUpdateLinksEntityRelationInput"]: {
		create?: GraphQLTypes["LinkListCreateInput"],
	update?: GraphQLTypes["LinkListUpdateInput"],
	upsert?: GraphQLTypes["LinkSectionUpsertLinksRelationInput"],
	connect?: GraphQLTypes["LinkListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkSectionUpsertLinksRelationInput"]: {
		update?: GraphQLTypes["LinkListUpdateInput"],
	create?: GraphQLTypes["LinkListCreateInput"]
};
	["FooterMenuUpsertLinksRelationInput"]: {
		update?: GraphQLTypes["LinkSectionUpdateInput"],
	create?: GraphQLTypes["LinkSectionCreateInput"]
};
	["FooterMenuUpdateLinksTwoEntityRelationInput"]: {
		create?: GraphQLTypes["LinkSectionCreateInput"],
	update?: GraphQLTypes["LinkSectionUpdateInput"],
	upsert?: GraphQLTypes["FooterMenuUpsertLinksTwoRelationInput"],
	connect?: GraphQLTypes["LinkSectionUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FooterMenuUpsertLinksTwoRelationInput"]: {
		update?: GraphQLTypes["LinkSectionUpdateInput"],
	create?: GraphQLTypes["LinkSectionCreateInput"]
};
	["FooterMenuUpdateSocialEntityRelationInput"]: {
		create?: GraphQLTypes["SocialSectionCreateInput"],
	update?: GraphQLTypes["SocialSectionUpdateInput"],
	upsert?: GraphQLTypes["FooterMenuUpsertSocialRelationInput"],
	connect?: GraphQLTypes["SocialSectionUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SocialSectionUpdateInput"]: {
		title?: string,
	socialLinks?: GraphQLTypes["SocialSectionUpdateSocialLinksEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SocialSectionUpdateSocialLinksEntityRelationInput"]: {
		create?: GraphQLTypes["SocialLinkListCreateInput"],
	update?: GraphQLTypes["SocialLinkListUpdateInput"],
	upsert?: GraphQLTypes["SocialSectionUpsertSocialLinksRelationInput"],
	connect?: GraphQLTypes["SocialLinkListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SocialLinkListUpdateInput"]: {
		items?: Array<GraphQLTypes["SocialLinkListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["SocialLinkListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["SocialLinkItemWithoutListCreateInput"],
	update?: GraphQLTypes["SocialLinkListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["SocialLinkListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["SocialLinkItemUniqueWhere"],
	disconnect?: GraphQLTypes["SocialLinkItemUniqueWhere"],
	delete?: GraphQLTypes["SocialLinkItemUniqueWhere"],
	alias?: string
};
	["SocialLinkListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["SocialLinkItemUniqueWhere"],
	data?: GraphQLTypes["SocialLinkItemWithoutListUpdateInput"]
};
	["SocialLinkItemWithoutListUpdateInput"]: {
		order?: number,
	socialLink?: GraphQLTypes["SocialLinkItemUpdateSocialLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SocialLinkItemUpdateSocialLinkEntityRelationInput"]: {
		create?: GraphQLTypes["SocialLinkCreateInput"],
	update?: GraphQLTypes["SocialLinkUpdateInput"],
	upsert?: GraphQLTypes["SocialLinkItemUpsertSocialLinkRelationInput"],
	connect?: GraphQLTypes["SocialLinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SocialLinkUpdateInput"]: {
		type?: GraphQLTypes["SocialLinkType"],
	url?: string,
	_dummy_field_?: boolean
};
	["SocialLinkItemUpsertSocialLinkRelationInput"]: {
		update?: GraphQLTypes["SocialLinkUpdateInput"],
	create?: GraphQLTypes["SocialLinkCreateInput"]
};
	["SocialLinkListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["SocialLinkItemUniqueWhere"],
	update?: GraphQLTypes["SocialLinkItemWithoutListUpdateInput"],
	create?: GraphQLTypes["SocialLinkItemWithoutListCreateInput"]
};
	["SocialSectionUpsertSocialLinksRelationInput"]: {
		update?: GraphQLTypes["SocialLinkListUpdateInput"],
	create?: GraphQLTypes["SocialLinkListCreateInput"]
};
	["FooterMenuUpsertSocialRelationInput"]: {
		update?: GraphQLTypes["SocialSectionUpdateInput"],
	create?: GraphQLTypes["SocialSectionCreateInput"]
};
	["FooterMenuUpdateNewsletterEntityRelationInput"]: {
		create?: GraphQLTypes["NewsletterSectionCreateInput"],
	update?: GraphQLTypes["NewsletterSectionUpdateInput"],
	upsert?: GraphQLTypes["FooterMenuUpsertNewsletterRelationInput"],
	connect?: GraphQLTypes["NewsletterSectionUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["NewsletterSectionUpdateInput"]: {
		title?: string,
	newsletter?: GraphQLTypes["NewsletterSectionUpdateNewsletterEntityRelationInput"],
	_dummy_field_?: boolean
};
	["NewsletterSectionUpdateNewsletterEntityRelationInput"]: {
		create?: GraphQLTypes["NewsletterCreateInput"],
	update?: GraphQLTypes["NewsletterUpdateInput"],
	upsert?: GraphQLTypes["NewsletterSectionUpsertNewsletterRelationInput"],
	connect?: GraphQLTypes["NewsletterUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["NewsletterUpdateInput"]: {
		input?: string,
	button?: string,
	_dummy_field_?: boolean
};
	["NewsletterSectionUpsertNewsletterRelationInput"]: {
		update?: GraphQLTypes["NewsletterUpdateInput"],
	create?: GraphQLTypes["NewsletterCreateInput"]
};
	["FooterMenuUpsertNewsletterRelationInput"]: {
		update?: GraphQLTypes["NewsletterSectionUpdateInput"],
	create?: GraphQLTypes["NewsletterSectionCreateInput"]
};
	["LinkSectionConnection"]: {
	__typename: "LinkSectionConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkSectionEdge"]>
};
	["LinkSectionEdge"]: {
	__typename: "LinkSectionEdge",
	node: GraphQLTypes["LinkSection"]
};
	["LinkListConnection"]: {
	__typename: "LinkListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkListEdge"]>
};
	["LinkListEdge"]: {
	__typename: "LinkListEdge",
	node: GraphQLTypes["LinkList"]
};
	["LinkItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	list?: GraphQLTypes["LinkItemCreateListEntityRelationInput"],
	link?: GraphQLTypes["LinkItemCreateLinkEntityRelationInput"],
	title?: string,
	_dummy_field_?: boolean
};
	["LinkItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkListUniqueWhere"],
	create?: GraphQLTypes["LinkListWithoutItemsCreateInput"]
};
	["LinkListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["LinkItemUpdateInput"]: {
		order?: number,
	list?: GraphQLTypes["LinkItemUpdateListEntityRelationInput"],
	link?: GraphQLTypes["LinkItemUpdateLinkEntityRelationInput"],
	title?: string,
	_dummy_field_?: boolean
};
	["LinkItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["LinkListWithoutItemsCreateInput"],
	update?: GraphQLTypes["LinkListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["LinkItemUpsertListRelationInput"],
	connect?: GraphQLTypes["LinkListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["LinkItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["LinkListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["LinkListWithoutItemsCreateInput"]
};
	["NewsletterSectionConnection"]: {
	__typename: "NewsletterSectionConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["NewsletterSectionEdge"]>
};
	["NewsletterSectionEdge"]: {
	__typename: "NewsletterSectionEdge",
	node: GraphQLTypes["NewsletterSection"]
};
	["NewsletterConnection"]: {
	__typename: "NewsletterConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["NewsletterEdge"]>
};
	["NewsletterEdge"]: {
	__typename: "NewsletterEdge",
	node: GraphQLTypes["Newsletter"]
};
	["OnlineSectionConnection"]: {
	__typename: "OnlineSectionConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["OnlineSectionEdge"]>
};
	["OnlineSectionEdge"]: {
	__typename: "OnlineSectionEdge",
	node: GraphQLTypes["OnlineSection"]
};
	["AppLinkConnection"]: {
	__typename: "AppLinkConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["AppLinkEdge"]>
};
	["AppLinkEdge"]: {
	__typename: "AppLinkEdge",
	node: GraphQLTypes["AppLink"]
};
	["AppLinkListConnection"]: {
	__typename: "AppLinkListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["AppLinkListEdge"]>
};
	["AppLinkListEdge"]: {
	__typename: "AppLinkListEdge",
	node: GraphQLTypes["AppLinkList"]
};
	["AppLinkItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	list?: GraphQLTypes["AppLinkItemCreateListEntityRelationInput"],
	appLink?: GraphQLTypes["AppLinkItemCreateAppLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["AppLinkItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["AppLinkListUniqueWhere"],
	create?: GraphQLTypes["AppLinkListWithoutItemsCreateInput"]
};
	["AppLinkListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["AppLinkItemUpdateInput"]: {
		order?: number,
	list?: GraphQLTypes["AppLinkItemUpdateListEntityRelationInput"],
	appLink?: GraphQLTypes["AppLinkItemUpdateAppLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["AppLinkItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["AppLinkListWithoutItemsCreateInput"],
	update?: GraphQLTypes["AppLinkListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["AppLinkItemUpsertListRelationInput"],
	connect?: GraphQLTypes["AppLinkListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["AppLinkListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["AppLinkItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["AppLinkListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["AppLinkListWithoutItemsCreateInput"]
};
	["SocialSectionConnection"]: {
	__typename: "SocialSectionConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SocialSectionEdge"]>
};
	["SocialSectionEdge"]: {
	__typename: "SocialSectionEdge",
	node: GraphQLTypes["SocialSection"]
};
	["SocialLinkConnection"]: {
	__typename: "SocialLinkConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SocialLinkEdge"]>
};
	["SocialLinkEdge"]: {
	__typename: "SocialLinkEdge",
	node: GraphQLTypes["SocialLink"]
};
	["SocialLinkListConnection"]: {
	__typename: "SocialLinkListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SocialLinkListEdge"]>
};
	["SocialLinkListEdge"]: {
	__typename: "SocialLinkListEdge",
	node: GraphQLTypes["SocialLinkList"]
};
	["SocialLinkItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	list?: GraphQLTypes["SocialLinkItemCreateListEntityRelationInput"],
	socialLink?: GraphQLTypes["SocialLinkItemCreateSocialLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SocialLinkItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["SocialLinkListUniqueWhere"],
	create?: GraphQLTypes["SocialLinkListWithoutItemsCreateInput"]
};
	["SocialLinkListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["SocialLinkItemUpdateInput"]: {
		order?: number,
	list?: GraphQLTypes["SocialLinkItemUpdateListEntityRelationInput"],
	socialLink?: GraphQLTypes["SocialLinkItemUpdateSocialLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SocialLinkItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["SocialLinkListWithoutItemsCreateInput"],
	update?: GraphQLTypes["SocialLinkListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["SocialLinkItemUpsertListRelationInput"],
	connect?: GraphQLTypes["SocialLinkListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SocialLinkListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["SocialLinkItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["SocialLinkListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["SocialLinkListWithoutItemsCreateInput"]
};
	["SharedContentConnection"]: {
	__typename: "SharedContentConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SharedContentEdge"]>
};
	["SharedContentEdge"]: {
	__typename: "SharedContentEdge",
	node: GraphQLTypes["SharedContent"]
};
	["SharedContentCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	contentReference?: Array<GraphQLTypes["SharedContentCreateContentReferenceEntityRelationInput"]>,
	content?: GraphQLTypes["SharedContentCreateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SharedContentCreateContentReferenceEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	create?: GraphQLTypes["ContentReferenceWithoutSharedContentCreateInput"],
	alias?: string
};
	["ContentReferenceWithoutSharedContentCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ContentReferenceType"],
	contentPart?: GraphQLTypes["ContentReferenceCreateContentPartEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	variant?: GraphQLTypes["ContentReferenceVariant"],
	color?: string,
	embed?: GraphQLTypes["ContentReferenceCreateEmbedEntityRelationInput"],
	article?: GraphQLTypes["ContentReferenceCreateArticleEntityRelationInput"],
	audio?: GraphQLTypes["ContentReferenceCreateAudioEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"],
	images?: Array<GraphQLTypes["ContentReferenceCreateImagesEntityRelationInput"]>,
	pollAnswer?: GraphQLTypes["ContentReferenceCreatePollAnswerEntityRelationInput"],
	listicle?: Array<GraphQLTypes["ContentReferenceCreateListicleEntityRelationInput"]>,
	faq?: Array<GraphQLTypes["ContentReferenceCreateFaqEntityRelationInput"]>,
	links?: Array<GraphQLTypes["ContentReferenceCreateLinksEntityRelationInput"]>,
	awards?: Array<GraphQLTypes["ContentReferenceCreateAwardsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ContentReferenceCreateReviewsEntityRelationInput"]>,
	target?: GraphQLTypes["ContentReferenceCreateTargetEntityRelationInput"],
	subscriptionForm?: GraphQLTypes["ContentReferenceCreateSubscriptionFormEntityRelationInput"],
	buttons?: Array<GraphQLTypes["ContentReferenceCreateButtonsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["SharedContentUpdateInput"]: {
		name?: string,
	contentReference?: Array<GraphQLTypes["SharedContentUpdateContentReferenceEntityRelationInput"]>,
	content?: GraphQLTypes["SharedContentUpdateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SharedContentUpdateContentReferenceEntityRelationInput"]: {
		create?: GraphQLTypes["ContentReferenceWithoutSharedContentCreateInput"],
	update?: GraphQLTypes["SharedContentUpdateContentReferenceRelationInput"],
	upsert?: GraphQLTypes["SharedContentUpsertContentReferenceRelationInput"],
	connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	disconnect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	delete?: GraphQLTypes["ContentReferenceUniqueWhere"],
	alias?: string
};
	["SharedContentUpdateContentReferenceRelationInput"]: {
		by?: GraphQLTypes["ContentReferenceUniqueWhere"],
	data?: GraphQLTypes["ContentReferenceWithoutSharedContentUpdateInput"]
};
	["ContentReferenceWithoutSharedContentUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"],
	contentPart?: GraphQLTypes["ContentReferenceUpdateContentPartEntityRelationInput"],
	primaryText?: string,
	secondaryText?: string,
	variant?: GraphQLTypes["ContentReferenceVariant"],
	color?: string,
	embed?: GraphQLTypes["ContentReferenceUpdateEmbedEntityRelationInput"],
	article?: GraphQLTypes["ContentReferenceUpdateArticleEntityRelationInput"],
	audio?: GraphQLTypes["ContentReferenceUpdateAudioEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"],
	images?: Array<GraphQLTypes["ContentReferenceUpdateImagesEntityRelationInput"]>,
	pollAnswer?: GraphQLTypes["ContentReferenceUpdatePollAnswerEntityRelationInput"],
	listicle?: Array<GraphQLTypes["ContentReferenceUpdateListicleEntityRelationInput"]>,
	faq?: Array<GraphQLTypes["ContentReferenceUpdateFaqEntityRelationInput"]>,
	links?: Array<GraphQLTypes["ContentReferenceUpdateLinksEntityRelationInput"]>,
	awards?: Array<GraphQLTypes["ContentReferenceUpdateAwardsEntityRelationInput"]>,
	reviews?: Array<GraphQLTypes["ContentReferenceUpdateReviewsEntityRelationInput"]>,
	target?: GraphQLTypes["ContentReferenceUpdateTargetEntityRelationInput"],
	subscriptionForm?: GraphQLTypes["ContentReferenceUpdateSubscriptionFormEntityRelationInput"],
	buttons?: Array<GraphQLTypes["ContentReferenceUpdateButtonsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["SharedContentUpsertContentReferenceRelationInput"]: {
		by?: GraphQLTypes["ContentReferenceUniqueWhere"],
	update?: GraphQLTypes["ContentReferenceWithoutSharedContentUpdateInput"],
	create?: GraphQLTypes["ContentReferenceWithoutSharedContentCreateInput"]
};
	["QueryTransaction"]: {
	__typename: "QueryTransaction",
	getArticle?: GraphQLTypes["Article"],
	listArticle: Array<GraphQLTypes["Article"]>,
	paginateArticle: GraphQLTypes["ArticleConnection"],
	validateCreateArticle: GraphQLTypes["_ValidationResult"],
	validateUpdateArticle: GraphQLTypes["_ValidationResult"],
	getArticleAuthor?: GraphQLTypes["ArticleAuthor"],
	listArticleAuthor: Array<GraphQLTypes["ArticleAuthor"]>,
	paginateArticleAuthor: GraphQLTypes["ArticleAuthorConnection"],
	validateCreateArticleAuthor: GraphQLTypes["_ValidationResult"],
	validateUpdateArticleAuthor: GraphQLTypes["_ValidationResult"],
	getAuthor?: GraphQLTypes["Author"],
	listAuthor: Array<GraphQLTypes["Author"]>,
	paginateAuthor: GraphQLTypes["AuthorConnection"],
	validateCreateAuthor: GraphQLTypes["_ValidationResult"],
	validateUpdateAuthor: GraphQLTypes["_ValidationResult"],
	getAuthorTopArticle?: GraphQLTypes["AuthorTopArticle"],
	listAuthorTopArticle: Array<GraphQLTypes["AuthorTopArticle"]>,
	paginateAuthorTopArticle: GraphQLTypes["AuthorTopArticleConnection"],
	validateCreateAuthorTopArticle: GraphQLTypes["_ValidationResult"],
	validateUpdateAuthorTopArticle: GraphQLTypes["_ValidationResult"],
	getContent?: GraphQLTypes["Content"],
	listContent: Array<GraphQLTypes["Content"]>,
	paginateContent: GraphQLTypes["ContentConnection"],
	validateCreateContent: GraphQLTypes["_ValidationResult"],
	validateUpdateContent: GraphQLTypes["_ValidationResult"],
	getContentPart?: GraphQLTypes["ContentPart"],
	listContentPart: Array<GraphQLTypes["ContentPart"]>,
	paginateContentPart: GraphQLTypes["ContentPartConnection"],
	validateCreateContentPart: GraphQLTypes["_ValidationResult"],
	validateUpdateContentPart: GraphQLTypes["_ValidationResult"],
	getContentReference?: GraphQLTypes["ContentReference"],
	listContentReference: Array<GraphQLTypes["ContentReference"]>,
	paginateContentReference: GraphQLTypes["ContentReferenceConnection"],
	validateCreateContentReference: GraphQLTypes["_ValidationResult"],
	validateUpdateContentReference: GraphQLTypes["_ValidationResult"],
	getHomepageArticle?: GraphQLTypes["HomepageArticle"],
	listHomepageArticle: Array<GraphQLTypes["HomepageArticle"]>,
	paginateHomepageArticle: GraphQLTypes["HomepageArticleConnection"],
	validateCreateHomepageArticle: GraphQLTypes["_ValidationResult"],
	validateUpdateHomepageArticle: GraphQLTypes["_ValidationResult"],
	getImage?: GraphQLTypes["Image"],
	listImage: Array<GraphQLTypes["Image"]>,
	paginateImage: GraphQLTypes["ImageConnection"],
	validateCreateImage: GraphQLTypes["_ValidationResult"],
	validateUpdateImage: GraphQLTypes["_ValidationResult"],
	getImageUse?: GraphQLTypes["ImageUse"],
	listImageUse: Array<GraphQLTypes["ImageUse"]>,
	paginateImageUse: GraphQLTypes["ImageUseConnection"],
	validateCreateImageUse: GraphQLTypes["_ValidationResult"],
	validateUpdateImageUse: GraphQLTypes["_ValidationResult"],
	getImageTag?: GraphQLTypes["ImageTag"],
	listImageTag: Array<GraphQLTypes["ImageTag"]>,
	paginateImageTag: GraphQLTypes["ImageTagConnection"],
	validateCreateImageTag: GraphQLTypes["_ValidationResult"],
	validateUpdateImageTag: GraphQLTypes["_ValidationResult"],
	getIssue?: GraphQLTypes["Issue"],
	listIssue: Array<GraphQLTypes["Issue"]>,
	paginateIssue: GraphQLTypes["IssueConnection"],
	validateCreateIssue: GraphQLTypes["_ValidationResult"],
	validateUpdateIssue: GraphQLTypes["_ValidationResult"],
	getIssueArticle?: GraphQLTypes["IssueArticle"],
	listIssueArticle: Array<GraphQLTypes["IssueArticle"]>,
	paginateIssueArticle: GraphQLTypes["IssueArticleConnection"],
	validateCreateIssueArticle: GraphQLTypes["_ValidationResult"],
	validateUpdateIssueArticle: GraphQLTypes["_ValidationResult"],
	getLink?: GraphQLTypes["Link"],
	listLink: Array<GraphQLTypes["Link"]>,
	paginateLink: GraphQLTypes["LinkConnection"],
	validateCreateLink: GraphQLTypes["_ValidationResult"],
	validateUpdateLink: GraphQLTypes["_ValidationResult"],
	getTextContent?: GraphQLTypes["TextContent"],
	listTextContent: Array<GraphQLTypes["TextContent"]>,
	paginateTextContent: GraphQLTypes["TextContentConnection"],
	validateCreateTextContent: GraphQLTypes["_ValidationResult"],
	validateUpdateTextContent: GraphQLTypes["_ValidationResult"],
	getTextContentPart?: GraphQLTypes["TextContentPart"],
	listTextContentPart: Array<GraphQLTypes["TextContentPart"]>,
	paginateTextContentPart: GraphQLTypes["TextContentPartConnection"],
	validateCreateTextContentPart: GraphQLTypes["_ValidationResult"],
	validateUpdateTextContentPart: GraphQLTypes["_ValidationResult"],
	getTextContentReference?: GraphQLTypes["TextContentReference"],
	listTextContentReference: Array<GraphQLTypes["TextContentReference"]>,
	paginateTextContentReference: GraphQLTypes["TextContentReferenceConnection"],
	validateCreateTextContentReference: GraphQLTypes["_ValidationResult"],
	validateUpdateTextContentReference: GraphQLTypes["_ValidationResult"],
	getUrl?: GraphQLTypes["Url"],
	listUrl: Array<GraphQLTypes["Url"]>,
	paginateUrl: GraphQLTypes["UrlConnection"],
	validateCreateUrl: GraphQLTypes["_ValidationResult"],
	validateUpdateUrl: GraphQLTypes["_ValidationResult"],
	getArticleTag?: GraphQLTypes["ArticleTag"],
	listArticleTag: Array<GraphQLTypes["ArticleTag"]>,
	paginateArticleTag: GraphQLTypes["ArticleTagConnection"],
	validateCreateArticleTag: GraphQLTypes["_ValidationResult"],
	validateUpdateArticleTag: GraphQLTypes["_ValidationResult"],
	getCategory?: GraphQLTypes["Category"],
	listCategory: Array<GraphQLTypes["Category"]>,
	paginateCategory: GraphQLTypes["CategoryConnection"],
	validateCreateCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateCategory: GraphQLTypes["_ValidationResult"],
	getArticleCategory?: GraphQLTypes["ArticleCategory"],
	listArticleCategory: Array<GraphQLTypes["ArticleCategory"]>,
	paginateArticleCategory: GraphQLTypes["ArticleCategoryConnection"],
	validateCreateArticleCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateArticleCategory: GraphQLTypes["_ValidationResult"],
	getAudio?: GraphQLTypes["Audio"],
	listAudio: Array<GraphQLTypes["Audio"]>,
	paginateAudio: GraphQLTypes["AudioConnection"],
	validateCreateAudio: GraphQLTypes["_ValidationResult"],
	validateUpdateAudio: GraphQLTypes["_ValidationResult"],
	getAudioUse?: GraphQLTypes["AudioUse"],
	listAudioUse: Array<GraphQLTypes["AudioUse"]>,
	paginateAudioUse: GraphQLTypes["AudioUseConnection"],
	validateCreateAudioUse: GraphQLTypes["_ValidationResult"],
	validateUpdateAudioUse: GraphQLTypes["_ValidationResult"],
	getEmbed?: GraphQLTypes["Embed"],
	listEmbed: Array<GraphQLTypes["Embed"]>,
	paginateEmbed: GraphQLTypes["EmbedConnection"],
	validateCreateEmbed: GraphQLTypes["_ValidationResult"],
	validateUpdateEmbed: GraphQLTypes["_ValidationResult"],
	getImageContent?: GraphQLTypes["ImageContent"],
	listImageContent: Array<GraphQLTypes["ImageContent"]>,
	paginateImageContent: GraphQLTypes["ImageContentConnection"],
	validateCreateImageContent: GraphQLTypes["_ValidationResult"],
	validateUpdateImageContent: GraphQLTypes["_ValidationResult"],
	getListicle?: GraphQLTypes["Listicle"],
	listListicle: Array<GraphQLTypes["Listicle"]>,
	paginateListicle: GraphQLTypes["ListicleConnection"],
	validateCreateListicle: GraphQLTypes["_ValidationResult"],
	validateUpdateListicle: GraphQLTypes["_ValidationResult"],
	getPollAnswer?: GraphQLTypes["PollAnswer"],
	listPollAnswer: Array<GraphQLTypes["PollAnswer"]>,
	paginatePollAnswer: GraphQLTypes["PollAnswerConnection"],
	validateCreatePollAnswer: GraphQLTypes["_ValidationResult"],
	validateUpdatePollAnswer: GraphQLTypes["_ValidationResult"],
	getTag?: GraphQLTypes["Tag"],
	listTag: Array<GraphQLTypes["Tag"]>,
	paginateTag: GraphQLTypes["TagConnection"],
	validateCreateTag: GraphQLTypes["_ValidationResult"],
	validateUpdateTag: GraphQLTypes["_ValidationResult"],
	getFAQ?: GraphQLTypes["FAQ"],
	listFAQ: Array<GraphQLTypes["FAQ"]>,
	paginateFAQ: GraphQLTypes["FAQConnection"],
	validateCreateFAQ: GraphQLTypes["_ValidationResult"],
	validateUpdateFAQ: GraphQLTypes["_ValidationResult"],
	getLinkContent?: GraphQLTypes["LinkContent"],
	listLinkContent: Array<GraphQLTypes["LinkContent"]>,
	paginateLinkContent: GraphQLTypes["LinkContentConnection"],
	validateCreateLinkContent: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkContent: GraphQLTypes["_ValidationResult"],
	getAwardContent?: GraphQLTypes["AwardContent"],
	listAwardContent: Array<GraphQLTypes["AwardContent"]>,
	paginateAwardContent: GraphQLTypes["AwardContentConnection"],
	validateCreateAwardContent: GraphQLTypes["_ValidationResult"],
	validateUpdateAwardContent: GraphQLTypes["_ValidationResult"],
	getReviewContent?: GraphQLTypes["ReviewContent"],
	listReviewContent: Array<GraphQLTypes["ReviewContent"]>,
	paginateReviewContent: GraphQLTypes["ReviewContentConnection"],
	validateCreateReviewContent: GraphQLTypes["_ValidationResult"],
	validateUpdateReviewContent: GraphQLTypes["_ValidationResult"],
	getPage?: GraphQLTypes["Page"],
	listPage: Array<GraphQLTypes["Page"]>,
	paginatePage: GraphQLTypes["PageConnection"],
	validateCreatePage: GraphQLTypes["_ValidationResult"],
	validateUpdatePage: GraphQLTypes["_ValidationResult"],
	getTextTranslation?: GraphQLTypes["TextTranslation"],
	listTextTranslation: Array<GraphQLTypes["TextTranslation"]>,
	paginateTextTranslation: GraphQLTypes["TextTranslationConnection"],
	validateCreateTextTranslation: GraphQLTypes["_ValidationResult"],
	validateUpdateTextTranslation: GraphQLTypes["_ValidationResult"],
	getSeo?: GraphQLTypes["Seo"],
	listSeo: Array<GraphQLTypes["Seo"]>,
	paginateSeo: GraphQLTypes["SeoConnection"],
	validateCreateSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateSeo: GraphQLTypes["_ValidationResult"],
	getFile?: GraphQLTypes["File"],
	listFile: Array<GraphQLTypes["File"]>,
	paginateFile: GraphQLTypes["FileConnection"],
	validateCreateFile: GraphQLTypes["_ValidationResult"],
	validateUpdateFile: GraphQLTypes["_ValidationResult"],
	getFileUse?: GraphQLTypes["FileUse"],
	listFileUse: Array<GraphQLTypes["FileUse"]>,
	paginateFileUse: GraphQLTypes["FileUseConnection"],
	validateCreateFileUse: GraphQLTypes["_ValidationResult"],
	validateUpdateFileUse: GraphQLTypes["_ValidationResult"],
	getContentBlock?: GraphQLTypes["ContentBlock"],
	listContentBlock: Array<GraphQLTypes["ContentBlock"]>,
	paginateContentBlock: GraphQLTypes["ContentBlockConnection"],
	validateCreateContentBlock: GraphQLTypes["_ValidationResult"],
	validateUpdateContentBlock: GraphQLTypes["_ValidationResult"],
	getContentArticle?: GraphQLTypes["ContentArticle"],
	listContentArticle: Array<GraphQLTypes["ContentArticle"]>,
	paginateContentArticle: GraphQLTypes["ContentArticleConnection"],
	validateCreateContentArticle: GraphQLTypes["_ValidationResult"],
	validateUpdateContentArticle: GraphQLTypes["_ValidationResult"],
	getUnlockedArticle?: GraphQLTypes["UnlockedArticle"],
	listUnlockedArticle: Array<GraphQLTypes["UnlockedArticle"]>,
	paginateUnlockedArticle: GraphQLTypes["UnlockedArticleConnection"],
	validateCreateUnlockedArticle: GraphQLTypes["_ValidationResult"],
	validateUpdateUnlockedArticle: GraphQLTypes["_ValidationResult"],
	getUser?: GraphQLTypes["User"],
	listUser: Array<GraphQLTypes["User"]>,
	paginateUser: GraphQLTypes["UserConnection"],
	validateCreateUser: GraphQLTypes["_ValidationResult"],
	validateUpdateUser: GraphQLTypes["_ValidationResult"],
	getNotification?: GraphQLTypes["Notification"],
	listNotification: Array<GraphQLTypes["Notification"]>,
	paginateNotification: GraphQLTypes["NotificationConnection"],
	validateCreateNotification: GraphQLTypes["_ValidationResult"],
	validateUpdateNotification: GraphQLTypes["_ValidationResult"],
	getAppReview?: GraphQLTypes["AppReview"],
	listAppReview: Array<GraphQLTypes["AppReview"]>,
	paginateAppReview: GraphQLTypes["AppReviewConnection"],
	validateCreateAppReview: GraphQLTypes["_ValidationResult"],
	validateUpdateAppReview: GraphQLTypes["_ValidationResult"],
	getProduct?: GraphQLTypes["Product"],
	listProduct: Array<GraphQLTypes["Product"]>,
	paginateProduct: GraphQLTypes["ProductConnection"],
	validateCreateProduct: GraphQLTypes["_ValidationResult"],
	validateUpdateProduct: GraphQLTypes["_ValidationResult"],
	getSubscriptionForm?: GraphQLTypes["SubscriptionForm"],
	listSubscriptionForm: Array<GraphQLTypes["SubscriptionForm"]>,
	paginateSubscriptionForm: GraphQLTypes["SubscriptionFormConnection"],
	validateCreateSubscriptionForm: GraphQLTypes["_ValidationResult"],
	validateUpdateSubscriptionForm: GraphQLTypes["_ValidationResult"],
	getSubscriptionFormSection?: GraphQLTypes["SubscriptionFormSection"],
	listSubscriptionFormSection: Array<GraphQLTypes["SubscriptionFormSection"]>,
	paginateSubscriptionFormSection: GraphQLTypes["SubscriptionFormSectionConnection"],
	validateCreateSubscriptionFormSection: GraphQLTypes["_ValidationResult"],
	validateUpdateSubscriptionFormSection: GraphQLTypes["_ValidationResult"],
	getSubscriptionFormInput?: GraphQLTypes["SubscriptionFormInput"],
	listSubscriptionFormInput: Array<GraphQLTypes["SubscriptionFormInput"]>,
	paginateSubscriptionFormInput: GraphQLTypes["SubscriptionFormInputConnection"],
	validateCreateSubscriptionFormInput: GraphQLTypes["_ValidationResult"],
	validateUpdateSubscriptionFormInput: GraphQLTypes["_ValidationResult"],
	getSubscriptionFormOption?: GraphQLTypes["SubscriptionFormOption"],
	listSubscriptionFormOption: Array<GraphQLTypes["SubscriptionFormOption"]>,
	paginateSubscriptionFormOption: GraphQLTypes["SubscriptionFormOptionConnection"],
	validateCreateSubscriptionFormOption: GraphQLTypes["_ValidationResult"],
	validateUpdateSubscriptionFormOption: GraphQLTypes["_ValidationResult"],
	getButton?: GraphQLTypes["Button"],
	listButton: Array<GraphQLTypes["Button"]>,
	paginateButton: GraphQLTypes["ButtonConnection"],
	validateCreateButton: GraphQLTypes["_ValidationResult"],
	validateUpdateButton: GraphQLTypes["_ValidationResult"],
	getArticleHistoryTag?: GraphQLTypes["ArticleHistoryTag"],
	listArticleHistoryTag: Array<GraphQLTypes["ArticleHistoryTag"]>,
	paginateArticleHistoryTag: GraphQLTypes["ArticleHistoryTagConnection"],
	validateCreateArticleHistoryTag: GraphQLTypes["_ValidationResult"],
	validateUpdateArticleHistoryTag: GraphQLTypes["_ValidationResult"],
	getArticleHistoryPeriod?: GraphQLTypes["ArticleHistoryPeriod"],
	listArticleHistoryPeriod: Array<GraphQLTypes["ArticleHistoryPeriod"]>,
	paginateArticleHistoryPeriod: GraphQLTypes["ArticleHistoryPeriodConnection"],
	validateCreateArticleHistoryPeriod: GraphQLTypes["_ValidationResult"],
	validateUpdateArticleHistoryPeriod: GraphQLTypes["_ValidationResult"],
	getHistoryTag?: GraphQLTypes["HistoryTag"],
	listHistoryTag: Array<GraphQLTypes["HistoryTag"]>,
	paginateHistoryTag: GraphQLTypes["HistoryTagConnection"],
	validateCreateHistoryTag: GraphQLTypes["_ValidationResult"],
	validateUpdateHistoryTag: GraphQLTypes["_ValidationResult"],
	getHistoryPeriod?: GraphQLTypes["HistoryPeriod"],
	listHistoryPeriod: Array<GraphQLTypes["HistoryPeriod"]>,
	paginateHistoryPeriod: GraphQLTypes["HistoryPeriodConnection"],
	validateCreateHistoryPeriod: GraphQLTypes["_ValidationResult"],
	validateUpdateHistoryPeriod: GraphQLTypes["_ValidationResult"],
	getHistoryHomePage?: GraphQLTypes["HistoryHomePage"],
	listHistoryHomePage: Array<GraphQLTypes["HistoryHomePage"]>,
	paginateHistoryHomePage: GraphQLTypes["HistoryHomePageConnection"],
	validateCreateHistoryHomePage: GraphQLTypes["_ValidationResult"],
	validateUpdateHistoryHomePage: GraphQLTypes["_ValidationResult"],
	getHistoryCover?: GraphQLTypes["HistoryCover"],
	listHistoryCover: Array<GraphQLTypes["HistoryCover"]>,
	paginateHistoryCover: GraphQLTypes["HistoryCoverConnection"],
	validateCreateHistoryCover: GraphQLTypes["_ValidationResult"],
	validateUpdateHistoryCover: GraphQLTypes["_ValidationResult"],
	getHistoryTextList?: GraphQLTypes["HistoryTextList"],
	listHistoryTextList: Array<GraphQLTypes["HistoryTextList"]>,
	paginateHistoryTextList: GraphQLTypes["HistoryTextListConnection"],
	validateCreateHistoryTextList: GraphQLTypes["_ValidationResult"],
	validateUpdateHistoryTextList: GraphQLTypes["_ValidationResult"],
	getHistoryTextItem?: GraphQLTypes["HistoryTextItem"],
	listHistoryTextItem: Array<GraphQLTypes["HistoryTextItem"]>,
	paginateHistoryTextItem: GraphQLTypes["HistoryTextItemConnection"],
	validateCreateHistoryTextItem: GraphQLTypes["_ValidationResult"],
	validateUpdateHistoryTextItem: GraphQLTypes["_ValidationResult"],
	getFooterMenu?: GraphQLTypes["FooterMenu"],
	listFooterMenu: Array<GraphQLTypes["FooterMenu"]>,
	paginateFooterMenu: GraphQLTypes["FooterMenuConnection"],
	validateCreateFooterMenu: GraphQLTypes["_ValidationResult"],
	validateUpdateFooterMenu: GraphQLTypes["_ValidationResult"],
	getLinkSection?: GraphQLTypes["LinkSection"],
	listLinkSection: Array<GraphQLTypes["LinkSection"]>,
	paginateLinkSection: GraphQLTypes["LinkSectionConnection"],
	validateCreateLinkSection: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkSection: GraphQLTypes["_ValidationResult"],
	getLinkList?: GraphQLTypes["LinkList"],
	listLinkList: Array<GraphQLTypes["LinkList"]>,
	paginateLinkList: GraphQLTypes["LinkListConnection"],
	validateCreateLinkList: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkList: GraphQLTypes["_ValidationResult"],
	getLinkItem?: GraphQLTypes["LinkItem"],
	listLinkItem: Array<GraphQLTypes["LinkItem"]>,
	paginateLinkItem: GraphQLTypes["LinkItemConnection"],
	validateCreateLinkItem: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkItem: GraphQLTypes["_ValidationResult"],
	getNewsletterSection?: GraphQLTypes["NewsletterSection"],
	listNewsletterSection: Array<GraphQLTypes["NewsletterSection"]>,
	paginateNewsletterSection: GraphQLTypes["NewsletterSectionConnection"],
	validateCreateNewsletterSection: GraphQLTypes["_ValidationResult"],
	validateUpdateNewsletterSection: GraphQLTypes["_ValidationResult"],
	getNewsletter?: GraphQLTypes["Newsletter"],
	listNewsletter: Array<GraphQLTypes["Newsletter"]>,
	paginateNewsletter: GraphQLTypes["NewsletterConnection"],
	validateCreateNewsletter: GraphQLTypes["_ValidationResult"],
	validateUpdateNewsletter: GraphQLTypes["_ValidationResult"],
	getOnlineSection?: GraphQLTypes["OnlineSection"],
	listOnlineSection: Array<GraphQLTypes["OnlineSection"]>,
	paginateOnlineSection: GraphQLTypes["OnlineSectionConnection"],
	validateCreateOnlineSection: GraphQLTypes["_ValidationResult"],
	validateUpdateOnlineSection: GraphQLTypes["_ValidationResult"],
	getAppLink?: GraphQLTypes["AppLink"],
	listAppLink: Array<GraphQLTypes["AppLink"]>,
	paginateAppLink: GraphQLTypes["AppLinkConnection"],
	validateCreateAppLink: GraphQLTypes["_ValidationResult"],
	validateUpdateAppLink: GraphQLTypes["_ValidationResult"],
	getAppLinkList?: GraphQLTypes["AppLinkList"],
	listAppLinkList: Array<GraphQLTypes["AppLinkList"]>,
	paginateAppLinkList: GraphQLTypes["AppLinkListConnection"],
	validateCreateAppLinkList: GraphQLTypes["_ValidationResult"],
	validateUpdateAppLinkList: GraphQLTypes["_ValidationResult"],
	getAppLinkItem?: GraphQLTypes["AppLinkItem"],
	listAppLinkItem: Array<GraphQLTypes["AppLinkItem"]>,
	paginateAppLinkItem: GraphQLTypes["AppLinkItemConnection"],
	validateCreateAppLinkItem: GraphQLTypes["_ValidationResult"],
	validateUpdateAppLinkItem: GraphQLTypes["_ValidationResult"],
	getSocialSection?: GraphQLTypes["SocialSection"],
	listSocialSection: Array<GraphQLTypes["SocialSection"]>,
	paginateSocialSection: GraphQLTypes["SocialSectionConnection"],
	validateCreateSocialSection: GraphQLTypes["_ValidationResult"],
	validateUpdateSocialSection: GraphQLTypes["_ValidationResult"],
	getSocialLink?: GraphQLTypes["SocialLink"],
	listSocialLink: Array<GraphQLTypes["SocialLink"]>,
	paginateSocialLink: GraphQLTypes["SocialLinkConnection"],
	validateCreateSocialLink: GraphQLTypes["_ValidationResult"],
	validateUpdateSocialLink: GraphQLTypes["_ValidationResult"],
	getSocialLinkList?: GraphQLTypes["SocialLinkList"],
	listSocialLinkList: Array<GraphQLTypes["SocialLinkList"]>,
	paginateSocialLinkList: GraphQLTypes["SocialLinkListConnection"],
	validateCreateSocialLinkList: GraphQLTypes["_ValidationResult"],
	validateUpdateSocialLinkList: GraphQLTypes["_ValidationResult"],
	getSocialLinkItem?: GraphQLTypes["SocialLinkItem"],
	listSocialLinkItem: Array<GraphQLTypes["SocialLinkItem"]>,
	paginateSocialLinkItem: GraphQLTypes["SocialLinkItemConnection"],
	validateCreateSocialLinkItem: GraphQLTypes["_ValidationResult"],
	validateUpdateSocialLinkItem: GraphQLTypes["_ValidationResult"],
	getSharedContent?: GraphQLTypes["SharedContent"],
	listSharedContent: Array<GraphQLTypes["SharedContent"]>,
	paginateSharedContent: GraphQLTypes["SharedContentConnection"],
	validateCreateSharedContent: GraphQLTypes["_ValidationResult"],
	validateUpdateSharedContent: GraphQLTypes["_ValidationResult"]
};
	["Info"]: {
	__typename: "Info",
	description?: string
};
	["Mutation"]: {
	__typename: "Mutation",
	createArticle: GraphQLTypes["ArticleCreateResult"],
	deleteArticle: GraphQLTypes["ArticleDeleteResult"],
	updateArticle: GraphQLTypes["ArticleUpdateResult"],
	upsertArticle: GraphQLTypes["ArticleUpsertResult"],
	createArticleAuthor: GraphQLTypes["ArticleAuthorCreateResult"],
	deleteArticleAuthor: GraphQLTypes["ArticleAuthorDeleteResult"],
	updateArticleAuthor: GraphQLTypes["ArticleAuthorUpdateResult"],
	upsertArticleAuthor: GraphQLTypes["ArticleAuthorUpsertResult"],
	createAuthor: GraphQLTypes["AuthorCreateResult"],
	deleteAuthor: GraphQLTypes["AuthorDeleteResult"],
	updateAuthor: GraphQLTypes["AuthorUpdateResult"],
	upsertAuthor: GraphQLTypes["AuthorUpsertResult"],
	createAuthorTopArticle: GraphQLTypes["AuthorTopArticleCreateResult"],
	deleteAuthorTopArticle: GraphQLTypes["AuthorTopArticleDeleteResult"],
	updateAuthorTopArticle: GraphQLTypes["AuthorTopArticleUpdateResult"],
	upsertAuthorTopArticle: GraphQLTypes["AuthorTopArticleUpsertResult"],
	createContent: GraphQLTypes["ContentCreateResult"],
	deleteContent: GraphQLTypes["ContentDeleteResult"],
	updateContent: GraphQLTypes["ContentUpdateResult"],
	upsertContent: GraphQLTypes["ContentUpsertResult"],
	createContentPart: GraphQLTypes["ContentPartCreateResult"],
	deleteContentPart: GraphQLTypes["ContentPartDeleteResult"],
	updateContentPart: GraphQLTypes["ContentPartUpdateResult"],
	upsertContentPart: GraphQLTypes["ContentPartUpsertResult"],
	createContentReference: GraphQLTypes["ContentReferenceCreateResult"],
	deleteContentReference: GraphQLTypes["ContentReferenceDeleteResult"],
	updateContentReference: GraphQLTypes["ContentReferenceUpdateResult"],
	upsertContentReference: GraphQLTypes["ContentReferenceUpsertResult"],
	createHomepageArticle: GraphQLTypes["HomepageArticleCreateResult"],
	deleteHomepageArticle: GraphQLTypes["HomepageArticleDeleteResult"],
	updateHomepageArticle: GraphQLTypes["HomepageArticleUpdateResult"],
	upsertHomepageArticle: GraphQLTypes["HomepageArticleUpsertResult"],
	createImage: GraphQLTypes["ImageCreateResult"],
	deleteImage: GraphQLTypes["ImageDeleteResult"],
	updateImage: GraphQLTypes["ImageUpdateResult"],
	upsertImage: GraphQLTypes["ImageUpsertResult"],
	createImageUse: GraphQLTypes["ImageUseCreateResult"],
	deleteImageUse: GraphQLTypes["ImageUseDeleteResult"],
	updateImageUse: GraphQLTypes["ImageUseUpdateResult"],
	upsertImageUse: GraphQLTypes["ImageUseUpsertResult"],
	createImageTag: GraphQLTypes["ImageTagCreateResult"],
	deleteImageTag: GraphQLTypes["ImageTagDeleteResult"],
	updateImageTag: GraphQLTypes["ImageTagUpdateResult"],
	upsertImageTag: GraphQLTypes["ImageTagUpsertResult"],
	createIssue: GraphQLTypes["IssueCreateResult"],
	deleteIssue: GraphQLTypes["IssueDeleteResult"],
	updateIssue: GraphQLTypes["IssueUpdateResult"],
	upsertIssue: GraphQLTypes["IssueUpsertResult"],
	createIssueArticle: GraphQLTypes["IssueArticleCreateResult"],
	deleteIssueArticle: GraphQLTypes["IssueArticleDeleteResult"],
	updateIssueArticle: GraphQLTypes["IssueArticleUpdateResult"],
	upsertIssueArticle: GraphQLTypes["IssueArticleUpsertResult"],
	createLink: GraphQLTypes["LinkCreateResult"],
	deleteLink: GraphQLTypes["LinkDeleteResult"],
	updateLink: GraphQLTypes["LinkUpdateResult"],
	upsertLink: GraphQLTypes["LinkUpsertResult"],
	createTextContent: GraphQLTypes["TextContentCreateResult"],
	deleteTextContent: GraphQLTypes["TextContentDeleteResult"],
	updateTextContent: GraphQLTypes["TextContentUpdateResult"],
	upsertTextContent: GraphQLTypes["TextContentUpsertResult"],
	createTextContentPart: GraphQLTypes["TextContentPartCreateResult"],
	deleteTextContentPart: GraphQLTypes["TextContentPartDeleteResult"],
	updateTextContentPart: GraphQLTypes["TextContentPartUpdateResult"],
	upsertTextContentPart: GraphQLTypes["TextContentPartUpsertResult"],
	createTextContentReference: GraphQLTypes["TextContentReferenceCreateResult"],
	deleteTextContentReference: GraphQLTypes["TextContentReferenceDeleteResult"],
	updateTextContentReference: GraphQLTypes["TextContentReferenceUpdateResult"],
	upsertTextContentReference: GraphQLTypes["TextContentReferenceUpsertResult"],
	createUrl: GraphQLTypes["UrlCreateResult"],
	deleteUrl: GraphQLTypes["UrlDeleteResult"],
	updateUrl: GraphQLTypes["UrlUpdateResult"],
	upsertUrl: GraphQLTypes["UrlUpsertResult"],
	createArticleTag: GraphQLTypes["ArticleTagCreateResult"],
	deleteArticleTag: GraphQLTypes["ArticleTagDeleteResult"],
	updateArticleTag: GraphQLTypes["ArticleTagUpdateResult"],
	upsertArticleTag: GraphQLTypes["ArticleTagUpsertResult"],
	createCategory: GraphQLTypes["CategoryCreateResult"],
	deleteCategory: GraphQLTypes["CategoryDeleteResult"],
	updateCategory: GraphQLTypes["CategoryUpdateResult"],
	upsertCategory: GraphQLTypes["CategoryUpsertResult"],
	createArticleCategory: GraphQLTypes["ArticleCategoryCreateResult"],
	deleteArticleCategory: GraphQLTypes["ArticleCategoryDeleteResult"],
	updateArticleCategory: GraphQLTypes["ArticleCategoryUpdateResult"],
	upsertArticleCategory: GraphQLTypes["ArticleCategoryUpsertResult"],
	createAudio: GraphQLTypes["AudioCreateResult"],
	deleteAudio: GraphQLTypes["AudioDeleteResult"],
	updateAudio: GraphQLTypes["AudioUpdateResult"],
	upsertAudio: GraphQLTypes["AudioUpsertResult"],
	createAudioUse: GraphQLTypes["AudioUseCreateResult"],
	deleteAudioUse: GraphQLTypes["AudioUseDeleteResult"],
	updateAudioUse: GraphQLTypes["AudioUseUpdateResult"],
	upsertAudioUse: GraphQLTypes["AudioUseUpsertResult"],
	createEmbed: GraphQLTypes["EmbedCreateResult"],
	deleteEmbed: GraphQLTypes["EmbedDeleteResult"],
	updateEmbed: GraphQLTypes["EmbedUpdateResult"],
	upsertEmbed: GraphQLTypes["EmbedUpsertResult"],
	createImageContent: GraphQLTypes["ImageContentCreateResult"],
	deleteImageContent: GraphQLTypes["ImageContentDeleteResult"],
	updateImageContent: GraphQLTypes["ImageContentUpdateResult"],
	upsertImageContent: GraphQLTypes["ImageContentUpsertResult"],
	createListicle: GraphQLTypes["ListicleCreateResult"],
	deleteListicle: GraphQLTypes["ListicleDeleteResult"],
	updateListicle: GraphQLTypes["ListicleUpdateResult"],
	upsertListicle: GraphQLTypes["ListicleUpsertResult"],
	createPollAnswer: GraphQLTypes["PollAnswerCreateResult"],
	deletePollAnswer: GraphQLTypes["PollAnswerDeleteResult"],
	updatePollAnswer: GraphQLTypes["PollAnswerUpdateResult"],
	upsertPollAnswer: GraphQLTypes["PollAnswerUpsertResult"],
	createTag: GraphQLTypes["TagCreateResult"],
	deleteTag: GraphQLTypes["TagDeleteResult"],
	updateTag: GraphQLTypes["TagUpdateResult"],
	upsertTag: GraphQLTypes["TagUpsertResult"],
	createFAQ: GraphQLTypes["FAQCreateResult"],
	deleteFAQ: GraphQLTypes["FAQDeleteResult"],
	updateFAQ: GraphQLTypes["FAQUpdateResult"],
	upsertFAQ: GraphQLTypes["FAQUpsertResult"],
	createLinkContent: GraphQLTypes["LinkContentCreateResult"],
	deleteLinkContent: GraphQLTypes["LinkContentDeleteResult"],
	updateLinkContent: GraphQLTypes["LinkContentUpdateResult"],
	upsertLinkContent: GraphQLTypes["LinkContentUpsertResult"],
	createAwardContent: GraphQLTypes["AwardContentCreateResult"],
	deleteAwardContent: GraphQLTypes["AwardContentDeleteResult"],
	updateAwardContent: GraphQLTypes["AwardContentUpdateResult"],
	upsertAwardContent: GraphQLTypes["AwardContentUpsertResult"],
	createReviewContent: GraphQLTypes["ReviewContentCreateResult"],
	deleteReviewContent: GraphQLTypes["ReviewContentDeleteResult"],
	updateReviewContent: GraphQLTypes["ReviewContentUpdateResult"],
	upsertReviewContent: GraphQLTypes["ReviewContentUpsertResult"],
	createPage: GraphQLTypes["PageCreateResult"],
	deletePage: GraphQLTypes["PageDeleteResult"],
	updatePage: GraphQLTypes["PageUpdateResult"],
	upsertPage: GraphQLTypes["PageUpsertResult"],
	createTextTranslation: GraphQLTypes["TextTranslationCreateResult"],
	deleteTextTranslation: GraphQLTypes["TextTranslationDeleteResult"],
	updateTextTranslation: GraphQLTypes["TextTranslationUpdateResult"],
	upsertTextTranslation: GraphQLTypes["TextTranslationUpsertResult"],
	createSeo: GraphQLTypes["SeoCreateResult"],
	deleteSeo: GraphQLTypes["SeoDeleteResult"],
	updateSeo: GraphQLTypes["SeoUpdateResult"],
	upsertSeo: GraphQLTypes["SeoUpsertResult"],
	createFile: GraphQLTypes["FileCreateResult"],
	deleteFile: GraphQLTypes["FileDeleteResult"],
	updateFile: GraphQLTypes["FileUpdateResult"],
	upsertFile: GraphQLTypes["FileUpsertResult"],
	createFileUse: GraphQLTypes["FileUseCreateResult"],
	deleteFileUse: GraphQLTypes["FileUseDeleteResult"],
	updateFileUse: GraphQLTypes["FileUseUpdateResult"],
	upsertFileUse: GraphQLTypes["FileUseUpsertResult"],
	createContentBlock: GraphQLTypes["ContentBlockCreateResult"],
	deleteContentBlock: GraphQLTypes["ContentBlockDeleteResult"],
	updateContentBlock: GraphQLTypes["ContentBlockUpdateResult"],
	upsertContentBlock: GraphQLTypes["ContentBlockUpsertResult"],
	createContentArticle: GraphQLTypes["ContentArticleCreateResult"],
	deleteContentArticle: GraphQLTypes["ContentArticleDeleteResult"],
	updateContentArticle: GraphQLTypes["ContentArticleUpdateResult"],
	upsertContentArticle: GraphQLTypes["ContentArticleUpsertResult"],
	createUnlockedArticle: GraphQLTypes["UnlockedArticleCreateResult"],
	deleteUnlockedArticle: GraphQLTypes["UnlockedArticleDeleteResult"],
	updateUnlockedArticle: GraphQLTypes["UnlockedArticleUpdateResult"],
	upsertUnlockedArticle: GraphQLTypes["UnlockedArticleUpsertResult"],
	createUser: GraphQLTypes["UserCreateResult"],
	deleteUser: GraphQLTypes["UserDeleteResult"],
	updateUser: GraphQLTypes["UserUpdateResult"],
	upsertUser: GraphQLTypes["UserUpsertResult"],
	createNotification: GraphQLTypes["NotificationCreateResult"],
	deleteNotification: GraphQLTypes["NotificationDeleteResult"],
	updateNotification: GraphQLTypes["NotificationUpdateResult"],
	upsertNotification: GraphQLTypes["NotificationUpsertResult"],
	createAppReview: GraphQLTypes["AppReviewCreateResult"],
	deleteAppReview: GraphQLTypes["AppReviewDeleteResult"],
	updateAppReview: GraphQLTypes["AppReviewUpdateResult"],
	upsertAppReview: GraphQLTypes["AppReviewUpsertResult"],
	createProduct: GraphQLTypes["ProductCreateResult"],
	deleteProduct: GraphQLTypes["ProductDeleteResult"],
	updateProduct: GraphQLTypes["ProductUpdateResult"],
	upsertProduct: GraphQLTypes["ProductUpsertResult"],
	createSubscriptionForm: GraphQLTypes["SubscriptionFormCreateResult"],
	deleteSubscriptionForm: GraphQLTypes["SubscriptionFormDeleteResult"],
	updateSubscriptionForm: GraphQLTypes["SubscriptionFormUpdateResult"],
	upsertSubscriptionForm: GraphQLTypes["SubscriptionFormUpsertResult"],
	createSubscriptionFormSection: GraphQLTypes["SubscriptionFormSectionCreateResult"],
	deleteSubscriptionFormSection: GraphQLTypes["SubscriptionFormSectionDeleteResult"],
	updateSubscriptionFormSection: GraphQLTypes["SubscriptionFormSectionUpdateResult"],
	upsertSubscriptionFormSection: GraphQLTypes["SubscriptionFormSectionUpsertResult"],
	createSubscriptionFormInput: GraphQLTypes["SubscriptionFormInputCreateResult"],
	deleteSubscriptionFormInput: GraphQLTypes["SubscriptionFormInputDeleteResult"],
	updateSubscriptionFormInput: GraphQLTypes["SubscriptionFormInputUpdateResult"],
	upsertSubscriptionFormInput: GraphQLTypes["SubscriptionFormInputUpsertResult"],
	createSubscriptionFormOption: GraphQLTypes["SubscriptionFormOptionCreateResult"],
	deleteSubscriptionFormOption: GraphQLTypes["SubscriptionFormOptionDeleteResult"],
	updateSubscriptionFormOption: GraphQLTypes["SubscriptionFormOptionUpdateResult"],
	upsertSubscriptionFormOption: GraphQLTypes["SubscriptionFormOptionUpsertResult"],
	createButton: GraphQLTypes["ButtonCreateResult"],
	deleteButton: GraphQLTypes["ButtonDeleteResult"],
	updateButton: GraphQLTypes["ButtonUpdateResult"],
	upsertButton: GraphQLTypes["ButtonUpsertResult"],
	createArticleHistoryTag: GraphQLTypes["ArticleHistoryTagCreateResult"],
	deleteArticleHistoryTag: GraphQLTypes["ArticleHistoryTagDeleteResult"],
	updateArticleHistoryTag: GraphQLTypes["ArticleHistoryTagUpdateResult"],
	upsertArticleHistoryTag: GraphQLTypes["ArticleHistoryTagUpsertResult"],
	createArticleHistoryPeriod: GraphQLTypes["ArticleHistoryPeriodCreateResult"],
	deleteArticleHistoryPeriod: GraphQLTypes["ArticleHistoryPeriodDeleteResult"],
	updateArticleHistoryPeriod: GraphQLTypes["ArticleHistoryPeriodUpdateResult"],
	upsertArticleHistoryPeriod: GraphQLTypes["ArticleHistoryPeriodUpsertResult"],
	createHistoryTag: GraphQLTypes["HistoryTagCreateResult"],
	deleteHistoryTag: GraphQLTypes["HistoryTagDeleteResult"],
	updateHistoryTag: GraphQLTypes["HistoryTagUpdateResult"],
	upsertHistoryTag: GraphQLTypes["HistoryTagUpsertResult"],
	createHistoryPeriod: GraphQLTypes["HistoryPeriodCreateResult"],
	deleteHistoryPeriod: GraphQLTypes["HistoryPeriodDeleteResult"],
	updateHistoryPeriod: GraphQLTypes["HistoryPeriodUpdateResult"],
	upsertHistoryPeriod: GraphQLTypes["HistoryPeriodUpsertResult"],
	createHistoryHomePage: GraphQLTypes["HistoryHomePageCreateResult"],
	deleteHistoryHomePage: GraphQLTypes["HistoryHomePageDeleteResult"],
	updateHistoryHomePage: GraphQLTypes["HistoryHomePageUpdateResult"],
	upsertHistoryHomePage: GraphQLTypes["HistoryHomePageUpsertResult"],
	createHistoryCover: GraphQLTypes["HistoryCoverCreateResult"],
	deleteHistoryCover: GraphQLTypes["HistoryCoverDeleteResult"],
	updateHistoryCover: GraphQLTypes["HistoryCoverUpdateResult"],
	upsertHistoryCover: GraphQLTypes["HistoryCoverUpsertResult"],
	createHistoryTextList: GraphQLTypes["HistoryTextListCreateResult"],
	deleteHistoryTextList: GraphQLTypes["HistoryTextListDeleteResult"],
	updateHistoryTextList: GraphQLTypes["HistoryTextListUpdateResult"],
	upsertHistoryTextList: GraphQLTypes["HistoryTextListUpsertResult"],
	createHistoryTextItem: GraphQLTypes["HistoryTextItemCreateResult"],
	deleteHistoryTextItem: GraphQLTypes["HistoryTextItemDeleteResult"],
	updateHistoryTextItem: GraphQLTypes["HistoryTextItemUpdateResult"],
	upsertHistoryTextItem: GraphQLTypes["HistoryTextItemUpsertResult"],
	createFooterMenu: GraphQLTypes["FooterMenuCreateResult"],
	deleteFooterMenu: GraphQLTypes["FooterMenuDeleteResult"],
	updateFooterMenu: GraphQLTypes["FooterMenuUpdateResult"],
	upsertFooterMenu: GraphQLTypes["FooterMenuUpsertResult"],
	createLinkSection: GraphQLTypes["LinkSectionCreateResult"],
	deleteLinkSection: GraphQLTypes["LinkSectionDeleteResult"],
	updateLinkSection: GraphQLTypes["LinkSectionUpdateResult"],
	upsertLinkSection: GraphQLTypes["LinkSectionUpsertResult"],
	createLinkList: GraphQLTypes["LinkListCreateResult"],
	deleteLinkList: GraphQLTypes["LinkListDeleteResult"],
	updateLinkList: GraphQLTypes["LinkListUpdateResult"],
	upsertLinkList: GraphQLTypes["LinkListUpsertResult"],
	createLinkItem: GraphQLTypes["LinkItemCreateResult"],
	deleteLinkItem: GraphQLTypes["LinkItemDeleteResult"],
	updateLinkItem: GraphQLTypes["LinkItemUpdateResult"],
	upsertLinkItem: GraphQLTypes["LinkItemUpsertResult"],
	createNewsletterSection: GraphQLTypes["NewsletterSectionCreateResult"],
	deleteNewsletterSection: GraphQLTypes["NewsletterSectionDeleteResult"],
	updateNewsletterSection: GraphQLTypes["NewsletterSectionUpdateResult"],
	upsertNewsletterSection: GraphQLTypes["NewsletterSectionUpsertResult"],
	createNewsletter: GraphQLTypes["NewsletterCreateResult"],
	deleteNewsletter: GraphQLTypes["NewsletterDeleteResult"],
	updateNewsletter: GraphQLTypes["NewsletterUpdateResult"],
	upsertNewsletter: GraphQLTypes["NewsletterUpsertResult"],
	createOnlineSection: GraphQLTypes["OnlineSectionCreateResult"],
	deleteOnlineSection: GraphQLTypes["OnlineSectionDeleteResult"],
	updateOnlineSection: GraphQLTypes["OnlineSectionUpdateResult"],
	upsertOnlineSection: GraphQLTypes["OnlineSectionUpsertResult"],
	createAppLink: GraphQLTypes["AppLinkCreateResult"],
	deleteAppLink: GraphQLTypes["AppLinkDeleteResult"],
	updateAppLink: GraphQLTypes["AppLinkUpdateResult"],
	upsertAppLink: GraphQLTypes["AppLinkUpsertResult"],
	createAppLinkList: GraphQLTypes["AppLinkListCreateResult"],
	deleteAppLinkList: GraphQLTypes["AppLinkListDeleteResult"],
	updateAppLinkList: GraphQLTypes["AppLinkListUpdateResult"],
	upsertAppLinkList: GraphQLTypes["AppLinkListUpsertResult"],
	createAppLinkItem: GraphQLTypes["AppLinkItemCreateResult"],
	deleteAppLinkItem: GraphQLTypes["AppLinkItemDeleteResult"],
	updateAppLinkItem: GraphQLTypes["AppLinkItemUpdateResult"],
	upsertAppLinkItem: GraphQLTypes["AppLinkItemUpsertResult"],
	createSocialSection: GraphQLTypes["SocialSectionCreateResult"],
	deleteSocialSection: GraphQLTypes["SocialSectionDeleteResult"],
	updateSocialSection: GraphQLTypes["SocialSectionUpdateResult"],
	upsertSocialSection: GraphQLTypes["SocialSectionUpsertResult"],
	createSocialLink: GraphQLTypes["SocialLinkCreateResult"],
	deleteSocialLink: GraphQLTypes["SocialLinkDeleteResult"],
	updateSocialLink: GraphQLTypes["SocialLinkUpdateResult"],
	upsertSocialLink: GraphQLTypes["SocialLinkUpsertResult"],
	createSocialLinkList: GraphQLTypes["SocialLinkListCreateResult"],
	deleteSocialLinkList: GraphQLTypes["SocialLinkListDeleteResult"],
	updateSocialLinkList: GraphQLTypes["SocialLinkListUpdateResult"],
	upsertSocialLinkList: GraphQLTypes["SocialLinkListUpsertResult"],
	createSocialLinkItem: GraphQLTypes["SocialLinkItemCreateResult"],
	deleteSocialLinkItem: GraphQLTypes["SocialLinkItemDeleteResult"],
	updateSocialLinkItem: GraphQLTypes["SocialLinkItemUpdateResult"],
	upsertSocialLinkItem: GraphQLTypes["SocialLinkItemUpsertResult"],
	createSharedContent: GraphQLTypes["SharedContentCreateResult"],
	deleteSharedContent: GraphQLTypes["SharedContentDeleteResult"],
	updateSharedContent: GraphQLTypes["SharedContentUpdateResult"],
	upsertSharedContent: GraphQLTypes["SharedContentUpsertResult"],
	transaction: GraphQLTypes["MutationTransaction"],
	query: GraphQLTypes["Query"],
	generateUploadUrl: GraphQLTypes["S3SignedUpload"],
	generateReadUrl: GraphQLTypes["S3SignedRead"]
};
	["ArticleCreateResult"]: {
	__typename: "ArticleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Article"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MutationResult"]: {
	__typename:"ArticleCreateResult" | "ArticleDeleteResult" | "ArticleUpdateResult" | "ArticleUpsertResult" | "ArticleAuthorCreateResult" | "ArticleAuthorDeleteResult" | "ArticleAuthorUpdateResult" | "ArticleAuthorUpsertResult" | "AuthorCreateResult" | "AuthorDeleteResult" | "AuthorUpdateResult" | "AuthorUpsertResult" | "AuthorTopArticleCreateResult" | "AuthorTopArticleDeleteResult" | "AuthorTopArticleUpdateResult" | "AuthorTopArticleUpsertResult" | "ContentCreateResult" | "ContentDeleteResult" | "ContentUpdateResult" | "ContentUpsertResult" | "ContentPartCreateResult" | "ContentPartDeleteResult" | "ContentPartUpdateResult" | "ContentPartUpsertResult" | "ContentReferenceCreateResult" | "ContentReferenceDeleteResult" | "ContentReferenceUpdateResult" | "ContentReferenceUpsertResult" | "HomepageArticleCreateResult" | "HomepageArticleDeleteResult" | "HomepageArticleUpdateResult" | "HomepageArticleUpsertResult" | "ImageCreateResult" | "ImageDeleteResult" | "ImageUpdateResult" | "ImageUpsertResult" | "ImageUseCreateResult" | "ImageUseDeleteResult" | "ImageUseUpdateResult" | "ImageUseUpsertResult" | "ImageTagCreateResult" | "ImageTagDeleteResult" | "ImageTagUpdateResult" | "ImageTagUpsertResult" | "IssueCreateResult" | "IssueDeleteResult" | "IssueUpdateResult" | "IssueUpsertResult" | "IssueArticleCreateResult" | "IssueArticleDeleteResult" | "IssueArticleUpdateResult" | "IssueArticleUpsertResult" | "LinkCreateResult" | "LinkDeleteResult" | "LinkUpdateResult" | "LinkUpsertResult" | "TextContentCreateResult" | "TextContentDeleteResult" | "TextContentUpdateResult" | "TextContentUpsertResult" | "TextContentPartCreateResult" | "TextContentPartDeleteResult" | "TextContentPartUpdateResult" | "TextContentPartUpsertResult" | "TextContentReferenceCreateResult" | "TextContentReferenceDeleteResult" | "TextContentReferenceUpdateResult" | "TextContentReferenceUpsertResult" | "UrlCreateResult" | "UrlDeleteResult" | "UrlUpdateResult" | "UrlUpsertResult" | "ArticleTagCreateResult" | "ArticleTagDeleteResult" | "ArticleTagUpdateResult" | "ArticleTagUpsertResult" | "CategoryCreateResult" | "CategoryDeleteResult" | "CategoryUpdateResult" | "CategoryUpsertResult" | "ArticleCategoryCreateResult" | "ArticleCategoryDeleteResult" | "ArticleCategoryUpdateResult" | "ArticleCategoryUpsertResult" | "AudioCreateResult" | "AudioDeleteResult" | "AudioUpdateResult" | "AudioUpsertResult" | "AudioUseCreateResult" | "AudioUseDeleteResult" | "AudioUseUpdateResult" | "AudioUseUpsertResult" | "EmbedCreateResult" | "EmbedDeleteResult" | "EmbedUpdateResult" | "EmbedUpsertResult" | "ImageContentCreateResult" | "ImageContentDeleteResult" | "ImageContentUpdateResult" | "ImageContentUpsertResult" | "ListicleCreateResult" | "ListicleDeleteResult" | "ListicleUpdateResult" | "ListicleUpsertResult" | "PollAnswerCreateResult" | "PollAnswerDeleteResult" | "PollAnswerUpdateResult" | "PollAnswerUpsertResult" | "TagCreateResult" | "TagDeleteResult" | "TagUpdateResult" | "TagUpsertResult" | "FAQCreateResult" | "FAQDeleteResult" | "FAQUpdateResult" | "FAQUpsertResult" | "LinkContentCreateResult" | "LinkContentDeleteResult" | "LinkContentUpdateResult" | "LinkContentUpsertResult" | "AwardContentCreateResult" | "AwardContentDeleteResult" | "AwardContentUpdateResult" | "AwardContentUpsertResult" | "ReviewContentCreateResult" | "ReviewContentDeleteResult" | "ReviewContentUpdateResult" | "ReviewContentUpsertResult" | "PageCreateResult" | "PageDeleteResult" | "PageUpdateResult" | "PageUpsertResult" | "TextTranslationCreateResult" | "TextTranslationDeleteResult" | "TextTranslationUpdateResult" | "TextTranslationUpsertResult" | "SeoCreateResult" | "SeoDeleteResult" | "SeoUpdateResult" | "SeoUpsertResult" | "FileCreateResult" | "FileDeleteResult" | "FileUpdateResult" | "FileUpsertResult" | "FileUseCreateResult" | "FileUseDeleteResult" | "FileUseUpdateResult" | "FileUseUpsertResult" | "ContentBlockCreateResult" | "ContentBlockDeleteResult" | "ContentBlockUpdateResult" | "ContentBlockUpsertResult" | "ContentArticleCreateResult" | "ContentArticleDeleteResult" | "ContentArticleUpdateResult" | "ContentArticleUpsertResult" | "UnlockedArticleCreateResult" | "UnlockedArticleDeleteResult" | "UnlockedArticleUpdateResult" | "UnlockedArticleUpsertResult" | "UserCreateResult" | "UserDeleteResult" | "UserUpdateResult" | "UserUpsertResult" | "NotificationCreateResult" | "NotificationDeleteResult" | "NotificationUpdateResult" | "NotificationUpsertResult" | "AppReviewCreateResult" | "AppReviewDeleteResult" | "AppReviewUpdateResult" | "AppReviewUpsertResult" | "ProductCreateResult" | "ProductDeleteResult" | "ProductUpdateResult" | "ProductUpsertResult" | "SubscriptionFormCreateResult" | "SubscriptionFormDeleteResult" | "SubscriptionFormUpdateResult" | "SubscriptionFormUpsertResult" | "SubscriptionFormSectionCreateResult" | "SubscriptionFormSectionDeleteResult" | "SubscriptionFormSectionUpdateResult" | "SubscriptionFormSectionUpsertResult" | "SubscriptionFormInputCreateResult" | "SubscriptionFormInputDeleteResult" | "SubscriptionFormInputUpdateResult" | "SubscriptionFormInputUpsertResult" | "SubscriptionFormOptionCreateResult" | "SubscriptionFormOptionDeleteResult" | "SubscriptionFormOptionUpdateResult" | "SubscriptionFormOptionUpsertResult" | "ButtonCreateResult" | "ButtonDeleteResult" | "ButtonUpdateResult" | "ButtonUpsertResult" | "ArticleHistoryTagCreateResult" | "ArticleHistoryTagDeleteResult" | "ArticleHistoryTagUpdateResult" | "ArticleHistoryTagUpsertResult" | "ArticleHistoryPeriodCreateResult" | "ArticleHistoryPeriodDeleteResult" | "ArticleHistoryPeriodUpdateResult" | "ArticleHistoryPeriodUpsertResult" | "HistoryTagCreateResult" | "HistoryTagDeleteResult" | "HistoryTagUpdateResult" | "HistoryTagUpsertResult" | "HistoryPeriodCreateResult" | "HistoryPeriodDeleteResult" | "HistoryPeriodUpdateResult" | "HistoryPeriodUpsertResult" | "HistoryHomePageCreateResult" | "HistoryHomePageDeleteResult" | "HistoryHomePageUpdateResult" | "HistoryHomePageUpsertResult" | "HistoryCoverCreateResult" | "HistoryCoverDeleteResult" | "HistoryCoverUpdateResult" | "HistoryCoverUpsertResult" | "HistoryTextListCreateResult" | "HistoryTextListDeleteResult" | "HistoryTextListUpdateResult" | "HistoryTextListUpsertResult" | "HistoryTextItemCreateResult" | "HistoryTextItemDeleteResult" | "HistoryTextItemUpdateResult" | "HistoryTextItemUpsertResult" | "FooterMenuCreateResult" | "FooterMenuDeleteResult" | "FooterMenuUpdateResult" | "FooterMenuUpsertResult" | "LinkSectionCreateResult" | "LinkSectionDeleteResult" | "LinkSectionUpdateResult" | "LinkSectionUpsertResult" | "LinkListCreateResult" | "LinkListDeleteResult" | "LinkListUpdateResult" | "LinkListUpsertResult" | "LinkItemCreateResult" | "LinkItemDeleteResult" | "LinkItemUpdateResult" | "LinkItemUpsertResult" | "NewsletterSectionCreateResult" | "NewsletterSectionDeleteResult" | "NewsletterSectionUpdateResult" | "NewsletterSectionUpsertResult" | "NewsletterCreateResult" | "NewsletterDeleteResult" | "NewsletterUpdateResult" | "NewsletterUpsertResult" | "OnlineSectionCreateResult" | "OnlineSectionDeleteResult" | "OnlineSectionUpdateResult" | "OnlineSectionUpsertResult" | "AppLinkCreateResult" | "AppLinkDeleteResult" | "AppLinkUpdateResult" | "AppLinkUpsertResult" | "AppLinkListCreateResult" | "AppLinkListDeleteResult" | "AppLinkListUpdateResult" | "AppLinkListUpsertResult" | "AppLinkItemCreateResult" | "AppLinkItemDeleteResult" | "AppLinkItemUpdateResult" | "AppLinkItemUpsertResult" | "SocialSectionCreateResult" | "SocialSectionDeleteResult" | "SocialSectionUpdateResult" | "SocialSectionUpsertResult" | "SocialLinkCreateResult" | "SocialLinkDeleteResult" | "SocialLinkUpdateResult" | "SocialLinkUpsertResult" | "SocialLinkListCreateResult" | "SocialLinkListDeleteResult" | "SocialLinkListUpdateResult" | "SocialLinkListUpsertResult" | "SocialLinkItemCreateResult" | "SocialLinkItemDeleteResult" | "SocialLinkItemUpdateResult" | "SocialLinkItemUpsertResult" | "SharedContentCreateResult" | "SharedContentDeleteResult" | "SharedContentUpdateResult" | "SharedContentUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>
	['...on ArticleCreateResult']: '__union' & GraphQLTypes["ArticleCreateResult"];
	['...on ArticleDeleteResult']: '__union' & GraphQLTypes["ArticleDeleteResult"];
	['...on ArticleUpdateResult']: '__union' & GraphQLTypes["ArticleUpdateResult"];
	['...on ArticleUpsertResult']: '__union' & GraphQLTypes["ArticleUpsertResult"];
	['...on ArticleAuthorCreateResult']: '__union' & GraphQLTypes["ArticleAuthorCreateResult"];
	['...on ArticleAuthorDeleteResult']: '__union' & GraphQLTypes["ArticleAuthorDeleteResult"];
	['...on ArticleAuthorUpdateResult']: '__union' & GraphQLTypes["ArticleAuthorUpdateResult"];
	['...on ArticleAuthorUpsertResult']: '__union' & GraphQLTypes["ArticleAuthorUpsertResult"];
	['...on AuthorCreateResult']: '__union' & GraphQLTypes["AuthorCreateResult"];
	['...on AuthorDeleteResult']: '__union' & GraphQLTypes["AuthorDeleteResult"];
	['...on AuthorUpdateResult']: '__union' & GraphQLTypes["AuthorUpdateResult"];
	['...on AuthorUpsertResult']: '__union' & GraphQLTypes["AuthorUpsertResult"];
	['...on AuthorTopArticleCreateResult']: '__union' & GraphQLTypes["AuthorTopArticleCreateResult"];
	['...on AuthorTopArticleDeleteResult']: '__union' & GraphQLTypes["AuthorTopArticleDeleteResult"];
	['...on AuthorTopArticleUpdateResult']: '__union' & GraphQLTypes["AuthorTopArticleUpdateResult"];
	['...on AuthorTopArticleUpsertResult']: '__union' & GraphQLTypes["AuthorTopArticleUpsertResult"];
	['...on ContentCreateResult']: '__union' & GraphQLTypes["ContentCreateResult"];
	['...on ContentDeleteResult']: '__union' & GraphQLTypes["ContentDeleteResult"];
	['...on ContentUpdateResult']: '__union' & GraphQLTypes["ContentUpdateResult"];
	['...on ContentUpsertResult']: '__union' & GraphQLTypes["ContentUpsertResult"];
	['...on ContentPartCreateResult']: '__union' & GraphQLTypes["ContentPartCreateResult"];
	['...on ContentPartDeleteResult']: '__union' & GraphQLTypes["ContentPartDeleteResult"];
	['...on ContentPartUpdateResult']: '__union' & GraphQLTypes["ContentPartUpdateResult"];
	['...on ContentPartUpsertResult']: '__union' & GraphQLTypes["ContentPartUpsertResult"];
	['...on ContentReferenceCreateResult']: '__union' & GraphQLTypes["ContentReferenceCreateResult"];
	['...on ContentReferenceDeleteResult']: '__union' & GraphQLTypes["ContentReferenceDeleteResult"];
	['...on ContentReferenceUpdateResult']: '__union' & GraphQLTypes["ContentReferenceUpdateResult"];
	['...on ContentReferenceUpsertResult']: '__union' & GraphQLTypes["ContentReferenceUpsertResult"];
	['...on HomepageArticleCreateResult']: '__union' & GraphQLTypes["HomepageArticleCreateResult"];
	['...on HomepageArticleDeleteResult']: '__union' & GraphQLTypes["HomepageArticleDeleteResult"];
	['...on HomepageArticleUpdateResult']: '__union' & GraphQLTypes["HomepageArticleUpdateResult"];
	['...on HomepageArticleUpsertResult']: '__union' & GraphQLTypes["HomepageArticleUpsertResult"];
	['...on ImageCreateResult']: '__union' & GraphQLTypes["ImageCreateResult"];
	['...on ImageDeleteResult']: '__union' & GraphQLTypes["ImageDeleteResult"];
	['...on ImageUpdateResult']: '__union' & GraphQLTypes["ImageUpdateResult"];
	['...on ImageUpsertResult']: '__union' & GraphQLTypes["ImageUpsertResult"];
	['...on ImageUseCreateResult']: '__union' & GraphQLTypes["ImageUseCreateResult"];
	['...on ImageUseDeleteResult']: '__union' & GraphQLTypes["ImageUseDeleteResult"];
	['...on ImageUseUpdateResult']: '__union' & GraphQLTypes["ImageUseUpdateResult"];
	['...on ImageUseUpsertResult']: '__union' & GraphQLTypes["ImageUseUpsertResult"];
	['...on ImageTagCreateResult']: '__union' & GraphQLTypes["ImageTagCreateResult"];
	['...on ImageTagDeleteResult']: '__union' & GraphQLTypes["ImageTagDeleteResult"];
	['...on ImageTagUpdateResult']: '__union' & GraphQLTypes["ImageTagUpdateResult"];
	['...on ImageTagUpsertResult']: '__union' & GraphQLTypes["ImageTagUpsertResult"];
	['...on IssueCreateResult']: '__union' & GraphQLTypes["IssueCreateResult"];
	['...on IssueDeleteResult']: '__union' & GraphQLTypes["IssueDeleteResult"];
	['...on IssueUpdateResult']: '__union' & GraphQLTypes["IssueUpdateResult"];
	['...on IssueUpsertResult']: '__union' & GraphQLTypes["IssueUpsertResult"];
	['...on IssueArticleCreateResult']: '__union' & GraphQLTypes["IssueArticleCreateResult"];
	['...on IssueArticleDeleteResult']: '__union' & GraphQLTypes["IssueArticleDeleteResult"];
	['...on IssueArticleUpdateResult']: '__union' & GraphQLTypes["IssueArticleUpdateResult"];
	['...on IssueArticleUpsertResult']: '__union' & GraphQLTypes["IssueArticleUpsertResult"];
	['...on LinkCreateResult']: '__union' & GraphQLTypes["LinkCreateResult"];
	['...on LinkDeleteResult']: '__union' & GraphQLTypes["LinkDeleteResult"];
	['...on LinkUpdateResult']: '__union' & GraphQLTypes["LinkUpdateResult"];
	['...on LinkUpsertResult']: '__union' & GraphQLTypes["LinkUpsertResult"];
	['...on TextContentCreateResult']: '__union' & GraphQLTypes["TextContentCreateResult"];
	['...on TextContentDeleteResult']: '__union' & GraphQLTypes["TextContentDeleteResult"];
	['...on TextContentUpdateResult']: '__union' & GraphQLTypes["TextContentUpdateResult"];
	['...on TextContentUpsertResult']: '__union' & GraphQLTypes["TextContentUpsertResult"];
	['...on TextContentPartCreateResult']: '__union' & GraphQLTypes["TextContentPartCreateResult"];
	['...on TextContentPartDeleteResult']: '__union' & GraphQLTypes["TextContentPartDeleteResult"];
	['...on TextContentPartUpdateResult']: '__union' & GraphQLTypes["TextContentPartUpdateResult"];
	['...on TextContentPartUpsertResult']: '__union' & GraphQLTypes["TextContentPartUpsertResult"];
	['...on TextContentReferenceCreateResult']: '__union' & GraphQLTypes["TextContentReferenceCreateResult"];
	['...on TextContentReferenceDeleteResult']: '__union' & GraphQLTypes["TextContentReferenceDeleteResult"];
	['...on TextContentReferenceUpdateResult']: '__union' & GraphQLTypes["TextContentReferenceUpdateResult"];
	['...on TextContentReferenceUpsertResult']: '__union' & GraphQLTypes["TextContentReferenceUpsertResult"];
	['...on UrlCreateResult']: '__union' & GraphQLTypes["UrlCreateResult"];
	['...on UrlDeleteResult']: '__union' & GraphQLTypes["UrlDeleteResult"];
	['...on UrlUpdateResult']: '__union' & GraphQLTypes["UrlUpdateResult"];
	['...on UrlUpsertResult']: '__union' & GraphQLTypes["UrlUpsertResult"];
	['...on ArticleTagCreateResult']: '__union' & GraphQLTypes["ArticleTagCreateResult"];
	['...on ArticleTagDeleteResult']: '__union' & GraphQLTypes["ArticleTagDeleteResult"];
	['...on ArticleTagUpdateResult']: '__union' & GraphQLTypes["ArticleTagUpdateResult"];
	['...on ArticleTagUpsertResult']: '__union' & GraphQLTypes["ArticleTagUpsertResult"];
	['...on CategoryCreateResult']: '__union' & GraphQLTypes["CategoryCreateResult"];
	['...on CategoryDeleteResult']: '__union' & GraphQLTypes["CategoryDeleteResult"];
	['...on CategoryUpdateResult']: '__union' & GraphQLTypes["CategoryUpdateResult"];
	['...on CategoryUpsertResult']: '__union' & GraphQLTypes["CategoryUpsertResult"];
	['...on ArticleCategoryCreateResult']: '__union' & GraphQLTypes["ArticleCategoryCreateResult"];
	['...on ArticleCategoryDeleteResult']: '__union' & GraphQLTypes["ArticleCategoryDeleteResult"];
	['...on ArticleCategoryUpdateResult']: '__union' & GraphQLTypes["ArticleCategoryUpdateResult"];
	['...on ArticleCategoryUpsertResult']: '__union' & GraphQLTypes["ArticleCategoryUpsertResult"];
	['...on AudioCreateResult']: '__union' & GraphQLTypes["AudioCreateResult"];
	['...on AudioDeleteResult']: '__union' & GraphQLTypes["AudioDeleteResult"];
	['...on AudioUpdateResult']: '__union' & GraphQLTypes["AudioUpdateResult"];
	['...on AudioUpsertResult']: '__union' & GraphQLTypes["AudioUpsertResult"];
	['...on AudioUseCreateResult']: '__union' & GraphQLTypes["AudioUseCreateResult"];
	['...on AudioUseDeleteResult']: '__union' & GraphQLTypes["AudioUseDeleteResult"];
	['...on AudioUseUpdateResult']: '__union' & GraphQLTypes["AudioUseUpdateResult"];
	['...on AudioUseUpsertResult']: '__union' & GraphQLTypes["AudioUseUpsertResult"];
	['...on EmbedCreateResult']: '__union' & GraphQLTypes["EmbedCreateResult"];
	['...on EmbedDeleteResult']: '__union' & GraphQLTypes["EmbedDeleteResult"];
	['...on EmbedUpdateResult']: '__union' & GraphQLTypes["EmbedUpdateResult"];
	['...on EmbedUpsertResult']: '__union' & GraphQLTypes["EmbedUpsertResult"];
	['...on ImageContentCreateResult']: '__union' & GraphQLTypes["ImageContentCreateResult"];
	['...on ImageContentDeleteResult']: '__union' & GraphQLTypes["ImageContentDeleteResult"];
	['...on ImageContentUpdateResult']: '__union' & GraphQLTypes["ImageContentUpdateResult"];
	['...on ImageContentUpsertResult']: '__union' & GraphQLTypes["ImageContentUpsertResult"];
	['...on ListicleCreateResult']: '__union' & GraphQLTypes["ListicleCreateResult"];
	['...on ListicleDeleteResult']: '__union' & GraphQLTypes["ListicleDeleteResult"];
	['...on ListicleUpdateResult']: '__union' & GraphQLTypes["ListicleUpdateResult"];
	['...on ListicleUpsertResult']: '__union' & GraphQLTypes["ListicleUpsertResult"];
	['...on PollAnswerCreateResult']: '__union' & GraphQLTypes["PollAnswerCreateResult"];
	['...on PollAnswerDeleteResult']: '__union' & GraphQLTypes["PollAnswerDeleteResult"];
	['...on PollAnswerUpdateResult']: '__union' & GraphQLTypes["PollAnswerUpdateResult"];
	['...on PollAnswerUpsertResult']: '__union' & GraphQLTypes["PollAnswerUpsertResult"];
	['...on TagCreateResult']: '__union' & GraphQLTypes["TagCreateResult"];
	['...on TagDeleteResult']: '__union' & GraphQLTypes["TagDeleteResult"];
	['...on TagUpdateResult']: '__union' & GraphQLTypes["TagUpdateResult"];
	['...on TagUpsertResult']: '__union' & GraphQLTypes["TagUpsertResult"];
	['...on FAQCreateResult']: '__union' & GraphQLTypes["FAQCreateResult"];
	['...on FAQDeleteResult']: '__union' & GraphQLTypes["FAQDeleteResult"];
	['...on FAQUpdateResult']: '__union' & GraphQLTypes["FAQUpdateResult"];
	['...on FAQUpsertResult']: '__union' & GraphQLTypes["FAQUpsertResult"];
	['...on LinkContentCreateResult']: '__union' & GraphQLTypes["LinkContentCreateResult"];
	['...on LinkContentDeleteResult']: '__union' & GraphQLTypes["LinkContentDeleteResult"];
	['...on LinkContentUpdateResult']: '__union' & GraphQLTypes["LinkContentUpdateResult"];
	['...on LinkContentUpsertResult']: '__union' & GraphQLTypes["LinkContentUpsertResult"];
	['...on AwardContentCreateResult']: '__union' & GraphQLTypes["AwardContentCreateResult"];
	['...on AwardContentDeleteResult']: '__union' & GraphQLTypes["AwardContentDeleteResult"];
	['...on AwardContentUpdateResult']: '__union' & GraphQLTypes["AwardContentUpdateResult"];
	['...on AwardContentUpsertResult']: '__union' & GraphQLTypes["AwardContentUpsertResult"];
	['...on ReviewContentCreateResult']: '__union' & GraphQLTypes["ReviewContentCreateResult"];
	['...on ReviewContentDeleteResult']: '__union' & GraphQLTypes["ReviewContentDeleteResult"];
	['...on ReviewContentUpdateResult']: '__union' & GraphQLTypes["ReviewContentUpdateResult"];
	['...on ReviewContentUpsertResult']: '__union' & GraphQLTypes["ReviewContentUpsertResult"];
	['...on PageCreateResult']: '__union' & GraphQLTypes["PageCreateResult"];
	['...on PageDeleteResult']: '__union' & GraphQLTypes["PageDeleteResult"];
	['...on PageUpdateResult']: '__union' & GraphQLTypes["PageUpdateResult"];
	['...on PageUpsertResult']: '__union' & GraphQLTypes["PageUpsertResult"];
	['...on TextTranslationCreateResult']: '__union' & GraphQLTypes["TextTranslationCreateResult"];
	['...on TextTranslationDeleteResult']: '__union' & GraphQLTypes["TextTranslationDeleteResult"];
	['...on TextTranslationUpdateResult']: '__union' & GraphQLTypes["TextTranslationUpdateResult"];
	['...on TextTranslationUpsertResult']: '__union' & GraphQLTypes["TextTranslationUpsertResult"];
	['...on SeoCreateResult']: '__union' & GraphQLTypes["SeoCreateResult"];
	['...on SeoDeleteResult']: '__union' & GraphQLTypes["SeoDeleteResult"];
	['...on SeoUpdateResult']: '__union' & GraphQLTypes["SeoUpdateResult"];
	['...on SeoUpsertResult']: '__union' & GraphQLTypes["SeoUpsertResult"];
	['...on FileCreateResult']: '__union' & GraphQLTypes["FileCreateResult"];
	['...on FileDeleteResult']: '__union' & GraphQLTypes["FileDeleteResult"];
	['...on FileUpdateResult']: '__union' & GraphQLTypes["FileUpdateResult"];
	['...on FileUpsertResult']: '__union' & GraphQLTypes["FileUpsertResult"];
	['...on FileUseCreateResult']: '__union' & GraphQLTypes["FileUseCreateResult"];
	['...on FileUseDeleteResult']: '__union' & GraphQLTypes["FileUseDeleteResult"];
	['...on FileUseUpdateResult']: '__union' & GraphQLTypes["FileUseUpdateResult"];
	['...on FileUseUpsertResult']: '__union' & GraphQLTypes["FileUseUpsertResult"];
	['...on ContentBlockCreateResult']: '__union' & GraphQLTypes["ContentBlockCreateResult"];
	['...on ContentBlockDeleteResult']: '__union' & GraphQLTypes["ContentBlockDeleteResult"];
	['...on ContentBlockUpdateResult']: '__union' & GraphQLTypes["ContentBlockUpdateResult"];
	['...on ContentBlockUpsertResult']: '__union' & GraphQLTypes["ContentBlockUpsertResult"];
	['...on ContentArticleCreateResult']: '__union' & GraphQLTypes["ContentArticleCreateResult"];
	['...on ContentArticleDeleteResult']: '__union' & GraphQLTypes["ContentArticleDeleteResult"];
	['...on ContentArticleUpdateResult']: '__union' & GraphQLTypes["ContentArticleUpdateResult"];
	['...on ContentArticleUpsertResult']: '__union' & GraphQLTypes["ContentArticleUpsertResult"];
	['...on UnlockedArticleCreateResult']: '__union' & GraphQLTypes["UnlockedArticleCreateResult"];
	['...on UnlockedArticleDeleteResult']: '__union' & GraphQLTypes["UnlockedArticleDeleteResult"];
	['...on UnlockedArticleUpdateResult']: '__union' & GraphQLTypes["UnlockedArticleUpdateResult"];
	['...on UnlockedArticleUpsertResult']: '__union' & GraphQLTypes["UnlockedArticleUpsertResult"];
	['...on UserCreateResult']: '__union' & GraphQLTypes["UserCreateResult"];
	['...on UserDeleteResult']: '__union' & GraphQLTypes["UserDeleteResult"];
	['...on UserUpdateResult']: '__union' & GraphQLTypes["UserUpdateResult"];
	['...on UserUpsertResult']: '__union' & GraphQLTypes["UserUpsertResult"];
	['...on NotificationCreateResult']: '__union' & GraphQLTypes["NotificationCreateResult"];
	['...on NotificationDeleteResult']: '__union' & GraphQLTypes["NotificationDeleteResult"];
	['...on NotificationUpdateResult']: '__union' & GraphQLTypes["NotificationUpdateResult"];
	['...on NotificationUpsertResult']: '__union' & GraphQLTypes["NotificationUpsertResult"];
	['...on AppReviewCreateResult']: '__union' & GraphQLTypes["AppReviewCreateResult"];
	['...on AppReviewDeleteResult']: '__union' & GraphQLTypes["AppReviewDeleteResult"];
	['...on AppReviewUpdateResult']: '__union' & GraphQLTypes["AppReviewUpdateResult"];
	['...on AppReviewUpsertResult']: '__union' & GraphQLTypes["AppReviewUpsertResult"];
	['...on ProductCreateResult']: '__union' & GraphQLTypes["ProductCreateResult"];
	['...on ProductDeleteResult']: '__union' & GraphQLTypes["ProductDeleteResult"];
	['...on ProductUpdateResult']: '__union' & GraphQLTypes["ProductUpdateResult"];
	['...on ProductUpsertResult']: '__union' & GraphQLTypes["ProductUpsertResult"];
	['...on SubscriptionFormCreateResult']: '__union' & GraphQLTypes["SubscriptionFormCreateResult"];
	['...on SubscriptionFormDeleteResult']: '__union' & GraphQLTypes["SubscriptionFormDeleteResult"];
	['...on SubscriptionFormUpdateResult']: '__union' & GraphQLTypes["SubscriptionFormUpdateResult"];
	['...on SubscriptionFormUpsertResult']: '__union' & GraphQLTypes["SubscriptionFormUpsertResult"];
	['...on SubscriptionFormSectionCreateResult']: '__union' & GraphQLTypes["SubscriptionFormSectionCreateResult"];
	['...on SubscriptionFormSectionDeleteResult']: '__union' & GraphQLTypes["SubscriptionFormSectionDeleteResult"];
	['...on SubscriptionFormSectionUpdateResult']: '__union' & GraphQLTypes["SubscriptionFormSectionUpdateResult"];
	['...on SubscriptionFormSectionUpsertResult']: '__union' & GraphQLTypes["SubscriptionFormSectionUpsertResult"];
	['...on SubscriptionFormInputCreateResult']: '__union' & GraphQLTypes["SubscriptionFormInputCreateResult"];
	['...on SubscriptionFormInputDeleteResult']: '__union' & GraphQLTypes["SubscriptionFormInputDeleteResult"];
	['...on SubscriptionFormInputUpdateResult']: '__union' & GraphQLTypes["SubscriptionFormInputUpdateResult"];
	['...on SubscriptionFormInputUpsertResult']: '__union' & GraphQLTypes["SubscriptionFormInputUpsertResult"];
	['...on SubscriptionFormOptionCreateResult']: '__union' & GraphQLTypes["SubscriptionFormOptionCreateResult"];
	['...on SubscriptionFormOptionDeleteResult']: '__union' & GraphQLTypes["SubscriptionFormOptionDeleteResult"];
	['...on SubscriptionFormOptionUpdateResult']: '__union' & GraphQLTypes["SubscriptionFormOptionUpdateResult"];
	['...on SubscriptionFormOptionUpsertResult']: '__union' & GraphQLTypes["SubscriptionFormOptionUpsertResult"];
	['...on ButtonCreateResult']: '__union' & GraphQLTypes["ButtonCreateResult"];
	['...on ButtonDeleteResult']: '__union' & GraphQLTypes["ButtonDeleteResult"];
	['...on ButtonUpdateResult']: '__union' & GraphQLTypes["ButtonUpdateResult"];
	['...on ButtonUpsertResult']: '__union' & GraphQLTypes["ButtonUpsertResult"];
	['...on ArticleHistoryTagCreateResult']: '__union' & GraphQLTypes["ArticleHistoryTagCreateResult"];
	['...on ArticleHistoryTagDeleteResult']: '__union' & GraphQLTypes["ArticleHistoryTagDeleteResult"];
	['...on ArticleHistoryTagUpdateResult']: '__union' & GraphQLTypes["ArticleHistoryTagUpdateResult"];
	['...on ArticleHistoryTagUpsertResult']: '__union' & GraphQLTypes["ArticleHistoryTagUpsertResult"];
	['...on ArticleHistoryPeriodCreateResult']: '__union' & GraphQLTypes["ArticleHistoryPeriodCreateResult"];
	['...on ArticleHistoryPeriodDeleteResult']: '__union' & GraphQLTypes["ArticleHistoryPeriodDeleteResult"];
	['...on ArticleHistoryPeriodUpdateResult']: '__union' & GraphQLTypes["ArticleHistoryPeriodUpdateResult"];
	['...on ArticleHistoryPeriodUpsertResult']: '__union' & GraphQLTypes["ArticleHistoryPeriodUpsertResult"];
	['...on HistoryTagCreateResult']: '__union' & GraphQLTypes["HistoryTagCreateResult"];
	['...on HistoryTagDeleteResult']: '__union' & GraphQLTypes["HistoryTagDeleteResult"];
	['...on HistoryTagUpdateResult']: '__union' & GraphQLTypes["HistoryTagUpdateResult"];
	['...on HistoryTagUpsertResult']: '__union' & GraphQLTypes["HistoryTagUpsertResult"];
	['...on HistoryPeriodCreateResult']: '__union' & GraphQLTypes["HistoryPeriodCreateResult"];
	['...on HistoryPeriodDeleteResult']: '__union' & GraphQLTypes["HistoryPeriodDeleteResult"];
	['...on HistoryPeriodUpdateResult']: '__union' & GraphQLTypes["HistoryPeriodUpdateResult"];
	['...on HistoryPeriodUpsertResult']: '__union' & GraphQLTypes["HistoryPeriodUpsertResult"];
	['...on HistoryHomePageCreateResult']: '__union' & GraphQLTypes["HistoryHomePageCreateResult"];
	['...on HistoryHomePageDeleteResult']: '__union' & GraphQLTypes["HistoryHomePageDeleteResult"];
	['...on HistoryHomePageUpdateResult']: '__union' & GraphQLTypes["HistoryHomePageUpdateResult"];
	['...on HistoryHomePageUpsertResult']: '__union' & GraphQLTypes["HistoryHomePageUpsertResult"];
	['...on HistoryCoverCreateResult']: '__union' & GraphQLTypes["HistoryCoverCreateResult"];
	['...on HistoryCoverDeleteResult']: '__union' & GraphQLTypes["HistoryCoverDeleteResult"];
	['...on HistoryCoverUpdateResult']: '__union' & GraphQLTypes["HistoryCoverUpdateResult"];
	['...on HistoryCoverUpsertResult']: '__union' & GraphQLTypes["HistoryCoverUpsertResult"];
	['...on HistoryTextListCreateResult']: '__union' & GraphQLTypes["HistoryTextListCreateResult"];
	['...on HistoryTextListDeleteResult']: '__union' & GraphQLTypes["HistoryTextListDeleteResult"];
	['...on HistoryTextListUpdateResult']: '__union' & GraphQLTypes["HistoryTextListUpdateResult"];
	['...on HistoryTextListUpsertResult']: '__union' & GraphQLTypes["HistoryTextListUpsertResult"];
	['...on HistoryTextItemCreateResult']: '__union' & GraphQLTypes["HistoryTextItemCreateResult"];
	['...on HistoryTextItemDeleteResult']: '__union' & GraphQLTypes["HistoryTextItemDeleteResult"];
	['...on HistoryTextItemUpdateResult']: '__union' & GraphQLTypes["HistoryTextItemUpdateResult"];
	['...on HistoryTextItemUpsertResult']: '__union' & GraphQLTypes["HistoryTextItemUpsertResult"];
	['...on FooterMenuCreateResult']: '__union' & GraphQLTypes["FooterMenuCreateResult"];
	['...on FooterMenuDeleteResult']: '__union' & GraphQLTypes["FooterMenuDeleteResult"];
	['...on FooterMenuUpdateResult']: '__union' & GraphQLTypes["FooterMenuUpdateResult"];
	['...on FooterMenuUpsertResult']: '__union' & GraphQLTypes["FooterMenuUpsertResult"];
	['...on LinkSectionCreateResult']: '__union' & GraphQLTypes["LinkSectionCreateResult"];
	['...on LinkSectionDeleteResult']: '__union' & GraphQLTypes["LinkSectionDeleteResult"];
	['...on LinkSectionUpdateResult']: '__union' & GraphQLTypes["LinkSectionUpdateResult"];
	['...on LinkSectionUpsertResult']: '__union' & GraphQLTypes["LinkSectionUpsertResult"];
	['...on LinkListCreateResult']: '__union' & GraphQLTypes["LinkListCreateResult"];
	['...on LinkListDeleteResult']: '__union' & GraphQLTypes["LinkListDeleteResult"];
	['...on LinkListUpdateResult']: '__union' & GraphQLTypes["LinkListUpdateResult"];
	['...on LinkListUpsertResult']: '__union' & GraphQLTypes["LinkListUpsertResult"];
	['...on LinkItemCreateResult']: '__union' & GraphQLTypes["LinkItemCreateResult"];
	['...on LinkItemDeleteResult']: '__union' & GraphQLTypes["LinkItemDeleteResult"];
	['...on LinkItemUpdateResult']: '__union' & GraphQLTypes["LinkItemUpdateResult"];
	['...on LinkItemUpsertResult']: '__union' & GraphQLTypes["LinkItemUpsertResult"];
	['...on NewsletterSectionCreateResult']: '__union' & GraphQLTypes["NewsletterSectionCreateResult"];
	['...on NewsletterSectionDeleteResult']: '__union' & GraphQLTypes["NewsletterSectionDeleteResult"];
	['...on NewsletterSectionUpdateResult']: '__union' & GraphQLTypes["NewsletterSectionUpdateResult"];
	['...on NewsletterSectionUpsertResult']: '__union' & GraphQLTypes["NewsletterSectionUpsertResult"];
	['...on NewsletterCreateResult']: '__union' & GraphQLTypes["NewsletterCreateResult"];
	['...on NewsletterDeleteResult']: '__union' & GraphQLTypes["NewsletterDeleteResult"];
	['...on NewsletterUpdateResult']: '__union' & GraphQLTypes["NewsletterUpdateResult"];
	['...on NewsletterUpsertResult']: '__union' & GraphQLTypes["NewsletterUpsertResult"];
	['...on OnlineSectionCreateResult']: '__union' & GraphQLTypes["OnlineSectionCreateResult"];
	['...on OnlineSectionDeleteResult']: '__union' & GraphQLTypes["OnlineSectionDeleteResult"];
	['...on OnlineSectionUpdateResult']: '__union' & GraphQLTypes["OnlineSectionUpdateResult"];
	['...on OnlineSectionUpsertResult']: '__union' & GraphQLTypes["OnlineSectionUpsertResult"];
	['...on AppLinkCreateResult']: '__union' & GraphQLTypes["AppLinkCreateResult"];
	['...on AppLinkDeleteResult']: '__union' & GraphQLTypes["AppLinkDeleteResult"];
	['...on AppLinkUpdateResult']: '__union' & GraphQLTypes["AppLinkUpdateResult"];
	['...on AppLinkUpsertResult']: '__union' & GraphQLTypes["AppLinkUpsertResult"];
	['...on AppLinkListCreateResult']: '__union' & GraphQLTypes["AppLinkListCreateResult"];
	['...on AppLinkListDeleteResult']: '__union' & GraphQLTypes["AppLinkListDeleteResult"];
	['...on AppLinkListUpdateResult']: '__union' & GraphQLTypes["AppLinkListUpdateResult"];
	['...on AppLinkListUpsertResult']: '__union' & GraphQLTypes["AppLinkListUpsertResult"];
	['...on AppLinkItemCreateResult']: '__union' & GraphQLTypes["AppLinkItemCreateResult"];
	['...on AppLinkItemDeleteResult']: '__union' & GraphQLTypes["AppLinkItemDeleteResult"];
	['...on AppLinkItemUpdateResult']: '__union' & GraphQLTypes["AppLinkItemUpdateResult"];
	['...on AppLinkItemUpsertResult']: '__union' & GraphQLTypes["AppLinkItemUpsertResult"];
	['...on SocialSectionCreateResult']: '__union' & GraphQLTypes["SocialSectionCreateResult"];
	['...on SocialSectionDeleteResult']: '__union' & GraphQLTypes["SocialSectionDeleteResult"];
	['...on SocialSectionUpdateResult']: '__union' & GraphQLTypes["SocialSectionUpdateResult"];
	['...on SocialSectionUpsertResult']: '__union' & GraphQLTypes["SocialSectionUpsertResult"];
	['...on SocialLinkCreateResult']: '__union' & GraphQLTypes["SocialLinkCreateResult"];
	['...on SocialLinkDeleteResult']: '__union' & GraphQLTypes["SocialLinkDeleteResult"];
	['...on SocialLinkUpdateResult']: '__union' & GraphQLTypes["SocialLinkUpdateResult"];
	['...on SocialLinkUpsertResult']: '__union' & GraphQLTypes["SocialLinkUpsertResult"];
	['...on SocialLinkListCreateResult']: '__union' & GraphQLTypes["SocialLinkListCreateResult"];
	['...on SocialLinkListDeleteResult']: '__union' & GraphQLTypes["SocialLinkListDeleteResult"];
	['...on SocialLinkListUpdateResult']: '__union' & GraphQLTypes["SocialLinkListUpdateResult"];
	['...on SocialLinkListUpsertResult']: '__union' & GraphQLTypes["SocialLinkListUpsertResult"];
	['...on SocialLinkItemCreateResult']: '__union' & GraphQLTypes["SocialLinkItemCreateResult"];
	['...on SocialLinkItemDeleteResult']: '__union' & GraphQLTypes["SocialLinkItemDeleteResult"];
	['...on SocialLinkItemUpdateResult']: '__union' & GraphQLTypes["SocialLinkItemUpdateResult"];
	['...on SocialLinkItemUpsertResult']: '__union' & GraphQLTypes["SocialLinkItemUpsertResult"];
	['...on SharedContentCreateResult']: '__union' & GraphQLTypes["SharedContentCreateResult"];
	['...on SharedContentDeleteResult']: '__union' & GraphQLTypes["SharedContentDeleteResult"];
	['...on SharedContentUpdateResult']: '__union' & GraphQLTypes["SharedContentUpdateResult"];
	['...on SharedContentUpsertResult']: '__union' & GraphQLTypes["SharedContentUpsertResult"];
};
	["_MutationError"]: {
	__typename: "_MutationError",
	path: Array<GraphQLTypes["_PathFragment"]>,
	paths: Array<GraphQLTypes["_PathFragment"]>,
	type: GraphQLTypes["_MutationErrorType"],
	message?: string
};
	["_MutationErrorType"]: _MutationErrorType;
	["ArticleDeleteResult"]: {
	__typename: "ArticleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Article"]
};
	["ArticleUpdateResult"]: {
	__typename: "ArticleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Article"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArticleUpsertResult"]: {
	__typename: "ArticleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Article"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArticleAuthorCreateResult"]: {
	__typename: "ArticleAuthorCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArticleAuthor"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArticleAuthorDeleteResult"]: {
	__typename: "ArticleAuthorDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArticleAuthor"]
};
	["ArticleAuthorUpdateResult"]: {
	__typename: "ArticleAuthorUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArticleAuthor"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArticleAuthorUpsertResult"]: {
	__typename: "ArticleAuthorUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArticleAuthor"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AuthorCreateResult"]: {
	__typename: "AuthorCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Author"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AuthorDeleteResult"]: {
	__typename: "AuthorDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Author"]
};
	["AuthorUpdateResult"]: {
	__typename: "AuthorUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Author"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AuthorUpsertResult"]: {
	__typename: "AuthorUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Author"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AuthorTopArticleCreateResult"]: {
	__typename: "AuthorTopArticleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AuthorTopArticle"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AuthorTopArticleDeleteResult"]: {
	__typename: "AuthorTopArticleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AuthorTopArticle"]
};
	["AuthorTopArticleUpdateResult"]: {
	__typename: "AuthorTopArticleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AuthorTopArticle"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AuthorTopArticleUpsertResult"]: {
	__typename: "AuthorTopArticleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AuthorTopArticle"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentCreateResult"]: {
	__typename: "ContentCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentDeleteResult"]: {
	__typename: "ContentDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"]
};
	["ContentUpdateResult"]: {
	__typename: "ContentUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentUpsertResult"]: {
	__typename: "ContentUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentPartCreateResult"]: {
	__typename: "ContentPartCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentPart"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentPartDeleteResult"]: {
	__typename: "ContentPartDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentPart"]
};
	["ContentPartUpdateResult"]: {
	__typename: "ContentPartUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentPart"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentPartUpsertResult"]: {
	__typename: "ContentPartUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentPart"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceCreateResult"]: {
	__typename: "ContentReferenceCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceDeleteResult"]: {
	__typename: "ContentReferenceDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"]
};
	["ContentReferenceUpdateResult"]: {
	__typename: "ContentReferenceUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceUpsertResult"]: {
	__typename: "ContentReferenceUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomepageArticleCreateResult"]: {
	__typename: "HomepageArticleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomepageArticle"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomepageArticleDeleteResult"]: {
	__typename: "HomepageArticleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomepageArticle"]
};
	["HomepageArticleUpdateResult"]: {
	__typename: "HomepageArticleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomepageArticle"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomepageArticleUpsertResult"]: {
	__typename: "HomepageArticleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomepageArticle"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageCreateResult"]: {
	__typename: "ImageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageDeleteResult"]: {
	__typename: "ImageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"]
};
	["ImageUpdateResult"]: {
	__typename: "ImageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageUpsertResult"]: {
	__typename: "ImageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageUseCreateResult"]: {
	__typename: "ImageUseCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageUse"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageUseDeleteResult"]: {
	__typename: "ImageUseDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageUse"]
};
	["ImageUseUpdateResult"]: {
	__typename: "ImageUseUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageUse"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageUseUpsertResult"]: {
	__typename: "ImageUseUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageUse"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageTagCreateResult"]: {
	__typename: "ImageTagCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageTag"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageTagDeleteResult"]: {
	__typename: "ImageTagDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageTag"]
};
	["ImageTagUpdateResult"]: {
	__typename: "ImageTagUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageTag"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageTagUpsertResult"]: {
	__typename: "ImageTagUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageTag"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["IssueCreateResult"]: {
	__typename: "IssueCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Issue"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["IssueDeleteResult"]: {
	__typename: "IssueDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Issue"]
};
	["IssueUpdateResult"]: {
	__typename: "IssueUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Issue"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["IssueUpsertResult"]: {
	__typename: "IssueUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Issue"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["IssueArticleCreateResult"]: {
	__typename: "IssueArticleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IssueArticle"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["IssueArticleDeleteResult"]: {
	__typename: "IssueArticleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IssueArticle"]
};
	["IssueArticleUpdateResult"]: {
	__typename: "IssueArticleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IssueArticle"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["IssueArticleUpsertResult"]: {
	__typename: "IssueArticleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["IssueArticle"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkCreateResult"]: {
	__typename: "LinkCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkDeleteResult"]: {
	__typename: "LinkDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"]
};
	["LinkUpdateResult"]: {
	__typename: "LinkUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkUpsertResult"]: {
	__typename: "LinkUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextContentCreateResult"]: {
	__typename: "TextContentCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextContent"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextContentDeleteResult"]: {
	__typename: "TextContentDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextContent"]
};
	["TextContentUpdateResult"]: {
	__typename: "TextContentUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextContent"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextContentUpsertResult"]: {
	__typename: "TextContentUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextContent"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextContentPartCreateResult"]: {
	__typename: "TextContentPartCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextContentPart"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextContentPartDeleteResult"]: {
	__typename: "TextContentPartDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextContentPart"]
};
	["TextContentPartUpdateResult"]: {
	__typename: "TextContentPartUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextContentPart"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextContentPartUpsertResult"]: {
	__typename: "TextContentPartUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextContentPart"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextContentReferenceCreateResult"]: {
	__typename: "TextContentReferenceCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextContentReference"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextContentReferenceDeleteResult"]: {
	__typename: "TextContentReferenceDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextContentReference"]
};
	["TextContentReferenceUpdateResult"]: {
	__typename: "TextContentReferenceUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextContentReference"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextContentReferenceUpsertResult"]: {
	__typename: "TextContentReferenceUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextContentReference"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["UrlCreateResult"]: {
	__typename: "UrlCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Url"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["UrlDeleteResult"]: {
	__typename: "UrlDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Url"]
};
	["UrlUpdateResult"]: {
	__typename: "UrlUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Url"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["UrlUpsertResult"]: {
	__typename: "UrlUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Url"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArticleTagCreateResult"]: {
	__typename: "ArticleTagCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArticleTag"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArticleTagDeleteResult"]: {
	__typename: "ArticleTagDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArticleTag"]
};
	["ArticleTagUpdateResult"]: {
	__typename: "ArticleTagUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArticleTag"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArticleTagUpsertResult"]: {
	__typename: "ArticleTagUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArticleTag"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["CategoryCreateResult"]: {
	__typename: "CategoryCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Category"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["CategoryDeleteResult"]: {
	__typename: "CategoryDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Category"]
};
	["CategoryUpdateResult"]: {
	__typename: "CategoryUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Category"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["CategoryUpsertResult"]: {
	__typename: "CategoryUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Category"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArticleCategoryCreateResult"]: {
	__typename: "ArticleCategoryCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArticleCategory"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArticleCategoryDeleteResult"]: {
	__typename: "ArticleCategoryDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArticleCategory"]
};
	["ArticleCategoryUpdateResult"]: {
	__typename: "ArticleCategoryUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArticleCategory"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArticleCategoryUpsertResult"]: {
	__typename: "ArticleCategoryUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArticleCategory"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AudioCreateResult"]: {
	__typename: "AudioCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Audio"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AudioDeleteResult"]: {
	__typename: "AudioDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Audio"]
};
	["AudioUpdateResult"]: {
	__typename: "AudioUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Audio"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AudioUpsertResult"]: {
	__typename: "AudioUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Audio"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AudioUseCreateResult"]: {
	__typename: "AudioUseCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AudioUse"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AudioUseDeleteResult"]: {
	__typename: "AudioUseDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AudioUse"]
};
	["AudioUseUpdateResult"]: {
	__typename: "AudioUseUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AudioUse"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AudioUseUpsertResult"]: {
	__typename: "AudioUseUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AudioUse"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EmbedCreateResult"]: {
	__typename: "EmbedCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Embed"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EmbedDeleteResult"]: {
	__typename: "EmbedDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Embed"]
};
	["EmbedUpdateResult"]: {
	__typename: "EmbedUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Embed"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EmbedUpsertResult"]: {
	__typename: "EmbedUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Embed"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageContentCreateResult"]: {
	__typename: "ImageContentCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageContent"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageContentDeleteResult"]: {
	__typename: "ImageContentDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageContent"]
};
	["ImageContentUpdateResult"]: {
	__typename: "ImageContentUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageContent"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageContentUpsertResult"]: {
	__typename: "ImageContentUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageContent"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ListicleCreateResult"]: {
	__typename: "ListicleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Listicle"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ListicleDeleteResult"]: {
	__typename: "ListicleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Listicle"]
};
	["ListicleUpdateResult"]: {
	__typename: "ListicleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Listicle"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ListicleUpsertResult"]: {
	__typename: "ListicleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Listicle"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PollAnswerCreateResult"]: {
	__typename: "PollAnswerCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PollAnswer"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PollAnswerDeleteResult"]: {
	__typename: "PollAnswerDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PollAnswer"]
};
	["PollAnswerUpdateResult"]: {
	__typename: "PollAnswerUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PollAnswer"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PollAnswerUpsertResult"]: {
	__typename: "PollAnswerUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PollAnswer"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TagCreateResult"]: {
	__typename: "TagCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Tag"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TagDeleteResult"]: {
	__typename: "TagDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Tag"]
};
	["TagUpdateResult"]: {
	__typename: "TagUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Tag"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TagUpsertResult"]: {
	__typename: "TagUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Tag"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FAQCreateResult"]: {
	__typename: "FAQCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FAQ"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FAQDeleteResult"]: {
	__typename: "FAQDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FAQ"]
};
	["FAQUpdateResult"]: {
	__typename: "FAQUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FAQ"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FAQUpsertResult"]: {
	__typename: "FAQUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FAQ"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkContentCreateResult"]: {
	__typename: "LinkContentCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkContent"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkContentDeleteResult"]: {
	__typename: "LinkContentDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkContent"]
};
	["LinkContentUpdateResult"]: {
	__typename: "LinkContentUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkContent"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkContentUpsertResult"]: {
	__typename: "LinkContentUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkContent"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AwardContentCreateResult"]: {
	__typename: "AwardContentCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AwardContent"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AwardContentDeleteResult"]: {
	__typename: "AwardContentDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AwardContent"]
};
	["AwardContentUpdateResult"]: {
	__typename: "AwardContentUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AwardContent"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AwardContentUpsertResult"]: {
	__typename: "AwardContentUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AwardContent"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ReviewContentCreateResult"]: {
	__typename: "ReviewContentCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ReviewContent"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ReviewContentDeleteResult"]: {
	__typename: "ReviewContentDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ReviewContent"]
};
	["ReviewContentUpdateResult"]: {
	__typename: "ReviewContentUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ReviewContent"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ReviewContentUpsertResult"]: {
	__typename: "ReviewContentUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ReviewContent"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PageCreateResult"]: {
	__typename: "PageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Page"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PageDeleteResult"]: {
	__typename: "PageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Page"]
};
	["PageUpdateResult"]: {
	__typename: "PageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Page"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PageUpsertResult"]: {
	__typename: "PageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Page"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextTranslationCreateResult"]: {
	__typename: "TextTranslationCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextTranslation"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextTranslationDeleteResult"]: {
	__typename: "TextTranslationDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextTranslation"]
};
	["TextTranslationUpdateResult"]: {
	__typename: "TextTranslationUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextTranslation"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TextTranslationUpsertResult"]: {
	__typename: "TextTranslationUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TextTranslation"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoCreateResult"]: {
	__typename: "SeoCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoDeleteResult"]: {
	__typename: "SeoDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"]
};
	["SeoUpdateResult"]: {
	__typename: "SeoUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoUpsertResult"]: {
	__typename: "SeoUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FileCreateResult"]: {
	__typename: "FileCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["File"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FileDeleteResult"]: {
	__typename: "FileDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["File"]
};
	["FileUpdateResult"]: {
	__typename: "FileUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["File"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FileUpsertResult"]: {
	__typename: "FileUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["File"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FileUseCreateResult"]: {
	__typename: "FileUseCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FileUse"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FileUseDeleteResult"]: {
	__typename: "FileUseDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FileUse"]
};
	["FileUseUpdateResult"]: {
	__typename: "FileUseUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FileUse"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FileUseUpsertResult"]: {
	__typename: "FileUseUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FileUse"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockCreateResult"]: {
	__typename: "ContentBlockCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockDeleteResult"]: {
	__typename: "ContentBlockDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"]
};
	["ContentBlockUpdateResult"]: {
	__typename: "ContentBlockUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockUpsertResult"]: {
	__typename: "ContentBlockUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentArticleCreateResult"]: {
	__typename: "ContentArticleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentArticle"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentArticleDeleteResult"]: {
	__typename: "ContentArticleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentArticle"]
};
	["ContentArticleUpdateResult"]: {
	__typename: "ContentArticleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentArticle"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentArticleUpsertResult"]: {
	__typename: "ContentArticleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentArticle"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["UnlockedArticleCreateResult"]: {
	__typename: "UnlockedArticleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UnlockedArticle"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["UnlockedArticleDeleteResult"]: {
	__typename: "UnlockedArticleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UnlockedArticle"]
};
	["UnlockedArticleUpdateResult"]: {
	__typename: "UnlockedArticleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UnlockedArticle"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["UnlockedArticleUpsertResult"]: {
	__typename: "UnlockedArticleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["UnlockedArticle"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserCreateResult"]: {
	__typename: "UserCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["User"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserDeleteResult"]: {
	__typename: "UserDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["User"]
};
	["UserUpdateResult"]: {
	__typename: "UserUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["User"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["UserUpsertResult"]: {
	__typename: "UserUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["User"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NotificationCreateResult"]: {
	__typename: "NotificationCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Notification"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NotificationDeleteResult"]: {
	__typename: "NotificationDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Notification"]
};
	["NotificationUpdateResult"]: {
	__typename: "NotificationUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Notification"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NotificationUpsertResult"]: {
	__typename: "NotificationUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Notification"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AppReviewCreateResult"]: {
	__typename: "AppReviewCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AppReview"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AppReviewDeleteResult"]: {
	__typename: "AppReviewDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AppReview"]
};
	["AppReviewUpdateResult"]: {
	__typename: "AppReviewUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AppReview"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AppReviewUpsertResult"]: {
	__typename: "AppReviewUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AppReview"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductCreateResult"]: {
	__typename: "ProductCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Product"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductDeleteResult"]: {
	__typename: "ProductDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Product"]
};
	["ProductUpdateResult"]: {
	__typename: "ProductUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Product"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ProductUpsertResult"]: {
	__typename: "ProductUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Product"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SubscriptionFormCreateResult"]: {
	__typename: "SubscriptionFormCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubscriptionForm"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SubscriptionFormDeleteResult"]: {
	__typename: "SubscriptionFormDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubscriptionForm"]
};
	["SubscriptionFormUpdateResult"]: {
	__typename: "SubscriptionFormUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubscriptionForm"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SubscriptionFormUpsertResult"]: {
	__typename: "SubscriptionFormUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubscriptionForm"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SubscriptionFormSectionCreateResult"]: {
	__typename: "SubscriptionFormSectionCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubscriptionFormSection"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SubscriptionFormSectionDeleteResult"]: {
	__typename: "SubscriptionFormSectionDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubscriptionFormSection"]
};
	["SubscriptionFormSectionUpdateResult"]: {
	__typename: "SubscriptionFormSectionUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubscriptionFormSection"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SubscriptionFormSectionUpsertResult"]: {
	__typename: "SubscriptionFormSectionUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubscriptionFormSection"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SubscriptionFormInputCreateResult"]: {
	__typename: "SubscriptionFormInputCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubscriptionFormInput"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SubscriptionFormInputDeleteResult"]: {
	__typename: "SubscriptionFormInputDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubscriptionFormInput"]
};
	["SubscriptionFormInputUpdateResult"]: {
	__typename: "SubscriptionFormInputUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubscriptionFormInput"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SubscriptionFormInputUpsertResult"]: {
	__typename: "SubscriptionFormInputUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubscriptionFormInput"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SubscriptionFormOptionCreateResult"]: {
	__typename: "SubscriptionFormOptionCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubscriptionFormOption"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SubscriptionFormOptionDeleteResult"]: {
	__typename: "SubscriptionFormOptionDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubscriptionFormOption"]
};
	["SubscriptionFormOptionUpdateResult"]: {
	__typename: "SubscriptionFormOptionUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubscriptionFormOption"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SubscriptionFormOptionUpsertResult"]: {
	__typename: "SubscriptionFormOptionUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubscriptionFormOption"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ButtonCreateResult"]: {
	__typename: "ButtonCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Button"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ButtonDeleteResult"]: {
	__typename: "ButtonDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Button"]
};
	["ButtonUpdateResult"]: {
	__typename: "ButtonUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Button"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ButtonUpsertResult"]: {
	__typename: "ButtonUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Button"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArticleHistoryTagCreateResult"]: {
	__typename: "ArticleHistoryTagCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArticleHistoryTag"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArticleHistoryTagDeleteResult"]: {
	__typename: "ArticleHistoryTagDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArticleHistoryTag"]
};
	["ArticleHistoryTagUpdateResult"]: {
	__typename: "ArticleHistoryTagUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArticleHistoryTag"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArticleHistoryTagUpsertResult"]: {
	__typename: "ArticleHistoryTagUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArticleHistoryTag"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArticleHistoryPeriodCreateResult"]: {
	__typename: "ArticleHistoryPeriodCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArticleHistoryPeriod"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArticleHistoryPeriodDeleteResult"]: {
	__typename: "ArticleHistoryPeriodDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArticleHistoryPeriod"]
};
	["ArticleHistoryPeriodUpdateResult"]: {
	__typename: "ArticleHistoryPeriodUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArticleHistoryPeriod"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArticleHistoryPeriodUpsertResult"]: {
	__typename: "ArticleHistoryPeriodUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArticleHistoryPeriod"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HistoryTagCreateResult"]: {
	__typename: "HistoryTagCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HistoryTag"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HistoryTagDeleteResult"]: {
	__typename: "HistoryTagDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HistoryTag"]
};
	["HistoryTagUpdateResult"]: {
	__typename: "HistoryTagUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HistoryTag"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HistoryTagUpsertResult"]: {
	__typename: "HistoryTagUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HistoryTag"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HistoryPeriodCreateResult"]: {
	__typename: "HistoryPeriodCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HistoryPeriod"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HistoryPeriodDeleteResult"]: {
	__typename: "HistoryPeriodDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HistoryPeriod"]
};
	["HistoryPeriodUpdateResult"]: {
	__typename: "HistoryPeriodUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HistoryPeriod"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HistoryPeriodUpsertResult"]: {
	__typename: "HistoryPeriodUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HistoryPeriod"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HistoryHomePageCreateResult"]: {
	__typename: "HistoryHomePageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HistoryHomePage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HistoryHomePageDeleteResult"]: {
	__typename: "HistoryHomePageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HistoryHomePage"]
};
	["HistoryHomePageUpdateResult"]: {
	__typename: "HistoryHomePageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HistoryHomePage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HistoryHomePageUpsertResult"]: {
	__typename: "HistoryHomePageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HistoryHomePage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HistoryCoverCreateResult"]: {
	__typename: "HistoryCoverCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HistoryCover"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HistoryCoverDeleteResult"]: {
	__typename: "HistoryCoverDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HistoryCover"]
};
	["HistoryCoverUpdateResult"]: {
	__typename: "HistoryCoverUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HistoryCover"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HistoryCoverUpsertResult"]: {
	__typename: "HistoryCoverUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HistoryCover"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HistoryTextListCreateResult"]: {
	__typename: "HistoryTextListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HistoryTextList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HistoryTextListDeleteResult"]: {
	__typename: "HistoryTextListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HistoryTextList"]
};
	["HistoryTextListUpdateResult"]: {
	__typename: "HistoryTextListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HistoryTextList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HistoryTextListUpsertResult"]: {
	__typename: "HistoryTextListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HistoryTextList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HistoryTextItemCreateResult"]: {
	__typename: "HistoryTextItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HistoryTextItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HistoryTextItemDeleteResult"]: {
	__typename: "HistoryTextItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HistoryTextItem"]
};
	["HistoryTextItemUpdateResult"]: {
	__typename: "HistoryTextItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HistoryTextItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HistoryTextItemUpsertResult"]: {
	__typename: "HistoryTextItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HistoryTextItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterMenuCreateResult"]: {
	__typename: "FooterMenuCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterMenu"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterMenuDeleteResult"]: {
	__typename: "FooterMenuDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterMenu"]
};
	["FooterMenuUpdateResult"]: {
	__typename: "FooterMenuUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterMenu"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterMenuUpsertResult"]: {
	__typename: "FooterMenuUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterMenu"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkSectionCreateResult"]: {
	__typename: "LinkSectionCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkSection"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkSectionDeleteResult"]: {
	__typename: "LinkSectionDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkSection"]
};
	["LinkSectionUpdateResult"]: {
	__typename: "LinkSectionUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkSection"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkSectionUpsertResult"]: {
	__typename: "LinkSectionUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkSection"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkListCreateResult"]: {
	__typename: "LinkListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkListDeleteResult"]: {
	__typename: "LinkListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkList"]
};
	["LinkListUpdateResult"]: {
	__typename: "LinkListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkListUpsertResult"]: {
	__typename: "LinkListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkItemCreateResult"]: {
	__typename: "LinkItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkItemDeleteResult"]: {
	__typename: "LinkItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkItem"]
};
	["LinkItemUpdateResult"]: {
	__typename: "LinkItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkItemUpsertResult"]: {
	__typename: "LinkItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NewsletterSectionCreateResult"]: {
	__typename: "NewsletterSectionCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NewsletterSection"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NewsletterSectionDeleteResult"]: {
	__typename: "NewsletterSectionDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NewsletterSection"]
};
	["NewsletterSectionUpdateResult"]: {
	__typename: "NewsletterSectionUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NewsletterSection"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NewsletterSectionUpsertResult"]: {
	__typename: "NewsletterSectionUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NewsletterSection"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NewsletterCreateResult"]: {
	__typename: "NewsletterCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Newsletter"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NewsletterDeleteResult"]: {
	__typename: "NewsletterDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Newsletter"]
};
	["NewsletterUpdateResult"]: {
	__typename: "NewsletterUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Newsletter"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NewsletterUpsertResult"]: {
	__typename: "NewsletterUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Newsletter"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["OnlineSectionCreateResult"]: {
	__typename: "OnlineSectionCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OnlineSection"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["OnlineSectionDeleteResult"]: {
	__typename: "OnlineSectionDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OnlineSection"]
};
	["OnlineSectionUpdateResult"]: {
	__typename: "OnlineSectionUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OnlineSection"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["OnlineSectionUpsertResult"]: {
	__typename: "OnlineSectionUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["OnlineSection"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AppLinkCreateResult"]: {
	__typename: "AppLinkCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AppLink"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AppLinkDeleteResult"]: {
	__typename: "AppLinkDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AppLink"]
};
	["AppLinkUpdateResult"]: {
	__typename: "AppLinkUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AppLink"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AppLinkUpsertResult"]: {
	__typename: "AppLinkUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AppLink"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AppLinkListCreateResult"]: {
	__typename: "AppLinkListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AppLinkList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AppLinkListDeleteResult"]: {
	__typename: "AppLinkListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AppLinkList"]
};
	["AppLinkListUpdateResult"]: {
	__typename: "AppLinkListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AppLinkList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AppLinkListUpsertResult"]: {
	__typename: "AppLinkListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AppLinkList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AppLinkItemCreateResult"]: {
	__typename: "AppLinkItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AppLinkItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AppLinkItemDeleteResult"]: {
	__typename: "AppLinkItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AppLinkItem"]
};
	["AppLinkItemUpdateResult"]: {
	__typename: "AppLinkItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AppLinkItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["AppLinkItemUpsertResult"]: {
	__typename: "AppLinkItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["AppLinkItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialSectionCreateResult"]: {
	__typename: "SocialSectionCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialSection"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialSectionDeleteResult"]: {
	__typename: "SocialSectionDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialSection"]
};
	["SocialSectionUpdateResult"]: {
	__typename: "SocialSectionUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialSection"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialSectionUpsertResult"]: {
	__typename: "SocialSectionUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialSection"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialLinkCreateResult"]: {
	__typename: "SocialLinkCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLink"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialLinkDeleteResult"]: {
	__typename: "SocialLinkDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLink"]
};
	["SocialLinkUpdateResult"]: {
	__typename: "SocialLinkUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLink"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialLinkUpsertResult"]: {
	__typename: "SocialLinkUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLink"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialLinkListCreateResult"]: {
	__typename: "SocialLinkListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLinkList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialLinkListDeleteResult"]: {
	__typename: "SocialLinkListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLinkList"]
};
	["SocialLinkListUpdateResult"]: {
	__typename: "SocialLinkListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLinkList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialLinkListUpsertResult"]: {
	__typename: "SocialLinkListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLinkList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialLinkItemCreateResult"]: {
	__typename: "SocialLinkItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLinkItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialLinkItemDeleteResult"]: {
	__typename: "SocialLinkItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLinkItem"]
};
	["SocialLinkItemUpdateResult"]: {
	__typename: "SocialLinkItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLinkItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialLinkItemUpsertResult"]: {
	__typename: "SocialLinkItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLinkItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SharedContentCreateResult"]: {
	__typename: "SharedContentCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SharedContent"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SharedContentDeleteResult"]: {
	__typename: "SharedContentDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SharedContent"]
};
	["SharedContentUpdateResult"]: {
	__typename: "SharedContentUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SharedContent"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SharedContentUpsertResult"]: {
	__typename: "SharedContentUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SharedContent"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MutationTransaction"]: {
	__typename: "MutationTransaction",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	validation: GraphQLTypes["_ValidationResult"],
	createArticle: GraphQLTypes["ArticleCreateResult"],
	deleteArticle: GraphQLTypes["ArticleDeleteResult"],
	updateArticle: GraphQLTypes["ArticleUpdateResult"],
	upsertArticle: GraphQLTypes["ArticleUpsertResult"],
	createArticleAuthor: GraphQLTypes["ArticleAuthorCreateResult"],
	deleteArticleAuthor: GraphQLTypes["ArticleAuthorDeleteResult"],
	updateArticleAuthor: GraphQLTypes["ArticleAuthorUpdateResult"],
	upsertArticleAuthor: GraphQLTypes["ArticleAuthorUpsertResult"],
	createAuthor: GraphQLTypes["AuthorCreateResult"],
	deleteAuthor: GraphQLTypes["AuthorDeleteResult"],
	updateAuthor: GraphQLTypes["AuthorUpdateResult"],
	upsertAuthor: GraphQLTypes["AuthorUpsertResult"],
	createAuthorTopArticle: GraphQLTypes["AuthorTopArticleCreateResult"],
	deleteAuthorTopArticle: GraphQLTypes["AuthorTopArticleDeleteResult"],
	updateAuthorTopArticle: GraphQLTypes["AuthorTopArticleUpdateResult"],
	upsertAuthorTopArticle: GraphQLTypes["AuthorTopArticleUpsertResult"],
	createContent: GraphQLTypes["ContentCreateResult"],
	deleteContent: GraphQLTypes["ContentDeleteResult"],
	updateContent: GraphQLTypes["ContentUpdateResult"],
	upsertContent: GraphQLTypes["ContentUpsertResult"],
	createContentPart: GraphQLTypes["ContentPartCreateResult"],
	deleteContentPart: GraphQLTypes["ContentPartDeleteResult"],
	updateContentPart: GraphQLTypes["ContentPartUpdateResult"],
	upsertContentPart: GraphQLTypes["ContentPartUpsertResult"],
	createContentReference: GraphQLTypes["ContentReferenceCreateResult"],
	deleteContentReference: GraphQLTypes["ContentReferenceDeleteResult"],
	updateContentReference: GraphQLTypes["ContentReferenceUpdateResult"],
	upsertContentReference: GraphQLTypes["ContentReferenceUpsertResult"],
	createHomepageArticle: GraphQLTypes["HomepageArticleCreateResult"],
	deleteHomepageArticle: GraphQLTypes["HomepageArticleDeleteResult"],
	updateHomepageArticle: GraphQLTypes["HomepageArticleUpdateResult"],
	upsertHomepageArticle: GraphQLTypes["HomepageArticleUpsertResult"],
	createImage: GraphQLTypes["ImageCreateResult"],
	deleteImage: GraphQLTypes["ImageDeleteResult"],
	updateImage: GraphQLTypes["ImageUpdateResult"],
	upsertImage: GraphQLTypes["ImageUpsertResult"],
	createImageUse: GraphQLTypes["ImageUseCreateResult"],
	deleteImageUse: GraphQLTypes["ImageUseDeleteResult"],
	updateImageUse: GraphQLTypes["ImageUseUpdateResult"],
	upsertImageUse: GraphQLTypes["ImageUseUpsertResult"],
	createImageTag: GraphQLTypes["ImageTagCreateResult"],
	deleteImageTag: GraphQLTypes["ImageTagDeleteResult"],
	updateImageTag: GraphQLTypes["ImageTagUpdateResult"],
	upsertImageTag: GraphQLTypes["ImageTagUpsertResult"],
	createIssue: GraphQLTypes["IssueCreateResult"],
	deleteIssue: GraphQLTypes["IssueDeleteResult"],
	updateIssue: GraphQLTypes["IssueUpdateResult"],
	upsertIssue: GraphQLTypes["IssueUpsertResult"],
	createIssueArticle: GraphQLTypes["IssueArticleCreateResult"],
	deleteIssueArticle: GraphQLTypes["IssueArticleDeleteResult"],
	updateIssueArticle: GraphQLTypes["IssueArticleUpdateResult"],
	upsertIssueArticle: GraphQLTypes["IssueArticleUpsertResult"],
	createLink: GraphQLTypes["LinkCreateResult"],
	deleteLink: GraphQLTypes["LinkDeleteResult"],
	updateLink: GraphQLTypes["LinkUpdateResult"],
	upsertLink: GraphQLTypes["LinkUpsertResult"],
	createTextContent: GraphQLTypes["TextContentCreateResult"],
	deleteTextContent: GraphQLTypes["TextContentDeleteResult"],
	updateTextContent: GraphQLTypes["TextContentUpdateResult"],
	upsertTextContent: GraphQLTypes["TextContentUpsertResult"],
	createTextContentPart: GraphQLTypes["TextContentPartCreateResult"],
	deleteTextContentPart: GraphQLTypes["TextContentPartDeleteResult"],
	updateTextContentPart: GraphQLTypes["TextContentPartUpdateResult"],
	upsertTextContentPart: GraphQLTypes["TextContentPartUpsertResult"],
	createTextContentReference: GraphQLTypes["TextContentReferenceCreateResult"],
	deleteTextContentReference: GraphQLTypes["TextContentReferenceDeleteResult"],
	updateTextContentReference: GraphQLTypes["TextContentReferenceUpdateResult"],
	upsertTextContentReference: GraphQLTypes["TextContentReferenceUpsertResult"],
	createUrl: GraphQLTypes["UrlCreateResult"],
	deleteUrl: GraphQLTypes["UrlDeleteResult"],
	updateUrl: GraphQLTypes["UrlUpdateResult"],
	upsertUrl: GraphQLTypes["UrlUpsertResult"],
	createArticleTag: GraphQLTypes["ArticleTagCreateResult"],
	deleteArticleTag: GraphQLTypes["ArticleTagDeleteResult"],
	updateArticleTag: GraphQLTypes["ArticleTagUpdateResult"],
	upsertArticleTag: GraphQLTypes["ArticleTagUpsertResult"],
	createCategory: GraphQLTypes["CategoryCreateResult"],
	deleteCategory: GraphQLTypes["CategoryDeleteResult"],
	updateCategory: GraphQLTypes["CategoryUpdateResult"],
	upsertCategory: GraphQLTypes["CategoryUpsertResult"],
	createArticleCategory: GraphQLTypes["ArticleCategoryCreateResult"],
	deleteArticleCategory: GraphQLTypes["ArticleCategoryDeleteResult"],
	updateArticleCategory: GraphQLTypes["ArticleCategoryUpdateResult"],
	upsertArticleCategory: GraphQLTypes["ArticleCategoryUpsertResult"],
	createAudio: GraphQLTypes["AudioCreateResult"],
	deleteAudio: GraphQLTypes["AudioDeleteResult"],
	updateAudio: GraphQLTypes["AudioUpdateResult"],
	upsertAudio: GraphQLTypes["AudioUpsertResult"],
	createAudioUse: GraphQLTypes["AudioUseCreateResult"],
	deleteAudioUse: GraphQLTypes["AudioUseDeleteResult"],
	updateAudioUse: GraphQLTypes["AudioUseUpdateResult"],
	upsertAudioUse: GraphQLTypes["AudioUseUpsertResult"],
	createEmbed: GraphQLTypes["EmbedCreateResult"],
	deleteEmbed: GraphQLTypes["EmbedDeleteResult"],
	updateEmbed: GraphQLTypes["EmbedUpdateResult"],
	upsertEmbed: GraphQLTypes["EmbedUpsertResult"],
	createImageContent: GraphQLTypes["ImageContentCreateResult"],
	deleteImageContent: GraphQLTypes["ImageContentDeleteResult"],
	updateImageContent: GraphQLTypes["ImageContentUpdateResult"],
	upsertImageContent: GraphQLTypes["ImageContentUpsertResult"],
	createListicle: GraphQLTypes["ListicleCreateResult"],
	deleteListicle: GraphQLTypes["ListicleDeleteResult"],
	updateListicle: GraphQLTypes["ListicleUpdateResult"],
	upsertListicle: GraphQLTypes["ListicleUpsertResult"],
	createPollAnswer: GraphQLTypes["PollAnswerCreateResult"],
	deletePollAnswer: GraphQLTypes["PollAnswerDeleteResult"],
	updatePollAnswer: GraphQLTypes["PollAnswerUpdateResult"],
	upsertPollAnswer: GraphQLTypes["PollAnswerUpsertResult"],
	createTag: GraphQLTypes["TagCreateResult"],
	deleteTag: GraphQLTypes["TagDeleteResult"],
	updateTag: GraphQLTypes["TagUpdateResult"],
	upsertTag: GraphQLTypes["TagUpsertResult"],
	createFAQ: GraphQLTypes["FAQCreateResult"],
	deleteFAQ: GraphQLTypes["FAQDeleteResult"],
	updateFAQ: GraphQLTypes["FAQUpdateResult"],
	upsertFAQ: GraphQLTypes["FAQUpsertResult"],
	createLinkContent: GraphQLTypes["LinkContentCreateResult"],
	deleteLinkContent: GraphQLTypes["LinkContentDeleteResult"],
	updateLinkContent: GraphQLTypes["LinkContentUpdateResult"],
	upsertLinkContent: GraphQLTypes["LinkContentUpsertResult"],
	createAwardContent: GraphQLTypes["AwardContentCreateResult"],
	deleteAwardContent: GraphQLTypes["AwardContentDeleteResult"],
	updateAwardContent: GraphQLTypes["AwardContentUpdateResult"],
	upsertAwardContent: GraphQLTypes["AwardContentUpsertResult"],
	createReviewContent: GraphQLTypes["ReviewContentCreateResult"],
	deleteReviewContent: GraphQLTypes["ReviewContentDeleteResult"],
	updateReviewContent: GraphQLTypes["ReviewContentUpdateResult"],
	upsertReviewContent: GraphQLTypes["ReviewContentUpsertResult"],
	createPage: GraphQLTypes["PageCreateResult"],
	deletePage: GraphQLTypes["PageDeleteResult"],
	updatePage: GraphQLTypes["PageUpdateResult"],
	upsertPage: GraphQLTypes["PageUpsertResult"],
	createTextTranslation: GraphQLTypes["TextTranslationCreateResult"],
	deleteTextTranslation: GraphQLTypes["TextTranslationDeleteResult"],
	updateTextTranslation: GraphQLTypes["TextTranslationUpdateResult"],
	upsertTextTranslation: GraphQLTypes["TextTranslationUpsertResult"],
	createSeo: GraphQLTypes["SeoCreateResult"],
	deleteSeo: GraphQLTypes["SeoDeleteResult"],
	updateSeo: GraphQLTypes["SeoUpdateResult"],
	upsertSeo: GraphQLTypes["SeoUpsertResult"],
	createFile: GraphQLTypes["FileCreateResult"],
	deleteFile: GraphQLTypes["FileDeleteResult"],
	updateFile: GraphQLTypes["FileUpdateResult"],
	upsertFile: GraphQLTypes["FileUpsertResult"],
	createFileUse: GraphQLTypes["FileUseCreateResult"],
	deleteFileUse: GraphQLTypes["FileUseDeleteResult"],
	updateFileUse: GraphQLTypes["FileUseUpdateResult"],
	upsertFileUse: GraphQLTypes["FileUseUpsertResult"],
	createContentBlock: GraphQLTypes["ContentBlockCreateResult"],
	deleteContentBlock: GraphQLTypes["ContentBlockDeleteResult"],
	updateContentBlock: GraphQLTypes["ContentBlockUpdateResult"],
	upsertContentBlock: GraphQLTypes["ContentBlockUpsertResult"],
	createContentArticle: GraphQLTypes["ContentArticleCreateResult"],
	deleteContentArticle: GraphQLTypes["ContentArticleDeleteResult"],
	updateContentArticle: GraphQLTypes["ContentArticleUpdateResult"],
	upsertContentArticle: GraphQLTypes["ContentArticleUpsertResult"],
	createUnlockedArticle: GraphQLTypes["UnlockedArticleCreateResult"],
	deleteUnlockedArticle: GraphQLTypes["UnlockedArticleDeleteResult"],
	updateUnlockedArticle: GraphQLTypes["UnlockedArticleUpdateResult"],
	upsertUnlockedArticle: GraphQLTypes["UnlockedArticleUpsertResult"],
	createUser: GraphQLTypes["UserCreateResult"],
	deleteUser: GraphQLTypes["UserDeleteResult"],
	updateUser: GraphQLTypes["UserUpdateResult"],
	upsertUser: GraphQLTypes["UserUpsertResult"],
	createNotification: GraphQLTypes["NotificationCreateResult"],
	deleteNotification: GraphQLTypes["NotificationDeleteResult"],
	updateNotification: GraphQLTypes["NotificationUpdateResult"],
	upsertNotification: GraphQLTypes["NotificationUpsertResult"],
	createAppReview: GraphQLTypes["AppReviewCreateResult"],
	deleteAppReview: GraphQLTypes["AppReviewDeleteResult"],
	updateAppReview: GraphQLTypes["AppReviewUpdateResult"],
	upsertAppReview: GraphQLTypes["AppReviewUpsertResult"],
	createProduct: GraphQLTypes["ProductCreateResult"],
	deleteProduct: GraphQLTypes["ProductDeleteResult"],
	updateProduct: GraphQLTypes["ProductUpdateResult"],
	upsertProduct: GraphQLTypes["ProductUpsertResult"],
	createSubscriptionForm: GraphQLTypes["SubscriptionFormCreateResult"],
	deleteSubscriptionForm: GraphQLTypes["SubscriptionFormDeleteResult"],
	updateSubscriptionForm: GraphQLTypes["SubscriptionFormUpdateResult"],
	upsertSubscriptionForm: GraphQLTypes["SubscriptionFormUpsertResult"],
	createSubscriptionFormSection: GraphQLTypes["SubscriptionFormSectionCreateResult"],
	deleteSubscriptionFormSection: GraphQLTypes["SubscriptionFormSectionDeleteResult"],
	updateSubscriptionFormSection: GraphQLTypes["SubscriptionFormSectionUpdateResult"],
	upsertSubscriptionFormSection: GraphQLTypes["SubscriptionFormSectionUpsertResult"],
	createSubscriptionFormInput: GraphQLTypes["SubscriptionFormInputCreateResult"],
	deleteSubscriptionFormInput: GraphQLTypes["SubscriptionFormInputDeleteResult"],
	updateSubscriptionFormInput: GraphQLTypes["SubscriptionFormInputUpdateResult"],
	upsertSubscriptionFormInput: GraphQLTypes["SubscriptionFormInputUpsertResult"],
	createSubscriptionFormOption: GraphQLTypes["SubscriptionFormOptionCreateResult"],
	deleteSubscriptionFormOption: GraphQLTypes["SubscriptionFormOptionDeleteResult"],
	updateSubscriptionFormOption: GraphQLTypes["SubscriptionFormOptionUpdateResult"],
	upsertSubscriptionFormOption: GraphQLTypes["SubscriptionFormOptionUpsertResult"],
	createButton: GraphQLTypes["ButtonCreateResult"],
	deleteButton: GraphQLTypes["ButtonDeleteResult"],
	updateButton: GraphQLTypes["ButtonUpdateResult"],
	upsertButton: GraphQLTypes["ButtonUpsertResult"],
	createArticleHistoryTag: GraphQLTypes["ArticleHistoryTagCreateResult"],
	deleteArticleHistoryTag: GraphQLTypes["ArticleHistoryTagDeleteResult"],
	updateArticleHistoryTag: GraphQLTypes["ArticleHistoryTagUpdateResult"],
	upsertArticleHistoryTag: GraphQLTypes["ArticleHistoryTagUpsertResult"],
	createArticleHistoryPeriod: GraphQLTypes["ArticleHistoryPeriodCreateResult"],
	deleteArticleHistoryPeriod: GraphQLTypes["ArticleHistoryPeriodDeleteResult"],
	updateArticleHistoryPeriod: GraphQLTypes["ArticleHistoryPeriodUpdateResult"],
	upsertArticleHistoryPeriod: GraphQLTypes["ArticleHistoryPeriodUpsertResult"],
	createHistoryTag: GraphQLTypes["HistoryTagCreateResult"],
	deleteHistoryTag: GraphQLTypes["HistoryTagDeleteResult"],
	updateHistoryTag: GraphQLTypes["HistoryTagUpdateResult"],
	upsertHistoryTag: GraphQLTypes["HistoryTagUpsertResult"],
	createHistoryPeriod: GraphQLTypes["HistoryPeriodCreateResult"],
	deleteHistoryPeriod: GraphQLTypes["HistoryPeriodDeleteResult"],
	updateHistoryPeriod: GraphQLTypes["HistoryPeriodUpdateResult"],
	upsertHistoryPeriod: GraphQLTypes["HistoryPeriodUpsertResult"],
	createHistoryHomePage: GraphQLTypes["HistoryHomePageCreateResult"],
	deleteHistoryHomePage: GraphQLTypes["HistoryHomePageDeleteResult"],
	updateHistoryHomePage: GraphQLTypes["HistoryHomePageUpdateResult"],
	upsertHistoryHomePage: GraphQLTypes["HistoryHomePageUpsertResult"],
	createHistoryCover: GraphQLTypes["HistoryCoverCreateResult"],
	deleteHistoryCover: GraphQLTypes["HistoryCoverDeleteResult"],
	updateHistoryCover: GraphQLTypes["HistoryCoverUpdateResult"],
	upsertHistoryCover: GraphQLTypes["HistoryCoverUpsertResult"],
	createHistoryTextList: GraphQLTypes["HistoryTextListCreateResult"],
	deleteHistoryTextList: GraphQLTypes["HistoryTextListDeleteResult"],
	updateHistoryTextList: GraphQLTypes["HistoryTextListUpdateResult"],
	upsertHistoryTextList: GraphQLTypes["HistoryTextListUpsertResult"],
	createHistoryTextItem: GraphQLTypes["HistoryTextItemCreateResult"],
	deleteHistoryTextItem: GraphQLTypes["HistoryTextItemDeleteResult"],
	updateHistoryTextItem: GraphQLTypes["HistoryTextItemUpdateResult"],
	upsertHistoryTextItem: GraphQLTypes["HistoryTextItemUpsertResult"],
	createFooterMenu: GraphQLTypes["FooterMenuCreateResult"],
	deleteFooterMenu: GraphQLTypes["FooterMenuDeleteResult"],
	updateFooterMenu: GraphQLTypes["FooterMenuUpdateResult"],
	upsertFooterMenu: GraphQLTypes["FooterMenuUpsertResult"],
	createLinkSection: GraphQLTypes["LinkSectionCreateResult"],
	deleteLinkSection: GraphQLTypes["LinkSectionDeleteResult"],
	updateLinkSection: GraphQLTypes["LinkSectionUpdateResult"],
	upsertLinkSection: GraphQLTypes["LinkSectionUpsertResult"],
	createLinkList: GraphQLTypes["LinkListCreateResult"],
	deleteLinkList: GraphQLTypes["LinkListDeleteResult"],
	updateLinkList: GraphQLTypes["LinkListUpdateResult"],
	upsertLinkList: GraphQLTypes["LinkListUpsertResult"],
	createLinkItem: GraphQLTypes["LinkItemCreateResult"],
	deleteLinkItem: GraphQLTypes["LinkItemDeleteResult"],
	updateLinkItem: GraphQLTypes["LinkItemUpdateResult"],
	upsertLinkItem: GraphQLTypes["LinkItemUpsertResult"],
	createNewsletterSection: GraphQLTypes["NewsletterSectionCreateResult"],
	deleteNewsletterSection: GraphQLTypes["NewsletterSectionDeleteResult"],
	updateNewsletterSection: GraphQLTypes["NewsletterSectionUpdateResult"],
	upsertNewsletterSection: GraphQLTypes["NewsletterSectionUpsertResult"],
	createNewsletter: GraphQLTypes["NewsletterCreateResult"],
	deleteNewsletter: GraphQLTypes["NewsletterDeleteResult"],
	updateNewsletter: GraphQLTypes["NewsletterUpdateResult"],
	upsertNewsletter: GraphQLTypes["NewsletterUpsertResult"],
	createOnlineSection: GraphQLTypes["OnlineSectionCreateResult"],
	deleteOnlineSection: GraphQLTypes["OnlineSectionDeleteResult"],
	updateOnlineSection: GraphQLTypes["OnlineSectionUpdateResult"],
	upsertOnlineSection: GraphQLTypes["OnlineSectionUpsertResult"],
	createAppLink: GraphQLTypes["AppLinkCreateResult"],
	deleteAppLink: GraphQLTypes["AppLinkDeleteResult"],
	updateAppLink: GraphQLTypes["AppLinkUpdateResult"],
	upsertAppLink: GraphQLTypes["AppLinkUpsertResult"],
	createAppLinkList: GraphQLTypes["AppLinkListCreateResult"],
	deleteAppLinkList: GraphQLTypes["AppLinkListDeleteResult"],
	updateAppLinkList: GraphQLTypes["AppLinkListUpdateResult"],
	upsertAppLinkList: GraphQLTypes["AppLinkListUpsertResult"],
	createAppLinkItem: GraphQLTypes["AppLinkItemCreateResult"],
	deleteAppLinkItem: GraphQLTypes["AppLinkItemDeleteResult"],
	updateAppLinkItem: GraphQLTypes["AppLinkItemUpdateResult"],
	upsertAppLinkItem: GraphQLTypes["AppLinkItemUpsertResult"],
	createSocialSection: GraphQLTypes["SocialSectionCreateResult"],
	deleteSocialSection: GraphQLTypes["SocialSectionDeleteResult"],
	updateSocialSection: GraphQLTypes["SocialSectionUpdateResult"],
	upsertSocialSection: GraphQLTypes["SocialSectionUpsertResult"],
	createSocialLink: GraphQLTypes["SocialLinkCreateResult"],
	deleteSocialLink: GraphQLTypes["SocialLinkDeleteResult"],
	updateSocialLink: GraphQLTypes["SocialLinkUpdateResult"],
	upsertSocialLink: GraphQLTypes["SocialLinkUpsertResult"],
	createSocialLinkList: GraphQLTypes["SocialLinkListCreateResult"],
	deleteSocialLinkList: GraphQLTypes["SocialLinkListDeleteResult"],
	updateSocialLinkList: GraphQLTypes["SocialLinkListUpdateResult"],
	upsertSocialLinkList: GraphQLTypes["SocialLinkListUpsertResult"],
	createSocialLinkItem: GraphQLTypes["SocialLinkItemCreateResult"],
	deleteSocialLinkItem: GraphQLTypes["SocialLinkItemDeleteResult"],
	updateSocialLinkItem: GraphQLTypes["SocialLinkItemUpdateResult"],
	upsertSocialLinkItem: GraphQLTypes["SocialLinkItemUpsertResult"],
	createSharedContent: GraphQLTypes["SharedContentCreateResult"],
	deleteSharedContent: GraphQLTypes["SharedContentDeleteResult"],
	updateSharedContent: GraphQLTypes["SharedContentUpdateResult"],
	upsertSharedContent: GraphQLTypes["SharedContentUpsertResult"],
	query?: GraphQLTypes["Query"]
};
	["MutationTransactionOptions"]: {
		deferForeignKeyConstraints?: boolean
};
	/** Json custom scalar type */
["Json"]:any;
	["_Schema"]: {
	__typename: "_Schema",
	enums: Array<GraphQLTypes["_Enum"]>,
	entities: Array<GraphQLTypes["_Entity"]>
};
	["_Entity"]: {
	__typename: "_Entity",
	name: string,
	customPrimaryAllowed: boolean,
	fields: Array<GraphQLTypes["_Field"]>,
	unique: Array<GraphQLTypes["_UniqueConstraint"]>
};
	["_UniqueConstraint"]: {
	__typename: "_UniqueConstraint",
	fields: Array<string>
};
	["_Field"]: {
	__typename:"_Column" | "_Relation",
	name: string,
	type: string,
	nullable?: boolean,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
	['...on _Column']: '__union' & GraphQLTypes["_Column"];
	['...on _Relation']: '__union' & GraphQLTypes["_Relation"];
};
	["_Column"]: {
	__typename: "_Column",
	name: string,
	type: string,
	enumName?: string,
	defaultValue?: GraphQLTypes["Json"],
	nullable: boolean,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
};
	["_OnDeleteBehaviour"]: _OnDeleteBehaviour;
	["_RelationSide"]: _RelationSide;
	["_OrderByDirection"]: _OrderByDirection;
	["_OrderBy"]: {
	__typename: "_OrderBy",
	path: Array<string>,
	direction: GraphQLTypes["_OrderByDirection"]
};
	["_Relation"]: {
	__typename: "_Relation",
	name: string,
	type: string,
	side: GraphQLTypes["_RelationSide"],
	targetEntity: string,
	ownedBy?: string,
	inversedBy?: string,
	nullable?: boolean,
	onDelete?: GraphQLTypes["_OnDeleteBehaviour"],
	orphanRemoval?: boolean,
	orderBy?: Array<GraphQLTypes["_OrderBy"]>,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
};
	["_Rule"]: {
	__typename: "_Rule",
	message?: GraphQLTypes["_RuleMessage"],
	validator: number
};
	["_Validator"]: {
	__typename: "_Validator",
	operation: string,
	arguments: Array<GraphQLTypes["_Argument"]>
};
	["_Argument"]:{
	__typename:"_ValidatorArgument" | "_PathArgument" | "_LiteralArgument"
	['...on _ValidatorArgument']: '__union' & GraphQLTypes["_ValidatorArgument"];
	['...on _PathArgument']: '__union' & GraphQLTypes["_PathArgument"];
	['...on _LiteralArgument']: '__union' & GraphQLTypes["_LiteralArgument"];
};
	["_ValidatorArgument"]: {
	__typename: "_ValidatorArgument",
	validator: number
};
	["_PathArgument"]: {
	__typename: "_PathArgument",
	path: Array<string>
};
	["_LiteralArgument"]: {
	__typename: "_LiteralArgument",
	value?: GraphQLTypes["Json"]
};
	["_RuleMessage"]: {
	__typename: "_RuleMessage",
	text?: string
};
	["_Enum"]: {
	__typename: "_Enum",
	name: string,
	values: Array<string>
};
	["S3SignedUpload"]: {
	__typename: "S3SignedUpload",
	url: string,
	headers: Array<GraphQLTypes["S3Header"]>,
	method: string,
	/** Allowed patterns:
** */
	objectKey: string,
	bucket: string,
	publicUrl: string
};
	["S3Header"]: {
	__typename: "S3Header",
	key: string,
	value: string
};
	["S3Acl"]: S3Acl;
	["S3SignedRead"]: {
	__typename: "S3SignedRead",
	url: string,
	headers: Array<GraphQLTypes["S3Header"]>,
	method: string,
	/** Allowed patterns:
** */
	objectKey: string,
	bucket: string
}
    }
export const enum ContentReferenceType {
	audio = "audio",
	podcast = "podcast",
	quote = "quote",
	big_link = "big_link",
	block_link = "block_link",
	image = "image",
	photo_gallery = "photo_gallery",
	photo_grid = "photo_grid",
	embed = "embed",
	html_code = "html_code",
	listicle = "listicle",
	info_box = "info_box",
	poll_answer = "poll_answer",
	respekt = "respekt",
	despekt = "despekt",
	subnavigation = "subnavigation",
	promobox = "promobox",
	faq = "faq",
	awards = "awards",
	reviews = "reviews",
	feature = "feature",
	link = "link",
	subscription_form = "subscription_form",
	banner = "banner",
	image_with_text = "image_with_text",
	download_button = "download_button",
	text_with_icons = "text_with_icons",
	buttons = "buttons",
	slides = "slides",
	shared_content = "shared_content"
}
export const enum ContentReferenceVariant {
	first = "first",
	second = "second",
	third = "third",
	fourth = "fourth"
}
export const enum EmbedType {
	youtube = "youtube",
	vimeo = "vimeo",
	spotify = "spotify",
	soundcloud = "soundcloud",
	googleForm = "googleForm"
}
export const enum ImageAlign {
	center = "center",
	left = "left",
	right = "right",
	top = "top",
	bottom = "bottom"
}
export const enum LinkType {
	internal = "internal",
	external = "external"
}
export const enum SubscriptionFormInputType {
	radio = "radio",
	checkbox = "checkbox",
	radio_discount = "radio_discount",
	checkbox_club = "checkbox_club",
	contribute = "contribute"
}
export const enum Types {
	digital = "digital",
	digital_with_club = "digital_with_club",
	issue = "issue",
	issue_old = "issue_old",
	print = "print",
	print_with_club = "print_with_club"
}
export const enum ContentBlockType {
	youtube = "youtube",
	promo_block = "promo_block",
	text_block = "text_block",
	feature_articles = "feature_articles",
	subscription_form = "subscription_form"
}
export const enum IssueKind {
	weekly = "weekly",
	special = "special",
	supplement = "supplement"
}
export const enum ButtonType {
	primary = "primary",
	secondary = "secondary",
	appStore = "appStore",
	googlePlay = "googlePlay",
	amazon = "amazon"
}
export const enum AuthorCategory {
	staff = "staff",
	external = "external",
	other = "other"
}
export const enum PageTemplate {
	default = "default",
	digital = "digital",
	subscription = "subscription"
}
export const enum SeoTwCard {
	summary = "summary",
	summary_large_image = "summary_large_image",
	app = "app",
	player = "player"
}
export const enum ArticleAuthorLegacyStringAuthor {
	yes = "yes"
}
export const enum ArticleState {
	draft = "draft",
	for_review = "for_review",
	published = "published"
}
export const enum Template {
	default = "default",
	full_photo = "full_photo",
	poll = "poll",
	last_week = "last_week",
	review = "review",
	respekt_despekt = "respekt_despekt",
	comix = "comix",
	photo_gallery = "photo_gallery",
	podcast = "podcast",
	video = "video"
}
export const enum TextContentReferenceType {
	link = "link"
}
export const enum ArticleTitleAlignment {
	left = "left",
	center = "center",
	right = "right"
}
export const enum OrderDirection {
	asc = "asc",
	desc = "desc",
	ascNullsFirst = "ascNullsFirst",
	descNullsLast = "descNullsLast"
}
export const enum HistoryHomePageUnique {
	One = "One"
}
export const enum FooterMenuUnique {
	One = "One"
}
export const enum AppLinkType {
	AppStore = "AppStore",
	GooglePlay = "GooglePlay",
	Amazon = "Amazon"
}
export const enum SocialLinkType {
	facebook = "facebook",
	twitter = "twitter",
	instagram = "instagram"
}
export const enum _MutationErrorType {
	NotNullConstraintViolation = "NotNullConstraintViolation",
	UniqueConstraintViolation = "UniqueConstraintViolation",
	ForeignKeyConstraintViolation = "ForeignKeyConstraintViolation",
	NotFoundOrDenied = "NotFoundOrDenied",
	NonUniqueWhereInput = "NonUniqueWhereInput",
	InvalidDataInput = "InvalidDataInput",
	SqlError = "SqlError"
}
export const enum _OnDeleteBehaviour {
	restrict = "restrict",
	cascade = "cascade",
	setNull = "setNull"
}
export const enum _RelationSide {
	owning = "owning",
	inverse = "inverse"
}
export const enum _OrderByDirection {
	asc = "asc",
	desc = "desc"
}
export const enum S3Acl {
	PUBLIC_READ = "PUBLIC_READ",
	PRIVATE = "PRIVATE",
	NONE = "NONE"
}
export class GraphQLError extends Error {
    constructor(public response: GraphQLResponse) {
      super("");
      console.error(response);
    }
    override toString() {
      return "GraphQL Response Error";
    }
  }


export type UnwrapPromise<T> = T extends Promise<infer R> ? R : T;
export type ZeusState<T extends (...args: any[]) => Promise<any>> = NonNullable<
  UnwrapPromise<ReturnType<T>>
>;
export type ZeusHook<
  T extends (
    ...args: any[]
  ) => Record<string, (...args: any[]) => Promise<any>>,
  N extends keyof ReturnType<T>
> = ZeusState<ReturnType<T>[N]>;

type WithTypeNameValue<T> = T & {
  __typename?: boolean;
};
type AliasType<T> = WithTypeNameValue<T> & {
  __alias?: Record<string, WithTypeNameValue<T>>;
};
export interface GraphQLResponse {
  data?: Record<string, any>;
  errors?: Array<{
    message: string;
  }>;
}
type DeepAnify<T> = {
  [P in keyof T]?: any;
};
type IsPayLoad<T> = T extends [any, infer PayLoad] ? PayLoad : T;
type IsArray<T, U> = T extends Array<infer R> ? InputType<R, U>[] : InputType<T, U>;
type FlattenArray<T> = T extends Array<infer R> ? R : T;

type IsInterfaced<SRC extends DeepAnify<DST>, DST> = FlattenArray<SRC> extends ZEUS_INTERFACES | ZEUS_UNIONS
  ? {
      [P in keyof SRC]: SRC[P] extends '__union' & infer R
        ? P extends keyof DST
          ? IsArray<R, '__typename' extends keyof DST ? DST[P] & { __typename: true } : DST[P]>
          : {}
        : never;
    }[keyof DST] &
      {
        [P in keyof Omit<
          Pick<
            SRC,
            {
              [P in keyof DST]: SRC[P] extends '__union' & infer R ? never : P;
            }[keyof DST]
          >,
          '__typename'
        >]: IsPayLoad<DST[P]> extends boolean ? SRC[P] : IsArray<SRC[P], DST[P]>;
      }
  : {
      [P in keyof Pick<SRC, keyof DST>]: IsPayLoad<DST[P]> extends boolean ? SRC[P] : IsArray<SRC[P], DST[P]>;
    };

export type MapType<SRC, DST> = SRC extends DeepAnify<DST> ? IsInterfaced<SRC, DST> : never;
export type InputType<SRC, DST> = IsPayLoad<DST> extends { __alias: infer R }
  ? {
      [P in keyof R]: MapType<SRC, R[P]>;
    } &
      MapType<SRC, Omit<IsPayLoad<DST>, '__alias'>>
  : MapType<SRC, IsPayLoad<DST>>;
type Func<P extends any[], R> = (...args: P) => R;
type AnyFunc = Func<any, any>;
export type ArgsType<F extends AnyFunc> = F extends Func<infer P, any> ? P : never;
export type OperationOptions = {
  variables?: Record<string, any>;
  operationName?: string;
};
export type SubscriptionToGraphQL<Z, T> = {
  ws: WebSocket;
  on: (fn: (args: InputType<T, Z>) => void) => void;
  off: (fn: (e: { data?: InputType<T, Z>; code?: number; reason?: string; message?: string }) => void) => void;
  error: (fn: (e: { data?: InputType<T, Z>; errors?: string[] }) => void) => void;
  open: () => void;
};
export type SelectionFunction<V> = <T>(t: T | V) => T;
export type fetchOptions = ArgsType<typeof fetch>;
type websocketOptions = typeof WebSocket extends new (
  ...args: infer R
) => WebSocket
  ? R
  : never;
export type chainOptions =
  | [fetchOptions[0], fetchOptions[1] & {websocket?: websocketOptions}]
  | [fetchOptions[0]];
export type FetchFunction = (
  query: string,
  variables?: Record<string, any>,
) => Promise<any>;
export type SubscriptionFunction = (query: string) => any;
type NotUndefined<T> = T extends undefined ? never : T;
export type ResolverType<F> = NotUndefined<F extends [infer ARGS, any] ? ARGS : undefined>;



export const ZeusSelect = <T>() => ((t: any) => t) as SelectionFunction<T>;

export const ScalarResolver = (scalar: string, value: any) => {
  switch (scalar) {
    case 'String':
      return  `${JSON.stringify(value)}`;
    case 'Int':
      return `${value}`;
    case 'Float':
      return `${value}`;
    case 'Boolean':
      return `${value}`;
    case 'ID':
      return `"${value}"`;
    case 'enum':
      return `${value}`;
    case 'scalar':
      return `${value}`;
    default:
      return false;
  }
};


export const TypesPropsResolver = ({
    value,
    type,
    name,
    key,
    blockArrays
}: {
    value: any;
    type: string;
    name: string;
    key?: string;
    blockArrays?: boolean;
}): string => {
    if (value === null) {
        return `null`;
    }
    let resolvedValue = AllTypesProps[type][name];
    if (key) {
        resolvedValue = resolvedValue[key];
    }
    if (!resolvedValue) {
        throw new Error(`Cannot resolve ${type} ${name}${key ? ` ${key}` : ''}`)
    }
    const typeResolved = resolvedValue.type;
    const isArray = resolvedValue.array;
    const isArrayRequired = resolvedValue.arrayRequired;
    if (typeof value === 'string' && value.startsWith(`ZEUS_VAR$`)) {
        const isRequired = resolvedValue.required ? '!' : '';
        let t = `${typeResolved}`;
        if (isArray) {
          if (isRequired) {
              t = `${t}!`;
          }
          t = `[${t}]`;
          if(isArrayRequired){
            t = `${t}!`;
          }
        }else{
          if (isRequired) {
                t = `${t}!`;
          }
        }
        return `\$${value.split(`ZEUS_VAR$`)[1]}__ZEUS_VAR__${t}`;
    }
    if (isArray && !blockArrays) {
        return `[${value
        .map((v: any) => TypesPropsResolver({ value: v, type, name, key, blockArrays: true }))
        .join(',')}]`;
    }
    const reslovedScalar = ScalarResolver(typeResolved, value);
    if (!reslovedScalar) {
        const resolvedType = AllTypesProps[typeResolved];
        if (typeof resolvedType === 'object') {
        const argsKeys = Object.keys(resolvedType);
        return `{${argsKeys
            .filter((ak) => value[ak] !== undefined)
            .map(
            (ak) => `${ak}:${TypesPropsResolver({ value: value[ak], type: typeResolved, name: ak })}`
            )}}`;
        }
        return ScalarResolver(AllTypesProps[typeResolved], value) as string;
    }
    return reslovedScalar;
};


const isArrayFunction = (
  parent: string[],
  a: any[]
) => {
  const [values, r] = a;
  const [mainKey, key, ...keys] = parent;
  const keyValues = Object.keys(values).filter((k) => typeof values[k] !== 'undefined');

  if (!keys.length) {
      return keyValues.length > 0
        ? `(${keyValues
            .map(
              (v) =>
                `${v}:${TypesPropsResolver({
                  value: values[v],
                  type: mainKey,
                  name: key,
                  key: v
                })}`
            )
            .join(',')})${r ? traverseToSeekArrays(parent, r) : ''}`
        : traverseToSeekArrays(parent, r);
    }

  const [typeResolverKey] = keys.splice(keys.length - 1, 1);
  let valueToResolve = ReturnTypes[mainKey][key];
  for (const k of keys) {
    valueToResolve = ReturnTypes[valueToResolve][k];
  }

  const argumentString =
    keyValues.length > 0
      ? `(${keyValues
          .map(
            (v) =>
              `${v}:${TypesPropsResolver({
                value: values[v],
                type: valueToResolve,
                name: typeResolverKey,
                key: v
              })}`
          )
          .join(',')})${r ? traverseToSeekArrays(parent, r) : ''}`
      : traverseToSeekArrays(parent, r);
  return argumentString;
};


const resolveKV = (k: string, v: boolean | string | { [x: string]: boolean | string }) =>
  typeof v === 'boolean' ? k : typeof v === 'object' ? `${k}{${objectToTree(v)}}` : `${k}${v}`;


const objectToTree = (o: { [x: string]: boolean | string }): string =>
  `{${Object.keys(o).map((k) => `${resolveKV(k, o[k])}`).join(' ')}}`;


const traverseToSeekArrays = (parent: string[], a?: any): string => {
  if (!a) return '';
  if (Object.keys(a).length === 0) {
    return '';
  }
  let b: Record<string, any> = {};
  if (Array.isArray(a)) {
    return isArrayFunction([...parent], a);
  } else {
    if (typeof a === 'object') {
      Object.keys(a)
        .filter((k) => typeof a[k] !== 'undefined')
        .forEach((k) => {
        if (k === '__alias') {
          Object.keys(a[k]).forEach((aliasKey) => {
            const aliasOperations = a[k][aliasKey];
            const aliasOperationName = Object.keys(aliasOperations)[0];
            const aliasOperation = aliasOperations[aliasOperationName];
            b[
              `${aliasOperationName}__alias__${aliasKey}: ${aliasOperationName}`
            ] = traverseToSeekArrays([...parent, aliasOperationName], aliasOperation);
          });
        } else {
          b[k] = traverseToSeekArrays([...parent, k], a[k]);
        }
      });
    } else {
      return '';
    }
  }
  return objectToTree(b);
};  


const buildQuery = (type: string, a?: Record<any, any>) => 
  traverseToSeekArrays([type], a);


const inspectVariables = (query: string) => {
  const regex = /\$\b\w*__ZEUS_VAR__\[?[^!^\]^\s^,^\)^\}]*[!]?[\]]?[!]?/g;
  let result;
  const AllVariables: string[] = [];
  while ((result = regex.exec(query))) {
    if (AllVariables.includes(result[0])) {
      continue;
    }
    AllVariables.push(result[0]);
  }
  if (!AllVariables.length) {
    return query;
  }
  let filteredQuery = query;
  AllVariables.forEach((variable) => {
    while (filteredQuery.includes(variable)) {
      filteredQuery = filteredQuery.replace(variable, variable.split('__ZEUS_VAR__')[0]);
    }
  });
  return `(${AllVariables.map((a) => a.split('__ZEUS_VAR__'))
    .map(([variableName, variableType]) => `${variableName}:${variableType}`)
    .join(', ')})${filteredQuery}`;
};


export const queryConstruct = (t: 'query' | 'mutation' | 'subscription', tName: string, operationName?: string) => (o: Record<any, any>) =>
  `${t.toLowerCase()}${operationName ? ' ' + operationName : ''}${inspectVariables(buildQuery(tName, o))}`;
  

export const fullChainConstruct = (fn: FetchFunction) => (t: 'query' | 'mutation' | 'subscription', tName: string) => (
  o: Record<any, any>,
  options?: OperationOptions,
) => fn(queryConstruct(t, tName, options?.operationName)(o), options?.variables).then((r:any) => { 
  seekForAliases(r)
  return r
});


export const fullSubscriptionConstruct = (fn: SubscriptionFunction) => (
  t: 'query' | 'mutation' | 'subscription',
  tName: string,
) => (o: Record<any, any>, options?: OperationOptions) =>
  fn(queryConstruct(t, tName, options?.operationName)(o));


const seekForAliases = (response: any) => {
  const traverseAlias = (value: any) => {
    if (Array.isArray(value)) {
      value.forEach(seekForAliases);
    } else {
      if (typeof value === 'object') {
        seekForAliases(value);
      }
    }
  };
  if (typeof response === 'object' && response) {
    const keys = Object.keys(response);
    if (keys.length < 1) {
      return;
    }
    keys.forEach((k) => {
      const value = response[k];
      if (k.indexOf('__alias__') !== -1) {
        const [operation, alias] = k.split('__alias__');
        response[alias] = {
          [operation]: value,
        };
        delete response[k];
      }
      traverseAlias(value);
    });
  }
};


export const $ = (t: TemplateStringsArray): any => `ZEUS_VAR$${t.join('')}`;


export const resolverFor = <
  X,
  T extends keyof ValueTypes,
  Z extends keyof ValueTypes[T],
>(
  type: T,
  field: Z,
  fn: (
    args: Required<ValueTypes[T]>[Z] extends [infer Input, any] ? Input : any,
    source: any,
  ) => Z extends keyof ModelTypes[T] ? ModelTypes[T][Z] | Promise<ModelTypes[T][Z]> | X : any,
) => fn as (args?: any,source?: any) => any;


const handleFetchResponse = (
  response: Parameters<Extract<Parameters<ReturnType<typeof fetch>['then']>[0], Function>>[0]
): Promise<GraphQLResponse> => {
  if (!response.ok) {
    return new Promise((_, reject) => {
      response.text().then(text => {
        try { reject(JSON.parse(text)); }
        catch (err) { reject(text); }
      }).catch(reject);
    });
  }
  return response.json();
};

export const apiFetch = (options: fetchOptions) => (query: string, variables: Record<string, any> = {}) => {
    let fetchFunction = fetch;
    let queryString = query;
    let fetchOptions = options[1] || {};
    if (fetchOptions.method && fetchOptions.method === 'GET') {
      queryString = encodeURIComponent(query);
      return fetchFunction(`${options[0]}?query=${queryString}`, fetchOptions)
        .then(handleFetchResponse)
        .then((response: GraphQLResponse) => {
          if (response.errors) {
            throw new GraphQLError(response);
          }
          return response.data;
        });
    }
    return fetchFunction(`${options[0]}`, {
      body: JSON.stringify({ query: queryString, variables }),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      ...fetchOptions
    })
      .then(handleFetchResponse)
      .then((response: GraphQLResponse) => {
        if (response.errors) {
          throw new GraphQLError(response);
        }
        return response.data;
      });
  };
  

export const apiSubscription = (options: chainOptions) => (
    query: string,
  ) => {
    try {
      const queryString = options[0] + '?query=' + encodeURIComponent(query);
      const wsString = queryString.replace('http', 'ws');
      const host = (options.length > 1 && options[1]?.websocket?.[0]) || wsString;
      const webSocketOptions = options[1]?.websocket || [host];
      const ws = new WebSocket(...webSocketOptions);
      return {
        ws,
        on: (e: (args: any) => void) => {
          ws.onmessage = (event:any) => {
            if(event.data){
              const parsed = JSON.parse(event.data)
              const data = parsed.data
              if (data) {
                seekForAliases(data);
              }
              return e(data);
            }
          };
        },
        off: (e: (args: any) => void) => {
          ws.onclose = e;
        },
        error: (e: (args: any) => void) => {
          ws.onerror = e;
        },
        open: (e: () => void) => {
          ws.onopen = e;
        },
      };
    } catch {
      throw new Error('No websockets implemented');
    }
  };



const allOperations = {
    "query": "Query",
    "mutation": "Mutation"
}

export type GenericOperation<O> = O extends 'query'
  ? "Query"
  : O extends 'mutation'
  ? "Mutation"
  : never

export const Thunder = (fn: FetchFunction) => <
  O extends 'query' | 'mutation',
  R extends keyof ValueTypes = GenericOperation<O>
>(
  operation: O,
) => <Z extends ValueTypes[R]>(o: Z | ValueTypes[R], ops?: OperationOptions) =>
  fullChainConstruct(fn)(operation, allOperations[operation])(o as any, ops) as Promise<InputType<GraphQLTypes[R], Z>>;

export const Chain = (...options: chainOptions) => Thunder(apiFetch(options));  
  
export const SubscriptionThunder = (fn: SubscriptionFunction) => <
  O extends 'query' | 'mutation',
  R extends keyof ValueTypes = GenericOperation<O>
>(
  operation: O,
) => <Z extends ValueTypes[R]>(
  o: Z | ValueTypes[R],
  ops?: OperationOptions
)=>
  fullSubscriptionConstruct(fn)(operation, allOperations[operation])(
    o as any,
    ops,
  ) as SubscriptionToGraphQL<Z, GraphQLTypes[R]>;

export const Subscription = (...options: chainOptions) => SubscriptionThunder(apiSubscription(options));
export const Zeus = <
  Z extends ValueTypes[R],
  O extends 'query' | 'mutation',
  R extends keyof ValueTypes = GenericOperation<O>
>(
  operation: O,
  o: Z | ValueTypes[R],
  operationName?: string,
) => queryConstruct(operation, allOperations[operation], operationName)(o as any);
export const Selector = <T extends keyof ValueTypes>(key: T) => ZeusSelect<ValueTypes[T]>();
  
export type FragmentResult<K extends keyof GraphQLTypes, Q extends unknown | (() => unknown)> = InputType<
	GraphQLTypes[K],
	Q extends () => unknown ? ReturnType<Q> : Q
>